(function () {
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
/**
 * @license
 * Copyright 2010-2023 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $0147bee01cff6558$export$3545e07a80636437 = "155";
const $0147bee01cff6558$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $0147bee01cff6558$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $0147bee01cff6558$export$3237e1f2c1ea1f44 = 0;
const $0147bee01cff6558$export$b9a7b4fc5cb15f9b = 1;
const $0147bee01cff6558$export$b8058bcc7037d3f3 = 2;
const $0147bee01cff6558$export$f24be24dcddeac0d = 3;
const $0147bee01cff6558$export$346307dbae2b7447 = 0;
const $0147bee01cff6558$export$5813f879eee7cd88 = 1;
const $0147bee01cff6558$export$a47c4b43a1be34f0 = 2;
const $0147bee01cff6558$export$896ae1ade6c829c4 = 3;
const $0147bee01cff6558$export$2ede184fc2998901 = 0;
const $0147bee01cff6558$export$d9f0486e75b5ace = 1;
const $0147bee01cff6558$export$3b296b6f144d5b03 = 2;
const $0147bee01cff6558$export$211211c00f97204d = 2; // r149
const $0147bee01cff6558$export$63b8d6b580fc65ba = 0;
const $0147bee01cff6558$export$5b29a26d96ee6af0 = 1;
const $0147bee01cff6558$export$777d8f9551c2216b = 2;
const $0147bee01cff6558$export$cdfa06f868e2e467 = 3;
const $0147bee01cff6558$export$4138e1c684b46a20 = 4;
const $0147bee01cff6558$export$eda4864c68df1fa2 = 5;
const $0147bee01cff6558$export$20183a0484ce21a0 = 100;
const $0147bee01cff6558$export$73e0df5177988548 = 101;
const $0147bee01cff6558$export$28e582859cbec660 = 102;
const $0147bee01cff6558$export$c8c1508da8d0600c = 103;
const $0147bee01cff6558$export$99948c02fb51055f = 104;
const $0147bee01cff6558$export$2110f05edf778d3d = 200;
const $0147bee01cff6558$export$8805bad65e24940e = 201;
const $0147bee01cff6558$export$7fbe15b28d28cf52 = 202;
const $0147bee01cff6558$export$947829af9f2c17f6 = 203;
const $0147bee01cff6558$export$d5773124e86cf28c = 204;
const $0147bee01cff6558$export$11d468cc7f19e971 = 205;
const $0147bee01cff6558$export$a78aed1ca2a87192 = 206;
const $0147bee01cff6558$export$5d0fe17fd8773bac = 207;
const $0147bee01cff6558$export$ef5f2dd8ffac5574 = 208;
const $0147bee01cff6558$export$56b85b2686ab16 = 209;
const $0147bee01cff6558$export$c05e2a1fc8609506 = 210;
const $0147bee01cff6558$export$69025ce147cee220 = 0;
const $0147bee01cff6558$export$7182eb52ea3b3f04 = 1;
const $0147bee01cff6558$export$eedccec66ab7ebe = 2;
const $0147bee01cff6558$export$296f78a0b892f81a = 3;
const $0147bee01cff6558$export$a60d398fc7b7590e = 4;
const $0147bee01cff6558$export$7d7234c1240a1fc4 = 5;
const $0147bee01cff6558$export$c5e2c52991f30937 = 6;
const $0147bee01cff6558$export$2f843afa843d8916 = 7;
const $0147bee01cff6558$export$e50ac29801f1774d = 0;
const $0147bee01cff6558$export$9f9d94f963c85479 = 1;
const $0147bee01cff6558$export$e641dc52bc3494aa = 2;
const $0147bee01cff6558$export$9fcb6b4294603b2 = 0;
const $0147bee01cff6558$export$98f52c2a46c598ca = 1;
const $0147bee01cff6558$export$74b25e54b3bcd548 = 2;
const $0147bee01cff6558$export$932b3dd283d4a366 = 3;
const $0147bee01cff6558$export$a0d98fe6d7e4af64 = 4;
const $0147bee01cff6558$export$2c7b09c1e9abfb5e = 5;
const $0147bee01cff6558$export$1beec6768cbb3d2d = 300;
const $0147bee01cff6558$export$8759762a6477f2c4 = 301;
const $0147bee01cff6558$export$dc59f8aed047f61d = 302;
const $0147bee01cff6558$export$d64030b316d3b087 = 303;
const $0147bee01cff6558$export$ee99d97d46898098 = 304;
const $0147bee01cff6558$export$dbf3e70ff37af79 = 306;
const $0147bee01cff6558$export$533346c8e8dac0f5 = 1000;
const $0147bee01cff6558$export$9d9334239a5a5e06 = 1001;
const $0147bee01cff6558$export$c7e7c00b14f51a4f = 1002;
const $0147bee01cff6558$export$727aa5ec3fe39bf0 = 1003;
const $0147bee01cff6558$export$d129e38cf6feaa8c = 1004;
const $0147bee01cff6558$export$14a4936464a36496 = 1004;
const $0147bee01cff6558$export$d2327c1afe5bfdf2 = 1005;
const $0147bee01cff6558$export$cbc5b7f5647595d8 = 1005;
const $0147bee01cff6558$export$8a72f490b25c56c8 = 1006;
const $0147bee01cff6558$export$19a719f377145a13 = 1007;
const $0147bee01cff6558$export$dbe96bee3fe9dbf0 = 1007;
const $0147bee01cff6558$export$5d8599b6a933fb1b = 1008;
const $0147bee01cff6558$export$90d80f1e3506775f = 1008;
const $0147bee01cff6558$export$2e8ce08d3f6f5e10 = 1009;
const $0147bee01cff6558$export$545fce0311a9796a = 1010;
const $0147bee01cff6558$export$88572337f312435f = 1011;
const $0147bee01cff6558$export$c63dc51868b06a9d = 1012;
const $0147bee01cff6558$export$5c612977753abe2 = 1013;
const $0147bee01cff6558$export$c3c7fc4518ebba96 = 1014;
const $0147bee01cff6558$export$f6d331659b644596 = 1015;
const $0147bee01cff6558$export$2697304443f382bc = 1016;
const $0147bee01cff6558$export$b3969b01faf587f2 = 1017;
const $0147bee01cff6558$export$18886f8ae33e90de = 1018;
const $0147bee01cff6558$export$6c8ea339bfab1301 = 1020;
const $0147bee01cff6558$export$988473390501ed4b = 1021;
const $0147bee01cff6558$export$3f8bb04b555a363c = 1023;
const $0147bee01cff6558$export$cc09ccbf6d1ed449 = 1024;
const $0147bee01cff6558$export$9053a81c4a69c289 = 1025;
const $0147bee01cff6558$export$c1b6b5136be58045 = 1026;
const $0147bee01cff6558$export$1e113ac2d0905829 = 1027;
const $0147bee01cff6558$export$4e041a7967d15c4b = 1028;
const $0147bee01cff6558$export$aa92e870a709d190 = 1029;
const $0147bee01cff6558$export$6cdf0b461c7ce8a0 = 1030;
const $0147bee01cff6558$export$1ba1c45f9f77d4d7 = 1031;
const $0147bee01cff6558$export$c200e7d26f592f21 = 1033;
const $0147bee01cff6558$export$21d1799c6d552fc0 = 33776;
const $0147bee01cff6558$export$afa304c3e981b668 = 33777;
const $0147bee01cff6558$export$d2a1a68024a3e56c = 33778;
const $0147bee01cff6558$export$9a79c424327dacf9 = 33779;
const $0147bee01cff6558$export$19ada9bbb1af3573 = 35840;
const $0147bee01cff6558$export$d0f0355bb3d948e4 = 35841;
const $0147bee01cff6558$export$b82296714358084c = 35842;
const $0147bee01cff6558$export$b71692456c47b6c3 = 35843;
const $0147bee01cff6558$export$6ab91af2d757aee7 = 36196;
const $0147bee01cff6558$export$7800993ef8106a6a = 37492;
const $0147bee01cff6558$export$23ed8300a860e7d8 = 37496;
const $0147bee01cff6558$export$dc5570b4a2b92d48 = 37808;
const $0147bee01cff6558$export$68880cd325f8b2fb = 37809;
const $0147bee01cff6558$export$7d2c0be323373d95 = 37810;
const $0147bee01cff6558$export$22b52da301fc3a3e = 37811;
const $0147bee01cff6558$export$c009e2cb4a66485e = 37812;
const $0147bee01cff6558$export$118fff5afa255b63 = 37813;
const $0147bee01cff6558$export$120713c829ae0667 = 37814;
const $0147bee01cff6558$export$c79eeabbf53313e9 = 37815;
const $0147bee01cff6558$export$443cf6567cdd6424 = 37816;
const $0147bee01cff6558$export$6573984fc9840780 = 37817;
const $0147bee01cff6558$export$e7aee563f30091de = 37818;
const $0147bee01cff6558$export$2eb8634622ddeab7 = 37819;
const $0147bee01cff6558$export$202b1ce7b5d25742 = 37820;
const $0147bee01cff6558$export$18ab77abd087e467 = 37821;
const $0147bee01cff6558$export$ce40b115e188bc81 = 36492;
const $0147bee01cff6558$export$b1688df4c4c21670 = 36283;
const $0147bee01cff6558$export$fc15e5d8261eed58 = 36284;
const $0147bee01cff6558$export$d220f6ade8463a0f = 36285;
const $0147bee01cff6558$export$768646d09dc1b6ef = 36286;
const $0147bee01cff6558$export$d62fdc9d1b1cccad = 2200;
const $0147bee01cff6558$export$dfaf4422ce096e29 = 2201;
const $0147bee01cff6558$export$f8f6f2041b78e210 = 2202;
const $0147bee01cff6558$export$995b32462a65e855 = 2300;
const $0147bee01cff6558$export$30fac1aace31cf4d = 2301;
const $0147bee01cff6558$export$198b11ff4c72bb30 = 2302;
const $0147bee01cff6558$export$7f795934b84ab523 = 2400;
const $0147bee01cff6558$export$24a4ccb5099273b5 = 2401;
const $0147bee01cff6558$export$8e8c3ecdcd8e1fee = 2402;
const $0147bee01cff6558$export$bcfbbdcf8de7f8cd = 2500;
const $0147bee01cff6558$export$d875e029ef558d3 = 2501;
const $0147bee01cff6558$export$4c28c87c2dc84758 = 0;
const $0147bee01cff6558$export$b23a071aa286eb29 = 1;
const $0147bee01cff6558$export$f0d8293634f88842 = 2;
/** @deprecated Use LinearSRGBColorSpace or NoColorSpace in three.js r152+. */ const $0147bee01cff6558$export$7207336e4151a112 = 3000;
/** @deprecated Use SRGBColorSpace in three.js r152+. */ const $0147bee01cff6558$export$f32388edbb32674 = 3001;
const $0147bee01cff6558$export$deeb383078690b50 = 3200;
const $0147bee01cff6558$export$8f910f4c4f73df11 = 3201;
const $0147bee01cff6558$export$2852a58ebdac27b8 = 0;
const $0147bee01cff6558$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const $0147bee01cff6558$export$bfcb490c2dd3db51 = "";
const $0147bee01cff6558$export$561f394b24edfcaa = "srgb";
const $0147bee01cff6558$export$42429b3acfb233a4 = "srgb-linear";
const $0147bee01cff6558$export$626af19ae879bdf6 = "display-p3";
const $0147bee01cff6558$export$69433f11f42d5527 = 0;
const $0147bee01cff6558$export$9f542ae4b5baca34 = 7680;
const $0147bee01cff6558$export$8a4f28336ef203d3 = 7681;
const $0147bee01cff6558$export$2928c0231297c036 = 7682;
const $0147bee01cff6558$export$c0e9611c8a15f9a8 = 7683;
const $0147bee01cff6558$export$9c2c08927385dcc4 = 34055;
const $0147bee01cff6558$export$7c74ea00fa1315e6 = 34056;
const $0147bee01cff6558$export$22e2e5726612443 = 5386;
const $0147bee01cff6558$export$1343870698229224 = 512;
const $0147bee01cff6558$export$8e1d8ed281997fa6 = 513;
const $0147bee01cff6558$export$55648a1cde8329a7 = 514;
const $0147bee01cff6558$export$2dff107857e6aca2 = 515;
const $0147bee01cff6558$export$6f93765ab2f451a2 = 516;
const $0147bee01cff6558$export$6f3fb2d2440f2b76 = 517;
const $0147bee01cff6558$export$4119cf7b4c98fd5a = 518;
const $0147bee01cff6558$export$14cf96713ddd97a8 = 519;
const $0147bee01cff6558$export$d9e2d19a747baaab = 512;
const $0147bee01cff6558$export$36bcf49c713b3eb7 = 513;
const $0147bee01cff6558$export$66f28d946fc6a0d5 = 514;
const $0147bee01cff6558$export$64eea11eb407ddf1 = 515;
const $0147bee01cff6558$export$155af022118f3a38 = 516;
const $0147bee01cff6558$export$67ab95dde6bed156 = 517;
const $0147bee01cff6558$export$1cdcb70d53d65f61 = 518;
const $0147bee01cff6558$export$187b73a3e352c145 = 519;
const $0147bee01cff6558$export$763e8360f4d7f77d = 35044;
const $0147bee01cff6558$export$8505d14ac8546ca = 35048;
const $0147bee01cff6558$export$721e63549e51d81e = 35040;
const $0147bee01cff6558$export$415731dc4f48e299 = 35045;
const $0147bee01cff6558$export$9e809946455f13bc = 35049;
const $0147bee01cff6558$export$2ed9499a35b5f832 = 35041;
const $0147bee01cff6558$export$32ab2503ea19469a = 35046;
const $0147bee01cff6558$export$ab4022c2c3f86315 = 35050;
const $0147bee01cff6558$export$ba7f1db36a76a970 = 35042;
const $0147bee01cff6558$export$43600cc67fabd9f = "100";
const $0147bee01cff6558$export$f63012db5506e7dd = "300 es";
const $0147bee01cff6558$export$ca1dce8b5e1de74d = 1035; // fallback for WebGL 1
const $0147bee01cff6558$export$5a0e9190d10875d3 = 2000;
const $0147bee01cff6558$export$cc83beedcb9be9ac = 2001;
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $0147bee01cff6558$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $0147bee01cff6558$var$_lut = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0a",
    "0b",
    "0c",
    "0d",
    "0e",
    "0f",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1a",
    "1b",
    "1c",
    "1d",
    "1e",
    "1f",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2a",
    "2b",
    "2c",
    "2d",
    "2e",
    "2f",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3a",
    "3b",
    "3c",
    "3d",
    "3e",
    "3f",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4a",
    "4b",
    "4c",
    "4d",
    "4e",
    "4f",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5a",
    "5b",
    "5c",
    "5d",
    "5e",
    "5f",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6a",
    "6b",
    "6c",
    "6d",
    "6e",
    "6f",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7a",
    "7b",
    "7c",
    "7d",
    "7e",
    "7f",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8a",
    "8b",
    "8c",
    "8d",
    "8e",
    "8f",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9a",
    "9b",
    "9c",
    "9d",
    "9e",
    "9f",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "aa",
    "ab",
    "ac",
    "ad",
    "ae",
    "af",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "ba",
    "bb",
    "bc",
    "bd",
    "be",
    "bf",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "ca",
    "cb",
    "cc",
    "cd",
    "ce",
    "cf",
    "d0",
    "d1",
    "d2",
    "d3",
    "d4",
    "d5",
    "d6",
    "d7",
    "d8",
    "d9",
    "da",
    "db",
    "dc",
    "dd",
    "de",
    "df",
    "e0",
    "e1",
    "e2",
    "e3",
    "e4",
    "e5",
    "e6",
    "e7",
    "e8",
    "e9",
    "ea",
    "eb",
    "ec",
    "ed",
    "ee",
    "ef",
    "f0",
    "f1",
    "f2",
    "f3",
    "f4",
    "f5",
    "f6",
    "f7",
    "f8",
    "f9",
    "fa",
    "fb",
    "fc",
    "fd",
    "fe",
    "ff"
];
let $0147bee01cff6558$var$_seed = 1234567;
const $0147bee01cff6558$var$DEG2RAD = Math.PI / 180;
const $0147bee01cff6558$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $0147bee01cff6558$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $0147bee01cff6558$var$_lut[d0 & 0xff] + $0147bee01cff6558$var$_lut[d0 >> 8 & 0xff] + $0147bee01cff6558$var$_lut[d0 >> 16 & 0xff] + $0147bee01cff6558$var$_lut[d0 >> 24 & 0xff] + "-" + $0147bee01cff6558$var$_lut[d1 & 0xff] + $0147bee01cff6558$var$_lut[d1 >> 8 & 0xff] + "-" + $0147bee01cff6558$var$_lut[d1 >> 16 & 0x0f | 0x40] + $0147bee01cff6558$var$_lut[d1 >> 24 & 0xff] + "-" + $0147bee01cff6558$var$_lut[d2 & 0x3f | 0x80] + $0147bee01cff6558$var$_lut[d2 >> 8 & 0xff] + "-" + $0147bee01cff6558$var$_lut[d2 >> 16 & 0xff] + $0147bee01cff6558$var$_lut[d2 >> 24 & 0xff] + $0147bee01cff6558$var$_lut[d3 & 0xff] + $0147bee01cff6558$var$_lut[d3 >> 8 & 0xff] + $0147bee01cff6558$var$_lut[d3 >> 16 & 0xff] + $0147bee01cff6558$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $0147bee01cff6558$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $0147bee01cff6558$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $0147bee01cff6558$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $0147bee01cff6558$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $0147bee01cff6558$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $0147bee01cff6558$var$damp(x, y, lambda, dt) {
    return $0147bee01cff6558$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $0147bee01cff6558$var$pingpong(x, length = 1) {
    return length - Math.abs($0147bee01cff6558$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $0147bee01cff6558$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $0147bee01cff6558$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $0147bee01cff6558$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $0147bee01cff6558$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $0147bee01cff6558$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $0147bee01cff6558$var$seededRandom(s) {
    if (s !== undefined) $0147bee01cff6558$var$_seed = s;
    // Mulberry32 generator
    let t = $0147bee01cff6558$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $0147bee01cff6558$var$degToRad(degrees) {
    return degrees * $0147bee01cff6558$var$DEG2RAD;
}
function $0147bee01cff6558$var$radToDeg(radians) {
    return radians * $0147bee01cff6558$var$RAD2DEG;
}
function $0147bee01cff6558$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $0147bee01cff6558$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $0147bee01cff6558$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $0147bee01cff6558$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case "XYX":
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case "YZY":
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case "ZXZ":
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case "XZX":
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case "YXY":
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case "ZYZ":
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
    }
}
function $0147bee01cff6558$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error("Invalid component type.");
    }
}
function $0147bee01cff6558$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error("Invalid component type.");
    }
}
const $0147bee01cff6558$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $0147bee01cff6558$var$DEG2RAD,
    RAD2DEG: $0147bee01cff6558$var$RAD2DEG,
    generateUUID: $0147bee01cff6558$var$generateUUID,
    clamp: $0147bee01cff6558$var$clamp,
    euclideanModulo: $0147bee01cff6558$var$euclideanModulo,
    mapLinear: $0147bee01cff6558$var$mapLinear,
    inverseLerp: $0147bee01cff6558$var$inverseLerp,
    lerp: $0147bee01cff6558$var$lerp,
    damp: $0147bee01cff6558$var$damp,
    pingpong: $0147bee01cff6558$var$pingpong,
    smoothstep: $0147bee01cff6558$var$smoothstep,
    smootherstep: $0147bee01cff6558$var$smootherstep,
    randInt: $0147bee01cff6558$var$randInt,
    randFloat: $0147bee01cff6558$var$randFloat,
    randFloatSpread: $0147bee01cff6558$var$randFloatSpread,
    seededRandom: $0147bee01cff6558$var$seededRandom,
    degToRad: $0147bee01cff6558$var$degToRad,
    radToDeg: $0147bee01cff6558$var$radToDeg,
    isPowerOfTwo: $0147bee01cff6558$var$isPowerOfTwo,
    ceilPowerOfTwo: $0147bee01cff6558$var$ceilPowerOfTwo,
    floorPowerOfTwo: $0147bee01cff6558$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $0147bee01cff6558$var$setQuaternionFromProperEuler,
    normalize: $0147bee01cff6558$var$normalize,
    denormalize: $0147bee01cff6558$var$denormalize
};
class $0147bee01cff6558$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        $0147bee01cff6558$export$c977b3e384af9ae1.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($0147bee01cff6558$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
class $0147bee01cff6558$export$8ff26dafa08918 {
    constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        $0147bee01cff6558$export$8ff26dafa08918.prototype.isMatrix3 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    //
    scale(sx, sy) {
        this.premultiply($0147bee01cff6558$var$_m3.makeScale(sx, sy));
        return this;
    }
    rotate(theta) {
        this.premultiply($0147bee01cff6558$var$_m3.makeRotation(-theta));
        return this;
    }
    translate(tx, ty) {
        this.premultiply($0147bee01cff6558$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    //
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $0147bee01cff6558$var$_m3 = /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918();
function $0147bee01cff6558$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $0147bee01cff6558$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $0147bee01cff6558$var$getTypedArray(type, buffer) {
    return new $0147bee01cff6558$var$TYPED_ARRAYS[type](buffer);
}
function $0147bee01cff6558$var$createElementNS(name) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", name);
}
const $0147bee01cff6558$var$_cache = {};
function $0147bee01cff6558$var$warnOnce(message) {
    if (message in $0147bee01cff6558$var$_cache) return;
    $0147bee01cff6558$var$_cache[message] = true;
    console.warn(message);
}
function $0147bee01cff6558$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $0147bee01cff6558$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
/**
 * Matrices converting P3 <-> Rec. 709 primaries, without gamut mapping
 * or clipping. Based on W3C specifications for sRGB and Display P3,
 * and ICC specifications for the D50 connection space. Values in/out
 * are _linear_ sRGB and _linear_ Display P3.
 *
 * Note that both sRGB and Display P3 use the sRGB transfer functions.
 *
 * Reference:
 * - http://www.russellcottrell.com/photo/matrixCalculator.htm
 */ const $0147bee01cff6558$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918().fromArray([
    0.8224621,
    0.0331941,
    0.0170827,
    0.1775380,
    0.9668058,
    0.0723974,
    -0.0000001,
    0.0000001,
    0.9105199
]);
const $0147bee01cff6558$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918().fromArray([
    1.2249401,
    -0.0420569,
    -0.0196376,
    -0.2249404,
    1.0420571,
    -0.0786361,
    0.0000001,
    0.0000000,
    1.0982735
]);
function $0147bee01cff6558$var$DisplayP3ToLinearSRGB(color) {
    // Display P3 uses the sRGB transfer functions
    return color.convertSRGBToLinear().applyMatrix3($0147bee01cff6558$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB);
}
function $0147bee01cff6558$var$LinearSRGBToDisplayP3(color) {
    // Display P3 uses the sRGB transfer functions
    return color.applyMatrix3($0147bee01cff6558$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3).convertLinearToSRGB();
}
// Conversions from <source> to Linear-sRGB reference space.
const $0147bee01cff6558$var$TO_LINEAR = {
    [$0147bee01cff6558$export$42429b3acfb233a4]: (color)=>color,
    [$0147bee01cff6558$export$561f394b24edfcaa]: (color)=>color.convertSRGBToLinear(),
    [$0147bee01cff6558$export$626af19ae879bdf6]: $0147bee01cff6558$var$DisplayP3ToLinearSRGB
};
// Conversions to <target> from Linear-sRGB reference space.
const $0147bee01cff6558$var$FROM_LINEAR = {
    [$0147bee01cff6558$export$42429b3acfb233a4]: (color)=>color,
    [$0147bee01cff6558$export$561f394b24edfcaa]: (color)=>color.convertLinearToSRGB(),
    [$0147bee01cff6558$export$626af19ae879bdf6]: $0147bee01cff6558$var$LinearSRGBToDisplayP3
};
const $0147bee01cff6558$export$5e6fd513f44698c = {
    enabled: true,
    get legacyMode () {
        console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.");
        return !this.enabled;
    },
    set legacyMode (legacyMode){
        console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.");
        this.enabled = !legacyMode;
    },
    get workingColorSpace () {
        return $0147bee01cff6558$export$42429b3acfb233a4;
    },
    set workingColorSpace (colorSpace){
        console.warn("THREE.ColorManagement: .workingColorSpace is readonly.");
    },
    convert: function(color, sourceColorSpace, targetColorSpace) {
        if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
        const sourceToLinear = $0147bee01cff6558$var$TO_LINEAR[sourceColorSpace];
        const targetFromLinear = $0147bee01cff6558$var$FROM_LINEAR[targetColorSpace];
        if (sourceToLinear === undefined || targetFromLinear === undefined) throw new Error(`Unsupported color space conversion, "${sourceColorSpace}" to "${targetColorSpace}".`);
        return targetFromLinear(sourceToLinear(color));
    },
    fromWorkingColorSpace: function(color, targetColorSpace) {
        return this.convert(color, this.workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color, sourceColorSpace) {
        return this.convert(color, sourceColorSpace, this.workingColorSpace);
    }
};
let $0147bee01cff6558$var$_canvas;
class $0147bee01cff6558$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === "undefined") return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($0147bee01cff6558$var$_canvas === undefined) $0147bee01cff6558$var$_canvas = $0147bee01cff6558$var$createElementNS("canvas");
            $0147bee01cff6558$var$_canvas.width = image.width;
            $0147bee01cff6558$var$_canvas.height = image.height;
            const context = $0147bee01cff6558$var$_canvas.getContext("2d");
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $0147bee01cff6558$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", image);
            return canvas.toDataURL("image/jpeg", 0.6);
        } else return canvas.toDataURL("image/png");
    }
    static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
            const canvas = $0147bee01cff6558$var$createElementNS("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext("2d");
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $0147bee01cff6558$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($0147bee01cff6558$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $0147bee01cff6558$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.");
            return image;
        }
    }
}
let $0147bee01cff6558$var$sourceId = 0;
class $0147bee01cff6558$export$1d2df86270c81ecb {
    constructor(data = null){
        this.isSource = true;
        Object.defineProperty(this, "id", {
            value: $0147bee01cff6558$var$sourceId++
        });
        this.uuid = $0147bee01cff6558$var$generateUUID();
        this.data = data;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ""
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($0147bee01cff6558$var$serializeImage(data[i].image));
                else url.push($0147bee01cff6558$var$serializeImage(data[i]));
            } else // texture
            url = $0147bee01cff6558$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $0147bee01cff6558$var$serializeImage(image) {
    if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) // default images
    return $0147bee01cff6558$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn("THREE.Texture: Unable to serialize Texture.");
            return {};
        }
    }
}
let $0147bee01cff6558$var$textureId = 0;
class $0147bee01cff6558$export$5431306cf43de24a extends $0147bee01cff6558$export$ec8b666c5fe2c75a {
    constructor(image = $0147bee01cff6558$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $0147bee01cff6558$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $0147bee01cff6558$export$9d9334239a5a5e06, wrapT = $0147bee01cff6558$export$9d9334239a5a5e06, magFilter = $0147bee01cff6558$export$8a72f490b25c56c8, minFilter = $0147bee01cff6558$export$5d8599b6a933fb1b, format = $0147bee01cff6558$export$3f8bb04b555a363c, type = $0147bee01cff6558$export$2e8ce08d3f6f5e10, anisotropy = $0147bee01cff6558$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace1 = $0147bee01cff6558$export$bfcb490c2dd3db51){
        super();
        this.isTexture = true;
        Object.defineProperty(this, "id", {
            value: $0147bee01cff6558$var$textureId++
        });
        this.uuid = $0147bee01cff6558$var$generateUUID();
        this.name = "";
        this.source = new $0147bee01cff6558$export$1d2df86270c81ecb(image);
        this.mipmaps = [];
        this.mapping = mapping;
        this.channel = 0;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $0147bee01cff6558$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1);
        this.center = new $0147bee01cff6558$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $0147bee01cff6558$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        if (typeof colorSpace1 === "string") this.colorSpace = colorSpace1;
        else {
            $0147bee01cff6558$var$warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace.");
            this.colorSpace = colorSpace1 === $0147bee01cff6558$export$f32388edbb32674 ? $0147bee01cff6558$export$561f394b24edfcaa : $0147bee01cff6558$export$bfcb490c2dd3db51;
        }
        this.userData = {};
        this.version = 0;
        this.onUpdate = null;
        this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        this.needsPMREMUpdate = false; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
    }
    get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.6,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(uv) {
        if (this.mapping !== $0147bee01cff6558$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $0147bee01cff6558$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $0147bee01cff6558$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $0147bee01cff6558$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $0147bee01cff6558$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $0147bee01cff6558$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $0147bee01cff6558$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    get encoding() {
        $0147bee01cff6558$var$warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace.");
        return this.colorSpace === $0147bee01cff6558$export$561f394b24edfcaa ? $0147bee01cff6558$export$f32388edbb32674 : $0147bee01cff6558$export$7207336e4151a112;
    }
    set encoding(encoding) {
        $0147bee01cff6558$var$warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace.");
        this.colorSpace = encoding === $0147bee01cff6558$export$f32388edbb32674 ? $0147bee01cff6558$export$561f394b24edfcaa : $0147bee01cff6558$export$bfcb490c2dd3db51;
    }
}
$0147bee01cff6558$export$5431306cf43de24a.DEFAULT_IMAGE = null;
$0147bee01cff6558$export$5431306cf43de24a.DEFAULT_MAPPING = $0147bee01cff6558$export$1beec6768cbb3d2d;
$0147bee01cff6558$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
class $0147bee01cff6558$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        $0147bee01cff6558$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $0147bee01cff6558$export$efcb1f8bf367cbfb extends $0147bee01cff6558$export$ec8b666c5fe2c75a {
    constructor(width = 1, height = 1, options = {}){
        super();
        this.isRenderTarget = true;
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $0147bee01cff6558$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $0147bee01cff6558$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: 1
        };
        if (options.encoding !== undefined) {
            // @deprecated, r152
            $0147bee01cff6558$var$warnOnce("THREE.WebGLRenderTarget: option.encoding has been replaced by option.colorSpace.");
            options.colorSpace = options.encoding === $0147bee01cff6558$export$f32388edbb32674 ? $0147bee01cff6558$export$561f394b24edfcaa : $0147bee01cff6558$export$bfcb490c2dd3db51;
        }
        this.texture = new $0147bee01cff6558$export$5431306cf43de24a(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        this.texture.isRenderTargetTexture = true;
        this.texture.flipY = false;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.internalFormat = options.internalFormat !== undefined ? options.internalFormat : null;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $0147bee01cff6558$export$8a72f490b25c56c8;
        this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
        this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;
        this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
        this.samples = options.samples !== undefined ? options.samples : 0;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            this.texture.image.width = width;
            this.texture.image.height = height;
            this.texture.image.depth = depth;
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.texture = source.texture.clone();
        this.texture.isRenderTargetTexture = true;
        // ensure image object is not shared, see #20328
        const image = Object.assign({}, source.texture.image);
        this.texture.source = new $0147bee01cff6558$export$1d2df86270c81ecb(image);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $0147bee01cff6558$export$3c052beb2e51e23f extends $0147bee01cff6558$export$efcb1f8bf367cbfb {
    constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        this.isWebGLRenderTarget = true;
    }
}
class $0147bee01cff6558$export$dfac6c8e811406a3 extends $0147bee01cff6558$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.isDataArrayTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $0147bee01cff6558$export$727aa5ec3fe39bf0;
        this.minFilter = $0147bee01cff6558$export$727aa5ec3fe39bf0;
        this.wrapR = $0147bee01cff6558$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $0147bee01cff6558$export$c77a02c11ed180c7 extends $0147bee01cff6558$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1){
        super(width, height);
        this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        this.texture = new $0147bee01cff6558$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $0147bee01cff6558$export$d7a3086320f856db extends $0147bee01cff6558$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.isData3DTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $0147bee01cff6558$export$727aa5ec3fe39bf0;
        this.minFilter = $0147bee01cff6558$export$727aa5ec3fe39bf0;
        this.wrapR = $0147bee01cff6558$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $0147bee01cff6558$export$7ee06591009639df extends $0147bee01cff6558$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1){
        super(width, height);
        this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        this.texture = new $0147bee01cff6558$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $0147bee01cff6558$export$bd934554fb721730 extends $0147bee01cff6558$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, count = 1, options = {}){
        super(width, height, options);
        this.isWebGLMultipleRenderTargets = true;
        const texture = this.texture;
        this.texture = [];
        for(let i = 0; i < count; i++){
            this.texture[i] = texture.clone();
            this.texture[i].isRenderTargetTexture = true;
        }
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.texture.length; i < il; i++){
                this.texture[i].image.width = width;
                this.texture[i].image.height = height;
                this.texture[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    copy(source) {
        this.dispose();
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.texture.length = 0;
        for(let i = 0, il = source.texture.length; i < il; i++){
            this.texture[i] = source.texture[i].clone();
            this.texture[i].isRenderTargetTexture = true;
        }
        return this;
    }
}
class $0147bee01cff6558$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case "XYZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "YXZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "ZXY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "ZYX":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "YZX":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "XZY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + order);
        }
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($0147bee01cff6558$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize();
            this._onChangeCallback();
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // Derived from http://planning.cs.uiuc.edu/node198.html
        // Note, this source uses w, x, y, z ordering,
        // so we swap the order below.
        const u1 = Math.random();
        const sqrt1u1 = Math.sqrt(1 - u1);
        const sqrtu1 = Math.sqrt(u1);
        const u2 = 2 * Math.PI * Math.random();
        const u3 = 2 * Math.PI * Math.random();
        return this.set(sqrt1u1 * Math.cos(u2), sqrtu1 * Math.sin(u3), sqrtu1 * Math.cos(u3), sqrt1u1 * Math.sin(u2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        return this;
    }
    toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
class $0147bee01cff6558$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        $0147bee01cff6558$export$64b5c384219d3699.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        return this.applyQuaternion($0147bee01cff6558$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($0147bee01cff6558$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        const x = this.x, y = this.y, z = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // calculate quat * vector
        const ix = qw * x + qy * z - qz * y;
        const iy = qw * y + qz * x - qx * z;
        const iz = qw * z + qx * y - qy * x;
        const iw = -qx * x - qy * y - qz * z;
        // calculate result * inverse quat
        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v) {
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $0147bee01cff6558$var$_vector$b.copy(this).projectOnVector(planeNormal);
        return this.sub($0147bee01cff6558$var$_vector$b);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($0147bee01cff6558$var$_vector$b.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($0147bee01cff6558$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // Derived from https://mathworld.wolfram.com/SpherePointPicking.html
        const u = (Math.random() - 0.5) * 2;
        const t = Math.random() * Math.PI * 2;
        const f = Math.sqrt(1 - u ** 2);
        this.x = f * Math.cos(t);
        this.y = f * Math.sin(t);
        this.z = u;
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $0147bee01cff6558$var$_vector$b = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_quaternion$4 = /*@__PURE__*/ new $0147bee01cff6558$export$23d6a54f0bbc85a3();
class $0147bee01cff6558$export$6f7d5a9418ab2aa3 {
    constructor(min = new $0147bee01cff6558$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $0147bee01cff6558$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.isBox3 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($0147bee01cff6558$var$_vector$a.fromArray(array, i));
        return this;
    }
    setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($0147bee01cff6558$var$_vector$a.fromBufferAttribute(attribute, i));
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $0147bee01cff6558$var$_vector$a.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        if (object.boundingBox !== undefined) {
            if (object.boundingBox === null) object.computeBoundingBox();
            $0147bee01cff6558$var$_box$3.copy(object.boundingBox);
            $0147bee01cff6558$var$_box$3.applyMatrix4(object.matrixWorld);
            this.union($0147bee01cff6558$var$_box$3);
        } else {
            const geometry = object.geometry;
            if (geometry !== undefined) {
                if (precise && geometry.attributes !== undefined && geometry.attributes.position !== undefined) {
                    const position = geometry.attributes.position;
                    for(let i = 0, l = position.count; i < l; i++){
                        $0147bee01cff6558$var$_vector$a.fromBufferAttribute(position, i).applyMatrix4(object.matrixWorld);
                        this.expandByPoint($0147bee01cff6558$var$_vector$a);
                    }
                } else {
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $0147bee01cff6558$var$_box$3.copy(geometry.boundingBox);
                    $0147bee01cff6558$var$_box$3.applyMatrix4(object.matrixWorld);
                    this.union($0147bee01cff6558$var$_box$3);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $0147bee01cff6558$var$_vector$a);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $0147bee01cff6558$var$_vector$a.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($0147bee01cff6558$var$_center);
        $0147bee01cff6558$var$_extents.subVectors(this.max, $0147bee01cff6558$var$_center);
        // translate triangle to aabb origin
        $0147bee01cff6558$var$_v0$2.subVectors(triangle.a, $0147bee01cff6558$var$_center);
        $0147bee01cff6558$var$_v1$7.subVectors(triangle.b, $0147bee01cff6558$var$_center);
        $0147bee01cff6558$var$_v2$4.subVectors(triangle.c, $0147bee01cff6558$var$_center);
        // compute edge vectors for triangle
        $0147bee01cff6558$var$_f0.subVectors($0147bee01cff6558$var$_v1$7, $0147bee01cff6558$var$_v0$2);
        $0147bee01cff6558$var$_f1.subVectors($0147bee01cff6558$var$_v2$4, $0147bee01cff6558$var$_v1$7);
        $0147bee01cff6558$var$_f2.subVectors($0147bee01cff6558$var$_v0$2, $0147bee01cff6558$var$_v2$4);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$0147bee01cff6558$var$_f0.z,
            $0147bee01cff6558$var$_f0.y,
            0,
            -$0147bee01cff6558$var$_f1.z,
            $0147bee01cff6558$var$_f1.y,
            0,
            -$0147bee01cff6558$var$_f2.z,
            $0147bee01cff6558$var$_f2.y,
            $0147bee01cff6558$var$_f0.z,
            0,
            -$0147bee01cff6558$var$_f0.x,
            $0147bee01cff6558$var$_f1.z,
            0,
            -$0147bee01cff6558$var$_f1.x,
            $0147bee01cff6558$var$_f2.z,
            0,
            -$0147bee01cff6558$var$_f2.x,
            -$0147bee01cff6558$var$_f0.y,
            $0147bee01cff6558$var$_f0.x,
            0,
            -$0147bee01cff6558$var$_f1.y,
            $0147bee01cff6558$var$_f1.x,
            0,
            -$0147bee01cff6558$var$_f2.y,
            $0147bee01cff6558$var$_f2.x,
            0
        ];
        if (!$0147bee01cff6558$var$satForAxes(axes, $0147bee01cff6558$var$_v0$2, $0147bee01cff6558$var$_v1$7, $0147bee01cff6558$var$_v2$4, $0147bee01cff6558$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$0147bee01cff6558$var$satForAxes(axes, $0147bee01cff6558$var$_v0$2, $0147bee01cff6558$var$_v1$7, $0147bee01cff6558$var$_v2$4, $0147bee01cff6558$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $0147bee01cff6558$var$_triangleNormal.crossVectors($0147bee01cff6558$var$_f0, $0147bee01cff6558$var$_f1);
        axes = [
            $0147bee01cff6558$var$_triangleNormal.x,
            $0147bee01cff6558$var$_triangleNormal.y,
            $0147bee01cff6558$var$_triangleNormal.z
        ];
        return $0147bee01cff6558$var$satForAxes(axes, $0147bee01cff6558$var$_v0$2, $0147bee01cff6558$var$_v1$7, $0147bee01cff6558$var$_v2$4, $0147bee01cff6558$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $0147bee01cff6558$var$_vector$a).distanceTo(point);
    }
    getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($0147bee01cff6558$var$_vector$a).length() * 0.5;
        }
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $0147bee01cff6558$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $0147bee01cff6558$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $0147bee01cff6558$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $0147bee01cff6558$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $0147bee01cff6558$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $0147bee01cff6558$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $0147bee01cff6558$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $0147bee01cff6558$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($0147bee01cff6558$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $0147bee01cff6558$var$_points = [
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699()
];
const $0147bee01cff6558$var$_vector$a = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_box$3 = /*@__PURE__*/ new $0147bee01cff6558$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $0147bee01cff6558$var$_v0$2 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_v1$7 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_v2$4 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
// triangle edge vectors
const $0147bee01cff6558$var$_f0 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_f1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_f2 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_center = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_extents = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_triangleNormal = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_testAxis = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
function $0147bee01cff6558$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $0147bee01cff6558$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($0147bee01cff6558$var$_testAxis.x) + extents.y * Math.abs($0147bee01cff6558$var$_testAxis.y) + extents.z * Math.abs($0147bee01cff6558$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($0147bee01cff6558$var$_testAxis);
        const p1 = v1.dot($0147bee01cff6558$var$_testAxis);
        const p2 = v2.dot($0147bee01cff6558$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $0147bee01cff6558$var$_box$2 = /*@__PURE__*/ new $0147bee01cff6558$export$6f7d5a9418ab2aa3();
const $0147bee01cff6558$var$_v1$6 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_v2$3 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$805e8b72413ccaba {
    constructor(center = new $0147bee01cff6558$export$64b5c384219d3699(), radius = -1){
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $0147bee01cff6558$var$_box$2.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $0147bee01cff6558$var$_v1$6.subVectors(point, this.center);
        const lengthSq = $0147bee01cff6558$var$_v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($0147bee01cff6558$var$_v1$6, delta / length);
            this.radius += delta;
        }
        return this;
    }
    union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $0147bee01cff6558$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($0147bee01cff6558$var$_v1$6.copy(sphere.center).add($0147bee01cff6558$var$_v2$3));
            this.expandByPoint($0147bee01cff6558$var$_v1$6.copy(sphere.center).sub($0147bee01cff6558$var$_v2$3));
        }
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $0147bee01cff6558$var$_vector$9 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_segCenter = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_segDir = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_diff = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_edge1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_edge2 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_normal$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$a186db52eed6d40e {
    constructor(origin = new $0147bee01cff6558$export$64b5c384219d3699(), direction = new $0147bee01cff6558$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $0147bee01cff6558$var$_vector$9));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $0147bee01cff6558$var$_vector$9.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $0147bee01cff6558$var$_vector$9.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $0147bee01cff6558$var$_vector$9.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $0147bee01cff6558$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $0147bee01cff6558$var$_segDir.copy(v1).sub(v0).normalize();
        $0147bee01cff6558$var$_diff.copy(this.origin).sub($0147bee01cff6558$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($0147bee01cff6558$var$_segDir);
        const b0 = $0147bee01cff6558$var$_diff.dot(this.direction);
        const b1 = -$0147bee01cff6558$var$_diff.dot($0147bee01cff6558$var$_segDir);
        const c = $0147bee01cff6558$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($0147bee01cff6558$var$_segCenter).addScaledVector($0147bee01cff6558$var$_segDir, s1);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $0147bee01cff6558$var$_vector$9.subVectors(sphere.center, this.origin);
        const tca = $0147bee01cff6558$var$_vector$9.dot(this.direction);
        const d2 = $0147bee01cff6558$var$_vector$9.dot($0147bee01cff6558$var$_vector$9) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $0147bee01cff6558$var$_vector$9) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $0147bee01cff6558$var$_edge1.subVectors(b, a);
        $0147bee01cff6558$var$_edge2.subVectors(c, a);
        $0147bee01cff6558$var$_normal$1.crossVectors($0147bee01cff6558$var$_edge1, $0147bee01cff6558$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($0147bee01cff6558$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $0147bee01cff6558$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($0147bee01cff6558$var$_edge2.crossVectors($0147bee01cff6558$var$_diff, $0147bee01cff6558$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($0147bee01cff6558$var$_edge1.cross($0147bee01cff6558$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $0147bee01cff6558$var$_diff.dot($0147bee01cff6558$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $0147bee01cff6558$export$2ae72fc923e5eb5 {
    constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        $0147bee01cff6558$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $0147bee01cff6558$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $0147bee01cff6558$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $0147bee01cff6558$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $0147bee01cff6558$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === "XYZ") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === "YXZ") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === "ZXY") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === "ZYX") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === "YZX") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === "XZY") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($0147bee01cff6558$var$_zero, q, $0147bee01cff6558$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $0147bee01cff6558$var$_z.subVectors(eye, target);
        if ($0147bee01cff6558$var$_z.lengthSq() === 0) // eye and target are in the same position
        $0147bee01cff6558$var$_z.z = 1;
        $0147bee01cff6558$var$_z.normalize();
        $0147bee01cff6558$var$_x.crossVectors(up, $0147bee01cff6558$var$_z);
        if ($0147bee01cff6558$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $0147bee01cff6558$var$_z.x += 0.0001;
            else $0147bee01cff6558$var$_z.z += 0.0001;
            $0147bee01cff6558$var$_z.normalize();
            $0147bee01cff6558$var$_x.crossVectors(up, $0147bee01cff6558$var$_z);
        }
        $0147bee01cff6558$var$_x.normalize();
        $0147bee01cff6558$var$_y.crossVectors($0147bee01cff6558$var$_z, $0147bee01cff6558$var$_x);
        te[0] = $0147bee01cff6558$var$_x.x;
        te[4] = $0147bee01cff6558$var$_y.x;
        te[8] = $0147bee01cff6558$var$_z.x;
        te[1] = $0147bee01cff6558$var$_x.y;
        te[5] = $0147bee01cff6558$var$_y.y;
        te[9] = $0147bee01cff6558$var$_z.y;
        te[2] = $0147bee01cff6558$var$_x.z;
        te[6] = $0147bee01cff6558$var$_y.z;
        te[10] = $0147bee01cff6558$var$_z.z;
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $0147bee01cff6558$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $0147bee01cff6558$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $0147bee01cff6558$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $0147bee01cff6558$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $0147bee01cff6558$var$_m1$2.elements[0] *= invSX;
        $0147bee01cff6558$var$_m1$2.elements[1] *= invSX;
        $0147bee01cff6558$var$_m1$2.elements[2] *= invSX;
        $0147bee01cff6558$var$_m1$2.elements[4] *= invSY;
        $0147bee01cff6558$var$_m1$2.elements[5] *= invSY;
        $0147bee01cff6558$var$_m1$2.elements[6] *= invSY;
        $0147bee01cff6558$var$_m1$2.elements[8] *= invSZ;
        $0147bee01cff6558$var$_m1$2.elements[9] *= invSZ;
        $0147bee01cff6558$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($0147bee01cff6558$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far, coordinateSystem = $0147bee01cff6558$export$5a0e9190d10875d3) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (coordinateSystem === $0147bee01cff6558$export$5a0e9190d10875d3) {
            c = -(far + near) / (far - near);
            d = -2 * far * near / (far - near);
        } else if (coordinateSystem === $0147bee01cff6558$export$cc83beedcb9be9ac) {
            c = -far / (far - near);
            d = -far * near / (far - near);
        } else throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + coordinateSystem);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = $0147bee01cff6558$export$5a0e9190d10875d3) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        let z, zInv;
        if (coordinateSystem === $0147bee01cff6558$export$5a0e9190d10875d3) {
            z = (far + near) * p;
            zInv = -2 * p;
        } else if (coordinateSystem === $0147bee01cff6558$export$cc83beedcb9be9ac) {
            z = near * p;
            zInv = -1 * p;
        } else throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + coordinateSystem);
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = zInv;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $0147bee01cff6558$var$_v1$5 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_m1$2 = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_zero = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(0, 0, 0);
const $0147bee01cff6558$var$_one = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(1, 1, 1);
const $0147bee01cff6558$var$_x = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_y = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_z = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_matrix = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_quaternion$3 = /*@__PURE__*/ new $0147bee01cff6558$export$23d6a54f0bbc85a3();
class $0147bee01cff6558$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $0147bee01cff6558$export$d93cc409a0768c5f.DEFAULT_ORDER){
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case "XYZ":
                this._y = Math.asin($0147bee01cff6558$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case "YXZ":
                this._x = Math.asin(-$0147bee01cff6558$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case "ZXY":
                this._x = Math.asin($0147bee01cff6558$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case "ZYX":
                this._y = Math.asin(-$0147bee01cff6558$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case "YZX":
                this._z = Math.asin($0147bee01cff6558$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case "XZY":
                this._z = Math.asin(-$0147bee01cff6558$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $0147bee01cff6558$var$_matrix.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($0147bee01cff6558$var$_matrix, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $0147bee01cff6558$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($0147bee01cff6558$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
$0147bee01cff6558$export$d93cc409a0768c5f.DEFAULT_ORDER = "XYZ";
class $0147bee01cff6558$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
}
let $0147bee01cff6558$var$_object3DId = 0;
const $0147bee01cff6558$var$_v1$4 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_q1 = /*@__PURE__*/ new $0147bee01cff6558$export$23d6a54f0bbc85a3();
const $0147bee01cff6558$var$_m1$1 = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_target = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_position$3 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_scale$2 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_quaternion$2 = /*@__PURE__*/ new $0147bee01cff6558$export$23d6a54f0bbc85a3();
const $0147bee01cff6558$var$_xAxis = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(1, 0, 0);
const $0147bee01cff6558$var$_yAxis = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(0, 1, 0);
const $0147bee01cff6558$var$_zAxis = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(0, 0, 1);
const $0147bee01cff6558$var$_addedEvent = {
    type: "added"
};
const $0147bee01cff6558$var$_removedEvent = {
    type: "removed"
};
class $0147bee01cff6558$export$e4dd07dff30cc924 extends $0147bee01cff6558$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isObject3D = true;
        Object.defineProperty(this, "id", {
            value: $0147bee01cff6558$var$_object3DId++
        });
        this.uuid = $0147bee01cff6558$var$generateUUID();
        this.name = "";
        this.type = "Object3D";
        this.parent = null;
        this.children = [];
        this.up = $0147bee01cff6558$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $0147bee01cff6558$export$64b5c384219d3699();
        const rotation = new $0147bee01cff6558$export$d93cc409a0768c5f();
        const quaternion = new $0147bee01cff6558$export$23d6a54f0bbc85a3();
        const scale = new $0147bee01cff6558$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $0147bee01cff6558$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $0147bee01cff6558$export$8ff26dafa08918()
            }
        });
        this.matrix = new $0147bee01cff6558$export$2ae72fc923e5eb5();
        this.matrixWorld = new $0147bee01cff6558$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $0147bee01cff6558$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        this.matrixWorldNeedsUpdate = false;
        this.matrixWorldAutoUpdate = $0147bee01cff6558$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        this.layers = new $0147bee01cff6558$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $0147bee01cff6558$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($0147bee01cff6558$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $0147bee01cff6558$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($0147bee01cff6558$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($0147bee01cff6558$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($0147bee01cff6558$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($0147bee01cff6558$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $0147bee01cff6558$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($0147bee01cff6558$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($0147bee01cff6558$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($0147bee01cff6558$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($0147bee01cff6558$var$_zAxis, distance);
    }
    localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($0147bee01cff6558$var$_m1$1.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $0147bee01cff6558$var$_target.copy(x);
        else $0147bee01cff6558$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $0147bee01cff6558$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $0147bee01cff6558$var$_m1$1.lookAt($0147bee01cff6558$var$_position$3, $0147bee01cff6558$var$_target, this.up);
        else $0147bee01cff6558$var$_m1$1.lookAt($0147bee01cff6558$var$_target, $0147bee01cff6558$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($0147bee01cff6558$var$_m1$1);
        if (parent) {
            $0147bee01cff6558$var$_m1$1.extractRotation(parent.matrixWorld);
            $0147bee01cff6558$var$_q1.setFromRotationMatrix($0147bee01cff6558$var$_m1$1);
            this.quaternion.premultiply($0147bee01cff6558$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error("THREE.Object3D.add: object can't be added as a child of itself.", object);
            return this;
        }
        if (object && object.isObject3D) {
            if (object.parent !== null) object.parent.remove(object);
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($0147bee01cff6558$var$_addedEvent);
        } else console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($0147bee01cff6558$var$_removedEvent);
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        for(let i = 0; i < this.children.length; i++){
            const object = this.children[i];
            object.parent = null;
            object.dispatchEvent($0147bee01cff6558$var$_removedEvent);
        }
        this.children.length = 0;
        return this;
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $0147bee01cff6558$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $0147bee01cff6558$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($0147bee01cff6558$var$_m1$1);
        this.add(object);
        object.updateWorldMatrix(false, true);
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty("id", id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty("name", name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getObjectsByProperty(name, value) {
        let result = [];
        if (this[name] === value) result.push(this);
        for(let i = 0, l = this.children.length; i < l; i++){
            const childResult = this.children[i].getObjectsByProperty(name, value);
            if (childResult.length > 0) result = result.concat(childResult);
        }
        return result;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($0147bee01cff6558$var$_position$3, target, $0147bee01cff6558$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($0147bee01cff6558$var$_position$3, $0147bee01cff6558$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // update children
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            if (child.matrixWorldAutoUpdate === true || force === true) child.updateMatrixWorld(force);
        }
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null && parent.matrixWorldAutoUpdate === true) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.parent === null) this.matrixWorld.copy(this.matrix);
        else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        // update children
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                if (child.matrixWorldAutoUpdate === true) child.updateWorldMatrix(false, true);
            }
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === "string";
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.6,
                type: "Object",
                generator: "Object3D.toJSON"
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== "") object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = "InstancedMesh";
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations.slice();
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
$0147bee01cff6558$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(0, 1, 0);
$0147bee01cff6558$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
$0147bee01cff6558$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const $0147bee01cff6558$var$_v0$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_v1$3 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_v2$2 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_v3$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vab = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vac = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vbc = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vap = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vbp = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vcp = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
let $0147bee01cff6558$var$warnedGetUV = false;
class $0147bee01cff6558$export$5a465592bfe74b48 {
    constructor(a = new $0147bee01cff6558$export$64b5c384219d3699(), b = new $0147bee01cff6558$export$64b5c384219d3699(), c = new $0147bee01cff6558$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $0147bee01cff6558$var$_v0$1.subVectors(a, b);
        target.cross($0147bee01cff6558$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $0147bee01cff6558$var$_v0$1.subVectors(c, a);
        $0147bee01cff6558$var$_v1$3.subVectors(b, a);
        $0147bee01cff6558$var$_v2$2.subVectors(point, a);
        const dot00 = $0147bee01cff6558$var$_v0$1.dot($0147bee01cff6558$var$_v0$1);
        const dot01 = $0147bee01cff6558$var$_v0$1.dot($0147bee01cff6558$var$_v1$3);
        const dot02 = $0147bee01cff6558$var$_v0$1.dot($0147bee01cff6558$var$_v2$2);
        const dot11 = $0147bee01cff6558$var$_v1$3.dot($0147bee01cff6558$var$_v1$3);
        const dot12 = $0147bee01cff6558$var$_v1$3.dot($0147bee01cff6558$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        this.getBarycoord(point, a, b, c, $0147bee01cff6558$var$_v3$1);
        return $0147bee01cff6558$var$_v3$1.x >= 0 && $0147bee01cff6558$var$_v3$1.y >= 0 && $0147bee01cff6558$var$_v3$1.x + $0147bee01cff6558$var$_v3$1.y <= 1;
    }
    static getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
        if ($0147bee01cff6558$var$warnedGetUV === false) {
            console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation().");
            $0147bee01cff6558$var$warnedGetUV = true;
        }
        return this.getInterpolation(point, p1, p2, p3, uv1, uv2, uv3, target);
    }
    static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        this.getBarycoord(point, p1, p2, p3, $0147bee01cff6558$var$_v3$1);
        target.setScalar(0);
        target.addScaledVector(v1, $0147bee01cff6558$var$_v3$1.x);
        target.addScaledVector(v2, $0147bee01cff6558$var$_v3$1.y);
        target.addScaledVector(v3, $0147bee01cff6558$var$_v3$1.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $0147bee01cff6558$var$_v0$1.subVectors(c, b);
        $0147bee01cff6558$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $0147bee01cff6558$var$_v0$1.cross($0147bee01cff6558$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $0147bee01cff6558$var$_v0$1.subVectors(this.c, this.b);
        $0147bee01cff6558$var$_v1$3.subVectors(this.a, this.b);
        return $0147bee01cff6558$var$_v0$1.cross($0147bee01cff6558$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $0147bee01cff6558$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $0147bee01cff6558$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getUV(point, uv1, uv2, uv3, target) {
        if ($0147bee01cff6558$var$warnedGetUV === false) {
            console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation().");
            $0147bee01cff6558$var$warnedGetUV = true;
        }
        return $0147bee01cff6558$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
    }
    getInterpolation(point, v1, v2, v3, target) {
        return $0147bee01cff6558$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    containsPoint(point) {
        return $0147bee01cff6558$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $0147bee01cff6558$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $0147bee01cff6558$var$_vab.subVectors(b, a);
        $0147bee01cff6558$var$_vac.subVectors(c, a);
        $0147bee01cff6558$var$_vap.subVectors(p, a);
        const d1 = $0147bee01cff6558$var$_vab.dot($0147bee01cff6558$var$_vap);
        const d2 = $0147bee01cff6558$var$_vac.dot($0147bee01cff6558$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $0147bee01cff6558$var$_vbp.subVectors(p, b);
        const d3 = $0147bee01cff6558$var$_vab.dot($0147bee01cff6558$var$_vbp);
        const d4 = $0147bee01cff6558$var$_vac.dot($0147bee01cff6558$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($0147bee01cff6558$var$_vab, v);
        }
        $0147bee01cff6558$var$_vcp.subVectors(p, c);
        const d5 = $0147bee01cff6558$var$_vab.dot($0147bee01cff6558$var$_vcp);
        const d6 = $0147bee01cff6558$var$_vac.dot($0147bee01cff6558$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($0147bee01cff6558$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $0147bee01cff6558$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($0147bee01cff6558$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($0147bee01cff6558$var$_vab, v).addScaledVector($0147bee01cff6558$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
let $0147bee01cff6558$var$materialId = 0;
class $0147bee01cff6558$export$a2d8b23205c25948 extends $0147bee01cff6558$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isMaterial = true;
        Object.defineProperty(this, "id", {
            value: $0147bee01cff6558$var$materialId++
        });
        this.uuid = $0147bee01cff6558$var$generateUUID();
        this.name = "";
        this.type = "Material";
        this.blending = $0147bee01cff6558$export$5b29a26d96ee6af0;
        this.side = $0147bee01cff6558$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.alphaHash = false;
        this.blendSrc = $0147bee01cff6558$export$d5773124e86cf28c;
        this.blendDst = $0147bee01cff6558$export$11d468cc7f19e971;
        this.blendEquation = $0147bee01cff6558$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.depthFunc = $0147bee01cff6558$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $0147bee01cff6558$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $0147bee01cff6558$export$9f542ae4b5baca34;
        this.stencilZFail = $0147bee01cff6558$export$9f542ae4b5baca34;
        this.stencilZPass = $0147bee01cff6558$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.forceSinglePass = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    onBuild() {}
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.6,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $0147bee01cff6558$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $0147bee01cff6558$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = this.transparent;
        data.depthFunc = this.depthFunc;
        data.depthTest = this.depthTest;
        data.depthWrite = this.depthWrite;
        data.colorWrite = this.colorWrite;
        data.stencilWrite = this.stencilWrite;
        data.stencilWriteMask = this.stencilWriteMask;
        data.stencilFunc = this.stencilFunc;
        data.stencilRef = this.stencilRef;
        data.stencilFuncMask = this.stencilFuncMask;
        data.stencilFail = this.stencilFail;
        data.stencilZFail = this.stencilZFail;
        data.stencilZPass = this.stencilZPass;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaHash === true) data.alphaHash = this.alphaHash;
        if (this.alphaToCoverage === true) data.alphaToCoverage = this.alphaToCoverage;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
        if (this.forceSinglePass === true) data.forceSinglePass = this.forceSinglePass;
        if (this.wireframe === true) data.wireframe = this.wireframe;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== "round") data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== "round") data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = this.flatShading;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaHash = source.alphaHash;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
const $0147bee01cff6558$var$_colorKeywords = {
    "aliceblue": 0xF0F8FF,
    "antiquewhite": 0xFAEBD7,
    "aqua": 0x00FFFF,
    "aquamarine": 0x7FFFD4,
    "azure": 0xF0FFFF,
    "beige": 0xF5F5DC,
    "bisque": 0xFFE4C4,
    "black": 0x000000,
    "blanchedalmond": 0xFFEBCD,
    "blue": 0x0000FF,
    "blueviolet": 0x8A2BE2,
    "brown": 0xA52A2A,
    "burlywood": 0xDEB887,
    "cadetblue": 0x5F9EA0,
    "chartreuse": 0x7FFF00,
    "chocolate": 0xD2691E,
    "coral": 0xFF7F50,
    "cornflowerblue": 0x6495ED,
    "cornsilk": 0xFFF8DC,
    "crimson": 0xDC143C,
    "cyan": 0x00FFFF,
    "darkblue": 0x00008B,
    "darkcyan": 0x008B8B,
    "darkgoldenrod": 0xB8860B,
    "darkgray": 0xA9A9A9,
    "darkgreen": 0x006400,
    "darkgrey": 0xA9A9A9,
    "darkkhaki": 0xBDB76B,
    "darkmagenta": 0x8B008B,
    "darkolivegreen": 0x556B2F,
    "darkorange": 0xFF8C00,
    "darkorchid": 0x9932CC,
    "darkred": 0x8B0000,
    "darksalmon": 0xE9967A,
    "darkseagreen": 0x8FBC8F,
    "darkslateblue": 0x483D8B,
    "darkslategray": 0x2F4F4F,
    "darkslategrey": 0x2F4F4F,
    "darkturquoise": 0x00CED1,
    "darkviolet": 0x9400D3,
    "deeppink": 0xFF1493,
    "deepskyblue": 0x00BFFF,
    "dimgray": 0x696969,
    "dimgrey": 0x696969,
    "dodgerblue": 0x1E90FF,
    "firebrick": 0xB22222,
    "floralwhite": 0xFFFAF0,
    "forestgreen": 0x228B22,
    "fuchsia": 0xFF00FF,
    "gainsboro": 0xDCDCDC,
    "ghostwhite": 0xF8F8FF,
    "gold": 0xFFD700,
    "goldenrod": 0xDAA520,
    "gray": 0x808080,
    "green": 0x008000,
    "greenyellow": 0xADFF2F,
    "grey": 0x808080,
    "honeydew": 0xF0FFF0,
    "hotpink": 0xFF69B4,
    "indianred": 0xCD5C5C,
    "indigo": 0x4B0082,
    "ivory": 0xFFFFF0,
    "khaki": 0xF0E68C,
    "lavender": 0xE6E6FA,
    "lavenderblush": 0xFFF0F5,
    "lawngreen": 0x7CFC00,
    "lemonchiffon": 0xFFFACD,
    "lightblue": 0xADD8E6,
    "lightcoral": 0xF08080,
    "lightcyan": 0xE0FFFF,
    "lightgoldenrodyellow": 0xFAFAD2,
    "lightgray": 0xD3D3D3,
    "lightgreen": 0x90EE90,
    "lightgrey": 0xD3D3D3,
    "lightpink": 0xFFB6C1,
    "lightsalmon": 0xFFA07A,
    "lightseagreen": 0x20B2AA,
    "lightskyblue": 0x87CEFA,
    "lightslategray": 0x778899,
    "lightslategrey": 0x778899,
    "lightsteelblue": 0xB0C4DE,
    "lightyellow": 0xFFFFE0,
    "lime": 0x00FF00,
    "limegreen": 0x32CD32,
    "linen": 0xFAF0E6,
    "magenta": 0xFF00FF,
    "maroon": 0x800000,
    "mediumaquamarine": 0x66CDAA,
    "mediumblue": 0x0000CD,
    "mediumorchid": 0xBA55D3,
    "mediumpurple": 0x9370DB,
    "mediumseagreen": 0x3CB371,
    "mediumslateblue": 0x7B68EE,
    "mediumspringgreen": 0x00FA9A,
    "mediumturquoise": 0x48D1CC,
    "mediumvioletred": 0xC71585,
    "midnightblue": 0x191970,
    "mintcream": 0xF5FFFA,
    "mistyrose": 0xFFE4E1,
    "moccasin": 0xFFE4B5,
    "navajowhite": 0xFFDEAD,
    "navy": 0x000080,
    "oldlace": 0xFDF5E6,
    "olive": 0x808000,
    "olivedrab": 0x6B8E23,
    "orange": 0xFFA500,
    "orangered": 0xFF4500,
    "orchid": 0xDA70D6,
    "palegoldenrod": 0xEEE8AA,
    "palegreen": 0x98FB98,
    "paleturquoise": 0xAFEEEE,
    "palevioletred": 0xDB7093,
    "papayawhip": 0xFFEFD5,
    "peachpuff": 0xFFDAB9,
    "peru": 0xCD853F,
    "pink": 0xFFC0CB,
    "plum": 0xDDA0DD,
    "powderblue": 0xB0E0E6,
    "purple": 0x800080,
    "rebeccapurple": 0x663399,
    "red": 0xFF0000,
    "rosybrown": 0xBC8F8F,
    "royalblue": 0x4169E1,
    "saddlebrown": 0x8B4513,
    "salmon": 0xFA8072,
    "sandybrown": 0xF4A460,
    "seagreen": 0x2E8B57,
    "seashell": 0xFFF5EE,
    "sienna": 0xA0522D,
    "silver": 0xC0C0C0,
    "skyblue": 0x87CEEB,
    "slateblue": 0x6A5ACD,
    "slategray": 0x708090,
    "slategrey": 0x708090,
    "snow": 0xFFFAFA,
    "springgreen": 0x00FF7F,
    "steelblue": 0x4682B4,
    "tan": 0xD2B48C,
    "teal": 0x008080,
    "thistle": 0xD8BFD8,
    "tomato": 0xFF6347,
    "turquoise": 0x40E0D0,
    "violet": 0xEE82EE,
    "wheat": 0xF5DEB3,
    "white": 0xFFFFFF,
    "whitesmoke": 0xF5F5F5,
    "yellow": 0xFFFF00,
    "yellowgreen": 0x9ACD32
};
const $0147bee01cff6558$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $0147bee01cff6558$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $0147bee01cff6558$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
class $0147bee01cff6558$export$892596cec99bc70e {
    constructor(r, g, b){
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        return this.set(r, g, b);
    }
    set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === "number") this.setHex(value);
            else if (typeof value === "string") this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex, colorSpace1 = $0147bee01cff6558$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $0147bee01cff6558$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setRGB(r, g, b, colorSpace1 = $0147bee01cff6558$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $0147bee01cff6558$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setHSL(h, s, l, colorSpace1 = $0147bee01cff6558$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $0147bee01cff6558$var$euclideanModulo(h, 1);
        s = $0147bee01cff6558$var$clamp(s, 0, 1);
        l = $0147bee01cff6558$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $0147bee01cff6558$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $0147bee01cff6558$var$hue2rgb(q, p, h);
            this.b = $0147bee01cff6558$var$hue2rgb(q, p, h - 1 / 3);
        }
        $0147bee01cff6558$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setStyle(style, colorSpace1 = $0147bee01cff6558$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn("THREE.Color: Alpha component of " + style + " will be ignored.");
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case "rgb":
                case "rgba":
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace1);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace1);
                    }
                    break;
                case "hsl":
                case "hsla":
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace1);
                    }
                    break;
                default:
                    console.warn("THREE.Color: Unknown color model " + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace1);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace1);
            else console.warn("THREE.Color: Invalid hex color " + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace1);
        return this;
    }
    setColorName(style, colorSpace1 = $0147bee01cff6558$export$561f394b24edfcaa) {
        // color keywords
        const hex = $0147bee01cff6558$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace1);
        else // unknown color
        console.warn("THREE.Color: Unknown color " + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $0147bee01cff6558$var$SRGBToLinear(color.r);
        this.g = $0147bee01cff6558$var$SRGBToLinear(color.g);
        this.b = $0147bee01cff6558$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $0147bee01cff6558$var$LinearToSRGB(color.r);
        this.g = $0147bee01cff6558$var$LinearToSRGB(color.g);
        this.b = $0147bee01cff6558$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex(colorSpace1 = $0147bee01cff6558$export$561f394b24edfcaa) {
        $0147bee01cff6558$export$5e6fd513f44698c.fromWorkingColorSpace($0147bee01cff6558$var$_color.copy(this), colorSpace1);
        return Math.round($0147bee01cff6558$var$clamp($0147bee01cff6558$var$_color.r * 255, 0, 255)) * 65536 + Math.round($0147bee01cff6558$var$clamp($0147bee01cff6558$var$_color.g * 255, 0, 255)) * 256 + Math.round($0147bee01cff6558$var$clamp($0147bee01cff6558$var$_color.b * 255, 0, 255));
    }
    getHexString(colorSpace1 = $0147bee01cff6558$export$561f394b24edfcaa) {
        return ("000000" + this.getHex(colorSpace1).toString(16)).slice(-6);
    }
    getHSL(target, colorSpace1 = $0147bee01cff6558$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $0147bee01cff6558$export$5e6fd513f44698c.fromWorkingColorSpace($0147bee01cff6558$var$_color.copy(this), colorSpace1);
        const r = $0147bee01cff6558$var$_color.r, g = $0147bee01cff6558$var$_color.g, b = $0147bee01cff6558$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getRGB(target, colorSpace1 = $0147bee01cff6558$export$5e6fd513f44698c.workingColorSpace) {
        $0147bee01cff6558$export$5e6fd513f44698c.fromWorkingColorSpace($0147bee01cff6558$var$_color.copy(this), colorSpace1);
        target.r = $0147bee01cff6558$var$_color.r;
        target.g = $0147bee01cff6558$var$_color.g;
        target.b = $0147bee01cff6558$var$_color.b;
        return target;
    }
    getStyle(colorSpace1 = $0147bee01cff6558$export$561f394b24edfcaa) {
        $0147bee01cff6558$export$5e6fd513f44698c.fromWorkingColorSpace($0147bee01cff6558$var$_color.copy(this), colorSpace1);
        const r = $0147bee01cff6558$var$_color.r, g = $0147bee01cff6558$var$_color.g, b = $0147bee01cff6558$var$_color.b;
        if (colorSpace1 !== $0147bee01cff6558$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace1} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    offsetHSL(h, s, l) {
        this.getHSL($0147bee01cff6558$var$_hslA);
        $0147bee01cff6558$var$_hslA.h += h;
        $0147bee01cff6558$var$_hslA.s += s;
        $0147bee01cff6558$var$_hslA.l += l;
        this.setHSL($0147bee01cff6558$var$_hslA.h, $0147bee01cff6558$var$_hslA.s, $0147bee01cff6558$var$_hslA.l);
        return this;
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($0147bee01cff6558$var$_hslA);
        color.getHSL($0147bee01cff6558$var$_hslB);
        const h = $0147bee01cff6558$var$lerp($0147bee01cff6558$var$_hslA.h, $0147bee01cff6558$var$_hslB.h, alpha);
        const s = $0147bee01cff6558$var$lerp($0147bee01cff6558$var$_hslA.s, $0147bee01cff6558$var$_hslB.s, alpha);
        const l = $0147bee01cff6558$var$lerp($0147bee01cff6558$var$_hslA.l, $0147bee01cff6558$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const $0147bee01cff6558$var$_color = /*@__PURE__*/ new $0147bee01cff6558$export$892596cec99bc70e();
$0147bee01cff6558$export$892596cec99bc70e.NAMES = $0147bee01cff6558$var$_colorKeywords;
class $0147bee01cff6558$export$55cbcc9b622fe1f5 extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshBasicMaterial = true;
        this.type = "MeshBasicMaterial";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $0147bee01cff6558$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $0147bee01cff6558$var$_tables = /*@__PURE__*/ $0147bee01cff6558$var$_generateTables();
function $0147bee01cff6558$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
// float32 to float16
function $0147bee01cff6558$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn("THREE.DataUtils.toHalfFloat(): Value out of range.");
    val = $0147bee01cff6558$var$clamp(val, -65504, 65504);
    $0147bee01cff6558$var$_tables.floatView[0] = val;
    const f = $0147bee01cff6558$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $0147bee01cff6558$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $0147bee01cff6558$var$_tables.shiftTable[e]);
}
// float16 to float32
function $0147bee01cff6558$var$fromHalfFloat(val) {
    const m = val >> 10;
    $0147bee01cff6558$var$_tables.uint32View[0] = $0147bee01cff6558$var$_tables.mantissaTable[$0147bee01cff6558$var$_tables.offsetTable[m] + (val & 0x3ff)] + $0147bee01cff6558$var$_tables.exponentTable[m];
    return $0147bee01cff6558$var$_tables.floatView[0];
}
const $0147bee01cff6558$export$11ce8b759162cc80 = {
    toHalfFloat: $0147bee01cff6558$var$toHalfFloat,
    fromHalfFloat: $0147bee01cff6558$var$fromHalfFloat
};
const $0147bee01cff6558$var$_vector$8 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vector2$1 = /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1();
class $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.isBufferAttribute = true;
        this.name = "";
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized;
        this.usage = $0147bee01cff6558$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.gpuType = $0147bee01cff6558$export$f6d331659b644596;
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $0147bee01cff6558$var$_vector2$1.fromBufferAttribute(this, i);
            $0147bee01cff6558$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $0147bee01cff6558$var$_vector2$1.x, $0147bee01cff6558$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $0147bee01cff6558$var$_vector$8.fromBufferAttribute(this, i);
            $0147bee01cff6558$var$_vector$8.applyMatrix3(m);
            this.setXYZ(i, $0147bee01cff6558$var$_vector$8.x, $0147bee01cff6558$var$_vector$8.y, $0147bee01cff6558$var$_vector$8.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $0147bee01cff6558$var$_vector$8.fromBufferAttribute(this, i);
            $0147bee01cff6558$var$_vector$8.applyMatrix4(m);
            this.setXYZ(i, $0147bee01cff6558$var$_vector$8.x, $0147bee01cff6558$var$_vector$8.y, $0147bee01cff6558$var$_vector$8.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $0147bee01cff6558$var$_vector$8.fromBufferAttribute(this, i);
            $0147bee01cff6558$var$_vector$8.applyNormalMatrix(m);
            this.setXYZ(i, $0147bee01cff6558$var$_vector$8.x, $0147bee01cff6558$var$_vector$8.y, $0147bee01cff6558$var$_vector$8.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $0147bee01cff6558$var$_vector$8.fromBufferAttribute(this, i);
            $0147bee01cff6558$var$_vector$8.transformDirection(m);
            this.setXYZ(i, $0147bee01cff6558$var$_vector$8.x, $0147bee01cff6558$var$_vector$8.y, $0147bee01cff6558$var$_vector$8.z);
        }
        return this;
    }
    set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    getComponent(index, component) {
        let value = this.array[index * this.itemSize + component];
        if (this.normalized) value = $0147bee01cff6558$var$denormalize(value, this.array);
        return value;
    }
    setComponent(index, component, value) {
        if (this.normalized) value = $0147bee01cff6558$var$normalize(value, this.array);
        this.array[index * this.itemSize + component] = value;
        return this;
    }
    getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $0147bee01cff6558$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $0147bee01cff6558$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $0147bee01cff6558$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $0147bee01cff6558$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $0147bee01cff6558$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $0147bee01cff6558$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $0147bee01cff6558$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $0147bee01cff6558$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $0147bee01cff6558$var$normalize(x, this.array);
            y = $0147bee01cff6558$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $0147bee01cff6558$var$normalize(x, this.array);
            y = $0147bee01cff6558$var$normalize(y, this.array);
            z = $0147bee01cff6558$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $0147bee01cff6558$var$normalize(x, this.array);
            y = $0147bee01cff6558$var$normalize(y, this.array);
            z = $0147bee01cff6558$var$normalize(z, this.array);
            w = $0147bee01cff6558$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== "") data.name = this.name;
        if (this.usage !== $0147bee01cff6558$export$763e8360f4d7f77d) data.usage = this.usage;
        if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
        return data;
    }
}
//
class $0147bee01cff6558$export$f9ff2d6a20248cbf extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $0147bee01cff6558$export$cacc90cf35d11cdd extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $0147bee01cff6558$export$baaa85a1a812c157 extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $0147bee01cff6558$export$2b755a102ccdcefe extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $0147bee01cff6558$export$640a853f68025f2e extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $0147bee01cff6558$export$46b369aed2968a0a extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $0147bee01cff6558$export$7eb8c9fa25cd5bd6 extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $0147bee01cff6558$export$dbd3698c64958d69 extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = $0147bee01cff6558$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $0147bee01cff6558$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $0147bee01cff6558$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $0147bee01cff6558$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $0147bee01cff6558$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $0147bee01cff6558$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $0147bee01cff6558$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $0147bee01cff6558$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $0147bee01cff6558$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $0147bee01cff6558$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $0147bee01cff6558$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $0147bee01cff6558$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $0147bee01cff6558$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $0147bee01cff6558$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $0147bee01cff6558$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $0147bee01cff6558$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $0147bee01cff6558$var$normalize(x, this.array);
            y = $0147bee01cff6558$var$normalize(y, this.array);
        }
        this.array[index + 0] = $0147bee01cff6558$var$toHalfFloat(x);
        this.array[index + 1] = $0147bee01cff6558$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $0147bee01cff6558$var$normalize(x, this.array);
            y = $0147bee01cff6558$var$normalize(y, this.array);
            z = $0147bee01cff6558$var$normalize(z, this.array);
        }
        this.array[index + 0] = $0147bee01cff6558$var$toHalfFloat(x);
        this.array[index + 1] = $0147bee01cff6558$var$toHalfFloat(y);
        this.array[index + 2] = $0147bee01cff6558$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $0147bee01cff6558$var$normalize(x, this.array);
            y = $0147bee01cff6558$var$normalize(y, this.array);
            z = $0147bee01cff6558$var$normalize(z, this.array);
            w = $0147bee01cff6558$var$normalize(w, this.array);
        }
        this.array[index + 0] = $0147bee01cff6558$var$toHalfFloat(x);
        this.array[index + 1] = $0147bee01cff6558$var$toHalfFloat(y);
        this.array[index + 2] = $0147bee01cff6558$var$toHalfFloat(z);
        this.array[index + 3] = $0147bee01cff6558$var$toHalfFloat(w);
        return this;
    }
}
class $0147bee01cff6558$export$cbe7a62641830ebd extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
class $0147bee01cff6558$export$9e0ade74842adbb8 extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float64Array(array), itemSize, normalized);
    }
}
let $0147bee01cff6558$var$_id$1 = 0;
const $0147bee01cff6558$var$_m1 = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_obj = /*@__PURE__*/ new $0147bee01cff6558$export$e4dd07dff30cc924();
const $0147bee01cff6558$var$_offset = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_box$1 = /*@__PURE__*/ new $0147bee01cff6558$export$6f7d5a9418ab2aa3();
const $0147bee01cff6558$var$_boxMorphTargets = /*@__PURE__*/ new $0147bee01cff6558$export$6f7d5a9418ab2aa3();
const $0147bee01cff6558$var$_vector$7 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$b7be63a67df8959 extends $0147bee01cff6558$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isBufferGeometry = true;
        Object.defineProperty(this, "id", {
            value: $0147bee01cff6558$var$_id$1++
        });
        this.uuid = $0147bee01cff6558$var$generateUUID();
        this.name = "";
        this.type = "BufferGeometry";
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($0147bee01cff6558$var$arrayNeedsUint32(index) ? $0147bee01cff6558$export$7eb8c9fa25cd5bd6 : $0147bee01cff6558$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $0147bee01cff6558$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $0147bee01cff6558$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($0147bee01cff6558$var$_m1);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $0147bee01cff6558$var$_m1.makeRotationX(angle);
        this.applyMatrix4($0147bee01cff6558$var$_m1);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $0147bee01cff6558$var$_m1.makeRotationY(angle);
        this.applyMatrix4($0147bee01cff6558$var$_m1);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $0147bee01cff6558$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($0147bee01cff6558$var$_m1);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $0147bee01cff6558$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($0147bee01cff6558$var$_m1);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $0147bee01cff6558$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($0147bee01cff6558$var$_m1);
        return this;
    }
    lookAt(vector) {
        $0147bee01cff6558$var$_obj.lookAt(vector);
        $0147bee01cff6558$var$_obj.updateMatrix();
        this.applyMatrix4($0147bee01cff6558$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($0147bee01cff6558$var$_offset).negate();
        this.translate($0147bee01cff6558$var$_offset.x, $0147bee01cff6558$var$_offset.y, $0147bee01cff6558$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(position, 3));
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $0147bee01cff6558$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingBox.set(new $0147bee01cff6558$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $0147bee01cff6558$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $0147bee01cff6558$var$_box$1.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $0147bee01cff6558$var$_vector$7.addVectors(this.boundingBox.min, $0147bee01cff6558$var$_box$1.min);
                    this.boundingBox.expandByPoint($0147bee01cff6558$var$_vector$7);
                    $0147bee01cff6558$var$_vector$7.addVectors(this.boundingBox.max, $0147bee01cff6558$var$_box$1.max);
                    this.boundingBox.expandByPoint($0147bee01cff6558$var$_vector$7);
                } else {
                    this.boundingBox.expandByPoint($0147bee01cff6558$var$_box$1.min);
                    this.boundingBox.expandByPoint($0147bee01cff6558$var$_box$1.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $0147bee01cff6558$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingSphere.set(new $0147bee01cff6558$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $0147bee01cff6558$var$_box$1.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $0147bee01cff6558$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $0147bee01cff6558$var$_vector$7.addVectors($0147bee01cff6558$var$_box$1.min, $0147bee01cff6558$var$_boxMorphTargets.min);
                    $0147bee01cff6558$var$_box$1.expandByPoint($0147bee01cff6558$var$_vector$7);
                    $0147bee01cff6558$var$_vector$7.addVectors($0147bee01cff6558$var$_box$1.max, $0147bee01cff6558$var$_boxMorphTargets.max);
                    $0147bee01cff6558$var$_box$1.expandByPoint($0147bee01cff6558$var$_vector$7);
                } else {
                    $0147bee01cff6558$var$_box$1.expandByPoint($0147bee01cff6558$var$_boxMorphTargets.min);
                    $0147bee01cff6558$var$_box$1.expandByPoint($0147bee01cff6558$var$_boxMorphTargets.max);
                }
            }
            $0147bee01cff6558$var$_box$1.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $0147bee01cff6558$var$_vector$7.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($0147bee01cff6558$var$_vector$7));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $0147bee01cff6558$var$_vector$7.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $0147bee01cff6558$var$_offset.fromBufferAttribute(position, j);
                        $0147bee01cff6558$var$_vector$7.add($0147bee01cff6558$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($0147bee01cff6558$var$_vector$7));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
            return;
        }
        const indices = index.array;
        const positions = attributes.position.array;
        const normals = attributes.normal.array;
        const uvs = attributes.uv.array;
        const nVertices = positions.length / 3;
        if (this.hasAttribute("tangent") === false) this.setAttribute("tangent", new $0147bee01cff6558$export$8dea267bd6bde117(new Float32Array(4 * nVertices), 4));
        const tangents = this.getAttribute("tangent").array;
        const tan1 = [], tan2 = [];
        for(let i = 0; i < nVertices; i++){
            tan1[i] = new $0147bee01cff6558$export$64b5c384219d3699();
            tan2[i] = new $0147bee01cff6558$export$64b5c384219d3699();
        }
        const vA = new $0147bee01cff6558$export$64b5c384219d3699(), vB = new $0147bee01cff6558$export$64b5c384219d3699(), vC = new $0147bee01cff6558$export$64b5c384219d3699(), uvA = new $0147bee01cff6558$export$c977b3e384af9ae1(), uvB = new $0147bee01cff6558$export$c977b3e384af9ae1(), uvC = new $0147bee01cff6558$export$c977b3e384af9ae1(), sdir = new $0147bee01cff6558$export$64b5c384219d3699(), tdir = new $0147bee01cff6558$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromArray(positions, a * 3);
            vB.fromArray(positions, b * 3);
            vC.fromArray(positions, c * 3);
            uvA.fromArray(uvs, a * 2);
            uvB.fromArray(uvs, b * 2);
            uvC.fromArray(uvs, c * 2);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: indices.length
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
        }
        const tmp = new $0147bee01cff6558$export$64b5c384219d3699(), tmp2 = new $0147bee01cff6558$export$64b5c384219d3699();
        const n = new $0147bee01cff6558$export$64b5c384219d3699(), n2 = new $0147bee01cff6558$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromArray(normals, v * 3);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangents[v * 4] = tmp.x;
            tangents[v * 4 + 1] = tmp.y;
            tangents[v * 4 + 2] = tmp.z;
            tangents[v * 4 + 3] = w;
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(indices[j + 0]);
                handleVertex(indices[j + 1]);
                handleVertex(indices[j + 2]);
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute("position");
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute("normal");
            if (normalAttribute === undefined) {
                normalAttribute = new $0147bee01cff6558$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute("normal", normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $0147bee01cff6558$export$64b5c384219d3699(), pB = new $0147bee01cff6558$export$64b5c384219d3699(), pC = new $0147bee01cff6558$export$64b5c384219d3699();
            const nA = new $0147bee01cff6558$export$64b5c384219d3699(), nB = new $0147bee01cff6558$export$64b5c384219d3699(), nC = new $0147bee01cff6558$export$64b5c384219d3699();
            const cb = new $0147bee01cff6558$export$64b5c384219d3699(), ab = new $0147bee01cff6558$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $0147bee01cff6558$var$_vector$7.fromBufferAttribute(normals, i);
            $0147bee01cff6558$var$_vector$7.normalize();
            normals.setXYZ(i, $0147bee01cff6558$var$_vector$7.x, $0147bee01cff6558$var$_vector$7.y, $0147bee01cff6558$var$_vector$7.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $0147bee01cff6558$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.");
            return this;
        }
        const geometry2 = new $0147bee01cff6558$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
const $0147bee01cff6558$var$_inverseMatrix$3 = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_ray$3 = /*@__PURE__*/ new $0147bee01cff6558$export$a186db52eed6d40e();
const $0147bee01cff6558$var$_sphere$5 = /*@__PURE__*/ new $0147bee01cff6558$export$805e8b72413ccaba();
const $0147bee01cff6558$var$_sphereHitAt = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vA$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vB$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vC$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_tempA = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_morphA = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_uvA$1 = /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1();
const $0147bee01cff6558$var$_uvB$1 = /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1();
const $0147bee01cff6558$var$_uvC$1 = /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1();
const $0147bee01cff6558$var$_normalA = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_normalB = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_normalC = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_intersectionPoint = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_intersectionPointWorld = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$e176487c05830cc5 extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(geometry = new $0147bee01cff6558$export$b7be63a67df8959(), material = new $0147bee01cff6558$export$55cbcc9b622fe1f5()){
        super();
        this.isMesh = true;
        this.type = "Mesh";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $0147bee01cff6558$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $0147bee01cff6558$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $0147bee01cff6558$var$_morphA.addScaledVector($0147bee01cff6558$var$_tempA, influence);
                else $0147bee01cff6558$var$_morphA.addScaledVector($0147bee01cff6558$var$_tempA.sub(target), influence);
            }
            target.add($0147bee01cff6558$var$_morphA);
        }
        return target;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $0147bee01cff6558$var$_sphere$5.copy(geometry.boundingSphere);
        $0147bee01cff6558$var$_sphere$5.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        $0147bee01cff6558$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
        if ($0147bee01cff6558$var$_sphere$5.containsPoint($0147bee01cff6558$var$_ray$3.origin) === false) {
            if ($0147bee01cff6558$var$_ray$3.intersectSphere($0147bee01cff6558$var$_sphere$5, $0147bee01cff6558$var$_sphereHitAt) === null) return;
            if ($0147bee01cff6558$var$_ray$3.origin.distanceToSquared($0147bee01cff6558$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        $0147bee01cff6558$var$_inverseMatrix$3.copy(matrixWorld).invert();
        $0147bee01cff6558$var$_ray$3.copy(raycaster.ray).applyMatrix4($0147bee01cff6558$var$_inverseMatrix$3);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if ($0147bee01cff6558$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $0147bee01cff6558$var$_ray$3);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $0147bee01cff6558$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $0147bee01cff6558$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $0147bee01cff6558$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $0147bee01cff6558$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $0147bee01cff6558$var$checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $0147bee01cff6558$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $0147bee01cff6558$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $0147bee01cff6558$var$_intersectionPointWorld.copy(point);
    $0147bee01cff6558$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($0147bee01cff6558$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $0147bee01cff6558$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $0147bee01cff6558$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $0147bee01cff6558$var$_vA$1);
    object.getVertexPosition(b, $0147bee01cff6558$var$_vB$1);
    object.getVertexPosition(c, $0147bee01cff6558$var$_vC$1);
    const intersection = $0147bee01cff6558$var$checkIntersection(object, material, raycaster, ray, $0147bee01cff6558$var$_vA$1, $0147bee01cff6558$var$_vB$1, $0147bee01cff6558$var$_vC$1, $0147bee01cff6558$var$_intersectionPoint);
    if (intersection) {
        if (uv) {
            $0147bee01cff6558$var$_uvA$1.fromBufferAttribute(uv, a);
            $0147bee01cff6558$var$_uvB$1.fromBufferAttribute(uv, b);
            $0147bee01cff6558$var$_uvC$1.fromBufferAttribute(uv, c);
            intersection.uv = $0147bee01cff6558$export$5a465592bfe74b48.getInterpolation($0147bee01cff6558$var$_intersectionPoint, $0147bee01cff6558$var$_vA$1, $0147bee01cff6558$var$_vB$1, $0147bee01cff6558$var$_vC$1, $0147bee01cff6558$var$_uvA$1, $0147bee01cff6558$var$_uvB$1, $0147bee01cff6558$var$_uvC$1, new $0147bee01cff6558$export$c977b3e384af9ae1());
        }
        if (uv1) {
            $0147bee01cff6558$var$_uvA$1.fromBufferAttribute(uv1, a);
            $0147bee01cff6558$var$_uvB$1.fromBufferAttribute(uv1, b);
            $0147bee01cff6558$var$_uvC$1.fromBufferAttribute(uv1, c);
            intersection.uv1 = $0147bee01cff6558$export$5a465592bfe74b48.getInterpolation($0147bee01cff6558$var$_intersectionPoint, $0147bee01cff6558$var$_vA$1, $0147bee01cff6558$var$_vB$1, $0147bee01cff6558$var$_vC$1, $0147bee01cff6558$var$_uvA$1, $0147bee01cff6558$var$_uvB$1, $0147bee01cff6558$var$_uvC$1, new $0147bee01cff6558$export$c977b3e384af9ae1());
            intersection.uv2 = intersection.uv1; // @deprecated, r152
        }
        if (normal) {
            $0147bee01cff6558$var$_normalA.fromBufferAttribute(normal, a);
            $0147bee01cff6558$var$_normalB.fromBufferAttribute(normal, b);
            $0147bee01cff6558$var$_normalC.fromBufferAttribute(normal, c);
            intersection.normal = $0147bee01cff6558$export$5a465592bfe74b48.getInterpolation($0147bee01cff6558$var$_intersectionPoint, $0147bee01cff6558$var$_vA$1, $0147bee01cff6558$var$_vB$1, $0147bee01cff6558$var$_vC$1, $0147bee01cff6558$var$_normalA, $0147bee01cff6558$var$_normalB, $0147bee01cff6558$var$_normalC, new $0147bee01cff6558$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $0147bee01cff6558$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $0147bee01cff6558$export$5a465592bfe74b48.getNormal($0147bee01cff6558$var$_vA$1, $0147bee01cff6558$var$_vB$1, $0147bee01cff6558$var$_vC$1, face.normal);
        intersection.face = face;
    }
    return intersection;
}
class $0147bee01cff6558$export$33e43285f7406bd5 extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = "BoxGeometry";
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane("z", "y", "x", -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane("z", "y", "x", 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane("x", "z", "y", 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane("x", "z", "y", 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane("x", "y", "z", 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane("x", "y", "z", -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $0147bee01cff6558$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Uniform Utilities
 */ function $0147bee01cff6558$var$cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().");
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $0147bee01cff6558$var$mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $0147bee01cff6558$var$cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $0147bee01cff6558$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $0147bee01cff6558$var$getUnlitUniformColorSpace(renderer) {
    if (renderer.getRenderTarget() === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    return $0147bee01cff6558$export$42429b3acfb233a4;
}
// Legacy
const $0147bee01cff6558$export$d8ecdf8615bfea69 = {
    clone: $0147bee01cff6558$var$cloneUniforms,
    merge: $0147bee01cff6558$var$mergeUniforms
};
var $0147bee01cff6558$var$default_vertex = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $0147bee01cff6558$var$default_fragment = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class $0147bee01cff6558$export$83c7d75d550a8b0d extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShaderMaterial = true;
        this.type = "ShaderMaterial";
        this.defines = {};
        this.uniforms = {};
        this.uniformsGroups = [];
        this.vertexShader = $0147bee01cff6558$var$default_vertex;
        this.fragmentShader = $0147bee01cff6558$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.forceSinglePass = true;
        this.extensions = {
            derivatives: false,
            fragDepth: false,
            drawBuffers: false,
            shaderTextureLOD: false // set to use shader texture LOD
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            "color": [
                1,
                1,
                1
            ],
            "uv": [
                0,
                0
            ],
            "uv1": [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $0147bee01cff6558$var$cloneUniforms(source.uniforms);
        this.uniformsGroups = $0147bee01cff6558$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: "t",
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: "c",
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: "v2",
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: "v3",
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: "v4",
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: "m3",
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: "m4",
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
class $0147bee01cff6558$export$79f141de891a5fed extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isCamera = true;
        this.type = "Camera";
        this.matrixWorldInverse = new $0147bee01cff6558$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $0147bee01cff6558$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $0147bee01cff6558$export$2ae72fc923e5eb5();
        this.coordinateSystem = $0147bee01cff6558$export$5a0e9190d10875d3;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(-e[8], -e[9], -e[10]).normalize();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $0147bee01cff6558$export$74e4ae24825f68d7 extends $0147bee01cff6558$export$79f141de891a5fed {
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.isPerspectiveCamera = true;
        this.type = "PerspectiveCamera";
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $0147bee01cff6558$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($0147bee01cff6558$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $0147bee01cff6558$var$RAD2DEG * 2 * Math.atan(Math.tan($0147bee01cff6558$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($0147bee01cff6558$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const $0147bee01cff6558$var$fov = -90; // negative fov is not an error
const $0147bee01cff6558$var$aspect = 1;
class $0147bee01cff6558$export$d0cdd0bd804995de extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(near, far, renderTarget){
        super();
        this.type = "CubeCamera";
        this.renderTarget = renderTarget;
        this.coordinateSystem = null;
        const cameraPX = new $0147bee01cff6558$export$74e4ae24825f68d7($0147bee01cff6558$var$fov, $0147bee01cff6558$var$aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new $0147bee01cff6558$export$74e4ae24825f68d7($0147bee01cff6558$var$fov, $0147bee01cff6558$var$aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new $0147bee01cff6558$export$74e4ae24825f68d7($0147bee01cff6558$var$fov, $0147bee01cff6558$var$aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new $0147bee01cff6558$export$74e4ae24825f68d7($0147bee01cff6558$var$fov, $0147bee01cff6558$var$aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new $0147bee01cff6558$export$74e4ae24825f68d7($0147bee01cff6558$var$fov, $0147bee01cff6558$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new $0147bee01cff6558$export$74e4ae24825f68d7($0147bee01cff6558$var$fov, $0147bee01cff6558$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
    updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === $0147bee01cff6558$export$5a0e9190d10875d3) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === $0147bee01cff6558$export$cc83beedcb9be9ac) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const renderTarget = this.renderTarget;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentXrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4);
        renderer.render(scene, cameraPZ);
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
class $0147bee01cff6558$export$ee2e5a18258a4049 extends $0147bee01cff6558$export$5431306cf43de24a {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $0147bee01cff6558$export$8759762a6477f2c4;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCubeTexture = true;
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
class $0147bee01cff6558$export$ac386671d651941e extends $0147bee01cff6558$export$3c052beb2e51e23f {
    constructor(size = 1, options = {}){
        super(size, size, options);
        this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        if (options.encoding !== undefined) {
            // @deprecated, r152
            $0147bee01cff6558$var$warnOnce("THREE.WebGLCubeRenderTarget: option.encoding has been replaced by option.colorSpace.");
            options.colorSpace = options.encoding === $0147bee01cff6558$export$f32388edbb32674 ? $0147bee01cff6558$export$561f394b24edfcaa : $0147bee01cff6558$export$bfcb490c2dd3db51;
        }
        this.texture = new $0147bee01cff6558$export$ee2e5a18258a4049(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $0147bee01cff6558$export$8a72f490b25c56c8;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $0147bee01cff6558$export$33e43285f7406bd5(5, 5, 5);
        const material = new $0147bee01cff6558$export$83c7d75d550a8b0d({
            name: "CubemapFromEquirect",
            uniforms: $0147bee01cff6558$var$cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $0147bee01cff6558$export$d9f0486e75b5ace,
            blending: $0147bee01cff6558$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $0147bee01cff6558$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $0147bee01cff6558$export$5d8599b6a933fb1b) texture.minFilter = $0147bee01cff6558$export$8a72f490b25c56c8;
        const camera = new $0147bee01cff6558$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
const $0147bee01cff6558$var$_vector1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vector2 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_normalMatrix = /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918();
class $0147bee01cff6558$export$7ff5ac152ef991b0 {
    constructor(normal = new $0147bee01cff6558$export$64b5c384219d3699(1, 0, 0), constant = 0){
        this.isPlane = true;
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $0147bee01cff6558$var$_vector1.subVectors(c, b).cross($0147bee01cff6558$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    intersectLine(line, target) {
        const direction = line.delta($0147bee01cff6558$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $0147bee01cff6558$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($0147bee01cff6558$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $0147bee01cff6558$var$_sphere$4 = /*@__PURE__*/ new $0147bee01cff6558$export$805e8b72413ccaba();
const $0147bee01cff6558$var$_vector$6 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$35efe6f4c85463d2 {
    constructor(p0 = new $0147bee01cff6558$export$7ff5ac152ef991b0(), p1 = new $0147bee01cff6558$export$7ff5ac152ef991b0(), p2 = new $0147bee01cff6558$export$7ff5ac152ef991b0(), p3 = new $0147bee01cff6558$export$7ff5ac152ef991b0(), p4 = new $0147bee01cff6558$export$7ff5ac152ef991b0(), p5 = new $0147bee01cff6558$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m, coordinateSystem = $0147bee01cff6558$export$5a0e9190d10875d3) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        if (coordinateSystem === $0147bee01cff6558$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        else if (coordinateSystem === $0147bee01cff6558$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize();
        else throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + coordinateSystem);
        return this;
    }
    intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $0147bee01cff6558$var$_sphere$4.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $0147bee01cff6558$var$_sphere$4.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($0147bee01cff6558$var$_sphere$4);
    }
    intersectsSprite(sprite) {
        $0147bee01cff6558$var$_sphere$4.center.set(0, 0, 0);
        $0147bee01cff6558$var$_sphere$4.radius = 0.7071067811865476;
        $0147bee01cff6558$var$_sphere$4.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($0147bee01cff6558$var$_sphere$4);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $0147bee01cff6558$var$_vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $0147bee01cff6558$var$_vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $0147bee01cff6558$var$_vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($0147bee01cff6558$var$_vector$6) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
function $0147bee01cff6558$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $0147bee01cff6558$var$WebGLAttributes(gl, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) {
                if (isWebGL2) type = gl.HALF_FLOAT;
                else throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
            } else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRange = attribute.updateRange;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            if (isWebGL2) gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            else gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
            updateRange.count = -1; // reset range
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class $0147bee01cff6558$export$967d831af31f69ce extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = "PlaneGeometry";
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
var $0147bee01cff6558$var$alphahash_fragment = "#ifdef USE_ALPHAHASH\n	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var $0147bee01cff6558$var$alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n	const float ALPHA_HASH_SCALE = 0.05;\n	float hash2D( vec2 value ) {\n		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n	}\n	float hash3D( vec3 value ) {\n		return hash2D( vec2( hash2D( value.xy ), value.z ) );\n	}\n	float getAlphaHashThreshold( vec3 position ) {\n		float maxDeriv = max(\n			length( dFdx( position.xyz ) ),\n			length( dFdy( position.xyz ) )\n		);\n		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n		vec2 pixScales = vec2(\n			exp2( floor( log2( pixScale ) ) ),\n			exp2( ceil( log2( pixScale ) ) )\n		);\n		vec2 alpha = vec2(\n			hash3D( floor( pixScales.x * position.xyz ) ),\n			hash3D( floor( pixScales.y * position.xyz ) )\n		);\n		float lerpFactor = fract( log2( pixScale ) );\n		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n		float a = min( lerpFactor, 1.0 - lerpFactor );\n		vec3 cases = vec3(\n			x * x / ( 2.0 * a * ( 1.0 - a ) ),\n			( x - 0.5 * a ) / ( 1.0 - a ),\n			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n		);\n		float threshold = ( x < ( 1.0 - a ) )\n			? ( ( x < a ) ? cases.x : cases.y )\n			: cases.z;\n		return clamp( threshold , 1.0e-6, 1.0 );\n	}\n#endif";
var $0147bee01cff6558$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $0147bee01cff6558$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $0147bee01cff6558$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n	if ( diffuseColor.a < alphaTest ) discard;\n#endif";
var $0147bee01cff6558$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif";
var $0147bee01cff6558$var$aomap_fragment = "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif";
var $0147bee01cff6558$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif";
var $0147bee01cff6558$var$begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n	vPosition = vec3( position );\n#endif";
var $0147bee01cff6558$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $0147bee01cff6558$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n} // validated";
var $0147bee01cff6558$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n	const mat3 XYZ_TO_REC709 = mat3(\n		 3.2404542, -0.9692660,  0.0556434,\n		-1.5371385,  1.8760108, -0.2040259,\n		-0.4985314,  0.0415560,  1.0572252\n	);\n	vec3 Fresnel0ToIor( vec3 fresnel0 ) {\n		vec3 sqrtF0 = sqrt( fresnel0 );\n		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n	}\n	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n	}\n	float IorToFresnel0( float transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n	}\n	vec3 evalSensitivity( float OPD, vec3 shift ) {\n		float phase = 2.0 * PI * OPD * 1.0e-9;\n		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n		xyz /= 1.0685e-7;\n		vec3 rgb = XYZ_TO_REC709 * xyz;\n		return rgb;\n	}\n	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n		vec3 I;\n		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n		float cosTheta2Sq = 1.0 - sinTheta2Sq;\n		if ( cosTheta2Sq < 0.0 ) {\n			return vec3( 1.0 );\n		}\n		float cosTheta2 = sqrt( cosTheta2Sq );\n		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n		float R12 = F_Schlick( R0, 1.0, cosTheta1 );\n		float T121 = 1.0 - R12;\n		float phi12 = 0.0;\n		if ( iridescenceIOR < outsideIOR ) phi12 = PI;\n		float phi21 = PI - phi12;\n		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n		vec3 phi23 = vec3( 0.0 );\n		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n		vec3 phi = vec3( phi21 ) + phi23;\n		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n		vec3 r123 = sqrt( R123 );\n		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n		vec3 C0 = R12 + Rs;\n		I = C0;\n		vec3 Cm = Rs - T121;\n		for ( int m = 1; m <= 2; ++ m ) {\n			Cm *= r123;\n			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n			I += Cm * Sm;\n		}\n		return max( I, vec3( 0.0 ) );\n	}\n#endif";
var $0147bee01cff6558$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vBumpMapUv );\n		vec2 dSTdy = dFdy( vBumpMapUv );\n		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = dFdx( surf_pos.xyz );\n		vec3 vSigmaY = dFdy( surf_pos.xyz );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif";
var $0147bee01cff6558$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n		plane = clippingPlanes[ i ];\n		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n	}\n	#pragma unroll_loop_end\n	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n		bool clipped = true;\n		#pragma unroll_loop_start\n		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n		}\n		#pragma unroll_loop_end\n		if ( clipped ) discard;\n	#endif\n#endif";
var $0147bee01cff6558$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $0147bee01cff6558$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif";
var $0147bee01cff6558$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif";
var $0147bee01cff6558$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif";
var $0147bee01cff6558$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif";
var $0147bee01cff6558$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	varying vec3 vColor;\n#endif";
var $0147bee01cff6558$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif";
var $0147bee01cff6558$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\nstruct GeometricContext {\n	vec3 position;\n	vec3 normal;\n	vec3 viewDir;\n#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal;\n#endif\n};\n#ifdef USE_ALPHAHASH\n	varying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n	const vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n	return dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $0147bee01cff6558$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define cubeUV_r0 1.0\n	#define cubeUV_v0 0.339\n	#define cubeUV_m0 - 2.0\n	#define cubeUV_r1 0.8\n	#define cubeUV_v1 0.276\n	#define cubeUV_m1 - 1.0\n	#define cubeUV_r4 0.4\n	#define cubeUV_v4 0.046\n	#define cubeUV_m4 2.0\n	#define cubeUV_r5 0.305\n	#define cubeUV_v5 0.016\n	#define cubeUV_m5 3.0\n	#define cubeUV_r6 0.21\n	#define cubeUV_v6 0.0038\n	#define cubeUV_m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= cubeUV_r1 ) {\n			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n		} else if ( roughness >= cubeUV_r4 ) {\n			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n		} else if ( roughness >= cubeUV_r5 ) {\n			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n		} else if ( roughness >= cubeUV_r6 ) {\n			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif";
var $0147bee01cff6558$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n	mat3 m = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n	transformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif";
var $0147bee01cff6558$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif";
var $0147bee01cff6558$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $0147bee01cff6558$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $0147bee01cff6558$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif";
var $0147bee01cff6558$var$colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $0147bee01cff6558$var$colorspace_pars_fragment = "vec4 LinearToLinear( in vec4 value ) {\n	return value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $0147bee01cff6558$var$envmap_fragment = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif";
var $0147bee01cff6558$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif";
var $0147bee01cff6558$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif";
var $0147bee01cff6558$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif";
var $0147bee01cff6558$var$envmap_vertex = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif";
var $0147bee01cff6558$var$fog_vertex = "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif";
var $0147bee01cff6558$var$fog_pars_vertex = "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif";
var $0147bee01cff6558$var$fog_fragment = "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $0147bee01cff6558$var$fog_pars_fragment = "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif";
var $0147bee01cff6558$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		vec2 fw = fwidth( coord ) * 0.5;\n		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n	#endif\n}";
var $0147bee01cff6558$var$lightmap_fragment = "#ifdef USE_LIGHTMAP\n	vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n	reflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";
var $0147bee01cff6558$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif";
var $0147bee01cff6558$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $0147bee01cff6558$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n	vec3 diffuseColor;\n	float specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Lambert\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert";
var $0147bee01cff6558$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	#if defined ( LEGACY_LIGHTS )\n		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n		}\n		return 1.0;\n	#else\n		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n		if ( cutoffDistance > 0.0 ) {\n			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n		}\n		return distanceFalloff;\n	#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif";
var $0147bee01cff6558$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	#ifdef USE_ANISOTROPY\n		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n			#ifdef ENVMAP_TYPE_CUBE_UV\n				vec3 bentNormal = cross( bitangent, viewDir );\n				bentNormal = normalize( cross( bentNormal, bitangent ) );\n				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n				return getIBLRadiance( viewDir, bentNormal, roughness );\n			#else\n				return vec3( 0.0 );\n			#endif\n		}\n	#endif\n#endif";
var $0147bee01cff6558$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $0147bee01cff6558$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon";
var $0147bee01cff6558$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $0147bee01cff6558$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong";
var $0147bee01cff6558$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	material.ior = ior;\n	#ifdef USE_SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULAR_COLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n		#endif\n		#ifdef USE_SPECULAR_INTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n	material.iridescence = iridescence;\n	material.iridescenceIOR = iridescenceIOR;\n	#ifdef USE_IRIDESCENCEMAP\n		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n	#endif\n	#ifdef USE_IRIDESCENCE_THICKNESSMAP\n		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n	#else\n		material.iridescenceThickness = iridescenceThicknessMaximum;\n	#endif\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEEN_COLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	#ifdef USE_ANISOTROPYMAP\n		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n	#else\n		vec2 anisotropyV = anisotropyVector;\n	#endif\n	material.anisotropy = length( anisotropyV );\n	anisotropyV /= material.anisotropy;\n	material.anisotropy = saturate( material.anisotropy );\n	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n	material.anisotropyT = tbn[ 0 ] * anisotropyV.x - tbn[ 1 ] * anisotropyV.y;\n	material.anisotropyB = tbn[ 1 ] * anisotropyV.x + tbn[ 0 ] * anisotropyV.y;\n#endif";
var $0147bee01cff6558$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_IRIDESCENCE\n		float iridescence;\n		float iridescenceIOR;\n		float iridescenceThickness;\n		vec3 iridescenceFresnel;\n		vec3 iridescenceF0;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n	#ifdef IOR\n		float ior;\n	#endif\n	#ifdef USE_TRANSMISSION\n		float transmission;\n		float transmissionAlpha;\n		float thickness;\n		float attenuationDistance;\n		vec3 attenuationColor;\n	#endif\n	#ifdef USE_ANISOTROPY\n		float anisotropy;\n		float alphaT;\n		vec3 anisotropyT;\n		vec3 anisotropyB;\n	#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n		float v = 0.5 / ( gv + gl );\n		return saturate(v);\n	}\n	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n		float a2 = alphaT * alphaB;\n		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n		highp float v2 = dot( v, v );\n		float w2 = a2 / v2;\n		return RECIPROCAL_PI * a2 * pow2 ( w2 );\n	}\n#endif\n#ifdef USE_CLEARCOAT\n	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n		vec3 f0 = material.clearcoatF0;\n		float f90 = material.clearcoatF90;\n		float roughness = material.clearcoatRoughness;\n		float alpha = pow2( roughness );\n		vec3 halfDir = normalize( lightDir + viewDir );\n		float dotNL = saturate( dot( normal, lightDir ) );\n		float dotNV = saturate( dot( normal, viewDir ) );\n		float dotNH = saturate( dot( normal, halfDir ) );\n		float dotVH = saturate( dot( viewDir, halfDir ) );\n		vec3 F = F_Schlick( f0, f90, dotVH );\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n		return F * ( V * D );\n	}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 f0 = material.specularColor;\n	float f90 = material.specularF90;\n	float roughness = material.roughness;\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	#ifdef USE_IRIDESCENCE\n		F = mix( F, material.iridescenceFresnel, material.iridescence );\n	#endif\n	#ifdef USE_ANISOTROPY\n		float dotTL = dot( material.anisotropyT, lightDir );\n		float dotTV = dot( material.anisotropyT, viewDir );\n		float dotTH = dot( material.anisotropyT, halfDir );\n		float dotBL = dot( material.anisotropyB, lightDir );\n		float dotBV = dot( material.anisotropyB, viewDir );\n		float dotBH = dot( material.anisotropyB, halfDir );\n		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n	#else\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n	#endif\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	#ifdef USE_IRIDESCENCE\n		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n	#else\n		vec3 Fr = specularColor;\n	#endif\n	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometry.normal;\n		vec3 viewDir = geometry.viewDir;\n		vec3 position = geometry.position;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecular += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	#ifdef USE_IRIDESCENCE\n		computeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n	#else\n		computeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	#endif\n	vec3 totalScattering = singleScattering + multiScattering;\n	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $0147bee01cff6558$var$lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n	geometry.clearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n	float dotNVi = saturate( dot( normal, geometry.viewDir ) );\n	if ( material.iridescenceThickness == 0.0 ) {\n		material.iridescence = 0.0;\n	} else {\n		material.iridescence = saturate( material.iridescence );\n	}\n	if ( material.iridescence > 0.0 ) {\n		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n	}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	vec4 spotColor;\n	vec3 spotLightCoord;\n	bool inSpotLightMap;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometry, directLight );\n		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n		#else\n		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#endif\n		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n		#endif\n		#undef SPOT_LIGHT_MAP_INDEX\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	irradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $0147bee01cff6558$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometry.normal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	#ifdef USE_ANISOTROPY\n		radiance += getIBLAnisotropyRadiance( geometry.viewDir, geometry.normal, material.roughness, material.anisotropyB, material.anisotropy );\n	#else\n		radiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n	#endif\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif";
var $0147bee01cff6558$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var $0147bee01cff6558$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $0147bee01cff6558$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var $0147bee01cff6558$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		varying float vFragDepth;\n		varying float vIsPerspective;\n	#else\n		uniform float logDepthBufFC;\n	#endif\n#endif";
var $0147bee01cff6558$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		vFragDepth = 1.0 + gl_Position.w;\n		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n	#else\n		if ( isPerspectiveMatrix( projectionMatrix ) ) {\n			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n			gl_Position.z *= gl_Position.w;\n		}\n	#endif\n#endif";
var $0147bee01cff6558$var$map_fragment = "#ifdef USE_MAP\n	diffuseColor *= texture2D( map, vMapUv );\n#endif";
var $0147bee01cff6558$var$map_pars_fragment = "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif";
var $0147bee01cff6558$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	#if defined( USE_POINTS_UV )\n		vec2 uv = vUv;\n	#else\n		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n	#endif\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $0147bee01cff6558$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n	varying vec2 vUv;\n#else\n	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n		uniform mat3 uvTransform;\n	#endif\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $0147bee01cff6558$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n	metalnessFactor *= texelMetalness.b;\n#endif";
var $0147bee01cff6558$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif";
var $0147bee01cff6558$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif";
var $0147bee01cff6558$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n	#endif\n#endif";
var $0147bee01cff6558$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n	uniform float morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n		uniform sampler2DArray morphTargetsTexture;\n		uniform ivec2 morphTargetsTextureSize;\n		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n			int y = texelIndex / morphTargetsTextureSize.x;\n			int x = texelIndex - y * morphTargetsTextureSize.x;\n			ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n			return texelFetch( morphTargetsTexture, morphUV, 0 );\n		}\n	#else\n		#ifndef USE_MORPHNORMALS\n			uniform float morphTargetInfluences[ 8 ];\n		#else\n			uniform float morphTargetInfluences[ 4 ];\n		#endif\n	#endif\n#endif";
var $0147bee01cff6558$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		transformed += morphTarget0 * morphTargetInfluences[ 0 ];\n		transformed += morphTarget1 * morphTargetInfluences[ 1 ];\n		transformed += morphTarget2 * morphTargetInfluences[ 2 ];\n		transformed += morphTarget3 * morphTargetInfluences[ 3 ];\n		#ifndef USE_MORPHNORMALS\n			transformed += morphTarget4 * morphTargetInfluences[ 4 ];\n			transformed += morphTarget5 * morphTargetInfluences[ 5 ];\n			transformed += morphTarget6 * morphTargetInfluences[ 6 ];\n			transformed += morphTarget7 * morphTargetInfluences[ 7 ];\n		#endif\n	#endif\n#endif";
var $0147bee01cff6558$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = dFdx( vViewPosition );\n	vec3 fdy = dFdy( vViewPosition );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal *= faceDirection;\n	#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n	#ifdef USE_TANGENT\n		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn = getTangentFrame( - vViewPosition, normal,\n		#if defined( USE_NORMALMAP )\n			vNormalMapUv\n		#elif defined( USE_CLEARCOAT_NORMALMAP )\n			vClearcoatNormalMapUv\n		#else\n			vUv\n		#endif\n		);\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn[0] *= faceDirection;\n		tbn[1] *= faceDirection;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	#ifdef USE_TANGENT\n		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn2[0] *= faceDirection;\n		tbn2[1] *= faceDirection;\n	#endif\n#endif\nvec3 geometryNormal = normal;";
var $0147bee01cff6558$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	normal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $0147bee01cff6558$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $0147bee01cff6558$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $0147bee01cff6558$var$normal_vertex = "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif";
var $0147bee01cff6558$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n		vec3 q0 = dFdx( eye_pos.xyz );\n		vec3 q1 = dFdy( eye_pos.xyz );\n		vec2 st0 = dFdx( uv.st );\n		vec2 st1 = dFdy( uv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n		return mat3( T * scale, B * scale, N );\n	}\n#endif";
var $0147bee01cff6558$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = geometryNormal;\n#endif";
var $0147bee01cff6558$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	clearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $0147bee01cff6558$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif";
var $0147bee01cff6558$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n	uniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform sampler2D iridescenceThicknessMap;\n#endif";
var $0147bee01cff6558$var$opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $0147bee01cff6558$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n	vec4 r = vec4( fract( v * PackFactors ), v );\n	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n	return packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n	return unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $0147bee01cff6558$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $0147bee01cff6558$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $0147bee01cff6558$var$dithering_fragment = "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $0147bee01cff6558$var$dithering_pars_fragment = "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif";
var $0147bee01cff6558$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n	roughnessFactor *= texelRoughness.g;\n#endif";
var $0147bee01cff6558$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif";
var $0147bee01cff6558$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return shadow;\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n		vec3 lightToPosition = shadowCoord.xyz;\n		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;\n		vec3 bd3D = normalize( lightToPosition );\n		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n			return (\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n			) * ( 1.0 / 9.0 );\n		#else\n			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n		#endif\n	}\n#endif";
var $0147bee01cff6558$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif";
var $0147bee01cff6558$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n	vec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n		shadowWorldPosition = worldPosition;\n		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n		#endif\n		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n#endif";
var $0147bee01cff6558$var$shadowmask_pars_fragment = "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}";
var $0147bee01cff6558$var$skinbase_vertex = "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $0147bee01cff6558$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	uniform highp sampler2D boneTexture;\n	uniform int boneTextureSize;\n	mat4 getBoneMatrix( const in float i ) {\n		float j = i * 4.0;\n		float x = mod( j, float( boneTextureSize ) );\n		float y = floor( j / float( boneTextureSize ) );\n		float dx = 1.0 / float( boneTextureSize );\n		float dy = 1.0 / float( boneTextureSize );\n		y = dy * ( y + 0.5 );\n		vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n		vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n		vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n		vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n		mat4 bone = mat4( v1, v2, v3, v4 );\n		return bone;\n	}\n#endif";
var $0147bee01cff6558$var$skinning_vertex = "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $0147bee01cff6558$var$skinnormal_vertex = "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif";
var $0147bee01cff6558$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif";
var $0147bee01cff6558$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif";
var $0147bee01cff6558$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $0147bee01cff6558$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $0147bee01cff6558$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n	material.transmission = transmission;\n	material.transmissionAlpha = 1.0;\n	material.thickness = thickness;\n	material.attenuationDistance = attenuationDistance;\n	material.attenuationColor = attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmitted = getIBLVolumeRefraction(\n		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n		material.attenuationColor, material.attenuationDistance );\n	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $0147bee01cff6558$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	float w0( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n	}\n	float w1( float a ) {\n		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n	}\n	float w2( float a ){\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n	}\n	float w3( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * a * a );\n	}\n	float g0( float a ) {\n		return w0( a ) + w1( a );\n	}\n	float g1( float a ) {\n		return w2( a ) + w3( a );\n	}\n	float h0( float a ) {\n		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n	}\n	float h1( float a ) {\n		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n	}\n	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n		uv = uv * texelSize.zw + 0.5;\n		vec2 iuv = floor( uv );\n		vec2 fuv = fract( uv );\n		float g0x = g0( fuv.x );\n		float g1x = g1( fuv.x );\n		float h0x = h0( fuv.x );\n		float h1x = h1( fuv.x );\n		float h0y = h0( fuv.y );\n		float h1y = h1( fuv.y );\n		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n	}\n	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n		vec2 fLodSizeInv = 1.0 / fLodSize;\n		vec2 cLodSizeInv = 1.0 / cLodSize;\n		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n		return mix( fSample, cSample, fract( lod ) );\n	}\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n	}\n	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( isinf( attenuationDistance ) ) {\n			return vec3( 1.0 );\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n		vec3 refractedRayExit = position + transmissionRay;\n		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n		vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n		refractionCoords += 1.0;\n		refractionCoords /= 2.0;\n		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n		vec3 transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n		vec3 attenuatedColor = transmittance * transmittedLight.rgb;\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n	}\n#endif";
var $0147bee01cff6558$var$uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
var $0147bee01cff6558$var$uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	uniform mat3 mapTransform;\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform mat3 alphaMapTransform;\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	uniform mat3 lightMapTransform;\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	uniform mat3 aoMapTransform;\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	uniform mat3 bumpMapTransform;\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	uniform mat3 normalMapTransform;\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	uniform mat3 displacementMapTransform;\n	varying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	uniform mat3 emissiveMapTransform;\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	uniform mat3 metalnessMapTransform;\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	uniform mat3 roughnessMapTransform;\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	uniform mat3 anisotropyMapTransform;\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	uniform mat3 clearcoatMapTransform;\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform mat3 clearcoatNormalMapTransform;\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform mat3 clearcoatRoughnessMapTransform;\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	uniform mat3 sheenColorMapTransform;\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	uniform mat3 sheenRoughnessMapTransform;\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	uniform mat3 iridescenceMapTransform;\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform mat3 iridescenceThicknessMapTransform;\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	uniform mat3 specularMapTransform;\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	uniform mat3 specularColorMapTransform;\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	uniform mat3 specularIntensityMapTransform;\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
var $0147bee01cff6558$var$uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	vUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $0147bee01cff6558$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif";
const $0147bee01cff6558$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $0147bee01cff6558$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const $0147bee01cff6558$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const $0147bee01cff6558$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n	uniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n	uniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );\n	#else\n		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const $0147bee01cff6558$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const $0147bee01cff6558$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n	gl_FragColor = texColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const $0147bee01cff6558$var$vertex$e = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}";
const $0147bee01cff6558$var$fragment$e = "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#endif\n}";
const $0147bee01cff6558$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}";
const $0147bee01cff6558$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}";
const $0147bee01cff6558$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}";
const $0147bee01cff6558$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const $0147bee01cff6558$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $0147bee01cff6558$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $0147bee01cff6558$var$vertex$a = "#include <common>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}";
const $0147bee01cff6558$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $0147bee01cff6558$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $0147bee01cff6558$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_lambert_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $0147bee01cff6558$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}";
const $0147bee01cff6558$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $0147bee01cff6558$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}";
const $0147bee01cff6558$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}";
const $0147bee01cff6558$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $0147bee01cff6558$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $0147bee01cff6558$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}";
const $0147bee01cff6558$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef USE_SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULAR_COLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n	#ifdef USE_SPECULAR_INTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n	uniform float iridescence;\n	uniform float iridescenceIOR;\n	uniform float iridescenceThicknessMinimum;\n	uniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEEN_COLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	uniform vec2 anisotropyVector;\n	#ifdef USE_ANISOTROPYMAP\n		uniform sampler2D anisotropyMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n	#endif\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $0147bee01cff6558$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $0147bee01cff6558$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $0147bee01cff6558$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n	varying vec2 vUv;\n	uniform mat3 uvTransform;\n#endif\nvoid main() {\n	#ifdef USE_POINTS_UV\n		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	#endif\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}";
const $0147bee01cff6558$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $0147bee01cff6558$var$vertex$2 = "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $0147bee01cff6558$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	#include <logdepthbuf_fragment>\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}";
const $0147bee01cff6558$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n	vec2 scale;\n	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $0147bee01cff6558$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}";
const $0147bee01cff6558$export$955f9f2e84c43c8b = {
    alphahash_fragment: $0147bee01cff6558$var$alphahash_fragment,
    alphahash_pars_fragment: $0147bee01cff6558$var$alphahash_pars_fragment,
    alphamap_fragment: $0147bee01cff6558$var$alphamap_fragment,
    alphamap_pars_fragment: $0147bee01cff6558$var$alphamap_pars_fragment,
    alphatest_fragment: $0147bee01cff6558$var$alphatest_fragment,
    alphatest_pars_fragment: $0147bee01cff6558$var$alphatest_pars_fragment,
    aomap_fragment: $0147bee01cff6558$var$aomap_fragment,
    aomap_pars_fragment: $0147bee01cff6558$var$aomap_pars_fragment,
    begin_vertex: $0147bee01cff6558$var$begin_vertex,
    beginnormal_vertex: $0147bee01cff6558$var$beginnormal_vertex,
    bsdfs: $0147bee01cff6558$var$bsdfs,
    iridescence_fragment: $0147bee01cff6558$var$iridescence_fragment,
    bumpmap_pars_fragment: $0147bee01cff6558$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $0147bee01cff6558$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $0147bee01cff6558$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $0147bee01cff6558$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $0147bee01cff6558$var$clipping_planes_vertex,
    color_fragment: $0147bee01cff6558$var$color_fragment,
    color_pars_fragment: $0147bee01cff6558$var$color_pars_fragment,
    color_pars_vertex: $0147bee01cff6558$var$color_pars_vertex,
    color_vertex: $0147bee01cff6558$var$color_vertex,
    common: $0147bee01cff6558$var$common,
    cube_uv_reflection_fragment: $0147bee01cff6558$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $0147bee01cff6558$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $0147bee01cff6558$var$displacementmap_pars_vertex,
    displacementmap_vertex: $0147bee01cff6558$var$displacementmap_vertex,
    emissivemap_fragment: $0147bee01cff6558$var$emissivemap_fragment,
    emissivemap_pars_fragment: $0147bee01cff6558$var$emissivemap_pars_fragment,
    colorspace_fragment: $0147bee01cff6558$var$colorspace_fragment,
    colorspace_pars_fragment: $0147bee01cff6558$var$colorspace_pars_fragment,
    envmap_fragment: $0147bee01cff6558$var$envmap_fragment,
    envmap_common_pars_fragment: $0147bee01cff6558$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $0147bee01cff6558$var$envmap_pars_fragment,
    envmap_pars_vertex: $0147bee01cff6558$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $0147bee01cff6558$var$envmap_physical_pars_fragment,
    envmap_vertex: $0147bee01cff6558$var$envmap_vertex,
    fog_vertex: $0147bee01cff6558$var$fog_vertex,
    fog_pars_vertex: $0147bee01cff6558$var$fog_pars_vertex,
    fog_fragment: $0147bee01cff6558$var$fog_fragment,
    fog_pars_fragment: $0147bee01cff6558$var$fog_pars_fragment,
    gradientmap_pars_fragment: $0147bee01cff6558$var$gradientmap_pars_fragment,
    lightmap_fragment: $0147bee01cff6558$var$lightmap_fragment,
    lightmap_pars_fragment: $0147bee01cff6558$var$lightmap_pars_fragment,
    lights_lambert_fragment: $0147bee01cff6558$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $0147bee01cff6558$var$lights_lambert_pars_fragment,
    lights_pars_begin: $0147bee01cff6558$var$lights_pars_begin,
    lights_toon_fragment: $0147bee01cff6558$var$lights_toon_fragment,
    lights_toon_pars_fragment: $0147bee01cff6558$var$lights_toon_pars_fragment,
    lights_phong_fragment: $0147bee01cff6558$var$lights_phong_fragment,
    lights_phong_pars_fragment: $0147bee01cff6558$var$lights_phong_pars_fragment,
    lights_physical_fragment: $0147bee01cff6558$var$lights_physical_fragment,
    lights_physical_pars_fragment: $0147bee01cff6558$var$lights_physical_pars_fragment,
    lights_fragment_begin: $0147bee01cff6558$var$lights_fragment_begin,
    lights_fragment_maps: $0147bee01cff6558$var$lights_fragment_maps,
    lights_fragment_end: $0147bee01cff6558$var$lights_fragment_end,
    logdepthbuf_fragment: $0147bee01cff6558$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $0147bee01cff6558$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $0147bee01cff6558$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $0147bee01cff6558$var$logdepthbuf_vertex,
    map_fragment: $0147bee01cff6558$var$map_fragment,
    map_pars_fragment: $0147bee01cff6558$var$map_pars_fragment,
    map_particle_fragment: $0147bee01cff6558$var$map_particle_fragment,
    map_particle_pars_fragment: $0147bee01cff6558$var$map_particle_pars_fragment,
    metalnessmap_fragment: $0147bee01cff6558$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $0147bee01cff6558$var$metalnessmap_pars_fragment,
    morphcolor_vertex: $0147bee01cff6558$var$morphcolor_vertex,
    morphnormal_vertex: $0147bee01cff6558$var$morphnormal_vertex,
    morphtarget_pars_vertex: $0147bee01cff6558$var$morphtarget_pars_vertex,
    morphtarget_vertex: $0147bee01cff6558$var$morphtarget_vertex,
    normal_fragment_begin: $0147bee01cff6558$var$normal_fragment_begin,
    normal_fragment_maps: $0147bee01cff6558$var$normal_fragment_maps,
    normal_pars_fragment: $0147bee01cff6558$var$normal_pars_fragment,
    normal_pars_vertex: $0147bee01cff6558$var$normal_pars_vertex,
    normal_vertex: $0147bee01cff6558$var$normal_vertex,
    normalmap_pars_fragment: $0147bee01cff6558$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $0147bee01cff6558$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $0147bee01cff6558$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $0147bee01cff6558$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $0147bee01cff6558$var$iridescence_pars_fragment,
    opaque_fragment: $0147bee01cff6558$var$opaque_fragment,
    packing: $0147bee01cff6558$var$packing,
    premultiplied_alpha_fragment: $0147bee01cff6558$var$premultiplied_alpha_fragment,
    project_vertex: $0147bee01cff6558$var$project_vertex,
    dithering_fragment: $0147bee01cff6558$var$dithering_fragment,
    dithering_pars_fragment: $0147bee01cff6558$var$dithering_pars_fragment,
    roughnessmap_fragment: $0147bee01cff6558$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $0147bee01cff6558$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $0147bee01cff6558$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $0147bee01cff6558$var$shadowmap_pars_vertex,
    shadowmap_vertex: $0147bee01cff6558$var$shadowmap_vertex,
    shadowmask_pars_fragment: $0147bee01cff6558$var$shadowmask_pars_fragment,
    skinbase_vertex: $0147bee01cff6558$var$skinbase_vertex,
    skinning_pars_vertex: $0147bee01cff6558$var$skinning_pars_vertex,
    skinning_vertex: $0147bee01cff6558$var$skinning_vertex,
    skinnormal_vertex: $0147bee01cff6558$var$skinnormal_vertex,
    specularmap_fragment: $0147bee01cff6558$var$specularmap_fragment,
    specularmap_pars_fragment: $0147bee01cff6558$var$specularmap_pars_fragment,
    tonemapping_fragment: $0147bee01cff6558$var$tonemapping_fragment,
    tonemapping_pars_fragment: $0147bee01cff6558$var$tonemapping_pars_fragment,
    transmission_fragment: $0147bee01cff6558$var$transmission_fragment,
    transmission_pars_fragment: $0147bee01cff6558$var$transmission_pars_fragment,
    uv_pars_fragment: $0147bee01cff6558$var$uv_pars_fragment,
    uv_pars_vertex: $0147bee01cff6558$var$uv_pars_vertex,
    uv_vertex: $0147bee01cff6558$var$uv_vertex,
    worldpos_vertex: $0147bee01cff6558$var$worldpos_vertex,
    background_vert: $0147bee01cff6558$var$vertex$h,
    background_frag: $0147bee01cff6558$var$fragment$h,
    backgroundCube_vert: $0147bee01cff6558$var$vertex$g,
    backgroundCube_frag: $0147bee01cff6558$var$fragment$g,
    cube_vert: $0147bee01cff6558$var$vertex$f,
    cube_frag: $0147bee01cff6558$var$fragment$f,
    depth_vert: $0147bee01cff6558$var$vertex$e,
    depth_frag: $0147bee01cff6558$var$fragment$e,
    distanceRGBA_vert: $0147bee01cff6558$var$vertex$d,
    distanceRGBA_frag: $0147bee01cff6558$var$fragment$d,
    equirect_vert: $0147bee01cff6558$var$vertex$c,
    equirect_frag: $0147bee01cff6558$var$fragment$c,
    linedashed_vert: $0147bee01cff6558$var$vertex$b,
    linedashed_frag: $0147bee01cff6558$var$fragment$b,
    meshbasic_vert: $0147bee01cff6558$var$vertex$a,
    meshbasic_frag: $0147bee01cff6558$var$fragment$a,
    meshlambert_vert: $0147bee01cff6558$var$vertex$9,
    meshlambert_frag: $0147bee01cff6558$var$fragment$9,
    meshmatcap_vert: $0147bee01cff6558$var$vertex$8,
    meshmatcap_frag: $0147bee01cff6558$var$fragment$8,
    meshnormal_vert: $0147bee01cff6558$var$vertex$7,
    meshnormal_frag: $0147bee01cff6558$var$fragment$7,
    meshphong_vert: $0147bee01cff6558$var$vertex$6,
    meshphong_frag: $0147bee01cff6558$var$fragment$6,
    meshphysical_vert: $0147bee01cff6558$var$vertex$5,
    meshphysical_frag: $0147bee01cff6558$var$fragment$5,
    meshtoon_vert: $0147bee01cff6558$var$vertex$4,
    meshtoon_frag: $0147bee01cff6558$var$fragment$4,
    points_vert: $0147bee01cff6558$var$vertex$3,
    points_frag: $0147bee01cff6558$var$fragment$3,
    shadow_vert: $0147bee01cff6558$var$vertex$2,
    shadow_frag: $0147bee01cff6558$var$fragment$2,
    sprite_vert: $0147bee01cff6558$var$vertex$1,
    sprite_frag: $0147bee01cff6558$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ const $0147bee01cff6558$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
        },
        normalScale: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    }
};
const $0147bee01cff6558$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.common,
            $0147bee01cff6558$export$6643083551874bf5.specularmap,
            $0147bee01cff6558$export$6643083551874bf5.envmap,
            $0147bee01cff6558$export$6643083551874bf5.aomap,
            $0147bee01cff6558$export$6643083551874bf5.lightmap,
            $0147bee01cff6558$export$6643083551874bf5.fog
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.common,
            $0147bee01cff6558$export$6643083551874bf5.specularmap,
            $0147bee01cff6558$export$6643083551874bf5.envmap,
            $0147bee01cff6558$export$6643083551874bf5.aomap,
            $0147bee01cff6558$export$6643083551874bf5.lightmap,
            $0147bee01cff6558$export$6643083551874bf5.emissivemap,
            $0147bee01cff6558$export$6643083551874bf5.bumpmap,
            $0147bee01cff6558$export$6643083551874bf5.normalmap,
            $0147bee01cff6558$export$6643083551874bf5.displacementmap,
            $0147bee01cff6558$export$6643083551874bf5.fog,
            $0147bee01cff6558$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $0147bee01cff6558$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.common,
            $0147bee01cff6558$export$6643083551874bf5.specularmap,
            $0147bee01cff6558$export$6643083551874bf5.envmap,
            $0147bee01cff6558$export$6643083551874bf5.aomap,
            $0147bee01cff6558$export$6643083551874bf5.lightmap,
            $0147bee01cff6558$export$6643083551874bf5.emissivemap,
            $0147bee01cff6558$export$6643083551874bf5.bumpmap,
            $0147bee01cff6558$export$6643083551874bf5.normalmap,
            $0147bee01cff6558$export$6643083551874bf5.displacementmap,
            $0147bee01cff6558$export$6643083551874bf5.fog,
            $0147bee01cff6558$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $0147bee01cff6558$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new $0147bee01cff6558$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.common,
            $0147bee01cff6558$export$6643083551874bf5.envmap,
            $0147bee01cff6558$export$6643083551874bf5.aomap,
            $0147bee01cff6558$export$6643083551874bf5.lightmap,
            $0147bee01cff6558$export$6643083551874bf5.emissivemap,
            $0147bee01cff6558$export$6643083551874bf5.bumpmap,
            $0147bee01cff6558$export$6643083551874bf5.normalmap,
            $0147bee01cff6558$export$6643083551874bf5.displacementmap,
            $0147bee01cff6558$export$6643083551874bf5.roughnessmap,
            $0147bee01cff6558$export$6643083551874bf5.metalnessmap,
            $0147bee01cff6558$export$6643083551874bf5.fog,
            $0147bee01cff6558$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $0147bee01cff6558$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                } // temporary
            }
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.common,
            $0147bee01cff6558$export$6643083551874bf5.aomap,
            $0147bee01cff6558$export$6643083551874bf5.lightmap,
            $0147bee01cff6558$export$6643083551874bf5.emissivemap,
            $0147bee01cff6558$export$6643083551874bf5.bumpmap,
            $0147bee01cff6558$export$6643083551874bf5.normalmap,
            $0147bee01cff6558$export$6643083551874bf5.displacementmap,
            $0147bee01cff6558$export$6643083551874bf5.gradientmap,
            $0147bee01cff6558$export$6643083551874bf5.fog,
            $0147bee01cff6558$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $0147bee01cff6558$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.common,
            $0147bee01cff6558$export$6643083551874bf5.bumpmap,
            $0147bee01cff6558$export$6643083551874bf5.normalmap,
            $0147bee01cff6558$export$6643083551874bf5.displacementmap,
            $0147bee01cff6558$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.points,
            $0147bee01cff6558$export$6643083551874bf5.fog
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.common,
            $0147bee01cff6558$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.common,
            $0147bee01cff6558$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.common,
            $0147bee01cff6558$export$6643083551874bf5.bumpmap,
            $0147bee01cff6558$export$6643083551874bf5.normalmap,
            $0147bee01cff6558$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.sprite,
            $0147bee01cff6558$export$6643083551874bf5.fog
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.common,
            $0147bee01cff6558$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.lights,
            $0147bee01cff6558$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new $0147bee01cff6558$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.shadow_frag
    }
};
$0147bee01cff6558$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ $0147bee01cff6558$var$mergeUniforms([
        $0147bee01cff6558$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new $0147bee01cff6558$export$892596cec99bc70e(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new $0147bee01cff6558$export$892596cec99bc70e(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new $0147bee01cff6558$export$892596cec99bc70e(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918()
            }
        }
    ]),
    vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshphysical_frag
};
const $0147bee01cff6558$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
function $0147bee01cff6558$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new $0147bee01cff6558$export$892596cec99bc70e(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function render(renderList, scene) {
        let forceClear = false;
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const xr = renderer.xr;
        const environmentBlendMode = xr.getEnvironmentBlendMode();
        switch(environmentBlendMode){
            case "opaque":
                forceClear = true;
                break;
            case "additive":
                state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
                forceClear = true;
                break;
            case "alpha-blend":
                state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
                forceClear = true;
                break;
        }
        if (renderer.autoClear || forceClear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        if (background && (background.isCubeTexture || background.mapping === $0147bee01cff6558$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $0147bee01cff6558$export$e176487c05830cc5(new $0147bee01cff6558$export$33e43285f7406bd5(1, 1, 1), new $0147bee01cff6558$export$83c7d75d550a8b0d({
                    name: "BackgroundCubeMaterial",
                    uniforms: $0147bee01cff6558$var$cloneUniforms($0147bee01cff6558$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $0147bee01cff6558$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $0147bee01cff6558$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: $0147bee01cff6558$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute("normal");
                boxMesh.geometry.deleteAttribute("uv");
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, "envMap", {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.toneMapped = background.colorSpace === $0147bee01cff6558$export$561f394b24edfcaa ? false : true;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $0147bee01cff6558$export$e176487c05830cc5(new $0147bee01cff6558$export$967d831af31f69ce(2, 2), new $0147bee01cff6558$export$83c7d75d550a8b0d({
                    name: "BackgroundMaterial",
                    uniforms: $0147bee01cff6558$var$cloneUniforms($0147bee01cff6558$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $0147bee01cff6558$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $0147bee01cff6558$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $0147bee01cff6558$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute("normal");
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, "map", {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = background.colorSpace === $0147bee01cff6558$export$561f394b24edfcaa ? false : true;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($0147bee01cff6558$var$_rgb, $0147bee01cff6558$var$getUnlitUniformColorSpace(renderer));
        state.buffers.color.setClear($0147bee01cff6558$var$_rgb.r, $0147bee01cff6558$var$_rgb.g, $0147bee01cff6558$var$_rgb.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render
    };
}
function $0147bee01cff6558$var$WebGLBindingStates(gl, extensions, attributes, capabilities) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const extension = capabilities.isWebGL2 ? null : extensions.get("OES_vertex_array_object");
    const vaoAvailable = capabilities.isWebGL2 || extension !== null;
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        if (vaoAvailable) {
            const state = getBindingState(geometry, program, material);
            if (currentState !== state) {
                currentState = state;
                bindVertexArrayObject(currentState.object);
            }
            updateBuffers = needsUpdate(object, geometry, program, index);
            if (updateBuffers) saveCache(object, geometry, program, index);
        } else {
            const wireframe = material.wireframe === true;
            if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
                currentState.geometry = geometry.id;
                currentState.program = program.id;
                currentState.wireframe = wireframe;
                updateBuffers = true;
            }
        }
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        if (capabilities.isWebGL2) return gl.createVertexArray();
        return extension.createVertexArrayOES();
    }
    function bindVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
        return extension.bindVertexArrayOES(vao);
    }
    function deleteVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
        return extension.deleteVertexArrayOES(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            const extension = capabilities.isWebGL2 ? gl : extensions.get("ANGLE_instanced_arrays");
            extension[capabilities.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
            if (extensions.get("ANGLE_instanced_arrays") === null) return;
        }
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes (WebGL 2 only)
                    const integer = capabilities.isWebGL2 === true && (type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === $0147bee01cff6558$export$5c612977753abe2);
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $0147bee01cff6558$var$WebGLBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = "drawArraysInstanced";
        } else {
            extension = extensions.get("ANGLE_instanced_arrays");
            methodName = "drawArraysInstancedANGLE";
            if (extension === null) {
                console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                return;
            }
        }
        extension[methodName](mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $0147bee01cff6558$var$WebGLCapabilities(gl, extensions, parameters) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function getMaxPrecision(precision) {
        if (precision === "highp") {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return "highp";
            precision = "mediump";
        }
        if (precision === "mediump") {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return "mediump";
        }
        return "lowp";
    }
    const isWebGL2 = typeof WebGL2RenderingContext !== "undefined" && gl.constructor.name === "WebGL2RenderingContext";
    let precision = parameters.precision !== undefined ? parameters.precision : "highp";
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn("THREE.WebGLRenderer:", precision, "not supported, using", maxPrecision, "instead.");
        precision = maxPrecision;
    }
    const drawBuffers = isWebGL2 || extensions.has("WEBGL_draw_buffers");
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const vertexTextures = maxVertexTextures > 0;
    const floatFragmentTextures = isWebGL2 || extensions.has("OES_texture_float");
    const floatVertexTextures = vertexTextures && floatFragmentTextures;
    const maxSamples = isWebGL2 ? gl.getParameter(gl.MAX_SAMPLES) : 0;
    return {
        isWebGL2: isWebGL2,
        drawBuffers: drawBuffers,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        floatFragmentTextures: floatFragmentTextures,
        floatVertexTextures: floatVertexTextures,
        maxSamples: maxSamples
    };
}
function $0147bee01cff6558$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new $0147bee01cff6558$export$7ff5ac152ef991b0(), viewNormalMatrix = new $0147bee01cff6558$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $0147bee01cff6558$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $0147bee01cff6558$export$d64030b316d3b087) texture.mapping = $0147bee01cff6558$export$8759762a6477f2c4;
        else if (mapping === $0147bee01cff6558$export$ee99d97d46898098) texture.mapping = $0147bee01cff6558$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture && texture.isRenderTargetTexture === false) {
            const mapping = texture.mapping;
            if (mapping === $0147bee01cff6558$export$d64030b316d3b087 || mapping === $0147bee01cff6558$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new $0147bee01cff6558$export$ac386671d651941e(image.height / 2);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener("dispose", onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $0147bee01cff6558$export$9ebf355ee4ed261b extends $0147bee01cff6558$export$79f141de891a5fed {
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.isOrthographicCamera = true;
        this.type = "OrthographicCamera";
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
const $0147bee01cff6558$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $0147bee01cff6558$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $0147bee01cff6558$var$MAX_SAMPLES = 20;
const $0147bee01cff6558$var$_flatCamera = /*@__PURE__*/ new $0147bee01cff6558$export$9ebf355ee4ed261b();
const $0147bee01cff6558$var$_clearColor = /*@__PURE__*/ new $0147bee01cff6558$export$892596cec99bc70e();
let $0147bee01cff6558$var$_oldTarget = null;
// Golden Ratio
const $0147bee01cff6558$var$PHI = (1 + Math.sqrt(5)) / 2;
const $0147bee01cff6558$var$INV_PHI = 1 / $0147bee01cff6558$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $0147bee01cff6558$var$_axisDirections = [
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(1, 1, 1),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(0, $0147bee01cff6558$var$PHI, $0147bee01cff6558$var$INV_PHI),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(0, $0147bee01cff6558$var$PHI, -$0147bee01cff6558$var$INV_PHI),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699($0147bee01cff6558$var$INV_PHI, 0, $0147bee01cff6558$var$PHI),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(-$0147bee01cff6558$var$INV_PHI, 0, $0147bee01cff6558$var$PHI),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699($0147bee01cff6558$var$PHI, $0147bee01cff6558$var$INV_PHI, 0),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(-$0147bee01cff6558$var$PHI, $0147bee01cff6558$var$INV_PHI, 0)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $0147bee01cff6558$export$6add42717753e221 {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $0147bee01cff6558$var$_oldTarget = this._renderer.getRenderTarget();
        this._setSize(256);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $0147bee01cff6558$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $0147bee01cff6558$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($0147bee01cff6558$var$_oldTarget);
        outputTarget.scissorTest = false;
        $0147bee01cff6558$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === $0147bee01cff6558$export$8759762a6477f2c4 || texture.mapping === $0147bee01cff6558$export$dc59f8aed047f61d) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $0147bee01cff6558$var$_oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: $0147bee01cff6558$export$8a72f490b25c56c8,
            minFilter: $0147bee01cff6558$export$8a72f490b25c56c8,
            generateMipmaps: false,
            type: $0147bee01cff6558$export$2697304443f382bc,
            format: $0147bee01cff6558$export$3f8bb04b555a363c,
            colorSpace: $0147bee01cff6558$export$42429b3acfb233a4,
            depthBuffer: false
        };
        const cubeUVRenderTarget = $0147bee01cff6558$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $0147bee01cff6558$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = $0147bee01cff6558$var$_createPlanes(_lodMax));
            this._blurMaterial = $0147bee01cff6558$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new $0147bee01cff6558$export$e176487c05830cc5(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $0147bee01cff6558$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new $0147bee01cff6558$export$74e4ae24825f68d7(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($0147bee01cff6558$var$_clearColor);
        renderer.toneMapping = $0147bee01cff6558$export$9fcb6b4294603b2;
        renderer.autoClear = false;
        const backgroundMaterial = new $0147bee01cff6558$export$55cbcc9b622fe1f5({
            name: "PMREM.Background",
            side: $0147bee01cff6558$export$d9f0486e75b5ace,
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new $0147bee01cff6558$export$e176487c05830cc5(new $0147bee01cff6558$export$33e43285f7406bd5(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($0147bee01cff6558$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            const size = this._cubeSize;
            $0147bee01cff6558$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === $0147bee01cff6558$export$8759762a6477f2c4 || texture.mapping === $0147bee01cff6558$export$dc59f8aed047f61d;
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $0147bee01cff6558$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $0147bee01cff6558$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new $0147bee01cff6558$export$e176487c05830cc5(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms["envMap"].value = texture;
        const size = this._cubeSize;
        $0147bee01cff6558$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $0147bee01cff6558$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        for(let i = 1; i < this._lodPlanes.length; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $0147bee01cff6558$var$_axisDirections[(i - 1) % $0147bee01cff6558$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, "latitudinal", poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, "longitudinal", poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== "latitudinal" && direction !== "longitudinal") console.error("blur direction must be either latitudinal or longitudinal!");
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new $0147bee01cff6558$export$e176487c05830cc5(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $0147bee01cff6558$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $0147bee01cff6558$var$MAX_SAMPLES;
        if (samples > $0147bee01cff6558$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$0147bee01cff6558$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $0147bee01cff6558$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms["envMap"].value = targetIn.texture;
        blurUniforms["samples"].value = samples;
        blurUniforms["weights"].value = weights;
        blurUniforms["latitudinal"].value = direction === "latitudinal";
        if (poleAxis) blurUniforms["poleAxis"].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms["dTheta"].value = radiansPerPixel;
        blurUniforms["mipInt"].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $0147bee01cff6558$var$LOD_MIN ? lodOut - _lodMax + $0147bee01cff6558$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $0147bee01cff6558$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $0147bee01cff6558$var$_flatCamera);
    }
}
function $0147bee01cff6558$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - $0147bee01cff6558$var$LOD_MIN + 1 + $0147bee01cff6558$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $0147bee01cff6558$var$LOD_MIN) sigma = $0147bee01cff6558$var$EXTRA_LOD_SIGMA[i - lodMax + $0147bee01cff6558$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new $0147bee01cff6558$export$b7be63a67df8959();
        planes.setAttribute("position", new $0147bee01cff6558$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute("uv", new $0147bee01cff6558$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute("faceIndex", new $0147bee01cff6558$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $0147bee01cff6558$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $0147bee01cff6558$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new $0147bee01cff6558$export$3c052beb2e51e23f(width, height, params);
    cubeUVRenderTarget.texture.mapping = $0147bee01cff6558$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = "PMREM.cubeUv";
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $0147bee01cff6558$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $0147bee01cff6558$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($0147bee01cff6558$var$MAX_SAMPLES);
    const poleAxis = new $0147bee01cff6558$export$64b5c384219d3699(0, 1, 0);
    const shaderMaterial = new $0147bee01cff6558$export$83c7d75d550a8b0d({
        name: "SphericalGaussianBlur",
        defines: {
            "n": $0147bee01cff6558$var$MAX_SAMPLES,
            "CUBEUV_TEXEL_WIDTH": 1.0 / width,
            "CUBEUV_TEXEL_HEIGHT": 1.0 / height,
            "CUBEUV_MAX_MIP": `${lodMax}.0`
        },
        uniforms: {
            "envMap": {
                value: null
            },
            "samples": {
                value: 1
            },
            "weights": {
                value: weights
            },
            "latitudinal": {
                value: false
            },
            "dTheta": {
                value: 0
            },
            "mipInt": {
                value: 0
            },
            "poleAxis": {
                value: poleAxis
            }
        },
        vertexShader: $0147bee01cff6558$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: $0147bee01cff6558$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $0147bee01cff6558$var$_getEquirectMaterial() {
    return new $0147bee01cff6558$export$83c7d75d550a8b0d({
        name: "EquirectangularToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            }
        },
        vertexShader: $0147bee01cff6558$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: $0147bee01cff6558$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $0147bee01cff6558$var$_getCubemapMaterial() {
    return new $0147bee01cff6558$export$83c7d75d550a8b0d({
        name: "CubemapToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            },
            "flipEnvMap": {
                value: -1
            }
        },
        vertexShader: $0147bee01cff6558$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: $0147bee01cff6558$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $0147bee01cff6558$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $0147bee01cff6558$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === $0147bee01cff6558$export$d64030b316d3b087 || mapping === $0147bee01cff6558$export$ee99d97d46898098;
            const isCubeMap = mapping === $0147bee01cff6558$export$8759762a6477f2c4 || mapping === $0147bee01cff6558$export$dc59f8aed047f61d;
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                if (texture.isRenderTargetTexture && texture.needsPMREMUpdate === true) {
                    texture.needsPMREMUpdate = false;
                    let renderTarget = cubeUVmaps.get(texture);
                    if (pmremGenerator === null) pmremGenerator = new $0147bee01cff6558$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (cubeUVmaps.has(texture)) return cubeUVmaps.get(texture).texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $0147bee01cff6558$export$6add42717753e221(renderer);
                            const renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener("dispose", onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $0147bee01cff6558$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case "WEBGL_depth_texture":
                extension = gl.getExtension("WEBGL_depth_texture") || gl.getExtension("MOZ_WEBGL_depth_texture") || gl.getExtension("WEBKIT_WEBGL_depth_texture");
                break;
            case "EXT_texture_filter_anisotropic":
                extension = gl.getExtension("EXT_texture_filter_anisotropic") || gl.getExtension("MOZ_EXT_texture_filter_anisotropic") || gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                break;
            case "WEBGL_compressed_texture_s3tc":
                extension = gl.getExtension("WEBGL_compressed_texture_s3tc") || gl.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                break;
            case "WEBGL_compressed_texture_pvrtc":
                extension = gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function(capabilities) {
            if (capabilities.isWebGL2) getExtension("EXT_color_buffer_float");
            else {
                getExtension("WEBGL_depth_texture");
                getExtension("OES_texture_float");
                getExtension("OES_texture_half_float");
                getExtension("OES_texture_half_float_linear");
                getExtension("OES_standard_derivatives");
                getExtension("OES_element_index_uint");
                getExtension("OES_vertex_array_object");
                getExtension("ANGLE_instanced_arrays");
            }
            getExtension("OES_texture_float_linear");
            getExtension("EXT_color_buffer_half_float");
            getExtension("WEBGL_multisampled_render_to_texture");
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) console.warn("THREE.WebGLRenderer: " + name + " extension not supported.");
            return extension;
        }
    };
}
function $0147bee01cff6558$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        for(const name in geometry.morphAttributes){
            const array = geometry.morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.remove(array[i]);
        }
        geometry.removeEventListener("dispose", onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener("dispose", onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], gl.ARRAY_BUFFER);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else if (geometryPosition !== undefined) {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        } else return;
        const attribute = new ($0147bee01cff6558$var$arrayNeedsUint32(indices) ? $0147bee01cff6558$export$7eb8c9fa25cd5bd6 : $0147bee01cff6558$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $0147bee01cff6558$var$WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = "drawElementsInstanced";
        } else {
            extension = extensions.get("ANGLE_instanced_arrays");
            methodName = "drawElementsInstancedANGLE";
            if (extension === null) {
                console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                return;
            }
        }
        extension[methodName](mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $0147bee01cff6558$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                console.error("THREE.WebGLInfo: Unknown draw mode:", mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $0147bee01cff6558$var$numericalSort(a, b) {
    return a[0] - b[0];
}
function $0147bee01cff6558$var$absNumericalSort(a, b) {
    return Math.abs(b[1]) - Math.abs(a[1]);
}
function $0147bee01cff6558$var$WebGLMorphtargets(gl, capabilities, textures) {
    const influencesList = {};
    const morphInfluences = new Float32Array(8);
    const morphTextures = new WeakMap();
    const morph = new $0147bee01cff6558$export$fa7daccca11cdbe3();
    const workInfluences = [];
    for(let i = 0; i < 8; i++)workInfluences[i] = [
        i,
        0
    ];
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        if (capabilities.isWebGL2 === true) {
            // instead of using attributes, the WebGL 2 code path encodes morph targets
            // into an array of data textures. Each layer represents a single morph target.
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            let entry = morphTextures.get(geometry);
            if (entry === undefined || entry.count !== morphTargetsCount) {
                if (entry !== undefined) entry.texture.dispose();
                const hasMorphPosition = geometry.morphAttributes.position !== undefined;
                const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
                const hasMorphColors = geometry.morphAttributes.color !== undefined;
                const morphTargets = geometry.morphAttributes.position || [];
                const morphNormals = geometry.morphAttributes.normal || [];
                const morphColors = geometry.morphAttributes.color || [];
                let vertexDataCount = 0;
                if (hasMorphPosition === true) vertexDataCount = 1;
                if (hasMorphNormals === true) vertexDataCount = 2;
                if (hasMorphColors === true) vertexDataCount = 3;
                let width = geometry.attributes.position.count * vertexDataCount;
                let height = 1;
                if (width > capabilities.maxTextureSize) {
                    height = Math.ceil(width / capabilities.maxTextureSize);
                    width = capabilities.maxTextureSize;
                }
                const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
                const texture = new $0147bee01cff6558$export$dfac6c8e811406a3(buffer, width, height, morphTargetsCount);
                texture.type = $0147bee01cff6558$export$f6d331659b644596;
                texture.needsUpdate = true;
                // fill buffer
                const vertexDataStride = vertexDataCount * 4;
                for(let i = 0; i < morphTargetsCount; i++){
                    const morphTarget = morphTargets[i];
                    const morphNormal = morphNormals[i];
                    const morphColor = morphColors[i];
                    const offset = width * height * 4 * i;
                    for(let j = 0; j < morphTarget.count; j++){
                        const stride = j * vertexDataStride;
                        if (hasMorphPosition === true) {
                            morph.fromBufferAttribute(morphTarget, j);
                            buffer[offset + stride + 0] = morph.x;
                            buffer[offset + stride + 1] = morph.y;
                            buffer[offset + stride + 2] = morph.z;
                            buffer[offset + stride + 3] = 0;
                        }
                        if (hasMorphNormals === true) {
                            morph.fromBufferAttribute(morphNormal, j);
                            buffer[offset + stride + 4] = morph.x;
                            buffer[offset + stride + 5] = morph.y;
                            buffer[offset + stride + 6] = morph.z;
                            buffer[offset + stride + 7] = 0;
                        }
                        if (hasMorphColors === true) {
                            morph.fromBufferAttribute(morphColor, j);
                            buffer[offset + stride + 8] = morph.x;
                            buffer[offset + stride + 9] = morph.y;
                            buffer[offset + stride + 10] = morph.z;
                            buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                        }
                    }
                }
                entry = {
                    count: morphTargetsCount,
                    texture: texture,
                    size: new $0147bee01cff6558$export$c977b3e384af9ae1(width, height)
                };
                morphTextures.set(geometry, entry);
                function disposeTexture() {
                    texture.dispose();
                    morphTextures.delete(geometry);
                    geometry.removeEventListener("dispose", disposeTexture);
                }
                geometry.addEventListener("dispose", disposeTexture);
            }
            //
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
            program.getUniforms().setValue(gl, "morphTargetInfluences", objectInfluences);
            program.getUniforms().setValue(gl, "morphTargetsTexture", entry.texture, textures);
            program.getUniforms().setValue(gl, "morphTargetsTextureSize", entry.size);
        } else {
            // When object doesn't have morph target influences defined, we treat it as a 0-length array
            // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
            const length = objectInfluences === undefined ? 0 : objectInfluences.length;
            let influences = influencesList[geometry.id];
            if (influences === undefined || influences.length !== length) {
                // initialise list
                influences = [];
                for(let i = 0; i < length; i++)influences[i] = [
                    i,
                    0
                ];
                influencesList[geometry.id] = influences;
            }
            // Collect influences
            for(let i = 0; i < length; i++){
                const influence = influences[i];
                influence[0] = i;
                influence[1] = objectInfluences[i];
            }
            influences.sort($0147bee01cff6558$var$absNumericalSort);
            for(let i = 0; i < 8; i++)if (i < length && influences[i][1]) {
                workInfluences[i][0] = influences[i][0];
                workInfluences[i][1] = influences[i][1];
            } else {
                workInfluences[i][0] = Number.MAX_SAFE_INTEGER;
                workInfluences[i][1] = 0;
            }
            workInfluences.sort($0147bee01cff6558$var$numericalSort);
            const morphTargets = geometry.morphAttributes.position;
            const morphNormals = geometry.morphAttributes.normal;
            let morphInfluencesSum = 0;
            for(let i = 0; i < 8; i++){
                const influence = workInfluences[i];
                const index = influence[0];
                const value = influence[1];
                if (index !== Number.MAX_SAFE_INTEGER && value) {
                    if (morphTargets && geometry.getAttribute("morphTarget" + i) !== morphTargets[index]) geometry.setAttribute("morphTarget" + i, morphTargets[index]);
                    if (morphNormals && geometry.getAttribute("morphNormal" + i) !== morphNormals[index]) geometry.setAttribute("morphNormal" + i, morphNormals[index]);
                    morphInfluences[i] = value;
                    morphInfluencesSum += value;
                } else {
                    if (morphTargets && geometry.hasAttribute("morphTarget" + i) === true) geometry.deleteAttribute("morphTarget" + i);
                    if (morphNormals && geometry.hasAttribute("morphNormal" + i) === true) geometry.deleteAttribute("morphNormal" + i);
                    morphInfluences[i] = 0;
                }
            }
            // GLSL shader uses formula baseinfluence * base + sum(target * influence)
            // This allows us to switch between absolute morphs and relative morphs without changing shader code
            // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
            program.getUniforms().setValue(gl, "morphTargetInfluences", morphInfluences);
        }
    }
    return {
        update: update
    };
}
function $0147bee01cff6558$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener("dispose", onInstancedMeshDispose) === false) object.addEventListener("dispose", onInstancedMeshDispose);
            if (updateMap.get(object) !== frame) {
                attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
                if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
                updateMap.set(object, frame);
            }
        }
        if (object.isSkinnedMesh) {
            const skeleton = object.skeleton;
            if (updateMap.get(skeleton) !== frame) {
                skeleton.update();
                updateMap.set(skeleton, frame);
            }
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener("dispose", onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $0147bee01cff6558$var$emptyTexture = /*@__PURE__*/ new $0147bee01cff6558$export$5431306cf43de24a();
const $0147bee01cff6558$var$emptyArrayTexture = /*@__PURE__*/ new $0147bee01cff6558$export$dfac6c8e811406a3();
const $0147bee01cff6558$var$empty3dTexture = /*@__PURE__*/ new $0147bee01cff6558$export$d7a3086320f856db();
const $0147bee01cff6558$var$emptyCubeTexture = /*@__PURE__*/ new $0147bee01cff6558$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $0147bee01cff6558$var$arrayCacheF32 = [];
const $0147bee01cff6558$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $0147bee01cff6558$var$mat4array = new Float32Array(16);
const $0147bee01cff6558$var$mat3array = new Float32Array(9);
const $0147bee01cff6558$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $0147bee01cff6558$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $0147bee01cff6558$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $0147bee01cff6558$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $0147bee01cff6558$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $0147bee01cff6558$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $0147bee01cff6558$var$allocTexUnits(textures, n) {
    let r = $0147bee01cff6558$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $0147bee01cff6558$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $0147bee01cff6558$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $0147bee01cff6558$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $0147bee01cff6558$var$copyArray(cache, v);
    }
}
function $0147bee01cff6558$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $0147bee01cff6558$var$copyArray(cache, v);
    }
}
function $0147bee01cff6558$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $0147bee01cff6558$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $0147bee01cff6558$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $0147bee01cff6558$var$copyArray(cache, v);
    } else {
        if ($0147bee01cff6558$var$arraysEqual(cache, elements)) return;
        $0147bee01cff6558$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $0147bee01cff6558$var$mat2array);
        $0147bee01cff6558$var$copyArray(cache, elements);
    }
}
function $0147bee01cff6558$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $0147bee01cff6558$var$copyArray(cache, v);
    } else {
        if ($0147bee01cff6558$var$arraysEqual(cache, elements)) return;
        $0147bee01cff6558$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $0147bee01cff6558$var$mat3array);
        $0147bee01cff6558$var$copyArray(cache, elements);
    }
}
function $0147bee01cff6558$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $0147bee01cff6558$var$copyArray(cache, v);
    } else {
        if ($0147bee01cff6558$var$arraysEqual(cache, elements)) return;
        $0147bee01cff6558$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $0147bee01cff6558$var$mat4array);
        $0147bee01cff6558$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $0147bee01cff6558$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $0147bee01cff6558$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $0147bee01cff6558$var$copyArray(cache, v);
    }
}
function $0147bee01cff6558$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $0147bee01cff6558$var$copyArray(cache, v);
    }
}
function $0147bee01cff6558$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $0147bee01cff6558$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $0147bee01cff6558$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $0147bee01cff6558$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $0147bee01cff6558$var$copyArray(cache, v);
    }
}
function $0147bee01cff6558$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $0147bee01cff6558$var$copyArray(cache, v);
    }
}
function $0147bee01cff6558$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $0147bee01cff6558$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $0147bee01cff6558$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2D(v || $0147bee01cff6558$var$emptyTexture, unit);
}
function $0147bee01cff6558$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $0147bee01cff6558$var$empty3dTexture, unit);
}
function $0147bee01cff6558$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $0147bee01cff6558$var$emptyCubeTexture, unit);
}
function $0147bee01cff6558$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $0147bee01cff6558$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $0147bee01cff6558$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $0147bee01cff6558$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $0147bee01cff6558$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $0147bee01cff6558$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $0147bee01cff6558$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $0147bee01cff6558$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $0147bee01cff6558$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $0147bee01cff6558$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $0147bee01cff6558$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $0147bee01cff6558$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $0147bee01cff6558$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $0147bee01cff6558$var$setValueV4i; // _VEC4
        case 0x1405:
            return $0147bee01cff6558$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $0147bee01cff6558$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $0147bee01cff6558$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $0147bee01cff6558$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $0147bee01cff6558$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $0147bee01cff6558$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $0147bee01cff6558$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $0147bee01cff6558$var$setValueT2DArray1;
    }
}
// Array of scalars
function $0147bee01cff6558$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $0147bee01cff6558$var$setValueV2fArray(gl, v) {
    const data = $0147bee01cff6558$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $0147bee01cff6558$var$setValueV3fArray(gl, v) {
    const data = $0147bee01cff6558$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $0147bee01cff6558$var$setValueV4fArray(gl, v) {
    const data = $0147bee01cff6558$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $0147bee01cff6558$var$setValueM2Array(gl, v) {
    const data = $0147bee01cff6558$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $0147bee01cff6558$var$setValueM3Array(gl, v) {
    const data = $0147bee01cff6558$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $0147bee01cff6558$var$setValueM4Array(gl, v) {
    const data = $0147bee01cff6558$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $0147bee01cff6558$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $0147bee01cff6558$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $0147bee01cff6558$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $0147bee01cff6558$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $0147bee01cff6558$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $0147bee01cff6558$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $0147bee01cff6558$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $0147bee01cff6558$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $0147bee01cff6558$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $0147bee01cff6558$var$allocTexUnits(textures, n);
    if (!$0147bee01cff6558$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $0147bee01cff6558$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $0147bee01cff6558$var$emptyTexture, units[i]);
}
function $0147bee01cff6558$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $0147bee01cff6558$var$allocTexUnits(textures, n);
    if (!$0147bee01cff6558$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $0147bee01cff6558$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $0147bee01cff6558$var$empty3dTexture, units[i]);
}
function $0147bee01cff6558$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $0147bee01cff6558$var$allocTexUnits(textures, n);
    if (!$0147bee01cff6558$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $0147bee01cff6558$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $0147bee01cff6558$var$emptyCubeTexture, units[i]);
}
function $0147bee01cff6558$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $0147bee01cff6558$var$allocTexUnits(textures, n);
    if (!$0147bee01cff6558$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $0147bee01cff6558$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $0147bee01cff6558$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $0147bee01cff6558$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $0147bee01cff6558$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $0147bee01cff6558$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $0147bee01cff6558$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $0147bee01cff6558$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $0147bee01cff6558$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $0147bee01cff6558$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $0147bee01cff6558$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $0147bee01cff6558$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $0147bee01cff6558$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $0147bee01cff6558$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $0147bee01cff6558$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $0147bee01cff6558$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $0147bee01cff6558$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $0147bee01cff6558$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $0147bee01cff6558$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $0147bee01cff6558$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $0147bee01cff6558$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $0147bee01cff6558$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $0147bee01cff6558$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $0147bee01cff6558$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.setValue = $0147bee01cff6558$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $0147bee01cff6558$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.size = activeInfo.size;
        this.setValue = $0147bee01cff6558$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $0147bee01cff6558$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $0147bee01cff6558$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $0147bee01cff6558$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $0147bee01cff6558$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $0147bee01cff6558$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $0147bee01cff6558$var$RePathPart.exec(path), matchEnd = $0147bee01cff6558$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === "]", subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === "[" && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $0147bee01cff6558$var$addUniform(container, subscript === undefined ? new $0147bee01cff6558$var$SingleUniform(id, activeInfo, addr) : new $0147bee01cff6558$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $0147bee01cff6558$var$StructuredUniform(id);
                $0147bee01cff6558$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $0147bee01cff6558$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $0147bee01cff6558$var$parseUniform(info, addr, this);
        }
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $0147bee01cff6558$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
let $0147bee01cff6558$var$programIdCount = 0;
function $0147bee01cff6558$var$handleSource(string, errorLine) {
    const lines = string.split("\n");
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? ">" : " "} ${line}: ${lines[i]}`);
    }
    return lines2.join("\n");
}
function $0147bee01cff6558$var$getEncodingComponents(colorSpace1) {
    switch(colorSpace1){
        case $0147bee01cff6558$export$42429b3acfb233a4:
            return [
                "Linear",
                "( value )"
            ];
        case $0147bee01cff6558$export$561f394b24edfcaa:
            return [
                "sRGB",
                "( value )"
            ];
        default:
            console.warn("THREE.WebGLProgram: Unsupported color space:", colorSpace1);
            return [
                "Linear",
                "( value )"
            ];
    }
}
function $0147bee01cff6558$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === "") return "";
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + "\n\n" + errors + "\n\n" + $0147bee01cff6558$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $0147bee01cff6558$var$getTexelEncodingFunction(functionName, colorSpace1) {
    const components = $0147bee01cff6558$var$getEncodingComponents(colorSpace1);
    return "vec4 " + functionName + "( vec4 value ) { return LinearTo" + components[0] + components[1] + "; }";
}
function $0147bee01cff6558$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case $0147bee01cff6558$export$98f52c2a46c598ca:
            toneMappingName = "Linear";
            break;
        case $0147bee01cff6558$export$74b25e54b3bcd548:
            toneMappingName = "Reinhard";
            break;
        case $0147bee01cff6558$export$932b3dd283d4a366:
            toneMappingName = "OptimizedCineon";
            break;
        case $0147bee01cff6558$export$a0d98fe6d7e4af64:
            toneMappingName = "ACESFilmic";
            break;
        case $0147bee01cff6558$export$2c7b09c1e9abfb5e:
            toneMappingName = "Custom";
            break;
        default:
            console.warn("THREE.WebGLProgram: Unsupported toneMapping:", toneMapping);
            toneMappingName = "Linear";
    }
    return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
}
function $0147bee01cff6558$var$generateExtensions(parameters) {
    const chunks = [
        parameters.extensionDerivatives || !!parameters.envMapCubeUVHeight || parameters.bumpMap || parameters.normalMapTangentSpace || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
        (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
        parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
        (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission) && parameters.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
    ];
    return chunks.filter($0147bee01cff6558$var$filterEmptyLine).join("\n");
}
function $0147bee01cff6558$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push("#define " + name + " " + value);
    }
    return chunks.join("\n");
}
function $0147bee01cff6558$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $0147bee01cff6558$var$filterEmptyLine(string) {
    return string !== "";
}
function $0147bee01cff6558$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $0147bee01cff6558$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $0147bee01cff6558$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $0147bee01cff6558$var$resolveIncludes(string) {
    return string.replace($0147bee01cff6558$var$includePattern, $0147bee01cff6558$var$includeReplacer);
}
const $0147bee01cff6558$var$shaderChunkMap = new Map([
    [
        "encodings_fragment",
        "colorspace_fragment"
    ],
    [
        "encodings_pars_fragment",
        "colorspace_pars_fragment"
    ],
    [
        "output_fragment",
        "opaque_fragment"
    ]
]);
function $0147bee01cff6558$var$includeReplacer(match, include) {
    let string = $0147bee01cff6558$export$955f9f2e84c43c8b[include];
    if (string === undefined) {
        const newInclude = $0147bee01cff6558$var$shaderChunkMap.get(include);
        if (newInclude !== undefined) {
            string = $0147bee01cff6558$export$955f9f2e84c43c8b[newInclude];
            console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
        } else throw new Error("Can not resolve #include <" + include + ">");
    }
    return $0147bee01cff6558$var$resolveIncludes(string);
}
// Unroll Loops
const $0147bee01cff6558$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $0147bee01cff6558$var$unrollLoops(string) {
    return string.replace($0147bee01cff6558$var$unrollLoopPattern, $0147bee01cff6558$var$loopReplacer);
}
function $0147bee01cff6558$var$loopReplacer(match, start, end, snippet) {
    let string = "";
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, "[ " + i + " ]").replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $0147bee01cff6558$var$generatePrecision(parameters) {
    let precisionstring = "precision " + parameters.precision + " float;\nprecision " + parameters.precision + " int;";
    if (parameters.precision === "highp") precisionstring += "\n#define HIGH_PRECISION";
    else if (parameters.precision === "mediump") precisionstring += "\n#define MEDIUM_PRECISION";
    else if (parameters.precision === "lowp") precisionstring += "\n#define LOW_PRECISION";
    return precisionstring;
}
function $0147bee01cff6558$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = "SHADOWMAP_TYPE_BASIC";
    if (parameters.shadowMapType === $0147bee01cff6558$export$5813f879eee7cd88) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF";
    else if (parameters.shadowMapType === $0147bee01cff6558$export$a47c4b43a1be34f0) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF_SOFT";
    else if (parameters.shadowMapType === $0147bee01cff6558$export$896ae1ade6c829c4) shadowMapTypeDefine = "SHADOWMAP_TYPE_VSM";
    return shadowMapTypeDefine;
}
function $0147bee01cff6558$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = "ENVMAP_TYPE_CUBE";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $0147bee01cff6558$export$8759762a6477f2c4:
        case $0147bee01cff6558$export$dc59f8aed047f61d:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE";
            break;
        case $0147bee01cff6558$export$dbf3e70ff37af79:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE_UV";
            break;
    }
    return envMapTypeDefine;
}
function $0147bee01cff6558$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = "ENVMAP_MODE_REFLECTION";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $0147bee01cff6558$export$dc59f8aed047f61d:
            envMapModeDefine = "ENVMAP_MODE_REFRACTION";
            break;
    }
    return envMapModeDefine;
}
function $0147bee01cff6558$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = "ENVMAP_BLENDING_NONE";
    if (parameters.envMap) switch(parameters.combine){
        case $0147bee01cff6558$export$e50ac29801f1774d:
            envMapBlendingDefine = "ENVMAP_BLENDING_MULTIPLY";
            break;
        case $0147bee01cff6558$export$9f9d94f963c85479:
            envMapBlendingDefine = "ENVMAP_BLENDING_MIX";
            break;
        case $0147bee01cff6558$export$e641dc52bc3494aa:
            envMapBlendingDefine = "ENVMAP_BLENDING_ADD";
            break;
    }
    return envMapBlendingDefine;
}
function $0147bee01cff6558$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $0147bee01cff6558$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $0147bee01cff6558$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $0147bee01cff6558$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $0147bee01cff6558$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $0147bee01cff6558$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $0147bee01cff6558$var$generateCubeUVSize(parameters);
    const customExtensions = parameters.isWebGL2 ? "" : $0147bee01cff6558$var$generateExtensions(parameters);
    const customDefines = $0147bee01cff6558$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? "#version " + parameters.glslVersion + "\n" : "";
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines
        ].filter($0147bee01cff6558$var$filterEmptyLine).join("\n");
        if (prefixVertex.length > 0) prefixVertex += "\n";
        prefixFragment = [
            customExtensions,
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines
        ].filter($0147bee01cff6558$var$filterEmptyLine).join("\n");
        if (prefixFragment.length > 0) prefixFragment += "\n";
    } else {
        prefixVertex = [
            $0147bee01cff6558$var$generatePrecision(parameters),
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.instancing ? "#define USE_INSTANCING" : "",
            parameters.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
            parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
            parameters.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
            parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.alphaHash ? "#define USE_ALPHAHASH" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
            //
            parameters.mapUv ? "#define MAP_UV " + parameters.mapUv : "",
            parameters.alphaMapUv ? "#define ALPHAMAP_UV " + parameters.alphaMapUv : "",
            parameters.lightMapUv ? "#define LIGHTMAP_UV " + parameters.lightMapUv : "",
            parameters.aoMapUv ? "#define AOMAP_UV " + parameters.aoMapUv : "",
            parameters.emissiveMapUv ? "#define EMISSIVEMAP_UV " + parameters.emissiveMapUv : "",
            parameters.bumpMapUv ? "#define BUMPMAP_UV " + parameters.bumpMapUv : "",
            parameters.normalMapUv ? "#define NORMALMAP_UV " + parameters.normalMapUv : "",
            parameters.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + parameters.displacementMapUv : "",
            parameters.metalnessMapUv ? "#define METALNESSMAP_UV " + parameters.metalnessMapUv : "",
            parameters.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + parameters.roughnessMapUv : "",
            parameters.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + parameters.anisotropyMapUv : "",
            parameters.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + parameters.clearcoatMapUv : "",
            parameters.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + parameters.clearcoatNormalMapUv : "",
            parameters.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + parameters.clearcoatRoughnessMapUv : "",
            parameters.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + parameters.iridescenceMapUv : "",
            parameters.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + parameters.iridescenceThicknessMapUv : "",
            parameters.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + parameters.sheenColorMapUv : "",
            parameters.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + parameters.sheenRoughnessMapUv : "",
            parameters.specularMapUv ? "#define SPECULARMAP_UV " + parameters.specularMapUv : "",
            parameters.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + parameters.specularColorMapUv : "",
            parameters.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + parameters.specularIntensityMapUv : "",
            parameters.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + parameters.transmissionMapUv : "",
            parameters.thicknessMapUv ? "#define THICKNESSMAP_UV " + parameters.thicknessMapUv : "",
            //
            parameters.vertexTangents && parameters.flatShading === false ? "#define USE_TANGENT" : "",
            parameters.vertexColors ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUv1s ? "#define USE_UV1" : "",
            parameters.vertexUv2s ? "#define USE_UV2" : "",
            parameters.vertexUv3s ? "#define USE_UV3" : "",
            parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.skinning ? "#define USE_SKINNING" : "",
            parameters.morphTargets ? "#define USE_MORPHTARGETS" : "",
            parameters.morphNormals && parameters.flatShading === false ? "#define USE_MORPHNORMALS" : "",
            parameters.morphColors && parameters.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + parameters.morphTextureStride : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_COUNT " + parameters.morphTargetsCount : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
            parameters.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
            "uniform mat4 modelMatrix;",
            "uniform mat4 modelViewMatrix;",
            "uniform mat4 projectionMatrix;",
            "uniform mat4 viewMatrix;",
            "uniform mat3 normalMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            "#ifdef USE_INSTANCING",
            "	attribute mat4 instanceMatrix;",
            "#endif",
            "#ifdef USE_INSTANCING_COLOR",
            "	attribute vec3 instanceColor;",
            "#endif",
            "attribute vec3 position;",
            "attribute vec3 normal;",
            "attribute vec2 uv;",
            "#ifdef USE_UV1",
            "	attribute vec2 uv1;",
            "#endif",
            "#ifdef USE_UV2",
            "	attribute vec2 uv2;",
            "#endif",
            "#ifdef USE_UV3",
            "	attribute vec2 uv3;",
            "#endif",
            "#ifdef USE_TANGENT",
            "	attribute vec4 tangent;",
            "#endif",
            "#if defined( USE_COLOR_ALPHA )",
            "	attribute vec4 color;",
            "#elif defined( USE_COLOR )",
            "	attribute vec3 color;",
            "#endif",
            "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
            "	attribute vec3 morphTarget0;",
            "	attribute vec3 morphTarget1;",
            "	attribute vec3 morphTarget2;",
            "	attribute vec3 morphTarget3;",
            "	#ifdef USE_MORPHNORMALS",
            "		attribute vec3 morphNormal0;",
            "		attribute vec3 morphNormal1;",
            "		attribute vec3 morphNormal2;",
            "		attribute vec3 morphNormal3;",
            "	#else",
            "		attribute vec3 morphTarget4;",
            "		attribute vec3 morphTarget5;",
            "		attribute vec3 morphTarget6;",
            "		attribute vec3 morphTarget7;",
            "	#endif",
            "#endif",
            "#ifdef USE_SKINNING",
            "	attribute vec4 skinIndex;",
            "	attribute vec4 skinWeight;",
            "#endif",
            "\n"
        ].filter($0147bee01cff6558$var$filterEmptyLine).join("\n");
        prefixFragment = [
            customExtensions,
            $0147bee01cff6558$var$generatePrecision(parameters),
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.matcap ? "#define USE_MATCAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapTypeDefine : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.envMap ? "#define " + envMapBlendingDefine : "",
            envMapCubeUVSize ? "#define CUBEUV_TEXEL_WIDTH " + envMapCubeUVSize.texelWidth : "",
            envMapCubeUVSize ? "#define CUBEUV_TEXEL_HEIGHT " + envMapCubeUVSize.texelHeight : "",
            envMapCubeUVSize ? "#define CUBEUV_MAX_MIP " + envMapCubeUVSize.maxMip + ".0" : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
            parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.anisotropy ? "#define USE_ANISOTROPY" : "",
            parameters.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
            parameters.clearcoat ? "#define USE_CLEARCOAT" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.iridescence ? "#define USE_IRIDESCENCE" : "",
            parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
            parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.alphaTest ? "#define USE_ALPHATEST" : "",
            parameters.alphaHash ? "#define USE_ALPHAHASH" : "",
            parameters.sheen ? "#define USE_SHEEN" : "",
            parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.vertexTangents && parameters.flatShading === false ? "#define USE_TANGENT" : "",
            parameters.vertexColors || parameters.instancingColor ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUv1s ? "#define USE_UV1" : "",
            parameters.vertexUv2s ? "#define USE_UV2" : "",
            parameters.vertexUv3s ? "#define USE_UV3" : "",
            parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
            parameters.gradientMap ? "#define USE_GRADIENTMAP" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
            parameters.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
            "uniform mat4 viewMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            parameters.toneMapping !== $0147bee01cff6558$export$9fcb6b4294603b2 ? "#define TONE_MAPPING" : "",
            parameters.toneMapping !== $0147bee01cff6558$export$9fcb6b4294603b2 ? $0147bee01cff6558$export$955f9f2e84c43c8b["tonemapping_pars_fragment"] : "",
            parameters.toneMapping !== $0147bee01cff6558$export$9fcb6b4294603b2 ? $0147bee01cff6558$var$getToneMappingFunction("toneMapping", parameters.toneMapping) : "",
            parameters.dithering ? "#define DITHERING" : "",
            parameters.opaque ? "#define OPAQUE" : "",
            $0147bee01cff6558$export$955f9f2e84c43c8b["colorspace_pars_fragment"],
            $0147bee01cff6558$var$getTexelEncodingFunction("linearToOutputTexel", parameters.outputColorSpace),
            parameters.useDepthPacking ? "#define DEPTH_PACKING " + parameters.depthPacking : "",
            "\n"
        ].filter($0147bee01cff6558$var$filterEmptyLine).join("\n");
    }
    vertexShader = $0147bee01cff6558$var$resolveIncludes(vertexShader);
    vertexShader = $0147bee01cff6558$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $0147bee01cff6558$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $0147bee01cff6558$var$resolveIncludes(fragmentShader);
    fragmentShader = $0147bee01cff6558$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $0147bee01cff6558$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $0147bee01cff6558$var$unrollLoops(vertexShader);
    fragmentShader = $0147bee01cff6558$var$unrollLoops(fragmentShader);
    if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = "#version 300 es\n";
        prefixVertex = [
            "precision mediump sampler2DArray;",
            "#define attribute in",
            "#define varying out",
            "#define texture2D texture"
        ].join("\n") + "\n" + prefixVertex;
        prefixFragment = [
            "#define varying in",
            parameters.glslVersion === $0147bee01cff6558$export$f63012db5506e7dd ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
            parameters.glslVersion === $0147bee01cff6558$export$f63012db5506e7dd ? "" : "#define gl_FragColor pc_fragColor",
            "#define gl_FragDepthEXT gl_FragDepth",
            "#define texture2D texture",
            "#define textureCube texture",
            "#define texture2DProj textureProj",
            "#define texture2DLodEXT textureLod",
            "#define texture2DProjLodEXT textureProjLod",
            "#define textureCubeLodEXT textureLod",
            "#define texture2DGradEXT textureGrad",
            "#define texture2DProjGradEXT textureProjGrad",
            "#define textureCubeGradEXT textureGrad"
        ].join("\n") + "\n" + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $0147bee01cff6558$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = $0147bee01cff6558$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, "position");
    gl.linkProgram(program);
    // check for link errors
    if (renderer.debug.checkShaderErrors) {
        const programLog = gl.getProgramInfoLog(program).trim();
        const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
        const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
        let runnable = true;
        let haveDiagnostics = true;
        if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
            runnable = false;
            if (typeof renderer.debug.onShaderError === "function") renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
            else {
                // default error reporting
                const vertexErrors = $0147bee01cff6558$var$getShaderErrors(gl, glVertexShader, "vertex");
                const fragmentErrors = $0147bee01cff6558$var$getShaderErrors(gl, glFragmentShader, "fragment");
                console.error("THREE.WebGLProgram: Shader Error " + gl.getError() + " - " + "VALIDATE_STATUS " + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + "\n\n" + "Program Info Log: " + programLog + "\n" + vertexErrors + "\n" + fragmentErrors);
            }
        } else if (programLog !== "") console.warn("THREE.WebGLProgram: Program Info Log:", programLog);
        else if (vertexLog === "" || fragmentLog === "") haveDiagnostics = false;
        if (haveDiagnostics) this.diagnostics = {
            runnable: runnable,
            programLog: programLog,
            vertexShader: {
                log: vertexLog,
                prefix: prefixVertex
            },
            fragmentShader: {
                log: fragmentLog,
                prefix: prefixFragment
            }
        };
    }
    // Clean up
    // Crashes in iOS9 and iOS10. #18402
    // gl.detachShader( program, glVertexShader );
    // gl.detachShader( program, glFragmentShader );
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) cachedUniforms = new $0147bee01cff6558$var$WebGLUniforms(gl, program);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) cachedAttributes = $0147bee01cff6558$var$fetchAttributeLocations(gl, program);
        return cachedAttributes;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $0147bee01cff6558$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $0147bee01cff6558$var$_id = 0;
class $0147bee01cff6558$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $0147bee01cff6558$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class $0147bee01cff6558$var$WebGLShaderStage {
    constructor(code){
        this.id = $0147bee01cff6558$var$_id++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $0147bee01cff6558$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new $0147bee01cff6558$export$89312ce47c0ca777();
    const _customShaders = new $0147bee01cff6558$var$WebGLShaderCache();
    const programs = [];
    const IS_WEBGL2 = capabilities.isWebGL2;
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distanceRGBA",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    function getChannel(value) {
        if (value === 0) return "uv";
        return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === $0147bee01cff6558$export$dbf3e70ff37af79 ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn("THREE.WebGLProgram.getParameters:", material.precision, "not supported, using", precision, "instead.");
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $0147bee01cff6558$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_ANISOTROPY = material.anisotropy > 0;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_ALPHAHASH = !!material.alphaHash;
        const HAS_EXTENSIONS = !!material.extensions;
        const HAS_ATTRIBUTE_UV1 = !!geometry.attributes.uv1;
        const HAS_ATTRIBUTE_UV2 = !!geometry.attributes.uv2;
        const HAS_ATTRIBUTE_UV3 = !!geometry.attributes.uv3;
        let toneMapping = $0147bee01cff6558$export$9fcb6b4294603b2;
        if (material.toneMapped) {
            if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) toneMapping = renderer.toneMapping;
        }
        const parameters = {
            isWebGL2: IS_WEBGL2,
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : $0147bee01cff6558$export$42429b3acfb233a4,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === $0147bee01cff6558$export$9990ad26f9db5b2c,
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === $0147bee01cff6558$export$2852a58ebdac27b8,
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === $0147bee01cff6558$export$5b29a26d96ee6af0,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            alphaHash: HAS_ALPHAHASH,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            vertexUv1s: HAS_ATTRIBUTE_UV1,
            vertexUv2s: HAS_ATTRIBUTE_UV2,
            vertexUv3s: HAS_ATTRIBUTE_UV3,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: fog && fog.isFogExp2,
            flatShading: material.flatShading === true,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: toneMapping,
            useLegacyLights: renderer._useLegacyLights,
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === $0147bee01cff6558$export$3b296b6f144d5b03,
            flipSided: material.side === $0147bee01cff6558$export$d9f0486e75b5ace,
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionDerivatives: HAS_EXTENSIONS && material.extensions.derivatives === true,
            extensionFragDepth: HAS_EXTENSIONS && material.extensions.fragDepth === true,
            extensionDrawBuffers: HAS_EXTENSIONS && material.extensions.drawBuffers === true,
            extensionShaderTextureLOD: HAS_EXTENSIONS && material.extensions.shaderTextureLOD === true,
            rendererExtensionFragDepth: IS_WEBGL2 || extensions.has("EXT_frag_depth"),
            rendererExtensionDrawBuffers: IS_WEBGL2 || extensions.has("WEBGL_draw_buffers"),
            rendererExtensionShaderTextureLod: IS_WEBGL2 || extensions.has("EXT_shader_texture_lod"),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.isWebGL2) _programLayers.enable(0);
        if (parameters.supportsVertexTextures) _programLayers.enable(1);
        if (parameters.instancing) _programLayers.enable(2);
        if (parameters.instancingColor) _programLayers.enable(3);
        if (parameters.matcap) _programLayers.enable(4);
        if (parameters.envMap) _programLayers.enable(5);
        if (parameters.normalMapObjectSpace) _programLayers.enable(6);
        if (parameters.normalMapTangentSpace) _programLayers.enable(7);
        if (parameters.clearcoat) _programLayers.enable(8);
        if (parameters.iridescence) _programLayers.enable(9);
        if (parameters.alphaTest) _programLayers.enable(10);
        if (parameters.vertexColors) _programLayers.enable(11);
        if (parameters.vertexAlphas) _programLayers.enable(12);
        if (parameters.vertexUv1s) _programLayers.enable(13);
        if (parameters.vertexUv2s) _programLayers.enable(14);
        if (parameters.vertexUv3s) _programLayers.enable(15);
        if (parameters.vertexTangents) _programLayers.enable(16);
        if (parameters.anisotropy) _programLayers.enable(17);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.skinning) _programLayers.enable(4);
        if (parameters.morphTargets) _programLayers.enable(5);
        if (parameters.morphNormals) _programLayers.enable(6);
        if (parameters.morphColors) _programLayers.enable(7);
        if (parameters.premultipliedAlpha) _programLayers.enable(8);
        if (parameters.shadowMapEnabled) _programLayers.enable(9);
        if (parameters.useLegacyLights) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $0147bee01cff6558$export$bee4a7d47f8f5014[shaderID];
            uniforms = $0147bee01cff6558$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $0147bee01cff6558$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $0147bee01cff6558$var$WebGLProperties() {
    let properties = new WeakMap();
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $0147bee01cff6558$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $0147bee01cff6558$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $0147bee01cff6558$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $0147bee01cff6558$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $0147bee01cff6558$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $0147bee01cff6558$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $0147bee01cff6558$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $0147bee01cff6558$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $0147bee01cff6558$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $0147bee01cff6558$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        direction: new $0147bee01cff6558$export$64b5c384219d3699(),
                        color: new $0147bee01cff6558$export$892596cec99bc70e()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        position: new $0147bee01cff6558$export$64b5c384219d3699(),
                        direction: new $0147bee01cff6558$export$64b5c384219d3699(),
                        color: new $0147bee01cff6558$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        position: new $0147bee01cff6558$export$64b5c384219d3699(),
                        color: new $0147bee01cff6558$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    uniforms = {
                        direction: new $0147bee01cff6558$export$64b5c384219d3699(),
                        skyColor: new $0147bee01cff6558$export$892596cec99bc70e(),
                        groundColor: new $0147bee01cff6558$export$892596cec99bc70e()
                    };
                    break;
                case "RectAreaLight":
                    uniforms = {
                        color: new $0147bee01cff6558$export$892596cec99bc70e(),
                        position: new $0147bee01cff6558$export$64b5c384219d3699(),
                        halfWidth: new $0147bee01cff6558$export$64b5c384219d3699(),
                        halfHeight: new $0147bee01cff6558$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $0147bee01cff6558$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $0147bee01cff6558$export$c977b3e384af9ae1()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $0147bee01cff6558$export$c977b3e384af9ae1()
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $0147bee01cff6558$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $0147bee01cff6558$var$nextVersion = 0;
function $0147bee01cff6558$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $0147bee01cff6558$var$WebGLLights(extensions, capabilities) {
    const cache = new $0147bee01cff6558$var$UniformsCache();
    const shadowCache = $0147bee01cff6558$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new $0147bee01cff6558$export$64b5c384219d3699());
    const vector3 = new $0147bee01cff6558$export$64b5c384219d3699();
    const matrix4 = new $0147bee01cff6558$export$2ae72fc923e5eb5();
    const matrix42 = new $0147bee01cff6558$export$2ae72fc923e5eb5();
    function setup(lights, useLegacyLights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($0147bee01cff6558$var$shadowCastingAndTexturingLightsFirst);
        // artist-friendly light intensity scaling factor
        const scaleFactor = useLegacyLights === true ? Math.PI : 1;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity * scaleFactor;
                g += color.g * intensity * scaleFactor;
                b += color.b * intensity * scaleFactor;
            } else if (light.isLightProbe) for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
            else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity * scaleFactor);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity * scaleFactor);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity * scaleFactor);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (capabilities.isWebGL2) {
                // WebGL 2
                state.rectAreaLTC1 = $0147bee01cff6558$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $0147bee01cff6558$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                // WebGL 1
                if (extensions.has("OES_texture_float_linear") === true) {
                    state.rectAreaLTC1 = $0147bee01cff6558$export$6643083551874bf5.LTC_FLOAT_1;
                    state.rectAreaLTC2 = $0147bee01cff6558$export$6643083551874bf5.LTC_FLOAT_2;
                } else if (extensions.has("OES_texture_half_float_linear") === true) {
                    state.rectAreaLTC1 = $0147bee01cff6558$export$6643083551874bf5.LTC_HALF_1;
                    state.rectAreaLTC2 = $0147bee01cff6558$export$6643083551874bf5.LTC_HALF_2;
                } else console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.");
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            state.version = $0147bee01cff6558$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $0147bee01cff6558$var$WebGLRenderState(extensions, capabilities) {
    const lights = new $0147bee01cff6558$var$WebGLLights(extensions, capabilities);
    const lightsArray = [];
    const shadowsArray = [];
    function init() {
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights(useLegacyLights) {
        lights.setup(lightsArray, useLegacyLights);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        lights: lights
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $0147bee01cff6558$var$WebGLRenderStates(extensions, capabilities) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $0147bee01cff6558$var$WebGLRenderState(extensions, capabilities);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $0147bee01cff6558$var$WebGLRenderState(extensions, capabilities);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $0147bee01cff6558$export$2698c22ec13825db extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDepthMaterial = true;
        this.type = "MeshDepthMaterial";
        this.depthPacking = $0147bee01cff6558$export$deeb383078690b50;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
class $0147bee01cff6558$export$33e187ed002f2a19 extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDistanceMaterial = true;
        this.type = "MeshDistanceMaterial";
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
const $0147bee01cff6558$var$vertex = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}";
const $0147bee01cff6558$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $0147bee01cff6558$var$WebGLShadowMap(_renderer, _objects, _capabilities) {
    let _frustum = new $0147bee01cff6558$export$35efe6f4c85463d2();
    const _shadowMapSize = new $0147bee01cff6558$export$c977b3e384af9ae1(), _viewportSize = new $0147bee01cff6558$export$c977b3e384af9ae1(), _viewport = new $0147bee01cff6558$export$fa7daccca11cdbe3(), _depthMaterial = new $0147bee01cff6558$export$2698c22ec13825db({
        depthPacking: $0147bee01cff6558$export$8f910f4c4f73df11
    }), _distanceMaterial = new $0147bee01cff6558$export$33e187ed002f2a19(), _materialCache = {}, _maxTextureSize = _capabilities.maxTextureSize;
    const shadowSide = {
        [$0147bee01cff6558$export$2ede184fc2998901]: $0147bee01cff6558$export$d9f0486e75b5ace,
        [$0147bee01cff6558$export$d9f0486e75b5ace]: $0147bee01cff6558$export$2ede184fc2998901,
        [$0147bee01cff6558$export$3b296b6f144d5b03]: $0147bee01cff6558$export$3b296b6f144d5b03
    };
    const shadowMaterialVertical = new $0147bee01cff6558$export$83c7d75d550a8b0d({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $0147bee01cff6558$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $0147bee01cff6558$var$vertex,
        fragmentShader: $0147bee01cff6558$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new $0147bee01cff6558$export$b7be63a67df8959();
    fullScreenTri.setAttribute("position", new $0147bee01cff6558$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new $0147bee01cff6558$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $0147bee01cff6558$export$5813f879eee7cd88;
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = _renderer.getRenderTarget();
        const activeCubeFace = _renderer.getActiveCubeFace();
        const activeMipmapLevel = _renderer.getActiveMipmapLevel();
        const _state = _renderer.state;
        // Set GL state for depth map.
        _state.setBlending($0147bee01cff6558$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const toVSM = _previousType !== $0147bee01cff6558$export$896ae1ade6c829c4 && this.type === $0147bee01cff6558$export$896ae1ade6c829c4;
        const fromVSM = _previousType === $0147bee01cff6558$export$896ae1ade6c829c4 && this.type !== $0147bee01cff6558$export$896ae1ade6c829c4;
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn("THREE.WebGLShadowMap:", light, "has no shadow.");
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || toVSM === true || fromVSM === true) {
                const pars = this.type !== $0147bee01cff6558$export$896ae1ade6c829c4 ? {
                    minFilter: $0147bee01cff6558$export$727aa5ec3fe39bf0,
                    magFilter: $0147bee01cff6558$export$727aa5ec3fe39bf0
                } : {};
                if (shadow.map !== null) shadow.map.dispose();
                shadow.map = new $0147bee01cff6558$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + ".shadowMap";
                shadow.camera.updateProjectionMatrix();
            }
            _renderer.setRenderTarget(shadow.map);
            _renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === $0147bee01cff6558$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = _objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new $0147bee01cff6558$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.mapPass);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.map);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (_renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $0147bee01cff6558$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = _renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $0147bee01cff6558$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = _objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
}
function $0147bee01cff6558$var$WebGLState(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function ColorBuffer() {
        let locked = false;
        const color = new $0147bee01cff6558$export$fa7daccca11cdbe3();
        let currentColorMask = null;
        const currentColorClear = new $0147bee01cff6558$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case $0147bee01cff6558$export$69025ce147cee220:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case $0147bee01cff6558$export$7182eb52ea3b3f04:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case $0147bee01cff6558$export$eedccec66ab7ebe:
                            gl.depthFunc(gl.LESS);
                            break;
                        case $0147bee01cff6558$export$296f78a0b892f81a:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case $0147bee01cff6558$export$a60d398fc7b7590e:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case $0147bee01cff6558$export$7d7234c1240a1fc4:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case $0147bee01cff6558$export$c5e2c52991f30937:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case $0147bee01cff6558$export$2f843afa843d8916:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf("WebGL") !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf("OpenGL ES") !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new $0147bee01cff6558$export$fa7daccca11cdbe3().fromArray(scissorParam);
    const currentViewport = new $0147bee01cff6558$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (isWebGL2 && (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY)) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    if (isWebGL2) {
        emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
        emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    }
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc($0147bee01cff6558$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($0147bee01cff6558$export$b9a7b4fc5cb15f9b);
    enable(gl.CULL_FACE);
    setBlending($0147bee01cff6558$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            if (isWebGL2) {
                // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
                if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
                if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            }
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            if (renderTarget.isWebGLMultipleRenderTargets) {
                const textures = renderTarget.texture;
                if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                    for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                    drawBuffers.length = textures.length;
                    needsUpdate = true;
                }
            } else if (drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                drawBuffers[0] = gl.COLOR_ATTACHMENT0;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) {
            if (capabilities.isWebGL2) gl.drawBuffers(drawBuffers);
            else extensions.get("WEBGL_draw_buffers").drawBuffersWEBGL(drawBuffers);
        }
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [$0147bee01cff6558$export$20183a0484ce21a0]: gl.FUNC_ADD,
        [$0147bee01cff6558$export$73e0df5177988548]: gl.FUNC_SUBTRACT,
        [$0147bee01cff6558$export$28e582859cbec660]: gl.FUNC_REVERSE_SUBTRACT
    };
    if (isWebGL2) {
        equationToGL[$0147bee01cff6558$export$c8c1508da8d0600c] = gl.MIN;
        equationToGL[$0147bee01cff6558$export$99948c02fb51055f] = gl.MAX;
    } else {
        const extension = extensions.get("EXT_blend_minmax");
        if (extension !== null) {
            equationToGL[$0147bee01cff6558$export$c8c1508da8d0600c] = extension.MIN_EXT;
            equationToGL[$0147bee01cff6558$export$99948c02fb51055f] = extension.MAX_EXT;
        }
    }
    const factorToGL = {
        [$0147bee01cff6558$export$2110f05edf778d3d]: gl.ZERO,
        [$0147bee01cff6558$export$8805bad65e24940e]: gl.ONE,
        [$0147bee01cff6558$export$7fbe15b28d28cf52]: gl.SRC_COLOR,
        [$0147bee01cff6558$export$d5773124e86cf28c]: gl.SRC_ALPHA,
        [$0147bee01cff6558$export$c05e2a1fc8609506]: gl.SRC_ALPHA_SATURATE,
        [$0147bee01cff6558$export$ef5f2dd8ffac5574]: gl.DST_COLOR,
        [$0147bee01cff6558$export$a78aed1ca2a87192]: gl.DST_ALPHA,
        [$0147bee01cff6558$export$947829af9f2c17f6]: gl.ONE_MINUS_SRC_COLOR,
        [$0147bee01cff6558$export$11d468cc7f19e971]: gl.ONE_MINUS_SRC_ALPHA,
        [$0147bee01cff6558$export$56b85b2686ab16]: gl.ONE_MINUS_DST_COLOR,
        [$0147bee01cff6558$export$5d0fe17fd8773bac]: gl.ONE_MINUS_DST_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        if (blending === $0147bee01cff6558$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== $0147bee01cff6558$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $0147bee01cff6558$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $0147bee01cff6558$export$20183a0484ce21a0) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = $0147bee01cff6558$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $0147bee01cff6558$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $0147bee01cff6558$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $0147bee01cff6558$export$777d8f9551c2216b:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case $0147bee01cff6558$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $0147bee01cff6558$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                else switch(blending){
                    case $0147bee01cff6558$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $0147bee01cff6558$export$777d8f9551c2216b:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                        break;
                    case $0147bee01cff6558$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $0147bee01cff6558$export$4138e1c684b46a20:
                        gl.blendFunc(gl.ZERO, gl.SRC_COLOR);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $0147bee01cff6558$export$3b296b6f144d5b03 ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === $0147bee01cff6558$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $0147bee01cff6558$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($0147bee01cff6558$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $0147bee01cff6558$export$3237e1f2c1ea1f44) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === $0147bee01cff6558$export$b9a7b4fc5cb15f9b) gl.cullFace(gl.BACK);
                else if (cullFace === $0147bee01cff6558$export$b8058bcc7037d3f3) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        if (isWebGL2 === true) {
            gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
            gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        }
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $0147bee01cff6558$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const isWebGL2 = capabilities.isWebGL2;
    const maxTextures = capabilities.maxTextures;
    const maxCubemapSize = capabilities.maxCubemapSize;
    const maxTextureSize = capabilities.maxTextureSize;
    const maxSamples = capabilities.maxSamples;
    const multisampledRTTExt = extensions.has("WEBGL_multisampled_render_to_texture") ? extensions.get("WEBGL_multisampled_render_to_texture") : null;
    const supportsInvalidateFramebuffer = typeof navigator === "undefined" ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== "undefined" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : $0147bee01cff6558$var$createElementNS("canvas");
    }
    function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
        let scale = 1;
        // handle case if texture exceeds max size
        if (image.width > maxSize || image.height > maxSize) scale = maxSize / Math.max(image.width, image.height);
        // only perform resize if necessary
        if (scale < 1 || needsPowerOfTwo === true) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
                const floor = needsPowerOfTwo ? $0147bee01cff6558$var$floorPowerOfTwo : Math.floor;
                const width = floor(scale * image.width);
                const height = floor(scale * image.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext("2d");
                context.drawImage(image, 0, 0, width, height);
                console.warn("THREE.WebGLRenderer: Texture has been resized from (" + image.width + "x" + image.height + ") to (" + width + "x" + height + ").");
                return canvas;
            } else {
                if ("data" in image) console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + image.width + "x" + image.height + ").");
                return image;
            }
        }
        return image;
    }
    function isPowerOfTwo$1(image) {
        return $0147bee01cff6558$var$isPowerOfTwo(image.width) && $0147bee01cff6558$var$isPowerOfTwo(image.height);
    }
    function textureNeedsPowerOfTwo(texture) {
        if (isWebGL2) return false;
        return texture.wrapS !== $0147bee01cff6558$export$9d9334239a5a5e06 || texture.wrapT !== $0147bee01cff6558$export$9d9334239a5a5e06 || texture.minFilter !== $0147bee01cff6558$export$727aa5ec3fe39bf0 && texture.minFilter !== $0147bee01cff6558$export$8a72f490b25c56c8;
    }
    function textureNeedsGenerateMipmaps(texture, supportsMips) {
        return texture.generateMipmaps && supportsMips && texture.minFilter !== $0147bee01cff6558$export$727aa5ec3fe39bf0 && texture.minFilter !== $0147bee01cff6558$export$8a72f490b25c56c8;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace1, forceLinearTransfer = false) {
        if (isWebGL2 === false) return glFormat;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + internalFormatName + "'");
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RED_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.R8I;
            if (glType === _gl.SHORT) internalFormat = _gl.R16I;
            if (glType === _gl.INT) internalFormat = _gl.R32I;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RGBA) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = colorSpace1 === $0147bee01cff6558$export$561f394b24edfcaa && forceLinearTransfer === false ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get("EXT_color_buffer_float");
        return internalFormat;
    }
    function getMipLevels(texture, image, supportsMips) {
        if (textureNeedsGenerateMipmaps(texture, supportsMips) === true || texture.isFramebufferTexture && texture.minFilter !== $0147bee01cff6558$export$727aa5ec3fe39bf0 && texture.minFilter !== $0147bee01cff6558$export$8a72f490b25c56c8) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    // Fallback filters for non-power-of-2 textures
    function filterFallback(f) {
        if (f === $0147bee01cff6558$export$727aa5ec3fe39bf0 || f === $0147bee01cff6558$export$d129e38cf6feaa8c || f === $0147bee01cff6558$export$d2327c1afe5bfdf2) return _gl.NEAREST;
        return _gl.LINEAR;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener("dispose", onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglTexture !== undefined) {
            _gl.deleteTexture(textureProperties.__webglTexture);
            info.memory.textures--;
        }
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) for(let level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            if (Array.isArray(renderTargetProperties.__webglFramebuffer)) for(let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        if (renderTarget.isWebGLMultipleRenderTargets) for(let i = 0, il = texture.length; i < il; i++){
            const attachmentProperties = properties.get(texture[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(texture[i]);
        }
        properties.remove(texture);
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= maxTextures) console.warn("THREE.WebGLTextures: Trying to use " + textureUnit + " texture units while this GPU supports only " + maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
            else if (image.complete === false) console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [$0147bee01cff6558$export$533346c8e8dac0f5]: _gl.REPEAT,
        [$0147bee01cff6558$export$9d9334239a5a5e06]: _gl.CLAMP_TO_EDGE,
        [$0147bee01cff6558$export$c7e7c00b14f51a4f]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [$0147bee01cff6558$export$727aa5ec3fe39bf0]: _gl.NEAREST,
        [$0147bee01cff6558$export$d129e38cf6feaa8c]: _gl.NEAREST_MIPMAP_NEAREST,
        [$0147bee01cff6558$export$d2327c1afe5bfdf2]: _gl.NEAREST_MIPMAP_LINEAR,
        [$0147bee01cff6558$export$8a72f490b25c56c8]: _gl.LINEAR,
        [$0147bee01cff6558$export$19a719f377145a13]: _gl.LINEAR_MIPMAP_NEAREST,
        [$0147bee01cff6558$export$5d8599b6a933fb1b]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
        [$0147bee01cff6558$export$d9e2d19a747baaab]: _gl.NEVER,
        [$0147bee01cff6558$export$187b73a3e352c145]: _gl.ALWAYS,
        [$0147bee01cff6558$export$36bcf49c713b3eb7]: _gl.LESS,
        [$0147bee01cff6558$export$64eea11eb407ddf1]: _gl.LEQUAL,
        [$0147bee01cff6558$export$66f28d946fc6a0d5]: _gl.EQUAL,
        [$0147bee01cff6558$export$1cdcb70d53d65f61]: _gl.GEQUAL,
        [$0147bee01cff6558$export$155af022118f3a38]: _gl.GREATER,
        [$0147bee01cff6558$export$67ab95dde6bed156]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture, supportsMips) {
        if (supportsMips) {
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
            if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
            _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
            _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        } else {
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, _gl.CLAMP_TO_EDGE);
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, _gl.CLAMP_TO_EDGE);
            if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, _gl.CLAMP_TO_EDGE);
            if (texture.wrapS !== $0147bee01cff6558$export$9d9334239a5a5e06 || texture.wrapT !== $0147bee01cff6558$export$9d9334239a5a5e06) console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.");
            _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterFallback(texture.magFilter));
            _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterFallback(texture.minFilter));
            if (texture.minFilter !== $0147bee01cff6558$export$727aa5ec3fe39bf0 && texture.minFilter !== $0147bee01cff6558$export$8a72f490b25c56c8) console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.");
        }
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            if (texture.magFilter === $0147bee01cff6558$export$727aa5ec3fe39bf0) return;
            if (texture.minFilter !== $0147bee01cff6558$export$d2327c1afe5bfdf2 && texture.minFilter !== $0147bee01cff6558$export$5d8599b6a933fb1b) return;
            if (texture.type === $0147bee01cff6558$export$f6d331659b644596 && extensions.has("OES_texture_float_linear") === false) return; // verify extension for WebGL 1 and WebGL 2
            if (isWebGL2 === false && texture.type === $0147bee01cff6558$export$2697304443f382bc && extensions.has("OES_texture_half_float_linear") === false) return; // verify extension for WebGL 1 only
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener("dispose", onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, _gl.NONE);
            const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
            let image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
            image = verifyColorSpace(texture, image);
            const supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.colorSpace);
            let glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            setTextureParameters(textureType, texture, supportsMips);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const levels = getMipLevels(texture, image, supportsMips);
            if (texture.isDepthTexture) {
                // populate depth texture with dummy data
                glInternalFormat = _gl.DEPTH_COMPONENT;
                if (isWebGL2) {
                    if (texture.type === $0147bee01cff6558$export$f6d331659b644596) glInternalFormat = _gl.DEPTH_COMPONENT32F;
                    else if (texture.type === $0147bee01cff6558$export$c3c7fc4518ebba96) glInternalFormat = _gl.DEPTH_COMPONENT24;
                    else if (texture.type === $0147bee01cff6558$export$6c8ea339bfab1301) glInternalFormat = _gl.DEPTH24_STENCIL8;
                    else glInternalFormat = _gl.DEPTH_COMPONENT16; // WebGL2 requires sized internalformat for glTexImage2D
                } else if (texture.type === $0147bee01cff6558$export$f6d331659b644596) console.error("WebGLRenderer: Floating point depth texture requires WebGL2.");
                // validation checks for WebGL 1
                if (texture.format === $0147bee01cff6558$export$c1b6b5136be58045 && glInternalFormat === _gl.DEPTH_COMPONENT) // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                {
                    if (texture.type !== $0147bee01cff6558$export$c63dc51868b06a9d && texture.type !== $0147bee01cff6558$export$c3c7fc4518ebba96) {
                        console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.");
                        texture.type = $0147bee01cff6558$export$c3c7fc4518ebba96;
                        glType = utils.convert(texture.type);
                    }
                }
                if (texture.format === $0147bee01cff6558$export$1e113ac2d0905829 && glInternalFormat === _gl.DEPTH_COMPONENT) {
                    // Depth stencil textures need the DEPTH_STENCIL internal format
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    glInternalFormat = _gl.DEPTH_STENCIL;
                    // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                    // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    if (texture.type !== $0147bee01cff6558$export$6c8ea339bfab1301) {
                        console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.");
                        texture.type = $0147bee01cff6558$export$6c8ea339bfab1301;
                        glType = utils.convert(texture.type);
                    }
                }
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $0147bee01cff6558$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data, 0, 0);
                                else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                        } else if (useTexStorage) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                        else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $0147bee01cff6558$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                        } else if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, _gl.NONE);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            let levels = getMipLevels(texture, image, supportsMips);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture, supportsMips);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== $0147bee01cff6558$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()");
                        } else if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, cubeImage[0].width, cubeImage[0].height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        if (!renderTargetProperties.__hasExternalTextures) {
            const width = Math.max(1, renderTarget.width >> level);
            const height = Math.max(1, renderTarget.height >> level);
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, level);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
            let glInternalFormat = _gl.DEPTH_COMPONENT16;
            if (isMultisample || useMultisampledRTT(renderTarget)) {
                const depthTexture = renderTarget.depthTexture;
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === $0147bee01cff6558$export$f6d331659b644596) glInternalFormat = _gl.DEPTH_COMPONENT32F;
                    else if (depthTexture.type === $0147bee01cff6558$export$c3c7fc4518ebba96) glInternalFormat = _gl.DEPTH_COMPONENT24;
                }
                const samples = getRenderTargetSamples(renderTarget);
                if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer);
        } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
            const samples = getRenderTargetSamples(renderTarget);
            if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, _gl.DEPTH24_STENCIL8, renderTarget.width, renderTarget.height);
            else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, _gl.DEPTH24_STENCIL8, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, _gl.DEPTH_STENCIL, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
                renderTarget.texture
            ];
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error("Depth Texture with cube render targets is not supported");
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === $0147bee01cff6558$export$c1b6b5136be58045) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === $0147bee01cff6558$export$1e113ac2d0905829) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else throw new Error("Unknown depthTexture format");
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error("target.depthTexture not supported in Cube render targets");
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
            }
        } else {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener("dispose", onRenderTargetDispose);
        if (renderTarget.isWebGLMultipleRenderTargets !== true) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)if (isWebGL2 && texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer[i] = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            if (isWebGL2 && texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) {
                if (capabilities.drawBuffers) {
                    const textures = renderTarget.texture;
                    for(let i = 0, il = textures.length; i < il; i++){
                        const attachmentProperties = properties.get(textures[i]);
                        if (attachmentProperties.__webglTexture === undefined) {
                            attachmentProperties.__webglTexture = _gl.createTexture();
                            info.memory.textures++;
                        }
                    }
                } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
            }
            if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                const textures = isMultipleRenderTargets ? texture : [
                    texture
                ];
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture, supportsMips);
            for(let i = 0; i < 6; i++){
                if (isWebGL2 && texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level);
                else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            const textures = renderTarget.texture;
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(_gl.TEXTURE_2D, attachmentProperties.__webglTexture);
                setTextureParameters(_gl.TEXTURE_2D, attachment, supportsMips);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, 0);
                if (textureNeedsGenerateMipmaps(attachment, supportsMips)) generateMipmap(_gl.TEXTURE_2D);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {
                if (isWebGL2) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
                else console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.");
            }
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture, supportsMips);
            if (isWebGL2 && texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
            else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
            renderTarget.texture
        ];
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                const target = renderTarget.isWebGLCubeRenderTarget ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(target, webglTexture);
                generateMipmap(target);
                state.unbindTexture();
            }
        }
    }
    function updateMultisampleRenderTarget(renderTarget) {
        if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
            const textures = renderTarget.isWebGLMultipleRenderTargets ? renderTarget.texture : [
                renderTarget.texture
            ];
            const width = renderTarget.width;
            const height = renderTarget.height;
            let mask = _gl.COLOR_BUFFER_BIT;
            const invalidationArray = [];
            const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            const renderTargetProperties = properties.get(renderTarget);
            const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
            // If MRT we need to remove FBO attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
            }
            state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            for(let i = 0; i < textures.length; i++){
                invalidationArray.push(_gl.COLOR_ATTACHMENT0 + i);
                if (renderTarget.depthBuffer) invalidationArray.push(depthStyle);
                const ignoreDepthValues = renderTargetProperties.__ignoreDepthValues !== undefined ? renderTargetProperties.__ignoreDepthValues : false;
                if (ignoreDepthValues === false) {
                    if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                    if (renderTarget.stencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                }
                if (isMultipleRenderTargets) _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                if (ignoreDepthValues === true) {
                    _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, [
                        depthStyle
                    ]);
                    _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                        depthStyle
                    ]);
                }
                if (isMultipleRenderTargets) {
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                }
                _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                if (supportsInvalidateFramebuffer) _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArray);
            }
            state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                const webglTexture = properties.get(textures[i]).__webglTexture;
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
            }
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return isWebGL2 && renderTarget.samples > 0 && extensions.has("WEBGL_multisampled_render_to_texture") === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace1 = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.format === $0147bee01cff6558$export$ca1dce8b5e1de74d) return image;
        if (colorSpace1 !== $0147bee01cff6558$export$42429b3acfb233a4 && colorSpace1 !== $0147bee01cff6558$export$bfcb490c2dd3db51) {
            // sRGB
            if (colorSpace1 === $0147bee01cff6558$export$561f394b24edfcaa) {
                if (isWebGL2 === false) {
                    // in WebGL 1, try to use EXT_sRGB extension and unsized formats
                    if (extensions.has("EXT_sRGB") === true && format === $0147bee01cff6558$export$3f8bb04b555a363c) {
                        texture.format = $0147bee01cff6558$export$ca1dce8b5e1de74d;
                        // it's not possible to generate mips in WebGL 1 with this extension
                        texture.minFilter = $0147bee01cff6558$export$8a72f490b25c56c8;
                        texture.generateMipmaps = false;
                    } else // slow fallback (CPU decode)
                    image = $0147bee01cff6558$export$698882cf06df44aa.sRGBToLinear(image);
                } else // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
                if (format !== $0147bee01cff6558$export$3f8bb04b555a363c || type !== $0147bee01cff6558$export$2e8ce08d3f6f5e10) console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.");
            } else console.error("THREE.WebGLTextures: Unsupported texture color space:", colorSpace1);
        }
        return image;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $0147bee01cff6558$export$ddaebcad857649a8(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function convert(p, colorSpace1 = $0147bee01cff6558$export$bfcb490c2dd3db51) {
        let extension;
        if (p === $0147bee01cff6558$export$2e8ce08d3f6f5e10) return gl.UNSIGNED_BYTE;
        if (p === $0147bee01cff6558$export$b3969b01faf587f2) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === $0147bee01cff6558$export$18886f8ae33e90de) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === $0147bee01cff6558$export$545fce0311a9796a) return gl.BYTE;
        if (p === $0147bee01cff6558$export$88572337f312435f) return gl.SHORT;
        if (p === $0147bee01cff6558$export$c63dc51868b06a9d) return gl.UNSIGNED_SHORT;
        if (p === $0147bee01cff6558$export$5c612977753abe2) return gl.INT;
        if (p === $0147bee01cff6558$export$c3c7fc4518ebba96) return gl.UNSIGNED_INT;
        if (p === $0147bee01cff6558$export$f6d331659b644596) return gl.FLOAT;
        if (p === $0147bee01cff6558$export$2697304443f382bc) {
            if (isWebGL2) return gl.HALF_FLOAT;
            extension = extensions.get("OES_texture_half_float");
            if (extension !== null) return extension.HALF_FLOAT_OES;
            else return null;
        }
        if (p === $0147bee01cff6558$export$988473390501ed4b) return gl.ALPHA;
        if (p === $0147bee01cff6558$export$3f8bb04b555a363c) return gl.RGBA;
        if (p === $0147bee01cff6558$export$cc09ccbf6d1ed449) return gl.LUMINANCE;
        if (p === $0147bee01cff6558$export$9053a81c4a69c289) return gl.LUMINANCE_ALPHA;
        if (p === $0147bee01cff6558$export$c1b6b5136be58045) return gl.DEPTH_COMPONENT;
        if (p === $0147bee01cff6558$export$1e113ac2d0905829) return gl.DEPTH_STENCIL;
        // WebGL 1 sRGB fallback
        if (p === $0147bee01cff6558$export$ca1dce8b5e1de74d) {
            extension = extensions.get("EXT_sRGB");
            if (extension !== null) return extension.SRGB_ALPHA_EXT;
            else return null;
        }
        // WebGL2 formats.
        if (p === $0147bee01cff6558$export$4e041a7967d15c4b) return gl.RED;
        if (p === $0147bee01cff6558$export$aa92e870a709d190) return gl.RED_INTEGER;
        if (p === $0147bee01cff6558$export$6cdf0b461c7ce8a0) return gl.RG;
        if (p === $0147bee01cff6558$export$1ba1c45f9f77d4d7) return gl.RG_INTEGER;
        if (p === $0147bee01cff6558$export$c200e7d26f592f21) return gl.RGBA_INTEGER;
        // S3TC
        if (p === $0147bee01cff6558$export$21d1799c6d552fc0 || p === $0147bee01cff6558$export$afa304c3e981b668 || p === $0147bee01cff6558$export$d2a1a68024a3e56c || p === $0147bee01cff6558$export$9a79c424327dacf9) {
            if (colorSpace1 === $0147bee01cff6558$export$561f394b24edfcaa) {
                extension = extensions.get("WEBGL_compressed_texture_s3tc_srgb");
                if (extension !== null) {
                    if (p === $0147bee01cff6558$export$21d1799c6d552fc0) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === $0147bee01cff6558$export$afa304c3e981b668) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === $0147bee01cff6558$export$d2a1a68024a3e56c) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === $0147bee01cff6558$export$9a79c424327dacf9) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get("WEBGL_compressed_texture_s3tc");
                if (extension !== null) {
                    if (p === $0147bee01cff6558$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === $0147bee01cff6558$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === $0147bee01cff6558$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === $0147bee01cff6558$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === $0147bee01cff6558$export$19ada9bbb1af3573 || p === $0147bee01cff6558$export$d0f0355bb3d948e4 || p === $0147bee01cff6558$export$b82296714358084c || p === $0147bee01cff6558$export$b71692456c47b6c3) {
            extension = extensions.get("WEBGL_compressed_texture_pvrtc");
            if (extension !== null) {
                if (p === $0147bee01cff6558$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $0147bee01cff6558$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $0147bee01cff6558$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $0147bee01cff6558$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC1
        if (p === $0147bee01cff6558$export$6ab91af2d757aee7) {
            extension = extensions.get("WEBGL_compressed_texture_etc1");
            if (extension !== null) return extension.COMPRESSED_RGB_ETC1_WEBGL;
            else return null;
        }
        // ETC2
        if (p === $0147bee01cff6558$export$7800993ef8106a6a || p === $0147bee01cff6558$export$23ed8300a860e7d8) {
            extension = extensions.get("WEBGL_compressed_texture_etc");
            if (extension !== null) {
                if (p === $0147bee01cff6558$export$7800993ef8106a6a) return colorSpace1 === $0147bee01cff6558$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === $0147bee01cff6558$export$23ed8300a860e7d8) return colorSpace1 === $0147bee01cff6558$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === $0147bee01cff6558$export$dc5570b4a2b92d48 || p === $0147bee01cff6558$export$68880cd325f8b2fb || p === $0147bee01cff6558$export$7d2c0be323373d95 || p === $0147bee01cff6558$export$22b52da301fc3a3e || p === $0147bee01cff6558$export$c009e2cb4a66485e || p === $0147bee01cff6558$export$118fff5afa255b63 || p === $0147bee01cff6558$export$120713c829ae0667 || p === $0147bee01cff6558$export$c79eeabbf53313e9 || p === $0147bee01cff6558$export$443cf6567cdd6424 || p === $0147bee01cff6558$export$6573984fc9840780 || p === $0147bee01cff6558$export$e7aee563f30091de || p === $0147bee01cff6558$export$2eb8634622ddeab7 || p === $0147bee01cff6558$export$202b1ce7b5d25742 || p === $0147bee01cff6558$export$18ab77abd087e467) {
            extension = extensions.get("WEBGL_compressed_texture_astc");
            if (extension !== null) {
                if (p === $0147bee01cff6558$export$dc5570b4a2b92d48) return colorSpace1 === $0147bee01cff6558$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === $0147bee01cff6558$export$68880cd325f8b2fb) return colorSpace1 === $0147bee01cff6558$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === $0147bee01cff6558$export$7d2c0be323373d95) return colorSpace1 === $0147bee01cff6558$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === $0147bee01cff6558$export$22b52da301fc3a3e) return colorSpace1 === $0147bee01cff6558$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === $0147bee01cff6558$export$c009e2cb4a66485e) return colorSpace1 === $0147bee01cff6558$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === $0147bee01cff6558$export$118fff5afa255b63) return colorSpace1 === $0147bee01cff6558$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === $0147bee01cff6558$export$120713c829ae0667) return colorSpace1 === $0147bee01cff6558$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === $0147bee01cff6558$export$c79eeabbf53313e9) return colorSpace1 === $0147bee01cff6558$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === $0147bee01cff6558$export$443cf6567cdd6424) return colorSpace1 === $0147bee01cff6558$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === $0147bee01cff6558$export$6573984fc9840780) return colorSpace1 === $0147bee01cff6558$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === $0147bee01cff6558$export$e7aee563f30091de) return colorSpace1 === $0147bee01cff6558$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === $0147bee01cff6558$export$2eb8634622ddeab7) return colorSpace1 === $0147bee01cff6558$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === $0147bee01cff6558$export$202b1ce7b5d25742) return colorSpace1 === $0147bee01cff6558$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === $0147bee01cff6558$export$18ab77abd087e467) return colorSpace1 === $0147bee01cff6558$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === $0147bee01cff6558$export$ce40b115e188bc81) {
            extension = extensions.get("EXT_texture_compression_bptc");
            if (extension !== null) {
                if (p === $0147bee01cff6558$export$ce40b115e188bc81) return colorSpace1 === $0147bee01cff6558$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
            } else return null;
        }
        // RGTC
        if (p === $0147bee01cff6558$export$b1688df4c4c21670 || p === $0147bee01cff6558$export$fc15e5d8261eed58 || p === $0147bee01cff6558$export$d220f6ade8463a0f || p === $0147bee01cff6558$export$768646d09dc1b6ef) {
            extension = extensions.get("EXT_texture_compression_rgtc");
            if (extension !== null) {
                if (p === $0147bee01cff6558$export$ce40b115e188bc81) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === $0147bee01cff6558$export$fc15e5d8261eed58) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === $0147bee01cff6558$export$d220f6ade8463a0f) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === $0147bee01cff6558$export$768646d09dc1b6ef) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === $0147bee01cff6558$export$6c8ea339bfab1301) {
            if (isWebGL2) return gl.UNSIGNED_INT_24_8;
            extension = extensions.get("WEBGL_depth_texture");
            if (extension !== null) return extension.UNSIGNED_INT_24_8_WEBGL;
            else return null;
        }
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
class $0147bee01cff6558$export$56b937d9e5581166 extends $0147bee01cff6558$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.isArrayCamera = true;
        this.cameras = array;
    }
}
class $0147bee01cff6558$export$eb2fcfdbd7ba97d4 extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isGroup = true;
        this.type = "Group";
    }
}
const $0147bee01cff6558$var$_moveEvent = {
    type: "move"
};
class $0147bee01cff6558$var$WebXRController {
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $0147bee01cff6558$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $0147bee01cff6558$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $0147bee01cff6558$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $0147bee01cff6558$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $0147bee01cff6558$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $0147bee01cff6558$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $0147bee01cff6558$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: "connected",
            data: inputSource
        });
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: "disconnected",
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== "visible-blurred") {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints["index-finger-tip"];
                const thumbTip = hand.joints["thumb-tip"];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: "pinchend",
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: "pinchstart",
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($0147bee01cff6558$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    // private method
    _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new $0147bee01cff6558$export$eb2fcfdbd7ba97d4();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
}
class $0147bee01cff6558$export$fc830aa069cc8c2f extends $0147bee01cff6558$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format){
        format = format !== undefined ? format : $0147bee01cff6558$export$c1b6b5136be58045;
        if (format !== $0147bee01cff6558$export$c1b6b5136be58045 && format !== $0147bee01cff6558$export$1e113ac2d0905829) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        if (type === undefined && format === $0147bee01cff6558$export$c1b6b5136be58045) type = $0147bee01cff6558$export$c3c7fc4518ebba96;
        if (type === undefined && format === $0147bee01cff6558$export$1e113ac2d0905829) type = $0147bee01cff6558$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isDepthTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $0147bee01cff6558$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $0147bee01cff6558$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
        this.compareFunction = null;
    }
    copy(source) {
        super.copy(source);
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
}
class $0147bee01cff6558$var$WebXRManager extends $0147bee01cff6558$export$ec8b666c5fe2c75a {
    constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = "local-floor";
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        //
        const cameraL = new $0147bee01cff6558$export$74e4ae24825f68d7();
        cameraL.layers.enable(1);
        cameraL.viewport = new $0147bee01cff6558$export$fa7daccca11cdbe3();
        const cameraR = new $0147bee01cff6558$export$74e4ae24825f68d7();
        cameraR.layers.enable(2);
        cameraR.viewport = new $0147bee01cff6558$export$fa7daccca11cdbe3();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraXR = new $0147bee01cff6558$export$56b937d9e5581166();
        cameraXR.layers.enable(1);
        cameraXR.layers.enable(2);
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $0147bee01cff6558$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $0147bee01cff6558$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $0147bee01cff6558$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener("select", onSessionEvent);
            session.removeEventListener("selectstart", onSessionEvent);
            session.removeEventListener("selectend", onSessionEvent);
            session.removeEventListener("squeeze", onSessionEvent);
            session.removeEventListener("squeezestart", onSessionEvent);
            session.removeEventListener("squeezeend", onSessionEvent);
            session.removeEventListener("end", onSessionEnd);
            session.removeEventListener("inputsourceschange", onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            scope.dispatchEvent({
                type: "sessionend"
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
        };
        this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
            return glBinding;
        };
        this.getFrame = function() {
            return xrFrame;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener("select", onSessionEvent);
                session.addEventListener("selectstart", onSessionEvent);
                session.addEventListener("selectend", onSessionEvent);
                session.addEventListener("squeeze", onSessionEvent);
                session.addEventListener("squeezestart", onSessionEvent);
                session.addEventListener("squeezeend", onSessionEvent);
                session.addEventListener("end", onSessionEnd);
                session.addEventListener("inputsourceschange", onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                if (session.renderState.layers === undefined || renderer.capabilities.isWebGL2 === false) {
                    const layerInit = {
                        antialias: session.renderState.layers === undefined ? attributes.antialias : true,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    newRenderTarget = new $0147bee01cff6558$export$3c052beb2e51e23f(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: $0147bee01cff6558$export$3f8bb04b555a363c,
                        type: $0147bee01cff6558$export$2e8ce08d3f6f5e10,
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? $0147bee01cff6558$export$1e113ac2d0905829 : $0147bee01cff6558$export$c1b6b5136be58045;
                        depthType = attributes.stencil ? $0147bee01cff6558$export$6c8ea339bfab1301 : $0147bee01cff6558$export$c3c7fc4518ebba96;
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    newRenderTarget = new $0147bee01cff6558$export$3c052beb2e51e23f(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: $0147bee01cff6558$export$3f8bb04b555a363c,
                        type: $0147bee01cff6558$export$2e8ce08d3f6f5e10,
                        depthTexture: new $0147bee01cff6558$export$fc830aa069cc8c2f(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0
                    });
                    const renderTargetProperties = renderer.properties.get(newRenderTarget);
                    renderTargetProperties.__ignoreDepthValues = glProjLayer.ignoreDepthValues;
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: "sessionstart"
                });
            }
        };
        this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new $0147bee01cff6558$export$64b5c384219d3699();
        const cameraRPos = new $0147bee01cff6558$export$64b5c384219d3699();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Find the union of the frustum values of the cameras and scale
            // the values so that the near plane's position does not change in world space,
            // although must now be relative to the new union camera.
            const near2 = near + zOffset;
            const far2 = far + zOffset;
            const left2 = left - xOffset;
            const right2 = right + (ipd - xOffset);
            const top2 = topFov * far / far2 * near2;
            const bottom2 = bottomFov * far / far2 * near2;
            camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
            camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
            if (session === null) return;
            cameraXR.near = cameraR.near = cameraL.near = camera.near;
            cameraXR.far = cameraR.far = cameraL.far = camera.far;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            const parent = camera.parent;
            const cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraXR, parent);
        };
        function updateUserCamera(camera, cameraXR, parent) {
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            const children = camera.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = $0147bee01cff6558$var$RAD2DEG * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        this.getCamera = function() {
            return cameraXR;
        };
        this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new $0147bee01cff6558$export$74e4ae24825f68d7();
                        camera.layers.enable(i);
                        camera.viewport = new $0147bee01cff6558$export$fa7daccca11cdbe3();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: "planesdetected",
                data: frame
            });
            xrFrame = null;
        }
        const animation = new $0147bee01cff6558$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
function $0147bee01cff6558$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, $0147bee01cff6558$var$getUnlitUniformColorSpace(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $0147bee01cff6558$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $0147bee01cff6558$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const envMap = properties.get(material).envMap;
        if (envMap) {
            uniforms.envMap.value = envMap;
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            // artist-friendly light intensity scaling factor
            const scaleFactor = renderer._useLegacyLights === true ? Math.PI : 1;
            uniforms.lightMapIntensity.value = material.lightMapIntensity * scaleFactor;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        const envMap = properties.get(material).envMap;
        if (envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === $0147bee01cff6558$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $0147bee01cff6558$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = capabilities.isWebGL2 ? gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS) : 0; // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener("dispose", onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.");
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniform = uniforms[i];
            // partly update the buffer if necessary
            if (hasUniformChanged(uniform, i, cache) === true) {
                const offset = uniform.__offset;
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                let arrayOffset = 0;
                for(let i = 0; i < values.length; i++){
                    const value = values[i];
                    const info = getUniformSize(value);
                    if (typeof value === "number") {
                        uniform.__data[0] = value;
                        gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                    } else if (value.isMatrix3) {
                        // manually converting 3x3 to 3x4
                        uniform.__data[0] = value.elements[0];
                        uniform.__data[1] = value.elements[1];
                        uniform.__data[2] = value.elements[2];
                        uniform.__data[3] = value.elements[0];
                        uniform.__data[4] = value.elements[3];
                        uniform.__data[5] = value.elements[4];
                        uniform.__data[6] = value.elements[5];
                        uniform.__data[7] = value.elements[0];
                        uniform.__data[8] = value.elements[6];
                        uniform.__data[9] = value.elements[7];
                        uniform.__data[10] = value.elements[8];
                        uniform.__data[11] = value.elements[0];
                    } else {
                        value.toArray(uniform.__data, arrayOffset);
                        arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                    }
                }
                gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, cache) {
        const value = uniform.value;
        if (cache[index] === undefined) {
            // cache entry does not exist so far
            if (typeof value === "number") cache[index] = value;
            else {
                const values = Array.isArray(value) ? value : [
                    value
                ];
                const tempValues = [];
                for(let i = 0; i < values.length; i++)tempValues.push(values[i].clone());
                cache[index] = tempValues;
            }
            return true;
        } else {
            // compare current value with cached entry
            if (typeof value === "number") {
                if (cache[index] !== value) {
                    cache[index] = value;
                    return true;
                }
            } else {
                const cachedObjects = Array.isArray(cache[index]) ? cache[index] : [
                    cache[index]
                ];
                const values = Array.isArray(value) ? value : [
                    value
                ];
                for(let i = 0; i < cachedObjects.length; i++){
                    const cachedObject = cachedObjects[i];
                    if (cachedObject.equals(values[i]) === false) {
                        cachedObject.copy(values[i]);
                        return true;
                    }
                }
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        let chunkOffset = 0; // offset within a single chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniform = uniforms[i];
            const infos = {
                boundary: 0,
                storage: 0 // bytes
            };
            const values = Array.isArray(uniform.value) ? uniform.value : [
                uniform.value
            ];
            for(let j = 0, jl = values.length; j < jl; j++){
                const value = values[j];
                const info = getUniformSize(value);
                infos.boundary += info.boundary;
                infos.storage += info.storage;
            }
            // the following two properties will be used for partial buffer updates
            uniform.__data = new Float32Array(infos.storage / Float32Array.BYTES_PER_ELEMENT);
            uniform.__offset = offset;
            //
            if (i > 0) {
                chunkOffset = offset % chunkSize;
                const remainingSizeInChunk = chunkSize - chunkOffset;
                // check for chunk overflow
                if (chunkOffset !== 0 && remainingSizeInChunk - infos.boundary < 0) {
                    // add padding and adjust offset
                    offset += chunkSize - chunkOffset;
                    uniform.__offset = offset;
                }
            }
            offset += infos.storage;
        }
        // ensure correct final padding
        chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === "number") {
            // float/int
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.");
        else console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener("dispose", onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
function $0147bee01cff6558$var$createCanvasElement() {
    const canvas = $0147bee01cff6558$var$createElementNS("canvas");
    canvas.style.display = "block";
    return canvas;
}
class $0147bee01cff6558$export$f6cc00ef28d7cf97 {
    constructor(parameters = {}){
        const { canvas: canvas = $0147bee01cff6558$var$createCanvasElement(), context: context = null, depth: depth = true, stencil: stencil = true, alpha: alpha = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = true, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = "default", failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false } = parameters;
        this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) _alpha = context.getContextAttributes().alpha;
        else _alpha = alpha;
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // public properties
        this.domElement = canvas;
        // Debug configuration container
        this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        this.autoClear = true;
        this.autoClearColor = true;
        this.autoClearDepth = true;
        this.autoClearStencil = true;
        // scene graph
        this.sortObjects = true;
        // user-defined clipping
        this.clippingPlanes = [];
        this.localClippingEnabled = false;
        // physically based shading
        this.outputColorSpace = $0147bee01cff6558$export$561f394b24edfcaa;
        // physical lights
        this._useLegacyLights = false;
        // tone mapping
        this.toneMapping = $0147bee01cff6558$export$9fcb6b4294603b2;
        this.toneMappingExposure = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new $0147bee01cff6558$export$fa7daccca11cdbe3();
        const _currentScissor = new $0147bee01cff6558$export$fa7daccca11cdbe3();
        let _currentScissorTest = null;
        const _currentClearColor = new $0147bee01cff6558$export$892596cec99bc70e(0x000000);
        let _currentClearAlpha = 0;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new $0147bee01cff6558$export$fa7daccca11cdbe3(0, 0, _width, _height);
        const _scissor = new $0147bee01cff6558$export$fa7daccca11cdbe3(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new $0147bee01cff6558$export$35efe6f4c85463d2();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // transmission
        let _transmissionRenderTarget = null;
        // camera matrices cache
        const _projScreenMatrix = new $0147bee01cff6558$export$2ae72fc923e5eb5();
        const _vector2 = new $0147bee01cff6558$export$c977b3e384af9ae1();
        const _vector3 = new $0147bee01cff6558$export$64b5c384219d3699();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextNames, contextAttributes) {
            for(let i = 0; i < contextNames.length; i++){
                const contextName = contextNames[i];
                const context = canvas.getContext(contextName, contextAttributes);
                if (context !== null) return context;
            }
            return null;
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ("setAttribute" in canvas) canvas.setAttribute("data-engine", `three.js r${$0147bee01cff6558$export$3545e07a80636437}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener("webglcontextlost", onContextLost, false);
            canvas.addEventListener("webglcontextrestored", onContextRestore, false);
            canvas.addEventListener("webglcontextcreationerror", onContextCreationError, false);
            if (_gl === null) {
                const contextNames = [
                    "webgl2",
                    "webgl",
                    "experimental-webgl"
                ];
                if (_this.isWebGL1Renderer === true) contextNames.shift();
                _gl = getContext(contextNames, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextNames)) throw new Error("Error creating WebGL context with your selected attributes.");
                    else throw new Error("Error creating WebGL context.");
                }
            }
            if (typeof WebGLRenderingContext !== "undefined" && _gl instanceof WebGLRenderingContext) console.warn("THREE.WebGLRenderer: WebGL 1 support was deprecated in r153 and will be removed in r163.");
            // Some experimental-webgl implementations do not have getShaderPrecisionFormat
            if (_gl.getShaderPrecisionFormat === undefined) _gl.getShaderPrecisionFormat = function() {
                return {
                    "rangeMin": 1,
                    "rangeMax": 1,
                    "precision": 1
                };
            };
        } catch (error) {
            console.error("THREE.WebGLRenderer: " + error.message);
            throw error;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $0147bee01cff6558$var$WebGLExtensions(_gl);
            capabilities = new $0147bee01cff6558$var$WebGLCapabilities(_gl, extensions, parameters);
            extensions.init(capabilities);
            utils = new $0147bee01cff6558$export$ddaebcad857649a8(_gl, extensions, capabilities);
            state = new $0147bee01cff6558$var$WebGLState(_gl, extensions, capabilities);
            info = new $0147bee01cff6558$var$WebGLInfo(_gl);
            properties = new $0147bee01cff6558$var$WebGLProperties();
            textures = new $0147bee01cff6558$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $0147bee01cff6558$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $0147bee01cff6558$var$WebGLCubeUVMaps(_this);
            attributes = new $0147bee01cff6558$var$WebGLAttributes(_gl, capabilities);
            bindingStates = new $0147bee01cff6558$var$WebGLBindingStates(_gl, extensions, attributes, capabilities);
            geometries = new $0147bee01cff6558$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $0147bee01cff6558$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $0147bee01cff6558$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $0147bee01cff6558$var$WebGLClipping(properties);
            programCache = new $0147bee01cff6558$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $0147bee01cff6558$var$WebGLMaterials(_this, properties);
            renderLists = new $0147bee01cff6558$var$WebGLRenderLists();
            renderStates = new $0147bee01cff6558$var$WebGLRenderStates(extensions, capabilities);
            background = new $0147bee01cff6558$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $0147bee01cff6558$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $0147bee01cff6558$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $0147bee01cff6558$var$WebGLBufferRenderer(_gl, extensions, info, capabilities);
            indexedBufferRenderer = new $0147bee01cff6558$var$WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
            info.programs = programCache.programs;
            _this.capabilities = capabilities;
            _this.extensions = extensions;
            _this.properties = properties;
            _this.renderLists = renderLists;
            _this.shadowMap = shadowMap;
            _this.state = state;
            _this.info = info;
        }
        initGLContext();
        // xr
        const xr = new $0147bee01cff6558$var$WebXRManager(_this, _gl);
        this.xr = xr;
        // API
        this.getContext = function() {
            return _gl;
        };
        this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        this.forceContextLoss = function() {
            const extension = extensions.get("WEBGL_lose_context");
            if (extension) extension.loseContext();
        };
        this.forceContextRestore = function() {
            const extension = extensions.get("WEBGL_lose_context");
            if (extension) extension.restoreContext();
        };
        this.getPixelRatio = function() {
            return _pixelRatio;
        };
        this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        this.getSize = function(target) {
            return target.set(_width, _height);
        };
        this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + "px";
                canvas.style.height = height + "px";
            }
            this.setViewport(0, 0, width, height);
        };
        this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
        };
        this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
        };
        this.getScissorTest = function() {
            return _scissorTest;
        };
        this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        this.setClearColor = function() {
            background.setClearColor.apply(background, arguments);
        };
        this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        this.setClearAlpha = function() {
            background.setClearAlpha.apply(background, arguments);
        };
        this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                let isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    const targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = targetFormat === $0147bee01cff6558$export$c200e7d26f592f21 || targetFormat === $0147bee01cff6558$export$1ba1c45f9f77d4d7 || targetFormat === $0147bee01cff6558$export$aa92e870a709d190;
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    const targetType = _currentRenderTarget.texture.type;
                    const isUnsignedType = targetType === $0147bee01cff6558$export$2e8ce08d3f6f5e10 || targetType === $0147bee01cff6558$export$c3c7fc4518ebba96 || targetType === $0147bee01cff6558$export$c63dc51868b06a9d || targetType === $0147bee01cff6558$export$6c8ea339bfab1301 || targetType === $0147bee01cff6558$export$b3969b01faf587f2 || targetType === $0147bee01cff6558$export$18886f8ae33e90de;
                    const clearColor = background.getClearColor();
                    const a = background.getClearAlpha();
                    const r = clearColor.r;
                    const g = clearColor.g;
                    const b = clearColor.b;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) bits |= _gl.STENCIL_BUFFER_BIT;
            _gl.clear(bits);
        };
        this.clearColor = function() {
            this.clear(true, false, false);
        };
        this.clearDepth = function() {
            this.clear(false, true, false);
        };
        this.clearStencil = function() {
            this.clear(false, false, true);
        };
        //
        this.dispose = function() {
            canvas.removeEventListener("webglcontextlost", onContextLost, false);
            canvas.removeEventListener("webglcontextrestored", onContextRestore, false);
            canvas.removeEventListener("webglcontextcreationerror", onContextCreationError, false);
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener("sessionstart", onXRSessionStart);
            xr.removeEventListener("sessionend", onXRSessionEnd);
            if (_transmissionRenderTarget) {
                _transmissionRenderTarget.dispose();
                _transmissionRenderTarget = null;
            }
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            console.log("THREE.WebGLRenderer: Context Lost.");
            _isContextLost = true;
        }
        function onContextRestore() {
            console.log("THREE.WebGLRenderer: Context Restored.");
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener("dispose", onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                if (index === undefined) return;
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        this.compile = function(scene, camera) {
            function prepare(material, scene, object) {
                if (material.transparent === true && material.side === $0147bee01cff6558$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                    material.side = $0147bee01cff6558$export$d9f0486e75b5ace;
                    material.needsUpdate = true;
                    getProgram(material, scene, object);
                    material.side = $0147bee01cff6558$export$2ede184fc2998901;
                    material.needsUpdate = true;
                    getProgram(material, scene, object);
                    material.side = $0147bee01cff6558$export$3b296b6f144d5b03;
                } else getProgram(material, scene, object);
            }
            currentRenderState = renderStates.get(scene);
            currentRenderState.init();
            renderStateStack.push(currentRenderState);
            scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights(_this._useLegacyLights);
            scene.traverse(function(object) {
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepare(material2, scene, object);
                    }
                    else prepare(material, scene, object);
                }
            });
            renderStateStack.pop();
            currentRenderState = null;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $0147bee01cff6558$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== "undefined") animation.setContext(self);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener("sessionstart", onXRSessionStart);
        xr.addEventListener("sessionend", onXRSessionEnd);
        // Rendering
        this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
                return;
            }
            if (_isContextLost === true) return;
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init();
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            //
            this.info.render.frame++;
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            //
            background.render(currentRenderList, scene);
            // render scene
            currentRenderState.setupLights(_this._useLegacyLights);
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderScene(currentRenderList, scene, camera2, camera2.viewport);
                }
            } else renderScene(currentRenderList, scene, camera);
            //
            if (_currentRenderTarget !== null) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) currentRenderState = renderStateStack[renderStateStack.length - 1];
            else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector3.copy(object.boundingSphere.center);
                            } else {
                                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                                _vector3.copy(geometry.boundingSphere.center);
                            }
                            _vector3.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector3.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            const transparentObjects = currentRenderList.transparent;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            const isWebGL2 = capabilities.isWebGL2;
            if (_transmissionRenderTarget === null) _transmissionRenderTarget = new $0147bee01cff6558$export$3c052beb2e51e23f(1, 1, {
                generateMipmaps: true,
                type: extensions.has("EXT_color_buffer_half_float") ? $0147bee01cff6558$export$2697304443f382bc : $0147bee01cff6558$export$2e8ce08d3f6f5e10,
                minFilter: $0147bee01cff6558$export$5d8599b6a933fb1b,
                samples: isWebGL2 ? 4 : 0
            });
            _this.getDrawingBufferSize(_vector2);
            if (isWebGL2) _transmissionRenderTarget.setSize(_vector2.x, _vector2.y);
            else _transmissionRenderTarget.setSize($0147bee01cff6558$var$floorPowerOfTwo(_vector2.x), $0147bee01cff6558$var$floorPowerOfTwo(_vector2.y));
            //
            const currentRenderTarget = _this.getRenderTarget();
            _this.setRenderTarget(_transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = $0147bee01cff6558$export$9fcb6b4294603b2;
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
            textures.updateRenderTargetMipmap(_transmissionRenderTarget);
            let renderTargetNeedsUpdate = false;
            for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                const renderItem = transmissiveObjects[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = renderItem.material;
                const group = renderItem.group;
                if (material.side === $0147bee01cff6558$export$3b296b6f144d5b03 && object.layers.test(camera.layers)) {
                    const currentSide = material.side;
                    material.side = $0147bee01cff6558$export$d9f0486e75b5ace;
                    material.needsUpdate = true;
                    renderObject(object, scene, camera, geometry, material, group);
                    material.side = currentSide;
                    material.needsUpdate = true;
                    renderTargetNeedsUpdate = true;
                }
            }
            if (renderTargetNeedsUpdate === true) {
                textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
                textures.updateRenderTargetMipmap(_transmissionRenderTarget);
            }
            _this.setRenderTarget(currentRenderTarget);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
                const group = renderItem.group;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === $0147bee01cff6558$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                material.side = $0147bee01cff6558$export$d9f0486e75b5ace;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $0147bee01cff6558$export$2ede184fc2998901;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $0147bee01cff6558$export$3b296b6f144d5b03;
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            if (programs === undefined) {
                // new material
                material.addEventListener("dispose", onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBuild(object, parameters, _this);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            const progUniforms = program.getUniforms();
            const uniformsList = $0147bee01cff6558$var$WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = uniformsList;
            return program;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.instancing = parameters.instancing;
            materialProperties.instancingColor = parameters.instancingColor;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            const colorSpace1 = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : $0147bee01cff6558$export$42429b3acfb233a4;
            const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            let toneMapping = $0147bee01cff6558$export$9fcb6b4294603b2;
            if (material.toneMapped) {
                if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) toneMapping = _this.toneMapping;
            }
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace1) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (capabilities.isWebGL2 === true && materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                p_uniforms.setValue(_gl, "projectionMatrix", camera.projectionMatrix);
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, "logDepthBufFC", 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
                // load material specific uniforms
                // (shader material also gets them for the sake of genericity)
                if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
                    const uCamPos = p_uniforms.map.cameraPosition;
                    if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                }
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, "isOrthographic", camera.isOrthographicCamera === true);
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || object.isSkinnedMesh) p_uniforms.setValue(_gl, "viewMatrix", camera.matrixWorldInverse);
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, "bindMatrix");
                p_uniforms.setOptional(_gl, object, "bindMatrixInverse");
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (capabilities.floatVertexTextures) {
                        if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                        p_uniforms.setValue(_gl, "boneTexture", skeleton.boneTexture, textures);
                        p_uniforms.setValue(_gl, "boneTextureSize", skeleton.boneTextureSize);
                    } else console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required.");
                }
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined && capabilities.isWebGL2 === true) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, "receiveShadow", object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, "toneMappingExposure", _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
                $0147bee01cff6558$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $0147bee01cff6558$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, "center", object.center);
            // common matrices
            p_uniforms.setValue(_gl, "modelViewMatrix", object.modelViewMatrix);
            p_uniforms.setValue(_gl, "normalMatrix", object.normalMatrix);
            p_uniforms.setValue(_gl, "modelMatrix", object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++)if (capabilities.isWebGL2) {
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                } else console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.");
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__hasExternalTextures = true;
            if (renderTargetProperties.__hasExternalTextures) {
                renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
                if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
                // are midframe flushes and an external depth buffer. Disable use of the extension.
                {
                    if (extensions.has("WEBGL_multisampled_render_to_texture") === true) {
                        console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided");
                        renderTargetProperties.__useRenderToTexture = false;
                    }
                }
            }
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let useDefaultFramebuffer = true;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // We need to make sure to rebind the framebuffer.
                    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
                    useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    if (Array.isArray(__webglFramebuffer[activeCubeFace])) framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
                    else framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (capabilities.isWebGL2 && renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else if (Array.isArray(__webglFramebuffer)) framebuffer = __webglFramebuffer[activeMipmapLevel];
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound && capabilities.drawBuffers && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const textureProperties = properties.get(renderTarget.texture);
                const layer = activeCubeFace || 0;
                _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.texture;
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (textureFormat !== $0147bee01cff6558$export$3f8bb04b555a363c && utils.convert(textureFormat) !== _gl.getParameter(_gl.IMPLEMENTATION_COLOR_READ_FORMAT)) {
                        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                        return;
                    }
                    const halfFloatSupportedByExt = textureType === $0147bee01cff6558$export$2697304443f382bc && (extensions.has("EXT_color_buffer_half_float") || capabilities.isWebGL2 && extensions.has("EXT_color_buffer_float"));
                    if (textureType !== $0147bee01cff6558$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== _gl.getParameter(_gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
                    !(textureType === $0147bee01cff6558$export$f6d331659b644596 && (capabilities.isWebGL2 || extensions.has("OES_texture_float") || extensions.has("WEBGL_color_buffer_float"))) && // Chrome Mac >= 52 and Firefox
                    !halfFloatSupportedByExt) {
                        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        this.copyFramebufferToTexture = function(position, texture, level = 0) {
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, position.x, position.y, width, height);
            state.unbindTexture();
        };
        this.copyTextureToTexture = function(position, srcTexture, dstTexture, level = 0) {
            const width = srcTexture.image.width;
            const height = srcTexture.image.height;
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            textures.setTexture2D(dstTexture, 0);
            // As another texture upload may have changed pixelStorei
            // parameters, make sure they are correct for the dstTexture
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
            else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
            else _gl.texSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, glFormat, glType, srcTexture.image);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(_gl.TEXTURE_2D);
            state.unbindTexture();
        };
        this.copyTextureToTexture3D = function(sourceBox, position, srcTexture, dstTexture, level = 0) {
            if (_this.isWebGL1Renderer) {
                console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
                return;
            }
            const width = sourceBox.max.x - sourceBox.min.x + 1;
            const height = sourceBox.max.y - sourceBox.min.y + 1;
            const depth = sourceBox.max.z - sourceBox.min.z + 1;
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
                return;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            const unpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const unpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const unpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const unpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const unpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, sourceBox.min.x);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, sourceBox.min.y);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, sourceBox.min.z);
            if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data);
            else if (srcTexture.isCompressedArrayTexture) {
                console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.");
                _gl.compressedTexSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data);
            } else _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, unpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, unpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, unpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, unpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, unpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    get coordinateSystem() {
        return $0147bee01cff6558$export$5a0e9190d10875d3;
    }
    get physicallyCorrectLights() {
        console.warn("THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead.");
        return !this.useLegacyLights;
    }
    set physicallyCorrectLights(value) {
        console.warn("THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead.");
        this.useLegacyLights = !value;
    }
    get outputEncoding() {
        console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead.");
        return this.outputColorSpace === $0147bee01cff6558$export$561f394b24edfcaa ? $0147bee01cff6558$export$f32388edbb32674 : $0147bee01cff6558$export$7207336e4151a112;
    }
    set outputEncoding(encoding) {
        console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead.");
        this.outputColorSpace = encoding === $0147bee01cff6558$export$f32388edbb32674 ? $0147bee01cff6558$export$561f394b24edfcaa : $0147bee01cff6558$export$42429b3acfb233a4;
    }
    get useLegacyLights() {
        console.warn("THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733.");
        return this._useLegacyLights;
    }
    set useLegacyLights(value) {
        console.warn("THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733.");
        this._useLegacyLights = value;
    }
}
class $0147bee01cff6558$export$a2f65229194348f9 extends $0147bee01cff6558$export$f6cc00ef28d7cf97 {
}
$0147bee01cff6558$export$a2f65229194348f9.prototype.isWebGL1Renderer = true;
class $0147bee01cff6558$export$6f1519f023b8d0f6 {
    constructor(color, density = 0.00025){
        this.isFogExp2 = true;
        this.name = "";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(color);
        this.density = density;
    }
    clone() {
        return new $0147bee01cff6558$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: "FogExp2",
            color: this.color.getHex(),
            density: this.density
        };
    }
}
class $0147bee01cff6558$export$3c890837b09508d4 {
    constructor(color, near = 1, far = 1000){
        this.isFog = true;
        this.name = "";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    clone() {
        return new $0147bee01cff6558$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: "Fog",
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
class $0147bee01cff6558$export$38af1803e3442a7f extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isScene = true;
        this.type = "Scene";
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.backgroundBlurriness = 0;
        this.backgroundIntensity = 1;
        this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        return data;
    }
}
class $0147bee01cff6558$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $0147bee01cff6558$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
        this.uuid = $0147bee01cff6558$var$generateUUID();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $0147bee01cff6558$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $0147bee01cff6558$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $0147bee01cff6558$var$_vector$5 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.isInterleavedBufferAttribute = true;
        this.name = "";
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $0147bee01cff6558$var$_vector$5.fromBufferAttribute(this, i);
            $0147bee01cff6558$var$_vector$5.applyMatrix4(m);
            this.setXYZ(i, $0147bee01cff6558$var$_vector$5.x, $0147bee01cff6558$var$_vector$5.y, $0147bee01cff6558$var$_vector$5.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $0147bee01cff6558$var$_vector$5.fromBufferAttribute(this, i);
            $0147bee01cff6558$var$_vector$5.applyNormalMatrix(m);
            this.setXYZ(i, $0147bee01cff6558$var$_vector$5.x, $0147bee01cff6558$var$_vector$5.y, $0147bee01cff6558$var$_vector$5.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $0147bee01cff6558$var$_vector$5.fromBufferAttribute(this, i);
            $0147bee01cff6558$var$_vector$5.transformDirection(m);
            this.setXYZ(i, $0147bee01cff6558$var$_vector$5.x, $0147bee01cff6558$var$_vector$5.y, $0147bee01cff6558$var$_vector$5.z);
        }
        return this;
    }
    setX(index, x) {
        if (this.normalized) x = $0147bee01cff6558$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        if (this.normalized) y = $0147bee01cff6558$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        if (this.normalized) z = $0147bee01cff6558$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        if (this.normalized) w = $0147bee01cff6558$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $0147bee01cff6558$var$denormalize(x, this.array);
        return x;
    }
    getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $0147bee01cff6558$var$denormalize(y, this.array);
        return y;
    }
    getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $0147bee01cff6558$var$denormalize(z, this.array);
        return z;
    }
    getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $0147bee01cff6558$var$denormalize(w, this.array);
        return w;
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $0147bee01cff6558$var$normalize(x, this.array);
            y = $0147bee01cff6558$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $0147bee01cff6558$var$normalize(x, this.array);
            y = $0147bee01cff6558$var$normalize(y, this.array);
            z = $0147bee01cff6558$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $0147bee01cff6558$var$normalize(x, this.array);
            y = $0147bee01cff6558$var$normalize(y, this.array);
            z = $0147bee01cff6558$var$normalize(z, this.array);
            w = $0147bee01cff6558$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $0147bee01cff6558$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $0147bee01cff6558$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
class $0147bee01cff6558$export$5ec7dd1c6994bf8e extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isSpriteMaterial = true;
        this.type = "SpriteMaterial";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $0147bee01cff6558$var$_geometry;
const $0147bee01cff6558$var$_intersectPoint = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_worldScale = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_mvPosition = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_alignedPosition = /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1();
const $0147bee01cff6558$var$_rotatedPosition = /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1();
const $0147bee01cff6558$var$_viewWorldMatrix = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_vA = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vB = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vC = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_uvA = /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1();
const $0147bee01cff6558$var$_uvB = /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1();
const $0147bee01cff6558$var$_uvC = /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1();
class $0147bee01cff6558$export$3075603db8e6204c extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(material){
        super();
        this.isSprite = true;
        this.type = "Sprite";
        if ($0147bee01cff6558$var$_geometry === undefined) {
            $0147bee01cff6558$var$_geometry = new $0147bee01cff6558$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $0147bee01cff6558$export$3d5cd879f108f53f(float32Array, 5);
            $0147bee01cff6558$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $0147bee01cff6558$var$_geometry.setAttribute("position", new $0147bee01cff6558$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $0147bee01cff6558$var$_geometry.setAttribute("uv", new $0147bee01cff6558$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $0147bee01cff6558$var$_geometry;
        this.material = material !== undefined ? material : new $0147bee01cff6558$export$5ec7dd1c6994bf8e();
        this.center = new $0147bee01cff6558$export$c977b3e384af9ae1(0.5, 0.5);
    }
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $0147bee01cff6558$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $0147bee01cff6558$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $0147bee01cff6558$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $0147bee01cff6558$var$_worldScale.multiplyScalar(-$0147bee01cff6558$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $0147bee01cff6558$var$transformVertex($0147bee01cff6558$var$_vA.set(-0.5, -0.5, 0), $0147bee01cff6558$var$_mvPosition, center, $0147bee01cff6558$var$_worldScale, sin, cos);
        $0147bee01cff6558$var$transformVertex($0147bee01cff6558$var$_vB.set(0.5, -0.5, 0), $0147bee01cff6558$var$_mvPosition, center, $0147bee01cff6558$var$_worldScale, sin, cos);
        $0147bee01cff6558$var$transformVertex($0147bee01cff6558$var$_vC.set(0.5, 0.5, 0), $0147bee01cff6558$var$_mvPosition, center, $0147bee01cff6558$var$_worldScale, sin, cos);
        $0147bee01cff6558$var$_uvA.set(0, 0);
        $0147bee01cff6558$var$_uvB.set(1, 0);
        $0147bee01cff6558$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($0147bee01cff6558$var$_vA, $0147bee01cff6558$var$_vB, $0147bee01cff6558$var$_vC, false, $0147bee01cff6558$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $0147bee01cff6558$var$transformVertex($0147bee01cff6558$var$_vB.set(-0.5, 0.5, 0), $0147bee01cff6558$var$_mvPosition, center, $0147bee01cff6558$var$_worldScale, sin, cos);
            $0147bee01cff6558$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($0147bee01cff6558$var$_vA, $0147bee01cff6558$var$_vC, $0147bee01cff6558$var$_vB, false, $0147bee01cff6558$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($0147bee01cff6558$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $0147bee01cff6558$var$_intersectPoint.clone(),
            uv: $0147bee01cff6558$export$5a465592bfe74b48.getInterpolation($0147bee01cff6558$var$_intersectPoint, $0147bee01cff6558$var$_vA, $0147bee01cff6558$var$_vB, $0147bee01cff6558$var$_vC, $0147bee01cff6558$var$_uvA, $0147bee01cff6558$var$_uvB, $0147bee01cff6558$var$_uvC, new $0147bee01cff6558$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $0147bee01cff6558$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $0147bee01cff6558$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $0147bee01cff6558$var$_rotatedPosition.x = cos * $0147bee01cff6558$var$_alignedPosition.x - sin * $0147bee01cff6558$var$_alignedPosition.y;
        $0147bee01cff6558$var$_rotatedPosition.y = sin * $0147bee01cff6558$var$_alignedPosition.x + cos * $0147bee01cff6558$var$_alignedPosition.y;
    } else $0147bee01cff6558$var$_rotatedPosition.copy($0147bee01cff6558$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $0147bee01cff6558$var$_rotatedPosition.x;
    vertexPosition.y += $0147bee01cff6558$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($0147bee01cff6558$var$_viewWorldMatrix);
}
const $0147bee01cff6558$var$_v1$2 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_v2$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$112e7237be0c5f30 extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = "LOD";
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $0147bee01cff6558$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($0147bee01cff6558$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $0147bee01cff6558$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $0147bee01cff6558$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $0147bee01cff6558$var$_v1$2.distanceTo($0147bee01cff6558$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
}
const $0147bee01cff6558$var$_basePosition = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_skinIndex = /*@__PURE__*/ new $0147bee01cff6558$export$fa7daccca11cdbe3();
const $0147bee01cff6558$var$_skinWeight = /*@__PURE__*/ new $0147bee01cff6558$export$fa7daccca11cdbe3();
const $0147bee01cff6558$var$_vector3 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_matrix4 = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_vertex = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_sphere$3 = /*@__PURE__*/ new $0147bee01cff6558$export$805e8b72413ccaba();
const $0147bee01cff6558$var$_inverseMatrix$2 = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_ray$2 = /*@__PURE__*/ new $0147bee01cff6558$export$a186db52eed6d40e();
class $0147bee01cff6558$export$b303577035157ecf extends $0147bee01cff6558$export$e176487c05830cc5 {
    constructor(geometry, material){
        super(geometry, material);
        this.isSkinnedMesh = true;
        this.type = "SkinnedMesh";
        this.bindMode = "attached";
        this.bindMatrix = new $0147bee01cff6558$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $0147bee01cff6558$export$2ae72fc923e5eb5();
        this.boundingBox = null;
        this.boundingSphere = null;
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $0147bee01cff6558$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute("position");
        for(let i = 0; i < positionAttribute.count; i++){
            $0147bee01cff6558$var$_vertex.fromBufferAttribute(positionAttribute, i);
            this.applyBoneTransform(i, $0147bee01cff6558$var$_vertex);
            this.boundingBox.expandByPoint($0147bee01cff6558$var$_vertex);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $0147bee01cff6558$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute("position");
        for(let i = 0; i < positionAttribute.count; i++){
            $0147bee01cff6558$var$_vertex.fromBufferAttribute(positionAttribute, i);
            this.applyBoneTransform(i, $0147bee01cff6558$var$_vertex);
            this.boundingSphere.expandByPoint($0147bee01cff6558$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    raycast(raycaster, intersects) {
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $0147bee01cff6558$var$_sphere$3.copy(this.boundingSphere);
        $0147bee01cff6558$var$_sphere$3.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($0147bee01cff6558$var$_sphere$3) === false) return;
        // convert ray to local space of skinned mesh
        $0147bee01cff6558$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $0147bee01cff6558$var$_ray$2.copy(raycaster.ray).applyMatrix4($0147bee01cff6558$var$_inverseMatrix$2);
        // test with bounding box in local space
        if (this.boundingBox !== null) {
            if ($0147bee01cff6558$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $0147bee01cff6558$var$_ray$2);
    }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $0147bee01cff6558$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === "attached") this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === "detached") this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
    applyBoneTransform(index, vector) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $0147bee01cff6558$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $0147bee01cff6558$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $0147bee01cff6558$var$_basePosition.copy(vector).applyMatrix4(this.bindMatrix);
        vector.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $0147bee01cff6558$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $0147bee01cff6558$var$_skinIndex.getComponent(i);
                $0147bee01cff6558$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                vector.addScaledVector($0147bee01cff6558$var$_vector3.copy($0147bee01cff6558$var$_basePosition).applyMatrix4($0147bee01cff6558$var$_matrix4), weight);
            }
        }
        return vector.applyMatrix4(this.bindMatrixInverse);
    }
    boneTransform(index, vector) {
        console.warn("THREE.SkinnedMesh: .boneTransform() was renamed to .applyBoneTransform() in r151.");
        return this.applyBoneTransform(index, vector);
    }
}
class $0147bee01cff6558$export$b127726e56765aa4 extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isBone = true;
        this.type = "Bone";
    }
}
class $0147bee01cff6558$export$b691f601014eabe1 extends $0147bee01cff6558$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $0147bee01cff6558$export$727aa5ec3fe39bf0, minFilter = $0147bee01cff6558$export$727aa5ec3fe39bf0, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isDataTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
const $0147bee01cff6558$var$_offsetMatrix = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_identityMatrix = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
class $0147bee01cff6558$export$8f31e4c4a37b8e9c {
    constructor(bones = [], boneInverses = []){
        this.uuid = $0147bee01cff6558$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.boneTextureSize = 0;
        this.init();
    }
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.");
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $0147bee01cff6558$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $0147bee01cff6558$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $0147bee01cff6558$var$_identityMatrix;
            $0147bee01cff6558$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $0147bee01cff6558$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $0147bee01cff6558$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = $0147bee01cff6558$var$ceilPowerOfTwo(size);
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $0147bee01cff6558$export$b691f601014eabe1(boneMatrices, size, size, $0147bee01cff6558$export$3f8bb04b555a363c, $0147bee01cff6558$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        this.boneTextureSize = size;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn("THREE.Skeleton: No bone found with UUID:", uuid);
                bone = new $0147bee01cff6558$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $0147bee01cff6558$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: "Skeleton",
                generator: "Skeleton.toJSON"
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
class $0147bee01cff6558$export$32ea87a8b54d744a extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        this.isInstancedBufferAttribute = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $0147bee01cff6558$var$_instanceLocalMatrix = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_instanceWorldMatrix = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_instanceIntersects = [];
const $0147bee01cff6558$var$_box3 = /*@__PURE__*/ new $0147bee01cff6558$export$6f7d5a9418ab2aa3();
const $0147bee01cff6558$var$_identity = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_mesh = /*@__PURE__*/ new $0147bee01cff6558$export$e176487c05830cc5();
const $0147bee01cff6558$var$_sphere$2 = /*@__PURE__*/ new $0147bee01cff6558$export$805e8b72413ccaba();
class $0147bee01cff6558$export$f3c979c331175ad7 extends $0147bee01cff6558$export$e176487c05830cc5 {
    constructor(geometry, material, count){
        super(geometry, material);
        this.isInstancedMesh = true;
        this.instanceMatrix = new $0147bee01cff6558$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.count = count;
        this.boundingBox = null;
        this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $0147bee01cff6558$var$_identity);
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $0147bee01cff6558$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $0147bee01cff6558$var$_instanceLocalMatrix);
            $0147bee01cff6558$var$_box3.copy(geometry.boundingBox).applyMatrix4($0147bee01cff6558$var$_instanceLocalMatrix);
            this.boundingBox.union($0147bee01cff6558$var$_box3);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $0147bee01cff6558$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $0147bee01cff6558$var$_instanceLocalMatrix);
            $0147bee01cff6558$var$_sphere$2.copy(geometry.boundingSphere).applyMatrix4($0147bee01cff6558$var$_instanceLocalMatrix);
            this.boundingSphere.union($0147bee01cff6558$var$_sphere$2);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $0147bee01cff6558$var$_mesh.geometry = this.geometry;
        $0147bee01cff6558$var$_mesh.material = this.material;
        if ($0147bee01cff6558$var$_mesh.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $0147bee01cff6558$var$_sphere$2.copy(this.boundingSphere);
        $0147bee01cff6558$var$_sphere$2.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($0147bee01cff6558$var$_sphere$2) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $0147bee01cff6558$var$_instanceLocalMatrix);
            $0147bee01cff6558$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $0147bee01cff6558$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $0147bee01cff6558$var$_mesh.matrixWorld = $0147bee01cff6558$var$_instanceWorldMatrix;
            $0147bee01cff6558$var$_mesh.raycast(raycaster, $0147bee01cff6558$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $0147bee01cff6558$var$_instanceIntersects.length; i < l; i++){
                const intersect = $0147bee01cff6558$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $0147bee01cff6558$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $0147bee01cff6558$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $0147bee01cff6558$export$fbaaa33907730a0c extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isLineBasicMaterial = true;
        this.type = "LineBasicMaterial";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.linewidth = 1;
        this.linecap = "round";
        this.linejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $0147bee01cff6558$var$_start$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_end$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_inverseMatrix$1 = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_ray$1 = /*@__PURE__*/ new $0147bee01cff6558$export$a186db52eed6d40e();
const $0147bee01cff6558$var$_sphere$1 = /*@__PURE__*/ new $0147bee01cff6558$export$805e8b72413ccaba();
class $0147bee01cff6558$export$17d680238e50603e extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(geometry = new $0147bee01cff6558$export$b7be63a67df8959(), material = new $0147bee01cff6558$export$fbaaa33907730a0c()){
        super();
        this.isLine = true;
        this.type = "Line";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $0147bee01cff6558$var$_start$1.fromBufferAttribute(positionAttribute, i - 1);
                $0147bee01cff6558$var$_end$1.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $0147bee01cff6558$var$_start$1.distanceTo($0147bee01cff6558$var$_end$1);
            }
            geometry.setAttribute("lineDistance", new $0147bee01cff6558$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $0147bee01cff6558$var$_sphere$1.copy(geometry.boundingSphere);
        $0147bee01cff6558$var$_sphere$1.applyMatrix4(matrixWorld);
        $0147bee01cff6558$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($0147bee01cff6558$var$_sphere$1) === false) return;
        //
        $0147bee01cff6558$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $0147bee01cff6558$var$_ray$1.copy(raycaster.ray).applyMatrix4($0147bee01cff6558$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const vStart = new $0147bee01cff6558$export$64b5c384219d3699();
        const vEnd = new $0147bee01cff6558$export$64b5c384219d3699();
        const interSegment = new $0147bee01cff6558$export$64b5c384219d3699();
        const interRay = new $0147bee01cff6558$export$64b5c384219d3699();
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                vStart.fromBufferAttribute(positionAttribute, a);
                vEnd.fromBufferAttribute(positionAttribute, b);
                const distSq = $0147bee01cff6558$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                vStart.fromBufferAttribute(positionAttribute, i);
                vEnd.fromBufferAttribute(positionAttribute, i + 1);
                const distSq = $0147bee01cff6558$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
const $0147bee01cff6558$var$_start = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_end = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$ff1ed10fedfdd604 extends $0147bee01cff6558$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineSegments = true;
        this.type = "LineSegments";
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $0147bee01cff6558$var$_start.fromBufferAttribute(positionAttribute, i);
                $0147bee01cff6558$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $0147bee01cff6558$var$_start.distanceTo($0147bee01cff6558$var$_end);
            }
            geometry.setAttribute("lineDistance", new $0147bee01cff6558$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
}
class $0147bee01cff6558$export$f85a24d745e4f17d extends $0147bee01cff6558$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineLoop = true;
        this.type = "LineLoop";
    }
}
class $0147bee01cff6558$export$a178c45366ce5d6b extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isPointsMaterial = true;
        this.type = "PointsMaterial";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $0147bee01cff6558$var$_inverseMatrix = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_ray = /*@__PURE__*/ new $0147bee01cff6558$export$a186db52eed6d40e();
const $0147bee01cff6558$var$_sphere = /*@__PURE__*/ new $0147bee01cff6558$export$805e8b72413ccaba();
const $0147bee01cff6558$var$_position$2 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$1c787534cb11aa3e extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(geometry = new $0147bee01cff6558$export$b7be63a67df8959(), material = new $0147bee01cff6558$export$a178c45366ce5d6b()){
        super();
        this.isPoints = true;
        this.type = "Points";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $0147bee01cff6558$var$_sphere.copy(geometry.boundingSphere);
        $0147bee01cff6558$var$_sphere.applyMatrix4(matrixWorld);
        $0147bee01cff6558$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($0147bee01cff6558$var$_sphere) === false) return;
        //
        $0147bee01cff6558$var$_inverseMatrix.copy(matrixWorld).invert();
        $0147bee01cff6558$var$_ray.copy(raycaster.ray).applyMatrix4($0147bee01cff6558$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $0147bee01cff6558$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $0147bee01cff6558$var$testPoint($0147bee01cff6558$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $0147bee01cff6558$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $0147bee01cff6558$var$testPoint($0147bee01cff6558$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $0147bee01cff6558$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $0147bee01cff6558$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $0147bee01cff6558$export$64b5c384219d3699();
        $0147bee01cff6558$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
class $0147bee01cff6558$export$6e09d1edf8d5a25c extends $0147bee01cff6558$export$5431306cf43de24a {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isVideoTexture = true;
        this.minFilter = minFilter !== undefined ? minFilter : $0147bee01cff6558$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $0147bee01cff6558$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ("requestVideoFrameCallback" in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = "requestVideoFrameCallback" in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
class $0147bee01cff6558$export$9270d786f73ce6fe extends $0147bee01cff6558$export$5431306cf43de24a {
    constructor(width, height){
        super({
            width: width,
            height: height
        });
        this.isFramebufferTexture = true;
        this.magFilter = $0147bee01cff6558$export$727aa5ec3fe39bf0;
        this.minFilter = $0147bee01cff6558$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
class $0147bee01cff6558$export$3466bac9141a5cc4 extends $0147bee01cff6558$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCompressedTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
class $0147bee01cff6558$export$5fe6b8e34b274fcb extends $0147bee01cff6558$export$3466bac9141a5cc4 {
    constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        this.isCompressedArrayTexture = true;
        this.image.depth = depth;
        this.wrapR = $0147bee01cff6558$export$9d9334239a5a5e06;
    }
}
class $0147bee01cff6558$export$d80173634de65bff extends $0147bee01cff6558$export$3466bac9141a5cc4 {
    constructor(images, format, type){
        super(undefined, images[0].width, images[0].height, format, type, $0147bee01cff6558$export$8759762a6477f2c4);
        this.isCompressedCubeTexture = true;
        this.isCubeTexture = true;
        this.image = images;
    }
}
class $0147bee01cff6558$export$f7189e49152d1c13 extends $0147bee01cff6558$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(){
        this.type = "Curve";
        this.arcLengthDivisions = 200;
    }
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn("THREE.Curve: .getPoint() not implemented.");
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $0147bee01cff6558$export$c977b3e384af9ae1() : new $0147bee01cff6558$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $0147bee01cff6558$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $0147bee01cff6558$export$64b5c384219d3699();
        const mat = new $0147bee01cff6558$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $0147bee01cff6558$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $0147bee01cff6558$export$64b5c384219d3699();
        binormals[0] = new $0147bee01cff6558$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($0147bee01cff6558$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($0147bee01cff6558$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: "Curve",
                generator: "Curve.toJSON"
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
class $0147bee01cff6558$export$3f87a931616cde04 extends $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.isEllipseCurve = true;
        this.type = "EllipseCurve";
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
    getPoint(t, optionalTarget) {
        const point = optionalTarget || new $0147bee01cff6558$export$c977b3e384af9ae1();
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
class $0147bee01cff6558$export$b1eedc9aab6300e8 extends $0147bee01cff6558$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.isArcCurve = true;
        this.type = "ArcCurve";
    }
}
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $0147bee01cff6558$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $0147bee01cff6558$var$tmp = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$px = /*@__PURE__*/ new $0147bee01cff6558$var$CubicPoly();
const $0147bee01cff6558$var$py = /*@__PURE__*/ new $0147bee01cff6558$var$CubicPoly();
const $0147bee01cff6558$var$pz = /*@__PURE__*/ new $0147bee01cff6558$var$CubicPoly();
class $0147bee01cff6558$export$b9146b27c24b744c extends $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(points = [], closed = false, curveType = "centripetal", tension = 0.5){
        super();
        this.isCatmullRomCurve3 = true;
        this.type = "CatmullRomCurve3";
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
    getPoint(t, optionalTarget = new $0147bee01cff6558$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $0147bee01cff6558$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $0147bee01cff6558$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $0147bee01cff6558$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $0147bee01cff6558$var$tmp;
        }
        if (this.curveType === "centripetal" || this.curveType === "chordal") {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === "chordal" ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $0147bee01cff6558$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $0147bee01cff6558$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $0147bee01cff6558$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === "catmullrom") {
            $0147bee01cff6558$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $0147bee01cff6558$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $0147bee01cff6558$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($0147bee01cff6558$var$px.calc(weight), $0147bee01cff6558$var$py.calc(weight), $0147bee01cff6558$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $0147bee01cff6558$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */ function $0147bee01cff6558$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $0147bee01cff6558$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $0147bee01cff6558$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $0147bee01cff6558$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $0147bee01cff6558$var$QuadraticBezier(t, p0, p1, p2) {
    return $0147bee01cff6558$var$QuadraticBezierP0(t, p0) + $0147bee01cff6558$var$QuadraticBezierP1(t, p1) + $0147bee01cff6558$var$QuadraticBezierP2(t, p2);
}
//
function $0147bee01cff6558$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $0147bee01cff6558$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $0147bee01cff6558$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $0147bee01cff6558$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $0147bee01cff6558$var$CubicBezier(t, p0, p1, p2, p3) {
    return $0147bee01cff6558$var$CubicBezierP0(t, p0) + $0147bee01cff6558$var$CubicBezierP1(t, p1) + $0147bee01cff6558$var$CubicBezierP2(t, p2) + $0147bee01cff6558$var$CubicBezierP3(t, p3);
}
class $0147bee01cff6558$export$e36650d36468bb39 extends $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $0147bee01cff6558$export$c977b3e384af9ae1(), v1 = new $0147bee01cff6558$export$c977b3e384af9ae1(), v2 = new $0147bee01cff6558$export$c977b3e384af9ae1(), v3 = new $0147bee01cff6558$export$c977b3e384af9ae1()){
        super();
        this.isCubicBezierCurve = true;
        this.type = "CubicBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $0147bee01cff6558$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($0147bee01cff6558$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $0147bee01cff6558$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $0147bee01cff6558$export$13d5f1c9525f246c extends $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $0147bee01cff6558$export$64b5c384219d3699(), v1 = new $0147bee01cff6558$export$64b5c384219d3699(), v2 = new $0147bee01cff6558$export$64b5c384219d3699(), v3 = new $0147bee01cff6558$export$64b5c384219d3699()){
        super();
        this.isCubicBezierCurve3 = true;
        this.type = "CubicBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $0147bee01cff6558$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($0147bee01cff6558$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $0147bee01cff6558$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $0147bee01cff6558$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $0147bee01cff6558$export$ab2e07e76531a47e extends $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $0147bee01cff6558$export$c977b3e384af9ae1(), v2 = new $0147bee01cff6558$export$c977b3e384af9ae1()){
        super();
        this.isLineCurve = true;
        this.type = "LineCurve";
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $0147bee01cff6558$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $0147bee01cff6558$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $0147bee01cff6558$export$1fdfd9d9cf487600 extends $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $0147bee01cff6558$export$64b5c384219d3699(), v2 = new $0147bee01cff6558$export$64b5c384219d3699()){
        super();
        this.isLineCurve3 = true;
        this.type = "LineCurve3";
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $0147bee01cff6558$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $0147bee01cff6558$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $0147bee01cff6558$export$5938c4ee491a43ad extends $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $0147bee01cff6558$export$c977b3e384af9ae1(), v1 = new $0147bee01cff6558$export$c977b3e384af9ae1(), v2 = new $0147bee01cff6558$export$c977b3e384af9ae1()){
        super();
        this.isQuadraticBezierCurve = true;
        this.type = "QuadraticBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $0147bee01cff6558$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($0147bee01cff6558$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $0147bee01cff6558$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $0147bee01cff6558$export$bf3f4c7e459f90fc extends $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $0147bee01cff6558$export$64b5c384219d3699(), v1 = new $0147bee01cff6558$export$64b5c384219d3699(), v2 = new $0147bee01cff6558$export$64b5c384219d3699()){
        super();
        this.isQuadraticBezierCurve3 = true;
        this.type = "QuadraticBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $0147bee01cff6558$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($0147bee01cff6558$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $0147bee01cff6558$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $0147bee01cff6558$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $0147bee01cff6558$export$d3bdd77da77afc1b extends $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(points = []){
        super();
        this.isSplineCurve = true;
        this.type = "SplineCurve";
        this.points = points;
    }
    getPoint(t, optionalTarget = new $0147bee01cff6558$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($0147bee01cff6558$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $0147bee01cff6558$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $0147bee01cff6558$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $0147bee01cff6558$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $0147bee01cff6558$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $0147bee01cff6558$export$b9146b27c24b744c,
    CubicBezierCurve: $0147bee01cff6558$export$e36650d36468bb39,
    CubicBezierCurve3: $0147bee01cff6558$export$13d5f1c9525f246c,
    EllipseCurve: $0147bee01cff6558$export$3f87a931616cde04,
    LineCurve: $0147bee01cff6558$export$ab2e07e76531a47e,
    LineCurve3: $0147bee01cff6558$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $0147bee01cff6558$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $0147bee01cff6558$export$bf3f4c7e459f90fc,
    SplineCurve: $0147bee01cff6558$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $0147bee01cff6558$export$4aaf9b66af1bbf2c extends $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(){
        super();
        this.type = "CurvePath";
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) this.curves.push(new $0147bee01cff6558$export$ab2e07e76531a47e(endPoint, startPoint));
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t, optionalTarget) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $0147bee01cff6558$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
class $0147bee01cff6558$export$4b2950bdac9b6ee9 extends $0147bee01cff6558$export$4aaf9b66af1bbf2c {
    constructor(points){
        super();
        this.type = "Path";
        this.currentPoint = new $0147bee01cff6558$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $0147bee01cff6558$export$ab2e07e76531a47e(this.currentPoint.clone(), new $0147bee01cff6558$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $0147bee01cff6558$export$5938c4ee491a43ad(this.currentPoint.clone(), new $0147bee01cff6558$export$c977b3e384af9ae1(aCPx, aCPy), new $0147bee01cff6558$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $0147bee01cff6558$export$e36650d36468bb39(this.currentPoint.clone(), new $0147bee01cff6558$export$c977b3e384af9ae1(aCP1x, aCP1y), new $0147bee01cff6558$export$c977b3e384af9ae1(aCP2x, aCP2y), new $0147bee01cff6558$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $0147bee01cff6558$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $0147bee01cff6558$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
class $0147bee01cff6558$export$6d839803fcd1882c extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(points = [
        new $0147bee01cff6558$export$c977b3e384af9ae1(0, -0.5),
        new $0147bee01cff6558$export$c977b3e384af9ae1(0.5, 0),
        new $0147bee01cff6558$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = "LatheGeometry";
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $0147bee01cff6558$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
        const uv = new $0147bee01cff6558$export$c977b3e384af9ae1();
        const normal = new $0147bee01cff6558$export$64b5c384219d3699();
        const curNormal = new $0147bee01cff6558$export$64b5c384219d3699();
        const prevNormal = new $0147bee01cff6558$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
class $0147bee01cff6558$export$41680e8551036033 extends $0147bee01cff6558$export$6d839803fcd1882c {
    constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8){
        const path = new $0147bee01cff6558$export$4b2950bdac9b6ee9();
        path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
        path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
        super(path.getPoints(capSegments), radialSegments);
        this.type = "CapsuleGeometry";
        this.parameters = {
            radius: radius,
            length: length,
            capSegments: capSegments,
            radialSegments: radialSegments
        };
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$41680e8551036033(data.radius, data.length, data.capSegments, data.radialSegments);
    }
}
class $0147bee01cff6558$export$d5c0e8d607467193 extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CircleGeometry";
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
        const uv = new $0147bee01cff6558$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
class $0147bee01cff6558$export$68f745719dbe5198 extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CylinderGeometry";
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $0147bee01cff6558$export$64b5c384219d3699();
            const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $0147bee01cff6558$export$c977b3e384af9ae1();
            const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $0147bee01cff6558$export$a7a48974f285c9b3 extends $0147bee01cff6558$export$68f745719dbe5198 {
    constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = "ConeGeometry";
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $0147bee01cff6558$export$60e57a7d3f20ff65 extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = "PolyhedronGeometry";
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $0147bee01cff6558$export$64b5c384219d3699();
            const b = new $0147bee01cff6558$export$64b5c384219d3699();
            const c = new $0147bee01cff6558$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $0147bee01cff6558$export$64b5c384219d3699();
            const b = new $0147bee01cff6558$export$64b5c384219d3699();
            const c = new $0147bee01cff6558$export$64b5c384219d3699();
            const centroid = new $0147bee01cff6558$export$64b5c384219d3699();
            const uvA = new $0147bee01cff6558$export$c977b3e384af9ae1();
            const uvB = new $0147bee01cff6558$export$c977b3e384af9ae1();
            const uvC = new $0147bee01cff6558$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.details);
    }
}
class $0147bee01cff6558$export$c0babfeb8708fc9c extends $0147bee01cff6558$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = "DodecahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
}
const $0147bee01cff6558$var$_v0 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_v1$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_normal = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_triangle = /*@__PURE__*/ new $0147bee01cff6558$export$5a465592bfe74b48();
class $0147bee01cff6558$export$4730b1542707547f extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = "EdgesGeometry";
        this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($0147bee01cff6558$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute("position");
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                "a",
                "b",
                "c"
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $0147bee01cff6558$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $0147bee01cff6558$var$_triangle.getNormal($0147bee01cff6558$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $0147bee01cff6558$var$_triangle[vertKeys[j]];
                    const v1 = $0147bee01cff6558$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($0147bee01cff6558$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $0147bee01cff6558$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $0147bee01cff6558$var$_v0.fromBufferAttribute(positionAttr, index0);
                $0147bee01cff6558$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($0147bee01cff6558$var$_v0.x, $0147bee01cff6558$var$_v0.y, $0147bee01cff6558$var$_v0.z);
                vertices.push($0147bee01cff6558$var$_v1$1.x, $0147bee01cff6558$var$_v1$1.y, $0147bee01cff6558$var$_v1$1.z);
            }
            this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
class $0147bee01cff6558$export$6428a7f2611ef1fa extends $0147bee01cff6558$export$4b2950bdac9b6ee9 {
    constructor(points){
        super(points);
        this.uuid = $0147bee01cff6558$var$generateUUID();
        this.type = "Shape";
        this.holes = [];
    }
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $0147bee01cff6558$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.4)
 */ const $0147bee01cff6558$var$Earcut = {
    triangulate: function(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $0147bee01cff6558$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $0147bee01cff6558$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 32767 / invSize : 0;
        }
        $0147bee01cff6558$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $0147bee01cff6558$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $0147bee01cff6558$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $0147bee01cff6558$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $0147bee01cff6558$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $0147bee01cff6558$var$equals(last, last.next)) {
        $0147bee01cff6558$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $0147bee01cff6558$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($0147bee01cff6558$var$equals(p, p.next) || $0147bee01cff6558$var$area(p.prev, p, p.next) === 0)) {
            $0147bee01cff6558$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $0147bee01cff6558$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $0147bee01cff6558$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $0147bee01cff6558$var$isEarHashed(ear, minX, minY, invSize) : $0147bee01cff6558$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $0147bee01cff6558$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $0147bee01cff6558$var$earcutLinked($0147bee01cff6558$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $0147bee01cff6558$var$cureLocalIntersections($0147bee01cff6558$var$filterPoints(ear), triangles, dim);
                $0147bee01cff6558$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $0147bee01cff6558$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $0147bee01cff6558$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($0147bee01cff6558$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $0147bee01cff6558$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $0147bee01cff6558$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $0147bee01cff6558$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($0147bee01cff6558$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    const minZ = $0147bee01cff6558$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $0147bee01cff6558$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $0147bee01cff6558$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $0147bee01cff6558$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $0147bee01cff6558$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $0147bee01cff6558$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $0147bee01cff6558$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $0147bee01cff6558$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $0147bee01cff6558$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $0147bee01cff6558$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $0147bee01cff6558$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$0147bee01cff6558$var$equals(a, b) && $0147bee01cff6558$var$intersects(a, p, p.next, b) && $0147bee01cff6558$var$locallyInside(a, b) && $0147bee01cff6558$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $0147bee01cff6558$var$removeNode(p);
            $0147bee01cff6558$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $0147bee01cff6558$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $0147bee01cff6558$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $0147bee01cff6558$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $0147bee01cff6558$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $0147bee01cff6558$var$filterPoints(a, a.next);
                c = $0147bee01cff6558$var$filterPoints(c, c.next);
                // run earcut on each half
                $0147bee01cff6558$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $0147bee01cff6558$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $0147bee01cff6558$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $0147bee01cff6558$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($0147bee01cff6558$var$getLeftmost(list));
    }
    queue.sort($0147bee01cff6558$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $0147bee01cff6558$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $0147bee01cff6558$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $0147bee01cff6558$var$eliminateHole(hole, outerNode) {
    const bridge = $0147bee01cff6558$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $0147bee01cff6558$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $0147bee01cff6558$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $0147bee01cff6558$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $0147bee01cff6558$var$findHoleBridge(hole, outerNode) {
    let p = outerNode, qx = -Infinity, m;
    const hx = hole.x, hy = hole.y;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $0147bee01cff6558$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($0147bee01cff6558$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $0147bee01cff6558$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $0147bee01cff6558$var$sectorContainsSector(m, p) {
    return $0147bee01cff6558$var$area(m.prev, m, p.prev) < 0 && $0147bee01cff6558$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $0147bee01cff6558$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $0147bee01cff6558$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $0147bee01cff6558$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $0147bee01cff6558$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $0147bee01cff6558$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $0147bee01cff6558$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $0147bee01cff6558$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $0147bee01cff6558$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$0147bee01cff6558$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($0147bee01cff6558$var$locallyInside(a, b) && $0147bee01cff6558$var$locallyInside(b, a) && $0147bee01cff6558$var$middleInside(a, b) && // locally visible
    ($0147bee01cff6558$var$area(a.prev, a, b.prev) || $0147bee01cff6558$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $0147bee01cff6558$var$equals(a, b) && $0147bee01cff6558$var$area(a.prev, a, a.next) > 0 && $0147bee01cff6558$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $0147bee01cff6558$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $0147bee01cff6558$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $0147bee01cff6558$var$intersects(p1, q1, p2, q2) {
    const o1 = $0147bee01cff6558$var$sign($0147bee01cff6558$var$area(p1, q1, p2));
    const o2 = $0147bee01cff6558$var$sign($0147bee01cff6558$var$area(p1, q1, q2));
    const o3 = $0147bee01cff6558$var$sign($0147bee01cff6558$var$area(p2, q2, p1));
    const o4 = $0147bee01cff6558$var$sign($0147bee01cff6558$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $0147bee01cff6558$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $0147bee01cff6558$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $0147bee01cff6558$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $0147bee01cff6558$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $0147bee01cff6558$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $0147bee01cff6558$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $0147bee01cff6558$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $0147bee01cff6558$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $0147bee01cff6558$var$locallyInside(a, b) {
    return $0147bee01cff6558$var$area(a.prev, a, a.next) < 0 ? $0147bee01cff6558$var$area(a, b, a.next) >= 0 && $0147bee01cff6558$var$area(a, a.prev, b) >= 0 : $0147bee01cff6558$var$area(a, b, a.prev) < 0 || $0147bee01cff6558$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $0147bee01cff6558$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $0147bee01cff6558$var$splitPolygon(a, b) {
    const a2 = new $0147bee01cff6558$var$Node(a.i, a.x, a.y), b2 = new $0147bee01cff6558$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $0147bee01cff6558$var$insertNode(i, x, y, last) {
    const p = new $0147bee01cff6558$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $0147bee01cff6558$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $0147bee01cff6558$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $0147bee01cff6558$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $0147bee01cff6558$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $0147bee01cff6558$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $0147bee01cff6558$var$removeDupEndPts(contour);
        $0147bee01cff6558$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($0147bee01cff6558$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $0147bee01cff6558$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $0147bee01cff6558$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $0147bee01cff6558$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $0147bee01cff6558$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $0147bee01cff6558$export$598697a1efa63ca7 extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(shapes = new $0147bee01cff6558$export$6428a7f2611ef1fa([
        new $0147bee01cff6558$export$c977b3e384af9ae1(0.5, 0.5),
        new $0147bee01cff6558$export$c977b3e384af9ae1(-0.5, 0.5),
        new $0147bee01cff6558$export$c977b3e384af9ae1(-0.5, -0.5),
        new $0147bee01cff6558$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = "ExtrudeGeometry";
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $0147bee01cff6558$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $0147bee01cff6558$export$64b5c384219d3699();
                normal = new $0147bee01cff6558$export$64b5c384219d3699();
                position2 = new $0147bee01cff6558$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$0147bee01cff6558$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($0147bee01cff6558$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $0147bee01cff6558$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error("THREE.ExtrudeGeometry: vec does not exist");
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $0147bee01cff6558$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $0147bee01cff6558$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $0147bee01cff6558$var$toJSON$1(shapes, options, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $0147bee01cff6558$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $0147bee01cff6558$export$598697a1efa63ca7(geometryShapes, data.options);
    }
}
const $0147bee01cff6558$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $0147bee01cff6558$export$c977b3e384af9ae1(a_x, a_y),
            new $0147bee01cff6558$export$c977b3e384af9ae1(b_x, b_y),
            new $0147bee01cff6558$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $0147bee01cff6558$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $0147bee01cff6558$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $0147bee01cff6558$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $0147bee01cff6558$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $0147bee01cff6558$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $0147bee01cff6558$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $0147bee01cff6558$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $0147bee01cff6558$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $0147bee01cff6558$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $0147bee01cff6558$export$9567cc828c9535da extends $0147bee01cff6558$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "IcosahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$9567cc828c9535da(data.radius, data.detail);
    }
}
class $0147bee01cff6558$export$1954e2b809fe361e extends $0147bee01cff6558$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = "OctahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$1954e2b809fe361e(data.radius, data.detail);
    }
}
class $0147bee01cff6558$export$68cb731f50f614af extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "RingGeometry";
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
        const uv = new $0147bee01cff6558$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
class $0147bee01cff6558$export$57a29a1c803e9065 extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(shapes = new $0147bee01cff6558$export$6428a7f2611ef1fa([
        new $0147bee01cff6558$export$c977b3e384af9ae1(0, 0.5),
        new $0147bee01cff6558$export$c977b3e384af9ae1(-0.5, -0.5),
        new $0147bee01cff6558$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = "ShapeGeometry";
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($0147bee01cff6558$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($0147bee01cff6558$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $0147bee01cff6558$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $0147bee01cff6558$var$toJSON(shapes, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $0147bee01cff6558$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
}
function $0147bee01cff6558$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $0147bee01cff6558$export$1b417fc3b307a251 extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = "SphereGeometry";
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
        const normal = new $0147bee01cff6558$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
class $0147bee01cff6558$export$fb3f7adc68bd6e02 extends $0147bee01cff6558$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "TetrahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
}
class $0147bee01cff6558$export$a2312a2a1fa56495 extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2){
        super();
        this.type = "TorusGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $0147bee01cff6558$export$64b5c384219d3699();
        const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
        const normal = new $0147bee01cff6558$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
class $0147bee01cff6558$export$77e9bfadfb9ab8c8 extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = "TorusKnotGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
        const normal = new $0147bee01cff6558$export$64b5c384219d3699();
        const P1 = new $0147bee01cff6558$export$64b5c384219d3699();
        const P2 = new $0147bee01cff6558$export$64b5c384219d3699();
        const B = new $0147bee01cff6558$export$64b5c384219d3699();
        const T = new $0147bee01cff6558$export$64b5c384219d3699();
        const N = new $0147bee01cff6558$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
class $0147bee01cff6558$export$7897d9d48904490c extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(path = new $0147bee01cff6558$export$bf3f4c7e459f90fc(new $0147bee01cff6558$export$64b5c384219d3699(-1, -1, 0), new $0147bee01cff6558$export$64b5c384219d3699(-1, 1, 0), new $0147bee01cff6558$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = "TubeGeometry";
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
        const normal = new $0147bee01cff6558$export$64b5c384219d3699();
        const uv = new $0147bee01cff6558$export$c977b3e384af9ae1();
        let P = new $0147bee01cff6558$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $0147bee01cff6558$export$7897d9d48904490c(new $0147bee01cff6558$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
class $0147bee01cff6558$export$4b739da06d24892b extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(geometry = null){
        super();
        this.type = "WireframeGeometry";
        this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $0147bee01cff6558$export$64b5c384219d3699();
            const end = new $0147bee01cff6558$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($0147bee01cff6558$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($0147bee01cff6558$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
function $0147bee01cff6558$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $0147bee01cff6558$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $0147bee01cff6558$export$33e43285f7406bd5,
    CapsuleGeometry: $0147bee01cff6558$export$41680e8551036033,
    CircleGeometry: $0147bee01cff6558$export$d5c0e8d607467193,
    ConeGeometry: $0147bee01cff6558$export$a7a48974f285c9b3,
    CylinderGeometry: $0147bee01cff6558$export$68f745719dbe5198,
    DodecahedronGeometry: $0147bee01cff6558$export$c0babfeb8708fc9c,
    EdgesGeometry: $0147bee01cff6558$export$4730b1542707547f,
    ExtrudeGeometry: $0147bee01cff6558$export$598697a1efa63ca7,
    IcosahedronGeometry: $0147bee01cff6558$export$9567cc828c9535da,
    LatheGeometry: $0147bee01cff6558$export$6d839803fcd1882c,
    OctahedronGeometry: $0147bee01cff6558$export$1954e2b809fe361e,
    PlaneGeometry: $0147bee01cff6558$export$967d831af31f69ce,
    PolyhedronGeometry: $0147bee01cff6558$export$60e57a7d3f20ff65,
    RingGeometry: $0147bee01cff6558$export$68cb731f50f614af,
    ShapeGeometry: $0147bee01cff6558$export$57a29a1c803e9065,
    SphereGeometry: $0147bee01cff6558$export$1b417fc3b307a251,
    TetrahedronGeometry: $0147bee01cff6558$export$fb3f7adc68bd6e02,
    TorusGeometry: $0147bee01cff6558$export$a2312a2a1fa56495,
    TorusKnotGeometry: $0147bee01cff6558$export$77e9bfadfb9ab8c8,
    TubeGeometry: $0147bee01cff6558$export$7897d9d48904490c,
    WireframeGeometry: $0147bee01cff6558$export$4b739da06d24892b
});
class $0147bee01cff6558$export$e8564da406055a3 extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShadowMaterial = true;
        this.type = "ShadowMaterial";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
class $0147bee01cff6558$export$21c421a2e1df9d22 extends $0147bee01cff6558$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.isRawShaderMaterial = true;
        this.type = "RawShaderMaterial";
    }
}
class $0147bee01cff6558$export$f2980790215acccd extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshStandardMaterial = true;
        this.defines = {
            "STANDARD": ""
        };
        this.type = "MeshStandardMaterial";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $0147bee01cff6558$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0147bee01cff6558$export$2852a58ebdac27b8;
        this.normalScale = new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapIntensity = 1.0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": ""
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $0147bee01cff6558$export$28d04986c4269c9f extends $0147bee01cff6558$export$f2980790215acccd {
    constructor(parameters){
        super();
        this.isMeshPhysicalMaterial = true;
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.type = "MeshPhysicalMaterial";
        this.anisotropyRotation = 0;
        this.anisotropyMap = null;
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, "reflectivity", {
            get: function() {
                return $0147bee01cff6558$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.iridescenceMap = null;
        this.iridescenceIOR = 1.3;
        this.iridescenceThicknessRange = [
            100,
            400
        ];
        this.iridescenceThicknessMap = null;
        this.sheenColor = new $0147bee01cff6558$export$892596cec99bc70e(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = Infinity;
        this.attenuationColor = new $0147bee01cff6558$export$892596cec99bc70e(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new $0147bee01cff6558$export$892596cec99bc70e(1, 1, 1);
        this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
class $0147bee01cff6558$export$24c72f71cbaf0678 extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshPhongMaterial = true;
        this.type = "MeshPhongMaterial";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $0147bee01cff6558$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $0147bee01cff6558$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0147bee01cff6558$export$2852a58ebdac27b8;
        this.normalScale = new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $0147bee01cff6558$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $0147bee01cff6558$export$df893cf97e765622 extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshToonMaterial = true;
        this.defines = {
            "TOON": ""
        };
        this.type = "MeshToonMaterial";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $0147bee01cff6558$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0147bee01cff6558$export$2852a58ebdac27b8;
        this.normalScale = new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
class $0147bee01cff6558$export$bfe8c0a091f41ae7 extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshNormalMaterial = true;
        this.type = "MeshNormalMaterial";
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0147bee01cff6558$export$2852a58ebdac27b8;
        this.normalScale = new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
class $0147bee01cff6558$export$5023a9a8114806b8 extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshLambertMaterial = true;
        this.type = "MeshLambertMaterial";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $0147bee01cff6558$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0147bee01cff6558$export$2852a58ebdac27b8;
        this.normalScale = new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $0147bee01cff6558$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $0147bee01cff6558$export$6f5fef6235ec12ee extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshMatcapMaterial = true;
        this.defines = {
            "MATCAP": ""
        };
        this.type = "MeshMatcapMaterial";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0147bee01cff6558$export$2852a58ebdac27b8;
        this.normalScale = new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "MATCAP": ""
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $0147bee01cff6558$export$327886a3efaeaebe extends $0147bee01cff6558$export$fbaaa33907730a0c {
    constructor(parameters){
        super();
        this.isLineDashedMaterial = true;
        this.type = "LineDashedMaterial";
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
// same as Array.prototype.slice, but also works on typed arrays
function $0147bee01cff6558$var$arraySlice(array, from, to) {
    if ($0147bee01cff6558$var$isTypedArray(array)) // in ios9 array.subarray(from, undefined) will return empty array
    // but array.subarray(from) or array.subarray(from, len) is correct
    return new array.constructor(array.subarray(from, to !== undefined ? to : array.length));
    return array.slice(from, to);
}
// converts an array to a specific type
function $0147bee01cff6558$var$convertArray(array, type, forceClone) {
    if (!array || // let 'undefined' and 'null' pass
    !forceClone && array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === "number") return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
function $0147bee01cff6558$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
// returns an array by which times and values can be sorted
function $0147bee01cff6558$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
// uses the array previously returned by 'getKeyframeOrder' to sort data
function $0147bee01cff6558$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
// function for parsing AOS keyframe formats
function $0147bee01cff6558$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push.apply(values, value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
function $0147bee01cff6558$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $0147bee01cff6558$var$convertArray(times, track.times.constructor);
        track.values = $0147bee01cff6558$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
function $0147bee01cff6558$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === "bool" || referenceTrackType === "string") continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = $0147bee01cff6558$var$arraySlice(referenceTrack.values, startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = $0147bee01cff6558$var$arraySlice(referenceTrack.values, startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = $0147bee01cff6558$var$arraySlice(interpolant.resultBuffer, startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === "quaternion") {
            const referenceQuat = new $0147bee01cff6558$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === "quaternion") // Multiply the conjugate for quaternion track types
            $0147bee01cff6558$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $0147bee01cff6558$export$d875e029ef558d3;
    return targetClip;
}
const $0147bee01cff6558$export$7ee8caa573e71ad1 = {
    arraySlice: $0147bee01cff6558$var$arraySlice,
    convertArray: $0147bee01cff6558$var$convertArray,
    isTypedArray: $0147bee01cff6558$var$isTypedArray,
    getKeyframeOrder: $0147bee01cff6558$var$getKeyframeOrder,
    sortedArray: $0147bee01cff6558$var$sortedArray,
    flattenJSON: $0147bee01cff6558$var$flattenJSON,
    subclip: $0147bee01cff6558$var$subclip,
    makeClipAdditive: $0147bee01cff6558$var$makeClipAdditive
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $0147bee01cff6558$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error("call to abstract method");
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $0147bee01cff6558$export$3646682e7a3959 extends $0147bee01cff6558$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $0147bee01cff6558$export$7f795934b84ab523,
            endingEnd: $0147bee01cff6558$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $0147bee01cff6558$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $0147bee01cff6558$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $0147bee01cff6558$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $0147bee01cff6558$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
class $0147bee01cff6558$export$a8e6009059f51e1a extends $0147bee01cff6558$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */ class $0147bee01cff6558$export$fb9758ef7ef8d5cc extends $0147bee01cff6558$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
class $0147bee01cff6558$export$b0e479f45b7006d6 {
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error("THREE.KeyframeTrack: track name is undefined");
        if (times === undefined || times.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + name);
        this.name = name;
        this.times = $0147bee01cff6558$var$convertArray(times, this.TimeBufferType);
        this.values = $0147bee01cff6558$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                "name": track.name,
                "times": $0147bee01cff6558$var$convertArray(track.times, Array),
                "values": $0147bee01cff6558$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $0147bee01cff6558$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $0147bee01cff6558$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $0147bee01cff6558$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $0147bee01cff6558$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $0147bee01cff6558$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $0147bee01cff6558$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn("THREE.KeyframeTrack:", message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $0147bee01cff6558$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $0147bee01cff6558$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $0147bee01cff6558$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = $0147bee01cff6558$var$arraySlice(times, from, to);
            this.values = $0147bee01cff6558$var$arraySlice(this.values, from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error("THREE.KeyframeTrack: Invalid value size in track.", this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error("THREE.KeyframeTrack: Track is empty.", this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === "number" && isNaN(currTime)) {
                console.error("THREE.KeyframeTrack: Time is not a valid number.", this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error("THREE.KeyframeTrack: Out of order keys.", this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($0147bee01cff6558$var$isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error("THREE.KeyframeTrack: Value is not a valid number.", this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = $0147bee01cff6558$var$arraySlice(this.times), values = $0147bee01cff6558$var$arraySlice(this.values), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $0147bee01cff6558$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = $0147bee01cff6558$var$arraySlice(times, 0, writeIndex);
            this.values = $0147bee01cff6558$var$arraySlice(values, 0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = $0147bee01cff6558$var$arraySlice(this.times, 0);
        const values = $0147bee01cff6558$var$arraySlice(this.values, 0);
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
$0147bee01cff6558$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$0147bee01cff6558$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$0147bee01cff6558$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $0147bee01cff6558$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $0147bee01cff6558$export$d3a344b98cf0b775 extends $0147bee01cff6558$export$b0e479f45b7006d6 {
}
$0147bee01cff6558$export$d3a344b98cf0b775.prototype.ValueTypeName = "bool";
$0147bee01cff6558$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$0147bee01cff6558$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $0147bee01cff6558$export$995b32462a65e855;
$0147bee01cff6558$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$0147bee01cff6558$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $0147bee01cff6558$export$83444c5d885347d8 extends $0147bee01cff6558$export$b0e479f45b7006d6 {
}
$0147bee01cff6558$export$83444c5d885347d8.prototype.ValueTypeName = "color";
/**
 * A Track of numeric keyframe values.
 */ class $0147bee01cff6558$export$d45f0d1a4d9a9314 extends $0147bee01cff6558$export$b0e479f45b7006d6 {
}
$0147bee01cff6558$export$d45f0d1a4d9a9314.prototype.ValueTypeName = "number";
/**
 * Spherical linear unit quaternion interpolant.
 */ class $0147bee01cff6558$export$2db1cfb7923d931e extends $0147bee01cff6558$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$0147bee01cff6558$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $0147bee01cff6558$export$b8043f12b5aafbd7 extends $0147bee01cff6558$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $0147bee01cff6558$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$0147bee01cff6558$export$b8043f12b5aafbd7.prototype.ValueTypeName = "quaternion";
// ValueBufferType is inherited
$0147bee01cff6558$export$b8043f12b5aafbd7.prototype.DefaultInterpolation = $0147bee01cff6558$export$30fac1aace31cf4d;
$0147bee01cff6558$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $0147bee01cff6558$export$6ce41d4f3a8df9cd extends $0147bee01cff6558$export$b0e479f45b7006d6 {
}
$0147bee01cff6558$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = "string";
$0147bee01cff6558$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$0147bee01cff6558$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $0147bee01cff6558$export$995b32462a65e855;
$0147bee01cff6558$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$0147bee01cff6558$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $0147bee01cff6558$export$5ce2dcb4cc9f2bff extends $0147bee01cff6558$export$b0e479f45b7006d6 {
}
$0147bee01cff6558$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = "vector";
class $0147bee01cff6558$export$d942c706bf23829c {
    constructor(name, duration = -1, tracks, blendMode = $0147bee01cff6558$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $0147bee01cff6558$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($0147bee01cff6558$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            "name": clip.name,
            "duration": clip.duration,
            "tracks": tracks,
            "uuid": clip.uuid,
            "blendMode": clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($0147bee01cff6558$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $0147bee01cff6558$var$getKeyframeOrder(times);
            times = $0147bee01cff6558$var$sortedArray(times, 1, order);
            values = $0147bee01cff6558$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $0147bee01cff6558$export$d45f0d1a4d9a9314(".morphTargetInfluences[" + morphTargetSequence[i].name + "]", times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error("THREE.AnimationClip: No animation in JSONLoader data.");
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $0147bee01cff6558$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || "default";
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $0147bee01cff6558$export$d45f0d1a4d9a9314(".morphTargetInfluence[" + morphTargetName + "]", times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = ".bones[" + bones[h].name + "]";
                addNonemptyTrack($0147bee01cff6558$export$5ce2dcb4cc9f2bff, boneName + ".position", animationKeys, "pos", tracks);
                addNonemptyTrack($0147bee01cff6558$export$b8043f12b5aafbd7, boneName + ".quaternion", animationKeys, "rot", tracks);
                addNonemptyTrack($0147bee01cff6558$export$5ce2dcb4cc9f2bff, boneName + ".scale", animationKeys, "scl", tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $0147bee01cff6558$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case "scalar":
        case "double":
        case "float":
        case "number":
        case "integer":
            return $0147bee01cff6558$export$d45f0d1a4d9a9314;
        case "vector":
        case "vector2":
        case "vector3":
        case "vector4":
            return $0147bee01cff6558$export$5ce2dcb4cc9f2bff;
        case "color":
            return $0147bee01cff6558$export$83444c5d885347d8;
        case "quaternion":
            return $0147bee01cff6558$export$b8043f12b5aafbd7;
        case "bool":
        case "boolean":
            return $0147bee01cff6558$export$d3a344b98cf0b775;
        case "string":
            return $0147bee01cff6558$export$6ce41d4f3a8df9cd;
    }
    throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + typeName);
}
function $0147bee01cff6558$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
    const trackType = $0147bee01cff6558$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $0147bee01cff6558$var$flattenJSON(json.keys, times, values, "value");
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $0147bee01cff6558$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $0147bee01cff6558$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $0147bee01cff6558$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $0147bee01cff6558$export$99cc795e99919eed();
class $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        this.manager = manager !== undefined ? manager : $0147bee01cff6558$export$b033c3f9a95c6a16;
        this.crossOrigin = "anonymous";
        this.withCredentials = false;
        this.path = "";
        this.resourcePath = "";
        this.requestHeader = {};
    }
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
$0147bee01cff6558$export$3b0d6d7590275603.DEFAULT_MATERIAL_NAME = "__DEFAULT";
const $0147bee01cff6558$var$loading = {};
class $0147bee01cff6558$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
class $0147bee01cff6558$export$98435a25b5cf7b2b extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $0147bee01cff6558$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($0147bee01cff6558$var$loading[url] !== undefined) {
            $0147bee01cff6558$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $0147bee01cff6558$var$loading[url] = [];
        $0147bee01cff6558$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? "include" : "same-origin"
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn("THREE.FileLoader: HTTP Status 0 received.");
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === "undefined" || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $0147bee01cff6558$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get("Content-Length") || response.headers.get("X-File-Size");
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent("progress", {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $0147bee01cff6558$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case "arraybuffer":
                    return response.arrayBuffer();
                case "blob":
                    return response.blob();
                case "document":
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case "json":
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $0147bee01cff6558$export$94affb487e701bf2.add(url, data);
            const callbacks = $0147bee01cff6558$var$loading[url];
            delete $0147bee01cff6558$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $0147bee01cff6558$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $0147bee01cff6558$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
class $0147bee01cff6558$export$29711c7e14f61db extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $0147bee01cff6558$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $0147bee01cff6558$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $0147bee01cff6558$export$bd73ce947a280350 extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $0147bee01cff6558$export$3466bac9141a5cc4();
        const loader = new $0147bee01cff6558$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $0147bee01cff6558$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $0147bee01cff6558$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $0147bee01cff6558$export$8905ce1c7a2464a1 extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $0147bee01cff6558$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $0147bee01cff6558$var$createElementNS("img");
        function onImageLoad() {
            removeEventListeners();
            $0147bee01cff6558$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener("load", onImageLoad, false);
            image.removeEventListener("error", onImageError, false);
        }
        image.addEventListener("load", onImageLoad, false);
        image.addEventListener("error", onImageError, false);
        if (url.slice(0, 5) !== "data:") {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
class $0147bee01cff6558$export$2ec114afc2cf6308 extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(urls, onLoad, onProgress, onError) {
        const texture = new $0147bee01cff6558$export$ee2e5a18258a4049();
        texture.colorSpace = $0147bee01cff6558$export$561f394b24edfcaa;
        const loader = new $0147bee01cff6558$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $0147bee01cff6558$export$792d8a18f2c55855 extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $0147bee01cff6558$export$b691f601014eabe1();
        const loader = new $0147bee01cff6558$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            let texData;
            try {
                texData = scope.parse(buffer);
            } catch (error) {
                if (onError !== undefined) onError(error);
                else {
                    console.error(error);
                    return;
                }
            }
            if (!texData) return onError(); // TODO: Remove this when all loaders properly throw errors
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $0147bee01cff6558$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $0147bee01cff6558$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $0147bee01cff6558$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $0147bee01cff6558$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            else if (texData.encoding !== undefined) texture.encoding = texData.encoding;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $0147bee01cff6558$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $0147bee01cff6558$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
class $0147bee01cff6558$export$fd1bfc71f64c538c extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new $0147bee01cff6558$export$5431306cf43de24a();
        const loader = new $0147bee01cff6558$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $0147bee01cff6558$export$6ecadb6ed240d696 extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(color, intensity = 1){
        super();
        this.isLight = true;
        this.type = "Light";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
class $0147bee01cff6558$export$8d474f55edbb9624 extends $0147bee01cff6558$export$6ecadb6ed240d696 {
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.isHemisphereLight = true;
        this.type = "HemisphereLight";
        this.position.copy($0147bee01cff6558$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.groundColor = new $0147bee01cff6558$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
const $0147bee01cff6558$var$_projScreenMatrix$1 = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_lightPositionWorld$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_lookTarget$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$var$LightShadow {
    constructor(camera){
        this.camera = camera;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new $0147bee01cff6558$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $0147bee01cff6558$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $0147bee01cff6558$export$35efe6f4c85463d2();
        this._frameExtents = new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $0147bee01cff6558$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $0147bee01cff6558$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($0147bee01cff6558$var$_lightPositionWorld$1);
        $0147bee01cff6558$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($0147bee01cff6558$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $0147bee01cff6558$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($0147bee01cff6558$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($0147bee01cff6558$var$_projScreenMatrix$1);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
class $0147bee01cff6558$var$SpotLightShadow extends $0147bee01cff6558$var$LightShadow {
    constructor(){
        super(new $0147bee01cff6558$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.isSpotLightShadow = true;
        this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $0147bee01cff6558$var$RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
class $0147bee01cff6558$export$81495cbb73897362 extends $0147bee01cff6558$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        this.isSpotLight = true;
        this.type = "SpotLight";
        this.position.copy($0147bee01cff6558$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $0147bee01cff6558$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay;
        this.map = null;
        this.shadow = new $0147bee01cff6558$var$SpotLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
const $0147bee01cff6558$var$_projScreenMatrix = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_lightPositionWorld = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_lookTarget = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$var$PointLightShadow extends $0147bee01cff6558$var$LightShadow {
    constructor(){
        super(new $0147bee01cff6558$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this.isPointLightShadow = true;
        this._frameExtents = new $0147bee01cff6558$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $0147bee01cff6558$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $0147bee01cff6558$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $0147bee01cff6558$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $0147bee01cff6558$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $0147bee01cff6558$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $0147bee01cff6558$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $0147bee01cff6558$export$64b5c384219d3699(1, 0, 0),
            new $0147bee01cff6558$export$64b5c384219d3699(-1, 0, 0),
            new $0147bee01cff6558$export$64b5c384219d3699(0, 0, 1),
            new $0147bee01cff6558$export$64b5c384219d3699(0, 0, -1),
            new $0147bee01cff6558$export$64b5c384219d3699(0, 1, 0),
            new $0147bee01cff6558$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $0147bee01cff6558$export$64b5c384219d3699(0, 1, 0),
            new $0147bee01cff6558$export$64b5c384219d3699(0, 1, 0),
            new $0147bee01cff6558$export$64b5c384219d3699(0, 1, 0),
            new $0147bee01cff6558$export$64b5c384219d3699(0, 1, 0),
            new $0147bee01cff6558$export$64b5c384219d3699(0, 0, 1),
            new $0147bee01cff6558$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $0147bee01cff6558$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($0147bee01cff6558$var$_lightPositionWorld);
        $0147bee01cff6558$var$_lookTarget.copy(camera.position);
        $0147bee01cff6558$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($0147bee01cff6558$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$0147bee01cff6558$var$_lightPositionWorld.x, -$0147bee01cff6558$var$_lightPositionWorld.y, -$0147bee01cff6558$var$_lightPositionWorld.z);
        $0147bee01cff6558$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($0147bee01cff6558$var$_projScreenMatrix);
    }
}
class $0147bee01cff6558$export$4c9c1cb3f0b6f455 extends $0147bee01cff6558$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        this.isPointLight = true;
        this.type = "PointLight";
        this.distance = distance;
        this.decay = decay;
        this.shadow = new $0147bee01cff6558$var$PointLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $0147bee01cff6558$var$DirectionalLightShadow extends $0147bee01cff6558$var$LightShadow {
    constructor(){
        super(new $0147bee01cff6558$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        this.isDirectionalLightShadow = true;
    }
}
class $0147bee01cff6558$export$3fea33cc9972c868 extends $0147bee01cff6558$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isDirectionalLight = true;
        this.type = "DirectionalLight";
        this.position.copy($0147bee01cff6558$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $0147bee01cff6558$export$e4dd07dff30cc924();
        this.shadow = new $0147bee01cff6558$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $0147bee01cff6558$export$af279bfef9ec2c96 extends $0147bee01cff6558$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isAmbientLight = true;
        this.type = "AmbientLight";
    }
}
class $0147bee01cff6558$export$61db2d908bbd2429 extends $0147bee01cff6558$export$6ecadb6ed240d696 {
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.isRectAreaLight = true;
        this.type = "RectAreaLight";
        this.width = width;
        this.height = height;
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $0147bee01cff6558$export$ba61ce607e1f405a {
    constructor(){
        this.isSphericalHarmonics3 = true;
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $0147bee01cff6558$export$64b5c384219d3699());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
class $0147bee01cff6558$export$e7ef036e309b38d2 extends $0147bee01cff6558$export$6ecadb6ed240d696 {
    constructor(sh = new $0147bee01cff6558$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.isLightProbe = true;
        this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
class $0147bee01cff6558$export$3bd6d323353dcf96 extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.textures = {};
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $0147bee01cff6558$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn("THREE.MaterialLoader: Undefined texture", name);
            return textures[name];
        }
        const material = $0147bee01cff6558$export$3bd6d323353dcf96.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $0147bee01cff6558$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
        if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.alphaHash !== undefined) material.alphaHash = json.alphaHash;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== 1) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === "number") material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case "t":
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case "c":
                    material.uniforms[name].value = new $0147bee01cff6558$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case "v2":
                    material.uniforms[name].value = new $0147bee01cff6558$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case "v3":
                    material.uniforms[name].value = new $0147bee01cff6558$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case "v4":
                    material.uniforms[name].value = new $0147bee01cff6558$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case "m3":
                    material.uniforms[name].value = new $0147bee01cff6558$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case "m4":
                    material.uniforms[name].value = new $0147bee01cff6558$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $0147bee01cff6558$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $0147bee01cff6558$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
    static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $0147bee01cff6558$export$e8564da406055a3,
            SpriteMaterial: $0147bee01cff6558$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $0147bee01cff6558$export$21c421a2e1df9d22,
            ShaderMaterial: $0147bee01cff6558$export$83c7d75d550a8b0d,
            PointsMaterial: $0147bee01cff6558$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $0147bee01cff6558$export$28d04986c4269c9f,
            MeshStandardMaterial: $0147bee01cff6558$export$f2980790215acccd,
            MeshPhongMaterial: $0147bee01cff6558$export$24c72f71cbaf0678,
            MeshToonMaterial: $0147bee01cff6558$export$df893cf97e765622,
            MeshNormalMaterial: $0147bee01cff6558$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $0147bee01cff6558$export$5023a9a8114806b8,
            MeshDepthMaterial: $0147bee01cff6558$export$2698c22ec13825db,
            MeshDistanceMaterial: $0147bee01cff6558$export$33e187ed002f2a19,
            MeshBasicMaterial: $0147bee01cff6558$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $0147bee01cff6558$export$6f5fef6235ec12ee,
            LineDashedMaterial: $0147bee01cff6558$export$327886a3efaeaebe,
            LineBasicMaterial: $0147bee01cff6558$export$fbaaa33907730a0c,
            Material: $0147bee01cff6558$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
class $0147bee01cff6558$export$b5d2dc08d867e41a {
    static decodeText(array) {
        if (typeof TextDecoder !== "undefined") return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = "";
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf("/");
        if (index === -1) return "./";
        return url.slice(0, index + 1);
    }
    static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== "string" || url === "") return "";
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, "$1");
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
class $0147bee01cff6558$export$231f009cbe414146 extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(){
        super();
        this.isInstancedBufferGeometry = true;
        this.type = "InstancedBufferGeometry";
        this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
class $0147bee01cff6558$export$dc275bb96327833a extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $0147bee01cff6558$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $0147bee01cff6558$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $0147bee01cff6558$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $0147bee01cff6558$export$231f009cbe414146() : new $0147bee01cff6558$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $0147bee01cff6558$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $0147bee01cff6558$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $0147bee01cff6558$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $0147bee01cff6558$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $0147bee01cff6558$export$32ea87a8b54d744a : $0147bee01cff6558$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            if (attribute.updateRange !== undefined) {
                bufferAttribute.updateRange.offset = attribute.updateRange.offset;
                bufferAttribute.updateRange.count = attribute.updateRange.count;
            }
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $0147bee01cff6558$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $0147bee01cff6558$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $0147bee01cff6558$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $0147bee01cff6558$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $0147bee01cff6558$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
class $0147bee01cff6558$export$40110c8505c5ad19 extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === "" ? $0147bee01cff6558$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $0147bee01cff6558$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error("THREE:ObjectLoader: Can't parse " + url + ".", error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") {
                if (onError !== undefined) onError(new Error("THREE.ObjectLoader: Can't load " + url));
                console.error("THREE.ObjectLoader: Can't load " + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === "" ? $0147bee01cff6558$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $0147bee01cff6558$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") throw new Error("THREE.ObjectLoader: Can't load " + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $0147bee01cff6558$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $0147bee01cff6558$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $0147bee01cff6558$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case "BufferGeometry":
                    case "InstancedBufferGeometry":
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $0147bee01cff6558$var$Geometries) geometry = $0147bee01cff6558$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $0147bee01cff6558$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $0147bee01cff6558$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $0147bee01cff6558$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $0147bee01cff6558$export$99cc795e99919eed(onLoad);
            loader = new $0147bee01cff6558$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $0147bee01cff6558$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $0147bee01cff6558$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $0147bee01cff6558$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $0147bee01cff6558$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $0147bee01cff6558$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $0147bee01cff6558$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $0147bee01cff6558$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $0147bee01cff6558$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === "number") return value;
            console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn("THREE.ObjectLoader: Undefined image", data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $0147bee01cff6558$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $0147bee01cff6558$export$b691f601014eabe1();
                else texture = new $0147bee01cff6558$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $0147bee01cff6558$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $0147bee01cff6558$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $0147bee01cff6558$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.encoding !== undefined) texture.encoding = data.encoding; // @deprecated, r152
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $0147bee01cff6558$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $0147bee01cff6558$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn("THREE.ObjectLoader: Undefined geometry", name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined material", uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn("THREE.ObjectLoader: Undefined material", name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined texture", uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case "Scene":
                object = new $0147bee01cff6558$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $0147bee01cff6558$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === "Fog") object.fog = new $0147bee01cff6558$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === "FogExp2") object.fog = new $0147bee01cff6558$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                break;
            case "PerspectiveCamera":
                object = new $0147bee01cff6558$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "OrthographicCamera":
                object = new $0147bee01cff6558$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "AmbientLight":
                object = new $0147bee01cff6558$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case "DirectionalLight":
                object = new $0147bee01cff6558$export$3fea33cc9972c868(data.color, data.intensity);
                break;
            case "PointLight":
                object = new $0147bee01cff6558$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case "RectAreaLight":
                object = new $0147bee01cff6558$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case "SpotLight":
                object = new $0147bee01cff6558$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                break;
            case "HemisphereLight":
                object = new $0147bee01cff6558$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case "LightProbe":
                object = new $0147bee01cff6558$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case "SkinnedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $0147bee01cff6558$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case "Mesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $0147bee01cff6558$export$e176487c05830cc5(geometry, material);
                break;
            case "InstancedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $0147bee01cff6558$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $0147bee01cff6558$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $0147bee01cff6558$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case "LOD":
                object = new $0147bee01cff6558$export$112e7237be0c5f30();
                break;
            case "Line":
                object = new $0147bee01cff6558$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineLoop":
                object = new $0147bee01cff6558$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineSegments":
                object = new $0147bee01cff6558$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "PointCloud":
            case "Points":
                object = new $0147bee01cff6558$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "Sprite":
                object = new $0147bee01cff6558$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case "Group":
                object = new $0147bee01cff6558$export$eb2fcfdbd7ba97d4();
                break;
            case "Bone":
                object = new $0147bee01cff6558$export$b127726e56765aa4();
                break;
            default:
                object = new $0147bee01cff6558$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === "LOD") {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty("uuid", level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn("THREE.ObjectLoader: No skeleton found with UUID:", child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
}
const $0147bee01cff6558$var$TEXTURE_MAPPING = {
    UVMapping: $0147bee01cff6558$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $0147bee01cff6558$export$8759762a6477f2c4,
    CubeRefractionMapping: $0147bee01cff6558$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $0147bee01cff6558$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $0147bee01cff6558$export$ee99d97d46898098,
    CubeUVReflectionMapping: $0147bee01cff6558$export$dbf3e70ff37af79
};
const $0147bee01cff6558$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $0147bee01cff6558$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $0147bee01cff6558$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $0147bee01cff6558$export$c7e7c00b14f51a4f
};
const $0147bee01cff6558$var$TEXTURE_FILTER = {
    NearestFilter: $0147bee01cff6558$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $0147bee01cff6558$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $0147bee01cff6558$export$d2327c1afe5bfdf2,
    LinearFilter: $0147bee01cff6558$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $0147bee01cff6558$export$19a719f377145a13,
    LinearMipmapLinearFilter: $0147bee01cff6558$export$5d8599b6a933fb1b
};
class $0147bee01cff6558$export$52286b55c4a9b51f extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === "undefined") console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported.");
        if (typeof fetch === "undefined") console.warn("THREE.ImageBitmapLoader: fetch() not supported.");
        this.options = {
            premultiplyAlpha: "none"
        };
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $0147bee01cff6558$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include";
        fetchOptions.headers = this.requestHeader;
        fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: "none"
            }));
        }).then(function(imageBitmap) {
            $0147bee01cff6558$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
        }).catch(function(e) {
            if (onError) onError(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        scope.manager.itemStart(url);
    }
}
let $0147bee01cff6558$var$_context;
class $0147bee01cff6558$export$fcbc63750ec2a81f {
    static getContext() {
        if ($0147bee01cff6558$var$_context === undefined) $0147bee01cff6558$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $0147bee01cff6558$var$_context;
    }
    static setContext(value) {
        $0147bee01cff6558$var$_context = value;
    }
}
class $0147bee01cff6558$export$d8d5fccfbf47714e extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $0147bee01cff6558$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $0147bee01cff6558$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                }, handleError);
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
        }
    }
}
class $0147bee01cff6558$export$2f22dadc8bc42820 extends $0147bee01cff6558$export$e7ef036e309b38d2 {
    constructor(skyColor, groundColor, intensity = 1){
        super(undefined, intensity);
        this.isHemisphereLightProbe = true;
        const color1 = new $0147bee01cff6558$export$892596cec99bc70e().set(skyColor);
        const color2 = new $0147bee01cff6558$export$892596cec99bc70e().set(groundColor);
        const sky = new $0147bee01cff6558$export$64b5c384219d3699(color1.r, color1.g, color1.b);
        const ground = new $0147bee01cff6558$export$64b5c384219d3699(color2.r, color2.g, color2.b);
        // without extra factor of PI in the shader, should = 1 / Math.sqrt( Math.PI );
        const c0 = Math.sqrt(Math.PI);
        const c1 = c0 * Math.sqrt(0.75);
        this.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
        this.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
    }
}
class $0147bee01cff6558$export$afe310a21c86023d extends $0147bee01cff6558$export$e7ef036e309b38d2 {
    constructor(color, intensity = 1){
        super(undefined, intensity);
        this.isAmbientLightProbe = true;
        const color1 = new $0147bee01cff6558$export$892596cec99bc70e().set(color);
        // without extra factor of PI in the shader, would be 2 / Math.sqrt( Math.PI );
        this.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
    }
}
const $0147bee01cff6558$var$_eyeRight = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_eyeLeft = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_projectionMatrix = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
class $0147bee01cff6558$export$bc7f73a1065bee0c {
    constructor(){
        this.type = "StereoCamera";
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $0147bee01cff6558$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $0147bee01cff6558$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $0147bee01cff6558$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($0147bee01cff6558$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $0147bee01cff6558$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $0147bee01cff6558$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $0147bee01cff6558$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $0147bee01cff6558$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($0147bee01cff6558$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $0147bee01cff6558$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $0147bee01cff6558$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($0147bee01cff6558$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($0147bee01cff6558$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($0147bee01cff6558$var$_eyeRight);
    }
}
class $0147bee01cff6558$export$9735c82c4bae3302 {
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = $0147bee01cff6558$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $0147bee01cff6558$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $0147bee01cff6558$var$now() {
    return (typeof performance === "undefined" ? Date : performance).now(); // see #10732
}
const $0147bee01cff6558$var$_position$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_quaternion$1 = /*@__PURE__*/ new $0147bee01cff6558$export$23d6a54f0bbc85a3();
const $0147bee01cff6558$var$_scale$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_orientation$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$8a1b810c6fde8951 extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "AudioListener";
        this.context = $0147bee01cff6558$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $0147bee01cff6558$export$9735c82c4bae3302();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($0147bee01cff6558$var$_position$1, $0147bee01cff6558$var$_quaternion$1, $0147bee01cff6558$var$_scale$1);
        $0147bee01cff6558$var$_orientation$1.set(0, 0, -1).applyQuaternion($0147bee01cff6558$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($0147bee01cff6558$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($0147bee01cff6558$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($0147bee01cff6558$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($0147bee01cff6558$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($0147bee01cff6558$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($0147bee01cff6558$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($0147bee01cff6558$var$_position$1.x, $0147bee01cff6558$var$_position$1.y, $0147bee01cff6558$var$_position$1.z);
            listener.setOrientation($0147bee01cff6558$var$_orientation$1.x, $0147bee01cff6558$var$_orientation$1.y, $0147bee01cff6558$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
class $0147bee01cff6558$export$153755f98d9861de extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(listener){
        super();
        this.type = "Audio";
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = "empty";
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = "audioNode";
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaNode";
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaStreamNode";
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = "buffer";
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn("THREE.Audio: Audio is already playing.");
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop();
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.source.detune === undefined) return; // only set detune when available
        if (this.isPlaying === true) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
}
const $0147bee01cff6558$var$_position = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_quaternion = /*@__PURE__*/ new $0147bee01cff6558$export$23d6a54f0bbc85a3();
const $0147bee01cff6558$var$_scale = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_orientation = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$4b3e397ef1832507 extends $0147bee01cff6558$export$153755f98d9861de {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = "HRTF";
        this.panner.connect(this.gain);
    }
    connect() {
        super.connect();
        this.panner.connect(this.gain);
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($0147bee01cff6558$var$_position, $0147bee01cff6558$var$_quaternion, $0147bee01cff6558$var$_scale);
        $0147bee01cff6558$var$_orientation.set(0, 0, 1).applyQuaternion($0147bee01cff6558$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($0147bee01cff6558$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($0147bee01cff6558$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($0147bee01cff6558$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($0147bee01cff6558$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($0147bee01cff6558$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($0147bee01cff6558$var$_orientation.z, endTime);
        } else {
            panner.setPosition($0147bee01cff6558$var$_position.x, $0147bee01cff6558$var$_position.y, $0147bee01cff6558$var$_position.z);
            panner.setOrientation($0147bee01cff6558$var$_orientation.x, $0147bee01cff6558$var$_orientation.y, $0147bee01cff6558$var$_orientation.z);
        }
    }
}
class $0147bee01cff6558$export$d47da1ef3d382827 {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
class $0147bee01cff6558$export$dfe0af1ca1acb78a {
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case "quaternion":
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case "string":
            case "bool":
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $0147bee01cff6558$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $0147bee01cff6558$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $0147bee01cff6558$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $0147bee01cff6558$var$_RESERVED_CHARS_RE = "\\[\\]\\.:\\/";
const $0147bee01cff6558$var$_reservedRe = new RegExp("[" + $0147bee01cff6558$var$_RESERVED_CHARS_RE + "]", "g");
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $0147bee01cff6558$var$_wordChar = "[^" + $0147bee01cff6558$var$_RESERVED_CHARS_RE + "]";
const $0147bee01cff6558$var$_wordCharOrDot = "[^" + $0147bee01cff6558$var$_RESERVED_CHARS_RE.replace("\\.", "") + "]";
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $0147bee01cff6558$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace("WC", $0147bee01cff6558$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $0147bee01cff6558$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace("WCOD", $0147bee01cff6558$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $0147bee01cff6558$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", $0147bee01cff6558$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $0147bee01cff6558$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", $0147bee01cff6558$var$_wordChar);
const $0147bee01cff6558$var$_trackRe = new RegExp("^" + $0147bee01cff6558$var$_directoryRe + $0147bee01cff6558$var$_nodeRe + $0147bee01cff6558$var$_objectRe + $0147bee01cff6558$var$_propertyRe + "$");
const $0147bee01cff6558$var$_supportedObjectNames = [
    "material",
    "materials",
    "bones",
    "map"
];
class $0147bee01cff6558$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $0147bee01cff6558$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $0147bee01cff6558$export$7bf70fcf9f891893 {
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $0147bee01cff6558$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $0147bee01cff6558$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $0147bee01cff6558$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $0147bee01cff6558$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, "_").replace($0147bee01cff6558$var$_reservedRe, "");
    }
    static parseTrackName(trackName) {
        const matches = $0147bee01cff6558$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error("PropertyBinding: Cannot parse trackName: " + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf(".");
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($0147bee01cff6558$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === "" || nodeName === "." || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $0147bee01cff6558$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.warn("THREE.PropertyBinding: No target node found for track: " + this.path + ".");
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case "materials":
                    if (!targetObject.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case "bones":
                    if (!targetObject.skeleton) {
                        console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case "map":
                    if ("map" in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error("THREE.PropertyBinding: Trying to update property for track: " + nodeName + "." + propertyName + " but it wasn't found.", targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === "morphTargetInfluences") {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$0147bee01cff6558$export$7bf70fcf9f891893.Composite = $0147bee01cff6558$var$Composite;
$0147bee01cff6558$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$0147bee01cff6558$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$0147bee01cff6558$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $0147bee01cff6558$export$7bf70fcf9f891893.prototype._getValue_direct,
    $0147bee01cff6558$export$7bf70fcf9f891893.prototype._getValue_array,
    $0147bee01cff6558$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $0147bee01cff6558$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$0147bee01cff6558$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_direct,
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_array,
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $0147bee01cff6558$export$30619c2afd3f34db {
    constructor(){
        this.isAnimationObjectGroup = true;
        this.uuid = $0147bee01cff6558$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $0147bee01cff6558$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $0147bee01cff6558$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $0147bee01cff6558$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
class $0147bee01cff6558$export$6946940a69e799e {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $0147bee01cff6558$export$7f795934b84ab523,
            endingEnd: $0147bee01cff6558$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $0147bee01cff6558$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $0147bee01cff6558$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $0147bee01cff6558$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $0147bee01cff6558$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $0147bee01cff6558$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "finished",
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "loop",
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $0147bee01cff6558$export$24a4ccb5099273b5;
            settings.endingEnd = $0147bee01cff6558$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $0147bee01cff6558$export$24a4ccb5099273b5 : $0147bee01cff6558$export$7f795934b84ab523;
            else settings.endingStart = $0147bee01cff6558$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $0147bee01cff6558$export$24a4ccb5099273b5 : $0147bee01cff6558$export$7f795934b84ab523;
            else settings.endingEnd = $0147bee01cff6558$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $0147bee01cff6558$var$_controlInterpolantsResultBuffer = new Float32Array(1);
class $0147bee01cff6558$export$fbd77e5aefaa0102 extends $0147bee01cff6558$export$ec8b666c5fe2c75a {
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $0147bee01cff6558$export$dfe0af1ca1acb78a($0147bee01cff6558$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $0147bee01cff6558$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $0147bee01cff6558$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === "string" ? $0147bee01cff6558$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $0147bee01cff6558$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $0147bee01cff6558$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === "string" ? $0147bee01cff6558$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
class $0147bee01cff6558$export$2947cebfe91c02f8 {
    constructor(value){
        this.value = value;
    }
    clone() {
        return new $0147bee01cff6558$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $0147bee01cff6558$var$id = 0;
class $0147bee01cff6558$export$c412d5ffe1f79209 extends $0147bee01cff6558$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isUniformsGroup = true;
        Object.defineProperty(this, "id", {
            value: $0147bee01cff6558$var$id++
        });
        this.name = "";
        this.usage = $0147bee01cff6558$export$763e8360f4d7f77d;
        this.uniforms = [];
    }
    add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    setName(name) {
        this.name = name;
        return this;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++)this.uniforms.push(uniformsSource[i].clone());
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $0147bee01cff6558$export$25ec0e1af1389358 extends $0147bee01cff6558$export$3d5cd879f108f53f {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.isInstancedInterleavedBuffer = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
class $0147bee01cff6558$export$6b7339ae8dbddf73 {
    constructor(buffer, type, itemSize, elementSize, count){
        this.isGLBufferAttribute = true;
        this.name = "";
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
}
class $0147bee01cff6558$export$8b7aaceff00bd2f {
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $0147bee01cff6558$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $0147bee01cff6558$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error("THREE.Raycaster: Unsupported camera type: " + camera.type);
    }
    intersectObject(object, recursive = true, intersects = []) {
        $0147bee01cff6558$var$intersectObject(object, this, intersects, recursive);
        intersects.sort($0147bee01cff6558$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$0147bee01cff6558$var$intersectObject(objects[i], this, intersects, recursive);
        intersects.sort($0147bee01cff6558$var$ascSort);
        return intersects;
    }
}
function $0147bee01cff6558$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $0147bee01cff6558$var$intersectObject(object, raycaster, intersects, recursive) {
    if (object.layers.test(raycaster.layers)) object.raycast(raycaster, intersects);
    if (recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$0147bee01cff6558$var$intersectObject(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */ class $0147bee01cff6558$export$d712cd887b4a00f7 {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be between EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($0147bee01cff6558$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $0147bee01cff6558$export$287165bb2177f4fd {
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $0147bee01cff6558$var$_vector$4 = /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1();
class $0147bee01cff6558$export$60f553fa130f08b0 {
    constructor(min = new $0147bee01cff6558$export$c977b3e384af9ae1(Infinity, Infinity), max = new $0147bee01cff6558$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.isBox2 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $0147bee01cff6558$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $0147bee01cff6558$var$_vector$4).distanceTo(point);
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $0147bee01cff6558$var$_startP = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_startEnd = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$e0ba6359f1954fd3 {
    constructor(start = new $0147bee01cff6558$export$64b5c384219d3699(), end = new $0147bee01cff6558$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $0147bee01cff6558$var$_startP.subVectors(point, this.start);
        $0147bee01cff6558$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $0147bee01cff6558$var$_startEnd.dot($0147bee01cff6558$var$_startEnd);
        const startEnd_startP = $0147bee01cff6558$var$_startEnd.dot($0147bee01cff6558$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $0147bee01cff6558$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $0147bee01cff6558$var$_vector$3 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$4b14638ffdd81e68 extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(light, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "SpotLightHelper";
        const geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(positions, 3));
        const material = new $0147bee01cff6558$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $0147bee01cff6558$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $0147bee01cff6558$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($0147bee01cff6558$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $0147bee01cff6558$var$_vector$2 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_boneMatrix = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_matrixWorldInv = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
class $0147bee01cff6558$export$5277df3c9e732259 extends $0147bee01cff6558$export$ff1ed10fedfdd604 {
    constructor(object){
        const bones = $0147bee01cff6558$var$getBoneList(object);
        const geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $0147bee01cff6558$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $0147bee01cff6558$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $0147bee01cff6558$export$cbe7a62641830ebd(colors, 3));
        const material = new $0147bee01cff6558$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.isSkeletonHelper = true;
        this.type = "SkeletonHelper";
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute("position");
        $0147bee01cff6558$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $0147bee01cff6558$var$_boneMatrix.multiplyMatrices($0147bee01cff6558$var$_matrixWorldInv, bone.matrixWorld);
                $0147bee01cff6558$var$_vector$2.setFromMatrixPosition($0147bee01cff6558$var$_boneMatrix);
                position.setXYZ(j, $0147bee01cff6558$var$_vector$2.x, $0147bee01cff6558$var$_vector$2.y, $0147bee01cff6558$var$_vector$2.z);
                $0147bee01cff6558$var$_boneMatrix.multiplyMatrices($0147bee01cff6558$var$_matrixWorldInv, bone.parent.matrixWorld);
                $0147bee01cff6558$var$_vector$2.setFromMatrixPosition($0147bee01cff6558$var$_boneMatrix);
                position.setXYZ(j + 1, $0147bee01cff6558$var$_vector$2.x, $0147bee01cff6558$var$_vector$2.y, $0147bee01cff6558$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute("position").needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $0147bee01cff6558$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $0147bee01cff6558$var$getBoneList(object.children[i]));
    return boneList;
}
class $0147bee01cff6558$export$9a9291685b9e4023 extends $0147bee01cff6558$export$e176487c05830cc5 {
    constructor(light, sphereSize, color){
        const geometry = new $0147bee01cff6558$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $0147bee01cff6558$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.color = color;
        this.type = "PointLightHelper";
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $0147bee01cff6558$var$_vector$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_color1 = /*@__PURE__*/ new $0147bee01cff6558$export$892596cec99bc70e();
const $0147bee01cff6558$var$_color2 = /*@__PURE__*/ new $0147bee01cff6558$export$892596cec99bc70e();
class $0147bee01cff6558$export$8dca15f13f4f8172 extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "HemisphereLightHelper";
        const geometry = new $0147bee01cff6558$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $0147bee01cff6558$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute("position");
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute("color", new $0147bee01cff6558$export$8dea267bd6bde117(colors, 3));
        this.add(new $0147bee01cff6558$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute("color");
            $0147bee01cff6558$var$_color1.copy(this.light.color);
            $0147bee01cff6558$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $0147bee01cff6558$var$_color1 : $0147bee01cff6558$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($0147bee01cff6558$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $0147bee01cff6558$export$3875d39926561055 extends $0147bee01cff6558$export$ff1ed10fedfdd604 {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $0147bee01cff6558$export$892596cec99bc70e(color1);
        color2 = new $0147bee01cff6558$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $0147bee01cff6558$export$cbe7a62641830ebd(colors, 3));
        const material = new $0147bee01cff6558$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "GridHelper";
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $0147bee01cff6558$export$361430a10f533cd3 extends $0147bee01cff6558$export$ff1ed10fedfdd604 {
    constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $0147bee01cff6558$export$892596cec99bc70e(color1);
        color2 = new $0147bee01cff6558$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $0147bee01cff6558$export$cbe7a62641830ebd(colors, 3));
        const material = new $0147bee01cff6558$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "PolarGridHelper";
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $0147bee01cff6558$var$_v1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_v2 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_v3 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$f8e434dc14203e7d extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "DirectionalLightHelper";
        if (size === undefined) size = 1;
        let geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $0147bee01cff6558$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $0147bee01cff6558$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $0147bee01cff6558$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $0147bee01cff6558$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $0147bee01cff6558$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $0147bee01cff6558$var$_v3.subVectors($0147bee01cff6558$var$_v2, $0147bee01cff6558$var$_v1);
        this.lightPlane.lookAt($0147bee01cff6558$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($0147bee01cff6558$var$_v2);
        this.targetLine.scale.z = $0147bee01cff6558$var$_v3.length();
    }
}
const $0147bee01cff6558$var$_vector = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_camera = /*@__PURE__*/ new $0147bee01cff6558$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */ class $0147bee01cff6558$export$ed8e93f853cd795 extends $0147bee01cff6558$export$ff1ed10fedfdd604 {
    constructor(camera){
        const geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        const material = new $0147bee01cff6558$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine("n1", "n2");
        addLine("n2", "n4");
        addLine("n4", "n3");
        addLine("n3", "n1");
        // far
        addLine("f1", "f2");
        addLine("f2", "f4");
        addLine("f4", "f3");
        addLine("f3", "f1");
        // sides
        addLine("n1", "f1");
        addLine("n2", "f2");
        addLine("n3", "f3");
        addLine("n4", "f4");
        // cone
        addLine("p", "n1");
        addLine("p", "n2");
        addLine("p", "n3");
        addLine("p", "n4");
        // up
        addLine("u1", "u2");
        addLine("u2", "u3");
        addLine("u3", "u1");
        // target
        addLine("c", "t");
        addLine("p", "c");
        // cross
        addLine("cn1", "cn2");
        addLine("cn3", "cn4");
        addLine("cf1", "cf2");
        addLine("cf3", "cf4");
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $0147bee01cff6558$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = "CameraHelper";
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $0147bee01cff6558$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $0147bee01cff6558$export$892596cec99bc70e(0xff0000);
        const colorUp = new $0147bee01cff6558$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $0147bee01cff6558$export$892596cec99bc70e(0xffffff);
        const colorCross = new $0147bee01cff6558$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute("color");
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $0147bee01cff6558$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        $0147bee01cff6558$var$setPoint("c", pointMap, geometry, $0147bee01cff6558$var$_camera, 0, 0, -1);
        $0147bee01cff6558$var$setPoint("t", pointMap, geometry, $0147bee01cff6558$var$_camera, 0, 0, 1);
        // near
        $0147bee01cff6558$var$setPoint("n1", pointMap, geometry, $0147bee01cff6558$var$_camera, -w, -h, -1);
        $0147bee01cff6558$var$setPoint("n2", pointMap, geometry, $0147bee01cff6558$var$_camera, w, -h, -1);
        $0147bee01cff6558$var$setPoint("n3", pointMap, geometry, $0147bee01cff6558$var$_camera, -w, h, -1);
        $0147bee01cff6558$var$setPoint("n4", pointMap, geometry, $0147bee01cff6558$var$_camera, w, h, -1);
        // far
        $0147bee01cff6558$var$setPoint("f1", pointMap, geometry, $0147bee01cff6558$var$_camera, -w, -h, 1);
        $0147bee01cff6558$var$setPoint("f2", pointMap, geometry, $0147bee01cff6558$var$_camera, w, -h, 1);
        $0147bee01cff6558$var$setPoint("f3", pointMap, geometry, $0147bee01cff6558$var$_camera, -w, h, 1);
        $0147bee01cff6558$var$setPoint("f4", pointMap, geometry, $0147bee01cff6558$var$_camera, w, h, 1);
        // up
        $0147bee01cff6558$var$setPoint("u1", pointMap, geometry, $0147bee01cff6558$var$_camera, w * 0.7, h * 1.1, -1);
        $0147bee01cff6558$var$setPoint("u2", pointMap, geometry, $0147bee01cff6558$var$_camera, -w * 0.7, h * 1.1, -1);
        $0147bee01cff6558$var$setPoint("u3", pointMap, geometry, $0147bee01cff6558$var$_camera, 0, h * 2, -1);
        // cross
        $0147bee01cff6558$var$setPoint("cf1", pointMap, geometry, $0147bee01cff6558$var$_camera, -w, 0, 1);
        $0147bee01cff6558$var$setPoint("cf2", pointMap, geometry, $0147bee01cff6558$var$_camera, w, 0, 1);
        $0147bee01cff6558$var$setPoint("cf3", pointMap, geometry, $0147bee01cff6558$var$_camera, 0, -h, 1);
        $0147bee01cff6558$var$setPoint("cf4", pointMap, geometry, $0147bee01cff6558$var$_camera, 0, h, 1);
        $0147bee01cff6558$var$setPoint("cn1", pointMap, geometry, $0147bee01cff6558$var$_camera, -w, 0, -1);
        $0147bee01cff6558$var$setPoint("cn2", pointMap, geometry, $0147bee01cff6558$var$_camera, w, 0, -1);
        $0147bee01cff6558$var$setPoint("cn3", pointMap, geometry, $0147bee01cff6558$var$_camera, 0, -h, -1);
        $0147bee01cff6558$var$setPoint("cn4", pointMap, geometry, $0147bee01cff6558$var$_camera, 0, h, -1);
        geometry.getAttribute("position").needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $0147bee01cff6558$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $0147bee01cff6558$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute("position");
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $0147bee01cff6558$var$_vector.x, $0147bee01cff6558$var$_vector.y, $0147bee01cff6558$var$_vector.z);
    }
}
const $0147bee01cff6558$var$_box = /*@__PURE__*/ new $0147bee01cff6558$export$6f7d5a9418ab2aa3();
class $0147bee01cff6558$export$38a664cc862a6a9d extends $0147bee01cff6558$export$ff1ed10fedfdd604 {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        geometry.setIndex(new $0147bee01cff6558$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $0147bee01cff6558$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $0147bee01cff6558$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = "BoxHelper";
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn("THREE.BoxHelper: .update() has no longer arguments.");
        if (this.object !== undefined) $0147bee01cff6558$var$_box.setFromObject(this.object);
        if ($0147bee01cff6558$var$_box.isEmpty()) return;
        const min = $0147bee01cff6558$var$_box.min;
        const max = $0147bee01cff6558$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $0147bee01cff6558$export$ce39f4bb96c9a290 extends $0147bee01cff6558$export$ff1ed10fedfdd604 {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        geometry.setIndex(new $0147bee01cff6558$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $0147bee01cff6558$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = "Box3Helper";
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $0147bee01cff6558$export$a34fe8156c66e5d7 extends $0147bee01cff6558$export$17d680238e50603e {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $0147bee01cff6558$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = "PlaneHelper";
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $0147bee01cff6558$export$b7be63a67df8959();
        geometry2.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $0147bee01cff6558$export$e176487c05830cc5(geometry2, new $0147bee01cff6558$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
}
const $0147bee01cff6558$var$_axis = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
let $0147bee01cff6558$var$_lineGeometry, $0147bee01cff6558$var$_coneGeometry;
class $0147bee01cff6558$export$a3008e7bd8d2cbe7 extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    // dir is assumed to be normalized
    constructor(dir = new $0147bee01cff6558$export$64b5c384219d3699(0, 0, 1), origin = new $0147bee01cff6558$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = "ArrowHelper";
        if ($0147bee01cff6558$var$_lineGeometry === undefined) {
            $0147bee01cff6558$var$_lineGeometry = new $0147bee01cff6558$export$b7be63a67df8959();
            $0147bee01cff6558$var$_lineGeometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $0147bee01cff6558$var$_coneGeometry = new $0147bee01cff6558$export$68f745719dbe5198(0, 0.5, 1, 5, 1);
            $0147bee01cff6558$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $0147bee01cff6558$export$17d680238e50603e($0147bee01cff6558$var$_lineGeometry, new $0147bee01cff6558$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $0147bee01cff6558$export$e176487c05830cc5($0147bee01cff6558$var$_coneGeometry, new $0147bee01cff6558$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $0147bee01cff6558$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($0147bee01cff6558$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
}
class $0147bee01cff6558$export$6c8303f35b8578fd extends $0147bee01cff6558$export$ff1ed10fedfdd604 {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $0147bee01cff6558$export$cbe7a62641830ebd(colors, 3));
        const material = new $0147bee01cff6558$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "AxesHelper";
    }
    setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $0147bee01cff6558$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $0147bee01cff6558$export$148534a3c727230b {
    constructor(){
        this.type = "ShapePath";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(x, y) {
        this.currentPath = new $0147bee01cff6558$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $0147bee01cff6558$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $0147bee01cff6558$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $0147bee01cff6558$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $0147bee01cff6558$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: $0147bee01cff6558$export$3545e07a80636437
    }
}));
if (typeof window !== "undefined") {
    if (window.__THREE__) console.warn("WARNING: Multiple instances of Three.js being imported.");
    else window.__THREE__ = $0147bee01cff6558$export$3545e07a80636437;
}



const $20476b744622e59b$var$_euler = new (0, $0147bee01cff6558$export$d93cc409a0768c5f)(0, 0, 0, "YXZ");
const $20476b744622e59b$var$_vector = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
const $20476b744622e59b$var$_changeEvent = {
    type: "change"
};
const $20476b744622e59b$var$_lockEvent = {
    type: "lock"
};
const $20476b744622e59b$var$_unlockEvent = {
    type: "unlock"
};
const $20476b744622e59b$var$_PI_2 = Math.PI / 2;
class $20476b744622e59b$export$e08ee79bd6cc99de extends (0, $0147bee01cff6558$export$ec8b666c5fe2c75a) {
    constructor(camera, domElement){
        super();
        this.camera = camera;
        this.domElement = domElement;
        this.isLocked = false;
        // Set to constrain the pitch of the camera
        // Range is 0 to Math.PI radians
        this.minPolarAngle = 0; // radians
        this.maxPolarAngle = Math.PI; // radians
        this.pointerSpeed = 1.0;
        this._onMouseMove = $20476b744622e59b$var$onMouseMove.bind(this);
        this._onPointerlockChange = $20476b744622e59b$var$onPointerlockChange.bind(this);
        this._onPointerlockError = $20476b744622e59b$var$onPointerlockError.bind(this);
        this.connect();
    }
    connect() {
        this.domElement.ownerDocument.addEventListener("mousemove", this._onMouseMove);
        this.domElement.ownerDocument.addEventListener("pointerlockchange", this._onPointerlockChange);
        this.domElement.ownerDocument.addEventListener("pointerlockerror", this._onPointerlockError);
    }
    disconnect() {
        this.domElement.ownerDocument.removeEventListener("mousemove", this._onMouseMove);
        this.domElement.ownerDocument.removeEventListener("pointerlockchange", this._onPointerlockChange);
        this.domElement.ownerDocument.removeEventListener("pointerlockerror", this._onPointerlockError);
    }
    dispose() {
        this.disconnect();
    }
    getObject() {
        return this.camera;
    }
    getDirection(v) {
        return v.set(0, 0, -1).applyQuaternion(this.camera.quaternion);
    }
    moveForward(distance) {
        // move forward parallel to the xz-plane
        // assumes camera.up is y-up
        const camera = this.camera;
        $20476b744622e59b$var$_vector.setFromMatrixColumn(camera.matrix, 0);
        $20476b744622e59b$var$_vector.crossVectors(camera.up, $20476b744622e59b$var$_vector);
        camera.position.addScaledVector($20476b744622e59b$var$_vector, distance);
    }
    moveRight(distance) {
        const camera = this.camera;
        $20476b744622e59b$var$_vector.setFromMatrixColumn(camera.matrix, 0);
        camera.position.addScaledVector($20476b744622e59b$var$_vector, distance);
    }
    lock() {
        this.domElement.requestPointerLock();
    }
    unlock() {
        this.domElement.ownerDocument.exitPointerLock();
    }
}
// event listeners
function $20476b744622e59b$var$onMouseMove(event) {
    if (this.isLocked === false) return;
    const movementX = event.movementX || event.mozMovementX || event.webkitMovementX || 0;
    const movementY = event.movementY || event.mozMovementY || event.webkitMovementY || 0;
    const camera = this.camera;
    $20476b744622e59b$var$_euler.setFromQuaternion(camera.quaternion);
    $20476b744622e59b$var$_euler.y -= movementX * 0.002 * this.pointerSpeed;
    $20476b744622e59b$var$_euler.x -= movementY * 0.002 * this.pointerSpeed;
    $20476b744622e59b$var$_euler.x = Math.max($20476b744622e59b$var$_PI_2 - this.maxPolarAngle, Math.min($20476b744622e59b$var$_PI_2 - this.minPolarAngle, $20476b744622e59b$var$_euler.x));
    camera.quaternion.setFromEuler($20476b744622e59b$var$_euler);
    this.dispatchEvent($20476b744622e59b$var$_changeEvent);
}
function $20476b744622e59b$var$onPointerlockChange() {
    if (this.domElement.ownerDocument.pointerLockElement === this.domElement) {
        this.dispatchEvent($20476b744622e59b$var$_lockEvent);
        this.isLocked = true;
    } else {
        this.dispatchEvent($20476b744622e59b$var$_unlockEvent);
        this.isLocked = false;
    }
}
function $20476b744622e59b$var$onPointerlockError() {
    console.error("THREE.PointerLockControls: Unable to use Pointer Lock API");
}



const $c9d3829446f00917$var$_taskCache = new WeakMap();
class $c9d3829446f00917$export$45c25de53be259ac extends (0, $0147bee01cff6558$export$3b0d6d7590275603) {
    constructor(manager){
        super(manager);
        this.decoderPath = "";
        this.decoderConfig = {};
        this.decoderBinary = null;
        this.decoderPending = null;
        this.workerLimit = 4;
        this.workerPool = [];
        this.workerNextTaskID = 1;
        this.workerSourceURL = "";
        this.defaultAttributeIDs = {
            position: "POSITION",
            normal: "NORMAL",
            color: "COLOR",
            uv: "TEX_COORD"
        };
        this.defaultAttributeTypes = {
            position: "Float32Array",
            normal: "Float32Array",
            color: "Float32Array",
            uv: "Float32Array"
        };
    }
    setDecoderPath(path) {
        this.decoderPath = path;
        return this;
    }
    setDecoderConfig(config) {
        this.decoderConfig = config;
        return this;
    }
    setWorkerLimit(workerLimit) {
        this.workerLimit = workerLimit;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        const loader = new (0, $0147bee01cff6558$export$98435a25b5cf7b2b)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, (buffer)=>{
            this.parse(buffer, onLoad, onError);
        }, onProgress, onError);
    }
    parse(buffer, onLoad, onError) {
        this.decodeDracoFile(buffer, onLoad, null, null, (0, $0147bee01cff6558$export$561f394b24edfcaa)).catch(onError);
    }
    decodeDracoFile(buffer, callback, attributeIDs, attributeTypes, vertexColorSpace = (0, $0147bee01cff6558$export$42429b3acfb233a4)) {
        const taskConfig = {
            attributeIDs: attributeIDs || this.defaultAttributeIDs,
            attributeTypes: attributeTypes || this.defaultAttributeTypes,
            useUniqueIDs: !!attributeIDs,
            vertexColorSpace: vertexColorSpace
        };
        return this.decodeGeometry(buffer, taskConfig).then(callback);
    }
    decodeGeometry(buffer, taskConfig) {
        const taskKey = JSON.stringify(taskConfig);
        // Check for an existing task using this buffer. A transferred buffer cannot be transferred
        // again from this thread.
        if ($c9d3829446f00917$var$_taskCache.has(buffer)) {
            const cachedTask = $c9d3829446f00917$var$_taskCache.get(buffer);
            if (cachedTask.key === taskKey) return cachedTask.promise;
            else if (buffer.byteLength === 0) // Technically, it would be possible to wait for the previous task to complete,
            // transfer the buffer back, and decode again with the second configuration. That
            // is complex, and I don't know of any reason to decode a Draco buffer twice in
            // different ways, so this is left unimplemented.
            throw new Error("THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred.");
        }
        //
        let worker;
        const taskID = this.workerNextTaskID++;
        const taskCost = buffer.byteLength;
        // Obtain a worker and assign a task, and construct a geometry instance
        // when the task completes.
        const geometryPending = this._getWorker(taskID, taskCost).then((_worker)=>{
            worker = _worker;
            return new Promise((resolve, reject)=>{
                worker._callbacks[taskID] = {
                    resolve: resolve,
                    reject: reject
                };
                worker.postMessage({
                    type: "decode",
                    id: taskID,
                    taskConfig: taskConfig,
                    buffer: buffer
                }, [
                    buffer
                ]);
            // this.debug();
            });
        }).then((message)=>this._createGeometry(message.geometry));
        // Remove task from the task list.
        // Note: replaced '.finally()' with '.catch().then()' block - iOS 11 support (#19416)
        geometryPending.catch(()=>true).then(()=>{
            if (worker && taskID) this._releaseTask(worker, taskID);
        });
        // Cache the task result.
        $c9d3829446f00917$var$_taskCache.set(buffer, {
            key: taskKey,
            promise: geometryPending
        });
        return geometryPending;
    }
    _createGeometry(geometryData) {
        const geometry = new (0, $0147bee01cff6558$export$b7be63a67df8959)();
        if (geometryData.index) geometry.setIndex(new (0, $0147bee01cff6558$export$8dea267bd6bde117)(geometryData.index.array, 1));
        for(let i = 0; i < geometryData.attributes.length; i++){
            const result = geometryData.attributes[i];
            const name = result.name;
            const array = result.array;
            const itemSize = result.itemSize;
            const attribute = new (0, $0147bee01cff6558$export$8dea267bd6bde117)(array, itemSize);
            if (name === "color") {
                this._assignVertexColorSpace(attribute, result.vertexColorSpace);
                attribute.normalized = array instanceof Float32Array === false;
            }
            geometry.setAttribute(name, attribute);
        }
        return geometry;
    }
    _assignVertexColorSpace(attribute, inputColorSpace) {
        // While .drc files do not specify colorspace, the only 'official' tooling
        // is PLY and OBJ converters, which use sRGB. We'll assume sRGB when a .drc
        // file is passed into .load() or .parse(). GLTFLoader uses internal APIs
        // to decode geometry, and vertex colors are already Linear-sRGB in there.
        if (inputColorSpace !== (0, $0147bee01cff6558$export$561f394b24edfcaa)) return;
        const _color = new (0, $0147bee01cff6558$export$892596cec99bc70e)();
        for(let i = 0, il = attribute.count; i < il; i++){
            _color.fromBufferAttribute(attribute, i).convertSRGBToLinear();
            attribute.setXYZ(i, _color.r, _color.g, _color.b);
        }
    }
    _loadLibrary(url, responseType) {
        const loader = new (0, $0147bee01cff6558$export$98435a25b5cf7b2b)(this.manager);
        loader.setPath(this.decoderPath);
        loader.setResponseType(responseType);
        loader.setWithCredentials(this.withCredentials);
        return new Promise((resolve, reject)=>{
            loader.load(url, resolve, undefined, reject);
        });
    }
    preload() {
        this._initDecoder();
        return this;
    }
    _initDecoder() {
        if (this.decoderPending) return this.decoderPending;
        const useJS = typeof WebAssembly !== "object" || this.decoderConfig.type === "js";
        const librariesPending = [];
        if (useJS) librariesPending.push(this._loadLibrary("draco_decoder.js", "text"));
        else {
            librariesPending.push(this._loadLibrary("draco_wasm_wrapper.js", "text"));
            librariesPending.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"));
        }
        this.decoderPending = Promise.all(librariesPending).then((libraries)=>{
            const jsContent = libraries[0];
            if (!useJS) this.decoderConfig.wasmBinary = libraries[1];
            const fn = $c9d3829446f00917$var$DRACOWorker.toString();
            const body = [
                "/* draco decoder */",
                jsContent,
                "",
                "/* worker */",
                fn.substring(fn.indexOf("{") + 1, fn.lastIndexOf("}"))
            ].join("\n");
            this.workerSourceURL = URL.createObjectURL(new Blob([
                body
            ]));
        });
        return this.decoderPending;
    }
    _getWorker(taskID, taskCost) {
        return this._initDecoder().then(()=>{
            if (this.workerPool.length < this.workerLimit) {
                const worker = new Worker(this.workerSourceURL);
                worker._callbacks = {};
                worker._taskCosts = {};
                worker._taskLoad = 0;
                worker.postMessage({
                    type: "init",
                    decoderConfig: this.decoderConfig
                });
                worker.onmessage = function(e) {
                    const message = e.data;
                    switch(message.type){
                        case "decode":
                            worker._callbacks[message.id].resolve(message);
                            break;
                        case "error":
                            worker._callbacks[message.id].reject(message);
                            break;
                        default:
                            console.error('THREE.DRACOLoader: Unexpected message, "' + message.type + '"');
                    }
                };
                this.workerPool.push(worker);
            } else this.workerPool.sort(function(a, b) {
                return a._taskLoad > b._taskLoad ? -1 : 1;
            });
            const worker = this.workerPool[this.workerPool.length - 1];
            worker._taskCosts[taskID] = taskCost;
            worker._taskLoad += taskCost;
            return worker;
        });
    }
    _releaseTask(worker, taskID) {
        worker._taskLoad -= worker._taskCosts[taskID];
        delete worker._callbacks[taskID];
        delete worker._taskCosts[taskID];
    }
    debug() {
        console.log("Task load: ", this.workerPool.map((worker)=>worker._taskLoad));
    }
    dispose() {
        for(let i = 0; i < this.workerPool.length; ++i)this.workerPool[i].terminate();
        this.workerPool.length = 0;
        if (this.workerSourceURL !== "") URL.revokeObjectURL(this.workerSourceURL);
        return this;
    }
}
/* WEB WORKER */ function $c9d3829446f00917$var$DRACOWorker() {
    let decoderConfig;
    let decoderPending;
    onmessage = function(e) {
        const message = e.data;
        switch(message.type){
            case "init":
                decoderConfig = message.decoderConfig;
                decoderPending = new Promise(function(resolve /*, reject*/ ) {
                    decoderConfig.onModuleLoaded = function(draco) {
                        // Module is Promise-like. Wrap before resolving to avoid loop.
                        resolve({
                            draco: draco
                        });
                    };
                    DracoDecoderModule(decoderConfig); // eslint-disable-line no-undef
                });
                break;
            case "decode":
                const buffer = message.buffer;
                const taskConfig = message.taskConfig;
                decoderPending.then((module)=>{
                    const draco = module.draco;
                    const decoder = new draco.Decoder();
                    try {
                        const geometry = decodeGeometry(draco, decoder, new Int8Array(buffer), taskConfig);
                        const buffers = geometry.attributes.map((attr)=>attr.array.buffer);
                        if (geometry.index) buffers.push(geometry.index.array.buffer);
                        self.postMessage({
                            type: "decode",
                            id: message.id,
                            geometry: geometry
                        }, buffers);
                    } catch (error) {
                        console.error(error);
                        self.postMessage({
                            type: "error",
                            id: message.id,
                            error: error.message
                        });
                    } finally{
                        draco.destroy(decoder);
                    }
                });
                break;
        }
    };
    function decodeGeometry(draco, decoder, array, taskConfig) {
        const attributeIDs = taskConfig.attributeIDs;
        const attributeTypes = taskConfig.attributeTypes;
        let dracoGeometry;
        let decodingStatus;
        const geometryType = decoder.GetEncodedGeometryType(array);
        if (geometryType === draco.TRIANGULAR_MESH) {
            dracoGeometry = new draco.Mesh();
            decodingStatus = decoder.DecodeArrayToMesh(array, array.byteLength, dracoGeometry);
        } else if (geometryType === draco.POINT_CLOUD) {
            dracoGeometry = new draco.PointCloud();
            decodingStatus = decoder.DecodeArrayToPointCloud(array, array.byteLength, dracoGeometry);
        } else throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
        if (!decodingStatus.ok() || dracoGeometry.ptr === 0) throw new Error("THREE.DRACOLoader: Decoding failed: " + decodingStatus.error_msg());
        const geometry = {
            index: null,
            attributes: []
        };
        // Gather all vertex attributes.
        for(const attributeName in attributeIDs){
            const attributeType = self[attributeTypes[attributeName]];
            let attribute;
            let attributeID;
            // A Draco file may be created with default vertex attributes, whose attribute IDs
            // are mapped 1:1 from their semantic name (POSITION, NORMAL, ...). Alternatively,
            // a Draco file may contain a custom set of attributes, identified by known unique
            // IDs. glTF files always do the latter, and `.drc` files typically do the former.
            if (taskConfig.useUniqueIDs) {
                attributeID = attributeIDs[attributeName];
                attribute = decoder.GetAttributeByUniqueId(dracoGeometry, attributeID);
            } else {
                attributeID = decoder.GetAttributeId(dracoGeometry, draco[attributeIDs[attributeName]]);
                if (attributeID === -1) continue;
                attribute = decoder.GetAttribute(dracoGeometry, attributeID);
            }
            const attributeResult = decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute);
            if (attributeName === "color") attributeResult.vertexColorSpace = taskConfig.vertexColorSpace;
            geometry.attributes.push(attributeResult);
        }
        // Add index.
        if (geometryType === draco.TRIANGULAR_MESH) geometry.index = decodeIndex(draco, decoder, dracoGeometry);
        draco.destroy(dracoGeometry);
        return geometry;
    }
    function decodeIndex(draco, decoder, dracoGeometry) {
        const numFaces = dracoGeometry.num_faces();
        const numIndices = numFaces * 3;
        const byteLength = numIndices * 4;
        const ptr = draco._malloc(byteLength);
        decoder.GetTrianglesUInt32Array(dracoGeometry, byteLength, ptr);
        const index = new Uint32Array(draco.HEAPF32.buffer, ptr, numIndices).slice();
        draco._free(ptr);
        return {
            array: index,
            itemSize: 1
        };
    }
    function decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute) {
        const numComponents = attribute.num_components();
        const numPoints = dracoGeometry.num_points();
        const numValues = numPoints * numComponents;
        const byteLength = numValues * attributeType.BYTES_PER_ELEMENT;
        const dataType = getDracoDataType(draco, attributeType);
        const ptr = draco._malloc(byteLength);
        decoder.GetAttributeDataArrayForAllPoints(dracoGeometry, attribute, dataType, byteLength, ptr);
        const array = new attributeType(draco.HEAPF32.buffer, ptr, numValues).slice();
        draco._free(ptr);
        return {
            name: attributeName,
            array: array,
            itemSize: numComponents
        };
    }
    function getDracoDataType(draco, attributeType) {
        switch(attributeType){
            case Float32Array:
                return draco.DT_FLOAT32;
            case Int8Array:
                return draco.DT_INT8;
            case Int16Array:
                return draco.DT_INT16;
            case Int32Array:
                return draco.DT_INT32;
            case Uint8Array:
                return draco.DT_UINT8;
            case Uint16Array:
                return draco.DT_UINT16;
            case Uint32Array:
                return draco.DT_UINT32;
        }
    }
}




function $a3a83ae92476a547$export$676e3e70c930f774(geometry, MikkTSpace, negateSign = true) {
    if (!MikkTSpace || !MikkTSpace.isReady) throw new Error("BufferGeometryUtils: Initialized MikkTSpace library required.");
    if (!geometry.hasAttribute("position") || !geometry.hasAttribute("normal") || !geometry.hasAttribute("uv")) throw new Error('BufferGeometryUtils: Tangents require "position", "normal", and "uv" attributes.');
    function getAttributeArray(attribute) {
        if (attribute.normalized || attribute.isInterleavedBufferAttribute) {
            const dstArray = new Float32Array(attribute.count * attribute.itemSize);
            for(let i = 0, j = 0; i < attribute.count; i++){
                dstArray[j++] = attribute.getX(i);
                dstArray[j++] = attribute.getY(i);
                if (attribute.itemSize > 2) dstArray[j++] = attribute.getZ(i);
            }
            return dstArray;
        }
        if (attribute.array instanceof Float32Array) return attribute.array;
        return new Float32Array(attribute.array);
    }
    // MikkTSpace algorithm requires non-indexed input.
    const _geometry = geometry.index ? geometry.toNonIndexed() : geometry;
    // Compute vertex tangents.
    const tangents = MikkTSpace.generateTangents(getAttributeArray(_geometry.attributes.position), getAttributeArray(_geometry.attributes.normal), getAttributeArray(_geometry.attributes.uv));
    // Texture coordinate convention of glTF differs from the apparent
    // default of the MikkTSpace library; .w component must be flipped.
    if (negateSign) for(let i = 3; i < tangents.length; i += 4)tangents[i] *= -1;
    //
    _geometry.setAttribute("tangent", new (0, $0147bee01cff6558$export$8dea267bd6bde117)(tangents, 4));
    if (geometry !== _geometry) geometry.copy(_geometry);
    return geometry;
}
/**
 * @param  {Array<BufferGeometry>} geometries
 * @param  {Boolean} useGroups
 * @return {BufferGeometry}
 */ function $a3a83ae92476a547$export$f06f69b3bf41d25c(geometries, useGroups = false) {
    const isIndexed = geometries[0].index !== null;
    const attributesUsed = new Set(Object.keys(geometries[0].attributes));
    const morphAttributesUsed = new Set(Object.keys(geometries[0].morphAttributes));
    const attributes = {};
    const morphAttributes = {};
    const morphTargetsRelative = geometries[0].morphTargetsRelative;
    const mergedGeometry = new (0, $0147bee01cff6558$export$b7be63a67df8959)();
    let offset = 0;
    for(let i = 0; i < geometries.length; ++i){
        const geometry = geometries[i];
        let attributesCount = 0;
        // ensure that all geometries are indexed, or none
        if (isIndexed !== (geometry.index !== null)) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.");
            return null;
        }
        // gather attributes, exit early if they're different
        for(const name in geometry.attributes){
            if (!attributesUsed.has(name)) {
                console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.');
                return null;
            }
            if (attributes[name] === undefined) attributes[name] = [];
            attributes[name].push(geometry.attributes[name]);
            attributesCount++;
        }
        // ensure geometries have the same number of attributes
        if (attributesCount !== attributesUsed.size) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ". Make sure all geometries have the same number of attributes.");
            return null;
        }
        // gather morph attributes, exit early if they're different
        if (morphTargetsRelative !== geometry.morphTargetsRelative) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ". .morphTargetsRelative must be consistent throughout all geometries.");
            return null;
        }
        for(const name in geometry.morphAttributes){
            if (!morphAttributesUsed.has(name)) {
                console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ".  .morphAttributes must be consistent throughout all geometries.");
                return null;
            }
            if (morphAttributes[name] === undefined) morphAttributes[name] = [];
            morphAttributes[name].push(geometry.morphAttributes[name]);
        }
        if (useGroups) {
            let count;
            if (isIndexed) count = geometry.index.count;
            else if (geometry.attributes.position !== undefined) count = geometry.attributes.position.count;
            else {
                console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ". The geometry must have either an index or a position attribute");
                return null;
            }
            mergedGeometry.addGroup(offset, count, i);
            offset += count;
        }
    }
    // merge indices
    if (isIndexed) {
        let indexOffset = 0;
        const mergedIndex = [];
        for(let i = 0; i < geometries.length; ++i){
            const index = geometries[i].index;
            for(let j = 0; j < index.count; ++j)mergedIndex.push(index.getX(j) + indexOffset);
            indexOffset += geometries[i].attributes.position.count;
        }
        mergedGeometry.setIndex(mergedIndex);
    }
    // merge attributes
    for(const name in attributes){
        const mergedAttribute = $a3a83ae92476a547$export$9f98db6234c4bd78(attributes[name]);
        if (!mergedAttribute) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + name + " attribute.");
            return null;
        }
        mergedGeometry.setAttribute(name, mergedAttribute);
    }
    // merge morph attributes
    for(const name in morphAttributes){
        const numMorphTargets = morphAttributes[name][0].length;
        if (numMorphTargets === 0) break;
        mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
        mergedGeometry.morphAttributes[name] = [];
        for(let i = 0; i < numMorphTargets; ++i){
            const morphAttributesToMerge = [];
            for(let j = 0; j < morphAttributes[name].length; ++j)morphAttributesToMerge.push(morphAttributes[name][j][i]);
            const mergedMorphAttribute = $a3a83ae92476a547$export$9f98db6234c4bd78(morphAttributesToMerge);
            if (!mergedMorphAttribute) {
                console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + name + " morphAttribute.");
                return null;
            }
            mergedGeometry.morphAttributes[name].push(mergedMorphAttribute);
        }
    }
    return mergedGeometry;
}
/**
 * @param {Array<BufferAttribute>} attributes
 * @return {BufferAttribute}
 */ function $a3a83ae92476a547$export$9f98db6234c4bd78(attributes) {
    let TypedArray;
    let itemSize;
    let normalized;
    let gpuType = -1;
    let arrayLength = 0;
    for(let i = 0; i < attributes.length; ++i){
        const attribute = attributes[i];
        if (attribute.isInterleavedBufferAttribute) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. InterleavedBufferAttributes are not supported.");
            return null;
        }
        if (TypedArray === undefined) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.");
            return null;
        }
        if (itemSize === undefined) itemSize = attribute.itemSize;
        if (itemSize !== attribute.itemSize) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.");
            return null;
        }
        if (normalized === undefined) normalized = attribute.normalized;
        if (normalized !== attribute.normalized) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.");
            return null;
        }
        if (gpuType === -1) gpuType = attribute.gpuType;
        if (gpuType !== attribute.gpuType) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.gpuType must be consistent across matching attributes.");
            return null;
        }
        arrayLength += attribute.array.length;
    }
    const array = new TypedArray(arrayLength);
    let offset = 0;
    for(let i = 0; i < attributes.length; ++i){
        array.set(attributes[i].array, offset);
        offset += attributes[i].array.length;
    }
    const result = new (0, $0147bee01cff6558$export$8dea267bd6bde117)(array, itemSize, normalized);
    if (gpuType !== undefined) result.gpuType = gpuType;
    return result;
}
function $a3a83ae92476a547$export$4848639a9adff548(attribute) {
    if (attribute.isInstancedInterleavedBufferAttribute || attribute.isInterleavedBufferAttribute) return $a3a83ae92476a547$export$4b7aa2f2134b7e19(attribute);
    if (attribute.isInstancedBufferAttribute) return new (0, $0147bee01cff6558$export$32ea87a8b54d744a)().copy(attribute);
    return new (0, $0147bee01cff6558$export$8dea267bd6bde117)().copy(attribute);
}
/**
 * @param {Array<BufferAttribute>} attributes
 * @return {Array<InterleavedBufferAttribute>}
 */ function $a3a83ae92476a547$export$308f9509e428a845(attributes) {
    // Interleaves the provided attributes into an InterleavedBuffer and returns
    // a set of InterleavedBufferAttributes for each attribute
    let TypedArray;
    let arrayLength = 0;
    let stride = 0;
    // calculate the length and type of the interleavedBuffer
    for(let i = 0, l = attributes.length; i < l; ++i){
        const attribute = attributes[i];
        if (TypedArray === undefined) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error("AttributeBuffers of different types cannot be interleaved");
            return null;
        }
        arrayLength += attribute.array.length;
        stride += attribute.itemSize;
    }
    // Create the set of buffer attributes
    const interleavedBuffer = new (0, $0147bee01cff6558$export$3d5cd879f108f53f)(new TypedArray(arrayLength), stride);
    let offset = 0;
    const res = [];
    const getters = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ];
    const setters = [
        "setX",
        "setY",
        "setZ",
        "setW"
    ];
    for(let j = 0, l = attributes.length; j < l; j++){
        const attribute = attributes[j];
        const itemSize = attribute.itemSize;
        const count = attribute.count;
        const iba = new (0, $0147bee01cff6558$export$920b6d07334599c7)(interleavedBuffer, itemSize, offset, attribute.normalized);
        res.push(iba);
        offset += itemSize;
        // Move the data for each attribute into the new interleavedBuffer
        // at the appropriate offset
        for(let c = 0; c < count; c++)for(let k = 0; k < itemSize; k++)iba[setters[k]](c, attribute[getters[k]](c));
    }
    return res;
}
function $a3a83ae92476a547$export$4b7aa2f2134b7e19(attribute) {
    const cons = attribute.data.array.constructor;
    const count = attribute.count;
    const itemSize = attribute.itemSize;
    const normalized = attribute.normalized;
    const array = new cons(count * itemSize);
    let newAttribute;
    if (attribute.isInstancedInterleavedBufferAttribute) newAttribute = new (0, $0147bee01cff6558$export$32ea87a8b54d744a)(array, itemSize, normalized, attribute.meshPerAttribute);
    else newAttribute = new (0, $0147bee01cff6558$export$8dea267bd6bde117)(array, itemSize, normalized);
    for(let i = 0; i < count; i++){
        newAttribute.setX(i, attribute.getX(i));
        if (itemSize >= 2) newAttribute.setY(i, attribute.getY(i));
        if (itemSize >= 3) newAttribute.setZ(i, attribute.getZ(i));
        if (itemSize >= 4) newAttribute.setW(i, attribute.getW(i));
    }
    return newAttribute;
}
function $a3a83ae92476a547$export$e7413b17bfaaa80b(geometry) {
    const attributes = geometry.attributes;
    const morphTargets = geometry.morphTargets;
    const attrMap = new Map();
    for(const key in attributes){
        const attr = attributes[key];
        if (attr.isInterleavedBufferAttribute) {
            if (!attrMap.has(attr)) attrMap.set(attr, $a3a83ae92476a547$export$4b7aa2f2134b7e19(attr));
            attributes[key] = attrMap.get(attr);
        }
    }
    for(const key in morphTargets){
        const attr = morphTargets[key];
        if (attr.isInterleavedBufferAttribute) {
            if (!attrMap.has(attr)) attrMap.set(attr, $a3a83ae92476a547$export$4b7aa2f2134b7e19(attr));
            morphTargets[key] = attrMap.get(attr);
        }
    }
}
/**
 * @param {Array<BufferGeometry>} geometry
 * @return {number}
 */ function $a3a83ae92476a547$export$35bee7999e19754d(geometry) {
    // Return the estimated memory used by this geometry in bytes
    // Calculate using itemSize, count, and BYTES_PER_ELEMENT to account
    // for InterleavedBufferAttributes.
    let mem = 0;
    for(const name in geometry.attributes){
        const attr = geometry.getAttribute(name);
        mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;
    }
    const indices = geometry.getIndex();
    mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
    return mem;
}
/**
 * @param {BufferGeometry} geometry
 * @param {number} tolerance
 * @return {BufferGeometry}
 */ function $a3a83ae92476a547$export$e36bb98c4c944f9(geometry, tolerance = 1e-4) {
    tolerance = Math.max(tolerance, Number.EPSILON);
    // Generate an index buffer if the geometry doesn't have one, or optimize it
    // if it's already available.
    const hashToIndex = {};
    const indices = geometry.getIndex();
    const positions = geometry.getAttribute("position");
    const vertexCount = indices ? indices.count : positions.count;
    // next value for triangle indices
    let nextIndex = 0;
    // attributes and new attribute arrays
    const attributeNames = Object.keys(geometry.attributes);
    const tmpAttributes = {};
    const tmpMorphAttributes = {};
    const newIndices = [];
    const getters = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ];
    const setters = [
        "setX",
        "setY",
        "setZ",
        "setW"
    ];
    // Initialize the arrays, allocating space conservatively. Extra
    // space will be trimmed in the last step.
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        const attr = geometry.attributes[name];
        tmpAttributes[name] = new (0, $0147bee01cff6558$export$8dea267bd6bde117)(new attr.array.constructor(attr.count * attr.itemSize), attr.itemSize, attr.normalized);
        const morphAttr = geometry.morphAttributes[name];
        if (morphAttr) tmpMorphAttributes[name] = new (0, $0147bee01cff6558$export$8dea267bd6bde117)(new morphAttr.array.constructor(morphAttr.count * morphAttr.itemSize), morphAttr.itemSize, morphAttr.normalized);
    }
    // convert the error tolerance to an amount of decimal places to truncate to
    const decimalShift = Math.log10(1 / tolerance);
    const shiftMultiplier = Math.pow(10, decimalShift);
    for(let i = 0; i < vertexCount; i++){
        const index = indices ? indices.getX(i) : i;
        // Generate a hash for the vertex attributes at the current index 'i'
        let hash = "";
        for(let j = 0, l = attributeNames.length; j < l; j++){
            const name = attributeNames[j];
            const attribute = geometry.getAttribute(name);
            const itemSize = attribute.itemSize;
            for(let k = 0; k < itemSize; k++)// double tilde truncates the decimal value
            hash += `${~~(attribute[getters[k]](index) * shiftMultiplier)},`;
        }
        // Add another reference to the vertex if it's already
        // used by another index
        if (hash in hashToIndex) newIndices.push(hashToIndex[hash]);
        else {
            // copy data to the new index in the temporary attributes
            for(let j = 0, l = attributeNames.length; j < l; j++){
                const name = attributeNames[j];
                const attribute = geometry.getAttribute(name);
                const morphAttr = geometry.morphAttributes[name];
                const itemSize = attribute.itemSize;
                const newarray = tmpAttributes[name];
                const newMorphArrays = tmpMorphAttributes[name];
                for(let k = 0; k < itemSize; k++){
                    const getterFunc = getters[k];
                    const setterFunc = setters[k];
                    newarray[setterFunc](nextIndex, attribute[getterFunc](index));
                    if (morphAttr) for(let m = 0, ml = morphAttr.length; m < ml; m++)newMorphArrays[m][setterFunc](nextIndex, morphAttr[m][getterFunc](index));
                }
            }
            hashToIndex[hash] = nextIndex;
            newIndices.push(nextIndex);
            nextIndex++;
        }
    }
    // generate result BufferGeometry
    const result = geometry.clone();
    for(const name in geometry.attributes){
        const tmpAttribute = tmpAttributes[name];
        result.setAttribute(name, new (0, $0147bee01cff6558$export$8dea267bd6bde117)(tmpAttribute.array.slice(0, nextIndex * tmpAttribute.itemSize), tmpAttribute.itemSize, tmpAttribute.normalized));
        if (!(name in tmpMorphAttributes)) continue;
        for(let j = 0; j < tmpMorphAttributes[name].length; j++){
            const tmpMorphAttribute = tmpMorphAttributes[name][j];
            result.morphAttributes[name][j] = new (0, $0147bee01cff6558$export$8dea267bd6bde117)(tmpMorphAttribute.array.slice(0, nextIndex * tmpMorphAttribute.itemSize), tmpMorphAttribute.itemSize, tmpMorphAttribute.normalized);
        }
    }
    // indices
    result.setIndex(newIndices);
    return result;
}
/**
 * @param {BufferGeometry} geometry
 * @param {number} drawMode
 * @return {BufferGeometry}
 */ function $a3a83ae92476a547$export$5492ca6e5c0c7aa0(geometry, drawMode) {
    if (drawMode === (0, $0147bee01cff6558$export$4c28c87c2dc84758)) {
        console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.");
        return geometry;
    }
    if (drawMode === (0, $0147bee01cff6558$export$f0d8293634f88842) || drawMode === (0, $0147bee01cff6558$export$b23a071aa286eb29)) {
        let index = geometry.getIndex();
        // generate index if not present
        if (index === null) {
            const indices = [];
            const position = geometry.getAttribute("position");
            if (position !== undefined) {
                for(let i = 0; i < position.count; i++)indices.push(i);
                geometry.setIndex(indices);
                index = geometry.getIndex();
            } else {
                console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.");
                return geometry;
            }
        }
        //
        const numberOfTriangles = index.count - 2;
        const newIndices = [];
        if (drawMode === (0, $0147bee01cff6558$export$f0d8293634f88842)) // gl.TRIANGLE_FAN
        for(let i = 1; i <= numberOfTriangles; i++){
            newIndices.push(index.getX(0));
            newIndices.push(index.getX(i));
            newIndices.push(index.getX(i + 1));
        }
        else {
            // gl.TRIANGLE_STRIP
            for(let i = 0; i < numberOfTriangles; i++)if (i % 2 === 0) {
                newIndices.push(index.getX(i));
                newIndices.push(index.getX(i + 1));
                newIndices.push(index.getX(i + 2));
            } else {
                newIndices.push(index.getX(i + 2));
                newIndices.push(index.getX(i + 1));
                newIndices.push(index.getX(i));
            }
        }
        if (newIndices.length / 3 !== numberOfTriangles) console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
        // build final geometry
        const newGeometry = geometry.clone();
        newGeometry.setIndex(newIndices);
        newGeometry.clearGroups();
        return newGeometry;
    } else {
        console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", drawMode);
        return geometry;
    }
}
/**
 * Calculates the morphed attributes of a morphed/skinned BufferGeometry.
 * Helpful for Raytracing or Decals.
 * @param {Mesh | Line | Points} object An instance of Mesh, Line or Points.
 * @return {Object} An Object with original position/normal attributes and morphed ones.
 */ function $a3a83ae92476a547$export$29e54e2e4ab904e7(object) {
    const _vA = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
    const _vB = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
    const _vC = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
    const _tempA = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
    const _tempB = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
    const _tempC = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
    const _morphA = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
    const _morphB = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
    const _morphC = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
    function _calculateMorphedAttributeData(object, attribute, morphAttribute, morphTargetsRelative, a, b, c, modifiedAttributeArray) {
        _vA.fromBufferAttribute(attribute, a);
        _vB.fromBufferAttribute(attribute, b);
        _vC.fromBufferAttribute(attribute, c);
        const morphInfluences = object.morphTargetInfluences;
        if (morphAttribute && morphInfluences) {
            _morphA.set(0, 0, 0);
            _morphB.set(0, 0, 0);
            _morphC.set(0, 0, 0);
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const influence = morphInfluences[i];
                const morph = morphAttribute[i];
                if (influence === 0) continue;
                _tempA.fromBufferAttribute(morph, a);
                _tempB.fromBufferAttribute(morph, b);
                _tempC.fromBufferAttribute(morph, c);
                if (morphTargetsRelative) {
                    _morphA.addScaledVector(_tempA, influence);
                    _morphB.addScaledVector(_tempB, influence);
                    _morphC.addScaledVector(_tempC, influence);
                } else {
                    _morphA.addScaledVector(_tempA.sub(_vA), influence);
                    _morphB.addScaledVector(_tempB.sub(_vB), influence);
                    _morphC.addScaledVector(_tempC.sub(_vC), influence);
                }
            }
            _vA.add(_morphA);
            _vB.add(_morphB);
            _vC.add(_morphC);
        }
        if (object.isSkinnedMesh) {
            object.applyBoneTransform(a, _vA);
            object.applyBoneTransform(b, _vB);
            object.applyBoneTransform(c, _vC);
        }
        modifiedAttributeArray[a * 3 + 0] = _vA.x;
        modifiedAttributeArray[a * 3 + 1] = _vA.y;
        modifiedAttributeArray[a * 3 + 2] = _vA.z;
        modifiedAttributeArray[b * 3 + 0] = _vB.x;
        modifiedAttributeArray[b * 3 + 1] = _vB.y;
        modifiedAttributeArray[b * 3 + 2] = _vB.z;
        modifiedAttributeArray[c * 3 + 0] = _vC.x;
        modifiedAttributeArray[c * 3 + 1] = _vC.y;
        modifiedAttributeArray[c * 3 + 2] = _vC.z;
    }
    const geometry = object.geometry;
    const material = object.material;
    let a, b, c;
    const index = geometry.index;
    const positionAttribute = geometry.attributes.position;
    const morphPosition = geometry.morphAttributes.position;
    const morphTargetsRelative = geometry.morphTargetsRelative;
    const normalAttribute = geometry.attributes.normal;
    const morphNormal = geometry.morphAttributes.position;
    const groups = geometry.groups;
    const drawRange = geometry.drawRange;
    let i, j, il, jl;
    let group;
    let start, end;
    const modifiedPosition = new Float32Array(positionAttribute.count * positionAttribute.itemSize);
    const modifiedNormal = new Float32Array(normalAttribute.count * normalAttribute.itemSize);
    if (index !== null) {
        // indexed buffer geometry
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = index.getX(j);
                b = index.getX(j + 1);
                c = index.getX(j + 2);
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(index.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = index.getX(i);
                b = index.getX(i + 1);
                c = index.getX(i + 2);
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    } else {
        // non-indexed buffer geometry
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = j;
                b = j + 1;
                c = j + 2;
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = i;
                b = i + 1;
                c = i + 2;
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    }
    const morphedPositionAttribute = new (0, $0147bee01cff6558$export$cbe7a62641830ebd)(modifiedPosition, 3);
    const morphedNormalAttribute = new (0, $0147bee01cff6558$export$cbe7a62641830ebd)(modifiedNormal, 3);
    return {
        positionAttribute: positionAttribute,
        normalAttribute: normalAttribute,
        morphedPositionAttribute: morphedPositionAttribute,
        morphedNormalAttribute: morphedNormalAttribute
    };
}
function $a3a83ae92476a547$export$8babbf41197098b1(geometry) {
    if (geometry.groups.length === 0) {
        console.warn("THREE.BufferGeometryUtils.mergeGroups(): No groups are defined. Nothing to merge.");
        return geometry;
    }
    let groups = geometry.groups;
    // sort groups by material index
    groups = groups.sort((a, b)=>{
        if (a.materialIndex !== b.materialIndex) return a.materialIndex - b.materialIndex;
        return a.start - b.start;
    });
    // create index for non-indexed geometries
    if (geometry.getIndex() === null) {
        const positionAttribute = geometry.getAttribute("position");
        const indices = [];
        for(let i = 0; i < positionAttribute.count; i += 3)indices.push(i, i + 1, i + 2);
        geometry.setIndex(indices);
    }
    // sort index
    const index = geometry.getIndex();
    const newIndices = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        const groupStart = group.start;
        const groupLength = groupStart + group.count;
        for(let j = groupStart; j < groupLength; j++)newIndices.push(index.getX(j));
    }
    geometry.dispose(); // Required to force buffer recreation
    geometry.setIndex(newIndices);
    // update groups indices
    let start = 0;
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        group.start = start;
        start += group.count;
    }
    // merge groups
    let currentGroup = groups[0];
    geometry.groups = [
        currentGroup
    ];
    for(let i = 1; i < groups.length; i++){
        const group = groups[i];
        if (currentGroup.materialIndex === group.materialIndex) currentGroup.count += group.count;
        else {
            currentGroup = group;
            geometry.groups.push(currentGroup);
        }
    }
    return geometry;
}
/**
 * Modifies the supplied geometry if it is non-indexed, otherwise creates a new,
 * non-indexed geometry. Returns the geometry with smooth normals everywhere except
 * faces that meet at an angle greater than the crease angle.
 *
 * @param {BufferGeometry} geometry
 * @param {number} [creaseAngle]
 * @return {BufferGeometry}
 */ function $a3a83ae92476a547$export$b525764477fc001f(geometry, creaseAngle = Math.PI / 3 /* 60 degrees */ ) {
    const creaseDot = Math.cos(creaseAngle);
    const hashMultiplier = (1 + 1e-10) * 1e2;
    // reusable vectors
    const verts = [
        new (0, $0147bee01cff6558$export$64b5c384219d3699)(),
        new (0, $0147bee01cff6558$export$64b5c384219d3699)(),
        new (0, $0147bee01cff6558$export$64b5c384219d3699)()
    ];
    const tempVec1 = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
    const tempVec2 = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
    const tempNorm = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
    const tempNorm2 = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
    // hashes a vector
    function hashVertex(v) {
        const x = ~~(v.x * hashMultiplier);
        const y = ~~(v.y * hashMultiplier);
        const z = ~~(v.z * hashMultiplier);
        return `${x},${y},${z}`;
    }
    // BufferGeometry.toNonIndexed() warns if the geometry is non-indexed
    // and returns the original geometry
    const resultGeometry = geometry.index ? geometry.toNonIndexed() : geometry;
    const posAttr = resultGeometry.attributes.position;
    const vertexMap = {};
    // find all the normals shared by commonly located vertices
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        // add the normal to the map for all vertices
        const normal = new (0, $0147bee01cff6558$export$64b5c384219d3699)().crossVectors(tempVec1, tempVec2).normalize();
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            if (!(hash in vertexMap)) vertexMap[hash] = [];
            vertexMap[hash].push(normal);
        }
    }
    // average normals from all vertices that share a common location if they are within the
    // provided crease threshold
    const normalArray = new Float32Array(posAttr.count * 3);
    const normAttr = new (0, $0147bee01cff6558$export$8dea267bd6bde117)(normalArray, 3, false);
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        // get the face normal for this vertex
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        tempNorm.crossVectors(tempVec1, tempVec2).normalize();
        // average all normals that meet the threshold and set the normal value
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            const otherNormals = vertexMap[hash];
            tempNorm2.set(0, 0, 0);
            for(let k = 0, lk = otherNormals.length; k < lk; k++){
                const otherNorm = otherNormals[k];
                if (tempNorm.dot(otherNorm) > creaseDot) tempNorm2.add(otherNorm);
            }
            tempNorm2.normalize();
            normAttr.setXYZ(i3 + n, tempNorm2.x, tempNorm2.y, tempNorm2.z);
        }
    }
    resultGeometry.setAttribute("normal", normAttr);
    return resultGeometry;
}
function $a3a83ae92476a547$export$728c051ccdf8a702(geometries, useGroups = false) {
    console.warn("THREE.BufferGeometryUtils: mergeBufferGeometries() has been renamed to mergeGeometries()."); // @deprecated, r151
    return $a3a83ae92476a547$export$f06f69b3bf41d25c(geometries, useGroups);
}
function $a3a83ae92476a547$export$c4eef4c1c9d34ea9(attributes) {
    console.warn("THREE.BufferGeometryUtils: mergeBufferAttributes() has been renamed to mergeAttributes()."); // @deprecated, r151
    return $a3a83ae92476a547$export$9f98db6234c4bd78(attributes);
}


class $3af46d7a32572744$export$aa93f11e7884f0f4 extends (0, $0147bee01cff6558$export$3b0d6d7590275603) {
    constructor(manager){
        super(manager);
        this.dracoLoader = null;
        this.ktx2Loader = null;
        this.meshoptDecoder = null;
        this.pluginCallbacks = [];
        this.register(function(parser) {
            return new $3af46d7a32572744$var$GLTFMaterialsClearcoatExtension(parser);
        });
        this.register(function(parser) {
            return new $3af46d7a32572744$var$GLTFTextureBasisUExtension(parser);
        });
        this.register(function(parser) {
            return new $3af46d7a32572744$var$GLTFTextureWebPExtension(parser);
        });
        this.register(function(parser) {
            return new $3af46d7a32572744$var$GLTFTextureAVIFExtension(parser);
        });
        this.register(function(parser) {
            return new $3af46d7a32572744$var$GLTFMaterialsSheenExtension(parser);
        });
        this.register(function(parser) {
            return new $3af46d7a32572744$var$GLTFMaterialsTransmissionExtension(parser);
        });
        this.register(function(parser) {
            return new $3af46d7a32572744$var$GLTFMaterialsVolumeExtension(parser);
        });
        this.register(function(parser) {
            return new $3af46d7a32572744$var$GLTFMaterialsIorExtension(parser);
        });
        this.register(function(parser) {
            return new $3af46d7a32572744$var$GLTFMaterialsEmissiveStrengthExtension(parser);
        });
        this.register(function(parser) {
            return new $3af46d7a32572744$var$GLTFMaterialsSpecularExtension(parser);
        });
        this.register(function(parser) {
            return new $3af46d7a32572744$var$GLTFMaterialsIridescenceExtension(parser);
        });
        this.register(function(parser) {
            return new $3af46d7a32572744$var$GLTFMaterialsAnisotropyExtension(parser);
        });
        this.register(function(parser) {
            return new $3af46d7a32572744$var$GLTFLightsExtension(parser);
        });
        this.register(function(parser) {
            return new $3af46d7a32572744$var$GLTFMeshoptCompression(parser);
        });
        this.register(function(parser) {
            return new $3af46d7a32572744$var$GLTFMeshGpuInstancing(parser);
        });
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        let resourcePath;
        if (this.resourcePath !== "") resourcePath = this.resourcePath;
        else if (this.path !== "") resourcePath = this.path;
        else resourcePath = (0, $0147bee01cff6558$export$b5d2dc08d867e41a).extractUrlBase(url);
        // Tells the LoadingManager to track an extra item, which resolves after
        // the model is fully loaded. This means the count of items loaded will
        // be incorrect, but ensures manager.onLoad() does not fire early.
        this.manager.itemStart(url);
        const _onError = function(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        };
        const loader = new (0, $0147bee01cff6558$export$98435a25b5cf7b2b)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(data) {
            try {
                scope.parse(data, resourcePath, function(gltf) {
                    onLoad(gltf);
                    scope.manager.itemEnd(url);
                }, _onError);
            } catch (e) {
                _onError(e);
            }
        }, onProgress, _onError);
    }
    setDRACOLoader(dracoLoader) {
        this.dracoLoader = dracoLoader;
        return this;
    }
    setDDSLoader() {
        throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
    }
    setKTX2Loader(ktx2Loader) {
        this.ktx2Loader = ktx2Loader;
        return this;
    }
    setMeshoptDecoder(meshoptDecoder) {
        this.meshoptDecoder = meshoptDecoder;
        return this;
    }
    register(callback) {
        if (this.pluginCallbacks.indexOf(callback) === -1) this.pluginCallbacks.push(callback);
        return this;
    }
    unregister(callback) {
        if (this.pluginCallbacks.indexOf(callback) !== -1) this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
        return this;
    }
    parse(data, path, onLoad, onError) {
        let json;
        const extensions = {};
        const plugins = {};
        const textDecoder = new TextDecoder();
        if (typeof data === "string") json = JSON.parse(data);
        else if (data instanceof ArrayBuffer) {
            const magic = textDecoder.decode(new Uint8Array(data, 0, 4));
            if (magic === $3af46d7a32572744$var$BINARY_EXTENSION_HEADER_MAGIC) {
                try {
                    extensions[$3af46d7a32572744$var$EXTENSIONS.KHR_BINARY_GLTF] = new $3af46d7a32572744$var$GLTFBinaryExtension(data);
                } catch (error) {
                    if (onError) onError(error);
                    return;
                }
                json = JSON.parse(extensions[$3af46d7a32572744$var$EXTENSIONS.KHR_BINARY_GLTF].content);
            } else json = JSON.parse(textDecoder.decode(data));
        } else json = data;
        if (json.asset === undefined || json.asset.version[0] < 2) {
            if (onError) onError(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."));
            return;
        }
        const parser = new $3af46d7a32572744$var$GLTFParser(json, {
            path: path || this.resourcePath || "",
            crossOrigin: this.crossOrigin,
            requestHeader: this.requestHeader,
            manager: this.manager,
            ktx2Loader: this.ktx2Loader,
            meshoptDecoder: this.meshoptDecoder
        });
        parser.fileLoader.setRequestHeader(this.requestHeader);
        for(let i = 0; i < this.pluginCallbacks.length; i++){
            const plugin = this.pluginCallbacks[i](parser);
            plugins[plugin.name] = plugin;
            // Workaround to avoid determining as unknown extension
            // in addUnknownExtensionsToUserData().
            // Remove this workaround if we move all the existing
            // extension handlers to plugin system
            extensions[plugin.name] = true;
        }
        if (json.extensionsUsed) for(let i = 0; i < json.extensionsUsed.length; ++i){
            const extensionName = json.extensionsUsed[i];
            const extensionsRequired = json.extensionsRequired || [];
            switch(extensionName){
                case $3af46d7a32572744$var$EXTENSIONS.KHR_MATERIALS_UNLIT:
                    extensions[extensionName] = new $3af46d7a32572744$var$GLTFMaterialsUnlitExtension();
                    break;
                case $3af46d7a32572744$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
                    extensions[extensionName] = new $3af46d7a32572744$var$GLTFDracoMeshCompressionExtension(json, this.dracoLoader);
                    break;
                case $3af46d7a32572744$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM:
                    extensions[extensionName] = new $3af46d7a32572744$var$GLTFTextureTransformExtension();
                    break;
                case $3af46d7a32572744$var$EXTENSIONS.KHR_MESH_QUANTIZATION:
                    extensions[extensionName] = new $3af46d7a32572744$var$GLTFMeshQuantizationExtension();
                    break;
                default:
                    if (extensionsRequired.indexOf(extensionName) >= 0 && plugins[extensionName] === undefined) console.warn('THREE.GLTFLoader: Unknown extension "' + extensionName + '".');
            }
        }
        parser.setExtensions(extensions);
        parser.setPlugins(plugins);
        parser.parse(onLoad, onError);
    }
    parseAsync(data, path) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.parse(data, path, resolve, reject);
        });
    }
}
/* GLTFREGISTRY */ function $3af46d7a32572744$var$GLTFRegistry() {
    let objects = {};
    return {
        get: function(key) {
            return objects[key];
        },
        add: function(key, object) {
            objects[key] = object;
        },
        remove: function(key) {
            delete objects[key];
        },
        removeAll: function() {
            objects = {};
        }
    };
}
/*********************************/ /********** EXTENSIONS ***********/ /*********************************/ const $3af46d7a32572744$var$EXTENSIONS = {
    KHR_BINARY_GLTF: "KHR_binary_glTF",
    KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
    KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
    KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
    KHR_MATERIALS_IOR: "KHR_materials_ior",
    KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
    KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
    KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
    KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
    KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
    KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
    KHR_MATERIALS_VOLUME: "KHR_materials_volume",
    KHR_TEXTURE_BASISU: "KHR_texture_basisu",
    KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
    KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
    KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
    EXT_TEXTURE_WEBP: "EXT_texture_webp",
    EXT_TEXTURE_AVIF: "EXT_texture_avif",
    EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
    EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
};
/**
 * Punctual Lights Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_lights_punctual
 */ class $3af46d7a32572744$var$GLTFLightsExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $3af46d7a32572744$var$EXTENSIONS.KHR_LIGHTS_PUNCTUAL;
        // Object3D instance caches
        this.cache = {
            refs: {},
            uses: {}
        };
    }
    _markDefs() {
        const parser = this.parser;
        const nodeDefs = this.parser.json.nodes || [];
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.extensions && nodeDef.extensions[this.name] && nodeDef.extensions[this.name].light !== undefined) parser._addNodeRef(this.cache, nodeDef.extensions[this.name].light);
        }
    }
    _loadLight(lightIndex) {
        const parser = this.parser;
        const cacheKey = "light:" + lightIndex;
        let dependency = parser.cache.get(cacheKey);
        if (dependency) return dependency;
        const json = parser.json;
        const extensions = json.extensions && json.extensions[this.name] || {};
        const lightDefs = extensions.lights || [];
        const lightDef = lightDefs[lightIndex];
        let lightNode;
        const color = new (0, $0147bee01cff6558$export$892596cec99bc70e)(0xffffff);
        if (lightDef.color !== undefined) color.fromArray(lightDef.color);
        const range = lightDef.range !== undefined ? lightDef.range : 0;
        switch(lightDef.type){
            case "directional":
                lightNode = new (0, $0147bee01cff6558$export$3fea33cc9972c868)(color);
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            case "point":
                lightNode = new (0, $0147bee01cff6558$export$4c9c1cb3f0b6f455)(color);
                lightNode.distance = range;
                break;
            case "spot":
                lightNode = new (0, $0147bee01cff6558$export$81495cbb73897362)(color);
                lightNode.distance = range;
                // Handle spotlight properties.
                lightDef.spot = lightDef.spot || {};
                lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== undefined ? lightDef.spot.innerConeAngle : 0;
                lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== undefined ? lightDef.spot.outerConeAngle : Math.PI / 4.0;
                lightNode.angle = lightDef.spot.outerConeAngle;
                lightNode.penumbra = 1.0 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            default:
                throw new Error("THREE.GLTFLoader: Unexpected light type: " + lightDef.type);
        }
        // Some lights (e.g. spot) default to a position other than the origin. Reset the position
        // here, because node-level parsing will only override position if explicitly specified.
        lightNode.position.set(0, 0, 0);
        lightNode.decay = 2;
        $3af46d7a32572744$var$assignExtrasToUserData(lightNode, lightDef);
        if (lightDef.intensity !== undefined) lightNode.intensity = lightDef.intensity;
        lightNode.name = parser.createUniqueName(lightDef.name || "light_" + lightIndex);
        dependency = Promise.resolve(lightNode);
        parser.cache.add(cacheKey, dependency);
        return dependency;
    }
    getDependency(type, index) {
        if (type !== "light") return;
        return this._loadLight(index);
    }
    createNodeAttachment(nodeIndex) {
        const self1 = this;
        const parser = this.parser;
        const json = parser.json;
        const nodeDef = json.nodes[nodeIndex];
        const lightDef = nodeDef.extensions && nodeDef.extensions[this.name] || {};
        const lightIndex = lightDef.light;
        if (lightIndex === undefined) return null;
        return this._loadLight(lightIndex).then(function(light) {
            return parser._getNodeRef(self1.cache, lightIndex, light);
        });
    }
}
/**
 * Unlit Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_unlit
 */ class $3af46d7a32572744$var$GLTFMaterialsUnlitExtension {
    constructor(){
        this.name = $3af46d7a32572744$var$EXTENSIONS.KHR_MATERIALS_UNLIT;
    }
    getMaterialType() {
        return 0, $0147bee01cff6558$export$55cbcc9b622fe1f5;
    }
    extendParams(materialParams, materialDef, parser) {
        const pending = [];
        materialParams.color = new (0, $0147bee01cff6558$export$892596cec99bc70e)(1.0, 1.0, 1.0);
        materialParams.opacity = 1.0;
        const metallicRoughness = materialDef.pbrMetallicRoughness;
        if (metallicRoughness) {
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.fromArray(array);
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, (0, $0147bee01cff6558$export$561f394b24edfcaa)));
        }
        return Promise.all(pending);
    }
}
/**
 * Materials Emissive Strength Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/blob/5768b3ce0ef32bc39cdf1bef10b948586635ead3/extensions/2.0/Khronos/KHR_materials_emissive_strength/README.md
 */ class $3af46d7a32572744$var$GLTFMaterialsEmissiveStrengthExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $3af46d7a32572744$var$EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const emissiveStrength = materialDef.extensions[this.name].emissiveStrength;
        if (emissiveStrength !== undefined) materialParams.emissiveIntensity = emissiveStrength;
        return Promise.resolve();
    }
}
/**
 * Clearcoat Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_clearcoat
 */ class $3af46d7a32572744$var$GLTFMaterialsClearcoatExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $3af46d7a32572744$var$EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $0147bee01cff6558$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.clearcoatFactor !== undefined) materialParams.clearcoat = extension.clearcoatFactor;
        if (extension.clearcoatTexture !== undefined) pending.push(parser.assignTexture(materialParams, "clearcoatMap", extension.clearcoatTexture));
        if (extension.clearcoatRoughnessFactor !== undefined) materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;
        if (extension.clearcoatRoughnessTexture !== undefined) pending.push(parser.assignTexture(materialParams, "clearcoatRoughnessMap", extension.clearcoatRoughnessTexture));
        if (extension.clearcoatNormalTexture !== undefined) {
            pending.push(parser.assignTexture(materialParams, "clearcoatNormalMap", extension.clearcoatNormalTexture));
            if (extension.clearcoatNormalTexture.scale !== undefined) {
                const scale = extension.clearcoatNormalTexture.scale;
                materialParams.clearcoatNormalScale = new (0, $0147bee01cff6558$export$c977b3e384af9ae1)(scale, scale);
            }
        }
        return Promise.all(pending);
    }
}
/**
 * Iridescence Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_iridescence
 */ class $3af46d7a32572744$var$GLTFMaterialsIridescenceExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $3af46d7a32572744$var$EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $0147bee01cff6558$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.iridescenceFactor !== undefined) materialParams.iridescence = extension.iridescenceFactor;
        if (extension.iridescenceTexture !== undefined) pending.push(parser.assignTexture(materialParams, "iridescenceMap", extension.iridescenceTexture));
        if (extension.iridescenceIor !== undefined) materialParams.iridescenceIOR = extension.iridescenceIor;
        if (materialParams.iridescenceThicknessRange === undefined) materialParams.iridescenceThicknessRange = [
            100,
            400
        ];
        if (extension.iridescenceThicknessMinimum !== undefined) materialParams.iridescenceThicknessRange[0] = extension.iridescenceThicknessMinimum;
        if (extension.iridescenceThicknessMaximum !== undefined) materialParams.iridescenceThicknessRange[1] = extension.iridescenceThicknessMaximum;
        if (extension.iridescenceThicknessTexture !== undefined) pending.push(parser.assignTexture(materialParams, "iridescenceThicknessMap", extension.iridescenceThicknessTexture));
        return Promise.all(pending);
    }
}
/**
 * Sheen Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/main/extensions/2.0/Khronos/KHR_materials_sheen
 */ class $3af46d7a32572744$var$GLTFMaterialsSheenExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $3af46d7a32572744$var$EXTENSIONS.KHR_MATERIALS_SHEEN;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $0147bee01cff6558$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        materialParams.sheenColor = new (0, $0147bee01cff6558$export$892596cec99bc70e)(0, 0, 0);
        materialParams.sheenRoughness = 0;
        materialParams.sheen = 1;
        const extension = materialDef.extensions[this.name];
        if (extension.sheenColorFactor !== undefined) materialParams.sheenColor.fromArray(extension.sheenColorFactor);
        if (extension.sheenRoughnessFactor !== undefined) materialParams.sheenRoughness = extension.sheenRoughnessFactor;
        if (extension.sheenColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, "sheenColorMap", extension.sheenColorTexture, (0, $0147bee01cff6558$export$561f394b24edfcaa)));
        if (extension.sheenRoughnessTexture !== undefined) pending.push(parser.assignTexture(materialParams, "sheenRoughnessMap", extension.sheenRoughnessTexture));
        return Promise.all(pending);
    }
}
/**
 * Transmission Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_transmission
 * Draft: https://github.com/KhronosGroup/glTF/pull/1698
 */ class $3af46d7a32572744$var$GLTFMaterialsTransmissionExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $3af46d7a32572744$var$EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $0147bee01cff6558$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.transmissionFactor !== undefined) materialParams.transmission = extension.transmissionFactor;
        if (extension.transmissionTexture !== undefined) pending.push(parser.assignTexture(materialParams, "transmissionMap", extension.transmissionTexture));
        return Promise.all(pending);
    }
}
/**
 * Materials Volume Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_volume
 */ class $3af46d7a32572744$var$GLTFMaterialsVolumeExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $3af46d7a32572744$var$EXTENSIONS.KHR_MATERIALS_VOLUME;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $0147bee01cff6558$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.thickness = extension.thicknessFactor !== undefined ? extension.thicknessFactor : 0;
        if (extension.thicknessTexture !== undefined) pending.push(parser.assignTexture(materialParams, "thicknessMap", extension.thicknessTexture));
        materialParams.attenuationDistance = extension.attenuationDistance || Infinity;
        const colorArray = extension.attenuationColor || [
            1,
            1,
            1
        ];
        materialParams.attenuationColor = new (0, $0147bee01cff6558$export$892596cec99bc70e)(colorArray[0], colorArray[1], colorArray[2]);
        return Promise.all(pending);
    }
}
/**
 * Materials ior Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_ior
 */ class $3af46d7a32572744$var$GLTFMaterialsIorExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $3af46d7a32572744$var$EXTENSIONS.KHR_MATERIALS_IOR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $0147bee01cff6558$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const extension = materialDef.extensions[this.name];
        materialParams.ior = extension.ior !== undefined ? extension.ior : 1.5;
        return Promise.resolve();
    }
}
/**
 * Materials specular Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_specular
 */ class $3af46d7a32572744$var$GLTFMaterialsSpecularExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $3af46d7a32572744$var$EXTENSIONS.KHR_MATERIALS_SPECULAR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $0147bee01cff6558$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.specularIntensity = extension.specularFactor !== undefined ? extension.specularFactor : 1.0;
        if (extension.specularTexture !== undefined) pending.push(parser.assignTexture(materialParams, "specularIntensityMap", extension.specularTexture));
        const colorArray = extension.specularColorFactor || [
            1,
            1,
            1
        ];
        materialParams.specularColor = new (0, $0147bee01cff6558$export$892596cec99bc70e)(colorArray[0], colorArray[1], colorArray[2]);
        if (extension.specularColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, "specularColorMap", extension.specularColorTexture, (0, $0147bee01cff6558$export$561f394b24edfcaa)));
        return Promise.all(pending);
    }
}
/**
 * Materials anisotropy Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_anisotropy
 */ class $3af46d7a32572744$var$GLTFMaterialsAnisotropyExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $3af46d7a32572744$var$EXTENSIONS.KHR_MATERIALS_ANISOTROPY;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $0147bee01cff6558$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.anisotropyStrength !== undefined) materialParams.anisotropy = extension.anisotropyStrength;
        if (extension.anisotropyRotation !== undefined) materialParams.anisotropyRotation = extension.anisotropyRotation;
        if (extension.anisotropyTexture !== undefined) pending.push(parser.assignTexture(materialParams, "anisotropyMap", extension.anisotropyTexture));
        return Promise.all(pending);
    }
}
/**
 * BasisU Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_basisu
 */ class $3af46d7a32572744$var$GLTFTextureBasisUExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $3af46d7a32572744$var$EXTENSIONS.KHR_TEXTURE_BASISU;
    }
    loadTexture(textureIndex) {
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[this.name]) return null;
        const extension = textureDef.extensions[this.name];
        const loader = parser.options.ktx2Loader;
        if (!loader) {
            if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
            else // Assumes that the extension is optional and that a fallback texture is present
            return null;
        }
        return parser.loadTextureImage(textureIndex, extension.source, loader);
    }
}
/**
 * WebP Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_webp
 */ class $3af46d7a32572744$var$GLTFTextureWebPExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $3af46d7a32572744$var$EXTENSIONS.EXT_TEXTURE_WEBP;
        this.isSupported = null;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
            // Fall back to PNG or JPEG.
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            // Lossy test image. Support for lossy images doesn't guarantee support for all
            // WebP images, unfortunately.
            image.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
}
/**
 * AVIF Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_avif
 */ class $3af46d7a32572744$var$GLTFTextureAVIFExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $3af46d7a32572744$var$EXTENSIONS.EXT_TEXTURE_AVIF;
        this.isSupported = null;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error("THREE.GLTFLoader: AVIF required by asset but unsupported.");
            // Fall back to PNG or JPEG.
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            // Lossy test image.
            image.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=";
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
}
/**
 * meshopt BufferView Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_meshopt_compression
 */ class $3af46d7a32572744$var$GLTFMeshoptCompression {
    constructor(parser){
        this.name = $3af46d7a32572744$var$EXTENSIONS.EXT_MESHOPT_COMPRESSION;
        this.parser = parser;
    }
    loadBufferView(index) {
        const json = this.parser.json;
        const bufferView = json.bufferViews[index];
        if (bufferView.extensions && bufferView.extensions[this.name]) {
            const extensionDef = bufferView.extensions[this.name];
            const buffer = this.parser.getDependency("buffer", extensionDef.buffer);
            const decoder = this.parser.options.meshoptDecoder;
            if (!decoder || !decoder.supported) {
                if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
                else // Assumes that the extension is optional and that fallback buffer data is present
                return null;
            }
            return buffer.then(function(res) {
                const byteOffset = extensionDef.byteOffset || 0;
                const byteLength = extensionDef.byteLength || 0;
                const count = extensionDef.count;
                const stride = extensionDef.byteStride;
                const source = new Uint8Array(res, byteOffset, byteLength);
                if (decoder.decodeGltfBufferAsync) return decoder.decodeGltfBufferAsync(count, stride, source, extensionDef.mode, extensionDef.filter).then(function(res) {
                    return res.buffer;
                });
                else // Support for MeshoptDecoder 0.18 or earlier, without decodeGltfBufferAsync
                return decoder.ready.then(function() {
                    const result = new ArrayBuffer(count * stride);
                    decoder.decodeGltfBuffer(new Uint8Array(result), count, stride, source, extensionDef.mode, extensionDef.filter);
                    return result;
                });
            });
        } else return null;
    }
}
/**
 * GPU Instancing Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_mesh_gpu_instancing
 *
 */ class $3af46d7a32572744$var$GLTFMeshGpuInstancing {
    constructor(parser){
        this.name = $3af46d7a32572744$var$EXTENSIONS.EXT_MESH_GPU_INSTANCING;
        this.parser = parser;
    }
    createNodeMesh(nodeIndex) {
        const json = this.parser.json;
        const nodeDef = json.nodes[nodeIndex];
        if (!nodeDef.extensions || !nodeDef.extensions[this.name] || nodeDef.mesh === undefined) return null;
        const meshDef = json.meshes[nodeDef.mesh];
        // No Points or Lines + Instancing support yet
        for (const primitive of meshDef.primitives){
            if (primitive.mode !== $3af46d7a32572744$var$WEBGL_CONSTANTS.TRIANGLES && primitive.mode !== $3af46d7a32572744$var$WEBGL_CONSTANTS.TRIANGLE_STRIP && primitive.mode !== $3af46d7a32572744$var$WEBGL_CONSTANTS.TRIANGLE_FAN && primitive.mode !== undefined) return null;
        }
        const extensionDef = nodeDef.extensions[this.name];
        const attributesDef = extensionDef.attributes;
        // @TODO: Can we support InstancedMesh + SkinnedMesh?
        const pending = [];
        const attributes = {};
        for(const key in attributesDef)pending.push(this.parser.getDependency("accessor", attributesDef[key]).then((accessor)=>{
            attributes[key] = accessor;
            return attributes[key];
        }));
        if (pending.length < 1) return null;
        pending.push(this.parser.createNodeMesh(nodeIndex));
        return Promise.all(pending).then((results)=>{
            const nodeObject = results.pop();
            const meshes = nodeObject.isGroup ? nodeObject.children : [
                nodeObject
            ];
            const count = results[0].count; // All attribute counts should be same
            const instancedMeshes = [];
            for (const mesh of meshes){
                // Temporal variables
                const m = new (0, $0147bee01cff6558$export$2ae72fc923e5eb5)();
                const p = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
                const q = new (0, $0147bee01cff6558$export$23d6a54f0bbc85a3)();
                const s = new (0, $0147bee01cff6558$export$64b5c384219d3699)(1, 1, 1);
                const instancedMesh = new (0, $0147bee01cff6558$export$f3c979c331175ad7)(mesh.geometry, mesh.material, count);
                for(let i = 0; i < count; i++){
                    if (attributes.TRANSLATION) p.fromBufferAttribute(attributes.TRANSLATION, i);
                    if (attributes.ROTATION) q.fromBufferAttribute(attributes.ROTATION, i);
                    if (attributes.SCALE) s.fromBufferAttribute(attributes.SCALE, i);
                    instancedMesh.setMatrixAt(i, m.compose(p, q, s));
                }
                // Add instance attributes to the geometry, excluding TRS.
                for(const attributeName in attributes)if (attributeName !== "TRANSLATION" && attributeName !== "ROTATION" && attributeName !== "SCALE") mesh.geometry.setAttribute(attributeName, attributes[attributeName]);
                // Just in case
                (0, $0147bee01cff6558$export$e4dd07dff30cc924).prototype.copy.call(instancedMesh, mesh);
                this.parser.assignFinalMaterial(instancedMesh);
                instancedMeshes.push(instancedMesh);
            }
            if (nodeObject.isGroup) {
                nodeObject.clear();
                nodeObject.add(...instancedMeshes);
                return nodeObject;
            }
            return instancedMeshes[0];
        });
    }
}
/* BINARY EXTENSION */ const $3af46d7a32572744$var$BINARY_EXTENSION_HEADER_MAGIC = "glTF";
const $3af46d7a32572744$var$BINARY_EXTENSION_HEADER_LENGTH = 12;
const $3af46d7a32572744$var$BINARY_EXTENSION_CHUNK_TYPES = {
    JSON: 0x4E4F534A,
    BIN: 0x004E4942
};
class $3af46d7a32572744$var$GLTFBinaryExtension {
    constructor(data){
        this.name = $3af46d7a32572744$var$EXTENSIONS.KHR_BINARY_GLTF;
        this.content = null;
        this.body = null;
        const headerView = new DataView(data, 0, $3af46d7a32572744$var$BINARY_EXTENSION_HEADER_LENGTH);
        const textDecoder = new TextDecoder();
        this.header = {
            magic: textDecoder.decode(new Uint8Array(data.slice(0, 4))),
            version: headerView.getUint32(4, true),
            length: headerView.getUint32(8, true)
        };
        if (this.header.magic !== $3af46d7a32572744$var$BINARY_EXTENSION_HEADER_MAGIC) throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
        else if (this.header.version < 2.0) throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
        const chunkContentsLength = this.header.length - $3af46d7a32572744$var$BINARY_EXTENSION_HEADER_LENGTH;
        const chunkView = new DataView(data, $3af46d7a32572744$var$BINARY_EXTENSION_HEADER_LENGTH);
        let chunkIndex = 0;
        while(chunkIndex < chunkContentsLength){
            const chunkLength = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            const chunkType = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            if (chunkType === $3af46d7a32572744$var$BINARY_EXTENSION_CHUNK_TYPES.JSON) {
                const contentArray = new Uint8Array(data, $3af46d7a32572744$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
                this.content = textDecoder.decode(contentArray);
            } else if (chunkType === $3af46d7a32572744$var$BINARY_EXTENSION_CHUNK_TYPES.BIN) {
                const byteOffset = $3af46d7a32572744$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
                this.body = data.slice(byteOffset, byteOffset + chunkLength);
            }
            // Clients must ignore chunks with unknown types.
            chunkIndex += chunkLength;
        }
        if (this.content === null) throw new Error("THREE.GLTFLoader: JSON content not found.");
    }
}
/**
 * DRACO Mesh Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_draco_mesh_compression
 */ class $3af46d7a32572744$var$GLTFDracoMeshCompressionExtension {
    constructor(json, dracoLoader){
        if (!dracoLoader) throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
        this.name = $3af46d7a32572744$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
        this.json = json;
        this.dracoLoader = dracoLoader;
        this.dracoLoader.preload();
    }
    decodePrimitive(primitive, parser) {
        const json = this.json;
        const dracoLoader = this.dracoLoader;
        const bufferViewIndex = primitive.extensions[this.name].bufferView;
        const gltfAttributeMap = primitive.extensions[this.name].attributes;
        const threeAttributeMap = {};
        const attributeNormalizedMap = {};
        const attributeTypeMap = {};
        for(const attributeName in gltfAttributeMap){
            const threeAttributeName = $3af46d7a32572744$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            threeAttributeMap[threeAttributeName] = gltfAttributeMap[attributeName];
        }
        for(const attributeName in primitive.attributes){
            const threeAttributeName = $3af46d7a32572744$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            if (gltfAttributeMap[attributeName] !== undefined) {
                const accessorDef = json.accessors[primitive.attributes[attributeName]];
                const componentType = $3af46d7a32572744$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
                attributeTypeMap[threeAttributeName] = componentType.name;
                attributeNormalizedMap[threeAttributeName] = accessorDef.normalized === true;
            }
        }
        return parser.getDependency("bufferView", bufferViewIndex).then(function(bufferView) {
            return new Promise(function(resolve) {
                dracoLoader.decodeDracoFile(bufferView, function(geometry) {
                    for(const attributeName in geometry.attributes){
                        const attribute = geometry.attributes[attributeName];
                        const normalized = attributeNormalizedMap[attributeName];
                        if (normalized !== undefined) attribute.normalized = normalized;
                    }
                    resolve(geometry);
                }, threeAttributeMap, attributeTypeMap);
            });
        });
    }
}
/**
 * Texture Transform Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_transform
 */ class $3af46d7a32572744$var$GLTFTextureTransformExtension {
    constructor(){
        this.name = $3af46d7a32572744$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM;
    }
    extendTexture(texture, transform) {
        if ((transform.texCoord === undefined || transform.texCoord === texture.channel) && transform.offset === undefined && transform.rotation === undefined && transform.scale === undefined) // See https://github.com/mrdoob/three.js/issues/21819.
        return texture;
        texture = texture.clone();
        if (transform.texCoord !== undefined) texture.channel = transform.texCoord;
        if (transform.offset !== undefined) texture.offset.fromArray(transform.offset);
        if (transform.rotation !== undefined) texture.rotation = transform.rotation;
        if (transform.scale !== undefined) texture.repeat.fromArray(transform.scale);
        texture.needsUpdate = true;
        return texture;
    }
}
/**
 * Mesh Quantization Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization
 */ class $3af46d7a32572744$var$GLTFMeshQuantizationExtension {
    constructor(){
        this.name = $3af46d7a32572744$var$EXTENSIONS.KHR_MESH_QUANTIZATION;
    }
}
/*********************************/ /********** INTERPOLATION ********/ /*********************************/ // Spline Interpolation
// Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#appendix-c-spline-interpolation
class $3af46d7a32572744$var$GLTFCubicSplineInterpolant extends (0, $0147bee01cff6558$export$b558baee9c0f72d3) {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    copySampleValue_(index) {
        // Copies a sample value to the result buffer. See description of glTF
        // CUBICSPLINE values layout in interpolate_() function below.
        const result = this.resultBuffer, values = this.sampleValues, valueSize = this.valueSize, offset = index * valueSize * 3 + valueSize;
        for(let i = 0; i !== valueSize; i++)result[i] = values[offset + i];
        return result;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer;
        const values = this.sampleValues;
        const stride = this.valueSize;
        const stride2 = stride * 2;
        const stride3 = stride * 3;
        const td = t1 - t0;
        const p = (t - t0) / td;
        const pp = p * p;
        const ppp = pp * p;
        const offset1 = i1 * stride3;
        const offset0 = offset1 - stride3;
        const s2 = -2 * ppp + 3 * pp;
        const s3 = ppp - pp;
        const s0 = 1 - s2;
        const s1 = s3 - pp + p;
        // Layout of keyframe output values for CUBICSPLINE animations:
        //   [ inTangent_1, splineVertex_1, outTangent_1, inTangent_2, splineVertex_2, ... ]
        for(let i = 0; i !== stride; i++){
            const p0 = values[offset0 + i + stride]; // splineVertex_k
            const m0 = values[offset0 + i + stride2] * td; // outTangent_k * (t_k+1 - t_k)
            const p1 = values[offset1 + i + stride]; // splineVertex_k+1
            const m1 = values[offset1 + i] * td; // inTangent_k+1 * (t_k+1 - t_k)
            result[i] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;
        }
        return result;
    }
}
const $3af46d7a32572744$var$_q = new (0, $0147bee01cff6558$export$23d6a54f0bbc85a3)();
class $3af46d7a32572744$var$GLTFCubicSplineQuaternionInterpolant extends $3af46d7a32572744$var$GLTFCubicSplineInterpolant {
    interpolate_(i1, t0, t, t1) {
        const result = super.interpolate_(i1, t0, t, t1);
        $3af46d7a32572744$var$_q.fromArray(result).normalize().toArray(result);
        return result;
    }
}
/*********************************/ /********** INTERNALS ************/ /*********************************/ /* CONSTANTS */ const $3af46d7a32572744$var$WEBGL_CONSTANTS = {
    FLOAT: 5126,
    //FLOAT_MAT2: 35674,
    FLOAT_MAT3: 35675,
    FLOAT_MAT4: 35676,
    FLOAT_VEC2: 35664,
    FLOAT_VEC3: 35665,
    FLOAT_VEC4: 35666,
    LINEAR: 9729,
    REPEAT: 10497,
    SAMPLER_2D: 35678,
    POINTS: 0,
    LINES: 1,
    LINE_LOOP: 2,
    LINE_STRIP: 3,
    TRIANGLES: 4,
    TRIANGLE_STRIP: 5,
    TRIANGLE_FAN: 6,
    UNSIGNED_BYTE: 5121,
    UNSIGNED_SHORT: 5123
};
const $3af46d7a32572744$var$WEBGL_COMPONENT_TYPES = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
};
const $3af46d7a32572744$var$WEBGL_FILTERS = {
    9728: (0, $0147bee01cff6558$export$727aa5ec3fe39bf0),
    9729: (0, $0147bee01cff6558$export$8a72f490b25c56c8),
    9984: (0, $0147bee01cff6558$export$d129e38cf6feaa8c),
    9985: (0, $0147bee01cff6558$export$19a719f377145a13),
    9986: (0, $0147bee01cff6558$export$d2327c1afe5bfdf2),
    9987: (0, $0147bee01cff6558$export$5d8599b6a933fb1b)
};
const $3af46d7a32572744$var$WEBGL_WRAPPINGS = {
    33071: (0, $0147bee01cff6558$export$9d9334239a5a5e06),
    33648: (0, $0147bee01cff6558$export$c7e7c00b14f51a4f),
    10497: (0, $0147bee01cff6558$export$533346c8e8dac0f5)
};
const $3af46d7a32572744$var$WEBGL_TYPE_SIZES = {
    "SCALAR": 1,
    "VEC2": 2,
    "VEC3": 3,
    "VEC4": 4,
    "MAT2": 4,
    "MAT3": 9,
    "MAT4": 16
};
const $3af46d7a32572744$var$ATTRIBUTES = {
    POSITION: "position",
    NORMAL: "normal",
    TANGENT: "tangent",
    TEXCOORD_0: "uv",
    TEXCOORD_1: "uv1",
    TEXCOORD_2: "uv2",
    TEXCOORD_3: "uv3",
    COLOR_0: "color",
    WEIGHTS_0: "skinWeight",
    JOINTS_0: "skinIndex"
};
const $3af46d7a32572744$var$PATH_PROPERTIES = {
    scale: "scale",
    translation: "position",
    rotation: "quaternion",
    weights: "morphTargetInfluences"
};
const $3af46d7a32572744$var$INTERPOLATION = {
    CUBICSPLINE: undefined,
    // keyframe track will be initialized with a default interpolation type, then modified.
    LINEAR: (0, $0147bee01cff6558$export$30fac1aace31cf4d),
    STEP: (0, $0147bee01cff6558$export$995b32462a65e855)
};
const $3af46d7a32572744$var$ALPHA_MODES = {
    OPAQUE: "OPAQUE",
    MASK: "MASK",
    BLEND: "BLEND"
};
/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#default-material
 */ function $3af46d7a32572744$var$createDefaultMaterial(cache) {
    if (cache["DefaultMaterial"] === undefined) cache["DefaultMaterial"] = new (0, $0147bee01cff6558$export$f2980790215acccd)({
        color: 0xFFFFFF,
        emissive: 0x000000,
        metalness: 1,
        roughness: 1,
        transparent: false,
        depthTest: true,
        side: (0, $0147bee01cff6558$export$2ede184fc2998901)
    });
    return cache["DefaultMaterial"];
}
function $3af46d7a32572744$var$addUnknownExtensionsToUserData(knownExtensions, object, objectDef) {
    // Add unknown glTF extensions to an object's userData.
    for(const name in objectDef.extensions)if (knownExtensions[name] === undefined) {
        object.userData.gltfExtensions = object.userData.gltfExtensions || {};
        object.userData.gltfExtensions[name] = objectDef.extensions[name];
    }
}
/**
 * @param {Object3D|Material|BufferGeometry} object
 * @param {GLTF.definition} gltfDef
 */ function $3af46d7a32572744$var$assignExtrasToUserData(object, gltfDef) {
    if (gltfDef.extras !== undefined) {
        if (typeof gltfDef.extras === "object") Object.assign(object.userData, gltfDef.extras);
        else console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + gltfDef.extras);
    }
}
/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#morph-targets
 *
 * @param {BufferGeometry} geometry
 * @param {Array<GLTF.Target>} targets
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */ function $3af46d7a32572744$var$addMorphTargets(geometry, targets, parser) {
    let hasMorphPosition = false;
    let hasMorphNormal = false;
    let hasMorphColor = false;
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (target.POSITION !== undefined) hasMorphPosition = true;
        if (target.NORMAL !== undefined) hasMorphNormal = true;
        if (target.COLOR_0 !== undefined) hasMorphColor = true;
        if (hasMorphPosition && hasMorphNormal && hasMorphColor) break;
    }
    if (!hasMorphPosition && !hasMorphNormal && !hasMorphColor) return Promise.resolve(geometry);
    const pendingPositionAccessors = [];
    const pendingNormalAccessors = [];
    const pendingColorAccessors = [];
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (hasMorphPosition) {
            const pendingAccessor = target.POSITION !== undefined ? parser.getDependency("accessor", target.POSITION) : geometry.attributes.position;
            pendingPositionAccessors.push(pendingAccessor);
        }
        if (hasMorphNormal) {
            const pendingAccessor = target.NORMAL !== undefined ? parser.getDependency("accessor", target.NORMAL) : geometry.attributes.normal;
            pendingNormalAccessors.push(pendingAccessor);
        }
        if (hasMorphColor) {
            const pendingAccessor = target.COLOR_0 !== undefined ? parser.getDependency("accessor", target.COLOR_0) : geometry.attributes.color;
            pendingColorAccessors.push(pendingAccessor);
        }
    }
    return Promise.all([
        Promise.all(pendingPositionAccessors),
        Promise.all(pendingNormalAccessors),
        Promise.all(pendingColorAccessors)
    ]).then(function(accessors) {
        const morphPositions = accessors[0];
        const morphNormals = accessors[1];
        const morphColors = accessors[2];
        if (hasMorphPosition) geometry.morphAttributes.position = morphPositions;
        if (hasMorphNormal) geometry.morphAttributes.normal = morphNormals;
        if (hasMorphColor) geometry.morphAttributes.color = morphColors;
        geometry.morphTargetsRelative = true;
        return geometry;
    });
}
/**
 * @param {Mesh} mesh
 * @param {GLTF.Mesh} meshDef
 */ function $3af46d7a32572744$var$updateMorphTargets(mesh, meshDef) {
    mesh.updateMorphTargets();
    if (meshDef.weights !== undefined) for(let i = 0, il = meshDef.weights.length; i < il; i++)mesh.morphTargetInfluences[i] = meshDef.weights[i];
    // .extras has user-defined data, so check that .extras.targetNames is an array.
    if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {
        const targetNames = meshDef.extras.targetNames;
        if (mesh.morphTargetInfluences.length === targetNames.length) {
            mesh.morphTargetDictionary = {};
            for(let i = 0, il = targetNames.length; i < il; i++)mesh.morphTargetDictionary[targetNames[i]] = i;
        } else console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
    }
}
function $3af46d7a32572744$var$createPrimitiveKey(primitiveDef) {
    let geometryKey;
    const dracoExtension = primitiveDef.extensions && primitiveDef.extensions[$3af46d7a32572744$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
    if (dracoExtension) geometryKey = "draco:" + dracoExtension.bufferView + ":" + dracoExtension.indices + ":" + $3af46d7a32572744$var$createAttributesKey(dracoExtension.attributes);
    else geometryKey = primitiveDef.indices + ":" + $3af46d7a32572744$var$createAttributesKey(primitiveDef.attributes) + ":" + primitiveDef.mode;
    if (primitiveDef.targets !== undefined) for(let i = 0, il = primitiveDef.targets.length; i < il; i++)geometryKey += ":" + $3af46d7a32572744$var$createAttributesKey(primitiveDef.targets[i]);
    return geometryKey;
}
function $3af46d7a32572744$var$createAttributesKey(attributes) {
    let attributesKey = "";
    const keys = Object.keys(attributes).sort();
    for(let i = 0, il = keys.length; i < il; i++)attributesKey += keys[i] + ":" + attributes[keys[i]] + ";";
    return attributesKey;
}
function $3af46d7a32572744$var$getNormalizedComponentScale(constructor) {
    // Reference:
    // https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization#encoding-quantized-data
    switch(constructor){
        case Int8Array:
            return 1 / 127;
        case Uint8Array:
            return 1 / 255;
        case Int16Array:
            return 1 / 32767;
        case Uint16Array:
            return 1 / 65535;
        default:
            throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
    }
}
function $3af46d7a32572744$var$getImageURIMimeType(uri) {
    if (uri.search(/\.jpe?g($|\?)/i) > 0 || uri.search(/^data\:image\/jpeg/) === 0) return "image/jpeg";
    if (uri.search(/\.webp($|\?)/i) > 0 || uri.search(/^data\:image\/webp/) === 0) return "image/webp";
    return "image/png";
}
const $3af46d7a32572744$var$_identityMatrix = new (0, $0147bee01cff6558$export$2ae72fc923e5eb5)();
/* GLTF PARSER */ class $3af46d7a32572744$var$GLTFParser {
    constructor(json = {}, options = {}){
        this.json = json;
        this.extensions = {};
        this.plugins = {};
        this.options = options;
        // loader object cache
        this.cache = new $3af46d7a32572744$var$GLTFRegistry();
        // associations between Three.js objects and glTF elements
        this.associations = new Map();
        // BufferGeometry caching
        this.primitiveCache = {};
        // Node cache
        this.nodeCache = {};
        // Object3D instance caches
        this.meshCache = {
            refs: {},
            uses: {}
        };
        this.cameraCache = {
            refs: {},
            uses: {}
        };
        this.lightCache = {
            refs: {},
            uses: {}
        };
        this.sourceCache = {};
        this.textureCache = {};
        // Track node names, to ensure no duplicates
        this.nodeNamesUsed = {};
        // Use an ImageBitmapLoader if imageBitmaps are supported. Moves much of the
        // expensive work of uploading a texture to the GPU off the main thread.
        let isSafari = false;
        let isFirefox = false;
        let firefoxVersion = -1;
        if (typeof navigator !== "undefined") {
            isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) === true;
            isFirefox = navigator.userAgent.indexOf("Firefox") > -1;
            firefoxVersion = isFirefox ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1;
        }
        if (typeof createImageBitmap === "undefined" || isSafari || isFirefox && firefoxVersion < 98) this.textureLoader = new (0, $0147bee01cff6558$export$fd1bfc71f64c538c)(this.options.manager);
        else this.textureLoader = new (0, $0147bee01cff6558$export$52286b55c4a9b51f)(this.options.manager);
        this.textureLoader.setCrossOrigin(this.options.crossOrigin);
        this.textureLoader.setRequestHeader(this.options.requestHeader);
        this.fileLoader = new (0, $0147bee01cff6558$export$98435a25b5cf7b2b)(this.options.manager);
        this.fileLoader.setResponseType("arraybuffer");
        if (this.options.crossOrigin === "use-credentials") this.fileLoader.setWithCredentials(true);
    }
    setExtensions(extensions) {
        this.extensions = extensions;
    }
    setPlugins(plugins) {
        this.plugins = plugins;
    }
    parse(onLoad, onError) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        // Clear the loader cache
        this.cache.removeAll();
        this.nodeCache = {};
        // Mark the special nodes/meshes in json for efficient parse
        this._invokeAll(function(ext) {
            return ext._markDefs && ext._markDefs();
        });
        Promise.all(this._invokeAll(function(ext) {
            return ext.beforeRoot && ext.beforeRoot();
        })).then(function() {
            return Promise.all([
                parser.getDependencies("scene"),
                parser.getDependencies("animation"),
                parser.getDependencies("camera")
            ]);
        }).then(function(dependencies) {
            const result = {
                scene: dependencies[0][json.scene || 0],
                scenes: dependencies[0],
                animations: dependencies[1],
                cameras: dependencies[2],
                asset: json.asset,
                parser: parser,
                userData: {}
            };
            $3af46d7a32572744$var$addUnknownExtensionsToUserData(extensions, result, json);
            $3af46d7a32572744$var$assignExtrasToUserData(result, json);
            Promise.all(parser._invokeAll(function(ext) {
                return ext.afterRoot && ext.afterRoot(result);
            })).then(function() {
                onLoad(result);
            });
        }).catch(onError);
    }
    /**
	 * Marks the special nodes/meshes in json for efficient parse.
	 */ _markDefs() {
        const nodeDefs = this.json.nodes || [];
        const skinDefs = this.json.skins || [];
        const meshDefs = this.json.meshes || [];
        // Nothing in the node definition indicates whether it is a Bone or an
        // Object3D. Use the skins' joint references to mark bones.
        for(let skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++){
            const joints = skinDefs[skinIndex].joints;
            for(let i = 0, il = joints.length; i < il; i++)nodeDefs[joints[i]].isBone = true;
        }
        // Iterate over all nodes, marking references to shared resources,
        // as well as skeleton joints.
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.mesh !== undefined) {
                this._addNodeRef(this.meshCache, nodeDef.mesh);
                // Nothing in the mesh definition indicates whether it is
                // a SkinnedMesh or Mesh. Use the node's mesh reference
                // to mark SkinnedMesh if node has skin.
                if (nodeDef.skin !== undefined) meshDefs[nodeDef.mesh].isSkinnedMesh = true;
            }
            if (nodeDef.camera !== undefined) this._addNodeRef(this.cameraCache, nodeDef.camera);
        }
    }
    /**
	 * Counts references to shared node / Object3D resources. These resources
	 * can be reused, or "instantiated", at multiple nodes in the scene
	 * hierarchy. Mesh, Camera, and Light instances are instantiated and must
	 * be marked. Non-scenegraph resources (like Materials, Geometries, and
	 * Textures) can be reused directly and are not marked here.
	 *
	 * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
	 */ _addNodeRef(cache, index) {
        if (index === undefined) return;
        if (cache.refs[index] === undefined) cache.refs[index] = cache.uses[index] = 0;
        cache.refs[index]++;
    }
    /** Returns a reference to a shared resource, cloning it if necessary. */ _getNodeRef(cache, index, object) {
        if (cache.refs[index] <= 1) return object;
        const ref = object.clone();
        // Propagates mappings to the cloned object, prevents mappings on the
        // original object from being lost.
        const updateMappings = (original, clone)=>{
            const mappings = this.associations.get(original);
            if (mappings != null) this.associations.set(clone, mappings);
            for (const [i, child] of original.children.entries())updateMappings(child, clone.children[i]);
        };
        updateMappings(object, ref);
        ref.name += "_instance_" + cache.uses[index]++;
        return ref;
    }
    _invokeOne(func) {
        const extensions = Object.values(this.plugins);
        extensions.push(this);
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) return result;
        }
        return null;
    }
    _invokeAll(func) {
        const extensions = Object.values(this.plugins);
        extensions.unshift(this);
        const pending = [];
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) pending.push(result);
        }
        return pending;
    }
    /**
	 * Requests the specified dependency asynchronously, with caching.
	 * @param {string} type
	 * @param {number} index
	 * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
	 */ getDependency(type, index) {
        const cacheKey = type + ":" + index;
        let dependency = this.cache.get(cacheKey);
        if (!dependency) {
            switch(type){
                case "scene":
                    dependency = this.loadScene(index);
                    break;
                case "node":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadNode && ext.loadNode(index);
                    });
                    break;
                case "mesh":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMesh && ext.loadMesh(index);
                    });
                    break;
                case "accessor":
                    dependency = this.loadAccessor(index);
                    break;
                case "bufferView":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadBufferView && ext.loadBufferView(index);
                    });
                    break;
                case "buffer":
                    dependency = this.loadBuffer(index);
                    break;
                case "material":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMaterial && ext.loadMaterial(index);
                    });
                    break;
                case "texture":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadTexture && ext.loadTexture(index);
                    });
                    break;
                case "skin":
                    dependency = this.loadSkin(index);
                    break;
                case "animation":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadAnimation && ext.loadAnimation(index);
                    });
                    break;
                case "camera":
                    dependency = this.loadCamera(index);
                    break;
                default:
                    dependency = this._invokeOne(function(ext) {
                        return ext != this && ext.getDependency && ext.getDependency(type, index);
                    });
                    if (!dependency) throw new Error("Unknown type: " + type);
                    break;
            }
            this.cache.add(cacheKey, dependency);
        }
        return dependency;
    }
    /**
	 * Requests all dependencies of the specified type asynchronously, with caching.
	 * @param {string} type
	 * @return {Promise<Array<Object>>}
	 */ getDependencies(type) {
        let dependencies = this.cache.get(type);
        if (!dependencies) {
            const parser = this;
            const defs = this.json[type + (type === "mesh" ? "es" : "s")] || [];
            dependencies = Promise.all(defs.map(function(def, index) {
                return parser.getDependency(type, index);
            }));
            this.cache.add(type, dependencies);
        }
        return dependencies;
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
	 * @param {number} bufferIndex
	 * @return {Promise<ArrayBuffer>}
	 */ loadBuffer(bufferIndex) {
        const bufferDef = this.json.buffers[bufferIndex];
        const loader = this.fileLoader;
        if (bufferDef.type && bufferDef.type !== "arraybuffer") throw new Error("THREE.GLTFLoader: " + bufferDef.type + " buffer type is not supported.");
        // If present, GLB container is required to be the first buffer.
        if (bufferDef.uri === undefined && bufferIndex === 0) return Promise.resolve(this.extensions[$3af46d7a32572744$var$EXTENSIONS.KHR_BINARY_GLTF].body);
        const options = this.options;
        return new Promise(function(resolve, reject) {
            loader.load((0, $0147bee01cff6558$export$b5d2dc08d867e41a).resolveURL(bufferDef.uri, options.path), resolve, undefined, function() {
                reject(new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".'));
            });
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
	 * @param {number} bufferViewIndex
	 * @return {Promise<ArrayBuffer>}
	 */ loadBufferView(bufferViewIndex) {
        const bufferViewDef = this.json.bufferViews[bufferViewIndex];
        return this.getDependency("buffer", bufferViewDef.buffer).then(function(buffer) {
            const byteLength = bufferViewDef.byteLength || 0;
            const byteOffset = bufferViewDef.byteOffset || 0;
            return buffer.slice(byteOffset, byteOffset + byteLength);
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
	 * @param {number} accessorIndex
	 * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
	 */ loadAccessor(accessorIndex) {
        const parser = this;
        const json = this.json;
        const accessorDef = this.json.accessors[accessorIndex];
        if (accessorDef.bufferView === undefined && accessorDef.sparse === undefined) {
            const itemSize = $3af46d7a32572744$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $3af46d7a32572744$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            const normalized = accessorDef.normalized === true;
            const array = new TypedArray(accessorDef.count * itemSize);
            return Promise.resolve(new (0, $0147bee01cff6558$export$8dea267bd6bde117)(array, itemSize, normalized));
        }
        const pendingBufferViews = [];
        if (accessorDef.bufferView !== undefined) pendingBufferViews.push(this.getDependency("bufferView", accessorDef.bufferView));
        else pendingBufferViews.push(null);
        if (accessorDef.sparse !== undefined) {
            pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.indices.bufferView));
            pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.values.bufferView));
        }
        return Promise.all(pendingBufferViews).then(function(bufferViews) {
            const bufferView = bufferViews[0];
            const itemSize = $3af46d7a32572744$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $3af46d7a32572744$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            // For VEC3: itemSize is 3, elementBytes is 4, itemBytes is 12.
            const elementBytes = TypedArray.BYTES_PER_ELEMENT;
            const itemBytes = elementBytes * itemSize;
            const byteOffset = accessorDef.byteOffset || 0;
            const byteStride = accessorDef.bufferView !== undefined ? json.bufferViews[accessorDef.bufferView].byteStride : undefined;
            const normalized = accessorDef.normalized === true;
            let array, bufferAttribute;
            // The buffer is not interleaved if the stride is the item size in bytes.
            if (byteStride && byteStride !== itemBytes) {
                // Each "slice" of the buffer, as defined by 'count' elements of 'byteStride' bytes, gets its own InterleavedBuffer
                // This makes sure that IBA.count reflects accessor.count properly
                const ibSlice = Math.floor(byteOffset / byteStride);
                const ibCacheKey = "InterleavedBuffer:" + accessorDef.bufferView + ":" + accessorDef.componentType + ":" + ibSlice + ":" + accessorDef.count;
                let ib = parser.cache.get(ibCacheKey);
                if (!ib) {
                    array = new TypedArray(bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes);
                    // Integer parameters to IB/IBA are in array elements, not bytes.
                    ib = new (0, $0147bee01cff6558$export$3d5cd879f108f53f)(array, byteStride / elementBytes);
                    parser.cache.add(ibCacheKey, ib);
                }
                bufferAttribute = new (0, $0147bee01cff6558$export$920b6d07334599c7)(ib, itemSize, byteOffset % byteStride / elementBytes, normalized);
            } else {
                if (bufferView === null) array = new TypedArray(accessorDef.count * itemSize);
                else array = new TypedArray(bufferView, byteOffset, accessorDef.count * itemSize);
                bufferAttribute = new (0, $0147bee01cff6558$export$8dea267bd6bde117)(array, itemSize, normalized);
            }
            // https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#sparse-accessors
            if (accessorDef.sparse !== undefined) {
                const itemSizeIndices = $3af46d7a32572744$var$WEBGL_TYPE_SIZES.SCALAR;
                const TypedArrayIndices = $3af46d7a32572744$var$WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];
                const byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
                const byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;
                const sparseIndices = new TypedArrayIndices(bufferViews[1], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices);
                const sparseValues = new TypedArray(bufferViews[2], byteOffsetValues, accessorDef.sparse.count * itemSize);
                if (bufferView !== null) // Avoid modifying the original ArrayBuffer, if the bufferView wasn't initialized with zeroes.
                bufferAttribute = new (0, $0147bee01cff6558$export$8dea267bd6bde117)(bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized);
                for(let i = 0, il = sparseIndices.length; i < il; i++){
                    const index = sparseIndices[i];
                    bufferAttribute.setX(index, sparseValues[i * itemSize]);
                    if (itemSize >= 2) bufferAttribute.setY(index, sparseValues[i * itemSize + 1]);
                    if (itemSize >= 3) bufferAttribute.setZ(index, sparseValues[i * itemSize + 2]);
                    if (itemSize >= 4) bufferAttribute.setW(index, sparseValues[i * itemSize + 3]);
                    if (itemSize >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
                }
            }
            return bufferAttribute;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
	 * @param {number} textureIndex
	 * @return {Promise<THREE.Texture|null>}
	 */ loadTexture(textureIndex) {
        const json = this.json;
        const options = this.options;
        const textureDef = json.textures[textureIndex];
        const sourceIndex = textureDef.source;
        const sourceDef = json.images[sourceIndex];
        let loader = this.textureLoader;
        if (sourceDef.uri) {
            const handler = options.manager.getHandler(sourceDef.uri);
            if (handler !== null) loader = handler;
        }
        return this.loadTextureImage(textureIndex, sourceIndex, loader);
    }
    loadTextureImage(textureIndex, sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const textureDef = json.textures[textureIndex];
        const sourceDef = json.images[sourceIndex];
        const cacheKey = (sourceDef.uri || sourceDef.bufferView) + ":" + textureDef.sampler;
        if (this.textureCache[cacheKey]) // See https://github.com/mrdoob/three.js/issues/21559.
        return this.textureCache[cacheKey];
        const promise = this.loadImageSource(sourceIndex, loader).then(function(texture) {
            texture.flipY = false;
            texture.name = textureDef.name || sourceDef.name || "";
            if (texture.name === "" && typeof sourceDef.uri === "string" && sourceDef.uri.startsWith("data:image/") === false) texture.name = sourceDef.uri;
            const samplers = json.samplers || {};
            const sampler = samplers[textureDef.sampler] || {};
            texture.magFilter = $3af46d7a32572744$var$WEBGL_FILTERS[sampler.magFilter] || (0, $0147bee01cff6558$export$8a72f490b25c56c8);
            texture.minFilter = $3af46d7a32572744$var$WEBGL_FILTERS[sampler.minFilter] || (0, $0147bee01cff6558$export$5d8599b6a933fb1b);
            texture.wrapS = $3af46d7a32572744$var$WEBGL_WRAPPINGS[sampler.wrapS] || (0, $0147bee01cff6558$export$533346c8e8dac0f5);
            texture.wrapT = $3af46d7a32572744$var$WEBGL_WRAPPINGS[sampler.wrapT] || (0, $0147bee01cff6558$export$533346c8e8dac0f5);
            parser.associations.set(texture, {
                textures: textureIndex
            });
            return texture;
        }).catch(function() {
            return null;
        });
        this.textureCache[cacheKey] = promise;
        return promise;
    }
    loadImageSource(sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const options = this.options;
        if (this.sourceCache[sourceIndex] !== undefined) return this.sourceCache[sourceIndex].then((texture)=>texture.clone());
        const sourceDef = json.images[sourceIndex];
        const URL = self.URL || self.webkitURL;
        let sourceURI = sourceDef.uri || "";
        let isObjectURL = false;
        if (sourceDef.bufferView !== undefined) // Load binary image data from bufferView, if provided.
        sourceURI = parser.getDependency("bufferView", sourceDef.bufferView).then(function(bufferView) {
            isObjectURL = true;
            const blob = new Blob([
                bufferView
            ], {
                type: sourceDef.mimeType
            });
            sourceURI = URL.createObjectURL(blob);
            return sourceURI;
        });
        else if (sourceDef.uri === undefined) throw new Error("THREE.GLTFLoader: Image " + sourceIndex + " is missing URI and bufferView");
        const promise = Promise.resolve(sourceURI).then(function(sourceURI) {
            return new Promise(function(resolve, reject) {
                let onLoad = resolve;
                if (loader.isImageBitmapLoader === true) onLoad = function(imageBitmap) {
                    const texture = new (0, $0147bee01cff6558$export$5431306cf43de24a)(imageBitmap);
                    texture.needsUpdate = true;
                    resolve(texture);
                };
                loader.load((0, $0147bee01cff6558$export$b5d2dc08d867e41a).resolveURL(sourceURI, options.path), onLoad, undefined, reject);
            });
        }).then(function(texture) {
            // Clean up resources and configure Texture.
            if (isObjectURL === true) URL.revokeObjectURL(sourceURI);
            texture.userData.mimeType = sourceDef.mimeType || $3af46d7a32572744$var$getImageURIMimeType(sourceDef.uri);
            return texture;
        }).catch(function(error) {
            console.error("THREE.GLTFLoader: Couldn't load texture", sourceURI);
            throw error;
        });
        this.sourceCache[sourceIndex] = promise;
        return promise;
    }
    /**
	 * Asynchronously assigns a texture to the given material parameters.
	 * @param {Object} materialParams
	 * @param {string} mapName
	 * @param {Object} mapDef
	 * @return {Promise<Texture>}
	 */ assignTexture(materialParams, mapName, mapDef, colorSpace) {
        const parser = this;
        return this.getDependency("texture", mapDef.index).then(function(texture) {
            if (!texture) return null;
            if (mapDef.texCoord !== undefined && mapDef.texCoord > 0) {
                texture = texture.clone();
                texture.channel = mapDef.texCoord;
            }
            if (parser.extensions[$3af46d7a32572744$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {
                const transform = mapDef.extensions !== undefined ? mapDef.extensions[$3af46d7a32572744$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM] : undefined;
                if (transform) {
                    const gltfReference = parser.associations.get(texture);
                    texture = parser.extensions[$3af46d7a32572744$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(texture, transform);
                    parser.associations.set(texture, gltfReference);
                }
            }
            if (colorSpace !== undefined) texture.colorSpace = colorSpace;
            materialParams[mapName] = texture;
            return texture;
        });
    }
    /**
	 * Assigns final material to a Mesh, Line, or Points instance. The instance
	 * already has a material (generated from the glTF material options alone)
	 * but reuse of the same glTF material may require multiple threejs materials
	 * to accommodate different primitive types, defines, etc. New materials will
	 * be created if necessary, and reused from a cache.
	 * @param  {Object3D} mesh Mesh, Line, or Points instance.
	 */ assignFinalMaterial(mesh) {
        const geometry = mesh.geometry;
        let material = mesh.material;
        const useDerivativeTangents = geometry.attributes.tangent === undefined;
        const useVertexColors = geometry.attributes.color !== undefined;
        const useFlatShading = geometry.attributes.normal === undefined;
        if (mesh.isPoints) {
            const cacheKey = "PointsMaterial:" + material.uuid;
            let pointsMaterial = this.cache.get(cacheKey);
            if (!pointsMaterial) {
                pointsMaterial = new (0, $0147bee01cff6558$export$a178c45366ce5d6b)();
                (0, $0147bee01cff6558$export$a2d8b23205c25948).prototype.copy.call(pointsMaterial, material);
                pointsMaterial.color.copy(material.color);
                pointsMaterial.map = material.map;
                pointsMaterial.sizeAttenuation = false; // glTF spec says points should be 1px
                this.cache.add(cacheKey, pointsMaterial);
            }
            material = pointsMaterial;
        } else if (mesh.isLine) {
            const cacheKey = "LineBasicMaterial:" + material.uuid;
            let lineMaterial = this.cache.get(cacheKey);
            if (!lineMaterial) {
                lineMaterial = new (0, $0147bee01cff6558$export$fbaaa33907730a0c)();
                (0, $0147bee01cff6558$export$a2d8b23205c25948).prototype.copy.call(lineMaterial, material);
                lineMaterial.color.copy(material.color);
                lineMaterial.map = material.map;
                this.cache.add(cacheKey, lineMaterial);
            }
            material = lineMaterial;
        }
        // Clone the material if it will be modified
        if (useDerivativeTangents || useVertexColors || useFlatShading) {
            let cacheKey = "ClonedMaterial:" + material.uuid + ":";
            if (useDerivativeTangents) cacheKey += "derivative-tangents:";
            if (useVertexColors) cacheKey += "vertex-colors:";
            if (useFlatShading) cacheKey += "flat-shading:";
            let cachedMaterial = this.cache.get(cacheKey);
            if (!cachedMaterial) {
                cachedMaterial = material.clone();
                if (useVertexColors) cachedMaterial.vertexColors = true;
                if (useFlatShading) cachedMaterial.flatShading = true;
                if (useDerivativeTangents) {
                    // https://github.com/mrdoob/three.js/issues/11438#issuecomment-507003995
                    if (cachedMaterial.normalScale) cachedMaterial.normalScale.y *= -1;
                    if (cachedMaterial.clearcoatNormalScale) cachedMaterial.clearcoatNormalScale.y *= -1;
                }
                this.cache.add(cacheKey, cachedMaterial);
                this.associations.set(cachedMaterial, this.associations.get(material));
            }
            material = cachedMaterial;
        }
        mesh.material = material;
    }
    getMaterialType() {
        return 0, $0147bee01cff6558$export$f2980790215acccd;
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
	 * @param {number} materialIndex
	 * @return {Promise<Material>}
	 */ loadMaterial(materialIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const materialDef = json.materials[materialIndex];
        let materialType;
        const materialParams = {};
        const materialExtensions = materialDef.extensions || {};
        const pending = [];
        if (materialExtensions[$3af46d7a32572744$var$EXTENSIONS.KHR_MATERIALS_UNLIT]) {
            const kmuExtension = extensions[$3af46d7a32572744$var$EXTENSIONS.KHR_MATERIALS_UNLIT];
            materialType = kmuExtension.getMaterialType();
            pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));
        } else {
            // Specification:
            // https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#metallic-roughness-material
            const metallicRoughness = materialDef.pbrMetallicRoughness || {};
            materialParams.color = new (0, $0147bee01cff6558$export$892596cec99bc70e)(1.0, 1.0, 1.0);
            materialParams.opacity = 1.0;
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.fromArray(array);
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, (0, $0147bee01cff6558$export$561f394b24edfcaa)));
            materialParams.metalness = metallicRoughness.metallicFactor !== undefined ? metallicRoughness.metallicFactor : 1.0;
            materialParams.roughness = metallicRoughness.roughnessFactor !== undefined ? metallicRoughness.roughnessFactor : 1.0;
            if (metallicRoughness.metallicRoughnessTexture !== undefined) {
                pending.push(parser.assignTexture(materialParams, "metalnessMap", metallicRoughness.metallicRoughnessTexture));
                pending.push(parser.assignTexture(materialParams, "roughnessMap", metallicRoughness.metallicRoughnessTexture));
            }
            materialType = this._invokeOne(function(ext) {
                return ext.getMaterialType && ext.getMaterialType(materialIndex);
            });
            pending.push(Promise.all(this._invokeAll(function(ext) {
                return ext.extendMaterialParams && ext.extendMaterialParams(materialIndex, materialParams);
            })));
        }
        if (materialDef.doubleSided === true) materialParams.side = (0, $0147bee01cff6558$export$3b296b6f144d5b03);
        const alphaMode = materialDef.alphaMode || $3af46d7a32572744$var$ALPHA_MODES.OPAQUE;
        if (alphaMode === $3af46d7a32572744$var$ALPHA_MODES.BLEND) {
            materialParams.transparent = true;
            // See: https://github.com/mrdoob/three.js/issues/17706
            materialParams.depthWrite = false;
        } else {
            materialParams.transparent = false;
            if (alphaMode === $3af46d7a32572744$var$ALPHA_MODES.MASK) materialParams.alphaTest = materialDef.alphaCutoff !== undefined ? materialDef.alphaCutoff : 0.5;
        }
        if (materialDef.normalTexture !== undefined && materialType !== (0, $0147bee01cff6558$export$55cbcc9b622fe1f5)) {
            pending.push(parser.assignTexture(materialParams, "normalMap", materialDef.normalTexture));
            materialParams.normalScale = new (0, $0147bee01cff6558$export$c977b3e384af9ae1)(1, 1);
            if (materialDef.normalTexture.scale !== undefined) {
                const scale = materialDef.normalTexture.scale;
                materialParams.normalScale.set(scale, scale);
            }
        }
        if (materialDef.occlusionTexture !== undefined && materialType !== (0, $0147bee01cff6558$export$55cbcc9b622fe1f5)) {
            pending.push(parser.assignTexture(materialParams, "aoMap", materialDef.occlusionTexture));
            if (materialDef.occlusionTexture.strength !== undefined) materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;
        }
        if (materialDef.emissiveFactor !== undefined && materialType !== (0, $0147bee01cff6558$export$55cbcc9b622fe1f5)) materialParams.emissive = new (0, $0147bee01cff6558$export$892596cec99bc70e)().fromArray(materialDef.emissiveFactor);
        if (materialDef.emissiveTexture !== undefined && materialType !== (0, $0147bee01cff6558$export$55cbcc9b622fe1f5)) pending.push(parser.assignTexture(materialParams, "emissiveMap", materialDef.emissiveTexture, (0, $0147bee01cff6558$export$561f394b24edfcaa)));
        return Promise.all(pending).then(function() {
            const material = new materialType(materialParams);
            if (materialDef.name) material.name = materialDef.name;
            $3af46d7a32572744$var$assignExtrasToUserData(material, materialDef);
            parser.associations.set(material, {
                materials: materialIndex
            });
            if (materialDef.extensions) $3af46d7a32572744$var$addUnknownExtensionsToUserData(extensions, material, materialDef);
            return material;
        });
    }
    /** When Object3D instances are targeted by animation, they need unique names. */ createUniqueName(originalName) {
        const sanitizedName = (0, $0147bee01cff6558$export$7bf70fcf9f891893).sanitizeNodeName(originalName || "");
        if (sanitizedName in this.nodeNamesUsed) return sanitizedName + "_" + ++this.nodeNamesUsed[sanitizedName];
        else {
            this.nodeNamesUsed[sanitizedName] = 0;
            return sanitizedName;
        }
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
	 *
	 * Creates BufferGeometries from primitives.
	 *
	 * @param {Array<GLTF.Primitive>} primitives
	 * @return {Promise<Array<BufferGeometry>>}
	 */ loadGeometries(primitives) {
        const parser = this;
        const extensions = this.extensions;
        const cache = this.primitiveCache;
        function createDracoPrimitive(primitive) {
            return extensions[$3af46d7a32572744$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(primitive, parser).then(function(geometry) {
                return $3af46d7a32572744$var$addPrimitiveAttributes(geometry, primitive, parser);
            });
        }
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const primitive = primitives[i];
            const cacheKey = $3af46d7a32572744$var$createPrimitiveKey(primitive);
            // See if we've already created this geometry
            const cached = cache[cacheKey];
            if (cached) // Use the cached geometry if it exists
            pending.push(cached.promise);
            else {
                let geometryPromise;
                if (primitive.extensions && primitive.extensions[$3af46d7a32572744$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) // Use DRACO geometry if available
                geometryPromise = createDracoPrimitive(primitive);
                else // Otherwise create a new geometry
                geometryPromise = $3af46d7a32572744$var$addPrimitiveAttributes(new (0, $0147bee01cff6558$export$b7be63a67df8959)(), primitive, parser);
                // Cache this geometry
                cache[cacheKey] = {
                    primitive: primitive,
                    promise: geometryPromise
                };
                pending.push(geometryPromise);
            }
        }
        return Promise.all(pending);
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
	 * @param {number} meshIndex
	 * @return {Promise<Group|Mesh|SkinnedMesh>}
	 */ loadMesh(meshIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const meshDef = json.meshes[meshIndex];
        const primitives = meshDef.primitives;
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const material = primitives[i].material === undefined ? $3af46d7a32572744$var$createDefaultMaterial(this.cache) : this.getDependency("material", primitives[i].material);
            pending.push(material);
        }
        pending.push(parser.loadGeometries(primitives));
        return Promise.all(pending).then(function(results) {
            const materials = results.slice(0, results.length - 1);
            const geometries = results[results.length - 1];
            const meshes = [];
            for(let i = 0, il = geometries.length; i < il; i++){
                const geometry = geometries[i];
                const primitive = primitives[i];
                // 1. create Mesh
                let mesh;
                const material = materials[i];
                if (primitive.mode === $3af46d7a32572744$var$WEBGL_CONSTANTS.TRIANGLES || primitive.mode === $3af46d7a32572744$var$WEBGL_CONSTANTS.TRIANGLE_STRIP || primitive.mode === $3af46d7a32572744$var$WEBGL_CONSTANTS.TRIANGLE_FAN || primitive.mode === undefined) {
                    // .isSkinnedMesh isn't in glTF spec. See ._markDefs()
                    mesh = meshDef.isSkinnedMesh === true ? new (0, $0147bee01cff6558$export$b303577035157ecf)(geometry, material) : new (0, $0147bee01cff6558$export$e176487c05830cc5)(geometry, material);
                    if (mesh.isSkinnedMesh === true) // normalize skin weights to fix malformed assets (see #15319)
                    mesh.normalizeSkinWeights();
                    if (primitive.mode === $3af46d7a32572744$var$WEBGL_CONSTANTS.TRIANGLE_STRIP) mesh.geometry = (0, $a3a83ae92476a547$export$5492ca6e5c0c7aa0)(mesh.geometry, (0, $0147bee01cff6558$export$b23a071aa286eb29));
                    else if (primitive.mode === $3af46d7a32572744$var$WEBGL_CONSTANTS.TRIANGLE_FAN) mesh.geometry = (0, $a3a83ae92476a547$export$5492ca6e5c0c7aa0)(mesh.geometry, (0, $0147bee01cff6558$export$f0d8293634f88842));
                } else if (primitive.mode === $3af46d7a32572744$var$WEBGL_CONSTANTS.LINES) mesh = new (0, $0147bee01cff6558$export$ff1ed10fedfdd604)(geometry, material);
                else if (primitive.mode === $3af46d7a32572744$var$WEBGL_CONSTANTS.LINE_STRIP) mesh = new (0, $0147bee01cff6558$export$17d680238e50603e)(geometry, material);
                else if (primitive.mode === $3af46d7a32572744$var$WEBGL_CONSTANTS.LINE_LOOP) mesh = new (0, $0147bee01cff6558$export$f85a24d745e4f17d)(geometry, material);
                else if (primitive.mode === $3af46d7a32572744$var$WEBGL_CONSTANTS.POINTS) mesh = new (0, $0147bee01cff6558$export$1c787534cb11aa3e)(geometry, material);
                else throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + primitive.mode);
                if (Object.keys(mesh.geometry.morphAttributes).length > 0) $3af46d7a32572744$var$updateMorphTargets(mesh, meshDef);
                mesh.name = parser.createUniqueName(meshDef.name || "mesh_" + meshIndex);
                $3af46d7a32572744$var$assignExtrasToUserData(mesh, meshDef);
                if (primitive.extensions) $3af46d7a32572744$var$addUnknownExtensionsToUserData(extensions, mesh, primitive);
                parser.assignFinalMaterial(mesh);
                meshes.push(mesh);
            }
            for(let i = 0, il = meshes.length; i < il; i++)parser.associations.set(meshes[i], {
                meshes: meshIndex,
                primitives: i
            });
            if (meshes.length === 1) {
                if (meshDef.extensions) $3af46d7a32572744$var$addUnknownExtensionsToUserData(extensions, meshes[0], meshDef);
                return meshes[0];
            }
            const group = new (0, $0147bee01cff6558$export$eb2fcfdbd7ba97d4)();
            if (meshDef.extensions) $3af46d7a32572744$var$addUnknownExtensionsToUserData(extensions, group, meshDef);
            parser.associations.set(group, {
                meshes: meshIndex
            });
            for(let i = 0, il = meshes.length; i < il; i++)group.add(meshes[i]);
            return group;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
	 * @param {number} cameraIndex
	 * @return {Promise<THREE.Camera>}
	 */ loadCamera(cameraIndex) {
        let camera;
        const cameraDef = this.json.cameras[cameraIndex];
        const params = cameraDef[cameraDef.type];
        if (!params) {
            console.warn("THREE.GLTFLoader: Missing camera parameters.");
            return;
        }
        if (cameraDef.type === "perspective") camera = new (0, $0147bee01cff6558$export$74e4ae24825f68d7)((0, $0147bee01cff6558$export$6a7ef315a0d1ef07).radToDeg(params.yfov), params.aspectRatio || 1, params.znear || 1, params.zfar || 2e6);
        else if (cameraDef.type === "orthographic") camera = new (0, $0147bee01cff6558$export$9ebf355ee4ed261b)(-params.xmag, params.xmag, params.ymag, -params.ymag, params.znear, params.zfar);
        if (cameraDef.name) camera.name = this.createUniqueName(cameraDef.name);
        $3af46d7a32572744$var$assignExtrasToUserData(camera, cameraDef);
        return Promise.resolve(camera);
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
	 * @param {number} skinIndex
	 * @return {Promise<Skeleton>}
	 */ loadSkin(skinIndex) {
        const skinDef = this.json.skins[skinIndex];
        const pending = [];
        for(let i = 0, il = skinDef.joints.length; i < il; i++)pending.push(this._loadNodeShallow(skinDef.joints[i]));
        if (skinDef.inverseBindMatrices !== undefined) pending.push(this.getDependency("accessor", skinDef.inverseBindMatrices));
        else pending.push(null);
        return Promise.all(pending).then(function(results) {
            const inverseBindMatrices = results.pop();
            const jointNodes = results;
            // Note that bones (joint nodes) may or may not be in the
            // scene graph at this time.
            const bones = [];
            const boneInverses = [];
            for(let i = 0, il = jointNodes.length; i < il; i++){
                const jointNode = jointNodes[i];
                if (jointNode) {
                    bones.push(jointNode);
                    const mat = new (0, $0147bee01cff6558$export$2ae72fc923e5eb5)();
                    if (inverseBindMatrices !== null) mat.fromArray(inverseBindMatrices.array, i * 16);
                    boneInverses.push(mat);
                } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', skinDef.joints[i]);
            }
            return new (0, $0147bee01cff6558$export$8f31e4c4a37b8e9c)(bones, boneInverses);
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
	 * @param {number} animationIndex
	 * @return {Promise<AnimationClip>}
	 */ loadAnimation(animationIndex) {
        const json = this.json;
        const parser = this;
        const animationDef = json.animations[animationIndex];
        const animationName = animationDef.name ? animationDef.name : "animation_" + animationIndex;
        const pendingNodes = [];
        const pendingInputAccessors = [];
        const pendingOutputAccessors = [];
        const pendingSamplers = [];
        const pendingTargets = [];
        for(let i = 0, il = animationDef.channels.length; i < il; i++){
            const channel = animationDef.channels[i];
            const sampler = animationDef.samplers[channel.sampler];
            const target = channel.target;
            const name = target.node;
            const input = animationDef.parameters !== undefined ? animationDef.parameters[sampler.input] : sampler.input;
            const output = animationDef.parameters !== undefined ? animationDef.parameters[sampler.output] : sampler.output;
            if (target.node === undefined) continue;
            pendingNodes.push(this.getDependency("node", name));
            pendingInputAccessors.push(this.getDependency("accessor", input));
            pendingOutputAccessors.push(this.getDependency("accessor", output));
            pendingSamplers.push(sampler);
            pendingTargets.push(target);
        }
        return Promise.all([
            Promise.all(pendingNodes),
            Promise.all(pendingInputAccessors),
            Promise.all(pendingOutputAccessors),
            Promise.all(pendingSamplers),
            Promise.all(pendingTargets)
        ]).then(function(dependencies) {
            const nodes = dependencies[0];
            const inputAccessors = dependencies[1];
            const outputAccessors = dependencies[2];
            const samplers = dependencies[3];
            const targets = dependencies[4];
            const tracks = [];
            for(let i = 0, il = nodes.length; i < il; i++){
                const node = nodes[i];
                const inputAccessor = inputAccessors[i];
                const outputAccessor = outputAccessors[i];
                const sampler = samplers[i];
                const target = targets[i];
                if (node === undefined) continue;
                if (node.updateMatrix) node.updateMatrix();
                const createdTracks = parser._createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target);
                if (createdTracks) for(let k = 0; k < createdTracks.length; k++)tracks.push(createdTracks[k]);
            }
            return new (0, $0147bee01cff6558$export$d942c706bf23829c)(animationName, undefined, tracks);
        });
    }
    createNodeMesh(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        if (nodeDef.mesh === undefined) return null;
        return parser.getDependency("mesh", nodeDef.mesh).then(function(mesh) {
            const node = parser._getNodeRef(parser.meshCache, nodeDef.mesh, mesh);
            // if weights are provided on the node, override weights on the mesh.
            if (nodeDef.weights !== undefined) node.traverse(function(o) {
                if (!o.isMesh) return;
                for(let i = 0, il = nodeDef.weights.length; i < il; i++)o.morphTargetInfluences[i] = nodeDef.weights[i];
            });
            return node;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
	 * @param {number} nodeIndex
	 * @return {Promise<Object3D>}
	 */ loadNode(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        const nodePending = parser._loadNodeShallow(nodeIndex);
        const childPending = [];
        const childrenDef = nodeDef.children || [];
        for(let i = 0, il = childrenDef.length; i < il; i++)childPending.push(parser.getDependency("node", childrenDef[i]));
        const skeletonPending = nodeDef.skin === undefined ? Promise.resolve(null) : parser.getDependency("skin", nodeDef.skin);
        return Promise.all([
            nodePending,
            Promise.all(childPending),
            skeletonPending
        ]).then(function(results) {
            const node = results[0];
            const children = results[1];
            const skeleton = results[2];
            if (skeleton !== null) // This full traverse should be fine because
            // child glTF nodes have not been added to this node yet.
            node.traverse(function(mesh) {
                if (!mesh.isSkinnedMesh) return;
                mesh.bind(skeleton, $3af46d7a32572744$var$_identityMatrix);
            });
            for(let i = 0, il = children.length; i < il; i++)node.add(children[i]);
            return node;
        });
    }
    // ._loadNodeShallow() parses a single node.
    // skin and child nodes are created and added in .loadNode() (no '_' prefix).
    _loadNodeShallow(nodeIndex) {
        const json = this.json;
        const extensions = this.extensions;
        const parser = this;
        // This method is called from .loadNode() and .loadSkin().
        // Cache a node to avoid duplication.
        if (this.nodeCache[nodeIndex] !== undefined) return this.nodeCache[nodeIndex];
        const nodeDef = json.nodes[nodeIndex];
        // reserve node's name before its dependencies, so the root has the intended name.
        const nodeName = nodeDef.name ? parser.createUniqueName(nodeDef.name) : "";
        const pending = [];
        const meshPromise = parser._invokeOne(function(ext) {
            return ext.createNodeMesh && ext.createNodeMesh(nodeIndex);
        });
        if (meshPromise) pending.push(meshPromise);
        if (nodeDef.camera !== undefined) pending.push(parser.getDependency("camera", nodeDef.camera).then(function(camera) {
            return parser._getNodeRef(parser.cameraCache, nodeDef.camera, camera);
        }));
        parser._invokeAll(function(ext) {
            return ext.createNodeAttachment && ext.createNodeAttachment(nodeIndex);
        }).forEach(function(promise) {
            pending.push(promise);
        });
        this.nodeCache[nodeIndex] = Promise.all(pending).then(function(objects) {
            let node;
            // .isBone isn't in glTF spec. See ._markDefs
            if (nodeDef.isBone === true) node = new (0, $0147bee01cff6558$export$b127726e56765aa4)();
            else if (objects.length > 1) node = new (0, $0147bee01cff6558$export$eb2fcfdbd7ba97d4)();
            else if (objects.length === 1) node = objects[0];
            else node = new (0, $0147bee01cff6558$export$e4dd07dff30cc924)();
            if (node !== objects[0]) for(let i = 0, il = objects.length; i < il; i++)node.add(objects[i]);
            if (nodeDef.name) {
                node.userData.name = nodeDef.name;
                node.name = nodeName;
            }
            $3af46d7a32572744$var$assignExtrasToUserData(node, nodeDef);
            if (nodeDef.extensions) $3af46d7a32572744$var$addUnknownExtensionsToUserData(extensions, node, nodeDef);
            if (nodeDef.matrix !== undefined) {
                const matrix = new (0, $0147bee01cff6558$export$2ae72fc923e5eb5)();
                matrix.fromArray(nodeDef.matrix);
                node.applyMatrix4(matrix);
            } else {
                if (nodeDef.translation !== undefined) node.position.fromArray(nodeDef.translation);
                if (nodeDef.rotation !== undefined) node.quaternion.fromArray(nodeDef.rotation);
                if (nodeDef.scale !== undefined) node.scale.fromArray(nodeDef.scale);
            }
            if (!parser.associations.has(node)) parser.associations.set(node, {});
            parser.associations.get(node).nodes = nodeIndex;
            return node;
        });
        return this.nodeCache[nodeIndex];
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
	 * @param {number} sceneIndex
	 * @return {Promise<Group>}
	 */ loadScene(sceneIndex) {
        const extensions = this.extensions;
        const sceneDef = this.json.scenes[sceneIndex];
        const parser = this;
        // Loader returns Group, not Scene.
        // See: https://github.com/mrdoob/three.js/issues/18342#issuecomment-578981172
        const scene = new (0, $0147bee01cff6558$export$eb2fcfdbd7ba97d4)();
        if (sceneDef.name) scene.name = parser.createUniqueName(sceneDef.name);
        $3af46d7a32572744$var$assignExtrasToUserData(scene, sceneDef);
        if (sceneDef.extensions) $3af46d7a32572744$var$addUnknownExtensionsToUserData(extensions, scene, sceneDef);
        const nodeIds = sceneDef.nodes || [];
        const pending = [];
        for(let i = 0, il = nodeIds.length; i < il; i++)pending.push(parser.getDependency("node", nodeIds[i]));
        return Promise.all(pending).then(function(nodes) {
            for(let i = 0, il = nodes.length; i < il; i++)scene.add(nodes[i]);
            // Removes dangling associations, associations that reference a node that
            // didn't make it into the scene.
            const reduceAssociations = (node)=>{
                const reducedAssociations = new Map();
                for (const [key, value] of parser.associations)if (key instanceof (0, $0147bee01cff6558$export$a2d8b23205c25948) || key instanceof (0, $0147bee01cff6558$export$5431306cf43de24a)) reducedAssociations.set(key, value);
                node.traverse((node)=>{
                    const mappings = parser.associations.get(node);
                    if (mappings != null) reducedAssociations.set(node, mappings);
                });
                return reducedAssociations;
            };
            parser.associations = reduceAssociations(scene);
            return scene;
        });
    }
    _createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target) {
        const tracks = [];
        const targetName = node.name ? node.name : node.uuid;
        const targetNames = [];
        if ($3af46d7a32572744$var$PATH_PROPERTIES[target.path] === $3af46d7a32572744$var$PATH_PROPERTIES.weights) node.traverse(function(object) {
            if (object.morphTargetInfluences) targetNames.push(object.name ? object.name : object.uuid);
        });
        else targetNames.push(targetName);
        let TypedKeyframeTrack;
        switch($3af46d7a32572744$var$PATH_PROPERTIES[target.path]){
            case $3af46d7a32572744$var$PATH_PROPERTIES.weights:
                TypedKeyframeTrack = (0, $0147bee01cff6558$export$d45f0d1a4d9a9314);
                break;
            case $3af46d7a32572744$var$PATH_PROPERTIES.rotation:
                TypedKeyframeTrack = (0, $0147bee01cff6558$export$b8043f12b5aafbd7);
                break;
            case $3af46d7a32572744$var$PATH_PROPERTIES.position:
            case $3af46d7a32572744$var$PATH_PROPERTIES.scale:
                TypedKeyframeTrack = (0, $0147bee01cff6558$export$5ce2dcb4cc9f2bff);
                break;
            default:
                switch(outputAccessor.itemSize){
                    case 1:
                        TypedKeyframeTrack = (0, $0147bee01cff6558$export$d45f0d1a4d9a9314);
                        break;
                    case 2:
                    case 3:
                    default:
                        TypedKeyframeTrack = (0, $0147bee01cff6558$export$5ce2dcb4cc9f2bff);
                        break;
                }
                break;
        }
        const interpolation = sampler.interpolation !== undefined ? $3af46d7a32572744$var$INTERPOLATION[sampler.interpolation] : (0, $0147bee01cff6558$export$30fac1aace31cf4d);
        const outputArray = this._getArrayFromAccessor(outputAccessor);
        for(let j = 0, jl = targetNames.length; j < jl; j++){
            const track = new TypedKeyframeTrack(targetNames[j] + "." + $3af46d7a32572744$var$PATH_PROPERTIES[target.path], inputAccessor.array, outputArray, interpolation);
            // Override interpolation with custom factory method.
            if (sampler.interpolation === "CUBICSPLINE") this._createCubicSplineTrackInterpolant(track);
            tracks.push(track);
        }
        return tracks;
    }
    _getArrayFromAccessor(accessor) {
        let outputArray = accessor.array;
        if (accessor.normalized) {
            const scale = $3af46d7a32572744$var$getNormalizedComponentScale(outputArray.constructor);
            const scaled = new Float32Array(outputArray.length);
            for(let j = 0, jl = outputArray.length; j < jl; j++)scaled[j] = outputArray[j] * scale;
            outputArray = scaled;
        }
        return outputArray;
    }
    _createCubicSplineTrackInterpolant(track) {
        track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {
            // A CUBICSPLINE keyframe in glTF has three output values for each input value,
            // representing inTangent, splineVertex, and outTangent. As a result, track.getValueSize()
            // must be divided by three to get the interpolant's sampleSize argument.
            const interpolantType = this instanceof (0, $0147bee01cff6558$export$b8043f12b5aafbd7) ? $3af46d7a32572744$var$GLTFCubicSplineQuaternionInterpolant : $3af46d7a32572744$var$GLTFCubicSplineInterpolant;
            return new interpolantType(this.times, this.values, this.getValueSize() / 3, result);
        };
        // Mark as CUBICSPLINE. `track.getInterpolation()` doesn't support custom interpolants.
        track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
    }
}
/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 */ function $3af46d7a32572744$var$computeBounds(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const box = new (0, $0147bee01cff6558$export$6f7d5a9418ab2aa3)();
    if (attributes.POSITION !== undefined) {
        const accessor = parser.json.accessors[attributes.POSITION];
        const min = accessor.min;
        const max = accessor.max;
        // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.
        if (min !== undefined && max !== undefined) {
            box.set(new (0, $0147bee01cff6558$export$64b5c384219d3699)(min[0], min[1], min[2]), new (0, $0147bee01cff6558$export$64b5c384219d3699)(max[0], max[1], max[2]));
            if (accessor.normalized) {
                const boxScale = $3af46d7a32572744$var$getNormalizedComponentScale($3af46d7a32572744$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                box.min.multiplyScalar(boxScale);
                box.max.multiplyScalar(boxScale);
            }
        } else {
            console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
            return;
        }
    } else return;
    const targets = primitiveDef.targets;
    if (targets !== undefined) {
        const maxDisplacement = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
        const vector = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
        for(let i = 0, il = targets.length; i < il; i++){
            const target = targets[i];
            if (target.POSITION !== undefined) {
                const accessor = parser.json.accessors[target.POSITION];
                const min = accessor.min;
                const max = accessor.max;
                // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.
                if (min !== undefined && max !== undefined) {
                    // we need to get max of absolute components because target weight is [-1,1]
                    vector.setX(Math.max(Math.abs(min[0]), Math.abs(max[0])));
                    vector.setY(Math.max(Math.abs(min[1]), Math.abs(max[1])));
                    vector.setZ(Math.max(Math.abs(min[2]), Math.abs(max[2])));
                    if (accessor.normalized) {
                        const boxScale = $3af46d7a32572744$var$getNormalizedComponentScale($3af46d7a32572744$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                        vector.multiplyScalar(boxScale);
                    }
                    // Note: this assumes that the sum of all weights is at most 1. This isn't quite correct - it's more conservative
                    // to assume that each target can have a max weight of 1. However, for some use cases - notably, when morph targets
                    // are used to implement key-frame animations and as such only two are active at a time - this results in very large
                    // boxes. So for now we make a box that's sometimes a touch too small but is hopefully mostly of reasonable size.
                    maxDisplacement.max(vector);
                } else console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
            }
        }
        // As per comment above this box isn't conservative, but has a reasonable size for a very large number of morph targets.
        box.expandByVector(maxDisplacement);
    }
    geometry.boundingBox = box;
    const sphere = new (0, $0147bee01cff6558$export$805e8b72413ccaba)();
    box.getCenter(sphere.center);
    sphere.radius = box.min.distanceTo(box.max) / 2;
    geometry.boundingSphere = sphere;
}
/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */ function $3af46d7a32572744$var$addPrimitiveAttributes(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const pending = [];
    function assignAttributeAccessor(accessorIndex, attributeName) {
        return parser.getDependency("accessor", accessorIndex).then(function(accessor) {
            geometry.setAttribute(attributeName, accessor);
        });
    }
    for(const gltfAttributeName in attributes){
        const threeAttributeName = $3af46d7a32572744$var$ATTRIBUTES[gltfAttributeName] || gltfAttributeName.toLowerCase();
        // Skip attributes already provided by e.g. Draco extension.
        if (threeAttributeName in geometry.attributes) continue;
        pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));
    }
    if (primitiveDef.indices !== undefined && !geometry.index) {
        const accessor = parser.getDependency("accessor", primitiveDef.indices).then(function(accessor) {
            geometry.setIndex(accessor);
        });
        pending.push(accessor);
    }
    $3af46d7a32572744$var$assignExtrasToUserData(geometry, primitiveDef);
    $3af46d7a32572744$var$computeBounds(geometry, primitiveDef, parser);
    return Promise.all(pending).then(function() {
        return primitiveDef.targets !== undefined ? $3af46d7a32572744$var$addMorphTargets(geometry, primitiveDef.targets, parser) : geometry;
    });
}




/**
 * @webxr-input-profiles/motion-controllers 1.0.0 https://github.com/immersive-web/webxr-input-profiles
 */ const $f1b821fb91c3aab9$export$a002182e51710d39 = {
    Handedness: Object.freeze({
        NONE: "none",
        LEFT: "left",
        RIGHT: "right"
    }),
    ComponentState: Object.freeze({
        DEFAULT: "default",
        TOUCHED: "touched",
        PRESSED: "pressed"
    }),
    ComponentProperty: Object.freeze({
        BUTTON: "button",
        X_AXIS: "xAxis",
        Y_AXIS: "yAxis",
        STATE: "state"
    }),
    ComponentType: Object.freeze({
        TRIGGER: "trigger",
        SQUEEZE: "squeeze",
        TOUCHPAD: "touchpad",
        THUMBSTICK: "thumbstick",
        BUTTON: "button"
    }),
    ButtonTouchThreshold: 0.05,
    AxisTouchThreshold: 0.1,
    VisualResponseProperty: Object.freeze({
        TRANSFORM: "transform",
        VISIBILITY: "visibility"
    })
};
/**
 * @description Static helper function to fetch a JSON file and turn it into a JS object
 * @param {string} path - Path to JSON file to be fetched
 */ async function $f1b821fb91c3aab9$var$fetchJsonFile(path) {
    const response = await fetch(path);
    if (!response.ok) throw new Error(response.statusText);
    else return response.json();
}
async function $f1b821fb91c3aab9$export$cdc669b4504544b3(basePath) {
    if (!basePath) throw new Error("No basePath supplied");
    const profileListFileName = "profilesList.json";
    const profilesList = await $f1b821fb91c3aab9$var$fetchJsonFile(`${basePath}/${profileListFileName}`);
    return profilesList;
}
async function $f1b821fb91c3aab9$export$665d336fd546fbed(xrInputSource, basePath, defaultProfile = null, getAssetPath = true) {
    if (!xrInputSource) throw new Error("No xrInputSource supplied");
    if (!basePath) throw new Error("No basePath supplied");
    // Get the list of profiles
    const supportedProfilesList = await $f1b821fb91c3aab9$export$cdc669b4504544b3(basePath);
    // Find the relative path to the first requested profile that is recognized
    let match;
    xrInputSource.profiles.some((profileId)=>{
        const supportedProfile = supportedProfilesList[profileId];
        if (supportedProfile) match = {
            profileId: profileId,
            profilePath: `${basePath}/${supportedProfile.path}`,
            deprecated: !!supportedProfile.deprecated
        };
        return !!match;
    });
    if (!match) {
        if (!defaultProfile) throw new Error("No matching profile name found");
        const supportedProfile = supportedProfilesList[defaultProfile];
        if (!supportedProfile) throw new Error(`No matching profile name found and default profile "${defaultProfile}" missing.`);
        match = {
            profileId: defaultProfile,
            profilePath: `${basePath}/${supportedProfile.path}`,
            deprecated: !!supportedProfile.deprecated
        };
    }
    const profile = await $f1b821fb91c3aab9$var$fetchJsonFile(match.profilePath);
    let assetPath;
    if (getAssetPath) {
        let layout;
        if (xrInputSource.handedness === "any") layout = profile.layouts[Object.keys(profile.layouts)[0]];
        else layout = profile.layouts[xrInputSource.handedness];
        if (!layout) throw new Error(`No matching handedness, ${xrInputSource.handedness}, in profile ${match.profileId}`);
        if (layout.assetPath) assetPath = match.profilePath.replace("profile.json", layout.assetPath);
    }
    return {
        profile: profile,
        assetPath: assetPath
    };
}
/** @constant {Object} */ const $f1b821fb91c3aab9$var$defaultComponentValues = {
    xAxis: 0,
    yAxis: 0,
    button: 0,
    state: $f1b821fb91c3aab9$export$a002182e51710d39.ComponentState.DEFAULT
};
/**
 * @description Converts an X, Y coordinate from the range -1 to 1 (as reported by the Gamepad
 * API) to the range 0 to 1 (for interpolation). Also caps the X, Y values to be bounded within
 * a circle. This ensures that thumbsticks are not animated outside the bounds of their physical
 * range of motion and touchpads do not report touch locations off their physical bounds.
 * @param {number} x The original x coordinate in the range -1 to 1
 * @param {number} y The original y coordinate in the range -1 to 1
 */ function $f1b821fb91c3aab9$var$normalizeAxes(x = 0, y = 0) {
    let xAxis = x;
    let yAxis = y;
    // Determine if the point is outside the bounds of the circle
    // and, if so, place it on the edge of the circle
    const hypotenuse = Math.sqrt(x * x + y * y);
    if (hypotenuse > 1) {
        const theta = Math.atan2(y, x);
        xAxis = Math.cos(theta);
        yAxis = Math.sin(theta);
    }
    // Scale and move the circle so values are in the interpolation range.  The circle's origin moves
    // from (0, 0) to (0.5, 0.5). The circle's radius scales from 1 to be 0.5.
    const result = {
        normalizedXAxis: xAxis * 0.5 + 0.5,
        normalizedYAxis: yAxis * 0.5 + 0.5
    };
    return result;
}
/**
 * Contains the description of how the 3D model should visually respond to a specific user input.
 * This is accomplished by initializing the object with the name of a node in the 3D model and
 * property that need to be modified in response to user input, the name of the nodes representing
 * the allowable range of motion, and the name of the input which triggers the change. In response
 * to the named input changing, this object computes the appropriate weighting to use for
 * interpolating between the range of motion nodes.
 */ class $f1b821fb91c3aab9$var$VisualResponse {
    constructor(visualResponseDescription){
        this.componentProperty = visualResponseDescription.componentProperty;
        this.states = visualResponseDescription.states;
        this.valueNodeName = visualResponseDescription.valueNodeName;
        this.valueNodeProperty = visualResponseDescription.valueNodeProperty;
        if (this.valueNodeProperty === $f1b821fb91c3aab9$export$a002182e51710d39.VisualResponseProperty.TRANSFORM) {
            this.minNodeName = visualResponseDescription.minNodeName;
            this.maxNodeName = visualResponseDescription.maxNodeName;
        }
        // Initializes the response's current value based on default data
        this.value = 0;
        this.updateFromComponent($f1b821fb91c3aab9$var$defaultComponentValues);
    }
    /**
   * Computes the visual response's interpolation weight based on component state
   * @param {Object} componentValues - The component from which to update
   * @param {number} xAxis - The reported X axis value of the component
   * @param {number} yAxis - The reported Y axis value of the component
   * @param {number} button - The reported value of the component's button
   * @param {string} state - The component's active state
   */ updateFromComponent({ xAxis: xAxis, yAxis: yAxis, button: button, state: state }) {
        const { normalizedXAxis: normalizedXAxis, normalizedYAxis: normalizedYAxis } = $f1b821fb91c3aab9$var$normalizeAxes(xAxis, yAxis);
        switch(this.componentProperty){
            case $f1b821fb91c3aab9$export$a002182e51710d39.ComponentProperty.X_AXIS:
                this.value = this.states.includes(state) ? normalizedXAxis : 0.5;
                break;
            case $f1b821fb91c3aab9$export$a002182e51710d39.ComponentProperty.Y_AXIS:
                this.value = this.states.includes(state) ? normalizedYAxis : 0.5;
                break;
            case $f1b821fb91c3aab9$export$a002182e51710d39.ComponentProperty.BUTTON:
                this.value = this.states.includes(state) ? button : 0;
                break;
            case $f1b821fb91c3aab9$export$a002182e51710d39.ComponentProperty.STATE:
                if (this.valueNodeProperty === $f1b821fb91c3aab9$export$a002182e51710d39.VisualResponseProperty.VISIBILITY) this.value = this.states.includes(state);
                else this.value = this.states.includes(state) ? 1.0 : 0.0;
                break;
            default:
                throw new Error(`Unexpected visualResponse componentProperty ${this.componentProperty}`);
        }
    }
}
class $f1b821fb91c3aab9$var$Component {
    /**
   * @param {Object} componentId - Id of the component
   * @param {Object} componentDescription - Description of the component to be created
   */ constructor(componentId, componentDescription){
        if (!componentId || !componentDescription || !componentDescription.visualResponses || !componentDescription.gamepadIndices || Object.keys(componentDescription.gamepadIndices).length === 0) throw new Error("Invalid arguments supplied");
        this.id = componentId;
        this.type = componentDescription.type;
        this.rootNodeName = componentDescription.rootNodeName;
        this.touchPointNodeName = componentDescription.touchPointNodeName;
        // Build all the visual responses for this component
        this.visualResponses = {};
        Object.keys(componentDescription.visualResponses).forEach((responseName)=>{
            const visualResponse = new $f1b821fb91c3aab9$var$VisualResponse(componentDescription.visualResponses[responseName]);
            this.visualResponses[responseName] = visualResponse;
        });
        // Set default values
        this.gamepadIndices = Object.assign({}, componentDescription.gamepadIndices);
        this.values = {
            state: $f1b821fb91c3aab9$export$a002182e51710d39.ComponentState.DEFAULT,
            button: this.gamepadIndices.button !== undefined ? 0 : undefined,
            xAxis: this.gamepadIndices.xAxis !== undefined ? 0 : undefined,
            yAxis: this.gamepadIndices.yAxis !== undefined ? 0 : undefined
        };
    }
    get data() {
        const data = {
            id: this.id,
            ...this.values
        };
        return data;
    }
    /**
   * @description Poll for updated data based on current gamepad state
   * @param {Object} gamepad - The gamepad object from which the component data should be polled
   */ updateFromGamepad(gamepad) {
        // Set the state to default before processing other data sources
        this.values.state = $f1b821fb91c3aab9$export$a002182e51710d39.ComponentState.DEFAULT;
        // Get and normalize button
        if (this.gamepadIndices.button !== undefined && gamepad.buttons.length > this.gamepadIndices.button) {
            const gamepadButton = gamepad.buttons[this.gamepadIndices.button];
            this.values.button = gamepadButton.value;
            this.values.button = this.values.button < 0 ? 0 : this.values.button;
            this.values.button = this.values.button > 1 ? 1 : this.values.button;
            // Set the state based on the button
            if (gamepadButton.pressed || this.values.button === 1) this.values.state = $f1b821fb91c3aab9$export$a002182e51710d39.ComponentState.PRESSED;
            else if (gamepadButton.touched || this.values.button > $f1b821fb91c3aab9$export$a002182e51710d39.ButtonTouchThreshold) this.values.state = $f1b821fb91c3aab9$export$a002182e51710d39.ComponentState.TOUCHED;
        }
        // Get and normalize x axis value
        if (this.gamepadIndices.xAxis !== undefined && gamepad.axes.length > this.gamepadIndices.xAxis) {
            this.values.xAxis = gamepad.axes[this.gamepadIndices.xAxis];
            this.values.xAxis = this.values.xAxis < -1 ? -1 : this.values.xAxis;
            this.values.xAxis = this.values.xAxis > 1 ? 1 : this.values.xAxis;
            // If the state is still default, check if the xAxis makes it touched
            if (this.values.state === $f1b821fb91c3aab9$export$a002182e51710d39.ComponentState.DEFAULT && Math.abs(this.values.xAxis) > $f1b821fb91c3aab9$export$a002182e51710d39.AxisTouchThreshold) this.values.state = $f1b821fb91c3aab9$export$a002182e51710d39.ComponentState.TOUCHED;
        }
        // Get and normalize Y axis value
        if (this.gamepadIndices.yAxis !== undefined && gamepad.axes.length > this.gamepadIndices.yAxis) {
            this.values.yAxis = gamepad.axes[this.gamepadIndices.yAxis];
            this.values.yAxis = this.values.yAxis < -1 ? -1 : this.values.yAxis;
            this.values.yAxis = this.values.yAxis > 1 ? 1 : this.values.yAxis;
            // If the state is still default, check if the yAxis makes it touched
            if (this.values.state === $f1b821fb91c3aab9$export$a002182e51710d39.ComponentState.DEFAULT && Math.abs(this.values.yAxis) > $f1b821fb91c3aab9$export$a002182e51710d39.AxisTouchThreshold) this.values.state = $f1b821fb91c3aab9$export$a002182e51710d39.ComponentState.TOUCHED;
        }
        // Update the visual response weights based on the current component data
        Object.values(this.visualResponses).forEach((visualResponse)=>{
            visualResponse.updateFromComponent(this.values);
        });
    }
}
/**
  * @description Builds a motion controller with components and visual responses based on the
  * supplied profile description. Data is polled from the xrInputSource's gamepad.
  * @author Nell Waliczek / https://github.com/NellWaliczek
*/ class $f1b821fb91c3aab9$export$d04f314260fc930a {
    /**
   * @param {Object} xrInputSource - The XRInputSource to build the MotionController around
   * @param {Object} profile - The best matched profile description for the supplied xrInputSource
   * @param {Object} assetUrl
   */ constructor(xrInputSource, profile, assetUrl){
        if (!xrInputSource) throw new Error("No xrInputSource supplied");
        if (!profile) throw new Error("No profile supplied");
        this.xrInputSource = xrInputSource;
        this.assetUrl = assetUrl;
        this.id = profile.profileId;
        // Build child components as described in the profile description
        this.layoutDescription = profile.layouts[xrInputSource.handedness];
        this.components = {};
        Object.keys(this.layoutDescription.components).forEach((componentId)=>{
            const componentDescription = this.layoutDescription.components[componentId];
            this.components[componentId] = new $f1b821fb91c3aab9$var$Component(componentId, componentDescription);
        });
        // Initialize components based on current gamepad state
        this.updateFromGamepad();
    }
    get gripSpace() {
        return this.xrInputSource.gripSpace;
    }
    get targetRaySpace() {
        return this.xrInputSource.targetRaySpace;
    }
    /**
   * @description Returns a subset of component data for simplified debugging
   */ get data() {
        const data = [];
        Object.values(this.components).forEach((component)=>{
            data.push(component.data);
        });
        return data;
    }
    /**
   * @description Poll for updated data based on current gamepad state
   */ updateFromGamepad() {
        Object.values(this.components).forEach((component)=>{
            component.updateFromGamepad(this.xrInputSource.gamepad);
        });
    }
}


const $25a186ed6a8e7fe5$var$DEFAULT_PROFILES_PATH = "https://cdn.jsdelivr.net/npm/@webxr-input-profiles/assets@1.0/dist/profiles";
const $25a186ed6a8e7fe5$var$DEFAULT_PROFILE = "generic-trigger";
class $25a186ed6a8e7fe5$var$XRControllerModel extends (0, $0147bee01cff6558$export$e4dd07dff30cc924) {
    constructor(){
        super();
        this.motionController = null;
        this.envMap = null;
    }
    setEnvironmentMap(envMap) {
        if (this.envMap == envMap) return this;
        this.envMap = envMap;
        this.traverse((child)=>{
            if (child.isMesh) {
                child.material.envMap = this.envMap;
                child.material.needsUpdate = true;
            }
        });
        return this;
    }
    /**
	 * Polls data from the XRInputSource and updates the model's components to match
	 * the real world data
	 */ updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (!this.motionController) return;
        // Cause the MotionController to poll the Gamepad for data
        this.motionController.updateFromGamepad();
        // Update the 3D model to reflect the button, thumbstick, and touchpad state
        Object.values(this.motionController.components).forEach((component)=>{
            // Update node data based on the visual responses' current states
            Object.values(component.visualResponses).forEach((visualResponse)=>{
                const { valueNode: valueNode, minNode: minNode, maxNode: maxNode, value: value, valueNodeProperty: valueNodeProperty } = visualResponse;
                // Skip if the visual response node is not found. No error is needed,
                // because it will have been reported at load time.
                if (!valueNode) return;
                // Calculate the new properties based on the weight supplied
                if (valueNodeProperty === (0, $f1b821fb91c3aab9$export$a002182e51710d39).VisualResponseProperty.VISIBILITY) valueNode.visible = value;
                else if (valueNodeProperty === (0, $f1b821fb91c3aab9$export$a002182e51710d39).VisualResponseProperty.TRANSFORM) {
                    valueNode.quaternion.slerpQuaternions(minNode.quaternion, maxNode.quaternion, value);
                    valueNode.position.lerpVectors(minNode.position, maxNode.position, value);
                }
            });
        });
    }
}
/**
 * Walks the model's tree to find the nodes needed to animate the components and
 * saves them to the motionContoller components for use in the frame loop. When
 * touchpads are found, attaches a touch dot to them.
 */ function $25a186ed6a8e7fe5$var$findNodes(motionController, scene) {
    // Loop through the components and find the nodes needed for each components' visual responses
    Object.values(motionController.components).forEach((component)=>{
        const { type: type, touchPointNodeName: touchPointNodeName, visualResponses: visualResponses } = component;
        if (type === (0, $f1b821fb91c3aab9$export$a002182e51710d39).ComponentType.TOUCHPAD) {
            component.touchPointNode = scene.getObjectByName(touchPointNodeName);
            if (component.touchPointNode) {
                // Attach a touch dot to the touchpad.
                const sphereGeometry = new (0, $0147bee01cff6558$export$1b417fc3b307a251)(0.001);
                const material = new (0, $0147bee01cff6558$export$55cbcc9b622fe1f5)({
                    color: 0x0000FF
                });
                const sphere = new (0, $0147bee01cff6558$export$e176487c05830cc5)(sphereGeometry, material);
                component.touchPointNode.add(sphere);
            } else console.warn(`Could not find touch dot, ${component.touchPointNodeName}, in touchpad component ${component.id}`);
        }
        // Loop through all the visual responses to be applied to this component
        Object.values(visualResponses).forEach((visualResponse)=>{
            const { valueNodeName: valueNodeName, minNodeName: minNodeName, maxNodeName: maxNodeName, valueNodeProperty: valueNodeProperty } = visualResponse;
            // If animating a transform, find the two nodes to be interpolated between.
            if (valueNodeProperty === (0, $f1b821fb91c3aab9$export$a002182e51710d39).VisualResponseProperty.TRANSFORM) {
                visualResponse.minNode = scene.getObjectByName(minNodeName);
                visualResponse.maxNode = scene.getObjectByName(maxNodeName);
                // If the extents cannot be found, skip this animation
                if (!visualResponse.minNode) {
                    console.warn(`Could not find ${minNodeName} in the model`);
                    return;
                }
                if (!visualResponse.maxNode) {
                    console.warn(`Could not find ${maxNodeName} in the model`);
                    return;
                }
            }
            // If the target node cannot be found, skip this animation
            visualResponse.valueNode = scene.getObjectByName(valueNodeName);
            if (!visualResponse.valueNode) console.warn(`Could not find ${valueNodeName} in the model`);
        });
    });
}
function $25a186ed6a8e7fe5$var$addAssetSceneToControllerModel(controllerModel, scene) {
    // Find the nodes needed for animation and cache them on the motionController.
    $25a186ed6a8e7fe5$var$findNodes(controllerModel.motionController, scene);
    // Apply any environment map that the mesh already has set.
    if (controllerModel.envMap) scene.traverse((child)=>{
        if (child.isMesh) {
            child.material.envMap = controllerModel.envMap;
            child.material.needsUpdate = true;
        }
    });
    // Add the glTF scene to the controllerModel.
    controllerModel.add(scene);
}
class $25a186ed6a8e7fe5$export$100331f925a5e0de {
    constructor(gltfLoader = null){
        this.gltfLoader = gltfLoader;
        this.path = $25a186ed6a8e7fe5$var$DEFAULT_PROFILES_PATH;
        this._assetCache = {};
        // If a GLTFLoader wasn't supplied to the constructor create a new one.
        if (!this.gltfLoader) this.gltfLoader = new (0, $3af46d7a32572744$export$aa93f11e7884f0f4)();
    }
    createControllerModel(controller) {
        const controllerModel = new $25a186ed6a8e7fe5$var$XRControllerModel();
        let scene = null;
        controller.addEventListener("connected", (event)=>{
            const xrInputSource = event.data;
            if (xrInputSource.targetRayMode !== "tracked-pointer" || !xrInputSource.gamepad) return;
            (0, $f1b821fb91c3aab9$export$665d336fd546fbed)(xrInputSource, this.path, $25a186ed6a8e7fe5$var$DEFAULT_PROFILE).then(({ profile: profile, assetPath: assetPath })=>{
                controllerModel.motionController = new (0, $f1b821fb91c3aab9$export$d04f314260fc930a)(xrInputSource, profile, assetPath);
                const cachedAsset = this._assetCache[controllerModel.motionController.assetUrl];
                if (cachedAsset) {
                    scene = cachedAsset.scene.clone();
                    $25a186ed6a8e7fe5$var$addAssetSceneToControllerModel(controllerModel, scene);
                } else {
                    if (!this.gltfLoader) throw new Error("GLTFLoader not set.");
                    this.gltfLoader.setPath("");
                    this.gltfLoader.load(controllerModel.motionController.assetUrl, (asset)=>{
                        this._assetCache[controllerModel.motionController.assetUrl] = asset;
                        scene = asset.scene.clone();
                        $25a186ed6a8e7fe5$var$addAssetSceneToControllerModel(controllerModel, scene);
                    }, null, ()=>{
                        throw new Error(`Asset ${controllerModel.motionController.assetUrl} missing or malformed.`);
                    });
                }
            }).catch((err)=>{
                console.warn(err);
            });
        });
        controller.addEventListener("disconnected", ()=>{
            controllerModel.motionController = null;
            controllerModel.remove(scene);
            scene = null;
        });
        return controllerModel;
    }
}




const $2f53b448bf3d9b2e$var$_matrix = new (0, $0147bee01cff6558$export$2ae72fc923e5eb5)();
const $2f53b448bf3d9b2e$var$_vector = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
class $2f53b448bf3d9b2e$export$31b2556b4cd059d {
    constructor(handModel, controller, path, handedness, options){
        this.controller = controller;
        this.handModel = handModel;
        this.envMap = null;
        let geometry;
        if (!options || !options.primitive || options.primitive === "sphere") geometry = new (0, $0147bee01cff6558$export$1b417fc3b307a251)(1, 10, 10);
        else if (options.primitive === "box") geometry = new (0, $0147bee01cff6558$export$33e43285f7406bd5)(1, 1, 1);
        const material = new (0, $0147bee01cff6558$export$f2980790215acccd)();
        this.handMesh = new (0, $0147bee01cff6558$export$f3c979c331175ad7)(geometry, material, 30);
        this.handMesh.frustumCulled = false;
        this.handMesh.instanceMatrix.setUsage((0, $0147bee01cff6558$export$8505d14ac8546ca)); // will be updated every frame
        this.handMesh.castShadow = true;
        this.handMesh.receiveShadow = true;
        this.handModel.add(this.handMesh);
        this.joints = [
            "wrist",
            "thumb-metacarpal",
            "thumb-phalanx-proximal",
            "thumb-phalanx-distal",
            "thumb-tip",
            "index-finger-metacarpal",
            "index-finger-phalanx-proximal",
            "index-finger-phalanx-intermediate",
            "index-finger-phalanx-distal",
            "index-finger-tip",
            "middle-finger-metacarpal",
            "middle-finger-phalanx-proximal",
            "middle-finger-phalanx-intermediate",
            "middle-finger-phalanx-distal",
            "middle-finger-tip",
            "ring-finger-metacarpal",
            "ring-finger-phalanx-proximal",
            "ring-finger-phalanx-intermediate",
            "ring-finger-phalanx-distal",
            "ring-finger-tip",
            "pinky-finger-metacarpal",
            "pinky-finger-phalanx-proximal",
            "pinky-finger-phalanx-intermediate",
            "pinky-finger-phalanx-distal",
            "pinky-finger-tip"
        ];
    }
    updateMesh() {
        const defaultRadius = 0.008;
        const joints = this.controller.joints;
        let count = 0;
        for(let i = 0; i < this.joints.length; i++){
            const joint = joints[this.joints[i]];
            if (joint.visible) {
                $2f53b448bf3d9b2e$var$_vector.setScalar(joint.jointRadius || defaultRadius);
                $2f53b448bf3d9b2e$var$_matrix.compose(joint.position, joint.quaternion, $2f53b448bf3d9b2e$var$_vector);
                this.handMesh.setMatrixAt(i, $2f53b448bf3d9b2e$var$_matrix);
                count++;
            }
        }
        this.handMesh.count = count;
        this.handMesh.instanceMatrix.needsUpdate = true;
    }
}



const $8a589c37f79a49ac$var$DEFAULT_HAND_PROFILE_PATH = "https://cdn.jsdelivr.net/npm/@webxr-input-profiles/assets@1.0/dist/profiles/generic-hand/";
class $8a589c37f79a49ac$export$bfa512d6162fb52e {
    constructor(handModel, controller, path, handedness, loader = null){
        this.controller = controller;
        this.handModel = handModel;
        this.bones = [];
        if (loader === null) {
            loader = new (0, $3af46d7a32572744$export$aa93f11e7884f0f4)();
            loader.setPath(path || $8a589c37f79a49ac$var$DEFAULT_HAND_PROFILE_PATH);
        }
        loader.load(`${handedness}.glb`, (gltf)=>{
            const object = gltf.scene.children[0];
            this.handModel.add(object);
            const mesh = object.getObjectByProperty("type", "SkinnedMesh");
            mesh.frustumCulled = false;
            mesh.castShadow = true;
            mesh.receiveShadow = true;
            const joints = [
                "wrist",
                "thumb-metacarpal",
                "thumb-phalanx-proximal",
                "thumb-phalanx-distal",
                "thumb-tip",
                "index-finger-metacarpal",
                "index-finger-phalanx-proximal",
                "index-finger-phalanx-intermediate",
                "index-finger-phalanx-distal",
                "index-finger-tip",
                "middle-finger-metacarpal",
                "middle-finger-phalanx-proximal",
                "middle-finger-phalanx-intermediate",
                "middle-finger-phalanx-distal",
                "middle-finger-tip",
                "ring-finger-metacarpal",
                "ring-finger-phalanx-proximal",
                "ring-finger-phalanx-intermediate",
                "ring-finger-phalanx-distal",
                "ring-finger-tip",
                "pinky-finger-metacarpal",
                "pinky-finger-phalanx-proximal",
                "pinky-finger-phalanx-intermediate",
                "pinky-finger-phalanx-distal",
                "pinky-finger-tip"
            ];
            joints.forEach((jointName)=>{
                const bone = object.getObjectByName(jointName);
                if (bone !== undefined) bone.jointName = jointName;
                else console.warn(`Couldn't find ${jointName} in ${handedness} hand mesh`);
                this.bones.push(bone);
            });
        });
    }
    updateMesh() {
        // XR Joints
        const XRJoints = this.controller.joints;
        for(let i = 0; i < this.bones.length; i++){
            const bone = this.bones[i];
            if (bone) {
                const XRJoint = XRJoints[bone.jointName];
                if (XRJoint.visible) {
                    const position = XRJoint.position;
                    bone.position.copy(position);
                    bone.quaternion.copy(XRJoint.quaternion);
                // bone.scale.setScalar( XRJoint.jointRadius || defaultRadius );
                }
            }
        }
    }
}


class $576d6801968b24ff$var$XRHandModel extends (0, $0147bee01cff6558$export$e4dd07dff30cc924) {
    constructor(controller){
        super();
        this.controller = controller;
        this.motionController = null;
        this.envMap = null;
        this.mesh = null;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.motionController) this.motionController.updateMesh();
    }
}
class $576d6801968b24ff$export$9f83d49e5842bce4 {
    constructor(){
        this.path = null;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    createHandModel(controller, profile) {
        const handModel = new $576d6801968b24ff$var$XRHandModel(controller);
        controller.addEventListener("connected", (event)=>{
            const xrInputSource = event.data;
            if (xrInputSource.hand && !handModel.motionController) {
                handModel.xrInputSource = xrInputSource;
                // @todo Detect profile if not provided
                if (profile === undefined || profile === "spheres") handModel.motionController = new (0, $2f53b448bf3d9b2e$export$31b2556b4cd059d)(handModel, controller, this.path, xrInputSource.handedness, {
                    primitive: "sphere"
                });
                else if (profile === "boxes") handModel.motionController = new (0, $2f53b448bf3d9b2e$export$31b2556b4cd059d)(handModel, controller, this.path, xrInputSource.handedness, {
                    primitive: "box"
                });
                else if (profile === "mesh") handModel.motionController = new (0, $8a589c37f79a49ac$export$bfa512d6162fb52e)(handModel, controller, this.path, xrInputSource.handedness);
            }
            controller.visible = true;
        });
        controller.addEventListener("disconnected", ()=>{
            controller.visible = false;
        // handModel.motionController = null;
        // handModel.remove( scene );
        // scene = null;
        });
        return handModel;
    }
}



/**
 * Work based on :
 * https://github.com/Slayvin: Flat mirror for three.js
 * https://home.adelphi.edu/~stemkoski/ : An implementation of water shader based on the flat mirror
 * http://29a.ch/ && http://29a.ch/slides/2012/webglwater/ : Water shader explanations in WebGL
 */ class $1830f4d044a5f406$export$1832bdd7a783545e extends (0, $0147bee01cff6558$export$e176487c05830cc5) {
    constructor(geometry, options = {}){
        super(geometry);
        this.isWater = true;
        const scope = this;
        const textureWidth = options.textureWidth !== undefined ? options.textureWidth : 512;
        const textureHeight = options.textureHeight !== undefined ? options.textureHeight : 512;
        const clipBias = options.clipBias !== undefined ? options.clipBias : 0.0;
        const alpha = options.alpha !== undefined ? options.alpha : 1.0;
        const time = options.time !== undefined ? options.time : 0.0;
        const normalSampler = options.waterNormals !== undefined ? options.waterNormals : null;
        const sunDirection = options.sunDirection !== undefined ? options.sunDirection : new (0, $0147bee01cff6558$export$64b5c384219d3699)(0.70707, 0.70707, 0.0);
        const sunColor = new (0, $0147bee01cff6558$export$892596cec99bc70e)(options.sunColor !== undefined ? options.sunColor : 0xffffff);
        const waterColor = new (0, $0147bee01cff6558$export$892596cec99bc70e)(options.waterColor !== undefined ? options.waterColor : 0x7F7F7F);
        const eye = options.eye !== undefined ? options.eye : new (0, $0147bee01cff6558$export$64b5c384219d3699)(0, 0, 0);
        const distortionScale = options.distortionScale !== undefined ? options.distortionScale : 20.0;
        const side = options.side !== undefined ? options.side : (0, $0147bee01cff6558$export$2ede184fc2998901);
        const fog = options.fog !== undefined ? options.fog : false;
        //
        const mirrorPlane = new (0, $0147bee01cff6558$export$7ff5ac152ef991b0)();
        const normal = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
        const mirrorWorldPosition = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
        const cameraWorldPosition = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
        const rotationMatrix = new (0, $0147bee01cff6558$export$2ae72fc923e5eb5)();
        const lookAtPosition = new (0, $0147bee01cff6558$export$64b5c384219d3699)(0, 0, -1);
        const clipPlane = new (0, $0147bee01cff6558$export$fa7daccca11cdbe3)();
        const view = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
        const target = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
        const q = new (0, $0147bee01cff6558$export$fa7daccca11cdbe3)();
        const textureMatrix = new (0, $0147bee01cff6558$export$2ae72fc923e5eb5)();
        const mirrorCamera = new (0, $0147bee01cff6558$export$74e4ae24825f68d7)();
        const renderTarget = new (0, $0147bee01cff6558$export$3c052beb2e51e23f)(textureWidth, textureHeight);
        const mirrorShader = {
            uniforms: (0, $0147bee01cff6558$export$d8ecdf8615bfea69).merge([
                (0, $0147bee01cff6558$export$6643083551874bf5)["fog"],
                (0, $0147bee01cff6558$export$6643083551874bf5)["lights"],
                {
                    "normalSampler": {
                        value: null
                    },
                    "mirrorSampler": {
                        value: null
                    },
                    "alpha": {
                        value: 1.0
                    },
                    "time": {
                        value: 0.0
                    },
                    "size": {
                        value: 1.0
                    },
                    "distortionScale": {
                        value: 20.0
                    },
                    "textureMatrix": {
                        value: new (0, $0147bee01cff6558$export$2ae72fc923e5eb5)()
                    },
                    "sunColor": {
                        value: new (0, $0147bee01cff6558$export$892596cec99bc70e)(0x7F7F7F)
                    },
                    "sunDirection": {
                        value: new (0, $0147bee01cff6558$export$64b5c384219d3699)(0.70707, 0.70707, 0)
                    },
                    "eye": {
                        value: new (0, $0147bee01cff6558$export$64b5c384219d3699)()
                    },
                    "waterColor": {
                        value: new (0, $0147bee01cff6558$export$892596cec99bc70e)(0x555555)
                    }
                }
            ]),
            vertexShader: /* glsl */ `
				uniform mat4 textureMatrix;
				uniform float time;

				varying vec4 mirrorCoord;
				varying vec4 worldPosition;

				#include <common>
				#include <fog_pars_vertex>
				#include <shadowmap_pars_vertex>
				#include <logdepthbuf_pars_vertex>

				void main() {
					mirrorCoord = modelMatrix * vec4( position, 1.0 );
					worldPosition = mirrorCoord.xyzw;
					mirrorCoord = textureMatrix * mirrorCoord;
					vec4 mvPosition =  modelViewMatrix * vec4( position, 1.0 );
					gl_Position = projectionMatrix * mvPosition;

				#include <beginnormal_vertex>
				#include <defaultnormal_vertex>
				#include <logdepthbuf_vertex>
				#include <fog_vertex>
				#include <shadowmap_vertex>
			}`,
            fragmentShader: /* glsl */ `
				uniform sampler2D mirrorSampler;
				uniform float alpha;
				uniform float time;
				uniform float size;
				uniform float distortionScale;
				uniform sampler2D normalSampler;
				uniform vec3 sunColor;
				uniform vec3 sunDirection;
				uniform vec3 eye;
				uniform vec3 waterColor;

				varying vec4 mirrorCoord;
				varying vec4 worldPosition;

				vec4 getNoise( vec2 uv ) {
					vec2 uv0 = ( uv / 103.0 ) + vec2(time / 17.0, time / 29.0);
					vec2 uv1 = uv / 107.0-vec2( time / -19.0, time / 31.0 );
					vec2 uv2 = uv / vec2( 8907.0, 9803.0 ) + vec2( time / 101.0, time / 97.0 );
					vec2 uv3 = uv / vec2( 1091.0, 1027.0 ) - vec2( time / 109.0, time / -113.0 );
					vec4 noise = texture2D( normalSampler, uv0 ) +
						texture2D( normalSampler, uv1 ) +
						texture2D( normalSampler, uv2 ) +
						texture2D( normalSampler, uv3 );
					return noise * 0.5 - 1.0;
				}

				void sunLight( const vec3 surfaceNormal, const vec3 eyeDirection, float shiny, float spec, float diffuse, inout vec3 diffuseColor, inout vec3 specularColor ) {
					vec3 reflection = normalize( reflect( -sunDirection, surfaceNormal ) );
					float direction = max( 0.0, dot( eyeDirection, reflection ) );
					specularColor += pow( direction, shiny ) * sunColor * spec;
					diffuseColor += max( dot( sunDirection, surfaceNormal ), 0.0 ) * sunColor * diffuse;
				}

				#include <common>
				#include <packing>
				#include <bsdfs>
				#include <fog_pars_fragment>
				#include <logdepthbuf_pars_fragment>
				#include <lights_pars_begin>
				#include <shadowmap_pars_fragment>
				#include <shadowmask_pars_fragment>

				void main() {

					#include <logdepthbuf_fragment>
					vec4 noise = getNoise( worldPosition.xz * size );
					vec3 surfaceNormal = normalize( noise.xzy * vec3( 1.5, 1.0, 1.5 ) );

					vec3 diffuseLight = vec3(0.0);
					vec3 specularLight = vec3(0.0);

					vec3 worldToEye = eye-worldPosition.xyz;
					vec3 eyeDirection = normalize( worldToEye );
					sunLight( surfaceNormal, eyeDirection, 100.0, 2.0, 0.5, diffuseLight, specularLight );

					float distance = length(worldToEye);

					vec2 distortion = surfaceNormal.xz * ( 0.001 + 1.0 / distance ) * distortionScale;
					vec3 reflectionSample = vec3( texture2D( mirrorSampler, mirrorCoord.xy / mirrorCoord.w + distortion ) );

					float theta = max( dot( eyeDirection, surfaceNormal ), 0.0 );
					float rf0 = 0.3;
					float reflectance = rf0 + ( 1.0 - rf0 ) * pow( ( 1.0 - theta ), 5.0 );
					vec3 scatter = max( 0.0, dot( surfaceNormal, eyeDirection ) ) * waterColor;
					vec3 albedo = mix( ( sunColor * diffuseLight * 0.3 + scatter ) * getShadowMask(), ( vec3( 0.1 ) + reflectionSample * 0.9 + reflectionSample * specularLight ), reflectance);
					vec3 outgoingLight = albedo;
					gl_FragColor = vec4( outgoingLight, alpha );

					#include <tonemapping_fragment>
					#include <colorspace_fragment>
					#include <fog_fragment>	
				}`
        };
        const material = new (0, $0147bee01cff6558$export$83c7d75d550a8b0d)({
            fragmentShader: mirrorShader.fragmentShader,
            vertexShader: mirrorShader.vertexShader,
            uniforms: (0, $0147bee01cff6558$export$d8ecdf8615bfea69).clone(mirrorShader.uniforms),
            lights: true,
            side: side,
            fog: fog
        });
        material.uniforms["mirrorSampler"].value = renderTarget.texture;
        material.uniforms["textureMatrix"].value = textureMatrix;
        material.uniforms["alpha"].value = alpha;
        material.uniforms["time"].value = time;
        material.uniforms["normalSampler"].value = normalSampler;
        material.uniforms["sunColor"].value = sunColor;
        material.uniforms["waterColor"].value = waterColor;
        material.uniforms["sunDirection"].value = sunDirection;
        material.uniforms["distortionScale"].value = distortionScale;
        material.uniforms["eye"].value = eye;
        scope.material = material;
        scope.onBeforeRender = function(renderer, scene, camera) {
            mirrorWorldPosition.setFromMatrixPosition(scope.matrixWorld);
            cameraWorldPosition.setFromMatrixPosition(camera.matrixWorld);
            rotationMatrix.extractRotation(scope.matrixWorld);
            normal.set(0, 0, 1);
            normal.applyMatrix4(rotationMatrix);
            view.subVectors(mirrorWorldPosition, cameraWorldPosition);
            // Avoid rendering when mirror is facing away
            if (view.dot(normal) > 0) return;
            view.reflect(normal).negate();
            view.add(mirrorWorldPosition);
            rotationMatrix.extractRotation(camera.matrixWorld);
            lookAtPosition.set(0, 0, -1);
            lookAtPosition.applyMatrix4(rotationMatrix);
            lookAtPosition.add(cameraWorldPosition);
            target.subVectors(mirrorWorldPosition, lookAtPosition);
            target.reflect(normal).negate();
            target.add(mirrorWorldPosition);
            mirrorCamera.position.copy(view);
            mirrorCamera.up.set(0, 1, 0);
            mirrorCamera.up.applyMatrix4(rotationMatrix);
            mirrorCamera.up.reflect(normal);
            mirrorCamera.lookAt(target);
            mirrorCamera.far = camera.far; // Used in WebGLBackground
            mirrorCamera.updateMatrixWorld();
            mirrorCamera.projectionMatrix.copy(camera.projectionMatrix);
            // Update the texture matrix
            textureMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
            textureMatrix.multiply(mirrorCamera.projectionMatrix);
            textureMatrix.multiply(mirrorCamera.matrixWorldInverse);
            // Now update projection matrix with new clip plane, implementing code from: http://www.terathon.com/code/oblique.html
            // Paper explaining this technique: http://www.terathon.com/lengyel/Lengyel-Oblique.pdf
            mirrorPlane.setFromNormalAndCoplanarPoint(normal, mirrorWorldPosition);
            mirrorPlane.applyMatrix4(mirrorCamera.matrixWorldInverse);
            clipPlane.set(mirrorPlane.normal.x, mirrorPlane.normal.y, mirrorPlane.normal.z, mirrorPlane.constant);
            const projectionMatrix = mirrorCamera.projectionMatrix;
            q.x = (Math.sign(clipPlane.x) + projectionMatrix.elements[8]) / projectionMatrix.elements[0];
            q.y = (Math.sign(clipPlane.y) + projectionMatrix.elements[9]) / projectionMatrix.elements[5];
            q.z = -1;
            q.w = (1.0 + projectionMatrix.elements[10]) / projectionMatrix.elements[14];
            // Calculate the scaled plane vector
            clipPlane.multiplyScalar(2.0 / clipPlane.dot(q));
            // Replacing the third row of the projection matrix
            projectionMatrix.elements[2] = clipPlane.x;
            projectionMatrix.elements[6] = clipPlane.y;
            projectionMatrix.elements[10] = clipPlane.z + 1.0 - clipBias;
            projectionMatrix.elements[14] = clipPlane.w;
            eye.setFromMatrixPosition(camera.matrixWorld);
            // Render
            const currentRenderTarget = renderer.getRenderTarget();
            const currentXrEnabled = renderer.xr.enabled;
            const currentShadowAutoUpdate = renderer.shadowMap.autoUpdate;
            scope.visible = false;
            renderer.xr.enabled = false; // Avoid camera modification and recursion
            renderer.shadowMap.autoUpdate = false; // Avoid re-computing shadows
            renderer.setRenderTarget(renderTarget);
            renderer.state.buffers.depth.setMask(true); // make sure the depth buffer is writable so it can be properly cleared, see #18897
            if (renderer.autoClear === false) renderer.clear();
            renderer.render(scene, mirrorCamera);
            scope.visible = true;
            renderer.xr.enabled = currentXrEnabled;
            renderer.shadowMap.autoUpdate = currentShadowAutoUpdate;
            renderer.setRenderTarget(currentRenderTarget);
            // Restore viewport
            const viewport = camera.viewport;
            if (viewport !== undefined) renderer.state.viewport(viewport);
        };
    }
}


var $ca0c8b2242e522d2$export$c9d39ca3bcd93abb;
var $ca0c8b2242e522d2$export$b791fe48eec8032a;
/*!
 *  howler.js v2.2.4
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    "use strict";
    /** Global Methods **/ /***************************************************************************/ /**
   * Create the global controller. All contained methods and properties apply
   * to all sounds that are currently playing or will be in the future.
   */ var HowlerGlobal1 = function() {
        this.init();
    };
    HowlerGlobal1.prototype = {
        /**
     * Initialize the global Howler object.
     * @return {Howler}
     */ init: function() {
            var self = this || Howler1;
            // Create a global ID counter.
            self._counter = 1000;
            // Pool of unlocked HTML5 Audio objects.
            self._html5AudioPool = [];
            self.html5PoolSize = 10;
            // Internal properties.
            self._codecs = {};
            self._howls = [];
            self._muted = false;
            self._volume = 1;
            self._canPlayEvent = "canplaythrough";
            self._navigator = typeof window !== "undefined" && window.navigator ? window.navigator : null;
            // Public properties.
            self.masterGain = null;
            self.noAudio = false;
            self.usingWebAudio = true;
            self.autoSuspend = true;
            self.ctx = null;
            // Set to false to disable the auto audio unlocker.
            self.autoUnlock = true;
            // Setup the various state values for global tracking.
            self._setup();
            return self;
        },
        /**
     * Get/set the global volume for all sounds.
     * @param  {Float} vol Volume from 0.0 to 1.0.
     * @return {Howler/Float}     Returns self or current volume.
     */ volume: function(vol) {
            var self = this || Howler1;
            vol = parseFloat(vol);
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            if (typeof vol !== "undefined" && vol >= 0 && vol <= 1) {
                self._volume = vol;
                // Don't update any of the nodes if we are muted.
                if (self._muted) return self;
                // When using Web Audio, we just need to adjust the master gain.
                if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                // Loop through and change volume for all HTML5 audio nodes.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and change the volumes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node) sound._node.volume = sound._volume * vol;
                    }
                }
                return self;
            }
            return self._volume;
        },
        /**
     * Handle muting and unmuting globally.
     * @param  {Boolean} muted Is muted or not.
     */ mute: function(muted) {
            var self = this || Howler1;
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            self._muted = muted;
            // With Web Audio, we just need to mute the master gain.
            if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(muted ? 0 : self._volume, Howler1.ctx.currentTime);
            // Loop through and mute all HTML5 Audio nodes.
            for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                // Get all of the sounds in this Howl group.
                var ids = self._howls[i]._getSoundIds();
                // Loop through all sounds and mark the audio node as muted.
                for(var j = 0; j < ids.length; j++){
                    var sound = self._howls[i]._soundById(ids[j]);
                    if (sound && sound._node) sound._node.muted = muted ? true : sound._muted;
                }
            }
            return self;
        },
        /**
     * Handle stopping all sounds globally.
     */ stop: function() {
            var self = this || Howler1;
            // Loop through all Howls and stop them.
            for(var i = 0; i < self._howls.length; i++)self._howls[i].stop();
            return self;
        },
        /**
     * Unload and destroy all currently loaded Howl objects.
     * @return {Howler}
     */ unload: function() {
            var self = this || Howler1;
            for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].unload();
            // Create a new AudioContext to make sure it is fully reset.
            if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== "undefined") {
                self.ctx.close();
                self.ctx = null;
                setupAudioContext();
            }
            return self;
        },
        /**
     * Check for codec support of specific extension.
     * @param  {String} ext Audio file extention.
     * @return {Boolean}
     */ codecs: function(ext) {
            return (this || Howler1)._codecs[ext.replace(/^x-/, "")];
        },
        /**
     * Setup various state values for global tracking.
     * @return {Howler}
     */ _setup: function() {
            var self = this || Howler1;
            // Keeps track of the suspend/resume state of the AudioContext.
            self.state = self.ctx ? self.ctx.state || "suspended" : "suspended";
            // Automatically begin the 30-second suspend process
            self._autoSuspend();
            // Check if audio is available.
            if (!self.usingWebAudio) {
                // No audio is available on this system if noAudio is set to true.
                if (typeof Audio !== "undefined") try {
                    var test = new Audio();
                    // Check if the canplaythrough event is available.
                    if (typeof test.oncanplaythrough === "undefined") self._canPlayEvent = "canplay";
                } catch (e) {
                    self.noAudio = true;
                }
                else self.noAudio = true;
            }
            // Test to make sure audio isn't disabled in Internet Explorer.
            try {
                var test = new Audio();
                if (test.muted) self.noAudio = true;
            } catch (e) {}
            // Check for supported codecs.
            if (!self.noAudio) self._setupCodecs();
            return self;
        },
        /**
     * Check for browser support for various codecs and cache the results.
     * @return {Howler}
     */ _setupCodecs: function() {
            var self = this || Howler1;
            var audioTest = null;
            // Must wrap in a try/catch because IE11 in server mode throws an error.
            try {
                audioTest = typeof Audio !== "undefined" ? new Audio() : null;
            } catch (err) {
                return self;
            }
            if (!audioTest || typeof audioTest.canPlayType !== "function") return self;
            var mpegTest = audioTest.canPlayType("audio/mpeg;").replace(/^no$/, "");
            // Opera version <33 has mixed MP3 support, so we need to check for and block it.
            var ua = self._navigator ? self._navigator.userAgent : "";
            var checkOpera = ua.match(/OPR\/(\d+)/g);
            var isOldOpera = checkOpera && parseInt(checkOpera[0].split("/")[1], 10) < 33;
            var checkSafari = ua.indexOf("Safari") !== -1 && ua.indexOf("Chrome") === -1;
            var safariVersion = ua.match(/Version\/(.*?) /);
            var isOldSafari = checkSafari && safariVersion && parseInt(safariVersion[1], 10) < 15;
            self._codecs = {
                mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType("audio/mp3;").replace(/^no$/, ""))),
                mpeg: !!mpegTest,
                opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ""),
                ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                wav: !!(audioTest.canPlayType('audio/wav; codecs="1"') || audioTest.canPlayType("audio/wav")).replace(/^no$/, ""),
                aac: !!audioTest.canPlayType("audio/aac;").replace(/^no$/, ""),
                caf: !!audioTest.canPlayType("audio/x-caf;").replace(/^no$/, ""),
                m4a: !!(audioTest.canPlayType("audio/x-m4a;") || audioTest.canPlayType("audio/m4a;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                m4b: !!(audioTest.canPlayType("audio/x-m4b;") || audioTest.canPlayType("audio/m4b;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                mp4: !!(audioTest.canPlayType("audio/x-mp4;") || audioTest.canPlayType("audio/mp4;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                weba: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                webm: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ""),
                flac: !!(audioTest.canPlayType("audio/x-flac;") || audioTest.canPlayType("audio/flac;")).replace(/^no$/, "")
            };
            return self;
        },
        /**
     * Some browsers/devices will only allow audio to be played after a user interaction.
     * Attempt to automatically unlock audio on the first user interaction.
     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
     * @return {Howler}
     */ _unlockAudio: function() {
            var self = this || Howler1;
            // Only run this if Web Audio is supported and it hasn't already been unlocked.
            if (self._audioUnlocked || !self.ctx) return;
            self._audioUnlocked = false;
            self.autoUnlock = false;
            // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
            // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
            // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
            if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
                self._mobileUnloaded = true;
                self.unload();
            }
            // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
            // http://stackoverflow.com/questions/24119684
            self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);
            // Call this method on touch start to create and play a buffer,
            // then check if the audio actually played to determine if
            // audio has now been unlocked on iOS, Android, etc.
            var unlock = function(e) {
                // Create a pool of unlocked HTML5 Audio objects that can
                // be used for playing sounds without user interaction. HTML5
                // Audio objects must be individually unlocked, as opposed
                // to the WebAudio API which only needs a single activation.
                // This must occur before WebAudio setup or the source.onended
                // event will not fire.
                while(self._html5AudioPool.length < self.html5PoolSize)try {
                    var audioNode = new Audio();
                    // Mark this Audio object as unlocked to ensure it can get returned
                    // to the unlocked pool when released.
                    audioNode._unlocked = true;
                    // Add the audio node to the pool.
                    self._releaseHtml5Audio(audioNode);
                } catch (e) {
                    self.noAudio = true;
                    break;
                }
                // Loop through any assigned audio nodes and unlock them.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and unlock the audio nodes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node && !sound._node._unlocked) {
                            sound._node._unlocked = true;
                            sound._node.load();
                        }
                    }
                }
                // Fix Android can not play in suspend state.
                self._autoResume();
                // Create an empty buffer.
                var source = self.ctx.createBufferSource();
                source.buffer = self._scratchBuffer;
                source.connect(self.ctx.destination);
                // Play the empty buffer.
                if (typeof source.start === "undefined") source.noteOn(0);
                else source.start(0);
                // Calling resume() on a stack initiated by user gesture is what actually unlocks the audio on Android Chrome >= 55.
                if (typeof self.ctx.resume === "function") self.ctx.resume();
                // Setup a timeout to check that we are unlocked on the next event loop.
                source.onended = function() {
                    source.disconnect(0);
                    // Update the unlocked state and prevent this check from happening again.
                    self._audioUnlocked = true;
                    // Remove the touch start listener.
                    document.removeEventListener("touchstart", unlock, true);
                    document.removeEventListener("touchend", unlock, true);
                    document.removeEventListener("click", unlock, true);
                    document.removeEventListener("keydown", unlock, true);
                    // Let all sounds know that audio has been unlocked.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit("unlock");
                };
            };
            // Setup a touch start listener to attempt an unlock in.
            document.addEventListener("touchstart", unlock, true);
            document.addEventListener("touchend", unlock, true);
            document.addEventListener("click", unlock, true);
            document.addEventListener("keydown", unlock, true);
            return self;
        },
        /**
     * Get an unlocked HTML5 Audio object from the pool. If none are left,
     * return a new Audio object and throw a warning.
     * @return {Audio} HTML5 Audio object.
     */ _obtainHtml5Audio: function() {
            var self = this || Howler1;
            // Return the next object from the pool if one exists.
            if (self._html5AudioPool.length) return self._html5AudioPool.pop();
            //.Check if the audio is locked and throw a warning.
            var testPlay = new Audio().play();
            if (testPlay && typeof Promise !== "undefined" && (testPlay instanceof Promise || typeof testPlay.then === "function")) testPlay.catch(function() {
                console.warn("HTML5 Audio pool exhausted, returning potentially locked audio object.");
            });
            return new Audio();
        },
        /**
     * Return an activated HTML5 Audio object to the pool.
     * @return {Howler}
     */ _releaseHtml5Audio: function(audio) {
            var self = this || Howler1;
            // Don't add audio to the pool if we don't know if it has been unlocked.
            if (audio._unlocked) self._html5AudioPool.push(audio);
            return self;
        },
        /**
     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
     * @return {Howler}
     */ _autoSuspend: function() {
            var self = this;
            if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === "undefined" || !Howler1.usingWebAudio) return;
            // Check if any sounds are playing.
            for(var i = 0; i < self._howls.length; i++){
                if (self._howls[i]._webAudio) for(var j = 0; j < self._howls[i]._sounds.length; j++){
                    if (!self._howls[i]._sounds[j]._paused) return self;
                }
            }
            if (self._suspendTimer) clearTimeout(self._suspendTimer);
            // If no sound has played after 30 seconds, suspend the context.
            self._suspendTimer = setTimeout(function() {
                if (!self.autoSuspend) return;
                self._suspendTimer = null;
                self.state = "suspending";
                // Handle updating the state of the audio context after suspending.
                var handleSuspension = function() {
                    self.state = "suspended";
                    if (self._resumeAfterSuspend) {
                        delete self._resumeAfterSuspend;
                        self._autoResume();
                    }
                };
                // Either the state gets suspended or it is interrupted.
                // Either way, we need to update the state to suspended.
                self.ctx.suspend().then(handleSuspension, handleSuspension);
            }, 30000);
            return self;
        },
        /**
     * Automatically resume the Web Audio AudioContext when a new sound is played.
     * @return {Howler}
     */ _autoResume: function() {
            var self = this;
            if (!self.ctx || typeof self.ctx.resume === "undefined" || !Howler1.usingWebAudio) return;
            if (self.state === "running" && self.ctx.state !== "interrupted" && self._suspendTimer) {
                clearTimeout(self._suspendTimer);
                self._suspendTimer = null;
            } else if (self.state === "suspended" || self.state === "running" && self.ctx.state === "interrupted") {
                self.ctx.resume().then(function() {
                    self.state = "running";
                    // Emit to all Howls that the audio has resumed.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit("resume");
                });
                if (self._suspendTimer) {
                    clearTimeout(self._suspendTimer);
                    self._suspendTimer = null;
                }
            } else if (self.state === "suspending") self._resumeAfterSuspend = true;
            return self;
        }
    };
    // Setup the global audio controller.
    var Howler1 = new HowlerGlobal1();
    /** Group Methods **/ /***************************************************************************/ /**
   * Create an audio group controller.
   * @param {Object} o Passed in properties for this group.
   */ var Howl1 = function(o) {
        var self = this;
        // Throw an error if no source is provided.
        if (!o.src || o.src.length === 0) {
            console.error("An array of source files must be passed with any new Howl.");
            return;
        }
        self.init(o);
    };
    Howl1.prototype = {
        /**
     * Initialize a new Howl group object.
     * @param  {Object} o Passed in properties for this group.
     * @return {Howl}
     */ init: function(o) {
            var self = this;
            // If we don't have an AudioContext created yet, run the setup.
            if (!Howler1.ctx) setupAudioContext();
            // Setup user-defined default properties.
            self._autoplay = o.autoplay || false;
            self._format = typeof o.format !== "string" ? o.format : [
                o.format
            ];
            self._html5 = o.html5 || false;
            self._muted = o.mute || false;
            self._loop = o.loop || false;
            self._pool = o.pool || 5;
            self._preload = typeof o.preload === "boolean" || o.preload === "metadata" ? o.preload : true;
            self._rate = o.rate || 1;
            self._sprite = o.sprite || {};
            self._src = typeof o.src !== "string" ? o.src : [
                o.src
            ];
            self._volume = o.volume !== undefined ? o.volume : 1;
            self._xhr = {
                method: o.xhr && o.xhr.method ? o.xhr.method : "GET",
                headers: o.xhr && o.xhr.headers ? o.xhr.headers : null,
                withCredentials: o.xhr && o.xhr.withCredentials ? o.xhr.withCredentials : false
            };
            // Setup all other default properties.
            self._duration = 0;
            self._state = "unloaded";
            self._sounds = [];
            self._endTimers = {};
            self._queue = [];
            self._playLock = false;
            // Setup event listeners.
            self._onend = o.onend ? [
                {
                    fn: o.onend
                }
            ] : [];
            self._onfade = o.onfade ? [
                {
                    fn: o.onfade
                }
            ] : [];
            self._onload = o.onload ? [
                {
                    fn: o.onload
                }
            ] : [];
            self._onloaderror = o.onloaderror ? [
                {
                    fn: o.onloaderror
                }
            ] : [];
            self._onplayerror = o.onplayerror ? [
                {
                    fn: o.onplayerror
                }
            ] : [];
            self._onpause = o.onpause ? [
                {
                    fn: o.onpause
                }
            ] : [];
            self._onplay = o.onplay ? [
                {
                    fn: o.onplay
                }
            ] : [];
            self._onstop = o.onstop ? [
                {
                    fn: o.onstop
                }
            ] : [];
            self._onmute = o.onmute ? [
                {
                    fn: o.onmute
                }
            ] : [];
            self._onvolume = o.onvolume ? [
                {
                    fn: o.onvolume
                }
            ] : [];
            self._onrate = o.onrate ? [
                {
                    fn: o.onrate
                }
            ] : [];
            self._onseek = o.onseek ? [
                {
                    fn: o.onseek
                }
            ] : [];
            self._onunlock = o.onunlock ? [
                {
                    fn: o.onunlock
                }
            ] : [];
            self._onresume = [];
            // Web Audio or HTML5 Audio?
            self._webAudio = Howler1.usingWebAudio && !self._html5;
            // Automatically try to enable audio.
            if (typeof Howler1.ctx !== "undefined" && Howler1.ctx && Howler1.autoUnlock) Howler1._unlockAudio();
            // Keep track of this Howl group in the global controller.
            Howler1._howls.push(self);
            // If they selected autoplay, add a play event to the load queue.
            if (self._autoplay) self._queue.push({
                event: "play",
                action: function() {
                    self.play();
                }
            });
            // Load the source file unless otherwise specified.
            if (self._preload && self._preload !== "none") self.load();
            return self;
        },
        /**
     * Load the audio file.
     * @return {Howler}
     */ load: function() {
            var self = this;
            var url = null;
            // If no audio is available, quit immediately.
            if (Howler1.noAudio) {
                self._emit("loaderror", null, "No audio support.");
                return;
            }
            // Make sure our source is in an array.
            if (typeof self._src === "string") self._src = [
                self._src
            ];
            // Loop through the sources and pick the first one that is compatible.
            for(var i = 0; i < self._src.length; i++){
                var ext, str;
                if (self._format && self._format[i]) // If an extension was specified, use that instead.
                ext = self._format[i];
                else {
                    // Make sure the source is a string.
                    str = self._src[i];
                    if (typeof str !== "string") {
                        self._emit("loaderror", null, "Non-string found in selected audio sources - ignoring.");
                        continue;
                    }
                    // Extract the file extension from the URL or base64 data URI.
                    ext = /^data:audio\/([^;,]+);/i.exec(str);
                    if (!ext) ext = /\.([^.]+)$/.exec(str.split("?", 1)[0]);
                    if (ext) ext = ext[1].toLowerCase();
                }
                // Log a warning if no extension was found.
                if (!ext) console.warn('No file extension was found. Consider using the "format" property or specify an extension.');
                // Check if this extension is available.
                if (ext && Howler1.codecs(ext)) {
                    url = self._src[i];
                    break;
                }
            }
            if (!url) {
                self._emit("loaderror", null, "No codec support for selected audio sources.");
                return;
            }
            self._src = url;
            self._state = "loading";
            // If the hosting page is HTTPS and the source isn't,
            // drop down to HTML5 Audio to avoid Mixed Content errors.
            if (window.location.protocol === "https:" && url.slice(0, 5) === "http:") {
                self._html5 = true;
                self._webAudio = false;
            }
            // Create a new sound object and add it to the pool.
            new Sound1(self);
            // Load and decode the audio data for playback.
            if (self._webAudio) loadBuffer(self);
            return self;
        },
        /**
     * Play a sound or resume previous playback.
     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Number}          Sound ID.
     */ play: function(sprite, internal) {
            var self = this;
            var id = null;
            // Determine if a sprite, sound id or nothing was passed
            if (typeof sprite === "number") {
                id = sprite;
                sprite = null;
            } else if (typeof sprite === "string" && self._state === "loaded" && !self._sprite[sprite]) // If the passed sprite doesn't exist, do nothing.
            return null;
            else if (typeof sprite === "undefined") {
                // Use the default sound sprite (plays the full audio length).
                sprite = "__default";
                // Check if there is a single paused sound that isn't ended.
                // If there is, play that sound. If not, continue as usual.
                if (!self._playLock) {
                    var num = 0;
                    for(var i = 0; i < self._sounds.length; i++)if (self._sounds[i]._paused && !self._sounds[i]._ended) {
                        num++;
                        id = self._sounds[i]._id;
                    }
                    if (num === 1) sprite = null;
                    else id = null;
                }
            }
            // Get the selected node, or get one from the pool.
            var sound = id ? self._soundById(id) : self._inactiveSound();
            // If the sound doesn't exist, do nothing.
            if (!sound) return null;
            // Select the sprite definition.
            if (id && !sprite) sprite = sound._sprite || "__default";
            // If the sound hasn't loaded, we must wait to get the audio's duration.
            // We also need to wait to make sure we don't run into race conditions with
            // the order of function calls.
            if (self._state !== "loaded") {
                // Set the sprite value on this sound.
                sound._sprite = sprite;
                // Mark this sound as not ended in case another sound is played before this one loads.
                sound._ended = false;
                // Add the sound to the queue to be played on load.
                var soundId = sound._id;
                self._queue.push({
                    event: "play",
                    action: function() {
                        self.play(soundId);
                    }
                });
                return soundId;
            }
            // Don't play the sound if an id was passed and it is already playing.
            if (id && !sound._paused) {
                // Trigger the play event, in order to keep iterating through queue.
                if (!internal) self._loadQueue("play");
                return sound._id;
            }
            // Make sure the AudioContext isn't suspended, and resume it if it is.
            if (self._webAudio) Howler1._autoResume();
            // Determine how long to play for and where to start playing.
            var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
            var duration = Math.max(0, (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000 - seek);
            var timeout = duration * 1000 / Math.abs(sound._rate);
            var start = self._sprite[sprite][0] / 1000;
            var stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
            sound._sprite = sprite;
            // Mark the sound as ended instantly so that this async playback
            // doesn't get grabbed by another call to play while this one waits to start.
            sound._ended = false;
            // Update the parameters of the sound.
            var setParams = function() {
                sound._paused = false;
                sound._seek = seek;
                sound._start = start;
                sound._stop = stop;
                sound._loop = !!(sound._loop || self._sprite[sprite][2]);
            };
            // End the sound instantly if seek is at the end.
            if (seek >= stop) {
                self._ended(sound);
                return;
            }
            // Begin the actual playback.
            var node = sound._node;
            if (self._webAudio) {
                // Fire this when the sound is ready to play to begin Web Audio playback.
                var playWebAudio = function() {
                    self._playLock = false;
                    setParams();
                    self._refreshBuffer(sound);
                    // Setup the playback params.
                    var vol = sound._muted || self._muted ? 0 : sound._volume;
                    node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                    sound._playStart = Howler1.ctx.currentTime;
                    // Play the sound using the supported method.
                    if (typeof node.bufferSource.start === "undefined") sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
                    else sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
                    // Start a new timer if none is present.
                    if (timeout !== Infinity) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                    if (!internal) setTimeout(function() {
                        self._emit("play", sound._id);
                        self._loadQueue();
                    }, 0);
                };
                if (Howler1.state === "running" && Howler1.ctx.state !== "interrupted") playWebAudio();
                else {
                    self._playLock = true;
                    // Wait for the audio context to resume before playing.
                    self.once("resume", playWebAudio);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            } else {
                // Fire this when the sound is ready to play to begin HTML5 Audio playback.
                var playHtml5 = function() {
                    node.currentTime = seek;
                    node.muted = sound._muted || self._muted || Howler1._muted || node.muted;
                    node.volume = sound._volume * Howler1.volume();
                    node.playbackRate = sound._rate;
                    // Some browsers will throw an error if this is called without user interaction.
                    try {
                        var play = node.play();
                        // Support older browsers that don't support promises, and thus don't have this issue.
                        if (play && typeof Promise !== "undefined" && (play instanceof Promise || typeof play.then === "function")) {
                            // Implements a lock to prevent DOMException: The play() request was interrupted by a call to pause().
                            self._playLock = true;
                            // Set param values immediately.
                            setParams();
                            // Releases the lock and executes queued actions.
                            play.then(function() {
                                self._playLock = false;
                                node._unlocked = true;
                                if (!internal) self._emit("play", sound._id);
                                else self._loadQueue();
                            }).catch(function() {
                                self._playLock = false;
                                self._emit("playerror", sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                                // Reset the ended and paused values.
                                sound._ended = true;
                                sound._paused = true;
                            });
                        } else if (!internal) {
                            self._playLock = false;
                            setParams();
                            self._emit("play", sound._id);
                        }
                        // Setting rate before playing won't work in IE, so we set it again here.
                        node.playbackRate = sound._rate;
                        // If the node is still paused, then we can assume there was a playback issue.
                        if (node.paused) {
                            self._emit("playerror", sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                            return;
                        }
                        // Setup the end timer on sprites or listen for the ended event.
                        if (sprite !== "__default" || sound._loop) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                        else {
                            self._endTimers[sound._id] = function() {
                                // Fire ended on this audio node.
                                self._ended(sound);
                                // Clear this listener.
                                node.removeEventListener("ended", self._endTimers[sound._id], false);
                            };
                            node.addEventListener("ended", self._endTimers[sound._id], false);
                        }
                    } catch (err) {
                        self._emit("playerror", sound._id, err);
                    }
                };
                // If this is streaming audio, make sure the src is set and load again.
                if (node.src === "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA") {
                    node.src = self._src;
                    node.load();
                }
                // Play immediately if ready, or wait for the 'canplaythrough'e vent.
                var loadedNoReadyState = window && window.ejecta || !node.readyState && Howler1._navigator.isCocoonJS;
                if (node.readyState >= 3 || loadedNoReadyState) playHtml5();
                else {
                    self._playLock = true;
                    self._state = "loading";
                    var listener = function() {
                        self._state = "loaded";
                        // Begin playback.
                        playHtml5();
                        // Clear this listener.
                        node.removeEventListener(Howler1._canPlayEvent, listener, false);
                    };
                    node.addEventListener(Howler1._canPlayEvent, listener, false);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            }
            return sound._id;
        },
        /**
     * Pause playback and save current position.
     * @param  {Number} id The sound ID (empty to pause all in group).
     * @return {Howl}
     */ pause: function(id) {
            var self = this;
            // If the sound hasn't loaded or a play() promise is pending, add it to the load queue to pause when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "pause",
                    action: function() {
                        self.pause(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be paused.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound && !sound._paused) {
                    // Reset the seek position.
                    sound._seek = self.seek(ids[i]);
                    sound._rateSeek = 0;
                    sound._paused = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) {
                            // Make sure the sound has been created.
                            if (!sound._node.bufferSource) continue;
                            if (typeof sound._node.bufferSource.stop === "undefined") sound._node.bufferSource.noteOff(0);
                            else sound._node.bufferSource.stop(0);
                            // Clean up the buffer source.
                            self._cleanBuffer(sound._node);
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) sound._node.pause();
                    }
                }
                // Fire the pause event, unless `true` is passed as the 2nd argument.
                if (!arguments[1]) self._emit("pause", sound ? sound._id : null);
            }
            return self;
        },
        /**
     * Stop playback and reset to start.
     * @param  {Number} id The sound ID (empty to stop all in group).
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Howl}
     */ stop: function(id, internal) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to stop when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "stop",
                    action: function() {
                        self.stop(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be stopped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    // Reset the seek position.
                    sound._seek = sound._start || 0;
                    sound._rateSeek = 0;
                    sound._paused = true;
                    sound._ended = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) // Make sure the sound's AudioBufferSourceNode has been created.
                        {
                            if (sound._node.bufferSource) {
                                if (typeof sound._node.bufferSource.stop === "undefined") sound._node.bufferSource.noteOff(0);
                                else sound._node.bufferSource.stop(0);
                                // Clean up the buffer source.
                                self._cleanBuffer(sound._node);
                            }
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
                            sound._node.currentTime = sound._start || 0;
                            sound._node.pause();
                            // If this is a live stream, stop download once the audio is stopped.
                            if (sound._node.duration === Infinity) self._clearSound(sound._node);
                        }
                    }
                    if (!internal) self._emit("stop", sound._id);
                }
            }
            return self;
        },
        /**
     * Mute/unmute a single sound or all sounds in this Howl group.
     * @param  {Boolean} muted Set to true to mute and false to unmute.
     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
     * @return {Howl}
     */ mute: function(muted, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to mute when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "mute",
                    action: function() {
                        self.mute(muted, id);
                    }
                });
                return self;
            }
            // If applying mute/unmute to all sounds, update the group's value.
            if (typeof id === "undefined") {
                if (typeof muted === "boolean") self._muted = muted;
                else return self._muted;
            }
            // If no id is passed, get all ID's to be muted.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    sound._muted = muted;
                    // Cancel active fade and set the volume to the end value.
                    if (sound._interval) self._stopFade(sound._id);
                    if (self._webAudio && sound._node) sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler1.ctx.currentTime);
                    else if (sound._node) sound._node.muted = Howler1._muted ? true : muted;
                    self._emit("mute", sound._id);
                }
            }
            return self;
        },
        /**
     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
     *   volume() -> Returns the group's volume value.
     *   volume(id) -> Returns the sound id's current volume.
     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
     *   volume(vol, id) -> Sets the volume of passed sound id.
     * @return {Howl/Number} Returns self or current volume.
     */ volume: function() {
            var self = this;
            var args = arguments;
            var vol, id;
            // Determine the values based on arguments.
            if (args.length === 0) // Return the value of the groups' volume.
            return self._volume;
            else if (args.length === 1 || args.length === 2 && typeof args[1] === "undefined") {
                // First check if this is an ID, and if not, assume it is a new volume.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else vol = parseFloat(args[0]);
            } else if (args.length >= 2) {
                vol = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the volume or return the current volume.
            var sound;
            if (typeof vol !== "undefined" && vol >= 0 && vol <= 1) {
                // If the sound hasn't loaded, add it to the load queue to change volume when capable.
                if (self._state !== "loaded" || self._playLock) {
                    self._queue.push({
                        event: "volume",
                        action: function() {
                            self.volume.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group volume.
                if (typeof id === "undefined") self._volume = vol;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        sound._volume = vol;
                        // Stop currently running fades.
                        if (!args[2]) self._stopFade(id[i]);
                        if (self._webAudio && sound._node && !sound._muted) sound._node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                        else if (sound._node && !sound._muted) sound._node.volume = vol * Howler1.volume();
                        self._emit("volume", sound._id);
                    }
                }
            } else {
                sound = id ? self._soundById(id) : self._sounds[0];
                return sound ? sound._volume : 0;
            }
            return self;
        },
        /**
     * Fade a currently playing sound between two volumes (if no id is passed, all sounds will fade).
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id (omit to fade all sounds).
     * @return {Howl}
     */ fade: function(from, to, len, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to fade when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "fade",
                    action: function() {
                        self.fade(from, to, len, id);
                    }
                });
                return self;
            }
            // Make sure the to/from/len values are numbers.
            from = Math.min(Math.max(0, parseFloat(from)), 1);
            to = Math.min(Math.max(0, parseFloat(to)), 1);
            len = parseFloat(len);
            // Set the volume to the start position.
            self.volume(from, id);
            // Fade the volume of one or all sounds.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                // Create a linear fade or fall back to timeouts with HTML5 Audio.
                if (sound) {
                    // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
                    if (!id) self._stopFade(ids[i]);
                    // If we are using Web Audio, let the native methods do the actual fade.
                    if (self._webAudio && !sound._muted) {
                        var currentTime = Howler1.ctx.currentTime;
                        var end = currentTime + len / 1000;
                        sound._volume = from;
                        sound._node.gain.setValueAtTime(from, currentTime);
                        sound._node.gain.linearRampToValueAtTime(to, end);
                    }
                    self._startFadeInterval(sound, from, to, len, ids[i], typeof id === "undefined");
                }
            }
            return self;
        },
        /**
     * Starts the internal interval to fade a sound.
     * @param  {Object} sound Reference to sound to fade.
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id to fade.
     * @param  {Boolean} isGroup   If true, set the volume on the group.
     */ _startFadeInterval: function(sound, from, to, len, id, isGroup) {
            var self = this;
            var vol = from;
            var diff = to - from;
            var steps = Math.abs(diff / 0.01);
            var stepLen = Math.max(4, steps > 0 ? len / steps : len);
            var lastTick = Date.now();
            // Store the value being faded to.
            sound._fadeTo = to;
            // Update the volume value on each interval tick.
            sound._interval = setInterval(function() {
                // Update the volume based on the time since the last tick.
                var tick = (Date.now() - lastTick) / len;
                lastTick = Date.now();
                vol += diff * tick;
                // Round to within 2 decimal points.
                vol = Math.round(vol * 100) / 100;
                // Make sure the volume is in the right bounds.
                if (diff < 0) vol = Math.max(to, vol);
                else vol = Math.min(to, vol);
                // Change the volume.
                if (self._webAudio) sound._volume = vol;
                else self.volume(vol, sound._id, true);
                // Set the group's volume.
                if (isGroup) self._volume = vol;
                // When the fade is complete, stop it and fire event.
                if (to < from && vol <= to || to > from && vol >= to) {
                    clearInterval(sound._interval);
                    sound._interval = null;
                    sound._fadeTo = null;
                    self.volume(to, sound._id);
                    self._emit("fade", sound._id);
                }
            }, stepLen);
        },
        /**
     * Internal method that stops the currently playing fade when
     * a new fade starts, volume is changed or the sound is stopped.
     * @param  {Number} id The sound id.
     * @return {Howl}
     */ _stopFade: function(id) {
            var self = this;
            var sound = self._soundById(id);
            if (sound && sound._interval) {
                if (self._webAudio) sound._node.gain.cancelScheduledValues(Howler1.ctx.currentTime);
                clearInterval(sound._interval);
                sound._interval = null;
                self.volume(sound._fadeTo, id);
                sound._fadeTo = null;
                self._emit("fade", id);
            }
            return self;
        },
        /**
     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
     *   loop() -> Returns the group's loop value.
     *   loop(id) -> Returns the sound id's loop value.
     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
     *   loop(loop, id) -> Sets the loop value of passed sound id.
     * @return {Howl/Boolean} Returns self or current loop value.
     */ loop: function() {
            var self = this;
            var args = arguments;
            var loop, id, sound;
            // Determine the values for loop and id.
            if (args.length === 0) // Return the grou's loop value.
            return self._loop;
            else if (args.length === 1) {
                if (typeof args[0] === "boolean") {
                    loop = args[0];
                    self._loop = loop;
                } else {
                    // Return this sound's loop value.
                    sound = self._soundById(parseInt(args[0], 10));
                    return sound ? sound._loop : false;
                }
            } else if (args.length === 2) {
                loop = args[0];
                id = parseInt(args[1], 10);
            }
            // If no id is passed, get all ID's to be looped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                sound = self._soundById(ids[i]);
                if (sound) {
                    sound._loop = loop;
                    if (self._webAudio && sound._node && sound._node.bufferSource) {
                        sound._node.bufferSource.loop = loop;
                        if (loop) {
                            sound._node.bufferSource.loopStart = sound._start || 0;
                            sound._node.bufferSource.loopEnd = sound._stop;
                            // If playing, restart playback to ensure looping updates.
                            if (self.playing(ids[i])) {
                                self.pause(ids[i], true);
                                self.play(ids[i], true);
                            }
                        }
                    }
                }
            }
            return self;
        },
        /**
     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   rate() -> Returns the first sound node's current playback rate.
     *   rate(id) -> Returns the sound id's current playback rate.
     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
     *   rate(rate, id) -> Sets the playback rate of passed sound id.
     * @return {Howl/Number} Returns self or the current playback rate.
     */ rate: function() {
            var self = this;
            var args = arguments;
            var rate, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current rate of the first node.
            id = self._sounds[0]._id;
            else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new rate value.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else rate = parseFloat(args[0]);
            } else if (args.length === 2) {
                rate = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the playback rate or return the current value.
            var sound;
            if (typeof rate === "number") {
                // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
                if (self._state !== "loaded" || self._playLock) {
                    self._queue.push({
                        event: "rate",
                        action: function() {
                            self.rate.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group rate.
                if (typeof id === "undefined") self._rate = rate;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        // Keep track of our position when the rate changed and update the playback
                        // start position so we can properly adjust the seek position for time elapsed.
                        if (self.playing(id[i])) {
                            sound._rateSeek = self.seek(id[i]);
                            sound._playStart = self._webAudio ? Howler1.ctx.currentTime : sound._playStart;
                        }
                        sound._rate = rate;
                        // Change the playback rate.
                        if (self._webAudio && sound._node && sound._node.bufferSource) sound._node.bufferSource.playbackRate.setValueAtTime(rate, Howler1.ctx.currentTime);
                        else if (sound._node) sound._node.playbackRate = rate;
                        // Reset the timers.
                        var seek = self.seek(id[i]);
                        var duration = (self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000 - seek;
                        var timeout = duration * 1000 / Math.abs(sound._rate);
                        // Start a new end timer if sound is already playing.
                        if (self._endTimers[id[i]] || !sound._paused) {
                            self._clearTimer(id[i]);
                            self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
                        }
                        self._emit("rate", sound._id);
                    }
                }
            } else {
                sound = self._soundById(id);
                return sound ? sound._rate : self._rate;
            }
            return self;
        },
        /**
     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   seek() -> Returns the first sound node's current seek position.
     *   seek(id) -> Returns the sound id's current seek position.
     *   seek(seek) -> Sets the seek position of the first sound node.
     *   seek(seek, id) -> Sets the seek position of passed sound id.
     * @return {Howl/Number} Returns self or the current seek position.
     */ seek: function() {
            var self = this;
            var args = arguments;
            var seek, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current position of the first node.
            {
                if (self._sounds.length) id = self._sounds[0]._id;
            } else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new seek position.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else if (self._sounds.length) {
                    id = self._sounds[0]._id;
                    seek = parseFloat(args[0]);
                }
            } else if (args.length === 2) {
                seek = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // If there is no ID, bail out.
            if (typeof id === "undefined") return 0;
            // If the sound hasn't loaded, add it to the load queue to seek when capable.
            if (typeof seek === "number" && (self._state !== "loaded" || self._playLock)) {
                self._queue.push({
                    event: "seek",
                    action: function() {
                        self.seek.apply(self, args);
                    }
                });
                return self;
            }
            // Get the sound.
            var sound = self._soundById(id);
            if (sound) {
                if (typeof seek === "number" && seek >= 0) {
                    // Pause the sound and update position for restarting playback.
                    var playing = self.playing(id);
                    if (playing) self.pause(id, true);
                    // Move the position of the track and cancel timer.
                    sound._seek = seek;
                    sound._ended = false;
                    self._clearTimer(id);
                    // Update the seek position for HTML5 Audio.
                    if (!self._webAudio && sound._node && !isNaN(sound._node.duration)) sound._node.currentTime = seek;
                    // Seek and emit when ready.
                    var seekAndEmit = function() {
                        // Restart the playback if the sound was playing.
                        if (playing) self.play(id, true);
                        self._emit("seek", id);
                    };
                    // Wait for the play lock to be unset before emitting (HTML5 Audio).
                    if (playing && !self._webAudio) {
                        var emitSeek = function() {
                            if (!self._playLock) seekAndEmit();
                            else setTimeout(emitSeek, 0);
                        };
                        setTimeout(emitSeek, 0);
                    } else seekAndEmit();
                } else {
                    if (self._webAudio) {
                        var realTime = self.playing(id) ? Howler1.ctx.currentTime - sound._playStart : 0;
                        var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
                        return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
                    } else return sound._node.currentTime;
                }
            }
            return self;
        },
        /**
     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
     * @return {Boolean} True if playing and false if not.
     */ playing: function(id) {
            var self = this;
            // Check the passed sound ID (if any).
            if (typeof id === "number") {
                var sound = self._soundById(id);
                return sound ? !sound._paused : false;
            }
            // Otherwise, loop through all sounds and check if any are playing.
            for(var i = 0; i < self._sounds.length; i++){
                if (!self._sounds[i]._paused) return true;
            }
            return false;
        },
        /**
     * Get the duration of this sound. Passing a sound id will return the sprite duration.
     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
     * @return {Number} Audio duration in seconds.
     */ duration: function(id) {
            var self = this;
            var duration = self._duration;
            // If we pass an ID, get the sound and return the sprite length.
            var sound = self._soundById(id);
            if (sound) duration = self._sprite[sound._sprite][1] / 1000;
            return duration;
        },
        /**
     * Returns the current loaded state of this Howl.
     * @return {String} 'unloaded', 'loading', 'loaded'
     */ state: function() {
            return this._state;
        },
        /**
     * Unload and destroy the current Howl object.
     * This will immediately stop all sound instances attached to this group.
     */ unload: function() {
            var self = this;
            // Stop playing any active sounds.
            var sounds = self._sounds;
            for(var i = 0; i < sounds.length; i++){
                // Stop the sound if it is currently playing.
                if (!sounds[i]._paused) self.stop(sounds[i]._id);
                // Remove the source or disconnect.
                if (!self._webAudio) {
                    // Set the source to 0-second silence to stop any downloading (except in IE).
                    self._clearSound(sounds[i]._node);
                    // Remove any event listeners.
                    sounds[i]._node.removeEventListener("error", sounds[i]._errorFn, false);
                    sounds[i]._node.removeEventListener(Howler1._canPlayEvent, sounds[i]._loadFn, false);
                    sounds[i]._node.removeEventListener("ended", sounds[i]._endFn, false);
                    // Release the Audio object back to the pool.
                    Howler1._releaseHtml5Audio(sounds[i]._node);
                }
                // Empty out all of the nodes.
                delete sounds[i]._node;
                // Make sure all timers are cleared out.
                self._clearTimer(sounds[i]._id);
            }
            // Remove the references in the global Howler object.
            var index = Howler1._howls.indexOf(self);
            if (index >= 0) Howler1._howls.splice(index, 1);
            // Delete this sound from the cache (if no other Howl is using it).
            var remCache = true;
            for(i = 0; i < Howler1._howls.length; i++)if (Howler1._howls[i]._src === self._src || self._src.indexOf(Howler1._howls[i]._src) >= 0) {
                remCache = false;
                break;
            }
            if (cache && remCache) delete cache[self._src];
            // Clear global errors.
            Howler1.noAudio = false;
            // Clear out `self`.
            self._state = "unloaded";
            self._sounds = [];
            self = null;
            return null;
        },
        /**
     * Listen to a custom event.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
     * @return {Howl}
     */ on: function(event, fn, id, once) {
            var self = this;
            var events = self["_on" + event];
            if (typeof fn === "function") events.push(once ? {
                id: id,
                fn: fn,
                once: once
            } : {
                id: id,
                fn: fn
            });
            return self;
        },
        /**
     * Remove a custom event. Call without parameters to remove all events.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
     * @param  {Number}   id    (optional) Only remove events for this sound.
     * @return {Howl}
     */ off: function(event, fn, id) {
            var self = this;
            var events = self["_on" + event];
            var i = 0;
            // Allow passing just an event and ID.
            if (typeof fn === "number") {
                id = fn;
                fn = null;
            }
            if (fn || id) // Loop through event store and remove the passed function.
            for(i = 0; i < events.length; i++){
                var isId = id === events[i].id;
                if (fn === events[i].fn && isId || !fn && isId) {
                    events.splice(i, 1);
                    break;
                }
            }
            else if (event) // Clear out all events of this type.
            self["_on" + event] = [];
            else {
                // Clear out all events of every type.
                var keys = Object.keys(self);
                for(i = 0; i < keys.length; i++)if (keys[i].indexOf("_on") === 0 && Array.isArray(self[keys[i]])) self[keys[i]] = [];
            }
            return self;
        },
        /**
     * Listen to a custom event and remove it once fired.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @return {Howl}
     */ once: function(event, fn, id) {
            var self = this;
            // Setup the event listener.
            self.on(event, fn, id, 1);
            return self;
        },
        /**
     * Emit all events of a specific type and pass the sound id.
     * @param  {String} event Event name.
     * @param  {Number} id    Sound ID.
     * @param  {Number} msg   Message to go with event.
     * @return {Howl}
     */ _emit: function(event, id, msg) {
            var self = this;
            var events = self["_on" + event];
            // Loop through event store and fire all functions.
            for(var i = events.length - 1; i >= 0; i--)// Only fire the listener if the correct ID is used.
            if (!events[i].id || events[i].id === id || event === "load") {
                setTimeout((function(fn) {
                    fn.call(this, id, msg);
                }).bind(self, events[i].fn), 0);
                // If this event was setup with `once`, remove it.
                if (events[i].once) self.off(event, events[i].fn, events[i].id);
            }
            // Pass the event type into load queue so that it can continue stepping.
            self._loadQueue(event);
            return self;
        },
        /**
     * Queue of actions initiated before the sound has loaded.
     * These will be called in sequence, with the next only firing
     * after the previous has finished executing (even if async like play).
     * @return {Howl}
     */ _loadQueue: function(event) {
            var self = this;
            if (self._queue.length > 0) {
                var task = self._queue[0];
                // Remove this task if a matching event was passed.
                if (task.event === event) {
                    self._queue.shift();
                    self._loadQueue();
                }
                // Run the task if no event type is passed.
                if (!event) task.action();
            }
            return self;
        },
        /**
     * Fired when playback ends at the end of the duration.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _ended: function(sound) {
            var self = this;
            var sprite = sound._sprite;
            // If we are using IE and there was network latency we may be clipping
            // audio before it completes playing. Lets check the node to make sure it
            // believes it has completed, before ending the playback.
            if (!self._webAudio && sound._node && !sound._node.paused && !sound._node.ended && sound._node.currentTime < sound._stop) {
                setTimeout(self._ended.bind(self, sound), 100);
                return self;
            }
            // Should this sound loop?
            var loop = !!(sound._loop || self._sprite[sprite][2]);
            // Fire the ended event.
            self._emit("end", sound._id);
            // Restart the playback for HTML5 Audio loop.
            if (!self._webAudio && loop) self.stop(sound._id, true).play(sound._id);
            // Restart this timer if on a Web Audio loop.
            if (self._webAudio && loop) {
                self._emit("play", sound._id);
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                sound._playStart = Howler1.ctx.currentTime;
                var timeout = (sound._stop - sound._start) * 1000 / Math.abs(sound._rate);
                self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
            }
            // Mark the node as paused.
            if (self._webAudio && !loop) {
                sound._paused = true;
                sound._ended = true;
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                self._clearTimer(sound._id);
                // Clean up the buffer source.
                self._cleanBuffer(sound._node);
                // Attempt to auto-suspend AudioContext if no sounds are still playing.
                Howler1._autoSuspend();
            }
            // When using a sprite, end the track.
            if (!self._webAudio && !loop) self.stop(sound._id, true);
            return self;
        },
        /**
     * Clear the end timer for a sound playback.
     * @param  {Number} id The sound ID.
     * @return {Howl}
     */ _clearTimer: function(id) {
            var self = this;
            if (self._endTimers[id]) {
                // Clear the timeout or remove the ended listener.
                if (typeof self._endTimers[id] !== "function") clearTimeout(self._endTimers[id]);
                else {
                    var sound = self._soundById(id);
                    if (sound && sound._node) sound._node.removeEventListener("ended", self._endTimers[id], false);
                }
                delete self._endTimers[id];
            }
            return self;
        },
        /**
     * Return the sound identified by this ID, or return null.
     * @param  {Number} id Sound ID
     * @return {Object}    Sound object or null.
     */ _soundById: function(id) {
            var self = this;
            // Loop through all sounds and find the one with this ID.
            for(var i = 0; i < self._sounds.length; i++){
                if (id === self._sounds[i]._id) return self._sounds[i];
            }
            return null;
        },
        /**
     * Return an inactive sound from the pool or create a new one.
     * @return {Sound} Sound playback object.
     */ _inactiveSound: function() {
            var self = this;
            self._drain();
            // Find the first inactive node to recycle.
            for(var i = 0; i < self._sounds.length; i++){
                if (self._sounds[i]._ended) return self._sounds[i].reset();
            }
            // If no inactive node was found, create a new one.
            return new Sound1(self);
        },
        /**
     * Drain excess inactive sounds from the pool.
     */ _drain: function() {
            var self = this;
            var limit = self._pool;
            var cnt = 0;
            var i = 0;
            // If there are less sounds than the max pool size, we are done.
            if (self._sounds.length < limit) return;
            // Count the number of inactive sounds.
            for(i = 0; i < self._sounds.length; i++)if (self._sounds[i]._ended) cnt++;
            // Remove excess inactive sounds, going in reverse order.
            for(i = self._sounds.length - 1; i >= 0; i--){
                if (cnt <= limit) return;
                if (self._sounds[i]._ended) {
                    // Disconnect the audio source when using Web Audio.
                    if (self._webAudio && self._sounds[i]._node) self._sounds[i]._node.disconnect(0);
                    // Remove sounds until we have the pool size.
                    self._sounds.splice(i, 1);
                    cnt--;
                }
            }
        },
        /**
     * Get all ID's from the sounds pool.
     * @param  {Number} id Only return one ID if one is passed.
     * @return {Array}    Array of IDs.
     */ _getSoundIds: function(id) {
            var self = this;
            if (typeof id === "undefined") {
                var ids = [];
                for(var i = 0; i < self._sounds.length; i++)ids.push(self._sounds[i]._id);
                return ids;
            } else return [
                id
            ];
        },
        /**
     * Load the sound back into the buffer source.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _refreshBuffer: function(sound) {
            var self = this;
            // Setup the buffer source for playback.
            sound._node.bufferSource = Howler1.ctx.createBufferSource();
            sound._node.bufferSource.buffer = cache[self._src];
            // Connect to the correct node.
            if (sound._panner) sound._node.bufferSource.connect(sound._panner);
            else sound._node.bufferSource.connect(sound._node);
            // Setup looping and playback rate.
            sound._node.bufferSource.loop = sound._loop;
            if (sound._loop) {
                sound._node.bufferSource.loopStart = sound._start || 0;
                sound._node.bufferSource.loopEnd = sound._stop || 0;
            }
            sound._node.bufferSource.playbackRate.setValueAtTime(sound._rate, Howler1.ctx.currentTime);
            return self;
        },
        /**
     * Prevent memory leaks by cleaning up the buffer source after playback.
     * @param  {Object} node Sound's audio node containing the buffer source.
     * @return {Howl}
     */ _cleanBuffer: function(node) {
            var self = this;
            var isIOS = Howler1._navigator && Howler1._navigator.vendor.indexOf("Apple") >= 0;
            if (!node.bufferSource) return self;
            if (Howler1._scratchBuffer && node.bufferSource) {
                node.bufferSource.onended = null;
                node.bufferSource.disconnect(0);
                if (isIOS) try {
                    node.bufferSource.buffer = Howler1._scratchBuffer;
                } catch (e) {}
            }
            node.bufferSource = null;
            return self;
        },
        /**
     * Set the source to a 0-second silence to stop any downloading (except in IE).
     * @param  {Object} node Audio node to clear.
     */ _clearSound: function(node) {
            var checkIE = /MSIE |Trident\//.test(Howler1._navigator && Howler1._navigator.userAgent);
            if (!checkIE) node.src = "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA";
        }
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Setup the sound object, which each node attached to a Howl group is contained in.
   * @param {Object} howl The Howl parent group.
   */ var Sound1 = function(howl) {
        this._parent = howl;
        this.init();
    };
    Sound1.prototype = {
        /**
     * Initialize a new Sound object.
     * @return {Sound}
     */ init: function() {
            var self = this;
            var parent = self._parent;
            // Setup the default parameters.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = "__default";
            // Generate a unique ID for this sound.
            self._id = ++Howler1._counter;
            // Add itself to the parent's pool.
            parent._sounds.push(self);
            // Create the new node.
            self.create();
            return self;
        },
        /**
     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
     * @return {Sound}
     */ create: function() {
            var self = this;
            var parent = self._parent;
            var volume = Howler1._muted || self._muted || self._parent._muted ? 0 : self._volume;
            if (parent._webAudio) {
                // Create the gain node for controlling volume (the source will connect to this).
                self._node = typeof Howler1.ctx.createGain === "undefined" ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
                self._node.gain.setValueAtTime(volume, Howler1.ctx.currentTime);
                self._node.paused = true;
                self._node.connect(Howler1.masterGain);
            } else if (!Howler1.noAudio) {
                // Get an unlocked Audio object from the pool.
                self._node = Howler1._obtainHtml5Audio();
                // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
                self._errorFn = self._errorListener.bind(self);
                self._node.addEventListener("error", self._errorFn, false);
                // Listen for 'canplaythrough' event to let us know the sound is ready.
                self._loadFn = self._loadListener.bind(self);
                self._node.addEventListener(Howler1._canPlayEvent, self._loadFn, false);
                // Listen for the 'ended' event on the sound to account for edge-case where
                // a finite sound has a duration of Infinity.
                self._endFn = self._endListener.bind(self);
                self._node.addEventListener("ended", self._endFn, false);
                // Setup the new audio node.
                self._node.src = parent._src;
                self._node.preload = parent._preload === true ? "auto" : parent._preload;
                self._node.volume = volume * Howler1.volume();
                // Begin loading the source.
                self._node.load();
            }
            return self;
        },
        /**
     * Reset the parameters of this sound to the original state (for recycle).
     * @return {Sound}
     */ reset: function() {
            var self = this;
            var parent = self._parent;
            // Reset all of the parameters of this sound.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._rateSeek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = "__default";
            // Generate a new ID so that it isn't confused with the previous sound.
            self._id = ++Howler1._counter;
            return self;
        },
        /**
     * HTML5 Audio error listener callback.
     */ _errorListener: function() {
            var self = this;
            // Fire an error event and pass back the code.
            self._parent._emit("loaderror", self._id, self._node.error ? self._node.error.code : 0);
            // Clear the event listener.
            self._node.removeEventListener("error", self._errorFn, false);
        },
        /**
     * HTML5 Audio canplaythrough listener callback.
     */ _loadListener: function() {
            var self = this;
            var parent = self._parent;
            // Round up the duration to account for the lower precision in HTML5 Audio.
            parent._duration = Math.ceil(self._node.duration * 10) / 10;
            // Setup a sprite if none is defined.
            if (Object.keys(parent._sprite).length === 0) parent._sprite = {
                __default: [
                    0,
                    parent._duration * 1000
                ]
            };
            if (parent._state !== "loaded") {
                parent._state = "loaded";
                parent._emit("load");
                parent._loadQueue();
            }
            // Clear the event listener.
            self._node.removeEventListener(Howler1._canPlayEvent, self._loadFn, false);
        },
        /**
     * HTML5 Audio ended listener callback.
     */ _endListener: function() {
            var self = this;
            var parent = self._parent;
            // Only handle the `ended`` event if the duration is Infinity.
            if (parent._duration === Infinity) {
                // Update the parent duration to match the real audio duration.
                // Round up the duration to account for the lower precision in HTML5 Audio.
                parent._duration = Math.ceil(self._node.duration * 10) / 10;
                // Update the sprite that corresponds to the real duration.
                if (parent._sprite.__default[1] === Infinity) parent._sprite.__default[1] = parent._duration * 1000;
                // Run the regular ended method.
                parent._ended(self);
            }
            // Clear the event listener since the duration is now correct.
            self._node.removeEventListener("ended", self._endFn, false);
        }
    };
    /** Helper Methods **/ /***************************************************************************/ var cache = {};
    /**
   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
   * @param  {Howl} self
   */ var loadBuffer = function(self) {
        var url = self._src;
        // Check if the buffer has already been cached and use it instead.
        if (cache[url]) {
            // Set the duration from the cache.
            self._duration = cache[url].duration;
            // Load the sound into this Howl.
            loadSound(self);
            return;
        }
        if (/^data:[^;]+;base64,/.test(url)) {
            // Decode the base64 data URI without XHR, since some browsers don't support it.
            var data = atob(url.split(",")[1]);
            var dataView = new Uint8Array(data.length);
            for(var i = 0; i < data.length; ++i)dataView[i] = data.charCodeAt(i);
            decodeAudioData(dataView.buffer, self);
        } else {
            // Load the buffer from the URL.
            var xhr = new XMLHttpRequest();
            xhr.open(self._xhr.method, url, true);
            xhr.withCredentials = self._xhr.withCredentials;
            xhr.responseType = "arraybuffer";
            // Apply any custom headers to the request.
            if (self._xhr.headers) Object.keys(self._xhr.headers).forEach(function(key) {
                xhr.setRequestHeader(key, self._xhr.headers[key]);
            });
            xhr.onload = function() {
                // Make sure we get a successful response back.
                var code = (xhr.status + "")[0];
                if (code !== "0" && code !== "2" && code !== "3") {
                    self._emit("loaderror", null, "Failed loading audio file with status: " + xhr.status + ".");
                    return;
                }
                decodeAudioData(xhr.response, self);
            };
            xhr.onerror = function() {
                // If there is an error, switch to HTML5 Audio.
                if (self._webAudio) {
                    self._html5 = true;
                    self._webAudio = false;
                    self._sounds = [];
                    delete cache[url];
                    self.load();
                }
            };
            safeXhrSend(xhr);
        }
    };
    /**
   * Send the XHR request wrapped in a try/catch.
   * @param  {Object} xhr XHR to send.
   */ var safeXhrSend = function(xhr) {
        try {
            xhr.send();
        } catch (e) {
            xhr.onerror();
        }
    };
    /**
   * Decode audio data from an array buffer.
   * @param  {ArrayBuffer} arraybuffer The audio data.
   * @param  {Howl}        self
   */ var decodeAudioData = function(arraybuffer, self) {
        // Fire a load error if something broke.
        var error = function() {
            self._emit("loaderror", null, "Decoding audio data failed.");
        };
        // Load the sound on success.
        var success = function(buffer) {
            if (buffer && self._sounds.length > 0) {
                cache[self._src] = buffer;
                loadSound(self, buffer);
            } else error();
        };
        // Decode the buffer into an audio source.
        if (typeof Promise !== "undefined" && Howler1.ctx.decodeAudioData.length === 1) Howler1.ctx.decodeAudioData(arraybuffer).then(success).catch(error);
        else Howler1.ctx.decodeAudioData(arraybuffer, success, error);
    };
    /**
   * Sound is now loaded, so finish setting everything up and fire the loaded event.
   * @param  {Howl} self
   * @param  {Object} buffer The decoded buffer sound source.
   */ var loadSound = function(self, buffer) {
        // Set the duration.
        if (buffer && !self._duration) self._duration = buffer.duration;
        // Setup a sprite if none is defined.
        if (Object.keys(self._sprite).length === 0) self._sprite = {
            __default: [
                0,
                self._duration * 1000
            ]
        };
        // Fire the loaded event.
        if (self._state !== "loaded") {
            self._state = "loaded";
            self._emit("load");
            self._loadQueue();
        }
    };
    /**
   * Setup the audio context when available, or switch to HTML5 Audio mode.
   */ var setupAudioContext = function() {
        // If we have already detected that Web Audio isn't supported, don't run this step again.
        if (!Howler1.usingWebAudio) return;
        // Check if we are using Web Audio and setup the AudioContext if we are.
        try {
            if (typeof AudioContext !== "undefined") Howler1.ctx = new AudioContext();
            else if (typeof webkitAudioContext !== "undefined") Howler1.ctx = new webkitAudioContext();
            else Howler1.usingWebAudio = false;
        } catch (e) {
            Howler1.usingWebAudio = false;
        }
        // If the audio context creation still failed, set using web audio to false.
        if (!Howler1.ctx) Howler1.usingWebAudio = false;
        // Check if a webview is being used on iOS8 or earlier (rather than the browser).
        // If it is, disable Web Audio as it causes crashing.
        var iOS = /iP(hone|od|ad)/.test(Howler1._navigator && Howler1._navigator.platform);
        var appVersion = Howler1._navigator && Howler1._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        var version = appVersion ? parseInt(appVersion[1], 10) : null;
        if (iOS && version && version < 9) {
            var safari = /safari/.test(Howler1._navigator && Howler1._navigator.userAgent.toLowerCase());
            if (Howler1._navigator && !safari) Howler1.usingWebAudio = false;
        }
        // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
        if (Howler1.usingWebAudio) {
            Howler1.masterGain = typeof Howler1.ctx.createGain === "undefined" ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
            Howler1.masterGain.gain.setValueAtTime(Howler1._muted ? 0 : Howler1._volume, Howler1.ctx.currentTime);
            Howler1.masterGain.connect(Howler1.ctx.destination);
        }
        // Re-run the setup on Howler.
        Howler1._setup();
    };
    // Add support for AMD (Asynchronous Module Definition) libraries such as require.js.
    if (typeof define === "function" && define.amd) define([], function() {
        return {
            Howler: Howler1,
            Howl: Howl1
        };
    });
    $ca0c8b2242e522d2$export$c9d39ca3bcd93abb = Howler1;
    $ca0c8b2242e522d2$export$b791fe48eec8032a = Howl1;
    // Add to global in Node.js (for testing, etc).
    if (typeof $parcel$global !== "undefined") {
        $parcel$global.HowlerGlobal = HowlerGlobal1;
        $parcel$global.Howler = Howler1;
        $parcel$global.Howl = Howl1;
        $parcel$global.Sound = Sound1;
    } else if (typeof window !== "undefined") {
        window.HowlerGlobal = HowlerGlobal1;
        window.Howler = Howler1;
        window.Howl = Howl1;
        window.Sound = Sound1;
    }
})();
/*!
 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
 *  
 *  howler.js v2.2.4
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    "use strict";
    // Setup default properties.
    HowlerGlobal.prototype._pos = [
        0,
        0,
        0
    ];
    HowlerGlobal.prototype._orientation = [
        0,
        0,
        -1,
        0,
        1,
        0
    ];
    /** Global Methods **/ /***************************************************************************/ /**
   * Helper method to update the stereo panning position of all current Howls.
   * Future Howls will not use this value unless explicitly set.
   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
   * @return {Howler/Number}     Self or current stereo panning value.
   */ HowlerGlobal.prototype.stereo = function(pan) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Loop through all Howls and update their stereo panning.
        for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].stereo(pan);
        return self;
    };
    /**
   * Get/set the position of the listener in 3D cartesian space. Sounds using
   * 3D position will be relative to the listener's position.
   * @param  {Number} x The x-position of the listener.
   * @param  {Number} y The y-position of the listener.
   * @param  {Number} z The z-position of the listener.
   * @return {Howler/Array}   Self or current listener position.
   */ HowlerGlobal.prototype.pos = function(x, y, z) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? self._pos[1] : y;
        z = typeof z !== "number" ? self._pos[2] : z;
        if (typeof x === "number") {
            self._pos = [
                x,
                y,
                z
            ];
            if (typeof self.ctx.listener.positionX !== "undefined") {
                self.ctx.listener.positionX.setTargetAtTime(self._pos[0], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionY.setTargetAtTime(self._pos[1], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionZ.setTargetAtTime(self._pos[2], Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
        } else return self._pos;
        return self;
    };
    /**
   * Get/set the direction the listener is pointing in the 3D cartesian space.
   * A front and up vector must be provided. The front is the direction the
   * face of the listener is pointing, and up is the direction the top of the
   * listener is pointing. Thus, these values are expected to be at right angles
   * from each other.
   * @param  {Number} x   The x-orientation of the listener.
   * @param  {Number} y   The y-orientation of the listener.
   * @param  {Number} z   The z-orientation of the listener.
   * @param  {Number} xUp The x-orientation of the top of the listener.
   * @param  {Number} yUp The y-orientation of the top of the listener.
   * @param  {Number} zUp The z-orientation of the top of the listener.
   * @return {Howler/Array}     Returns self or the current orientation vectors.
   */ HowlerGlobal.prototype.orientation = function(x, y, z, xUp, yUp, zUp) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        var or = self._orientation;
        y = typeof y !== "number" ? or[1] : y;
        z = typeof z !== "number" ? or[2] : z;
        xUp = typeof xUp !== "number" ? or[3] : xUp;
        yUp = typeof yUp !== "number" ? or[4] : yUp;
        zUp = typeof zUp !== "number" ? or[5] : zUp;
        if (typeof x === "number") {
            self._orientation = [
                x,
                y,
                z,
                xUp,
                yUp,
                zUp
            ];
            if (typeof self.ctx.listener.forwardX !== "undefined") {
                self.ctx.listener.forwardX.setTargetAtTime(x, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardY.setTargetAtTime(y, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardZ.setTargetAtTime(z, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upX.setTargetAtTime(xUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upY.setTargetAtTime(yUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upZ.setTargetAtTime(zUp, Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
        } else return or;
        return self;
    };
    /** Group Methods **/ /***************************************************************************/ /**
   * Add new properties to the core init.
   * @param  {Function} _super Core init method.
   * @return {Howl}
   */ Howl.prototype.init = function(_super) {
        return function(o) {
            var self = this;
            // Setup user-defined default properties.
            self._orientation = o.orientation || [
                1,
                0,
                0
            ];
            self._stereo = o.stereo || null;
            self._pos = o.pos || null;
            self._pannerAttr = {
                coneInnerAngle: typeof o.coneInnerAngle !== "undefined" ? o.coneInnerAngle : 360,
                coneOuterAngle: typeof o.coneOuterAngle !== "undefined" ? o.coneOuterAngle : 360,
                coneOuterGain: typeof o.coneOuterGain !== "undefined" ? o.coneOuterGain : 0,
                distanceModel: typeof o.distanceModel !== "undefined" ? o.distanceModel : "inverse",
                maxDistance: typeof o.maxDistance !== "undefined" ? o.maxDistance : 10000,
                panningModel: typeof o.panningModel !== "undefined" ? o.panningModel : "HRTF",
                refDistance: typeof o.refDistance !== "undefined" ? o.refDistance : 1,
                rolloffFactor: typeof o.rolloffFactor !== "undefined" ? o.rolloffFactor : 1
            };
            // Setup event listeners.
            self._onstereo = o.onstereo ? [
                {
                    fn: o.onstereo
                }
            ] : [];
            self._onpos = o.onpos ? [
                {
                    fn: o.onpos
                }
            ] : [];
            self._onorientation = o.onorientation ? [
                {
                    fn: o.onorientation
                }
            ] : [];
            // Complete initilization with howler.js core's init function.
            return _super.call(this, o);
        };
    }(Howl.prototype.init);
    /**
   * Get/set the stereo panning of the audio source for this sound or all in the group.
   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Number}    Returns self or the current stereo panning value.
   */ Howl.prototype.stereo = function(pan, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "stereo",
                action: function() {
                    self.stereo(pan, id);
                }
            });
            return self;
        }
        // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
        var pannerType = typeof Howler.ctx.createStereoPanner === "undefined" ? "spatial" : "stereo";
        // Setup the group's stereo panning if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's stereo panning if no parameters are passed.
            if (typeof pan === "number") {
                self._stereo = pan;
                self._pos = [
                    pan,
                    0,
                    0
                ];
            } else return self._stereo;
        }
        // Change the streo panning of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof pan === "number") {
                    sound._stereo = pan;
                    sound._pos = [
                        pan,
                        0,
                        0
                    ];
                    if (sound._node) {
                        // If we are falling back, make sure the panningModel is equalpower.
                        sound._pannerAttr.panningModel = "equalpower";
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || !sound._panner.pan) setupPanner(sound, pannerType);
                        if (pannerType === "spatial") {
                            if (typeof sound._panner.positionX !== "undefined") {
                                sound._panner.positionX.setValueAtTime(pan, Howler.ctx.currentTime);
                                sound._panner.positionY.setValueAtTime(0, Howler.ctx.currentTime);
                                sound._panner.positionZ.setValueAtTime(0, Howler.ctx.currentTime);
                            } else sound._panner.setPosition(pan, 0, 0);
                        } else sound._panner.pan.setValueAtTime(pan, Howler.ctx.currentTime);
                    }
                    self._emit("stereo", sound._id);
                } else return sound._stereo;
            }
        }
        return self;
    };
    /**
   * Get/set the 3D spatial position of the audio source for this sound or group relative to the global listener.
   * @param  {Number} x  The x-position of the audio source.
   * @param  {Number} y  The y-position of the audio source.
   * @param  {Number} z  The z-position of the audio source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
   */ Howl.prototype.pos = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change position when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "pos",
                action: function() {
                    self.pos(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? 0 : y;
        z = typeof z !== "number" ? -0.5 : z;
        // Setup the group's spatial position if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's spatial position if no parameters are passed.
            if (typeof x === "number") self._pos = [
                x,
                y,
                z
            ];
            else return self._pos;
        }
        // Change the spatial position of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === "number") {
                    sound._pos = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || sound._panner.pan) setupPanner(sound, "spatial");
                        if (typeof sound._panner.positionX !== "undefined") {
                            sound._panner.positionX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.positionY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.positionZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setPosition(x, y, z);
                    }
                    self._emit("pos", sound._id);
                } else return sound._pos;
            }
        }
        return self;
    };
    /**
   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
   * space. Depending on how direction the sound is, based on the `cone` attributes,
   * a sound pointing away from the listener can be quiet or silent.
   * @param  {Number} x  The x-orientation of the source.
   * @param  {Number} y  The y-orientation of the source.
   * @param  {Number} z  The z-orientation of the source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
   */ Howl.prototype.orientation = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "orientation",
                action: function() {
                    self.orientation(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? self._orientation[1] : y;
        z = typeof z !== "number" ? self._orientation[2] : z;
        // Setup the group's spatial orientation if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's spatial orientation if no parameters are passed.
            if (typeof x === "number") self._orientation = [
                x,
                y,
                z
            ];
            else return self._orientation;
        }
        // Change the spatial orientation of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === "number") {
                    sound._orientation = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner) {
                            // Make sure we have a position to setup the node with.
                            if (!sound._pos) sound._pos = self._pos || [
                                0,
                                0,
                                -0.5
                            ];
                            setupPanner(sound, "spatial");
                        }
                        if (typeof sound._panner.orientationX !== "undefined") {
                            sound._panner.orientationX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.orientationY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.orientationZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setOrientation(x, y, z);
                    }
                    self._emit("orientation", sound._id);
                } else return sound._orientation;
            }
        }
        return self;
    };
    /**
   * Get/set the panner node's attributes for a sound or group of sounds.
   * This method can optionall take 0, 1 or 2 arguments.
   *   pannerAttr() -> Returns the group's values.
   *   pannerAttr(id) -> Returns the sound id's values.
   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
   *   pannerAttr(o, id) -> Set's the values of passed sound id.
   *
   *   Attributes:
   *     coneInnerAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      inside of which there will be no volume reduction.
   *     coneOuterAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      outside of which the volume will be reduced to a constant value of `coneOuterGain`.
   *     coneOuterGain - (0 by default) A parameter for directional audio sources, this is the gain outside of the
   *                     `coneOuterAngle`. It is a linear value in the range `[0, 1]`.
   *     distanceModel - ('inverse' by default) Determines algorithm used to reduce volume as audio moves away from
   *                     listener. Can be `linear`, `inverse` or `exponential.
   *     maxDistance - (10000 by default) The maximum distance between source and listener, after which the volume
   *                   will not be reduced any further.
   *     refDistance - (1 by default) A reference distance for reducing volume as source moves further from the listener.
   *                   This is simply a variable of the distance model and has a different effect depending on which model
   *                   is used and the scale of your coordinates. Generally, volume will be equal to 1 at this distance.
   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener. This is simply a
   *                     variable of the distance model and can be in the range of `[0, 1]` with `linear` and `[0, ∞]`
   *                     with `inverse` and `exponential`.
   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
   *                     Can be `HRTF` or `equalpower`.
   *
   * @return {Howl/Object} Returns self or current panner attributes.
   */ Howl.prototype.pannerAttr = function() {
        var self = this;
        var args = arguments;
        var o, id, sound;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // Determine the values based on arguments.
        if (args.length === 0) // Return the group's panner attribute values.
        return self._pannerAttr;
        else if (args.length === 1) {
            if (typeof args[0] === "object") {
                o = args[0];
                // Set the grou's panner attribute values.
                if (typeof id === "undefined") {
                    if (!o.pannerAttr) o.pannerAttr = {
                        coneInnerAngle: o.coneInnerAngle,
                        coneOuterAngle: o.coneOuterAngle,
                        coneOuterGain: o.coneOuterGain,
                        distanceModel: o.distanceModel,
                        maxDistance: o.maxDistance,
                        refDistance: o.refDistance,
                        rolloffFactor: o.rolloffFactor,
                        panningModel: o.panningModel
                    };
                    self._pannerAttr = {
                        coneInnerAngle: typeof o.pannerAttr.coneInnerAngle !== "undefined" ? o.pannerAttr.coneInnerAngle : self._coneInnerAngle,
                        coneOuterAngle: typeof o.pannerAttr.coneOuterAngle !== "undefined" ? o.pannerAttr.coneOuterAngle : self._coneOuterAngle,
                        coneOuterGain: typeof o.pannerAttr.coneOuterGain !== "undefined" ? o.pannerAttr.coneOuterGain : self._coneOuterGain,
                        distanceModel: typeof o.pannerAttr.distanceModel !== "undefined" ? o.pannerAttr.distanceModel : self._distanceModel,
                        maxDistance: typeof o.pannerAttr.maxDistance !== "undefined" ? o.pannerAttr.maxDistance : self._maxDistance,
                        refDistance: typeof o.pannerAttr.refDistance !== "undefined" ? o.pannerAttr.refDistance : self._refDistance,
                        rolloffFactor: typeof o.pannerAttr.rolloffFactor !== "undefined" ? o.pannerAttr.rolloffFactor : self._rolloffFactor,
                        panningModel: typeof o.pannerAttr.panningModel !== "undefined" ? o.pannerAttr.panningModel : self._panningModel
                    };
                }
            } else {
                // Return this sound's panner attribute values.
                sound = self._soundById(parseInt(args[0], 10));
                return sound ? sound._pannerAttr : self._pannerAttr;
            }
        } else if (args.length === 2) {
            o = args[0];
            id = parseInt(args[1], 10);
        }
        // Update the values of the specified sounds.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            sound = self._soundById(ids[i]);
            if (sound) {
                // Merge the new values into the sound.
                var pa = sound._pannerAttr;
                pa = {
                    coneInnerAngle: typeof o.coneInnerAngle !== "undefined" ? o.coneInnerAngle : pa.coneInnerAngle,
                    coneOuterAngle: typeof o.coneOuterAngle !== "undefined" ? o.coneOuterAngle : pa.coneOuterAngle,
                    coneOuterGain: typeof o.coneOuterGain !== "undefined" ? o.coneOuterGain : pa.coneOuterGain,
                    distanceModel: typeof o.distanceModel !== "undefined" ? o.distanceModel : pa.distanceModel,
                    maxDistance: typeof o.maxDistance !== "undefined" ? o.maxDistance : pa.maxDistance,
                    refDistance: typeof o.refDistance !== "undefined" ? o.refDistance : pa.refDistance,
                    rolloffFactor: typeof o.rolloffFactor !== "undefined" ? o.rolloffFactor : pa.rolloffFactor,
                    panningModel: typeof o.panningModel !== "undefined" ? o.panningModel : pa.panningModel
                };
                // Create a new panner node if one doesn't already exist.
                var panner = sound._panner;
                if (!panner) {
                    // Make sure we have a position to setup the node with.
                    if (!sound._pos) sound._pos = self._pos || [
                        0,
                        0,
                        -0.5
                    ];
                    // Create a new panner node.
                    setupPanner(sound, "spatial");
                    panner = sound._panner;
                }
                // Update the panner values or create a new panner if none exists.
                panner.coneInnerAngle = pa.coneInnerAngle;
                panner.coneOuterAngle = pa.coneOuterAngle;
                panner.coneOuterGain = pa.coneOuterGain;
                panner.distanceModel = pa.distanceModel;
                panner.maxDistance = pa.maxDistance;
                panner.refDistance = pa.refDistance;
                panner.rolloffFactor = pa.rolloffFactor;
                panner.panningModel = pa.panningModel;
            }
        }
        return self;
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Add new properties to the core Sound init.
   * @param  {Function} _super Core Sound init method.
   * @return {Sound}
   */ Sound.prototype.init = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Setup user-defined default properties.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // Complete initilization with howler.js core Sound's init function.
            _super.call(this);
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
        };
    }(Sound.prototype.init);
    /**
   * Override the Sound.reset method to clean up properties from the spatial plugin.
   * @param  {Function} _super Sound reset method.
   * @return {Sound}
   */ Sound.prototype.reset = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Reset all spatial plugin properties on this sound.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
            else if (self._panner) {
                // Disconnect the panner.
                self._panner.disconnect(0);
                self._panner = undefined;
                parent._refreshBuffer(self);
            }
            // Complete resetting of the sound.
            return _super.call(this);
        };
    }(Sound.prototype.reset);
    /** Helper Methods **/ /***************************************************************************/ /**
   * Create a new panner node and save it on the sound.
   * @param  {Sound} sound Specific sound to setup panning on.
   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
   */ var setupPanner = function(sound, type) {
        type = type || "spatial";
        // Create the new panner node.
        if (type === "spatial") {
            sound._panner = Howler.ctx.createPanner();
            sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
            sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
            sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
            sound._panner.distanceModel = sound._pannerAttr.distanceModel;
            sound._panner.maxDistance = sound._pannerAttr.maxDistance;
            sound._panner.refDistance = sound._pannerAttr.refDistance;
            sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
            sound._panner.panningModel = sound._pannerAttr.panningModel;
            if (typeof sound._panner.positionX !== "undefined") {
                sound._panner.positionX.setValueAtTime(sound._pos[0], Howler.ctx.currentTime);
                sound._panner.positionY.setValueAtTime(sound._pos[1], Howler.ctx.currentTime);
                sound._panner.positionZ.setValueAtTime(sound._pos[2], Howler.ctx.currentTime);
            } else sound._panner.setPosition(sound._pos[0], sound._pos[1], sound._pos[2]);
            if (typeof sound._panner.orientationX !== "undefined") {
                sound._panner.orientationX.setValueAtTime(sound._orientation[0], Howler.ctx.currentTime);
                sound._panner.orientationY.setValueAtTime(sound._orientation[1], Howler.ctx.currentTime);
                sound._panner.orientationZ.setValueAtTime(sound._orientation[2], Howler.ctx.currentTime);
            } else sound._panner.setOrientation(sound._orientation[0], sound._orientation[1], sound._orientation[2]);
        } else {
            sound._panner = Howler.ctx.createStereoPanner();
            sound._panner.pan.setValueAtTime(sound._stereo, Howler.ctx.currentTime);
        }
        sound._panner.connect(sound._node);
        // Update the connections.
        if (!sound._paused) sound._parent.pause(sound._id, true).play(sound._id, true);
    };
})();


var $471e05f612aa773e$exports = {};
!function(e) {
    $471e05f612aa773e$exports = e();
}(function() {
    return (function e(t, a, s) {
        function n(_, i) {
            if (!a[_]) {
                if (!t[_]) {
                    var o = undefined;
                    if (!i && o) return o(_, !0);
                    if (r) return r(_, !0);
                    var l = new Error("Cannot find module '" + _ + "'");
                    throw l.code = "MODULE_NOT_FOUND", l;
                }
                var f = a[_] = {
                    exports: {}
                };
                t[_][0].call(f.exports, function(e) {
                    return n(t[_][1][e] || e);
                }, f, f.exports, e, t, a, s);
            }
            return a[_].exports;
        }
        for(var r = undefined, _ = 0; _ < s.length; _++)n(s[_]);
        return n;
    })({
        1: [
            function(e, t, a) {
                "use strict";
                Object.defineProperty(a, "__esModule", {
                    value: !0
                }), a.simpleMp3 = void 0;
                var s = e(2);
                a.simpleMp3 = function(e, t) {
                    var a = e.channelData, n = a[0].length;
                    if (1 != a.length && 2 != a.length) throw new Error("simpleMp3 Error, do not support " + a.length + " channels.");
                    var r = e.sampleRate ? e.sampleRate : 44100, _ = e.bytePerSample ? e.bytePerSample : 2;
                    if (1 !== _ && 2 !== _ && 4 !== _) throw new Error("simpleMp3 Error, bytePerSample can only be 1, 2 or 4");
                    var i, o, l, f = e.quality ? e.quality : 192, c = new (new s).Mp3Encoder(a.length, r, f), h = [];
                    switch(t && t(.1), _){
                        case 1:
                            o = -127, l = 128, i = Int8Array;
                            break;
                        case 2:
                            o = -32767, l = 32768, i = Int16Array;
                            break;
                        case 4:
                            o = -2147483647, l = 2147483648, i = Int32Array;
                    }
                    for(var u = [], b = 0 - o, p = 0; p < a.length; p++){
                        for(var m = new i(a[p].length), d = a[p], v = 0; v < n; ++v){
                            var g = d[v] * (d[v] < 0 ? b : l);
                            m[v] = Math.max(o, Math.min(l, g));
                        }
                        u.push(m);
                    }
                    for(p = 0; p < n; p += 1152){
                        var S = [];
                        for(v = 0; v < u.length; ++v)S.push(u[v].subarray(p, p + 1152));
                        var R = c.encodeBuffer.apply(c, S);
                        R && R.length > 0 && h.push(R.buffer), t && t(.1 + .85 * p / n);
                    }
                    var M = c.flush();
                    return M && M.length > 0 && h.push(M.buffer), h;
                };
            },
            {
                2: 2
            }
        ],
        2: [
            function(e, t, a) {
                t.exports = function() {
                    function e(e) {
                        return new Int8Array(e);
                    }
                    function t(e) {
                        return new Int32Array(e);
                    }
                    function a(e) {
                        return new Float32Array(e);
                    }
                    function s(e) {
                        if (1 == e.length) return a(e[0]);
                        var t = e[0];
                        e = e.slice(1);
                        for(var n = [], r = 0; r < t; r++)n.push(s(e));
                        return n;
                    }
                    function n(e) {
                        if (1 == e.length) return t(e[0]);
                        var a = e[0];
                        e = e.slice(1);
                        for(var s = [], r = 0; r < a; r++)s.push(n(e));
                        return s;
                    }
                    function r(e) {
                        if (1 == e.length) return t = e[0], new Int16Array(t);
                        var t, a = e[0];
                        e = e.slice(1);
                        for(var s = [], n = 0; n < a; n++)s.push(r(e));
                        return s;
                    }
                    function _(e) {
                        if (1 == e.length) return new Array(e[0]);
                        var t = e[0];
                        e = e.slice(1);
                        for(var a = [], s = 0; s < t; s++)a.push(_(e));
                        return a;
                    }
                    var i = {
                        fill: function(e, t, a, s) {
                            if (2 == arguments.length) for(var n = 0; n < e.length; n++)e[n] = arguments[1];
                            else for(n = t; n < a; n++)e[n] = s;
                        }
                    }, o = {
                        arraycopy: function(e, t, a, s, n) {
                            for(var r = t + n; t < r;)a[s++] = e[t++];
                        }
                    }, l = {};
                    function f(e) {
                        this.ordinal = e;
                    }
                    l.SQRT2 = 1.4142135623730951, l.FAST_LOG10 = function(e) {
                        return Math.log10(e);
                    }, l.FAST_LOG10_X = function(e, t) {
                        return Math.log10(e) * t;
                    }, f.short_block_allowed = new f(0), f.short_block_coupled = new f(1), f.short_block_dispensed = new f(2), f.short_block_forced = new f(3);
                    var c = {};
                    function h(e) {
                        this.ordinal = e;
                    }
                    function u(e) {
                        var t = e;
                        this.ordinal = function() {
                            return t;
                        };
                    }
                    function b() {
                        this.getLameVersion = function() {
                            return "3.98.4";
                        }, this.getLameShortVersion = function() {
                            return "3.98.4";
                        }, this.getLameVeryShortVersion = function() {
                            return "LAME3.98r";
                        }, this.getPsyVersion = function() {
                            return "0.93";
                        }, this.getLameUrl = function() {
                            return "http://www.mp3dev.org/";
                        }, this.getLameOsBitness = function() {
                            return "32bits";
                        };
                    }
                    function p() {
                        function e(e, t, a, s, n, r, _, i, o, l, f, c, h, u, b) {
                            this.vbr_q = e, this.quant_comp = t, this.quant_comp_s = a, this.expY = s, this.st_lrm = n, this.st_s = r, this.masking_adj = _, this.masking_adj_short = i, this.ath_lower = o, this.ath_curve = l, this.ath_sensitivity = f, this.interch = c, this.safejoint = h, this.sfb21mod = u, this.msfix = b;
                        }
                        function t(e, t, a, s, n, r, _, i, o, l, f, c, h, u) {
                            this.quant_comp = t, this.quant_comp_s = a, this.safejoint = s, this.nsmsfix = n, this.st_lrm = r, this.st_s = _, this.nsbass = i, this.scale = o, this.masking_adj = l, this.ath_lower = f, this.ath_curve = c, this.interch = h, this.sfscale = u;
                        }
                        var a;
                        this.setModules = function(e) {
                            a = e;
                        };
                        var s = [
                            new e(0, 9, 9, 0, 5.2, 125, -4.2, -6.3, 4.8, 1, 0, 0, 2, 21, .97),
                            new e(1, 9, 9, 0, 5.3, 125, -3.6, -5.6, 4.5, 1.5, 0, 0, 2, 21, 1.35),
                            new e(2, 9, 9, 0, 5.6, 125, -2.2, -3.5, 2.8, 2, 0, 0, 2, 21, 1.49),
                            new e(3, 9, 9, 1, 5.8, 130, -1.8, -2.8, 2.6, 3, -4, 0, 2, 20, 1.64),
                            new e(4, 9, 9, 1, 6, 135, -0.7, -1.1, 1.1, 3.5, -8, 0, 2, 0, 1.79),
                            new e(5, 9, 9, 1, 6.4, 140, .5, .4, -7.5, 4, -12, 2e-4, 0, 0, 1.95),
                            new e(6, 9, 9, 1, 6.6, 145, .67, .65, -14.7, 6.5, -19, 4e-4, 0, 0, 2.3),
                            new e(7, 9, 9, 1, 6.6, 145, .8, .75, -19.7, 8, -22, 6e-4, 0, 0, 2.7),
                            new e(8, 9, 9, 1, 6.6, 145, 1.2, 1.15, -27.5, 10, -23, 7e-4, 0, 0, 0),
                            new e(9, 9, 9, 1, 6.6, 145, 1.6, 1.6, -36, 11, -25, 8e-4, 0, 0, 0),
                            new e(10, 9, 9, 1, 6.6, 145, 2, 2, -36, 12, -25, 8e-4, 0, 0, 0)
                        ], n = [
                            new e(0, 9, 9, 0, 4.2, 25, -7, -4, 7.5, 1, 0, 0, 2, 26, .97),
                            new e(1, 9, 9, 0, 4.2, 25, -5.6, -3.6, 4.5, 1.5, 0, 0, 2, 21, 1.35),
                            new e(2, 9, 9, 0, 4.2, 25, -4.4, -1.8, 2, 2, 0, 0, 2, 18, 1.49),
                            new e(3, 9, 9, 1, 4.2, 25, -3.4, -1.25, 1.1, 3, -4, 0, 2, 15, 1.64),
                            new e(4, 9, 9, 1, 4.2, 25, -2.2, .1, 0, 3.5, -8, 0, 2, 0, 1.79),
                            new e(5, 9, 9, 1, 4.2, 25, -1, 1.65, -7.7, 4, -12, 2e-4, 0, 0, 1.95),
                            new e(6, 9, 9, 1, 4.2, 25, -0, 2.47, -7.7, 6.5, -19, 4e-4, 0, 0, 2),
                            new e(7, 9, 9, 1, 4.2, 25, .5, 2, -14.5, 8, -22, 6e-4, 0, 0, 2),
                            new e(8, 9, 9, 1, 4.2, 25, 1, 2.4, -22, 10, -23, 7e-4, 0, 0, 2),
                            new e(9, 9, 9, 1, 4.2, 25, 1.5, 2.95, -30, 11, -25, 8e-4, 0, 0, 2),
                            new e(10, 9, 9, 1, 4.2, 25, 2, 2.95, -36, 12, -30, 8e-4, 0, 0, 2)
                        ];
                        function r(e, t, a) {
                            var r = e.VBR == h.vbr_rh ? s : n, _ = e.VBR_q_frac, i = r[t], o = r[t + 1], l = i;
                            i.st_lrm = i.st_lrm + _ * (o.st_lrm - i.st_lrm), i.st_s = i.st_s + _ * (o.st_s - i.st_s), i.masking_adj = i.masking_adj + _ * (o.masking_adj - i.masking_adj), i.masking_adj_short = i.masking_adj_short + _ * (o.masking_adj_short - i.masking_adj_short), i.ath_lower = i.ath_lower + _ * (o.ath_lower - i.ath_lower), i.ath_curve = i.ath_curve + _ * (o.ath_curve - i.ath_curve), i.ath_sensitivity = i.ath_sensitivity + _ * (o.ath_sensitivity - i.ath_sensitivity), i.interch = i.interch + _ * (o.interch - i.interch), i.msfix = i.msfix + _ * (o.msfix - i.msfix), function(e, t) {
                                0 > t && (t = 0), 9 < t && (t = 9), e.VBR_q = t, e.VBR_q_frac = 0;
                            }(e, l.vbr_q), 0 != a ? e.quant_comp = l.quant_comp : Math.abs(e.quant_comp - -1) > 0 || (e.quant_comp = l.quant_comp), 0 != a ? e.quant_comp_short = l.quant_comp_s : Math.abs(e.quant_comp_short - -1) > 0 || (e.quant_comp_short = l.quant_comp_s), 0 != l.expY && (e.experimentalY = 0 != l.expY), 0 != a ? e.internal_flags.nsPsy.attackthre = l.st_lrm : Math.abs(e.internal_flags.nsPsy.attackthre - -1) > 0 || (e.internal_flags.nsPsy.attackthre = l.st_lrm), 0 != a ? e.internal_flags.nsPsy.attackthre_s = l.st_s : Math.abs(e.internal_flags.nsPsy.attackthre_s - -1) > 0 || (e.internal_flags.nsPsy.attackthre_s = l.st_s), 0 != a ? e.maskingadjust = l.masking_adj : Math.abs(e.maskingadjust - 0) > 0 || (e.maskingadjust = l.masking_adj), 0 != a ? e.maskingadjust_short = l.masking_adj_short : Math.abs(e.maskingadjust_short - 0) > 0 || (e.maskingadjust_short = l.masking_adj_short), 0 != a ? e.ATHlower = -l.ath_lower / 10 : Math.abs(10 * -e.ATHlower - 0) > 0 || (e.ATHlower = -l.ath_lower / 10), 0 != a ? e.ATHcurve = l.ath_curve : Math.abs(e.ATHcurve - -1) > 0 || (e.ATHcurve = l.ath_curve), 0 != a ? e.athaa_sensitivity = l.ath_sensitivity : Math.abs(e.athaa_sensitivity - -1) > 0 || (e.athaa_sensitivity = l.ath_sensitivity), l.interch > 0 && (0 != a ? e.interChRatio = l.interch : Math.abs(e.interChRatio - -1) > 0 || (e.interChRatio = l.interch)), l.safejoint > 0 && (e.exp_nspsytune = e.exp_nspsytune | l.safejoint), l.sfb21mod > 0 && (e.exp_nspsytune = e.exp_nspsytune | l.sfb21mod << 20), 0 != a ? e.msfix = l.msfix : Math.abs(e.msfix - -1) > 0 || (e.msfix = l.msfix), 0 == a && (e.VBR_q = t, e.VBR_q_frac = _);
                        }
                        var _ = [
                            new t(8, 9, 9, 0, 0, 6.6, 145, 0, .95, 0, -30, 11, .0012, 1),
                            new t(16, 9, 9, 0, 0, 6.6, 145, 0, .95, 0, -25, 11, .001, 1),
                            new t(24, 9, 9, 0, 0, 6.6, 145, 0, .95, 0, -20, 11, .001, 1),
                            new t(32, 9, 9, 0, 0, 6.6, 145, 0, .95, 0, -15, 11, .001, 1),
                            new t(40, 9, 9, 0, 0, 6.6, 145, 0, .95, 0, -10, 11, 9e-4, 1),
                            new t(48, 9, 9, 0, 0, 6.6, 145, 0, .95, 0, -10, 11, 9e-4, 1),
                            new t(56, 9, 9, 0, 0, 6.6, 145, 0, .95, 0, -6, 11, 8e-4, 1),
                            new t(64, 9, 9, 0, 0, 6.6, 145, 0, .95, 0, -2, 11, 8e-4, 1),
                            new t(80, 9, 9, 0, 0, 6.6, 145, 0, .95, 0, 0, 8, 7e-4, 1),
                            new t(96, 9, 9, 0, 2.5, 6.6, 145, 0, .95, 0, 1, 5.5, 6e-4, 1),
                            new t(112, 9, 9, 0, 2.25, 6.6, 145, 0, .95, 0, 2, 4.5, 5e-4, 1),
                            new t(128, 9, 9, 0, 1.95, 6.4, 140, 0, .95, 0, 3, 4, 2e-4, 1),
                            new t(160, 9, 9, 1, 1.79, 6, 135, 0, .95, -2, 5, 3.5, 0, 1),
                            new t(192, 9, 9, 1, 1.49, 5.6, 125, 0, .97, -4, 7, 3, 0, 0),
                            new t(224, 9, 9, 1, 1.25, 5.2, 125, 0, .98, -6, 9, 2, 0, 0),
                            new t(256, 9, 9, 1, .97, 5.2, 125, 0, 1, -8, 10, 1, 0, 0),
                            new t(320, 9, 9, 1, .9, 5.2, 125, 0, 1, -10, 12, 0, 0, 0)
                        ];
                        function i(e, t, s) {
                            var n = t, r = a.nearestBitrateFullIndex(t);
                            if (e.VBR = h.vbr_abr, e.VBR_mean_bitrate_kbps = n, e.VBR_mean_bitrate_kbps = Math.min(e.VBR_mean_bitrate_kbps, 320), e.VBR_mean_bitrate_kbps = Math.max(e.VBR_mean_bitrate_kbps, 8), e.brate = e.VBR_mean_bitrate_kbps, e.VBR_mean_bitrate_kbps > 320 && (e.disable_reservoir = !0), _[r].safejoint > 0 && (e.exp_nspsytune = 2 | e.exp_nspsytune), _[r].sfscale > 0 && (e.internal_flags.noise_shaping = 2), Math.abs(_[r].nsbass) > 0) {
                                var i = int(4 * _[r].nsbass);
                                i < 0 && (i += 64), e.exp_nspsytune = e.exp_nspsytune | i << 2;
                            }
                            return 0 != s ? e.quant_comp = _[r].quant_comp : Math.abs(e.quant_comp - -1) > 0 || (e.quant_comp = _[r].quant_comp), 0 != s ? e.quant_comp_short = _[r].quant_comp_s : Math.abs(e.quant_comp_short - -1) > 0 || (e.quant_comp_short = _[r].quant_comp_s), 0 != s ? e.msfix = _[r].nsmsfix : Math.abs(e.msfix - -1) > 0 || (e.msfix = _[r].nsmsfix), 0 != s ? e.internal_flags.nsPsy.attackthre = _[r].st_lrm : Math.abs(e.internal_flags.nsPsy.attackthre - -1) > 0 || (e.internal_flags.nsPsy.attackthre = _[r].st_lrm), 0 != s ? e.internal_flags.nsPsy.attackthre_s = _[r].st_s : Math.abs(e.internal_flags.nsPsy.attackthre_s - -1) > 0 || (e.internal_flags.nsPsy.attackthre_s = _[r].st_s), 0 != s ? e.scale = _[r].scale : Math.abs(e.scale - -1) > 0 || (e.scale = _[r].scale), 0 != s ? e.maskingadjust = _[r].masking_adj : Math.abs(e.maskingadjust - 0) > 0 || (e.maskingadjust = _[r].masking_adj), _[r].masking_adj > 0 ? 0 != s ? e.maskingadjust_short = .9 * _[r].masking_adj : Math.abs(e.maskingadjust_short - 0) > 0 || (e.maskingadjust_short = .9 * _[r].masking_adj) : 0 != s ? e.maskingadjust_short = 1.1 * _[r].masking_adj : Math.abs(e.maskingadjust_short - 0) > 0 || (e.maskingadjust_short = 1.1 * _[r].masking_adj), 0 != s ? e.ATHlower = -_[r].ath_lower / 10 : Math.abs(10 * -e.ATHlower - 0) > 0 || (e.ATHlower = -_[r].ath_lower / 10), 0 != s ? e.ATHcurve = _[r].ath_curve : Math.abs(e.ATHcurve - -1) > 0 || (e.ATHcurve = _[r].ath_curve), 0 != s ? e.interChRatio = _[r].interch : Math.abs(e.interChRatio - -1) > 0 || (e.interChRatio = _[r].interch), t;
                        }
                        this.apply_preset = function(e, t, a) {
                            switch(t){
                                case z.R3MIX:
                                    t = z.V3, e.VBR = h.vbr_mtrh;
                                    break;
                                case z.MEDIUM:
                                    t = z.V4, e.VBR = h.vbr_rh;
                                    break;
                                case z.MEDIUM_FAST:
                                    t = z.V4, e.VBR = h.vbr_mtrh;
                                    break;
                                case z.STANDARD:
                                    t = z.V2, e.VBR = h.vbr_rh;
                                    break;
                                case z.STANDARD_FAST:
                                    t = z.V2, e.VBR = h.vbr_mtrh;
                                    break;
                                case z.EXTREME:
                                    t = z.V0, e.VBR = h.vbr_rh;
                                    break;
                                case z.EXTREME_FAST:
                                    t = z.V0, e.VBR = h.vbr_mtrh;
                                    break;
                                case z.INSANE:
                                    return t = 320, e.preset = t, i(e, t, a), e.VBR = h.vbr_off, t;
                            }
                            switch(e.preset = t, t){
                                case z.V9:
                                    return r(e, 9, a), t;
                                case z.V8:
                                    return r(e, 8, a), t;
                                case z.V7:
                                    return r(e, 7, a), t;
                                case z.V6:
                                    return r(e, 6, a), t;
                                case z.V5:
                                    return r(e, 5, a), t;
                                case z.V4:
                                    return r(e, 4, a), t;
                                case z.V3:
                                    return r(e, 3, a), t;
                                case z.V2:
                                    return r(e, 2, a), t;
                                case z.V1:
                                    return r(e, 1, a), t;
                                case z.V0:
                                    return r(e, 0, a), t;
                            }
                            return 8 <= t && t <= 320 ? i(e, t, a) : (e.preset = 0, t);
                        };
                    }
                    function m() {
                        var e = (m.YULE_ORDER, .95), t = (m.MAX_SAMP_FREQ, m.RMS_WINDOW_TIME_NUMERATOR), a = m.RMS_WINDOW_TIME_DENOMINATOR, s = (m.MAX_SAMPLES_PER_WINDOW, [
                            [
                                .038575994352,
                                -3.84664617118067,
                                -0.02160367184185,
                                7.81501653005538,
                                -0.00123395316851,
                                -11.34170355132042,
                                -0.00009291677959,
                                13.05504219327545,
                                -0.01655260341619,
                                -12.28759895145294,
                                .02161526843274,
                                9.4829380631979,
                                -0.02074045215285,
                                -5.87257861775999,
                                .00594298065125,
                                2.75465861874613,
                                .00306428023191,
                                -0.86984376593551,
                                .00012025322027,
                                .13919314567432,
                                .00288463683916
                            ],
                            [
                                .0541865640643,
                                -3.47845948550071,
                                -0.02911007808948,
                                6.36317777566148,
                                -0.00848709379851,
                                -8.54751527471874,
                                -0.00851165645469,
                                9.4769360780128,
                                -0.00834990904936,
                                -8.81498681370155,
                                .02245293253339,
                                6.85401540936998,
                                -0.02596338512915,
                                -4.39470996079559,
                                .01624864962975,
                                2.19611684890774,
                                -0.00240879051584,
                                -0.75104302451432,
                                .00674613682247,
                                .13149317958808,
                                -0.00187763777362
                            ],
                            [
                                .15457299681924,
                                -2.37898834973084,
                                -0.09331049056315,
                                2.84868151156327,
                                -0.06247880153653,
                                -2.64577170229825,
                                .02163541888798,
                                2.23697657451713,
                                -0.05588393329856,
                                -1.67148153367602,
                                .04781476674921,
                                1.00595954808547,
                                .00222312597743,
                                -0.45953458054983,
                                .03174092540049,
                                .16378164858596,
                                -0.01390589421898,
                                -0.05032077717131,
                                .00651420667831,
                                .0234789740702,
                                -0.00881362733839
                            ],
                            [
                                .30296907319327,
                                -1.61273165137247,
                                -0.22613988682123,
                                1.0797749225997,
                                -0.08587323730772,
                                -0.2565625775407,
                                .03282930172664,
                                -0.1627671912044,
                                -0.00915702933434,
                                -0.22638893773906,
                                -0.02364141202522,
                                .39120800788284,
                                -0.00584456039913,
                                -0.22138138954925,
                                .06276101321749,
                                .04500235387352,
                                -0.00000828086748,
                                .02005851806501,
                                .00205861885564,
                                .00302439095741,
                                -0.02950134983287
                            ],
                            [
                                .33642304856132,
                                -1.49858979367799,
                                -0.2557224142557,
                                .87350271418188,
                                -0.11828570177555,
                                .12205022308084,
                                .11921148675203,
                                -0.80774944671438,
                                -0.07834489609479,
                                .47854794562326,
                                -0.0046997791438,
                                -0.12453458140019,
                                -0.0058950022444,
                                -0.04067510197014,
                                .05724228140351,
                                .08333755284107,
                                .00832043980773,
                                -0.04237348025746,
                                -0.0163538138454,
                                .02977207319925,
                                -0.0176017656815
                            ],
                            [
                                .4491525660845,
                                -0.62820619233671,
                                -0.14351757464547,
                                .29661783706366,
                                -0.22784394429749,
                                -0.372563729424,
                                -0.01419140100551,
                                .00213767857124,
                                .04078262797139,
                                -0.42029820170918,
                                -0.12398163381748,
                                .22199650564824,
                                .04097565135648,
                                .00613424350682,
                                .10478503600251,
                                .06747620744683,
                                -0.01863887810927,
                                .05784820375801,
                                -0.03193428438915,
                                .03222754072173,
                                .00541907748707
                            ],
                            [
                                .56619470757641,
                                -1.04800335126349,
                                -0.75464456939302,
                                .29156311971249,
                                .1624213774223,
                                -0.26806001042947,
                                .16744243493672,
                                .00819999645858,
                                -0.18901604199609,
                                .45054734505008,
                                .3093178284183,
                                -0.33032403314006,
                                -0.27562961986224,
                                .0673936833311,
                                .00647310677246,
                                -0.04784254229033,
                                .08647503780351,
                                .01639907836189,
                                -0.0378898455484,
                                .01807364323573,
                                -0.00588215443421
                            ],
                            [
                                .58100494960553,
                                -0.51035327095184,
                                -0.53174909058578,
                                -0.31863563325245,
                                -0.14289799034253,
                                -0.20256413484477,
                                .17520704835522,
                                .1472815413433,
                                .02377945217615,
                                .38952639978999,
                                .15558449135573,
                                -0.23313271880868,
                                -0.25344790059353,
                                -0.05246019024463,
                                .01628462406333,
                                -0.02505961724053,
                                .06920467763959,
                                .02442357316099,
                                -0.03721611395801,
                                .01818801111503,
                                -0.00749618797172
                            ],
                            [
                                .53648789255105,
                                -0.2504987195602,
                                -0.42163034350696,
                                -0.43193942311114,
                                -0.00275953611929,
                                -0.03424681017675,
                                .04267842219415,
                                -0.04678328784242,
                                -0.10214864179676,
                                .26408300200955,
                                .14590772289388,
                                .15113130533216,
                                -0.02459864859345,
                                -0.17556493366449,
                                -0.11202315195388,
                                -0.18823009262115,
                                -0.04060034127,
                                .05477720428674,
                                .0478866554818,
                                .0470440968812,
                                -0.02217936801134
                            ]
                        ]), n = [
                            [
                                .98621192462708,
                                -1.97223372919527,
                                -1.97242384925416,
                                .97261396931306,
                                .98621192462708
                            ],
                            [
                                .98500175787242,
                                -1.96977855582618,
                                -1.97000351574484,
                                .9702284756635,
                                .98500175787242
                            ],
                            [
                                .97938932735214,
                                -1.95835380975398,
                                -1.95877865470428,
                                .95920349965459,
                                .97938932735214
                            ],
                            [
                                .97531843204928,
                                -1.95002759149878,
                                -1.95063686409857,
                                .95124613669835,
                                .97531843204928
                            ],
                            [
                                .97316523498161,
                                -1.94561023566527,
                                -1.94633046996323,
                                .94705070426118,
                                .97316523498161
                            ],
                            [
                                .96454515552826,
                                -1.92783286977036,
                                -1.92909031105652,
                                .93034775234268,
                                .96454515552826
                            ],
                            [
                                .96009142950541,
                                -1.91858953033784,
                                -1.92018285901082,
                                .92177618768381,
                                .96009142950541
                            ],
                            [
                                .95856916599601,
                                -1.9154210807478,
                                -1.91713833199203,
                                .91885558323625,
                                .95856916599601
                            ],
                            [
                                .94597685600279,
                                -1.88903307939452,
                                -1.89195371200558,
                                .89487434461664,
                                .94597685600279
                            ]
                        ];
                        function r(e, t, a, s, n, r) {
                            for(; 0 != n--;)a[s] = 1e-10 + e[t + 0] * r[0] - a[s - 1] * r[1] + e[t - 1] * r[2] - a[s - 2] * r[3] + e[t - 2] * r[4] - a[s - 3] * r[5] + e[t - 3] * r[6] - a[s - 4] * r[7] + e[t - 4] * r[8] - a[s - 5] * r[9] + e[t - 5] * r[10] - a[s - 6] * r[11] + e[t - 6] * r[12] - a[s - 7] * r[13] + e[t - 7] * r[14] - a[s - 8] * r[15] + e[t - 8] * r[16] - a[s - 9] * r[17] + e[t - 9] * r[18] - a[s - 10] * r[19] + e[t - 10] * r[20], ++s, ++t;
                        }
                        function _(e, t, a, s, n, r) {
                            for(; 0 != n--;)a[s] = e[t + 0] * r[0] - a[s - 1] * r[1] + e[t - 1] * r[2] - a[s - 2] * r[3] + e[t - 2] * r[4], ++s, ++t;
                        }
                        function l(e) {
                            return e * e;
                        }
                        this.InitGainAnalysis = function(e, s) {
                            return function(e, s) {
                                for(var n = 0; n < MAX_ORDER; n++)e.linprebuf[n] = e.lstepbuf[n] = e.loutbuf[n] = e.rinprebuf[n] = e.rstepbuf[n] = e.routbuf[n] = 0;
                                switch(0 | s){
                                    case 48e3:
                                        e.reqindex = 0;
                                        break;
                                    case 44100:
                                        e.reqindex = 1;
                                        break;
                                    case 32e3:
                                        e.reqindex = 2;
                                        break;
                                    case 24e3:
                                        e.reqindex = 3;
                                        break;
                                    case 22050:
                                        e.reqindex = 4;
                                        break;
                                    case 16e3:
                                        e.reqindex = 5;
                                        break;
                                    case 12e3:
                                        e.reqindex = 6;
                                        break;
                                    case 11025:
                                        e.reqindex = 7;
                                        break;
                                    case 8e3:
                                        e.reqindex = 8;
                                        break;
                                    default:
                                        return INIT_GAIN_ANALYSIS_ERROR;
                                }
                                return e.sampleWindow = 0 | (s * t + a - 1) / a, e.lsum = 0, e.rsum = 0, e.totsamp = 0, i.ill(e.A, 0), INIT_GAIN_ANALYSIS_OK;
                            }(e, s) != INIT_GAIN_ANALYSIS_OK ? INIT_GAIN_ANALYSIS_ERROR : (e.linpre = MAX_ORDER, e.rinpre = MAX_ORDER, e.lstep = MAX_ORDER, e.rstep = MAX_ORDER, e.lout = MAX_ORDER, e.rout = MAX_ORDER, i.fill(e.B, 0), INIT_GAIN_ANALYSIS_OK);
                        }, this.AnalyzeSamples = function(e, t, a, i, f, c, h) {
                            var u, b, p, d, v, g, S;
                            if (0 == c) return GAIN_ANALYSIS_OK;
                            switch(S = 0, v = c, h){
                                case 1:
                                    i = t, f = a;
                                    break;
                                case 2:
                                    break;
                                default:
                                    return GAIN_ANALYSIS_ERROR;
                            }
                            for(c < MAX_ORDER ? (o.arraycopy(t, a, e.linprebuf, MAX_ORDER, c), o.arraycopy(i, f, e.rinprebuf, MAX_ORDER, c)) : (o.arraycopy(t, a, e.linprebuf, MAX_ORDER, MAX_ORDER), o.arraycopy(i, f, e.rinprebuf, MAX_ORDER, MAX_ORDER)); v > 0;){
                                g = v > e.sampleWindow - e.totsamp ? e.sampleWindow - e.totsamp : v, S < MAX_ORDER ? (u = e.linpre + S, b = e.linprebuf, p = e.rinpre + S, d = e.rinprebuf, g > MAX_ORDER - S && (g = MAX_ORDER - S)) : (u = a + S, b = t, p = f + S, d = i), r(b, u, e.lstepbuf, e.lstep + e.totsamp, g, s[e.reqindex]), r(d, p, e.rstepbuf, e.rstep + e.totsamp, g, s[e.reqindex]), _(e.lstepbuf, e.lstep + e.totsamp, e.loutbuf, e.lout + e.totsamp, g, n[e.reqindex]), _(e.rstepbuf, e.rstep + e.totsamp, e.routbuf, e.rout + e.totsamp, g, n[e.reqindex]), u = e.lout + e.totsamp, b = e.loutbuf, p = e.rout + e.totsamp, d = e.routbuf;
                                for(var R = g % 8; 0 != R--;)e.lsum += l(b[u++]), e.rsum += l(d[p++]);
                                for(R = g / 8; 0 != R--;)e.lsum += l(b[u + 0]) + l(b[u + 1]) + l(b[u + 2]) + l(b[u + 3]) + l(b[u + 4]) + l(b[u + 5]) + l(b[u + 6]) + l(b[u + 7]), u += 8, e.rsum += l(d[p + 0]) + l(d[p + 1]) + l(d[p + 2]) + l(d[p + 3]) + l(d[p + 4]) + l(d[p + 5]) + l(d[p + 6]) + l(d[p + 7]), p += 8;
                                if (v -= g, S += g, e.totsamp += g, e.totsamp == e.sampleWindow) {
                                    var M = 10 * m.STEPS_per_dB * Math.log10((e.lsum + e.rsum) / e.totsamp * .5 + 1e-37), A = M <= 0 ? 0 : 0 | M;
                                    A >= e.A.length && (A = e.A.length - 1), e.A[A]++, e.lsum = e.rsum = 0, o.arraycopy(e.loutbuf, e.totsamp, e.loutbuf, 0, MAX_ORDER), o.arraycopy(e.routbuf, e.totsamp, e.routbuf, 0, MAX_ORDER), o.arraycopy(e.lstepbuf, e.totsamp, e.lstepbuf, 0, MAX_ORDER), o.arraycopy(e.rstepbuf, e.totsamp, e.rstepbuf, 0, MAX_ORDER), e.totsamp = 0;
                                }
                                if (e.totsamp > e.sampleWindow) return GAIN_ANALYSIS_ERROR;
                            }
                            return c < MAX_ORDER ? (o.arraycopy(e.linprebuf, c, e.linprebuf, 0, MAX_ORDER - c), o.arraycopy(e.rinprebuf, c, e.rinprebuf, 0, MAX_ORDER - c), o.arraycopy(t, a, e.linprebuf, MAX_ORDER - c, c), o.arraycopy(i, f, e.rinprebuf, MAX_ORDER - c, c)) : (o.arraycopy(t, a + c - MAX_ORDER, e.linprebuf, 0, MAX_ORDER), o.arraycopy(i, f + c - MAX_ORDER, e.rinprebuf, 0, MAX_ORDER)), GAIN_ANALYSIS_OK;
                        }, this.GetTitleGain = function(t) {
                            for(var a = function(t, a) {
                                var s, n = 0;
                                for(s = 0; s < a; s++)n += t[s];
                                if (0 == n) return GAIN_NOT_ENOUGH_SAMPLES;
                                var r = 0 | Math.ceil(n * (1 - e));
                                for(s = a; s-- > 0 && !((r -= t[s]) <= 0););
                                return 64.82 - s / m.STEPS_per_dB;
                            }(t.A, t.A.length), s = 0; s < t.A.length; s++)t.B[s] += t.A[s], t.A[s] = 0;
                            for(s = 0; s < MAX_ORDER; s++)t.linprebuf[s] = t.lstepbuf[s] = t.loutbuf[s] = t.rinprebuf[s] = t.rstepbuf[s] = t.routbuf[s] = 0;
                            return t.totsamp = 0, t.lsum = t.rsum = 0, a;
                        };
                    }
                    function d() {
                        var e = null;
                        function a(e) {
                            this.bits = 0 | e;
                        }
                        this.qupvt = null, this.setModules = function(t) {
                            this.qupvt = t, e = t;
                        };
                        var s = [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                1
                            ],
                            [
                                1,
                                1
                            ],
                            [
                                1,
                                1
                            ],
                            [
                                1,
                                2
                            ],
                            [
                                2,
                                2
                            ],
                            [
                                2,
                                3
                            ],
                            [
                                2,
                                3
                            ],
                            [
                                3,
                                4
                            ],
                            [
                                3,
                                4
                            ],
                            [
                                3,
                                4
                            ],
                            [
                                4,
                                5
                            ],
                            [
                                4,
                                5
                            ],
                            [
                                4,
                                6
                            ],
                            [
                                5,
                                6
                            ],
                            [
                                5,
                                6
                            ],
                            [
                                5,
                                7
                            ],
                            [
                                6,
                                7
                            ],
                            [
                                6,
                                7
                            ]
                        ];
                        function n(e, t, a, s, n, r) {
                            var _ = .5946 / t;
                            for(e >>= 1; 0 != e--;)n[r++] = _ > a[s++] ? 0 : 1, n[r++] = _ > a[s++] ? 0 : 1;
                        }
                        function r(t, a, s, n, r, _) {
                            var i = (t >>= 1) % 2;
                            for(t >>= 1; 0 != t--;){
                                var o, l, f, c, h, u, b, p;
                                o = s[n++] * a, l = s[n++] * a, h = 0 | o, f = s[n++] * a, u = 0 | l, c = s[n++] * a, b = 0 | f, o += e.adj43[h], p = 0 | c, l += e.adj43[u], r[_++] = 0 | o, f += e.adj43[b], r[_++] = 0 | l, c += e.adj43[p], r[_++] = 0 | f, r[_++] = 0 | c;
                            }
                            0 != i && (h = 0 | (o = s[n++] * a), u = 0 | (l = s[n++] * a), o += e.adj43[h], l += e.adj43[u], r[_++] = 0 | o, r[_++] = 0 | l);
                        }
                        var _ = [
                            1,
                            2,
                            5,
                            7,
                            7,
                            10,
                            10,
                            13,
                            13,
                            13,
                            13,
                            13,
                            13,
                            13,
                            13
                        ];
                        function l(e, t, a, s) {
                            var n = function(e, t, a) {
                                var s = 0, n = 0;
                                do {
                                    var r = e[t++], _ = e[t++];
                                    s < r && (s = r), n < _ && (n = _);
                                }while (t < a);
                                return s < n && (s = n), s;
                            }(e, t, a);
                            switch(n){
                                case 0:
                                    return n;
                                case 1:
                                    return function(e, t, a, s) {
                                        var n = 0, r = M.ht[1].hlen;
                                        do {
                                            var _ = 2 * e[t + 0] + e[t + 1];
                                            t += 2, n += r[_];
                                        }while (t < a);
                                        return s.bits += n, 1;
                                    }(e, t, a, s);
                                case 2:
                                case 3:
                                    return function(e, t, a, s, n) {
                                        var r, _, i = 0, o = M.ht[s].xlen;
                                        _ = 2 == s ? M.table23 : M.table56;
                                        do {
                                            var l = e[t + 0] * o + e[t + 1];
                                            t += 2, i += _[l];
                                        }while (t < a);
                                        return r = 65535 & i, (i >>= 16) > r && (i = r, s++), n.bits += i, s;
                                    }(e, t, a, _[n - 1], s);
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                case 8:
                                case 9:
                                case 10:
                                case 11:
                                case 12:
                                case 13:
                                case 14:
                                case 15:
                                    return function(e, t, a, s, n) {
                                        var r = 0, _ = 0, i = 0, o = M.ht[s].xlen, l = M.ht[s].hlen, f = M.ht[s + 1].hlen, c = M.ht[s + 2].hlen;
                                        do {
                                            var h = e[t + 0] * o + e[t + 1];
                                            t += 2, r += l[h], _ += f[h], i += c[h];
                                        }while (t < a);
                                        var u = s;
                                        return r > _ && (r = _, u++), r > i && (r = i, u = s + 2), n.bits += r, u;
                                    }(e, t, a, _[n - 1], s);
                                default:
                                    if (n > P.IXMAX_VAL) return s.bits = P.LARGE_BITS, -1;
                                    var r, i;
                                    for(n -= 15, r = 24; r < 32 && !(M.ht[r].linmax >= n); r++);
                                    for(i = r - 8; i < 24 && !(M.ht[i].linmax >= n); i++);
                                    return function(e, t, a, s, n, r) {
                                        var _, i = 65536 * M.ht[s].xlen + M.ht[n].xlen, o = 0;
                                        do {
                                            var l = e[t++], f = e[t++];
                                            0 != l && (l > 14 && (l = 15, o += i), l *= 16), 0 != f && (f > 14 && (f = 15, o += i), l += f), o += M.largetbl[l];
                                        }while (t < a);
                                        return _ = 65535 & o, (o >>= 16) > _ && (o = _, s = n), r.bits += o, s;
                                    }(e, t, a, i, r, s);
                            }
                        }
                        function f(e, t, s, n, r, _, i, o) {
                            for(var f = t.big_values, c = 2; c < D.SBMAX_l + 1; c++){
                                var h = e.scalefac_band.l[c];
                                if (h >= f) break;
                                var u = r[c - 2] + t.count1bits;
                                if (s.part2_3_length <= u) break;
                                var b = new a(u), p = l(n, h, f, b);
                                u = b.bits, s.part2_3_length <= u || (s.assign(t), s.part2_3_length = u, s.region0_count = _[c - 2], s.region1_count = c - 2 - _[c - 2], s.table_select[0] = i[c - 2], s.table_select[1] = o[c - 2], s.table_select[2] = p);
                            }
                        }
                        this.noquant_count_bits = function(e, t, s) {
                            var n = t.l3_enc, r = Math.min(576, t.max_nonzero_coeff + 2 >> 1 << 1);
                            for(null != s && (s.sfb_count1 = 0); r > 1 && 0 == (n[r - 1] | n[r - 2]); r -= 2);
                            t.count1 = r;
                            for(var _ = 0, i = 0; r > 3; r -= 4){
                                var o;
                                if ((2147483647 & (n[r - 1] | n[r - 2] | n[r - 3] | n[r - 4])) > 1) break;
                                o = 2 * (2 * (2 * n[r - 4] + n[r - 3]) + n[r - 2]) + n[r - 1], _ += M.t32l[o], i += M.t33l[o];
                            }
                            var f = _;
                            if (t.count1table_select = 0, _ > i && (f = i, t.count1table_select = 1), t.count1bits = f, t.big_values = r, 0 == r) return f;
                            if (t.block_type == D.SHORT_TYPE) (_ = 3 * e.scalefac_band.s[3]) > t.big_values && (_ = t.big_values), i = t.big_values;
                            else if (t.block_type == D.NORM_TYPE) {
                                if (_ = t.region0_count = e.bv_scf[r - 2], i = t.region1_count = e.bv_scf[r - 1], i = e.scalefac_band.l[_ + i + 2], _ = e.scalefac_band.l[_ + 1], i < r) {
                                    var c = new a(f);
                                    t.table_select[2] = l(n, i, r, c), f = c.bits;
                                }
                            } else t.region0_count = 7, t.region1_count = D.SBMAX_l - 1 - 7 - 1, (_ = e.scalefac_band.l[8]) > (i = r) && (_ = i);
                            if (_ = Math.min(_, r), i = Math.min(i, r), 0 < _ && (c = new a(f), t.table_select[0] = l(n, 0, _, c), f = c.bits), _ < i && (c = new a(f), t.table_select[1] = l(n, _, i, c), f = c.bits), 2 == e.use_best_huffman && (t.part2_3_length = f, best_huffman_divide(e, t), f = t.part2_3_length), null != s && t.block_type == D.NORM_TYPE) {
                                for(var h = 0; e.scalefac_band.l[h] < t.big_values;)h++;
                                s.sfb_count1 = h;
                            }
                            return f;
                        }, this.count_bits = function(t, a, s, _) {
                            var o = s.l3_enc, l = P.IXMAX_VAL / e.IPOW20(s.global_gain);
                            if (s.xrpow_max > l) return P.LARGE_BITS;
                            if (function(t, a, s, _, o) {
                                var l, f, c, h = 0, u = 0, b = 0, p = 0, m = a, d = 0, v = m, g = 0, S = t, R = 0;
                                for(c = null != o && _.global_gain == o.global_gain, f = _.block_type == D.SHORT_TYPE ? 38 : 21, l = 0; l <= f; l++){
                                    var M = -1;
                                    if ((c || _.block_type == D.NORM_TYPE) && (M = _.global_gain - (_.scalefac[l] + (0 != _.preflag ? e.pretab[l] : 0) << _.scalefac_scale + 1) - 8 * _.subblock_gain[_.window[l]]), c && o.step[l] == M) 0 != u && (r(u, s, S, R, v, g), u = 0), 0 != b && (n(b, s, S, R, v, g), b = 0);
                                    else {
                                        var A, B = _.width[l];
                                        if (h + _.width[l] > _.max_nonzero_coeff && (A = _.max_nonzero_coeff - h + 1, i.fill(a, _.max_nonzero_coeff, 576, 0), (B = A) < 0 && (B = 0), l = f + 1), 0 == u && 0 == b && (v = m, g = d, S = t, R = p), null != o && o.sfb_count1 > 0 && l >= o.sfb_count1 && o.step[l] > 0 && M >= o.step[l] ? (0 != u && (r(u, s, S, R, v, g), u = 0, v = m, g = d, S = t, R = p), b += B) : (0 != b && (n(b, s, S, R, v, g), b = 0, v = m, g = d, S = t, R = p), u += B), B <= 0) {
                                            0 != b && (n(b, s, S, R, v, g), b = 0), 0 != u && (r(u, s, S, R, v, g), u = 0);
                                            break;
                                        }
                                    }
                                    l <= f && (d += _.width[l], p += _.width[l], h += _.width[l]);
                                }
                                0 != u && (r(u, s, S, R, v, g), u = 0), 0 != b && (n(b, s, S, R, v, g), b = 0);
                            }(a, o, e.IPOW20(s.global_gain), s, _), 0 != (2 & t.substep_shaping)) for(var f = 0, c = s.global_gain + s.scalefac_scale, h = .634521682242439 / e.IPOW20(c), u = 0; u < s.sfbmax; u++){
                                var b, p = s.width[u];
                                if (0 == t.pseudohalf[u]) f += p;
                                else for(b = f, f += p; b < f; ++b)o[b] = a[b] >= h ? o[b] : 0;
                            }
                            return this.noquant_count_bits(t, s, _);
                        }, this.best_huffman_divide = function(e, s) {
                            var n = new H, r = s.l3_enc, _ = t(23), i = t(23), o = t(23), c = t(23);
                            if (s.block_type != D.SHORT_TYPE || 1 != e.mode_gr) {
                                n.assign(s), s.block_type == D.NORM_TYPE && (function(e, t, s, n, r, _, i) {
                                    for(var o = t.big_values, f = 0; f <= 22; f++)n[f] = P.LARGE_BITS;
                                    for(f = 0; f < 16; f++){
                                        var c = e.scalefac_band.l[f + 1];
                                        if (c >= o) break;
                                        var h = 0, u = new a(h), b = l(s, 0, c, u);
                                        h = u.bits;
                                        for(var p = 0; p < 8; p++){
                                            var m = e.scalefac_band.l[f + p + 2];
                                            if (m >= o) break;
                                            var d = h, v = l(s, c, m, u = new a(d));
                                            d = u.bits, n[f + p] > d && (n[f + p] = d, r[f + p] = f, _[f + p] = b, i[f + p] = v);
                                        }
                                    }
                                }(e, s, r, _, i, o, c), f(e, n, s, r, _, i, o, c));
                                var h = n.big_values;
                                if (!(0 == h || (r[h - 2] | r[h - 1]) > 1 || (h = s.count1 + 2) > 576)) {
                                    n.assign(s), n.count1 = h;
                                    for(var u = 0, b = 0; h > n.big_values; h -= 4){
                                        var p = 2 * (2 * (2 * r[h - 4] + r[h - 3]) + r[h - 2]) + r[h - 1];
                                        u += M.t32l[p], b += M.t33l[p];
                                    }
                                    if (n.big_values = h, n.count1table_select = 0, u > b && (u = b, n.count1table_select = 1), n.count1bits = u, n.block_type == D.NORM_TYPE) f(e, n, s, r, _, i, o, c);
                                    else {
                                        if (n.part2_3_length = u, (u = e.scalefac_band.l[8]) > h && (u = h), u > 0) {
                                            var m = new a(n.part2_3_length);
                                            n.table_select[0] = l(r, 0, u, m), n.part2_3_length = m.bits;
                                        }
                                        h > u && (m = new a(n.part2_3_length), n.table_select[1] = l(r, u, h, m), n.part2_3_length = m.bits), s.part2_3_length > n.part2_3_length && s.assign(n);
                                    }
                                }
                            }
                        };
                        var c = [
                            1,
                            1,
                            1,
                            1,
                            8,
                            2,
                            2,
                            2,
                            4,
                            4,
                            4,
                            8,
                            8,
                            8,
                            16,
                            16
                        ], h = [
                            1,
                            2,
                            4,
                            8,
                            1,
                            2,
                            4,
                            8,
                            2,
                            4,
                            8,
                            2,
                            4,
                            8,
                            4,
                            8
                        ], u = [
                            0,
                            0,
                            0,
                            0,
                            3,
                            1,
                            1,
                            1,
                            2,
                            2,
                            2,
                            3,
                            3,
                            3,
                            4,
                            4
                        ], b = [
                            0,
                            1,
                            2,
                            3,
                            0,
                            1,
                            2,
                            3,
                            1,
                            2,
                            3,
                            1,
                            2,
                            3,
                            2,
                            3
                        ];
                        d.slen1_tab = u, d.slen2_tab = b, this.best_scalefac_store = function(t, a, s, n) {
                            var r, _, i, o, l = n.tt[a][s], f = 0;
                            for(i = 0, r = 0; r < l.sfbmax; r++){
                                var p = l.width[r];
                                for(i += p, o = -p; o < 0 && 0 == l.l3_enc[o + i]; o++);
                                0 == o && (l.scalefac[r] = f = -2);
                            }
                            if (0 == l.scalefac_scale && 0 == l.preflag) {
                                var m = 0;
                                for(r = 0; r < l.sfbmax; r++)l.scalefac[r] > 0 && (m |= l.scalefac[r]);
                                if (0 == (1 & m) && 0 != m) {
                                    for(r = 0; r < l.sfbmax; r++)l.scalefac[r] > 0 && (l.scalefac[r] >>= 1);
                                    l.scalefac_scale = f = 1;
                                }
                            }
                            if (0 == l.preflag && l.block_type != D.SHORT_TYPE && 2 == t.mode_gr) {
                                for(r = 11; r < D.SBPSY_l && !(l.scalefac[r] < e.pretab[r] && -2 != l.scalefac[r]); r++);
                                if (r == D.SBPSY_l) {
                                    for(r = 11; r < D.SBPSY_l; r++)l.scalefac[r] > 0 && (l.scalefac[r] -= e.pretab[r]);
                                    l.preflag = f = 1;
                                }
                            }
                            for(_ = 0; _ < 4; _++)n.scfsi[s][_] = 0;
                            for(2 == t.mode_gr && 1 == a && n.tt[0][s].block_type != D.SHORT_TYPE && n.tt[1][s].block_type != D.SHORT_TYPE && (function(e, t) {
                                for(var a, s = t.tt[1][e], n = t.tt[0][e], r = 0; r < M.scfsi_band.length - 1; r++){
                                    for(a = M.scfsi_band[r]; a < M.scfsi_band[r + 1] && !(n.scalefac[a] != s.scalefac[a] && s.scalefac[a] >= 0); a++);
                                    if (a == M.scfsi_band[r + 1]) {
                                        for(a = M.scfsi_band[r]; a < M.scfsi_band[r + 1]; a++)s.scalefac[a] = -1;
                                        t.scfsi[e][r] = 1;
                                    }
                                }
                                var _ = 0, i = 0;
                                for(a = 0; a < 11; a++)-1 != s.scalefac[a] && (i++, _ < s.scalefac[a] && (_ = s.scalefac[a]));
                                for(var o = 0, l = 0; a < D.SBPSY_l; a++)-1 != s.scalefac[a] && (l++, o < s.scalefac[a] && (o = s.scalefac[a]));
                                for(r = 0; r < 16; r++)if (_ < c[r] && o < h[r]) {
                                    var f = u[r] * i + b[r] * l;
                                    s.part2_length > f && (s.part2_length = f, s.scalefac_compress = r);
                                }
                            }(s, n), f = 0), r = 0; r < l.sfbmax; r++)-2 == l.scalefac[r] && (l.scalefac[r] = 0);
                            0 != f && (2 == t.mode_gr ? this.scale_bitcount(l) : this.scale_bitcount_lsf(t, l));
                        };
                        var p = [
                            0,
                            18,
                            36,
                            54,
                            54,
                            36,
                            54,
                            72,
                            54,
                            72,
                            90,
                            72,
                            90,
                            108,
                            108,
                            126
                        ], m = [
                            0,
                            18,
                            36,
                            54,
                            51,
                            35,
                            53,
                            71,
                            52,
                            70,
                            88,
                            69,
                            87,
                            105,
                            104,
                            122
                        ], v = [
                            0,
                            10,
                            20,
                            30,
                            33,
                            21,
                            31,
                            41,
                            32,
                            42,
                            52,
                            43,
                            53,
                            63,
                            64,
                            74
                        ];
                        this.scale_bitcount = function(t) {
                            var a, s, n, r = 0, _ = 0, i = t.scalefac;
                            if (t.block_type == D.SHORT_TYPE) n = p, 0 != t.mixed_block_flag && (n = m);
                            else if (n = v, 0 == t.preflag) {
                                for(s = 11; s < D.SBPSY_l && !(i[s] < e.pretab[s]); s++);
                                if (s == D.SBPSY_l) for(t.preflag = 1, s = 11; s < D.SBPSY_l; s++)i[s] -= e.pretab[s];
                            }
                            for(s = 0; s < t.sfbdivide; s++)r < i[s] && (r = i[s]);
                            for(; s < t.sfbmax; s++)_ < i[s] && (_ = i[s]);
                            for(t.part2_length = P.LARGE_BITS, a = 0; a < 16; a++)r < c[a] && _ < h[a] && t.part2_length > n[a] && (t.part2_length = n[a], t.scalefac_compress = a);
                            return t.part2_length == P.LARGE_BITS;
                        };
                        var g = [
                            [
                                15,
                                15,
                                7,
                                7
                            ],
                            [
                                15,
                                15,
                                7,
                                0
                            ],
                            [
                                7,
                                3,
                                0,
                                0
                            ],
                            [
                                15,
                                31,
                                31,
                                0
                            ],
                            [
                                7,
                                7,
                                7,
                                0
                            ],
                            [
                                3,
                                3,
                                0,
                                0
                            ]
                        ];
                        this.scale_bitcount_lsf = function(a, s) {
                            var n, r, _, i, l, f, c, h, u = t(4), b = s.scalefac;
                            for(n = 0 != s.preflag ? 2 : 0, c = 0; c < 4; c++)u[c] = 0;
                            if (s.block_type == D.SHORT_TYPE) {
                                r = 1;
                                var p = e.nr_of_sfb_block[n][r];
                                for(h = 0, _ = 0; _ < 4; _++)for(i = p[_] / 3, c = 0; c < i; c++, h++)for(l = 0; l < 3; l++)b[3 * h + l] > u[_] && (u[_] = b[3 * h + l]);
                            } else for(r = 0, p = e.nr_of_sfb_block[n][r], h = 0, _ = 0; _ < 4; _++)for(i = p[_], c = 0; c < i; c++, h++)b[h] > u[_] && (u[_] = b[h]);
                            for(f = !1, _ = 0; _ < 4; _++)u[_] > g[n][_] && (f = !0);
                            if (!f) {
                                var m, d, v, R;
                                for(s.sfb_partition_table = e.nr_of_sfb_block[n][r], _ = 0; _ < 4; _++)s.slen[_] = S[u[_]];
                                switch(m = s.slen[0], d = s.slen[1], v = s.slen[2], R = s.slen[3], n){
                                    case 0:
                                        s.scalefac_compress = (5 * m + d << 4) + (v << 2) + R;
                                        break;
                                    case 1:
                                        s.scalefac_compress = 400 + (5 * m + d << 2) + v;
                                        break;
                                    case 2:
                                        s.scalefac_compress = 500 + 3 * m + d;
                                        break;
                                    default:
                                        o.err.printf("intensity stereo not implemented yet\n");
                                }
                            }
                            if (!f) for(s.part2_length = 0, _ = 0; _ < 4; _++)s.part2_length += s.slen[_] * s.sfb_partition_table[_];
                            return f;
                        };
                        var S = [
                            0,
                            1,
                            2,
                            2,
                            3,
                            3,
                            3,
                            3,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ];
                        this.huffman_init = function(e) {
                            for(var t = 2; t <= 576; t += 2){
                                for(var a, n = 0; e.scalefac_band.l[++n] < t;);
                                for(a = s[n][0]; e.scalefac_band.l[a + 1] > t;)a--;
                                for(a < 0 && (a = s[n][0]), e.bv_scf[t - 2] = a, a = s[n][1]; e.scalefac_band.l[a + e.bv_scf[t - 2] + 2] > t;)a--;
                                a < 0 && (a = s[n][1]), e.bv_scf[t - 1] = a;
                            }
                        };
                    }
                    function v() {
                        var e;
                        this.setModules = function(t) {
                            e = t;
                        }, this.ResvFrameBegin = function(t, a) {
                            var s, n = t.internal_flags, r = n.l3_side, _ = e.getframebits(t);
                            a.bits = (_ - 8 * n.sideinfo_len) / n.mode_gr;
                            var i = 2048 * n.mode_gr - 8;
                            t.brate > 320 ? s = 8 * int(1e3 * t.brate / (t.out_samplerate / 1152) / 8 + .5) : (s = 11520, t.strict_ISO && (s = 8 * int(32e4 / (t.out_samplerate / 1152) / 8 + .5))), n.ResvMax = s - _, n.ResvMax > i && (n.ResvMax = i), (n.ResvMax < 0 || t.disable_reservoir) && (n.ResvMax = 0);
                            var o = a.bits * n.mode_gr + Math.min(n.ResvSize, n.ResvMax);
                            return o > s && (o = s), r.resvDrain_pre = 0, null != n.pinfo && (n.pinfo.mean_bits = a.bits / 2, n.pinfo.resvsize = n.ResvSize), o;
                        }, this.ResvMaxBits = function(e, t, a, s) {
                            var n, r = e.internal_flags, _ = r.ResvSize, i = r.ResvMax;
                            0 != s && (_ += t), 0 != (1 & r.substep_shaping) && (i *= .9), a.bits = t, 10 * _ > 9 * i ? (n = _ - 9 * i / 10, a.bits += n, r.substep_shaping |= 128) : (n = 0, r.substep_shaping &= 127, e.disable_reservoir || 0 != (1 & r.substep_shaping) || (a.bits -= .1 * t));
                            var o = _ < 6 * r.ResvMax / 10 ? _ : 6 * r.ResvMax / 10;
                            return (o -= n) < 0 && (o = 0), o;
                        }, this.ResvAdjust = function(e, t) {
                            e.ResvSize -= t.part2_3_length + t.part2_length;
                        }, this.ResvFrameEnd = function(e, t) {
                            var a, s = e.l3_side;
                            e.ResvSize += t * e.mode_gr;
                            var n = 0;
                            s.resvDrain_post = 0, s.resvDrain_pre = 0, 0 != (a = e.ResvSize % 8) && (n += a), (a = e.ResvSize - n - e.ResvMax) > 0 && (n += a);
                            var r = Math.min(8 * s.main_data_begin, n) / 8;
                            s.resvDrain_pre += 8 * r, n -= 8 * r, e.ResvSize -= 8 * r, s.main_data_begin -= r, s.resvDrain_post += n, e.ResvSize -= n;
                        };
                    }
                    function g() {
                        var a = this, n = null, r = null, _ = null, l = null;
                        this.setModules = function(e, t, a, s) {
                            n = e, r = t, _ = a, l = s;
                        };
                        var f = null, c = 0, h = 0, u = 0;
                        function b(e) {
                            o.arraycopy(e.header[e.w_ptr].buf, 0, f, h, e.sideinfo_len), h += e.sideinfo_len, c += 8 * e.sideinfo_len, e.w_ptr = e.w_ptr + 1 & F.MAX_HEADER_BUF - 1;
                        }
                        function p(e, t, a) {
                            for(; a > 0;){
                                var s;
                                0 == u && (u = 8, h++, e.header[e.w_ptr].write_timing == c && b(e), f[h] = 0), a -= s = Math.min(a, u), u -= s, f[h] |= t >> a << u, c += s;
                            }
                        }
                        function v(e, t, a) {
                            for(; a > 0;){
                                var s;
                                0 == u && (u = 8, f[++h] = 0), a -= s = Math.min(a, u), u -= s, f[h] |= t >> a << u, c += s;
                            }
                        }
                        function g(e, t) {
                            var a, s = e.internal_flags;
                            if (t >= 8 && (p(s, 76, 8), t -= 8), t >= 8 && (p(s, 65, 8), t -= 8), t >= 8 && (p(s, 77, 8), t -= 8), t >= 8 && (p(s, 69, 8), t -= 8), t >= 32) {
                                var n = _.getLameShortVersion();
                                if (t >= 32) for(a = 0; a < n.length && t >= 8; ++a)t -= 8, p(s, n.charAt(a), 8);
                            }
                            for(; t >= 1; t -= 1)p(s, s.ancillary_flag, 1), s.ancillary_flag ^= e.disable_reservoir ? 0 : 1;
                        }
                        function S(e, t, a) {
                            for(var s = e.header[e.h_ptr].ptr; a > 0;){
                                var n = Math.min(a, 8 - (7 & s));
                                a -= n, e.header[e.h_ptr].buf[s >> 3] |= t >> a << 8 - (7 & s) - n, s += n;
                            }
                            e.header[e.h_ptr].ptr = s;
                        }
                        function R(e, t) {
                            e <<= 8;
                            for(var a = 0; a < 8; a++)0 != (65536 & ((t <<= 1) ^ (e <<= 1))) && (t ^= 32773);
                            return t;
                        }
                        function A(e, t) {
                            var a, s = M.ht[t.count1table_select + 32], n = 0, r = t.big_values, _ = t.big_values;
                            for(a = (t.count1 - t.big_values) / 4; a > 0; --a){
                                var i = 0, o = 0;
                                0 != t.l3_enc[r + 0] && (o += 8, t.xr[_ + 0] < 0 && i++), 0 != t.l3_enc[r + 1] && (o += 4, i *= 2, t.xr[_ + 1] < 0 && i++), 0 != t.l3_enc[r + 2] && (o += 2, i *= 2, t.xr[_ + 2] < 0 && i++), 0 != t.l3_enc[r + 3] && (o++, i *= 2, t.xr[_ + 3] < 0 && i++), r += 4, _ += 4, p(e, i + s.table[o], s.hlen[o]), n += s.hlen[o];
                            }
                            return n;
                        }
                        function B(e, t, a, s, n) {
                            var r = M.ht[t], _ = 0;
                            if (0 == t) return _;
                            for(var i = a; i < s; i += 2){
                                var o = 0, l = 0, f = r.xlen, c = r.xlen, h = 0, u = n.l3_enc[i], b = n.l3_enc[i + 1];
                                0 != u && (n.xr[i] < 0 && h++, o--), t > 15 && (u > 14 && (h |= u - 15 << 1, l = f, u = 15), b > 14 && (h <<= f, h |= b - 15, l += f, b = 15), c = 16), 0 != b && (h <<= 1, n.xr[i + 1] < 0 && h++, o--), u = u * c + b, l -= o, o += r.hlen[u], p(e, r.table[u], o), p(e, h, l), _ += o + l;
                            }
                            return _;
                        }
                        function w(e, t) {
                            var a = 3 * e.scalefac_band.s[3];
                            return a > t.big_values && (a = t.big_values), B(e, t.table_select[0], 0, a, t) + B(e, t.table_select[1], a, t.big_values, t);
                        }
                        function E(e, t) {
                            var a, s, n, r;
                            a = t.big_values;
                            var _ = t.region0_count + 1;
                            return n = e.scalefac_band.l[_], _ += t.region1_count + 1, n > a && (n = a), (r = e.scalefac_band.l[_]) > a && (r = a), s = B(e, t.table_select[0], 0, n, t), (s += B(e, t.table_select[1], n, r, t)) + B(e, t.table_select[2], r, a, t);
                        }
                        function T() {
                            this.total = 0;
                        }
                        function k(e, t) {
                            var s, n, r, _, i, l = e.internal_flags;
                            return i = l.w_ptr, -1 == (_ = l.h_ptr - 1) && (_ = F.MAX_HEADER_BUF - 1), s = l.header[_].write_timing - c, t.total = s, s >= 0 && (n = 1 + _ - i, _ < i && (n = 1 + _ - i + F.MAX_HEADER_BUF), s -= 8 * n * l.sideinfo_len), s += r = a.getframebits(e), t.total += r, t.total % 8 != 0 ? t.total = 1 + t.total / 8 : t.total = t.total / 8, t.total += h + 1, s < 0 && o.err.println("strange error flushing buffer ... \n"), s;
                        }
                        this.getframebits = function(e) {
                            var t, a = e.internal_flags;
                            return t = 0 != a.bitrate_index ? M.bitrate_table[e.version][a.bitrate_index] : e.brate, 8 * (0 | 72e3 * (e.version + 1) * t / e.out_samplerate + a.padding);
                        }, this.CRC_writeheader = function(e, t) {
                            var a = 65535;
                            a = R(255 & t[2], a), a = R(255 & t[3], a);
                            for(var s = 6; s < e.sideinfo_len; s++)a = R(255 & t[s], a);
                            t[4] = byte(a >> 8), t[5] = byte(255 & a);
                        }, this.flush_bitstream = function(e) {
                            var t, a, s = e.internal_flags, r = s.h_ptr - 1;
                            if (-1 == r && (r = F.MAX_HEADER_BUF - 1), t = s.l3_side, !((a = k(e, new T)) < 0)) {
                                if (g(e, a), s.ResvSize = 0, t.main_data_begin = 0, s.findReplayGain) {
                                    var _ = n.GetTitleGain(s.rgdata);
                                    s.RadioGain = 0 | Math.floor(10 * _ + .5);
                                }
                                s.findPeakSample && (s.noclipGainChange = 0 | Math.ceil(20 * Math.log10(s.PeakSample / 32767) * 10), s.noclipGainChange > 0 && (EQ(e.scale, 1) || EQ(e.scale, 0)) ? s.noclipScale = Math.floor(32767 / s.PeakSample * 100) / 100 : s.noclipScale = -1);
                            }
                        }, this.add_dummy_byte = function(e, t, a) {
                            for(var s, n = e.internal_flags; a-- > 0;)for(v(0, t, 8), s = 0; s < F.MAX_HEADER_BUF; ++s)n.header[s].write_timing += 8;
                        }, this.format_bitstream = function(e) {
                            var t, a = e.internal_flags;
                            t = a.l3_side;
                            var s = this.getframebits(e);
                            g(e, t.resvDrain_pre), function(e, t) {
                                var a, s, n, r = e.internal_flags;
                                if (a = r.l3_side, r.header[r.h_ptr].ptr = 0, i.fill(r.header[r.h_ptr].buf, 0, r.sideinfo_len, 0), e.out_samplerate < 16e3 ? S(r, 4094, 12) : S(r, 4095, 12), S(r, e.version, 1), S(r, 1, 2), S(r, e.error_protection ? 0 : 1, 1), S(r, r.bitrate_index, 4), S(r, r.samplerate_index, 2), S(r, r.padding, 1), S(r, e.extension, 1), S(r, e.mode.ordinal(), 2), S(r, r.mode_ext, 2), S(r, e.copyright, 1), S(r, e.original, 1), S(r, e.emphasis, 2), e.error_protection && S(r, 0, 16), 1 == e.version) {
                                    for(S(r, a.main_data_begin, 9), 2 == r.channels_out ? S(r, a.private_bits, 3) : S(r, a.private_bits, 5), n = 0; n < r.channels_out; n++){
                                        var _;
                                        for(_ = 0; _ < 4; _++)S(r, a.scfsi[n][_], 1);
                                    }
                                    for(s = 0; s < 2; s++)for(n = 0; n < r.channels_out; n++)S(r, (l = a.tt[s][n]).part2_3_length + l.part2_length, 12), S(r, l.big_values / 2, 9), S(r, l.global_gain, 8), S(r, l.scalefac_compress, 4), l.block_type != D.NORM_TYPE ? (S(r, 1, 1), S(r, l.block_type, 2), S(r, l.mixed_block_flag, 1), 14 == l.table_select[0] && (l.table_select[0] = 16), S(r, l.table_select[0], 5), 14 == l.table_select[1] && (l.table_select[1] = 16), S(r, l.table_select[1], 5), S(r, l.subblock_gain[0], 3), S(r, l.subblock_gain[1], 3), S(r, l.subblock_gain[2], 3)) : (S(r, 0, 1), 14 == l.table_select[0] && (l.table_select[0] = 16), S(r, l.table_select[0], 5), 14 == l.table_select[1] && (l.table_select[1] = 16), S(r, l.table_select[1], 5), 14 == l.table_select[2] && (l.table_select[2] = 16), S(r, l.table_select[2], 5), S(r, l.region0_count, 4), S(r, l.region1_count, 3)), S(r, l.preflag, 1), S(r, l.scalefac_scale, 1), S(r, l.count1table_select, 1);
                                } else for(S(r, a.main_data_begin, 8), S(r, a.private_bits, r.channels_out), s = 0, n = 0; n < r.channels_out; n++){
                                    var l;
                                    S(r, (l = a.tt[s][n]).part2_3_length + l.part2_length, 12), S(r, l.big_values / 2, 9), S(r, l.global_gain, 8), S(r, l.scalefac_compress, 9), l.block_type != D.NORM_TYPE ? (S(r, 1, 1), S(r, l.block_type, 2), S(r, l.mixed_block_flag, 1), 14 == l.table_select[0] && (l.table_select[0] = 16), S(r, l.table_select[0], 5), 14 == l.table_select[1] && (l.table_select[1] = 16), S(r, l.table_select[1], 5), S(r, l.subblock_gain[0], 3), S(r, l.subblock_gain[1], 3), S(r, l.subblock_gain[2], 3)) : (S(r, 0, 1), 14 == l.table_select[0] && (l.table_select[0] = 16), S(r, l.table_select[0], 5), 14 == l.table_select[1] && (l.table_select[1] = 16), S(r, l.table_select[1], 5), 14 == l.table_select[2] && (l.table_select[2] = 16), S(r, l.table_select[2], 5), S(r, l.region0_count, 4), S(r, l.region1_count, 3)), S(r, l.scalefac_scale, 1), S(r, l.count1table_select, 1);
                                }
                                e.error_protection && CRC_writeheader(r, r.header[r.h_ptr].buf);
                                var f = r.h_ptr;
                                r.h_ptr = f + 1 & F.MAX_HEADER_BUF - 1, r.header[r.h_ptr].write_timing = r.header[f].write_timing + t, r.h_ptr == r.w_ptr && o.err.println("Error: MAX_HEADER_BUF too small in bitstream.c \n");
                            }(e, s);
                            var n = 8 * a.sideinfo_len;
                            if (n += function(e) {
                                var t, a, s, n, r = 0, _ = e.internal_flags, i = _.l3_side;
                                if (1 == e.version) for(t = 0; t < 2; t++)for(a = 0; a < _.channels_out; a++){
                                    var o = i.tt[t][a], l = d.slen1_tab[o.scalefac_compress], f = d.slen2_tab[o.scalefac_compress];
                                    for(n = 0, s = 0; s < o.sfbdivide; s++)-1 != o.scalefac[s] && (p(_, o.scalefac[s], l), n += l);
                                    for(; s < o.sfbmax; s++)-1 != o.scalefac[s] && (p(_, o.scalefac[s], f), n += f);
                                    o.block_type == D.SHORT_TYPE ? n += w(_, o) : n += E(_, o), r += n += A(_, o);
                                }
                                else for(t = 0, a = 0; a < _.channels_out; a++){
                                    var c, h, u = 0;
                                    if (n = 0, s = 0, h = 0, (o = i.tt[t][a]).block_type == D.SHORT_TYPE) {
                                        for(; h < 4; h++){
                                            var b = o.sfb_partition_table[h] / 3, m = o.slen[h];
                                            for(c = 0; c < b; c++, s++)p(_, Math.max(o.scalefac[3 * s + 0], 0), m), p(_, Math.max(o.scalefac[3 * s + 1], 0), m), p(_, Math.max(o.scalefac[3 * s + 2], 0), m), u += 3 * m;
                                        }
                                        n += w(_, o);
                                    } else {
                                        for(; h < 4; h++)for(b = o.sfb_partition_table[h], m = o.slen[h], c = 0; c < b; c++, s++)p(_, Math.max(o.scalefac[s], 0), m), u += m;
                                        n += E(_, o);
                                    }
                                    r += u + (n += A(_, o));
                                }
                                return r;
                            }(e), g(e, t.resvDrain_post), n += t.resvDrain_post, t.main_data_begin += (s - n) / 8, k(e, new T) != a.ResvSize && o.err.println("Internal buffer inconsistency. flushbits <> ResvSize"), 8 * t.main_data_begin != a.ResvSize && (o.err.printf("bit reservoir error: \nl3_side.main_data_begin: %d \nResvoir size:             %d \nresv drain (post)         %d \nresv drain (pre)          %d \nheader and sideinfo:      %d \ndata bits:                %d \ntotal bits:               %d (remainder: %d) \nbitsperframe:             %d \n", 8 * t.main_data_begin, a.ResvSize, t.resvDrain_post, t.resvDrain_pre, 8 * a.sideinfo_len, n - t.resvDrain_post - 8 * a.sideinfo_len, n, n % 8, s), o.err.println("This is a fatal error.  It has several possible causes:"), o.err.println("90%%  LAME compiled with buggy version of gcc using advanced optimizations"), o.err.println(" 9%%  Your system is overclocked"), o.err.println(" 1%%  bug in LAME encoding library"), a.ResvSize = 8 * t.main_data_begin), c > 1e9) {
                                var r;
                                for(r = 0; r < F.MAX_HEADER_BUF; ++r)a.header[r].write_timing -= c;
                                c = 0;
                            }
                            return 0;
                        }, this.copy_buffer = function(e, a, _, i, c) {
                            var b = h + 1;
                            if (b <= 0) return 0;
                            if (0 != i && b > i) return -1;
                            if (o.arraycopy(f, 0, a, _, b), h = -1, u = 0, 0 != c) {
                                var p = t(1);
                                if (p[0] = e.nMusicCRC, l.updateMusicCRC(p, a, _, b), e.nMusicCRC = p[0], b > 0 && (e.VBR_seek_table.nBytesWritten += b), e.decode_on_the_fly) {
                                    for(var d, v = s([
                                        2,
                                        1152
                                    ]), g = b, S = -1; 0 != S;)if (S = r.hip_decode1_unclipped(e.hip, a, _, g, v[0], v[1]), g = 0, -1 == S && (S = 0), S > 0) {
                                        if (e.findPeakSample) {
                                            for(d = 0; d < S; d++)v[0][d] > e.PeakSample ? e.PeakSample = v[0][d] : -v[0][d] > e.PeakSample && (e.PeakSample = -v[0][d]);
                                            if (e.channels_out > 1) for(d = 0; d < S; d++)v[1][d] > e.PeakSample ? e.PeakSample = v[1][d] : -v[1][d] > e.PeakSample && (e.PeakSample = -v[1][d]);
                                        }
                                        if (e.findReplayGain && n.AnalyzeSamples(e.rgdata, v[0], 0, v[1], 0, S, e.channels_out) == m.GAIN_ANALYSIS_ERROR) return -6;
                                    }
                                }
                            }
                            return b;
                        }, this.init_bit_stream_w = function(t) {
                            f = e(z.LAME_MAXMP3BUFFER), t.h_ptr = t.w_ptr = 0, t.header[t.h_ptr].write_timing = 0, h = -1, u = 0, c = 0;
                        };
                    }
                    function S() {
                        var t, a, s;
                        this.setModules = function(e, n, r) {
                            t = e, a = n, s = r;
                        };
                        var n = S.NUMTOCENTRIES, r = S.MAXFRAMESIZE, _ = n + 4 + 4 + 4 + 4 + 4 + 9 + 1 + 1 + 8 + 1 + 1 + 3 + 1 + 1 + 2 + 4 + 2 + 2, l = [
                            0,
                            49345,
                            49537,
                            320,
                            49921,
                            960,
                            640,
                            49729,
                            50689,
                            1728,
                            1920,
                            51009,
                            1280,
                            50625,
                            50305,
                            1088,
                            52225,
                            3264,
                            3456,
                            52545,
                            3840,
                            53185,
                            52865,
                            3648,
                            2560,
                            51905,
                            52097,
                            2880,
                            51457,
                            2496,
                            2176,
                            51265,
                            55297,
                            6336,
                            6528,
                            55617,
                            6912,
                            56257,
                            55937,
                            6720,
                            7680,
                            57025,
                            57217,
                            8e3,
                            56577,
                            7616,
                            7296,
                            56385,
                            5120,
                            54465,
                            54657,
                            5440,
                            55041,
                            6080,
                            5760,
                            54849,
                            53761,
                            4800,
                            4992,
                            54081,
                            4352,
                            53697,
                            53377,
                            4160,
                            61441,
                            12480,
                            12672,
                            61761,
                            13056,
                            62401,
                            62081,
                            12864,
                            13824,
                            63169,
                            63361,
                            14144,
                            62721,
                            13760,
                            13440,
                            62529,
                            15360,
                            64705,
                            64897,
                            15680,
                            65281,
                            16320,
                            16e3,
                            65089,
                            64001,
                            15040,
                            15232,
                            64321,
                            14592,
                            63937,
                            63617,
                            14400,
                            10240,
                            59585,
                            59777,
                            10560,
                            60161,
                            11200,
                            10880,
                            59969,
                            60929,
                            11968,
                            12160,
                            61249,
                            11520,
                            60865,
                            60545,
                            11328,
                            58369,
                            9408,
                            9600,
                            58689,
                            9984,
                            59329,
                            59009,
                            9792,
                            8704,
                            58049,
                            58241,
                            9024,
                            57601,
                            8640,
                            8320,
                            57409,
                            40961,
                            24768,
                            24960,
                            41281,
                            25344,
                            41921,
                            41601,
                            25152,
                            26112,
                            42689,
                            42881,
                            26432,
                            42241,
                            26048,
                            25728,
                            42049,
                            27648,
                            44225,
                            44417,
                            27968,
                            44801,
                            28608,
                            28288,
                            44609,
                            43521,
                            27328,
                            27520,
                            43841,
                            26880,
                            43457,
                            43137,
                            26688,
                            30720,
                            47297,
                            47489,
                            31040,
                            47873,
                            31680,
                            31360,
                            47681,
                            48641,
                            32448,
                            32640,
                            48961,
                            32e3,
                            48577,
                            48257,
                            31808,
                            46081,
                            29888,
                            30080,
                            46401,
                            30464,
                            47041,
                            46721,
                            30272,
                            29184,
                            45761,
                            45953,
                            29504,
                            45313,
                            29120,
                            28800,
                            45121,
                            20480,
                            37057,
                            37249,
                            20800,
                            37633,
                            21440,
                            21120,
                            37441,
                            38401,
                            22208,
                            22400,
                            38721,
                            21760,
                            38337,
                            38017,
                            21568,
                            39937,
                            23744,
                            23936,
                            40257,
                            24320,
                            40897,
                            40577,
                            24128,
                            23040,
                            39617,
                            39809,
                            23360,
                            39169,
                            22976,
                            22656,
                            38977,
                            34817,
                            18624,
                            18816,
                            35137,
                            19200,
                            35777,
                            35457,
                            19008,
                            19968,
                            36545,
                            36737,
                            20288,
                            36097,
                            19904,
                            19584,
                            35905,
                            17408,
                            33985,
                            34177,
                            17728,
                            34561,
                            18368,
                            18048,
                            34369,
                            33281,
                            17088,
                            17280,
                            33601,
                            16640,
                            33217,
                            32897,
                            16448
                        ];
                        function c(e, t) {
                            var a = 255 & e[t + 0];
                            return a <<= 8, a |= 255 & e[t + 1], a <<= 8, a |= 255 & e[t + 2], (a <<= 8) | 255 & e[t + 3];
                        }
                        function u(e, t, a) {
                            e[t + 0] = 255 & a >> 24, e[t + 1] = 255 & a >> 16, e[t + 2] = 255 & a >> 8, e[t + 3] = 255 & a;
                        }
                        function b(e, t, a) {
                            e[t + 0] = 255 & a >> 8, e[t + 1] = 255 & a;
                        }
                        function p(e, t, a) {
                            return 255 & (e << t | a & ~(-1 << t));
                        }
                        function m(e, a) {
                            var s = e.internal_flags;
                            a[0] = p(a[0], 8, 255), a[1] = p(a[1], 3, 7), a[1] = p(a[1], 1, e.out_samplerate < 16e3 ? 0 : 1), a[1] = p(a[1], 1, e.version), a[1] = p(a[1], 2, 1), a[1] = p(a[1], 1, e.error_protection ? 0 : 1), a[2] = p(a[2], 4, s.bitrate_index), a[2] = p(a[2], 2, s.samplerate_index), a[2] = p(a[2], 1, 0), a[2] = p(a[2], 1, e.extension), a[3] = p(a[3], 2, e.mode.ordinal()), a[3] = p(a[3], 2, s.mode_ext), a[3] = p(a[3], 1, e.copyright), a[3] = p(a[3], 1, e.original), a[3] = p(a[3], 2, e.emphasis), a[0] = 255;
                            var n, r, _ = 241 & a[1];
                            n = 1 == e.version ? 128 : e.out_samplerate < 16e3 ? 32 : 64, e.VBR == h.vbr_off && (n = e.brate), r = e.free_format ? 0 : 255 & 16 * t.BitrateIndex(n, e.version, e.out_samplerate), 1 == e.version ? (a[1] = 255 & (10 | _), _ = 13 & a[2], a[2] = 255 & (r | _)) : (a[1] = 255 & (2 | _), _ = 13 & a[2], a[2] = 255 & (r | _));
                        }
                        function d(e, t) {
                            return t >> 8 ^ l[255 & (t ^ e)];
                        }
                        this.addVbrFrame = function(e) {
                            var t = e.internal_flags, a = M.bitrate_table[e.version][t.bitrate_index];
                            !function(e, t) {
                                if (e.nVbrNumFrames++, e.sum += t, e.seen++, !(e.seen < e.want) && (e.pos < e.size && (e.bag[e.pos] = e.sum, e.pos++, e.seen = 0), e.pos == e.size)) {
                                    for(var a = 1; a < e.size; a += 2)e.bag[a / 2] = e.bag[a];
                                    e.want *= 2, e.pos /= 2;
                                }
                            }(t.VBR_seek_table, a);
                        }, this.getVbrTag = function(e) {
                            var t = new VBRTagData, a = 0;
                            t.flags = 0;
                            var s = e[a + 1] >> 3 & 1, r = e[a + 2] >> 2 & 3, _ = e[a + 3] >> 6 & 3, i = e[a + 2] >> 4 & 15;
                            if (i = M.bitrate_table[s][i], e[a + 1] >> 4 == 14 ? t.samprate = M.samplerate_table[2][r] : t.samprate = M.samplerate_table[s][r], !function(e, t) {
                                return new String(e, t, 4(), null).equals("Xing") || new String(e, t, 4(), null).equals("Info");
                            }(e, a += 0 != s ? 3 != _ ? 36 : 21 : 3 != _ ? 21 : 13)) return null;
                            a += 4, t.hId = s;
                            var o = t.flags = c(e, a);
                            if (a += 4, 0 != (1 & o) && (t.frames = c(e, a), a += 4), 0 != (2 & o) && (t.bytes = c(e, a), a += 4), 0 != (4 & o)) {
                                if (null != t.toc) for(var l = 0; l < n; l++)t.toc[l] = e[a + l];
                                a += n;
                            }
                            t.vbrScale = -1, 0 != (8 & o) && (t.vbrScale = c(e, a), a += 4), t.headersize = 72e3 * (s + 1) * i / t.samprate;
                            var f = e[(a += 21) + 0] << 4;
                            f += e[a + 1] >> 4;
                            var h = (15 & e[a + 1]) << 8;
                            return (f < 0 || f > 3e3) && (f = -1), ((h += 255 & e[a + 2]) < 0 || h > 3e3) && (h = -1), t.encDelay = f, t.encPadding = h, t;
                        }, this.InitVbrTag = function(t) {
                            var s, n = t.internal_flags;
                            s = 1 == t.version ? 128 : t.out_samplerate < 16e3 ? 32 : 64, t.VBR == h.vbr_off && (s = t.brate);
                            var i = 72e3 * (t.version + 1) * s / t.out_samplerate, o = n.sideinfo_len + _;
                            if (n.VBR_seek_table.TotalFrameSize = i, i < o || i > r) t.bWriteVbrTag = !1;
                            else {
                                n.VBR_seek_table.nVbrNumFrames = 0, n.VBR_seek_table.nBytesWritten = 0, n.VBR_seek_table.sum = 0, n.VBR_seek_table.seen = 0, n.VBR_seek_table.want = 1, n.VBR_seek_table.pos = 0, null == n.VBR_seek_table.bag && (n.VBR_seek_table.bag = new int[400], n.VBR_seek_table.size = 400);
                                var l = e(r);
                                m(t, l);
                                for(var f = n.VBR_seek_table.TotalFrameSize, c = 0; c < f; ++c)a.add_dummy_byte(t, 255 & l[c], 1);
                            }
                        }, this.updateMusicCRC = function(e, t, a, s) {
                            for(var n = 0; n < s; ++n)e[0] = d(t[a + n], e[0]);
                        }, this.getLameTagFrame = function(t, r) {
                            var _ = t.internal_flags;
                            if (!t.bWriteVbrTag) return 0;
                            if (_.Class_ID != z.LAME_ID) return 0;
                            if (_.VBR_seek_table.pos <= 0) return 0;
                            if (r.length < _.VBR_seek_table.TotalFrameSize) return _.VBR_seek_table.TotalFrameSize;
                            i.fill(r, 0, _.VBR_seek_table.TotalFrameSize, 0), m(t, r);
                            var l = e(n);
                            if (t.free_format) for(var c = 1; c < n; ++c)l[c] = 255 & 255 * c / 100;
                            else !function(e, t) {
                                if (!(e.pos <= 0)) for(var a = 1; a < n; ++a){
                                    var s = a / n, r = 0 | Math.floor(s * e.pos);
                                    r > e.pos - 1 && (r = e.pos - 1);
                                    var _ = 0 | 256 * e.bag[r] / e.sum;
                                    _ > 255 && (_ = 255), t[a] = 255 & _;
                                }
                            }(_.VBR_seek_table, l);
                            var p = _.sideinfo_len;
                            t.error_protection && (p -= 2), t.VBR == h.vbr_off ? (r[p++] = 255 & "Info".charAt(0), r[p++] = 255 & "Info".charAt(1), r[p++] = 255 & "Info".charAt(2), r[p++] = 255 & "Info".charAt(3)) : (r[p++] = 255 & "Xing".charAt(0), r[p++] = 255 & "Xing".charAt(1), r[p++] = 255 & "Xing".charAt(2), r[p++] = 255 & "Xing".charAt(3)), u(r, p, 15), u(r, p += 4, _.VBR_seek_table.nVbrNumFrames), p += 4;
                            var v = _.VBR_seek_table.nBytesWritten + _.VBR_seek_table.TotalFrameSize;
                            u(r, p, 0 | v), p += 4, o.arraycopy(l, 0, r, p, l.length), p += l.length, t.error_protection && a.CRC_writeheader(_, r);
                            var g = 0;
                            for(c = 0; c < p; c++)g = d(r[c], g);
                            return p += function(e, t, a, n, r) {
                                var _, i, o, l, c, h, p = e.internal_flags, m = 0, v = e.encoder_delay, g = e.encoder_padding, S = 100 - 10 * e.VBR_q - e.quality, R = s.getLameVeryShortVersion(), M = [
                                    1,
                                    5,
                                    3,
                                    2,
                                    4,
                                    0,
                                    3
                                ], A = 0 | (e.lowpassfreq / 100 + .5 > 255 ? 255 : e.lowpassfreq / 100 + .5), B = 0, w = 0, E = e.internal_flags.noise_shaping, T = 0, k = 0, y = 0 != (1 & e.exp_nspsytune), x = 0 != (2 & e.exp_nspsytune), P = !1, I = !1, H = e.internal_flags.nogap_total, O = e.internal_flags.nogap_current, V = e.ATHtype;
                                switch(e.VBR){
                                    case vbr_abr:
                                        c = e.VBR_mean_bitrate_kbps;
                                        break;
                                    case vbr_off:
                                        c = e.brate;
                                        break;
                                    default:
                                        c = e.VBR_min_bitrate_kbps;
                                }
                                switch(_ = 0 + (e.VBR.ordinal() < M.length ? M[e.VBR.ordinal()] : 0), p.findReplayGain && (p.RadioGain > 510 && (p.RadioGain = 510), p.RadioGain < -510 && (p.RadioGain = -510), w = 8192, w |= 3072, p.RadioGain >= 0 ? w |= p.RadioGain : (w |= 512, w |= -p.RadioGain)), p.findPeakSample && (B = Math.abs(0 | p.PeakSample / 32767 * Math.pow(2, 23) + .5)), -1 != H && (O > 0 && (I = !0), O < H - 1 && (P = !0)), l = V + ((y ? 1 : 0) << 4) + ((x ? 1 : 0) << 5) + ((P ? 1 : 0) << 6) + ((I ? 1 : 0) << 7), S < 0 && (S = 0), e.mode){
                                    case MONO:
                                        T = 0;
                                        break;
                                    case STEREO:
                                        T = 1;
                                        break;
                                    case DUAL_CHANNEL:
                                        T = 2;
                                        break;
                                    case JOINT_STEREO:
                                        T = e.force_ms ? 4 : 3;
                                        break;
                                    case NOT_SET:
                                    default:
                                        T = 7;
                                }
                                h = e.in_samplerate <= 32e3 ? 0 : 48e3 == e.in_samplerate ? 2 : e.in_samplerate > 48e3 ? 3 : 1, (e.short_blocks == f.short_block_forced || e.short_blocks == f.short_block_dispensed || -1 == e.lowpassfreq && -1 == e.highpassfreq || e.scale_left < e.scale_right || e.scale_left > e.scale_right || e.disable_reservoir && e.brate < 320 || e.noATH || e.ATHonly || 0 == V || e.in_samplerate <= 32e3) && (k = 1), i = E + (T << 2) + (k << 5) + (h << 6), o = p.nMusicCRC, u(a, n + m, S), m += 4;
                                for(var L = 0; L < 9; L++)a[n + m + L] = 255 & R.charAt(L);
                                a[n + (m += 9)] = 255 & _, a[n + ++m] = 255 & A, u(a, n + ++m, B), b(a, n + (m += 4), w), b(a, n + (m += 2), 0), a[n + (m += 2)] = 255 & l, a[n + ++m] = c >= 255 ? 255 : 255 & c, a[n + ++m] = 255 & v >> 4, a[n + m + 1] = 255 & (v << 4) + (g >> 8), a[n + m + 2] = 255 & g, a[n + (m += 3)] = 255 & i, m++, a[n + m++] = 0, b(a, n + m, e.preset), u(a, n + (m += 2), t), b(a, n + (m += 4), o), m += 2;
                                for(var N = 0; N < m; N++)r = d(a[n + N], r);
                                return b(a, n + m, r), m + 2;
                            }(t, v, r, p, g), _.VBR_seek_table.TotalFrameSize;
                        }, this.putVbrTag = function(t, a) {
                            if (t.internal_flags.VBR_seek_table.pos <= 0) return -1;
                            if (a.seek(a.length()), 0 == a.length()) return -1;
                            var s = function(t) {
                                t.seek(0);
                                var a = e(10);
                                return t.readFully(a), new String(a, "ISO-8859-1").startsWith("ID3") ? 0 : ((127 & a[6]) << 21 | (127 & a[7]) << 14 | (127 & a[8]) << 7 | 127 & a[9]) + a.length;
                            }(a);
                            a.seek(s);
                            var n = e(r), _ = getLameTagFrame(t, n);
                            return _ > n.length ? -1 : (_ < 1 || a.write(n, 0, _), 0);
                        };
                    }
                    function R(e, t, a, s) {
                        this.xlen = e, this.linmax = t, this.table = a, this.hlen = s;
                    }
                    c.MAX_VALUE = 34028235e31, h.vbr_off = new h(0), h.vbr_mt = new h(1), h.vbr_rh = new h(2), h.vbr_abr = new h(3), h.vbr_mtrh = new h(4), h.vbr_default = h.vbr_mtrh, u.STEREO = new u(0), u.JOINT_STEREO = new u(1), u.DUAL_CHANNEL = new u(2), u.MONO = new u(3), u.NOT_SET = new u(4), m.STEPS_per_dB = 100, m.MAX_dB = 120, m.GAIN_NOT_ENOUGH_SAMPLES = -24601, m.GAIN_ANALYSIS_ERROR = 0, m.GAIN_ANALYSIS_OK = 1, m.INIT_GAIN_ANALYSIS_ERROR = 0, m.INIT_GAIN_ANALYSIS_OK = 1, m.YULE_ORDER = 10, m.MAX_ORDER = m.YULE_ORDER, m.MAX_SAMP_FREQ = 48e3, m.RMS_WINDOW_TIME_NUMERATOR = 1, m.RMS_WINDOW_TIME_DENOMINATOR = 20, m.MAX_SAMPLES_PER_WINDOW = m.MAX_SAMP_FREQ * m.RMS_WINDOW_TIME_NUMERATOR / m.RMS_WINDOW_TIME_DENOMINATOR + 1, g.EQ = function(e, t) {
                        return Math.abs(e) > Math.abs(t) ? Math.abs(e - t) <= 1e-6 * Math.abs(e) : Math.abs(e - t) <= 1e-6 * Math.abs(t);
                    }, g.NEQ = function(e, t) {
                        return !g.EQ(e, t);
                    }, S.NUMTOCENTRIES = 100, S.MAXFRAMESIZE = 2880;
                    var M = {};
                    function A(e) {
                        this.bits = e;
                    }
                    function B() {
                        this.setModules = function(e, t) {};
                    }
                    function w() {
                        this.over_noise = 0, this.tot_noise = 0, this.max_noise = 0, this.over_count = 0, this.over_SSD = 0, this.bits = 0;
                    }
                    function E() {
                        this.class_id = 0, this.num_samples = 0, this.num_channels = 0, this.in_samplerate = 0, this.out_samplerate = 0, this.scale = 0, this.scale_left = 0, this.scale_right = 0, this.analysis = !1, this.bWriteVbrTag = !1, this.decode_only = !1, this.quality = 0, this.mode = u.STEREO, this.force_ms = !1, this.free_format = !1, this.findReplayGain = !1, this.decode_on_the_fly = !1, this.write_id3tag_automatic = !1, this.brate = 0, this.compression_ratio = 0, this.copyright = 0, this.original = 0, this.extension = 0, this.emphasis = 0, this.error_protection = 0, this.strict_ISO = !1, this.disable_reservoir = !1, this.quant_comp = 0, this.quant_comp_short = 0, this.experimentalY = !1, this.experimentalZ = 0, this.exp_nspsytune = 0, this.preset = 0, this.VBR = null, this.VBR_q_frac = 0, this.VBR_q = 0, this.VBR_mean_bitrate_kbps = 0, this.VBR_min_bitrate_kbps = 0, this.VBR_max_bitrate_kbps = 0, this.VBR_hard_min = 0, this.lowpassfreq = 0, this.highpassfreq = 0, this.lowpasswidth = 0, this.highpasswidth = 0, this.maskingadjust = 0, this.maskingadjust_short = 0, this.ATHonly = !1, this.ATHshort = !1, this.noATH = !1, this.ATHtype = 0, this.ATHcurve = 0, this.ATHlower = 0, this.athaa_type = 0, this.athaa_loudapprox = 0, this.athaa_sensitivity = 0, this.short_blocks = null, this.useTemporal = !1, this.interChRatio = 0, this.msfix = 0, this.tune = !1, this.tune_value_a = 0, this.version = 0, this.encoder_delay = 0, this.encoder_padding = 0, this.framesize = 0, this.frameNum = 0, this.lame_allocated_gfp = 0, this.internal_flags = null;
                    }
                    function T() {
                        this.linprebuf = a(2 * m.MAX_ORDER), this.linpre = 0, this.lstepbuf = a(m.MAX_SAMPLES_PER_WINDOW + m.MAX_ORDER), this.lstep = 0, this.loutbuf = a(m.MAX_SAMPLES_PER_WINDOW + m.MAX_ORDER), this.lout = 0, this.rinprebuf = a(2 * m.MAX_ORDER), this.rinpre = 0, this.rstepbuf = a(m.MAX_SAMPLES_PER_WINDOW + m.MAX_ORDER), this.rstep = 0, this.routbuf = a(m.MAX_SAMPLES_PER_WINDOW + m.MAX_ORDER), this.rout = 0, this.sampleWindow = 0, this.totsamp = 0, this.lsum = 0, this.rsum = 0, this.freqindex = 0, this.first = 0, this.A = t(0 | m.STEPS_per_dB * m.MAX_dB), this.B = t(0 | m.STEPS_per_dB * m.MAX_dB);
                    }
                    function k() {
                        this.useAdjust = 0, this.aaSensitivityP = 0, this.adjust = 0, this.adjustLimit = 0, this.decay = 0, this.floor = 0, this.l = a(D.SBMAX_l), this.s = a(D.SBMAX_s), this.psfb21 = a(D.PSFB21), this.psfb12 = a(D.PSFB12), this.cb_l = a(D.CBANDS), this.cb_s = a(D.CBANDS), this.eql_w = a(D.BLKSIZE / 2);
                    }
                    function y(e) {
                        var s = e;
                        this.quantize = s, this.iteration_loop = function(e, s, n, r) {
                            var _, i = e.internal_flags, o = a(O.SFBMAX), l = a(576), f = t(2), c = 0, h = i.l3_side, u = new A(c);
                            this.quantize.rv.ResvFrameBegin(e, u), c = u.bits;
                            for(var b = 0; b < i.mode_gr; b++){
                                _ = this.quantize.qupvt.on_pe(e, s, f, c, b, b), i.mode_ext == D.MPG_MD_MS_LR && (this.quantize.ms_convert(i.l3_side, b), this.quantize.qupvt.reduce_side(f, n[b], c, _));
                                for(var p = 0; p < i.channels_out; p++){
                                    var m, d, v = h.tt[b][p];
                                    v.block_type != D.SHORT_TYPE ? (m = 0, d = i.PSY.mask_adjust - m) : (m = 0, d = i.PSY.mask_adjust_short - m), i.masking_lower = Math.pow(10, .1 * d), this.quantize.init_outer_loop(i, v), this.quantize.init_xrpow(i, v, l) && (this.quantize.qupvt.calc_xmin(e, r[b][p], v, o), this.quantize.outer_loop(e, v, o, l, p, f[p])), this.quantize.iteration_finish_one(i, b, p);
                                }
                            }
                            this.quantize.rv.ResvFrameEnd(i, c);
                        };
                    }
                    function x(e, a, s, n) {
                        this.l = t(1 + D.SBMAX_l), this.s = t(1 + D.SBMAX_s), this.psfb21 = t(1 + D.PSFB21), this.psfb12 = t(1 + D.PSFB12);
                        var r = this.l, _ = this.s;
                        4 == arguments.length && (this.arrL = arguments[0], this.arrS = arguments[1], this.arr21 = arguments[2], this.arr12 = arguments[3], o.arraycopy(this.arrL, 0, r, 0, Math.min(this.arrL.length, this.l.length)), o.arraycopy(this.arrS, 0, _, 0, Math.min(this.arrS.length, this.s.length)), o.arraycopy(this.arr21, 0, this.psfb21, 0, Math.min(this.arr21.length, this.psfb21.length)), o.arraycopy(this.arr12, 0, this.psfb12, 0, Math.min(this.arr12.length, this.psfb12.length)));
                    }
                    function P() {
                        var e = null, s = null, n = null;
                        this.setModules = function(t, a, r) {
                            e = t, s = a, n = r;
                        }, this.IPOW20 = function(e) {
                            return b[e];
                        };
                        var r = P.IXMAX_VAL + 2, _ = P.Q_MAX, i = P.Q_MAX2, o = (P.LARGE_BITS, 100);
                        this.nr_of_sfb_block = [
                            [
                                [
                                    6,
                                    5,
                                    5,
                                    5
                                ],
                                [
                                    9,
                                    9,
                                    9,
                                    9
                                ],
                                [
                                    6,
                                    9,
                                    9,
                                    9
                                ]
                            ],
                            [
                                [
                                    6,
                                    5,
                                    7,
                                    3
                                ],
                                [
                                    9,
                                    9,
                                    12,
                                    6
                                ],
                                [
                                    6,
                                    9,
                                    12,
                                    6
                                ]
                            ],
                            [
                                [
                                    11,
                                    10,
                                    0,
                                    0
                                ],
                                [
                                    18,
                                    18,
                                    0,
                                    0
                                ],
                                [
                                    15,
                                    18,
                                    0,
                                    0
                                ]
                            ],
                            [
                                [
                                    7,
                                    7,
                                    7,
                                    0
                                ],
                                [
                                    12,
                                    12,
                                    12,
                                    0
                                ],
                                [
                                    6,
                                    15,
                                    12,
                                    0
                                ]
                            ],
                            [
                                [
                                    6,
                                    6,
                                    6,
                                    3
                                ],
                                [
                                    12,
                                    9,
                                    9,
                                    6
                                ],
                                [
                                    6,
                                    12,
                                    9,
                                    6
                                ]
                            ],
                            [
                                [
                                    8,
                                    8,
                                    5,
                                    0
                                ],
                                [
                                    15,
                                    12,
                                    9,
                                    0
                                ],
                                [
                                    6,
                                    18,
                                    9,
                                    0
                                ]
                            ]
                        ];
                        var f = [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            1,
                            1,
                            1,
                            2,
                            2,
                            3,
                            3,
                            3,
                            2,
                            0
                        ];
                        this.pretab = f, this.sfBandIndex = [
                            new x([
                                0,
                                6,
                                12,
                                18,
                                24,
                                30,
                                36,
                                44,
                                54,
                                66,
                                80,
                                96,
                                116,
                                140,
                                168,
                                200,
                                238,
                                284,
                                336,
                                396,
                                464,
                                522,
                                576
                            ], [
                                0,
                                4,
                                8,
                                12,
                                18,
                                24,
                                32,
                                42,
                                56,
                                74,
                                100,
                                132,
                                174,
                                192
                            ], [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ], [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ]),
                            new x([
                                0,
                                6,
                                12,
                                18,
                                24,
                                30,
                                36,
                                44,
                                54,
                                66,
                                80,
                                96,
                                114,
                                136,
                                162,
                                194,
                                232,
                                278,
                                332,
                                394,
                                464,
                                540,
                                576
                            ], [
                                0,
                                4,
                                8,
                                12,
                                18,
                                26,
                                36,
                                48,
                                62,
                                80,
                                104,
                                136,
                                180,
                                192
                            ], [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ], [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ]),
                            new x([
                                0,
                                6,
                                12,
                                18,
                                24,
                                30,
                                36,
                                44,
                                54,
                                66,
                                80,
                                96,
                                116,
                                140,
                                168,
                                200,
                                238,
                                284,
                                336,
                                396,
                                464,
                                522,
                                576
                            ], [
                                0,
                                4,
                                8,
                                12,
                                18,
                                26,
                                36,
                                48,
                                62,
                                80,
                                104,
                                134,
                                174,
                                192
                            ], [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ], [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ]),
                            new x([
                                0,
                                4,
                                8,
                                12,
                                16,
                                20,
                                24,
                                30,
                                36,
                                44,
                                52,
                                62,
                                74,
                                90,
                                110,
                                134,
                                162,
                                196,
                                238,
                                288,
                                342,
                                418,
                                576
                            ], [
                                0,
                                4,
                                8,
                                12,
                                16,
                                22,
                                30,
                                40,
                                52,
                                66,
                                84,
                                106,
                                136,
                                192
                            ], [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ], [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ]),
                            new x([
                                0,
                                4,
                                8,
                                12,
                                16,
                                20,
                                24,
                                30,
                                36,
                                42,
                                50,
                                60,
                                72,
                                88,
                                106,
                                128,
                                156,
                                190,
                                230,
                                276,
                                330,
                                384,
                                576
                            ], [
                                0,
                                4,
                                8,
                                12,
                                16,
                                22,
                                28,
                                38,
                                50,
                                64,
                                80,
                                100,
                                126,
                                192
                            ], [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ], [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ]),
                            new x([
                                0,
                                4,
                                8,
                                12,
                                16,
                                20,
                                24,
                                30,
                                36,
                                44,
                                54,
                                66,
                                82,
                                102,
                                126,
                                156,
                                194,
                                240,
                                296,
                                364,
                                448,
                                550,
                                576
                            ], [
                                0,
                                4,
                                8,
                                12,
                                16,
                                22,
                                30,
                                42,
                                58,
                                78,
                                104,
                                138,
                                180,
                                192
                            ], [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ], [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ]),
                            new x([
                                0,
                                6,
                                12,
                                18,
                                24,
                                30,
                                36,
                                44,
                                54,
                                66,
                                80,
                                96,
                                116,
                                140,
                                168,
                                200,
                                238,
                                284,
                                336,
                                396,
                                464,
                                522,
                                576
                            ], [
                                0,
                                4,
                                8,
                                12,
                                18,
                                26,
                                36,
                                48,
                                62,
                                80,
                                104,
                                134,
                                174,
                                192
                            ], [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ], [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ]),
                            new x([
                                0,
                                6,
                                12,
                                18,
                                24,
                                30,
                                36,
                                44,
                                54,
                                66,
                                80,
                                96,
                                116,
                                140,
                                168,
                                200,
                                238,
                                284,
                                336,
                                396,
                                464,
                                522,
                                576
                            ], [
                                0,
                                4,
                                8,
                                12,
                                18,
                                26,
                                36,
                                48,
                                62,
                                80,
                                104,
                                134,
                                174,
                                192
                            ], [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ], [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ]),
                            new x([
                                0,
                                12,
                                24,
                                36,
                                48,
                                60,
                                72,
                                88,
                                108,
                                132,
                                160,
                                192,
                                232,
                                280,
                                336,
                                400,
                                476,
                                566,
                                568,
                                570,
                                572,
                                574,
                                576
                            ], [
                                0,
                                8,
                                16,
                                24,
                                36,
                                52,
                                72,
                                96,
                                124,
                                160,
                                162,
                                164,
                                166,
                                192
                            ], [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ], [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ])
                        ];
                        var u = a(_ + i + 1), b = a(_), p = a(r), m = a(r);
                        function d(e, t) {
                            var a = n.ATHformula(t, e);
                            return a -= o, Math.pow(10, a / 10 + e.ATHlower);
                        }
                        function v(e) {
                            this.s = e;
                        }
                        this.adj43 = m, this.iteration_init = function(t) {
                            var a, s = t.internal_flags, n = s.l3_side;
                            if (0 == s.iteration_init_init) {
                                for(s.iteration_init_init = 1, n.main_data_begin = 0, function(e) {
                                    for(var t = e.internal_flags.ATH.l, a = e.internal_flags.ATH.psfb21, s = e.internal_flags.ATH.s, n = e.internal_flags.ATH.psfb12, r = e.internal_flags, _ = e.out_samplerate, i = 0; i < D.SBMAX_l; i++){
                                        var o = r.scalefac_band.l[i], l = r.scalefac_band.l[i + 1];
                                        t[i] = c.MAX_VALUE;
                                        for(var f = o; f < l; f++){
                                            var h = d(e, f * _ / 1152);
                                            t[i] = Math.min(t[i], h);
                                        }
                                    }
                                    for(i = 0; i < D.PSFB21; i++)for(o = r.scalefac_band.psfb21[i], l = r.scalefac_band.psfb21[i + 1], a[i] = c.MAX_VALUE, f = o; f < l; f++)h = d(e, f * _ / 1152), a[i] = Math.min(a[i], h);
                                    for(i = 0; i < D.SBMAX_s; i++){
                                        for(o = r.scalefac_band.s[i], l = r.scalefac_band.s[i + 1], s[i] = c.MAX_VALUE, f = o; f < l; f++)h = d(e, f * _ / 384), s[i] = Math.min(s[i], h);
                                        s[i] *= r.scalefac_band.s[i + 1] - r.scalefac_band.s[i];
                                    }
                                    for(i = 0; i < D.PSFB12; i++){
                                        for(o = r.scalefac_band.psfb12[i], l = r.scalefac_band.psfb12[i + 1], n[i] = c.MAX_VALUE, f = o; f < l; f++)h = d(e, f * _ / 384), n[i] = Math.min(n[i], h);
                                        n[i] *= r.scalefac_band.s[13] - r.scalefac_band.s[12];
                                    }
                                    if (e.noATH) {
                                        for(i = 0; i < D.SBMAX_l; i++)t[i] = 1e-20;
                                        for(i = 0; i < D.PSFB21; i++)a[i] = 1e-20;
                                        for(i = 0; i < D.SBMAX_s; i++)s[i] = 1e-20;
                                        for(i = 0; i < D.PSFB12; i++)n[i] = 1e-20;
                                    }
                                    r.ATH.floor = 10 * Math.log10(d(e, -1));
                                }(t), p[0] = 0, a = 1; a < r; a++)p[a] = Math.pow(a, 4 / 3);
                                for(a = 0; a < r - 1; a++)m[a] = a + 1 - Math.pow(.5 * (p[a] + p[a + 1]), .75);
                                for(m[a] = .5, a = 0; a < _; a++)b[a] = Math.pow(2, -0.1875 * (a - 210));
                                for(a = 0; a <= _ + i; a++)u[a] = Math.pow(2, .25 * (a - 210 - i));
                                var o, l, f, h;
                                for(e.huffman_init(s), (a = t.exp_nspsytune >> 2 & 63) >= 32 && (a -= 64), o = Math.pow(10, a / 4 / 10), (a = t.exp_nspsytune >> 8 & 63) >= 32 && (a -= 64), l = Math.pow(10, a / 4 / 10), (a = t.exp_nspsytune >> 14 & 63) >= 32 && (a -= 64), f = Math.pow(10, a / 4 / 10), (a = t.exp_nspsytune >> 20 & 63) >= 32 && (a -= 64), h = f * Math.pow(10, a / 4 / 10), a = 0; a < D.SBMAX_l; a++)v = a <= 6 ? o : a <= 13 ? l : a <= 20 ? f : h, s.nsPsy.longfact[a] = v;
                                for(a = 0; a < D.SBMAX_s; a++){
                                    var v;
                                    v = a <= 5 ? o : a <= 10 ? l : a <= 11 ? f : h, s.nsPsy.shortfact[a] = v;
                                }
                            }
                        }, this.on_pe = function(e, a, n, r, _, i) {
                            var o, l, f = e.internal_flags, c = 0, h = t(2), u = new A(c), b = s.ResvMaxBits(e, r, u, i), p = (c = u.bits) + b;
                            for(p > F.MAX_BITS_PER_GRANULE && (p = F.MAX_BITS_PER_GRANULE), o = 0, l = 0; l < f.channels_out; ++l)n[l] = Math.min(F.MAX_BITS_PER_CHANNEL, c / f.channels_out), h[l] = 0 | n[l] * a[_][l] / 700 - n[l], h[l] > 3 * r / 4 && (h[l] = 3 * r / 4), h[l] < 0 && (h[l] = 0), h[l] + n[l] > F.MAX_BITS_PER_CHANNEL && (h[l] = Math.max(0, F.MAX_BITS_PER_CHANNEL - n[l])), o += h[l];
                            if (o > b) for(l = 0; l < f.channels_out; ++l)h[l] = b * h[l] / o;
                            for(l = 0; l < f.channels_out; ++l)n[l] += h[l], b -= h[l];
                            for(o = 0, l = 0; l < f.channels_out; ++l)o += n[l];
                            if (o > F.MAX_BITS_PER_GRANULE) for(l = 0; l < f.channels_out; ++l)n[l] *= F.MAX_BITS_PER_GRANULE, n[l] /= o, n[l];
                            return p;
                        }, this.reduce_side = function(e, t, a, s) {
                            var n = .33 * (.5 - t) / .5;
                            n < 0 && (n = 0), n > .5 && (n = .5);
                            var r = 0 | .5 * n * (e[0] + e[1]);
                            r > F.MAX_BITS_PER_CHANNEL - e[0] && (r = F.MAX_BITS_PER_CHANNEL - e[0]), r < 0 && (r = 0), e[1] >= 125 && (e[1] - r > 125 ? (e[0] < a && (e[0] += r), e[1] -= r) : (e[0] += e[1] - 125, e[1] = 125)), (r = e[0] + e[1]) > s && (e[0] = s * e[0] / r, e[1] = s * e[1] / r);
                        }, this.athAdjust = function(e, t, a) {
                            var s = 90.30873362, n = l.FAST_LOG10_X(t, 10), r = e * e, _ = 0;
                            return n -= a, r > 1e-20 && (_ = 1 + l.FAST_LOG10_X(r, 10 / s)), _ < 0 && (_ = 0), n *= _, n += a + s - 94.82444863, Math.pow(10, .1 * n);
                        }, this.calc_xmin = function(e, t, a, s) {
                            var n, r = 0, _ = e.internal_flags, i = 0, o = 0, l = _.ATH, f = a.xr, c = e.VBR == h.vbr_mtrh ? 1 : 0, u = _.masking_lower;
                            for(e.VBR != h.vbr_mtrh && e.VBR != h.vbr_mt || (u = 1), n = 0; n < a.psy_lmax; n++){
                                M = (R = e.VBR == h.vbr_rh || e.VBR == h.vbr_mtrh ? athAdjust(l.adjust, l.l[n], l.floor) : l.adjust * l.l[n]) / (d = a.width[n]), A = 2220446049250313e-31, T = d >> 1, E = 0;
                                do E += k = f[i] * f[i], A += k < M ? k : M, E += y = f[++i] * f[i], A += y < M ? y : M, i++;
                                while (--T > 0);
                                E > R && o++, n == D.SBPSY_l && A < (w = R * _.nsPsy.longfact[n]) && (A = w), 0 != c && (R = A), e.ATHonly || (B = t.en.l[n]) > 0 && (w = E * t.thm.l[n] * u / B, 0 != c && (w *= _.nsPsy.longfact[n]), R < w && (R = w)), s[r++] = 0 != c ? R : R * _.nsPsy.longfact[n];
                            }
                            var b = 575;
                            if (a.block_type != D.SHORT_TYPE) for(var p = 576; 0 != p-- && g.EQ(f[p], 0);)b = p;
                            a.max_nonzero_coeff = b;
                            for(var m = a.sfb_smin; n < a.psymax; m++, n += 3){
                                var d, v, S;
                                for(S = e.VBR == h.vbr_rh || e.VBR == h.vbr_mtrh ? athAdjust(l.adjust, l.s[m], l.floor) : l.adjust * l.s[m], d = a.width[n], v = 0; v < 3; v++){
                                    var R, M, A, B, w, E = 0, T = d >> 1;
                                    M = S / d, A = 2220446049250313e-31;
                                    do {
                                        var k, y;
                                        E += k = f[i] * f[i], A += k < M ? k : M, E += y = f[++i] * f[i], A += y < M ? y : M, i++;
                                    }while (--T > 0);
                                    E > S && o++, m == D.SBPSY_s && A < (w = S * _.nsPsy.shortfact[m]) && (A = w), R = 0 != c ? A : S, e.ATHonly || e.ATHshort || (B = t.en.s[m][v]) > 0 && (w = E * t.thm.s[m][v] * u / B, 0 != c && (w *= _.nsPsy.shortfact[m]), R < w && (R = w)), s[r++] = 0 != c ? R : R * _.nsPsy.shortfact[m];
                                }
                                e.useTemporal && (s[r - 3] > s[r - 3 + 1] && (s[r - 3 + 1] += (s[r - 3] - s[r - 3 + 1]) * _.decay), s[r - 3 + 1] > s[r - 3 + 2] && (s[r - 3 + 2] += (s[r - 3 + 1] - s[r - 3 + 2]) * _.decay));
                            }
                            return o;
                        }, this.calc_noise_core = function(e, t, s, n) {
                            var r = 0, _ = t.s, i = e.l3_enc;
                            if (_ > e.count1) for(; 0 != s--;)l = e.xr[_], _++, r += l * l, l = e.xr[_], _++, r += l * l;
                            else if (_ > e.big_values) {
                                var o = a(2);
                                for(o[0] = 0, o[1] = n; 0 != s--;)l = Math.abs(e.xr[_]) - o[i[_]], _++, r += l * l, l = Math.abs(e.xr[_]) - o[i[_]], _++, r += l * l;
                            } else for(; 0 != s--;){
                                var l;
                                l = Math.abs(e.xr[_]) - p[i[_]] * n, _++, r += l * l, l = Math.abs(e.xr[_]) - p[i[_]] * n, _++, r += l * l;
                            }
                            return t.s = _, r;
                        }, this.calc_noise = function(e, t, a, s, n) {
                            var r, _, i = 0, o = 0, c = 0, h = 0, b = 0, p = -20, m = 0, d = e.scalefac, g = 0;
                            for(s.over_SSD = 0, r = 0; r < e.psymax; r++){
                                var S, R = e.global_gain - (d[g++] + (0 != e.preflag ? f[r] : 0) << e.scalefac_scale + 1) - 8 * e.subblock_gain[e.window[r]], M = 0;
                                if (null != n && n.step[r] == R) M = n.noise[r], m += e.width[r], a[i++] = M / t[o++], M = n.noise_log[r];
                                else {
                                    var A, B = u[R + P.Q_MAX2];
                                    _ = e.width[r] >> 1, m + e.width[r] > e.max_nonzero_coeff && (_ = (A = e.max_nonzero_coeff - m + 1) > 0 ? A >> 1 : 0);
                                    var w = new v(m);
                                    M = this.calc_noise_core(e, w, _, B), m = w.s, null != n && (n.step[r] = R, n.noise[r] = M), M = a[i++] = M / t[o++], M = l.FAST_LOG10(Math.max(M, 1e-20)), null != n && (n.noise_log[r] = M);
                                }
                                null != n && (n.global_gain = e.global_gain), b += M, M > 0 && (S = Math.max(0 | 10 * M + .5, 1), s.over_SSD += S * S, c++, h += M), p = Math.max(p, M);
                            }
                            return s.over_count = c, s.tot_noise = b, s.over_noise = h, s.max_noise = p, c;
                        }, this.set_pinfo = function(e, t, s, n, r) {
                            var _, i, o, l, c, h = e.internal_flags, u = 0 == t.scalefac_scale ? .5 : 1, b = t.scalefac, p = a(O.SFBMAX), m = a(O.SFBMAX), d = new w;
                            calc_xmin(e, s, t, p), calc_noise(t, p, m, d, null);
                            var v = 0;
                            for(i = t.sfb_lmax, t.block_type != D.SHORT_TYPE && 0 == t.mixed_block_flag && (i = 22), _ = 0; _ < i; _++){
                                var g = h.scalefac_band.l[_], S = (R = h.scalefac_band.l[_ + 1]) - g;
                                for(l = 0; v < R; v++)l += t.xr[v] * t.xr[v];
                                l /= S, c = 1e15, h.pinfo.en[n][r][_] = c * l, h.pinfo.xfsf[n][r][_] = c * p[_] * m[_] / S, s.en.l[_] > 0 && !e.ATHonly ? l /= s.en.l[_] : l = 0, h.pinfo.thr[n][r][_] = c * Math.max(l * s.thm.l[_], h.ATH.l[_]), h.pinfo.LAMEsfb[n][r][_] = 0, 0 != t.preflag && _ >= 11 && (h.pinfo.LAMEsfb[n][r][_] = -u * f[_]), _ < D.SBPSY_l && (h.pinfo.LAMEsfb[n][r][_] -= u * b[_]);
                            }
                            if (t.block_type == D.SHORT_TYPE) for(i = _, _ = t.sfb_smin; _ < D.SBMAX_s; _++){
                                g = h.scalefac_band.s[_], S = (R = h.scalefac_band.s[_ + 1]) - g;
                                for(var R, M = 0; M < 3; M++){
                                    for(l = 0, o = g; o < R; o++)l += t.xr[v] * t.xr[v], v++;
                                    l = Math.max(l / S, 1e-20), c = 1e15, h.pinfo.en_s[n][r][3 * _ + M] = c * l, h.pinfo.xfsf_s[n][r][3 * _ + M] = c * p[i] * m[i] / S, s.en.s[_][M] > 0 ? l /= s.en.s[_][M] : l = 0, (e.ATHonly || e.ATHshort) && (l = 0), h.pinfo.thr_s[n][r][3 * _ + M] = c * Math.max(l * s.thm.s[_][M], h.ATH.s[_]), h.pinfo.LAMEsfb_s[n][r][3 * _ + M] = -2 * t.subblock_gain[M], _ < D.SBPSY_s && (h.pinfo.LAMEsfb_s[n][r][3 * _ + M] -= u * b[i]), i++;
                                }
                            }
                            h.pinfo.LAMEqss[n][r] = t.global_gain, h.pinfo.LAMEmainbits[n][r] = t.part2_3_length + t.part2_length, h.pinfo.LAMEsfbits[n][r] = t.part2_length, h.pinfo.over[n][r] = d.over_count, h.pinfo.max_noise[n][r] = 10 * d.max_noise, h.pinfo.over_noise[n][r] = 10 * d.over_noise, h.pinfo.tot_noise[n][r] = 10 * d.tot_noise, h.pinfo.over_SSD[n][r] = d.over_SSD;
                        };
                    }
                    function I() {
                        this.global_gain = 0, this.sfb_count1 = 0, this.step = t(39), this.noise = a(39), this.noise_log = a(39);
                    }
                    function H() {
                        this.xr = a(576), this.l3_enc = t(576), this.scalefac = t(O.SFBMAX), this.xrpow_max = 0, this.part2_3_length = 0, this.big_values = 0, this.count1 = 0, this.global_gain = 0, this.scalefac_compress = 0, this.block_type = 0, this.mixed_block_flag = 0, this.table_select = t(3), this.subblock_gain = t(4), this.region0_count = 0, this.region1_count = 0, this.preflag = 0, this.scalefac_scale = 0, this.count1table_select = 0, this.part2_length = 0, this.sfb_lmax = 0, this.sfb_smin = 0, this.psy_lmax = 0, this.sfbmax = 0, this.psymax = 0, this.sfbdivide = 0, this.width = t(O.SFBMAX), this.window = t(O.SFBMAX), this.count1bits = 0, this.sfb_partition_table = null, this.slen = t(4), this.max_nonzero_coeff = 0;
                        var e = this;
                        function s(e) {
                            return new Int32Array(e);
                        }
                        this.assign = function(t) {
                            var a;
                            e.xr = (a = t.xr, new Float32Array(a)), e.l3_enc = s(t.l3_enc), e.scalefac = s(t.scalefac), e.xrpow_max = t.xrpow_max, e.part2_3_length = t.part2_3_length, e.big_values = t.big_values, e.count1 = t.count1, e.global_gain = t.global_gain, e.scalefac_compress = t.scalefac_compress, e.block_type = t.block_type, e.mixed_block_flag = t.mixed_block_flag, e.table_select = s(t.table_select), e.subblock_gain = s(t.subblock_gain), e.region0_count = t.region0_count, e.region1_count = t.region1_count, e.preflag = t.preflag, e.scalefac_scale = t.scalefac_scale, e.count1table_select = t.count1table_select, e.part2_length = t.part2_length, e.sfb_lmax = t.sfb_lmax, e.sfb_smin = t.sfb_smin, e.psy_lmax = t.psy_lmax, e.sfbmax = t.sfbmax, e.psymax = t.psymax, e.sfbdivide = t.sfbdivide, e.width = s(t.width), e.window = s(t.window), e.count1bits = t.count1bits, e.sfb_partition_table = t.sfb_partition_table.slice(0), e.slen = s(t.slen), e.max_nonzero_coeff = t.max_nonzero_coeff;
                        };
                    }
                    M.t1HB = [
                        1,
                        1,
                        1,
                        0
                    ], M.t2HB = [
                        1,
                        2,
                        1,
                        3,
                        1,
                        1,
                        3,
                        2,
                        0
                    ], M.t3HB = [
                        3,
                        2,
                        1,
                        1,
                        1,
                        1,
                        3,
                        2,
                        0
                    ], M.t5HB = [
                        1,
                        2,
                        6,
                        5,
                        3,
                        1,
                        4,
                        4,
                        7,
                        5,
                        7,
                        1,
                        6,
                        1,
                        1,
                        0
                    ], M.t6HB = [
                        7,
                        3,
                        5,
                        1,
                        6,
                        2,
                        3,
                        2,
                        5,
                        4,
                        4,
                        1,
                        3,
                        3,
                        2,
                        0
                    ], M.t7HB = [
                        1,
                        2,
                        10,
                        19,
                        16,
                        10,
                        3,
                        3,
                        7,
                        10,
                        5,
                        3,
                        11,
                        4,
                        13,
                        17,
                        8,
                        4,
                        12,
                        11,
                        18,
                        15,
                        11,
                        2,
                        7,
                        6,
                        9,
                        14,
                        3,
                        1,
                        6,
                        4,
                        5,
                        3,
                        2,
                        0
                    ], M.t8HB = [
                        3,
                        4,
                        6,
                        18,
                        12,
                        5,
                        5,
                        1,
                        2,
                        16,
                        9,
                        3,
                        7,
                        3,
                        5,
                        14,
                        7,
                        3,
                        19,
                        17,
                        15,
                        13,
                        10,
                        4,
                        13,
                        5,
                        8,
                        11,
                        5,
                        1,
                        12,
                        4,
                        4,
                        1,
                        1,
                        0
                    ], M.t9HB = [
                        7,
                        5,
                        9,
                        14,
                        15,
                        7,
                        6,
                        4,
                        5,
                        5,
                        6,
                        7,
                        7,
                        6,
                        8,
                        8,
                        8,
                        5,
                        15,
                        6,
                        9,
                        10,
                        5,
                        1,
                        11,
                        7,
                        9,
                        6,
                        4,
                        1,
                        14,
                        4,
                        6,
                        2,
                        6,
                        0
                    ], M.t10HB = [
                        1,
                        2,
                        10,
                        23,
                        35,
                        30,
                        12,
                        17,
                        3,
                        3,
                        8,
                        12,
                        18,
                        21,
                        12,
                        7,
                        11,
                        9,
                        15,
                        21,
                        32,
                        40,
                        19,
                        6,
                        14,
                        13,
                        22,
                        34,
                        46,
                        23,
                        18,
                        7,
                        20,
                        19,
                        33,
                        47,
                        27,
                        22,
                        9,
                        3,
                        31,
                        22,
                        41,
                        26,
                        21,
                        20,
                        5,
                        3,
                        14,
                        13,
                        10,
                        11,
                        16,
                        6,
                        5,
                        1,
                        9,
                        8,
                        7,
                        8,
                        4,
                        4,
                        2,
                        0
                    ], M.t11HB = [
                        3,
                        4,
                        10,
                        24,
                        34,
                        33,
                        21,
                        15,
                        5,
                        3,
                        4,
                        10,
                        32,
                        17,
                        11,
                        10,
                        11,
                        7,
                        13,
                        18,
                        30,
                        31,
                        20,
                        5,
                        25,
                        11,
                        19,
                        59,
                        27,
                        18,
                        12,
                        5,
                        35,
                        33,
                        31,
                        58,
                        30,
                        16,
                        7,
                        5,
                        28,
                        26,
                        32,
                        19,
                        17,
                        15,
                        8,
                        14,
                        14,
                        12,
                        9,
                        13,
                        14,
                        9,
                        4,
                        1,
                        11,
                        4,
                        6,
                        6,
                        6,
                        3,
                        2,
                        0
                    ], M.t12HB = [
                        9,
                        6,
                        16,
                        33,
                        41,
                        39,
                        38,
                        26,
                        7,
                        5,
                        6,
                        9,
                        23,
                        16,
                        26,
                        11,
                        17,
                        7,
                        11,
                        14,
                        21,
                        30,
                        10,
                        7,
                        17,
                        10,
                        15,
                        12,
                        18,
                        28,
                        14,
                        5,
                        32,
                        13,
                        22,
                        19,
                        18,
                        16,
                        9,
                        5,
                        40,
                        17,
                        31,
                        29,
                        17,
                        13,
                        4,
                        2,
                        27,
                        12,
                        11,
                        15,
                        10,
                        7,
                        4,
                        1,
                        27,
                        12,
                        8,
                        12,
                        6,
                        3,
                        1,
                        0
                    ], M.t13HB = [
                        1,
                        5,
                        14,
                        21,
                        34,
                        51,
                        46,
                        71,
                        42,
                        52,
                        68,
                        52,
                        67,
                        44,
                        43,
                        19,
                        3,
                        4,
                        12,
                        19,
                        31,
                        26,
                        44,
                        33,
                        31,
                        24,
                        32,
                        24,
                        31,
                        35,
                        22,
                        14,
                        15,
                        13,
                        23,
                        36,
                        59,
                        49,
                        77,
                        65,
                        29,
                        40,
                        30,
                        40,
                        27,
                        33,
                        42,
                        16,
                        22,
                        20,
                        37,
                        61,
                        56,
                        79,
                        73,
                        64,
                        43,
                        76,
                        56,
                        37,
                        26,
                        31,
                        25,
                        14,
                        35,
                        16,
                        60,
                        57,
                        97,
                        75,
                        114,
                        91,
                        54,
                        73,
                        55,
                        41,
                        48,
                        53,
                        23,
                        24,
                        58,
                        27,
                        50,
                        96,
                        76,
                        70,
                        93,
                        84,
                        77,
                        58,
                        79,
                        29,
                        74,
                        49,
                        41,
                        17,
                        47,
                        45,
                        78,
                        74,
                        115,
                        94,
                        90,
                        79,
                        69,
                        83,
                        71,
                        50,
                        59,
                        38,
                        36,
                        15,
                        72,
                        34,
                        56,
                        95,
                        92,
                        85,
                        91,
                        90,
                        86,
                        73,
                        77,
                        65,
                        51,
                        44,
                        43,
                        42,
                        43,
                        20,
                        30,
                        44,
                        55,
                        78,
                        72,
                        87,
                        78,
                        61,
                        46,
                        54,
                        37,
                        30,
                        20,
                        16,
                        53,
                        25,
                        41,
                        37,
                        44,
                        59,
                        54,
                        81,
                        66,
                        76,
                        57,
                        54,
                        37,
                        18,
                        39,
                        11,
                        35,
                        33,
                        31,
                        57,
                        42,
                        82,
                        72,
                        80,
                        47,
                        58,
                        55,
                        21,
                        22,
                        26,
                        38,
                        22,
                        53,
                        25,
                        23,
                        38,
                        70,
                        60,
                        51,
                        36,
                        55,
                        26,
                        34,
                        23,
                        27,
                        14,
                        9,
                        7,
                        34,
                        32,
                        28,
                        39,
                        49,
                        75,
                        30,
                        52,
                        48,
                        40,
                        52,
                        28,
                        18,
                        17,
                        9,
                        5,
                        45,
                        21,
                        34,
                        64,
                        56,
                        50,
                        49,
                        45,
                        31,
                        19,
                        12,
                        15,
                        10,
                        7,
                        6,
                        3,
                        48,
                        23,
                        20,
                        39,
                        36,
                        35,
                        53,
                        21,
                        16,
                        23,
                        13,
                        10,
                        6,
                        1,
                        4,
                        2,
                        16,
                        15,
                        17,
                        27,
                        25,
                        20,
                        29,
                        11,
                        17,
                        12,
                        16,
                        8,
                        1,
                        1,
                        0,
                        1
                    ], M.t15HB = [
                        7,
                        12,
                        18,
                        53,
                        47,
                        76,
                        124,
                        108,
                        89,
                        123,
                        108,
                        119,
                        107,
                        81,
                        122,
                        63,
                        13,
                        5,
                        16,
                        27,
                        46,
                        36,
                        61,
                        51,
                        42,
                        70,
                        52,
                        83,
                        65,
                        41,
                        59,
                        36,
                        19,
                        17,
                        15,
                        24,
                        41,
                        34,
                        59,
                        48,
                        40,
                        64,
                        50,
                        78,
                        62,
                        80,
                        56,
                        33,
                        29,
                        28,
                        25,
                        43,
                        39,
                        63,
                        55,
                        93,
                        76,
                        59,
                        93,
                        72,
                        54,
                        75,
                        50,
                        29,
                        52,
                        22,
                        42,
                        40,
                        67,
                        57,
                        95,
                        79,
                        72,
                        57,
                        89,
                        69,
                        49,
                        66,
                        46,
                        27,
                        77,
                        37,
                        35,
                        66,
                        58,
                        52,
                        91,
                        74,
                        62,
                        48,
                        79,
                        63,
                        90,
                        62,
                        40,
                        38,
                        125,
                        32,
                        60,
                        56,
                        50,
                        92,
                        78,
                        65,
                        55,
                        87,
                        71,
                        51,
                        73,
                        51,
                        70,
                        30,
                        109,
                        53,
                        49,
                        94,
                        88,
                        75,
                        66,
                        122,
                        91,
                        73,
                        56,
                        42,
                        64,
                        44,
                        21,
                        25,
                        90,
                        43,
                        41,
                        77,
                        73,
                        63,
                        56,
                        92,
                        77,
                        66,
                        47,
                        67,
                        48,
                        53,
                        36,
                        20,
                        71,
                        34,
                        67,
                        60,
                        58,
                        49,
                        88,
                        76,
                        67,
                        106,
                        71,
                        54,
                        38,
                        39,
                        23,
                        15,
                        109,
                        53,
                        51,
                        47,
                        90,
                        82,
                        58,
                        57,
                        48,
                        72,
                        57,
                        41,
                        23,
                        27,
                        62,
                        9,
                        86,
                        42,
                        40,
                        37,
                        70,
                        64,
                        52,
                        43,
                        70,
                        55,
                        42,
                        25,
                        29,
                        18,
                        11,
                        11,
                        118,
                        68,
                        30,
                        55,
                        50,
                        46,
                        74,
                        65,
                        49,
                        39,
                        24,
                        16,
                        22,
                        13,
                        14,
                        7,
                        91,
                        44,
                        39,
                        38,
                        34,
                        63,
                        52,
                        45,
                        31,
                        52,
                        28,
                        19,
                        14,
                        8,
                        9,
                        3,
                        123,
                        60,
                        58,
                        53,
                        47,
                        43,
                        32,
                        22,
                        37,
                        24,
                        17,
                        12,
                        15,
                        10,
                        2,
                        1,
                        71,
                        37,
                        34,
                        30,
                        28,
                        20,
                        17,
                        26,
                        21,
                        16,
                        10,
                        6,
                        8,
                        6,
                        2,
                        0
                    ], M.t16HB = [
                        1,
                        5,
                        14,
                        44,
                        74,
                        63,
                        110,
                        93,
                        172,
                        149,
                        138,
                        242,
                        225,
                        195,
                        376,
                        17,
                        3,
                        4,
                        12,
                        20,
                        35,
                        62,
                        53,
                        47,
                        83,
                        75,
                        68,
                        119,
                        201,
                        107,
                        207,
                        9,
                        15,
                        13,
                        23,
                        38,
                        67,
                        58,
                        103,
                        90,
                        161,
                        72,
                        127,
                        117,
                        110,
                        209,
                        206,
                        16,
                        45,
                        21,
                        39,
                        69,
                        64,
                        114,
                        99,
                        87,
                        158,
                        140,
                        252,
                        212,
                        199,
                        387,
                        365,
                        26,
                        75,
                        36,
                        68,
                        65,
                        115,
                        101,
                        179,
                        164,
                        155,
                        264,
                        246,
                        226,
                        395,
                        382,
                        362,
                        9,
                        66,
                        30,
                        59,
                        56,
                        102,
                        185,
                        173,
                        265,
                        142,
                        253,
                        232,
                        400,
                        388,
                        378,
                        445,
                        16,
                        111,
                        54,
                        52,
                        100,
                        184,
                        178,
                        160,
                        133,
                        257,
                        244,
                        228,
                        217,
                        385,
                        366,
                        715,
                        10,
                        98,
                        48,
                        91,
                        88,
                        165,
                        157,
                        148,
                        261,
                        248,
                        407,
                        397,
                        372,
                        380,
                        889,
                        884,
                        8,
                        85,
                        84,
                        81,
                        159,
                        156,
                        143,
                        260,
                        249,
                        427,
                        401,
                        392,
                        383,
                        727,
                        713,
                        708,
                        7,
                        154,
                        76,
                        73,
                        141,
                        131,
                        256,
                        245,
                        426,
                        406,
                        394,
                        384,
                        735,
                        359,
                        710,
                        352,
                        11,
                        139,
                        129,
                        67,
                        125,
                        247,
                        233,
                        229,
                        219,
                        393,
                        743,
                        737,
                        720,
                        885,
                        882,
                        439,
                        4,
                        243,
                        120,
                        118,
                        115,
                        227,
                        223,
                        396,
                        746,
                        742,
                        736,
                        721,
                        712,
                        706,
                        223,
                        436,
                        6,
                        202,
                        224,
                        222,
                        218,
                        216,
                        389,
                        386,
                        381,
                        364,
                        888,
                        443,
                        707,
                        440,
                        437,
                        1728,
                        4,
                        747,
                        211,
                        210,
                        208,
                        370,
                        379,
                        734,
                        723,
                        714,
                        1735,
                        883,
                        877,
                        876,
                        3459,
                        865,
                        2,
                        377,
                        369,
                        102,
                        187,
                        726,
                        722,
                        358,
                        711,
                        709,
                        866,
                        1734,
                        871,
                        3458,
                        870,
                        434,
                        0,
                        12,
                        10,
                        7,
                        11,
                        10,
                        17,
                        11,
                        9,
                        13,
                        12,
                        10,
                        7,
                        5,
                        3,
                        1,
                        3
                    ], M.t24HB = [
                        15,
                        13,
                        46,
                        80,
                        146,
                        262,
                        248,
                        434,
                        426,
                        669,
                        653,
                        649,
                        621,
                        517,
                        1032,
                        88,
                        14,
                        12,
                        21,
                        38,
                        71,
                        130,
                        122,
                        216,
                        209,
                        198,
                        327,
                        345,
                        319,
                        297,
                        279,
                        42,
                        47,
                        22,
                        41,
                        74,
                        68,
                        128,
                        120,
                        221,
                        207,
                        194,
                        182,
                        340,
                        315,
                        295,
                        541,
                        18,
                        81,
                        39,
                        75,
                        70,
                        134,
                        125,
                        116,
                        220,
                        204,
                        190,
                        178,
                        325,
                        311,
                        293,
                        271,
                        16,
                        147,
                        72,
                        69,
                        135,
                        127,
                        118,
                        112,
                        210,
                        200,
                        188,
                        352,
                        323,
                        306,
                        285,
                        540,
                        14,
                        263,
                        66,
                        129,
                        126,
                        119,
                        114,
                        214,
                        202,
                        192,
                        180,
                        341,
                        317,
                        301,
                        281,
                        262,
                        12,
                        249,
                        123,
                        121,
                        117,
                        113,
                        215,
                        206,
                        195,
                        185,
                        347,
                        330,
                        308,
                        291,
                        272,
                        520,
                        10,
                        435,
                        115,
                        111,
                        109,
                        211,
                        203,
                        196,
                        187,
                        353,
                        332,
                        313,
                        298,
                        283,
                        531,
                        381,
                        17,
                        427,
                        212,
                        208,
                        205,
                        201,
                        193,
                        186,
                        177,
                        169,
                        320,
                        303,
                        286,
                        268,
                        514,
                        377,
                        16,
                        335,
                        199,
                        197,
                        191,
                        189,
                        181,
                        174,
                        333,
                        321,
                        305,
                        289,
                        275,
                        521,
                        379,
                        371,
                        11,
                        668,
                        184,
                        183,
                        179,
                        175,
                        344,
                        331,
                        314,
                        304,
                        290,
                        277,
                        530,
                        383,
                        373,
                        366,
                        10,
                        652,
                        346,
                        171,
                        168,
                        164,
                        318,
                        309,
                        299,
                        287,
                        276,
                        263,
                        513,
                        375,
                        368,
                        362,
                        6,
                        648,
                        322,
                        316,
                        312,
                        307,
                        302,
                        292,
                        284,
                        269,
                        261,
                        512,
                        376,
                        370,
                        364,
                        359,
                        4,
                        620,
                        300,
                        296,
                        294,
                        288,
                        282,
                        273,
                        266,
                        515,
                        380,
                        374,
                        369,
                        365,
                        361,
                        357,
                        2,
                        1033,
                        280,
                        278,
                        274,
                        267,
                        264,
                        259,
                        382,
                        378,
                        372,
                        367,
                        363,
                        360,
                        358,
                        356,
                        0,
                        43,
                        20,
                        19,
                        17,
                        15,
                        13,
                        11,
                        9,
                        7,
                        6,
                        4,
                        7,
                        5,
                        3,
                        1,
                        3
                    ], M.t32HB = [
                        1,
                        10,
                        8,
                        20,
                        12,
                        20,
                        16,
                        32,
                        14,
                        12,
                        24,
                        0,
                        28,
                        16,
                        24,
                        16
                    ], M.t33HB = [
                        15,
                        28,
                        26,
                        48,
                        22,
                        40,
                        36,
                        64,
                        14,
                        24,
                        20,
                        32,
                        12,
                        16,
                        8,
                        0
                    ], M.t1l = [
                        1,
                        4,
                        3,
                        5
                    ], M.t2l = [
                        1,
                        4,
                        7,
                        4,
                        5,
                        7,
                        6,
                        7,
                        8
                    ], M.t3l = [
                        2,
                        3,
                        7,
                        4,
                        4,
                        7,
                        6,
                        7,
                        8
                    ], M.t5l = [
                        1,
                        4,
                        7,
                        8,
                        4,
                        5,
                        8,
                        9,
                        7,
                        8,
                        9,
                        10,
                        8,
                        8,
                        9,
                        10
                    ], M.t6l = [
                        3,
                        4,
                        6,
                        8,
                        4,
                        4,
                        6,
                        7,
                        5,
                        6,
                        7,
                        8,
                        7,
                        7,
                        8,
                        9
                    ], M.t7l = [
                        1,
                        4,
                        7,
                        9,
                        9,
                        10,
                        4,
                        6,
                        8,
                        9,
                        9,
                        10,
                        7,
                        7,
                        9,
                        10,
                        10,
                        11,
                        8,
                        9,
                        10,
                        11,
                        11,
                        11,
                        8,
                        9,
                        10,
                        11,
                        11,
                        12,
                        9,
                        10,
                        11,
                        12,
                        12,
                        12
                    ], M.t8l = [
                        2,
                        4,
                        7,
                        9,
                        9,
                        10,
                        4,
                        4,
                        6,
                        10,
                        10,
                        10,
                        7,
                        6,
                        8,
                        10,
                        10,
                        11,
                        9,
                        10,
                        10,
                        11,
                        11,
                        12,
                        9,
                        9,
                        10,
                        11,
                        12,
                        12,
                        10,
                        10,
                        11,
                        11,
                        13,
                        13
                    ], M.t9l = [
                        3,
                        4,
                        6,
                        7,
                        9,
                        10,
                        4,
                        5,
                        6,
                        7,
                        8,
                        10,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        7,
                        7,
                        8,
                        9,
                        9,
                        10,
                        8,
                        8,
                        9,
                        9,
                        10,
                        11,
                        9,
                        9,
                        10,
                        10,
                        11,
                        11
                    ], M.t10l = [
                        1,
                        4,
                        7,
                        9,
                        10,
                        10,
                        10,
                        11,
                        4,
                        6,
                        8,
                        9,
                        10,
                        11,
                        10,
                        10,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        11,
                        11,
                        8,
                        9,
                        10,
                        11,
                        12,
                        12,
                        11,
                        12,
                        9,
                        10,
                        11,
                        12,
                        12,
                        12,
                        12,
                        12,
                        10,
                        11,
                        12,
                        12,
                        13,
                        13,
                        12,
                        13,
                        9,
                        10,
                        11,
                        12,
                        12,
                        12,
                        13,
                        13,
                        10,
                        10,
                        11,
                        12,
                        12,
                        13,
                        13,
                        13
                    ], M.t11l = [
                        2,
                        4,
                        6,
                        8,
                        9,
                        10,
                        9,
                        10,
                        4,
                        5,
                        6,
                        8,
                        10,
                        10,
                        9,
                        10,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        10,
                        10,
                        8,
                        8,
                        9,
                        11,
                        10,
                        12,
                        10,
                        11,
                        9,
                        10,
                        10,
                        11,
                        11,
                        12,
                        11,
                        12,
                        9,
                        10,
                        11,
                        12,
                        12,
                        13,
                        12,
                        13,
                        9,
                        9,
                        9,
                        10,
                        11,
                        12,
                        12,
                        12,
                        9,
                        9,
                        10,
                        11,
                        12,
                        12,
                        12,
                        12
                    ], M.t12l = [
                        4,
                        4,
                        6,
                        8,
                        9,
                        10,
                        10,
                        10,
                        4,
                        5,
                        6,
                        7,
                        9,
                        9,
                        10,
                        10,
                        6,
                        6,
                        7,
                        8,
                        9,
                        10,
                        9,
                        10,
                        7,
                        7,
                        8,
                        8,
                        9,
                        10,
                        10,
                        10,
                        8,
                        8,
                        9,
                        9,
                        10,
                        10,
                        10,
                        11,
                        9,
                        9,
                        10,
                        10,
                        10,
                        11,
                        10,
                        11,
                        9,
                        9,
                        9,
                        10,
                        10,
                        11,
                        11,
                        12,
                        10,
                        10,
                        10,
                        11,
                        11,
                        11,
                        11,
                        12
                    ], M.t13l = [
                        1,
                        5,
                        7,
                        8,
                        9,
                        10,
                        10,
                        11,
                        10,
                        11,
                        12,
                        12,
                        13,
                        13,
                        14,
                        14,
                        4,
                        6,
                        8,
                        9,
                        10,
                        10,
                        11,
                        11,
                        11,
                        11,
                        12,
                        12,
                        13,
                        14,
                        14,
                        14,
                        7,
                        8,
                        9,
                        10,
                        11,
                        11,
                        12,
                        12,
                        11,
                        12,
                        12,
                        13,
                        13,
                        14,
                        15,
                        15,
                        8,
                        9,
                        10,
                        11,
                        11,
                        12,
                        12,
                        12,
                        12,
                        13,
                        13,
                        13,
                        13,
                        14,
                        15,
                        15,
                        9,
                        9,
                        11,
                        11,
                        12,
                        12,
                        13,
                        13,
                        12,
                        13,
                        13,
                        14,
                        14,
                        15,
                        15,
                        16,
                        10,
                        10,
                        11,
                        12,
                        12,
                        12,
                        13,
                        13,
                        13,
                        13,
                        14,
                        13,
                        15,
                        15,
                        16,
                        16,
                        10,
                        11,
                        12,
                        12,
                        13,
                        13,
                        13,
                        13,
                        13,
                        14,
                        14,
                        14,
                        15,
                        15,
                        16,
                        16,
                        11,
                        11,
                        12,
                        13,
                        13,
                        13,
                        14,
                        14,
                        14,
                        14,
                        15,
                        15,
                        15,
                        16,
                        18,
                        18,
                        10,
                        10,
                        11,
                        12,
                        12,
                        13,
                        13,
                        14,
                        14,
                        14,
                        14,
                        15,
                        15,
                        16,
                        17,
                        17,
                        11,
                        11,
                        12,
                        12,
                        13,
                        13,
                        13,
                        15,
                        14,
                        15,
                        15,
                        16,
                        16,
                        16,
                        18,
                        17,
                        11,
                        12,
                        12,
                        13,
                        13,
                        14,
                        14,
                        15,
                        14,
                        15,
                        16,
                        15,
                        16,
                        17,
                        18,
                        19,
                        12,
                        12,
                        12,
                        13,
                        14,
                        14,
                        14,
                        14,
                        15,
                        15,
                        15,
                        16,
                        17,
                        17,
                        17,
                        18,
                        12,
                        13,
                        13,
                        14,
                        14,
                        15,
                        14,
                        15,
                        16,
                        16,
                        17,
                        17,
                        17,
                        18,
                        18,
                        18,
                        13,
                        13,
                        14,
                        15,
                        15,
                        15,
                        16,
                        16,
                        16,
                        16,
                        16,
                        17,
                        18,
                        17,
                        18,
                        18,
                        14,
                        14,
                        14,
                        15,
                        15,
                        15,
                        17,
                        16,
                        16,
                        19,
                        17,
                        17,
                        17,
                        19,
                        18,
                        18,
                        13,
                        14,
                        15,
                        16,
                        16,
                        16,
                        17,
                        16,
                        17,
                        17,
                        18,
                        18,
                        21,
                        20,
                        21,
                        18
                    ], M.t15l = [
                        3,
                        5,
                        6,
                        8,
                        8,
                        9,
                        10,
                        10,
                        10,
                        11,
                        11,
                        12,
                        12,
                        12,
                        13,
                        14,
                        5,
                        5,
                        7,
                        8,
                        9,
                        9,
                        10,
                        10,
                        10,
                        11,
                        11,
                        12,
                        12,
                        12,
                        13,
                        13,
                        6,
                        7,
                        7,
                        8,
                        9,
                        9,
                        10,
                        10,
                        10,
                        11,
                        11,
                        12,
                        12,
                        13,
                        13,
                        13,
                        7,
                        8,
                        8,
                        9,
                        9,
                        10,
                        10,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        13,
                        13,
                        13,
                        8,
                        8,
                        9,
                        9,
                        10,
                        10,
                        11,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        13,
                        13,
                        13,
                        9,
                        9,
                        9,
                        10,
                        10,
                        10,
                        11,
                        11,
                        11,
                        11,
                        12,
                        12,
                        13,
                        13,
                        13,
                        14,
                        10,
                        9,
                        10,
                        10,
                        10,
                        11,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        13,
                        13,
                        14,
                        14,
                        10,
                        10,
                        10,
                        11,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        12,
                        12,
                        13,
                        13,
                        13,
                        14,
                        10,
                        10,
                        10,
                        11,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        12,
                        13,
                        13,
                        14,
                        14,
                        14,
                        10,
                        10,
                        11,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        13,
                        13,
                        13,
                        13,
                        14,
                        14,
                        14,
                        11,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        12,
                        12,
                        13,
                        13,
                        13,
                        13,
                        14,
                        15,
                        14,
                        11,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        12,
                        13,
                        13,
                        13,
                        13,
                        14,
                        14,
                        14,
                        15,
                        12,
                        12,
                        11,
                        12,
                        12,
                        12,
                        13,
                        13,
                        13,
                        13,
                        13,
                        13,
                        14,
                        14,
                        15,
                        15,
                        12,
                        12,
                        12,
                        12,
                        12,
                        13,
                        13,
                        13,
                        13,
                        14,
                        14,
                        14,
                        14,
                        14,
                        15,
                        15,
                        13,
                        13,
                        13,
                        13,
                        13,
                        13,
                        13,
                        13,
                        14,
                        14,
                        14,
                        14,
                        15,
                        15,
                        14,
                        15,
                        13,
                        13,
                        13,
                        13,
                        13,
                        13,
                        13,
                        14,
                        14,
                        14,
                        14,
                        14,
                        15,
                        15,
                        15,
                        15
                    ], M.t16_5l = [
                        1,
                        5,
                        7,
                        9,
                        10,
                        10,
                        11,
                        11,
                        12,
                        12,
                        12,
                        13,
                        13,
                        13,
                        14,
                        11,
                        4,
                        6,
                        8,
                        9,
                        10,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        13,
                        14,
                        13,
                        14,
                        11,
                        7,
                        8,
                        9,
                        10,
                        11,
                        11,
                        12,
                        12,
                        13,
                        12,
                        13,
                        13,
                        13,
                        14,
                        14,
                        12,
                        9,
                        9,
                        10,
                        11,
                        11,
                        12,
                        12,
                        12,
                        13,
                        13,
                        14,
                        14,
                        14,
                        15,
                        15,
                        13,
                        10,
                        10,
                        11,
                        11,
                        12,
                        12,
                        13,
                        13,
                        13,
                        14,
                        14,
                        14,
                        15,
                        15,
                        15,
                        12,
                        10,
                        10,
                        11,
                        11,
                        12,
                        13,
                        13,
                        14,
                        13,
                        14,
                        14,
                        15,
                        15,
                        15,
                        16,
                        13,
                        11,
                        11,
                        11,
                        12,
                        13,
                        13,
                        13,
                        13,
                        14,
                        14,
                        14,
                        14,
                        15,
                        15,
                        16,
                        13,
                        11,
                        11,
                        12,
                        12,
                        13,
                        13,
                        13,
                        14,
                        14,
                        15,
                        15,
                        15,
                        15,
                        17,
                        17,
                        13,
                        11,
                        12,
                        12,
                        13,
                        13,
                        13,
                        14,
                        14,
                        15,
                        15,
                        15,
                        15,
                        16,
                        16,
                        16,
                        13,
                        12,
                        12,
                        12,
                        13,
                        13,
                        14,
                        14,
                        15,
                        15,
                        15,
                        15,
                        16,
                        15,
                        16,
                        15,
                        14,
                        12,
                        13,
                        12,
                        13,
                        14,
                        14,
                        14,
                        14,
                        15,
                        16,
                        16,
                        16,
                        17,
                        17,
                        16,
                        13,
                        13,
                        13,
                        13,
                        13,
                        14,
                        14,
                        15,
                        16,
                        16,
                        16,
                        16,
                        16,
                        16,
                        15,
                        16,
                        14,
                        13,
                        14,
                        14,
                        14,
                        14,
                        15,
                        15,
                        15,
                        15,
                        17,
                        16,
                        16,
                        16,
                        16,
                        18,
                        14,
                        15,
                        14,
                        14,
                        14,
                        15,
                        15,
                        16,
                        16,
                        16,
                        18,
                        17,
                        17,
                        17,
                        19,
                        17,
                        14,
                        14,
                        15,
                        13,
                        14,
                        16,
                        16,
                        15,
                        16,
                        16,
                        17,
                        18,
                        17,
                        19,
                        17,
                        16,
                        14,
                        11,
                        11,
                        11,
                        12,
                        12,
                        13,
                        13,
                        13,
                        14,
                        14,
                        14,
                        14,
                        14,
                        14,
                        14,
                        12
                    ], M.t16l = [
                        1,
                        5,
                        7,
                        9,
                        10,
                        10,
                        11,
                        11,
                        12,
                        12,
                        12,
                        13,
                        13,
                        13,
                        14,
                        10,
                        4,
                        6,
                        8,
                        9,
                        10,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        13,
                        14,
                        13,
                        14,
                        10,
                        7,
                        8,
                        9,
                        10,
                        11,
                        11,
                        12,
                        12,
                        13,
                        12,
                        13,
                        13,
                        13,
                        14,
                        14,
                        11,
                        9,
                        9,
                        10,
                        11,
                        11,
                        12,
                        12,
                        12,
                        13,
                        13,
                        14,
                        14,
                        14,
                        15,
                        15,
                        12,
                        10,
                        10,
                        11,
                        11,
                        12,
                        12,
                        13,
                        13,
                        13,
                        14,
                        14,
                        14,
                        15,
                        15,
                        15,
                        11,
                        10,
                        10,
                        11,
                        11,
                        12,
                        13,
                        13,
                        14,
                        13,
                        14,
                        14,
                        15,
                        15,
                        15,
                        16,
                        12,
                        11,
                        11,
                        11,
                        12,
                        13,
                        13,
                        13,
                        13,
                        14,
                        14,
                        14,
                        14,
                        15,
                        15,
                        16,
                        12,
                        11,
                        11,
                        12,
                        12,
                        13,
                        13,
                        13,
                        14,
                        14,
                        15,
                        15,
                        15,
                        15,
                        17,
                        17,
                        12,
                        11,
                        12,
                        12,
                        13,
                        13,
                        13,
                        14,
                        14,
                        15,
                        15,
                        15,
                        15,
                        16,
                        16,
                        16,
                        12,
                        12,
                        12,
                        12,
                        13,
                        13,
                        14,
                        14,
                        15,
                        15,
                        15,
                        15,
                        16,
                        15,
                        16,
                        15,
                        13,
                        12,
                        13,
                        12,
                        13,
                        14,
                        14,
                        14,
                        14,
                        15,
                        16,
                        16,
                        16,
                        17,
                        17,
                        16,
                        12,
                        13,
                        13,
                        13,
                        13,
                        14,
                        14,
                        15,
                        16,
                        16,
                        16,
                        16,
                        16,
                        16,
                        15,
                        16,
                        13,
                        13,
                        14,
                        14,
                        14,
                        14,
                        15,
                        15,
                        15,
                        15,
                        17,
                        16,
                        16,
                        16,
                        16,
                        18,
                        13,
                        15,
                        14,
                        14,
                        14,
                        15,
                        15,
                        16,
                        16,
                        16,
                        18,
                        17,
                        17,
                        17,
                        19,
                        17,
                        13,
                        14,
                        15,
                        13,
                        14,
                        16,
                        16,
                        15,
                        16,
                        16,
                        17,
                        18,
                        17,
                        19,
                        17,
                        16,
                        13,
                        10,
                        10,
                        10,
                        11,
                        11,
                        12,
                        12,
                        12,
                        13,
                        13,
                        13,
                        13,
                        13,
                        13,
                        13,
                        10
                    ], M.t24l = [
                        4,
                        5,
                        7,
                        8,
                        9,
                        10,
                        10,
                        11,
                        11,
                        12,
                        12,
                        12,
                        12,
                        12,
                        13,
                        10,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        10,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        12,
                        12,
                        10,
                        7,
                        7,
                        8,
                        9,
                        9,
                        10,
                        10,
                        11,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        13,
                        9,
                        8,
                        8,
                        9,
                        9,
                        10,
                        10,
                        10,
                        11,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        12,
                        9,
                        9,
                        9,
                        9,
                        10,
                        10,
                        10,
                        10,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        12,
                        13,
                        9,
                        10,
                        9,
                        10,
                        10,
                        10,
                        10,
                        11,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        12,
                        12,
                        9,
                        10,
                        10,
                        10,
                        10,
                        10,
                        11,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        12,
                        12,
                        13,
                        9,
                        11,
                        10,
                        10,
                        10,
                        11,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        12,
                        12,
                        13,
                        13,
                        10,
                        11,
                        11,
                        11,
                        11,
                        11,
                        11,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        12,
                        13,
                        13,
                        10,
                        11,
                        11,
                        11,
                        11,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        12,
                        12,
                        13,
                        13,
                        13,
                        10,
                        12,
                        11,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        13,
                        13,
                        13,
                        13,
                        10,
                        12,
                        12,
                        11,
                        11,
                        11,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        13,
                        13,
                        13,
                        13,
                        10,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        13,
                        13,
                        13,
                        13,
                        13,
                        10,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        13,
                        13,
                        13,
                        13,
                        13,
                        13,
                        13,
                        10,
                        13,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        13,
                        13,
                        13,
                        13,
                        13,
                        13,
                        13,
                        13,
                        10,
                        9,
                        9,
                        9,
                        9,
                        9,
                        9,
                        9,
                        9,
                        9,
                        9,
                        9,
                        10,
                        10,
                        10,
                        10,
                        6
                    ], M.t32l = [
                        1,
                        5,
                        5,
                        7,
                        5,
                        8,
                        7,
                        9,
                        5,
                        7,
                        7,
                        9,
                        7,
                        9,
                        9,
                        10
                    ], M.t33l = [
                        4,
                        5,
                        5,
                        6,
                        5,
                        6,
                        6,
                        7,
                        5,
                        6,
                        6,
                        7,
                        6,
                        7,
                        7,
                        8
                    ], M.ht = [
                        new R(0, 0, null, null),
                        new R(2, 0, M.t1HB, M.t1l),
                        new R(3, 0, M.t2HB, M.t2l),
                        new R(3, 0, M.t3HB, M.t3l),
                        new R(0, 0, null, null),
                        new R(4, 0, M.t5HB, M.t5l),
                        new R(4, 0, M.t6HB, M.t6l),
                        new R(6, 0, M.t7HB, M.t7l),
                        new R(6, 0, M.t8HB, M.t8l),
                        new R(6, 0, M.t9HB, M.t9l),
                        new R(8, 0, M.t10HB, M.t10l),
                        new R(8, 0, M.t11HB, M.t11l),
                        new R(8, 0, M.t12HB, M.t12l),
                        new R(16, 0, M.t13HB, M.t13l),
                        new R(0, 0, null, M.t16_5l),
                        new R(16, 0, M.t15HB, M.t15l),
                        new R(1, 1, M.t16HB, M.t16l),
                        new R(2, 3, M.t16HB, M.t16l),
                        new R(3, 7, M.t16HB, M.t16l),
                        new R(4, 15, M.t16HB, M.t16l),
                        new R(6, 63, M.t16HB, M.t16l),
                        new R(8, 255, M.t16HB, M.t16l),
                        new R(10, 1023, M.t16HB, M.t16l),
                        new R(13, 8191, M.t16HB, M.t16l),
                        new R(4, 15, M.t24HB, M.t24l),
                        new R(5, 31, M.t24HB, M.t24l),
                        new R(6, 63, M.t24HB, M.t24l),
                        new R(7, 127, M.t24HB, M.t24l),
                        new R(8, 255, M.t24HB, M.t24l),
                        new R(9, 511, M.t24HB, M.t24l),
                        new R(11, 2047, M.t24HB, M.t24l),
                        new R(13, 8191, M.t24HB, M.t24l),
                        new R(0, 0, M.t32HB, M.t32l),
                        new R(0, 0, M.t33HB, M.t33l)
                    ], M.largetbl = [
                        65540,
                        327685,
                        458759,
                        589832,
                        655369,
                        655370,
                        720906,
                        720907,
                        786443,
                        786444,
                        786444,
                        851980,
                        851980,
                        851980,
                        917517,
                        655370,
                        262149,
                        393222,
                        524295,
                        589832,
                        655369,
                        720906,
                        720906,
                        720907,
                        786443,
                        786443,
                        786444,
                        851980,
                        917516,
                        851980,
                        917516,
                        655370,
                        458759,
                        524295,
                        589832,
                        655369,
                        720905,
                        720906,
                        786442,
                        786443,
                        851979,
                        786443,
                        851979,
                        851980,
                        851980,
                        917516,
                        917517,
                        720905,
                        589832,
                        589832,
                        655369,
                        720905,
                        720906,
                        786442,
                        786442,
                        786443,
                        851979,
                        851979,
                        917515,
                        917516,
                        917516,
                        983052,
                        983052,
                        786441,
                        655369,
                        655369,
                        720905,
                        720906,
                        786442,
                        786442,
                        851978,
                        851979,
                        851979,
                        917515,
                        917516,
                        917516,
                        983052,
                        983052,
                        983053,
                        720905,
                        655370,
                        655369,
                        720906,
                        720906,
                        786442,
                        851978,
                        851979,
                        917515,
                        851979,
                        917515,
                        917516,
                        983052,
                        983052,
                        983052,
                        1048588,
                        786441,
                        720906,
                        720906,
                        720906,
                        786442,
                        851978,
                        851979,
                        851979,
                        851979,
                        917515,
                        917516,
                        917516,
                        917516,
                        983052,
                        983052,
                        1048589,
                        786441,
                        720907,
                        720906,
                        786442,
                        786442,
                        851979,
                        851979,
                        851979,
                        917515,
                        917516,
                        983052,
                        983052,
                        983052,
                        983052,
                        1114125,
                        1114125,
                        786442,
                        720907,
                        786443,
                        786443,
                        851979,
                        851979,
                        851979,
                        917515,
                        917515,
                        983051,
                        983052,
                        983052,
                        983052,
                        1048588,
                        1048589,
                        1048589,
                        786442,
                        786443,
                        786443,
                        786443,
                        851979,
                        851979,
                        917515,
                        917515,
                        983052,
                        983052,
                        983052,
                        983052,
                        1048588,
                        983053,
                        1048589,
                        983053,
                        851978,
                        786444,
                        851979,
                        786443,
                        851979,
                        917515,
                        917516,
                        917516,
                        917516,
                        983052,
                        1048588,
                        1048588,
                        1048589,
                        1114125,
                        1114125,
                        1048589,
                        786442,
                        851980,
                        851980,
                        851979,
                        851979,
                        917515,
                        917516,
                        983052,
                        1048588,
                        1048588,
                        1048588,
                        1048588,
                        1048589,
                        1048589,
                        983053,
                        1048589,
                        851978,
                        851980,
                        917516,
                        917516,
                        917516,
                        917516,
                        983052,
                        983052,
                        983052,
                        983052,
                        1114124,
                        1048589,
                        1048589,
                        1048589,
                        1048589,
                        1179661,
                        851978,
                        983052,
                        917516,
                        917516,
                        917516,
                        983052,
                        983052,
                        1048588,
                        1048588,
                        1048589,
                        1179661,
                        1114125,
                        1114125,
                        1114125,
                        1245197,
                        1114125,
                        851978,
                        917517,
                        983052,
                        851980,
                        917516,
                        1048588,
                        1048588,
                        983052,
                        1048589,
                        1048589,
                        1114125,
                        1179661,
                        1114125,
                        1245197,
                        1114125,
                        1048589,
                        851978,
                        655369,
                        655369,
                        655369,
                        720905,
                        720905,
                        786441,
                        786441,
                        786441,
                        851977,
                        851977,
                        851977,
                        851978,
                        851978,
                        851978,
                        851978,
                        655366
                    ], M.table23 = [
                        65538,
                        262147,
                        458759,
                        262148,
                        327684,
                        458759,
                        393222,
                        458759,
                        524296
                    ], M.table56 = [
                        65539,
                        262148,
                        458758,
                        524296,
                        262148,
                        327684,
                        524294,
                        589831,
                        458757,
                        524294,
                        589831,
                        655368,
                        524295,
                        524295,
                        589832,
                        655369
                    ], M.bitrate_table = [
                        [
                            0,
                            8,
                            16,
                            24,
                            32,
                            40,
                            48,
                            56,
                            64,
                            80,
                            96,
                            112,
                            128,
                            144,
                            160,
                            -1
                        ],
                        [
                            0,
                            32,
                            40,
                            48,
                            56,
                            64,
                            80,
                            96,
                            112,
                            128,
                            160,
                            192,
                            224,
                            256,
                            320,
                            -1
                        ],
                        [
                            0,
                            8,
                            16,
                            24,
                            32,
                            40,
                            48,
                            56,
                            64,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1
                        ]
                    ], M.samplerate_table = [
                        [
                            22050,
                            24e3,
                            16e3,
                            -1
                        ],
                        [
                            44100,
                            48e3,
                            32e3,
                            -1
                        ],
                        [
                            11025,
                            12e3,
                            8e3,
                            -1
                        ]
                    ], M.scfsi_band = [
                        0,
                        6,
                        11,
                        16,
                        21
                    ], P.Q_MAX = 257, P.Q_MAX2 = 116, P.LARGE_BITS = 1e5, P.IXMAX_VAL = 8206;
                    var O = {};
                    function V() {
                        var e, t, s;
                        this.rv = null, this.qupvt = null;
                        var n, r = new B;
                        function _(e) {
                            this.ordinal = e;
                        }
                        function f(e) {
                            for(var t = 0; t < e.sfbmax; t++)if (e.scalefac[t] + e.subblock_gain[e.window[t]] == 0) return !1;
                            return !0;
                        }
                        function c(e, t, a, s, n) {
                            var r;
                            switch(e){
                                default:
                                case 9:
                                    t.over_count > 0 ? (r = a.over_SSD <= t.over_SSD, a.over_SSD == t.over_SSD && (r = a.bits < t.bits)) : r = a.max_noise < 0 && 10 * a.max_noise + a.bits <= 10 * t.max_noise + t.bits;
                                    break;
                                case 0:
                                    r = a.over_count < t.over_count || a.over_count == t.over_count && a.over_noise < t.over_noise || a.over_count == t.over_count && g.EQ(a.over_noise, t.over_noise) && a.tot_noise < t.tot_noise;
                                    break;
                                case 8:
                                    a.max_noise = function(e, t) {
                                        for(var a, s = 1e-37, n = 0; n < t.psymax; n++)s += (a = e[n], l.FAST_LOG10(.368 + .632 * a * a * a));
                                        return Math.max(1e-20, s);
                                    }(n, s);
                                case 1:
                                    r = a.max_noise < t.max_noise;
                                    break;
                                case 2:
                                    r = a.tot_noise < t.tot_noise;
                                    break;
                                case 3:
                                    r = a.tot_noise < t.tot_noise && a.max_noise < t.max_noise;
                                    break;
                                case 4:
                                    r = a.max_noise <= 0 && t.max_noise > .2 || a.max_noise <= 0 && t.max_noise < 0 && t.max_noise > a.max_noise - .2 && a.tot_noise < t.tot_noise || a.max_noise <= 0 && t.max_noise > 0 && t.max_noise > a.max_noise - .2 && a.tot_noise < t.tot_noise + t.over_noise || a.max_noise > 0 && t.max_noise > -0.05 && t.max_noise > a.max_noise - .1 && a.tot_noise + a.over_noise < t.tot_noise + t.over_noise || a.max_noise > 0 && t.max_noise > -0.1 && t.max_noise > a.max_noise - .15 && a.tot_noise + a.over_noise + a.over_noise < t.tot_noise + t.over_noise + t.over_noise;
                                    break;
                                case 5:
                                    r = a.over_noise < t.over_noise || g.EQ(a.over_noise, t.over_noise) && a.tot_noise < t.tot_noise;
                                    break;
                                case 6:
                                    r = a.over_noise < t.over_noise || g.EQ(a.over_noise, t.over_noise) && (a.max_noise < t.max_noise || g.EQ(a.max_noise, t.max_noise) && a.tot_noise <= t.tot_noise);
                                    break;
                                case 7:
                                    r = a.over_count < t.over_count || a.over_noise < t.over_noise;
                            }
                            return 0 == t.over_count && (r = r && a.bits < t.bits), r;
                        }
                        function u(e, t, a, r, _) {
                            var o = e.internal_flags;
                            !function(e, t, a, s, n) {
                                var r, _ = e.internal_flags;
                                r = 0 == t.scalefac_scale ? 1.2968395546510096 : 1.6817928305074292;
                                for(var i = 0, o = 0; o < t.sfbmax; o++)i < a[o] && (i = a[o]);
                                var l = _.noise_shaping_amp;
                                switch(3 == l && (l = n ? 2 : 1), l){
                                    case 2:
                                        break;
                                    case 1:
                                        i > 1 ? i = Math.pow(i, .5) : i *= .95;
                                        break;
                                    case 0:
                                    default:
                                        i > 1 ? i = 1 : i *= .95;
                                }
                                var f = 0;
                                for(o = 0; o < t.sfbmax; o++){
                                    var c, h = t.width[o];
                                    if (f += h, !(a[o] < i)) {
                                        if (0 != (2 & _.substep_shaping) && (_.pseudohalf[o] = 0 == _.pseudohalf[o] ? 1 : 0, 0 == _.pseudohalf[o] && 2 == _.noise_shaping_amp)) return;
                                        for(t.scalefac[o]++, c = -h; c < 0; c++)s[f + c] *= r, s[f + c] > t.xrpow_max && (t.xrpow_max = s[f + c]);
                                        if (2 == _.noise_shaping_amp) return;
                                    }
                                }
                            }(e, t, a, r, _);
                            var l = f(t);
                            return !(l || (l = 2 == o.mode_gr ? n.scale_bitcount(t) : n.scale_bitcount_lsf(o, t)) && (o.noise_shaping > 1 && (i.fill(o.pseudohalf, 0), 0 == t.scalefac_scale ? (function(e, t) {
                                for(var a = 0, n = 0; n < e.sfbmax; n++){
                                    var r = e.width[n], _ = e.scalefac[n];
                                    if (0 != e.preflag && (_ += s.pretab[n]), a += r, 0 != (1 & _)) {
                                        _++;
                                        for(var i = -r; i < 0; i++)t[a + i] *= 1.2968395546510096, t[a + i] > e.xrpow_max && (e.xrpow_max = t[a + i]);
                                    }
                                    e.scalefac[n] = _ >> 1;
                                }
                                e.preflag = 0, e.scalefac_scale = 1;
                            }(t, r), l = !1) : t.block_type == D.SHORT_TYPE && o.subblock_gain > 0 && (l = function(e, t, a) {
                                var n, r = t.scalefac;
                                for(n = 0; n < t.sfb_lmax; n++)if (r[n] >= 16) return !0;
                                for(var _ = 0; _ < 3; _++){
                                    var i = 0, o = 0;
                                    for(n = t.sfb_lmax + _; n < t.sfbdivide; n += 3)i < r[n] && (i = r[n]);
                                    for(; n < t.sfbmax; n += 3)o < r[n] && (o = r[n]);
                                    if (!(i < 16 && o < 8)) {
                                        if (t.subblock_gain[_] >= 7) return !0;
                                        t.subblock_gain[_]++;
                                        var l = e.scalefac_band.l[t.sfb_lmax];
                                        for(n = t.sfb_lmax + _; n < t.sfbmax; n += 3){
                                            var f = t.width[n], c = r[n];
                                            if ((c -= 4 >> t.scalefac_scale) >= 0) r[n] = c, l += 3 * f;
                                            else {
                                                r[n] = 0;
                                                var h = 210 + (c << t.scalefac_scale + 1);
                                                b = s.IPOW20(h), l += f * (_ + 1);
                                                for(var u = -f; u < 0; u++)a[l + u] *= b, a[l + u] > t.xrpow_max && (t.xrpow_max = a[l + u]);
                                                l += f * (3 - _ - 1);
                                            }
                                        }
                                        var b = s.IPOW20(202);
                                        for(l += t.width[n] * (_ + 1), u = -t.width[n]; u < 0; u++)a[l + u] *= b, a[l + u] > t.xrpow_max && (t.xrpow_max = a[l + u]);
                                    }
                                }
                                return !1;
                            }(o, t, r) || f(t))), l || (l = 2 == o.mode_gr ? n.scale_bitcount(t) : n.scale_bitcount_lsf(o, t)), l));
                        }
                        this.setModules = function(a, _, i, o) {
                            e = a, t = _, this.rv = _, s = i, this.qupvt = i, n = o, r.setModules(s, n);
                        }, this.ms_convert = function(e, t) {
                            for(var a = 0; a < 576; ++a){
                                var s = e.tt[t][0].xr[a], n = e.tt[t][1].xr[a];
                                e.tt[t][0].xr[a] = (s + n) * (.5 * l.SQRT2), e.tt[t][1].xr[a] = (s - n) * (.5 * l.SQRT2);
                            }
                        }, this.init_xrpow = function(e, t, a) {
                            var s = 0, n = 0 | t.max_nonzero_coeff;
                            if (t.xrpow_max = 0, i.fill(a, n, 576, 0), (s = function(e, t, a, s) {
                                s = 0;
                                for(var n = 0; n <= a; ++n){
                                    var r = Math.abs(e.xr[n]);
                                    s += r, t[n] = Math.sqrt(r * Math.sqrt(r)), t[n] > e.xrpow_max && (e.xrpow_max = t[n]);
                                }
                                return s;
                            }(t, a, n, s)) > 1e-20) {
                                var r = 0;
                                0 != (2 & e.substep_shaping) && (r = 1);
                                for(var _ = 0; _ < t.psymax; _++)e.pseudohalf[_] = r;
                                return !0;
                            }
                            return i.fill(t.l3_enc, 0, 576, 0), !1;
                        }, this.init_outer_loop = function(e, t) {
                            t.part2_3_length = 0, t.big_values = 0, t.count1 = 0, t.global_gain = 210, t.scalefac_compress = 0, t.table_select[0] = 0, t.table_select[1] = 0, t.table_select[2] = 0, t.subblock_gain[0] = 0, t.subblock_gain[1] = 0, t.subblock_gain[2] = 0, t.subblock_gain[3] = 0, t.region0_count = 0, t.region1_count = 0, t.preflag = 0, t.scalefac_scale = 0, t.count1table_select = 0, t.part2_length = 0, t.sfb_lmax = D.SBPSY_l, t.sfb_smin = D.SBPSY_s, t.psy_lmax = e.sfb21_extra ? D.SBMAX_l : D.SBPSY_l, t.psymax = t.psy_lmax, t.sfbmax = t.sfb_lmax, t.sfbdivide = 11;
                            for(var n = 0; n < D.SBMAX_l; n++)t.width[n] = e.scalefac_band.l[n + 1] - e.scalefac_band.l[n], t.window[n] = 3;
                            if (t.block_type == D.SHORT_TYPE) {
                                var r = a(576);
                                t.sfb_smin = 0, t.sfb_lmax = 0, 0 != t.mixed_block_flag && (t.sfb_smin = 3, t.sfb_lmax = 2 * e.mode_gr + 4), t.psymax = t.sfb_lmax + 3 * ((e.sfb21_extra ? D.SBMAX_s : D.SBPSY_s) - t.sfb_smin), t.sfbmax = t.sfb_lmax + 3 * (D.SBPSY_s - t.sfb_smin), t.sfbdivide = t.sfbmax - 18, t.psy_lmax = t.sfb_lmax;
                                var _ = e.scalefac_band.l[t.sfb_lmax];
                                for(o.arraycopy(t.xr, 0, r, 0, 576), n = t.sfb_smin; n < D.SBMAX_s; n++)for(var l = e.scalefac_band.s[n], f = e.scalefac_band.s[n + 1], c = 0; c < 3; c++)for(var h = l; h < f; h++)t.xr[_++] = r[3 * h + c];
                                var u = t.sfb_lmax;
                                for(n = t.sfb_smin; n < D.SBMAX_s; n++)t.width[u] = t.width[u + 1] = t.width[u + 2] = e.scalefac_band.s[n + 1] - e.scalefac_band.s[n], t.window[u] = 0, t.window[u + 1] = 1, t.window[u + 2] = 2, u += 3;
                            }
                            t.count1bits = 0, t.sfb_partition_table = s.nr_of_sfb_block[0][0], t.slen[0] = 0, t.slen[1] = 0, t.slen[2] = 0, t.slen[3] = 0, t.max_nonzero_coeff = 575, i.fill(t.scalefac, 0), function(e, t) {
                                var a = e.ATH, n = t.xr;
                                if (t.block_type != D.SHORT_TYPE) for(var r = !1, _ = D.PSFB21 - 1; _ >= 0 && !r; _--){
                                    var i = e.scalefac_band.psfb21[_], o = e.scalefac_band.psfb21[_ + 1], l = s.athAdjust(a.adjust, a.psfb21[_], a.floor);
                                    e.nsPsy.longfact[21] > 1e-12 && (l *= e.nsPsy.longfact[21]);
                                    for(var f = o - 1; f >= i; f--){
                                        if (!(Math.abs(n[f]) < l)) {
                                            r = !0;
                                            break;
                                        }
                                        n[f] = 0;
                                    }
                                }
                                else for(var c = 0; c < 3; c++)for(r = !1, _ = D.PSFB12 - 1; _ >= 0 && !r; _--){
                                    o = (i = 3 * e.scalefac_band.s[12] + (e.scalefac_band.s[13] - e.scalefac_band.s[12]) * c + (e.scalefac_band.psfb12[_] - e.scalefac_band.psfb12[0])) + (e.scalefac_band.psfb12[_ + 1] - e.scalefac_band.psfb12[_]);
                                    var h = s.athAdjust(a.adjust, a.psfb12[_], a.floor);
                                    for(e.nsPsy.shortfact[12] > 1e-12 && (h *= e.nsPsy.shortfact[12]), f = o - 1; f >= i; f--){
                                        if (!(Math.abs(n[f]) < h)) {
                                            r = !0;
                                            break;
                                        }
                                        n[f] = 0;
                                    }
                                }
                            }(e, t);
                        }, _.BINSEARCH_NONE = new _(0), _.BINSEARCH_UP = new _(1), _.BINSEARCH_DOWN = new _(2), this.trancate_smallspectrums = function(e, t, r, _) {
                            var o = a(O.SFBMAX);
                            if ((0 != (4 & e.substep_shaping) || t.block_type != D.SHORT_TYPE) && 0 == (128 & e.substep_shaping)) {
                                s.calc_noise(t, r, o, new w, null);
                                for(var l = 0; l < 576; l++){
                                    var f = 0;
                                    0 != t.l3_enc[l] && (f = Math.abs(t.xr[l])), _[l] = f;
                                }
                                l = 0;
                                var c = 8;
                                t.block_type == D.SHORT_TYPE && (c = 6);
                                do {
                                    var h, u, b, p, m = t.width[c];
                                    if (l += m, !(o[c] >= 1 || (i.sort(_, l - m, m), g.EQ(_[l - 1], 0)))) {
                                        h = (1 - o[c]) * r[c], u = 0, p = 0;
                                        do {
                                            var d;
                                            for(b = 1; p + b < m && !g.NEQ(_[p + l - m], _[p + l + b - m]); b++);
                                            if (h < (d = _[p + l - m] * _[p + l - m] * b)) {
                                                0 != p && (u = _[p + l - m - 1]);
                                                break;
                                            }
                                            h -= d, p += b;
                                        }while (p < m);
                                        if (!g.EQ(u, 0)) do Math.abs(t.xr[l - m]) <= u && (t.l3_enc[l - m] = 0);
                                        while (--m > 0);
                                    }
                                }while (++c < t.psymax);
                                t.part2_3_length = n.noquant_count_bits(e, t, null);
                            }
                        }, this.outer_loop = function(e, t, r, i, l, f) {
                            var b = e.internal_flags, p = new H, m = a(576), d = a(O.SFBMAX), v = new w, g = new I, S = 9999999, R = !1, M = !1, A = 0;
                            if (function(e, t, a, s, r) {
                                var i, o = e.CurrentStep[s], l = !1, f = e.OldValue[s], c = _.BINSEARCH_NONE;
                                for(t.global_gain = f, a -= t.part2_length;;){
                                    var h;
                                    if (i = n.count_bits(e, r, t, null), 1 == o || i == a) break;
                                    i > a ? (c == _.BINSEARCH_DOWN && (l = !0), l && (o /= 2), c = _.BINSEARCH_UP, h = o) : (c == _.BINSEARCH_UP && (l = !0), l && (o /= 2), c = _.BINSEARCH_DOWN, h = -o), t.global_gain += h, t.global_gain < 0 && (t.global_gain = 0, l = !0), t.global_gain > 255 && (t.global_gain = 255, l = !0);
                                }
                                for(; i > a && t.global_gain < 255;)t.global_gain++, i = n.count_bits(e, r, t, null);
                                e.CurrentStep[s] = f - t.global_gain >= 4 ? 4 : 2, e.OldValue[s] = t.global_gain, t.part2_3_length = i;
                            }(b, t, f, l, i), 0 == b.noise_shaping) return 100;
                            s.calc_noise(t, r, d, v, g), v.bits = t.part2_3_length, p.assign(t);
                            var B = 0;
                            for(o.arraycopy(i, 0, m, 0, 576); !R;){
                                do {
                                    var E, T = new w, k = 255;
                                    if (E = 0 != (2 & b.substep_shaping) ? 20 : 3, b.sfb21_extra) {
                                        if (d[p.sfbmax] > 1) break;
                                        if (p.block_type == D.SHORT_TYPE && (d[p.sfbmax + 1] > 1 || d[p.sfbmax + 2] > 1)) break;
                                    }
                                    if (!u(e, p, d, i, M)) break;
                                    0 != p.scalefac_scale && (k = 254);
                                    var y = f - p.part2_length;
                                    if (y <= 0) break;
                                    for(; (p.part2_3_length = n.count_bits(b, i, p, g)) > y && p.global_gain <= k;)p.global_gain++;
                                    if (p.global_gain > k) break;
                                    if (0 == v.over_count) {
                                        for(; (p.part2_3_length = n.count_bits(b, i, p, g)) > S && p.global_gain <= k;)p.global_gain++;
                                        if (p.global_gain > k) break;
                                    }
                                    if (s.calc_noise(p, r, d, T, g), T.bits = p.part2_3_length, 0 != (c(t.block_type != D.SHORT_TYPE ? e.quant_comp : e.quant_comp_short, v, T, p, d) ? 1 : 0)) S = t.part2_3_length, v = T, t.assign(p), B = 0, o.arraycopy(i, 0, m, 0, 576);
                                    else if (0 == b.full_outer_loop) {
                                        if (++B > E && 0 == v.over_count) break;
                                        if (3 == b.noise_shaping_amp && M && B > 30) break;
                                        if (3 == b.noise_shaping_amp && M && p.global_gain - A > 15) break;
                                    }
                                }while (p.global_gain + p.scalefac_scale < 255);
                                3 == b.noise_shaping_amp ? M ? R = !0 : (p.assign(t), o.arraycopy(m, 0, i, 0, 576), B = 0, A = p.global_gain, M = !0) : R = !0;
                            }
                            return e.VBR == h.vbr_rh || e.VBR == h.vbr_mtrh ? o.arraycopy(m, 0, i, 0, 576) : 0 != (1 & b.substep_shaping) && trancate_smallspectrums(b, t, r, i), v.over_count;
                        }, this.iteration_finish_one = function(e, a, s) {
                            var r = e.l3_side, _ = r.tt[a][s];
                            n.best_scalefac_store(e, a, s, r), 1 == e.use_best_huffman && n.best_huffman_divide(e, _), t.ResvAdjust(e, _);
                        }, this.VBR_encode_granule = function(e, t, s, n, r, _, l) {
                            var f, c = e.internal_flags, h = new H, u = a(576), b = l, p = l + 1, m = (l + _) / 2, d = 0, v = c.sfb21_extra;
                            i.fill(h.l3_enc, 0);
                            do c.sfb21_extra = !(m > b - 42) && v, outer_loop(e, t, s, n, r, m) <= 0 ? (d = 1, p = t.part2_3_length, h.assign(t), o.arraycopy(n, 0, u, 0, 576), f = (l = p - 32) - _, m = (l + _) / 2) : (f = l - (_ = m + 32), m = (l + _) / 2, 0 != d && (d = 2, t.assign(h), o.arraycopy(u, 0, n, 0, 576)));
                            while (f > 12);
                            c.sfb21_extra = v, 2 == d && o.arraycopy(h.l3_enc, 0, t.l3_enc, 0, 576);
                        }, this.get_framebits = function(a, s) {
                            var n = a.internal_flags;
                            n.bitrate_index = n.VBR_min_bitrate;
                            var r = e.getframebits(a);
                            n.bitrate_index = 1, r = e.getframebits(a);
                            for(var _ = 1; _ <= n.VBR_max_bitrate; _++){
                                n.bitrate_index = _;
                                var i = new A(r);
                                s[_] = t.ResvFrameBegin(a, i), r = i.bits;
                            }
                        }, this.VBR_old_prepare = function(e, a, n, r, _, i, o, l, f) {
                            var c, h = e.internal_flags, u = 0, b = 1, p = 0;
                            h.bitrate_index = h.VBR_max_bitrate;
                            var m = t.ResvFrameBegin(e, new A(0)) / h.mode_gr;
                            get_framebits(e, i);
                            for(var d = 0; d < h.mode_gr; d++){
                                var v = s.on_pe(e, a, l[d], m, d, 0);
                                h.mode_ext == D.MPG_MD_MS_LR && (ms_convert(h.l3_side, d), s.reduce_side(l[d], n[d], m, v));
                                for(var g = 0; g < h.channels_out; ++g){
                                    var S = h.l3_side.tt[d][g];
                                    S.block_type != D.SHORT_TYPE ? (u = 1.28 / (1 + Math.exp(3.5 - a[d][g] / 300)) - .05, c = h.PSY.mask_adjust - u) : (u = 2.56 / (1 + Math.exp(3.5 - a[d][g] / 300)) - .14, c = h.PSY.mask_adjust_short - u), h.masking_lower = Math.pow(10, .1 * c), init_outer_loop(h, S), f[d][g] = s.calc_xmin(e, r[d][g], S, _[d][g]), 0 != f[d][g] && (b = 0), o[d][g] = 126, p += l[d][g];
                                }
                            }
                            for(d = 0; d < h.mode_gr; d++)for(g = 0; g < h.channels_out; g++)p > i[h.VBR_max_bitrate] && (l[d][g] *= i[h.VBR_max_bitrate], l[d][g] /= p), o[d][g] > l[d][g] && (o[d][g] = l[d][g]);
                            return b;
                        }, this.bitpressure_strategy = function(e, t, a, s) {
                            for(var n = 0; n < e.mode_gr; n++)for(var r = 0; r < e.channels_out; r++){
                                for(var _ = e.l3_side.tt[n][r], i = t[n][r], o = 0, l = 0; l < _.psy_lmax; l++)i[o++] *= 1 + .029 * l * l / D.SBMAX_l / D.SBMAX_l;
                                if (_.block_type == D.SHORT_TYPE) for(l = _.sfb_smin; l < D.SBMAX_s; l++)i[o++] *= 1 + .029 * l * l / D.SBMAX_s / D.SBMAX_s, i[o++] *= 1 + .029 * l * l / D.SBMAX_s / D.SBMAX_s, i[o++] *= 1 + .029 * l * l / D.SBMAX_s / D.SBMAX_s;
                                s[n][r] = 0 | Math.max(a[n][r], .9 * s[n][r]);
                            }
                        }, this.VBR_new_prepare = function(e, a, n, r, _, i) {
                            var o, l = e.internal_flags, f = 1, c = 0, h = 0;
                            if (e.free_format) l.bitrate_index = 0, u = new A(c), o = t.ResvFrameBegin(e, u), c = u.bits, _[0] = o;
                            else {
                                l.bitrate_index = l.VBR_max_bitrate;
                                var u = new A(c);
                                t.ResvFrameBegin(e, u), c = u.bits, get_framebits(e, _), o = _[l.VBR_max_bitrate];
                            }
                            for(var b = 0; b < l.mode_gr; b++){
                                s.on_pe(e, a, i[b], c, b, 0), l.mode_ext == D.MPG_MD_MS_LR && ms_convert(l.l3_side, b);
                                for(var p = 0; p < l.channels_out; ++p){
                                    var m = l.l3_side.tt[b][p];
                                    l.masking_lower = Math.pow(10, .1 * l.PSY.mask_adjust), init_outer_loop(l, m), 0 != s.calc_xmin(e, n[b][p], m, r[b][p]) && (f = 0), h += i[b][p];
                                }
                            }
                            for(b = 0; b < l.mode_gr; b++)for(p = 0; p < l.channels_out; p++)h > o && (i[b][p] *= o, i[b][p] /= h);
                            return f;
                        }, this.calc_target_bits = function(a, n, r, _, i, o) {
                            var l, f, c, h, u = a.internal_flags, b = u.l3_side, p = 0;
                            u.bitrate_index = u.VBR_max_bitrate;
                            var m = new A(p);
                            for(o[0] = t.ResvFrameBegin(a, m), p = m.bits, u.bitrate_index = 1, p = e.getframebits(a) - 8 * u.sideinfo_len, i[0] = p / (u.mode_gr * u.channels_out), p = a.VBR_mean_bitrate_kbps * a.framesize * 1e3, 0 != (1 & u.substep_shaping) && (p *= 1.09), p /= a.out_samplerate, p -= 8 * u.sideinfo_len, p /= u.mode_gr * u.channels_out, (l = .93 + .07 * (11 - a.compression_ratio) / 5.5) < .9 && (l = .9), l > 1 && (l = 1), f = 0; f < u.mode_gr; f++){
                                var d = 0;
                                for(c = 0; c < u.channels_out; c++){
                                    if (_[f][c] = int(l * p), n[f][c] > 700) {
                                        var v = int((n[f][c] - 700) / 1.4), g = b.tt[f][c];
                                        _[f][c] = int(l * p), g.block_type == D.SHORT_TYPE && v < p / 2 && (v = p / 2), v > 3 * p / 2 ? v = 3 * p / 2 : v < 0 && (v = 0), _[f][c] += v;
                                    }
                                    _[f][c] > F.MAX_BITS_PER_CHANNEL && (_[f][c] = F.MAX_BITS_PER_CHANNEL), d += _[f][c];
                                }
                                if (d > F.MAX_BITS_PER_GRANULE) for(c = 0; c < u.channels_out; ++c)_[f][c] *= F.MAX_BITS_PER_GRANULE, _[f][c] /= d;
                            }
                            if (u.mode_ext == D.MPG_MD_MS_LR) for(f = 0; f < u.mode_gr; f++)s.reduce_side(_[f], r[f], p * u.channels_out, F.MAX_BITS_PER_GRANULE);
                            for(h = 0, f = 0; f < u.mode_gr; f++)for(c = 0; c < u.channels_out; c++)_[f][c] > F.MAX_BITS_PER_CHANNEL && (_[f][c] = F.MAX_BITS_PER_CHANNEL), h += _[f][c];
                            if (h > o[0]) for(f = 0; f < u.mode_gr; f++)for(c = 0; c < u.channels_out; c++)_[f][c] *= o[0], _[f][c] /= h;
                        };
                    }
                    function L() {
                        this.thm = new C, this.en = new C;
                    }
                    function N() {
                        var e = [
                            -0.1482523854003001,
                            32.308141959636465,
                            296.40344946382766,
                            883.1344870032432,
                            11113.947376231741,
                            1057.2713659324597,
                            305.7402417275812,
                            30.825928907280012,
                            3.8533188138216365,
                            59.42900443849514,
                            709.5899960123345,
                            5281.91112291017,
                            -5829.66483675846,
                            -817.6293103748613,
                            -76.91656988279972,
                            -4.594269939176596,
                            .9063471690191471,
                            .1960342806591213,
                            -0.15466694054279598,
                            34.324387823855965,
                            301.8067566458425,
                            817.599602898885,
                            11573.795901679885,
                            1181.2520595540152,
                            321.59731579894424,
                            31.232021761053772,
                            3.7107095756221318,
                            53.650946155329365,
                            684.167428119626,
                            5224.56624370173,
                            -6366.391851890084,
                            -908.9766368219582,
                            -89.83068876699639,
                            -5.411397422890401,
                            .8206787908286602,
                            .3901806440322567,
                            -0.16070888947830023,
                            36.147034243915876,
                            304.11815768187864,
                            732.7429163887613,
                            11989.60988270091,
                            1300.012278487897,
                            335.28490093152146,
                            31.48816102859945,
                            3.373875931311736,
                            47.232241542899175,
                            652.7371796173471,
                            5132.414255594984,
                            -6909.087078780055,
                            -1001.9990371107289,
                            -103.62185754286375,
                            -6.104916304710272,
                            .7416505462720353,
                            .5805693545089249,
                            -0.16636367662261495,
                            37.751650073343995,
                            303.01103387567713,
                            627.9747488785183,
                            12358.763425278165,
                            1412.2779918482834,
                            346.7496836825721,
                            31.598286663170416,
                            3.1598635433980946,
                            40.57878626349686,
                            616.1671130880391,
                            5007.833007176154,
                            -7454.040671756168,
                            -1095.7960341867115,
                            -118.24411666465777,
                            -6.818469345853504,
                            .6681786379192989,
                            .7653668647301797,
                            -0.1716176790982088,
                            39.11551877123304,
                            298.3413246578966,
                            503.5259106886539,
                            12679.589408408976,
                            1516.5821921214542,
                            355.9850766329023,
                            31.395241710249053,
                            2.9164211881972335,
                            33.79716964664243,
                            574.8943997801362,
                            4853.234992253242,
                            -7997.57021486075,
                            -1189.7624067269965,
                            -133.6444792601766,
                            -7.7202770609839915,
                            .5993769336819237,
                            .9427934736519954,
                            -0.17645823955292173,
                            40.21879108166477,
                            289.9982036694474,
                            359.3226160751053,
                            12950.259102786438,
                            1612.1013903507662,
                            362.85067106591504,
                            31.045922092242872,
                            2.822222032597987,
                            26.988862316190684,
                            529.8996541764288,
                            4671.371946949588,
                            -8535.899136645805,
                            -1282.5898586244496,
                            -149.58553632943463,
                            -8.643494270763135,
                            .5345111359507916,
                            1.111140466039205,
                            -0.36174739330527045,
                            41.04429910497807,
                            277.5463268268618,
                            195.6386023135583,
                            13169.43812144731,
                            1697.6433561479398,
                            367.40983966190305,
                            30.557037410382826,
                            2.531473372857427,
                            20.070154905927314,
                            481.50208566532336,
                            4464.970341588308,
                            -9065.36882077239,
                            -1373.62841526722,
                            -166.1660487028118,
                            -9.58289321133207,
                            .4729647758913199,
                            1.268786568327291,
                            -0.36970682634889585,
                            41.393213350082036,
                            261.2935935556502,
                            12.935476055240873,
                            13336.131683328815,
                            1772.508612059496,
                            369.76534388639965,
                            29.751323653701338,
                            2.4023193045459172,
                            13.304795348228817,
                            430.5615775526625,
                            4237.0568611071185,
                            -9581.931701634761,
                            -1461.6913552409758,
                            -183.12733958476446,
                            -10.718010163869403,
                            .41421356237309503,
                            1.414213562373095,
                            -0.37677560326535325,
                            41.619486213528496,
                            241.05423794991074,
                            -187.94665032361226,
                            13450.063605744153,
                            1836.153896465782,
                            369.4908799925761,
                            29.001847876923147,
                            2.0714759319987186,
                            6.779591200894186,
                            377.7767837205709,
                            3990.386575512536,
                            -10081.709459700915,
                            -1545.947424837898,
                            -200.3762958015653,
                            -11.864482073055006,
                            .3578057213145241,
                            1.546020906725474,
                            -0.3829366947518991,
                            41.1516456456653,
                            216.47684307105183,
                            -406.1569483347166,
                            13511.136535077321,
                            1887.8076599260432,
                            367.3025214564151,
                            28.136213436723654,
                            1.913880671464418,
                            .3829366947518991,
                            323.85365704338597,
                            3728.1472257487526,
                            -10561.233882199509,
                            -1625.2025997821418,
                            -217.62525175416,
                            -13.015432208941645,
                            .3033466836073424,
                            1.66293922460509,
                            -0.5822628872992417,
                            40.35639251440489,
                            188.20071124269245,
                            -640.2706748618148,
                            13519.21490106562,
                            1927.6022433578062,
                            362.8197642637487,
                            26.968821921868447,
                            1.7463817695935329,
                            -5.62650678237171,
                            269.3016715297017,
                            3453.386536448852,
                            -11016.145278780888,
                            -1698.6569643425091,
                            -234.7658734267683,
                            -14.16351421663124,
                            .2504869601913055,
                            1.76384252869671,
                            -0.5887180101749253,
                            39.23429103868072,
                            155.76096234403798,
                            -889.2492977967378,
                            13475.470561874661,
                            1955.0535223723712,
                            356.4450994756727,
                            25.894952980042156,
                            1.5695032905781554,
                            -11.181939564328772,
                            214.80884394039484,
                            3169.1640829158237,
                            -11443.321309975563,
                            -1765.1588461316153,
                            -251.68908574481912,
                            -15.49755935939164,
                            .198912367379658,
                            1.847759065022573,
                            -0.7912582233652842,
                            37.39369355329111,
                            119.699486012458,
                            -1151.0956593239027,
                            13380.446257078214,
                            1970.3952110853447,
                            348.01959814116185,
                            24.731487364283044,
                            1.3850130831637748,
                            -16.421408865300393,
                            161.05030052864092,
                            2878.3322807850063,
                            -11838.991423510031,
                            -1823.985884688674,
                            -268.2854986386903,
                            -16.81724543849939,
                            .1483359875383474,
                            1.913880671464418,
                            -0.7960642926861912,
                            35.2322109610459,
                            80.01928065061526,
                            -1424.0212633405113,
                            13235.794061869668,
                            1973.804052543835,
                            337.9908651258184,
                            23.289159354463873,
                            1.3934255946442087,
                            -21.099669467133474,
                            108.48348407242611,
                            2583.700758091299,
                            -12199.726194855148,
                            -1874.2780658979746,
                            -284.2467154529415,
                            -18.11369784385905,
                            .09849140335716425,
                            1.961570560806461,
                            -0.998795456205172,
                            32.56307803611191,
                            36.958364584370486,
                            -1706.075448829146,
                            13043.287458812016,
                            1965.3831106103316,
                            326.43182772364605,
                            22.175018750622293,
                            1.198638339011324,
                            -25.371248002043963,
                            57.53505923036915,
                            2288.41886619975,
                            -12522.674544337233,
                            -1914.8400385312243,
                            -299.26241273417224,
                            -19.37805630698734,
                            .04912684976946725,
                            1.990369453344394,
                            .035780907 * l.SQRT2 * .5 / 2384e-9,
                            .017876148 * l.SQRT2 * .5 / 2384e-9,
                            .003134727 * l.SQRT2 * .5 / 2384e-9,
                            .002457142 * l.SQRT2 * .5 / 2384e-9,
                            971317e-9 * l.SQRT2 * .5 / 2384e-9,
                            218868e-9 * l.SQRT2 * .5 / 2384e-9,
                            101566e-9 * l.SQRT2 * .5 / 2384e-9,
                            13828e-9 * l.SQRT2 * .5 / 2384e-9,
                            12804.797818791945,
                            1945.5515939597317,
                            313.4244966442953,
                            20.801593959731544,
                            1995.1556208053692,
                            9.000838926174497,
                            -29.20218120805369
                        ], t = [
                            [
                                2382191739347913e-28,
                                6423305872147834e-28,
                                9400849094049688e-28,
                                1122435026096556e-27,
                                1183840321267481e-27,
                                1122435026096556e-27,
                                940084909404969e-27,
                                6423305872147839e-28,
                                2382191739347918e-28,
                                5456116108943412e-27,
                                4878985199565852e-27,
                                4240448995017367e-27,
                                3559909094758252e-27,
                                2858043359288075e-27,
                                2156177623817898e-27,
                                1475637723558783e-27,
                                8371015190102974e-28,
                                2599706096327376e-28,
                                -0.000000000005456116108943412,
                                -0.000000000004878985199565852,
                                -0.000000000004240448995017367,
                                -0.000000000003559909094758252,
                                -0.000000000002858043359288076,
                                -0.000000000002156177623817898,
                                -0.000000000001475637723558783,
                                -0.0000000000008371015190102975,
                                -0.0000000000002599706096327376,
                                -0.0000000000002382191739347923,
                                -0.0000000000006423305872147843,
                                -0.0000000000009400849094049696,
                                -0.000000000001122435026096556,
                                -0.000000000001183840321267481,
                                -0.000000000001122435026096556,
                                -0.0000000000009400849094049694,
                                -0.000000000000642330587214784,
                                -0.0000000000002382191739347918
                            ],
                            [
                                2382191739347913e-28,
                                6423305872147834e-28,
                                9400849094049688e-28,
                                1122435026096556e-27,
                                1183840321267481e-27,
                                1122435026096556e-27,
                                9400849094049688e-28,
                                6423305872147841e-28,
                                2382191739347918e-28,
                                5456116108943413e-27,
                                4878985199565852e-27,
                                4240448995017367e-27,
                                3559909094758253e-27,
                                2858043359288075e-27,
                                2156177623817898e-27,
                                1475637723558782e-27,
                                8371015190102975e-28,
                                2599706096327376e-28,
                                -0.000000000005461314069809755,
                                -0.000000000004921085770524055,
                                -0.000000000004343405037091838,
                                -0.000000000003732668368707687,
                                -0.000000000003093523840190885,
                                -0.000000000002430835727329465,
                                -0.000000000001734679010007751,
                                -0.000000000000974825365660928,
                                -0.0000000000002797435120168326,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                -0.0000000000002283748241799531,
                                -0.0000000000004037858874020686,
                                -0.0000000000002146547464825323
                            ],
                            [
                                .1316524975873958,
                                .414213562373095,
                                .7673269879789602,
                                1.091308501069271,
                                1.303225372841206,
                                1.56968557711749,
                                1.920982126971166,
                                2.414213562373094,
                                3.171594802363212,
                                4.510708503662055,
                                7.595754112725146,
                                22.90376554843115,
                                .984807753012208,
                                .6427876096865394,
                                .3420201433256688,
                                .9396926207859084,
                                -0.1736481776669303,
                                -0.7660444431189779,
                                .8660254037844387,
                                .5,
                                -0.5144957554275265,
                                -0.4717319685649723,
                                -0.3133774542039019,
                                -0.1819131996109812,
                                -0.09457419252642064,
                                -0.04096558288530405,
                                -0.01419856857247115,
                                -0.003699974673760037,
                                .8574929257125442,
                                .8817419973177052,
                                .9496286491027329,
                                .9833145924917901,
                                .9955178160675857,
                                .9991605581781475,
                                .999899195244447,
                                .9999931550702802
                            ],
                            [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                2283748241799531e-28,
                                4037858874020686e-28,
                                2146547464825323e-28,
                                5461314069809755e-27,
                                4921085770524055e-27,
                                4343405037091838e-27,
                                3732668368707687e-27,
                                3093523840190885e-27,
                                2430835727329466e-27,
                                1734679010007751e-27,
                                974825365660928e-27,
                                2797435120168326e-28,
                                -0.000000000005456116108943413,
                                -0.000000000004878985199565852,
                                -0.000000000004240448995017367,
                                -0.000000000003559909094758253,
                                -0.000000000002858043359288075,
                                -0.000000000002156177623817898,
                                -0.000000000001475637723558782,
                                -0.0000000000008371015190102975,
                                -0.0000000000002599706096327376,
                                -0.0000000000002382191739347913,
                                -0.0000000000006423305872147834,
                                -0.0000000000009400849094049688,
                                -0.000000000001122435026096556,
                                -0.000000000001183840321267481,
                                -0.000000000001122435026096556,
                                -0.0000000000009400849094049688,
                                -0.0000000000006423305872147841,
                                -0.0000000000002382191739347918
                            ]
                        ], s = t[D.SHORT_TYPE], n = t[D.SHORT_TYPE], r = t[D.SHORT_TYPE], _ = t[D.SHORT_TYPE], f = [
                            0,
                            1,
                            16,
                            17,
                            8,
                            9,
                            24,
                            25,
                            4,
                            5,
                            20,
                            21,
                            12,
                            13,
                            28,
                            29,
                            2,
                            3,
                            18,
                            19,
                            10,
                            11,
                            26,
                            27,
                            6,
                            7,
                            22,
                            23,
                            14,
                            15,
                            30,
                            31
                        ];
                        function c(t, a, s) {
                            for(var n, r, _, i = 10, o = a + 238 - 14 - 286, f = -15; f < 0; f++){
                                var c, h, u;
                                c = e[i + -10], h = t[o + -224] * c, u = t[a + 224] * c, c = e[i + -9], h += t[o + -160] * c, u += t[a + 160] * c, c = e[i + -8], h += t[o + -96] * c, u += t[a + 96] * c, c = e[i + -7], h += t[o + -32] * c, u += t[a + 32] * c, c = e[i + -6], h += t[o + 32] * c, u += t[a + -32] * c, c = e[i + -5], h += t[o + 96] * c, u += t[a + -96] * c, c = e[i + -4], h += t[o + 160] * c, u += t[a + -160] * c, c = e[i + -3], h += t[o + 224] * c, u += t[a + -224] * c, c = e[i + -2], h += t[a + -256] * c, u -= t[o + 256] * c, c = e[i + -1], h += t[a + -192] * c, u -= t[o + 192] * c, c = e[i + 0], h += t[a + -128] * c, u -= t[o + 128] * c, c = e[i + 1], h += t[a + -64] * c, u -= t[o + 64] * c, c = e[i + 2], h += t[a + 0] * c, u -= t[o + 0] * c, c = e[i + 3], h += t[a + 64] * c, u -= t[o + -64] * c, c = e[i + 4], h += t[a + 128] * c, u -= t[o + -128] * c, c = e[i + 5], h += t[a + 192] * c, c = (u -= t[o + -192] * c) - (h *= e[i + 6]), s[30 + 2 * f] = u + h, s[31 + 2 * f] = e[i + 7] * c, i += 18, a--, o++;
                            }
                            u = t[a + -16] * e[i + -10], h = t[a + -32] * e[i + -2], u += (t[a + -48] - t[a + 16]) * e[i + -9], h += t[a + -96] * e[i + -1], u += (t[a + -80] + t[a + 48]) * e[i + -8], h += t[a + -160] * e[i + 0], u += (t[a + -112] - t[a + 80]) * e[i + -7], h += t[a + -224] * e[i + 1], u += (t[a + -144] + t[a + 112]) * e[i + -6], h -= t[a + 32] * e[i + 2], u += (t[a + -176] - t[a + 144]) * e[i + -5], h -= t[a + 96] * e[i + 3], u += (t[a + -208] + t[a + 176]) * e[i + -4], h -= t[a + 160] * e[i + 4], u += (t[a + -240] - t[a + 208]) * e[i + -3], n = (h -= t[a + 224]) - u, r = h + u, u = s[14], h = s[15] - u, s[31] = r + u, s[30] = n + h, s[15] = n - h, s[14] = r - u, _ = s[28] - s[0], s[0] += s[28], s[28] = _ * e[i + -36 + 7], _ = s[29] - s[1], s[1] += s[29], s[29] = _ * e[i + -36 + 7], _ = s[26] - s[2], s[2] += s[26], s[26] = _ * e[i + -72 + 7], _ = s[27] - s[3], s[3] += s[27], s[27] = _ * e[i + -72 + 7], _ = s[24] - s[4], s[4] += s[24], s[24] = _ * e[i + -108 + 7], _ = s[25] - s[5], s[5] += s[25], s[25] = _ * e[i + -108 + 7], _ = s[22] - s[6], s[6] += s[22], s[22] = _ * l.SQRT2, _ = s[23] - s[7], s[7] += s[23], s[23] = _ * l.SQRT2 - s[7], s[7] -= s[6], s[22] -= s[7], s[23] -= s[22], _ = s[6], s[6] = s[31] - _, s[31] = s[31] + _, _ = s[7], s[7] = s[30] - _, s[30] = s[30] + _, _ = s[22], s[22] = s[15] - _, s[15] = s[15] + _, _ = s[23], s[23] = s[14] - _, s[14] = s[14] + _, _ = s[20] - s[8], s[8] += s[20], s[20] = _ * e[i + -180 + 7], _ = s[21] - s[9], s[9] += s[21], s[21] = _ * e[i + -180 + 7], _ = s[18] - s[10], s[10] += s[18], s[18] = _ * e[i + -216 + 7], _ = s[19] - s[11], s[11] += s[19], s[19] = _ * e[i + -216 + 7], _ = s[16] - s[12], s[12] += s[16], s[16] = _ * e[i + -252 + 7], _ = s[17] - s[13], s[13] += s[17], s[17] = _ * e[i + -252 + 7], _ = -s[20] + s[24], s[20] += s[24], s[24] = _ * e[i + -216 + 7], _ = -s[21] + s[25], s[21] += s[25], s[25] = _ * e[i + -216 + 7], _ = s[4] - s[8], s[4] += s[8], s[8] = _ * e[i + -216 + 7], _ = s[5] - s[9], s[5] += s[9], s[9] = _ * e[i + -216 + 7], _ = s[0] - s[12], s[0] += s[12], s[12] = _ * e[i + -72 + 7], _ = s[1] - s[13], s[1] += s[13], s[13] = _ * e[i + -72 + 7], _ = s[16] - s[28], s[16] += s[28], s[28] = _ * e[i + -72 + 7], _ = -s[17] + s[29], s[17] += s[29], s[29] = _ * e[i + -72 + 7], _ = l.SQRT2 * (s[2] - s[10]), s[2] += s[10], s[10] = _, _ = l.SQRT2 * (s[3] - s[11]), s[3] += s[11], s[11] = _, _ = l.SQRT2 * (-s[18] + s[26]), s[18] += s[26], s[26] = _ - s[18], _ = l.SQRT2 * (-s[19] + s[27]), s[19] += s[27], s[27] = _ - s[19], _ = s[2], s[19] -= s[3], s[3] -= _, s[2] = s[31] - _, s[31] += _, _ = s[3], s[11] -= s[19], s[18] -= _, s[3] = s[30] - _, s[30] += _, _ = s[18], s[27] -= s[11], s[19] -= _, s[18] = s[15] - _, s[15] += _, _ = s[19], s[10] -= _, s[19] = s[14] - _, s[14] += _, _ = s[10], s[11] -= _, s[10] = s[23] - _, s[23] += _, _ = s[11], s[26] -= _, s[11] = s[22] - _, s[22] += _, _ = s[26], s[27] -= _, s[26] = s[7] - _, s[7] += _, _ = s[27], s[27] = s[6] - _, s[6] += _, _ = l.SQRT2 * (s[0] - s[4]), s[0] += s[4], s[4] = _, _ = l.SQRT2 * (s[1] - s[5]), s[1] += s[5], s[5] = _, _ = l.SQRT2 * (s[16] - s[20]), s[16] += s[20], s[20] = _, _ = l.SQRT2 * (s[17] - s[21]), s[17] += s[21], s[21] = _, _ = -l.SQRT2 * (s[8] - s[12]), s[8] += s[12], s[12] = _ - s[8], _ = -l.SQRT2 * (s[9] - s[13]), s[9] += s[13], s[13] = _ - s[9], _ = -l.SQRT2 * (s[25] - s[29]), s[25] += s[29], s[29] = _ - s[25], _ = -l.SQRT2 * (s[24] + s[28]), s[24] -= s[28], s[28] = _ - s[24], _ = s[24] - s[16], s[24] = _, _ = s[20] - _, s[20] = _, _ = s[28] - _, s[28] = _, _ = s[25] - s[17], s[25] = _, _ = s[21] - _, s[21] = _, _ = s[29] - _, s[29] = _, _ = s[17] - s[1], s[17] = _, _ = s[9] - _, s[9] = _, _ = s[25] - _, s[25] = _, _ = s[5] - _, s[5] = _, _ = s[21] - _, s[21] = _, _ = s[13] - _, s[13] = _, _ = s[29] - _, s[29] = _, _ = s[1] - s[0], s[1] = _, _ = s[16] - _, s[16] = _, _ = s[17] - _, s[17] = _, _ = s[8] - _, s[8] = _, _ = s[9] - _, s[9] = _, _ = s[24] - _, s[24] = _, _ = s[25] - _, s[25] = _, _ = s[4] - _, s[4] = _, _ = s[5] - _, s[5] = _, _ = s[20] - _, s[20] = _, _ = s[21] - _, s[21] = _, _ = s[12] - _, s[12] = _, _ = s[13] - _, s[13] = _, _ = s[28] - _, s[28] = _, _ = s[29] - _, s[29] = _, _ = s[0], s[0] += s[31], s[31] -= _, _ = s[1], s[1] += s[30], s[30] -= _, _ = s[16], s[16] += s[15], s[15] -= _, _ = s[17], s[17] += s[14], s[14] -= _, _ = s[8], s[8] += s[23], s[23] -= _, _ = s[9], s[9] += s[22], s[22] -= _, _ = s[24], s[24] += s[7], s[7] -= _, _ = s[25], s[25] += s[6], s[6] -= _, _ = s[4], s[4] += s[27], s[27] -= _, _ = s[5], s[5] += s[26], s[26] -= _, _ = s[20], s[20] += s[11], s[11] -= _, _ = s[21], s[21] += s[10], s[10] -= _, _ = s[12], s[12] += s[19], s[19] -= _, _ = s[13], s[13] += s[18], s[18] -= _, _ = s[28], s[28] += s[3], s[3] -= _, _ = s[29], s[29] += s[2], s[2] -= _;
                        }
                        function h(e, a) {
                            for(var s = 0; s < 3; s++){
                                var n, r, _, i, o, l;
                                r = (i = e[a + 6] * t[D.SHORT_TYPE][0] - e[a + 15]) + (n = e[a + 0] * t[D.SHORT_TYPE][2] - e[a + 9]), _ = i - n, o = (i = e[a + 15] * t[D.SHORT_TYPE][0] + e[a + 6]) + (n = e[a + 9] * t[D.SHORT_TYPE][2] + e[a + 0]), l = -i + n, n = 2069978111953089e-26 * (e[a + 3] * t[D.SHORT_TYPE][1] - e[a + 12]), i = 2069978111953089e-26 * (e[a + 12] * t[D.SHORT_TYPE][1] + e[a + 3]), e[a + 0] = 190752519173728e-25 * r + n, e[a + 15] = 190752519173728e-25 * -o + i, _ = .8660254037844387 * _ * 1907525191737281e-26, o = .5 * o * 1907525191737281e-26 + i, e[a + 3] = _ - o, e[a + 6] = _ + o, r = .5 * r * 1907525191737281e-26 - n, l = .8660254037844387 * l * 1907525191737281e-26, e[a + 9] = r + l, e[a + 12] = r - l, a++;
                            }
                        }
                        this.mdct_sub48 = function(e, l, u) {
                            for(var b, p, m, d, v, g, S, R, M, A, B, w, E, T, k, y, x, P, I, H, O, V = l, L = 286, N = 0; N < e.channels_out; N++){
                                for(var X = 0; X < e.mode_gr; X++){
                                    for(var q, Y = e.l3_side.tt[X][N], C = Y.xr, F = 0, j = e.sb_sample[N][1 - X], G = 0, z = 0; z < 9; z++)for(c(V, L, j[G]), c(V, L + 32, j[G + 1]), G += 2, L += 64, q = 1; q < 32; q += 2)j[G - 1][q] *= -1;
                                    for(q = 0; q < 32; q++, F += 18){
                                        var K = Y.block_type, Z = e.sb_sample[N][X], Q = e.sb_sample[N][1 - X];
                                        if (0 != Y.mixed_block_flag && q < 2 && (K = 0), e.amp_filter[q] < 1e-12) i.fill(C, F + 0, F + 18, 0);
                                        else {
                                            if (e.amp_filter[q] < 1) for(z = 0; z < 18; z++)Q[z][f[q]] *= e.amp_filter[q];
                                            if (K == D.SHORT_TYPE) {
                                                for(z = -3; z < 0; z++){
                                                    var U = t[D.SHORT_TYPE][z + 3];
                                                    C[F + 3 * z + 9] = Z[9 + z][f[q]] * U - Z[8 - z][f[q]], C[F + 3 * z + 18] = Z[14 - z][f[q]] * U + Z[15 + z][f[q]], C[F + 3 * z + 10] = Z[15 + z][f[q]] * U - Z[14 - z][f[q]], C[F + 3 * z + 19] = Q[2 - z][f[q]] * U + Q[3 + z][f[q]], C[F + 3 * z + 11] = Q[3 + z][f[q]] * U - Q[2 - z][f[q]], C[F + 3 * z + 20] = Q[8 - z][f[q]] * U + Q[9 + z][f[q]];
                                                }
                                                h(C, F);
                                            } else {
                                                var W = a(18);
                                                for(z = -9; z < 0; z++){
                                                    var J, $;
                                                    J = t[K][z + 27] * Q[z + 9][f[q]] + t[K][z + 36] * Q[8 - z][f[q]], $ = t[K][z + 9] * Z[z + 9][f[q]] - t[K][z + 18] * Z[8 - z][f[q]], W[z + 9] = J - $ * s[3 + z + 9], W[z + 18] = J * s[3 + z + 9] + $;
                                                }
                                                b = C, p = F, d = void 0, v = void 0, B = void 0, I = void 0, g = (m = W)[17] - m[9], R = m[15] - m[11], M = m[14] - m[12], A = m[0] + m[8], B = m[1] + m[7], w = m[2] + m[6], E = m[3] + m[5], b[p + 17] = A + w - E - (B - m[4]), v = (A + w - E) * n[19] + (B - m[4]), d = (g - R - M) * n[18], b[p + 5] = d + v, b[p + 6] = d - v, S = (m[16] - m[10]) * n[18], B = B * n[19] + m[4], d = g * n[12] + S + R * n[13] + M * n[14], v = -A * n[16] + B - w * n[17] + E * n[15], b[p + 1] = d + v, b[p + 2] = d - v, d = g * n[13] - S - R * n[14] + M * n[12], v = -A * n[17] + B - w * n[15] + E * n[16], b[p + 9] = d + v, b[p + 10] = d - v, d = g * n[14] - S + R * n[12] - M * n[13], v = A * n[15] - B + w * n[16] - E * n[17], b[p + 13] = d + v, b[p + 14] = d - v, T = m[8] - m[0], y = m[6] - m[2], x = m[5] - m[3], P = m[17] + m[9], I = m[16] + m[10], H = m[15] + m[11], O = m[14] + m[12], b[p + 0] = P + H + O + (I + m[13]), d = (P + H + O) * n[19] - (I + m[13]), v = (T - y + x) * n[18], b[p + 11] = d + v, b[p + 12] = d - v, k = (m[7] - m[1]) * n[18], I = m[13] - I * n[19], d = P * n[15] - I + H * n[16] + O * n[17], v = T * n[14] + k + y * n[12] + x * n[13], b[p + 3] = d + v, b[p + 4] = d - v, d = -P * n[17] + I - H * n[15] - O * n[16], v = T * n[13] + k - y * n[14] - x * n[12], b[p + 7] = d + v, b[p + 8] = d - v, d = -P * n[16] + I - H * n[17] - O * n[15], v = T * n[12] - k + y * n[13] - x * n[14], b[p + 15] = d + v, b[p + 16] = d - v;
                                            }
                                        }
                                        if (K != D.SHORT_TYPE && 0 != q) for(z = 7; z >= 0; --z){
                                            var ee, te;
                                            ee = C[F + z] * r[20 + z] + C[F + -1 - z] * _[28 + z], te = C[F + z] * _[28 + z] - C[F + -1 - z] * r[20 + z], C[F + -1 - z] = ee, C[F + z] = te;
                                        }
                                    }
                                }
                                if (V = u, L = 286, 1 == e.mode_gr) for(var ae = 0; ae < 18; ae++)o.arraycopy(e.sb_sample[N][1][ae], 0, e.sb_sample[N][0][ae], 0, 32);
                            }
                        };
                    }
                    function D() {
                        var e = D.FFTOFFSET, n = D.MPG_MD_MS_LR, r = null;
                        this.psy = null;
                        var i = null, l = null, f = null;
                        this.setModules = function(e, t, a, s) {
                            r = e, this.psy = t, i = t, l = s, f = a;
                        };
                        var c = new N;
                        this.lame_encode_mp3_frame = function(b, p, m, d, v, g) {
                            var S, R = _([
                                2,
                                2
                            ]);
                            R[0][0] = new L, R[0][1] = new L, R[1][0] = new L, R[1][1] = new L;
                            var M, A = _([
                                2,
                                2
                            ]);
                            A[0][0] = new L, A[0][1] = new L, A[1][0] = new L, A[1][1] = new L;
                            var B, w, E, T = [
                                null,
                                null
                            ], k = b.internal_flags, y = s([
                                2,
                                4
                            ]), x = [
                                .5,
                                .5
                            ], P = [
                                [
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0
                                ]
                            ], I = [
                                [
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0
                                ]
                            ];
                            if (T[0] = p, T[1] = m, 0 == k.lame_encode_frame_init && function(e, t) {
                                var s, n, r = e.internal_flags;
                                if (0 == r.lame_encode_frame_init) {
                                    var _, i, o = a(2014), l = a(2014);
                                    for(r.lame_encode_frame_init = 1, _ = 0, i = 0; _ < 286 + 576 * (1 + r.mode_gr); ++_)_ < 576 * r.mode_gr ? (o[_] = 0, 2 == r.channels_out && (l[_] = 0)) : (o[_] = t[0][i], 2 == r.channels_out && (l[_] = t[1][i]), ++i);
                                    for(n = 0; n < r.mode_gr; n++)for(s = 0; s < r.channels_out; s++)r.l3_side.tt[n][s].block_type = D.SHORT_TYPE;
                                    c.mdct_sub48(r, o, l);
                                }
                            }(b, T), k.padding = 0, (k.slot_lag -= k.frac_SpF) < 0 && (k.slot_lag += b.out_samplerate, k.padding = 1), 0 != k.psymodel) {
                                var H = [
                                    null,
                                    null
                                ], O = 0, V = t(2);
                                for(E = 0; E < k.mode_gr; E++){
                                    for(w = 0; w < k.channels_out; w++)H[w] = T[w], O = 576 + 576 * E - D.FFTOFFSET;
                                    if (0 != (b.VBR == h.vbr_mtrh || b.VBR == h.vbr_mt ? i.L3psycho_anal_vbr(b, H, O, E, R, A, P[E], I[E], y[E], V) : i.L3psycho_anal_ns(b, H, O, E, R, A, P[E], I[E], y[E], V))) return -4;
                                    for(b.mode == u.JOINT_STEREO && (x[E] = y[E][2] + y[E][3], x[E] > 0 && (x[E] = y[E][3] / x[E])), w = 0; w < k.channels_out; w++){
                                        var N = k.l3_side.tt[E][w];
                                        N.block_type = V[w], N.mixed_block_flag = 0;
                                    }
                                }
                            } else for(E = 0; E < k.mode_gr; E++)for(w = 0; w < k.channels_out; w++)k.l3_side.tt[E][w].block_type = D.NORM_TYPE, k.l3_side.tt[E][w].mixed_block_flag = 0, I[E][w] = P[E][w] = 700;
                            if (function(e) {
                                var t, a;
                                if (0 != e.ATH.useAdjust) {
                                    if (a = e.loudness_sq[0][0], t = e.loudness_sq[1][0], 2 == e.channels_out ? (a += e.loudness_sq[0][1], t += e.loudness_sq[1][1]) : (a += a, t += t), 2 == e.mode_gr && (a = Math.max(a, t)), a *= .5, (a *= e.ATH.aaSensitivityP) > .03125) e.ATH.adjust >= 1 ? e.ATH.adjust = 1 : e.ATH.adjust < e.ATH.adjustLimit && (e.ATH.adjust = e.ATH.adjustLimit), e.ATH.adjustLimit = 1;
                                    else {
                                        var s = 31.98 * a + 625e-6;
                                        e.ATH.adjust >= s ? (e.ATH.adjust *= .075 * s + .925, e.ATH.adjust < s && (e.ATH.adjust = s)) : e.ATH.adjustLimit >= s ? e.ATH.adjust = s : e.ATH.adjust < e.ATH.adjustLimit && (e.ATH.adjust = e.ATH.adjustLimit), e.ATH.adjustLimit = s;
                                    }
                                } else e.ATH.adjust = 1;
                            }(k), c.mdct_sub48(k, T[0], T[1]), k.mode_ext = D.MPG_MD_LR_LR, b.force_ms) k.mode_ext = D.MPG_MD_MS_LR;
                            else if (b.mode == u.JOINT_STEREO) {
                                var X = 0, q = 0;
                                for(E = 0; E < k.mode_gr; E++)for(w = 0; w < k.channels_out; w++)X += I[E][w], q += P[E][w];
                                if (X <= 1 * q) {
                                    var Y = k.l3_side.tt[0], C = k.l3_side.tt[k.mode_gr - 1];
                                    Y[0].block_type == Y[1].block_type && C[0].block_type == C[1].block_type && (k.mode_ext = D.MPG_MD_MS_LR);
                                }
                            }
                            if (k.mode_ext == n ? (M = A, B = I) : (M = R, B = P), b.analysis && null != k.pinfo) for(E = 0; E < k.mode_gr; E++)for(w = 0; w < k.channels_out; w++)k.pinfo.ms_ratio[E] = k.ms_ratio[E], k.pinfo.ms_ener_ratio[E] = x[E], k.pinfo.blocktype[E][w] = k.l3_side.tt[E][w].block_type, k.pinfo.pe[E][w] = B[E][w], o.arraycopy(k.l3_side.tt[E][w].xr, 0, k.pinfo.xr[E][w], 0, 576), k.mode_ext == n && (k.pinfo.ers[E][w] = k.pinfo.ers[E][w + 2], o.arraycopy(k.pinfo.energy[E][w + 2], 0, k.pinfo.energy[E][w], 0, k.pinfo.energy[E][w].length));
                            if (b.VBR == h.vbr_off || b.VBR == h.vbr_abr) {
                                var F, j;
                                for(F = 0; F < 18; F++)k.nsPsy.pefirbuf[F] = k.nsPsy.pefirbuf[F + 1];
                                for(j = 0, E = 0; E < k.mode_gr; E++)for(w = 0; w < k.channels_out; w++)j += B[E][w];
                                for(k.nsPsy.pefirbuf[18] = j, j = k.nsPsy.pefirbuf[9], F = 0; F < 9; F++)j += (k.nsPsy.pefirbuf[F] + k.nsPsy.pefirbuf[18 - F]) * D.fircoef[F];
                                for(j = 3350 * k.mode_gr * k.channels_out / j, E = 0; E < k.mode_gr; E++)for(w = 0; w < k.channels_out; w++)B[E][w] *= j;
                            }
                            if (k.iteration_loop.iteration_loop(b, B, x, M), r.format_bitstream(b), S = r.copy_buffer(k, d, v, g, 1), b.bWriteVbrTag && l.addVbrFrame(b), b.analysis && null != k.pinfo) {
                                for(w = 0; w < k.channels_out; w++){
                                    var G;
                                    for(G = 0; G < e; G++)k.pinfo.pcmdata[w][G] = k.pinfo.pcmdata[w][G + b.framesize];
                                    for(G = e; G < 1600; G++)k.pinfo.pcmdata[w][G] = T[w][G - e];
                                }
                                f.set_frame_pinfo(b, M);
                            }
                            return function(e) {
                                var t, a;
                                for(e.bitrate_stereoMode_Hist[e.bitrate_index][4]++, e.bitrate_stereoMode_Hist[15][4]++, 2 == e.channels_out && (e.bitrate_stereoMode_Hist[e.bitrate_index][e.mode_ext]++, e.bitrate_stereoMode_Hist[15][e.mode_ext]++), t = 0; t < e.mode_gr; ++t)for(a = 0; a < e.channels_out; ++a){
                                    var s = 0 | e.l3_side.tt[t][a].block_type;
                                    0 != e.l3_side.tt[t][a].mixed_block_flag && (s = 4), e.bitrate_blockType_Hist[e.bitrate_index][s]++, e.bitrate_blockType_Hist[e.bitrate_index][5]++, e.bitrate_blockType_Hist[15][s]++, e.bitrate_blockType_Hist[15][5]++;
                                }
                            }(k), S;
                        };
                    }
                    function X() {
                        this.sum = 0, this.seen = 0, this.want = 0, this.pos = 0, this.size = 0, this.bag = null, this.nVbrNumFrames = 0, this.nBytesWritten = 0, this.TotalFrameSize = 0;
                    }
                    function q() {
                        this.tt = [
                            [
                                null,
                                null
                            ],
                            [
                                null,
                                null
                            ]
                        ], this.main_data_begin = 0, this.private_bits = 0, this.resvDrain_pre = 0, this.resvDrain_post = 0, this.scfsi = [
                            t(4),
                            t(4)
                        ];
                        for(var e = 0; e < 2; e++)for(var a = 0; a < 2; a++)this.tt[e][a] = new H;
                    }
                    function Y() {
                        this.last_en_subshort = s([
                            4,
                            9
                        ]), this.lastAttacks = t(4), this.pefirbuf = a(19), this.longfact = a(D.SBMAX_l), this.shortfact = a(D.SBMAX_s), this.attackthre = 0, this.attackthre_s = 0;
                    }
                    function C() {
                        this.l = a(D.SBMAX_l), this.s = s([
                            D.SBMAX_s,
                            3
                        ]);
                        var e = this;
                        this.assign = function(t) {
                            o.arraycopy(t.l, 0, e.l, 0, D.SBMAX_l);
                            for(var a = 0; a < D.SBMAX_s; a++)for(var s = 0; s < 3; s++)e.s[a][s] = t.s[a][s];
                        };
                    }
                    function F() {
                        function r() {
                            this.write_timing = 0, this.ptr = 0, this.buf = e(40);
                        }
                        this.Class_ID = 0, this.lame_encode_frame_init = 0, this.iteration_init_init = 0, this.fill_buffer_resample_init = 0, this.mfbuf = s([
                            2,
                            F.MFSIZE
                        ]), this.mode_gr = 0, this.channels_in = 0, this.channels_out = 0, this.resample_ratio = 0, this.mf_samples_to_encode = 0, this.mf_size = 0, this.VBR_min_bitrate = 0, this.VBR_max_bitrate = 0, this.bitrate_index = 0, this.samplerate_index = 0, this.mode_ext = 0, this.lowpass1 = 0, this.lowpass2 = 0, this.highpass1 = 0, this.highpass2 = 0, this.noise_shaping = 0, this.noise_shaping_amp = 0, this.substep_shaping = 0, this.psymodel = 0, this.noise_shaping_stop = 0, this.subblock_gain = 0, this.use_best_huffman = 0, this.full_outer_loop = 0, this.l3_side = new q, this.ms_ratio = a(2), this.padding = 0, this.frac_SpF = 0, this.slot_lag = 0, this.tag_spec = null, this.nMusicCRC = 0, this.OldValue = t(2), this.CurrentStep = t(2), this.masking_lower = 0, this.bv_scf = t(576), this.pseudohalf = t(O.SFBMAX), this.sfb21_extra = !1, this.inbuf_old = new Array(2), this.blackfilt = new Array(2 * F.BPC + 1), this.itime = new Float64Array(2), this.sideinfo_len = 0, this.sb_sample = s([
                            2,
                            2,
                            18,
                            D.SBLIMIT
                        ]), this.amp_filter = a(32), this.header = new Array(F.MAX_HEADER_BUF), this.h_ptr = 0, this.w_ptr = 0, this.ancillary_flag = 0, this.ResvSize = 0, this.ResvMax = 0, this.scalefac_band = new x, this.minval_l = a(D.CBANDS), this.minval_s = a(D.CBANDS), this.nb_1 = s([
                            4,
                            D.CBANDS
                        ]), this.nb_2 = s([
                            4,
                            D.CBANDS
                        ]), this.nb_s1 = s([
                            4,
                            D.CBANDS
                        ]), this.nb_s2 = s([
                            4,
                            D.CBANDS
                        ]), this.s3_ss = null, this.s3_ll = null, this.decay = 0, this.thm = new Array(4), this.en = new Array(4), this.tot_ener = a(4), this.loudness_sq = s([
                            2,
                            2
                        ]), this.loudness_sq_save = a(2), this.mld_l = a(D.SBMAX_l), this.mld_s = a(D.SBMAX_s), this.bm_l = t(D.SBMAX_l), this.bo_l = t(D.SBMAX_l), this.bm_s = t(D.SBMAX_s), this.bo_s = t(D.SBMAX_s), this.npart_l = 0, this.npart_s = 0, this.s3ind = n([
                            D.CBANDS,
                            2
                        ]), this.s3ind_s = n([
                            D.CBANDS,
                            2
                        ]), this.numlines_s = t(D.CBANDS), this.numlines_l = t(D.CBANDS), this.rnumlines_l = a(D.CBANDS), this.mld_cb_l = a(D.CBANDS), this.mld_cb_s = a(D.CBANDS), this.numlines_s_num1 = 0, this.numlines_l_num1 = 0, this.pe = a(4), this.ms_ratio_s_old = 0, this.ms_ratio_l_old = 0, this.ms_ener_ratio_old = 0, this.blocktype_old = t(2), this.nsPsy = new Y, this.VBR_seek_table = new X, this.ATH = null, this.PSY = null, this.nogap_total = 0, this.nogap_current = 0, this.decode_on_the_fly = !0, this.findReplayGain = !0, this.findPeakSample = !0, this.PeakSample = 0, this.RadioGain = 0, this.AudiophileGain = 0, this.rgdata = null, this.noclipGainChange = 0, this.noclipScale = 0, this.bitrate_stereoMode_Hist = n([
                            16,
                            5
                        ]), this.bitrate_blockType_Hist = n([
                            16,
                            6
                        ]), this.pinfo = null, this.hip = null, this.in_buffer_nsamples = 0, this.in_buffer_0 = null, this.in_buffer_1 = null, this.iteration_loop = null;
                        for(var _ = 0; _ < this.en.length; _++)this.en[_] = new C;
                        for(_ = 0; _ < this.thm.length; _++)this.thm[_] = new C;
                        for(_ = 0; _ < this.header.length; _++)this.header[_] = new r;
                    }
                    function j() {
                        var e = a(D.BLKSIZE), t = a(D.BLKSIZE_s / 2), s = [
                            .9238795325112867,
                            .3826834323650898,
                            .9951847266721969,
                            .0980171403295606,
                            .9996988186962042,
                            .02454122852291229,
                            .9999811752826011,
                            .006135884649154475
                        ];
                        function n(e, t, a) {
                            var n, r, _, i = 0, o = t + (a <<= 1);
                            n = 4;
                            do {
                                var f, c, h, u, b, p, m;
                                m = n >> 1, p = (b = n << 1) + (u = n), n = b << 1, _ = (r = t) + m;
                                do A = e[r + 0] - e[r + u], M = e[r + 0] + e[r + u], T = e[r + b] - e[r + p], w = e[r + b] + e[r + p], e[r + b] = M - w, e[r + 0] = M + w, e[r + p] = A - T, e[r + u] = A + T, A = e[_ + 0] - e[_ + u], M = e[_ + 0] + e[_ + u], T = l.SQRT2 * e[_ + p], w = l.SQRT2 * e[_ + b], e[_ + b] = M - w, e[_ + 0] = M + w, e[_ + p] = A - T, e[_ + u] = A + T, _ += n, r += n;
                                while (r < o);
                                for(c = s[i + 0], f = s[i + 1], h = 1; h < m; h++){
                                    var d, v;
                                    d = 1 - 2 * f * f, v = 2 * f * c, r = t + h, _ = t + u - h;
                                    do {
                                        var g, S, R, M, A, B, w, E, T, k;
                                        S = v * e[r + u] - d * e[_ + u], g = d * e[r + u] + v * e[_ + u], A = e[r + 0] - g, M = e[r + 0] + g, B = e[_ + 0] - S, R = e[_ + 0] + S, S = v * e[r + p] - d * e[_ + p], g = d * e[r + p] + v * e[_ + p], T = e[r + b] - g, w = e[r + b] + g, k = e[_ + b] - S, E = e[_ + b] + S, S = f * w - c * k, g = c * w + f * k, e[r + b] = M - g, e[r + 0] = M + g, e[_ + p] = B - S, e[_ + u] = B + S, S = c * E - f * T, g = f * E + c * T, e[_ + b] = R - g, e[_ + 0] = R + g, e[r + p] = A - S, e[r + u] = A + S, _ += n, r += n;
                                    }while (r < o);
                                    c = (d = c) * s[i + 0] - f * s[i + 1], f = d * s[i + 1] + f * s[i + 0];
                                }
                                i += 2;
                            }while (n < a);
                        }
                        var r = [
                            0,
                            128,
                            64,
                            192,
                            32,
                            160,
                            96,
                            224,
                            16,
                            144,
                            80,
                            208,
                            48,
                            176,
                            112,
                            240,
                            8,
                            136,
                            72,
                            200,
                            40,
                            168,
                            104,
                            232,
                            24,
                            152,
                            88,
                            216,
                            56,
                            184,
                            120,
                            248,
                            4,
                            132,
                            68,
                            196,
                            36,
                            164,
                            100,
                            228,
                            20,
                            148,
                            84,
                            212,
                            52,
                            180,
                            116,
                            244,
                            12,
                            140,
                            76,
                            204,
                            44,
                            172,
                            108,
                            236,
                            28,
                            156,
                            92,
                            220,
                            60,
                            188,
                            124,
                            252,
                            2,
                            130,
                            66,
                            194,
                            34,
                            162,
                            98,
                            226,
                            18,
                            146,
                            82,
                            210,
                            50,
                            178,
                            114,
                            242,
                            10,
                            138,
                            74,
                            202,
                            42,
                            170,
                            106,
                            234,
                            26,
                            154,
                            90,
                            218,
                            58,
                            186,
                            122,
                            250,
                            6,
                            134,
                            70,
                            198,
                            38,
                            166,
                            102,
                            230,
                            22,
                            150,
                            86,
                            214,
                            54,
                            182,
                            118,
                            246,
                            14,
                            142,
                            78,
                            206,
                            46,
                            174,
                            110,
                            238,
                            30,
                            158,
                            94,
                            222,
                            62,
                            190,
                            126,
                            254
                        ];
                        this.fft_short = function(e, a, s, _, i) {
                            for(var o = 0; o < 3; o++){
                                var l = D.BLKSIZE_s / 2, f = 65535 & 192 * (o + 1), c = D.BLKSIZE_s / 8 - 1;
                                do {
                                    var h, u, b, p, m, d = 255 & r[c << 2];
                                    u = (h = t[d] * _[s][i + d + f]) - (m = t[127 - d] * _[s][i + d + f + 128]), h += m, p = (b = t[d + 64] * _[s][i + d + f + 64]) - (m = t[63 - d] * _[s][i + d + f + 192]), b += m, l -= 4, a[o][l + 0] = h + b, a[o][l + 2] = h - b, a[o][l + 1] = u + p, a[o][l + 3] = u - p, u = (h = t[d + 1] * _[s][i + d + f + 1]) - (m = t[126 - d] * _[s][i + d + f + 129]), h += m, p = (b = t[d + 65] * _[s][i + d + f + 65]) - (m = t[62 - d] * _[s][i + d + f + 193]), b += m, a[o][l + D.BLKSIZE_s / 2 + 0] = h + b, a[o][l + D.BLKSIZE_s / 2 + 2] = h - b, a[o][l + D.BLKSIZE_s / 2 + 1] = u + p, a[o][l + D.BLKSIZE_s / 2 + 3] = u - p;
                                }while (--c >= 0);
                                n(a[o], l, D.BLKSIZE_s / 2);
                            }
                        }, this.fft_long = function(t, a, s, _, i) {
                            var o = D.BLKSIZE / 8 - 1, l = D.BLKSIZE / 2;
                            do {
                                var f, c, h, u, b, p = 255 & r[o];
                                c = (f = e[p] * _[s][i + p]) - (b = e[p + 512] * _[s][i + p + 512]), f += b, u = (h = e[p + 256] * _[s][i + p + 256]) - (b = e[p + 768] * _[s][i + p + 768]), h += b, a[0 + (l -= 4)] = f + h, a[l + 2] = f - h, a[l + 1] = c + u, a[l + 3] = c - u, c = (f = e[p + 1] * _[s][i + p + 1]) - (b = e[p + 513] * _[s][i + p + 513]), f += b, u = (h = e[p + 257] * _[s][i + p + 257]) - (b = e[p + 769] * _[s][i + p + 769]), h += b, a[l + D.BLKSIZE / 2 + 0] = f + h, a[l + D.BLKSIZE / 2 + 2] = f - h, a[l + D.BLKSIZE / 2 + 1] = c + u, a[l + D.BLKSIZE / 2 + 3] = c - u;
                            }while (--o >= 0);
                            n(a, l, D.BLKSIZE / 2);
                        }, this.init_fft = function(a) {
                            for(var s = 0; s < D.BLKSIZE; s++)e[s] = .42 - .5 * Math.cos(2 * Math.PI * (s + .5) / D.BLKSIZE) + .08 * Math.cos(4 * Math.PI * (s + .5) / D.BLKSIZE);
                            for(s = 0; s < D.BLKSIZE_s / 2; s++)t[s] = .5 * (1 - Math.cos(2 * Math.PI * (s + .5) / D.BLKSIZE_s));
                        };
                    }
                    function G() {
                        var e = new j, n = 2.302585092994046, r = 1 / 217621504 / (D.BLKSIZE / 2);
                        function _(e, t) {
                            for(var a = 0, s = 0; s < D.BLKSIZE / 2; ++s)a += e[s] * t.ATH.eql_w[s];
                            return a * r;
                        }
                        function o(t, a, s, n, r, i, o, f, c, h, u) {
                            var b = t.internal_flags;
                            if (c < 2) e.fft_long(b, n[r], c, h, u), e.fft_short(b, i[o], c, h, u);
                            else if (2 == c) {
                                for(var p = D.BLKSIZE - 1; p >= 0; --p){
                                    var m = n[r + 0][p], d = n[r + 1][p];
                                    n[r + 0][p] = (m + d) * l.SQRT2 * .5, n[r + 1][p] = (m - d) * l.SQRT2 * .5;
                                }
                                for(var v = 2; v >= 0; --v)for(p = D.BLKSIZE_s - 1; p >= 0; --p)m = i[o + 0][v][p], d = i[o + 1][v][p], i[o + 0][v][p] = (m + d) * l.SQRT2 * .5, i[o + 1][v][p] = (m - d) * l.SQRT2 * .5;
                            }
                            for(a[0] = n[r + 0][0], a[0] *= a[0], p = D.BLKSIZE / 2 - 1; p >= 0; --p){
                                var g = n[r + 0][D.BLKSIZE / 2 - p], S = n[r + 0][D.BLKSIZE / 2 + p];
                                a[D.BLKSIZE / 2 - p] = .5 * (g * g + S * S);
                            }
                            for(v = 2; v >= 0; --v)for(s[v][0] = i[o + 0][v][0], s[v][0] *= s[v][0], p = D.BLKSIZE_s / 2 - 1; p >= 0; --p)g = i[o + 0][v][D.BLKSIZE_s / 2 - p], S = i[o + 0][v][D.BLKSIZE_s / 2 + p], s[v][D.BLKSIZE_s / 2 - p] = .5 * (g * g + S * S);
                            var R = 0;
                            for(p = 11; p < D.HBLKSIZE; p++)R += a[p];
                            if (b.tot_ener[c] = R, t.analysis) {
                                for(p = 0; p < D.HBLKSIZE; p++)b.pinfo.energy[f][c][p] = b.pinfo.energy_save[c][p], b.pinfo.energy_save[c][p] = a[p];
                                b.pinfo.pe[f][c] = b.pe[c];
                            }
                            2 == t.athaa_loudapprox && c < 2 && (b.loudness_sq[f][c] = b.loudness_sq_save[c], b.loudness_sq_save[c] = _(a, b));
                        }
                        var b, p, m, d = [
                            1,
                            .79433,
                            .63096,
                            .63096,
                            .63096,
                            .63096,
                            .63096,
                            .25119,
                            .11749
                        ], v = [
                            3.3246 * 3.3246,
                            3.23837 * 3.23837,
                            9.9500500969,
                            9.0247369744,
                            8.1854926609,
                            7.0440875649,
                            2.46209 * 2.46209,
                            2.284 * 2.284,
                            4.4892710641,
                            1.96552 * 1.96552,
                            1.82335 * 1.82335,
                            1.69146 * 1.69146,
                            2.4621061921,
                            2.1508568964,
                            1.37074 * 1.37074,
                            1.31036 * 1.31036,
                            1.5691069696,
                            1.4555939904,
                            1.16203 * 1.16203,
                            1.2715945225,
                            1.09428 * 1.09428,
                            1.0659 * 1.0659,
                            1.0779838276,
                            1.0382591025,
                            1
                        ], g = [
                            1.7782755904,
                            1.35879 * 1.35879,
                            1.38454 * 1.38454,
                            1.39497 * 1.39497,
                            1.40548 * 1.40548,
                            1.3537 * 1.3537,
                            1.6999465924,
                            1.22321 * 1.22321,
                            1.3169398564,
                            1
                        ], S = [
                            5.5396212496,
                            2.29259 * 2.29259,
                            4.9868695969,
                            2.12675 * 2.12675,
                            2.02545 * 2.02545,
                            1.87894 * 1.87894,
                            1.74303 * 1.74303,
                            1.61695 * 1.61695,
                            2.2499700001,
                            1.39148 * 1.39148,
                            1.29083 * 1.29083,
                            1.19746 * 1.19746,
                            1.2339655056,
                            1.0779838276
                        ];
                        function R(e, t, a, s, n, r) {
                            var _, i, o;
                            if (t > e) {
                                if (!(t < e * p)) return e + t;
                                _ = t / e;
                            } else {
                                if (e >= t * p) return e + t;
                                _ = e / t;
                            }
                            if (e += t, s + 3 <= 6) {
                                if (_ >= b) return e;
                                var f = 0 | l.FAST_LOG10_X(_, 16);
                                return e * g[f];
                            }
                            return f = 0 | l.FAST_LOG10_X(_, 16), t = 0 != r ? n.ATH.cb_s[a] * n.ATH.adjust : n.ATH.cb_l[a] * n.ATH.adjust, e < m * t ? e > t ? (i = 1, f <= 13 && (i = S[f]), o = l.FAST_LOG10_X(e / t, 10 / 15), e * ((v[f] - i) * o + i)) : f > 13 ? e : e * S[f] : e * v[f];
                        }
                        var M = [
                            1.7782755904,
                            1.35879 * 1.35879,
                            1.38454 * 1.38454,
                            1.39497 * 1.39497,
                            1.40548 * 1.40548,
                            1.3537 * 1.3537,
                            1.6999465924,
                            1.22321 * 1.22321,
                            1.3169398564,
                            1
                        ];
                        function A(e, t, a) {
                            var s;
                            if (e < 0 && (e = 0), t < 0 && (t = 0), e <= 0) return t;
                            if (t <= 0) return e;
                            if (s = t > e ? t / e : e / t, -2 <= a && a <= 2) {
                                if (s >= b) return e + t;
                                var n = 0 | l.FAST_LOG10_X(s, 16);
                                return (e + t) * M[n];
                            }
                            return s < p ? e + t : (e < t && (e = t), e);
                        }
                        function B(e, t, a, s, n) {
                            var r, _, i = 0, o = 0;
                            for(r = _ = 0; r < D.SBMAX_s; ++_, ++r){
                                for(var l = e.bo_s[r], f = e.npart_s, c = l < f ? l : f; _ < c;)i += t[_], o += a[_], _++;
                                if (e.en[s].s[r][n] = i, e.thm[s].s[r][n] = o, _ >= f) {
                                    ++r;
                                    break;
                                }
                                var h = e.PSY.bo_s_weight[r], u = 1 - h;
                                i = h * t[_], o = h * a[_], e.en[s].s[r][n] += i, e.thm[s].s[r][n] += o, i = u * t[_], o = u * a[_];
                            }
                            for(; r < D.SBMAX_s; ++r)e.en[s].s[r][n] = 0, e.thm[s].s[r][n] = 0;
                        }
                        function w(e, t, a, s) {
                            var n, r, _ = 0, i = 0;
                            for(n = r = 0; n < D.SBMAX_l; ++r, ++n){
                                for(var o = e.bo_l[n], l = e.npart_l, f = o < l ? o : l; r < f;)_ += t[r], i += a[r], r++;
                                if (e.en[s].l[n] = _, e.thm[s].l[n] = i, r >= l) {
                                    ++n;
                                    break;
                                }
                                var c = e.PSY.bo_l_weight[n], h = 1 - c;
                                _ = c * t[r], i = c * a[r], e.en[s].l[n] += _, e.thm[s].l[n] += i, _ = h * t[r], i = h * a[r];
                            }
                            for(; n < D.SBMAX_l; ++n)e.en[s].l[n] = 0, e.thm[s].l[n] = 0;
                        }
                        function E(e, t, a, s, n, r) {
                            var _, i, o = e.internal_flags;
                            for(i = _ = 0; i < o.npart_s; ++i){
                                for(var l = 0, f = 0, c = o.numlines_s[i], h = 0; h < c; ++h, ++_){
                                    var u = t[r][_];
                                    l += u, f < u && (f = u);
                                }
                                a[i] = l;
                            }
                            for(_ = i = 0; i < o.npart_s; i++){
                                var b = o.s3ind_s[i][0], p = o.s3_ss[_++] * a[b];
                                for(++b; b <= o.s3ind_s[i][1];)p += o.s3_ss[_] * a[b], ++_, ++b;
                                var m = 2 * o.nb_s1[n][i];
                                if (s[i] = Math.min(p, m), o.blocktype_old[1 & n] == D.SHORT_TYPE) {
                                    m = 16 * o.nb_s2[n][i];
                                    var d = s[i];
                                    s[i] = Math.min(m, d);
                                }
                                o.nb_s2[n][i] = o.nb_s1[n][i], o.nb_s1[n][i] = p;
                            }
                            for(; i <= D.CBANDS; ++i)a[i] = 0, s[i] = 0;
                        }
                        function T(e, t, a) {
                            return a >= 1 ? e : a <= 0 ? t : t > 0 ? Math.pow(e / t, a) * t : 0;
                        }
                        var k = [
                            11.8,
                            13.6,
                            17.2,
                            32,
                            46.5,
                            51.3,
                            57.5,
                            67.1,
                            71.5,
                            84.6,
                            97.6,
                            130
                        ];
                        function y(e, t) {
                            for(var a = 309.07, s = 0; s < D.SBMAX_s - 1; s++)for(var r = 0; r < 3; r++){
                                var _ = e.thm.s[s][r];
                                if (_ > 0) {
                                    var i = _ * t, o = e.en.s[s][r];
                                    o > i && (a += o > 1e10 * i ? k[s] * (10 * n) : k[s] * l.FAST_LOG10(o / i));
                                }
                            }
                            return a;
                        }
                        var x = [
                            6.8,
                            5.8,
                            5.8,
                            6.4,
                            6.5,
                            9.9,
                            12.1,
                            14.4,
                            15,
                            18.9,
                            21.6,
                            26.9,
                            34.2,
                            40.2,
                            46.8,
                            56.5,
                            60.7,
                            73.9,
                            85.7,
                            93.4,
                            126.1
                        ];
                        function P(e, t) {
                            for(var a = 281.0575, s = 0; s < D.SBMAX_l - 1; s++){
                                var r = e.thm.l[s];
                                if (r > 0) {
                                    var _ = r * t, i = e.en.l[s];
                                    i > _ && (a += i > 1e10 * _ ? x[s] * (10 * n) : x[s] * l.FAST_LOG10(i / _));
                                }
                            }
                            return a;
                        }
                        function I(e, t, a, s, n) {
                            var r, _;
                            for(r = _ = 0; r < e.npart_l; ++r){
                                var i, o = 0, l = 0;
                                for(i = 0; i < e.numlines_l[r]; ++i, ++_){
                                    var f = t[_];
                                    o += f, l < f && (l = f);
                                }
                                a[r] = o, s[r] = l, n[r] = o * e.rnumlines_l[r];
                            }
                        }
                        function H(e, t, a, s) {
                            var n = d.length - 1, r = 0, _ = a[r] + a[r + 1];
                            for(_ > 0 ? ((i = t[r]) < t[r + 1] && (i = t[r + 1]), (o = 0 | (_ = 20 * (2 * i - _) / (_ * (e.numlines_l[r] + e.numlines_l[r + 1] - 1)))) > n && (o = n), s[r] = o) : s[r] = 0, r = 1; r < e.npart_l - 1; r++){
                                var i, o;
                                (_ = a[r - 1] + a[r] + a[r + 1]) > 0 ? ((i = t[r - 1]) < t[r] && (i = t[r]), i < t[r + 1] && (i = t[r + 1]), (o = 0 | (_ = 20 * (3 * i - _) / (_ * (e.numlines_l[r - 1] + e.numlines_l[r] + e.numlines_l[r + 1] - 1)))) > n && (o = n), s[r] = o) : s[r] = 0;
                            }
                            (_ = a[r - 1] + a[r]) > 0 ? ((i = t[r - 1]) < t[r] && (i = t[r]), (o = 0 | (_ = 20 * (2 * i - _) / (_ * (e.numlines_l[r - 1] + e.numlines_l[r] - 1)))) > n && (o = n), s[r] = o) : s[r] = 0;
                        }
                        var O = [
                            -0.00000000000000001730326,
                            -0.01703172,
                            -0.00000000000000001349528,
                            .0418072,
                            -0.0000000000000000673278,
                            -0.0876324,
                            -0.000000000000000030835,
                            .1863476,
                            -0.0000000000000001104424,
                            -0.627638
                        ];
                        function V(t, a, s, n, r, _, i, o) {
                            var f = t.internal_flags;
                            if (n < 2) e.fft_long(f, i[o], n, a, s);
                            else if (2 == n) for(var c = D.BLKSIZE - 1; c >= 0; --c){
                                var h = i[o + 0][c], u = i[o + 1][c];
                                i[o + 0][c] = (h + u) * l.SQRT2 * .5, i[o + 1][c] = (h - u) * l.SQRT2 * .5;
                            }
                            for(_[0] = i[o + 0][0], _[0] *= _[0], c = D.BLKSIZE / 2 - 1; c >= 0; --c){
                                var b = i[o + 0][D.BLKSIZE / 2 - c], p = i[o + 0][D.BLKSIZE / 2 + c];
                                _[D.BLKSIZE / 2 - c] = .5 * (b * b + p * p);
                            }
                            var m = 0;
                            for(c = 11; c < D.HBLKSIZE; c++)m += _[c];
                            if (f.tot_ener[n] = m, t.analysis) {
                                for(c = 0; c < D.HBLKSIZE; c++)f.pinfo.energy[r][n][c] = f.pinfo.energy_save[n][c], f.pinfo.energy_save[n][c] = _[c];
                                f.pinfo.pe[r][n] = f.pe[n];
                            }
                        }
                        function L(t, a, s, n, r, _, i, o) {
                            var f = t.internal_flags;
                            if (0 == r && n < 2 && e.fft_short(f, i[o], n, a, s), 2 == n) for(var c = D.BLKSIZE_s - 1; c >= 0; --c){
                                var h = i[o + 0][r][c], u = i[o + 1][r][c];
                                i[o + 0][r][c] = (h + u) * l.SQRT2 * .5, i[o + 1][r][c] = (h - u) * l.SQRT2 * .5;
                            }
                            for(_[r][0] = i[o + 0][r][0], _[r][0] *= _[r][0], c = D.BLKSIZE_s / 2 - 1; c >= 0; --c){
                                var b = i[o + 0][r][D.BLKSIZE_s / 2 - c], p = i[o + 0][r][D.BLKSIZE_s / 2 + c];
                                _[r][D.BLKSIZE_s / 2 - c] = .5 * (b * b + p * p);
                            }
                        }
                        function N(e, t, a, s) {
                            var n = e.internal_flags;
                            2 == e.athaa_loudapprox && a < 2 && (n.loudness_sq[t][a] = n.loudness_sq_save[a], n.loudness_sq_save[a] = _(s, n));
                        }
                        this.L3psycho_anal_ns = function(e, n, r, _, l, c, b, p, m, v) {
                            var g, S, M, A, k, x, V, L, N, X, q = e.internal_flags, Y = s([
                                2,
                                D.BLKSIZE
                            ]), C = s([
                                2,
                                3,
                                D.BLKSIZE_s
                            ]), F = a(D.CBANDS + 1), j = a(D.CBANDS + 1), G = a(D.CBANDS + 2), z = t(2), K = t(2), Z = s([
                                2,
                                576
                            ]), Q = t(D.CBANDS + 2), U = t(D.CBANDS + 2);
                            for(i.fill(U, 0), g = q.channels_out, e.mode == u.JOINT_STEREO && (g = 4), N = e.VBR == h.vbr_off ? 0 == q.ResvMax ? 0 : q.ResvSize / q.ResvMax * .5 : e.VBR == h.vbr_rh || e.VBR == h.vbr_mtrh || e.VBR == h.vbr_mt ? .6 : 1, S = 0; S < q.channels_out; S++){
                                var W = n[S], J = r + 576 - 350 - 21 + 192;
                                for(A = 0; A < 576; A++){
                                    var $, ee;
                                    for($ = W[J + A + 10], ee = 0, k = 0; k < 9; k += 2)$ += O[k] * (W[J + A + k] + W[J + A + 21 - k]), ee += O[k + 1] * (W[J + A + k + 1] + W[J + A + 21 - k - 1]);
                                    Z[S][A] = $ + ee;
                                }
                                l[_][S].en.assign(q.en[S]), l[_][S].thm.assign(q.thm[S]), g > 2 && (c[_][S].en.assign(q.en[S + 2]), c[_][S].thm.assign(q.thm[S + 2]));
                            }
                            for(S = 0; S < g; S++){
                                var te, ae = a(12), se = [
                                    0,
                                    0,
                                    0,
                                    0
                                ], ne = a(12), re = 1, _e = a(D.CBANDS), ie = a(D.CBANDS), oe = [
                                    0,
                                    0,
                                    0,
                                    0
                                ], le = a(D.HBLKSIZE), fe = s([
                                    3,
                                    D.HBLKSIZE_s
                                ]);
                                for(A = 0; A < 3; A++)ae[A] = q.nsPsy.last_en_subshort[S][A + 6], ne[A] = ae[A] / q.nsPsy.last_en_subshort[S][A + 4], se[0] += ae[A];
                                if (2 == S) for(A = 0; A < 576; A++){
                                    var ce, he;
                                    ce = Z[0][A], he = Z[1][A], Z[0][A] = ce + he, Z[1][A] = ce - he;
                                }
                                var ue = Z[1 & S], be = 0;
                                for(A = 0; A < 9; A++){
                                    for(var pe = be + 64, me = 1; be < pe; be++)me < Math.abs(ue[be]) && (me = Math.abs(ue[be]));
                                    q.nsPsy.last_en_subshort[S][A] = ae[A + 3] = me, se[1 + A / 3] += me, me > ae[A + 3 - 2] ? me /= ae[A + 3 - 2] : me = ae[A + 3 - 2] > 10 * me ? ae[A + 3 - 2] / (10 * me) : 0, ne[A + 3] = me;
                                }
                                if (e.analysis) {
                                    var de = ne[0];
                                    for(A = 1; A < 12; A++)de < ne[A] && (de = ne[A]);
                                    q.pinfo.ers[_][S] = q.pinfo.ers_save[S], q.pinfo.ers_save[S] = de;
                                }
                                for(te = 3 == S ? q.nsPsy.attackthre_s : q.nsPsy.attackthre, A = 0; A < 12; A++)0 == oe[A / 3] && ne[A] > te && (oe[A / 3] = A % 3 + 1);
                                for(A = 1; A < 4; A++)(se[A - 1] > se[A] ? se[A - 1] / se[A] : se[A] / se[A - 1]) < 1.7 && (oe[A] = 0, 1 == A && (oe[0] = 0));
                                for(0 != oe[0] && 0 != q.nsPsy.lastAttacks[S] && (oe[0] = 0), 3 != q.nsPsy.lastAttacks[S] && oe[0] + oe[1] + oe[2] + oe[3] == 0 || (re = 0, 0 != oe[1] && 0 != oe[0] && (oe[1] = 0), 0 != oe[2] && 0 != oe[1] && (oe[2] = 0), 0 != oe[3] && 0 != oe[2] && (oe[3] = 0)), S < 2 ? K[S] = re : 0 == re && (K[0] = K[1] = 0), m[S] = q.tot_ener[S], o(e, le, fe, Y, 1 & S, C, 1 & S, _, S, n, r), I(q, le, F, _e, ie), H(q, _e, ie, Q), L = 0; L < 3; L++){
                                    var ve, ge;
                                    for(E(e, fe, j, G, S, L), B(q, j, G, S, L), V = 0; V < D.SBMAX_s; V++){
                                        if (ge = q.thm[S].s[V][L], ge *= .8, oe[L] >= 2 || 1 == oe[L + 1]) {
                                            var Se = 0 != L ? L - 1 : 2;
                                            me = T(q.thm[S].s[V][Se], ge, .6 * N), ge = Math.min(ge, me);
                                        }
                                        1 == oe[L] ? (Se = 0 != L ? L - 1 : 2, me = T(q.thm[S].s[V][Se], ge, .3 * N), ge = Math.min(ge, me)) : (0 != L && 3 == oe[L - 1] || 0 == L && 3 == q.nsPsy.lastAttacks[S]) && (Se = 2 != L ? L + 1 : 0, me = T(q.thm[S].s[V][Se], ge, .3 * N), ge = Math.min(ge, me)), ve = ae[3 * L + 3] + ae[3 * L + 4] + ae[3 * L + 5], 6 * ae[3 * L + 5] < ve && (ge *= .5, 6 * ae[3 * L + 4] < ve && (ge *= .5)), q.thm[S].s[V][L] = ge;
                                    }
                                }
                                for(q.nsPsy.lastAttacks[S] = oe[2], x = 0, M = 0; M < q.npart_l; M++){
                                    for(var Re = q.s3ind[M][0], Me = F[Re] * d[Q[Re]], Ae = q.s3_ll[x++] * Me; ++Re <= q.s3ind[M][1];)Me = F[Re] * d[Q[Re]], Ae = R(Ae, q.s3_ll[x++] * Me, Re, Re - M, q, 0);
                                    Ae *= .158489319246111, q.blocktype_old[1 & S] == D.SHORT_TYPE ? G[M] = Ae : G[M] = T(Math.min(Ae, Math.min(2 * q.nb_1[S][M], 16 * q.nb_2[S][M])), Ae, N), q.nb_2[S][M] = q.nb_1[S][M], q.nb_1[S][M] = Ae;
                                }
                                for(; M <= D.CBANDS; ++M)F[M] = 0, G[M] = 0;
                                w(q, F, G, S);
                            }
                            for(e.mode != u.STEREO && e.mode != u.JOINT_STEREO || e.interChRatio > 0 && function(e, t) {
                                var a = e.internal_flags;
                                if (a.channels_out > 1) {
                                    for(var s = 0; s < D.SBMAX_l; s++){
                                        var n = a.thm[0].l[s], r = a.thm[1].l[s];
                                        a.thm[0].l[s] += r * t, a.thm[1].l[s] += n * t;
                                    }
                                    for(s = 0; s < D.SBMAX_s; s++)for(var _ = 0; _ < 3; _++)n = a.thm[0].s[s][_], r = a.thm[1].s[s][_], a.thm[0].s[s][_] += r * t, a.thm[1].s[s][_] += n * t;
                                }
                            }(e, e.interChRatio), e.mode == u.JOINT_STEREO && (function(e) {
                                for(var t = 0; t < D.SBMAX_l; t++)if (!(e.thm[0].l[t] > 1.58 * e.thm[1].l[t] || e.thm[1].l[t] > 1.58 * e.thm[0].l[t])) {
                                    var a = e.mld_l[t] * e.en[3].l[t], s = Math.max(e.thm[2].l[t], Math.min(e.thm[3].l[t], a));
                                    a = e.mld_l[t] * e.en[2].l[t];
                                    var n = Math.max(e.thm[3].l[t], Math.min(e.thm[2].l[t], a));
                                    e.thm[2].l[t] = s, e.thm[3].l[t] = n;
                                }
                                for(t = 0; t < D.SBMAX_s; t++)for(var r = 0; r < 3; r++)e.thm[0].s[t][r] > 1.58 * e.thm[1].s[t][r] || e.thm[1].s[t][r] > 1.58 * e.thm[0].s[t][r] || (a = e.mld_s[t] * e.en[3].s[t][r], s = Math.max(e.thm[2].s[t][r], Math.min(e.thm[3].s[t][r], a)), a = e.mld_s[t] * e.en[2].s[t][r], n = Math.max(e.thm[3].s[t][r], Math.min(e.thm[2].s[t][r], a)), e.thm[2].s[t][r] = s, e.thm[3].s[t][r] = n);
                            }(q), X = e.msfix, Math.abs(X) > 0 && function(e, t, a) {
                                var s = t, n = Math.pow(10, a);
                                t *= 2, s *= 2;
                                for(var r = 0; r < D.SBMAX_l; r++)f = e.ATH.cb_l[e.bm_l[r]] * n, (i = Math.min(Math.max(e.thm[0].l[r], f), Math.max(e.thm[1].l[r], f))) * t < (o = Math.max(e.thm[2].l[r], f)) + (l = Math.max(e.thm[3].l[r], f)) && (o *= c = i * s / (o + l), l *= c), e.thm[2].l[r] = Math.min(o, e.thm[2].l[r]), e.thm[3].l[r] = Math.min(l, e.thm[3].l[r]);
                                for(n *= D.BLKSIZE_s / D.BLKSIZE, r = 0; r < D.SBMAX_s; r++)for(var _ = 0; _ < 3; _++){
                                    var i, o, l, f, c;
                                    f = e.ATH.cb_s[e.bm_s[r]] * n, (i = Math.min(Math.max(e.thm[0].s[r][_], f), Math.max(e.thm[1].s[r][_], f))) * t < (o = Math.max(e.thm[2].s[r][_], f)) + (l = Math.max(e.thm[3].s[r][_], f)) && (o *= c = i * t / (o + l), l *= c), e.thm[2].s[r][_] = Math.min(e.thm[2].s[r][_], o), e.thm[3].s[r][_] = Math.min(e.thm[3].s[r][_], l);
                                }
                            }(q, X, e.ATHlower * q.ATH.adjust)), function(e, t, a, s) {
                                var n = e.internal_flags;
                                e.short_blocks != f.short_block_coupled || 0 != t[0] && 0 != t[1] || (t[0] = t[1] = 0);
                                for(var r = 0; r < n.channels_out; r++)s[r] = D.NORM_TYPE, e.short_blocks == f.short_block_dispensed && (t[r] = 1), e.short_blocks == f.short_block_forced && (t[r] = 0), 0 != t[r] ? n.blocktype_old[r] == D.SHORT_TYPE && (s[r] = D.STOP_TYPE) : (s[r] = D.SHORT_TYPE, n.blocktype_old[r] == D.NORM_TYPE && (n.blocktype_old[r] = D.START_TYPE), n.blocktype_old[r] == D.STOP_TYPE && (n.blocktype_old[r] = D.SHORT_TYPE)), a[r] = n.blocktype_old[r], n.blocktype_old[r] = s[r];
                            }(e, K, v, z), S = 0; S < g; S++){
                                var Be, we, Ee, Te = 0;
                                S > 1 ? (Be = p, Te = -2, we = D.NORM_TYPE, v[0] != D.SHORT_TYPE && v[1] != D.SHORT_TYPE || (we = D.SHORT_TYPE), Ee = c[_][S - 2]) : (Be = b, Te = 0, we = v[S], Ee = l[_][S]), we == D.SHORT_TYPE ? Be[Te + S] = y(Ee, q.masking_lower) : Be[Te + S] = P(Ee, q.masking_lower), e.analysis && (q.pinfo.pe[_][S] = Be[Te + S]);
                            }
                            return 0;
                        };
                        var X = [
                            -0.00000000000000001730326,
                            -0.01703172,
                            -0.00000000000000001349528,
                            .0418072,
                            -0.0000000000000000673278,
                            -0.0876324,
                            -0.000000000000000030835,
                            .1863476,
                            -0.0000000000000001104424,
                            -0.627638
                        ];
                        function q(e, t, a) {
                            if (0 == a) for(var s = 0; s < e.npart_s; s++)e.nb_s2[t][s] = e.nb_s1[t][s], e.nb_s1[t][s] = 0;
                        }
                        function Y(e, t) {
                            for(var a = 0; a < e.npart_l; a++)e.nb_2[t][a] = e.nb_1[t][a], e.nb_1[t][a] = 0;
                        }
                        function C(e, t, s, n, r, _) {
                            var i, o, l, f = e.internal_flags, c = new float[D.CBANDS], h = a(D.CBANDS), u = new int[D.CBANDS];
                            for(l = o = 0; l < f.npart_s; ++l){
                                var b = 0, p = 0, m = f.numlines_s[l];
                                for(i = 0; i < m; ++i, ++o){
                                    var v = t[_][o];
                                    b += v, p < v && (p = v);
                                }
                                s[l] = b, c[l] = p, h[l] = b / m;
                            }
                            for(; l < D.CBANDS; ++l)c[l] = 0, h[l] = 0;
                            for(function(e, t, a, s) {
                                var n = d.length - 1, r = 0, _ = a[r] + a[r + 1];
                                for(_ > 0 ? ((i = t[r]) < t[r + 1] && (i = t[r + 1]), (o = 0 | (_ = 20 * (2 * i - _) / (_ * (e.numlines_s[r] + e.numlines_s[r + 1] - 1)))) > n && (o = n), s[r] = o) : s[r] = 0, r = 1; r < e.npart_s - 1; r++){
                                    var i, o;
                                    (_ = a[r - 1] + a[r] + a[r + 1]) > 0 ? ((i = t[r - 1]) < t[r] && (i = t[r]), i < t[r + 1] && (i = t[r + 1]), (o = 0 | (_ = 20 * (3 * i - _) / (_ * (e.numlines_s[r - 1] + e.numlines_s[r] + e.numlines_s[r + 1] - 1)))) > n && (o = n), s[r] = o) : s[r] = 0;
                                }
                                (_ = a[r - 1] + a[r]) > 0 ? ((i = t[r - 1]) < t[r] && (i = t[r]), (o = 0 | (_ = 20 * (2 * i - _) / (_ * (e.numlines_s[r - 1] + e.numlines_s[r] - 1)))) > n && (o = n), s[r] = o) : s[r] = 0;
                            }(f, c, h, u), o = l = 0; l < f.npart_s; l++){
                                var g, S, R, M, B, w = f.s3ind_s[l][0], E = f.s3ind_s[l][1];
                                for(g = u[w], S = 1, M = f.s3_ss[o] * s[w] * d[u[w]], ++o, ++w; w <= E;)g += u[w], S += 1, M = A(M, R = f.s3_ss[o] * s[w] * d[u[w]], w - l), ++o, ++w;
                                M *= B = .5 * d[g = (1 + 2 * g) / (2 * S)], n[l] = M, f.nb_s2[r][l] = f.nb_s1[r][l], f.nb_s1[r][l] = M, R = c[l], R *= f.minval_s[l], R *= B, n[l] > R && (n[l] = R), f.masking_lower > 1 && (n[l] *= f.masking_lower), n[l] > s[l] && (n[l] = s[l]), f.masking_lower < 1 && (n[l] *= f.masking_lower);
                            }
                            for(; l < D.CBANDS; ++l)s[l] = 0, n[l] = 0;
                        }
                        function F(e, s, n, r, _) {
                            var i, o = a(D.CBANDS), l = a(D.CBANDS), f = t(D.CBANDS + 2);
                            I(e, s, n, o, l), H(e, o, l, f);
                            var c = 0;
                            for(i = 0; i < e.npart_l; i++){
                                var h, u, b, p = e.s3ind[i][0], m = e.s3ind[i][1], v = 0, g = 0;
                                for(v = f[p], g += 1, u = e.s3_ll[c] * n[p] * d[f[p]], ++c, ++p; p <= m;)v += f[p], g += 1, u = A(u, h = e.s3_ll[c] * n[p] * d[f[p]], p - i), ++c, ++p;
                                if (u *= b = .5 * d[v = (1 + 2 * v) / (2 * g)], e.blocktype_old[1 & _] == D.SHORT_TYPE) {
                                    var S = 2 * e.nb_1[_][i];
                                    r[i] = S > 0 ? Math.min(u, S) : Math.min(u, .3 * n[i]);
                                } else {
                                    var R = 16 * e.nb_2[_][i], M = 2 * e.nb_1[_][i];
                                    R <= 0 && (R = u), M <= 0 && (M = u), S = e.blocktype_old[1 & _] == D.NORM_TYPE ? Math.min(M, R) : M, r[i] = Math.min(u, S);
                                }
                                e.nb_2[_][i] = e.nb_1[_][i], e.nb_1[_][i] = u, h = o[i], h *= e.minval_l[i], h *= b, r[i] > h && (r[i] = h), e.masking_lower > 1 && (r[i] *= e.masking_lower), r[i] > n[i] && (r[i] = n[i]), e.masking_lower < 1 && (r[i] *= e.masking_lower);
                            }
                            for(; i < D.CBANDS; ++i)n[i] = 0, r[i] = 0;
                        }
                        function G(e, t, a, s, n, r, _) {
                            for(var i, o, l = 2 * r, f = r > 0 ? Math.pow(10, n) : 1, c = 0; c < _; ++c){
                                var h = e[2][c], u = e[3][c], b = t[0][c], p = t[1][c], m = t[2][c], d = t[3][c];
                                if (b <= 1.58 * p && p <= 1.58 * b) {
                                    var v = a[c] * u, g = a[c] * h;
                                    o = Math.max(m, Math.min(d, v)), i = Math.max(d, Math.min(m, g));
                                } else o = m, i = d;
                                if (r > 0) {
                                    var S, R, M = s[c] * f;
                                    if (S = Math.min(Math.max(b, M), Math.max(p, M)), (R = (m = Math.max(o, M)) + (d = Math.max(i, M))) > 0 && S * l < R) {
                                        var A = S * l / R;
                                        m *= A, d *= A;
                                    }
                                    o = Math.min(m, o), i = Math.min(d, i);
                                }
                                o > h && (o = h), i > u && (i = u), t[2][c] = o, t[3][c] = i;
                            }
                        }
                        function z(e, t) {
                            var a;
                            return (a = e >= 0 ? 27 * -e : e * t) <= -72 ? 0 : Math.exp(.2302585093 * a);
                        }
                        function K(e) {
                            var t, a, s, n, r = 0;
                            for(r = 0; z(r, e) > 1e-20; r -= 1);
                            for(s = r, n = 0; Math.abs(n - s) > 1e-12;)z(r = (n + s) / 2, e) > 0 ? n = r : s = r;
                            for(t = s, r = 0, r = 0; z(r, e) > 1e-20; r += 1);
                            for(s = 0, n = r; Math.abs(n - s) > 1e-12;)z(r = (n + s) / 2, e) > 0 ? s = r : n = r;
                            a = n;
                            var _, i = 0;
                            for(_ = 0; _ <= 1e3; ++_)i += z(r = t + _ * (a - t) / 1e3, e);
                            return 1001 / (i * (a - t));
                        }
                        function Z(e) {
                            return e < 0 && (e = 0), e *= .001, 13 * Math.atan(.76 * e) + 3.5 * Math.atan(e * e / 56.25);
                        }
                        function Q(e, s, n, r, _, i, o, l, f, c, h, u) {
                            var b, p = a(D.CBANDS + 1), m = l / (u > 15 ? 1152 : 384), d = t(D.HBLKSIZE);
                            l /= f;
                            var v = 0, g = 0;
                            for(b = 0; b < D.CBANDS; b++){
                                var S;
                                for(y = Z(l * v), p[b] = l * v, S = v; Z(l * S) - y < .34 && S <= f / 2; S++);
                                for(e[b] = S - v, g = b + 1; v < S;)d[v++] = b;
                                if (v > f / 2) {
                                    v = f / 2, ++b;
                                    break;
                                }
                            }
                            p[b] = l * v;
                            for(var R = 0; R < u; R++){
                                var M, A, B, w, E;
                                B = c[R], w = c[R + 1], (M = 0 | Math.floor(.5 + h * (B - .5))) < 0 && (M = 0), (A = 0 | Math.floor(.5 + h * (w - .5))) > f / 2 && (A = f / 2), n[R] = (d[M] + d[A]) / 2, s[R] = d[A];
                                var T = m * w;
                                o[R] = (T - p[s[R]]) / (p[s[R] + 1] - p[s[R]]), o[R] < 0 ? o[R] = 0 : o[R] > 1 && (o[R] = 1), E = Z(l * c[R] * h), E = Math.min(E, 15.5) / 15.5, i[R] = Math.pow(10, 1.25 * (1 - Math.cos(Math.PI * E)) - 2.5);
                            }
                            v = 0;
                            for(var k = 0; k < g; k++){
                                var y, x, P = e[k];
                                y = Z(l * v), x = Z(l * (v + P - 1)), r[k] = .5 * (y + x), y = Z(l * (v - .5)), x = Z(l * (v + P - .5)), _[k] = x - y, v += P;
                            }
                            return g;
                        }
                        function U(e, t, n, r, _, i) {
                            var o, l, f, c, h, u = s([
                                D.CBANDS,
                                D.CBANDS
                            ]), b = 0;
                            if (i) for(var p = 0; p < t; p++)for(o = 0; o < t; o++){
                                var m = (l = void 0, h = void 0, l = n[p] - n[o], f = (l *= l >= 0 ? 3 : 1.5) >= .5 && l <= 2.5 ? 8 * ((h = l - .5) * h - 2 * h) : 0, ((c = 15.811389 + 7.5 * (l += .474) - 17.5 * Math.sqrt(1 + l * l)) <= -60 ? 0 : (l = Math.exp(.2302585093 * (f + c)), l /= .6609193)) * r[o]);
                                u[p][o] = m * _[p];
                            }
                            else for(o = 0; o < t; o++){
                                var d = 15 + Math.min(21 / n[o], 12), v = K(d);
                                for(p = 0; p < t; p++)m = v * z(n[p] - n[o], d) * r[o], u[p][o] = m * _[p];
                            }
                            for(p = 0; p < t; p++){
                                for(o = 0; o < t && !(u[p][o] > 0); o++);
                                for(e[p][0] = o, o = t - 1; o > 0 && !(u[p][o] > 0); o--);
                                e[p][1] = o, b += e[p][1] - e[p][0] + 1;
                            }
                            var g = a(b), S = 0;
                            for(p = 0; p < t; p++)for(o = e[p][0]; o <= e[p][1]; o++)g[S++] = u[p][o];
                            return g;
                        }
                        function W(e) {
                            var t = Z(e);
                            return t = Math.min(t, 15.5) / 15.5, Math.pow(10, 1.25 * (1 - Math.cos(Math.PI * t)) - 2.5);
                        }
                        function J(e, t) {
                            return e < -0.3 && (e = 3410), e /= 1e3, e = Math.max(.1, e), 3.64 * Math.pow(e, -0.8) - 6.8 * Math.exp(-0.6 * Math.pow(e - 3.4, 2)) + 6 * Math.exp(-0.15 * Math.pow(e - 8.7, 2)) + .001 * (.6 + .04 * t) * Math.pow(e, 4);
                        }
                        this.L3psycho_anal_vbr = function(e, n, r, _, i, o, l, c, h, b) {
                            var p = e.internal_flags, m = a(D.HBLKSIZE), d = s([
                                3,
                                D.HBLKSIZE_s
                            ]), v = s([
                                2,
                                D.BLKSIZE
                            ]), g = s([
                                2,
                                3,
                                D.BLKSIZE_s
                            ]), S = s([
                                4,
                                D.CBANDS
                            ]), R = s([
                                4,
                                D.CBANDS
                            ]), M = s([
                                4,
                                3
                            ]), A = [
                                [
                                    0,
                                    0,
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    0
                                ]
                            ], E = t(2), k = e.mode == u.JOINT_STEREO ? 4 : p.channels_out;
                            !function(e, t, n, r, _, i, o, l, f, c) {
                                for(var h = s([
                                    2,
                                    576
                                ]), b = e.internal_flags, p = b.channels_out, m = e.mode == u.JOINT_STEREO ? 4 : p, d = 0; d < p; d++){
                                    firbuf = t[d];
                                    for(var v = n + 576 - 350 - 21 + 192, g = 0; g < 576; g++){
                                        var S, R;
                                        S = firbuf[v + g + 10], R = 0;
                                        for(var M = 0; M < 9; M += 2)S += X[M] * (firbuf[v + g + M] + firbuf[v + g + 21 - M]), R += X[M + 1] * (firbuf[v + g + M + 1] + firbuf[v + g + 21 - M - 1]);
                                        h[d][g] = S + R;
                                    }
                                    _[r][d].en.assign(b.en[d]), _[r][d].thm.assign(b.thm[d]), m > 2 && (i[r][d].en.assign(b.en[d + 2]), i[r][d].thm.assign(b.thm[d + 2]));
                                }
                                for(d = 0; d < m; d++){
                                    var A = a(12), B = a(12), w = [
                                        0,
                                        0,
                                        0,
                                        0
                                    ], E = h[1 & d], T = 0, k = 3 == d ? b.nsPsy.attackthre_s : b.nsPsy.attackthre, y = 1;
                                    if (2 == d) for(g = 0, M = 576; M > 0; ++g, --M){
                                        var x = h[0][g], P = h[1][g];
                                        h[0][g] = x + P, h[1][g] = x - P;
                                    }
                                    for(g = 0; g < 3; g++)B[g] = b.nsPsy.last_en_subshort[d][g + 6], A[g] = B[g] / b.nsPsy.last_en_subshort[d][g + 4], w[0] += B[g];
                                    for(g = 0; g < 9; g++){
                                        for(var I = T + 64, H = 1; T < I; T++)H < Math.abs(E[T]) && (H = Math.abs(E[T]));
                                        b.nsPsy.last_en_subshort[d][g] = B[g + 3] = H, w[1 + g / 3] += H, H > B[g + 3 - 2] ? H /= B[g + 3 - 2] : H = B[g + 3 - 2] > 10 * H ? B[g + 3 - 2] / (10 * H) : 0, A[g + 3] = H;
                                    }
                                    for(g = 0; g < 3; ++g){
                                        var O = B[3 * g + 3] + B[3 * g + 4] + B[3 * g + 5], V = 1;
                                        6 * B[3 * g + 5] < O && (V *= .5, 6 * B[3 * g + 4] < O && (V *= .5)), l[d][g] = V;
                                    }
                                    if (e.analysis) {
                                        var L = A[0];
                                        for(g = 1; g < 12; g++)L < A[g] && (L = A[g]);
                                        b.pinfo.ers[r][d] = b.pinfo.ers_save[d], b.pinfo.ers_save[d] = L;
                                    }
                                    for(g = 0; g < 12; g++)0 == f[d][g / 3] && A[g] > k && (f[d][g / 3] = g % 3 + 1);
                                    for(g = 1; g < 4; g++){
                                        var N = w[g - 1], D = w[g];
                                        Math.max(N, D) < 4e4 && N < 1.7 * D && D < 1.7 * N && (1 == g && f[d][0] <= f[d][g] && (f[d][0] = 0), f[d][g] = 0);
                                    }
                                    f[d][0] <= b.nsPsy.lastAttacks[d] && (f[d][0] = 0), 3 != b.nsPsy.lastAttacks[d] && f[d][0] + f[d][1] + f[d][2] + f[d][3] == 0 || (y = 0, 0 != f[d][1] && 0 != f[d][0] && (f[d][1] = 0), 0 != f[d][2] && 0 != f[d][1] && (f[d][2] = 0), 0 != f[d][3] && 0 != f[d][2] && (f[d][3] = 0)), d < 2 ? c[d] = y : 0 == y && (c[0] = c[1] = 0), o[d] = b.tot_ener[d];
                                }
                            }(e, n, r, _, i, o, h, M, A, E), function(e, t) {
                                var a = e.internal_flags;
                                e.short_blocks != f.short_block_coupled || 0 != t[0] && 0 != t[1] || (t[0] = t[1] = 0);
                                for(var s = 0; s < a.channels_out; s++)e.short_blocks == f.short_block_dispensed && (t[s] = 1), e.short_blocks == f.short_block_forced && (t[s] = 0);
                            }(e, E);
                            for(var x = 0; x < k; x++)V(e, n, r, x, _, m, v, H = 1 & x), N(e, _, x, m), 0 != E[H] ? F(p, m, S[x], R[x], x) : Y(p, x);
                            for(E[0] + E[1] == 2 && e.mode == u.JOINT_STEREO && G(S, R, p.mld_cb_l, p.ATH.cb_l, e.ATHlower * p.ATH.adjust, e.msfix, p.npart_l), x = 0; x < k; x++)0 != E[H = 1 & x] && w(p, S[x], R[x], x);
                            for(var I = 0; I < 3; I++){
                                for(x = 0; x < k; ++x)0 != E[H = 1 & x] ? q(p, x, I) : (L(e, n, r, x, I, d, g, H), C(e, d, S[x], R[x], x, I));
                                for(E[0] + E[1] == 0 && e.mode == u.JOINT_STEREO && G(S, R, p.mld_cb_s, p.ATH.cb_s, e.ATHlower * p.ATH.adjust, e.msfix, p.npart_s), x = 0; x < k; ++x)0 == E[H = 1 & x] && B(p, S[x], R[x], x, I);
                            }
                            for(x = 0; x < k; x++){
                                var H;
                                if (0 == E[H = 1 & x]) for(var O = 0; O < D.SBMAX_s; O++){
                                    var j = a(3);
                                    for(I = 0; I < 3; I++){
                                        var z = p.thm[x].s[O][I];
                                        if (z *= .8, A[x][I] >= 2 || 1 == A[x][I + 1]) {
                                            var K = 0 != I ? I - 1 : 2, Z = T(p.thm[x].s[O][K], z, .36);
                                            z = Math.min(z, Z);
                                        } else 1 == A[x][I] ? (K = 0 != I ? I - 1 : 2, Z = T(p.thm[x].s[O][K], z, .18), z = Math.min(z, Z)) : (0 != I && 3 == A[x][I - 1] || 0 == I && 3 == p.nsPsy.lastAttacks[x]) && (K = 2 != I ? I + 1 : 0, Z = T(p.thm[x].s[O][K], z, .18), z = Math.min(z, Z));
                                        z *= M[x][I], j[I] = z;
                                    }
                                    for(I = 0; I < 3; I++)p.thm[x].s[O][I] = j[I];
                                }
                            }
                            for(x = 0; x < k; x++)p.nsPsy.lastAttacks[x] = A[x][2];
                            for(function(e, t, a) {
                                for(var s = e.internal_flags, n = 0; n < s.channels_out; n++){
                                    var r = D.NORM_TYPE;
                                    0 != t[n] ? s.blocktype_old[n] == D.SHORT_TYPE && (r = D.STOP_TYPE) : (r = D.SHORT_TYPE, s.blocktype_old[n] == D.NORM_TYPE && (s.blocktype_old[n] = D.START_TYPE), s.blocktype_old[n] == D.STOP_TYPE && (s.blocktype_old[n] = D.SHORT_TYPE)), a[n] = s.blocktype_old[n], s.blocktype_old[n] = r;
                                }
                            }(e, E, b), x = 0; x < k; x++){
                                var Q, U, W, J;
                                x > 1 ? (Q = c, U = -2, W = D.NORM_TYPE, b[0] != D.SHORT_TYPE && b[1] != D.SHORT_TYPE || (W = D.SHORT_TYPE), J = o[_][x - 2]) : (Q = l, U = 0, W = b[x], J = i[_][x]), W == D.SHORT_TYPE ? Q[U + x] = y(J, p.masking_lower) : Q[U + x] = P(J, p.masking_lower), e.analysis && (p.pinfo.pe[_][x] = Q[U + x]);
                            }
                            return 0;
                        }, this.psymodel_init = function(t) {
                            var s, r, _ = t.internal_flags, i = !0, o = 13, l = 0, f = 0, u = -8.25, d = -4.5, v = a(D.CBANDS), g = a(D.CBANDS), S = a(D.CBANDS), R = t.out_samplerate;
                            switch(t.experimentalZ){
                                default:
                                case 0:
                                    i = !0;
                                    break;
                                case 1:
                                    i = t.VBR != h.vbr_mtrh && t.VBR != h.vbr_mt;
                                    break;
                                case 2:
                                    i = !1;
                                    break;
                                case 3:
                                    o = 8, l = -1.75, f = -0.0125, u = -8.25, d = -2.25;
                            }
                            for(_.ms_ener_ratio_old = .25, _.blocktype_old[0] = _.blocktype_old[1] = D.NORM_TYPE, s = 0; s < 4; ++s){
                                for(var M = 0; M < D.CBANDS; ++M)_.nb_1[s][M] = 1e20, _.nb_2[s][M] = 1e20, _.nb_s1[s][M] = _.nb_s2[s][M] = 1;
                                for(var A = 0; A < D.SBMAX_l; A++)_.en[s].l[A] = 1e20, _.thm[s].l[A] = 1e20;
                                for(M = 0; M < 3; ++M){
                                    for(A = 0; A < D.SBMAX_s; A++)_.en[s].s[A][M] = 1e20, _.thm[s].s[A][M] = 1e20;
                                    _.nsPsy.lastAttacks[s] = 0;
                                }
                                for(M = 0; M < 9; M++)_.nsPsy.last_en_subshort[s][M] = 10;
                            }
                            for(_.loudness_sq_save[0] = _.loudness_sq_save[1] = 0, _.npart_l = Q(_.numlines_l, _.bo_l, _.bm_l, v, g, _.mld_l, _.PSY.bo_l_weight, R, D.BLKSIZE, _.scalefac_band.l, D.BLKSIZE / 1152, D.SBMAX_l), s = 0; s < _.npart_l; s++){
                                var B = l;
                                v[s] >= o && (B = f * (v[s] - o) / (24 - o) + l * (24 - v[s]) / (24 - o)), S[s] = Math.pow(10, B / 10), _.numlines_l[s] > 0 ? _.rnumlines_l[s] = 1 / _.numlines_l[s] : _.rnumlines_l[s] = 0;
                            }
                            for(_.s3_ll = U(_.s3ind, _.npart_l, v, g, S, i), M = 0, s = 0; s < _.npart_l; s++){
                                T = c.MAX_VALUE;
                                for(var w = 0; w < _.numlines_l[s]; w++, M++){
                                    var E = R * M / (1e3 * D.BLKSIZE);
                                    k = this.ATHformula(1e3 * E, t) - 20, k = Math.pow(10, .1 * k), T > (k *= _.numlines_l[s]) && (T = k);
                                }
                                _.ATH.cb_l[s] = T, (T = 20 * v[s] / 10 - 20) > 6 && (T = 100), T < -15 && (T = -15), T -= 8, _.minval_l[s] = Math.pow(10, T / 10) * _.numlines_l[s];
                            }
                            for(_.npart_s = Q(_.numlines_s, _.bo_s, _.bm_s, v, g, _.mld_s, _.PSY.bo_s_weight, R, D.BLKSIZE_s, _.scalefac_band.s, D.BLKSIZE_s / 384, D.SBMAX_s), M = 0, s = 0; s < _.npart_s; s++){
                                var T;
                                for(B = u, v[s] >= o && (B = d * (v[s] - o) / (24 - o) + u * (24 - v[s]) / (24 - o)), S[s] = Math.pow(10, B / 10), T = c.MAX_VALUE, w = 0; w < _.numlines_s[s]; w++, M++){
                                    var k;
                                    E = R * M / (1e3 * D.BLKSIZE_s), k = this.ATHformula(1e3 * E, t) - 20, k = Math.pow(10, .1 * k), T > (k *= _.numlines_s[s]) && (T = k);
                                }
                                _.ATH.cb_s[s] = T, T = 7 * v[s] / 12 - 7, v[s] > 12 && (T *= 1 + 3.1 * Math.log(1 + T)), v[s] < 12 && (T *= 1 + 2.3 * Math.log(1 - T)), T < -15 && (T = -15), T -= 8, _.minval_s[s] = Math.pow(10, T / 10) * _.numlines_s[s];
                            }
                            _.s3_ss = U(_.s3ind_s, _.npart_s, v, g, S, i), b = Math.pow(10, 9 / 16), p = Math.pow(10, 1.5), m = Math.pow(10, 1.5), e.init_fft(_), _.decay = Math.exp(-1 * n / (.01 * R / 192)), r = 3.5, 0 != (2 & t.exp_nspsytune) && (r = 1), Math.abs(t.msfix) > 0 && (r = t.msfix), t.msfix = r;
                            for(var y = 0; y < _.npart_l; y++)_.s3ind[y][1] > _.npart_l - 1 && (_.s3ind[y][1] = _.npart_l - 1);
                            var x = 576 * _.mode_gr / R;
                            if (_.ATH.decay = Math.pow(10, -1.2 * x), _.ATH.adjust = .01, _.ATH.adjustLimit = 1, -1 != t.ATHtype) {
                                var P = t.out_samplerate / D.BLKSIZE, I = 0;
                                for(E = 0, s = 0; s < D.BLKSIZE / 2; ++s)E += P, _.ATH.eql_w[s] = 1 / Math.pow(10, this.ATHformula(E, t) / 10), I += _.ATH.eql_w[s];
                                for(I = 1 / I, s = D.BLKSIZE / 2; --s >= 0;)_.ATH.eql_w[s] *= I;
                            }
                            for(y = M = 0; y < _.npart_s; ++y)for(s = 0; s < _.numlines_s[y]; ++s)++M;
                            for(y = M = 0; y < _.npart_l; ++y)for(s = 0; s < _.numlines_l[y]; ++s)++M;
                            for(M = 0, s = 0; s < _.npart_l; s++)E = R * (M + _.numlines_l[s] / 2) / (1 * D.BLKSIZE), _.mld_cb_l[s] = W(E), M += _.numlines_l[s];
                            for(; s < D.CBANDS; ++s)_.mld_cb_l[s] = 1;
                            for(M = 0, s = 0; s < _.npart_s; s++)E = R * (M + _.numlines_s[s] / 2) / (1 * D.BLKSIZE_s), _.mld_cb_s[s] = W(E), M += _.numlines_s[s];
                            for(; s < D.CBANDS; ++s)_.mld_cb_s[s] = 1;
                            return 0;
                        }, this.ATHformula = function(e, t) {
                            var a;
                            switch(t.ATHtype){
                                case 0:
                                    a = J(e, 9);
                                    break;
                                case 1:
                                    a = J(e, -1);
                                    break;
                                case 2:
                                    a = J(e, 0);
                                    break;
                                case 3:
                                    a = J(e, 1) + 6;
                                    break;
                                case 4:
                                    a = J(e, t.ATHcurve);
                                    break;
                                default:
                                    a = J(e, 0);
                            }
                            return a;
                        };
                    }
                    function z() {
                        var e, t, s, _, i, l = this;
                        z.V9 = 410, z.V8 = 420, z.V7 = 430, z.V6 = 440, z.V5 = 450, z.V4 = 460, z.V3 = 470, z.V2 = 480, z.V1 = 490, z.V0 = 500, z.R3MIX = 1e3, z.STANDARD = 1001, z.EXTREME = 1002, z.INSANE = 1003, z.STANDARD_FAST = 1004, z.EXTREME_FAST = 1005, z.MEDIUM = 1006, z.MEDIUM_FAST = 1007, z.LAME_MAXMP3BUFFER = 147456;
                        var c, b, p, d = new G;
                        function v() {
                            this.mask_adjust = 0, this.mask_adjust_short = 0, this.bo_l_weight = a(D.SBMAX_l), this.bo_s_weight = a(D.SBMAX_s);
                        }
                        function S() {
                            this.lowerlimit = 0;
                        }
                        function R(e, t) {
                            this.lowpass = t;
                        }
                        this.enc = new D, this.setModules = function(a, n, r, o, l, f, h, u, m) {
                            e = a, t = n, s = r, _ = o, i = l, c = f, b = u, p = m, this.enc.setModules(t, d, _, c);
                        };
                        function A(e) {
                            return e > 1 ? 0 : e <= 0 ? 1 : Math.cos(Math.PI / 2 * e);
                        }
                        function B(e, t) {
                            switch(e){
                                case 44100:
                                    return t.version = 1, 0;
                                case 48e3:
                                    return t.version = 1, 1;
                                case 32e3:
                                    return t.version = 1, 2;
                                case 22050:
                                    return t.version = 0, 0;
                                case 24e3:
                                    return t.version = 0, 1;
                                case 16e3:
                                    return t.version = 0, 2;
                                case 11025:
                                    return t.version = 0, 0;
                                case 12e3:
                                    return t.version = 0, 1;
                                case 8e3:
                                    return t.version = 0, 2;
                                default:
                                    return t.version = 0, -1;
                            }
                        }
                        function w(e, t, a) {
                            a < 16e3 && (t = 2);
                            for(var s = M.bitrate_table[t][1], n = 2; n <= 14; n++)M.bitrate_table[t][n] > 0 && Math.abs(M.bitrate_table[t][n] - e) < Math.abs(s - e) && (s = M.bitrate_table[t][n]);
                            return s;
                        }
                        function x(e, t, a) {
                            a < 16e3 && (t = 2);
                            for(var s = 0; s <= 14; s++)if (M.bitrate_table[t][s] > 0 && M.bitrate_table[t][s] == e) return s;
                            return -1;
                        }
                        function P(e, t) {
                            var a = [
                                new R(8, 2e3),
                                new R(16, 3700),
                                new R(24, 3900),
                                new R(32, 5500),
                                new R(40, 7e3),
                                new R(48, 7500),
                                new R(56, 1e4),
                                new R(64, 11e3),
                                new R(80, 13500),
                                new R(96, 15100),
                                new R(112, 15600),
                                new R(128, 17e3),
                                new R(160, 17500),
                                new R(192, 18600),
                                new R(224, 19400),
                                new R(256, 19700),
                                new R(320, 20500)
                            ], s = l.nearestBitrateFullIndex(t);
                            e.lowerlimit = a[s].lowpass;
                        }
                        function I(e) {
                            var t = D.BLKSIZE + e.framesize - D.FFTOFFSET;
                            return Math.max(t, 512 + e.framesize - 32);
                        }
                        function H(e, t, a, s, n, r) {
                            var _ = l.enc.lame_encode_mp3_frame(e, t, a, s, n, r);
                            return e.frameNum++, _;
                        }
                        function O() {
                            this.n_in = 0, this.n_out = 0;
                        }
                        function V() {
                            this.num_used = 0;
                        }
                        function L(e, t, a) {
                            var s = Math.PI * t;
                            (e /= a) < 0 && (e = 0), e > 1 && (e = 1);
                            var n = e - .5, r = .42 - .5 * Math.cos(2 * e * Math.PI) + .08 * Math.cos(4 * e * Math.PI);
                            return Math.abs(n) < 1e-9 ? s / Math.PI : r * Math.sin(a * s * n) / (Math.PI * a * n);
                        }
                        function N(e, t, s, n, r, _, i, o, l) {
                            var f, c, h = e.internal_flags, u = 0, b = e.out_samplerate / function e(t, a) {
                                return 0 != a ? e(a, t % a) : t;
                            }(e.out_samplerate, e.in_samplerate);
                            b > F.BPC && (b = F.BPC);
                            var p = Math.abs(h.resample_ratio - Math.floor(.5 + h.resample_ratio)) < 1e-4 ? 1 : 0, m = 1 / h.resample_ratio;
                            m > 1 && (m = 1);
                            var d = 31;
                            0 == d % 2 && --d;
                            var v = (d += p) + 1;
                            if (0 == h.fill_buffer_resample_init) {
                                for(h.inbuf_old[0] = a(v), h.inbuf_old[1] = a(v), f = 0; f <= 2 * b; ++f)h.blackfilt[f] = a(v);
                                for(h.itime[0] = 0, h.itime[1] = 0, u = 0; u <= 2 * b; u++){
                                    var g = 0, S = (u - b) / (2 * b);
                                    for(f = 0; f <= d; f++)g += h.blackfilt[u][f] = L(f - S, m, d);
                                    for(f = 0; f <= d; f++)h.blackfilt[u][f] /= g;
                                }
                                h.fill_buffer_resample_init = 1;
                            }
                            var R = h.inbuf_old[l];
                            for(c = 0; c < n; c++){
                                var M, A;
                                if (M = c * h.resample_ratio, d + (u = 0 | Math.floor(M - h.itime[l])) - d / 2 >= i) break;
                                S = M - h.itime[l] - (u + d % 2 * .5), A = 0 | Math.floor(2 * S * b + b + .5);
                                var B = 0;
                                for(f = 0; f <= d; ++f){
                                    var w = f + u - d / 2;
                                    B += (w < 0 ? R[v + w] : r[_ + w]) * h.blackfilt[A][f];
                                }
                                t[s + c] = B;
                            }
                            if (o.num_used = Math.min(i, d + u - d / 2), h.itime[l] += o.num_used - c * h.resample_ratio, o.num_used >= v) for(f = 0; f < v; f++)R[f] = r[_ + o.num_used + f - v];
                            else {
                                var E = v - o.num_used;
                                for(f = 0; f < E; ++f)R[f] = R[f + o.num_used];
                                for(u = 0; f < v; ++f, ++u)R[f] = r[_ + u];
                            }
                            return c;
                        }
                        function X(e, t, a, s, n, r) {
                            var _ = e.internal_flags;
                            if (_.resample_ratio < .9999 || _.resample_ratio > 1.0001) for(var i = 0; i < _.channels_out; i++){
                                var o = new V;
                                r.n_out = N(e, t[i], _.mf_size, e.framesize, a[i], s, n, o, i), r.n_in = o.num_used;
                            }
                            else {
                                r.n_out = Math.min(e.framesize, n), r.n_in = r.n_out;
                                for(var l = 0; l < r.n_out; ++l)t[0][_.mf_size + l] = a[0][s + l], 2 == _.channels_out && (t[1][_.mf_size + l] = a[1][s + l]);
                            }
                        }
                        this.lame_init = function() {
                            var e = new E;
                            return 0 != function(e) {
                                var t;
                                return e.class_id = 4294479419, t = e.internal_flags = new F, e.mode = u.NOT_SET, e.original = 1, e.in_samplerate = 44100, e.num_channels = 2, e.num_samples = -1, e.bWriteVbrTag = !0, e.quality = -1, e.short_blocks = null, t.subblock_gain = -1, e.lowpassfreq = 0, e.highpassfreq = 0, e.lowpasswidth = -1, e.highpasswidth = -1, e.VBR = h.vbr_off, e.VBR_q = 4, e.ATHcurve = -1, e.VBR_mean_bitrate_kbps = 128, e.VBR_min_bitrate_kbps = 0, e.VBR_max_bitrate_kbps = 0, e.VBR_hard_min = 0, t.VBR_min_bitrate = 1, t.VBR_max_bitrate = 13, e.quant_comp = -1, e.quant_comp_short = -1, e.msfix = -1, t.resample_ratio = 1, t.OldValue[0] = 180, t.OldValue[1] = 180, t.CurrentStep[0] = 4, t.CurrentStep[1] = 4, t.masking_lower = 1, t.nsPsy.attackthre = -1, t.nsPsy.attackthre_s = -1, e.scale = -1, e.athaa_type = -1, e.ATHtype = -1, e.athaa_loudapprox = -1, e.athaa_sensitivity = 0, e.useTemporal = null, e.interChRatio = -1, t.mf_samples_to_encode = D.ENCDELAY + D.POSTDELAY, e.encoder_padding = 0, t.mf_size = D.ENCDELAY - D.MDCTDELAY, e.findReplayGain = !1, e.decode_on_the_fly = !1, t.decode_on_the_fly = !1, t.findReplayGain = !1, t.findPeakSample = !1, t.RadioGain = 0, t.AudiophileGain = 0, t.noclipGainChange = 0, t.noclipScale = -1, e.preset = 0, e.write_id3tag_automatic = !0, 0;
                            }(e) ? null : (e.lame_allocated_gfp = 1, e);
                        }, this.nearestBitrateFullIndex = function(e) {
                            var t = [
                                8,
                                16,
                                24,
                                32,
                                40,
                                48,
                                56,
                                64,
                                80,
                                96,
                                112,
                                128,
                                160,
                                192,
                                224,
                                256,
                                320
                            ], a = 0, s = 0, n = 0, r = 0;
                            r = t[16], n = 16, s = t[16], a = 16;
                            for(var _ = 0; _ < 16; _++)if (Math.max(e, t[_ + 1]) != e) {
                                r = t[_ + 1], n = _ + 1, s = t[_], a = _;
                                break;
                            }
                            return r - e > e - s ? a : n;
                        }, this.lame_init_params = function(a) {
                            var r, l, R, E = a.internal_flags;
                            if (E.Class_ID = 0, null == E.ATH && (E.ATH = new k), null == E.PSY && (E.PSY = new v), null == E.rgdata && (E.rgdata = new T), E.channels_in = a.num_channels, 1 == E.channels_in && (a.mode = u.MONO), E.channels_out = a.mode == u.MONO ? 1 : 2, E.mode_ext = D.MPG_MD_MS_LR, a.mode == u.MONO && (a.force_ms = !1), a.VBR == h.vbr_off && 128 != a.VBR_mean_bitrate_kbps && 0 == a.brate && (a.brate = a.VBR_mean_bitrate_kbps), a.VBR == h.vbr_off || a.VBR == h.vbr_mtrh || a.VBR == h.vbr_mt || (a.free_format = !1), a.VBR == h.vbr_off && 0 == a.brate && g.EQ(a.compression_ratio, 0) && (a.compression_ratio = 11.025), a.VBR == h.vbr_off && a.compression_ratio > 0 && (0 == a.out_samplerate && (a.out_samplerate = map2MP3Frequency(int(.97 * a.in_samplerate))), a.brate = 0 | 16 * a.out_samplerate * E.channels_out / (1e3 * a.compression_ratio), E.samplerate_index = B(a.out_samplerate, a), a.free_format || (a.brate = w(a.brate, a.version, a.out_samplerate))), 0 != a.out_samplerate && (a.out_samplerate < 16e3 ? (a.VBR_mean_bitrate_kbps = Math.max(a.VBR_mean_bitrate_kbps, 8), a.VBR_mean_bitrate_kbps = Math.min(a.VBR_mean_bitrate_kbps, 64)) : a.out_samplerate < 32e3 ? (a.VBR_mean_bitrate_kbps = Math.max(a.VBR_mean_bitrate_kbps, 8), a.VBR_mean_bitrate_kbps = Math.min(a.VBR_mean_bitrate_kbps, 160)) : (a.VBR_mean_bitrate_kbps = Math.max(a.VBR_mean_bitrate_kbps, 32), a.VBR_mean_bitrate_kbps = Math.min(a.VBR_mean_bitrate_kbps, 320))), 0 == a.lowpassfreq) {
                                var I = 16e3;
                                switch(a.VBR){
                                    case h.vbr_off:
                                        P(H = new S, a.brate), I = H.lowerlimit;
                                        break;
                                    case h.vbr_abr:
                                        var H;
                                        P(H = new S, a.VBR_mean_bitrate_kbps), I = H.lowerlimit;
                                        break;
                                    case h.vbr_rh:
                                        var O = [
                                            19500,
                                            19e3,
                                            18600,
                                            18e3,
                                            17500,
                                            16e3,
                                            15600,
                                            14900,
                                            12500,
                                            1e4,
                                            3950
                                        ];
                                        if (0 <= a.VBR_q && a.VBR_q <= 9) {
                                            var V = O[a.VBR_q], L = O[a.VBR_q + 1], N = a.VBR_q_frac;
                                            I = linear_int(V, L, N);
                                        } else I = 19500;
                                        break;
                                    default:
                                        O = [
                                            19500,
                                            19e3,
                                            18500,
                                            18e3,
                                            17500,
                                            16500,
                                            15500,
                                            14500,
                                            12500,
                                            9500,
                                            3950
                                        ], 0 <= a.VBR_q && a.VBR_q <= 9 ? (V = O[a.VBR_q], L = O[a.VBR_q + 1], N = a.VBR_q_frac, I = linear_int(V, L, N)) : I = 19500;
                                }
                                a.mode != u.MONO || a.VBR != h.vbr_off && a.VBR != h.vbr_abr || (I *= 1.5), a.lowpassfreq = 0 | I;
                            }
                            if (0 == a.out_samplerate && (2 * a.lowpassfreq > a.in_samplerate && (a.lowpassfreq = a.in_samplerate / 2), a.out_samplerate = (r = 0 | a.lowpassfreq, R = 44100, (l = a.in_samplerate) >= 48e3 ? R = 48e3 : l >= 44100 ? R = 44100 : l >= 32e3 ? R = 32e3 : l >= 24e3 ? R = 24e3 : l >= 22050 ? R = 22050 : l >= 16e3 ? R = 16e3 : l >= 12e3 ? R = 12e3 : l >= 11025 ? R = 11025 : l >= 8e3 && (R = 8e3), -1 == r ? R : (r <= 15960 && (R = 44100), r <= 15250 && (R = 32e3), r <= 11220 && (R = 24e3), r <= 9970 && (R = 22050), r <= 7230 && (R = 16e3), r <= 5420 && (R = 12e3), r <= 4510 && (R = 11025), r <= 3970 && (R = 8e3), l < R ? l > 44100 ? 48e3 : l > 32e3 ? 44100 : l > 24e3 ? 32e3 : l > 22050 ? 24e3 : l > 16e3 ? 22050 : l > 12e3 ? 16e3 : l > 11025 ? 12e3 : l > 8e3 ? 11025 : 8e3 : R))), a.lowpassfreq = Math.min(20500, a.lowpassfreq), a.lowpassfreq = Math.min(a.out_samplerate / 2, a.lowpassfreq), a.VBR == h.vbr_off && (a.compression_ratio = 16 * a.out_samplerate * E.channels_out / (1e3 * a.brate)), a.VBR == h.vbr_abr && (a.compression_ratio = 16 * a.out_samplerate * E.channels_out / (1e3 * a.VBR_mean_bitrate_kbps)), a.bWriteVbrTag || (a.findReplayGain = !1, a.decode_on_the_fly = !1, E.findPeakSample = !1), E.findReplayGain = a.findReplayGain, E.decode_on_the_fly = a.decode_on_the_fly, E.decode_on_the_fly && (E.findPeakSample = !0), E.findReplayGain && e.InitGainAnalysis(E.rgdata, a.out_samplerate) == m.INIT_GAIN_ANALYSIS_ERROR) return a.internal_flags = null, -6;
                            switch(E.decode_on_the_fly && !a.decode_only && (null != E.hip && p.hip_decode_exit(E.hip), E.hip = p.hip_decode_init()), E.mode_gr = a.out_samplerate <= 24e3 ? 1 : 2, a.framesize = 576 * E.mode_gr, a.encoder_delay = D.ENCDELAY, E.resample_ratio = a.in_samplerate / a.out_samplerate, a.VBR){
                                case h.vbr_mt:
                                case h.vbr_rh:
                                case h.vbr_mtrh:
                                    a.compression_ratio = [
                                        5.7,
                                        6.5,
                                        7.3,
                                        8.2,
                                        10,
                                        11.9,
                                        13,
                                        14,
                                        15,
                                        16.5
                                    ][a.VBR_q];
                                    break;
                                case h.vbr_abr:
                                    a.compression_ratio = 16 * a.out_samplerate * E.channels_out / (1e3 * a.VBR_mean_bitrate_kbps);
                                    break;
                                default:
                                    a.compression_ratio = 16 * a.out_samplerate * E.channels_out / (1e3 * a.brate);
                            }
                            if (a.mode == u.NOT_SET && (a.mode = u.JOINT_STEREO), a.highpassfreq > 0 ? (E.highpass1 = 2 * a.highpassfreq, a.highpasswidth >= 0 ? E.highpass2 = 2 * (a.highpassfreq + a.highpasswidth) : E.highpass2 = 2 * a.highpassfreq, E.highpass1 /= a.out_samplerate, E.highpass2 /= a.out_samplerate) : (E.highpass1 = 0, E.highpass2 = 0), a.lowpassfreq > 0 ? (E.lowpass2 = 2 * a.lowpassfreq, a.lowpasswidth >= 0 ? (E.lowpass1 = 2 * (a.lowpassfreq - a.lowpasswidth), E.lowpass1 < 0 && (E.lowpass1 = 0)) : E.lowpass1 = 2 * a.lowpassfreq, E.lowpass1 /= a.out_samplerate, E.lowpass2 /= a.out_samplerate) : (E.lowpass1 = 0, E.lowpass2 = 0), function(e) {
                                var t = e.internal_flags, a = 32, s = -1;
                                if (t.lowpass1 > 0) {
                                    for(var n = 999, r = 0; r <= 31; r++)(f = r / 31) >= t.lowpass2 && (a = Math.min(a, r)), t.lowpass1 < f && f < t.lowpass2 && (n = Math.min(n, r));
                                    t.lowpass1 = 999 == n ? (a - .75) / 31 : (n - .75) / 31, t.lowpass2 = a / 31;
                                }
                                if (t.highpass2 > 0 && t.highpass2 < .75 / 31 * .9 && (t.highpass1 = 0, t.highpass2 = 0, o.err.println("Warning: highpass filter disabled.  highpass frequency too small\n")), t.highpass2 > 0) {
                                    var _ = -1;
                                    for(r = 0; r <= 31; r++)(f = r / 31) <= t.highpass1 && (s = Math.max(s, r)), t.highpass1 < f && f < t.highpass2 && (_ = Math.max(_, r));
                                    t.highpass1 = s / 31, t.highpass2 = -1 == _ ? (s + .75) / 31 : (_ + .75) / 31;
                                }
                                for(r = 0; r < 32; r++){
                                    var i, l, f = r / 31;
                                    i = t.highpass2 > t.highpass1 ? A((t.highpass2 - f) / (t.highpass2 - t.highpass1 + 1e-20)) : 1, l = t.lowpass2 > t.lowpass1 ? A((f - t.lowpass1) / (t.lowpass2 - t.lowpass1 + 1e-20)) : 1, t.amp_filter[r] = i * l;
                                }
                            }(a), E.samplerate_index = B(a.out_samplerate, a), E.samplerate_index < 0) return a.internal_flags = null, -1;
                            if (a.VBR == h.vbr_off) {
                                if (a.free_format) E.bitrate_index = 0;
                                else if (a.brate = w(a.brate, a.version, a.out_samplerate), E.bitrate_index = x(a.brate, a.version, a.out_samplerate), E.bitrate_index <= 0) return a.internal_flags = null, -1;
                            } else E.bitrate_index = 1;
                            a.analysis && (a.bWriteVbrTag = !1), null != E.pinfo && (a.bWriteVbrTag = !1), t.init_bit_stream_w(E);
                            for(var X, q = E.samplerate_index + 3 * a.version + 6 * (a.out_samplerate < 16e3 ? 1 : 0), Y = 0; Y < D.SBMAX_l + 1; Y++)E.scalefac_band.l[Y] = _.sfBandIndex[q].l[Y];
                            for(Y = 0; Y < D.PSFB21 + 1; Y++){
                                var C = (E.scalefac_band.l[22] - E.scalefac_band.l[21]) / D.PSFB21, F = E.scalefac_band.l[21] + Y * C;
                                E.scalefac_band.psfb21[Y] = F;
                            }
                            for(E.scalefac_band.psfb21[D.PSFB21] = 576, Y = 0; Y < D.SBMAX_s + 1; Y++)E.scalefac_band.s[Y] = _.sfBandIndex[q].s[Y];
                            for(Y = 0; Y < D.PSFB12 + 1; Y++)C = (E.scalefac_band.s[13] - E.scalefac_band.s[12]) / D.PSFB12, F = E.scalefac_band.s[12] + Y * C, E.scalefac_band.psfb12[Y] = F;
                            for(E.scalefac_band.psfb12[D.PSFB12] = 192, 1 == a.version ? E.sideinfo_len = 1 == E.channels_out ? 21 : 36 : E.sideinfo_len = 1 == E.channels_out ? 13 : 21, a.error_protection && (E.sideinfo_len += 2), function(e) {
                                var t = e.internal_flags;
                                e.frameNum = 0, e.write_id3tag_automatic && b.id3tag_write_v2(e), t.bitrate_stereoMode_Hist = n([
                                    16,
                                    5
                                ]), t.bitrate_blockType_Hist = n([
                                    16,
                                    6
                                ]), t.PeakSample = 0, e.bWriteVbrTag && c.InitVbrTag(e);
                            }(a), E.Class_ID = 4294479419, X = 0; X < 19; X++)E.nsPsy.pefirbuf[X] = 700 * E.mode_gr * E.channels_out;
                            switch(-1 == a.ATHtype && (a.ATHtype = 4), a.VBR){
                                case h.vbr_mt:
                                    a.VBR = h.vbr_mtrh;
                                case h.vbr_mtrh:
                                    null == a.useTemporal && (a.useTemporal = !1), s.apply_preset(a, 500 - 10 * a.VBR_q, 0), a.quality < 0 && (a.quality = LAME_DEFAULT_QUALITY), a.quality < 5 && (a.quality = 0), a.quality > 5 && (a.quality = 5), E.PSY.mask_adjust = a.maskingadjust, E.PSY.mask_adjust_short = a.maskingadjust_short, a.experimentalY ? E.sfb21_extra = !1 : E.sfb21_extra = a.out_samplerate > 44e3, E.iteration_loop = new VBRNewIterationLoop(i);
                                    break;
                                case h.vbr_rh:
                                    s.apply_preset(a, 500 - 10 * a.VBR_q, 0), E.PSY.mask_adjust = a.maskingadjust, E.PSY.mask_adjust_short = a.maskingadjust_short, a.experimentalY ? E.sfb21_extra = !1 : E.sfb21_extra = a.out_samplerate > 44e3, a.quality > 6 && (a.quality = 6), a.quality < 0 && (a.quality = LAME_DEFAULT_QUALITY), E.iteration_loop = new VBROldIterationLoop(i);
                                    break;
                                default:
                                    var j;
                                    E.sfb21_extra = !1, a.quality < 0 && (a.quality = LAME_DEFAULT_QUALITY), (j = a.VBR) == h.vbr_off && (a.VBR_mean_bitrate_kbps = a.brate), s.apply_preset(a, a.VBR_mean_bitrate_kbps, 0), a.VBR = j, E.PSY.mask_adjust = a.maskingadjust, E.PSY.mask_adjust_short = a.maskingadjust_short, j == h.vbr_off ? E.iteration_loop = new y(i) : E.iteration_loop = new ABRIterationLoop(i);
                            }
                            if (a.VBR != h.vbr_off) {
                                if (E.VBR_min_bitrate = 1, E.VBR_max_bitrate = 14, a.out_samplerate < 16e3 && (E.VBR_max_bitrate = 8), 0 != a.VBR_min_bitrate_kbps && (a.VBR_min_bitrate_kbps = w(a.VBR_min_bitrate_kbps, a.version, a.out_samplerate), E.VBR_min_bitrate = x(a.VBR_min_bitrate_kbps, a.version, a.out_samplerate), E.VBR_min_bitrate < 0)) return -1;
                                if (0 != a.VBR_max_bitrate_kbps && (a.VBR_max_bitrate_kbps = w(a.VBR_max_bitrate_kbps, a.version, a.out_samplerate), E.VBR_max_bitrate = x(a.VBR_max_bitrate_kbps, a.version, a.out_samplerate), E.VBR_max_bitrate < 0)) return -1;
                                a.VBR_min_bitrate_kbps = M.bitrate_table[a.version][E.VBR_min_bitrate], a.VBR_max_bitrate_kbps = M.bitrate_table[a.version][E.VBR_max_bitrate], a.VBR_mean_bitrate_kbps = Math.min(M.bitrate_table[a.version][E.VBR_max_bitrate], a.VBR_mean_bitrate_kbps), a.VBR_mean_bitrate_kbps = Math.max(M.bitrate_table[a.version][E.VBR_min_bitrate], a.VBR_mean_bitrate_kbps);
                            }
                            return a.tune && (E.PSY.mask_adjust += a.tune_value_a, E.PSY.mask_adjust_short += a.tune_value_a), function(e) {
                                var t = e.internal_flags;
                                switch(e.quality){
                                    default:
                                    case 9:
                                        t.psymodel = 0, t.noise_shaping = 0, t.noise_shaping_amp = 0, t.noise_shaping_stop = 0, t.use_best_huffman = 0, t.full_outer_loop = 0;
                                        break;
                                    case 8:
                                        e.quality = 7;
                                    case 7:
                                        t.psymodel = 1, t.noise_shaping = 0, t.noise_shaping_amp = 0, t.noise_shaping_stop = 0, t.use_best_huffman = 0, t.full_outer_loop = 0;
                                        break;
                                    case 6:
                                    case 5:
                                        t.psymodel = 1, 0 == t.noise_shaping && (t.noise_shaping = 1), t.noise_shaping_amp = 0, t.noise_shaping_stop = 0, -1 == t.subblock_gain && (t.subblock_gain = 1), t.use_best_huffman = 0, t.full_outer_loop = 0;
                                        break;
                                    case 4:
                                        t.psymodel = 1, 0 == t.noise_shaping && (t.noise_shaping = 1), t.noise_shaping_amp = 0, t.noise_shaping_stop = 0, -1 == t.subblock_gain && (t.subblock_gain = 1), t.use_best_huffman = 1, t.full_outer_loop = 0;
                                        break;
                                    case 3:
                                        t.psymodel = 1, 0 == t.noise_shaping && (t.noise_shaping = 1), t.noise_shaping_amp = 1, t.noise_shaping_stop = 1, -1 == t.subblock_gain && (t.subblock_gain = 1), t.use_best_huffman = 1, t.full_outer_loop = 0;
                                        break;
                                    case 2:
                                        t.psymodel = 1, 0 == t.noise_shaping && (t.noise_shaping = 1), 0 == t.substep_shaping && (t.substep_shaping = 2), t.noise_shaping_amp = 1, t.noise_shaping_stop = 1, -1 == t.subblock_gain && (t.subblock_gain = 1), t.use_best_huffman = 1, t.full_outer_loop = 0;
                                        break;
                                    case 1:
                                    case 0:
                                        t.psymodel = 1, 0 == t.noise_shaping && (t.noise_shaping = 1), 0 == t.substep_shaping && (t.substep_shaping = 2), t.noise_shaping_amp = 2, t.noise_shaping_stop = 1, -1 == t.subblock_gain && (t.subblock_gain = 1), t.use_best_huffman = 1, t.full_outer_loop = 0;
                                }
                            }(a), a.athaa_type < 0 ? E.ATH.useAdjust = 3 : E.ATH.useAdjust = a.athaa_type, E.ATH.aaSensitivityP = Math.pow(10, a.athaa_sensitivity / -10), null == a.short_blocks && (a.short_blocks = f.short_block_allowed), a.short_blocks != f.short_block_allowed || a.mode != u.JOINT_STEREO && a.mode != u.STEREO || (a.short_blocks = f.short_block_coupled), a.quant_comp < 0 && (a.quant_comp = 1), a.quant_comp_short < 0 && (a.quant_comp_short = 0), a.msfix < 0 && (a.msfix = 0), a.exp_nspsytune = 1 | a.exp_nspsytune, a.internal_flags.nsPsy.attackthre < 0 && (a.internal_flags.nsPsy.attackthre = G.NSATTACKTHRE), a.internal_flags.nsPsy.attackthre_s < 0 && (a.internal_flags.nsPsy.attackthre_s = G.NSATTACKTHRE_S), a.scale < 0 && (a.scale = 1), a.ATHtype < 0 && (a.ATHtype = 4), a.ATHcurve < 0 && (a.ATHcurve = 4), a.athaa_loudapprox < 0 && (a.athaa_loudapprox = 2), a.interChRatio < 0 && (a.interChRatio = 0), null == a.useTemporal && (a.useTemporal = !0), E.slot_lag = E.frac_SpF = 0, a.VBR == h.vbr_off && (E.slot_lag = E.frac_SpF = 72e3 * (a.version + 1) * a.brate % a.out_samplerate | 0), _.iteration_init(a), d.psymodel_init(a), 0;
                        }, this.lame_encode_flush = function(e, a, s, n) {
                            var _, i, o, l, f = e.internal_flags, c = r([
                                2,
                                1152
                            ]), h = 0, u = f.mf_samples_to_encode - D.POSTDELAY, p = I(e);
                            if (f.mf_samples_to_encode < 1) return 0;
                            for(_ = 0, e.in_samplerate != e.out_samplerate && (u += 16 * e.out_samplerate / e.in_samplerate), (o = e.framesize - u % e.framesize) < 576 && (o += e.framesize), e.encoder_padding = o, l = (u + o) / e.framesize; l > 0 && h >= 0;){
                                var m = p - f.mf_size, d = e.frameNum;
                                m *= e.in_samplerate, (m /= e.out_samplerate) > 1152 && (m = 1152), m < 1 && (m = 1), i = n - _, 0 == n && (i = 0), s += h = this.lame_encode_buffer(e, c[0], c[1], m, a, s, i), _ += h, l -= d != e.frameNum ? 1 : 0;
                            }
                            if (f.mf_samples_to_encode = 0, h < 0) return h;
                            if (i = n - _, 0 == n && (i = 0), t.flush_bitstream(e), (h = t.copy_buffer(f, a, s, i, 1)) < 0) return h;
                            if (s += h, i = n - (_ += h), 0 == n && (i = 0), e.write_id3tag_automatic) {
                                if (b.id3tag_write_v1(e), (h = t.copy_buffer(f, a, s, i, 0)) < 0) return h;
                                _ += h;
                            }
                            return _;
                        }, this.lame_encode_buffer = function(s, n, r, _, i, o, l) {
                            var f = s.internal_flags, c = [
                                null,
                                null
                            ];
                            if (4294479419 != f.Class_ID) return -3;
                            if (0 == _) return 0;
                            !function(e, t) {
                                (null == e.in_buffer_0 || e.in_buffer_nsamples < t) && (e.in_buffer_0 = a(t), e.in_buffer_1 = a(t), e.in_buffer_nsamples = t);
                            }(f, _), c[0] = f.in_buffer_0, c[1] = f.in_buffer_1;
                            for(var h = 0; h < _; h++)c[0][h] = n[h], f.channels_in > 1 && (c[1][h] = r[h]);
                            return function(a, s, n, r, _, i, o) {
                                var l, f, c, h, u, b = a.internal_flags, p = 0, d = [
                                    null,
                                    null
                                ], v = [
                                    null,
                                    null
                                ];
                                if (4294479419 != b.Class_ID) return -3;
                                if (0 == r) return 0;
                                if ((u = t.copy_buffer(b, _, i, o, 0)) < 0) return u;
                                if (i += u, p += u, v[0] = s, v[1] = n, g.NEQ(a.scale, 0) && g.NEQ(a.scale, 1)) for(f = 0; f < r; ++f)v[0][f] *= a.scale, 2 == b.channels_out && (v[1][f] *= a.scale);
                                if (g.NEQ(a.scale_left, 0) && g.NEQ(a.scale_left, 1)) for(f = 0; f < r; ++f)v[0][f] *= a.scale_left;
                                if (g.NEQ(a.scale_right, 0) && g.NEQ(a.scale_right, 1)) for(f = 0; f < r; ++f)v[1][f] *= a.scale_right;
                                if (2 == a.num_channels && 1 == b.channels_out) for(f = 0; f < r; ++f)v[0][f] = .5 * (v[0][f] + v[1][f]), v[1][f] = 0;
                                h = I(a), d[0] = b.mfbuf[0], d[1] = b.mfbuf[1];
                                for(var S = 0; r > 0;){
                                    var R, M, A = [
                                        null,
                                        null
                                    ];
                                    A[0] = v[0], A[1] = v[1];
                                    var B = new O;
                                    if (X(a, d, A, S, r, B), R = B.n_in, M = B.n_out, b.findReplayGain && !b.decode_on_the_fly && e.AnalyzeSamples(b.rgdata, d[0], b.mf_size, d[1], b.mf_size, M, b.channels_out) == m.GAIN_ANALYSIS_ERROR) return -6;
                                    if (r -= R, S += R, b.channels_out, b.mf_size += M, b.mf_samples_to_encode < 1 && (b.mf_samples_to_encode = D.ENCDELAY + D.POSTDELAY), b.mf_samples_to_encode += M, b.mf_size >= h) {
                                        var w = o - p;
                                        if (0 == o && (w = 0), (l = H(a, d[0], d[1], _, i, w)) < 0) return l;
                                        for(i += l, p += l, b.mf_size -= a.framesize, b.mf_samples_to_encode -= a.framesize, c = 0; c < b.channels_out; c++)for(f = 0; f < b.mf_size; f++)d[c][f] = d[c][f + a.framesize];
                                    }
                                }
                                return p;
                            }(s, c[0], c[1], _, i, o, l);
                        };
                    }
                    function K() {
                        this.setModules = function(e, t) {};
                    }
                    function Z() {
                        this.setModules = function(e, t, a) {};
                    }
                    function Q() {}
                    function U() {
                        this.setModules = function(e, t) {};
                    }
                    function W() {
                        this.dataOffset = 0, this.dataLen = 0, this.channels = 0, this.sampleRate = 0;
                    }
                    function J(e) {
                        return e.charCodeAt(0) << 24 | e.charCodeAt(1) << 16 | e.charCodeAt(2) << 8 | e.charCodeAt(3);
                    }
                    O.SFBMAX = 3 * D.SBMAX_s, D.ENCDELAY = 576, D.POSTDELAY = 1152, D.MDCTDELAY = 48, D.FFTOFFSET = 224 + D.MDCTDELAY, D.DECDELAY = 528, D.SBLIMIT = 32, D.CBANDS = 64, D.SBPSY_l = 21, D.SBPSY_s = 12, D.SBMAX_l = 22, D.SBMAX_s = 13, D.PSFB21 = 6, D.PSFB12 = 6, D.BLKSIZE = 1024, D.HBLKSIZE = D.BLKSIZE / 2 + 1, D.BLKSIZE_s = 256, D.HBLKSIZE_s = D.BLKSIZE_s / 2 + 1, D.NORM_TYPE = 0, D.START_TYPE = 1, D.SHORT_TYPE = 2, D.STOP_TYPE = 3, D.MPG_MD_LR_LR = 0, D.MPG_MD_LR_I = 1, D.MPG_MD_MS_LR = 2, D.MPG_MD_MS_I = 3, D.fircoef = [
                        -0.1039435,
                        -0.1892065,
                        5 * -0.0432472,
                        -0.155915,
                        3898045e-23,
                        .0467745 * 5,
                        .50455,
                        .756825,
                        .187098 * 5
                    ], F.MFSIZE = 3456 + D.ENCDELAY - D.MDCTDELAY, F.MAX_HEADER_BUF = 256, F.MAX_BITS_PER_CHANNEL = 4095, F.MAX_BITS_PER_GRANULE = 7680, F.BPC = 320, W.RIFF = J("RIFF"), W.WAVE = J("WAVE"), W.fmt_ = J("fmt "), W.data = J("data"), W.readHeader = function(e) {
                        var t = new W, a = e.getUint32(0, !1);
                        if (W.RIFF == a && (e.getUint32(4, !0), W.WAVE == e.getUint32(8, !1) && W.fmt_ == e.getUint32(12, !1))) {
                            var s = e.getUint32(16, !0), n = 20;
                            switch(s){
                                case 16:
                                case 18:
                                    t.channels = e.getUint16(n + 2, !0), t.sampleRate = e.getUint32(n + 4, !0);
                                    break;
                                default:
                                    throw "extended fmt chunk not implemented";
                            }
                            n += s;
                            for(var r = W.data, _ = 0; r != a && (a = e.getUint32(n, !1), _ = e.getUint32(n + 4, !0), r != a);)n += _ + 8;
                            return t.dataLen = _, t.dataOffset = n + 8, t;
                        }
                    }, O.SFBMAX = 3 * D.SBMAX_s, this.Mp3Encoder = function(t, a, s) {
                        3 != arguments.length && (console.error("WARN: Mp3Encoder(channels, samplerate, kbps) not specified"), t = 1, a = 44100, s = 128);
                        var n = new z, r = new K, _ = new m, i = new g, o = new p, l = new P, f = new V, c = new S, h = new b, R = new U, M = new v, A = new d, B = new Z, w = new Q;
                        n.setModules(_, i, o, l, f, c, h, R, w), i.setModules(_, w, h, c), R.setModules(i, h), o.setModules(n), f.setModules(i, M, l, A), l.setModules(A, M, n.enc.psy), M.setModules(i), A.setModules(l), c.setModules(n, i, h), r.setModules(B, w), B.setModules(h, R, o);
                        var E = n.lame_init();
                        E.num_channels = t, E.in_samplerate = a, E.brate = s, E.mode = u.STEREO, E.quality = 3, E.bWriteVbrTag = !1, E.disable_reservoir = !0, E.write_id3tag_automatic = !1, n.lame_init_params(E);
                        var T = 1152, k = 0 | 1.25 * T + 7200, y = e(k);
                        this.encodeBuffer = function(a, s) {
                            1 == t && (s = a), a.length > T && (T = a.length, y = e(k = 0 | 1.25 * T + 7200));
                            var r = n.lame_encode_buffer(E, a, s, a.length, y, 0, k);
                            return new Int8Array(y.subarray(0, r));
                        }, this.flush = function() {
                            var e = n.lame_encode_flush(E, y, 0, k);
                            return new Int8Array(y.subarray(0, e));
                        };
                    }, this.WavHeader = W;
                };
            },
            {}
        ]
    }, {}, [
        1
    ])(1);
});


var $5d5077b5b986c9bc$export$1e511d4a378977f5;
var $5d5077b5b986c9bc$export$40b2248fa055142e;
"use strict";
$5d5077b5b986c9bc$export$1e511d4a378977f5 = true;
$5d5077b5b986c9bc$export$40b2248fa055142e = void 0;
/**
 *
 * detectIncognito v1.3.0 - (c) 2022 Joe Rutkowski <Joe@dreggle.com> (https://github.com/Joe12387/detectIncognito)
 *
 **/ var $5d5077b5b986c9bc$var$detectIncognito = function() {
    return new Promise(function(resolve, reject) {
        var browserName = "Unknown";
        function __callback(isPrivate) {
            resolve({
                isPrivate: isPrivate,
                browserName: browserName
            });
        }
        function identifyChromium() {
            var ua = navigator.userAgent;
            if (ua.match(/Chrome/)) {
                if (navigator.brave !== undefined) return "Brave";
                else if (ua.match(/Edg/)) return "Edge";
                else if (ua.match(/OPR/)) return "Opera";
                return "Chrome";
            } else return "Chromium";
        }
        function assertEvalToString(value) {
            return value === eval.toString().length;
        }
        function isSafari() {
            var v = navigator.vendor;
            return v !== undefined && v.indexOf("Apple") === 0 && assertEvalToString(37);
        }
        function isChrome() {
            var v = navigator.vendor;
            return v !== undefined && v.indexOf("Google") === 0 && assertEvalToString(33);
        }
        function isFirefox() {
            return document.documentElement !== undefined && document.documentElement.style.MozAppearance !== undefined && assertEvalToString(37);
        }
        function isMSIE() {
            return navigator.msSaveBlob !== undefined && assertEvalToString(39);
        }
        /**
         * Safari (Safari for iOS & macOS)
         **/ function newSafariTest() {
            var tmp_name = String(Math.random());
            try {
                var db = window.indexedDB.open(tmp_name, 1);
                db.onupgradeneeded = function(i) {
                    var _a, _b;
                    var res = (_a = i.target) === null || _a === void 0 ? void 0 : _a.result;
                    try {
                        res.createObjectStore("test", {
                            autoIncrement: true
                        }).put(new Blob);
                        __callback(false);
                    } catch (e) {
                        var message = e;
                        if (e instanceof Error) message = (_b = e.message) !== null && _b !== void 0 ? _b : e;
                        if (typeof message !== "string") return __callback(false);
                        var matchesExpectedError = /BlobURLs are not yet supported/.test(message);
                        return __callback(matchesExpectedError);
                    } finally{
                        res.close();
                        window.indexedDB.deleteDatabase(tmp_name);
                    }
                };
            } catch (e) {
                return __callback(false);
            }
        }
        function oldSafariTest() {
            var openDB = window.openDatabase;
            var storage = window.localStorage;
            try {
                openDB(null, null, null, null);
            } catch (e) {
                return __callback(true);
            }
            try {
                storage.setItem("test", "1");
                storage.removeItem("test");
            } catch (e) {
                return __callback(true);
            }
            return __callback(false);
        }
        function safariPrivateTest() {
            if (navigator.maxTouchPoints !== undefined) newSafariTest();
            else oldSafariTest();
        }
        /**
         * Chrome
         **/ function getQuotaLimit() {
            var w = window;
            if (w.performance !== undefined && w.performance.memory !== undefined && w.performance.memory.jsHeapSizeLimit !== undefined) return performance.memory.jsHeapSizeLimit;
            return 1073741824;
        }
        // >= 76
        function storageQuotaChromePrivateTest() {
            navigator.webkitTemporaryStorage.queryUsageAndQuota(function(_, quota) {
                var quotaInMib = Math.round(quota / 1048576);
                var quotaLimitInMib = Math.round(getQuotaLimit() / 1048576) * 2;
                __callback(quotaInMib < quotaLimitInMib);
            }, function(e) {
                reject(new Error("detectIncognito somehow failed to query storage quota: " + e.message));
            });
        }
        // 50 to 75
        function oldChromePrivateTest() {
            var fs = window.webkitRequestFileSystem;
            var success = function() {
                __callback(false);
            };
            var error = function() {
                __callback(true);
            };
            fs(0, 1, success, error);
        }
        function chromePrivateTest() {
            if (self.Promise !== undefined && self.Promise.allSettled !== undefined) storageQuotaChromePrivateTest();
            else oldChromePrivateTest();
        }
        /**
         * Firefox
         **/ function firefoxPrivateTest() {
            __callback(navigator.serviceWorker === undefined);
        }
        /**
         * MSIE
         **/ function msiePrivateTest() {
            __callback(window.indexedDB === undefined);
        }
        function main() {
            if (isSafari()) {
                browserName = "Safari";
                safariPrivateTest();
            } else if (isChrome()) {
                browserName = identifyChromium();
                chromePrivateTest();
            } else if (isFirefox()) {
                browserName = "Firefox";
                firefoxPrivateTest();
            } else if (isMSIE()) {
                browserName = "Internet Explorer";
                msiePrivateTest();
            } else reject(new Error("detectIncognito cannot determine the browser"));
        }
        main();
    });
};
$5d5077b5b986c9bc$export$40b2248fa055142e = $5d5077b5b986c9bc$var$detectIncognito;


const $548a1d91083ea662$export$18964e4f616ed5c8 = async (callback)=>{
    const vrCapable = await (async ()=>{
        try {
            return await navigator.xr?.isSessionSupported("immersive-vr");
        } catch (error) {
            return false;
        }
    })();
    const arCapable = await (async ()=>{
        try {
            return await navigator.xr?.isSessionSupported("immersive-ar");
        } catch (error) {
            return false;
        }
    })();
    let isIncognito;
    await (0, $5d5077b5b986c9bc$export$40b2248fa055142e)().then((result)=>{
        isIncognito = result.isPrivate;
    });
    const iOS = /^iP/.test(navigator.platform) || /^Mac/.test(navigator.platform) && navigator.maxTouchPoints > 4;
    const width = window.innerWidth;
    // console.log(`userAgent: ${navigator.userAgent}`)
    // console.log(`vendor: ${navigator.vendor}`)
    // console.log(`opera: ${navigator.opera}`)
    // console.log(`userAgentData.mobile: ${navigator.userAgentData?.mobile}`)
    // console.log(`regex: ${mobileRegex(navigator.userAgent || navigator.vendor || window.opera)}`)
    // console.log(`width: ${width}`)
    // console.log(!/CriOS/i.test(navigator.userAgent))
    // console.log(window.chrome !== null)
    // console.log(typeof window.chrome !== "undefined")
    // console.log(window.navigator.vendor === "Google Inc.")
    // console.log(typeof window.opr === "undefined")
    // console.log(window.navigator.userAgent.indexOf("Edge") <= -1)
    const isMobile = navigator.userAgentData?.mobile || iOS || width && width < 768 || $548a1d91083ea662$var$mobileRegex(navigator.userAgent || navigator.vendor || window.opera);
    const isSecure = window.location.protocol === "https:";
    const isSafari = iOS && !/CriOS/i.test(navigator.userAgent) && !/FxiOS/i.test(navigator.userAgent);
    const isChrome = !/Samsung/i.test(navigator.userAgent) && !/CriOS/i.test(navigator.userAgent) && window.chrome !== null && typeof window.chrome !== "undefined" && window.navigator.vendor === "Google Inc." && typeof window.opr === "undefined" && window.navigator.userAgent.indexOf("Edge") <= -1;
    const isEyejack = /EyeJack/i.test(navigator.userAgent);
    console.log("Retrieved intrisics");
    let instrinsics = {
        vrCapable: vrCapable,
        arCapable: arCapable,
        isMobile: isMobile,
        iOS: iOS,
        isSecure: isSecure,
        isIncognito: isIncognito,
        isSafari: isSafari,
        isChrome: isChrome,
        isEyejack: isEyejack
    };
    console.log(instrinsics);
    callback(instrinsics);
};
function $548a1d91083ea662$var$mobileRegex(a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) return true;
    return false;
}


const $bcfee5bf3b0094f1$export$83d89fbfd8236492 = {
    major: 1,
    minor: 2,
    patch: 0
};


const $6dd76e03ab0430e4$export$dd0364c440fe3322 = "HCAP_holovideo";
var $6dd76e03ab0430e4$export$870f5fb4eac0396b;
(function(StreamMode) {
    StreamMode[StreamMode["Automatic"] = 0] = "Automatic";
    StreamMode[StreamMode["MP4"] = 1] = "MP4";
    StreamMode[StreamMode["HLS"] = 2] = "HLS";
    StreamMode[StreamMode["Dash"] = 3] = "Dash";
})($6dd76e03ab0430e4$export$870f5fb4eac0396b || ($6dd76e03ab0430e4$export$870f5fb4eac0396b = {}));



class $6165386d9ecd96e9$export$f3bcef630ce7ca1e {
    _logger;
    _browserInfo;
    _fileInfo;
    gl;
    createOptions;
    caps;
    capsStr;
    nextPbo;
    readPbo;
    readFences;
    outputBufferIndex;
    texCopyVerts;
    textures;
    texCopyShader;
    fbo1;
    fbo2;
    pixelBuffers;
    octNormalsShader;
    contextRestoring;
    outputBuffers;
    normalsVao;
    normalsTF;
    vaos;
    transformFeedbacks;
    tfShader;
    deltasBuf;
    watermarkPixels;
    clientBuffers;
    constructor(context){
        this.gl = context;
    }
    initialize(logger, onContextLost, onContextRestored, browserInfo, createOptions, handleContextRestore = true) {
        this._logger = logger;
        if (!this.gl) {
            this._logger._logError("The WebGL backend needs the gl context!");
            return false;
        }
        this._browserInfo = browserInfo;
        this.createOptions = {
            disableAsyncDecode: false,
            numAsyncFrames: 3,
            disableTransformFeedback: false,
            ...createOptions
        };
        if (this.createOptions.numAsyncFrames < 2) {
            this._logger._logWarning("numAsyncFrames must be at least 2 (" + this.createOptions.numAsyncFrames + " specified)");
            this.createOptions.numAsyncFrames = 2;
        }
        if (handleContextRestore) {
            const canvas = this.gl.canvas;
            canvas.addEventListener("webglcontextlost", (event)=>{
                event.preventDefault();
                onContextLost();
            }, false);
            canvas.addEventListener("webglcontextrestored", (event)=>{
                this.contextRestoring = true;
                this._initializeWebGLResources();
                if (this._fileInfo) this.onLoaded(this._fileInfo);
                onContextRestored();
                this.contextRestoring = false;
            }, false);
        }
        this._initializeWebGLResources();
        return true;
    }
    onBeforeLoad(openOptions) {
        this.nextPbo = 0;
        this._deleteReadFences(this.gl);
    }
    onLoaded(fileInfo) {
        this._fileInfo = fileInfo;
        this._logger._logInfo(this.capsStr);
        const gl = this.gl;
        gl.bindTexture(gl.TEXTURE_2D, this.clientBuffers.tex);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, fileInfo.videoWidth, fileInfo.videoHeight, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        if (fileInfo.haveNormals) this.clientBuffers.norBuf = gl.createBuffer();
        if (this.outputBuffers) {
            const gl = this.gl;
            var saveVb = gl.getParameter(gl.ARRAY_BUFFER_BINDING);
            for(var i = 0; i < 3; ++i){
                gl.bindBuffer(gl.ARRAY_BUFFER, this.outputBuffers[i]);
                gl.bufferData(gl.ARRAY_BUFFER, 12 * fileInfo.maxVertexCount, gl.STREAM_COPY);
            }
            gl.bindBuffer(gl.ARRAY_BUFFER, saveVb);
        }
    }
    onSeekToTimeCompleted() {
        this.nextPbo = 0;
    }
    onRewind() {
        this.nextPbo = 0;
        this._deleteReadFences(this.gl);
    }
    onClose() {}
    release() {
        this._releaseWebGLResources(this.gl);
    }
    _createProgram(vertexShaderSource, fragmentShaderSource, preLink) {
        function createShader(source, type) {
            var shader = gl.createShader(type);
            gl.shaderSource(shader, source);
            gl.compileShader(shader);
            return shader;
        }
        const gl = this.gl;
        var program = gl.createProgram();
        var vshader = createShader(vertexShaderSource, gl.VERTEX_SHADER);
        gl.attachShader(program, vshader);
        var fshader = createShader(fragmentShaderSource, gl.FRAGMENT_SHADER);
        gl.attachShader(program, fshader);
        if (preLink) preLink(program);
        gl.linkProgram(program);
        var log = gl.getProgramInfoLog(program);
        if (log) this._logger._logError(log);
        log = gl.getShaderInfoLog(vshader);
        if (log) this._logger._logError(log);
        log = gl.getShaderInfoLog(fshader);
        if (log) this._logger._logError(log);
        gl.deleteShader(vshader);
        gl.deleteShader(fshader);
        return program;
    }
    _initializeWebGLResources() {
        var caps = {};
        const gl = this.gl;
        var version = gl.getParameter(gl.VERSION);
        caps.webgl2 = version.indexOf("WebGL 2.") != -1;
        caps.badTF = this.createOptions.disableTransformFeedback ?? false;
        if (this._browserInfo.isSafari || this._browserInfo.isMozillaWebXRViewer) caps.webgl2 = false;
        var debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
        if (debugInfo) {
            caps.vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
            caps.renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
            caps.isSafari = this._browserInfo.isSafari;
            caps.iOSVersion = this._browserInfo.iOSVersion;
            if (caps.renderer.indexOf("Mali") != -1) caps.badTF = true;
        }
        this.capsStr = JSON.stringify(caps, null, 4);
        this.caps = caps;
        this.fbo1 = gl.createFramebuffer();
        if (this.caps.webgl2) {
            this.caps.supports32BitIndices = true;
            if (!this.caps.badTF) this._setupTransformFeedback();
            if (this.createOptions.disableAsyncDecode) this.textures = [
                null
            ];
            else {
                this.textures = new Array(this.createOptions.numAsyncFrames);
                this.pixelBuffers = new Array(this.createOptions.numAsyncFrames);
                this.readFences = new Array(this.createOptions.numAsyncFrames);
                this.nextPbo = 0;
            }
        } else {
            this.caps.supports32BitIndices = gl.getExtension("OES_element_index_uint") != null;
            if (!this.caps.supports32BitIndices) this._logger._logWarning("WebGL1: extension 'OES_element_index_uint' not supported, captures w/32-bit index data will not be playable");
            this.textures = [
                null
            ];
        }
        this.fbo2 = gl.createFramebuffer();
        const psSource = `#version 100
        precision highp float;

        uniform lowp sampler2D textureSampler;
        uniform bool useGammaCorrection;

        vec3 toLinear(vec3 color) { return pow(color, vec3(2.2)); }

        varying mediump vec2 uv;
        void main()
        {
            vec3 color = texture2D(textureSampler, uv).xyz;

            vec3 adjustedColor = useGammaCorrection
                ? toLinear(color)
                : color;

            gl_FragColor = vec4(adjustedColor, 1.0);
        }
        `;
        const vsSource = `#version 100
        attribute mediump vec2 pos;
        varying mediump vec2 uv;
        void main()
        {
            uv = (0.5 * pos + vec2(0.5, 0.5));
            gl_Position = vec4(pos, 0.0, 1.0);
        }
        `;
        const texCopyVertexAttribLoc = 0;
        const prelink = (program)=>{
            gl.bindAttribLocation(program, texCopyVertexAttribLoc, "pos");
        };
        const texCopyShader = this._createProgram(vsSource, psSource, prelink);
        texCopyShader.useGammaCorrectionLoc = gl.getUniformLocation(texCopyShader, "useGammaCorrection");
        texCopyShader.vertexAttribLoc = texCopyVertexAttribLoc;
        texCopyShader.textureSamplerLoc = gl.getUniformLocation(texCopyShader, "textureSampler");
        this.texCopyShader = texCopyShader;
        this.texCopyShader.vertexAttribLoc = texCopyVertexAttribLoc;
        this.texCopyVerts = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.texCopyVerts);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([
            -1,
            3.0,
            3.0,
            -1,
            -1,
            -1
        ]), gl.STATIC_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        var saveTex = gl.getParameter(gl.TEXTURE_BINDING_2D);
        for(var i = 0; i < this.textures.length; ++i){
            this.textures[i] = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, this.textures[i]);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        }
        gl.bindTexture(gl.TEXTURE_2D, saveTex);
        this.clientBuffers = {
            indexBuf: gl.createBuffer(),
            norBuf: null,
            posBuf: gl.createBuffer(),
            tex: gl.createTexture(),
            uvBuf: gl.createBuffer()
        };
    }
    _deleteReadFences(gl) {
        if (this.readFences) {
            for(var i = 0; i < this.readFences.length; ++i)if (this.readFences[i] && gl instanceof WebGL2RenderingContext) {
                gl.deleteSync(this.readFences[i]);
                this.readFences[i] = null;
            }
        }
    }
    _releaseWebGLResources(gl) {
        if (this.caps.webgl2 && !this.caps.badTF && gl instanceof WebGL2RenderingContext) {
            gl.deleteBuffer(this.deltasBuf);
            for(var i = 0; i < 3; ++i){
                gl.deleteBuffer(this.outputBuffers[i]);
                this.outputBuffers[i] = null;
                gl.deleteTransformFeedback(this.transformFeedbacks[i]);
                this.transformFeedbacks[i] = null;
                gl.deleteVertexArray(this.vaos[i]);
                this.vaos[i] = null;
            }
            gl.deleteTransformFeedback(this.normalsTF);
            this.normalsTF = null;
            gl.deleteVertexArray(this.normalsVao);
            this.normalsVao = null;
            gl.deleteProgram(this.tfShader);
            this.tfShader = null;
            gl.deleteProgram(this.octNormalsShader);
            this.octNormalsShader = null;
        }
        if (this.texCopyShader) {
            gl.deleteProgram(this.texCopyShader);
            this.texCopyShader = null;
        }
        if (this.texCopyVerts) {
            gl.deleteBuffer(this.texCopyVerts);
            this.texCopyVerts = null;
        }
        if (this.pixelBuffers) for(var i = 0; i < this.pixelBuffers.length; ++i){
            gl.deleteBuffer(this.pixelBuffers[i]);
            this.pixelBuffers[i] = null;
        }
        this._deleteReadFences(this.gl);
        this.nextPbo = 0;
        for(var i = 0; i < this.textures.length; ++i)gl.deleteTexture(this.textures[i]);
        if (this.fbo1) {
            gl.deleteFramebuffer(this.fbo1);
            this.fbo1 = null;
        }
        if (this.fbo2) {
            gl.deleteFramebuffer(this.fbo2);
            this.fbo2 = null;
        }
        if (this.clientBuffers.tex) gl.deleteTexture(this.clientBuffers.tex);
        if (this.clientBuffers.posBuf) gl.deleteBuffer(this.clientBuffers.posBuf);
        if (this.clientBuffers.uvBuf) gl.deleteBuffer(this.clientBuffers.uvBuf);
        if (this.clientBuffers.norBuf) gl.deleteBuffer(this.clientBuffers.norBuf);
        if (this.clientBuffers.indexBuf) gl.deleteBuffer(this.clientBuffers.indexBuf);
        this.clientBuffers.tex = null;
        this.clientBuffers.posBuf = null;
        this.clientBuffers.uvBuf = null;
        this.clientBuffers.norBuf = null;
        this.clientBuffers.indexBuf = null;
    }
    _setupTransformFeedback() {
        var gl = this.gl;
        this.outputBufferIndex = 0;
        this.deltasBuf = gl.createBuffer();
        this.outputBuffers = [
            gl.createBuffer(),
            gl.createBuffer(),
            gl.createBuffer()
        ];
        this.transformFeedbacks = [
            gl.createTransformFeedback(),
            gl.createTransformFeedback(),
            gl.createTransformFeedback()
        ];
        this.vaos = [
            gl.createVertexArray(),
            gl.createVertexArray(),
            gl.createVertexArray()
        ];
        gl.bindVertexArray(null);
        for(var i = 0; i < 3; ++i){
            gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, this.transformFeedbacks[i]);
            gl.bindBufferBase(gl.TRANSFORM_FEEDBACK_BUFFER, 0, this.outputBuffers[i]);
        }
        this.normalsVao = gl.createVertexArray();
        this.normalsTF = gl.createTransformFeedback();
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null);
        gl.bindBuffer(gl.TRANSFORM_FEEDBACK_BUFFER, null);
        var tfShaderSourcePS = `#version 300 es
            out lowp vec4 fragColor;
            void main()
            {
                fragColor = vec4(0,0,0,0);
            }
            `;
        var tfShaderSourceVS = `#version 300 es
            in vec3 inQuantized;
            in vec3 prevPos;
            in vec3 prevPrevPos;

            uniform vec3 decodeMin;
            uniform vec3 decodeMax;
            uniform int havePrevPos;
            uniform int havePrevPrevPos;

            out vec3 outPos;

            void main()
            {
                if (havePrevPos == 1)
                {
                    vec3 dm = vec3(0.0, 0.0, 0.0);

                    if (havePrevPrevPos == 1)
                    {
                        dm = prevPos - prevPrevPos;
                    }

                    vec3 delta = (decodeMax - decodeMin) * inQuantized + decodeMin;
                    outPos = prevPos + dm + delta;
                }

                else
                {
                    outPos = (decodeMax - decodeMin) * inQuantized + decodeMin;
                }
            }`;
        var tfShader = this._createProgram(tfShaderSourceVS, tfShaderSourcePS, function(program) {
            gl.transformFeedbackVaryings(program, [
                "outPos"
            ], gl.SEPARATE_ATTRIBS);
        });
        tfShader.havePrevPosLoc = gl.getUniformLocation(tfShader, "havePrevPos");
        tfShader.havePrevPrevPosLoc = gl.getUniformLocation(tfShader, "havePrevPrevPos");
        tfShader.decodeMinLoc = gl.getUniformLocation(tfShader, "decodeMin");
        tfShader.decodeMaxLoc = gl.getUniformLocation(tfShader, "decodeMax");
        tfShader.inQuantizedLoc = gl.getAttribLocation(tfShader, "inQuantized");
        tfShader.prevPosLoc = gl.getAttribLocation(tfShader, "prevPos");
        tfShader.prevPrevPosLoc = gl.getAttribLocation(tfShader, "prevPrevPos");
        this.tfShader = tfShader;
        var octNormalsShaderSourceVS = `#version 300 es
            in vec2 inOctNormal;
            out vec3 outNormal;

            vec3 OctDecode(vec2 f)
            {
                f = f * 2.0 - 1.0;

                // https://twitter.com/Stubbesaurus/status/937994790553227264
                vec3 n = vec3( f.x, f.y, 1.0 - abs(f.x) - abs(f.y));
                float t = clamp(-n.z, 0.0, 1.0);
                n.x += n.x >= 0.0 ? -t : t;
                n.y += n.y >= 0.0 ? -t : t;
                return normalize(n);
            }

            void main()
            {
                outNormal = OctDecode(inOctNormal);
            }`;
        var octNormalsShader = this._createProgram(octNormalsShaderSourceVS, tfShaderSourcePS, function(program) {
            gl.transformFeedbackVaryings(program, [
                "outNormal"
            ], gl.SEPARATE_ATTRIBS);
        });
        octNormalsShader.inOctNormalLoc = gl.getAttribLocation(octNormalsShader, "inOctNormal");
        this.octNormalsShader = octNormalsShader;
    }
    updateMeshFromCompressedBuffers(meshState, sourceBuffers, updateClientBuffers, wasSeeking) {
        if (!this.caps.webgl2 || this.caps.badTF) return false;
        var gl = this.gl;
        meshState.curMesh.outputBuffer = this.outputBuffers[this.outputBufferIndex];
        var saveVb = gl.getParameter(gl.ARRAY_BUFFER_BINDING);
        var saveIb = gl.getParameter(gl.ELEMENT_ARRAY_BUFFER_BINDING);
        var saveShader = gl.getParameter(gl.CURRENT_PROGRAM);
        var saveVa = gl.getParameter(gl.VERTEX_ARRAY_BINDING);
        gl.useProgram(this.tfShader);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        var vertexCount = 0;
        var tfShader = this.tfShader;
        if (meshState.curMesh.primitives[0].extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].attributes.POSITION) {
            if (updateClientBuffers) {
                gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.clientBuffers.indexBuf);
                gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, sourceBuffers.indices, gl.STATIC_DRAW);
                gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, saveIb);
                gl.bindBuffer(gl.ARRAY_BUFFER, this.clientBuffers.uvBuf);
                gl.bufferData(gl.ARRAY_BUFFER, sourceBuffers.compressedUVs, gl.STATIC_DRAW);
            }
            gl.bindVertexArray(this.vaos[0]);
            vertexCount = meshState.curMesh.compressedPos.count;
            gl.bindBuffer(gl.ARRAY_BUFFER, this.deltasBuf);
            gl.bufferData(gl.ARRAY_BUFFER, sourceBuffers.compressedPos, gl.DYNAMIC_DRAW);
            gl.enableVertexAttribArray(tfShader.inQuantizedLoc);
            gl.vertexAttribPointer(tfShader.inQuantizedLoc, 3, meshState.curMesh.compressedPos.componentType, true, 0, 0);
            gl.disableVertexAttribArray(tfShader.prevPosLoc);
            gl.disableVertexAttribArray(tfShader.prevPrevPosLoc);
            var min = meshState.curMesh.compressedPos.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].decodeMin;
            var max = meshState.curMesh.compressedPos.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].decodeMax;
            gl.uniform3fv(tfShader.decodeMinLoc, min);
            gl.uniform3fv(tfShader.decodeMaxLoc, max);
            gl.uniform1i(tfShader.havePrevPosLoc, 0);
            gl.uniform1i(tfShader.havePrevPrevPosLoc, 0);
        } else {
            vertexCount = meshState.curMesh.deltas.count;
            if (meshState.prevPrevMesh == null) gl.bindVertexArray(this.vaos[1]);
            else gl.bindVertexArray(this.vaos[2]);
            gl.bindBuffer(gl.ARRAY_BUFFER, this.deltasBuf);
            gl.bufferData(gl.ARRAY_BUFFER, sourceBuffers.deltas, gl.DYNAMIC_DRAW);
            gl.enableVertexAttribArray(tfShader.inQuantizedLoc);
            gl.vertexAttribPointer(tfShader.inQuantizedLoc, 3, meshState.curMesh.deltas.componentType, true, 0, 0);
            gl.uniform3fv(tfShader.decodeMinLoc, meshState.curMesh.deltas.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].decodeMin);
            gl.uniform3fv(tfShader.decodeMaxLoc, meshState.curMesh.deltas.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].decodeMax);
            gl.uniform1i(tfShader.havePrevPosLoc, 1);
            gl.bindBuffer(gl.ARRAY_BUFFER, meshState.prevMesh.outputBuffer);
            gl.enableVertexAttribArray(tfShader.prevPosLoc);
            gl.vertexAttribPointer(tfShader.prevPosLoc, 3, gl.FLOAT, false, 0, 0);
            if (meshState.prevPrevMesh == null) {
                gl.uniform1i(tfShader.havePrevPrevPosLoc, 0);
                gl.disableVertexAttribArray(tfShader.prevPrevPosLoc);
            } else {
                gl.uniform1i(tfShader.havePrevPrevPosLoc, 1);
                gl.bindBuffer(gl.ARRAY_BUFFER, meshState.prevPrevMesh.outputBuffer);
                gl.enableVertexAttribArray(tfShader.prevPrevPosLoc);
                gl.vertexAttribPointer(tfShader.prevPrevPosLoc, 3, gl.FLOAT, false, 0, 0);
            }
        }
        var bufferSize = vertexCount * 12;
        gl.bindBuffer(gl.ARRAY_BUFFER, meshState.curMesh.outputBuffer);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, this.transformFeedbacks[this.outputBufferIndex]);
        gl.enable(gl.RASTERIZER_DISCARD);
        gl.beginTransformFeedback(gl.POINTS);
        gl.drawArrays(gl.POINTS, 0, vertexCount);
        gl.endTransformFeedback();
        gl.disable(gl.RASTERIZER_DISCARD);
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null);
        gl.bindBuffer(gl.TRANSFORM_FEEDBACK_BUFFER, null);
        if (updateClientBuffers) {
            gl.bindBuffer(gl.COPY_READ_BUFFER, meshState.curMesh.outputBuffer);
            gl.bindBuffer(gl.COPY_WRITE_BUFFER, this.clientBuffers.posBuf);
            gl.bufferData(gl.COPY_WRITE_BUFFER, bufferSize, gl.DYNAMIC_COPY);
            gl.copyBufferSubData(gl.COPY_READ_BUFFER, gl.COPY_WRITE_BUFFER, 0, 0, bufferSize);
            gl.bindBuffer(gl.COPY_READ_BUFFER, null);
            gl.bindBuffer(gl.COPY_WRITE_BUFFER, null);
            if (wasSeeking) {
                gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.clientBuffers.indexBuf);
                gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, meshState.lastKeyframeIndices, gl.DYNAMIC_DRAW);
                gl.bindBuffer(gl.ARRAY_BUFFER, this.clientBuffers.uvBuf);
                gl.bufferData(gl.ARRAY_BUFFER, meshState.lastKeyframeUVs, gl.DYNAMIC_DRAW);
            }
        }
        this.outputBufferIndex = (this.outputBufferIndex + 1) % 3;
        if (this.clientBuffers.norBuf && sourceBuffers.compressedNormals && updateClientBuffers) {
            if (this._fileInfo.octEncodedNormals) {
                gl.useProgram(this.octNormalsShader);
                gl.bindBuffer(gl.ARRAY_BUFFER, null);
                gl.bindVertexArray(this.normalsVao);
                gl.bindBuffer(gl.ARRAY_BUFFER, this.deltasBuf);
                gl.bufferData(gl.ARRAY_BUFFER, sourceBuffers.compressedNormals, gl.DYNAMIC_DRAW);
                gl.enableVertexAttribArray(this.octNormalsShader.inOctNormalLoc);
                gl.vertexAttribPointer(this.octNormalsShader.inOctNormalLoc, 2, gl.UNSIGNED_BYTE, true, 0, 0);
                var bufferSize = vertexCount * 12;
                gl.bindBuffer(gl.ARRAY_BUFFER, this.clientBuffers.norBuf);
                gl.bufferData(gl.ARRAY_BUFFER, bufferSize, gl.DYNAMIC_DRAW);
                gl.bindBuffer(gl.ARRAY_BUFFER, null);
                gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, this.normalsTF);
                gl.bindBufferBase(gl.TRANSFORM_FEEDBACK_BUFFER, 0, this.clientBuffers.norBuf);
                gl.enable(gl.RASTERIZER_DISCARD);
                gl.beginTransformFeedback(gl.POINTS);
                gl.drawArrays(gl.POINTS, 0, vertexCount);
                gl.endTransformFeedback();
                gl.disable(gl.RASTERIZER_DISCARD);
                gl.bindBufferBase(gl.TRANSFORM_FEEDBACK_BUFFER, 0, null);
                gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null);
                gl.bindBuffer(gl.TRANSFORM_FEEDBACK_BUFFER, null);
            } else {
                gl.bindBuffer(gl.ARRAY_BUFFER, this.clientBuffers.norBuf);
                gl.bufferData(gl.ARRAY_BUFFER, sourceBuffers.compressedNormals, gl.DYNAMIC_DRAW);
            }
        }
        gl.useProgram(saveShader);
        gl.bindBuffer(gl.ARRAY_BUFFER, saveVb);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, saveIb);
        gl.bindVertexArray(saveVa);
        return true;
    }
    _getSrgbTextureFormat() {
        const { gl: gl, caps: caps } = this;
        if (caps.webgl2 || gl instanceof WebGL2RenderingContext) return {
            internal: gl.SRGB8_ALPHA8,
            external: gl.RGBA
        };
        const extension = gl.getExtension("EXT_sRGB");
        if (!extension) return {
            internal: gl.RGBA,
            external: gl.RGBA
        };
        return {
            internal: extension.SRGB_EXT,
            external: extension.SRGB_EXT
        };
    }
    _copyTexture(source, destination, width, height, useGammaCorrection) {
        const { gl: gl, texCopyShader: texCopyShader } = this;
        const saveVb = gl.getParameter(gl.ARRAY_BUFFER_BINDING);
        const saveShader = gl.getParameter(gl.CURRENT_PROGRAM);
        const saveViewport = gl.getParameter(gl.VIEWPORT);
        const saveScissor = gl.isEnabled(gl.SCISSOR_TEST);
        const saveCulling = gl.isEnabled(gl.CULL_FACE);
        const saveBlend = gl.isEnabled(gl.BLEND);
        const saveActiveTexture = gl.getParameter(gl.ACTIVE_TEXTURE);
        const saveVertexAttribBufferBiding = gl.getVertexAttrib(texCopyShader.vertexAttribLoc, gl.VERTEX_ATTRIB_ARRAY_BUFFER_BINDING);
        const saveVertexAttribEnabled = gl.getVertexAttrib(texCopyShader.vertexAttribLoc, gl.VERTEX_ATTRIB_ARRAY_ENABLED);
        const saveVertexAttribArraySize = gl.getVertexAttrib(texCopyShader.vertexAttribLoc, gl.VERTEX_ATTRIB_ARRAY_SIZE);
        const saveVertexAttribArrayType = gl.getVertexAttrib(texCopyShader.vertexAttribLoc, gl.VERTEX_ATTRIB_ARRAY_TYPE);
        const saveVertexAttribNormalized = gl.getVertexAttrib(texCopyShader.vertexAttribLoc, gl.VERTEX_ATTRIB_ARRAY_NORMALIZED);
        const saveVertexAttribArrayStride = gl.getVertexAttrib(texCopyShader.vertexAttribLoc, gl.VERTEX_ATTRIB_ARRAY_STRIDE);
        const saveVertexAttribOffset = gl.getVertexAttribOffset(texCopyShader.vertexAttribLoc, gl.VERTEX_ATTRIB_ARRAY_POINTER);
        gl.activeTexture(gl.TEXTURE0);
        const saveTex = gl.getParameter(gl.TEXTURE_BINDING_2D);
        if (useGammaCorrection && !this.createOptions.useImmutableTexture) {
            gl.bindTexture(gl.TEXTURE_2D, destination);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        }
        gl.bindFramebuffer(gl.FRAMEBUFFER, this.fbo2);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, destination, 0);
        gl.viewport(0, 0, width, height);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.BLEND);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.bindTexture(gl.TEXTURE_2D, source);
        gl.useProgram(texCopyShader);
        gl.uniform1i(texCopyShader.textureSamplerLoc, 0);
        gl.uniform1i(texCopyShader.useGammaCorrectionLoc, Number(useGammaCorrection));
        gl.bindBuffer(gl.ARRAY_BUFFER, this.texCopyVerts);
        gl.enableVertexAttribArray(texCopyShader.vertexAttribLoc);
        gl.vertexAttribPointer(texCopyShader.vertexAttribLoc, 2, gl.FLOAT, false, 0, 0);
        gl.drawArrays(gl.TRIANGLES, 0, 3);
        gl.useProgram(saveShader);
        gl.bindBuffer(gl.ARRAY_BUFFER, saveVertexAttribBufferBiding);
        gl.vertexAttribPointer(texCopyShader.vertexAttribLoc, saveVertexAttribArraySize, saveVertexAttribArrayType, saveVertexAttribNormalized, saveVertexAttribArrayStride, saveVertexAttribOffset);
        if (saveVertexAttribEnabled) gl.enableVertexAttribArray(texCopyShader.vertexAttribLoc);
        else gl.disableVertexAttribArray(texCopyShader.vertexAttribLoc);
        gl.bindBuffer(gl.ARRAY_BUFFER, saveVb);
        gl.viewport(saveViewport[0], saveViewport[1], saveViewport[2], saveViewport[3]);
        if (saveScissor) gl.enable(gl.SCISSOR_TEST);
        if (saveBlend) gl.enable(gl.BLEND);
        if (saveCulling) gl.enable(gl.CULL_FACE);
        gl.bindTexture(gl.TEXTURE_2D, saveTex);
        gl.activeTexture(saveActiveTexture);
    }
    setBuffers(clientBuffers) {
        this.clientBuffers = clientBuffers;
    }
    setBuffersFromTypedArrays(clientBuffers) {
        this.clientBuffers = clientBuffers;
    }
    updateClientBuffers(indices, positions, uvs, normals, staticDraw) {
        var saveVb = this.gl.getParameter(this.gl.ARRAY_BUFFER_BINDING);
        var saveIb = this.gl.getParameter(this.gl.ELEMENT_ARRAY_BUFFER_BINDING);
        const usage = staticDraw ? this.gl.STATIC_DRAW : this.gl.DYNAMIC_DRAW;
        if (indices) {
            if (this.clientBuffers.indexBuf instanceof WebGLBuffer) {
                this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, this.clientBuffers.indexBuf);
                this.gl.bufferData(this.gl.ELEMENT_ARRAY_BUFFER, indices, usage);
            } else this.clientBuffers.indexBuf.set(indices);
        }
        if (positions) {
            if (this.clientBuffers.posBuf instanceof WebGLBuffer) {
                this.gl.bindBuffer(this.gl.ARRAY_BUFFER, this.clientBuffers.posBuf);
                this.gl.bufferData(this.gl.ARRAY_BUFFER, positions, usage);
            } else this.clientBuffers.posBuf.set(positions);
        }
        if (uvs) {
            if (this.clientBuffers.uvBuf instanceof WebGLBuffer) {
                this.gl.bindBuffer(this.gl.ARRAY_BUFFER, this.clientBuffers.uvBuf);
                this.gl.bufferData(this.gl.ARRAY_BUFFER, uvs, usage);
            } else this.clientBuffers.uvBuf.set(uvs);
        }
        if (normals) {
            if (this.clientBuffers.norBuf instanceof WebGLBuffer) {
                this.gl.bindBuffer(this.gl.ARRAY_BUFFER, this.clientBuffers.norBuf);
                this.gl.bufferData(this.gl.ARRAY_BUFFER, normals, usage);
            } else this.clientBuffers.norBuf.set(normals);
        }
        this.gl.bindBuffer(this.gl.ARRAY_BUFFER, saveVb);
        this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, saveIb);
    }
    setTexture(image) {
        const gl = this.gl;
        gl.pixelStorei(gl.PACK_ALIGNMENT, 4);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
        const saveTex = gl.getParameter(gl.TEXTURE_BINDING_2D);
        gl.bindTexture(gl.TEXTURE_2D, this.clientBuffers.tex);
        const useGammaCorrection = !!this.createOptions.outputLinearTextures;
        const srgbFormat = this._getSrgbTextureFormat();
        const defaultFormat = {
            internal: gl.RGBA,
            external: gl.RGBA
        };
        const format = useGammaCorrection ? srgbFormat : defaultFormat;
        if (this.createOptions.useImmutableTexture) {
            const { width: width, height: height } = image;
            gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, image);
        } else gl.texImage2D(gl.TEXTURE_2D, 0, format.internal, format.external, gl.UNSIGNED_BYTE, image);
        gl.bindTexture(gl.TEXTURE_2D, saveTex);
    }
    copyVideoTexture() {
        const { videoWidth: videoWidth, videoHeight: videoHeight } = this._fileInfo;
        const useGammaCorrection = !!this.createOptions.outputLinearTextures;
        const useAsyncDecode = this.caps.webgl2 && !this.createOptions.disableAsyncDecode;
        const textureSource = useAsyncDecode ? this.textures[this.readPbo] : this.textures[0];
        const gl = this.gl;
        const saveFbo = gl.getParameter(gl.FRAMEBUFFER_BINDING);
        const saveTex = gl.getParameter(gl.TEXTURE_BINDING_2D);
        this._copyTexture(textureSource, this.clientBuffers.tex, videoWidth, videoHeight, useGammaCorrection);
        gl.bindFramebuffer(gl.FRAMEBUFFER, saveFbo);
        gl.bindTexture(gl.TEXTURE_2D, saveTex);
    }
    _getWatermarkAsync(currentVideo) {
        const gl = this.gl;
        let result = null;
        const savePbo = gl.getParameter(gl.PIXEL_PACK_BUFFER_BINDING);
        let error = gl.getError();
        if (error != gl.NO_ERROR && error != gl.CONTEXT_LOST_WEBGL) this._logger._logWarning("WebGlBackend._getWatermarkAsync discarding prior webgl error: " + error);
        this.readPbo = (this.nextPbo + 1) % this.pixelBuffers.length;
        if (this.readFences[this.readPbo] != null) {
            var status = gl.getSyncParameter(this.readFences[this.readPbo], gl.SYNC_STATUS);
            gl.deleteSync(this.readFences[this.readPbo]);
            this.readFences[this.readPbo] = null;
            gl.bindBuffer(gl.PIXEL_PACK_BUFFER, this.pixelBuffers[this.readPbo]);
            gl.getBufferSubData(gl.PIXEL_PACK_BUFFER, 0, this.watermarkPixels, 0, this.watermarkPixels.byteLength);
            result = this.watermarkPixels;
        }
        if (!this.pixelBuffers[this.nextPbo]) {
            this.pixelBuffers[this.nextPbo] = gl.createBuffer();
            gl.bindBuffer(gl.PIXEL_PACK_BUFFER, this.pixelBuffers[this.nextPbo]);
            gl.bufferData(gl.PIXEL_PACK_BUFFER, this.watermarkPixels.byteLength, gl.DYNAMIC_READ);
        }
        gl.pixelStorei(gl.PACK_ALIGNMENT, 4);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
        gl.bindTexture(gl.TEXTURE_2D, this.textures[this.nextPbo]);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, currentVideo);
        gl.bindFramebuffer(gl.FRAMEBUFFER, this.fbo1);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this.textures[this.nextPbo], 0);
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, this.pixelBuffers[this.nextPbo]);
        gl.readPixels(0, 0, this.watermarkPixels.byteLength / 4, 1, gl.RGBA, gl.UNSIGNED_BYTE, 0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        if (gl.getError() == gl.NO_ERROR) {
            this.readFences[this.nextPbo] = gl.fenceSync(gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
            this.nextPbo = (this.nextPbo + 1) % this.pixelBuffers.length;
        } else this._logger._logWarning("webgl error: " + error + " skipping video texture read");
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, savePbo);
        return result;
    }
    _getWatermarkSync(currentVideo) {
        const gl = this.gl;
        let result = null;
        gl.pixelStorei(gl.PACK_ALIGNMENT, 4);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
        gl.bindTexture(gl.TEXTURE_2D, this.textures[0]);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, currentVideo);
        const error = gl.getError();
        if (error == gl.NO_ERROR) {
            gl.bindFramebuffer(gl.FRAMEBUFFER, this.fbo1);
            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this.textures[0], 0);
            gl.readPixels(0, 0, this.watermarkPixels.byteLength / 4, 1, gl.RGBA, gl.UNSIGNED_BYTE, this.watermarkPixels);
            result = this.watermarkPixels;
        } else this._logger._logWarning("webgl error: " + error + " skipping video texture read");
        return result;
    }
    getWatermark(currentVideo) {
        if (!this.watermarkPixels) this.watermarkPixels = new Uint8Array(this._fileInfo.videoWidth * 4);
        const gl = this.gl;
        const saveFbo = gl.getParameter(gl.FRAMEBUFFER_BINDING);
        const saveTex = gl.getParameter(gl.TEXTURE_BINDING_2D);
        const useAsyncDecode = this.caps.webgl2 && !this.createOptions.disableAsyncDecode;
        let result = useAsyncDecode ? this._getWatermarkAsync(currentVideo) : this._getWatermarkSync(currentVideo);
        gl.bindFramebuffer(gl.FRAMEBUFFER, saveFbo);
        gl.bindTexture(gl.TEXTURE_2D, saveTex);
        return [
            result,
            useAsyncDecode
        ];
    }
}


class $60ef8ac6208c5cef$export$fc28e97bbe326801 {
    constructor(context){}
    initialize(logger, onContextLost, onContextRestored, browserInfo, createOptions) {
        return true;
    }
    release() {}
    setBuffers(clientBuffers) {}
    setBuffersFromTypedArrays(clientBuffers) {}
    onBeforeLoad(openOptions) {}
    onLoaded(fileInfo) {}
    onSeekToTimeCompleted() {}
    onRewind() {}
    onClose() {}
    updateClientBuffers(indices, positions, uvs, normals, staticDraw) {}
    updateMeshFromCompressedBuffers(meshState, sourceBuffers, updateClientBuffers, wasSeeking) {
        return false;
    }
    setTexture(image) {}
    copyVideoTexture() {}
    getWatermark(currentVideo) {
        return [
            null,
            false
        ];
    }
}


const $13ab5e4789d9fbdb$var$MAJOR_PLACEHOLDER = (0, $bcfee5bf3b0094f1$export$83d89fbfd8236492).major;
const $13ab5e4789d9fbdb$var$MINOR_PLACEHOLDER = (0, $bcfee5bf3b0094f1$export$83d89fbfd8236492).minor;
const $13ab5e4789d9fbdb$var$PATCH_PLACEHOLDER = (0, $bcfee5bf3b0094f1$export$83d89fbfd8236492).patch;
const $13ab5e4789d9fbdb$var$GL_UNSIGNED_SHORT = 5123;
const $13ab5e4789d9fbdb$var$clamp = (num, min, max)=>num < min ? min : num > max ? max : num;
var $13ab5e4789d9fbdb$var$VideoStates;
(function(VideoStates) {
    VideoStates[VideoStates["Undefined"] = 0] = "Undefined";
    VideoStates[VideoStates["CanPlay"] = 1] = "CanPlay";
    VideoStates[VideoStates["CanPlayThrough"] = 2] = "CanPlayThrough";
    VideoStates[VideoStates["Waiting"] = 3] = "Waiting";
    VideoStates[VideoStates["Suspended"] = 4] = "Suspended";
    VideoStates[VideoStates["Stalled"] = 5] = "Stalled";
    VideoStates[VideoStates["Playing"] = 6] = "Playing";
})($13ab5e4789d9fbdb$var$VideoStates || ($13ab5e4789d9fbdb$var$VideoStates = {}));
var $13ab5e4789d9fbdb$export$b6616fff1cd26f39;
(function(ErrorStates) {
    ErrorStates[ErrorStates["NetworkError"] = -1] = "NetworkError";
    ErrorStates[ErrorStates["VideoError"] = -2] = "VideoError";
    ErrorStates[ErrorStates["PlaybackPrevented"] = -3] = "PlaybackPrevented";
})($13ab5e4789d9fbdb$export$b6616fff1cd26f39 || ($13ab5e4789d9fbdb$export$b6616fff1cd26f39 = {}));
var $13ab5e4789d9fbdb$export$47283907dceba392;
(function(States) {
    States[States["Closed"] = -1] = "Closed";
    States[States["Empty"] = 0] = "Empty";
    States[States["Opening"] = 1] = "Opening";
    States[States["Opened"] = 2] = "Opened";
    States[States["Playing"] = 3] = "Playing";
    States[States["Paused"] = 4] = "Paused";
})($13ab5e4789d9fbdb$export$47283907dceba392 || ($13ab5e4789d9fbdb$export$47283907dceba392 = {}));
class $13ab5e4789d9fbdb$export$f8b393fd290a031a {
    id;
    state;
    graphicsBackend;
    json;
    suspended;
    seekingAutoPlay;
    seekingStartBufferIndex;
    fallbackFrameBuffer;
    nextBufferLoadIndex;
    pendingBufferDownload;
    seekTargetTime;
    searchStartFrame;
    seeking;
    frameIndex;
    lastUpdate;
    lastVideoTime;
    currentBufferIndex;
    pauseAfterSeek;
    unmuteAfterSeek;
    eos;
    audioVolume = 1.0;
    logLevel = 1;
    openOptions;
    urlRoot;
    dashPlayer;
    httpRequest;
    minBuffers;
    buffersLoaded;
    minVideos;
    videosLoaded;
    buffers;
    freeArrayBuffers;
    meshState;
    lastKeyframe;
    contextLost;
    wasPlaying;
    onUpdate;
    onUpdateCurrentFrame;
    onBeforeLoad;
    errorCallback;
    onEndOfStream;
    onLoaded;
    browserInfo;
    fileInfo;
    currentFrameInfo;
    videoElement = null;
    meshFrames;
    nextVideoLoadIndex;
    videoState;
    lastVideoSampleIndex;
    pendingVideoEndEvent;
    needMeshData;
    pendingVideoEndEventWaitCount;
    fallbackTextureImage;
    oldVideoSampleIndex;
    filledFallbackFrame;
    requestKeyframe;
    static _instanceCounter = 0;
    static Version = {
        Major: $13ab5e4789d9fbdb$var$MAJOR_PLACEHOLDER,
        Minor: $13ab5e4789d9fbdb$var$MINOR_PLACEHOLDER,
        Patch: $13ab5e4789d9fbdb$var$PATCH_PLACEHOLDER,
        String: `${$13ab5e4789d9fbdb$var$MAJOR_PLACEHOLDER}.${$13ab5e4789d9fbdb$var$MINOR_PLACEHOLDER}.${$13ab5e4789d9fbdb$var$PATCH_PLACEHOLDER}`
    };
    _loadJSON(src, callback) {
        var xobj = new XMLHttpRequest();
        xobj.overrideMimeType("application/json");
        xobj.onreadystatechange = ()=>{
            if (xobj.readyState == 4 && xobj.status == 200) callback(xobj.responseText);
            else if (xobj.status >= 400) {
                this._logError("_loadJSON failed for: " + src + ", XMLHttpRequest status = " + xobj.status);
                this._onError($13ab5e4789d9fbdb$export$b6616fff1cd26f39.NetworkError);
            }
        };
        xobj.onerror = ()=>{
            this._logError("_loadJSON XMLHttpRequest error for: " + src + ", status = " + xobj.status);
            this._onError($13ab5e4789d9fbdb$export$b6616fff1cd26f39.NetworkError);
        };
        xobj.open("GET", src, true);
        xobj.send(null);
        return xobj.responseText;
    }
    _loadArrayBuffer(url, callback) {
        var xobj = new XMLHttpRequest();
        xobj.name = url.substring(url.lastIndexOf("/") + 1, url.length);
        xobj.responseType = "arraybuffer";
        xobj.onprogress = (e)=>{
            e.lengthComputable;
        };
        xobj.onreadystatechange = ()=>{
            if (xobj.readyState == 4) {
                if (xobj.status == 200) {
                    var arrayBuffer = xobj.response;
                    if (arrayBuffer && callback) callback(arrayBuffer);
                } else if (xobj.status >= 400) {
                    this._logError("_loadArrayBuffer failed for: " + url + ", XMLHttpRequest status = " + xobj.status);
                    this._onError($13ab5e4789d9fbdb$export$b6616fff1cd26f39.NetworkError);
                } else this._logWarning("_loadArrayBuffer unexpected status = " + xobj.status);
                if (this.httpRequest == xobj) this.httpRequest = null;
            }
        };
        xobj.ontimeout = ()=>{
            this._logError("_loadArrayBuffer timeout");
            this._onError($13ab5e4789d9fbdb$export$b6616fff1cd26f39.NetworkError);
        };
        xobj.open("GET", url, true);
        xobj.send(null);
        this.httpRequest = xobj;
    }
    _startPlaybackIfReady() {
        if (this.state == $13ab5e4789d9fbdb$export$47283907dceba392.Opening) {
            if (this.buffersLoaded >= this.minBuffers && this.videosLoaded >= this.minVideos) {
                this._logInfo("state -> Opened");
                this.state = $13ab5e4789d9fbdb$export$47283907dceba392.Opened;
                if (this.openOptions.onReady) this.openOptions.onReady();
                if (this.openOptions.autoplay) this.play();
                else if (this.seekingAutoPlay) {
                    delete this.seekingAutoPlay;
                    this.play();
                }
            }
        } else if (this.seekingAutoPlay) {
            if (this.buffersLoaded >= this.minBuffers && this.videosLoaded >= this.minVideos) {
                delete this.seekingAutoPlay;
                this.play();
            }
        }
        if (this.suspended) {
            let currentVideo = this._currentVideo();
            if ((currentVideo.paused || !currentVideo.playing) && currentVideo.preloaded) {
                this._logInfo("video " + currentVideo.mp4Name + " was suspended, resuming");
                this.suspended = false;
                currentVideo.play();
            }
        } else if (this.state == $13ab5e4789d9fbdb$export$47283907dceba392.Playing) {
            let currentVideo = this._currentVideo();
            if (!currentVideo.playing) currentVideo.play();
        }
    }
    _isBufferAlreadyLoaded(bufferIndex) {
        for(let i = 0; i < this.buffers.length; ++i){
            if (this.buffers[i]?.bufferIndex == bufferIndex) return true;
        }
        return false;
    }
    _loadNextBuffer() {
        if (this.freeArrayBuffers.length == 0) {
            if (this.openOptions.keepAllMeshesInMemory) {
                this._logInfo("All meshes loaded.");
                return;
            }
            this._logInfo("_loadNextBuffer: Waiting for next free buffer...");
            return;
        }
        let bufferIndex;
        if (this.seekingStartBufferIndex && this.fallbackFrameBuffer) {
            bufferIndex = this.nextBufferLoadIndex = this.seekingStartBufferIndex;
            delete this.seekingStartBufferIndex;
        } else bufferIndex = this.nextBufferLoadIndex;
        if (this.seekingStartBufferIndex) {
            this.nextBufferLoadIndex = this.seekingStartBufferIndex;
            delete this.seekingStartBufferIndex;
        } else do this.nextBufferLoadIndex = (this.nextBufferLoadIndex + 1) % this.json.buffers.length;
        while (this._isBufferAlreadyLoaded(this.nextBufferLoadIndex));
        if (this.fallbackFrameBuffer && this.nextBufferLoadIndex == 0) this.nextBufferLoadIndex = 1;
        var buffer = this.json.buffers[bufferIndex];
        var bufferName = buffer.uri;
        var bufferURL = this.urlRoot + bufferName;
        buffer.loaded = false;
        var arrayBufferIndex = -1;
        if (bufferIndex == 0) this._logInfo("loading preview frame buffer");
        else {
            arrayBufferIndex = this.freeArrayBuffers.shift();
            this._logInfo("loading buffer: " + buffer.uri + " into slot " + arrayBufferIndex);
        }
        this.pendingBufferDownload = true;
        this._loadArrayBuffer(bufferURL, (arrayBuffer)=>{
            if (!this.fallbackFrameBuffer && !this.filledFallbackFrame) {
                this._logInfo("fallback frame buffer downloaded " + buffer.uri);
                this.fallbackFrameBuffer = arrayBuffer;
                this._loadNextBuffer();
                this.pendingBufferDownload = false;
                return;
            }
            this._logInfo("buffer loaded: " + buffer.uri + " into slot " + arrayBufferIndex);
            ++this.buffersLoaded;
            this.buffers[arrayBufferIndex] = arrayBuffer;
            arrayBuffer.bufferIndex = bufferIndex;
            buffer.arrayBufferIndex = arrayBufferIndex;
            buffer.loaded = true;
            this.pendingBufferDownload = false;
            this.needMeshData = false;
            this._startPlaybackIfReady();
            this._loadNextBuffer();
        });
    }
    _setSeekTarget(seekTime) {
        this.seekTargetTime = seekTime;
        this.searchStartFrame = this._computeSeekSearchFrame(this.seekTargetTime);
        this.seeking = true;
        let ext = this.json.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322];
        let currentFrameTime = this.frameIndex / ext.framerate;
        if (this.searchStartFrame != this.lastKeyframe || this.seekTargetTime < currentFrameTime) this.requestKeyframe = true;
    }
    _frameIsKeyframe(frameIndex) {
        let frame = this.meshFrames[frameIndex];
        return frame.indices != undefined;
    }
    _computeSeekSearchFrame(targetTimeSec) {
        let ext = this.json.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322];
        let keyframes = ext.keyframes;
        for(let i = keyframes.length - 1; i >= 0; --i){
            let timestamp = keyframes[i] / ext.framerate;
            if (timestamp <= targetTimeSec) return keyframes[i];
        }
        return 0;
    }
    _computeSeekSearchTime(targetTimeSec) {
        let ext = this.json.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322];
        let keyframe = this._computeSeekSearchFrame(targetTimeSec);
        let timestamp = keyframe / ext.framerate;
        return timestamp;
    }
    _currentVideo() {
        const timeline = this.json.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].timeline;
        const image = this.json.images[timeline[0].image];
        const currentVideo = image.video;
        return currentVideo;
    }
    seekToTime(seekTimeMs, displayImmediately) {
        if (this.seeking) {
            this._logWarning("seekToTime: ignoring request due to prior seek in-progress");
            return;
        }
        if (this.httpRequest) {
            this.httpRequest.abort();
            this.httpRequest = null;
        }
        let currentVideo = this._currentVideo();
        let wasPlaying = false;
        if (this.state == $13ab5e4789d9fbdb$export$47283907dceba392.Playing) {
            wasPlaying = true;
            this.pause();
            currentVideo.playing = false;
            this.seekingAutoPlay = true;
        }
        this._setSeekTarget(seekTimeMs);
        let frame = this.meshFrames[this.searchStartFrame];
        const bufferViews = this.json.bufferViews;
        let bufferIndex = bufferViews[frame.indices.bufferView].buffer;
        let buffersNeeded = [];
        let index = bufferIndex;
        for(let i = 0; i < Math.min(this.openOptions.maxBuffers, this.json.buffers.length); ++i){
            if (index == 0) index = 1;
            buffersNeeded.push(index);
            index = (index + 1) % this.json.buffers.length;
        }
        let newStartBuffer = true;
        this.currentBufferIndex = -1;
        this.buffersLoaded = 0;
        let freeBuffers = [];
        for(let i = 0; i < this.buffers.length; ++i){
            if (!this.buffers[i]) {
                freeBuffers.push(i);
                continue;
            }
            let buffer = this.buffers[i].bufferIndex;
            if (buffer == bufferIndex) {
                newStartBuffer = false;
                this.currentBufferIndex = i;
            }
            if (buffersNeeded.indexOf(buffer) == -1) freeBuffers.push(i);
            else ++this.buffersLoaded;
        }
        if (!this.openOptions.keepAllMeshesInMemory) this.freeArrayBuffers = freeBuffers;
        if (newStartBuffer) this.seekingStartBufferIndex = bufferIndex;
        if (!wasPlaying && displayImmediately) {
            this.seekingAutoPlay = true;
            this.pauseAfterSeek = true;
        }
        this.oldVideoSampleIndex = this.lastVideoSampleIndex;
        this.lastVideoSampleIndex = -1;
        if (this.requestKeyframe) {
            this.lastKeyframe = -1;
            this.meshState.lastKeyframeIndices = null;
            this.meshState.lastKeyframeUVs = null;
            this.meshState.curMesh = null;
            this.meshState.prevMesh = null;
            this.meshState.prevPrevMesh = null;
        }
        this._setVideoStartTime(currentVideo);
        this.graphicsBackend.onSeekToTimeCompleted();
        if (freeBuffers.length == 0) this._startPlaybackIfReady();
        else this._loadNextBuffer();
        this._logDebug("seekToTime: targetTime = " + seekTimeMs + ", search start = " + this.searchStartFrame + " (in buffer " + bufferIndex + ")");
    }
    _setVideoStartTime(video) {
        if (this.seekTargetTime) {
            let searchStart = this._computeSeekSearchTime(this.seekTargetTime);
            const oldTime = video.currentTime;
            if (this.requestKeyframe) {
                video.currentTime = searchStart;
                this._logDebug("setVideoStartTime: requestKeyframe, video.currentTime was " + oldTime + ", video.currentTime -> searchStart = " + searchStart);
            } else if (video.currentTime > this.seekTargetTime) {
                video.currentTime = this.seekTargetTime;
                this._logDebug("setVideoStartTime: back up to seekTargetTime = " + this.seekTargetTime + ", video.currentTime was " + oldTime);
            } else this._logDebug("setVideoStartTime: don't touch video.currentTime, was " + oldTime);
            if (!video.muted) {
                video.muted = true;
                this.unmuteAfterSeek = true;
            }
        } else video.currentTime = 0.0;
    }
    cleanUpEventListeners = null;
    videoElementInitialized = false;
    _loadNextVideo() {
        if (this.videoElementInitialized) return;
        this.videoElementInitialized = true;
        const video = this.videoElement;
        var videoIndex = this.nextVideoLoadIndex;
        var numVideos = this.json.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].timeline.length;
        this.nextVideoLoadIndex = (this.nextVideoLoadIndex + 1) % numVideos;
        var image = this.json.images[this.json.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].timeline[videoIndex].image];
        image.video = video;
        video.preloaded = false;
        video.autoplay = false;
        video.muted = this.openOptions.autoplay || !this.openOptions.audioEnabled;
        if (this.browserInfo.isSafari) video.muted = true;
        video.loop = numVideos == 1 && !!this.openOptions.autoloop;
        video.preload = "auto";
        video.crossOrigin = this.openOptions.crossOrigin ?? "use-credentials";
        video.playing = false;
        video.preloaded = false;
        video.src = null;
        var imageExt = image.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322];
        if (this.openOptions.streamMode === undefined) this.openOptions.streamMode = (0, $6dd76e03ab0430e4$export$870f5fb4eac0396b).Automatic;
        let hasIOS14HLSIssue = this.browserInfo.iOSVersion && this.browserInfo.iOSVersion.major == 14 && this.browserInfo.iOSVersion.minor < 6;
        if (!this.browserInfo.iOSVersion && this.browserInfo.safariVersion && this.browserInfo.safariVersion.major < 15) hasIOS14HLSIssue = true;
        if (this.openOptions.streamMode == (0, $6dd76e03ab0430e4$export$870f5fb4eac0396b).HLS || this.openOptions.streamMode == (0, $6dd76e03ab0430e4$export$870f5fb4eac0396b).Automatic && (this.browserInfo.isSafari || this.browserInfo.isMozillaWebXRViewer) && imageExt.hlsUri && !hasIOS14HLSIssue) {
            this._setVideoStartTime(video);
            video.src = this.urlRoot + imageExt.hlsUri;
            video.mp4Name = imageExt.hlsUri;
        } else if (this.openOptions.streamMode == (0, $6dd76e03ab0430e4$export$870f5fb4eac0396b).Dash || this.openOptions.streamMode == (0, $6dd76e03ab0430e4$export$870f5fb4eac0396b).Automatic && !this.browserInfo.isSafari && !this.browserInfo.isMozillaWebXRViewer && imageExt.dashUri && typeof dashjs != "undefined") {
            if (!this.dashPlayer) {
                this.dashPlayer = dashjs.MediaPlayer().create();
                this.dashPlayer.initialize();
            }
            var url = this.urlRoot + imageExt.dashUri;
            if (this.seekTargetTime) {
                let searchStart = this._computeSeekSearchTime(this.seekTargetTime);
                url += "#t=" + searchStart;
                this.dashPlayer.attachView(video);
                this.dashPlayer.attachSource(url);
                video.currentTime = searchStart;
                if (!video.muted) {
                    video.muted = true;
                    this.unmuteAfterSeek = true;
                }
            } else {
                this.dashPlayer.attachView(video);
                this.dashPlayer.attachSource(url);
            }
            video.mp4Name = imageExt.dashUri;
        } else {
            this._setVideoStartTime(video);
            var url = this.urlRoot + image.uri;
            video.src = url;
            video.mp4Name = image.uri;
        }
        this._logInfo("loading video " + video.mp4Name);
        const onCanPlay = ()=>{
            this.videoState = $13ab5e4789d9fbdb$var$VideoStates.CanPlay;
        };
        const onPlay = ()=>{
            this.videoState = $13ab5e4789d9fbdb$var$VideoStates.Playing;
        };
        const onCanPlayThrough = ()=>{
            this.videoState = $13ab5e4789d9fbdb$var$VideoStates.CanPlayThrough;
        };
        const onWaiting = ()=>{
            this.videoState = $13ab5e4789d9fbdb$var$VideoStates.Waiting;
        };
        const onSuspend = ()=>{
            this.videoState = $13ab5e4789d9fbdb$var$VideoStates.Suspended;
        };
        const onStalled = ()=>{
            this.videoState = $13ab5e4789d9fbdb$var$VideoStates.Stalled;
        };
        video.addEventListener("canplay", onCanPlay);
        video.addEventListener("play", onPlay);
        video.addEventListener("canplaythrough", onCanPlayThrough);
        video.addEventListener("waiting", onWaiting);
        video.addEventListener("suspend", onSuspend);
        video.addEventListener("stalled", onStalled);
        this.cleanUpEventListeners = ()=>{
            video.removeEventListener("canplay", onCanPlay);
            video.removeEventListener("play", onPlay);
            video.removeEventListener("canplaythrough", onCanPlayThrough);
            video.removeEventListener("waiting", onWaiting);
            video.removeEventListener("suspend", onSuspend);
            video.removeEventListener("stalled", onStalled);
        };
        video.canplay = ()=>{
            this._logInfo("video -> canplay");
            this.videoState = $13ab5e4789d9fbdb$var$VideoStates.CanPlay;
        };
        video.canplaythrough = ()=>{
            this._logInfo("video -> canplaythrough");
            this.videoState = $13ab5e4789d9fbdb$var$VideoStates.CanPlayThrough;
        };
        video.waiting = ()=>{
            this._logInfo("video -> waiting");
            this.videoState = $13ab5e4789d9fbdb$var$VideoStates.Waiting;
        };
        video.suspend = ()=>{
            this._logInfo("video -> suspend");
            this.videoState = $13ab5e4789d9fbdb$var$VideoStates.Suspended;
        };
        video.stalled = ()=>{
            this._logInfo("video -> stalled");
            this.videoState = $13ab5e4789d9fbdb$var$VideoStates.Stalled;
        };
        video.onerror = (e)=>{
            if (e instanceof Event) {
                const target = e.target;
                this._logError("video error: " + target.error?.code + " - " + target.mp4Name);
                this._onError($13ab5e4789d9fbdb$export$b6616fff1cd26f39.VideoError, target.error);
            } else {
                this._logError("video error: " + e);
                this._onError($13ab5e4789d9fbdb$export$b6616fff1cd26f39.VideoError);
            }
        };
        video.onended = ()=>{
            this.pendingVideoEndEvent = true;
            this.pendingVideoEndEventWaitCount = 0;
        };
        if (this.browserInfo.isSafari) video.onplaying = ()=>{
            video.pause();
            video.muted = this.openOptions.autoplay || !this.openOptions.audioEnabled;
            video.preloaded = true;
            this._logInfo("video loaded: " + video.mp4Name);
            video.onplaying = ()=>{
                this._logInfo("video playing: " + video.mp4Name);
                video.playing = true;
            };
            ++this.videosLoaded;
            this._startPlaybackIfReady();
            this._loadNextVideo();
        };
        else {
            video.onloadeddata = ()=>{
                var playPromise = video.play();
                if (playPromise !== undefined) playPromise.then((_)=>{}).catch((error)=>{
                    video.onplaying?.(undefined);
                });
            };
            video.onplaying = ()=>{
                video.pause();
                video.preloaded = true;
                this._logInfo("video loaded: " + video.mp4Name);
                video.onplaying = ()=>{
                    this._logInfo("video playing: " + video.mp4Name);
                    video.playing = true;
                };
                ++this.videosLoaded;
                this._startPlaybackIfReady();
                this._loadNextVideo();
            };
        }
        if (this.browserInfo.isSafari) {
            let playPromise = video.play();
            if (playPromise !== undefined) playPromise.catch((error)=>{
                this._logWarning("play prevented: " + error);
                this._onError($13ab5e4789d9fbdb$export$b6616fff1cd26f39.PlaybackPrevented, error);
            });
        }
    }
    _resetFreeBuffers() {
        this.freeArrayBuffers = [];
        for(var i = 0; i < Math.min(this.openOptions.maxBuffers, this.json.buffers.length - 1); ++i)this.freeArrayBuffers.push(i);
    }
    rewind() {
        if (this.json) {
            this._logInfo("rewind");
            let currentVideo = this._currentVideo();
            currentVideo.pause();
            currentVideo.playing = false;
            currentVideo.currentTime = 0.0;
            this.pendingVideoEndEvent = false;
            this.state = $13ab5e4789d9fbdb$export$47283907dceba392.Opening;
            if (!this.openOptions.keepAllMeshesInMemory) this._resetFreeBuffers();
            this.currentBufferIndex = 0;
            this.nextBufferLoadIndex = this.fallbackFrameBuffer ? 1 : 0;
            this.frameIndex = -1;
            this.lastKeyframe = -1;
            this.meshState.lastKeyframeIndices = null;
            this.meshState.lastKeyframeUVs = null;
            this.lastVideoSampleIndex = -1;
            this.filledFallbackFrame = false;
            this.meshState.curMesh = null;
            this.meshState.prevMesh = null;
            this.meshState.prevPrevMesh = null;
            delete this.seekTargetTime;
            this.graphicsBackend.onRewind();
            this._loadNextBuffer();
            this._loadFallbackFrame();
            this._startPlaybackIfReady();
        }
    }
    forceLoad() {
        if (this.json) {
            let currentVideo = this._currentVideo();
            if (!currentVideo) this._logInfo("forceLoad: don't have currentVideo yet");
            else if (currentVideo.playing) this._logInfo("forceLoad: video already playing");
            else if (!currentVideo.preloaded) {
                this._logInfo("forceLoad: manually starting video");
                this.suspended = true;
                var playPromise = currentVideo.play();
                if (playPromise !== undefined) playPromise.then((_)=>{
                    this.state = $13ab5e4789d9fbdb$export$47283907dceba392.Playing;
                }).catch((error)=>{
                    this._logWarning("play prevented: " + error);
                    this._onError($13ab5e4789d9fbdb$export$b6616fff1cd26f39.PlaybackPrevented, error);
                });
            }
        } else this._logInfo("forceLoad: don't have json yet");
    }
    _onVideoEnded(video) {
        this._logInfo("video ended = " + video.mp4Name);
        this.videoElementInitialized = false;
        var timeline = this.json.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].timeline;
        this.state = $13ab5e4789d9fbdb$export$47283907dceba392.Opened;
        if (timeline.length - 1 === 0 && !this.openOptions.autoloop) {
            this.eos = true;
            if (this.onEndOfStream) this.onEndOfStream(this);
        } else {
            this._loadNextVideo();
            this._startPlaybackIfReady();
        }
    }
    setBuffers(clientBuffers) {
        if (this.graphicsBackend instanceof (0, $6165386d9ecd96e9$export$f3bcef630ce7ca1e)) this.graphicsBackend.setBuffers(clientBuffers);
        if (this.graphicsBackend instanceof (0, $60ef8ac6208c5cef$export$fc28e97bbe326801)) this.graphicsBackend.setBuffers(clientBuffers);
    }
    setBuffersFromTypedArrays(clientBuffers) {
        if (this.graphicsBackend instanceof (0, $6165386d9ecd96e9$export$f3bcef630ce7ca1e)) this.graphicsBackend.setBuffersFromTypedArrays(clientBuffers);
        if (this.graphicsBackend instanceof (0, $60ef8ac6208c5cef$export$fc28e97bbe326801)) this.graphicsBackend.setBuffersFromTypedArrays(clientBuffers);
    }
    _updateMesh(updateClientBuffers = false, wasSeeking = false) {
        this.frameIndex = (this.frameIndex + 1) % this.meshFrames.length;
        var frame = this.meshFrames[this.frameIndex];
        if (!frame.ensureBuffers()) return false;
        if (this.meshState.prevPrevMesh) this.meshState.prevPrevMesh.uncompressedPos = null;
        this.meshState.prevPrevMesh = this.meshState.prevMesh;
        this.meshState.prevMesh = this.meshState.curMesh;
        this.meshState.curMesh = frame;
        var sourceBuffers = {
            indices: null,
            compressedPos: null,
            compressedUVs: null,
            compressedNormals: null,
            deltas: null
        };
        var buffers = this.json.buffers;
        var bufferViews = this.json.bufferViews;
        var attributes = frame.primitives[0].extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].attributes;
        var arrayBufferIndex = -1;
        if (attributes.POSITION) {
            arrayBufferIndex = buffers[bufferViews[frame.indices.bufferView].buffer].arrayBufferIndex;
            var indexArrayBuf = this.buffers[arrayBufferIndex];
            var posArrayBuf = this.buffers[arrayBufferIndex];
            var uvArrayBuf = this.buffers[arrayBufferIndex];
            if (frame.indices.componentType == $13ab5e4789d9fbdb$var$GL_UNSIGNED_SHORT) sourceBuffers.indices = new Uint16Array(indexArrayBuf, bufferViews[frame.indices.bufferView].byteOffset + frame.indices.byteOffset, frame.indices.count);
            else sourceBuffers.indices = new Uint32Array(indexArrayBuf, bufferViews[frame.indices.bufferView].byteOffset + frame.indices.byteOffset, frame.indices.count);
            this.meshState.lastKeyframeIndices = sourceBuffers.indices;
            sourceBuffers.compressedPos = new Uint16Array(posArrayBuf, bufferViews[frame.compressedPos.bufferView].byteOffset + frame.compressedPos.byteOffset, frame.compressedPos.count * 3);
            this.meshState.lastKeyframeUVs = sourceBuffers.compressedUVs = new Uint16Array(uvArrayBuf, bufferViews[frame.compressedUVs.bufferView].byteOffset + frame.compressedUVs.byteOffset, frame.compressedUVs.count * 2);
        } else {
            arrayBufferIndex = buffers[bufferViews[frame.deltas.bufferView].buffer].arrayBufferIndex;
            var deltasArrayBuf = this.buffers[arrayBufferIndex];
            sourceBuffers.deltas = new Uint8Array(deltasArrayBuf, bufferViews[frame.deltas.bufferView].byteOffset + frame.deltas.byteOffset, frame.deltas.count * 3);
        }
        if (arrayBufferIndex != this.currentBufferIndex) {
            if (this.currentBufferIndex == -1) this.currentBufferIndex = arrayBufferIndex;
            else {
                this._logInfo("currentBufferIndex -> " + arrayBufferIndex);
                if (!this.openOptions.keepAllMeshesInMemory) this.freeArrayBuffers.push(this.currentBufferIndex);
                this.currentBufferIndex = arrayBufferIndex;
                if (!this.pendingBufferDownload) this._loadNextBuffer();
            }
        }
        if (frame.compressedNormals != null) {
            var norArrayBuf = this.buffers[buffers[bufferViews[frame.compressedNormals.bufferView].buffer].arrayBufferIndex];
            if (frame.compressedNormals.type == "VEC2") sourceBuffers.compressedNormals = new Uint8Array(norArrayBuf, bufferViews[frame.compressedNormals.bufferView].byteOffset + frame.compressedNormals.byteOffset, frame.compressedNormals.count * 2);
            else if (frame.compressedNormals.type == "VEC3") sourceBuffers.compressedNormals = new Uint16Array(norArrayBuf, bufferViews[frame.compressedNormals.bufferView].byteOffset + frame.compressedNormals.byteOffset, frame.compressedNormals.count * 3);
        }
        if (!this.graphicsBackend.updateMeshFromCompressedBuffers(this.meshState, sourceBuffers, updateClientBuffers, wasSeeking)) {
            if (frame.primitives[0].extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].attributes.POSITION) {
                const count = frame.compressedPos.count;
                frame.uncompressedPos = new Float32Array(count * 3);
                var min = frame.compressedPos.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].decodeMin;
                var max = frame.compressedPos.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].decodeMax;
                var bboxdx = (max[0] - min[0]) / 65535.0;
                var bboxdy = (max[1] - min[1]) / 65535.0;
                var bboxdz = (max[2] - min[2]) / 65535.0;
                for(var i = 0; i < count; ++i){
                    var i0 = 3 * i;
                    var i1 = i0 + 1;
                    var i2 = i0 + 2;
                    frame.uncompressedPos[i0] = sourceBuffers.compressedPos[i0] * bboxdx + min[0];
                    frame.uncompressedPos[i1] = sourceBuffers.compressedPos[i1] * bboxdy + min[1];
                    frame.uncompressedPos[i2] = sourceBuffers.compressedPos[i2] * bboxdz + min[2];
                }
                if (updateClientBuffers) this.graphicsBackend.updateClientBuffers(sourceBuffers.indices, frame.uncompressedPos, sourceBuffers.compressedUVs);
            } else if (this.meshState.prevMesh) {
                var count = frame.deltas.count;
                frame.uncompressedPos = new Float32Array(count * 3);
                var min = frame.deltas.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].decodeMin;
                var max = frame.deltas.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].decodeMax;
                var bboxdx = (max[0] - min[0]) / 255.0;
                var bboxdy = (max[1] - min[1]) / 255.0;
                var bboxdz = (max[2] - min[2]) / 255.0;
                var deltas = sourceBuffers.deltas;
                if (this.meshState.prevPrevMesh == null) for(var i = 0; i < count; ++i){
                    var i0 = 3 * i;
                    var i1 = i0 + 1;
                    var i2 = i0 + 2;
                    var x = this.meshState.prevMesh.uncompressedPos[i0];
                    var y = this.meshState.prevMesh.uncompressedPos[i1];
                    var z = this.meshState.prevMesh.uncompressedPos[i2];
                    var deltaX = deltas[i0] * bboxdx + min[0];
                    var deltaY = deltas[i1] * bboxdy + min[1];
                    var deltaZ = deltas[i2] * bboxdz + min[2];
                    x += deltaX;
                    y += deltaY;
                    z += deltaZ;
                    frame.uncompressedPos[i0] = x;
                    frame.uncompressedPos[i1] = y;
                    frame.uncompressedPos[i2] = z;
                }
                else for(var i = 0; i < count; ++i){
                    var i0 = 3 * i;
                    var i1 = i0 + 1;
                    var i2 = i0 + 2;
                    var x = this.meshState.prevMesh.uncompressedPos[i0];
                    var y = this.meshState.prevMesh.uncompressedPos[i1];
                    var z = this.meshState.prevMesh.uncompressedPos[i2];
                    var dx = x - this.meshState.prevPrevMesh.uncompressedPos[i0];
                    var dy = y - this.meshState.prevPrevMesh.uncompressedPos[i1];
                    var dz = z - this.meshState.prevPrevMesh.uncompressedPos[i2];
                    x += dx;
                    y += dy;
                    z += dz;
                    var deltaX = deltas[i0] * bboxdx + min[0];
                    var deltaY = deltas[i1] * bboxdy + min[1];
                    var deltaZ = deltas[i2] * bboxdz + min[2];
                    x += deltaX;
                    y += deltaY;
                    z += deltaZ;
                    frame.uncompressedPos[i0] = x;
                    frame.uncompressedPos[i1] = y;
                    frame.uncompressedPos[i2] = z;
                }
                if (updateClientBuffers) this.graphicsBackend.updateClientBuffers(wasSeeking ? this.meshState.lastKeyframeIndices : undefined, frame.uncompressedPos, wasSeeking ? this.meshState.lastKeyframeUVs : undefined);
            }
            if (this.fileInfo.haveNormals && sourceBuffers.compressedNormals && updateClientBuffers) {
                if (this.fileInfo.octEncodedNormals) {
                    const count = sourceBuffers.compressedNormals.length / 2;
                    var uncompressedNormals = new Float32Array(3 * count);
                    var abs = Math.abs;
                    for(var i = 0; i < count; ++i){
                        let x = sourceBuffers.compressedNormals[2 * i];
                        let y = sourceBuffers.compressedNormals[2 * i + 1];
                        x = -1 + x * 0.0078125;
                        y = -1 + y * 0.0078125;
                        let z = 1.0 - abs(x) - abs(y);
                        var t = $13ab5e4789d9fbdb$var$clamp(-z, 0.0, 1.0);
                        x += x >= 0.0 ? -t : t;
                        y += y >= 0.0 ? -t : t;
                        var invLen = 1.0 / Math.sqrt(x * x + y * y + z * z);
                        uncompressedNormals[3 * i] = x * invLen;
                        uncompressedNormals[3 * i + 1] = y * invLen;
                        uncompressedNormals[3 * i + 2] = z * invLen;
                    }
                    this.graphicsBackend.updateClientBuffers(undefined, undefined, undefined, uncompressedNormals);
                } else this.graphicsBackend.updateClientBuffers(undefined, undefined, undefined, sourceBuffers.compressedNormals);
            }
        }
        if (frame.primitives[0].extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].attributes.POSITION) {
            this.lastKeyframe = this.frameIndex;
            if (this.meshState.prevMesh) {
                this.meshState.prevMesh.uncompressedPos = null;
                this.meshState.prevMesh = null;
            }
            if (this.meshState.prevPrevMesh) {
                this.meshState.prevPrevMesh.uncompressedPos = null;
                this.meshState.prevPrevMesh = null;
            }
            frame.indexCount = frame.indices.count;
            var min = frame.compressedPos.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].decodeMin;
            var max = frame.compressedPos.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].decodeMax;
            this.currentFrameInfo.bboxMin = min;
            this.currentFrameInfo.bboxMax = max;
        } else frame.indexCount = this.meshState.prevMesh.indexCount;
        return true;
    }
    _setupMeshFrames() {
        const json = this.json;
        const accessors = json.accessors;
        const numFrames = json.meshes.length;
        const arrayBuffers = this.buffers;
        const hvo = this;
        const ensureBuffers = function() {
            var bufferViews = json.bufferViews;
            var buffers = json.buffers;
            if (this.primitives[0].extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].attributes.POSITION) {
                var indexBufferView = bufferViews[this.indices.bufferView];
                if (buffers[indexBufferView.buffer].arrayBufferIndex == undefined || arrayBuffers[buffers[indexBufferView.buffer].arrayBufferIndex].bufferIndex != indexBufferView.buffer) {
                    hvo._logInfo("buffer for frame " + this.frameIndex + " not downloaded yet: " + buffers[indexBufferView.buffer].uri);
                    return false;
                }
                var posBufferView = bufferViews[this.compressedPos.bufferView];
                if (buffers[posBufferView.buffer].arrayBufferIndex == undefined || arrayBuffers[buffers[posBufferView.buffer].arrayBufferIndex].bufferIndex != posBufferView.buffer) {
                    hvo._logInfo("buffer for frame " + this.frameIndex + " not downloaded yet: " + buffers[posBufferView.buffer].uri);
                    return false;
                }
                var uvBufferView = bufferViews[this.compressedUVs.bufferView];
                if (buffers[uvBufferView.buffer].arrayBufferIndex == undefined || arrayBuffers[buffers[uvBufferView.buffer].arrayBufferIndex].bufferIndex != uvBufferView.buffer) {
                    hvo._logInfo("buffer for frame " + this.frameIndex + " not downloaded yet: " + buffers[uvBufferView.buffer].uri);
                    return false;
                }
            } else {
                var deltaBufferView = bufferViews[this.deltas.bufferView];
                if (buffers[deltaBufferView.buffer].arrayBufferIndex == undefined || arrayBuffers[buffers[deltaBufferView.buffer].arrayBufferIndex].bufferIndex != deltaBufferView.buffer) {
                    hvo._logInfo("buffer for frame " + this.frameIndex + " not downloaded yet: " + buffers[deltaBufferView.buffer].uri);
                    return false;
                }
            }
            if (this.compressedNormals) {
                var norBufferView = bufferViews[this.compressedNormals.bufferView];
                if (buffers[norBufferView.buffer].arrayBufferIndex == undefined || arrayBuffers[buffers[norBufferView.buffer].arrayBufferIndex].bufferIndex != norBufferView.buffer) {
                    hvo._logInfo("buffer for frame " + this.frameIndex + " not downloaded yet: " + buffers[norBufferView.buffer].uri);
                    return false;
                }
            }
            return true;
        };
        for(var i = 0; i < numFrames; ++i){
            var meshFrame = this.json.meshes[i];
            meshFrame.frameIndex = i;
            meshFrame.ensureBuffers = ensureBuffers;
            var attributes = meshFrame.primitives[0].extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].attributes;
            if (attributes.POSITION) {
                meshFrame.indices = accessors[meshFrame.primitives[0].extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].indices];
                meshFrame.compressedUVs = accessors[attributes.TEXCOORD_0];
                meshFrame.compressedPos = accessors[attributes.POSITION];
            } else meshFrame.deltas = accessors[attributes._DELTA];
            if (attributes.NORMAL != null) {
                this.fileInfo.haveNormals = true;
                meshFrame.compressedNormals = accessors[attributes.NORMAL];
                if (meshFrame.compressedNormals.type == "VEC2") this.fileInfo.octEncodedNormals = true;
            }
            this.meshFrames.push(meshFrame);
        }
    }
    _onJsonLoaded(response) {
        this._logInfo("got json");
        this.json = JSON.parse(response);
        if (this.openOptions.keepAllMeshesInMemory) this.openOptions.maxBuffers = this.json.buffers.length - 1;
        this.minBuffers = Math.min(this.openOptions.minBuffers, this.json.buffers.length - 1);
        var timeline = this.json.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].timeline;
        this.minVideos = Math.min(2, timeline.length);
        this.buffers = [
            null,
            null,
            null
        ];
        this.videoElement = this.videoElement ?? document.createElement("video");
        this.videoElement.setAttribute("playsinline", "playsinline");
        this.videoElement.volume = this.audioVolume;
        for(var i = 0; i < Math.min(this.openOptions.maxBuffers, this.json.buffers.length - 1); ++i)this.freeArrayBuffers.push(i);
        if (this.openOptions.startTime) {
            this._setSeekTarget(this.openOptions.startTime);
            this.seekingAutoPlay = true;
            this.pauseAfterSeek = true;
        }
        this._setupMeshFrames();
        this._loadNextVideo();
        if (this.seekTargetTime) {
            let frame = this.meshFrames[this.searchStartFrame];
            const bufferViews = this.json.bufferViews;
            this.seekingStartBufferIndex = bufferViews[frame.indices.bufferView].buffer;
            this._loadNextBuffer();
        } else this._loadNextBuffer();
        this.currentBufferIndex = 0;
        var image = this.json.images[timeline[0].image].extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322];
        this.fileInfo.videoWidth = image.width;
        this.fileInfo.videoHeight = image.height;
        var ext = this.json.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322];
        const numFrames = this.json.meshes.length - 1;
        this.fileInfo.frameCount = numFrames;
        this.fileInfo.duration = 1000 * numFrames / ext.framerate;
        this.fileInfo.maxVertexCount = ext.maxVertexCount;
        this.fileInfo.maxIndexCount = ext.maxIndexCount;
        this.fileInfo.boundingBox = {
            min: ext.boundingMin,
            max: ext.boundingMax
        };
        this.fileInfo.indicesComponentType = this.meshFrames[0].indices.componentType;
        this.graphicsBackend.onLoaded(this.fileInfo);
        if (this.onLoaded) this.onLoaded(this.fileInfo);
    }
    _getChromeVersion() {
        var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
        return raw ? parseInt(raw[2], 10) : false;
    }
    _getIOSVersion() {
        var agent = window.navigator.userAgent;
        if (agent.indexOf("iPhone") > 0 || agent.indexOf("iPad") > 0 || agent.indexOf("iPod") > 0) {
            var raw = agent.match(/OS (\d+)_(\d+)_?(\d+)?/);
            if (raw) return {
                major: parseInt(raw[1] || "0", 10),
                minor: parseInt(raw[2] || "0", 10),
                patch: parseInt(raw[3] || "0", 10)
            };
        }
        return false;
    }
    _getSafariVersion() {
        var agent = window.navigator.userAgent;
        var raw = agent.match(/Version\/(\d+).(\d+).?(\d+)?/);
        if (raw) return {
            major: parseInt(raw[1] || "0", 10),
            minor: parseInt(raw[2] || "0", 10),
            patch: parseInt(raw[3] || "0", 10)
        };
        return false;
    }
    _logDebug(message, force) {
        if (this.logLevel >= 3) {
            var id = this.id;
            console.log(`[${id}] ` + message);
        }
    }
    _logInfo(message, force) {
        if (this.logLevel >= 2 || force) {
            var id = this.id;
            console.log(`[${id}] ` + message);
        }
    }
    _logWarning(message) {
        if (this.logLevel >= 1) {
            var id = this.id;
            console.log(`[${id}] ` + message);
        }
    }
    _logError(message) {
        if (this.logLevel >= 0) {
            var id = this.id;
            console.log(`[${id}] ` + message);
        }
    }
    _onError(type, info) {
        if (this.errorCallback) this.errorCallback(type, info);
    }
    onContextLost() {
        this.contextLost = true;
        this.wasPlaying = this.state == $13ab5e4789d9fbdb$export$47283907dceba392.Playing;
        this.pause();
        this._logInfo("contextlost -> pausing playback");
    }
    onContextRestored() {
        this.contextLost = false;
        this.updateToLastKeyframe();
        if (this.wasPlaying) {
            this.wasPlaying = false;
            this._logInfo("contextrestored -> resuming playback");
            this.play();
        }
    }
    constructor(context, createOptions, errorCallback){
        const makeBackend = ()=>{
            if (context instanceof WebGLRenderingContext) return new (0, $6165386d9ecd96e9$export$f3bcef630ce7ca1e)(context);
            if (context instanceof WebGL2RenderingContext) return new (0, $6165386d9ecd96e9$export$f3bcef630ce7ca1e)(context);
            if (context instanceof GPUCanvasContext) return new (0, $60ef8ac6208c5cef$export$fc28e97bbe326801)(context);
        };
        this.id = $13ab5e4789d9fbdb$export$f8b393fd290a031a._instanceCounter++;
        this.state = $13ab5e4789d9fbdb$export$47283907dceba392.Empty;
        this.suspended = false;
        this.graphicsBackend = makeBackend();
        this.errorCallback = errorCallback;
        this.meshState = {
            lastKeyframeIndices: null,
            lastKeyframeUVs: null,
            curMesh: null,
            prevMesh: null,
            prevPrevMesh: null
        };
        this.browserInfo = {
            isSafari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
            safariVersion: this._getSafariVersion(),
            iOSVersion: this._getIOSVersion(),
            isMozillaWebXRViewer: false
        };
        this.browserInfo.isMozillaWebXRViewer = this.browserInfo.iOSVersion && navigator.userAgent.includes("WebXRViewer");
        if (navigator.userAgent.includes("Mobile") && navigator.platform != "iPhone" && navigator.platform != "iPad" && navigator.platform != "iPod") this.browserInfo.isSafari = false;
        if (!this.graphicsBackend.initialize(this, this.onContextLost, this.onContextRestored, this.browserInfo, createOptions)) throw "Catastrophic failure while initializing the graphic backend!";
        document.addEventListener("visibilitychange", ()=>{
            if (document.hidden) {
                if (this.state == $13ab5e4789d9fbdb$export$47283907dceba392.Playing) {
                    this.wasPlaying = true;
                    this._logInfo("document hidden -> pausing playback");
                    this.pause();
                } else this.wasPlaying = false;
            } else if (this.wasPlaying) {
                this.wasPlaying = false;
                this._logInfo("document visible -> resuming playback");
                this.play();
            }
        });
        console.log("HoloVideoObject version " + $13ab5e4789d9fbdb$export$f8b393fd290a031a.Version.String);
    }
    getLoadProgress() {
        if (this.minBuffers == undefined) return 0;
        if (this.state >= $13ab5e4789d9fbdb$export$47283907dceba392.Opened) return 1.0;
        return (this.buffersLoaded + this.videosLoaded) / (this.minBuffers + this.minVideos);
    }
    updateToLastKeyframe() {
        if (this.lastKeyframe != -1) {
            this.frameIndex = this.lastKeyframe - 1;
            this.meshState.curMesh = null;
            this.meshState.prevMesh = null;
            this.meshState.prevPrevMesh = null;
        }
    }
    _loadFallbackFrame() {
        if (this.json && this.fallbackFrameBuffer) {
            if (!this.fallbackTextureImage) {
                this.fallbackTextureImage = new Image();
                var encode = function(input) {
                    var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                    var output = "";
                    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
                    var i = 0;
                    while(i < input.length){
                        chr1 = input[i++];
                        chr2 = i < input.length ? input[i++] : Number.NaN;
                        chr3 = i < input.length ? input[i++] : Number.NaN;
                        enc1 = chr1 >> 2;
                        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
                        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
                        enc4 = chr3 & 63;
                        if (isNaN(chr2)) enc3 = enc4 = 64;
                        else if (isNaN(chr3)) enc4 = 64;
                        output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
                    }
                    return output;
                };
                var fallbackImage = this.json.images[0];
                var bufferView = this.json.bufferViews[fallbackImage.bufferView];
                this.fallbackTextureImage.src = "data:image/jpeg;base64," + encode(new Uint8Array(this.fallbackFrameBuffer, bufferView.byteOffset, bufferView.byteLength));
                this.fallbackTextureImage.onload = ()=>{
                    this._logInfo("fallback image loaded");
                    this.fallbackTextureImage.loaded = true;
                };
            }
            if (this.fallbackTextureImage && this.fallbackTextureImage.loaded && !this.filledFallbackFrame) {
                var fallbackPrim = this.json.meshes[0].primitives[0];
                var posAccessor = this.json.accessors[fallbackPrim.attributes.POSITION];
                var posBufferView = this.json.bufferViews[posAccessor.bufferView];
                const posData = new Float32Array(this.fallbackFrameBuffer, posBufferView.byteOffset + posAccessor.byteOffset, posAccessor.count * 3);
                let norData = undefined;
                if (this.fileInfo.haveNormals) {
                    var norAccesor = this.json.accessors[fallbackPrim.attributes.NORMAL];
                    var norBufferView = this.json.bufferViews[norAccesor.bufferView];
                    norData = new Float32Array(this.fallbackFrameBuffer, norBufferView.byteOffset + norAccesor.byteOffset, norAccesor.count * 3);
                }
                var uvAccesor = this.json.accessors[fallbackPrim.attributes.TEXCOORD_0];
                var uvBufferView = this.json.bufferViews[uvAccesor.bufferView];
                const uvData = new Uint16Array(this.fallbackFrameBuffer, uvBufferView.byteOffset + uvAccesor.byteOffset, uvAccesor.count * 2);
                var indexAccessor = this.json.accessors[fallbackPrim.indices];
                var indexBufferView = this.json.bufferViews[indexAccessor.bufferView];
                const arrayConstructor = indexAccessor.componentType === $13ab5e4789d9fbdb$var$GL_UNSIGNED_SHORT ? Uint16Array : Uint32Array;
                const indexData = new arrayConstructor(this.fallbackFrameBuffer, indexBufferView.byteOffset + indexAccessor.byteOffset, indexAccessor.count);
                this.graphicsBackend.updateClientBuffers(indexData, posData, uvData, norData, true);
                this.graphicsBackend.setTexture(this.fallbackTextureImage);
                this.currentFrameInfo.primCount = indexAccessor.count;
                this.currentFrameInfo.indexCount = indexAccessor.count;
                this.currentFrameInfo.vertexCount = posAccessor.count;
                posAccessor = this.json.accessors[fallbackPrim.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].attributes.POSITION];
                var min = posAccessor.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].decodeMin;
                var max = posAccessor.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].decodeMax;
                this.currentFrameInfo.bboxMin = min;
                this.currentFrameInfo.bboxMax = max;
                this.filledFallbackFrame = true;
            }
            return this.filledFallbackFrame;
        }
        return false;
    }
    updateBuffers() {
        if (this.contextLost) return false;
        if (!this.json) return false;
        if (!this.filledFallbackFrame && !this.seekTargetTime) {
            const updated = this._loadFallbackFrame();
            this.onUpdate?.(updated, this.currentFrameInfo);
            return updated;
        }
        const timeline = this.json.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].timeline;
        const image = this.json.images[timeline[0].image];
        const currentVideo = image.video;
        let forceEndOfStream = false;
        if (currentVideo && currentVideo.playing && !this.suspended) {
            var now = window.performance.now();
            var videoNow = currentVideo.currentTime * 1000;
            if (now - this.lastUpdate < 20.0) return false;
            this.lastVideoTime = videoNow;
            this.lastUpdate = now;
            var videoSampleIndex = -1;
            const [watermarkPixels, dontCheckForInvalidFrame] = this.graphicsBackend.getWatermark(currentVideo);
            if (watermarkPixels) {
                var blockSize = image.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322].blockSize * 4;
                videoSampleIndex = 0;
                for(var i = 0; i < 16; ++i)if (watermarkPixels[blockSize * i + 0] > 128 || watermarkPixels[blockSize * i + 4] > 128) videoSampleIndex += 1 << i;
                var allBlack = true;
                if (!dontCheckForInvalidFrame && videoSampleIndex == 0 && videoSampleIndex < this.lastVideoSampleIndex) {
                    for(var i = 0; i < watermarkPixels.byteLength; ++i)if (watermarkPixels[i] != 0) {
                        allBlack = false;
                        break;
                    }
                    if (allBlack) {
                        this._logWarning("dropping empty/black video frame");
                        this.currentFrameInfo.primCount = 0;
                        this.onUpdate?.(true, this.currentFrameInfo);
                        return true;
                    }
                }
            }
            if (videoSampleIndex > -1 && videoSampleIndex != this.oldVideoSampleIndex) {
                let readMesh = true;
                if (this.seeking && this.requestKeyframe) {
                    if (this._frameIsKeyframe(videoSampleIndex)) {
                        this.requestKeyframe = false;
                        this.frameIndex = videoSampleIndex - 1;
                        this._logDebug("seeking found keyframe -> " + videoSampleIndex);
                    } else {
                        this._logDebug("seeking wait for keyframe -> " + videoSampleIndex);
                        readMesh = false;
                    }
                }
                if (readMesh && (this.meshState.curMesh == null || this.meshState.curMesh.frameIndex != videoSampleIndex)) {
                    let wasSeeking = this.seeking;
                    if (this.seeking) {
                        const ext = this.json.extensions[0, $6dd76e03ab0430e4$export$dd0364c440fe3322];
                        let frameTimestamp = videoSampleIndex / ext.framerate;
                        if (frameTimestamp < this.seekTargetTime) ;
                        else {
                            this.seeking = false;
                            this._logDebug("seeking finished at frame " + videoSampleIndex);
                            if (this.unmuteAfterSeek) currentVideo.muted = false;
                        }
                    }
                    if (!this.seeking && this.pauseAfterSeek && !this.seekingAutoPlay) {
                        this.pause();
                        currentVideo.playing = false;
                        delete this.pauseAfterSeek;
                    }
                    const updateClientBuffers = !this.seeking;
                    if (this.meshFrames[videoSampleIndex].ensureBuffers()) {
                        if (videoSampleIndex < this.lastVideoSampleIndex) {
                            this.frameIndex = -1;
                            this._updateMesh(updateClientBuffers, wasSeeking);
                            this._logInfo("loop detected, videoSampleIndex = " + videoSampleIndex + ", curMesh.frameIndex = " + this.meshState.curMesh?.frameIndex);
                        }
                        while(this.meshState.curMesh == null || this.meshState.curMesh.frameIndex < videoSampleIndex){
                            if (!this._updateMesh(updateClientBuffers, wasSeeking)) break;
                        }
                        this._logDebug("updated to frame index = " + videoSampleIndex);
                        if (this.meshState.curMesh?.frameIndex == videoSampleIndex && updateClientBuffers) this.graphicsBackend.copyVideoTexture();
                        if (this.meshState.curMesh && this.meshState.curMesh.frameIndex != videoSampleIndex) this._logInfo("texture (" + videoSampleIndex + ") <-> mesh (" + this.meshState.curMesh.frameIndex + ") mismatch");
                        this.lastVideoSampleIndex = videoSampleIndex;
                    } else {
                        this._logWarning("ran out of mesh data, suspending video " + currentVideo.mp4Name);
                        currentVideo.pause();
                        this.suspended = true;
                        this.needMeshData = true;
                        if (!this.pendingBufferDownload) this._loadNextBuffer();
                    }
                } else if (this.pendingVideoEndEvent && this.state == $13ab5e4789d9fbdb$export$47283907dceba392.Playing) {
                    this.pendingVideoEndEventWaitCount++;
                    forceEndOfStream = this.pendingVideoEndEventWaitCount > 3;
                }
            }
        }
        if (this.pendingVideoEndEvent && (this.lastVideoSampleIndex == this.meshFrames.length - 1 || forceEndOfStream)) {
            currentVideo.playing = false;
            this._onVideoEnded(currentVideo);
            this.pendingVideoEndEvent = false;
        }
        if (this.meshState.curMesh && !this.seeking) {
            this.currentFrameInfo.indexCount = this.meshState.curMesh.indexCount;
            this.currentFrameInfo.primCount = this.currentFrameInfo.indexCount;
            this.currentFrameInfo.vertexCount = this.meshState.curMesh.compressedPos?.count ?? this.meshState.curMesh.deltas.count;
            this.currentFrameInfo.frameIndex = this.meshState.curMesh.frameIndex;
            if (this.onUpdateCurrentFrame) this.onUpdateCurrentFrame(this.meshState.curMesh.frameIndex);
            this.onUpdate?.(true, this.currentFrameInfo);
            return true;
        }
        this.onUpdate?.(false, this.currentFrameInfo);
        return false;
    }
    close() {
        if (this.httpRequest) {
            this.httpRequest.abort();
            this.httpRequest = null;
        }
        if (this.dashPlayer) this.dashPlayer.reset();
        this.cleanUpEventListeners?.();
        this.videoElement.pause();
        this.videoElement.removeAttribute("src");
        this.videoElement.remove();
        this.videoElementInitialized = false;
        this.state = $13ab5e4789d9fbdb$export$47283907dceba392.Closed;
        this.graphicsBackend.onClose();
    }
    pause() {
        if (this.videoElement) {
            this.videoElement.pause();
            this.state = $13ab5e4789d9fbdb$export$47283907dceba392.Paused;
        }
    }
    setAudioVolume(volume) {
        this.audioVolume = volume;
        this.videoElement.volume = volume;
    }
    setAutoLooping(loop) {
        this.openOptions.autoloop = loop;
        this.videoElement.loop = loop;
    }
    setAudioEnabled(enabled) {
        this.videoElement.muted = !enabled;
    }
    audioEnabled() {
        return !this.videoElement.muted;
    }
    play() {
        if (this.browserInfo.isSafari) this.videoElement.pause();
        const playPromise = this.videoElement.play();
        if (playPromise !== undefined) playPromise.then(()=>{
            this.state = $13ab5e4789d9fbdb$export$47283907dceba392.Playing;
        }).catch((error)=>{
            this._logWarning(`play prevented ${error}`);
            this._onError($13ab5e4789d9fbdb$export$b6616fff1cd26f39.PlaybackPrevented, error);
        });
    }
    open(gltfURL, options) {
        if (this.state >= $13ab5e4789d9fbdb$export$47283907dceba392.Opening) this.close();
        this.state = $13ab5e4789d9fbdb$export$47283907dceba392.Opening;
        this.urlRoot = gltfURL.substring(0, gltfURL.lastIndexOf("/") + 1);
        this.meshFrames = [];
        this.buffersLoaded = 0;
        this.videosLoaded = 0;
        this.freeArrayBuffers = [];
        this.buffers = [];
        this.nextVideoLoadIndex = 0;
        this.nextBufferLoadIndex = 0;
        this.videoState = $13ab5e4789d9fbdb$var$VideoStates.Undefined;
        this.currentFrameInfo = {
            primCount: 0,
            indexCount: 0,
            vertexCount: 0
        };
        this.currentBufferIndex = -1;
        this.lastVideoTime = 0;
        this.lastUpdate = 0;
        this.json = null;
        this.fileInfo = {
            haveNormals: false,
            octEncodedNormals: false
        };
        if (options) this.openOptions = options;
        else this.openOptions = {};
        if (!this.openOptions.minBuffers) this.openOptions.minBuffers = 2;
        if (!this.openOptions.maxBuffers) this.openOptions.maxBuffers = 3;
        this.meshState.curMesh = null;
        this.meshState.prevMesh = null;
        this.meshState.prevPrevMesh = null;
        this.frameIndex = -1;
        this.lastKeyframe = -1;
        this.meshState.lastKeyframeIndices = null;
        this.meshState.lastKeyframeUVs = null;
        this.lastVideoSampleIndex = -1;
        this.filledFallbackFrame = false;
        this.fallbackFrameBuffer = null;
        this.fallbackTextureImage = null;
        this.eos = false;
        delete this.seekTargetTime;
        delete this.searchStartFrame;
        this.onBeforeLoad?.(options);
        this.graphicsBackend.onBeforeLoad(options);
        this._loadJSON(gltfURL, this._onJsonLoaded.bind(this));
    }
    getGraphicsBackend() {
        return this.graphicsBackend;
    }
}




class $013337927f576e46$export$5e105acdb17f490e {
    state;
    _onEndOfStream;
    _hvo;
    _fileInfo;
    _hvoOnEndOfStream(hvo) {
        if (this._onEndOfStream) this._onEndOfStream(this);
    }
    get onUpdateCurrentFrame() {
        return this.hvo.onUpdateCurrentFrame;
    }
    set onUpdateCurrentFrame(callback) {
        this.hvo.onUpdateCurrentFrame = callback;
    }
    get hvo() {
        return this._hvo;
    }
    constructor(context, callback, createOptions, updateCurrentFrameCallback, errorCallback){
        const hvo = this._createHoloVideoObject(context, createOptions, updateCurrentFrameCallback, errorCallback);
        this._hvo = hvo;
        hvo.onEndOfStream = this._hvoOnEndOfStream.bind(this);
        hvo.onUpdateCurrentFrame = updateCurrentFrameCallback;
        hvo.onLoaded = (fileInfo)=>{
            this._fileInfo = fileInfo;
            this.state = this._hvo.state;
            callback(fileInfo);
        };
    }
    open(url, options) {
        if (this.state > (0, $13ab5e4789d9fbdb$export$47283907dceba392).Empty) this.close();
        this._hvo.open(url, options);
        this.state = this._hvo.state;
    }
    update() {
        if (this._hvo) this.state = this._hvo.state;
        this._hvo.updateBuffers();
    }
    rewind() {
        this._hvo.rewind();
    }
    seekToTime(seekTime, displayImmediately) {
        this._hvo.seekToTime(seekTime, displayImmediately);
    }
    play() {
        if (this._hvo.state == (0, $13ab5e4789d9fbdb$export$47283907dceba392).Opening) this._hvo.forceLoad();
        else if (this._hvo.state >= (0, $13ab5e4789d9fbdb$export$47283907dceba392).Opened && this._hvo.state != (0, $13ab5e4789d9fbdb$export$47283907dceba392).Playing) this._hvo.play();
    }
    close() {
        this._hvo.close();
        this.onClose();
    }
    onClose() {}
    pause() {
        this._hvo.pause();
    }
    setLogLevel(level) {
        this._hvo.logLevel = level;
    }
    setAudioEnabled(enabled) {
        this._hvo.setAudioEnabled(enabled);
    }
    audioEnabled() {
        return this._hvo.audioEnabled();
    }
    setAudioVolume(volume) {
        this._hvo.setAudioVolume(volume);
    }
    setAutoLooping(loop) {
        this._hvo.setAutoLooping(loop);
    }
}






class $5baf1ca6b7ed00ff$export$ca33ba2b41a58bcf extends (0, $013337927f576e46$export$5e105acdb17f490e) {
    renderer;
    unlitMaterial;
    litMaterial;
    gl;
    clientBuffers;
    mesh;
    bufferGeometry;
    _createHoloVideoObject(context, createOptions, updateCurrentFrameCallback, errorCallback) {
        const hvo = new (0, $13ab5e4789d9fbdb$export$f8b393fd290a031a)(context, createOptions, errorCallback);
        hvo.onUpdate = this.onUpdate.bind(this);
        return hvo;
    }
    constructor(renderer, callback, createOptions, updateCurrentFrameCallback, errorCallback){
        super(renderer.getContext(), (fileInfo)=>{
            this.onLoaded(fileInfo);
            callback(this.mesh);
        }, {
            outputLinearTextures: renderer.outputEncoding === $0147bee01cff6558$export$f32388edbb32674,
            ...createOptions
        }, updateCurrentFrameCallback, errorCallback);
        this.renderer = renderer;
        const gl = renderer.getContext();
        this.gl = gl;
        this.clientBuffers = {
            tex: gl.createTexture(),
            indexBuf: gl.createBuffer(),
            norBuf: gl.createBuffer(),
            posBuf: gl.createBuffer(),
            uvBuf: gl.createBuffer()
        };
        this.unlitMaterial = new $0147bee01cff6558$export$55cbcc9b622fe1f5({
            map: null,
            transparent: false,
            side: $0147bee01cff6558$export$3b296b6f144d5b03
        });
        this.litMaterial = new $0147bee01cff6558$export$28d04986c4269c9f({
            map: null,
            transparent: false,
            side: $0147bee01cff6558$export$2ede184fc2998901,
            roughness: 1,
            metalness: 0
        });
    }
    release() {
        this.unlitMaterial.dispose();
        this.litMaterial.dispose();
    }
    onLoaded(fileInfo) {
        this._fileInfo = fileInfo;
        const useNormals = fileInfo.haveNormals;
        const indexType = fileInfo.indicesComponentType;
        if (this.hvo.getGraphicsBackend().contextRestoring) {
            if (this.mesh) {
                this.mesh.material.map = this._setVertexAttributes(this.mesh.geometry);
                this.mesh.material.needsUpdate = true;
            }
            return;
        }
        if (this.mesh) {
            const indexAt = this.mesh.geometry.getIndex();
            const normalAt = this.mesh.geometry.getAttribute("normal");
            const haveNormals = normalAt != undefined;
            if (indexAt.type != indexType || haveNormals != useNormals) this.mesh = null;
            else {
                const material = useNormals ? this.litMaterial : this.unlitMaterial;
                material.map = this.mesh.material.map;
                this.mesh.material = material;
            }
        }
        if (!this.mesh) {
            const bufferGeometry = new $0147bee01cff6558$export$b7be63a67df8959();
            bufferGeometry.boundingSphere = new $0147bee01cff6558$export$805e8b72413ccaba();
            bufferGeometry.boundingSphere.set(new $0147bee01cff6558$export$64b5c384219d3699(), Infinity);
            bufferGeometry.boundingBox = new $0147bee01cff6558$export$6f7d5a9418ab2aa3();
            bufferGeometry.boundingBox.set(new $0147bee01cff6558$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $0147bee01cff6558$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            const material = useNormals ? this.litMaterial : this.unlitMaterial;
            material.map = this._setVertexAttributes(bufferGeometry);
            const mesh = new $0147bee01cff6558$export$e176487c05830cc5(bufferGeometry, material);
            mesh.scale.x = 0.001;
            mesh.scale.y = 0.001;
            mesh.scale.z = 0.001;
            this.mesh = mesh;
            this.bufferGeometry = bufferGeometry;
        }
    }
    getMesh() {
        return this.mesh;
    }
    _setVertexAttributes(bufferGeometry) {
        const { gl: gl } = this;
        const { posBuf: posBuf } = this.clientBuffers;
        const revision = Number($0147bee01cff6558$export$3545e07a80636437);
        const posAttr = revision >= 120 ? new $0147bee01cff6558$export$6b7339ae8dbddf73(posBuf, gl.FLOAT, 3, 0) : new $0147bee01cff6558$export$6b7339ae8dbddf73(gl, posBuf, gl.FLOAT, 3, 0);
        bufferGeometry.setAttribute("position", posAttr);
        if (this.clientBuffers.norBuf) {
            const norAttr = revision >= 120 ? new $0147bee01cff6558$export$6b7339ae8dbddf73(this.clientBuffers.norBuf, gl.FLOAT, 3, 0) : new $0147bee01cff6558$export$6b7339ae8dbddf73(gl, this.clientBuffers.norBuf, gl.FLOAT, 3, 0);
            bufferGeometry.setAttribute("normal", norAttr);
        }
        const { uvBuf: uvBuf } = this.clientBuffers;
        const uvAttr = revision >= 120 ? new $0147bee01cff6558$export$6b7339ae8dbddf73(uvBuf, gl.UNSIGNED_SHORT, 2, 0) : new $0147bee01cff6558$export$6b7339ae8dbddf73(gl, uvBuf, gl.UNSIGNED_SHORT, 2, 0);
        uvAttr.normalized = true;
        bufferGeometry.setAttribute("uv", uvAttr);
        const { indexBuf: indexBuf } = this.clientBuffers;
        const indAttr = revision >= 120 ? new $0147bee01cff6558$export$6b7339ae8dbddf73(indexBuf, this._fileInfo.indicesComponentType, 0, 0) : new $0147bee01cff6558$export$6b7339ae8dbddf73(gl, indexBuf, this._fileInfo.indicesComponentType, 0, 0);
        bufferGeometry.setIndex(indAttr);
        const texture = new $0147bee01cff6558$export$5431306cf43de24a();
        const texProps = this.renderer.properties.get(texture);
        texProps.__webglTexture = this.clientBuffers.tex;
        var saveTex = gl.getParameter(gl.TEXTURE_BINDING_2D);
        gl.bindTexture(gl.TEXTURE_2D, texProps.__webglTexture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, this._fileInfo.videoWidth, this._fileInfo.videoHeight, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.bindTexture(gl.TEXTURE_2D, saveTex);
        this.hvo.setBuffers(this.clientBuffers);
        return texture;
    }
    onUpdate(updated, currentFrameInfo) {
        if (!updated) return;
        const min = currentFrameInfo.bboxMin;
        const max = currentFrameInfo.bboxMax;
        const bufferGeometry = this.bufferGeometry;
        bufferGeometry.boundingBox.min.x = min[0];
        bufferGeometry.boundingBox.min.y = min[1];
        bufferGeometry.boundingBox.min.z = min[2];
        bufferGeometry.boundingBox.max.x = max[0];
        bufferGeometry.boundingBox.max.y = max[1];
        bufferGeometry.boundingBox.max.z = max[2];
        bufferGeometry.boundingBox.getCenter(bufferGeometry.boundingSphere.center);
        const maxSide = Math.max(max[0] - min[0], max[1] - min[1], max[2] - min[2]);
        bufferGeometry.boundingSphere.radius = maxSide * 0.5;
        bufferGeometry.index.count = currentFrameInfo.primCount;
    }
    onClose() {
        if (this.bufferGeometry) this.bufferGeometry.index.count = 0;
    }
}


class $7bcffd70349fa9a4$export$da3cdac99155b982 {
    static createButton(renderer) {
        const button = document.createElement("button");
        function showEnterVR() {
            let currentSession = null;
            async function onSessionStarted(session) {
                session.addEventListener("end", onSessionEnded);
                await renderer.xr.setSession(session);
                button.textContent = "EXIT VR";
                currentSession = session;
            }
            function onSessionEnded() {
                currentSession.removeEventListener("end", onSessionEnded);
                button.textContent = "ENTER VR";
                currentSession = null;
            }
            //
            button.style.display = "";
            button.style.cursor = "pointer";
            button.style.left = "calc(50% - 50px)";
            button.style.width = "100px";
            button.textContent = "ENTER VR";
            button.onmouseenter = function() {
                button.style.opacity = "1.0";
            };
            button.onmouseleave = function() {
                button.style.opacity = "0.5";
            };
            button.onclick = function() {
                if (currentSession === null) {
                    // WebXR's requestReferenceSpace only works if the corresponding feature
                    // was requested at session creation time. For simplicity, just ask for
                    // the interesting ones as optional features, but be aware that the
                    // requestReferenceSpace call will fail if it turns out to be unavailable.
                    // ('local' is always available for immersive sessions and doesn't need to
                    // be requested separately.)
                    const sessionInit = {
                        optionalFeatures: [
                            "local-floor",
                            "bounded-floor",
                            "hand-tracking",
                            "layers"
                        ]
                    };
                    navigator.xr.requestSession("immersive-vr", sessionInit).then(onSessionStarted);
                } else currentSession.end();
            };
        }
        function disableButton() {
            button.style.display = "";
            button.style.cursor = "auto";
            button.style.left = "calc(50% - 75px)";
            button.style.width = "150px";
            button.onmouseenter = null;
            button.onmouseleave = null;
            button.onclick = null;
        }
        function showWebXRNotFound() {
            disableButton();
            button.textContent = "VR NOT SUPPORTED";
        }
        function showVRNotAllowed(exception) {
            disableButton();
            console.warn("Exception when trying to call xr.isSessionSupported", exception);
            button.textContent = "VR NOT ALLOWED";
        }
        function stylizeElement(element) {
            element.style.position = "absolute";
            element.style.bottom = "20px";
            element.style.padding = "12px 6px";
            element.style.border = "1px solid #fff";
            element.style.borderRadius = "4px";
            element.style.background = "rgba(0,0,0,0.1)";
            element.style.color = "#fff";
            element.style.font = "normal 13px sans-serif";
            element.style.textAlign = "center";
            element.style.opacity = "0.5";
            element.style.outline = "none";
            element.style.zIndex = "999";
        }
        if ("xr" in navigator) {
            button.id = "VRButton";
            button.style.display = "none";
            stylizeElement(button);
            navigator.xr.isSessionSupported("immersive-vr").then(function(supported) {
                supported ? showEnterVR() : showWebXRNotFound();
                if (supported && $7bcffd70349fa9a4$export$da3cdac99155b982.xrSessionIsGranted) button.click();
            }).catch(showVRNotAllowed);
            return button;
        } else {
            const message = document.createElement("a");
            if (window.isSecureContext === false) {
                message.href = document.location.href.replace(/^http:/, "https:");
                message.innerHTML = "WEBXR NEEDS HTTPS"; // TODO Improve message
            } else {
                message.href = "https://immersiveweb.dev/";
                message.innerHTML = "WEBXR NOT AVAILABLE";
            }
            message.style.left = "calc(50% - 90px)";
            message.style.width = "180px";
            message.style.textDecoration = "none";
            stylizeElement(message);
            return message;
        }
    }
    static registerSessionGrantedListener() {
        if ("xr" in navigator) {
            // WebXRViewer (based on Firefox) has a bug where addEventListener
            // throws a silent exception and aborts execution entirely.
            if (/WebXRViewer\//i.test(navigator.userAgent)) return;
            navigator.xr.addEventListener("sessiongranted", ()=>{
                $7bcffd70349fa9a4$export$da3cdac99155b982.xrSessionIsGranted = true;
            });
        }
    }
}
$7bcffd70349fa9a4$export$da3cdac99155b982.xrSessionIsGranted = false;
$7bcffd70349fa9a4$export$da3cdac99155b982.registerSessionGrantedListener();


/**
 * https://github.com/google/model-viewer/blob/master/packages/model-viewer/src/three-components/EnvironmentScene.ts
 */ 
class $ee4de29e557e6ffd$export$3ee6a4df67079774 extends (0, $0147bee01cff6558$export$38af1803e3442a7f) {
    constructor(renderer = null){
        super();
        const geometry = new (0, $0147bee01cff6558$export$33e43285f7406bd5)();
        geometry.deleteAttribute("uv");
        const roomMaterial = new (0, $0147bee01cff6558$export$f2980790215acccd)({
            side: (0, $0147bee01cff6558$export$d9f0486e75b5ace)
        });
        const boxMaterial = new (0, $0147bee01cff6558$export$f2980790215acccd)();
        let intensity = 5;
        if (renderer !== null && renderer._useLegacyLights === false) intensity = 900;
        const mainLight = new (0, $0147bee01cff6558$export$4c9c1cb3f0b6f455)(0xffffff, intensity, 28, 2);
        mainLight.position.set(0.418, 16.199, 0.300);
        this.add(mainLight);
        const room = new (0, $0147bee01cff6558$export$e176487c05830cc5)(geometry, roomMaterial);
        room.position.set(-0.757, 13.219, 0.717);
        room.scale.set(31.713, 28.305, 28.591);
        this.add(room);
        const box1 = new (0, $0147bee01cff6558$export$e176487c05830cc5)(geometry, boxMaterial);
        box1.position.set(-10.906, 2.009, 1.846);
        box1.rotation.set(0, -0.195, 0);
        box1.scale.set(2.328, 7.905, 4.651);
        this.add(box1);
        const box2 = new (0, $0147bee01cff6558$export$e176487c05830cc5)(geometry, boxMaterial);
        box2.position.set(-5.607, -0.754, -0.758);
        box2.rotation.set(0, 0.994, 0);
        box2.scale.set(1.970, 1.534, 3.955);
        this.add(box2);
        const box3 = new (0, $0147bee01cff6558$export$e176487c05830cc5)(geometry, boxMaterial);
        box3.position.set(6.167, 0.857, 7.803);
        box3.rotation.set(0, 0.561, 0);
        box3.scale.set(3.927, 6.285, 3.687);
        this.add(box3);
        const box4 = new (0, $0147bee01cff6558$export$e176487c05830cc5)(geometry, boxMaterial);
        box4.position.set(-2.017, 0.018, 6.124);
        box4.rotation.set(0, 0.333, 0);
        box4.scale.set(2.002, 4.566, 2.064);
        this.add(box4);
        const box5 = new (0, $0147bee01cff6558$export$e176487c05830cc5)(geometry, boxMaterial);
        box5.position.set(2.291, -0.756, -2.621);
        box5.rotation.set(0, -0.286, 0);
        box5.scale.set(1.546, 1.552, 1.496);
        this.add(box5);
        const box6 = new (0, $0147bee01cff6558$export$e176487c05830cc5)(geometry, boxMaterial);
        box6.position.set(-2.193, -0.369, -5.547);
        box6.rotation.set(0, 0.516, 0);
        box6.scale.set(3.875, 3.487, 2.986);
        this.add(box6);
        // -x right
        const light1 = new (0, $0147bee01cff6558$export$e176487c05830cc5)(geometry, $ee4de29e557e6ffd$var$createAreaLightMaterial(50));
        light1.position.set(-16.116, 14.37, 8.208);
        light1.scale.set(0.1, 2.428, 2.739);
        this.add(light1);
        // -x left
        const light2 = new (0, $0147bee01cff6558$export$e176487c05830cc5)(geometry, $ee4de29e557e6ffd$var$createAreaLightMaterial(50));
        light2.position.set(-16.109, 18.021, -8.207);
        light2.scale.set(0.1, 2.425, 2.751);
        this.add(light2);
        // +x
        const light3 = new (0, $0147bee01cff6558$export$e176487c05830cc5)(geometry, $ee4de29e557e6ffd$var$createAreaLightMaterial(17));
        light3.position.set(14.904, 12.198, -1.832);
        light3.scale.set(0.15, 4.265, 6.331);
        this.add(light3);
        // +z
        const light4 = new (0, $0147bee01cff6558$export$e176487c05830cc5)(geometry, $ee4de29e557e6ffd$var$createAreaLightMaterial(43));
        light4.position.set(-0.462, 8.89, 14.520);
        light4.scale.set(4.38, 5.441, 0.088);
        this.add(light4);
        // -z
        const light5 = new (0, $0147bee01cff6558$export$e176487c05830cc5)(geometry, $ee4de29e557e6ffd$var$createAreaLightMaterial(20));
        light5.position.set(3.235, 11.486, -12.541);
        light5.scale.set(2.5, 2.0, 0.1);
        this.add(light5);
        // +y
        const light6 = new (0, $0147bee01cff6558$export$e176487c05830cc5)(geometry, $ee4de29e557e6ffd$var$createAreaLightMaterial(100));
        light6.position.set(0.0, 20.0, 0.0);
        light6.scale.set(1.0, 0.1, 1.0);
        this.add(light6);
    }
    dispose() {
        const resources = new Set();
        this.traverse((object)=>{
            if (object.isMesh) {
                resources.add(object.geometry);
                resources.add(object.material);
            }
        });
        for (const resource of resources)resource.dispose();
    }
}
function $ee4de29e557e6ffd$var$createAreaLightMaterial(intensity) {
    const material = new (0, $0147bee01cff6558$export$55cbcc9b622fe1f5)();
    material.color.setScalar(intensity);
    return material;
}



class $6a85eb725296279e$export$f537b6caa7ee8695 extends (0, $0147bee01cff6558$export$e176487c05830cc5) {
    constructor(dom){
        const texture = new $6a85eb725296279e$var$HTMLTexture(dom);
        const geometry = new (0, $0147bee01cff6558$export$967d831af31f69ce)(texture.image.width * 0.001, texture.image.height * 0.001);
        const material = new (0, $0147bee01cff6558$export$55cbcc9b622fe1f5)({
            map: texture,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        function onEvent(event) {
            material.map.dispatchDOMEvent(event);
        }
        this.addEventListener("mousedown", onEvent);
        this.addEventListener("mousemove", onEvent);
        this.addEventListener("mouseup", onEvent);
        this.addEventListener("click", onEvent);
        this.dispose = function() {
            geometry.dispose();
            material.dispose();
            material.map.dispose();
            $6a85eb725296279e$var$canvases.delete(dom);
            this.removeEventListener("mousedown", onEvent);
            this.removeEventListener("mousemove", onEvent);
            this.removeEventListener("mouseup", onEvent);
            this.removeEventListener("click", onEvent);
        };
    }
}
class $6a85eb725296279e$var$HTMLTexture extends (0, $0147bee01cff6558$export$f7189e49152d1c13) {
    constructor(dom){
        super($6a85eb725296279e$var$html2canvas(dom));
        this.dom = dom;
        this.anisotropy = 16;
        this.colorSpace = (0, $0147bee01cff6558$export$561f394b24edfcaa);
        this.minFilter = (0, $0147bee01cff6558$export$8a72f490b25c56c8);
        this.magFilter = (0, $0147bee01cff6558$export$8a72f490b25c56c8);
        // Create an observer on the DOM, and run html2canvas update in the next loop
        const observer = new MutationObserver(()=>{
            if (!this.scheduleUpdate) // ideally should use xr.requestAnimationFrame, here setTimeout to avoid passing the renderer
            this.scheduleUpdate = setTimeout(()=>this.update(), 16);
        });
        const config = {
            attributes: true,
            childList: true,
            subtree: true,
            characterData: true
        };
        observer.observe(dom, config);
        this.observer = observer;
    }
    dispatchDOMEvent(event) {
        if (event.data) $6a85eb725296279e$var$htmlevent(this.dom, event.type, event.data.x, event.data.y);
    }
    update() {
        this.image = $6a85eb725296279e$var$html2canvas(this.dom);
        this.needsUpdate = true;
        this.scheduleUpdate = null;
    }
    dispose() {
        if (this.observer) this.observer.disconnect();
        this.scheduleUpdate = clearTimeout(this.scheduleUpdate);
        super.dispose();
    }
}
//
const $6a85eb725296279e$var$canvases = new WeakMap();
function $6a85eb725296279e$var$html2canvas(element) {
    const range = document.createRange();
    const color = new (0, $0147bee01cff6558$export$892596cec99bc70e)();
    function Clipper(context) {
        const clips = [];
        let isClipping = false;
        function doClip() {
            if (isClipping) {
                isClipping = false;
                context.restore();
            }
            if (clips.length === 0) return;
            let minX = -Infinity, minY = -Infinity;
            let maxX = Infinity, maxY = Infinity;
            for(let i = 0; i < clips.length; i++){
                const clip = clips[i];
                minX = Math.max(minX, clip.x);
                minY = Math.max(minY, clip.y);
                maxX = Math.min(maxX, clip.x + clip.width);
                maxY = Math.min(maxY, clip.y + clip.height);
            }
            context.save();
            context.beginPath();
            context.rect(minX, minY, maxX - minX, maxY - minY);
            context.clip();
            isClipping = true;
        }
        return {
            add: function(clip) {
                clips.push(clip);
                doClip();
            },
            remove: function() {
                clips.pop();
                doClip();
            }
        };
    }
    function drawText(style, x, y, string) {
        if (string !== "") {
            if (style.textTransform === "uppercase") string = string.toUpperCase();
            context.font = style.fontWeight + " " + style.fontSize + " " + style.fontFamily;
            context.textBaseline = "top";
            context.fillStyle = style.color;
            context.fillText(string, x, y + parseFloat(style.fontSize) * 0.1);
        }
    }
    function buildRectPath(x, y, w, h, r) {
        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;
        context.beginPath();
        context.moveTo(x + r, y);
        context.arcTo(x + w, y, x + w, y + h, r);
        context.arcTo(x + w, y + h, x, y + h, r);
        context.arcTo(x, y + h, x, y, r);
        context.arcTo(x, y, x + w, y, r);
        context.closePath();
    }
    function drawBorder(style, which, x, y, width, height) {
        const borderWidth = style[which + "Width"];
        const borderStyle = style[which + "Style"];
        const borderColor = style[which + "Color"];
        if (borderWidth !== "0px" && borderStyle !== "none" && borderColor !== "transparent" && borderColor !== "rgba(0, 0, 0, 0)") {
            context.strokeStyle = borderColor;
            context.lineWidth = parseFloat(borderWidth);
            context.beginPath();
            context.moveTo(x, y);
            context.lineTo(x + width, y + height);
            context.stroke();
        }
    }
    function drawElement(element, style) {
        let x = 0, y = 0, width = 0, height = 0;
        if (element.nodeType === Node.TEXT_NODE) {
            // text
            range.selectNode(element);
            const rect = range.getBoundingClientRect();
            x = rect.left - offset.left - 0.5;
            y = rect.top - offset.top - 0.5;
            width = rect.width;
            height = rect.height;
            drawText(style, x, y, element.nodeValue.trim());
        } else if (element.nodeType === Node.COMMENT_NODE) return;
        else if (element instanceof HTMLCanvasElement) {
            // Canvas element
            if (element.style.display === "none") return;
            context.save();
            const dpr = window.devicePixelRatio;
            context.scale(1 / dpr, 1 / dpr);
            context.drawImage(element, 0, 0);
            context.restore();
        } else if (element instanceof HTMLImageElement) {
            if (element.style.display === "none") return;
            const rect = element.getBoundingClientRect();
            x = rect.left - offset.left - 0.5;
            y = rect.top - offset.top - 0.5;
            width = rect.width;
            height = rect.height;
            context.drawImage(element, x, y, width, height);
        } else {
            if (element.style.display === "none") return;
            const rect = element.getBoundingClientRect();
            x = rect.left - offset.left - 0.5;
            y = rect.top - offset.top - 0.5;
            width = rect.width;
            height = rect.height;
            style = window.getComputedStyle(element);
            // Get the border of the element used for fill and border
            buildRectPath(x, y, width, height, parseFloat(style.borderRadius));
            const backgroundColor = style.backgroundColor;
            if (backgroundColor !== "transparent" && backgroundColor !== "rgba(0, 0, 0, 0)") {
                context.fillStyle = backgroundColor;
                context.fill();
            }
            // If all the borders match then stroke the round rectangle
            const borders = [
                "borderTop",
                "borderLeft",
                "borderBottom",
                "borderRight"
            ];
            let match = true;
            let prevBorder = null;
            for (const border of borders){
                if (prevBorder !== null) match = style[border + "Width"] === style[prevBorder + "Width"] && style[border + "Color"] === style[prevBorder + "Color"] && style[border + "Style"] === style[prevBorder + "Style"];
                if (match === false) break;
                prevBorder = border;
            }
            if (match === true) {
                // They all match so stroke the rectangle from before allows for border-radius
                const width = parseFloat(style.borderTopWidth);
                if (style.borderTopWidth !== "0px" && style.borderTopStyle !== "none" && style.borderTopColor !== "transparent" && style.borderTopColor !== "rgba(0, 0, 0, 0)") {
                    context.strokeStyle = style.borderTopColor;
                    context.lineWidth = width;
                    context.stroke();
                }
            } else {
                // Otherwise draw individual borders
                drawBorder(style, "borderTop", x, y, width, 0);
                drawBorder(style, "borderLeft", x, y, 0, height);
                drawBorder(style, "borderBottom", x, y + height, width, 0);
                drawBorder(style, "borderRight", x + width, y, 0, height);
            }
            if (element instanceof HTMLInputElement) {
                let accentColor = style.accentColor;
                if (accentColor === undefined || accentColor === "auto") accentColor = style.color;
                color.set(accentColor);
                const luminance = Math.sqrt(0.299 * color.r ** 2 + 0.587 * color.g ** 2 + 0.114 * color.b ** 2);
                const accentTextColor = luminance < 0.5 ? "white" : "#111111";
                if (element.type === "radio") {
                    buildRectPath(x, y, width, height, height);
                    context.fillStyle = "white";
                    context.strokeStyle = accentColor;
                    context.lineWidth = 1;
                    context.fill();
                    context.stroke();
                    if (element.checked) {
                        buildRectPath(x + 2, y + 2, width - 4, height - 4, height);
                        context.fillStyle = accentColor;
                        context.strokeStyle = accentTextColor;
                        context.lineWidth = 2;
                        context.fill();
                        context.stroke();
                    }
                }
                if (element.type === "checkbox") {
                    buildRectPath(x, y, width, height, 2);
                    context.fillStyle = element.checked ? accentColor : "white";
                    context.strokeStyle = element.checked ? accentTextColor : accentColor;
                    context.lineWidth = 1;
                    context.stroke();
                    context.fill();
                    if (element.checked) {
                        const currentTextAlign = context.textAlign;
                        context.textAlign = "center";
                        const properties = {
                            color: accentTextColor,
                            fontFamily: style.fontFamily,
                            fontSize: height + "px",
                            fontWeight: "bold"
                        };
                        drawText(properties, x + width / 2, y, "✔");
                        context.textAlign = currentTextAlign;
                    }
                }
                if (element.type === "range") {
                    const [min, max, value] = [
                        "min",
                        "max",
                        "value"
                    ].map((property)=>parseFloat(element[property]));
                    const position = (value - min) / (max - min) * (width - height);
                    buildRectPath(x, y + height / 4, width, height / 2, height / 4);
                    context.fillStyle = accentTextColor;
                    context.strokeStyle = accentColor;
                    context.lineWidth = 1;
                    context.fill();
                    context.stroke();
                    buildRectPath(x, y + height / 4, position + height / 2, height / 2, height / 4);
                    context.fillStyle = accentColor;
                    context.fill();
                    buildRectPath(x + position, y, height, height, height / 2);
                    context.fillStyle = accentColor;
                    context.fill();
                }
                if (element.type === "color" || element.type === "text" || element.type === "number") {
                    clipper.add({
                        x: x,
                        y: y,
                        width: width,
                        height: height
                    });
                    drawText(style, x + parseInt(style.paddingLeft), y + parseInt(style.paddingTop), element.value);
                    clipper.remove();
                }
            }
        }
        /*
		// debug
		context.strokeStyle = '#' + Math.random().toString( 16 ).slice( - 3 );
		context.strokeRect( x - 0.5, y - 0.5, width + 1, height + 1 );
		*/ const isClipping = style.overflow === "auto" || style.overflow === "hidden";
        if (isClipping) clipper.add({
            x: x,
            y: y,
            width: width,
            height: height
        });
        for(let i = 0; i < element.childNodes.length; i++)drawElement(element.childNodes[i], style);
        if (isClipping) clipper.remove();
    }
    const offset = element.getBoundingClientRect();
    let canvas = $6a85eb725296279e$var$canvases.get(element);
    if (canvas === undefined) {
        canvas = document.createElement("canvas");
        canvas.width = offset.width;
        canvas.height = offset.height;
        $6a85eb725296279e$var$canvases.set(element, canvas);
    }
    const context = canvas.getContext("2d" /*, { alpha: false }*/ );
    const clipper = new Clipper(context);
    // console.time( 'drawElement' );
    drawElement(element);
    // console.timeEnd( 'drawElement' );
    return canvas;
}
function $6a85eb725296279e$var$htmlevent(element, event, x, y) {
    const mouseEventInit = {
        clientX: x * element.offsetWidth + element.offsetLeft,
        clientY: y * element.offsetHeight + element.offsetTop,
        view: element.ownerDocument.defaultView
    };
    window.dispatchEvent(new MouseEvent(event, mouseEventInit));
    const rect = element.getBoundingClientRect();
    x = x * rect.width + rect.left;
    y = y * rect.height + rect.top;
    function traverse(element) {
        if (element.nodeType !== Node.TEXT_NODE && element.nodeType !== Node.COMMENT_NODE) {
            const rect = element.getBoundingClientRect();
            if (x > rect.left && x < rect.right && y > rect.top && y < rect.bottom) {
                element.dispatchEvent(new MouseEvent(event, mouseEventInit));
                if (element instanceof HTMLInputElement && element.type === "range" && (event === "mousedown" || event === "click")) {
                    const [min, max] = [
                        "min",
                        "max"
                    ].map((property)=>parseFloat(element[property]));
                    const width = rect.width;
                    const offsetX = x - rect.x;
                    const proportion = offsetX / width;
                    element.value = min + (max - min) * proportion;
                    element.dispatchEvent(new InputEvent("input", {
                        bubbles: true
                    }));
                }
            }
            for(let i = 0; i < element.childNodes.length; i++)traverse(element.childNodes[i]);
        }
    }
    traverse(element);
}



const $5ad5390113600fe3$var$_pointer = new (0, $0147bee01cff6558$export$c977b3e384af9ae1)();
const $5ad5390113600fe3$var$_event = {
    type: "",
    data: $5ad5390113600fe3$var$_pointer
};
class $5ad5390113600fe3$export$9aa3194f2509a9b4 extends (0, $0147bee01cff6558$export$eb2fcfdbd7ba97d4) {
    constructor(renderer, camera){
        super();
        const scope = this;
        const raycaster = new (0, $0147bee01cff6558$export$8b7aaceff00bd2f)();
        const tempMatrix = new (0, $0147bee01cff6558$export$2ae72fc923e5eb5)();
        // Pointer Events
        const element = renderer.domElement;
        function onPointerEvent(event) {
            event.stopPropagation();
            const rect = renderer.domElement.getBoundingClientRect();
            $5ad5390113600fe3$var$_pointer.x = (event.clientX - rect.left) / rect.width * 2 - 1;
            $5ad5390113600fe3$var$_pointer.y = -(event.clientY - rect.top) / rect.height * 2 + 1;
            raycaster.setFromCamera($5ad5390113600fe3$var$_pointer, camera);
            const intersects = raycaster.intersectObjects(scope.children, false);
            if (intersects.length > 0) {
                const intersection = intersects[0];
                const object = intersection.object;
                const uv = intersection.uv;
                $5ad5390113600fe3$var$_event.type = event.type;
                $5ad5390113600fe3$var$_event.data.set(uv.x, 1 - uv.y);
                object.dispatchEvent($5ad5390113600fe3$var$_event);
            }
        }
        element.addEventListener("pointerdown", onPointerEvent);
        element.addEventListener("pointerup", onPointerEvent);
        element.addEventListener("pointermove", onPointerEvent);
        element.addEventListener("mousedown", onPointerEvent);
        element.addEventListener("mouseup", onPointerEvent);
        element.addEventListener("mousemove", onPointerEvent);
        element.addEventListener("click", onPointerEvent);
        // WebXR Controller Events
        // TODO: Dispatch pointerevents too
        const events = {
            "move": "mousemove",
            "select": "click",
            "selectstart": "mousedown",
            "selectend": "mouseup"
        };
        function onXRControllerEvent(event) {
            const controller = event.target;
            tempMatrix.identity().extractRotation(controller.matrixWorld);
            raycaster.ray.origin.setFromMatrixPosition(controller.matrixWorld);
            raycaster.ray.direction.set(0, 0, -1).applyMatrix4(tempMatrix);
            const intersections = raycaster.intersectObjects(scope.children, false);
            if (intersections.length > 0) {
                const intersection = intersections[0];
                const object = intersection.object;
                const uv = intersection.uv;
                $5ad5390113600fe3$var$_event.type = events[event.type];
                $5ad5390113600fe3$var$_event.data.set(uv.x, 1 - uv.y);
                object.dispatchEvent($5ad5390113600fe3$var$_event);
            }
        }
        const controller1 = renderer.xr.getController(0);
        controller1.addEventListener("move", onXRControllerEvent);
        controller1.addEventListener("select", onXRControllerEvent);
        controller1.addEventListener("selectstart", onXRControllerEvent);
        controller1.addEventListener("selectend", onXRControllerEvent);
        const controller2 = renderer.xr.getController(1);
        controller2.addEventListener("move", onXRControllerEvent);
        controller2.addEventListener("select", onXRControllerEvent);
        controller2.addEventListener("selectstart", onXRControllerEvent);
        controller2.addEventListener("selectend", onXRControllerEvent);
    }
}




const $4a34a76b78d8eebe$var$inverseProjectionMatrix = new (0, $0147bee01cff6558$export$2ae72fc923e5eb5)();
class $4a34a76b78d8eebe$export$a9ce8eb014bc1bb4 {
    constructor(data){
        data = data || {};
        this.vertices = {
            near: [
                new (0, $0147bee01cff6558$export$64b5c384219d3699)(),
                new (0, $0147bee01cff6558$export$64b5c384219d3699)(),
                new (0, $0147bee01cff6558$export$64b5c384219d3699)(),
                new (0, $0147bee01cff6558$export$64b5c384219d3699)()
            ],
            far: [
                new (0, $0147bee01cff6558$export$64b5c384219d3699)(),
                new (0, $0147bee01cff6558$export$64b5c384219d3699)(),
                new (0, $0147bee01cff6558$export$64b5c384219d3699)(),
                new (0, $0147bee01cff6558$export$64b5c384219d3699)()
            ]
        };
        if (data.projectionMatrix !== undefined) this.setFromProjectionMatrix(data.projectionMatrix, data.maxFar || 10000);
    }
    setFromProjectionMatrix(projectionMatrix, maxFar) {
        const isOrthographic = projectionMatrix.elements[11] === 0;
        $4a34a76b78d8eebe$var$inverseProjectionMatrix.copy(projectionMatrix).invert();
        // 3 --- 0  vertices.near/far order
        // |     |
        // 2 --- 1
        // clip space spans from [-1, 1]
        this.vertices.near[0].set(1, 1, -1);
        this.vertices.near[1].set(1, -1, -1);
        this.vertices.near[2].set(-1, -1, -1);
        this.vertices.near[3].set(-1, 1, -1);
        this.vertices.near.forEach(function(v) {
            v.applyMatrix4($4a34a76b78d8eebe$var$inverseProjectionMatrix);
        });
        this.vertices.far[0].set(1, 1, 1);
        this.vertices.far[1].set(1, -1, 1);
        this.vertices.far[2].set(-1, -1, 1);
        this.vertices.far[3].set(-1, 1, 1);
        this.vertices.far.forEach(function(v) {
            v.applyMatrix4($4a34a76b78d8eebe$var$inverseProjectionMatrix);
            const absZ = Math.abs(v.z);
            if (isOrthographic) v.z *= Math.min(maxFar / absZ, 1.0);
            else v.multiplyScalar(Math.min(maxFar / absZ, 1.0));
        });
        return this.vertices;
    }
    split(breaks, target) {
        while(breaks.length > target.length)target.push(new $4a34a76b78d8eebe$export$a9ce8eb014bc1bb4());
        target.length = breaks.length;
        for(let i = 0; i < breaks.length; i++){
            const cascade = target[i];
            if (i === 0) for(let j = 0; j < 4; j++)cascade.vertices.near[j].copy(this.vertices.near[j]);
            else for(let j = 0; j < 4; j++)cascade.vertices.near[j].lerpVectors(this.vertices.near[j], this.vertices.far[j], breaks[i - 1]);
            if (i === breaks.length - 1) for(let j = 0; j < 4; j++)cascade.vertices.far[j].copy(this.vertices.far[j]);
            else for(let j = 0; j < 4; j++)cascade.vertices.far[j].lerpVectors(this.vertices.near[j], this.vertices.far[j], breaks[i]);
        }
    }
    toSpace(cameraMatrix, target) {
        for(let i = 0; i < 4; i++){
            target.vertices.near[i].copy(this.vertices.near[i]).applyMatrix4(cameraMatrix);
            target.vertices.far[i].copy(this.vertices.far[i]).applyMatrix4(cameraMatrix);
        }
    }
}



const $73006b90e99d0fba$export$ae677f2accb40597 = {
    lights_fragment_begin: /* glsl */ `
GeometricContext geometry;

geometry.position = - vViewPosition;
geometry.normal = normal;
geometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );

#ifdef CLEARCOAT

	geometry.clearcoatNormal = clearcoatNormal;

#endif

IncidentLight directLight;

#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )

	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif

	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {

		pointLight = pointLights[ i ];

		getPointLightInfo( pointLight, geometry, directLight );

		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif

		RE_Direct( directLight, geometry, material, reflectedLight );

	}
	#pragma unroll_loop_end

#endif

#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )

	SpotLight spotLight;
	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif

	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {

		spotLight = spotLights[ i ];

		getSpotLightInfo( spotLight, geometry, directLight );

		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;

		#endif

		RE_Direct( directLight, geometry, material, reflectedLight );

	}
	#pragma unroll_loop_end

#endif

#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct ) && defined( USE_CSM ) && defined( CSM_CASCADES )

	DirectionalLight directionalLight;
	float linearDepth = (vViewPosition.z) / (shadowFar - cameraNear);
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif

	#if defined( USE_SHADOWMAP ) && defined( CSM_FADE )
	vec2 cascade;
	float cascadeCenter;
	float closestEdge;
	float margin;
	float csmx;
	float csmy;

	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {

		directionalLight = directionalLights[ i ];
		getDirectionalLightInfo( directionalLight, geometry, directLight );

	  	#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
			// NOTE: Depth gets larger away from the camera.
			// cascade.x is closer, cascade.y is further
			cascade = CSM_cascades[ i ];
			cascadeCenter = ( cascade.x + cascade.y ) / 2.0;
			closestEdge = linearDepth < cascadeCenter ? cascade.x : cascade.y;
			margin = 0.25 * pow( closestEdge, 2.0 );
			csmx = cascade.x - margin / 2.0;
			csmy = cascade.y + margin / 2.0;
			if( linearDepth >= csmx && ( linearDepth < csmy || UNROLLED_LOOP_INDEX == CSM_CASCADES - 1 ) ) {

				float dist = min( linearDepth - csmx, csmy - linearDepth );
				float ratio = clamp( dist / margin, 0.0, 1.0 );

				vec3 prevColor = directLight.color;
				directionalLightShadow = directionalLightShadows[ i ];
				directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;

				bool shouldFadeLastCascade = UNROLLED_LOOP_INDEX == CSM_CASCADES - 1 && linearDepth > cascadeCenter;
				directLight.color = mix( prevColor, directLight.color, shouldFadeLastCascade ? ratio : 1.0 );

				ReflectedLight prevLight = reflectedLight;
				RE_Direct( directLight, geometry, material, reflectedLight );

				bool shouldBlend = UNROLLED_LOOP_INDEX != CSM_CASCADES - 1 || UNROLLED_LOOP_INDEX == CSM_CASCADES - 1 && linearDepth < cascadeCenter;
				float blendRatio = shouldBlend ? ratio : 1.0;

				reflectedLight.directDiffuse = mix( prevLight.directDiffuse, reflectedLight.directDiffuse, blendRatio );
				reflectedLight.directSpecular = mix( prevLight.directSpecular, reflectedLight.directSpecular, blendRatio );
				reflectedLight.indirectDiffuse = mix( prevLight.indirectDiffuse, reflectedLight.indirectDiffuse, blendRatio );
				reflectedLight.indirectSpecular = mix( prevLight.indirectSpecular, reflectedLight.indirectSpecular, blendRatio );

			}
	  	#endif

	}
	#pragma unroll_loop_end
	#else

		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {

			directionalLight = directionalLights[ i ];
			getDirectionalLightInfo( directionalLight, geometry, directLight );

			#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )

			directionalLightShadow = directionalLightShadows[ i ];
			if(linearDepth >= CSM_cascades[UNROLLED_LOOP_INDEX].x && linearDepth < CSM_cascades[UNROLLED_LOOP_INDEX].y) directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;

			if(linearDepth >= CSM_cascades[UNROLLED_LOOP_INDEX].x && (linearDepth < CSM_cascades[UNROLLED_LOOP_INDEX].y || UNROLLED_LOOP_INDEX == CSM_CASCADES - 1)) RE_Direct( directLight, geometry, material, reflectedLight );

			#endif

		}
		#pragma unroll_loop_end

	#endif

	#if ( NUM_DIR_LIGHTS > NUM_DIR_LIGHT_SHADOWS)
		// compute the lights not casting shadows (if any)

		#pragma unroll_loop_start
		for ( int i = NUM_DIR_LIGHT_SHADOWS; i < NUM_DIR_LIGHTS; i ++ ) {

			directionalLight = directionalLights[ i ];

			getDirectionalLightInfo( directionalLight, geometry, directLight );

			RE_Direct( directLight, geometry, material, reflectedLight );

		}
		#pragma unroll_loop_end

	#endif

#endif


#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct ) && !defined( USE_CSM ) && !defined( CSM_CASCADES )

	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif

	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {

		directionalLight = directionalLights[ i ];

		getDirectionalLightInfo( directionalLight, geometry, directLight );

		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif

		RE_Direct( directLight, geometry, material, reflectedLight );

	}
	#pragma unroll_loop_end

#endif

#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )

	RectAreaLight rectAreaLight;

	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {

		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );

	}
	#pragma unroll_loop_end

#endif

#if defined( RE_IndirectDiffuse )

	vec3 iblIrradiance = vec3( 0.0 );

	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );

	irradiance += getLightProbeIrradiance( lightProbe, geometry.normal );

	#if ( NUM_HEMI_LIGHTS > 0 )

		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {

			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );

		}
		#pragma unroll_loop_end

	#endif

#endif

#if defined( RE_IndirectSpecular )

	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );

#endif
`,
    lights_pars_begin: /* glsl */ `
#if defined( USE_CSM ) && defined( CSM_CASCADES )
uniform vec2 CSM_cascades[CSM_CASCADES];
uniform float cameraNear;
uniform float shadowFar;
#endif
	` + (0, $0147bee01cff6558$export$955f9f2e84c43c8b).lights_pars_begin
};


const $37bae728b1e75d55$var$_cameraToLightMatrix = new (0, $0147bee01cff6558$export$2ae72fc923e5eb5)();
const $37bae728b1e75d55$var$_lightSpaceFrustum = new (0, $4a34a76b78d8eebe$export$a9ce8eb014bc1bb4)();
const $37bae728b1e75d55$var$_center = new (0, $0147bee01cff6558$export$64b5c384219d3699)();
const $37bae728b1e75d55$var$_bbox = new (0, $0147bee01cff6558$export$6f7d5a9418ab2aa3)();
const $37bae728b1e75d55$var$_uniformArray = [];
const $37bae728b1e75d55$var$_logArray = [];
const $37bae728b1e75d55$var$_lightOrientationMatrix = new (0, $0147bee01cff6558$export$2ae72fc923e5eb5)();
const $37bae728b1e75d55$var$_lightOrientationMatrixInverse = new (0, $0147bee01cff6558$export$2ae72fc923e5eb5)();
const $37bae728b1e75d55$var$_up = new (0, $0147bee01cff6558$export$64b5c384219d3699)(0, 1, 0);
class $37bae728b1e75d55$export$e20267fb524e653f {
    constructor(data){
        this.camera = data.camera;
        this.parent = data.parent;
        this.cascades = data.cascades || 3;
        this.maxFar = data.maxFar || 100000;
        this.mode = data.mode || "practical";
        this.shadowMapSize = data.shadowMapSize || 2048;
        this.shadowBias = data.shadowBias || 0.000001;
        this.lightDirection = data.lightDirection || new (0, $0147bee01cff6558$export$64b5c384219d3699)(1, -1, 1).normalize();
        this.lightIntensity = data.lightIntensity || 3;
        this.lightNear = data.lightNear || 1;
        this.lightFar = data.lightFar || 2000;
        this.lightMargin = data.lightMargin || 200;
        this.customSplitsCallback = data.customSplitsCallback;
        this.fade = false;
        this.mainFrustum = new (0, $4a34a76b78d8eebe$export$a9ce8eb014bc1bb4)();
        this.frustums = [];
        this.breaks = [];
        this.lights = [];
        this.shaders = new Map();
        this.createLights();
        this.updateFrustums();
        this.injectInclude();
    }
    createLights() {
        for(let i = 0; i < this.cascades; i++){
            const light = new (0, $0147bee01cff6558$export$3fea33cc9972c868)(0xffffff, this.lightIntensity);
            light.castShadow = true;
            light.shadow.mapSize.width = this.shadowMapSize;
            light.shadow.mapSize.height = this.shadowMapSize;
            light.shadow.camera.near = this.lightNear;
            light.shadow.camera.far = this.lightFar;
            light.shadow.bias = this.shadowBias;
            this.parent.add(light);
            this.parent.add(light.target);
            this.lights.push(light);
        }
    }
    initCascades() {
        const camera = this.camera;
        camera.updateProjectionMatrix();
        this.mainFrustum.setFromProjectionMatrix(camera.projectionMatrix, this.maxFar);
        this.mainFrustum.split(this.breaks, this.frustums);
    }
    updateShadowBounds() {
        const frustums = this.frustums;
        for(let i = 0; i < frustums.length; i++){
            const light = this.lights[i];
            const shadowCam = light.shadow.camera;
            const frustum = this.frustums[i];
            // Get the two points that represent that furthest points on the frustum assuming
            // that's either the diagonal across the far plane or the diagonal across the whole
            // frustum itself.
            const nearVerts = frustum.vertices.near;
            const farVerts = frustum.vertices.far;
            const point1 = farVerts[0];
            let point2;
            if (point1.distanceTo(farVerts[2]) > point1.distanceTo(nearVerts[2])) point2 = farVerts[2];
            else point2 = nearVerts[2];
            let squaredBBWidth = point1.distanceTo(point2);
            if (this.fade) {
                // expand the shadow extents by the fade margin if fade is enabled.
                const camera = this.camera;
                const far = Math.max(camera.far, this.maxFar);
                const linearDepth = frustum.vertices.far[0].z / (far - camera.near);
                const margin = 0.25 * Math.pow(linearDepth, 2.0) * (far - camera.near);
                squaredBBWidth += margin;
            }
            shadowCam.left = -squaredBBWidth / 2;
            shadowCam.right = squaredBBWidth / 2;
            shadowCam.top = squaredBBWidth / 2;
            shadowCam.bottom = -squaredBBWidth / 2;
            shadowCam.updateProjectionMatrix();
        }
    }
    getBreaks() {
        const camera = this.camera;
        const far = Math.min(camera.far, this.maxFar);
        this.breaks.length = 0;
        switch(this.mode){
            case "uniform":
                uniformSplit(this.cascades, camera.near, far, this.breaks);
                break;
            case "logarithmic":
                logarithmicSplit(this.cascades, camera.near, far, this.breaks);
                break;
            case "practical":
                practicalSplit(this.cascades, camera.near, far, 0.5, this.breaks);
                break;
            case "custom":
                if (this.customSplitsCallback === undefined) console.error("CSM: Custom split scheme callback not defined.");
                this.customSplitsCallback(this.cascades, camera.near, far, this.breaks);
                break;
        }
        function uniformSplit(amount, near, far, target) {
            for(let i = 1; i < amount; i++)target.push((near + (far - near) * i / amount) / far);
            target.push(1);
        }
        function logarithmicSplit(amount, near, far, target) {
            for(let i = 1; i < amount; i++)target.push(near * (far / near) ** (i / amount) / far);
            target.push(1);
        }
        function practicalSplit(amount, near, far, lambda, target) {
            $37bae728b1e75d55$var$_uniformArray.length = 0;
            $37bae728b1e75d55$var$_logArray.length = 0;
            logarithmicSplit(amount, near, far, $37bae728b1e75d55$var$_logArray);
            uniformSplit(amount, near, far, $37bae728b1e75d55$var$_uniformArray);
            for(let i = 1; i < amount; i++)target.push((0, $0147bee01cff6558$export$6a7ef315a0d1ef07).lerp($37bae728b1e75d55$var$_uniformArray[i - 1], $37bae728b1e75d55$var$_logArray[i - 1], lambda));
            target.push(1);
        }
    }
    update() {
        const camera = this.camera;
        const frustums = this.frustums;
        // for each frustum we need to find its min-max box aligned with the light orientation
        // the position in _lightOrientationMatrix does not matter, as we transform there and back
        $37bae728b1e75d55$var$_lightOrientationMatrix.lookAt(new (0, $0147bee01cff6558$export$64b5c384219d3699)(), this.lightDirection, $37bae728b1e75d55$var$_up);
        $37bae728b1e75d55$var$_lightOrientationMatrixInverse.copy($37bae728b1e75d55$var$_lightOrientationMatrix).invert();
        for(let i = 0; i < frustums.length; i++){
            const light = this.lights[i];
            const shadowCam = light.shadow.camera;
            const texelWidth = (shadowCam.right - shadowCam.left) / this.shadowMapSize;
            const texelHeight = (shadowCam.top - shadowCam.bottom) / this.shadowMapSize;
            $37bae728b1e75d55$var$_cameraToLightMatrix.multiplyMatrices($37bae728b1e75d55$var$_lightOrientationMatrixInverse, camera.matrixWorld);
            frustums[i].toSpace($37bae728b1e75d55$var$_cameraToLightMatrix, $37bae728b1e75d55$var$_lightSpaceFrustum);
            const nearVerts = $37bae728b1e75d55$var$_lightSpaceFrustum.vertices.near;
            const farVerts = $37bae728b1e75d55$var$_lightSpaceFrustum.vertices.far;
            $37bae728b1e75d55$var$_bbox.makeEmpty();
            for(let j = 0; j < 4; j++){
                $37bae728b1e75d55$var$_bbox.expandByPoint(nearVerts[j]);
                $37bae728b1e75d55$var$_bbox.expandByPoint(farVerts[j]);
            }
            $37bae728b1e75d55$var$_bbox.getCenter($37bae728b1e75d55$var$_center);
            $37bae728b1e75d55$var$_center.z = $37bae728b1e75d55$var$_bbox.max.z + this.lightMargin;
            $37bae728b1e75d55$var$_center.x = Math.floor($37bae728b1e75d55$var$_center.x / texelWidth) * texelWidth;
            $37bae728b1e75d55$var$_center.y = Math.floor($37bae728b1e75d55$var$_center.y / texelHeight) * texelHeight;
            $37bae728b1e75d55$var$_center.applyMatrix4($37bae728b1e75d55$var$_lightOrientationMatrix);
            light.position.copy($37bae728b1e75d55$var$_center);
            light.target.position.copy($37bae728b1e75d55$var$_center);
            light.target.position.x += this.lightDirection.x;
            light.target.position.y += this.lightDirection.y;
            light.target.position.z += this.lightDirection.z;
        }
    }
    injectInclude() {
        (0, $0147bee01cff6558$export$955f9f2e84c43c8b).lights_fragment_begin = (0, $73006b90e99d0fba$export$ae677f2accb40597).lights_fragment_begin;
        (0, $0147bee01cff6558$export$955f9f2e84c43c8b).lights_pars_begin = (0, $73006b90e99d0fba$export$ae677f2accb40597).lights_pars_begin;
    }
    setupMaterial(material) {
        material.defines = material.defines || {};
        material.defines.USE_CSM = 1;
        material.defines.CSM_CASCADES = this.cascades;
        if (this.fade) material.defines.CSM_FADE = "";
        const breaksVec2 = [];
        const scope = this;
        const shaders = this.shaders;
        material.onBeforeCompile = function(shader) {
            const far = Math.min(scope.camera.far, scope.maxFar);
            scope.getExtendedBreaks(breaksVec2);
            shader.uniforms.CSM_cascades = {
                value: breaksVec2
            };
            shader.uniforms.cameraNear = {
                value: scope.camera.near
            };
            shader.uniforms.shadowFar = {
                value: far
            };
            shaders.set(material, shader);
        };
        shaders.set(material, null);
    }
    updateUniforms() {
        const far = Math.min(this.camera.far, this.maxFar);
        const shaders = this.shaders;
        shaders.forEach(function(shader, material) {
            if (shader !== null) {
                const uniforms = shader.uniforms;
                this.getExtendedBreaks(uniforms.CSM_cascades.value);
                uniforms.cameraNear.value = this.camera.near;
                uniforms.shadowFar.value = far;
            }
            if (!this.fade && "CSM_FADE" in material.defines) {
                delete material.defines.CSM_FADE;
                material.needsUpdate = true;
            } else if (this.fade && !("CSM_FADE" in material.defines)) {
                material.defines.CSM_FADE = "";
                material.needsUpdate = true;
            }
        }, this);
    }
    getExtendedBreaks(target) {
        while(target.length < this.breaks.length)target.push(new (0, $0147bee01cff6558$export$c977b3e384af9ae1)());
        target.length = this.breaks.length;
        for(let i = 0; i < this.cascades; i++){
            const amount = this.breaks[i];
            const prev = this.breaks[i - 1] || 0;
            target[i].x = prev;
            target[i].y = amount;
        }
    }
    updateFrustums() {
        this.getBreaks();
        this.initCascades();
        this.updateShadowBounds();
        this.updateUniforms();
    }
    remove() {
        for(let i = 0; i < this.lights.length; i++){
            this.parent.remove(this.lights[i].target);
            this.parent.remove(this.lights[i]);
        }
    }
    dispose() {
        const shaders = this.shaders;
        shaders.forEach(function(shader, material) {
            delete material.onBeforeCompile;
            delete material.defines.USE_CSM;
            delete material.defines.CSM_CASCADES;
            delete material.defines.CSM_FADE;
            if (shader !== null) {
                delete shader.uniforms.CSM_cascades;
                delete shader.uniforms.cameraNear;
                delete shader.uniforms.shadowFar;
            }
            material.needsUpdate = true;
        });
        shaders.clear();
    }
}


const $5fbffa87c50562b9$var$background_image = document.getElementById("background");
const $5fbffa87c50562b9$var$stems_element = document.getElementById("stems");
const $5fbffa87c50562b9$var$qr_div_element = document.getElementById("qr_div");
const $5fbffa87c50562b9$var$close_qr_button_element = document.getElementById("close_qr_button");
const $5fbffa87c50562b9$var$about_div_element = document.getElementById("about_div");
const $5fbffa87c50562b9$var$ar_overlay_div_element = document.getElementById("ar_overlay_div");
const $5fbffa87c50562b9$var$move_phone_div_element = document.getElementById("move_phone_div");
const $5fbffa87c50562b9$var$move_phone_image_element = document.getElementById("move_phone_image");
const $5fbffa87c50562b9$var$move_phone_slider_element = document.getElementById("move_phone_slider");
const $5fbffa87c50562b9$var$use_flowers_div_element = document.getElementById("use_flowers_div");
const $5fbffa87c50562b9$var$holo_skip_button = document.getElementById("holo_skip_button");
const $5fbffa87c50562b9$var$ar_record_button_element = document.getElementById("ar_record_button");
const $5fbffa87c50562b9$var$submit_message_element = document.getElementById("submit_message");
const $5fbffa87c50562b9$var$send_button_element = document.getElementById("send_button");
const $5fbffa87c50562b9$var$uploading_message_element = document.getElementById("uploading_message");
const $5fbffa87c50562b9$var$thank_you_element = document.getElementById("thank_you");
const $5fbffa87c50562b9$var$upload_cancel_button_element = document.getElementById("upload_cancel_button");
const $5fbffa87c50562b9$var$thanks_k_button_element = document.getElementById("thanks_k_button");
const $5fbffa87c50562b9$var$firstname_element = document.getElementById("firstname");
const $5fbffa87c50562b9$var$lastname_element = document.getElementById("lastname");
const $5fbffa87c50562b9$var$email_element = document.getElementById("email");
const $5fbffa87c50562b9$var$video_div_element = document.getElementById("video_div");
const $5fbffa87c50562b9$var$video_element = document.getElementById("video");
const $5fbffa87c50562b9$var$skip_button_element = document.getElementById("skip_button");
const $5fbffa87c50562b9$var$qr_copy_button = document.getElementById("qr_copy_button");
const $5fbffa87c50562b9$var$qr_copied = document.getElementById("qr_copied");
const $5fbffa87c50562b9$var$unpause_button_element = document.getElementById("unpause_button");
const $5fbffa87c50562b9$var$ar_menu_button_element = document.getElementById("ar_menu_button");
const $5fbffa87c50562b9$var$phone_menu = document.getElementById("phone_menu");
const $5fbffa87c50562b9$var$phone_credits = document.getElementById("phone_credits");
const $5fbffa87c50562b9$var$ar_move_button_element = document.getElementById("ar_move_button");
const $5fbffa87c50562b9$var$upload_fail_element = document.getElementById("upload_fail");
const $5fbffa87c50562b9$var$upload_fail_k_button_element = document.getElementById("upload_fail_k_button");
const $5fbffa87c50562b9$var$vr_info_div_element = document.getElementById("vr_info_div");
const $5fbffa87c50562b9$var$vr_info_button_element = document.getElementById("vr_info_button");
const $5fbffa87c50562b9$var$vr_info_div_2_element = document.getElementById("vr_info_div_2");
const $5fbffa87c50562b9$var$d_div_element = document.getElementById("d_div");
const $5fbffa87c50562b9$var$ar_session_over_element = document.getElementById("ar_session_over");
const $5fbffa87c50562b9$var$ar_session_over_ok_element = document.getElementById("ar_session_over_ok");
const $5fbffa87c50562b9$var$about_close_button = document.getElementById("about_close_button");
const $5fbffa87c50562b9$var$loading_descriptor = document.getElementById("loading_descriptor");
const $5fbffa87c50562b9$var$current_progress_text = document.getElementById("current_progress");
const $5fbffa87c50562b9$var$ar_record_button_img = document.getElementById("ar_record_button_img");
const $5fbffa87c50562b9$var$instruction = document.getElementById("instruction");
const $5fbffa87c50562b9$var$submit_cancel_button = document.getElementById("submit_cancel_button");
const $5fbffa87c50562b9$var$ar_menu_button_img = document.getElementById("ar_menu_button_img");
const $5fbffa87c50562b9$var$ar_move_button_img = document.getElementById("ar_move_button_img");
const $5fbffa87c50562b9$var$menu_return_button = document.getElementById("menu_return_button");
const $5fbffa87c50562b9$var$credits_div = document.getElementById("phone_credits");
const $5fbffa87c50562b9$var$menu_credits_button = document.getElementById("menu_credits_button");
const $5fbffa87c50562b9$var$menu_learn_button = document.getElementById("menu_learn_button");
const $5fbffa87c50562b9$var$credits_close_button = document.getElementById("credits_close_button");
const $5fbffa87c50562b9$var$onboarding = document.getElementById("onboarding");
const $5fbffa87c50562b9$var$onboarding_content = document.getElementById("onboarding_content");
const $5fbffa87c50562b9$var$phone_about = document.getElementById("phone_about");
const $5fbffa87c50562b9$var$submission_overlay = document.getElementById("submission_overlay");
const $5fbffa87c50562b9$var$submission_modal = document.getElementById("submission_modal");
const $5fbffa87c50562b9$var$iframe_modal = document.getElementById("iframe_modal");
const $5fbffa87c50562b9$var$close_iframe_modal = document.getElementById("close_iframe_modal");
const $5fbffa87c50562b9$var$iframe_modal_content = document.getElementById("iframe_modal_content");
const $5fbffa87c50562b9$var$termscon = document.getElementById("termscon");
const $5fbffa87c50562b9$var$menu_justice_button = document.getElementById("menu_justice_button");
const $5fbffa87c50562b9$var$about_close_button_img = document.getElementById("about_close_button_img");
const $5fbffa87c50562b9$var$credits_close_button_img = document.getElementById("credits_close_button_img");
let $5fbffa87c50562b9$var$currentSession;
const $5fbffa87c50562b9$var$APIKEY = "0Nl1itBHD5oRQUokeuLmpeK5C4E7y0qrWKNzuF3UeRHxL4JTCUAL7A0T505KH2jF";
const $5fbffa87c50562b9$var$API_URL = "https://adqan7wdeh.execute-api.us-east-1.amazonaws.com/dev/v2";
const $5fbffa87c50562b9$var$get_submissions = $5fbffa87c50562b9$var$API_URL + "/pub/submissions";
const $5fbffa87c50562b9$var$post_submit = $5fbffa87c50562b9$var$API_URL + "/pub/submit";
const $5fbffa87c50562b9$var$number_of_audio_flowers = 150;
let $5fbffa87c50562b9$var$user_entry = null;
let $5fbffa87c50562b9$var$special_mp3s = [];
let $5fbffa87c50562b9$var$common_mp3s = [];
let $5fbffa87c50562b9$var$friend_mp3s = [];
let $5fbffa87c50562b9$var$mode = "";
let $5fbffa87c50562b9$var$pause_helper;
let $5fbffa87c50562b9$var$dialoging;
let $5fbffa87c50562b9$var$music_howl;
let $5fbffa87c50562b9$var$music_howl_volume = .25;
let $5fbffa87c50562b9$var$sounds_loaded;
let $5fbffa87c50562b9$var$howl_mesh = null;
let $5fbffa87c50562b9$var$last_howl_mesh = null;
let $5fbffa87c50562b9$var$pointer = new $0147bee01cff6558$export$c977b3e384af9ae1(0, 0);
let $5fbffa87c50562b9$var$matrix = new $0147bee01cff6558$export$2ae72fc923e5eb5();
let $5fbffa87c50562b9$var$howl = null;
let $5fbffa87c50562b9$var$howl_index = 0;
let $5fbffa87c50562b9$var$howl_interval = null;
let $5fbffa87c50562b9$var$canvas, $5fbffa87c50562b9$var$context;
let $5fbffa87c50562b9$var$howl_mesh_opacity_step = .025;
let $5fbffa87c50562b9$var$butterflies, $5fbffa87c50562b9$var$butterflies_mixer = null;
let $5fbffa87c50562b9$var$room_butterflies, $5fbffa87c50562b9$var$room_butterflies_mixer = null;
let $5fbffa87c50562b9$var$butterflies_ar, $5fbffa87c50562b9$var$butterflies_ar_mixer = null;
let $5fbffa87c50562b9$var$info_group;
let $5fbffa87c50562b9$var$ar_loaded = false;
let $5fbffa87c50562b9$var$video_loaded = false;
let $5fbffa87c50562b9$var$envMap;
let $5fbffa87c50562b9$var$ar_loader_rings = [];
let $5fbffa87c50562b9$var$skippable_holo = false;
let $5fbffa87c50562b9$var$show_ar_halos = false;
let $5fbffa87c50562b9$var$hitTestSource = null;
let $5fbffa87c50562b9$var$hitTestSourceRequested = false;
let $5fbffa87c50562b9$var$reload_ar = true;
let $5fbffa87c50562b9$var$jun_holo_played = false;
let $5fbffa87c50562b9$var$tempMatrix = new $0147bee01cff6558$export$2ae72fc923e5eb5();
let $5fbffa87c50562b9$var$current_progress = 2;
const $5fbffa87c50562b9$var$total_progress = 6;
class $5fbffa87c50562b9$var$g {
    static start = (args)=>{
        $5fbffa87c50562b9$var$g.renderer = new $0147bee01cff6558$export$f6cc00ef28d7cf97({
            alpha: true,
            antialiazing: true
        });
        $5fbffa87c50562b9$var$g.renderer.shadowMap.enabled = true;
        $5fbffa87c50562b9$var$g.renderer.shadowMap.type = $0147bee01cff6558$export$a47c4b43a1be34f0;
        $5fbffa87c50562b9$var$g.renderer.xr.enabled = true;
        $5fbffa87c50562b9$var$g.garden_scene = new $0147bee01cff6558$export$38af1803e3442a7f();
        //g.scene.fog                  = new THREE.Fog( 0xf2e1ee, 0, 100 )
        $5fbffa87c50562b9$var$g.garden_scene.add(new $0147bee01cff6558$export$af279bfef9ec2c96(0xc0c0c0));
        $5fbffa87c50562b9$var$g.room_scene = new $0147bee01cff6558$export$38af1803e3442a7f();
        $5fbffa87c50562b9$var$g.scene = $5fbffa87c50562b9$var$g.garden_scene;
        const directional_light = new $0147bee01cff6558$export$3fea33cc9972c868();
        directional_light.position.set(30, 30, -30);
        directional_light.intensity = 1;
        directional_light.castShadow = true;
        $5fbffa87c50562b9$var$g.scene.add(directional_light);
        var d = 100;
        directional_light.shadow.camera.left = -d;
        directional_light.shadow.camera.right = d;
        directional_light.shadow.camera.top = d;
        directional_light.shadow.camera.bottom = -d;
        directional_light.shadow.camera.near = .1;
        directional_light.shadow.camera.far = 1000;
        directional_light.shadow.mapSize.x = 2048;
        directional_light.shadow.mapSize.y = 2048;
        /*
		const directional_light_helper  = new THREE.DirectionalLightHelper( directional_light )
		g.scene.add                   ( directional_light_helper )
		*/ /*
		g.csm = new CSM({
			maxFar         : 1000,
			cascades       : 4,
			mode           : 'practical',
			parent         : scene,
			shadowMapSize  : 1024,
			lightDirection : new THREE.Vector3( -1, -1, -1 ).normalize(),
			camera         : g.camera
		})
		*/ $5fbffa87c50562b9$var$g.scene.background = $5fbffa87c50562b9$var$envMap;
        $5fbffa87c50562b9$var$g.scene.environment = $5fbffa87c50562b9$var$envMap;
        //const light = new THREE.DirectionalLight()
        //light.position.set( 100, 100, 100 )
        //light.castShadow = true
        //g.scene.add( light )					
        $5fbffa87c50562b9$var$g.camera_group = new $0147bee01cff6558$export$eb2fcfdbd7ba97d4();
        $5fbffa87c50562b9$var$g.camera = new $0147bee01cff6558$export$74e4ae24825f68d7(50, 1, .01, 10000);
        //g.camera.layers.enable( 0 )
        //g.camera.layers.enable( 1 )
        $5fbffa87c50562b9$var$g.camera.position.y = 1.75;
        $5fbffa87c50562b9$var$g.camera_group.add($5fbffa87c50562b9$var$g.camera);
        $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$g.camera_group);
        $5fbffa87c50562b9$var$g.raycaster = new $0147bee01cff6558$export$8b7aaceff00bd2f();
        $5fbffa87c50562b9$var$g.clock = new $0147bee01cff6558$export$9735c82c4bae3302();
        $5fbffa87c50562b9$var$g.camera_position = new $0147bee01cff6558$export$64b5c384219d3699();
        $5fbffa87c50562b9$var$g.old_camera_position = new $0147bee01cff6558$export$64b5c384219d3699();
        {
            const resize = (args)=>{
                const width = window.innerWidth;
                const height = window.innerHeight;
                $5fbffa87c50562b9$var$g.camera.aspect = width / height;
                $5fbffa87c50562b9$var$g.camera.updateProjectionMatrix();
                $5fbffa87c50562b9$var$g.renderer.setSize(width, height);
            };
            resize();
            window.addEventListener("resize", resize);
        }
    };
}
class $5fbffa87c50562b9$var$w {
    static instances = [];
    static error_msg = "";
    static start = (args)=>{
        window.addEventListener("error", (event)=>{
            $5fbffa87c50562b9$var$w.error_msg = event.lineno + " = " + event.message;
        });
        $5fbffa87c50562b9$var$w.started = performance.now();
        $5fbffa87c50562b9$var$w.frames = 0;
        new $5fbffa87c50562b9$var$w();
    };
    static draw = (args)=>{
        $5fbffa87c50562b9$var$w.instances.forEach((instance)=>instance.draw(args));
    };
    static hide_all = (args)=>{
        $5fbffa87c50562b9$var$w.instances.forEach((instance)=>instance.plane.visible = false);
    };
    static show_all = (args)=>{
        $5fbffa87c50562b9$var$w.instances.forEach((instance)=>instance.plane.visible = true);
    };
    constructor(args){
        this.ignore_pointer = false;
        this.font_height = 16;
        this.canvas = document.createElement("canvas");
        this.canvas.height = 5 * this.font_height;
        this.canvas.width = this.canvas.height * 2;
        this.context = this.canvas.getContext("2d");
        this.plane = new $0147bee01cff6558$export$e176487c05830cc5(new $0147bee01cff6558$export$967d831af31f69ce(1, .5), new $0147bee01cff6558$export$55cbcc9b622fe1f5({
            transparent: true,
            map: new $0147bee01cff6558$export$f7189e49152d1c13(this.canvas)
        }));
        //this.plane.layers.set  ( 1 )
        this.plane.position.set(0, 1, -3);
        $5fbffa87c50562b9$var$g.camera.add(this.plane);
        $5fbffa87c50562b9$var$w.instances.push(this);
    }
    draw(args) {
        this.context.fillStyle = "#f2e1ee";
        this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
        this.context.textAlign = "left";
        this.context.textBaseline = "top";
        this.context.fillStyle = "#000000";
        this.context.font = this.font_height + "px Arial";
        const l = 0;
        const c = this.canvas.width / 2;
        let y = 0 //this.canvas.height  / 2
        ;
        this.context.fillText("state", l, y);
        this.context.fillText($5fbffa87c50562b9$var$w.error_msg, c, y);
        y += this.font_height;
        const delta1 = performance.now() - $5fbffa87c50562b9$var$w.started;
        const fps = ++$5fbffa87c50562b9$var$w.frames * 1000 / delta1;
        if (delta1 > 5000) {
            $5fbffa87c50562b9$var$w.frames = 0;
            $5fbffa87c50562b9$var$w.started = performance.now();
        }
        this.context.fillText("fps", l, y);
        this.context.fillText(fps.toFixed(2), c, y);
        y += this.font_height;
        this.context.fillText("calls", l, y);
        this.context.fillText($5fbffa87c50562b9$var$g.renderer.info.render.calls, c, y);
        y += this.font_height;
        this.context.fillText("triangles", l, y);
        this.context.fillText($5fbffa87c50562b9$var$g.renderer.info.render.triangles, c, y);
        y += this.font_height;
        this.context.fillText("textures", l, y);
        this.context.fillText($5fbffa87c50562b9$var$g.renderer.info.memory.textures, c, y);
        y += this.font_height;
        this.plane.material.map.needsUpdate = true;
    }
}
class $5fbffa87c50562b9$var$Swaying_material extends $0147bee01cff6558$export$83c7d75d550a8b0d {
    static instances = [];
    static update = (args)=>{
        for (const [index, instance] of $5fbffa87c50562b9$var$Swaying_material.instances.entries())instance.uniforms["time"].value = args.now / 2 + index / $5fbffa87c50562b9$var$Swaying_material.instances.length;
    };
    constructor(args){
        super({
            uniforms: {
                map: {
                    value: null
                },
                time: {
                    value: 0
                }
            },
            vertexShader: `
				varying vec2  vUv;
				uniform float time;
				void main() {
					vUv             = uv;
					
					vec4 mvPosition = vec4( position, 1.0 );

					float displacement = .1 * mvPosition.y * mvPosition.y * sin( time );
					mvPosition.x += displacement;
					
					#ifdef USE_INSTANCING
						mvPosition = instanceMatrix * mvPosition;
					#endif

					vec4 modelViewPosition = modelViewMatrix  * mvPosition;
					gl_Position            = projectionMatrix * modelViewPosition;
				}`,
            fragmentShader: `
				varying vec2      vUv;
				uniform sampler2D map;
				void main(){
					vec4 color         = texture( map, vUv );
					if( color.a < .5 ) discard;
					else {
						vec3 texture = color.rgb;
						texture      = pow( texture, vec3( 1. / 2.75 ));
						gl_FragColor = vec4( texture, 1. );		
					}
				}`
        });
        $5fbffa87c50562b9$var$Swaying_material.instances.push(this);
    }
}
class $5fbffa87c50562b9$var$a {
    static start = (callback)=>{
        document.getElementById("total_progress").innerText = $5fbffa87c50562b9$var$total_progress;
        const update_progress = (msg)=>{
            $5fbffa87c50562b9$var$current_progress_text.innerText = $5fbffa87c50562b9$var$current_progress++;
            $5fbffa87c50562b9$var$loading_descriptor.innerText = msg;
        };
        $5fbffa87c50562b9$var$a.particles = [];
        const size = 100;
        const y_size = 10;
        const bokeh_material = new $0147bee01cff6558$export$a178c45366ce5d6b({
            blending: $0147bee01cff6558$export$777d8f9551c2216b,
            transparent: true,
            opacity: .5,
            size: .25 + Math.random() * .25,
            map: new $0147bee01cff6558$export$fd1bfc71f64c538c().load("./assets/textures/bokeh.png")
        });
        const geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        const vertices = [];
        for(let j = 0; j < 250; j++){
            const x = Math.random() * size - size / 2;
            const y = Math.random() * y_size;
            const z = Math.random() * size - size / 2;
            vertices.push(x, y, z);
        }
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        const points = new $0147bee01cff6558$export$1c787534cb11aa3e(geometry, bokeh_material);
        $5fbffa87c50562b9$var$g.scene.add(points);
        $5fbffa87c50562b9$var$a.particles.push(points);
        $5fbffa87c50562b9$var$g.draco_loader = new (0, $c9d3829446f00917$export$45c25de53be259ac)().setDecoderPath("https://unpkg.com/three@0.161.0/examples/jsm/libs/draco/");
        const gltf_loader = new (0, $3af46d7a32572744$export$aa93f11e7884f0f4)();
        gltf_loader.setDRACOLoader($5fbffa87c50562b9$var$g.draco_loader);
        gltf_loader.load("./assets/models/garden.glb", (garden)=>{
            const create_instanced_meshes = (args)=>{
                const meshes = args.names.map((name)=>garden.scene.getObjectByName(name));
                //meshes.forEach( mesh =>{ mesh.material = new THREE.MeshPhongMaterial({ color: 0x553306 })})
                const instanced_meshes = meshes.map((mesh)=>new $0147bee01cff6558$export$f3c979c331175ad7(mesh.geometry, args.sway ? new $5fbffa87c50562b9$var$Swaying_material() : mesh.material, args.pqs.length / 10));
                if (args.sway) for (const [index, instanced_mesh] of instanced_meshes.entries()){
                    instanced_mesh.material.side = $0147bee01cff6558$export$3b296b6f144d5b03;
                    instanced_mesh.material.uniforms["map"].value = meshes[index].material.map;
                    instanced_mesh.material.uniforms.needsUpdate = true;
                }
                //instanced_mesh.instanceMatrix.setUsage(THREE.DynamicDrawUsage)
                const object3d = new $0147bee01cff6558$export$e4dd07dff30cc924();
                for(let i = 0; i < args.pqs.length / 10; ++i){
                    object3d.position.set(args.pqs[i * 10 + 0], args.pqs[i * 10 + 1], args.pqs[i * 10 + 2]);
                    object3d.quaternion.set(args.pqs[i * 10 + 3], args.pqs[i * 10 + 4], args.pqs[i * 10 + 5], args.pqs[i * 10 + 6]);
                    object3d.scale.set(args.pqs[i * 10 + 7], args.pqs[i * 10 + 8], args.pqs[i * 10 + 9]);
                    object3d.updateMatrix();
                    instanced_meshes.forEach((instanced_mesh)=>instanced_mesh.setMatrixAt(i, object3d.matrix));
                }
                instanced_meshes.forEach((instanced_mesh)=>{
                    instanced_mesh.castShadow = true;
                    instanced_mesh.instanceMatrix.needsUpdate = true;
                    if ("add_to_scene" in args ? args.add_to_scene : true) $5fbffa87c50562b9$var$g.scene.add(instanced_mesh);
                });
                return instanced_meshes;
            };
            {
                const tree_line_1 = garden.scene.getObjectByName("tree_line_1");
                $5fbffa87c50562b9$var$g.scene.add(tree_line_1);
                const tree_line_1001 = garden.scene.getObjectByName("tree_line_1001");
                $5fbffa87c50562b9$var$g.scene.add(tree_line_1001);
                const mountains = garden.scene.getObjectByName("mountains");
                $5fbffa87c50562b9$var$g.scene.add(mountains);
            }
            $5fbffa87c50562b9$var$a.garden_spawn = garden.scene.getObjectByName("start__spawn");
            $5fbffa87c50562b9$var$a.garden_teleport_spawn = garden.scene.getObjectByName("teleport__spawn");
            $5fbffa87c50562b9$var$a.garden_collider = garden.scene.getObjectByName("ground_collider");
            $5fbffa87c50562b9$var$a.garden_collider.visible = false;
            //a.garden_collider.receiveShadow = true
            $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.garden_collider);
            $5fbffa87c50562b9$var$a.jun = garden.scene.getObjectByName("JuNiyah__ho_kw");
            $5fbffa87c50562b9$var$a.jun.rotation.y = 1.5;
            $5fbffa87c50562b9$var$a.jun_holo = new $5fbffa87c50562b9$var$Holo({
                minBuffers: 2,
                volume: .2,
                duration: 77000,
                scene: $5fbffa87c50562b9$var$g.scene,
                position: $5fbffa87c50562b9$var$a.jun.position,
                rotation: $5fbffa87c50562b9$var$a.jun.rotation,
                hcap: "./captures/juniyah_7/juniyah_take7.hcap",
                flip: false
            });
            $5fbffa87c50562b9$var$a.lp = garden.scene.getObjectByName("ladyphoenix__ho_kw");
            $5fbffa87c50562b9$var$a.lp.rotation.y = 1.5;
            $5fbffa87c50562b9$var$a.lp_holo = new $5fbffa87c50562b9$var$Holo({
                minBuffers: 2,
                volume: 1,
                duration: 59000,
                scene: $5fbffa87c50562b9$var$g.scene,
                position: $5fbffa87c50562b9$var$a.lp.position,
                rotation: $5fbffa87c50562b9$var$a.lp.rotation,
                hcap: "./captures/shot1_stand_4_1504/shot1_stand_4.hcap"
            });
            $5fbffa87c50562b9$var$a.ken = garden.scene.getObjectByName("kenny__ho_kw");
            $5fbffa87c50562b9$var$a.ken_holo = new $5fbffa87c50562b9$var$Holo({
                minBuffers: 6,
                volume: .1,
                sound_src: "/assets/Everything.mp3",
                duration: 20000,
                scene: $5fbffa87c50562b9$var$g.scene,
                position: $5fbffa87c50562b9$var$a.ken.position,
                rotation: $5fbffa87c50562b9$var$a.ken.rotation,
                hcap: "./captures/kw_7_sync11867/kw_7.hcap"
            });
            {
                $5fbffa87c50562b9$var$a.grass_mesh = garden.scene.getObjectByName("grass");
                $5fbffa87c50562b9$var$a.grass_mesh.receiveShadow = true;
                $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.grass_mesh);
                const middle_grass_line = garden.scene.getObjectByName("middle_grass_line");
                $5fbffa87c50562b9$var$g.scene.add(middle_grass_line);
            }
            $5fbffa87c50562b9$var$a.mulch_mesh = garden.scene.getObjectByName("mulch");
            $5fbffa87c50562b9$var$a.mulch_mesh.receiveShadow = true;
            $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.mulch_mesh);
            $5fbffa87c50562b9$var$a.border_mesh = garden.scene.getObjectByName("border");
            $5fbffa87c50562b9$var$a.border_mesh.material = $5fbffa87c50562b9$var$reflective_material;
            //a.border_mesh.receiveShadow  = true
            $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.border_mesh);
            $5fbffa87c50562b9$var$a.border_inner_mesh = garden.scene.getObjectByName("border_inner");
            $5fbffa87c50562b9$var$a.border_inner_mesh.material = $5fbffa87c50562b9$var$reflective_material;
            //a.border_inner_mesh.receiveShadow  = true
            $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.border_inner_mesh);
            create_instanced_meshes({
                names: [
                    "oak_trunk",
                    "oak_leaves"
                ],
                pqs: [
                    -29.51,
                    0.41,
                    -60.26,
                    0.00,
                    -0.7,
                    0.00,
                    0.71,
                    0.70,
                    0.70,
                    0.70,
                    2.77,
                    0.04,
                    -25.75,
                    0.03,
                    -0.7,
                    -0.02,
                    0.71,
                    0.98,
                    0.98,
                    0.98,
                    9.62,
                    1.60,
                    -75.88,
                    0.02,
                    -0.71,
                    -0.03,
                    0.70,
                    0.98,
                    0.98,
                    0.98,
                    33.23,
                    1.37,
                    -41.46,
                    0.02,
                    -0.7,
                    -0.02,
                    0.71,
                    0.97,
                    0.97,
                    0.97,
                    -22.7,
                    0.32,
                    -0.22,
                    0.01,
                    -0.71,
                    0.00,
                    0.71,
                    0.77,
                    0.77,
                    0.77,
                    -45.94,
                    3.18,
                    -8.18,
                    0.03,
                    -0.71,
                    -0.03,
                    0.70,
                    0.43,
                    0.43,
                    0.43,
                    -26.73,
                    0.20,
                    -73.66,
                    0.01,
                    -0.7,
                    -0.01,
                    0.71,
                    0.72,
                    0.72,
                    0.72,
                    18.91,
                    1.63,
                    11.48,
                    0.02,
                    -0.71,
                    -0.03,
                    0.70,
                    0.58,
                    0.58,
                    0.58,
                    -9.32,
                    1.32,
                    -83.38,
                    0.00,
                    -0.71,
                    0.00,
                    0.70,
                    0.89,
                    0.89,
                    0.89,
                    10.84,
                    1.14,
                    -50.17,
                    0.01,
                    -0.71,
                    -0.01,
                    0.70,
                    0.98,
                    0.98,
                    0.98,
                    -36.05,
                    1.61,
                    -73.92,
                    0.01,
                    -0.71,
                    -0.02,
                    0.71,
                    0.47,
                    0.47,
                    0.47,
                    -20.58,
                    0.78,
                    -8.53,
                    0.01,
                    -0.71,
                    -0.01,
                    0.71,
                    0.49,
                    0.49,
                    0.49,
                    -17.41,
                    0.81,
                    -82.04,
                    0.02,
                    -0.71,
                    -0.02,
                    0.71,
                    0.57,
                    0.57,
                    0.57,
                    25.06,
                    0.38,
                    1.30,
                    0.01,
                    -0.71,
                    -0.02,
                    0.70,
                    0.90,
                    0.90,
                    0.90,
                    8.26,
                    1.05,
                    -56.32,
                    0.01,
                    -0.7,
                    -0.01,
                    0.71,
                    0.86,
                    0.86,
                    0.86,
                    -20.7,
                    0.89,
                    14.92,
                    0.02,
                    -0.71,
                    -0.01,
                    0.71,
                    0.60,
                    0.60,
                    0.60,
                    -32.94,
                    0.91,
                    -48.84,
                    0.01,
                    -0.7,
                    -0.01,
                    0.71,
                    0.71,
                    0.71,
                    0.71,
                    -7.74,
                    0.35,
                    -37.25,
                    0.01,
                    -0.71,
                    -0.01,
                    0.70,
                    0.77,
                    0.77,
                    0.77
                ],
                sway: false
            });
            create_instanced_meshes({
                names: [
                    "poplar_trunk",
                    "poplar_leaves"
                ],
                pqs: [
                    -21.71,
                    0.16,
                    -74.09,
                    0.02,
                    -0.71,
                    -0.02,
                    0.71,
                    0.79,
                    0.79,
                    0.79,
                    -46.22,
                    1.34,
                    -13.19,
                    0.02,
                    -0.71,
                    -0.01,
                    0.71,
                    0.46,
                    0.46,
                    0.46,
                    7.41,
                    -0.18,
                    -6.2,
                    0.01,
                    -0.71,
                    -0.01,
                    0.71,
                    0.91,
                    0.91,
                    0.91,
                    -5.11,
                    0.34,
                    -32.08,
                    0.02,
                    -0.71,
                    -0.02,
                    0.71,
                    0.57,
                    0.57,
                    0.57,
                    -23.81,
                    0.52,
                    4.12,
                    0.00,
                    -0.7,
                    0.00,
                    0.71,
                    0.87,
                    0.87,
                    0.87,
                    18.55,
                    0.70,
                    -42.61,
                    0.02,
                    -0.7,
                    -0.02,
                    0.71,
                    0.94,
                    0.94,
                    0.94,
                    -2.91,
                    0.31,
                    -35.43,
                    0.02,
                    -0.71,
                    -0.02,
                    0.71,
                    0.60,
                    0.60,
                    0.60,
                    -44.64,
                    2.71,
                    -9.24,
                    0.01,
                    -0.7,
                    -0.02,
                    0.71,
                    0.61,
                    0.61,
                    0.61,
                    39.18,
                    0.85,
                    -7.79,
                    0.03,
                    -0.71,
                    -0.03,
                    0.71,
                    0.62,
                    0.62,
                    0.62,
                    -42.54,
                    2.07,
                    -10.67,
                    0.03,
                    -0.7,
                    -0.03,
                    0.71,
                    0.83,
                    0.83,
                    0.83,
                    16.36,
                    2.11,
                    -72.28,
                    0.01,
                    -0.7,
                    -0.02,
                    0.71,
                    0.94,
                    0.94,
                    0.94,
                    35.85,
                    2.04,
                    -45.84,
                    0.02,
                    -0.71,
                    -0.02,
                    0.71,
                    0.47,
                    0.47,
                    0.47,
                    -42.09,
                    0.70,
                    -42.64,
                    0.01,
                    -0.71,
                    0.00,
                    0.71,
                    0.73,
                    0.73,
                    0.73,
                    -22.47,
                    0.75,
                    -36.89,
                    0.03,
                    -0.71,
                    -0.03,
                    0.70,
                    0.79,
                    0.79,
                    0.79,
                    30.18,
                    1.19,
                    4.89,
                    0.02,
                    -0.71,
                    -0.02,
                    0.70,
                    0.81,
                    0.81,
                    0.81,
                    20.91,
                    1.30,
                    -64.95,
                    0.01,
                    -0.7,
                    -0.02,
                    0.71,
                    0.42,
                    0.42,
                    0.42,
                    25.92,
                    -0.12,
                    -2.68,
                    0.01,
                    -0.71,
                    0.00,
                    0.71,
                    0.78,
                    0.78,
                    0.78,
                    -31.1,
                    0.17,
                    -39.21,
                    0.02,
                    -0.71,
                    -0.02,
                    0.71,
                    0.88,
                    0.88,
                    0.88,
                    -40.61,
                    2.44,
                    -67.31,
                    0.03,
                    -0.71,
                    -0.02,
                    0.71,
                    0.53,
                    0.53,
                    0.53,
                    1.23,
                    0.39,
                    -29.83,
                    0.01,
                    -0.7,
                    -0.02,
                    0.71,
                    0.64,
                    0.64,
                    0.64,
                    3.51,
                    -0.33,
                    -18.32,
                    0.02,
                    -0.71,
                    -0.01,
                    0.71,
                    0.71,
                    0.71,
                    0.71,
                    36.79,
                    0.85,
                    -35.12,
                    0.01,
                    -0.71,
                    -0.01,
                    0.71,
                    0.77,
                    0.77,
                    0.77,
                    -39.87,
                    1.53,
                    -11.86,
                    0.01,
                    -0.71,
                    -0.02,
                    0.70,
                    0.64,
                    0.64,
                    0.64,
                    -31.4,
                    1.96,
                    5.99,
                    0.03,
                    -0.71,
                    -0.02,
                    0.71,
                    0.97,
                    0.97,
                    0.97,
                    15.83,
                    1.00,
                    -46.06,
                    0.01,
                    -0.7,
                    0.00,
                    0.71,
                    0.61,
                    0.61,
                    0.61,
                    8.49,
                    1.03,
                    -60.41,
                    0.00,
                    -0.7,
                    0.00,
                    0.71,
                    0.57,
                    0.57,
                    0.57,
                    -17.27,
                    0.71,
                    -9.13,
                    0.01,
                    -0.7,
                    -0.02,
                    0.71,
                    0.61,
                    0.61,
                    0.61,
                    -35.58,
                    2.70,
                    6.91,
                    0.01,
                    -0.71,
                    0.00,
                    0.71,
                    0.43,
                    0.43,
                    0.43,
                    17.17,
                    1.67,
                    -76.33,
                    0.03,
                    -0.7,
                    -0.03,
                    0.71,
                    0.51,
                    0.51,
                    0.51,
                    13.94,
                    1.94,
                    -69.64,
                    0.02,
                    -0.71,
                    -0.03,
                    0.70,
                    0.74,
                    0.74,
                    0.74,
                    29.01,
                    1.30,
                    7.06,
                    0.01,
                    -0.7,
                    -0.02,
                    0.71,
                    0.70,
                    0.70,
                    0.70,
                    -37.93,
                    1.99,
                    -57.48,
                    0.01,
                    -0.71,
                    -0.01,
                    0.71,
                    0.95,
                    0.95,
                    0.95,
                    -24.51,
                    0.63,
                    -51.31,
                    0.03,
                    -0.71,
                    -0.03,
                    0.71,
                    0.47,
                    0.47,
                    0.47,
                    -20.43,
                    0.99,
                    -82.93,
                    0.01,
                    -0.7,
                    -0.01,
                    0.71,
                    0.58,
                    0.58,
                    0.58,
                    42.84,
                    1.21,
                    -13.68,
                    0.02,
                    -0.71,
                    -0.03,
                    0.70,
                    0.59,
                    0.59,
                    0.59,
                    -17.93,
                    1.31,
                    -12.31,
                    0.00,
                    -0.71,
                    -0.01,
                    0.70,
                    0.85,
                    0.85,
                    0.85,
                    -0.09,
                    0.81,
                    -82.93,
                    0.00,
                    -0.71,
                    0.00,
                    0.71,
                    0.66,
                    0.66,
                    0.66,
                    -4.91,
                    1.00,
                    -82.93,
                    0.00,
                    -0.7,
                    0.00,
                    0.71,
                    0.59,
                    0.59,
                    0.59,
                    28.90,
                    1.64,
                    -48.56,
                    0.01,
                    -0.71,
                    0.00,
                    0.70,
                    0.63,
                    0.63,
                    0.63,
                    42.45,
                    1.33,
                    -22.51,
                    0.00,
                    -0.71,
                    -0.01,
                    0.71,
                    0.66,
                    0.66,
                    0.66
                ],
                sway: false
            });
            {
                const flowers_pqs = [
                    [
                        6.19,
                        -0.18,
                        -5.95,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.89,
                        1.17,
                        -36.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.48,
                        0.78,
                        -36.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        20.33,
                        0.07,
                        -28.89,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.75,
                        0.36,
                        -52.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.51,
                        0.01,
                        -28.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.55,
                        0.35,
                        -36,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.78,
                        -0.72,
                        -21.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.32,
                        1.56,
                        -41.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.34,
                        0.76,
                        -49.36,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.10,
                        -0.26,
                        -29.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.52,
                        0.18,
                        -30.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.23,
                        0.52,
                        -31.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -43.03,
                        0.70,
                        -20.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        37.44,
                        0.59,
                        -32.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.23,
                        0.46,
                        -36.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.69,
                        0.41,
                        -33.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.48,
                        0.38,
                        -30.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.91,
                        -0.63,
                        -10.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.83,
                        0.39,
                        -29.28,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        24.37,
                        -0.4,
                        -6.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.45,
                        0.38,
                        -28.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.92,
                        1.40,
                        -18.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        14.53,
                        0.50,
                        -35.47,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.7,
                        -0.04,
                        -61.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        33.34,
                        0.56,
                        -37.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        32.88,
                        0.29,
                        -35.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.48,
                        -0.09,
                        -27.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -27.81,
                        0.20,
                        -17.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.88,
                        -0.01,
                        -56.58,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.27,
                        0.21,
                        -31.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.32,
                        0.38,
                        -35.89,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.42,
                        0.06,
                        -67.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.07,
                        0.68,
                        -34.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -43.06,
                        0.57,
                        -21.58,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.56,
                        0.68,
                        -44.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.08,
                        -0.16,
                        -27.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.33,
                        1.23,
                        -17.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.98,
                        0.31,
                        -37.4,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.39,
                        -0.03,
                        -27.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.33,
                        0.15,
                        -29.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.18,
                        0.26,
                        -39.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.55,
                        0.18,
                        -39.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.71,
                        0.35,
                        -33.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.80,
                        -0.18,
                        -24.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.91,
                        -0.24,
                        -25.28,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.74,
                        0.16,
                        -40.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.92,
                        0.36,
                        -31.9,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.32,
                        -0.15,
                        -27.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.86,
                        -0.01,
                        -28.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.41,
                        -0.32,
                        -24.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -31.2,
                        0.08,
                        -38.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.95,
                        -0.66,
                        -20.75,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.24,
                        0.87,
                        -22.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.19,
                        -0.19,
                        -27.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        31.75,
                        -0.16,
                        -35.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.45,
                        0.43,
                        -33.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.78,
                        0.28,
                        -30.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.49,
                        0.91,
                        -52.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -35.64,
                        0.48,
                        -16.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.17,
                        0.42,
                        -27.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.67,
                        0.70,
                        -34.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.03,
                        0.48,
                        -51.9,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        9.26,
                        0.53,
                        -40.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.27,
                        -0.08,
                        -71.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.20,
                        0.41,
                        -31.82,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.56,
                        0.21,
                        -73.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.39,
                        0.03,
                        -28.96,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.50,
                        0.65,
                        -46.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        32.64,
                        0.28,
                        -10.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.31,
                        -0.31,
                        -25.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.92,
                        0.01,
                        -27.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.96,
                        0.43,
                        -36.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.75,
                        0.26,
                        -31.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -32.52,
                        0.48,
                        -16.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.31,
                        0.92,
                        -55.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.85,
                        0.20,
                        -39.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.96,
                        0.71,
                        -42.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.51,
                        0.13,
                        -68.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.76,
                        1.33,
                        -17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.77,
                        0.29,
                        -47.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -40.66,
                        0.41,
                        -18.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.49,
                        0.44,
                        -31.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        20.20,
                        -0.39,
                        -9.05,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.39,
                        1.02,
                        -34.85,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.50,
                        -0.25,
                        -30.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.01,
                        1.32,
                        -40.11,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.12,
                        0.53,
                        -46.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.77,
                        1.11,
                        -53.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -26.48,
                        0.28,
                        -19.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.27,
                        -0.15,
                        -27.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.38,
                        -0.09,
                        -27.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.38,
                        -0.09,
                        -27.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        21.62,
                        -0.4,
                        -7.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.98,
                        -0.25,
                        -23.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.24,
                        0.13,
                        -40.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.5,
                        0.62,
                        -37.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.12,
                        1.52,
                        -18.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.97,
                        0.85,
                        -36.9,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.96,
                        0.20,
                        -39.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.5,
                        0.25,
                        -39.36,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.19,
                        0.18,
                        -59.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.86,
                        0.36,
                        -29.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -31.79,
                        0.58,
                        -16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.76,
                        0.10,
                        -71.85,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.24,
                        0.17,
                        -30.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.9,
                        0.14,
                        -40.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.37,
                        0.38,
                        -28.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.51,
                        -0.59,
                        -12.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.16,
                        -0.31,
                        -19.59,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.74,
                        0.06,
                        -71.26,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        37.11,
                        0.37,
                        -31.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.94,
                        0.25,
                        -58.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        21.68,
                        0.32,
                        -38.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.04,
                        0.02,
                        -50.11,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -35.29,
                        0.41,
                        -16.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.54,
                        0.42,
                        -36.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.67,
                        0.47,
                        -31.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.19,
                        0.61,
                        -32.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.20,
                        -0.05,
                        -27.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.58,
                        0.30,
                        -30.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.91,
                        0.57,
                        -16.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.58,
                        0.61,
                        -18.22,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.51,
                        0.44,
                        -6.26,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.56,
                        -0.38,
                        -24.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.59,
                        0.23,
                        -30.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        25.59,
                        -0.4,
                        -7.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.01,
                        0.85,
                        -55.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.54,
                        -0.49,
                        -19.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.4,
                        -0.18,
                        -26.33,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.78,
                        -0.49,
                        -17.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.64,
                        -0.32,
                        -26.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.93,
                        0.32,
                        -23.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.37,
                        0.88,
                        -33.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.06,
                        0.00,
                        -28.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.16,
                        1.15,
                        -6.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.39,
                        -0.46,
                        -19.94,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6,
                        0.28,
                        -39.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.54,
                        0.50,
                        -7.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.28,
                        1.23,
                        -54.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.67,
                        0.46,
                        -51.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.09,
                        0.04,
                        -50.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        14.48,
                        -0.5,
                        -9.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.92,
                        0.29,
                        -29.13,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.75,
                        1.19,
                        -21.45,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.87,
                        0.45,
                        -28.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.04,
                        0.40,
                        -32.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.99,
                        0.43,
                        -33.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.15,
                        0.43,
                        -16.26,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.61,
                        0.31,
                        -48.26,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        9.86,
                        0.00,
                        -37.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.80,
                        -0.58,
                        -19.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        20.32,
                        -0.23,
                        -8.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.96,
                        0.35,
                        -36.11,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        29.72,
                        0.15,
                        -7.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -31.39,
                        0.68,
                        -15.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.00,
                        -0.22,
                        -26.68,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.64,
                        0.04,
                        -28.93,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.03,
                        0.90,
                        -17.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.9,
                        0.66,
                        -18.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.55,
                        0.50,
                        -22.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -13.97,
                        0.51,
                        -47.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.18,
                        1.07,
                        -7.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        32.03,
                        -0.11,
                        -11.22,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.17,
                        0.14,
                        -30.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.04,
                        0.52,
                        -31.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.25,
                        0.45,
                        -36.45,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.65,
                        0.60,
                        -23.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.39,
                        -0.34,
                        -25.58,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.86,
                        -0.38,
                        -16.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        10.18,
                        0.32,
                        -39.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.53,
                        0.00,
                        -28.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.99,
                        0.44,
                        -18.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.55,
                        0.59,
                        -32.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.74,
                        0.71,
                        -30.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.19,
                        1.43,
                        -41.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -29.23,
                        0.37,
                        -16.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.69,
                        0.35,
                        -35.93,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        13.52,
                        0.36,
                        -36,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.22,
                        -0.03,
                        -60.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.19,
                        0.38,
                        -29.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.31,
                        -0.34,
                        -16.95,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.75,
                        0.43,
                        -35.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00
                    ],
                    [
                        6.65,
                        -0.24,
                        -2.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.92,
                        0.47,
                        -33.33,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.92,
                        1.19,
                        -13.93,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.00,
                        0.53,
                        -33.95,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.43,
                        -0.18,
                        -5.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.65,
                        0.60,
                        -32.98,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.12,
                        0.26,
                        -38.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.65,
                        -0.5,
                        -18.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.42,
                        0.63,
                        -31.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        40.29,
                        0.38,
                        -28.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.78,
                        0.23,
                        -39.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.22,
                        0.47,
                        -34.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.91,
                        0.21,
                        -39.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.32,
                        1.44,
                        -20.36,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.87,
                        0.46,
                        -50.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.62,
                        -0.4,
                        -23.41,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.58,
                        -0.09,
                        -12.3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.18,
                        0.45,
                        -34.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        14.13,
                        -0.33,
                        -6.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -37.38,
                        0.15,
                        -39.05,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.33,
                        0.88,
                        -37.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.85,
                        -0.12,
                        -27.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.10,
                        -0.19,
                        -24.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -32.73,
                        0.29,
                        -17.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        29.56,
                        -0.24,
                        -9.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.74,
                        0.00,
                        -28.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.39,
                        0.36,
                        -36.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.86,
                        -0.13,
                        -27.95,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.06,
                        0.64,
                        -18.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.67,
                        0.28,
                        -28.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.52,
                        0.19,
                        -39.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -40.43,
                        0.41,
                        -17.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.45,
                        -0.48,
                        -18.85,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.34,
                        0.20,
                        -38.79,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.1,
                        0.77,
                        -35.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.11,
                        0.45,
                        -36.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        31.18,
                        -0.22,
                        -35.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.92,
                        0.37,
                        -41.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.55,
                        0.90,
                        -54.26,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.91,
                        0.01,
                        -29.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.89,
                        0.48,
                        -46.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.73,
                        0.27,
                        -38.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        21.41,
                        0.37,
                        -38.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -35.43,
                        0.24,
                        -17.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.82,
                        1.41,
                        -15.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        31.52,
                        0.09,
                        -9.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.17,
                        -0.58,
                        -12.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.86,
                        0.80,
                        -4.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.73,
                        -0.7,
                        -21.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.10,
                        0.46,
                        -34.98,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        25.37,
                        0.04,
                        -38.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -43.62,
                        0.75,
                        -21.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.53,
                        1.02,
                        -34.4,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.55,
                        0.18,
                        -51.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.21,
                        0.95,
                        -45.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.34,
                        -0.03,
                        -60.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.94,
                        -0.38,
                        -17.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -43.53,
                        0.64,
                        -22.45,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.73,
                        -0.3,
                        -15.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.33,
                        0.88,
                        -37.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.94,
                        0.53,
                        -54.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.09,
                        -0.66,
                        -23.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.36,
                        0.21,
                        -31.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.97,
                        0.39,
                        -27.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.91,
                        0.11,
                        -70.4,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -42.89,
                        0.61,
                        -20.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.34,
                        0.56,
                        -51.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.37,
                        0.65,
                        -51.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.85,
                        0.41,
                        -46.89,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.96,
                        0.02,
                        -29.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -28.74,
                        0.15,
                        -17.77,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.60,
                        -0.46,
                        -23.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.23,
                        -0.46,
                        -11.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.04,
                        -0,
                        -28.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -31.42,
                        0.15,
                        -39.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.94,
                        0.03,
                        -29.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.87,
                        0.45,
                        -27.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -36.89,
                        0.49,
                        -40.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.54,
                        1.05,
                        -34.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        24.60,
                        -0.42,
                        -7.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        21.56,
                        0.18,
                        -35.59,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.38,
                        0.08,
                        -61.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        22.50,
                        -0.47,
                        -7.45,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.25,
                        0.62,
                        -32.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.26,
                        0.41,
                        -40.41,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        39.24,
                        0.83,
                        -31.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.46,
                        0.56,
                        -48.36,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.08,
                        0.66,
                        -19.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -35.22,
                        0.14,
                        -39.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -44.5,
                        0.83,
                        -23.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -35.22,
                        0.14,
                        -39.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.98,
                        -0.2,
                        -24.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.06,
                        0.01,
                        -29.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.93,
                        0.42,
                        -37.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.37,
                        0.68,
                        -45.68,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.23,
                        1.06,
                        -51.41,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.14,
                        -0.2,
                        -24.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.63,
                        0.39,
                        -30.89,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.47,
                        0.27,
                        -39.79,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.56,
                        1.17,
                        -7.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.98,
                        -0.58,
                        -13.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.15,
                        1.38,
                        -6.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.23,
                        -0.15,
                        -24.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.03,
                        0.35,
                        -36.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.85,
                        1.15,
                        -18.89,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.24,
                        0.57,
                        -19.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.69,
                        0.39,
                        -49.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.12,
                        -0.27,
                        -25.93,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.86,
                        0.78,
                        -7.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.05,
                        -0.35,
                        -25.13,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.01,
                        0.34,
                        -57.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.29,
                        0.04,
                        -28.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.29,
                        0.44,
                        -27.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.96,
                        0.70,
                        -49.82,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        37.82,
                        0.31,
                        -30.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.73,
                        0.93,
                        -33.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.03,
                        0.43,
                        -36.13,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        33.98,
                        0.06,
                        -13.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.54,
                        0.95,
                        -33.85,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.34,
                        0.04,
                        -30.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.53,
                        0.60,
                        -18.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.29,
                        0.67,
                        -45.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.18,
                        0.17,
                        -39.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -13.44,
                        0.34,
                        -49.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.26,
                        0.04,
                        -28.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.4,
                        0.19,
                        -72.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        39.90,
                        0.03,
                        -27.36,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.69,
                        0.41,
                        -34.05,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.77,
                        -0,
                        -29.13,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.62,
                        0.63,
                        -31.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.73,
                        0.36,
                        -29.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.22,
                        0.24,
                        -39.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.92,
                        -0.25,
                        -25.89,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.71,
                        0.25,
                        -39.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -28.45,
                        0.23,
                        -64.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.07,
                        0.23,
                        -39.47,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.38,
                        0.53,
                        -34.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.25,
                        0.59,
                        -20.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.52,
                        0.16,
                        -39.9,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        39.99,
                        0.64,
                        -29.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.16,
                        0.42,
                        -32.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.13,
                        -0.55,
                        -20.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.89,
                        0.26,
                        -38.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -38.14,
                        0.23,
                        -17.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -26.21,
                        0.41,
                        -18.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.66,
                        0.53,
                        -34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.89,
                        -0.22,
                        -24.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.29,
                        -0.15,
                        -27.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.93,
                        0.21,
                        -39.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.9,
                        -0.37,
                        -23.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.27,
                        0.54,
                        -33.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.47,
                        1.05,
                        -36.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.19,
                        -0.4,
                        -9.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.52,
                        0.16,
                        -39.9,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.21,
                        0.69,
                        -56.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.09,
                        1.40,
                        -20.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.67,
                        0.14,
                        -30.45,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -40.73,
                        -0.12,
                        -19.82,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.42,
                        -0.08,
                        -27.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.24,
                        -0.01,
                        -29.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.56,
                        -0.2,
                        -27.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -39.66,
                        0.46,
                        -17.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.72,
                        1.08,
                        -35.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        25.10,
                        0.19,
                        -39.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.24,
                        -0.02,
                        -27.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.03,
                        0.43,
                        -36.13,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.42,
                        0.69,
                        -31.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        21.23,
                        0.29,
                        -36.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.92,
                        0.92,
                        -33.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.07,
                        -0.17,
                        -24.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.25,
                        0.62,
                        -32.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.14,
                        -0.37,
                        -22.9,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.6,
                        1.29,
                        -50.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.31,
                        0.46,
                        -35.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        39.90,
                        0.03,
                        -27.36,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.18,
                        -0.01,
                        -28.08,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.11,
                        -0.28,
                        -23.98,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.2,
                        -0.01,
                        -68.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -13.71,
                        0.64,
                        -46.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.01,
                        0.69,
                        -34.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.76,
                        0.58,
                        -47.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.90,
                        -0.25,
                        -26.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.53,
                        1.03,
                        -36.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.49,
                        0.37,
                        -16.85,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.44,
                        0.30,
                        -39.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.69,
                        0.42,
                        -40.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00
                    ],
                    [
                        5.83,
                        -0.19,
                        -3.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        39.66,
                        0.43,
                        -29.22,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        35.08,
                        0.55,
                        -35.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.5,
                        0.34,
                        -31.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -39.9,
                        0.13,
                        -18.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -43.87,
                        0.75,
                        -22.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.27,
                        -0.29,
                        -24.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -39.74,
                        0.53,
                        -16.96,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        40.51,
                        0.11,
                        -26.93,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.98,
                        0.01,
                        -27.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.31,
                        -0.29,
                        -24.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -40.57,
                        -0.04,
                        -19.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.33,
                        0.32,
                        -5.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.47,
                        0.21,
                        -38.79,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.38,
                        0.87,
                        -37.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.44,
                        0.41,
                        -34.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.38,
                        0.26,
                        -39.28,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -26.94,
                        0.17,
                        -66.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.66,
                        -0.37,
                        -25.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -40.46,
                        0.26,
                        -18.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.56,
                        0.22,
                        -30.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.10,
                        0.39,
                        -35.58,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        39.05,
                        0.42,
                        -29.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.46,
                        0.02,
                        -10.05,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.96,
                        0.14,
                        -40.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.46,
                        0.53,
                        -51.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.2,
                        -0.33,
                        -25.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.93,
                        -0.66,
                        -12.22,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.19,
                        0.33,
                        -37.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.12,
                        -0.3,
                        -19.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.19,
                        0.08,
                        -29.18,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.22,
                        -0.27,
                        -26.73,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.77,
                        1.01,
                        -34.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -29.4,
                        0.52,
                        -15.59,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.18,
                        0.69,
                        -31.4,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.54,
                        0.11,
                        -71.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.10,
                        -0.47,
                        -19.95,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.12,
                        -0.02,
                        -28.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.39,
                        -0.27,
                        -23.47,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.45,
                        -0.25,
                        -26.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.15,
                        0.98,
                        -37.3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.16,
                        0.25,
                        -38.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.06,
                        -0.51,
                        -19.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.12,
                        0.59,
                        -19.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -27.31,
                        0.25,
                        -17.59,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.82,
                        0.63,
                        -32.41,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.44,
                        0.52,
                        -45.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.25,
                        0.09,
                        -73.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.07,
                        -0.36,
                        -16.3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.72,
                        -0.31,
                        -22.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.32,
                        1.20,
                        -38.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.67,
                        0.65,
                        -44.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.93,
                        -0.29,
                        -19.9,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.63,
                        0.10,
                        -40.41,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.45,
                        0.35,
                        -36.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.11,
                        -0.03,
                        -28.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -26.36,
                        0.36,
                        -39.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -42.64,
                        0.37,
                        -21.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        23.35,
                        -0.13,
                        -36.24,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.37,
                        0.41,
                        -37.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.21,
                        0.57,
                        -35.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.99,
                        -0.47,
                        -17.95,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.53,
                        0.16,
                        -71.73,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.32,
                        0.86,
                        -37.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.69,
                        1.02,
                        -5.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.23,
                        1.31,
                        -42.73,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.73,
                        -0.01,
                        -28.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        13.31,
                        0.71,
                        -38.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.54,
                        0.41,
                        -33.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        31.32,
                        0.08,
                        -35.89,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.27,
                        0.23,
                        -49.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.77,
                        -0.01,
                        -9.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.7,
                        0.21,
                        -39.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        38.07,
                        0.96,
                        -33.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.47,
                        0.03,
                        -28.93,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -29.51,
                        0.21,
                        -17.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.27,
                        0.41,
                        -33.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.86,
                        -0.24,
                        -26.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.56,
                        0.40,
                        -33.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.88,
                        -0.01,
                        -28.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.22,
                        0.20,
                        -29.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.02,
                        0.20,
                        -39.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.38,
                        0.69,
                        -21.89,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.2,
                        0.03,
                        -28.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -42.87,
                        0.57,
                        -36.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.67,
                        1.24,
                        -50.33,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.99,
                        0.69,
                        -16.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        36.16,
                        0.38,
                        -32.89,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.85,
                        0.46,
                        -5.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.29,
                        1.59,
                        -42.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -38.45,
                        0.45,
                        -16.85,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.73,
                        -0.27,
                        -23.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.54,
                        0.38,
                        -35.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -40.73,
                        0.20,
                        -37.93,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.08,
                        0.34,
                        -19.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.49,
                        0.42,
                        -37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.53,
                        0.51,
                        -34.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.50,
                        -0.33,
                        -25.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -43.57,
                        0.63,
                        -22.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.09,
                        1.02,
                        -34.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.89,
                        1.10,
                        -38.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.55,
                        0.92,
                        -33.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.9,
                        0.45,
                        -27.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.65,
                        -0.34,
                        -22.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.32,
                        0.46,
                        -34.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.5,
                        0.22,
                        -38.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.61,
                        -0.42,
                        -25.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.74,
                        0.47,
                        -18.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.88,
                        0.69,
                        -31.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.29,
                        0.87,
                        -20.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.89,
                        1.05,
                        -51.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.79,
                        1.13,
                        -36.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.79,
                        -0.49,
                        -19.95,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.7,
                        0.40,
                        -31.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        36.80,
                        0.29,
                        -31.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        14.69,
                        -0.3,
                        -5.85,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.32,
                        0.26,
                        -39.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.53,
                        0.76,
                        -18.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.51,
                        0.39,
                        -46.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.28,
                        0.87,
                        -3.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.32,
                        0.39,
                        -30.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.11,
                        0.16,
                        -58.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -29.34,
                        0.27,
                        -17.13,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        39.90,
                        -0.07,
                        -26.47,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.72,
                        0.17,
                        -69.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -34.91,
                        0.06,
                        -38.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6,
                        0.28,
                        -39.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.4,
                        0.07,
                        -66.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.22,
                        0.53,
                        -47.77,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.83,
                        0.19,
                        -72.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.33,
                        0.99,
                        -34.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.87,
                        -0.01,
                        -28.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        33.93,
                        0.32,
                        -12.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        20.42,
                        0.06,
                        -29.26,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.44,
                        0.19,
                        -38.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.85,
                        0.20,
                        -39.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.57,
                        -0.48,
                        -18.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.10,
                        0.42,
                        -30.68,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.92,
                        0.39,
                        -31.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.49,
                        0.07,
                        -61.13,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.15,
                        -0.06,
                        -27.85,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.81,
                        -0.03,
                        -72.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.99,
                        0.43,
                        -35.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.37,
                        0.46,
                        -38.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.67,
                        0.65,
                        -44.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -31.58,
                        0.26,
                        -39.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.55,
                        0.73,
                        -34.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.83,
                        1.34,
                        -43.75,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        14.31,
                        -0.57,
                        -13.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.32,
                        0.05,
                        -71.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.16,
                        0.78,
                        -37.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.77,
                        1.32,
                        -6.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.82,
                        0.46,
                        -46.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.58,
                        0.77,
                        -3.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.29,
                        0.44,
                        -32.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        13.73,
                        -0.61,
                        -12.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -13.92,
                        0.70,
                        -45.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.63,
                        -0.01,
                        -27.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.93,
                        0.42,
                        -32.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.01,
                        -0.26,
                        -24.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.82,
                        -0.18,
                        -26.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.92,
                        1.11,
                        -38.41,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.78,
                        -0.66,
                        -22.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.49,
                        0.69,
                        -2.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.71,
                        0.40,
                        -29.58,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.17,
                        0.22,
                        -30.3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.45,
                        0.58,
                        -33.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.73,
                        0.92,
                        -38.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -27.77,
                        0.10,
                        -38.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        21.91,
                        -0.41,
                        -7.4,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -28.59,
                        0.23,
                        -17.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.77,
                        0.06,
                        -63.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.89,
                        0.40,
                        -32.58,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        32.04,
                        0.40,
                        -37.24,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.89,
                        -0.49,
                        -23.59,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.18,
                        0.25,
                        -40.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.88,
                        0.74,
                        -20.95,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.07,
                        -0.44,
                        -23.13,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.88,
                        -0.25,
                        -25.79,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.1,
                        0.11,
                        -39.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        37.50,
                        0.76,
                        -33.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.27,
                        0.43,
                        -32.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.33,
                        -0.2,
                        -24.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.74,
                        -0.2,
                        -24.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        9.09,
                        0.66,
                        -41.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.32,
                        -0.42,
                        -22.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00
                    ],
                    [
                        6.79,
                        -0.09,
                        -7.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.94,
                        -0.3,
                        -20.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.95,
                        1.14,
                        -43.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.08,
                        -0.55,
                        -20.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.76,
                        -0.69,
                        -13.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.85,
                        0.53,
                        -30.89,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.02,
                        0.50,
                        -34.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.53,
                        -0.11,
                        -29.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -13.77,
                        0.33,
                        -48.94,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.12,
                        0.95,
                        -20.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.6,
                        0.29,
                        -31.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.13,
                        0.32,
                        -28.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.97,
                        0.56,
                        -47.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        29.22,
                        -0.33,
                        -35.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.21,
                        0.72,
                        -31.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.95,
                        1.37,
                        -40.41,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.68,
                        0.54,
                        -45.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.58,
                        1.40,
                        -8.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.84,
                        0.63,
                        -47.08,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.77,
                        0.28,
                        -30.13,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.3,
                        1.30,
                        -20.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        29.73,
                        -0.04,
                        -9.18,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.03,
                        -0.06,
                        -27.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.5,
                        0.00,
                        -28.18,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.54,
                        1.13,
                        -35.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.04,
                        0.50,
                        -34.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.22,
                        1.37,
                        -43.82,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -42.95,
                        0.55,
                        -37.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.83,
                        0.39,
                        -31.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.35,
                        0.52,
                        -47.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.89,
                        -0.02,
                        -28.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.44,
                        -0.3,
                        -15.22,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.36,
                        -0.61,
                        -21.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.15,
                        0.08,
                        -71.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -40.39,
                        0.52,
                        -17.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.57,
                        0.17,
                        -40.18,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.69,
                        -0.07,
                        -27.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.60,
                        0.04,
                        -6.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -38.16,
                        0.22,
                        -17.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.35,
                        -0.29,
                        -23.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.89,
                        1.05,
                        -51.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.28,
                        0.41,
                        -37.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.32,
                        1.20,
                        -38.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.48,
                        0.25,
                        -50.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.44,
                        -0.47,
                        -18.96,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.21,
                        0.57,
                        -35.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.01,
                        0.24,
                        -39.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.92,
                        0.42,
                        -32.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4,
                        0.32,
                        -37.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.12,
                        -0.41,
                        -24.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -27.67,
                        0.21,
                        -61.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        38.38,
                        0.52,
                        -30.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.25,
                        0.09,
                        -38.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        37.18,
                        0.45,
                        -31.9,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.33,
                        0.51,
                        -32.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -36.18,
                        0.09,
                        -38.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.73,
                        0.33,
                        -28.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -27.06,
                        0.20,
                        -59.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.43,
                        0.04,
                        -28.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.6,
                        0.69,
                        -22.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.96,
                        0.38,
                        -49.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.02,
                        0.42,
                        -36.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -29.72,
                        0.17,
                        -39.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.08,
                        -0.01,
                        -11.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.02,
                        0.96,
                        -53.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        36.23,
                        0.43,
                        -33.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.51,
                        0.14,
                        -29.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.01,
                        0.44,
                        -35.26,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -13.82,
                        1.32,
                        -15.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.52,
                        0.08,
                        -61.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.24,
                        1.01,
                        -54.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        25.11,
                        -0.13,
                        -37.05,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -29.09,
                        0.42,
                        -16.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.62,
                        -0.28,
                        -23.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.31,
                        -0.23,
                        -27.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.07,
                        0.25,
                        -31.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.45,
                        -0.08,
                        -27.68,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.01,
                        0.73,
                        -35.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.91,
                        0.61,
                        -48.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        20.50,
                        0.12,
                        -30.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.74,
                        0.69,
                        -22.68,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.39,
                        -0.3,
                        -19.98,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.15,
                        0.66,
                        -34.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.61,
                        -0.14,
                        -27.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -26.47,
                        0.18,
                        -60.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.32,
                        0.39,
                        -30.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.57,
                        0.77,
                        -44.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.47,
                        -0.38,
                        -23.3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.29,
                        -0.41,
                        -22.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -36.69,
                        0.10,
                        -17.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        13.98,
                        -0.6,
                        -11.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.11,
                        0.28,
                        -5.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.76,
                        -0.13,
                        -27.68,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.81,
                        0.01,
                        -28.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.39,
                        1.14,
                        -38.33,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.37,
                        0.43,
                        -28.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.79,
                        0.48,
                        -38.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.99,
                        0.59,
                        -31.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -39.82,
                        0.31,
                        -18.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.92,
                        0.40,
                        -20.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        30.86,
                        0.17,
                        -8.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.15,
                        0.66,
                        -33.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.66,
                        -0.21,
                        -26.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.30,
                        0.37,
                        -29.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.3,
                        0.29,
                        -31.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.33,
                        0.63,
                        -15.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.25,
                        0.24,
                        -49.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.65,
                        0.64,
                        -46.93,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.55,
                        0.47,
                        -30.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.86,
                        -0.34,
                        -10.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.54,
                        0.38,
                        -34.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.86,
                        0.38,
                        -6.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.67,
                        0.00,
                        -27.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.55,
                        -0.07,
                        -57.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.99,
                        -0.05,
                        -62.4,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.28,
                        0.64,
                        -30.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.82,
                        -0.72,
                        -21.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.21,
                        0.70,
                        -31.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        39.73,
                        0.29,
                        -28.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        38.80,
                        0.94,
                        -32.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.80,
                        -0.24,
                        -23.94,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.07,
                        0.84,
                        -37.24,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.75,
                        -0.09,
                        -27.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.89,
                        0.28,
                        -38.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.54,
                        1.41,
                        -19.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.07,
                        -0.36,
                        -16.3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.77,
                        1.02,
                        -37.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.87,
                        0.41,
                        -27.3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.29,
                        -0.08,
                        -27.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.55,
                        -0.01,
                        -28.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.02,
                        1.26,
                        -50.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.88,
                        -0.32,
                        -26.11,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.70,
                        -0.03,
                        -8.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.92,
                        -0.35,
                        -25.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.86,
                        0.58,
                        -21.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.93,
                        0.92,
                        -18.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.34,
                        -0.16,
                        -27.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.74,
                        -0.31,
                        -20.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.55,
                        0.69,
                        -30.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.48,
                        0.44,
                        -32.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.27,
                        -0.05,
                        -60.41,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.52,
                        0.80,
                        -35.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.78,
                        0.73,
                        -37.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.19,
                        0.21,
                        -19.58,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        35.46,
                        0.14,
                        -32.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.64,
                        -0.34,
                        -21.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.04,
                        0.21,
                        -30.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.5,
                        0.27,
                        -39.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.94,
                        0.24,
                        -39.28,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.48,
                        0.82,
                        -9.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        23.22,
                        -0.57,
                        -8.28,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.54,
                        0.11,
                        -71.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        21.23,
                        -0.37,
                        -8.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.21,
                        -0.2,
                        -24.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        32.80,
                        0.26,
                        -35.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.96,
                        0.68,
                        -47.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.09,
                        1.06,
                        -21.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        20.04,
                        -0.27,
                        -8.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        40.78,
                        0.36,
                        -28.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        13.98,
                        -0.6,
                        -11.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        39.10,
                        0.28,
                        -29.22,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.51,
                        1.40,
                        -41.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.59,
                        -0.04,
                        -28.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.62,
                        0.97,
                        -34.13,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.94,
                        0.68,
                        -15.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.28,
                        0.68,
                        -56.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.39,
                        0.21,
                        -40.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.29,
                        0.39,
                        -7.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.03,
                        -0.28,
                        -23.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.78,
                        0.51,
                        -34.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.86,
                        0.68,
                        -48.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.99,
                        0.08,
                        -50.98,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.51,
                        0.44,
                        -38.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.66,
                        0.07,
                        -49.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.11,
                        0.66,
                        -31.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.83,
                        -0.6,
                        -19.96,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.86,
                        0.03,
                        -71.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.97,
                        -0.15,
                        -27.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.5,
                        -0.24,
                        -27.47,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.81,
                        -0.01,
                        -9.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.73,
                        0.27,
                        -36.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.26,
                        0.92,
                        -33.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -13.79,
                        0.46,
                        -48.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.27,
                        0.20,
                        -38.82,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.96,
                        0.41,
                        -33.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00
                    ],
                    [
                        15.65,
                        0.06,
                        -7.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.65,
                        0.06,
                        -7.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -32.36,
                        0.37,
                        -16.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -32.36,
                        0.37,
                        -16.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.83,
                        0.20,
                        -38.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.83,
                        0.20,
                        -38.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        32.95,
                        0.49,
                        -9.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.28,
                        0.65,
                        -32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.28,
                        0.65,
                        -32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.04,
                        0.82,
                        -36.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.04,
                        0.82,
                        -36.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.69,
                        1.01,
                        -38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.69,
                        1.01,
                        -38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.81,
                        -0.3,
                        -24.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.81,
                        -0.3,
                        -24.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.17,
                        0.87,
                        -55.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.17,
                        0.87,
                        -55.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.42,
                        -0.37,
                        -22.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.02,
                        0.80,
                        -5.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.02,
                        0.80,
                        -5.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.21,
                        0.72,
                        -22.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.21,
                        0.72,
                        -22.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        33.26,
                        0.27,
                        -35.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        33.26,
                        0.27,
                        -35.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.88,
                        -0.57,
                        -21.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.88,
                        -0.57,
                        -21.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        33.45,
                        0.47,
                        -36.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        33.45,
                        0.47,
                        -36.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -13.91,
                        0.99,
                        -16.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -13.91,
                        0.99,
                        -16.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.38,
                        0.96,
                        -20.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.51,
                        0.41,
                        -31.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.51,
                        0.41,
                        -31.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.96,
                        0.38,
                        -36.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.96,
                        0.38,
                        -36.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.04,
                        0.11,
                        -49.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.04,
                        0.11,
                        -49.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        38.20,
                        0.78,
                        -32.22,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        38.20,
                        0.78,
                        -32.22,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.45,
                        0.19,
                        -39.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.45,
                        0.19,
                        -39.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.57,
                        0.42,
                        -49.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.75,
                        0.88,
                        -18.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.75,
                        0.88,
                        -18.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.89,
                        0.56,
                        -33.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.89,
                        0.56,
                        -33.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.05,
                        0.35,
                        -36.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.05,
                        0.35,
                        -36.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.98,
                        0.11,
                        -29.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.98,
                        0.11,
                        -29.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        32.42,
                        -0.63,
                        -13.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        32.42,
                        -0.63,
                        -13.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.27,
                        0.79,
                        -34.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.02,
                        -0.22,
                        -26.73,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.02,
                        -0.22,
                        -26.73,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.74,
                        0.05,
                        -29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.74,
                        0.05,
                        -29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.78,
                        0.75,
                        -43.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.78,
                        0.75,
                        -43.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.53,
                        -0.24,
                        -23.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.53,
                        -0.24,
                        -23.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.22,
                        0.82,
                        -55.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.22,
                        0.82,
                        -55.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.36,
                        0.44,
                        -35.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.36,
                        0.44,
                        -35.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.12,
                        0.43,
                        -34.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.71,
                        0.48,
                        -48.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.71,
                        0.48,
                        -48.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.9,
                        0.33,
                        -36.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.9,
                        0.33,
                        -36.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        38.15,
                        0.83,
                        -32.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        38.15,
                        0.83,
                        -32.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.09,
                        1.15,
                        -38.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.09,
                        1.15,
                        -38.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        33.65,
                        0.31,
                        -11.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        33.65,
                        0.31,
                        -11.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        13.44,
                        0.66,
                        -37.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.97,
                        0.33,
                        -32.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.97,
                        0.33,
                        -32.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.52,
                        0.06,
                        -66.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.52,
                        0.06,
                        -66.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.36,
                        0.67,
                        -45.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.36,
                        0.67,
                        -45.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.08,
                        0.62,
                        -34.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.08,
                        0.62,
                        -34.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.16,
                        0.37,
                        -28.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.16,
                        0.37,
                        -28.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.11,
                        0.68,
                        -49.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.11,
                        0.68,
                        -49.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.36,
                        -0.28,
                        -25.82,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.11,
                        -0.01,
                        -28.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.11,
                        -0.01,
                        -28.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.53,
                        0.46,
                        -32.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.53,
                        0.46,
                        -32.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.45,
                        0.25,
                        -19.79,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.45,
                        0.25,
                        -19.79,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        26.48,
                        -0.4,
                        -7.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        26.48,
                        -0.4,
                        -7.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.98,
                        0.87,
                        -33.58,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.98,
                        0.87,
                        -33.58,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -38.46,
                        0.06,
                        -18.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.74,
                        0.16,
                        -40.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.74,
                        0.16,
                        -40.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.87,
                        -0.03,
                        -27.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.87,
                        -0.03,
                        -27.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.34,
                        0.87,
                        -37.59,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.34,
                        0.87,
                        -37.59,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.79,
                        0.91,
                        -20.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.79,
                        0.91,
                        -20.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.46,
                        -0.14,
                        -24.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.46,
                        -0.14,
                        -24.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.94,
                        0.34,
                        -38.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.52,
                        1.05,
                        -36.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.52,
                        1.05,
                        -36.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.97,
                        0.41,
                        -33.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.97,
                        0.41,
                        -33.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.32,
                        0.64,
                        -45.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.32,
                        0.64,
                        -45.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.49,
                        -0.2,
                        -24.18,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.49,
                        -0.2,
                        -24.18,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.67,
                        0.04,
                        -69.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.67,
                        0.04,
                        -69.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -35.38,
                        0.17,
                        -17.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -35.38,
                        0.17,
                        -17.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.89,
                        1.07,
                        -35.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.84,
                        0.97,
                        -33.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.84,
                        0.97,
                        -33.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.75,
                        1.08,
                        -35.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.75,
                        1.08,
                        -35.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.44,
                        1.11,
                        -35.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.44,
                        1.11,
                        -35.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -40.97,
                        0.20,
                        -37.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -40.97,
                        0.20,
                        -37.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.74,
                        -0.61,
                        -20.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.74,
                        -0.61,
                        -20.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.36,
                        0.53,
                        -37.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.01,
                        1.32,
                        -40.11,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.01,
                        1.32,
                        -40.11,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        27.89,
                        0.19,
                        -38.73,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        27.89,
                        0.19,
                        -38.73,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.09,
                        0.00,
                        -28.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.09,
                        0.00,
                        -28.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.68,
                        0.86,
                        -5.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.68,
                        0.86,
                        -5.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.44,
                        -0.23,
                        -26.85,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.44,
                        -0.23,
                        -26.85,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.56,
                        -0.38,
                        -24.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.56,
                        -0.38,
                        -24.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.95,
                        0.87,
                        -19.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        29.29,
                        0.05,
                        -36.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        29.29,
                        0.05,
                        -36.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.31,
                        0.54,
                        -32.59,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.31,
                        0.54,
                        -32.59,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.93,
                        0.13,
                        -9.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.93,
                        0.13,
                        -9.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.27,
                        0.52,
                        -18.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.27,
                        0.52,
                        -18.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.26,
                        0.68,
                        -34.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.26,
                        0.68,
                        -34.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.41,
                        0.13,
                        -30.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.7,
                        0.46,
                        -38.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.7,
                        0.46,
                        -38.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.72,
                        0.21,
                        -39.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.72,
                        0.21,
                        -39.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.82,
                        -0.14,
                        -9.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.82,
                        -0.14,
                        -9.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.55,
                        -21.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.55,
                        -21.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.08,
                        0.17,
                        -72.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.08,
                        0.17,
                        -72.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -37.6,
                        0.23,
                        -17.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -37.6,
                        0.23,
                        -17.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.71,
                        0.65,
                        -21.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.06,
                        0.44,
                        -36.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.06,
                        0.44,
                        -36.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.52,
                        -0.2,
                        -26.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.52,
                        -0.2,
                        -26.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.65,
                        0.80,
                        -36.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.65,
                        0.80,
                        -36.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.63,
                        -0.19,
                        -27.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.63,
                        -0.19,
                        -27.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.69,
                        0.35,
                        -35.93,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.69,
                        0.35,
                        -35.93,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        21.40,
                        -0.43,
                        -8.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.08,
                        0.02,
                        -27.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.08,
                        0.02,
                        -27.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.73,
                        1.19,
                        -50.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.73,
                        1.19,
                        -50.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.77,
                        0.25,
                        -39.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.77,
                        0.25,
                        -39.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.58,
                        0.58,
                        -3.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.58,
                        0.58,
                        -3.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.37,
                        0.99,
                        -36.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.37,
                        0.99,
                        -36.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        14.73,
                        0.88,
                        -38.08,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.88,
                        0.59,
                        -37.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.88,
                        0.59,
                        -37.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.99,
                        1.39,
                        -40.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.99,
                        1.39,
                        -40.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        14.87,
                        0.87,
                        -37.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        14.87,
                        0.87,
                        -37.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.04,
                        0.21,
                        -40.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.04,
                        0.21,
                        -40.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.28,
                        1.06,
                        -6.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.28,
                        1.06,
                        -6.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.54,
                        0.16,
                        -30.36,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.54,
                        0.16,
                        -30.36,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.62,
                        -0.12,
                        -27.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -32.45,
                        0.40,
                        -40.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -32.45,
                        0.40,
                        -40.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.46,
                        0.08,
                        -65.45,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.46,
                        0.08,
                        -65.45,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.13,
                        -0.32,
                        -21.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.13,
                        -0.32,
                        -21.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.55,
                        0.04,
                        -28.98,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.55,
                        0.04,
                        -28.98,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.93,
                        -0.27,
                        -23.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.93,
                        -0.27,
                        -23.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.83,
                        -0.29,
                        -16.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.05,
                        1.18,
                        -6.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.05,
                        1.18,
                        -6.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.41,
                        0.92,
                        -36.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.41,
                        0.92,
                        -36.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.16,
                        0.34,
                        -37.26,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.16,
                        0.34,
                        -37.26,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.15,
                        -0.03,
                        -27.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.15,
                        -0.03,
                        -27.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.6,
                        1.21,
                        -21.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.6,
                        1.21,
                        -21.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        20.68,
                        0.10,
                        -31.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        20.68,
                        0.10,
                        -31.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.46,
                        0.42,
                        -28.45,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.53,
                        -0.62,
                        -16.79,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.53,
                        -0.62,
                        -16.79,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.2,
                        0.28,
                        -47.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.2,
                        0.28,
                        -47.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.1,
                        1.50,
                        -18.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.1,
                        1.50,
                        -18.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.47,
                        0.66,
                        -32.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.47,
                        0.66,
                        -32.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.29,
                        0.45,
                        -27.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.29,
                        0.45,
                        -27.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.71,
                        -0.56,
                        -19.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.18,
                        0.74,
                        -15.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.18,
                        0.74,
                        -15.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.80,
                        0.50,
                        -34.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.80,
                        0.50,
                        -34.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.2,
                        1.23,
                        -18.96,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.2,
                        1.23,
                        -18.96,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.25,
                        -0.32,
                        -20.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.25,
                        -0.32,
                        -20.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.88,
                        0.77,
                        -32.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.88,
                        0.77,
                        -32.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        20.72,
                        0.04,
                        -30.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.65,
                        0.05,
                        -66.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.65,
                        0.05,
                        -66.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.25,
                        -0.26,
                        -15.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.25,
                        -0.26,
                        -15.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.55,
                        0.70,
                        -44.79,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.55,
                        0.70,
                        -44.79,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.15,
                        1.23,
                        -21.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.15,
                        1.23,
                        -21.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.56,
                        0.89,
                        -51.79,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.56,
                        0.89,
                        -51.79,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.85,
                        -0.35,
                        -25.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.85,
                        -0.35,
                        -25.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.6,
                        0.21,
                        -55.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.56,
                        0.69,
                        -19.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.56,
                        0.69,
                        -19.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.47,
                        0.98,
                        -34.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.47,
                        0.98,
                        -34.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.81,
                        -0.23,
                        -28.05,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.81,
                        -0.23,
                        -28.05,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.36,
                        -0.13,
                        -28.33,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.36,
                        -0.13,
                        -28.33,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.11,
                        0.37,
                        -35.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.11,
                        0.37,
                        -35.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.34,
                        0.24,
                        -57.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.7,
                        0.24,
                        -39.75,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.7,
                        0.24,
                        -39.75,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -44.17,
                        0.85,
                        -20.77,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -44.17,
                        0.85,
                        -20.77,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.62,
                        1.12,
                        -36.22,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.62,
                        1.12,
                        -36.22,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        20.91,
                        -0.13,
                        -29.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        20.91,
                        -0.13,
                        -29.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.03,
                        0.50,
                        -34.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.03,
                        0.50,
                        -34.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.25,
                        0.67,
                        -18.9,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.25,
                        0.67,
                        -18.9,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.69,
                        0.42,
                        -28.95,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -42.78,
                        0.72,
                        -19.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -42.78,
                        0.72,
                        -19.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.04,
                        0.29,
                        -37.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.04,
                        0.29,
                        -37.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.12,
                        0.20,
                        -49.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.12,
                        0.20,
                        -49.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.88,
                        0.14,
                        -57.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.88,
                        0.14,
                        -57.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.08,
                        0.25,
                        -31.4,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.08,
                        0.25,
                        -31.4,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -28.96,
                        0.16,
                        -39.59,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.79,
                        0.91,
                        -33.93,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.79,
                        0.91,
                        -33.93,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.20,
                        -0.19,
                        -24.41,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.20,
                        -0.19,
                        -24.41,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.65,
                        -0.01,
                        -28.95,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.65,
                        -0.01,
                        -28.95,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.86,
                        0.91,
                        -33.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.86,
                        0.91,
                        -33.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.88,
                        0.26,
                        -39.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.88,
                        0.26,
                        -39.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        11.55,
                        -0.02,
                        -36.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.15,
                        0.27,
                        -39.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.15,
                        0.27,
                        -39.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.49,
                        0.99,
                        -35.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.49,
                        0.99,
                        -35.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.30,
                        0.03,
                        -10.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.30,
                        0.03,
                        -10.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.64,
                        -0.48,
                        -24.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.64,
                        -0.48,
                        -24.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.1,
                        -0.11,
                        -28.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.1,
                        -0.11,
                        -28.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        34.29,
                        0.07,
                        -34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        34.29,
                        0.07,
                        -34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.22,
                        0.24,
                        -39.3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.41,
                        0.32,
                        -38.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.41,
                        0.32,
                        -38.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.57,
                        0.01,
                        -28.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.57,
                        0.01,
                        -28.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.53,
                        -0.21,
                        -27.18,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.53,
                        -0.21,
                        -27.18,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.19,
                        0.28,
                        -32.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.19,
                        0.28,
                        -32.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.65,
                        -0,
                        -29.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.65,
                        -0,
                        -29.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.31,
                        0.24,
                        -39.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.57,
                        0.43,
                        -36.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.57,
                        0.43,
                        -36.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.68,
                        0.59,
                        -41.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.68,
                        0.59,
                        -41.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.87,
                        0.61,
                        -32.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.87,
                        0.61,
                        -32.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00
                    ],
                    [
                        6.43,
                        -0.22,
                        -4.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -34.4,
                        0.22,
                        -39.36,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.64,
                        0.42,
                        -23.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.16,
                        0.41,
                        -34.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.16,
                        0.55,
                        -33.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.72,
                        -0.17,
                        -27.11,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.08,
                        0.05,
                        -19.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.92,
                        0.47,
                        -34.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.7,
                        0.27,
                        -38.33,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.83,
                        0.42,
                        -7.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.38,
                        0.87,
                        -15.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.61,
                        0.36,
                        -32.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.5,
                        -0.07,
                        -26.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.75,
                        0.69,
                        -44.75,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -39.48,
                        0.11,
                        -38.4,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.03,
                        -0.17,
                        -27.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.39,
                        0.01,
                        -62.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.19,
                        0.24,
                        -38.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.75,
                        1.27,
                        -6.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.84,
                        -0.49,
                        -19.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.15,
                        0.34,
                        -53.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.27,
                        -0.1,
                        -28.18,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.99,
                        0.12,
                        -32.82,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        21.82,
                        0.30,
                        -37.68,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        10.13,
                        0.43,
                        -39.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.97,
                        -0.38,
                        -23.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.63,
                        0.53,
                        -19.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.83,
                        0.10,
                        -29.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -32.07,
                        0.41,
                        -40.93,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.34,
                        0.25,
                        -39.75,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        29.46,
                        0.08,
                        -8.33,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.05,
                        -0.58,
                        -21.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.26,
                        0.44,
                        -30.95,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.84,
                        0.45,
                        -28.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.33,
                        0.88,
                        -37.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.16,
                        -0.29,
                        -25.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.91,
                        0.35,
                        -35.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.45,
                        -0.18,
                        -26.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -28.03,
                        0.11,
                        -18.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.26,
                        0.25,
                        -38.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.83,
                        0.63,
                        -32.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.12,
                        0.44,
                        -36.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.73,
                        0.38,
                        -47.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.87,
                        0.44,
                        -35.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.28,
                        0.85,
                        -3.45,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.56,
                        0.25,
                        -39.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.96,
                        0.86,
                        -37.05,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.73,
                        0.00,
                        -27.79,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.03,
                        0.44,
                        -33.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.96,
                        0.44,
                        -32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.98,
                        0.45,
                        -28.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        38.65,
                        -0.12,
                        -28.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.30,
                        0.65,
                        -56.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.90,
                        0.84,
                        -37.05,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -27.76,
                        0.33,
                        -16.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.26,
                        0.87,
                        -7.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        13.89,
                        0.36,
                        -35.59,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.32,
                        1.30,
                        -50.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        26.28,
                        -0.5,
                        -7.82,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.18,
                        0.39,
                        -33.77,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.28,
                        0.43,
                        -36.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        25.25,
                        -0.19,
                        -36.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.16,
                        0.42,
                        -34.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.04,
                        -0.54,
                        -14.08,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.26,
                        0.64,
                        -22.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.77,
                        -0.34,
                        -20.68,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.57,
                        0.94,
                        -50.26,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.00,
                        0.39,
                        -30.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.54,
                        0.35,
                        -47.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.02,
                        0.13,
                        -71.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.50,
                        0.01,
                        -10.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.02,
                        0.41,
                        -31.33,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        32.48,
                        -0.17,
                        -12.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.67,
                        0.44,
                        -35.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.9,
                        -0.02,
                        -28.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.01,
                        1.14,
                        -44.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.26,
                        0.34,
                        -27.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.37,
                        0.31,
                        -38.47,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        34.21,
                        0.55,
                        -36.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        38.75,
                        0.93,
                        -32.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.94,
                        0.83,
                        -32.94,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.67,
                        0.20,
                        -39.73,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.51,
                        0.07,
                        -28.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.12,
                        1.19,
                        -16.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.38,
                        1.21,
                        -19.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.51,
                        0.02,
                        -51.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -28.76,
                        0.14,
                        -39.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.24,
                        0.42,
                        -36.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.62,
                        0.21,
                        -74.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.15,
                        0.46,
                        -45.75,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.32,
                        0.73,
                        -20.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        28.26,
                        -0.28,
                        -8.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -13.02,
                        0.42,
                        -48.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.64,
                        0.42,
                        -23.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.75,
                        0.06,
                        -65.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.23,
                        0.21,
                        -40.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.32,
                        0.24,
                        -39.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.86,
                        1.15,
                        -35.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.58,
                        0.42,
                        -31.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.67,
                        0.25,
                        -39.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.09,
                        0.13,
                        -71.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.78,
                        -0.32,
                        -26.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.38,
                        0.97,
                        -33.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.92,
                        0.78,
                        -48.98,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.88,
                        -0.25,
                        -3.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.07,
                        0.42,
                        -27.47,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.5,
                        0.06,
                        -70.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.45,
                        -0.79,
                        -22.13,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.3,
                        0.35,
                        -36.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.92,
                        1.19,
                        -17.82,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.21,
                        0.27,
                        -58.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.15,
                        0.28,
                        -23.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        14.91,
                        -0.59,
                        -12.85,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.21,
                        0.97,
                        -35.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.46,
                        -0.46,
                        -24.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.4,
                        0.19,
                        -71.68,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.27,
                        0.36,
                        -34.3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.48,
                        -0.12,
                        -31.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.25,
                        -0.35,
                        -25.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.32,
                        -0.44,
                        -22.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.07,
                        0.12,
                        -39.93,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        31.53,
                        -0.17,
                        -10.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.47,
                        1.30,
                        -21.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.05,
                        0.05,
                        -28.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.66,
                        0.01,
                        -28.47,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.05,
                        0.36,
                        -31.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.23,
                        -0.23,
                        -14.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.18,
                        0.45,
                        -34.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.83,
                        0.97,
                        -34.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.44,
                        0.68,
                        -37.47,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -34.32,
                        0.40,
                        -16.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.14,
                        0.80,
                        -35.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.43,
                        0.49,
                        -48.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.29,
                        0.04,
                        -73.93,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.74,
                        -0.02,
                        -11.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.04,
                        0.05,
                        -29.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        26.28,
                        -0.5,
                        -7.82,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.14,
                        -0.28,
                        -23.94,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.58,
                        0.05,
                        -30.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        39.90,
                        0.03,
                        -27.36,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -34.58,
                        0.53,
                        -41.33,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.59,
                        0.42,
                        -7.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.18,
                        0.45,
                        -34.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.17,
                        -0.07,
                        -27.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.74,
                        -0.01,
                        -29.45,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.97,
                        -0.09,
                        -28.11,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.80,
                        -0.52,
                        -19.58,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.76,
                        1.08,
                        -38.82,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.48,
                        0.57,
                        -33.59,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.71,
                        0.76,
                        -20.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.73,
                        0.92,
                        -38.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.88,
                        0.78,
                        -8.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.95,
                        0.85,
                        -36.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.95,
                        -0.19,
                        -5.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -36.5,
                        0.35,
                        -16.94,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.15,
                        0.84,
                        -35.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.32,
                        0.47,
                        -35.08,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.89,
                        0.20,
                        -31.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.64,
                        0.42,
                        -35.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.87,
                        0.38,
                        -33.98,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.49,
                        1.53,
                        -42.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -32.92,
                        0.05,
                        -38.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        37.96,
                        1.00,
                        -34.22,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.42,
                        0.44,
                        -32.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.07,
                        0.18,
                        -31.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.30,
                        0.38,
                        -30.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.37,
                        0.53,
                        -34.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -13.54,
                        0.56,
                        -47.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        24.62,
                        -0.59,
                        -8.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.07,
                        0.40,
                        -31.95,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.36,
                        0.85,
                        -44.96,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        9.24,
                        0.05,
                        -37.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.22,
                        0.33,
                        -51.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.45,
                        0.41,
                        -33.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.01,
                        0.29,
                        -38.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.05,
                        -0.07,
                        -27.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.84,
                        -0.31,
                        -20.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.69,
                        0.21,
                        -38.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        10.00,
                        0.09,
                        -38.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        25.13,
                        -0.61,
                        -8.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.89,
                        -0.22,
                        -24.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -44.85,
                        0.90,
                        -21.85,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.13,
                        0.08,
                        -29.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        29.96,
                        0.03,
                        -36.47,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.18,
                        0.21,
                        -29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        14.20,
                        -0.33,
                        -6.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00
                    ],
                    [
                        6.95,
                        -0.06,
                        -7.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.02,
                        -0.66,
                        -23.33,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.73,
                        0.85,
                        -32.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.4,
                        -0.2,
                        -27.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        29.81,
                        -0.21,
                        -35.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.07,
                        0.33,
                        -37.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.57,
                        0.49,
                        -40.59,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.27,
                        0.76,
                        -22.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.23,
                        0.40,
                        -33.68,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.91,
                        0.49,
                        -34.73,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.47,
                        0.97,
                        -34.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -26.69,
                        0.33,
                        -17.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.32,
                        0.37,
                        -31.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.05,
                        0.59,
                        -47.05,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.66,
                        0.67,
                        -56.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.4,
                        1.08,
                        -38.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -34.76,
                        0.67,
                        -15.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        39.64,
                        0.16,
                        -28.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.41,
                        0.11,
                        -29.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.16,
                        -0.61,
                        -12.47,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -43.42,
                        0.85,
                        -19.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.86,
                        0.43,
                        -32.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.39,
                        -0.18,
                        -27.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.68,
                        0.10,
                        -29.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.3,
                        0.08,
                        -69.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.4,
                        0.48,
                        -20.75,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.56,
                        0.20,
                        -39.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.29,
                        0.21,
                        -38.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.48,
                        0.08,
                        -70.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.4,
                        -0.2,
                        -27.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.12,
                        -0.18,
                        -24.36,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.17,
                        0.66,
                        -31.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.34,
                        0.19,
                        -38.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -27.51,
                        0.24,
                        -17.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.2,
                        0.24,
                        -39.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.09,
                        0.85,
                        -36.79,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.94,
                        0.21,
                        -39.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.18,
                        1.36,
                        -40.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.02,
                        -0.22,
                        -24.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -28.68,
                        0.36,
                        -16.28,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.01,
                        0.94,
                        -14.9,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.35,
                        0.40,
                        -32.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.29,
                        0.07,
                        -29.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.41,
                        1.26,
                        -53.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.28,
                        -0.61,
                        -20.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.42,
                        1.08,
                        -50.98,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.77,
                        0.14,
                        -30.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.2,
                        0.86,
                        -37.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.23,
                        0.37,
                        -49.73,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        34.54,
                        0.13,
                        -33.94,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -28.07,
                        0.30,
                        -16.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        10.38,
                        -0,
                        -37.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.72,
                        0.23,
                        -29.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.6,
                        0.37,
                        -32.28,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.02,
                        0.44,
                        -36.96,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.16,
                        0.49,
                        -31.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        34.72,
                        0.39,
                        -34.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.43,
                        -0.39,
                        -24.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.46,
                        1.30,
                        -20.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.19,
                        0.19,
                        -40.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.81,
                        0.34,
                        -27.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.45,
                        0.25,
                        -39.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.27,
                        0.85,
                        -49.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.68,
                        -0.01,
                        -27.33,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.80,
                        -0.58,
                        -19.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        37.67,
                        0.91,
                        -33.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.23,
                        0.66,
                        -48.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.49,
                        0.84,
                        -32.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.79,
                        -0.62,
                        -23.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9,
                        0.10,
                        -30.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -36.66,
                        0.04,
                        -17.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.15,
                        0.60,
                        -15.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.03,
                        0.89,
                        -36.94,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.48,
                        0.01,
                        -63.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.27,
                        0.85,
                        -49.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.58,
                        -0.2,
                        -27.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.43,
                        0.91,
                        -19.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.5,
                        -0.34,
                        -25.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.54,
                        0.50,
                        -7.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.62,
                        0.23,
                        -40.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.67,
                        1.16,
                        -35.75,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.84,
                        -0.24,
                        -26.4,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -29.59,
                        0.12,
                        -39.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.18,
                        0.35,
                        -36.89,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -27.01,
                        0.04,
                        -37.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -32.79,
                        0.46,
                        -16.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.23,
                        -0.28,
                        -25.77,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -26.95,
                        0.19,
                        -61.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.13,
                        -0.34,
                        -23.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.82,
                        0.90,
                        -37.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -43.69,
                        0.63,
                        -22.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.90,
                        -0.21,
                        -26.24,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.28,
                        0.17,
                        -39.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.29,
                        0.24,
                        -39.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.24,
                        0.35,
                        -37.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        14.11,
                        0.41,
                        -35.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.39,
                        0.13,
                        -68.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.18,
                        0.72,
                        -32.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.15,
                        0.05,
                        -65.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.29,
                        -0.42,
                        -24.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.24,
                        -0.44,
                        -17.75,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.10,
                        -0.16,
                        -27.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.06,
                        0.24,
                        -29.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.19,
                        0.74,
                        -36.26,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.48,
                        0.88,
                        -36.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.39,
                        -0.18,
                        -26.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -32.52,
                        0.48,
                        -16.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.33,
                        -0.36,
                        -25.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.49,
                        -0.44,
                        -24.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.54,
                        0.67,
                        -31.96,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        39.37,
                        -0.07,
                        -27.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        29.56,
                        0.11,
                        -8.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.65,
                        0.33,
                        -38.75,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.55,
                        0.69,
                        -31.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.89,
                        0.67,
                        -43.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.03,
                        0.37,
                        -31.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -40.92,
                        0.06,
                        -19.68,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.91,
                        0.08,
                        -29.82,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.44,
                        0.38,
                        -31.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        28.62,
                        -0,
                        -37.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        26.88,
                        -0.56,
                        -8.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.02,
                        0.60,
                        -33.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.23,
                        0.44,
                        -35.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.53,
                        -0.21,
                        -27.18,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.47,
                        -0.06,
                        -28.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.15,
                        0.21,
                        -29.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.4,
                        0.43,
                        -50.05,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.95,
                        1.13,
                        -35.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -26.39,
                        0.41,
                        -55.95,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.47,
                        0.01,
                        -73.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.63,
                        0.15,
                        -40.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.41,
                        0.35,
                        -35.94,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.89,
                        0.15,
                        -39.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.41,
                        0.41,
                        -35.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.28,
                        -0.61,
                        -20.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.79,
                        0.16,
                        -31.26,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.98,
                        0.22,
                        -39.94,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -44.17,
                        0.85,
                        -20.77,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.16,
                        -0.31,
                        -19.59,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        22.77,
                        -0.46,
                        -7.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.37,
                        0.07,
                        -29.96,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.93,
                        -0.26,
                        -23.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        22.45,
                        0.25,
                        -38.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        39.13,
                        0.13,
                        -28.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2,
                        0.06,
                        -66.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.64,
                        0.95,
                        -33.96,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.59,
                        0.23,
                        -40.3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.69,
                        0.87,
                        -37.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.43,
                        0.67,
                        -32.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.35,
                        0.25,
                        -39.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.18,
                        -0.12,
                        -26.36,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.35,
                        0.04,
                        -49.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.36,
                        0.06,
                        -31.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.06,
                        0.06,
                        -68.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.02,
                        -0.31,
                        -26.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.51,
                        1.44,
                        -42.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.83,
                        0.11,
                        -29.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.26,
                        0.45,
                        -36.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.20,
                        -0.23,
                        -23.77,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.95,
                        0.65,
                        -22.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.45,
                        0.68,
                        -43.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.04,
                        0.02,
                        -50.11,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.7,
                        0.25,
                        -39.11,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.76,
                        0.51,
                        -33.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.03,
                        -0.12,
                        -28.11,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.92,
                        0.57,
                        -32.47,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.75,
                        0.66,
                        -32.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.83,
                        0.11,
                        -57.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        26.48,
                        -0.4,
                        -7.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.12,
                        -0.24,
                        -27.08,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        30.54,
                        0.08,
                        -36.33,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.27,
                        0.38,
                        -37.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.90,
                        0.81,
                        -35.9,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.34,
                        0.53,
                        -45.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.81,
                        0.60,
                        -30.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.25,
                        0.44,
                        -36.36,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.35,
                        0.04,
                        -29.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        30.75,
                        0.40,
                        -38.18,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.06,
                        0.67,
                        -46.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.24,
                        0.10,
                        -62.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.24,
                        0.87,
                        -22.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.32,
                        0.51,
                        -34.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.04,
                        0.39,
                        -27.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.42,
                        0.45,
                        -32.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.45,
                        0.02,
                        -9.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.28,
                        -0.24,
                        -10.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00
                    ],
                    [
                        7.63,
                        -0.29,
                        -4.4,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.5,
                        0.72,
                        -55.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.92,
                        0.53,
                        -34.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.55,
                        0.21,
                        -30.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.14,
                        0.24,
                        -39.18,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.45,
                        0.62,
                        -32.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.78,
                        0.24,
                        -56.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.39,
                        0.21,
                        -40.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.72,
                        0.00,
                        -27.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.08,
                        0.60,
                        -36,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.58,
                        1.14,
                        -35.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        31.36,
                        0.06,
                        -35.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.78,
                        0.40,
                        -33.24,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.77,
                        0.34,
                        -34.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.89,
                        0.89,
                        -37.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.04,
                        1.12,
                        -49.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.31,
                        -0.29,
                        -23.28,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.84,
                        0.55,
                        -23.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.02,
                        0.01,
                        -29.05,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -37.08,
                        0.43,
                        -16.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.77,
                        0.60,
                        -34.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.01,
                        0.35,
                        -30.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.75,
                        0.66,
                        -47.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.15,
                        -0.04,
                        -60.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.16,
                        0.41,
                        -29.3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.69,
                        0.54,
                        -16.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.96,
                        0.25,
                        -39.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.1,
                        0.08,
                        -67.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.75,
                        0.05,
                        -72.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.62,
                        -0.47,
                        -23.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.56,
                        0.41,
                        -32.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.79,
                        -0.31,
                        -23.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        25.71,
                        -0.32,
                        -36.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.06,
                        0.56,
                        -18.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.36,
                        0.89,
                        -7.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.56,
                        1.32,
                        -40.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.73,
                        0.02,
                        -28.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -32.03,
                        0.33,
                        -17.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.86,
                        -0.68,
                        -10.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        32.95,
                        -0.34,
                        -13.3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.15,
                        -0.29,
                        -24.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.72,
                        0.42,
                        -33.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.89,
                        0.01,
                        -28.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.73,
                        0.03,
                        -28.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.94,
                        0.56,
                        -47.79,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.21,
                        0.35,
                        -36.41,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -28.21,
                        0.09,
                        -38.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.11,
                        0.73,
                        -22,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.06,
                        0.60,
                        -45.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.19,
                        0.76,
                        -2.3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.33,
                        0.16,
                        -30.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.40,
                        -0.75,
                        -22.59,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.9,
                        -0.05,
                        -71.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.73,
                        -0.22,
                        -26.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.45,
                        0.93,
                        -49.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.94,
                        0.34,
                        -31.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.18,
                        0.13,
                        -40.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -29.65,
                        0.18,
                        -39.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.95,
                        0.53,
                        -34.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.01,
                        0.45,
                        -35.05,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        37.44,
                        0.90,
                        -34.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.93,
                        1.47,
                        -8.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.98,
                        1.06,
                        -49.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.36,
                        0.74,
                        -44.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.89,
                        -0.72,
                        -13.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.14,
                        0.48,
                        -33.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.82,
                        0.32,
                        -47.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.89,
                        0.59,
                        -33.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.46,
                        0.42,
                        -33.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.20,
                        -0.74,
                        -11.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -33.18,
                        0.07,
                        -38.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.46,
                        -0.39,
                        -25.73,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.98,
                        -0.01,
                        -69.26,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.54,
                        0.01,
                        -29.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.74,
                        0.25,
                        -39.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.90,
                        -0.48,
                        -18.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.42,
                        0.75,
                        -55.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.84,
                        1.15,
                        -35.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.59,
                        1.41,
                        -40.73,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.2,
                        0.42,
                        -32.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.78,
                        0.49,
                        -34.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.85,
                        0.74,
                        -53.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.3,
                        0.85,
                        -20.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.76,
                        0.24,
                        -31.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.69,
                        1.14,
                        -35.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.19,
                        0.35,
                        -36.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.54,
                        0.01,
                        -29.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.08,
                        1.05,
                        -34.79,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.11,
                        0.22,
                        -38.68,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.17,
                        0.85,
                        -8.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.06,
                        0.73,
                        -35.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.21,
                        0.68,
                        -31.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -39.45,
                        0.13,
                        -38.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.85,
                        -0.25,
                        -14.89,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.6,
                        0.43,
                        -32.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.31,
                        1.04,
                        -49.95,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        29.79,
                        0.08,
                        -8.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.31,
                        0.11,
                        -30.18,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.73,
                        -0.05,
                        -29.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -27.53,
                        0.08,
                        -38.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.29,
                        0.35,
                        -30.28,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        40.23,
                        0.08,
                        -27.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.49,
                        0.05,
                        -29.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.64,
                        1.48,
                        -41.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -13.15,
                        1.29,
                        -14.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.22,
                        0.16,
                        -29.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.25,
                        0.27,
                        -39.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        39.72,
                        0.25,
                        -28.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        22.01,
                        0.16,
                        -36.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.33,
                        0.38,
                        -29.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.38,
                        0.03,
                        -61.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.11,
                        -0.38,
                        -24.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.45,
                        0.23,
                        -40.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.02,
                        0.41,
                        -32.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -42.64,
                        0.46,
                        -21.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -43.86,
                        0.68,
                        -22.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.32,
                        0.01,
                        -30.36,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.07,
                        -0.26,
                        -23.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.13,
                        -0.27,
                        -24.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.79,
                        0.51,
                        -34.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -39.31,
                        0.33,
                        -17.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.56,
                        0.22,
                        -39.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.52,
                        0.40,
                        -27.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.20,
                        0.52,
                        -6.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        10.40,
                        0.27,
                        -38.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        30.17,
                        -0.76,
                        -11.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.65,
                        0.94,
                        -20.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.13,
                        0.06,
                        -29.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.83,
                        0.48,
                        -49.75,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.33,
                        -0.61,
                        -17.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -42.32,
                        0.44,
                        -20.59,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.9,
                        0.15,
                        -30.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.60,
                        -0.25,
                        -23.98,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.30,
                        0.31,
                        -57.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.12,
                        -0.33,
                        -25.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.4,
                        1.45,
                        -20.73,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.97,
                        0.72,
                        -30.85,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.78,
                        -0.29,
                        -15.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.79,
                        1.06,
                        -54.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        9.57,
                        0.51,
                        -40.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.18,
                        0.73,
                        -35.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.78,
                        0.81,
                        -37.08,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.52,
                        -0.01,
                        -27.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.63,
                        0.36,
                        -19.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.96,
                        -0.14,
                        -27.75,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.04,
                        0.54,
                        -17.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        32.38,
                        0.02,
                        -35.22,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.98,
                        1.13,
                        -36.28,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -29.73,
                        0.23,
                        -40.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.45,
                        0.17,
                        -30.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.22,
                        -0.08,
                        -27.24,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.79,
                        1.13,
                        -36.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.67,
                        0.90,
                        -36.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.99,
                        -0.71,
                        -22.47,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.04,
                        -0.05,
                        -28.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.02,
                        0.51,
                        -51.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.25,
                        0.35,
                        -37.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.36,
                        1.14,
                        -38.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        14.32,
                        -0.58,
                        -10.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.73,
                        -0,
                        -27.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        28.75,
                        0.09,
                        -37.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.52,
                        1.03,
                        -38.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.84,
                        0.41,
                        -33.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.88,
                        0.06,
                        -29.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23,
                        1.08,
                        -21.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.1,
                        1.51,
                        -19.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.02,
                        0.29,
                        -38.45,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.33,
                        0.51,
                        -32.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.56,
                        1.21,
                        -43.94,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.78,
                        -0.21,
                        -25.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.00,
                        -0.75,
                        -21.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.98,
                        0.15,
                        -39.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.36,
                        -0.18,
                        -26.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.76,
                        0.01,
                        -28.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        9.98,
                        0.41,
                        -39.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -27.64,
                        0.22,
                        -17.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.14,
                        0.24,
                        -39.18,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.62,
                        0.20,
                        -39.77,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.71,
                        0.39,
                        -32.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.59,
                        0.99,
                        -36.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.14,
                        0.88,
                        -18.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.93,
                        -0.03,
                        -27.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.38,
                        -0.15,
                        -24.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.77,
                        -0.01,
                        -29.58,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.32,
                        1.34,
                        -8.98,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.31,
                        1.34,
                        -21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00
                    ],
                    [
                        7.18,
                        -0.18,
                        -5.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.79,
                        0.35,
                        -36.08,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.87,
                        0.68,
                        -31.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.88,
                        0.56,
                        -32.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.78,
                        0.41,
                        -33.33,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.65,
                        0.48,
                        -34.9,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.23,
                        1.02,
                        -35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.52,
                        0.62,
                        -33.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.55,
                        -0.25,
                        -24.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.09,
                        0.46,
                        -35.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.55,
                        0.44,
                        -37.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.75,
                        -0.31,
                        -24.89,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.43,
                        0.00,
                        -28.47,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.74,
                        0.23,
                        -29.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.02,
                        0.33,
                        -7.33,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.66,
                        0.49,
                        -56.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.41,
                        1.26,
                        -53.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.67,
                        0.05,
                        -67.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.19,
                        0.77,
                        -20.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -37.85,
                        0.40,
                        -16.93,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.77,
                        0.59,
                        -33.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.31,
                        -0.22,
                        -24.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.67,
                        0.47,
                        -31.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.10,
                        1.09,
                        -54.82,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.89,
                        0.72,
                        -20.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -28.45,
                        0.29,
                        -60.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.50,
                        -0.52,
                        -19.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        29.03,
                        -0.09,
                        -9.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        38.71,
                        1.21,
                        -35.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.45,
                        0.61,
                        -32.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.13,
                        0.66,
                        -32.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -29.66,
                        0.26,
                        -17.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.82,
                        0.72,
                        -30.82,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.63,
                        -0.12,
                        -25.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.45,
                        -0.28,
                        -3.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.46,
                        0.50,
                        -34.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.43,
                        0.36,
                        -35.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.36,
                        0.46,
                        -46.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.02,
                        -0.05,
                        -27.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.97,
                        1.24,
                        -9.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.85,
                        0.41,
                        -32.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.82,
                        0.04,
                        -67.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.62,
                        0.61,
                        -22.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.69,
                        0.15,
                        -39.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.1,
                        0.07,
                        -68.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.90,
                        -0.56,
                        -20.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -27.06,
                        0.13,
                        -38.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.80,
                        0.68,
                        -44.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.12,
                        -0.13,
                        -10.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.04,
                        0.11,
                        -49.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.86,
                        0.08,
                        -70.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.8,
                        1.46,
                        -20.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.2,
                        -0.04,
                        -60.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.98,
                        0.25,
                        -39.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.11,
                        0.16,
                        -39.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.36,
                        -0.56,
                        -10.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.78,
                        1.07,
                        -35.13,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.88,
                        0.07,
                        -66.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.99,
                        1.14,
                        -35.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.52,
                        0.65,
                        -32.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -38.11,
                        0.02,
                        -18.08,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.13,
                        0.94,
                        -18.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.05,
                        -0.46,
                        -17.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.07,
                        0.73,
                        -4.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.74,
                        0.10,
                        -50.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.43,
                        -0.44,
                        -24.4,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        33.65,
                        0.31,
                        -11.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.29,
                        -0.31,
                        -20.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.29,
                        0.70,
                        -17.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.32,
                        -0.26,
                        -3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.73,
                        0.00,
                        -29.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.72,
                        0.37,
                        -29.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.37,
                        0.26,
                        -39.3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -36.4,
                        0.48,
                        -16.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.3,
                        1.01,
                        -34.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.29,
                        0.65,
                        -35.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.75,
                        0.88,
                        -18.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.93,
                        0.07,
                        -65.41,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.66,
                        -0.61,
                        -20.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.68,
                        -0.38,
                        -25.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        21.62,
                        -0.4,
                        -7.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.36,
                        0.04,
                        -69.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.89,
                        0.51,
                        -23.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.36,
                        -0.17,
                        -27.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.96,
                        -0.01,
                        -28.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.45,
                        0.98,
                        -55.33,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.54,
                        -0.05,
                        -58.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.66,
                        0.01,
                        -28.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -26.06,
                        0.38,
                        -19.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.49,
                        0.84,
                        -32.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.51,
                        0.69,
                        -52.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.31,
                        0.35,
                        -36.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.54,
                        0.42,
                        -35.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.87,
                        0.59,
                        -33.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.02,
                        -0.55,
                        -20.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        26.96,
                        -0.66,
                        -8.75,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.24,
                        -0.23,
                        -27.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.41,
                        -0.52,
                        -21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.07,
                        0.69,
                        -31.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        31.92,
                        -0.44,
                        -12.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.51,
                        0.65,
                        -18.33,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.93,
                        0.67,
                        -2.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.49,
                        -0.44,
                        -24.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.33,
                        -0.72,
                        -22.96,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.11,
                        -0.19,
                        -26,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -40.97,
                        0.20,
                        -37.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.6,
                        0.26,
                        -39.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        20.83,
                        -0.14,
                        -28.68,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.61,
                        0.43,
                        -36.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.62,
                        -0.27,
                        -23.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.12,
                        0.82,
                        -53.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.23,
                        1.03,
                        -36.36,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.21,
                        0.01,
                        -28.96,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.04,
                        -0.12,
                        -13.05,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.26,
                        0.05,
                        -64.96,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.75,
                        1.10,
                        -35.28,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.56,
                        0.63,
                        -15.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.67,
                        -0.07,
                        -26.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        26.96,
                        -0.66,
                        -8.75,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.64,
                        0.24,
                        -39.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.91,
                        -0.18,
                        -26.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.66,
                        0.40,
                        -29.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.46,
                        -0.18,
                        -24.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.74,
                        0.15,
                        -39.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.17,
                        0.18,
                        -32.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -40.7,
                        0.32,
                        -18.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.76,
                        -0.37,
                        -24.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.80,
                        0.45,
                        -30.28,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.99,
                        0.20,
                        -38.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -26.64,
                        0.13,
                        -37.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.19,
                        -0.15,
                        -27.9,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        37.69,
                        0.87,
                        -33.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.30,
                        0.53,
                        -33.94,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        9.55,
                        0.03,
                        -37.58,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.38,
                        0.19,
                        -22.9,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.41,
                        1.21,
                        -38.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.19,
                        -0.19,
                        -27.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        10.70,
                        -0.04,
                        -36.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.15,
                        0.23,
                        -39.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -42.1,
                        0.38,
                        -36.4,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.09,
                        0.42,
                        -36.47,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.59,
                        0.36,
                        -34.26,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.21,
                        -0.03,
                        -27.24,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.92,
                        0.21,
                        -31.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        26.88,
                        -0.56,
                        -8.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.1,
                        0.07,
                        -68.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        28.62,
                        -0,
                        -37.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.97,
                        0.37,
                        -22.73,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.6,
                        0.26,
                        -39.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.96,
                        0.64,
                        -32.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.71,
                        0.22,
                        -21.22,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.71,
                        -0.2,
                        -27.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.56,
                        0.26,
                        -31.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.42,
                        1.08,
                        -50.98,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.83,
                        0.09,
                        -28.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        29.15,
                        0.03,
                        -8.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.47,
                        0.95,
                        -33.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        9.26,
                        0.53,
                        -40.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.18,
                        0.87,
                        -37.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.71,
                        0.43,
                        -36.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.55,
                        -0.24,
                        -5.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.27,
                        0.59,
                        -33.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.36,
                        -0.3,
                        -23.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.92,
                        0.20,
                        -39.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.18,
                        0.86,
                        -18.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -13.28,
                        0.50,
                        -48.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.94,
                        -0.26,
                        -25.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        33.52,
                        0.50,
                        -36.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.82,
                        0.52,
                        -48.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.06,
                        0.19,
                        -40.4,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.56,
                        0.69,
                        -19.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.54,
                        0.14,
                        -28.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.13,
                        0.02,
                        -28.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.86,
                        0.00,
                        -27.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.49,
                        0.12,
                        -22.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        14.94,
                        0.54,
                        -35.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -43.7,
                        0.73,
                        -21.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.04,
                        -0.06,
                        -71.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -37.27,
                        0.22,
                        -17.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.5,
                        0.69,
                        -37.24,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        10.89,
                        0.29,
                        -38.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.72,
                        -0.5,
                        -19.82,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.97,
                        0.85,
                        -36.9,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.54,
                        -0.2,
                        -26.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.33,
                        0.32,
                        -17.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.18,
                        0.27,
                        -39.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.25,
                        0.15,
                        -30.77,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.55,
                        0.52,
                        -32.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.85,
                        -0.65,
                        -23.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.22,
                        0.11,
                        -40.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00
                    ],
                    [
                        16.64,
                        0.53,
                        -33.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.08,
                        0.49,
                        -34.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.15,
                        1.63,
                        -17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        10.34,
                        -0,
                        -37.24,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.04,
                        0.17,
                        -40.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        10.41,
                        0.05,
                        -37.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.10,
                        -0.14,
                        -25.68,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        22.49,
                        -0.48,
                        -7.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.9,
                        0.47,
                        -34.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.67,
                        0.56,
                        -34.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.8,
                        0.32,
                        -37.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.97,
                        0.97,
                        -34.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.45,
                        0.20,
                        -33.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.87,
                        0.44,
                        -33.26,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.49,
                        0.44,
                        -31.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.32,
                        0.46,
                        -30.82,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.67,
                        0.17,
                        -36.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.88,
                        0.57,
                        -33.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.38,
                        0.24,
                        -17.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -29.48,
                        0.41,
                        -16.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.83,
                        0.04,
                        -27.13,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.61,
                        0.44,
                        -31.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -35.81,
                        0.28,
                        -39.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.91,
                        0.24,
                        -40.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.26,
                        0.67,
                        -30.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.95,
                        0.28,
                        -39.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.75,
                        0.62,
                        -34.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.18,
                        0.36,
                        -29.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        32.12,
                        -0.01,
                        -35.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.74,
                        1.31,
                        -19.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.3,
                        0.14,
                        -39.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.59,
                        0.30,
                        -21.18,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17,
                        0.17,
                        -49.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.98,
                        0.28,
                        -38.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.46,
                        1.20,
                        -19.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.19,
                        0.14,
                        -63.96,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.35,
                        0.37,
                        -28.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.47,
                        -0.3,
                        -26.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        14.02,
                        -0.43,
                        -8.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.89,
                        -0.04,
                        -27.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.51,
                        0.00,
                        -28.18,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.74,
                        1.01,
                        -34.18,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.52,
                        1.44,
                        -41.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.66,
                        0.65,
                        -46.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.61,
                        0.78,
                        -32.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.25,
                        0.36,
                        -30.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.34,
                        0.10,
                        -40.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        14.56,
                        -0.59,
                        -11.75,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.18,
                        0.25,
                        -49.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.55,
                        0.44,
                        -31.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.14,
                        0.25,
                        -39.73,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.16,
                        0.67,
                        -35.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.09,
                        0.60,
                        -31.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.09,
                        0.41,
                        -34.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.98,
                        0.42,
                        -22.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.07,
                        0.64,
                        -52.98,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.27,
                        0.27,
                        -38.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.89,
                        -0.07,
                        -25.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.71,
                        1.05,
                        -6.28,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.90,
                        -0.05,
                        -25.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.83,
                        0.16,
                        -30.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.57,
                        0.31,
                        -17.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.99,
                        0.74,
                        -31.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.63,
                        0.73,
                        -50.68,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.02,
                        0.74,
                        -58.41,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.08,
                        -0.32,
                        -23.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.18,
                        0.52,
                        -30.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        14.95,
                        0.21,
                        -33.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.39,
                        0.14,
                        -29.4,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.46,
                        0.25,
                        -33.22,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.94,
                        -0.08,
                        -28.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.58,
                        0.41,
                        -8.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -31.57,
                        0.35,
                        -40.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.28,
                        0.24,
                        -38.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.24,
                        0.69,
                        -36.77,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.87,
                        1.35,
                        -9.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.61,
                        0.44,
                        -2.24,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.65,
                        0.00,
                        -27.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        14.87,
                        -0.01,
                        -33.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -37.79,
                        0.31,
                        -39.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.93,
                        0.17,
                        -39.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.03,
                        0.58,
                        -30.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.75,
                        -0.49,
                        -20.77,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        35.83,
                        0.22,
                        -32.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.12,
                        1.65,
                        -15.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        13.01,
                        -0.5,
                        -10.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.66,
                        0.72,
                        -36.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.21,
                        0.17,
                        -31.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.12,
                        0.45,
                        -29.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.36,
                        0.15,
                        -33.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.19,
                        0.45,
                        -29.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.81,
                        0.32,
                        -33.5,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -34.36,
                        0.61,
                        -15.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.48,
                        0.42,
                        -30.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.58,
                        0.09,
                        -65.22,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.31,
                        0.67,
                        -35.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.04,
                        1.79,
                        -44.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -37.67,
                        0.54,
                        -16.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        32.23,
                        0.26,
                        -36.11,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.72,
                        -0.19,
                        -4.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.76,
                        1.04,
                        -34.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        13.36,
                        -0.55,
                        -14.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.46,
                        0.72,
                        -17.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.91,
                        0.53,
                        -31.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.16,
                        1.13,
                        -39.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.37,
                        0.86,
                        -49.22,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.91,
                        -0.4,
                        -22.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.75,
                        0.29,
                        -35.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.61,
                        1.54,
                        -42.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.50,
                        0.11,
                        -27.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.97,
                        0.06,
                        -63.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.65,
                        -0.41,
                        -19.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.24,
                        0.46,
                        -30.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -38.42,
                        0.46,
                        -16.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.24,
                        -0,
                        -29.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -34.17,
                        0.09,
                        -38.94,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.13,
                        -0.6,
                        -21.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        26.74,
                        -0.33,
                        -6.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -33.54,
                        0.10,
                        -38.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.13,
                        0.30,
                        -36.05,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.94,
                        1.39,
                        -41.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -36.17,
                        0.51,
                        -16.28,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.79,
                        0.33,
                        -29.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.39,
                        0.22,
                        -32.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.52,
                        1.52,
                        -7.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.97,
                        0.50,
                        -53.11,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.93,
                        0.35,
                        -38.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.44,
                        0.27,
                        -35.13,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.75,
                        0.12,
                        -26.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.35,
                        0.03,
                        -10.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.12,
                        -0.11,
                        -26.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.05,
                        0.43,
                        -31.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.45,
                        0.21,
                        -39.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.48,
                        0.82,
                        -36.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.27,
                        0.35,
                        -36.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        25.91,
                        -0.24,
                        -36.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -29.21,
                        0.25,
                        -65.3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.39,
                        0.38,
                        -34.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        13.18,
                        -0.48,
                        -8.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -40.72,
                        0.34,
                        -38.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.54,
                        0.07,
                        -56.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.74,
                        0.09,
                        -7.45,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.87,
                        0.24,
                        -39.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.49,
                        0.71,
                        -49.11,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.38,
                        -0.28,
                        -24.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        9.04,
                        0.08,
                        -38.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.36,
                        0.80,
                        -32.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.24,
                        -0.09,
                        -25.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.12,
                        0.70,
                        -30.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.11,
                        0.17,
                        -49.13,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.41,
                        1.77,
                        -43.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.76,
                        0.38,
                        -30.93,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        35.46,
                        0.11,
                        -32.82,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -45.12,
                        0.94,
                        -20.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.30,
                        -0.08,
                        -27.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.71,
                        -0.33,
                        -15.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.37,
                        1.16,
                        -39.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.65,
                        0.54,
                        -33.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.88,
                        0.06,
                        -74.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.76,
                        -0.41,
                        -20.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.66,
                        0.46,
                        -32.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.05,
                        1.22,
                        -18.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.64,
                        0.36,
                        -35.58,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.57,
                        0.66,
                        -47.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.75,
                        0.24,
                        -48.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.25,
                        0.49,
                        -31.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.19,
                        1.44,
                        -19.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -38.71,
                        0.36,
                        -17.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.35,
                        0.31,
                        -39.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.08,
                        0.01,
                        -58.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.49,
                        0.40,
                        -33.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.03,
                        0.61,
                        -35.28,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -44.62,
                        0.73,
                        -38.62,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.26,
                        0.28,
                        -38.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -28.04,
                        0.33,
                        -59.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.56,
                        -20.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.65,
                        0.40,
                        -30.4,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.13,
                        0.43,
                        -33.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.24,
                        0.58,
                        -51.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.18,
                        1.10,
                        -35.85,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.10,
                        0.43,
                        -29.77,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.03,
                        0.28,
                        -36.45,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.52,
                        0.09,
                        -74.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.1,
                        0.81,
                        -32.89,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -29.31,
                        0.25,
                        -65.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00
                    ],
                    [
                        6.39,
                        -0.22,
                        -2.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.89,
                        -0.58,
                        -17.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.72,
                        -0.31,
                        -21.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -43.1,
                        0.76,
                        -19.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.41,
                        0.94,
                        -37.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.18,
                        0.11,
                        -58.45,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -42.7,
                        0.31,
                        -22.08,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.31,
                        0.25,
                        -38.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.92,
                        0.37,
                        -41.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.55,
                        0.49,
                        -48.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.16,
                        -0.07,
                        -28.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.33,
                        0.58,
                        -15.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.3,
                        1.20,
                        -38.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.72,
                        1.53,
                        -41.79,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -35.91,
                        0.50,
                        -41.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.2,
                        0.10,
                        -38.9,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.69,
                        0.07,
                        -66.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.96,
                        0.22,
                        -38.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.60,
                        -0.61,
                        -23.3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.42,
                        -0.21,
                        -26.94,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.34,
                        -0.78,
                        -21.79,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.46,
                        0.18,
                        -39.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        16.83,
                        0.42,
                        -7.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.63,
                        0.37,
                        -35.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.95,
                        0.54,
                        -31.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.21,
                        0.73,
                        -56.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        35.54,
                        0.47,
                        -34.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.59,
                        0.93,
                        -51.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.9,
                        0.44,
                        -33.06,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.49,
                        1.19,
                        -54.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.65,
                        1.09,
                        -54.36,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.42,
                        0.80,
                        -55.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.39,
                        0.68,
                        -56.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.69,
                        -0.02,
                        -27.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.39,
                        0.77,
                        -44.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.05,
                        0.52,
                        -23.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -32.98,
                        0.25,
                        -39.58,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.24,
                        0.40,
                        -6.05,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.71,
                        -0.36,
                        -23.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.42,
                        0.09,
                        -30.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.17,
                        0.08,
                        -74.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.78,
                        -0.03,
                        -68.89,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.5,
                        1.03,
                        -36.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.36,
                        -0.34,
                        -23.11,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.45,
                        0.42,
                        -30.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.12,
                        0.19,
                        -72.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.21,
                        0.27,
                        -58.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.44,
                        0.86,
                        -33.28,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        14.32,
                        -0.61,
                        -11.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.87,
                        0.63,
                        -32.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.11,
                        0.31,
                        -28.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.09,
                        0.82,
                        -20.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.59,
                        0.38,
                        -34.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.18,
                        1.01,
                        -51.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.54,
                        0.55,
                        -46.96,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.32,
                        -0.01,
                        -68.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.34,
                        0.30,
                        -41.11,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -32.76,
                        0.40,
                        -16.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.98,
                        0.74,
                        -52.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        26.38,
                        -0.22,
                        -36.68,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.30,
                        -0.31,
                        -23.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.42,
                        0.50,
                        -34.47,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -29.63,
                        0.08,
                        -38.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.47,
                        -0.28,
                        -24.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.17,
                        0.46,
                        -35.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.09,
                        0.59,
                        -44.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.25,
                        -0.16,
                        -27.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.39,
                        0.36,
                        -36.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.21,
                        -0.39,
                        -23.24,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.11,
                        1.24,
                        -20,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.11,
                        0.35,
                        -31.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.79,
                        0.24,
                        -31.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.83,
                        0.16,
                        -39.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.11,
                        -0.33,
                        -25.3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -27.86,
                        0.31,
                        -41.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.36,
                        0.21,
                        -31.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        27.91,
                        -0.6,
                        -9.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.57,
                        1.60,
                        -42.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.73,
                        0.93,
                        -33.9,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.59,
                        0.62,
                        -34.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.92,
                        0.20,
                        -39.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.03,
                        0.39,
                        -35.94,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.16,
                        0.41,
                        -16.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.41,
                        0.20,
                        -64.68,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.06,
                        0.01,
                        -29.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.86,
                        0.26,
                        -38.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.92,
                        1.38,
                        -40.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.71,
                        -0.58,
                        -19.96,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.18,
                        0.70,
                        -35.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.29,
                        0.49,
                        -33.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        22.78,
                        0.14,
                        -37.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.53,
                        -0.28,
                        -24.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.01,
                        0.53,
                        -33.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.6,
                        0.51,
                        -18.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.22,
                        0.36,
                        -34.32,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        11.21,
                        0.34,
                        -38.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.13,
                        -0.22,
                        -26.59,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -42.94,
                        0.55,
                        -37.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        21.37,
                        -0.52,
                        -28.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.48,
                        0.67,
                        -3.83,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.32,
                        -0.34,
                        -9.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.19,
                        0.98,
                        -33.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.71,
                        0.14,
                        -58.98,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.44,
                        -0.28,
                        -23.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.12,
                        0.17,
                        -57.3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.78,
                        0.03,
                        -29.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -27.57,
                        0.21,
                        -60.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.08,
                        0.02,
                        -29.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        23.51,
                        -0.43,
                        -7.28,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.34,
                        1.04,
                        -19.85,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.02,
                        0.45,
                        -33.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.61,
                        -0.23,
                        -26.85,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.82,
                        -0.59,
                        -19.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.75,
                        0.48,
                        -45.93,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.00,
                        -0.33,
                        -25.23,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.83,
                        0.98,
                        -19.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.37,
                        -0.44,
                        -19.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.85,
                        -0.3,
                        -23.98,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.37,
                        0.53,
                        -34.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -16.05,
                        0.50,
                        -20.13,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.26,
                        1.34,
                        -6.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.73,
                        0.36,
                        -38.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.56,
                        -0.24,
                        -26.58,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.60,
                        -0.46,
                        -23.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.64,
                        0.49,
                        -34.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.02,
                        0.15,
                        -39.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.96,
                        -0.27,
                        -23.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.23,
                        0.29,
                        -41.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.82,
                        0.61,
                        -15.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.75,
                        0.38,
                        -57.77,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -42.65,
                        0.42,
                        -21.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.13,
                        0.21,
                        -39.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.46,
                        0.05,
                        -57.79,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.64,
                        0.10,
                        -39.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.75,
                        0.39,
                        -33.84,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.42,
                        0.45,
                        -36.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.51,
                        0.35,
                        -32.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -26.84,
                        0.31,
                        -57.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.64,
                        -0,
                        -27.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.39,
                        0.50,
                        -32.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.02,
                        0.37,
                        -36.69,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        28.19,
                        -0.01,
                        -37.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.46,
                        0.75,
                        -34.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        27.37,
                        -0.15,
                        -36.85,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        14.87,
                        0.70,
                        -36.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -42.26,
                        0.43,
                        -20.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.76,
                        1.31,
                        -6.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        38.40,
                        0.32,
                        -30.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -39.73,
                        0.33,
                        -17.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        30.34,
                        -0.32,
                        -10.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.03,
                        -0.13,
                        -20.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.84,
                        0.42,
                        -19.91,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.22,
                        -0.12,
                        -27.82,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.94,
                        -0.22,
                        -27.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.43,
                        1.29,
                        -18.94,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.71,
                        -0.18,
                        -30.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.46,
                        0.45,
                        -38.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -42.25,
                        0.59,
                        -19.4,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -28.29,
                        0.22,
                        -64.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.36,
                        -0.16,
                        -27.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.07,
                        0.13,
                        -57.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.62,
                        0.80,
                        -50.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        20.06,
                        0.12,
                        -29.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.62,
                        0.39,
                        -52.41,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.25,
                        0.61,
                        -45.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.65,
                        0.38,
                        -35.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.38,
                        0.39,
                        -33.82,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.62,
                        1.11,
                        -54.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.78,
                        -0.57,
                        -21.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.50,
                        0.64,
                        -32.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -20.97,
                        1.30,
                        -19.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.34,
                        0.47,
                        -35.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.2,
                        1.00,
                        -16.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.58,
                        -0.53,
                        -19.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.9,
                        1.46,
                        -19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        21.24,
                        -0.44,
                        -8.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.11,
                        1.10,
                        -49.58,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.85,
                        -0.38,
                        -16.68,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.37,
                        0.83,
                        -53.41,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -43.47,
                        0.83,
                        -19.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.75,
                        -0.02,
                        -29.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        12.80,
                        0.09,
                        -35.73,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.12,
                        -0.44,
                        -23.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.17,
                        0.56,
                        -33.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.06,
                        0.26,
                        -30.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        28.80,
                        -0.13,
                        -36.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.01,
                        0.42,
                        -32.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.92,
                        0.92,
                        -33.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.30,
                        -0.68,
                        -23.58,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        32.48,
                        -0.17,
                        -12.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00
                    ],
                    [
                        15.98,
                        -0.11,
                        -4.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        25.44,
                        -0.17,
                        -36.93,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.96,
                        -0.27,
                        -23.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.23,
                        0.40,
                        -32.56,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -40.96,
                        0.28,
                        -19.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        20.79,
                        0.37,
                        -36.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.45,
                        0.35,
                        -37.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.22,
                        0.25,
                        -38.93,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.46,
                        0.02,
                        -62.22,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -42.33,
                        0.56,
                        -19.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        29.62,
                        -0.14,
                        -36.05,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.27,
                        0.08,
                        -29.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.95,
                        -0.66,
                        -20.75,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.17,
                        0.26,
                        -39.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -37.24,
                        0.12,
                        -17.68,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.09,
                        0.42,
                        -32.4,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.87,
                        -0.24,
                        -26.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.96,
                        -0.07,
                        -69.04,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        23.14,
                        0.07,
                        -37.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.41,
                        -0.32,
                        -24.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.13,
                        0.01,
                        -29.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.37,
                        -0.36,
                        -26.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.83,
                        -0.01,
                        -28.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        36.78,
                        0.83,
                        -34.88,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.59,
                        0.35,
                        -35.58,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.81,
                        -0.58,
                        -12.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.99,
                        0.41,
                        -34.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.55,
                        0.57,
                        -33.3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.30,
                        0.42,
                        -36.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.81,
                        0.24,
                        -40.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.87,
                        1.19,
                        -43.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -40.8,
                        0.13,
                        -19.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        32.06,
                        0.16,
                        -10.24,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.56,
                        0.14,
                        -29.71,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.46,
                        0.38,
                        -35.39,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.65,
                        -0.59,
                        -23.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -27.02,
                        0.11,
                        -38.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.31,
                        0.42,
                        -30.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.67,
                        0.35,
                        -36.34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.54,
                        1.04,
                        -4.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.09,
                        -0.21,
                        -27.59,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        15.59,
                        -0.5,
                        -11.45,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.43,
                        -0.43,
                        -18.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.8,
                        0.40,
                        -37.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        34.29,
                        0.07,
                        -34,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.00,
                        -0.18,
                        -24.41,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.12,
                        -0.51,
                        -19.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.7,
                        0.24,
                        -39.75,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.39,
                        0.01,
                        -29.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        28.44,
                        -0.37,
                        -9.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -19.67,
                        0.48,
                        -32.45,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -13.29,
                        0.72,
                        -16.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.55,
                        -0.26,
                        -26.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.12,
                        -0.67,
                        -23.3,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -0.96,
                        0.38,
                        -36.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.72,
                        0.54,
                        -30.8,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -13.95,
                        1.38,
                        -15.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.8,
                        0.40,
                        -37.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.74,
                        -0.41,
                        -20.09,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.99,
                        0.37,
                        -16.89,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.07,
                        -0.22,
                        -24,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.61,
                        -0.05,
                        -29.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.28,
                        -0.41,
                        -24.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.9,
                        0.78,
                        -52.47,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.45,
                        0.99,
                        -35.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.37,
                        -0.12,
                        -28.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        12.16,
                        0.22,
                        -37.18,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.39,
                        0.69,
                        -31.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.72,
                        -0.28,
                        -27.45,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -44.86,
                        0.90,
                        -21.07,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -21.95,
                        0.19,
                        -30.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -27.5,
                        0.04,
                        -37.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -30.47,
                        0.14,
                        -39.11,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.40,
                        -0.23,
                        -23.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.78,
                        -0.04,
                        -29.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.88,
                        0.52,
                        -34.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.18,
                        1.54,
                        -41.96,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.59,
                        -0.59,
                        -21.44,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.28,
                        -0.05,
                        -30.12,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        17.69,
                        0.38,
                        -8.38,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12,
                        0.41,
                        -51.08,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.44,
                        -0.02,
                        -28.82,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.92,
                        -0.33,
                        -25.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.80,
                        -0.37,
                        -22.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.01,
                        -0.18,
                        -29.95,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.49,
                        0.24,
                        -39.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.66,
                        1.04,
                        -34.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        0.74,
                        0.43,
                        -35.11,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.63,
                        -0.5,
                        -18.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.33,
                        -0.35,
                        -25.86,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.25,
                        0.92,
                        -36.87,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.43,
                        -0.52,
                        -20.24,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.34,
                        0.53,
                        -45.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.38,
                        0.49,
                        -34.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.31,
                        0.77,
                        -37.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.60,
                        0.14,
                        -30.2,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        8.28,
                        -0.41,
                        -24.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -23.45,
                        0.99,
                        -20.57,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.89,
                        0.56,
                        -33.46,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.59,
                        0.60,
                        -47.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.98,
                        0.23,
                        -30,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        37.95,
                        0.25,
                        -30.35,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.21,
                        1.04,
                        -8.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        22.82,
                        0.03,
                        -36.79,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.14,
                        1.04,
                        -34.67,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        23.14,
                        0.07,
                        -37.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.42,
                        -0.21,
                        -23.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -12.31,
                        1.19,
                        -14.28,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -28.37,
                        0.23,
                        -62.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.82,
                        0.79,
                        -52.16,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.06,
                        -0.21,
                        -24.13,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        21.55,
                        -0.63,
                        -29.49,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.47,
                        1.08,
                        -37.73,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.75,
                        0.18,
                        -28.81,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.18,
                        1.35,
                        -16.42,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -2.66,
                        0.14,
                        -39.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.22,
                        0.54,
                        -32.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -13.05,
                        0.32,
                        -49.58,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.39,
                        0.40,
                        -29.74,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.37,
                        -0.13,
                        -27.45,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -39.62,
                        0.54,
                        -16.73,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.78,
                        0.03,
                        -57.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        38.18,
                        0.74,
                        -32.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -32.54,
                        0.18,
                        -39.22,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.2,
                        0.44,
                        -27.77,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.49,
                        0.22,
                        -39.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.05,
                        0.62,
                        -46.72,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.57,
                        0.36,
                        -47.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.11,
                        -0.76,
                        -21.65,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.6,
                        1.31,
                        -40.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.31,
                        0.85,
                        -33.21,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.33,
                        0.81,
                        -37.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        5.57,
                        0.02,
                        -28.61,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -17.74,
                        0.10,
                        -50.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -6.44,
                        0.21,
                        -73.76,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -9.81,
                        0.06,
                        -29.7,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -43.49,
                        0.65,
                        -22.22,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        21.19,
                        0.41,
                        -38.26,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.34,
                        0.50,
                        -34.18,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.49,
                        -0.33,
                        -23.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.25,
                        -0.26,
                        -15.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        38.00,
                        0.01,
                        -29.6,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.08,
                        0.03,
                        -68.37,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.31,
                        -0.1,
                        -27.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        1.95,
                        0.40,
                        -35.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -41.71,
                        0.39,
                        -38.14,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.24,
                        -0.01,
                        -28.08,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        18.26,
                        0.70,
                        -35.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.24,
                        0.63,
                        -19.48,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.57,
                        -0.26,
                        -23.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -39.51,
                        0.24,
                        -18.11,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        21.13,
                        -0.3,
                        -28.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.06,
                        0.52,
                        -56.98,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -7.54,
                        -0.31,
                        -27.33,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -3.99,
                        0.33,
                        -37.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.15,
                        0.81,
                        -37.41,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.04,
                        0.52,
                        -31.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.97,
                        -0.26,
                        -23.52,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -24.72,
                        0.45,
                        -37.4,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -42.53,
                        0.47,
                        -20.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.78,
                        -0.28,
                        -24.1,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        2.81,
                        -0.22,
                        -24.15,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.21,
                        0.04,
                        -29.27,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.33,
                        0.15,
                        -29.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.07,
                        -0.58,
                        -20.13,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.15,
                        0.83,
                        -37.31,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -14.29,
                        0.17,
                        -49.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -25.01,
                        0.29,
                        -55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        19.20,
                        -0.73,
                        -22.55,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.78,
                        0.60,
                        -48.78,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.81,
                        0.18,
                        -72.98,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.52,
                        -0.26,
                        -16.01,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.45,
                        0.59,
                        -47.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        3.33,
                        0.58,
                        -33.19,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        6.84,
                        -0.08,
                        -28.51,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        37.44,
                        0.59,
                        -32.25,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -18.41,
                        1.21,
                        -38.99,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -8.86,
                        -0.09,
                        -28.66,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -15.74,
                        0.77,
                        -18.95,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -22.53,
                        0.60,
                        -23.54,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        4.43,
                        0.15,
                        -28.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -4.17,
                        -0.19,
                        -26.94,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -10.04,
                        0.89,
                        -33.43,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -1.43,
                        0.92,
                        -52.36,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.76,
                        -0.37,
                        -24.53,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        7.55,
                        -0.38,
                        -25.92,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -5.41,
                        -0.22,
                        -27.63,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -40.19,
                        0.05,
                        -19.03,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        -11.74,
                        0.30,
                        -17.17,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00
                    ],
                    [
                        -7.98,
                        0.25,
                        -38.94,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.79,
                        0.79,
                        0.79,
                        -42.58,
                        0.50,
                        -20.84,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.46,
                        0.46,
                        0.46,
                        -20.49,
                        0.45,
                        -28.09,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        34.29,
                        0.03,
                        -33.84,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.57,
                        0.57,
                        0.57,
                        -31.01,
                        0.29,
                        -40.22,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.87,
                        0.87,
                        0.87,
                        4.46,
                        -0.19,
                        -24.32,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.94,
                        0.94,
                        0.94,
                        17.21,
                        0.52,
                        -33.28,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.60,
                        0.60,
                        0.60,
                        -5.83,
                        0.39,
                        -32.23,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.61,
                        0.61,
                        0.61,
                        4.20,
                        0.59,
                        -31.55,
                        0.03,
                        -0.71,
                        -0.03,
                        0.71,
                        0.62,
                        0.62,
                        0.62,
                        12.45,
                        0.29,
                        -37.15,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.83,
                        0.83,
                        0.83,
                        -24.63,
                        0.76,
                        -20.58,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.94,
                        0.94,
                        0.94,
                        25.26,
                        0.06,
                        -38.33,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.47,
                        0.47,
                        0.47,
                        4.34,
                        -0.17,
                        -24.52,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.73,
                        0.73,
                        0.73,
                        18.62,
                        -0.64,
                        -22.86,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.79,
                        0.79,
                        0.79,
                        5.22,
                        0.53,
                        -47.77,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.81,
                        0.81,
                        0.81,
                        -12.82,
                        0.31,
                        -49.87,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.42,
                        0.42,
                        0.42,
                        -31.21,
                        0.33,
                        -17.08,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.78,
                        0.78,
                        0.78,
                        -27.07,
                        0.17,
                        -65.87,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.88,
                        0.88,
                        0.88,
                        25.37,
                        -0.37,
                        -7.16,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.53,
                        0.53,
                        0.53,
                        8.45,
                        -0.46,
                        -24.25,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.64,
                        0.64,
                        0.64,
                        -24.83,
                        0.09,
                        -57.03,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.71,
                        0.71,
                        0.71,
                        0.89,
                        1.05,
                        -51.53,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.77,
                        0.77,
                        0.77,
                        32.04,
                        0.22,
                        -9.92,
                        0.01,
                        -0.71,
                        -0.02,
                        0.70,
                        0.64,
                        0.64,
                        0.64,
                        -3.15,
                        0.18,
                        -39.44,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.97,
                        0.97,
                        0.97,
                        -10.68,
                        0.76,
                        -32.27,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.61,
                        0.61,
                        0.61,
                        -15.5,
                        0.67,
                        -44.6,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.57,
                        0.57,
                        0.57,
                        1.02,
                        0.42,
                        -36.77,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.61,
                        0.61,
                        0.61,
                        -22.6,
                        0.69,
                        -22.64,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.43,
                        0.43,
                        0.43,
                        3.92,
                        -0.19,
                        -24.29,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.51,
                        0.51,
                        0.51,
                        28.46,
                        -0.67,
                        -10.36,
                        0.02,
                        -0.71,
                        -0.03,
                        0.70,
                        0.74,
                        0.74,
                        0.74,
                        -4.23,
                        -0.14,
                        -28.11,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.70,
                        0.70,
                        0.70,
                        8.52,
                        -0.4,
                        -24.82,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.95,
                        0.95,
                        0.95,
                        8.59,
                        -0.46,
                        -24.36,
                        0.03,
                        -0.71,
                        -0.03,
                        0.71,
                        0.47,
                        0.47,
                        0.47,
                        -2.02,
                        0.43,
                        -33.26,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.58,
                        0.58,
                        0.58,
                        -3.48,
                        0.03,
                        -68.95,
                        0.02,
                        -0.71,
                        -0.03,
                        0.70,
                        0.59,
                        0.59,
                        0.59,
                        -15.92,
                        0.71,
                        -19.3,
                        0.00,
                        -0.71,
                        -0.01,
                        0.70,
                        0.85,
                        0.85,
                        0.85,
                        -1,
                        0.11,
                        -62.48,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.66,
                        0.66,
                        0.66,
                        -9.92,
                        -0,
                        -29.01,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.59,
                        0.59,
                        0.59,
                        -8.74,
                        0.35,
                        -38.6,
                        0.01,
                        -0.71,
                        0.00,
                        0.70,
                        0.63,
                        0.63,
                        0.63,
                        40.80,
                        0.33,
                        -27.85,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.66,
                        0.66,
                        0.66,
                        -25.44,
                        0.03,
                        -65.24,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.82,
                        0.82,
                        0.82,
                        -20.1,
                        0.34,
                        -31.53,
                        0.01,
                        -0.71,
                        -0.02,
                        0.70,
                        0.75,
                        0.75,
                        0.75,
                        26.41,
                        -0.38,
                        -7.06,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.54,
                        0.54,
                        0.54,
                        -36.51,
                        0.51,
                        -16.24,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.86,
                        0.86,
                        0.86,
                        -2.66,
                        0.86,
                        -54.2,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.99,
                        0.99,
                        0.99,
                        6.99,
                        -0.24,
                        -26,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.62,
                        0.62,
                        0.62,
                        3.36,
                        0.57,
                        -57.97,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        0.93,
                        0.93,
                        0.93,
                        2.14,
                        0.44,
                        -29.94,
                        0.02,
                        -0.71,
                        -0.01,
                        0.70,
                        0.46,
                        0.46,
                        0.46,
                        -9.43,
                        0.90,
                        -36.31,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.48,
                        0.48,
                        0.48,
                        18.01,
                        0.52,
                        -7.16,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.68,
                        0.68,
                        0.68,
                        -5.79,
                        0.41,
                        -33.71,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.76,
                        0.76,
                        0.76,
                        -3.76,
                        0.15,
                        -39.92,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.49,
                        0.49,
                        0.49,
                        7.78,
                        -0.39,
                        -24.15,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.86,
                        0.86,
                        0.86,
                        16.31,
                        0.88,
                        -37.53,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.49,
                        0.49,
                        0.49,
                        2.01,
                        0.40,
                        -35.4,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.85,
                        0.85,
                        0.85,
                        -10.16,
                        1.08,
                        -36.1,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        1.00,
                        1.00,
                        1.00,
                        -1.88,
                        0.42,
                        -32.22,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        -24.61,
                        0.13,
                        -71.02,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.86,
                        0.86,
                        0.86,
                        -30.34,
                        0.30,
                        -41.21,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.96,
                        0.96,
                        0.96,
                        -9.83,
                        1.07,
                        -35.09,
                        0.03,
                        -0.71,
                        -0.03,
                        0.71,
                        0.42,
                        0.42,
                        0.42,
                        15.93,
                        0.86,
                        -37.08,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.76,
                        0.76,
                        0.76,
                        -9.04,
                        0.97,
                        -34.1,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        0.04,
                        1.12,
                        -49.61,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.64,
                        0.64,
                        0.64,
                        4.34,
                        0.27,
                        -29.56,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.78,
                        0.78,
                        0.78,
                        -8.9,
                        0.38,
                        -38.47,
                        0.00,
                        -0.71,
                        -0.01,
                        0.70,
                        0.96,
                        0.96,
                        0.96,
                        2.26,
                        0.93,
                        -55.46,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.87,
                        0.87,
                        0.87,
                        -19.96,
                        1.05,
                        -38.65,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.63,
                        0.63,
                        0.63,
                        -26.63,
                        0.24,
                        -38.93,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.94,
                        0.94,
                        0.94,
                        -0.66,
                        1.18,
                        -49.79,
                        0.00,
                        -0.71,
                        -0.01,
                        0.70,
                        0.95,
                        0.95,
                        0.95,
                        -17.29,
                        1.52,
                        -42.99,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.42,
                        0.42,
                        0.42,
                        6.73,
                        -0.05,
                        -29.06,
                        0.02,
                        -0.71,
                        -0.03,
                        0.70,
                        0.94,
                        0.94,
                        0.94,
                        38.78,
                        0.64,
                        -30.81,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.92,
                        0.92,
                        0.92,
                        8.17,
                        -0.14,
                        -27.22,
                        0.02,
                        -0.7,
                        -0.01,
                        0.71,
                        0.80,
                        0.80,
                        0.80,
                        5.94,
                        -0.19,
                        -5.32,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.76,
                        0.76,
                        0.76,
                        -10.33,
                        -0.02,
                        -27.31,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.97,
                        0.97,
                        0.97,
                        -18.5,
                        1.58,
                        -42.94,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.85,
                        0.85,
                        0.85,
                        -14.57,
                        0.77,
                        -44.37,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        0.64,
                        0.64,
                        0.64,
                        1.43,
                        -0.36,
                        -23.51,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.72,
                        0.72,
                        0.72,
                        -9.54,
                        0.79,
                        -36.88,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.50,
                        0.50,
                        0.50,
                        -8.81,
                        0.79,
                        -35.74,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.51,
                        0.51,
                        0.51,
                        14.74,
                        0.50,
                        -35.33,
                        0.00,
                        -0.71,
                        -0.01,
                        0.70,
                        0.77,
                        0.77,
                        0.77,
                        -23.78,
                        0.92,
                        -20.44,
                        0.02,
                        -0.7,
                        -0.01,
                        0.71,
                        0.52,
                        0.52,
                        0.52,
                        3.31,
                        0.50,
                        -34.05,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        0.83,
                        -0.57,
                        -21.24,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.85,
                        0.85,
                        0.85,
                        3.11,
                        0.63,
                        -32.54,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.68,
                        0.68,
                        0.68,
                        2.73,
                        0.41,
                        -28.85,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.96,
                        0.96,
                        0.96,
                        -17.86,
                        1.53,
                        -41.78,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.43,
                        0.43,
                        0.43,
                        8.41,
                        -0.36,
                        -25.16,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.94,
                        0.94,
                        0.94,
                        -2.68,
                        0.40,
                        -32.29,
                        0.02,
                        -0.71,
                        -0.03,
                        0.70,
                        0.53,
                        0.53,
                        0.53,
                        8.32,
                        -0.44,
                        -22.81,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.45,
                        0.45,
                        0.45,
                        30.98,
                        0.19,
                        -8.74,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.93,
                        0.93,
                        0.93,
                        -10.04,
                        -0.03,
                        -27.26,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.68,
                        0.68,
                        0.68,
                        2.10,
                        -0.47,
                        -19.95,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        -4.83,
                        0.36,
                        -35.55,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.48,
                        0.48,
                        0.48,
                        4.81,
                        -0.16,
                        -24.54,
                        -0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.43,
                        0.43,
                        0.43,
                        -30.53,
                        0.22,
                        -39.73,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.79,
                        0.79,
                        0.79,
                        6.01,
                        -0.01,
                        -28.5,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        -2.19,
                        0.14,
                        -56.96,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        21.23,
                        -0.47,
                        -8.86,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.50,
                        0.50,
                        0.50,
                        -9.11,
                        1.45,
                        -7.33,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.98,
                        0.98,
                        0.98,
                        19.26,
                        0.71,
                        -37.4,
                        0.00,
                        -0.71,
                        -0.01,
                        0.70,
                        0.73,
                        0.73,
                        0.73,
                        -2.15,
                        0.73,
                        -52.77,
                        0.01,
                        -0.71,
                        -0.02,
                        0.70,
                        0.66,
                        0.66,
                        0.66,
                        16.84,
                        0.08,
                        -32.09,
                        0.02,
                        -0.71,
                        -0.03,
                        0.71,
                        0.48,
                        0.48,
                        0.48,
                        18.27,
                        0.75,
                        -36.51,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        -11.4,
                        0.61,
                        -3.8,
                        0.00,
                        -0.71,
                        0.00,
                        0.70,
                        0.71,
                        0.71,
                        0.71,
                        8.19,
                        -0.21,
                        -26.59,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.90,
                        0.90,
                        0.90,
                        7.70,
                        -0.38,
                        -25.79,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.64,
                        0.64,
                        0.64,
                        2.62,
                        -0.25,
                        -24.05,
                        0.03,
                        -0.71,
                        -0.02,
                        0.70,
                        0.53,
                        0.53,
                        0.53,
                        -3.04,
                        0.12,
                        -39.94,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.94,
                        0.94,
                        0.94,
                        -19.31,
                        1.10,
                        -21.14,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.86,
                        0.86,
                        0.86,
                        -10.44,
                        -0.01,
                        -27.87,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.46,
                        0.46,
                        0.46,
                        -42.65,
                        0.40,
                        -21.59,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.93,
                        0.93,
                        0.93,
                        -10.34,
                        0.90,
                        -33.64,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.62,
                        0.62,
                        0.62,
                        0.31,
                        0.44,
                        -36.82,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.99,
                        0.99,
                        0.99,
                        17.47,
                        0.83,
                        -37.07,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.81,
                        0.81,
                        0.81,
                        37.28,
                        0.82,
                        -33.58,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        2.80,
                        0.42,
                        -28.94,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.59,
                        0.59,
                        0.59,
                        18.80,
                        0.37,
                        -30.86,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.93,
                        0.93,
                        0.93,
                        6.29,
                        -0.08,
                        -27.54,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.44,
                        0.44,
                        0.44,
                        -20.35,
                        0.79,
                        -36.12,
                        0.00,
                        -0.71,
                        0.01,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        -0.85,
                        1.20,
                        -53.73,
                        0.03,
                        -0.71,
                        -0.02,
                        0.70,
                        0.67,
                        0.67,
                        0.67,
                        -14.73,
                        0.06,
                        -49.82,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.43,
                        0.43,
                        0.43,
                        4.17,
                        -0.16,
                        -24.57,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.46,
                        0.46,
                        0.46,
                        -25.49,
                        0.15,
                        -69.51,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.97,
                        0.97,
                        0.97,
                        17.60,
                        0.74,
                        -34.77,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.84,
                        0.84,
                        0.84,
                        1.40,
                        -0.52,
                        -18.27,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.97,
                        0.97,
                        0.97,
                        1.05,
                        -0.55,
                        -19.63,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.47,
                        0.47,
                        0.47,
                        6.37,
                        -0.11,
                        -26.97,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.80,
                        0.80,
                        0.80,
                        -27.91,
                        0.03,
                        -37.92,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.91,
                        0.91,
                        0.91,
                        -4.09,
                        -0.2,
                        -26.61,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.59,
                        0.59,
                        0.59,
                        -25.2,
                        0.10,
                        -59.55,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.94,
                        0.94,
                        0.94,
                        -5.24,
                        0.04,
                        -71.08,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.87,
                        0.87,
                        0.87,
                        33.87,
                        0.44,
                        -35.96,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.80,
                        0.80,
                        0.80,
                        34.84,
                        0.09,
                        -33.52,
                        0.02,
                        -0.71,
                        -0.01,
                        0.70,
                        0.74,
                        0.74,
                        0.74,
                        -5.71,
                        0.74,
                        -8.11,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        -40.46,
                        0.26,
                        -18.7,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.60,
                        0.60,
                        0.60,
                        5.93,
                        -0.31,
                        -20.64,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.44,
                        0.44,
                        0.44,
                        -15.82,
                        0.46,
                        -46.21,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.76,
                        0.76,
                        0.76,
                        7.82,
                        0.68,
                        -43.64,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.97,
                        0.97,
                        0.97,
                        -15.4,
                        0.37,
                        -46.84,
                        0.03,
                        -0.71,
                        -0.02,
                        0.70,
                        0.57,
                        0.57,
                        0.57,
                        -20.75,
                        -0,
                        -52.6,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        4.71,
                        0.21,
                        -29.63,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.96,
                        0.96,
                        0.96,
                        -14.2,
                        0.59,
                        -45.76,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.92,
                        0.92,
                        0.92,
                        -11.45,
                        0.97,
                        -34.97,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.60,
                        0.60,
                        0.60,
                        12.69,
                        0.57,
                        -38.34,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.97,
                        0.97,
                        0.97,
                        -10.94,
                        0.92,
                        -33.63,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.67,
                        0.67,
                        0.67,
                        15.03,
                        -0.35,
                        -8.9,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.87,
                        0.87,
                        0.87,
                        -16.95,
                        1.03,
                        -19.44,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.52,
                        0.52,
                        0.52,
                        -20.49,
                        0.16,
                        -51.36,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.78,
                        0.78,
                        0.78,
                        -18.12,
                        0.95,
                        -20.7,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.82,
                        0.82,
                        0.82,
                        15.86,
                        -0.07,
                        -32.43,
                        0.02,
                        -0.7,
                        -0.01,
                        0.71,
                        0.67,
                        0.67,
                        0.67,
                        -3.02,
                        0.29,
                        -31.61,
                        0.02,
                        -0.71,
                        -0.03,
                        0.71,
                        0.54,
                        0.54,
                        0.54,
                        2.45,
                        0.62,
                        -32.74,
                        0.00,
                        -0.71,
                        0.00,
                        0.70,
                        0.74,
                        0.74,
                        0.74,
                        1.71,
                        -0.39,
                        -23.12,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.89,
                        0.89,
                        0.89,
                        -6.26,
                        0.26,
                        -39.62,
                        0.03,
                        -0.71,
                        -0.03,
                        0.71,
                        0.83,
                        0.83,
                        0.83,
                        -15.95,
                        1.14,
                        -43.48,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.63,
                        0.63,
                        0.63,
                        16.50,
                        -0.57,
                        -14.46,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.47,
                        0.47,
                        0.47,
                        1.86,
                        0.54,
                        -33.96,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.50,
                        0.50,
                        0.50,
                        -15.95,
                        1.14,
                        -43.48,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.49,
                        0.49,
                        0.49,
                        7.64,
                        -0.35,
                        -24.49,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        0.57,
                        0.44,
                        -36.67,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.94,
                        0.94,
                        0.94,
                        -5.71,
                        0.41,
                        -33.89,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.62,
                        0.62,
                        0.62,
                        18.81,
                        0.09,
                        -29.67,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.56,
                        0.56,
                        0.56,
                        -0.73,
                        0.09,
                        -63.4,
                        0.03,
                        -0.7,
                        -0.02,
                        0.71,
                        0.67,
                        0.67,
                        0.67,
                        -0.09,
                        0.15,
                        -62.79,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.56,
                        0.56,
                        0.56,
                        -2.69,
                        0.04,
                        -68.61,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.66,
                        0.66,
                        0.66,
                        1.27,
                        0.42,
                        -36.09,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.63,
                        0.63,
                        0.63,
                        8.01,
                        -0.28,
                        -26.23,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.94,
                        0.94,
                        0.94,
                        -10.63,
                        0.01,
                        -28.45,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.46,
                        0.46,
                        0.46,
                        17.24,
                        0.20,
                        -32.03,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.68,
                        0.68,
                        0.68,
                        3.03,
                        -0.19,
                        -24.33,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.45,
                        0.45,
                        0.45,
                        19.47,
                        -0.54,
                        -18.23,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.93,
                        0.93,
                        0.93,
                        1.49,
                        0.49,
                        -34.77,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.76,
                        0.76,
                        0.76,
                        -9.71,
                        1.07,
                        -35.14,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.50,
                        0.50,
                        0.50,
                        -15.78,
                        -0.04,
                        -50.42,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        14.19,
                        0.55,
                        -35.98,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.83,
                        0.83,
                        0.83,
                        -2.33,
                        0.39,
                        -31.93,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.96,
                        0.96,
                        0.96,
                        -24.38,
                        0.25,
                        -54.4,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.78,
                        0.78,
                        0.78,
                        1.53,
                        0.49,
                        -34.74,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.67,
                        0.67,
                        0.67,
                        -27.14,
                        0.20,
                        -60.21,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.62,
                        0.62,
                        0.62,
                        5.63,
                        -0.01,
                        -27.72,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.83,
                        0.83,
                        0.83,
                        5.30,
                        0.13,
                        -29.9,
                        0.03,
                        -0.71,
                        -0.02,
                        0.70,
                        0.58,
                        0.58,
                        0.58,
                        6.65,
                        -0.12,
                        -27.33,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.52,
                        0.52,
                        0.52,
                        -20.09,
                        0.65,
                        -34.75,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.64,
                        0.64,
                        0.64,
                        -19.53,
                        0.74,
                        -34.81,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.88,
                        0.88,
                        0.88,
                        -23.57,
                        0.71,
                        -37.93,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.73,
                        0.73,
                        0.73,
                        -28.73,
                        0.07,
                        -18.02,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.73,
                        0.73,
                        0.73,
                        8.17,
                        -0.45,
                        -23.91,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.64,
                        0.64,
                        0.64,
                        -38.56,
                        0.32,
                        -17.41,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.96,
                        0.96,
                        0.96,
                        -9.64,
                        -0.04,
                        -27.68,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.75,
                        0.75,
                        0.75,
                        -10.49,
                        1.01,
                        -36.65,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.70,
                        0.70,
                        0.70,
                        32.94,
                        0.12,
                        -11.6,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.49,
                        0.49,
                        0.49,
                        -1.31,
                        0.92,
                        -55.31,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.62,
                        0.62,
                        0.62,
                        -40.23,
                        0.56,
                        -17.06,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.92,
                        0.92,
                        0.92,
                        18.33,
                        0.65,
                        -33.99,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.44,
                        0.44,
                        0.44,
                        -27.36,
                        0.20,
                        -70.43,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.80,
                        0.80,
                        0.80,
                        19.14,
                        -0.48,
                        -19,
                        0.00,
                        -0.71,
                        -0.01,
                        0.70,
                        0.82,
                        0.82,
                        0.82,
                        6.05,
                        -0.2,
                        -3.08,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.67,
                        0.67,
                        0.67,
                        7.90,
                        -0.36,
                        -24.92,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.65,
                        0.65,
                        0.65,
                        -15.3,
                        0.50,
                        -45.47,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.56,
                        0.56,
                        0.56,
                        -8.36,
                        0.28,
                        -38.94,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.49,
                        0.49,
                        0.49,
                        -10.62,
                        0.02,
                        -28.74,
                        0.03,
                        -0.71,
                        -0.03,
                        0.71,
                        0.58,
                        0.58,
                        0.58,
                        6.45,
                        0.68,
                        -43.86,
                        0.00,
                        -0.71,
                        0.00,
                        0.70,
                        0.52,
                        0.52,
                        0.52,
                        -24.36,
                        0.04,
                        -69.51,
                        0.01,
                        -0.71,
                        -0.02,
                        0.70,
                        0.52,
                        0.52,
                        0.52,
                        -10.42,
                        -0.01,
                        -27.82,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.54,
                        0.54,
                        0.54,
                        0.79,
                        0.33,
                        -29.15,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.44,
                        0.44,
                        0.44,
                        1.12,
                        -0.55,
                        -20.62,
                        0.02,
                        -0.71,
                        -0.03,
                        0.70,
                        0.53,
                        0.53,
                        0.53,
                        -0.34,
                        0.24,
                        -57.51,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.87,
                        0.87,
                        0.87,
                        8.59,
                        -0.48,
                        -24.07,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.45,
                        0.45,
                        0.45,
                        -10.16,
                        0.90,
                        -36.95,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.47,
                        0.47,
                        0.47,
                        -5.51,
                        0.33,
                        -37.86,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.71,
                        0.71,
                        0.71,
                        23.60,
                        0.21,
                        -38.97,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.92,
                        0.92,
                        0.92,
                        -1.83,
                        0.40,
                        -33.7,
                        0.02,
                        -0.71,
                        -0.03,
                        0.71,
                        0.79,
                        0.79,
                        0.79,
                        -9.1,
                        -0.16,
                        -27.14,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.79,
                        0.79,
                        0.79,
                        19.17,
                        0.61,
                        -35.35,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.45,
                        0.45,
                        0.45,
                        10.68,
                        -0,
                        -37.18,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        8.65,
                        -0.22,
                        -26.34,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.92,
                        0.92,
                        0.92,
                        8.92,
                        -0.25,
                        -25.76,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.92,
                        0.92,
                        0.92,
                        -36.4,
                        0.27,
                        -39.73,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.56,
                        0.56,
                        0.56,
                        6.17,
                        0.08,
                        -29.96,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.63,
                        0.63,
                        0.63,
                        -0.99,
                        0.06,
                        -66.78,
                        0.01,
                        -0.71,
                        0.00,
                        0.70,
                        0.49,
                        0.49,
                        0.49,
                        -7.32,
                        -0.34,
                        -27.22,
                        0.03,
                        -0.71,
                        -0.02,
                        0.70,
                        0.93,
                        0.93,
                        0.93,
                        -9.7,
                        0.15,
                        -30.18,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.75,
                        0.75,
                        0.75,
                        20.39,
                        0.36,
                        -34.97,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.85,
                        0.85,
                        0.85,
                        -25.93,
                        0.46,
                        -18.82,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.50,
                        0.50,
                        0.50,
                        6.19,
                        -0.04,
                        -28.09,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.51,
                        0.51,
                        0.51,
                        -21.12,
                        0.40,
                        -32.71,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.66,
                        0.66,
                        0.66,
                        7.42,
                        -0.07,
                        -28.03,
                        0.02,
                        -0.71,
                        -0.03,
                        0.70,
                        0.96,
                        0.96,
                        0.96,
                        -13.13,
                        0.47,
                        -48.44,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.64,
                        0.64,
                        0.64,
                        -6.27,
                        -0.08,
                        -71.38,
                        0.01,
                        -0.71,
                        -0.02,
                        0.70,
                        0.98,
                        0.98,
                        0.98,
                        5.04,
                        0.09,
                        -29.19,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.73,
                        0.73,
                        0.73,
                        -25.71,
                        0.16,
                        -69.9,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.46,
                        0.46,
                        0.46,
                        -11.75,
                        0.82,
                        -32.59,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.71,
                        0.71,
                        0.71,
                        -19.5,
                        1.40,
                        -41.19,
                        0.03,
                        -0.71,
                        -0.02,
                        0.70,
                        0.93,
                        0.93,
                        0.93,
                        -37.08,
                        0.19,
                        -39.24,
                        0.02,
                        -0.7,
                        -0.01,
                        0.71,
                        0.72,
                        0.72,
                        0.72,
                        -15.04,
                        0.11,
                        -49.46,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.52,
                        0.52,
                        0.52,
                        -25.23,
                        0.01,
                        -61.2,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.48,
                        0.48,
                        0.48,
                        3.06,
                        0.66,
                        -32.11,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.86,
                        0.86,
                        0.86,
                        -23.67,
                        0.79,
                        -21.98,
                        0.00,
                        -0.71,
                        -0.01,
                        0.70,
                        0.89,
                        0.89,
                        0.89,
                        -10.16,
                        0.03,
                        -29.18,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        0.93,
                        0.93,
                        0.93,
                        -0.52,
                        0.42,
                        -33.41,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.43,
                        0.43,
                        0.43,
                        -8.02,
                        0.35,
                        -37.6,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.68,
                        0.68,
                        0.68,
                        3.14,
                        -0.26,
                        -23.57,
                        0.01,
                        -0.71,
                        0.00,
                        0.70,
                        0.66,
                        0.66,
                        0.66,
                        4.18,
                        -0.15,
                        -24.63,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.57,
                        0.57,
                        0.57,
                        -20.06,
                        0.52,
                        -33.31,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.44,
                        0.44,
                        0.44,
                        4.94,
                        -0.21,
                        -23.96,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.84,
                        0.84,
                        0.84,
                        7.88,
                        -0.43,
                        -23.07,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.57,
                        0.57,
                        0.57,
                        -16.77,
                        1.31,
                        -40.69,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.97,
                        0.97,
                        0.97,
                        -22.21,
                        0.72,
                        -22.46,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.65,
                        0.65,
                        0.65,
                        -19.74,
                        1.43,
                        -20.64,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.61,
                        0.61,
                        0.61,
                        19.11,
                        -0.76,
                        -21.65,
                        0.00,
                        -0.71,
                        0.00,
                        0.70,
                        0.96,
                        0.96,
                        0.96,
                        34.95,
                        0.62,
                        -35.63,
                        0.01,
                        -0.71,
                        -0.02,
                        0.70,
                        0.98,
                        0.98,
                        0.98,
                        3.75,
                        0.61,
                        -32.72,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.46,
                        0.46,
                        0.46,
                        -6.07,
                        0.42,
                        -32.78,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.59,
                        0.59,
                        0.59,
                        1.98,
                        0.52,
                        -34.36,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.79,
                        0.79,
                        0.79,
                        33.28,
                        0.32,
                        -11.24,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        0.50,
                        0.50,
                        0.50,
                        19.39,
                        -0.77,
                        -21.62,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.88,
                        0.88,
                        0.88,
                        -4.17,
                        0.35,
                        -36.1,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.85,
                        0.85,
                        0.85,
                        -38.86,
                        0.49,
                        -16.69,
                        0.03,
                        -0.71,
                        -0.03,
                        0.71,
                        0.86,
                        0.86,
                        0.86,
                        8.21,
                        -0.41,
                        -24.65,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.50,
                        0.50,
                        0.50,
                        -10.3,
                        1.11,
                        -35.96,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.42,
                        0.42,
                        0.42,
                        16.25,
                        -0.17,
                        -10.47,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.92,
                        0.92,
                        0.92,
                        3.93,
                        -0.28,
                        -15.54,
                        0.03,
                        -0.71,
                        -0.03,
                        0.71,
                        0.57,
                        0.57,
                        0.57,
                        4.76,
                        -0.32,
                        -19.85,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.55,
                        0.55,
                        0.55,
                        -3.74,
                        0.18,
                        -72.22,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.84,
                        0.84,
                        0.84,
                        -10.63,
                        0.93,
                        -37.1,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.74,
                        0.74,
                        0.74,
                        -1.53,
                        0.97,
                        -50.03,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.62,
                        0.62,
                        0.62,
                        -23.17,
                        0.49,
                        -35.07,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.70,
                        0.70,
                        0.70,
                        6.29,
                        0.04,
                        -29.72,
                        0.02,
                        -0.71,
                        -0.03,
                        0.71,
                        0.51,
                        0.51,
                        0.51,
                        36.46,
                        0.40,
                        -32.6,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.92,
                        0.92,
                        0.92,
                        -19.25,
                        0.57,
                        -32.78,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.71,
                        0.71,
                        0.71,
                        8.71,
                        -0.23,
                        -26.25,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.53,
                        0.53,
                        0.53,
                        -3.99,
                        -0.29,
                        -24.55,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.81,
                        0.81,
                        0.81,
                        -2.23,
                        0.41,
                        -33.55,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.85,
                        0.85,
                        0.85,
                        -1.78,
                        0.03,
                        -57.61,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.82,
                        0.82,
                        0.82,
                        -18.71,
                        1.49,
                        -18.95,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.67,
                        0.67,
                        0.67,
                        -5.54,
                        0.38,
                        -35.53,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.70,
                        0.70,
                        0.70,
                        15.69,
                        -0.23,
                        -4.37,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.51,
                        0.51,
                        0.51,
                        -22.44,
                        0.39,
                        -28.26,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.64,
                        0.64,
                        0.64,
                        3.23,
                        0.57,
                        -33.44,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.74,
                        0.74,
                        0.74,
                        18.36,
                        0.61,
                        -32.99,
                        0.01,
                        -0.71,
                        -0.02,
                        0.70,
                        0.68,
                        0.68,
                        0.68,
                        8.36,
                        -0.28,
                        -25.82,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.47,
                        0.47,
                        0.47,
                        14.11,
                        0.33,
                        -35.26,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.95,
                        0.95,
                        0.95,
                        1.31,
                        -0.42,
                        -23.18,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.81,
                        0.81,
                        0.81,
                        -13.16,
                        0.48,
                        -17.61,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.65,
                        0.65,
                        0.65,
                        -10.53,
                        0.01,
                        -28.52,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.94,
                        0.94,
                        0.94,
                        -4.74,
                        0.42,
                        -33.98,
                        0.00,
                        -0.71,
                        0.00,
                        0.70,
                        0.69,
                        0.69,
                        0.69,
                        6.08,
                        0.08,
                        -29.8,
                        0.03,
                        -0.71,
                        -0.02,
                        0.70,
                        0.42,
                        0.42,
                        0.42,
                        30.87,
                        -0.55,
                        -11.3,
                        0.01,
                        -0.71,
                        -0.02,
                        0.70,
                        0.65,
                        0.65,
                        0.65,
                        -13.98,
                        0.59,
                        -46.24,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.56,
                        0.56,
                        0.56,
                        2.82,
                        -0.24,
                        -23.99,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.42,
                        0.42,
                        0.42,
                        -19.95,
                        1.10,
                        -39.15,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.53,
                        0.53,
                        0.53,
                        -18.47,
                        1.36,
                        -40.4,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.43,
                        0.43,
                        0.43,
                        -40.29,
                        0.32,
                        -39.01,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.47,
                        0.47,
                        0.47,
                        4.64,
                        0.13,
                        -28.38,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.80,
                        0.80,
                        0.80,
                        -26.26,
                        0.33,
                        -56.52,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.64,
                        0.64,
                        0.64,
                        18.33,
                        0.68,
                        -35.14,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.85,
                        0.85,
                        0.85,
                        0.59,
                        -0.59,
                        -21.44,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.44,
                        0.44,
                        0.44,
                        2.75,
                        0.37,
                        -35.31,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.83,
                        0.83,
                        0.83,
                        2.48,
                        0.53,
                        -34.08,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.62,
                        0.62,
                        0.62,
                        -21.86,
                        0.41,
                        -27.24,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.95,
                        0.95,
                        0.95,
                        2.52,
                        0.60,
                        -33.11,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.56,
                        0.56,
                        0.56,
                        -31.4,
                        0.56,
                        -16.04,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.59,
                        0.59,
                        0.59,
                        -19.16,
                        1.14,
                        -38.88,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.78,
                        0.78,
                        0.78,
                        4.13,
                        0.31,
                        -29.48,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.97,
                        0.97,
                        0.97,
                        -8.5,
                        0.25,
                        -39.55,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.97,
                        0.97,
                        0.97,
                        4.73,
                        -0.2,
                        -13.82,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.54,
                        0.54,
                        0.54,
                        4.64,
                        0.13,
                        -28.38,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.76,
                        0.76,
                        0.76,
                        20.32,
                        0.18,
                        -30.54,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.98,
                        0.98,
                        0.98,
                        -19.44,
                        0.66,
                        -33.82,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.47,
                        0.47,
                        0.47,
                        4.30,
                        0.35,
                        -30.01,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.42,
                        0.42,
                        0.42,
                        -3,
                        0.12,
                        -39.86,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.88,
                        0.88,
                        0.88,
                        -27.71,
                        0.19,
                        -67.24,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.92,
                        0.92,
                        0.92,
                        -1.45,
                        0.17,
                        -39.01,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.65,
                        0.65,
                        0.65,
                        3.78,
                        0.62,
                        -32.53,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.92,
                        0.92,
                        0.92,
                        5.40,
                        -0.07,
                        -12.35,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.70,
                        0.70,
                        0.70,
                        -13.09,
                        0.64,
                        -47.1,
                        0.03,
                        -0.71,
                        -0.02,
                        0.70,
                        0.66,
                        0.66,
                        0.66,
                        28.89,
                        -0.06,
                        -36.71,
                        0.02,
                        -0.7,
                        -0.01,
                        0.71,
                        0.69,
                        0.69,
                        0.69,
                        -10.16,
                        -0.01,
                        -28.26,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.66,
                        0.66,
                        0.66,
                        38.35,
                        0.59,
                        -31.12,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.69,
                        0.69,
                        0.69,
                        4.56,
                        -0.18,
                        -24.4,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.76,
                        0.76,
                        0.76,
                        36.81,
                        0.67,
                        -33.43,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.93,
                        0.93,
                        0.93,
                        6.59,
                        -0.19,
                        -5.37,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.67,
                        0.67,
                        0.67,
                        -23.38,
                        0.06,
                        -31,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.78,
                        0.78,
                        0.78,
                        -17.11,
                        1.34,
                        -18.25,
                        0.03,
                        -0.71,
                        -0.02,
                        0.70,
                        0.83,
                        0.83,
                        0.83,
                        -2.33,
                        0.41,
                        -32.53,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.60,
                        0.60,
                        0.60,
                        -30.59,
                        0.29,
                        -17.18,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.54,
                        0.54,
                        0.54,
                        -10.93,
                        0.48,
                        -30.45,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.66,
                        0.66,
                        0.66,
                        -16.39,
                        1.51,
                        -16.81,
                        0.00,
                        -0.71,
                        0.00,
                        0.70,
                        0.53,
                        0.53,
                        0.53,
                        -7.23,
                        0.25,
                        -38.71,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.63,
                        0.63,
                        0.63,
                        31.27,
                        0.16,
                        -36.25,
                        0.02,
                        -0.7,
                        -0.01,
                        0.71,
                        0.84,
                        0.84,
                        0.84,
                        3.17,
                        -0.25,
                        -23.74,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.50,
                        0.50,
                        0.50,
                        -10.74,
                        0.00,
                        -27.71,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.64,
                        0.64,
                        0.64,
                        -25.43,
                        0.53,
                        -20.24,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        -8.31,
                        0.53,
                        -36.51,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        1.00,
                        1.00,
                        1.00,
                        2.15,
                        -0.45,
                        -17.97,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.48,
                        0.48,
                        0.48,
                        -43.16,
                        0.60,
                        -21.64,
                        0.02,
                        -0.71,
                        -0.01,
                        0.70,
                        0.70,
                        0.70,
                        0.70,
                        1.52,
                        0.51,
                        -34.25,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.69,
                        0.69,
                        0.69,
                        -4.67,
                        0.35,
                        -36.34,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.96,
                        0.96,
                        0.96,
                        13.54,
                        -0.58,
                        -11.86,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.66,
                        0.66,
                        0.66,
                        -0.77,
                        1.11,
                        -53.16,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.78,
                        0.78,
                        0.78,
                        -1.32,
                        0.11,
                        -61.98,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.97,
                        0.97,
                        0.97,
                        8.23,
                        -0.16,
                        -27.77,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.83,
                        0.83,
                        0.83,
                        3.92,
                        -0.28,
                        -15.37,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.53,
                        0.53,
                        0.53,
                        -2.95,
                        -0.14,
                        -26.09,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        -15.41,
                        0.94,
                        -43.51,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.67,
                        0.67,
                        0.67,
                        -22.79,
                        0.40,
                        -27.45,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.94,
                        0.94,
                        0.94,
                        -8.92,
                        0.09,
                        -30.22,
                        0.03,
                        -0.7,
                        -0.02,
                        0.71,
                        0.89,
                        0.89,
                        0.89,
                        2.32,
                        0.38,
                        -35.89,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        0.43,
                        0.43,
                        0.43,
                        -11.73,
                        0.85,
                        -32.88,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.68,
                        0.68,
                        0.68,
                        -20.62,
                        0.18,
                        -51.27,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.76,
                        0.76,
                        0.76,
                        -13.52,
                        0.67,
                        -46.15,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        0.70,
                        0.70,
                        0.70,
                        -41.67,
                        0.05,
                        -20.74,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.55,
                        0.55,
                        0.55,
                        1.68,
                        0.42,
                        -35.48,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.95,
                        0.95,
                        0.95,
                        -12.36,
                        0.27,
                        -51.59,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.86,
                        0.86,
                        0.86,
                        29.13,
                        -0.12,
                        -36.4,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.69,
                        0.69,
                        0.69,
                        -11.21,
                        0.63,
                        -3.45,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.97,
                        0.97,
                        0.97,
                        8.84,
                        -0.24,
                        -26.06,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.74,
                        0.74,
                        0.74,
                        -1.73,
                        0.35,
                        -34.41,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        6.83,
                        -0.24,
                        -4.31,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.97,
                        0.97,
                        0.97,
                        -11.66,
                        0.95,
                        -33.85,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.63,
                        0.63,
                        0.63,
                        4.30,
                        0.35,
                        -30.01,
                        0.01,
                        -0.71,
                        0.00,
                        0.70,
                        0.98,
                        0.98,
                        0.98,
                        -9.78,
                        -0.01,
                        -28.77,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.66,
                        0.66,
                        0.66,
                        -14.59,
                        0.38,
                        -46.93,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.60,
                        0.60,
                        0.60,
                        6.67,
                        -0.06,
                        -28.89,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.95,
                        0.95,
                        0.95,
                        -24.57,
                        0.01,
                        -68.53,
                        0.03,
                        -0.71,
                        -0.03,
                        0.71,
                        0.63,
                        0.63,
                        0.63,
                        0.72,
                        -0.58,
                        -20.33,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.47,
                        0.47,
                        0.47,
                        -20.4,
                        0.43,
                        -50.05,
                        0.00,
                        -0.7,
                        0.01,
                        0.71,
                        0.81,
                        0.81,
                        0.81,
                        -18.02,
                        1.21,
                        -39.53,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.55,
                        0.55,
                        0.55,
                        -1.01,
                        1.09,
                        -51.65,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.43,
                        0.43,
                        0.43,
                        -21.34,
                        0.45,
                        -28.17,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.88,
                        0.88,
                        0.88,
                        17.19,
                        0.66,
                        -34.38,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.98,
                        0.98,
                        0.98,
                        -0.45,
                        -0.43,
                        -22.94,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.87,
                        0.87,
                        0.87,
                        2.08,
                        0.49,
                        -30.71,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.78,
                        0.78,
                        0.78,
                        5.96,
                        -0.2,
                        -1.67,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.93,
                        0.93,
                        0.93,
                        8.25,
                        -0.35,
                        -25.14,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.47,
                        0.47,
                        0.47,
                        -19.87,
                        0.44,
                        -32.23,
                        0.01,
                        -0.71,
                        -0.02,
                        0.70,
                        0.64,
                        0.64,
                        0.64,
                        19.93,
                        0.34,
                        -31.06,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.92,
                        0.92,
                        0.92,
                        -9.97,
                        0.85,
                        -2.35,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.89,
                        0.89,
                        0.89,
                        5.96,
                        0.04,
                        -29.2,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.95,
                        0.95,
                        0.95,
                        -4.37,
                        0.13,
                        -40.44,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.80,
                        0.80,
                        0.80,
                        -18.98,
                        0.95,
                        -36.85,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.97,
                        0.97,
                        0.97,
                        -1.75,
                        0.42,
                        -33.26,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.71,
                        0.71,
                        0.71,
                        -12.19,
                        0.35,
                        -50.06,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.65,
                        0.65,
                        0.65,
                        21.18,
                        -0.35,
                        -29.12,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.50,
                        0.50,
                        0.50,
                        -2.81,
                        -0.09,
                        -27.25,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.80,
                        0.80,
                        0.80,
                        6.68,
                        -0.16,
                        -26.36,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.99,
                        0.99,
                        0.99,
                        12.15,
                        0.09,
                        -36.38,
                        0.03,
                        -0.7,
                        -0.02,
                        0.71,
                        0.93,
                        0.93,
                        0.93,
                        7.41,
                        -0.36,
                        -21.18,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.75,
                        0.75,
                        0.75,
                        19.44,
                        0.68,
                        -37.47,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.78,
                        0.78,
                        0.78,
                        -1.9,
                        -0.4,
                        -22.99,
                        0.01,
                        -0.71,
                        0.00,
                        0.70,
                        0.90,
                        0.90,
                        0.90,
                        -0.75,
                        0.08,
                        -62.02,
                        0.01,
                        -0.71,
                        0.00,
                        0.70,
                        0.77,
                        0.77,
                        0.77,
                        1.38,
                        0.46,
                        -35.31,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.87,
                        0.87,
                        0.87,
                        -2.75,
                        -0.09,
                        -27.18,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.92,
                        0.92,
                        0.92,
                        -36.16,
                        0.55,
                        -16.09,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.59,
                        0.59,
                        0.59,
                        -19.78,
                        1.20,
                        -21.21,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.79,
                        0.79,
                        0.79,
                        18.98,
                        0.45,
                        -31.05,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.61,
                        0.61,
                        0.61,
                        -0.24,
                        0.35,
                        -30.2,
                        0.03,
                        -0.7,
                        -0.02,
                        0.71,
                        0.67,
                        0.67,
                        0.67,
                        -7.47,
                        0.97,
                        -5.69,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.68,
                        0.68,
                        0.68,
                        4.26,
                        0.20,
                        -29,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.48,
                        0.48,
                        0.48,
                        -25.85,
                        0.46,
                        -19.46,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.51,
                        0.51,
                        0.51,
                        31.42,
                        0.06,
                        -35.81,
                        0.03,
                        -0.71,
                        -0.02,
                        0.70,
                        0.43,
                        0.43,
                        0.43,
                        31.63,
                        -0.69,
                        -12.61,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.56,
                        0.56,
                        0.56,
                        7.28,
                        -0.33,
                        -24.74,
                        0.03,
                        -0.71,
                        -0.03,
                        0.71,
                        0.79,
                        0.79,
                        0.79,
                        20.53,
                        0.13,
                        -30.75,
                        0.03,
                        -0.71,
                        -0.02,
                        0.70,
                        0.95,
                        0.95,
                        0.95,
                        -25.17,
                        0.03,
                        -60.78,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        0.59,
                        0.59,
                        0.59,
                        7.27,
                        -0.08,
                        -28.18,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.47,
                        0.47,
                        0.47,
                        -11.28,
                        0.96,
                        -33.83,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.88,
                        0.88,
                        0.88,
                        6.60,
                        -0.16,
                        -26.32,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.94,
                        0.94,
                        0.94,
                        7.10,
                        -0.29,
                        -25.67,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.97,
                        0.97,
                        0.97,
                        -0.29,
                        0.31,
                        -38.17,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.85,
                        0.85,
                        0.85,
                        -1.38,
                        0.39,
                        -33.82,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.72,
                        0.72,
                        0.72,
                        -9.19,
                        0.98,
                        -33.86,
                        0.00,
                        -0.71,
                        0.00,
                        0.70,
                        0.69,
                        0.69,
                        0.69,
                        -0.6,
                        1.26,
                        -50.37,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        -5.06,
                        0.37,
                        -35.61,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        -33.75,
                        0.36,
                        -40.22,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.46,
                        0.46,
                        0.46,
                        -15.53,
                        0.70,
                        -44.53,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.46,
                        0.46,
                        0.46,
                        0.96,
                        -0.36,
                        -23.59,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.62,
                        0.62,
                        0.62,
                        -14.54,
                        0.35,
                        -47.8,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.96,
                        0.96,
                        0.96,
                        5.37,
                        0.68,
                        -45.68,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        -3.15,
                        0.03,
                        -68.59,
                        0.02,
                        -0.71,
                        -0.01,
                        0.70,
                        0.52,
                        0.52,
                        0.52,
                        0.49,
                        0.42,
                        -37.01,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.58,
                        0.58,
                        0.58,
                        -5.67,
                        0.73,
                        -8.14,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.46,
                        0.46,
                        0.46,
                        -1.27,
                        1.14,
                        -50.63,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.45,
                        0.45,
                        0.45,
                        -4.96,
                        -0.19,
                        -27.88,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.96,
                        0.96,
                        0.96,
                        8.62,
                        -0.5,
                        -23.88,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.84,
                        0.84,
                        0.84,
                        -26.78,
                        0.28,
                        -18.5,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.65,
                        0.65,
                        0.65,
                        -39.73,
                        0.33,
                        -17.87,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.58,
                        0.58,
                        0.58,
                        -1.86,
                        0.16,
                        -39.08,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.92,
                        0.92,
                        0.92,
                        -4.89,
                        0.20,
                        -40.14,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.76,
                        0.76,
                        0.76,
                        4.69,
                        0.53,
                        -48.63,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.88,
                        0.88,
                        0.88,
                        -19.45,
                        0.68,
                        -34.06,
                        0.03,
                        -0.7,
                        -0.02,
                        0.71,
                        0.89,
                        0.89,
                        0.89,
                        -20.4,
                        1.47,
                        -20.18,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        1.76,
                        0.44,
                        -30.09,
                        0.02,
                        -0.71,
                        -0.01,
                        0.70,
                        0.92,
                        0.92,
                        0.92,
                        3.65,
                        0.60,
                        -32.98,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.80,
                        0.80,
                        0.80,
                        -9.45,
                        0.45,
                        -38.38,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.58,
                        0.58,
                        0.58,
                        -10.52,
                        0.01,
                        -28.59,
                        0.03,
                        -0.71,
                        -0.03,
                        0.71,
                        0.50,
                        0.50,
                        0.50,
                        -9.37,
                        0.76,
                        -36.77,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.85,
                        0.85,
                        0.85,
                        2.25,
                        0.70,
                        -49.12,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.92,
                        0.92,
                        0.92,
                        -4.44,
                        -0.13,
                        -69.6,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.79,
                        0.79,
                        0.79,
                        3.91,
                        0.66,
                        -32.03,
                        0.03,
                        -0.71,
                        -0.02,
                        0.70,
                        0.63,
                        0.63,
                        0.63,
                        -10.54,
                        1.05,
                        -34.64,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.98,
                        0.98,
                        0.98,
                        -29.05,
                        0.42,
                        -16.06,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.65,
                        0.65,
                        0.65,
                        -13.13,
                        1.28,
                        -14.67,
                        0.02,
                        -0.71,
                        -0.03,
                        0.70,
                        0.82,
                        0.82,
                        0.82,
                        11.76,
                        0.14,
                        -37.28,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        0.67,
                        0.67,
                        0.67,
                        -18.11,
                        0.24,
                        -50.1,
                        0.02,
                        -0.7,
                        -0.01,
                        0.71,
                        0.99,
                        0.99,
                        0.99,
                        -23.91,
                        0.50,
                        -23.86,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.69,
                        0.69,
                        0.69,
                        4.41,
                        0.37,
                        -30.3,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.68,
                        0.68,
                        0.68,
                        -4.2,
                        0.23,
                        -39.28,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.89,
                        0.89,
                        0.89,
                        -4.73,
                        0.19,
                        -72.54,
                        0.02,
                        -0.71,
                        -0.01,
                        0.70,
                        0.50,
                        0.50,
                        0.50,
                        -9.75,
                        0.95,
                        -4.34,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.49,
                        0.49,
                        0.49,
                        -1.41,
                        0.91,
                        -53.06,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.47,
                        0.47,
                        0.47,
                        -13.81,
                        1.28,
                        -15.49,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.61,
                        0.61,
                        0.61,
                        -25.75,
                        0.06,
                        -62.92,
                        0.03,
                        -0.7,
                        -0.02,
                        0.71,
                        0.80,
                        0.80,
                        0.80,
                        20.43,
                        0.06,
                        -29.41,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.64,
                        0.64,
                        0.64,
                        -8.33,
                        0.32,
                        -38.39,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.48,
                        0.48,
                        0.48,
                        -0.52,
                        0.11,
                        -62.67,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.65,
                        0.65,
                        0.65,
                        7.56,
                        0.70,
                        -44.54,
                        0.02,
                        -0.71,
                        -0.01,
                        0.70,
                        0.84,
                        0.84,
                        0.84,
                        18.37,
                        0.03,
                        -30.24,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        -19.65,
                        0.67,
                        -34.21,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.53,
                        0.53,
                        0.53,
                        9.46,
                        0.01,
                        -37.23,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.84,
                        0.84,
                        0.84,
                        3.65,
                        0.57,
                        -49.5,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.49,
                        0.49,
                        0.49,
                        -26.32,
                        0.16,
                        -67.07,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.48,
                        0.48,
                        0.48,
                        -9.72,
                        0.06,
                        -29.78,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        1.02,
                        0.43,
                        -36.34,
                        0.02,
                        -0.7,
                        -0.01,
                        0.71,
                        0.64,
                        0.64,
                        0.64,
                        7.53,
                        -0.15,
                        -27.37,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.68,
                        0.68,
                        0.68,
                        6.82,
                        -0.19,
                        -26.24,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.79,
                        0.79,
                        0.79,
                        -43.9,
                        0.79,
                        -21.53,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.83,
                        0.83,
                        0.83,
                        -11.34,
                        1.02,
                        -35.28,
                        0.02,
                        -0.71,
                        -0.03,
                        0.70,
                        0.68,
                        0.68,
                        0.68,
                        -7.91,
                        0.06,
                        -30.3,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        15.27,
                        -0.59,
                        -12.21,
                        0.00,
                        -0.71,
                        -0.01,
                        0.70,
                        0.95,
                        0.95,
                        0.95,
                        -22.97,
                        0.11,
                        -29.11,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        0.57,
                        0.57,
                        0.57,
                        4.05,
                        -0.22,
                        -24.04,
                        0.01,
                        -0.71,
                        0.00,
                        0.70,
                        0.45,
                        0.45,
                        0.45,
                        37.21,
                        0.05,
                        -30.64,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.82,
                        0.82,
                        0.82,
                        28.25,
                        -0.63,
                        -10.01,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.87,
                        0.87,
                        0.87,
                        3.31,
                        0.68,
                        -31.78,
                        0.02,
                        -0.71,
                        -0.03,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        -6.41,
                        0.25,
                        -39.48,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.66,
                        0.66,
                        0.66,
                        1.86,
                        0.35,
                        -28.49,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        7.85,
                        -0.36,
                        -24.71,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.94,
                        0.94,
                        0.94,
                        8.38,
                        -0.16,
                        -26.91,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.64,
                        0.64,
                        0.64,
                        -15.68,
                        1.16,
                        -42.82,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.76,
                        0.76,
                        0.76,
                        -7.98,
                        0.25,
                        -38.94,
                        0.03,
                        -0.7,
                        -0.02,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        -20.22,
                        0.59,
                        -34.21,
                        0.03,
                        -0.7,
                        -0.02,
                        0.71,
                        0.47,
                        0.47,
                        0.47,
                        1.28,
                        0.42,
                        -36.06,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.68,
                        0.68,
                        0.68,
                        -1.34,
                        0.18,
                        -38.91,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.69,
                        0.69,
                        0.69,
                        -18.59,
                        1.25,
                        -39.5,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.61,
                        0.61,
                        0.61,
                        19.72,
                        0.42,
                        -31.93,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.76,
                        0.76,
                        0.76,
                        -10.04,
                        -0,
                        -28.84,
                        0.01,
                        -0.71,
                        -0.02,
                        0.70,
                        0.54,
                        0.54,
                        0.54,
                        -17.92,
                        0.38,
                        -49.16,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.93,
                        0.93,
                        0.93,
                        8.35,
                        -0.47,
                        -23.54,
                        0.00,
                        -0.71,
                        0.00,
                        0.70,
                        0.91,
                        0.91,
                        0.91,
                        -7.69,
                        0.20,
                        -39.88,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        -2,
                        0.12,
                        -39.42,
                        0.00,
                        -0.71,
                        0.00,
                        0.70,
                        0.86,
                        0.86,
                        0.86,
                        4.74,
                        -0.26,
                        -14.45,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        -0.58,
                        1.20,
                        -49.8,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.72,
                        0.72,
                        0.72,
                        18.52,
                        0.23,
                        -30.66,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.53,
                        0.53,
                        0.53,
                        3.84,
                        0.36,
                        -29.42,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.72,
                        0.72,
                        0.72,
                        -3.33,
                        0.18,
                        -39.37,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.99,
                        0.99,
                        0.99,
                        14.78,
                        0.59,
                        -35.79,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.66,
                        0.66,
                        0.66,
                        -7.39,
                        0.20,
                        -40.13,
                        0.03,
                        -0.7,
                        -0.02,
                        0.71,
                        0.53,
                        0.53,
                        0.53,
                        8.52,
                        -0.46,
                        -24.24,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.94,
                        0.94,
                        0.94,
                        19.23,
                        -0.48,
                        -19.17,
                        0.01,
                        -0.71,
                        0.00,
                        0.70,
                        0.51,
                        0.51,
                        0.51,
                        14.44,
                        -0.33,
                        -7.58,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.60,
                        0.60,
                        0.60,
                        -2.15,
                        0.74,
                        -51.03,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.66,
                        0.66,
                        0.66,
                        21.96,
                        0.27,
                        -37.71,
                        0.02,
                        -0.71,
                        -0.03,
                        0.71,
                        0.99,
                        0.99,
                        0.99,
                        7.55,
                        -0.4,
                        -23.67,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.50,
                        0.50,
                        0.50,
                        -9.71,
                        -0.02,
                        -28.33,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        -2.76,
                        0.07,
                        -40.18,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.62,
                        0.62,
                        0.62,
                        -6.68,
                        0.46,
                        -32.13,
                        0.02,
                        -0.71,
                        -0.03,
                        0.71,
                        0.96,
                        0.96,
                        0.96,
                        -20.6,
                        0.51,
                        -33.66,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.89,
                        0.89,
                        0.89,
                        -11.22,
                        0.72,
                        -31.7,
                        0.03,
                        -0.71,
                        -0.03,
                        0.71,
                        0.98,
                        0.98,
                        0.98,
                        0.80,
                        0.38,
                        -29.88,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        0.98,
                        0.98,
                        0.98,
                        -11.87,
                        0.46,
                        -50.49,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.71,
                        0.71,
                        0.71,
                        32.07,
                        0.03,
                        -35.46,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.74,
                        0.74,
                        0.74,
                        -4.89,
                        0.14,
                        -72.18,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.58,
                        0.58,
                        0.58,
                        3.08,
                        -0.36,
                        -16.25,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.84,
                        0.84,
                        0.84,
                        0.44,
                        0.22,
                        -58.02,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        1.00,
                        1.00,
                        1.00,
                        24.97,
                        -0.01,
                        -37.65,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.49,
                        0.49,
                        0.49,
                        -2.82,
                        0.21,
                        -38.9,
                        0.01,
                        -0.71,
                        -0.02,
                        0.70,
                        0.42,
                        0.42,
                        0.42,
                        -6.38,
                        0.42,
                        -31.82,
                        0.02,
                        -0.71,
                        -0.03,
                        0.71,
                        0.42,
                        0.42,
                        0.42,
                        5.98,
                        0.02,
                        -11.2,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.88,
                        0.88,
                        0.88,
                        21.96,
                        0.27,
                        -37.71,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.62,
                        0.62,
                        0.62,
                        3.31,
                        0.68,
                        -31.78,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.77,
                        0.77,
                        0.77,
                        -13.37,
                        -0.08,
                        -51.28,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.48,
                        0.48,
                        0.48,
                        16.80,
                        -0.13,
                        -31.56,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.43,
                        0.43,
                        0.43,
                        18.29,
                        0.26,
                        -31.06,
                        0.00,
                        -0.71,
                        0.00,
                        0.70,
                        0.43,
                        0.43,
                        0.43,
                        -10.74,
                        -0,
                        -27.54,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.55,
                        0.55,
                        0.55,
                        -17.71,
                        1.39,
                        -18.68,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.57,
                        0.57,
                        0.57,
                        -9.71,
                        0.86,
                        -2.91,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.65,
                        0.65,
                        0.65,
                        -14.5,
                        0.36,
                        -47.7,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.46,
                        0.46,
                        0.46,
                        -9.19,
                        0.22,
                        -30.65,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.94,
                        0.94,
                        0.94,
                        37.98,
                        0.93,
                        -33.37,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.45,
                        0.45,
                        0.45,
                        -4.39,
                        -0.03,
                        -69.78,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.50,
                        0.50,
                        0.50,
                        -19.75,
                        0.75,
                        -35.34,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.73,
                        0.73,
                        0.73,
                        2.57,
                        -0.26,
                        -23.98,
                        0.00,
                        -0.71,
                        -0.01,
                        0.70,
                        0.58,
                        0.58,
                        0.58,
                        2.67,
                        0.45,
                        -29.55,
                        0.03,
                        -0.7,
                        -0.02,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        -8.33,
                        -0.27,
                        -26.73,
                        0.01,
                        -0.71,
                        -0.02,
                        0.70,
                        0.56,
                        0.56,
                        0.56,
                        -19.43,
                        0.97,
                        -37.43,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.65,
                        0.65,
                        0.65,
                        38.52,
                        0.32,
                        -30,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.44,
                        0.44,
                        0.44,
                        15.66,
                        0.86,
                        -37.07,
                        0.03,
                        -0.7,
                        -0.02,
                        0.71,
                        0.63,
                        0.63,
                        0.63,
                        15.73,
                        0.92,
                        -38.19,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.94,
                        0.94,
                        0.94,
                        -2.42,
                        -0.38,
                        -23.05,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.74,
                        0.74,
                        0.74,
                        2.45,
                        -0.27,
                        -23.92,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.97,
                        0.97,
                        0.97,
                        -9.19,
                        0.98,
                        -33.86,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.47,
                        0.47,
                        0.47,
                        8.75,
                        -0.25,
                        -25.9,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        1.00,
                        1.00,
                        1.00,
                        17.27,
                        -0.66,
                        -13.85,
                        0.01,
                        -0.71,
                        -0.02,
                        0.70,
                        0.88,
                        0.88,
                        0.88,
                        6.60,
                        -0.23,
                        -2.28,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.88,
                        0.88,
                        0.88,
                        2.33,
                        0.45,
                        -29.87,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.55,
                        0.55,
                        0.55,
                        17.08,
                        0.62,
                        -34.04,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        2.99,
                        0.60,
                        -33,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.87,
                        0.87,
                        0.87,
                        6.57,
                        -0.04,
                        -29.28,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        -6.26,
                        0.25,
                        -39.84,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.78,
                        0.78,
                        0.78,
                        -15.91,
                        0.91,
                        -18.68,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.56,
                        0.56,
                        0.56,
                        -0.53,
                        1.15,
                        -53.05,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.94,
                        0.94,
                        0.94,
                        3.21,
                        0.58,
                        -33.27,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.48,
                        0.48,
                        0.48,
                        19.41,
                        -0.56,
                        -19.84,
                        0.02,
                        -0.71,
                        -0.01,
                        0.70,
                        0.70,
                        0.70,
                        0.70,
                        -12.89,
                        1.30,
                        -13.9,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.96,
                        0.96,
                        0.96,
                        3.36,
                        0.61,
                        -32.81,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.46,
                        0.46,
                        0.46,
                        17.98,
                        0.70,
                        -34.45,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.50,
                        0.50,
                        0.50,
                        8.54,
                        -0.39,
                        -24.9,
                        0.03,
                        -0.71,
                        -0.02,
                        0.70,
                        0.46,
                        0.46,
                        0.46,
                        3.36,
                        -0.23,
                        -23.87,
                        0.02,
                        -0.71,
                        -0.03,
                        0.70,
                        0.57,
                        0.57,
                        0.57,
                        5.79,
                        -0.19,
                        -4.33,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.99,
                        0.99,
                        0.99,
                        18.77,
                        -0.54,
                        -19.88,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.44,
                        0.44,
                        0.44,
                        35.66,
                        0.44,
                        -33.81,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.92,
                        0.92,
                        0.92,
                        8.51,
                        -0.34,
                        -25.31,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.64,
                        0.64,
                        0.64,
                        -23.22,
                        0.02,
                        -54.96,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.71,
                        0.71,
                        0.71,
                        -39.17,
                        0.23,
                        -18,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.61,
                        0.61,
                        0.61,
                        19.50,
                        0.22,
                        -29.57,
                        0.02,
                        -0.71,
                        -0.03,
                        0.71,
                        0.80,
                        0.80,
                        0.80,
                        30.17,
                        0.20,
                        -7.8,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        1.11,
                        -0.28,
                        -24.01,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.66,
                        0.66,
                        0.66,
                        16.56,
                        0.04,
                        -32.21,
                        0.00,
                        -0.71,
                        -0.01,
                        0.70,
                        0.71,
                        0.71,
                        0.71,
                        -8.3,
                        0.19,
                        -30.79,
                        0.00,
                        -0.71,
                        0.00,
                        0.70,
                        0.62,
                        0.62,
                        0.62,
                        -19.81,
                        1.18,
                        -39.7,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.60,
                        0.60,
                        0.60,
                        6.67,
                        -0.33,
                        -20.57,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.62,
                        0.62,
                        0.62,
                        1.34,
                        -0.51,
                        -21.64,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.67,
                        0.67,
                        0.67,
                        -10.42,
                        0.02,
                        -28.81,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.72,
                        0.72,
                        0.72,
                        -4,
                        0.33,
                        -37.09,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.82,
                        0.82,
                        0.82,
                        -13.91,
                        0.37,
                        -48.53,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.82,
                        0.82,
                        0.82,
                        -43.47,
                        0.83,
                        -19.53,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.51,
                        0.51,
                        0.51,
                        0.98,
                        -0.56,
                        -19.53,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.52,
                        0.52,
                        0.52,
                        27.46,
                        -0.47,
                        -8.33,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.41,
                        0.41,
                        0.41,
                        -15.73,
                        0.22,
                        -48.78,
                        0.03,
                        -0.71,
                        -0.03,
                        0.71,
                        0.51,
                        0.51,
                        0.51,
                        4.85,
                        -0.15,
                        -24.64,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.87,
                        0.87,
                        0.87,
                        -15.14,
                        0.51,
                        -45.39,
                        0.01,
                        -0.71,
                        0.00,
                        0.70,
                        0.69,
                        0.69,
                        0.69,
                        -42.7,
                        0.31,
                        -22.08,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.94,
                        0.94,
                        0.94,
                        1.87,
                        0.51,
                        -34.45,
                        0.01,
                        -0.71,
                        0.00,
                        0.70,
                        0.80,
                        0.80,
                        0.80,
                        -19.46,
                        0.51,
                        -32.48,
                        0.01,
                        -0.71,
                        0.00,
                        0.70,
                        0.55,
                        0.55,
                        0.55,
                        -8.68,
                        0.15,
                        -30.63,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.84,
                        0.84,
                        0.84,
                        -20.61,
                        0.26,
                        -30.72,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.59,
                        0.59,
                        0.59,
                        -1.88,
                        0.33,
                        -34.74,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.86,
                        0.86,
                        0.86,
                        8.41,
                        -0.17,
                        -27.27,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.92,
                        0.92,
                        0.92,
                        6.64,
                        -0.22,
                        -2.17,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.66,
                        0.66,
                        0.66,
                        8.54,
                        -0.2,
                        -26.81,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.43,
                        0.43,
                        0.43,
                        -36.28,
                        -0.1,
                        -17.84,
                        0.03,
                        -0.71,
                        -0.03,
                        0.71,
                        0.73,
                        0.73,
                        0.73,
                        -2.78,
                        0.06,
                        -40.29,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.87,
                        0.87,
                        0.87,
                        -18.82,
                        1.20,
                        -39.22,
                        0.00,
                        -0.71,
                        0.00,
                        0.70,
                        0.66,
                        0.66,
                        0.66,
                        -17.26,
                        1.58,
                        -42.16,
                        0.01,
                        -0.71,
                        -0.02,
                        0.70,
                        0.93,
                        0.93,
                        0.93,
                        -10.55,
                        -0.01,
                        -27.56,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.92,
                        0.92,
                        0.92,
                        10.13,
                        0.43,
                        -39.64,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.72,
                        0.72,
                        0.72,
                        -12.01,
                        0.52,
                        -3.53,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.76,
                        0.76,
                        0.76,
                        2.09,
                        0.61,
                        -32.42,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.52,
                        0.52,
                        0.52,
                        -7.52,
                        1.14,
                        -8.9,
                        0.01,
                        -0.71,
                        0.00,
                        0.70,
                        0.61,
                        0.61,
                        0.61,
                        26.66,
                        0.20,
                        -39.37,
                        0.00,
                        -0.71,
                        0.00,
                        0.70,
                        0.86,
                        0.86,
                        0.86,
                        -22.66,
                        0.14,
                        -30.85,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.89,
                        0.89,
                        0.89,
                        20.45,
                        0.10,
                        -30.05,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.89,
                        0.89,
                        0.89,
                        -0.32,
                        0.45,
                        -56.54,
                        0.02,
                        -0.71,
                        -0.03,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        19.13,
                        0.49,
                        -31.28,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.81,
                        0.81,
                        0.81,
                        -30.63,
                        0.22,
                        -17.4,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.92,
                        0.92,
                        0.92,
                        1.73,
                        0.41,
                        -35.66,
                        0.03,
                        -0.71,
                        -0.03,
                        0.71,
                        0.46,
                        0.46,
                        0.46,
                        4.60,
                        0.17,
                        -29.21,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.66,
                        0.66,
                        0.66,
                        -24.92,
                        -0.04,
                        -66.24,
                        0.00,
                        -0.71,
                        -0.01,
                        0.70,
                        0.83,
                        0.83,
                        0.83,
                        -17.92,
                        0.38,
                        -49.16,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.64,
                        0.64,
                        0.64,
                        -4.73,
                        0.41,
                        -33.3,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.46,
                        0.46,
                        0.46,
                        -7.06,
                        0.24,
                        -39.35,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.45,
                        0.45,
                        0.45,
                        16.52,
                        -0.16,
                        -31.72,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.99,
                        0.99,
                        0.99,
                        -10.7,
                        1.07,
                        -36.5,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.76,
                        0.76,
                        0.76,
                        -42.41,
                        0.24,
                        -21.59,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.60,
                        0.60,
                        0.60,
                        -2.27,
                        0.04,
                        -68.2,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.68,
                        0.68,
                        0.68,
                        3.20,
                        0.61,
                        -49.43,
                        0.02,
                        -0.7,
                        -0.01,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        7.65,
                        0.70,
                        -44.45,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.96,
                        0.96,
                        0.96,
                        7.11,
                        -0.04,
                        -9.03,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.95,
                        0.95,
                        0.95,
                        -15.55,
                        -0.03,
                        -50.3,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.95,
                        0.95,
                        0.95,
                        32.77,
                        0.49,
                        -37.22,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        1.00,
                        1.00,
                        1.00,
                        12.51,
                        0.31,
                        -37.13,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.58,
                        0.58,
                        0.58,
                        -13.58,
                        1.36,
                        -14.61,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.53,
                        0.53,
                        0.53,
                        -1.36,
                        0.41,
                        -33.44,
                        0.00,
                        -0.71,
                        0.00,
                        0.70,
                        0.64,
                        0.64,
                        0.64,
                        -17.58,
                        1.58,
                        -17.6,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.77,
                        0.77,
                        0.77,
                        15.22,
                        0.86,
                        -37.21,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.46,
                        0.46,
                        0.46,
                        -13.57,
                        1.01,
                        -16.23,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.99,
                        0.99,
                        0.99,
                        -15.53,
                        0.70,
                        -44.53,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.89,
                        0.89,
                        0.89,
                        -17.51,
                        1.51,
                        -41.53,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        0.62,
                        0.62,
                        0.62,
                        5.34,
                        0.67,
                        -45.89,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.68,
                        0.68,
                        0.68,
                        -25.07,
                        -0.02,
                        -64.5,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.76,
                        0.76,
                        0.76,
                        3.34,
                        -0.2,
                        -24.18,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        -6.68,
                        0.46,
                        -32.13,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.64,
                        0.64,
                        0.64,
                        15.37,
                        -0.51,
                        -11.04,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.55,
                        0.55,
                        0.55,
                        -9.84,
                        1.04,
                        -34.73,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.86,
                        0.86,
                        0.86,
                        -21.08,
                        0.25,
                        -30.98,
                        0.03,
                        -0.71,
                        -0.03,
                        0.71,
                        0.68,
                        0.68,
                        0.68,
                        11.82,
                        0.27,
                        -37.82,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.87,
                        0.87,
                        0.87,
                        -10.34,
                        0.05,
                        -29.3,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.47,
                        0.47,
                        0.47,
                        -11.16,
                        1.03,
                        -34.53,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.58,
                        0.58,
                        0.58,
                        30.46,
                        0.02,
                        -36.15,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.87,
                        0.87,
                        0.87,
                        -1.59,
                        0.93,
                        -51.57,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.67,
                        0.67,
                        0.67,
                        34.54,
                        0.28,
                        -13.05,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.93,
                        0.93,
                        0.93,
                        -8.81,
                        0.93,
                        -4.54,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.96,
                        0.96,
                        0.96,
                        3.36,
                        0.61,
                        -32.81,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.49,
                        0.49,
                        0.49,
                        1.97,
                        0.53,
                        -34.16,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        0.84,
                        0.84,
                        0.84,
                        25.50,
                        0.04,
                        -38.15,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.57,
                        0.57,
                        0.57,
                        -21.56,
                        0.36,
                        -32.53,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.51,
                        0.51,
                        0.51,
                        -23.9,
                        0.05,
                        -70.48,
                        0.03,
                        -0.7,
                        -0.02,
                        0.71,
                        0.88,
                        0.88,
                        0.88,
                        6.86,
                        -0.18,
                        -5.95,
                        0.02,
                        -0.71,
                        -0.03,
                        0.70,
                        0.93,
                        0.93,
                        0.93,
                        17.57,
                        -0.29,
                        -30.04,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.48,
                        0.48,
                        0.48,
                        -11.32,
                        0.61,
                        -3.02,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.78,
                        0.78,
                        0.78,
                        17.86,
                        0.11,
                        -31.1,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.95,
                        0.95,
                        0.95,
                        20.27,
                        0.24,
                        -31.22,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.65,
                        0.65,
                        0.65,
                        16.01,
                        -0.34,
                        -10.93,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.73,
                        0.73,
                        0.73,
                        2.19,
                        0.40,
                        -35.31,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.47,
                        0.47,
                        0.47,
                        -16.42,
                        1.16,
                        -18.35,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.45,
                        0.45,
                        0.45,
                        -8.07,
                        0.30,
                        -38.38,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.73,
                        0.73,
                        0.73,
                        8.72,
                        -0.22,
                        -26.67,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.43,
                        0.43,
                        0.43,
                        18.29,
                        -0.55,
                        -20.14,
                        0.03,
                        -0.71,
                        -0.03,
                        0.71,
                        0.87,
                        0.87,
                        0.87,
                        -5.22,
                        0.42,
                        -34.3,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.94,
                        0.94,
                        0.94,
                        7.35,
                        -0.15,
                        -27.33,
                        0.02,
                        -0.71,
                        -0.03,
                        0.71,
                        0.65,
                        0.65,
                        0.65,
                        -2.78,
                        -0.07,
                        -27.66,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.85,
                        0.85,
                        0.85,
                        0.88,
                        1.10,
                        -50.73,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.89,
                        0.89,
                        0.89,
                        6.13,
                        -0.2,
                        -4.09,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.86,
                        0.86,
                        0.86,
                        -3.48,
                        0.16,
                        -71.68,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.55,
                        0.55,
                        0.55,
                        8.62,
                        -0.5,
                        -23.88,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.89,
                        0.89,
                        0.89,
                        14.02,
                        0.74,
                        -37.6,
                        0.00,
                        -0.71,
                        0.00,
                        0.70,
                        0.54,
                        0.54,
                        0.54,
                        5.88,
                        -0.19,
                        -4.76,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.41,
                        0.41,
                        0.41,
                        -15.15,
                        0.46,
                        -45.75,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.81,
                        0.81,
                        0.81,
                        -0.58,
                        0.40,
                        -34.11,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.86,
                        0.86,
                        0.86,
                        -1.57,
                        0.41,
                        -33.43,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.61,
                        0.61,
                        0.61,
                        -12.13,
                        0.73,
                        -32.64,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.54,
                        0.54,
                        0.54,
                        -19.73,
                        1.49,
                        -19.48,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.84,
                        0.84,
                        0.84,
                        -8.98,
                        -0.15,
                        -27.81,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        -9.53,
                        1.02,
                        -34.4,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.62,
                        0.62,
                        0.62,
                        -11.96,
                        0.88,
                        -33.52,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.70,
                        0.70,
                        0.70,
                        31.12,
                        0.19,
                        -8.85,
                        0.02,
                        -0.71,
                        -0.03,
                        0.70,
                        0.71,
                        0.71,
                        0.71,
                        19.99,
                        -0.6,
                        -19.88,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.43,
                        0.43,
                        0.43,
                        -8.44,
                        1.01,
                        -5.23,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        -5.05,
                        0.20,
                        -40.26,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.56,
                        0.56,
                        0.56,
                        -23.92,
                        0.38,
                        -35.26,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        -9.06,
                        -0.1,
                        -28.37,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.68,
                        0.68,
                        0.68,
                        23.74,
                        -0.06,
                        -36.92,
                        0.02,
                        -0.71,
                        -0.03,
                        0.70,
                        0.92,
                        0.92,
                        0.92,
                        -5.54,
                        0.08,
                        -72.1,
                        0.02,
                        -0.71,
                        -0.03,
                        0.70,
                        0.71,
                        0.71,
                        0.71,
                        -11.81,
                        0.53,
                        -4.06,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.80,
                        0.80,
                        0.80,
                        -15.15,
                        1.13,
                        -17.35,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.81,
                        0.81,
                        0.81,
                        -17.87,
                        1.05,
                        -20.29,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.85,
                        0.85,
                        0.85,
                        6.51,
                        -0.33,
                        -21.15,
                        0.03,
                        -0.71,
                        -0.03,
                        0.71,
                        0.82,
                        0.82,
                        0.82,
                        -7.11,
                        -0.09,
                        -72.52,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.44,
                        0.44,
                        0.44,
                        1.18,
                        0.28,
                        -57.97,
                        0.02,
                        -0.71,
                        -0.03,
                        0.71,
                        0.68,
                        0.68,
                        0.68,
                        -7.98,
                        0.25,
                        -38.94,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.65,
                        0.65,
                        0.65,
                        -23.61,
                        0.60,
                        -36.92,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.73,
                        0.73,
                        0.73,
                        -10.75,
                        0.01,
                        -28.14,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.56,
                        0.56,
                        0.56,
                        -0.66,
                        0.40,
                        -37.14,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.93,
                        0.93,
                        0.93,
                        7.60,
                        -0.36,
                        -26.01,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.57,
                        0.57,
                        0.57,
                        19.19,
                        -0.75,
                        -21.37,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.49,
                        0.49,
                        0.49,
                        -21.58,
                        0.63,
                        -35.3,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.62,
                        0.62,
                        0.62,
                        -23.26,
                        1.02,
                        -20.41,
                        0.03,
                        -0.7,
                        -0.02,
                        0.71,
                        0.56,
                        0.56,
                        0.56,
                        -4.26,
                        0.16,
                        -40.06,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.81,
                        0.81,
                        0.81,
                        0.73,
                        0.43,
                        -36.83,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.58,
                        0.58,
                        0.58,
                        29.16,
                        0.12,
                        -37.53,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.85,
                        0.85,
                        0.85,
                        3.48,
                        -0.33,
                        -16.96,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        0.50,
                        0.50,
                        0.50,
                        -34.47,
                        0.15,
                        -17.38,
                        0.01,
                        -0.71,
                        -0.02,
                        0.70,
                        0.42,
                        0.42,
                        0.42,
                        -6.34,
                        0.24,
                        -40.19,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.44,
                        0.44,
                        0.44,
                        -1.12,
                        1.21,
                        -54.39,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.53,
                        0.53,
                        0.53,
                        18.74,
                        -0.7,
                        -21.37,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.69,
                        0.69,
                        0.69,
                        5.95,
                        0.65,
                        -45.61,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        0.46,
                        0.46,
                        0.46,
                        -0.76,
                        0.29,
                        -56.92,
                        0.01,
                        -0.71,
                        0.00,
                        0.70,
                        0.68,
                        0.68,
                        0.68,
                        8.61,
                        -0.21,
                        -26.92,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        0.48,
                        0.48,
                        0.48,
                        7.99,
                        -0.37,
                        -24.77,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.54,
                        0.54,
                        0.54,
                        -21.24,
                        0.24,
                        -30.99,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.84,
                        0.84,
                        0.84,
                        3.59,
                        0.64,
                        -32.35,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        -10.86,
                        0.68,
                        -2.04,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.43,
                        0.43,
                        0.43,
                        0.50,
                        0.21,
                        -59.36,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.61,
                        0.61,
                        0.61,
                        14.89,
                        -0.25,
                        -5.83,
                        0.01,
                        -0.71,
                        -0.02,
                        0.70,
                        0.86,
                        0.86,
                        0.86,
                        -14.2,
                        1.00,
                        -16.88,
                        0.04,
                        -0.71,
                        -0.03,
                        0.71,
                        0.48,
                        0.48,
                        0.48,
                        2.03,
                        -0.35,
                        -23.39,
                        0.03,
                        -0.71,
                        -0.02,
                        0.70,
                        0.50,
                        0.50,
                        0.50,
                        -14.04,
                        0.48,
                        -47.54,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        0.68,
                        0.68,
                        0.68,
                        -5.45,
                        0.20,
                        -40.52,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.42,
                        0.42,
                        0.42,
                        -42.33,
                        0.45,
                        -38.51,
                        0.03,
                        -0.7,
                        -0.02,
                        0.71,
                        0.47,
                        0.47,
                        0.47,
                        3.37,
                        0.67,
                        -48,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.95,
                        0.95,
                        0.95,
                        -5.23,
                        0.25,
                        -39.78,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        36.65,
                        0.53,
                        -32.98,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.66,
                        0.66,
                        0.66,
                        -2.95,
                        0.22,
                        -38.63,
                        0.02,
                        -0.71,
                        -0.03,
                        0.71,
                        0.77,
                        0.77,
                        0.77,
                        4.04,
                        0.58,
                        -33.06,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.94,
                        0.94,
                        0.94,
                        -2.04,
                        0.07,
                        -57.25,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        2.54,
                        0.57,
                        -33.56,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.86,
                        0.86,
                        0.86,
                        -4.3,
                        0.35,
                        -36.21,
                        0.02,
                        -0.71,
                        -0.01,
                        0.70,
                        0.98,
                        0.98,
                        0.98,
                        -8.96,
                        0.02,
                        -29.81,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.83,
                        0.83,
                        0.83,
                        -2.96,
                        -0.11,
                        -27.2,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.77,
                        0.77,
                        0.77,
                        -43.82,
                        0.77,
                        -21.55,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        15.58,
                        -0.26,
                        -9.98,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.99,
                        0.99,
                        0.99,
                        18.80,
                        -0.54,
                        -17.89,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.50,
                        0.50,
                        0.50,
                        -25.14,
                        0.61,
                        -18.66,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.68,
                        0.68,
                        0.68,
                        -12.18,
                        0.41,
                        -49.26,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.41,
                        0.41,
                        0.41,
                        -16.97,
                        1.32,
                        -43.97,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.46,
                        0.46,
                        0.46,
                        23.99,
                        -0.41,
                        -7.27,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.96,
                        0.96,
                        0.96,
                        -6.26,
                        0.25,
                        -39.84,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.45,
                        0.45,
                        0.45,
                        1.55,
                        0.80,
                        -49.78,
                        0.01,
                        -0.71,
                        -0.02,
                        0.70,
                        0.51,
                        0.51,
                        0.51,
                        -16.83,
                        1.36,
                        -40.99,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.70,
                        0.70,
                        0.70,
                        1.83,
                        0.70,
                        -48.74,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.48,
                        0.48,
                        0.48,
                        19.10,
                        -0.65,
                        -16.92,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.64,
                        0.64,
                        0.64,
                        -32.1,
                        0.65,
                        -15.69,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.48,
                        0.48,
                        0.48,
                        18.04,
                        0.79,
                        -36.99,
                        0.02,
                        -0.71,
                        -0.03,
                        0.70,
                        0.67,
                        0.67,
                        0.67,
                        -25.53,
                        0.24,
                        -56.41,
                        0.02,
                        -0.71,
                        -0.01,
                        0.70,
                        0.97,
                        0.97,
                        0.97,
                        26.59,
                        -0.67,
                        -8.42,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.94,
                        0.94,
                        0.94,
                        34.06,
                        0.08,
                        -34.23,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.70,
                        0.70,
                        0.70,
                        14.38,
                        -0.33,
                        -7.3,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.45,
                        0.45,
                        0.45,
                        -32.76,
                        0.40,
                        -16.86,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.78,
                        0.78,
                        0.78,
                        7.79,
                        -0.13,
                        -27.42,
                        0.03,
                        -0.7,
                        -0.02,
                        0.71,
                        0.56,
                        0.56,
                        0.56,
                        -2.59,
                        0.74,
                        -53.06,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.47,
                        0.47,
                        0.47,
                        25.96,
                        -0.65,
                        -8.39,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.61,
                        0.61,
                        0.61,
                        -34.77,
                        0.60,
                        -15.97,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.79,
                        0.79,
                        0.79,
                        2.72,
                        0.56,
                        -33.69,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        -18.06,
                        1.22,
                        -20.04,
                        0.02,
                        -0.71,
                        -0.03,
                        0.70,
                        0.77,
                        0.77,
                        0.77,
                        -2.01,
                        0.43,
                        -33.23,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.93,
                        0.93,
                        0.93,
                        -17.15,
                        1.28,
                        -18.64,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.60,
                        0.60,
                        0.60,
                        -10.21,
                        0.00,
                        -28.72,
                        0.02,
                        -0.71,
                        -0.01,
                        0.70,
                        0.64,
                        0.64,
                        0.64,
                        39.40,
                        0.10,
                        -28.2,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        -1.87,
                        1.00,
                        -53.9,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.74,
                        0.74,
                        0.74,
                        -19.91,
                        0.43,
                        -32.16,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.99,
                        0.99,
                        0.99,
                        0.93,
                        0.46,
                        -34.78,
                        0.01,
                        -0.71,
                        -0.02,
                        0.70,
                        0.54,
                        0.54,
                        0.54,
                        32.21,
                        0.23,
                        -10.1,
                        0.03,
                        -0.7,
                        -0.02,
                        0.71,
                        0.54,
                        0.54,
                        0.54,
                        -18.33,
                        0.88,
                        -20.99,
                        0.00,
                        -0.71,
                        -0.01,
                        0.70,
                        0.80,
                        0.80,
                        0.80,
                        8.04,
                        -0.36,
                        -25,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.53,
                        0.53,
                        0.53,
                        28.26,
                        -0.28,
                        -8.74,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.51,
                        0.51,
                        0.51,
                        0.30,
                        0.65,
                        -56.35,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.96,
                        0.96,
                        0.96,
                        -1.89,
                        0.11,
                        -69.01,
                        0.01,
                        -0.71,
                        0.00,
                        0.70,
                        0.56,
                        0.56,
                        0.56,
                        -15.84,
                        0.47,
                        -46.03,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.53,
                        0.53,
                        0.53,
                        -12.38,
                        0.29,
                        -50.34,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.78,
                        0.78,
                        0.78,
                        5.54,
                        -0.33,
                        -21.88,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.94,
                        0.94,
                        0.94,
                        3.70,
                        -0.24,
                        -23.8,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.83,
                        0.83,
                        0.83,
                        3.43,
                        -0.3,
                        -15.21,
                        0.02,
                        -0.71,
                        -0.03,
                        0.71,
                        0.52,
                        0.52,
                        0.52,
                        17.13,
                        0.40,
                        -6.12,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.58,
                        0.58,
                        0.58,
                        19.22,
                        0.51,
                        -31.41,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.86,
                        0.86,
                        0.86,
                        21.76,
                        -0.97,
                        -9.97,
                        0.02,
                        -0.71,
                        -0.03,
                        0.71,
                        0.85,
                        0.85,
                        0.85,
                        -23.8,
                        0.11,
                        -32.55,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.73,
                        0.73,
                        0.73,
                        -22.74,
                        0.11,
                        -30.6,
                        0.01,
                        -0.7,
                        -0.02,
                        0.71,
                        0.78,
                        0.78,
                        0.78,
                        -16.62,
                        0.64,
                        -20.11,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.78,
                        0.78,
                        0.78,
                        6.51,
                        -0.04,
                        -28.59,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.58,
                        0.58,
                        0.58,
                        30.79,
                        0.20,
                        -36.75,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.78,
                        0.78,
                        0.78,
                        -1.77,
                        0.04,
                        -67.47,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.53,
                        0.53,
                        0.53,
                        -15.03,
                        0.27,
                        -47.43,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.85,
                        0.85,
                        0.85,
                        -0.26,
                        0.31,
                        -38.14,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.80,
                        0.80,
                        0.80,
                        15.66,
                        0.84,
                        -36.66,
                        -0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.46,
                        0.46,
                        0.46,
                        6.79,
                        -0.17,
                        -26.55,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.49,
                        0.49,
                        0.49,
                        -13.95,
                        0.54,
                        -47.02,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.97,
                        0.97,
                        0.97,
                        -34.04,
                        0.50,
                        -16.53,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.97,
                        0.97,
                        0.97,
                        -25.88,
                        0.17,
                        -69.77,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.69,
                        0.69,
                        0.69,
                        -19.08,
                        1.48,
                        -41.84,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.97,
                        0.97,
                        0.97,
                        -26.84,
                        0.17,
                        -64.15,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.61,
                        0.61,
                        0.61,
                        32.70,
                        0.42,
                        -9.7,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.53,
                        0.53,
                        0.53,
                        3.77,
                        -0.34,
                        -20.68,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.64,
                        0.64,
                        0.64,
                        1.76,
                        0.55,
                        -56.71,
                        0.02,
                        -0.71,
                        -0.03,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        -14.87,
                        0.63,
                        -18.76,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.57,
                        0.57,
                        0.57,
                        -1.25,
                        0.97,
                        -52.37,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.48,
                        0.48,
                        0.48,
                        -23.56,
                        0.34,
                        -34.32,
                        0.00,
                        -0.71,
                        0.00,
                        0.70,
                        0.63,
                        0.63,
                        0.63,
                        -4.89,
                        0.20,
                        -40.14,
                        0.00,
                        -0.71,
                        -0.01,
                        0.70,
                        0.93,
                        0.93,
                        0.93,
                        -14.98,
                        0.26,
                        -47.92,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.61,
                        0.61,
                        0.61,
                        1.60,
                        -0.51,
                        -18.47,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.61,
                        0.61,
                        0.61,
                        -25.71,
                        0.49,
                        -18.55,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.91,
                        0.91,
                        0.91,
                        -9.42,
                        0.09,
                        -30.07,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.51,
                        0.51,
                        0.51,
                        0.44,
                        0.37,
                        -37.68,
                        0.02,
                        -0.71,
                        -0.03,
                        0.71,
                        0.81,
                        0.81,
                        0.81,
                        0.60,
                        0.43,
                        -36.76,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        1.00,
                        1.00,
                        1.00,
                        16.99,
                        -0.64,
                        -13.13,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.88,
                        0.88,
                        0.88,
                        -2.76,
                        0.03,
                        -68.25,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.92,
                        0.92,
                        0.92,
                        5.07,
                        -0.17,
                        -24.55,
                        0.03,
                        -0.71,
                        -0.03,
                        0.71,
                        0.61,
                        0.61,
                        0.61,
                        -18.24,
                        1.31,
                        -39.97,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.96,
                        0.96,
                        0.96,
                        18.21,
                        0.73,
                        -35.89,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        0.69,
                        0.69,
                        0.69,
                        7.80,
                        -0.41,
                        -22.74,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.78,
                        0.78,
                        0.78,
                        -21.88,
                        0.42,
                        -26.98,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.46,
                        0.46,
                        0.46,
                        -20.2,
                        1.13,
                        -39.4,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.71,
                        0.71,
                        0.71,
                        8.05,
                        -0.41,
                        -22.42,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.52,
                        0.52,
                        0.52,
                        3.99,
                        0.64,
                        -32.31,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.56,
                        0.56,
                        0.56,
                        -14.72,
                        0.72,
                        -18.26,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.46,
                        0.46,
                        0.46,
                        -1.02,
                        0.11,
                        -62.42,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.96,
                        0.96,
                        0.96,
                        21.20,
                        -0.32,
                        -29.65,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        18.85,
                        -0.72,
                        -21.88,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.64,
                        0.64,
                        0.64,
                        38.43,
                        0.66,
                        -31.32,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.51,
                        0.51,
                        0.51,
                        19.32,
                        -0.62,
                        -17.48,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.48,
                        0.48,
                        0.48,
                        -5.79,
                        0.37,
                        -35.9,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.77,
                        0.77,
                        0.77,
                        2.01,
                        0.53,
                        -34.11,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.56,
                        0.56,
                        0.56,
                        0.76,
                        0.40,
                        -30.26,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.47,
                        0.47,
                        0.47,
                        -41.65,
                        0.13,
                        -20.47,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.64,
                        0.64,
                        0.64,
                        -25.32,
                        0.62,
                        -19.62,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.62,
                        0.62,
                        0.62,
                        -10.43,
                        0.00,
                        -28.41,
                        0.02,
                        -0.7,
                        -0.01,
                        0.71,
                        0.42,
                        0.42,
                        0.42,
                        -8.49,
                        0.09,
                        -30.36,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.55,
                        0.55,
                        0.55,
                        4.91,
                        0.10,
                        -28.97,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.94,
                        0.94,
                        0.94,
                        5.92,
                        0.01,
                        -28.7,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.84,
                        0.84,
                        0.84,
                        -10.63,
                        1.16,
                        -35.9,
                        0.02,
                        -0.71,
                        -0.01,
                        0.70,
                        0.67,
                        0.67,
                        0.67,
                        7.48,
                        -0.06,
                        -28.22,
                        0.00,
                        -0.71,
                        0.00,
                        0.71,
                        0.83,
                        0.83,
                        0.83,
                        -12.08,
                        0.40,
                        -49.88,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.77,
                        0.77,
                        0.77,
                        19.21,
                        0.43,
                        -30.81,
                        0.00,
                        -0.71,
                        -0.01,
                        0.71,
                        0.72,
                        0.72,
                        0.72,
                        0.33,
                        0.40,
                        -35.63,
                        0.02,
                        -0.7,
                        -0.01,
                        0.71,
                        0.70,
                        0.70,
                        0.70,
                        -0.8,
                        0.31,
                        -37.94,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.79,
                        0.79,
                        0.79,
                        2.23,
                        0.39,
                        -35.53,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.74,
                        0.74,
                        0.74,
                        31.04,
                        0.20,
                        -8.73,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.79,
                        0.79,
                        0.79,
                        19.32,
                        -0.76,
                        -21.44,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        0.55,
                        0.55,
                        0.55,
                        2.42,
                        0.80,
                        -55.88,
                        0.01,
                        -0.71,
                        0.00,
                        0.70,
                        0.84,
                        0.84,
                        0.84,
                        -11.96,
                        0.88,
                        -33.52,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.92,
                        0.92,
                        0.92,
                        6.54,
                        -0.22,
                        -2.18,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.55,
                        0.55,
                        0.55,
                        0.14,
                        0.43,
                        -37.03,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.78,
                        0.78,
                        0.78,
                        18.93,
                        0.47,
                        -5.54,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.89,
                        0.89,
                        0.89,
                        -2.78,
                        0.15,
                        -39.47,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.48,
                        0.48,
                        0.48,
                        17.78,
                        -0.16,
                        -30.4,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.64,
                        0.64,
                        0.64,
                        31.04,
                        -0.07,
                        -9.93,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.68,
                        0.68,
                        0.68,
                        -14.68,
                        0.74,
                        -44.17,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.87,
                        0.87,
                        0.87,
                        -10.21,
                        -0.01,
                        -28.35,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.82,
                        0.82,
                        0.82,
                        38.09,
                        1.01,
                        -34.1,
                        0.02,
                        -0.71,
                        -0.01,
                        0.70,
                        0.72,
                        0.72,
                        0.72,
                        -16.62,
                        1.42,
                        -42.71,
                        0.02,
                        -0.71,
                        -0.03,
                        0.71,
                        0.94,
                        0.94,
                        0.94,
                        8.96,
                        -0.28,
                        -25.42,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.64,
                        0.64,
                        0.64,
                        4.46,
                        -0.15,
                        -24.59,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.86,
                        0.86,
                        0.86,
                        -1.25,
                        0.97,
                        -52.37,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.81,
                        0.81,
                        0.81,
                        -18.45,
                        1.50,
                        -18.6,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.59,
                        0.59,
                        0.59,
                        2.44,
                        0.50,
                        -57.48,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.80,
                        0.80,
                        0.80,
                        -19.03,
                        1.13,
                        -38.69,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.85,
                        0.85,
                        0.85,
                        -1.25,
                        0.97,
                        -52.37,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.84,
                        0.84,
                        0.84,
                        33.74,
                        -0.08,
                        -33.97,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.86,
                        0.86,
                        0.86,
                        19.72,
                        0.42,
                        -31.52,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.67,
                        0.67,
                        0.67,
                        -23.28,
                        1.05,
                        -21.19,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.70,
                        0.70,
                        0.70,
                        -4.94,
                        -0.22,
                        -27.29,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.84,
                        0.84,
                        0.84,
                        3.34,
                        -0.2,
                        -24.21,
                        0.00,
                        -0.71,
                        0.00,
                        0.70,
                        0.93,
                        0.93,
                        0.93,
                        6.06,
                        0.06,
                        -10.4,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.60,
                        0.60,
                        0.60,
                        39.52,
                        0.08,
                        -27.97,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.84,
                        0.84,
                        0.84,
                        4.83,
                        0.58,
                        -47.49,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.70,
                        0.70,
                        0.70,
                        -10.88,
                        1.10,
                        -35.24,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.60,
                        0.60,
                        0.60,
                        -1.14,
                        0.14,
                        -68.73,
                        0.02,
                        -0.7,
                        -0.01,
                        0.71,
                        0.53,
                        0.53,
                        0.53,
                        -7.14,
                        0.24,
                        -39.34,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.70,
                        0.70,
                        0.70,
                        -24.45,
                        0.76,
                        -19.18,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.60,
                        0.60,
                        0.60,
                        -18.4,
                        1.36,
                        -19.75,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        1.71,
                        -0.5,
                        -20.99,
                        0.00,
                        -0.71,
                        -0.01,
                        0.70,
                        0.55,
                        0.55,
                        0.55,
                        -0.97,
                        1.07,
                        -53.23,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.45,
                        0.45,
                        0.45,
                        -10.19,
                        0.00,
                        -28.77,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.41,
                        0.41,
                        0.41,
                        23.38,
                        0.28,
                        -39.48,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.53,
                        0.53,
                        0.53,
                        1.82,
                        0.35,
                        -28.47,
                        0.03,
                        -0.71,
                        -0.03,
                        0.71,
                        0.53,
                        0.53,
                        0.53,
                        -8.96,
                        0.39,
                        -38.45,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.79,
                        0.79,
                        0.79,
                        -5.35,
                        0.41,
                        -33.35,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.80,
                        0.80,
                        0.80,
                        -15.98,
                        0.58,
                        -45.48,
                        0.02,
                        -0.71,
                        -0.01,
                        0.71,
                        0.71,
                        0.71,
                        0.71,
                        -22.13,
                        0.18,
                        -30.04,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.54,
                        0.54,
                        0.54,
                        6.91,
                        -0.08,
                        -28.39,
                        0.01,
                        -0.71,
                        -0.02,
                        0.70,
                        0.52,
                        0.52,
                        0.52,
                        0.43,
                        0.33,
                        -57.2,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.99,
                        0.99,
                        0.99,
                        -9,
                        1.49,
                        -8.11,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.72,
                        0.72,
                        0.72,
                        -14.25,
                        0.25,
                        -49.15,
                        0.02,
                        -0.71,
                        -0.02,
                        0.71,
                        0.83,
                        0.83,
                        0.83,
                        -13.04,
                        0.18,
                        -50.26,
                        0.00,
                        -0.71,
                        -0.01,
                        0.70,
                        0.56,
                        0.56,
                        0.56,
                        -15.87,
                        0.47,
                        -46.17,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.78,
                        0.78,
                        0.78,
                        -4.28,
                        0.41,
                        -33.98,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.78,
                        0.78,
                        0.78,
                        -14.82,
                        1.21,
                        -16.78,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        0.81,
                        0.81,
                        0.81,
                        7.84,
                        -0.37,
                        -25.22,
                        0.03,
                        -0.7,
                        -0.02,
                        0.71,
                        0.89,
                        0.89,
                        0.89,
                        -20.24,
                        0.04,
                        -51.97,
                        0.03,
                        -0.7,
                        -0.02,
                        0.71,
                        0.45,
                        0.45,
                        0.45,
                        20.16,
                        0.20,
                        -30.13,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.99,
                        0.99,
                        0.99,
                        16.67,
                        -0.59,
                        -11.96,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.84,
                        0.84,
                        0.84,
                        -2.98,
                        0.21,
                        -38.83,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.61,
                        0.61,
                        0.61,
                        5.58,
                        -0.09,
                        -12.3,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.83,
                        0.83,
                        0.83,
                        -21.49,
                        1.30,
                        -21.14,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.45,
                        0.45,
                        0.45,
                        -4.94,
                        0.18,
                        -40.38,
                        0.02,
                        -0.71,
                        -0.03,
                        0.70,
                        0.60,
                        0.60,
                        0.60,
                        -9.73,
                        0.07,
                        -29.86,
                        0.00,
                        -0.7,
                        0.00,
                        0.71,
                        0.73,
                        0.73,
                        0.73,
                        -10.87,
                        1.13,
                        -36.36,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.61,
                        0.61,
                        0.61,
                        -1.18,
                        1.01,
                        -51.81,
                        0.01,
                        -0.7,
                        0.00,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        -12.34,
                        0.39,
                        -49.51,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.72,
                        0.72,
                        0.72,
                        -14.25,
                        0.25,
                        -49.15,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.70,
                        0.70,
                        0.70,
                        -34.57,
                        0.65,
                        -15.68,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        -6.15,
                        0.00,
                        -71.61,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.68,
                        0.68,
                        0.68,
                        -9.72,
                        -0.03,
                        -27.78,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.83,
                        0.83,
                        0.83,
                        4.12,
                        0.66,
                        -31.92,
                        0.00,
                        -0.71,
                        -0.01,
                        0.70,
                        0.59,
                        0.59,
                        0.59,
                        -0.55,
                        0.41,
                        -36.25,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.58,
                        0.58,
                        0.58,
                        -0.2,
                        0.34,
                        -37.91,
                        0.03,
                        -0.7,
                        -0.02,
                        0.71,
                        0.89,
                        0.89,
                        0.89,
                        2.57,
                        0.65,
                        -49.62,
                        0.01,
                        -0.71,
                        0.00,
                        0.70,
                        0.44,
                        0.44,
                        0.44,
                        -41.61,
                        0.29,
                        -19.95,
                        0.02,
                        -0.7,
                        -0.01,
                        0.71,
                        0.58,
                        0.58,
                        0.58,
                        -6.46,
                        0.16,
                        -73.36,
                        0.03,
                        -0.71,
                        -0.03,
                        0.71,
                        0.76,
                        0.76,
                        0.76,
                        2.20,
                        0.59,
                        -33.01,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.71,
                        0.71,
                        0.71,
                        -11.43,
                        1.01,
                        -35.41,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.55,
                        0.55,
                        0.55,
                        4.71,
                        0.62,
                        -47.04,
                        0.03,
                        -0.7,
                        -0.03,
                        0.71,
                        0.98,
                        0.98,
                        0.98,
                        -18.76,
                        1.39,
                        -40.82,
                        0.02,
                        -0.7,
                        -0.02,
                        0.71,
                        0.55,
                        0.55,
                        0.55,
                        -21.14,
                        0.24,
                        -30.38,
                        0.02,
                        -0.7,
                        -0.03,
                        0.71,
                        0.44,
                        0.44,
                        0.44,
                        24.66,
                        -0.22,
                        -36.63,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.93,
                        0.93,
                        0.93,
                        -18.59,
                        1.19,
                        -38.97,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.42,
                        0.42,
                        0.42,
                        -10.01,
                        -0.01,
                        -28.62,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.94,
                        0.94,
                        0.94,
                        -2.49,
                        0.41,
                        -32.76,
                        0.03,
                        -0.71,
                        -0.03,
                        0.70,
                        0.81,
                        0.81,
                        0.81,
                        19.67,
                        0.02,
                        -7.92,
                        0.02,
                        -0.71,
                        -0.03,
                        0.70,
                        0.62,
                        0.62,
                        0.62,
                        -10.8,
                        1.04,
                        -36.69,
                        0.03,
                        -0.71,
                        -0.02,
                        0.70,
                        0.75,
                        0.75,
                        0.75,
                        18.63,
                        0.37,
                        -31.1,
                        0.02,
                        -0.71,
                        -0.01,
                        0.70,
                        0.54,
                        0.54,
                        0.54,
                        37.18,
                        0.44,
                        -31.85,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.81,
                        0.81,
                        0.81,
                        3.51,
                        -0.32,
                        -16.89,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.85,
                        0.85,
                        0.85,
                        17.66,
                        0.13,
                        -31.38,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.45,
                        0.45,
                        0.45,
                        -31.06,
                        0.31,
                        -17.14,
                        0.00,
                        -0.71,
                        0.00,
                        0.70,
                        0.44,
                        0.44,
                        0.44,
                        28.90,
                        -0.21,
                        -9.52,
                        0.00,
                        -0.7,
                        -0.01,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        0.46,
                        0.44,
                        -36.04,
                        0.03,
                        -0.71,
                        -0.02,
                        0.70,
                        0.70,
                        0.70,
                        0.70,
                        -9.32,
                        -0.09,
                        -28.13,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.43,
                        0.43,
                        0.43,
                        -8.2,
                        1.31,
                        -7.72,
                        0.01,
                        -0.71,
                        -0.01,
                        0.71,
                        0.69,
                        0.69,
                        0.69,
                        19.33,
                        -0.52,
                        -18.34,
                        0.01,
                        -0.71,
                        -0.02,
                        0.71,
                        0.47,
                        0.47,
                        0.47,
                        -4.48,
                        -0.28,
                        -23.49,
                        0.03,
                        -0.71,
                        -0.02,
                        0.71,
                        0.49,
                        0.49,
                        0.49,
                        -23.2,
                        0.19,
                        -32.18,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.57,
                        0.57,
                        0.57,
                        7.00,
                        -0.07,
                        -28.66,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.53,
                        0.53,
                        0.53,
                        -40.38,
                        0.53,
                        -17.31,
                        0.01,
                        -0.7,
                        -0.01,
                        0.71,
                        0.76,
                        0.76,
                        0.76,
                        3.99,
                        0.64,
                        -32.31,
                        0.02,
                        -0.71,
                        -0.02,
                        0.70,
                        0.71,
                        0.71,
                        0.71,
                        1.23,
                        0.37,
                        -29.4,
                        0.01,
                        -0.71,
                        0.00,
                        0.71,
                        0.87,
                        0.87,
                        0.87,
                        -8.36,
                        0.33,
                        -38.32,
                        0.01,
                        -0.71,
                        -0.01,
                        0.70,
                        0.42,
                        0.42,
                        0.42
                    ],
                    [
                        28.62,
                        -0.315,
                        -22.02,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        29.31,
                        -0.315,
                        -21.64,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        28.26,
                        -0.315,
                        -21.29,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00,
                        28.96,
                        -0.315,
                        -20.97,
                        0.00,
                        0.00,
                        0.00,
                        1.00,
                        1.00,
                        1.00,
                        1.00
                    ],
                    [
                        7.14,
                        -0.04,
                        -8.9,
                        0.02,
                        -0.67,
                        0.05,
                        0.74,
                        0.79,
                        0.79,
                        0.79,
                        -11.51,
                        0.87,
                        -33.03,
                        0.12,
                        -0.72,
                        0.00,
                        0.68,
                        0.46,
                        0.46,
                        0.46,
                        2.44,
                        0.50,
                        -57.48,
                        -0.03,
                        -0.7,
                        0.07,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        -15.24,
                        0.57,
                        -19.35,
                        0.03,
                        -0.73,
                        -0.02,
                        0.68,
                        0.57,
                        0.57,
                        0.57,
                        8.00,
                        -0.33,
                        -25.23,
                        0.04,
                        -0.66,
                        0.05,
                        0.75,
                        0.87,
                        0.87,
                        0.87,
                        9.45,
                        0.07,
                        -38.19,
                        0.05,
                        -0.6,
                        0.00,
                        0.80,
                        0.94,
                        0.94,
                        0.94,
                        -1.31,
                        0.44,
                        -32.96,
                        -0.11,
                        -0.73,
                        -0.07,
                        0.67,
                        0.60,
                        0.60,
                        0.60,
                        -8.18,
                        0.20,
                        -39.82,
                        -0.11,
                        -0.66,
                        0.05,
                        0.74,
                        0.61,
                        0.61,
                        0.61,
                        -7.52,
                        1.14,
                        -8.9,
                        0.01,
                        -0.73,
                        0.05,
                        0.68,
                        0.62,
                        0.62,
                        0.62,
                        3.83,
                        0.63,
                        -32.39,
                        0.01,
                        -0.62,
                        -0.06,
                        0.78,
                        0.83,
                        0.83,
                        0.83,
                        -4.28,
                        0.41,
                        -33.98,
                        -0.04,
                        -0.65,
                        -0.09,
                        0.75,
                        0.94,
                        0.94,
                        0.94,
                        -1.28,
                        0.25,
                        -38.35,
                        0.02,
                        -0.71,
                        -0.13,
                        0.69,
                        0.47,
                        0.47,
                        0.47,
                        19.70,
                        0.43,
                        -31.48,
                        0.05,
                        -0.7,
                        -0.04,
                        0.71,
                        0.73,
                        0.73,
                        0.73,
                        -26.68,
                        0.16,
                        -64.42,
                        -0.01,
                        -0.77,
                        0.01,
                        0.64,
                        0.79,
                        0.79,
                        0.79,
                        -17.79,
                        1.42,
                        -18.61,
                        -0.08,
                        -0.77,
                        -0.07,
                        0.63,
                        0.81,
                        0.81,
                        0.81,
                        5.30,
                        -0.19,
                        -24.44,
                        -0.14,
                        -0.66,
                        0.00,
                        0.74,
                        0.42,
                        0.42,
                        0.42,
                        -21.44,
                        0.25,
                        -28.97,
                        -0.02,
                        -0.73,
                        0.08,
                        0.68,
                        0.78,
                        0.78,
                        0.78,
                        -42.26,
                        0.43,
                        -20.55,
                        0.00,
                        -0.74,
                        -0.06,
                        0.67,
                        0.88,
                        0.88,
                        0.88,
                        -5.6,
                        0.41,
                        -33.9,
                        0.09,
                        -0.69,
                        0.01,
                        0.72,
                        0.53,
                        0.53,
                        0.53,
                        0.90,
                        -0.56,
                        -21.12,
                        -0.07,
                        -0.66,
                        0.04,
                        0.75,
                        0.64,
                        0.64,
                        0.64,
                        -23.47,
                        0.04,
                        -30.88,
                        0.03,
                        -0.73,
                        0.06,
                        0.68,
                        0.71,
                        0.71,
                        0.71,
                        1.34,
                        -0.53,
                        -18.91,
                        0.03,
                        -0.67,
                        -0.11,
                        0.73,
                        0.77,
                        0.77,
                        0.77,
                        -21.94,
                        1.22,
                        -20.26,
                        0.01,
                        -0.75,
                        -0.05,
                        0.65,
                        0.64,
                        0.64,
                        0.64,
                        9.68,
                        0.30,
                        -39.42,
                        0.09,
                        -0.73,
                        0.04,
                        0.68,
                        0.97,
                        0.97,
                        0.97,
                        7.68,
                        -0.12,
                        -27.69,
                        -0.03,
                        -0.63,
                        0.07,
                        0.78,
                        0.61,
                        0.61,
                        0.61,
                        17.23,
                        0.14,
                        -31.89,
                        0.07,
                        -0.65,
                        0.04,
                        0.75,
                        0.57,
                        0.57,
                        0.57,
                        40.47,
                        0.76,
                        -30.02,
                        -0.09,
                        -0.62,
                        0.00,
                        0.78,
                        0.61,
                        0.61,
                        0.61,
                        29.98,
                        0.51,
                        -39.42,
                        0.03,
                        -0.68,
                        0.10,
                        0.72,
                        0.43,
                        0.43,
                        0.43,
                        7.05,
                        0.69,
                        -44.78,
                        0.08,
                        -0.65,
                        -0.04,
                        0.75,
                        0.51,
                        0.51,
                        0.51,
                        17.40,
                        0.78,
                        -35.96,
                        -0.06,
                        -0.75,
                        -0.02,
                        0.66,
                        0.74,
                        0.74,
                        0.74,
                        -19.95,
                        0.50,
                        -32.99,
                        -0.11,
                        -0.65,
                        -0.01,
                        0.75,
                        0.70,
                        0.70,
                        0.70,
                        -2.39,
                        0.39,
                        -31.85,
                        0.00,
                        -0.71,
                        0.10,
                        0.70,
                        0.95,
                        0.95,
                        0.95,
                        7.32,
                        -0.1,
                        -27.9,
                        0.04,
                        -0.72,
                        -0.06,
                        0.69,
                        0.47,
                        0.47,
                        0.47,
                        -10.89,
                        1.04,
                        -34.74,
                        0.02,
                        -0.65,
                        0.01,
                        0.76,
                        0.58,
                        0.58,
                        0.58,
                        -2.78,
                        -0.13,
                        -25.95,
                        -0.1,
                        -0.76,
                        -0.06,
                        0.64,
                        0.59,
                        0.59,
                        0.59,
                        18.62,
                        0.52,
                        -31.96,
                        -0.11,
                        -0.76,
                        0.02,
                        0.64,
                        0.85,
                        0.85,
                        0.85,
                        5.95,
                        0.65,
                        -45.61,
                        -0.08,
                        -0.74,
                        -0.01,
                        0.67,
                        0.66,
                        0.66,
                        0.66,
                        -1.46,
                        0.08,
                        -64.73,
                        -0.08,
                        -0.64,
                        0.02,
                        0.76,
                        0.59,
                        0.59,
                        0.59,
                        -10.52,
                        0.03,
                        -28.85,
                        0.03,
                        -0.74,
                        0.08,
                        0.66,
                        0.63,
                        0.63,
                        0.63,
                        -28.41,
                        0.07,
                        -38.51,
                        0.02,
                        -0.67,
                        -0.11,
                        0.74,
                        0.66,
                        0.66,
                        0.66,
                        -16.72,
                        0.41,
                        -48.18,
                        0.01,
                        -0.66,
                        -0.06,
                        0.75,
                        0.82,
                        0.82,
                        0.82,
                        2.63,
                        0.44,
                        -34.81,
                        -0.02,
                        -0.76,
                        -0.08,
                        0.65,
                        0.75,
                        0.75,
                        0.75,
                        -5.67,
                        0.73,
                        -8.26,
                        0.12,
                        -0.69,
                        0.01,
                        0.71,
                        0.54,
                        0.54,
                        0.54,
                        -17.95,
                        1.45,
                        -41.17,
                        -0.07,
                        -0.7,
                        0.05,
                        0.71,
                        0.86,
                        0.86,
                        0.86,
                        -6.24,
                        0.27,
                        -39.24,
                        0.00,
                        -0.69,
                        0.02,
                        0.72,
                        0.99,
                        0.99,
                        0.99,
                        -10.73,
                        0.73,
                        -3.62,
                        0.08,
                        -0.65,
                        0.02,
                        0.75,
                        0.62,
                        0.62,
                        0.62,
                        -19.71,
                        0.83,
                        -36.1,
                        -0.05,
                        -0.61,
                        0.00,
                        0.79,
                        0.93,
                        0.93,
                        0.93,
                        1.93,
                        0.52,
                        -56.92,
                        0.06,
                        -0.75,
                        0.10,
                        0.65,
                        0.46,
                        0.46,
                        0.46,
                        -10.68,
                        1.06,
                        -36.54,
                        0.03,
                        -0.72,
                        -0.13,
                        0.68,
                        0.48,
                        0.48,
                        0.48,
                        17.87,
                        0.74,
                        -35.71,
                        0.05,
                        -0.66,
                        -0.02,
                        0.75,
                        0.68,
                        0.68,
                        0.68,
                        20.34,
                        0.11,
                        -29.68,
                        -0.07,
                        -0.65,
                        -0.03,
                        0.76,
                        0.76,
                        0.76,
                        0.76,
                        -6.66,
                        0.24,
                        -39.67,
                        0.00,
                        -0.64,
                        0.10,
                        0.76,
                        0.49,
                        0.49,
                        0.49,
                        -13.62,
                        0.81,
                        -16.89,
                        0.09,
                        -0.66,
                        0.01,
                        0.74,
                        0.86,
                        0.86,
                        0.86,
                        -16.41,
                        1.13,
                        -18.46,
                        -0.09,
                        -0.67,
                        0.01,
                        0.74,
                        0.49,
                        0.49,
                        0.49,
                        -9.78,
                        -0.03,
                        -27.69,
                        0.00,
                        -0.72,
                        0.08,
                        0.69,
                        0.85,
                        0.85,
                        0.85,
                        -8.64,
                        0.01,
                        -29.83,
                        0.03,
                        -0.69,
                        -0.07,
                        0.72,
                        1.00,
                        1.00,
                        1.00,
                        -6.15,
                        0.00,
                        -71.61,
                        0.01,
                        -0.64,
                        -0.03,
                        0.76,
                        0.91,
                        0.91,
                        0.91,
                        -20.96,
                        1.14,
                        -21.44,
                        -0.06,
                        -0.66,
                        -0.09,
                        0.74,
                        0.86,
                        0.86,
                        0.86,
                        -2.96,
                        0.22,
                        -38.67,
                        0.04,
                        -0.72,
                        -0.13,
                        0.68,
                        0.96,
                        0.96,
                        0.96,
                        3.70,
                        -0.24,
                        -23.8,
                        0.05,
                        -0.7,
                        -0.02,
                        0.71,
                        0.42,
                        0.42,
                        0.42,
                        -25.53,
                        0.24,
                        -56.41,
                        -0.03,
                        -0.77,
                        0.02,
                        0.64,
                        0.76,
                        0.76,
                        0.76,
                        2.37,
                        0.60,
                        -33.17,
                        -0.07,
                        -0.64,
                        -0.06,
                        0.77,
                        0.75,
                        0.75,
                        0.75,
                        6.25,
                        0.61,
                        -45.86,
                        0.00,
                        -0.67,
                        0.15,
                        0.72,
                        0.64,
                        0.64,
                        0.64,
                        -9.24,
                        0.33,
                        -30.93,
                        0.06,
                        -0.66,
                        -0.03,
                        0.75,
                        0.78,
                        0.78,
                        0.78,
                        18.40,
                        0.64,
                        -33.63,
                        -0.06,
                        -0.75,
                        -0.03,
                        0.66,
                        0.96,
                        0.96,
                        0.96,
                        -18.26,
                        0.16,
                        -50.61,
                        -0.12,
                        -0.66,
                        0.00,
                        0.75,
                        0.87,
                        0.87,
                        0.87,
                        7.14,
                        -0.14,
                        -27.27,
                        -0.01,
                        -0.7,
                        0.09,
                        0.71,
                        0.63,
                        0.63,
                        0.63,
                        -9.8,
                        -0.02,
                        -28.6,
                        0.04,
                        -0.64,
                        -0.03,
                        0.76,
                        0.94,
                        0.94,
                        0.94,
                        3.04,
                        -0.27,
                        -23.54,
                        -0.06,
                        -0.76,
                        -0.05,
                        0.64,
                        0.95,
                        0.95,
                        0.95,
                        2.13,
                        -0.46,
                        -20.4,
                        -0.13,
                        -0.75,
                        -0.01,
                        0.64,
                        0.42,
                        0.42,
                        0.42,
                        -17.06,
                        1.28,
                        -18.56,
                        -0.09,
                        -0.73,
                        0.01,
                        0.67,
                        0.94,
                        0.94,
                        0.94,
                        -26.06,
                        0.42,
                        -17.7,
                        -0.07,
                        -0.66,
                        0.01,
                        0.75,
                        0.92,
                        0.92,
                        0.92,
                        -13.7,
                        0.46,
                        -48.06,
                        0.02,
                        -0.66,
                        0.08,
                        0.75,
                        0.80,
                        0.80,
                        0.80,
                        15.28,
                        -0.27,
                        -4.78,
                        0.11,
                        -0.7,
                        -0.01,
                        0.71,
                        0.76,
                        0.76,
                        0.76,
                        7.84,
                        -0.37,
                        -25.22,
                        -0.05,
                        -0.74,
                        0.04,
                        0.66,
                        0.97,
                        0.97,
                        0.97,
                        -9.25,
                        -0.14,
                        -26.98,
                        -0.05,
                        -0.75,
                        -0.04,
                        0.66,
                        0.85,
                        0.85,
                        0.85,
                        -34.37,
                        0.29,
                        -17.1,
                        -0.11,
                        -0.63,
                        -0.01,
                        0.77,
                        0.64,
                        0.64,
                        0.64,
                        -41.08,
                        -0.1,
                        -20.16,
                        0.01,
                        -0.69,
                        0.10,
                        0.72,
                        0.72,
                        0.72,
                        0.72,
                        5.07,
                        -0.17,
                        -24.55,
                        0.08,
                        -0.71,
                        -0.04,
                        0.69,
                        0.50,
                        0.50,
                        0.50,
                        -24.43,
                        0.13,
                        -71.16,
                        -0.01,
                        -0.75,
                        0.03,
                        0.66,
                        0.51,
                        0.51,
                        0.51,
                        -9.58,
                        0.41,
                        -38.79,
                        -0.05,
                        -0.77,
                        -0.08,
                        0.64,
                        0.77,
                        0.77,
                        0.77,
                        -0.83,
                        1.08,
                        -52.1,
                        0.10,
                        -0.63,
                        0.00,
                        0.77,
                        0.52,
                        0.52,
                        0.52,
                        -15.92,
                        1.23,
                        -17.64,
                        -0.1,
                        -0.7,
                        -0.01,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        0.94,
                        -0.56,
                        -21.13,
                        -0.06,
                        -0.69,
                        0.07,
                        0.72,
                        0.85,
                        0.85,
                        0.85,
                        -43.26,
                        0.61,
                        -21.87,
                        0.02,
                        -0.75,
                        0.01,
                        0.66,
                        0.68,
                        0.68,
                        0.68,
                        4.77,
                        0.11,
                        -28.59,
                        0.08,
                        -0.68,
                        0.12,
                        0.72,
                        0.96,
                        0.96,
                        0.96,
                        0.73,
                        -0.26,
                        -24.26,
                        0.11,
                        -0.7,
                        -0.08,
                        0.70,
                        0.43,
                        0.43,
                        0.43,
                        36.65,
                        0.53,
                        -32.98,
                        -0.01,
                        -0.76,
                        0.01,
                        0.66,
                        0.94,
                        0.94,
                        0.94,
                        -41.93,
                        0.42,
                        -37.53,
                        -0.09,
                        -0.73,
                        -0.09,
                        0.67,
                        0.53,
                        0.53,
                        0.53,
                        -9.92,
                        -0.01,
                        -28.61,
                        0.11,
                        -0.77,
                        -0.05,
                        0.63,
                        0.45,
                        0.45,
                        0.45,
                        -6.86,
                        0.24,
                        -39.28,
                        0.02,
                        -0.65,
                        0.06,
                        0.76,
                        0.93,
                        0.93,
                        0.93,
                        1.54,
                        0.49,
                        -34.74,
                        0.12,
                        -0.75,
                        0.02,
                        0.66,
                        0.68,
                        0.68,
                        0.68,
                        -22.55,
                        0.17,
                        -28.92,
                        -0.02,
                        -0.65,
                        0.08,
                        0.76,
                        0.91,
                        0.91,
                        0.91,
                        19.19,
                        -0.78,
                        -21.94,
                        0.08,
                        -0.66,
                        0.02,
                        0.75,
                        0.48,
                        0.48,
                        0.48,
                        7.01,
                        -0.09,
                        -28.12,
                        -0.11,
                        -0.72,
                        0.01,
                        0.68,
                        0.43,
                        0.43,
                        0.43,
                        30.10,
                        0.21,
                        -37.47,
                        -0.06,
                        -0.76,
                        0.03,
                        0.65,
                        0.79,
                        0.79,
                        0.79,
                        3.97,
                        -0.28,
                        -15.86,
                        -0.08,
                        -0.68,
                        -0.04,
                        0.73,
                        0.75,
                        0.75,
                        0.75,
                        -23.1,
                        0.16,
                        -28.64,
                        -0.05,
                        -0.71,
                        0.12,
                        0.69,
                        0.90,
                        0.90,
                        0.90,
                        32.63,
                        -0.07,
                        -34.85,
                        0.01,
                        -0.73,
                        -0.03,
                        0.68,
                        0.50,
                        0.50,
                        0.50,
                        -2.83,
                        0.16,
                        -39.46,
                        0.05,
                        -0.63,
                        0.02,
                        0.78,
                        0.98,
                        0.98,
                        0.98,
                        -9.12,
                        0.72,
                        -36.58,
                        -0.09,
                        -0.77,
                        -0.03,
                        0.63,
                        0.73,
                        0.73,
                        0.73,
                        -3.46,
                        0.15,
                        -39.91,
                        -0.11,
                        -0.75,
                        -0.01,
                        0.66,
                        0.66,
                        0.66,
                        0.66,
                        23.20,
                        -0.52,
                        -8.03,
                        -0.1,
                        -0.71,
                        0.01,
                        0.70,
                        0.48,
                        0.48,
                        0.48,
                        -29.02,
                        0.26,
                        -41.34,
                        -0.04,
                        -0.65,
                        0.03,
                        0.76,
                        0.75,
                        0.75,
                        0.75,
                        -34.05,
                        0.40,
                        -16.83,
                        0.05,
                        -0.75,
                        0.06,
                        0.65,
                        0.71,
                        0.71,
                        0.71,
                        -24.83,
                        0.59,
                        -21.57,
                        0.01,
                        -0.76,
                        -0.12,
                        0.64,
                        0.90,
                        0.90,
                        0.90,
                        -2.32,
                        0.15,
                        -70.39,
                        0.09,
                        -0.73,
                        0.00,
                        0.68,
                        0.64,
                        0.64,
                        0.64,
                        7.42,
                        -0.35,
                        -26.05,
                        -0.02,
                        -0.75,
                        0.07,
                        0.66,
                        0.53,
                        0.53,
                        0.53,
                        -8.19,
                        0.28,
                        -38.75,
                        -0.02,
                        -0.75,
                        -0.07,
                        0.66,
                        0.94,
                        0.94,
                        0.94,
                        -1.92,
                        0.80,
                        -51.51,
                        0.12,
                        -0.68,
                        -0.01,
                        0.72,
                        0.86,
                        0.86,
                        0.86,
                        4.17,
                        -0.16,
                        -13.79,
                        -0.06,
                        -0.67,
                        0.03,
                        0.74,
                        0.46,
                        0.46,
                        0.46,
                        -2.23,
                        0.42,
                        -32.45,
                        0.02,
                        -0.68,
                        0.07,
                        0.73,
                        0.93,
                        0.93,
                        0.93,
                        7.74,
                        -0.39,
                        -25.27,
                        0.09,
                        -0.64,
                        -0.02,
                        0.77,
                        0.62,
                        0.62,
                        0.62,
                        -6.11,
                        -0.32,
                        -25.24,
                        -0.08,
                        -0.67,
                        -0.03,
                        0.74,
                        0.99,
                        0.99,
                        0.99,
                        -23.34,
                        1.02,
                        -21.29,
                        -0.02,
                        -0.73,
                        0.11,
                        0.68,
                        0.81,
                        0.81,
                        0.81,
                        16.20,
                        0.97,
                        -38.78,
                        0.02,
                        -0.7,
                        -0.06,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        28.30,
                        -0.26,
                        -8.65,
                        0.02,
                        -0.69,
                        -0.05,
                        0.72,
                        0.59,
                        0.59,
                        0.59,
                        -35.03,
                        0.32,
                        -40.03,
                        0.00,
                        -0.76,
                        -0.04,
                        0.65,
                        0.93,
                        0.93,
                        0.93,
                        7.01,
                        -0.35,
                        -21.2,
                        0.05,
                        -0.79,
                        0.02,
                        0.61,
                        0.44,
                        0.44,
                        0.44,
                        -3.86,
                        0.13,
                        -40.34,
                        0.06,
                        -0.68,
                        0.13,
                        0.72,
                        0.91,
                        0.91,
                        0.91,
                        -3.21,
                        -0.12,
                        -27.55,
                        0.08,
                        -0.76,
                        -0.05,
                        0.64,
                        0.67,
                        0.67,
                        0.67,
                        16.99,
                        -0.64,
                        -13.13,
                        0.04,
                        -0.68,
                        0.06,
                        0.73,
                        0.43,
                        0.43,
                        0.43,
                        -38.31,
                        -0.05,
                        -18.23,
                        0.13,
                        -0.68,
                        -0.04,
                        0.72,
                        0.46,
                        0.46,
                        0.46,
                        -9.64,
                        -0.03,
                        -28.26,
                        -0.04,
                        -0.65,
                        0.02,
                        0.76,
                        0.97,
                        0.97,
                        0.97,
                        14.91,
                        -0.59,
                        -12.85,
                        0.05,
                        -0.76,
                        0.07,
                        0.65,
                        0.84,
                        0.84,
                        0.84,
                        -11.18,
                        1.06,
                        -35.37,
                        0.01,
                        -0.73,
                        -0.13,
                        0.67,
                        0.97,
                        0.97,
                        0.97,
                        -26.21,
                        0.13,
                        -63.66,
                        0.06,
                        -0.65,
                        -0.02,
                        0.75,
                        0.47,
                        0.47,
                        0.47,
                        -25.55,
                        0.52,
                        -19.98,
                        -0.08,
                        -0.71,
                        -0.03,
                        0.70,
                        0.80,
                        0.80,
                        0.80,
                        18.79,
                        0.33,
                        -30.7,
                        -0.08,
                        -0.75,
                        0.06,
                        0.66,
                        0.91,
                        0.91,
                        0.91,
                        -1.23,
                        1.14,
                        -50.58,
                        -0.04,
                        -0.74,
                        -0.03,
                        0.67,
                        0.59,
                        0.59,
                        0.59,
                        -11.55,
                        0.46,
                        -51.84,
                        -0.14,
                        -0.73,
                        -0.01,
                        0.67,
                        0.94,
                        0.94,
                        0.94,
                        -3.08,
                        0.20,
                        -39.15,
                        -0.08,
                        -0.67,
                        0.03,
                        0.74,
                        0.87,
                        0.87,
                        0.87,
                        -5.14,
                        -0.26,
                        -26.91,
                        0.01,
                        -0.69,
                        0.06,
                        0.72,
                        0.80,
                        0.80,
                        0.80,
                        -22.03,
                        0.44,
                        -28.22,
                        0.06,
                        -0.77,
                        -0.03,
                        0.63,
                        0.74,
                        0.74,
                        0.74,
                        -2.9,
                        -0.37,
                        -23.09,
                        0.05,
                        -0.69,
                        0.08,
                        0.72,
                        0.75,
                        0.75,
                        0.75,
                        -16.48,
                        1.39,
                        -41.87,
                        0.08,
                        -0.77,
                        -0.05,
                        0.63,
                        0.60,
                        0.60,
                        0.60,
                        5.37,
                        -0.19,
                        -3.97,
                        0.04,
                        -0.74,
                        0.06,
                        0.67,
                        0.44,
                        0.44,
                        0.44,
                        -1.25,
                        0.97,
                        -52.37,
                        0.03,
                        -0.73,
                        -0.13,
                        0.67,
                        0.76,
                        0.76,
                        0.76,
                        -0.33,
                        1.22,
                        -51.65,
                        0.05,
                        -0.76,
                        -0.01,
                        0.64,
                        0.97,
                        0.97,
                        0.97,
                        -17.71,
                        1.46,
                        -43.81,
                        0.04,
                        -0.76,
                        0.08,
                        0.65,
                        0.57,
                        0.57,
                        0.57,
                        31.09,
                        0.57,
                        -39.05,
                        0.01,
                        -0.65,
                        -0.11,
                        0.75,
                        0.75,
                        0.75,
                        0.75,
                        1.83,
                        0.70,
                        -48.74,
                        0.00,
                        -0.74,
                        -0.08,
                        0.67,
                        0.96,
                        0.96,
                        0.96,
                        0.14,
                        0.21,
                        -57.83,
                        0.08,
                        -0.75,
                        -0.01,
                        0.66,
                        0.92,
                        0.92,
                        0.92,
                        3.76,
                        0.65,
                        -32.1,
                        0.01,
                        -0.69,
                        0.09,
                        0.72,
                        0.60,
                        0.60,
                        0.60,
                        19.23,
                        -0.68,
                        -23.46,
                        0.08,
                        -0.74,
                        -0.04,
                        0.67,
                        0.97,
                        0.97,
                        0.97,
                        -1.94,
                        0.42,
                        -32.99,
                        0.02,
                        -0.71,
                        0.06,
                        0.70,
                        0.67,
                        0.67,
                        0.67,
                        -25.75,
                        0.06,
                        -62.92,
                        0.04,
                        -0.64,
                        -0.07,
                        0.76,
                        0.87,
                        0.87,
                        0.87,
                        19.01,
                        -0.49,
                        -19.29,
                        -0.04,
                        -0.69,
                        -0.07,
                        0.72,
                        0.52,
                        0.52,
                        0.52,
                        20.81,
                        0.46,
                        -37.73,
                        0.05,
                        -0.66,
                        -0.11,
                        0.74,
                        0.78,
                        0.78,
                        0.78,
                        -13.58,
                        1.36,
                        -14.61,
                        -0.01,
                        -0.77,
                        -0.04,
                        0.64,
                        0.82,
                        0.82,
                        0.82,
                        -10.14,
                        -0,
                        -28.58,
                        0.09,
                        -0.63,
                        0.05,
                        0.77,
                        0.67,
                        0.67,
                        0.67,
                        -0.13,
                        -0.58,
                        -21.54,
                        -0.13,
                        -0.69,
                        0.00,
                        0.71,
                        0.54,
                        0.54,
                        0.54,
                        19.60,
                        0.02,
                        -7.99,
                        -0.04,
                        -0.75,
                        0.05,
                        0.65,
                        0.74,
                        0.74,
                        0.74,
                        -40.02,
                        -0.06,
                        -19.13,
                        -0.05,
                        -0.75,
                        -0.05,
                        0.66,
                        0.89,
                        0.89,
                        0.89,
                        -21.73,
                        0.43,
                        -28.3,
                        0.15,
                        -0.71,
                        -0.01,
                        0.68,
                        0.83,
                        0.83,
                        0.83,
                        -19.15,
                        0.84,
                        -35.71,
                        -0.03,
                        -0.66,
                        0.05,
                        0.75,
                        0.63,
                        0.63,
                        0.63,
                        3.36,
                        0.46,
                        -34.31,
                        0.06,
                        -0.69,
                        0.04,
                        0.72,
                        0.47,
                        0.47,
                        0.47,
                        -17.15,
                        1.28,
                        -18.64,
                        -0.1,
                        -0.65,
                        0.07,
                        0.75,
                        0.50,
                        0.50,
                        0.50,
                        -0.76,
                        0.29,
                        -56.92,
                        0.02,
                        -0.76,
                        0.04,
                        0.65,
                        0.49,
                        0.49,
                        0.49,
                        1.18,
                        0.28,
                        -57.97,
                        -0.05,
                        -0.68,
                        -0.13,
                        0.72,
                        0.90,
                        0.90,
                        0.90,
                        -19.17,
                        1.25,
                        -39.92,
                        0.06,
                        -0.71,
                        -0.1,
                        0.69,
                        0.94,
                        0.94,
                        0.94,
                        -29.63,
                        0.08,
                        -38.84,
                        0.03,
                        -0.73,
                        -0.01,
                        0.68,
                        0.62,
                        0.62,
                        0.62,
                        19.17,
                        -0.41,
                        -9.83,
                        0.03,
                        -0.64,
                        0.07,
                        0.76,
                        0.56,
                        0.56,
                        0.56,
                        -27.03,
                        0.21,
                        -59.28,
                        0.10,
                        -0.64,
                        0.01,
                        0.76,
                        0.67,
                        0.67,
                        0.67,
                        -9.96,
                        0.02,
                        -29.24,
                        -0.08,
                        -0.64,
                        0.00,
                        0.77,
                        0.56,
                        0.56,
                        0.56,
                        -10.21,
                        0.89,
                        -36.98,
                        0.02,
                        -0.72,
                        0.10,
                        0.68,
                        0.66,
                        0.66,
                        0.66,
                        10.82,
                        0.19,
                        -38.42,
                        0.04,
                        -0.75,
                        -0.08,
                        0.65,
                        0.63,
                        0.63,
                        0.63,
                        5.89,
                        0.03,
                        -29.01,
                        0.07,
                        -0.71,
                        0.03,
                        0.70,
                        0.94,
                        0.94,
                        0.94,
                        -4.96,
                        -0.19,
                        -27.88,
                        -0.07,
                        -0.72,
                        0.09,
                        0.69,
                        0.46,
                        0.46,
                        0.46,
                        -11.81,
                        0.46,
                        -51.49,
                        0.00,
                        -0.73,
                        -0.02,
                        0.68,
                        0.68,
                        0.68,
                        0.68,
                        -1.43,
                        0.44,
                        -32.68,
                        0.04,
                        -0.6,
                        0.01,
                        0.80,
                        0.45,
                        0.45,
                        0.45,
                        6.05,
                        0.57,
                        -46.49,
                        -0.12,
                        -0.68,
                        -0.07,
                        0.72,
                        0.93,
                        0.93,
                        0.93,
                        19.02,
                        -0.71,
                        -21.09,
                        -0.08,
                        -0.7,
                        0.11,
                        0.70,
                        0.76,
                        0.76,
                        0.76,
                        -23.31,
                        0.33,
                        -52.12,
                        0.01,
                        -0.75,
                        -0.01,
                        0.66,
                        0.50,
                        0.50,
                        0.50,
                        -8.63,
                        0.27,
                        -39.43,
                        0.09,
                        -0.74,
                        0.09,
                        0.67,
                        0.75,
                        0.75,
                        0.75,
                        21.18,
                        -0.35,
                        -29.12,
                        0.05,
                        -0.77,
                        -0.1,
                        0.62,
                        0.83,
                        0.83,
                        0.83,
                        39.27,
                        0.68,
                        -30.5,
                        0.06,
                        -0.65,
                        0.03,
                        0.76,
                        0.96,
                        0.96,
                        0.96,
                        -11.41,
                        1.02,
                        -35.47,
                        -0.13,
                        -0.73,
                        -0.01,
                        0.68,
                        0.78,
                        0.78,
                        0.78,
                        -28.15,
                        0.05,
                        -18.33,
                        -0.08,
                        -0.68,
                        0.04,
                        0.73,
                        0.67,
                        0.67,
                        0.67,
                        11.38,
                        0.08,
                        -37.48,
                        0.01,
                        -0.7,
                        0.05,
                        0.72,
                        0.62,
                        0.62,
                        0.62,
                        11.38,
                        0.08,
                        -37.48,
                        0.08,
                        -0.73,
                        -0.04,
                        0.68,
                        0.83,
                        0.83,
                        0.83,
                        -30.14,
                        0.06,
                        -38.64,
                        0.01,
                        -0.76,
                        0.04,
                        0.64,
                        0.58,
                        0.58,
                        0.58,
                        -26.25,
                        0.40,
                        -18.73,
                        -0.03,
                        -0.62,
                        -0.07,
                        0.78,
                        0.52,
                        0.52,
                        0.52,
                        -16.6,
                        1.20,
                        -18.45,
                        -0.02,
                        -0.66,
                        -0.12,
                        0.74,
                        0.64,
                        0.64,
                        0.64,
                        -16.06,
                        0.86,
                        -18.96,
                        0.02,
                        -0.65,
                        -0.09,
                        0.75,
                        0.88,
                        0.88,
                        0.88,
                        -4.3,
                        0.35,
                        -36.23,
                        -0.02,
                        -0.66,
                        -0.07,
                        0.75,
                        0.73,
                        0.73,
                        0.73,
                        -20.15,
                        1.39,
                        -20.9,
                        0.00,
                        -0.66,
                        -0.1,
                        0.75,
                        0.73,
                        0.73,
                        0.73,
                        -23,
                        1.08,
                        -21.42,
                        0.00,
                        -0.65,
                        -0.07,
                        0.76,
                        0.64,
                        0.64,
                        0.64,
                        16.85,
                        0.38,
                        -6.35,
                        -0.02,
                        -0.67,
                        -0.09,
                        0.74,
                        0.96,
                        0.96,
                        0.96,
                        6.37,
                        -0.22,
                        -2.05,
                        0.02,
                        -0.74,
                        -0.1,
                        0.67,
                        0.75,
                        0.75,
                        0.75,
                        -6.27,
                        0.38,
                        -31.57,
                        0.06,
                        -0.66,
                        0.00,
                        0.75,
                        0.70,
                        0.70,
                        0.70,
                        17.25,
                        0.80,
                        -36.27,
                        -0.09,
                        -0.65,
                        -0.02,
                        0.75,
                        0.49,
                        0.49,
                        0.49,
                        1.46,
                        0.88,
                        -55.41,
                        -0.01,
                        -0.7,
                        0.11,
                        0.70,
                        0.62,
                        0.62,
                        0.62,
                        -1.12,
                        1.00,
                        -55.18,
                        0.05,
                        -0.75,
                        -0.05,
                        0.66,
                        0.92,
                        0.92,
                        0.92,
                        14.31,
                        -0.57,
                        -13.42,
                        0.05,
                        -0.73,
                        0.05,
                        0.69,
                        0.44,
                        0.44,
                        0.44,
                        -5.13,
                        0.28,
                        -39.39,
                        -0.06,
                        -0.74,
                        0.13,
                        0.66,
                        0.80,
                        0.80,
                        0.80,
                        2.60,
                        0.37,
                        -35.46,
                        0.00,
                        -0.76,
                        -0.04,
                        0.64,
                        0.82,
                        0.82,
                        0.82,
                        -16.72,
                        0.83,
                        -19.75,
                        0.09,
                        -0.64,
                        0.05,
                        0.76,
                        0.67,
                        0.67,
                        0.67,
                        -8.63,
                        0.42,
                        -31.34,
                        -0.11,
                        -0.65,
                        0.01,
                        0.75,
                        0.65,
                        0.65,
                        0.65,
                        -16.02,
                        0.60,
                        -45.46,
                        0.00,
                        -0.74,
                        0.08,
                        0.67,
                        0.56,
                        0.56,
                        0.56,
                        -3.71,
                        0.15,
                        -39.95,
                        0.00,
                        -0.74,
                        -0.09,
                        0.67,
                        0.49,
                        0.49,
                        0.49,
                        28.45,
                        -0.06,
                        -36.84,
                        0.08,
                        -0.72,
                        -0.01,
                        0.69,
                        0.58,
                        0.58,
                        0.58,
                        -26.96,
                        -0,
                        -37.09,
                        -0.02,
                        -0.75,
                        0.05,
                        0.65,
                        0.52,
                        0.52,
                        0.52,
                        -26.7,
                        0.26,
                        -39.19,
                        -0.04,
                        -0.76,
                        -0.07,
                        0.65,
                        0.52,
                        0.52,
                        0.52,
                        2.98,
                        0.70,
                        -56.83,
                        0.13,
                        -0.71,
                        0.00,
                        0.69,
                        0.54,
                        0.54,
                        0.54,
                        -2.29,
                        0.72,
                        -52.84,
                        -0.04,
                        -0.74,
                        0.06,
                        0.67,
                        0.44,
                        0.44,
                        0.44,
                        -5.58,
                        0.09,
                        -72.2,
                        -0.02,
                        -0.75,
                        -0.04,
                        0.66,
                        0.53,
                        0.53,
                        0.53,
                        8.34,
                        -0.16,
                        -27.27,
                        0.11,
                        -0.76,
                        0.02,
                        0.64,
                        0.87,
                        0.87,
                        0.87,
                        -26.23,
                        0.18,
                        -69.74,
                        0.00,
                        -0.72,
                        0.11,
                        0.69,
                        0.45,
                        0.45,
                        0.45,
                        -10.69,
                        0.10,
                        -29.5,
                        0.03,
                        -0.76,
                        -0.05,
                        0.65,
                        0.47,
                        0.47,
                        0.47,
                        -5.08,
                        0.16,
                        -72.41,
                        0.08,
                        -0.69,
                        0.05,
                        0.72,
                        0.71,
                        0.71,
                        0.71,
                        16.86,
                        0.12,
                        -32.19,
                        -0.08,
                        -0.77,
                        0.05,
                        0.63,
                        0.92,
                        0.92,
                        0.92,
                        0.25,
                        0.66,
                        -56.34,
                        -0.07,
                        -0.7,
                        -0.04,
                        0.71,
                        0.79,
                        0.79,
                        0.79,
                        19.56,
                        -0.77,
                        -21.97,
                        -0.07,
                        -0.63,
                        0.08,
                        0.77,
                        0.79,
                        0.79,
                        0.79,
                        -22.6,
                        0.22,
                        -31.62,
                        0.06,
                        -0.7,
                        0.05,
                        0.71,
                        0.45,
                        0.45,
                        0.45,
                        -8.14,
                        1.20,
                        -9.82,
                        -0.08,
                        -0.63,
                        0.08,
                        0.77,
                        0.91,
                        0.91,
                        0.91,
                        18.16,
                        0.08,
                        -30.67,
                        0.05,
                        -0.71,
                        0.05,
                        0.70,
                        0.92,
                        0.92,
                        0.92,
                        18.27,
                        0.75,
                        -36.51,
                        0.08,
                        -0.77,
                        -0.09,
                        0.63,
                        0.92,
                        0.92,
                        0.92,
                        -21.19,
                        0.33,
                        -31.92,
                        0.04,
                        -0.75,
                        0.04,
                        0.66,
                        0.56,
                        0.56,
                        0.56,
                        -19.31,
                        1.10,
                        -21.14,
                        0.01,
                        -0.65,
                        0.13,
                        0.75,
                        0.63,
                        0.63,
                        0.63,
                        1.37,
                        0.48,
                        -34.78,
                        0.08,
                        -0.75,
                        -0.02,
                        0.66,
                        0.49,
                        0.49,
                        0.49,
                        -1.01,
                        0.38,
                        -36.43,
                        0.01,
                        -0.75,
                        0.07,
                        0.66,
                        0.93,
                        0.93,
                        0.93,
                        -32.03,
                        0.33,
                        -17.07,
                        -0.01,
                        -0.76,
                        -0.09,
                        0.64,
                        0.75,
                        0.75,
                        0.75,
                        6.10,
                        0.07,
                        -29.65,
                        0.11,
                        -0.71,
                        0.01,
                        0.70,
                        0.85,
                        0.85,
                        0.85,
                        -7.89,
                        0.70,
                        -32.46,
                        -0.06,
                        -0.72,
                        0.07,
                        0.69,
                        0.50,
                        0.50,
                        0.50,
                        29.03,
                        -0.16,
                        -36.29,
                        0.00,
                        -0.67,
                        -0.02,
                        0.74,
                        0.51,
                        0.51,
                        0.51,
                        -20.6,
                        0.44,
                        -27.81,
                        -0.03,
                        -0.61,
                        -0.06,
                        0.79,
                        0.66,
                        0.66,
                        0.66,
                        -10.11,
                        0.84,
                        -37.24,
                        -0.04,
                        -0.74,
                        -0.12,
                        0.66,
                        0.96,
                        0.96,
                        0.96,
                        -4.43,
                        -0.19,
                        -27.39,
                        0.10,
                        -0.67,
                        -0.03,
                        0.74,
                        0.64,
                        0.64,
                        0.64,
                        23.73,
                        -0.47,
                        -7.97,
                        -0.05,
                        -0.75,
                        0.00,
                        0.65,
                        0.98,
                        0.98,
                        0.98,
                        19.67,
                        0.43,
                        -33.67,
                        -0.11,
                        -0.72,
                        -0.03,
                        0.69,
                        0.73,
                        0.73,
                        0.73,
                        -19.37,
                        0.73,
                        -34.49,
                        -0.09,
                        -0.68,
                        0.06,
                        0.73,
                        0.46,
                        0.46,
                        0.46,
                        -26.11,
                        0.17,
                        -58.48,
                        0.01,
                        -0.65,
                        0.03,
                        0.76,
                        0.71,
                        0.71,
                        0.71,
                        39.00,
                        0.85,
                        -31.57,
                        0.09,
                        -0.77,
                        0.04,
                        0.63,
                        0.93,
                        0.93,
                        0.93,
                        -33.52,
                        0.68,
                        -15.62,
                        0.00,
                        -0.65,
                        0.11,
                        0.75,
                        0.72,
                        0.72,
                        0.72,
                        -6.16,
                        -0.29,
                        -24.56,
                        0.09,
                        -0.72,
                        0.00,
                        0.68,
                        0.52,
                        0.52,
                        0.52,
                        -7.15,
                        0.23,
                        -39.66,
                        -0.03,
                        -0.69,
                        0.07,
                        0.72,
                        0.48,
                        0.48,
                        0.48,
                        6.31,
                        0.04,
                        -29.87,
                        0.04,
                        -0.66,
                        -0.01,
                        0.75,
                        0.86,
                        0.86,
                        0.86,
                        -0.15,
                        1.27,
                        -54.03,
                        -0.08,
                        -0.75,
                        -0.04,
                        0.65,
                        0.89,
                        0.89,
                        0.89,
                        8.53,
                        -0.19,
                        -26.94,
                        -0.11,
                        -0.66,
                        0.01,
                        0.74,
                        0.93,
                        0.93,
                        0.93,
                        -7.88,
                        -0.01,
                        -73.39,
                        -0.01,
                        -0.74,
                        0.07,
                        0.67,
                        0.43,
                        0.43,
                        0.43,
                        6.78,
                        -0.07,
                        -28.65,
                        0.00,
                        -0.75,
                        -0.07,
                        0.65,
                        0.68,
                        0.68,
                        0.68,
                        -0.37,
                        0.43,
                        -36.33,
                        0.08,
                        -0.77,
                        0.01,
                        0.64,
                        0.66,
                        0.66,
                        0.66,
                        17.34,
                        0.33,
                        -5.28,
                        0.02,
                        -0.66,
                        0.10,
                        0.75,
                        0.57,
                        0.57,
                        0.57,
                        -11.25,
                        0.93,
                        -33.61,
                        0.10,
                        -0.68,
                        -0.02,
                        0.73,
                        0.44,
                        0.44,
                        0.44,
                        18.73,
                        0.46,
                        -6.1,
                        -0.07,
                        -0.68,
                        0.01,
                        0.73,
                        0.84,
                        0.84,
                        0.84,
                        19.62,
                        -0.55,
                        -19.67,
                        0.00,
                        -0.67,
                        0.07,
                        0.74,
                        0.57,
                        0.57,
                        0.57,
                        -22.27,
                        0.16,
                        -29.86,
                        0.09,
                        -0.72,
                        -0.01,
                        0.69,
                        0.97,
                        0.97,
                        0.97,
                        -41.72,
                        0.53,
                        -18.8,
                        -0.03,
                        -0.67,
                        0.06,
                        0.74,
                        0.65,
                        0.65,
                        0.65,
                        -36.71,
                        0.36,
                        -40.25,
                        0.06,
                        -0.71,
                        0.02,
                        0.70,
                        0.61,
                        0.61,
                        0.61,
                        -2.74,
                        0.06,
                        -40.21,
                        -0.04,
                        -0.79,
                        0.04,
                        0.61,
                        0.96,
                        0.96,
                        0.96,
                        -9.58,
                        0.48,
                        -38.35,
                        -0.06,
                        -0.77,
                        -0.06,
                        0.64,
                        0.98,
                        0.98,
                        0.98,
                        -25.77,
                        0.48,
                        -18.56,
                        0.15,
                        -0.7,
                        0.01,
                        0.70,
                        0.46,
                        0.46,
                        0.46,
                        -3.55,
                        0.11,
                        -71.14,
                        -0.05,
                        -0.66,
                        0.05,
                        0.75,
                        0.59,
                        0.59,
                        0.59,
                        0.10,
                        0.95,
                        -55.56,
                        0.05,
                        -0.68,
                        0.04,
                        0.73,
                        0.79,
                        0.79,
                        0.79,
                        5.93,
                        -0.29,
                        -19.9,
                        -0.12,
                        -0.64,
                        0.03,
                        0.76,
                        0.50,
                        0.50,
                        0.50,
                        7.88,
                        -0.32,
                        -26.07,
                        0.01,
                        -0.74,
                        0.07,
                        0.67,
                        0.88,
                        0.88,
                        0.88,
                        2.04,
                        0.40,
                        -35.65,
                        0.01,
                        -0.72,
                        -0.1,
                        0.69,
                        0.85,
                        0.85,
                        0.85,
                        -8.52,
                        0.30,
                        -38.99,
                        0.06,
                        -0.71,
                        -0.03,
                        0.70,
                        0.86,
                        0.86,
                        0.86,
                        4.15,
                        0.63,
                        -47.55,
                        -0.01,
                        -0.78,
                        0.01,
                        0.63,
                        0.50,
                        0.50,
                        0.50,
                        18.42,
                        0.71,
                        -35.9,
                        -0.09,
                        -0.67,
                        -0.1,
                        0.73,
                        0.42,
                        0.42,
                        0.42,
                        -6.86,
                        0.24,
                        -39.54,
                        0.06,
                        -0.72,
                        -0.14,
                        0.68,
                        0.92,
                        0.92,
                        0.92,
                        16.72,
                        0.34,
                        -32.88,
                        0.04,
                        -0.7,
                        -0.01,
                        0.72,
                        0.57,
                        0.57,
                        0.57,
                        -27.89,
                        0.27,
                        -59.54,
                        -0.02,
                        -0.61,
                        0.00,
                        0.79,
                        0.55,
                        0.55,
                        0.55,
                        13.84,
                        -0.56,
                        -13.6,
                        0.06,
                        -0.63,
                        0.08,
                        0.77,
                        0.84,
                        0.84,
                        0.84,
                        -33.11,
                        0.30,
                        -17.11,
                        0.14,
                        -0.73,
                        0.00,
                        0.67,
                        0.74,
                        0.74,
                        0.74,
                        -19.14,
                        1.12,
                        -38.7,
                        -0.03,
                        -0.69,
                        0.08,
                        0.72,
                        0.62,
                        0.62,
                        0.62,
                        -6.49,
                        0.25,
                        -39.32,
                        0.04,
                        -0.65,
                        -0.01,
                        0.76,
                        0.70,
                        0.70,
                        0.70,
                        2.87,
                        0.57,
                        -33.47,
                        -0.1,
                        -0.71,
                        -0.06,
                        0.70,
                        0.51,
                        0.51,
                        0.51,
                        -8.55,
                        0.05,
                        -30.16,
                        -0.07,
                        -0.62,
                        0.06,
                        0.78,
                        0.92,
                        0.92,
                        0.92,
                        7.15,
                        -0.2,
                        -26.88,
                        0.06,
                        -0.72,
                        0.06,
                        0.69,
                        0.71,
                        0.71,
                        0.71,
                        -10.85,
                        0.93,
                        -33.73,
                        0.08,
                        -0.65,
                        -0.11,
                        0.75,
                        0.53,
                        0.53,
                        0.53,
                        6.50,
                        -0.09,
                        -27.6,
                        -0.02,
                        -0.65,
                        -0.04,
                        0.76,
                        0.81,
                        0.81,
                        0.81,
                        -9.81,
                        0.77,
                        -1.26,
                        -0.04,
                        -0.65,
                        -0.12,
                        0.75,
                        0.85,
                        0.85,
                        0.85,
                        -11.33,
                        0.61,
                        -3.71,
                        0.02,
                        -0.65,
                        -0.09,
                        0.76,
                        0.82,
                        0.82,
                        0.82,
                        -13.19,
                        0.67,
                        -46.55,
                        -0.02,
                        -0.66,
                        -0.08,
                        0.74,
                        0.67,
                        0.67,
                        0.67,
                        -7.85,
                        0.20,
                        -39.54,
                        0.01,
                        -0.72,
                        -0.11,
                        0.68,
                        0.70,
                        0.70,
                        0.70,
                        -23.27,
                        0.34,
                        -27.4,
                        0.07,
                        -0.69,
                        -0.03,
                        0.72,
                        0.51,
                        0.51,
                        0.51,
                        -10.33,
                        -0,
                        -28.32,
                        -0.04,
                        -0.74,
                        0.01,
                        0.67,
                        0.64,
                        0.64,
                        0.64,
                        -20.35,
                        0.58,
                        -34.16,
                        -0.06,
                        -0.78,
                        -0.02,
                        0.62,
                        0.74,
                        0.74,
                        0.74,
                        -11.22,
                        0.99,
                        -34.14,
                        -0.12,
                        -0.74,
                        -0.04,
                        0.67,
                        0.68,
                        0.68,
                        0.68,
                        3.45,
                        0.60,
                        -30.95,
                        -0.1,
                        -0.72,
                        0.04,
                        0.68,
                        0.47,
                        0.47,
                        0.47,
                        3.91,
                        -0.19,
                        -24.26,
                        -0.04,
                        -0.75,
                        0.01,
                        0.66,
                        0.95,
                        0.95,
                        0.95,
                        5.88,
                        -0.03,
                        -27.83,
                        -0.09,
                        -0.74,
                        -0.05,
                        0.66,
                        0.81,
                        0.81,
                        0.81,
                        -2.38,
                        -0.08,
                        -26.33,
                        -0.12,
                        -0.67,
                        0.03,
                        0.73,
                        0.65,
                        0.65,
                        0.65,
                        -13.27,
                        0.65,
                        -46.81,
                        -0.01,
                        -0.69,
                        0.06,
                        0.72,
                        0.94,
                        0.94,
                        0.94,
                        -21.76,
                        0.43,
                        -28.29,
                        0.05,
                        -0.77,
                        -0.01,
                        0.63,
                        0.69,
                        0.69,
                        0.69,
                        7.04,
                        -0.26,
                        -26.06,
                        0.05,
                        -0.76,
                        0.08,
                        0.64,
                        0.42,
                        0.42,
                        0.42,
                        -13.1,
                        0.16,
                        -50.29,
                        0.00,
                        -0.74,
                        -0.12,
                        0.66,
                        0.65,
                        0.65,
                        0.65,
                        -28.2,
                        0.04,
                        -18.33,
                        0.08,
                        -0.69,
                        -0.02,
                        0.72,
                        0.56,
                        0.56,
                        0.56,
                        -2.07,
                        0.42,
                        -32.93,
                        -0.04,
                        -0.65,
                        0.02,
                        0.76,
                        0.42,
                        0.42,
                        0.42,
                        -8.78,
                        0.94,
                        -33.83,
                        0.05,
                        -0.65,
                        0.07,
                        0.75,
                        0.53,
                        0.53,
                        0.53,
                        -0.14,
                        0.43,
                        -36.25,
                        0.11,
                        -0.76,
                        -0.01,
                        0.64,
                        0.43,
                        0.43,
                        0.43,
                        -23.06,
                        0.42,
                        -26.73,
                        0.01,
                        -0.67,
                        0.09,
                        0.73,
                        0.47,
                        0.47,
                        0.47,
                        -20.5,
                        0.25,
                        -29.33,
                        0.08,
                        -0.74,
                        -0.02,
                        0.67,
                        0.80,
                        0.80,
                        0.80,
                        -3.02,
                        0.20,
                        -39.15,
                        0.01,
                        -0.69,
                        0.07,
                        0.72,
                        0.64,
                        0.64,
                        0.64,
                        15.76,
                        0.10,
                        -6.66,
                        0.06,
                        -0.65,
                        -0.04,
                        0.76,
                        0.85,
                        0.85,
                        0.85,
                        7.89,
                        -0.21,
                        -26.83,
                        -0.07,
                        -0.71,
                        -0.04,
                        0.70,
                        0.44,
                        0.44,
                        0.44,
                        1.00,
                        0.43,
                        -36.35,
                        -0.09,
                        -0.68,
                        0.09,
                        0.72,
                        0.83,
                        0.83,
                        0.83,
                        -18.39,
                        1.14,
                        -38.33,
                        0.01,
                        -0.71,
                        0.02,
                        0.70,
                        0.62,
                        0.62,
                        0.62,
                        -8.45,
                        -0.24,
                        -25.03,
                        0.05,
                        -0.63,
                        -0.09,
                        0.77,
                        0.95,
                        0.95,
                        0.95,
                        -25.09,
                        0.67,
                        -19.89,
                        -0.04,
                        -0.68,
                        -0.07,
                        0.73,
                        0.56,
                        0.56,
                        0.56,
                        -18.36,
                        1.14,
                        -38.27,
                        0.04,
                        -0.77,
                        -0.09,
                        0.63,
                        0.59,
                        0.59,
                        0.59,
                        3.70,
                        0.60,
                        -31.36,
                        0.03,
                        -0.79,
                        0.01,
                        0.61,
                        0.78,
                        0.78,
                        0.78,
                        4.44,
                        -0.26,
                        -15.81,
                        0.07,
                        -0.68,
                        0.12,
                        0.72,
                        0.97,
                        0.97,
                        0.97,
                        -14.8,
                        1.00,
                        -17.44,
                        0.10,
                        -0.67,
                        -0.07,
                        0.73,
                        0.97,
                        0.97,
                        0.97,
                        3.91,
                        -0.26,
                        -14.92,
                        -0.03,
                        -0.67,
                        -0.01,
                        0.74,
                        0.54,
                        0.54,
                        0.54,
                        -15.16,
                        1.14,
                        -17.33,
                        0.02,
                        -0.64,
                        0.10,
                        0.76,
                        0.76,
                        0.76,
                        0.76,
                        -5.57,
                        0.28,
                        -39.76,
                        0.09,
                        -0.76,
                        -0.01,
                        0.64,
                        0.98,
                        0.98,
                        0.98,
                        19.33,
                        -0.78,
                        -21.76,
                        0.02,
                        -0.72,
                        0.10,
                        0.69,
                        0.47,
                        0.47,
                        0.47,
                        -6.37,
                        0.87,
                        -7.09,
                        0.04,
                        -0.65,
                        -0.07,
                        0.76,
                        0.42,
                        0.42,
                        0.42,
                        -31.46,
                        0.15,
                        -39.1,
                        -0.04,
                        -0.68,
                        -0.07,
                        0.73,
                        0.88,
                        0.88,
                        0.88,
                        27.95,
                        -0.38,
                        -8.73,
                        0.04,
                        -0.76,
                        -0.1,
                        0.65,
                        0.92,
                        0.92,
                        0.92,
                        18.14,
                        0.76,
                        -36.47,
                        0.06,
                        -0.65,
                        0.02,
                        0.76,
                        0.65,
                        0.65,
                        0.65,
                        2.91,
                        0.66,
                        -47.68,
                        -0.12,
                        -0.68,
                        -0.02,
                        0.73,
                        0.92,
                        0.92,
                        0.92,
                        -0.69,
                        1.23,
                        -53.67,
                        -0.04,
                        -0.65,
                        0.08,
                        0.75,
                        0.70,
                        0.70,
                        0.70,
                        -37.59,
                        0.19,
                        -17.61,
                        0.05,
                        -0.76,
                        0.02,
                        0.64,
                        0.66,
                        0.66,
                        0.66,
                        -9.22,
                        0.02,
                        -29.63,
                        0.02,
                        -0.65,
                        0.11,
                        0.75,
                        0.69,
                        0.69,
                        0.69,
                        -40.98,
                        0.29,
                        -38.14,
                        0.11,
                        -0.7,
                        -0.01,
                        0.70,
                        0.66,
                        0.66,
                        0.66,
                        -12.06,
                        0.74,
                        -31.66,
                        -0.05,
                        -0.71,
                        0.05,
                        0.70,
                        0.69,
                        0.69,
                        0.69,
                        -39.63,
                        0.25,
                        -39.04,
                        0.00,
                        -0.76,
                        -0.01,
                        0.65,
                        0.76,
                        0.76,
                        0.76,
                        17.25,
                        0.80,
                        -36.27,
                        0.11,
                        -0.68,
                        0.10,
                        0.72,
                        0.93,
                        0.93,
                        0.93,
                        -2.75,
                        -0.09,
                        -27.14,
                        -0.12,
                        -0.73,
                        0.08,
                        0.67,
                        0.67,
                        0.67,
                        0.67,
                        -24.44,
                        0.81,
                        -20.22,
                        -0.03,
                        -0.65,
                        -0.01,
                        0.76,
                        0.78,
                        0.78,
                        0.78,
                        0.96,
                        -0.34,
                        -23.67,
                        0.06,
                        -0.74,
                        0.11,
                        0.66,
                        0.83,
                        0.83,
                        0.83,
                        3.64,
                        -0.2,
                        -24.19,
                        0.04,
                        -0.75,
                        -0.11,
                        0.65,
                        0.60,
                        0.60,
                        0.60,
                        -4.85,
                        0.25,
                        -39.51,
                        0.06,
                        -0.67,
                        0.01,
                        0.74,
                        0.54,
                        0.54,
                        0.54,
                        -30.38,
                        0.45,
                        -16.38,
                        -0.11,
                        -0.71,
                        -0.01,
                        0.69,
                        0.66,
                        0.66,
                        0.66,
                        2.06,
                        0.43,
                        -29.72,
                        -0.06,
                        -0.76,
                        0.04,
                        0.65,
                        0.53,
                        0.53,
                        0.53,
                        8.18,
                        -0.27,
                        -25.86,
                        -0.06,
                        -0.66,
                        -0.05,
                        0.75,
                        0.63,
                        0.63,
                        0.63,
                        -4.53,
                        0.42,
                        -33.66,
                        -0.01,
                        -0.63,
                        0.11,
                        0.77,
                        0.84,
                        0.84,
                        0.84,
                        37.18,
                        0.45,
                        -31.9,
                        0.09,
                        -0.71,
                        0.02,
                        0.70,
                        0.50,
                        0.50,
                        0.50,
                        -0.06,
                        0.36,
                        -37.77,
                        -0.06,
                        -0.69,
                        0.08,
                        0.72,
                        0.64,
                        0.64,
                        0.64,
                        1.50,
                        0.38,
                        -29.45,
                        0.02,
                        -0.71,
                        0.01,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        28.18,
                        0.09,
                        -37.77,
                        -0.03,
                        -0.61,
                        0.03,
                        0.79,
                        1.00,
                        1.00,
                        1.00,
                        19.23,
                        0.55,
                        -34.75,
                        0.05,
                        -0.62,
                        0.06,
                        0.78,
                        0.48,
                        0.48,
                        0.48,
                        27.13,
                        0.00,
                        -37.84,
                        0.13,
                        -0.75,
                        0.03,
                        0.65,
                        0.70,
                        0.70,
                        0.70,
                        6.89,
                        -0.35,
                        -21.37,
                        -0.02,
                        -0.7,
                        0.10,
                        0.71,
                        0.69,
                        0.69,
                        0.69,
                        -9.79,
                        0.53,
                        -38.35,
                        0.03,
                        -0.65,
                        -0.03,
                        0.76,
                        0.96,
                        0.96,
                        0.96,
                        -10.15,
                        1.10,
                        -35.41,
                        -0.08,
                        -0.69,
                        -0.07,
                        0.71,
                        0.66,
                        0.66,
                        0.66,
                        18.86,
                        -0.63,
                        -20.58,
                        -0.09,
                        -0.72,
                        0.12,
                        0.68,
                        0.78,
                        0.78,
                        0.78,
                        7.80,
                        -0.35,
                        -24.81,
                        0.00,
                        -0.65,
                        -0.02,
                        0.76,
                        0.97,
                        0.97,
                        0.97,
                        -8.65,
                        0.02,
                        -29.9,
                        -0.08,
                        -0.73,
                        -0.11,
                        0.67,
                        0.83,
                        0.83,
                        0.83,
                        19.18,
                        -0.54,
                        -18.1,
                        0.09,
                        -0.63,
                        -0.05,
                        0.77,
                        0.53,
                        0.53,
                        0.53,
                        -0.1,
                        1.33,
                        -50.99,
                        -0.07,
                        -0.72,
                        -0.04,
                        0.69,
                        0.90,
                        0.90,
                        0.90,
                        16.71,
                        0.82,
                        -36.06,
                        -0.1,
                        -0.67,
                        0.07,
                        0.73,
                        0.67,
                        0.67,
                        0.67,
                        -22.23,
                        0.34,
                        -51.35,
                        0.01,
                        -0.65,
                        0.03,
                        0.76,
                        0.94,
                        0.94,
                        0.94,
                        -0.72,
                        0.17,
                        -69.54,
                        0.12,
                        -0.67,
                        0.05,
                        0.73,
                        0.89,
                        0.89,
                        0.89,
                        6.18,
                        0.69,
                        -44.41,
                        -0.08,
                        -0.64,
                        0.04,
                        0.76,
                        0.43,
                        0.43,
                        0.43,
                        -40.46,
                        0.32,
                        -18.36,
                        0.03,
                        -0.68,
                        0.07,
                        0.73,
                        0.68,
                        0.68,
                        0.68,
                        21.32,
                        0.34,
                        -36.8,
                        0.10,
                        -0.65,
                        -0.04,
                        0.75,
                        0.76,
                        0.76,
                        0.76,
                        17.22,
                        0.15,
                        -31.92,
                        -0.05,
                        -0.65,
                        -0.01,
                        0.76,
                        0.70,
                        0.70,
                        0.70,
                        -24.38,
                        0.69,
                        -21.89,
                        0.03,
                        -0.66,
                        0.11,
                        0.74,
                        0.55,
                        0.55,
                        0.55,
                        0.83,
                        0.43,
                        -36.52,
                        0.09,
                        -0.76,
                        -0.02,
                        0.65,
                        0.95,
                        0.95,
                        0.95,
                        16.34,
                        -0.04,
                        -4.67,
                        0.02,
                        -0.73,
                        0.08,
                        0.67,
                        0.86,
                        0.86,
                        0.86,
                        -41.19,
                        0.21,
                        -19.58,
                        0.02,
                        -0.69,
                        -0.1,
                        0.72,
                        0.69,
                        0.69,
                        0.69,
                        -17.25,
                        0.24,
                        -49.57,
                        0.02,
                        -0.66,
                        -0.05,
                        0.75,
                        0.97,
                        0.97,
                        0.97,
                        1.06,
                        0.26,
                        -58.79,
                        -0.03,
                        -0.76,
                        -0.07,
                        0.65,
                        0.74,
                        0.74,
                        0.74,
                        5.88,
                        0.10,
                        -29.96,
                        0.13,
                        -0.72,
                        0.01,
                        0.68,
                        0.75,
                        0.75,
                        0.75,
                        1.59,
                        0.44,
                        -30.33,
                        -0.04,
                        -0.66,
                        0.06,
                        0.75,
                        0.97,
                        0.97,
                        0.97,
                        -11.49,
                        0.74,
                        -31.86,
                        0.06,
                        -0.74,
                        0.03,
                        0.67,
                        0.63,
                        0.63,
                        0.63
                    ],
                    [
                        5.57,
                        -0.18,
                        -2.48,
                        0.02,
                        -0.67,
                        0.05,
                        0.74,
                        0.79,
                        0.79,
                        0.79,
                        -2.12,
                        0.75,
                        -51.03,
                        0.12,
                        -0.72,
                        0.00,
                        0.68,
                        0.46,
                        0.46,
                        0.46,
                        18.45,
                        0.09,
                        -30.3,
                        -0.03,
                        -0.7,
                        0.07,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        7.96,
                        0.68,
                        -43.25,
                        0.03,
                        -0.73,
                        -0.02,
                        0.68,
                        0.57,
                        0.57,
                        0.57,
                        -1.14,
                        0.05,
                        -65.27,
                        0.04,
                        -0.66,
                        0.05,
                        0.75,
                        0.87,
                        0.87,
                        0.87,
                        38.21,
                        0.52,
                        -31.02,
                        0.05,
                        -0.6,
                        0.00,
                        0.80,
                        0.94,
                        0.94,
                        0.94,
                        7.36,
                        -0.4,
                        -23.36,
                        -0.11,
                        -0.73,
                        -0.07,
                        0.67,
                        0.60,
                        0.60,
                        0.60,
                        -6.54,
                        -0.31,
                        -25.14,
                        -0.11,
                        -0.66,
                        0.05,
                        0.74,
                        0.61,
                        0.61,
                        0.61,
                        2.24,
                        0.68,
                        -48.63,
                        0.01,
                        -0.73,
                        0.05,
                        0.68,
                        0.62,
                        0.62,
                        0.62,
                        33.40,
                        0.19,
                        -11.93,
                        0.01,
                        -0.62,
                        -0.06,
                        0.78,
                        0.83,
                        0.83,
                        0.83,
                        -0.08,
                        1.08,
                        -49.34,
                        -0.04,
                        -0.65,
                        -0.09,
                        0.75,
                        0.94,
                        0.94,
                        0.94,
                        1.46,
                        0.41,
                        -36.06,
                        0.02,
                        -0.71,
                        -0.13,
                        0.69,
                        0.47,
                        0.47,
                        0.47,
                        15.56,
                        -0.18,
                        -32.27,
                        0.05,
                        -0.7,
                        -0.04,
                        0.71,
                        0.73,
                        0.73,
                        0.73,
                        -24.15,
                        0.46,
                        -36.53,
                        -0.01,
                        -0.77,
                        0.01,
                        0.64,
                        0.79,
                        0.79,
                        0.79,
                        -18.41,
                        1.17,
                        -38.66,
                        -0.08,
                        -0.77,
                        -0.07,
                        0.63,
                        0.81,
                        0.81,
                        0.81,
                        2.51,
                        0.44,
                        -34.92,
                        -0.14,
                        -0.66,
                        0.00,
                        0.74,
                        0.42,
                        0.42,
                        0.42,
                        -6.77,
                        0.47,
                        -33.5,
                        -0.02,
                        -0.73,
                        0.08,
                        0.68,
                        0.78,
                        0.78,
                        0.78,
                        -22.95,
                        0.32,
                        -27.93,
                        0.00,
                        -0.74,
                        -0.06,
                        0.67,
                        0.88,
                        0.88,
                        0.88,
                        -6,
                        0.41,
                        -34.57,
                        0.09,
                        -0.69,
                        0.01,
                        0.72,
                        0.53,
                        0.53,
                        0.53,
                        -4.74,
                        0.16,
                        -40.45,
                        -0.07,
                        -0.66,
                        0.04,
                        0.75,
                        0.64,
                        0.64,
                        0.64,
                        -9.78,
                        0.62,
                        -37.89,
                        0.03,
                        -0.73,
                        0.06,
                        0.68,
                        0.71,
                        0.71,
                        0.71,
                        7.46,
                        0.67,
                        -43.52,
                        0.03,
                        -0.67,
                        -0.11,
                        0.73,
                        0.77,
                        0.77,
                        0.77,
                        0.62,
                        0.34,
                        -29.44,
                        0.01,
                        -0.75,
                        -0.05,
                        0.65,
                        0.64,
                        0.64,
                        0.64,
                        -14.1,
                        1.38,
                        -15.34,
                        0.09,
                        -0.73,
                        0.04,
                        0.68,
                        0.97,
                        0.97,
                        0.97,
                        -4.7,
                        0.15,
                        -40.51,
                        -0.03,
                        -0.63,
                        0.07,
                        0.78,
                        0.61,
                        0.61,
                        0.61,
                        17.41,
                        -0.03,
                        -31.25,
                        0.07,
                        -0.65,
                        0.04,
                        0.75,
                        0.57,
                        0.57,
                        0.57,
                        -1.45,
                        -0.05,
                        -60.62,
                        -0.09,
                        -0.62,
                        0.00,
                        0.78,
                        0.61,
                        0.61,
                        0.61,
                        -18.79,
                        0.28,
                        -50.16,
                        0.03,
                        -0.68,
                        0.10,
                        0.72,
                        0.43,
                        0.43,
                        0.43,
                        -3.59,
                        0.14,
                        -40.1,
                        0.08,
                        -0.65,
                        -0.04,
                        0.75,
                        0.51,
                        0.51,
                        0.51,
                        -9.11,
                        0.81,
                        -3.38,
                        -0.06,
                        -0.75,
                        -0.02,
                        0.66,
                        0.74,
                        0.74,
                        0.74,
                        18.20,
                        0.41,
                        -7.72,
                        -0.11,
                        -0.65,
                        -0.01,
                        0.75,
                        0.70,
                        0.70,
                        0.70,
                        -29.02,
                        0.20,
                        -40.29,
                        0.00,
                        -0.71,
                        0.10,
                        0.70,
                        0.95,
                        0.95,
                        0.95,
                        -10.85,
                        0.69,
                        -3.13,
                        0.04,
                        -0.72,
                        -0.06,
                        0.69,
                        0.47,
                        0.47,
                        0.47,
                        -32.37,
                        0.61,
                        -15.95,
                        0.02,
                        -0.65,
                        0.01,
                        0.76,
                        0.58,
                        0.58,
                        0.58,
                        -5.38,
                        0.25,
                        -39.92,
                        -0.1,
                        -0.76,
                        -0.06,
                        0.64,
                        0.59,
                        0.59,
                        0.59,
                        -39.13,
                        0.48,
                        -40.57,
                        -0.11,
                        -0.76,
                        0.02,
                        0.64,
                        0.85,
                        0.85,
                        0.85,
                        -1.1,
                        1.14,
                        -51.21,
                        -0.08,
                        -0.74,
                        -0.01,
                        0.67,
                        0.66,
                        0.66,
                        0.66,
                        -17.45,
                        1.62,
                        -42.4,
                        -0.08,
                        -0.64,
                        0.02,
                        0.76,
                        0.59,
                        0.59,
                        0.59,
                        17.01,
                        0.28,
                        -32.48,
                        0.03,
                        -0.74,
                        0.08,
                        0.66,
                        0.63,
                        0.63,
                        0.63,
                        2.85,
                        0.65,
                        -49.31,
                        0.02,
                        -0.67,
                        -0.11,
                        0.74,
                        0.66,
                        0.66,
                        0.66,
                        2.95,
                        -0.37,
                        -16.71,
                        0.01,
                        -0.66,
                        -0.06,
                        0.75,
                        0.82,
                        0.82,
                        0.82,
                        -1.96,
                        1.02,
                        -54.93,
                        -0.02,
                        -0.76,
                        -0.08,
                        0.65,
                        0.75,
                        0.75,
                        0.75,
                        1.09,
                        0.43,
                        -35.79,
                        0.12,
                        -0.69,
                        0.01,
                        0.71,
                        0.54,
                        0.54,
                        0.54,
                        -8.36,
                        -0.04,
                        -29.44,
                        -0.07,
                        -0.7,
                        0.05,
                        0.71,
                        0.86,
                        0.86,
                        0.86,
                        5.39,
                        0.04,
                        -28.69,
                        0.00,
                        -0.69,
                        0.02,
                        0.72,
                        0.99,
                        0.99,
                        0.99,
                        4.94,
                        0.07,
                        -28.36,
                        0.08,
                        -0.65,
                        0.02,
                        0.75,
                        0.62,
                        0.62,
                        0.62,
                        -10.7,
                        0.60,
                        -30.92,
                        -0.05,
                        -0.61,
                        0.00,
                        0.79,
                        0.93,
                        0.93,
                        0.93,
                        -9.01,
                        0.80,
                        -3.46,
                        0.06,
                        -0.75,
                        0.10,
                        0.65,
                        0.46,
                        0.46,
                        0.46,
                        -11.14,
                        1.12,
                        -35.83,
                        0.03,
                        -0.72,
                        -0.13,
                        0.68,
                        0.48,
                        0.48,
                        0.48,
                        -14.02,
                        1.23,
                        -15.91,
                        0.05,
                        -0.66,
                        -0.02,
                        0.75,
                        0.68,
                        0.68,
                        0.68,
                        -17.78,
                        0.12,
                        -50.58,
                        -0.07,
                        -0.65,
                        -0.03,
                        0.76,
                        0.76,
                        0.76,
                        0.76,
                        -39.7,
                        0.08,
                        -18.61,
                        0.00,
                        -0.64,
                        0.10,
                        0.76,
                        0.49,
                        0.49,
                        0.49,
                        19.53,
                        -0.57,
                        -19.82,
                        0.09,
                        -0.66,
                        0.01,
                        0.74,
                        0.86,
                        0.86,
                        0.86,
                        -39.55,
                        0.10,
                        -18.46,
                        -0.09,
                        -0.67,
                        0.01,
                        0.74,
                        0.49,
                        0.49,
                        0.49,
                        -13.32,
                        0.43,
                        -48.53,
                        0.00,
                        -0.72,
                        0.08,
                        0.69,
                        0.85,
                        0.85,
                        0.85,
                        -7.54,
                        -0.17,
                        -28.61,
                        0.03,
                        -0.69,
                        -0.07,
                        0.72,
                        1.00,
                        1.00,
                        1.00,
                        1.64,
                        0.52,
                        -34.25,
                        0.01,
                        -0.64,
                        -0.03,
                        0.76,
                        0.91,
                        0.91,
                        0.91,
                        -10.05,
                        -0.02,
                        -27.77,
                        -0.06,
                        -0.66,
                        -0.09,
                        0.74,
                        0.86,
                        0.86,
                        0.86,
                        39.54,
                        0.02,
                        -27.76,
                        0.04,
                        -0.72,
                        -0.13,
                        0.68,
                        0.96,
                        0.96,
                        0.96,
                        -8.94,
                        -0.08,
                        -28.7,
                        0.05,
                        -0.7,
                        -0.02,
                        0.71,
                        0.42,
                        0.42,
                        0.42,
                        -21.27,
                        0.42,
                        -27.25,
                        -0.03,
                        -0.77,
                        0.02,
                        0.64,
                        0.76,
                        0.76,
                        0.76,
                        18.02,
                        0.78,
                        -36.85,
                        -0.07,
                        -0.64,
                        -0.06,
                        0.77,
                        0.75,
                        0.75,
                        0.75,
                        7.20,
                        -0.3,
                        -26.08,
                        0.00,
                        -0.67,
                        0.15,
                        0.72,
                        0.64,
                        0.64,
                        0.64,
                        -4.4,
                        -0.2,
                        -27.15,
                        0.06,
                        -0.66,
                        -0.03,
                        0.75,
                        0.78,
                        0.78,
                        0.78,
                        28.90,
                        0.05,
                        -37.19,
                        -0.06,
                        -0.75,
                        -0.03,
                        0.66,
                        0.96,
                        0.96,
                        0.96,
                        17.76,
                        0.38,
                        -32.15,
                        -0.12,
                        -0.66,
                        0.00,
                        0.75,
                        0.87,
                        0.87,
                        0.87,
                        -7.97,
                        0.00,
                        -73.53,
                        -0.01,
                        -0.7,
                        0.09,
                        0.71,
                        0.63,
                        0.63,
                        0.63,
                        2.52,
                        0.61,
                        -32.91,
                        0.04,
                        -0.64,
                        -0.03,
                        0.76,
                        0.94,
                        0.94,
                        0.94,
                        -7.27,
                        0.57,
                        -33.19,
                        -0.06,
                        -0.76,
                        -0.05,
                        0.64,
                        0.95,
                        0.95,
                        0.95,
                        6.24,
                        -0.33,
                        -21.35,
                        -0.13,
                        -0.75,
                        -0.01,
                        0.64,
                        0.42,
                        0.42,
                        0.42,
                        1.87,
                        0.54,
                        -33.99,
                        -0.09,
                        -0.73,
                        0.01,
                        0.67,
                        0.94,
                        0.94,
                        0.94,
                        -2.05,
                        0.15,
                        -70.34,
                        -0.07,
                        -0.66,
                        0.01,
                        0.75,
                        0.92,
                        0.92,
                        0.92,
                        -21.81,
                        0.45,
                        -28.12,
                        0.02,
                        -0.66,
                        0.08,
                        0.75,
                        0.80,
                        0.80,
                        0.80,
                        8.85,
                        -0.24,
                        -26.39,
                        0.11,
                        -0.7,
                        -0.01,
                        0.71,
                        0.76,
                        0.76,
                        0.76,
                        16.51,
                        -0.04,
                        -10.22,
                        -0.05,
                        -0.74,
                        0.04,
                        0.66,
                        0.97,
                        0.97,
                        0.97,
                        -9.15,
                        1.42,
                        -6.96,
                        -0.05,
                        -0.75,
                        -0.04,
                        0.66,
                        0.85,
                        0.85,
                        0.85,
                        -23.67,
                        0.63,
                        -22.5,
                        -0.11,
                        -0.63,
                        -0.01,
                        0.77,
                        0.64,
                        0.64,
                        0.64,
                        3.93,
                        0.65,
                        -46.98,
                        0.01,
                        -0.69,
                        0.10,
                        0.72,
                        0.72,
                        0.72,
                        0.72,
                        -41.17,
                        0.03,
                        -20,
                        0.08,
                        -0.71,
                        -0.04,
                        0.69,
                        0.50,
                        0.50,
                        0.50,
                        -26.85,
                        0.18,
                        -62.65,
                        -0.01,
                        -0.75,
                        0.03,
                        0.66,
                        0.51,
                        0.51,
                        0.51,
                        -27.21,
                        0.32,
                        -17.04,
                        -0.05,
                        -0.77,
                        -0.08,
                        0.64,
                        0.77,
                        0.77,
                        0.77,
                        23.06,
                        -0.07,
                        -36.3,
                        0.10,
                        -0.63,
                        0.00,
                        0.77,
                        0.52,
                        0.52,
                        0.52,
                        14.98,
                        0.87,
                        -37.77,
                        -0.1,
                        -0.7,
                        -0.01,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        10.71,
                        0.32,
                        -38.97,
                        -0.06,
                        -0.69,
                        0.07,
                        0.72,
                        0.85,
                        0.85,
                        0.85,
                        6.48,
                        -0.14,
                        -26.43,
                        0.02,
                        -0.75,
                        0.01,
                        0.66,
                        0.68,
                        0.68,
                        0.68,
                        -9.23,
                        0.15,
                        -30.39,
                        0.08,
                        -0.68,
                        0.12,
                        0.72,
                        0.96,
                        0.96,
                        0.96,
                        7.39,
                        -0.39,
                        -22.68,
                        0.11,
                        -0.7,
                        -0.08,
                        0.70,
                        0.43,
                        0.43,
                        0.43,
                        -19.09,
                        1.43,
                        -41.35,
                        -0.01,
                        -0.76,
                        0.01,
                        0.66,
                        0.94,
                        0.94,
                        0.94,
                        -4.37,
                        -0.14,
                        -28.22,
                        -0.09,
                        -0.73,
                        -0.09,
                        0.67,
                        0.53,
                        0.53,
                        0.53,
                        -11.82,
                        0.47,
                        -50.28,
                        0.11,
                        -0.77,
                        -0.05,
                        0.63,
                        0.45,
                        0.45,
                        0.45,
                        1.29,
                        -0.53,
                        -19.59,
                        0.02,
                        -0.65,
                        0.06,
                        0.76,
                        0.93,
                        0.93,
                        0.93,
                        1.40,
                        0.40,
                        -29.79,
                        0.12,
                        -0.75,
                        0.02,
                        0.66,
                        0.68,
                        0.68,
                        0.68,
                        3.00,
                        0.62,
                        -32.69,
                        -0.02,
                        -0.65,
                        0.08,
                        0.76,
                        0.91,
                        0.91,
                        0.91,
                        -8.64,
                        -0.24,
                        -26.75,
                        0.08,
                        -0.66,
                        0.02,
                        0.75,
                        0.48,
                        0.48,
                        0.48,
                        -17.89,
                        1.56,
                        -42.07,
                        -0.11,
                        -0.72,
                        0.01,
                        0.68,
                        0.43,
                        0.43,
                        0.43,
                        12.35,
                        0.24,
                        -37.04,
                        -0.06,
                        -0.76,
                        0.03,
                        0.65,
                        0.79,
                        0.79,
                        0.79,
                        27.61,
                        0.01,
                        -37.58,
                        -0.08,
                        -0.68,
                        -0.04,
                        0.73,
                        0.75,
                        0.75,
                        0.75,
                        32.47,
                        0.58,
                        -38.16,
                        -0.05,
                        -0.71,
                        0.12,
                        0.69,
                        0.90,
                        0.90,
                        0.90,
                        -10.06,
                        1.09,
                        -35.75,
                        0.01,
                        -0.73,
                        -0.03,
                        0.68,
                        0.50,
                        0.50,
                        0.50,
                        0.68,
                        -0.58,
                        -20.87,
                        0.05,
                        -0.63,
                        0.02,
                        0.78,
                        0.98,
                        0.98,
                        0.98,
                        19.22,
                        -0.6,
                        -17.6,
                        -0.09,
                        -0.77,
                        -0.03,
                        0.63,
                        0.73,
                        0.73,
                        0.73,
                        -9.82,
                        0.09,
                        -29.92,
                        -0.11,
                        -0.75,
                        -0.01,
                        0.66,
                        0.66,
                        0.66,
                        0.66,
                        4.05,
                        0.62,
                        -47.88,
                        -0.1,
                        -0.71,
                        0.01,
                        0.70,
                        0.48,
                        0.48,
                        0.48,
                        -6.02,
                        0.22,
                        -73.38,
                        -0.04,
                        -0.65,
                        0.03,
                        0.76,
                        0.75,
                        0.75,
                        0.75,
                        2.58,
                        -0.31,
                        -23.3,
                        0.05,
                        -0.75,
                        0.06,
                        0.65,
                        0.71,
                        0.71,
                        0.71,
                        -16.37,
                        0.13,
                        -49.71,
                        0.01,
                        -0.76,
                        -0.12,
                        0.64,
                        0.90,
                        0.90,
                        0.90,
                        -6.9,
                        0.25,
                        -38.89,
                        0.09,
                        -0.73,
                        0.00,
                        0.68,
                        0.64,
                        0.64,
                        0.64,
                        -9.86,
                        0.92,
                        -3.39,
                        -0.02,
                        -0.75,
                        0.07,
                        0.66,
                        0.53,
                        0.53,
                        0.53,
                        4.97,
                        -0.05,
                        -12.61,
                        -0.02,
                        -0.75,
                        -0.07,
                        0.66,
                        0.94,
                        0.94,
                        0.94,
                        -7.71,
                        -0.3,
                        -25.22,
                        0.12,
                        -0.68,
                        -0.01,
                        0.72,
                        0.86,
                        0.86,
                        0.86,
                        7.93,
                        -0.35,
                        -25.22,
                        -0.06,
                        -0.67,
                        0.03,
                        0.74,
                        0.46,
                        0.46,
                        0.46,
                        -10.14,
                        0.82,
                        -37.39,
                        0.02,
                        -0.68,
                        0.07,
                        0.73,
                        0.93,
                        0.93,
                        0.93,
                        -25.02,
                        0.68,
                        -20.2,
                        0.09,
                        -0.64,
                        -0.02,
                        0.77,
                        0.62,
                        0.62,
                        0.62,
                        -36.1,
                        0.12,
                        -17.49,
                        -0.08,
                        -0.67,
                        -0.03,
                        0.74,
                        0.99,
                        0.99,
                        0.99,
                        -8.08,
                        -0.29,
                        -26.88,
                        -0.02,
                        -0.73,
                        0.11,
                        0.68,
                        0.81,
                        0.81,
                        0.81,
                        -11.87,
                        0.90,
                        -33.49,
                        0.02,
                        -0.7,
                        -0.06,
                        0.71,
                        0.75,
                        0.75,
                        0.75,
                        -21.02,
                        0.24,
                        -29.07,
                        0.02,
                        -0.69,
                        -0.05,
                        0.72,
                        0.59,
                        0.59,
                        0.59,
                        21.61,
                        -0.57,
                        -30.49,
                        0.00,
                        -0.76,
                        -0.04,
                        0.65,
                        0.93,
                        0.93,
                        0.93,
                        -0.14,
                        -0.58,
                        -21.52,
                        0.05,
                        -0.79,
                        0.02,
                        0.61,
                        0.44,
                        0.44,
                        0.44,
                        17.08,
                        0.10,
                        -4.38,
                        0.06,
                        -0.68,
                        0.13,
                        0.72,
                        0.91,
                        0.91,
                        0.91,
                        -7.37,
                        -0.37,
                        -26.46,
                        0.08,
                        -0.76,
                        -0.05,
                        0.64,
                        0.67,
                        0.67,
                        0.67,
                        2.44,
                        0.61,
                        -32.85,
                        0.04,
                        -0.68,
                        0.06,
                        0.73,
                        0.43,
                        0.43,
                        0.43,
                        -29.29,
                        0.32,
                        -16.87,
                        0.13,
                        -0.68,
                        -0.04,
                        0.72,
                        0.46,
                        0.46,
                        0.46,
                        5.00,
                        -0.19,
                        -24.31,
                        -0.04,
                        -0.65,
                        0.02,
                        0.76,
                        0.97,
                        0.97,
                        0.97,
                        -10.05,
                        -0,
                        -28.89,
                        0.05,
                        -0.76,
                        0.07,
                        0.65,
                        0.84,
                        0.84,
                        0.84,
                        18.79,
                        -0.65,
                        -23,
                        0.01,
                        -0.73,
                        -0.13,
                        0.67,
                        0.97,
                        0.97,
                        0.97,
                        3.74,
                        0.53,
                        -49.9,
                        0.06,
                        -0.65,
                        -0.02,
                        0.75,
                        0.47,
                        0.47,
                        0.47,
                        -7.26,
                        0.23,
                        -39.42,
                        -0.08,
                        -0.71,
                        -0.03,
                        0.70,
                        0.80,
                        0.80,
                        0.80,
                        -39.75,
                        0.36,
                        -17.76,
                        -0.08,
                        -0.75,
                        0.06,
                        0.66,
                        0.91,
                        0.91,
                        0.91,
                        -6.3,
                        0.41,
                        -35.2,
                        -0.04,
                        -0.74,
                        -0.03,
                        0.67,
                        0.59,
                        0.59,
                        0.59,
                        -21.94,
                        0.21,
                        -30.72,
                        -0.14,
                        -0.73,
                        -0.01,
                        0.67,
                        0.94,
                        0.94,
                        0.94,
                        -17.7,
                        0.02,
                        -51.12,
                        -0.08,
                        -0.67,
                        0.03,
                        0.74,
                        0.87,
                        0.87,
                        0.87,
                        2.57,
                        0.38,
                        -35.36,
                        0.01,
                        -0.69,
                        0.06,
                        0.72,
                        0.80,
                        0.80,
                        0.80,
                        7.77,
                        0.60,
                        -42.04,
                        0.06,
                        -0.77,
                        -0.03,
                        0.63,
                        0.74,
                        0.74,
                        0.74,
                        6.55,
                        -0.04,
                        -28.93,
                        0.05,
                        -0.69,
                        0.08,
                        0.72,
                        0.75,
                        0.75,
                        0.75,
                        -10.43,
                        0.95,
                        -34,
                        0.08,
                        -0.77,
                        -0.05,
                        0.63,
                        0.60,
                        0.60,
                        0.60,
                        16.89,
                        -0.62,
                        -12.76,
                        0.04,
                        -0.74,
                        0.06,
                        0.67,
                        0.44,
                        0.44,
                        0.44,
                        26.03,
                        -0.59,
                        -8.19,
                        0.03,
                        -0.73,
                        -0.13,
                        0.67,
                        0.76,
                        0.76,
                        0.76,
                        19.36,
                        -0.56,
                        -18.05,
                        0.05,
                        -0.76,
                        -0.01,
                        0.64,
                        0.97,
                        0.97,
                        0.97,
                        -7.33,
                        0.24,
                        -39.23,
                        0.04,
                        -0.76,
                        0.08,
                        0.65,
                        0.57,
                        0.57,
                        0.57,
                        -10.97,
                        1.03,
                        -34.61,
                        0.01,
                        -0.65,
                        -0.11,
                        0.75,
                        0.75,
                        0.75,
                        0.75,
                        -9.9,
                        -0.01,
                        -28.81,
                        0.00,
                        -0.74,
                        -0.08,
                        0.67,
                        0.96,
                        0.96,
                        0.96,
                        -0.51,
                        0.41,
                        -33.75,
                        0.08,
                        -0.75,
                        -0.01,
                        0.66,
                        0.92,
                        0.92,
                        0.92,
                        -10.67,
                        0.49,
                        -30.61,
                        0.01,
                        -0.69,
                        0.09,
                        0.72,
                        0.60,
                        0.60,
                        0.60,
                        -10.24,
                        0.02,
                        -29.05,
                        0.08,
                        -0.74,
                        -0.04,
                        0.67,
                        0.97,
                        0.97,
                        0.97,
                        0.62,
                        -0.59,
                        -20.62,
                        0.02,
                        -0.71,
                        0.06,
                        0.70,
                        0.67,
                        0.67,
                        0.67,
                        -3,
                        0.17,
                        -39.51,
                        0.04,
                        -0.64,
                        -0.07,
                        0.76,
                        0.87,
                        0.87,
                        0.87,
                        -43.07,
                        0.50,
                        -22.06,
                        -0.04,
                        -0.69,
                        -0.07,
                        0.72,
                        0.52,
                        0.52,
                        0.52,
                        5.43,
                        -0.31,
                        -22.85,
                        0.05,
                        -0.66,
                        -0.11,
                        0.74,
                        0.78,
                        0.78,
                        0.78,
                        0.99,
                        0.39,
                        -57.16,
                        -0.01,
                        -0.77,
                        -0.04,
                        0.64,
                        0.82,
                        0.82,
                        0.82,
                        -3.94,
                        0.08,
                        -70.99,
                        0.09,
                        -0.63,
                        0.05,
                        0.77,
                        0.67,
                        0.67,
                        0.67,
                        -22.45,
                        0.40,
                        -27.26,
                        -0.13,
                        -0.69,
                        0.00,
                        0.71,
                        0.54,
                        0.54,
                        0.54,
                        0.20,
                        1.02,
                        -55.2,
                        -0.04,
                        -0.75,
                        0.05,
                        0.65,
                        0.74,
                        0.74,
                        0.74,
                        4.12,
                        0.38,
                        -30,
                        -0.05,
                        -0.75,
                        -0.05,
                        0.66,
                        0.89,
                        0.89,
                        0.89,
                        5.49,
                        0.08,
                        -29.36,
                        0.15,
                        -0.71,
                        -0.01,
                        0.68,
                        0.83,
                        0.83,
                        0.83,
                        7.81,
                        -0.35,
                        -25.99,
                        -0.03,
                        -0.66,
                        0.05,
                        0.75,
                        0.63,
                        0.63,
                        0.63,
                        8.53,
                        -0.24,
                        -26.25,
                        0.06,
                        -0.69,
                        0.04,
                        0.72,
                        0.47,
                        0.47,
                        0.47,
                        4.38,
                        0.42,
                        -30.68,
                        -0.1,
                        -0.65,
                        0.07,
                        0.75,
                        0.50,
                        0.50,
                        0.50,
                        -5.92,
                        0.26,
                        -39.91,
                        0.02,
                        -0.76,
                        0.04,
                        0.65,
                        0.49,
                        0.49,
                        0.49,
                        -32,
                        0.11,
                        -38.83,
                        -0.05,
                        -0.68,
                        -0.13,
                        0.72,
                        0.90,
                        0.90,
                        0.90,
                        -10.76,
                        0.09,
                        -29.44,
                        0.06,
                        -0.71,
                        -0.1,
                        0.69,
                        0.94,
                        0.94,
                        0.94,
                        -9.71,
                        1.01,
                        -34.12,
                        0.03,
                        -0.73,
                        -0.01,
                        0.68,
                        0.62,
                        0.62,
                        0.62,
                        -23.03,
                        0.19,
                        -31.88,
                        0.03,
                        -0.64,
                        0.07,
                        0.76,
                        0.56,
                        0.56,
                        0.56,
                        8.52,
                        -0.19,
                        -26.88,
                        0.10,
                        -0.64,
                        0.01,
                        0.76,
                        0.67,
                        0.67,
                        0.67,
                        19.86,
                        0.37,
                        -31.05,
                        -0.08,
                        -0.64,
                        0.00,
                        0.77,
                        0.56,
                        0.56,
                        0.56,
                        9.36,
                        0.09,
                        -38.32,
                        0.02,
                        -0.72,
                        0.10,
                        0.68,
                        0.66,
                        0.66,
                        0.66,
                        -1.63,
                        0.67,
                        -55.87,
                        0.04,
                        -0.75,
                        -0.08,
                        0.65,
                        0.63,
                        0.63,
                        0.63,
                        -2.44,
                        -0.08,
                        -26.59,
                        0.07,
                        -0.71,
                        0.03,
                        0.70,
                        0.94,
                        0.94,
                        0.94,
                        -18.78,
                        1.13,
                        -38.47,
                        -0.07,
                        -0.72,
                        0.09,
                        0.69,
                        0.46,
                        0.46,
                        0.46,
                        5.56,
                        0.12,
                        -30,
                        0.00,
                        -0.73,
                        -0.02,
                        0.68,
                        0.68,
                        0.68,
                        0.68,
                        -0.04,
                        1.22,
                        -51.53,
                        0.04,
                        -0.6,
                        0.01,
                        0.80,
                        0.45,
                        0.45,
                        0.45,
                        -22.65,
                        0.14,
                        -30.8,
                        -0.12,
                        -0.68,
                        -0.07,
                        0.72,
                        0.93,
                        0.93,
                        0.93,
                        -14.51,
                        1.01,
                        -17.15,
                        -0.08,
                        -0.7,
                        0.11,
                        0.70,
                        0.76,
                        0.76,
                        0.76,
                        -18.32,
                        1.57,
                        -43.21,
                        0.01,
                        -0.75,
                        -0.01,
                        0.66,
                        0.50,
                        0.50,
                        0.50,
                        8.58,
                        -0.3,
                        -25.69,
                        0.09,
                        -0.74,
                        0.09,
                        0.67,
                        0.75,
                        0.75,
                        0.75,
                        -11.45,
                        0.24,
                        -29.62,
                        0.05,
                        -0.77,
                        -0.1,
                        0.62,
                        0.83,
                        0.83,
                        0.83,
                        16.97,
                        0.86,
                        -37.27,
                        0.06,
                        -0.65,
                        0.03,
                        0.76,
                        0.96,
                        0.96,
                        0.96,
                        33.79,
                        0.03,
                        -13.07,
                        -0.13,
                        -0.73,
                        -0.01,
                        0.68,
                        0.78,
                        0.78,
                        0.78,
                        -0.97,
                        0.06,
                        -65.63,
                        -0.08,
                        -0.68,
                        0.04,
                        0.73,
                        0.67,
                        0.67,
                        0.67,
                        0.30,
                        -0.61,
                        -21.24,
                        0.01,
                        -0.7,
                        0.05,
                        0.72,
                        0.62,
                        0.62,
                        0.62,
                        -0.51,
                        1.34,
                        -50.71,
                        0.08,
                        -0.73,
                        -0.04,
                        0.68,
                        0.83,
                        0.83,
                        0.83,
                        -5.8,
                        0.06,
                        -71.93,
                        0.01,
                        -0.76,
                        0.04,
                        0.64,
                        0.58,
                        0.58,
                        0.58,
                        -42.11,
                        0.62,
                        -18.87,
                        -0.03,
                        -0.62,
                        -0.07,
                        0.78,
                        0.52,
                        0.52,
                        0.52,
                        -16.2,
                        -0.1,
                        -50.82,
                        -0.02,
                        -0.66,
                        -0.12,
                        0.74,
                        0.64,
                        0.64,
                        0.64,
                        -18.54,
                        0.91,
                        -36.56,
                        0.02,
                        -0.65,
                        -0.09,
                        0.75,
                        0.88,
                        0.88,
                        0.88,
                        -27.34,
                        0.26,
                        -40.21,
                        -0.02,
                        -0.66,
                        -0.07,
                        0.75,
                        0.73,
                        0.73,
                        0.73,
                        -3.5,
                        -0.2,
                        -25.91,
                        0.00,
                        -0.66,
                        -0.1,
                        0.75,
                        0.73,
                        0.73,
                        0.73,
                        12.47,
                        0.16,
                        -36.52,
                        0.00,
                        -0.65,
                        -0.07,
                        0.76,
                        0.64,
                        0.64,
                        0.64,
                        10.04,
                        0.12,
                        -38.58,
                        -0.02,
                        -0.67,
                        -0.09,
                        0.74,
                        0.96,
                        0.96,
                        0.96,
                        -9.82,
                        0.90,
                        -36.77,
                        0.02,
                        -0.74,
                        -0.1,
                        0.67,
                        0.75,
                        0.75,
                        0.75,
                        -18.94,
                        1.45,
                        -19.65,
                        0.06,
                        -0.66,
                        0.00,
                        0.75,
                        0.70,
                        0.70,
                        0.70,
                        -7.35,
                        0.99,
                        -5.97,
                        -0.09,
                        -0.65,
                        -0.02,
                        0.75,
                        0.49,
                        0.49,
                        0.49,
                        4.90,
                        0.20,
                        -29.84,
                        -0.01,
                        -0.7,
                        0.11,
                        0.70,
                        0.62,
                        0.62,
                        0.62,
                        5.77,
                        0.05,
                        -11.14,
                        0.05,
                        -0.75,
                        -0.05,
                        0.66,
                        0.92,
                        0.92,
                        0.92,
                        -9.21,
                        0.60,
                        -37.24,
                        0.05,
                        -0.73,
                        0.05,
                        0.69,
                        0.44,
                        0.44,
                        0.44,
                        -17.19,
                        1.14,
                        -19.35,
                        -0.06,
                        -0.74,
                        0.13,
                        0.66,
                        0.80,
                        0.80,
                        0.80,
                        -24.98,
                        0.10,
                        -59.35,
                        0.00,
                        -0.76,
                        -0.04,
                        0.64,
                        0.82,
                        0.82,
                        0.82,
                        2.26,
                        0.39,
                        -35.56,
                        0.09,
                        -0.64,
                        0.05,
                        0.76,
                        0.67,
                        0.67,
                        0.67,
                        -0.34,
                        1.35,
                        -50.57,
                        -0.11,
                        -0.65,
                        0.01,
                        0.75,
                        0.65,
                        0.65,
                        0.65,
                        -29.26,
                        0.39,
                        -16.34,
                        0.00,
                        -0.74,
                        0.08,
                        0.67,
                        0.56,
                        0.56,
                        0.56,
                        -27.1,
                        0.27,
                        -17.79,
                        0.00,
                        -0.74,
                        -0.09,
                        0.67,
                        0.49,
                        0.49,
                        0.49,
                        18.20,
                        -0.03,
                        -30.29,
                        0.08,
                        -0.72,
                        -0.01,
                        0.69,
                        0.58,
                        0.58,
                        0.58,
                        -30.06,
                        0.51,
                        -15.95,
                        -0.02,
                        -0.75,
                        0.05,
                        0.65,
                        0.52,
                        0.52,
                        0.52,
                        5.40,
                        0.68,
                        -45.81,
                        -0.04,
                        -0.76,
                        -0.07,
                        0.65,
                        0.52,
                        0.52,
                        0.52,
                        17.50,
                        -0.04,
                        -31.11,
                        0.13,
                        -0.71,
                        0.00,
                        0.69,
                        0.54,
                        0.54,
                        0.54,
                        -4.55,
                        0.21,
                        -39.72,
                        -0.04,
                        -0.74,
                        0.06,
                        0.67,
                        0.44,
                        0.44,
                        0.44,
                        3.94,
                        -0.25,
                        -23.58,
                        -0.02,
                        -0.75,
                        -0.04,
                        0.66,
                        0.53,
                        0.53,
                        0.53,
                        16.58,
                        0.83,
                        -36.26,
                        0.11,
                        -0.76,
                        0.02,
                        0.64,
                        0.87,
                        0.87,
                        0.87,
                        -8.55,
                        0.63,
                        -36.21,
                        0.00,
                        -0.72,
                        0.11,
                        0.69,
                        0.45,
                        0.45,
                        0.45,
                        -36.93,
                        -0.04,
                        -17.8,
                        0.03,
                        -0.76,
                        -0.05,
                        0.65,
                        0.47,
                        0.47,
                        0.47,
                        -26.13,
                        0.14,
                        -62.01,
                        0.08,
                        -0.69,
                        0.05,
                        0.72,
                        0.71,
                        0.71,
                        0.71,
                        -24.96,
                        0.11,
                        -69.28,
                        -0.08,
                        -0.77,
                        0.05,
                        0.63,
                        0.92,
                        0.92,
                        0.92,
                        7.08,
                        -0.26,
                        -26.22,
                        -0.07,
                        -0.7,
                        -0.04,
                        0.71,
                        0.79,
                        0.79,
                        0.79,
                        -2.88,
                        -0.33,
                        -23.62,
                        -0.07,
                        -0.63,
                        0.08,
                        0.77,
                        0.79,
                        0.79,
                        0.79,
                        -1.3,
                        0.43,
                        -33.23,
                        0.06,
                        -0.7,
                        0.05,
                        0.71,
                        0.45,
                        0.45,
                        0.45,
                        -15.73,
                        0.46,
                        -45.98,
                        -0.08,
                        -0.63,
                        0.08,
                        0.77,
                        0.91,
                        0.91,
                        0.91,
                        -19.86,
                        0.09,
                        -51.58,
                        0.05,
                        -0.71,
                        0.05,
                        0.70,
                        0.92,
                        0.92,
                        0.92,
                        -22.63,
                        0.25,
                        -32.2,
                        0.08,
                        -0.77,
                        -0.09,
                        0.63,
                        0.92,
                        0.92,
                        0.92,
                        -20.34,
                        0.94,
                        -37.55,
                        0.04,
                        -0.75,
                        0.04,
                        0.66,
                        0.56,
                        0.56,
                        0.56,
                        -23.22,
                        0.18,
                        -28.38,
                        0.01,
                        -0.65,
                        0.13,
                        0.75,
                        0.63,
                        0.63,
                        0.63,
                        15.88,
                        0.85,
                        -36.94,
                        0.08,
                        -0.75,
                        -0.02,
                        0.66,
                        0.49,
                        0.49,
                        0.49,
                        32.10,
                        0.30,
                        -9.56,
                        0.01,
                        -0.75,
                        0.07,
                        0.66,
                        0.93,
                        0.93,
                        0.93,
                        15.67,
                        -0.57,
                        -12.33,
                        -0.01,
                        -0.76,
                        -0.09,
                        0.64,
                        0.75,
                        0.75,
                        0.75,
                        6.87,
                        -0.34,
                        -23.44,
                        0.11,
                        -0.71,
                        0.01,
                        0.70,
                        0.85,
                        0.85,
                        0.85,
                        -10.51,
                        0.66,
                        -31.32,
                        -0.06,
                        -0.72,
                        0.07,
                        0.69,
                        0.50,
                        0.50,
                        0.50,
                        24.54,
                        -0.5,
                        -8.23,
                        0.00,
                        -0.67,
                        -0.02,
                        0.74,
                        0.51,
                        0.51,
                        0.51,
                        3.43,
                        -0.34,
                        -21.44,
                        -0.03,
                        -0.61,
                        -0.06,
                        0.79,
                        0.66,
                        0.66,
                        0.66,
                        -10.7,
                        0.73,
                        -32.01,
                        -0.04,
                        -0.74,
                        -0.12,
                        0.66,
                        0.96,
                        0.96,
                        0.96,
                        34.14,
                        0.07,
                        -34.13,
                        0.10,
                        -0.67,
                        -0.03,
                        0.74,
                        0.64,
                        0.64,
                        0.64,
                        -3.96,
                        0.32,
                        -37.03,
                        -0.05,
                        -0.75,
                        0.00,
                        0.65,
                        0.98,
                        0.98,
                        0.98,
                        -1.96,
                        0.04,
                        -67.96,
                        -0.11,
                        -0.72,
                        -0.03,
                        0.69,
                        0.73,
                        0.73,
                        0.73,
                        0.52,
                        -0.4,
                        -23.39,
                        -0.09,
                        -0.68,
                        0.06,
                        0.73,
                        0.46,
                        0.46,
                        0.46,
                        3.26,
                        -0.36,
                        -19.04,
                        0.01,
                        -0.65,
                        0.03,
                        0.76,
                        0.71,
                        0.71,
                        0.71,
                        -4.28,
                        0.13,
                        -40.45,
                        0.09,
                        -0.77,
                        0.04,
                        0.63,
                        0.93,
                        0.93,
                        0.93,
                        1.84,
                        0.35,
                        -58.25,
                        0.00,
                        -0.65,
                        0.11,
                        0.75,
                        0.72,
                        0.72,
                        0.72,
                        14.81,
                        -0.56,
                        -11.33,
                        0.09,
                        -0.72,
                        0.00,
                        0.68,
                        0.52,
                        0.52,
                        0.52,
                        -8.12,
                        0.06,
                        -73.91,
                        -0.03,
                        -0.69,
                        0.07,
                        0.72,
                        0.48,
                        0.48,
                        0.48,
                        -0.6,
                        0.10,
                        -67.42,
                        0.04,
                        -0.66,
                        -0.01,
                        0.75,
                        0.86,
                        0.86,
                        0.86,
                        -26.85,
                        0.18,
                        -62.78,
                        -0.08,
                        -0.75,
                        -0.04,
                        0.65,
                        0.89,
                        0.89,
                        0.89,
                        -1.45,
                        0.96,
                        -53.35,
                        -0.11,
                        -0.66,
                        0.01,
                        0.74,
                        0.93,
                        0.93,
                        0.93,
                        -25.64,
                        0.54,
                        -19.31,
                        -0.01,
                        -0.74,
                        0.07,
                        0.67,
                        0.43,
                        0.43,
                        0.43,
                        4.84,
                        -0.19,
                        -24.23,
                        0.00,
                        -0.75,
                        -0.07,
                        0.65,
                        0.68,
                        0.68,
                        0.68,
                        0.21,
                        -0.58,
                        -21.78,
                        0.08,
                        -0.77,
                        0.01,
                        0.64,
                        0.66,
                        0.66,
                        0.66,
                        6.94,
                        -0.22,
                        -26.24,
                        0.02,
                        -0.66,
                        0.10,
                        0.75,
                        0.57,
                        0.57,
                        0.57,
                        4.32,
                        -0.26,
                        -15.59,
                        0.10,
                        -0.68,
                        -0.02,
                        0.73,
                        0.44,
                        0.44,
                        0.44,
                        11.90,
                        0.01,
                        -36.11,
                        -0.07,
                        -0.68,
                        0.01,
                        0.73,
                        0.84,
                        0.84,
                        0.84,
                        -7.22,
                        1.08,
                        -7.55,
                        0.00,
                        -0.67,
                        0.07,
                        0.74,
                        0.57,
                        0.57,
                        0.57,
                        32.22,
                        -0.11,
                        -11.49,
                        0.09,
                        -0.72,
                        -0.01,
                        0.69,
                        0.97,
                        0.97,
                        0.97,
                        -31.49,
                        0.36,
                        -40.71,
                        -0.03,
                        -0.67,
                        0.06,
                        0.74,
                        0.65,
                        0.65,
                        0.65,
                        -1.61,
                        0.11,
                        -57.34,
                        0.06,
                        -0.71,
                        0.02,
                        0.70,
                        0.61,
                        0.61,
                        0.61,
                        -2.78,
                        0.20,
                        -39.12,
                        -0.04,
                        -0.79,
                        0.04,
                        0.61,
                        0.96,
                        0.96,
                        0.96,
                        -2.49,
                        0.23,
                        -38.38,
                        -0.06,
                        -0.77,
                        -0.06,
                        0.64,
                        0.98,
                        0.98,
                        0.98,
                        -5.88,
                        0.71,
                        -9.19,
                        0.15,
                        -0.7,
                        0.01,
                        0.70,
                        0.46,
                        0.46,
                        0.46,
                        8.61,
                        -0.22,
                        -26.72,
                        -0.05,
                        -0.66,
                        0.05,
                        0.75,
                        0.59,
                        0.59,
                        0.59,
                        6.32,
                        0.03,
                        -29.71,
                        0.05,
                        -0.68,
                        0.04,
                        0.73,
                        0.79,
                        0.79,
                        0.79,
                        0.00,
                        1.31,
                        -50.67,
                        -0.12,
                        -0.64,
                        0.03,
                        0.76,
                        0.50,
                        0.50,
                        0.50,
                        -6.7,
                        -0.3,
                        -24.9,
                        0.01,
                        -0.74,
                        0.07,
                        0.67,
                        0.88,
                        0.88,
                        0.88,
                        20.74,
                        -0.32,
                        -8.52,
                        0.01,
                        -0.72,
                        -0.1,
                        0.69,
                        0.85,
                        0.85,
                        0.85,
                        8.53,
                        -0.3,
                        -25.66,
                        0.06,
                        -0.71,
                        -0.03,
                        0.70,
                        0.86,
                        0.86,
                        0.86,
                        -2.74,
                        0.16,
                        -39.39,
                        -0.01,
                        -0.78,
                        0.01,
                        0.63,
                        0.50,
                        0.50,
                        0.50,
                        -21.21,
                        0.42,
                        -33.18,
                        -0.09,
                        -0.67,
                        -0.1,
                        0.73,
                        0.42,
                        0.42,
                        0.42,
                        -10.67,
                        1.09,
                        -36.41,
                        0.06,
                        -0.72,
                        -0.14,
                        0.68,
                        0.92,
                        0.92,
                        0.92,
                        18.87,
                        0.59,
                        -34.02,
                        0.04,
                        -0.7,
                        -0.01,
                        0.72,
                        0.57,
                        0.57,
                        0.57,
                        -17.04,
                        1.45,
                        -43.3,
                        -0.02,
                        -0.61,
                        0.00,
                        0.79,
                        0.55,
                        0.55,
                        0.55,
                        -1.22,
                        0.26,
                        -38.27,
                        0.06,
                        -0.63,
                        0.08,
                        0.77,
                        0.84,
                        0.84,
                        0.84,
                        0.56,
                        -0.59,
                        -21.29,
                        0.14,
                        -0.73,
                        0.00,
                        0.67,
                        0.74,
                        0.74,
                        0.74,
                        -2.17,
                        0.39,
                        -33.84,
                        -0.03,
                        -0.69,
                        0.08,
                        0.72,
                        0.62,
                        0.62,
                        0.62,
                        -11.89,
                        0.90,
                        -33.63,
                        0.04,
                        -0.65,
                        -0.01,
                        0.76,
                        0.70,
                        0.70,
                        0.70,
                        1.99,
                        0.44,
                        -30.06,
                        -0.1,
                        -0.71,
                        -0.06,
                        0.70,
                        0.51,
                        0.51,
                        0.51,
                        0.56,
                        -0.32,
                        -23.89,
                        -0.07,
                        -0.62,
                        0.06,
                        0.78,
                        0.92,
                        0.92,
                        0.92,
                        30.39,
                        0.21,
                        -8.14,
                        0.06,
                        -0.72,
                        0.06,
                        0.69,
                        0.71,
                        0.71,
                        0.71,
                        1.77,
                        0.42,
                        -29.79,
                        0.08,
                        -0.65,
                        -0.11,
                        0.75,
                        0.53,
                        0.53,
                        0.53,
                        19.89,
                        0.53,
                        -35.92,
                        -0.02,
                        -0.65,
                        -0.04,
                        0.76,
                        0.81,
                        0.81,
                        0.81,
                        -28.45,
                        0.24,
                        -17.34,
                        -0.04,
                        -0.65,
                        -0.12,
                        0.75,
                        0.85,
                        0.85,
                        0.85,
                        -20.72,
                        1.45,
                        -20.6,
                        0.02,
                        -0.65,
                        -0.09,
                        0.76,
                        0.82,
                        0.82,
                        0.82,
                        1.27,
                        -0.54,
                        -18.66,
                        -0.02,
                        -0.66,
                        -0.08,
                        0.74,
                        0.67,
                        0.67,
                        0.67,
                        -11.51,
                        0.57,
                        -30.35,
                        0.01,
                        -0.72,
                        -0.11,
                        0.68,
                        0.70,
                        0.70,
                        0.70,
                        7.68,
                        -0.4,
                        -23.85,
                        0.07,
                        -0.69,
                        -0.03,
                        0.72,
                        0.51,
                        0.51,
                        0.51,
                        -26.68,
                        0.33,
                        -17.61,
                        -0.04,
                        -0.74,
                        0.01,
                        0.67,
                        0.64,
                        0.64,
                        0.64,
                        -10.68,
                        0.93,
                        -33.8,
                        -0.06,
                        -0.78,
                        -0.02,
                        0.62,
                        0.74,
                        0.74,
                        0.74,
                        -6.71,
                        -0.25,
                        -24.01,
                        -0.12,
                        -0.74,
                        -0.04,
                        0.67,
                        0.68,
                        0.68,
                        0.68,
                        -6.88,
                        0.43,
                        -34.66,
                        -0.1,
                        -0.72,
                        0.04,
                        0.68,
                        0.47,
                        0.47,
                        0.47,
                        -12.77,
                        0.48,
                        -48.6,
                        -0.04,
                        -0.75,
                        0.01,
                        0.66,
                        0.95,
                        0.95,
                        0.95,
                        8.47,
                        -0.18,
                        -26.89,
                        -0.09,
                        -0.74,
                        -0.05,
                        0.66,
                        0.81,
                        0.81,
                        0.81,
                        19.49,
                        -0.64,
                        -10.47,
                        -0.12,
                        -0.67,
                        0.03,
                        0.73,
                        0.65,
                        0.65,
                        0.65,
                        26.64,
                        -0.41,
                        -7.48,
                        -0.01,
                        -0.69,
                        0.06,
                        0.72,
                        0.94,
                        0.94,
                        0.94,
                        -25.39,
                        0.01,
                        -64.14,
                        0.05,
                        -0.77,
                        -0.01,
                        0.63,
                        0.69,
                        0.69,
                        0.69,
                        1.27,
                        -0.53,
                        -21.23,
                        0.05,
                        -0.76,
                        0.08,
                        0.64,
                        0.42,
                        0.42,
                        0.42,
                        -18.1,
                        0.78,
                        -21.05,
                        0.00,
                        -0.74,
                        -0.12,
                        0.66,
                        0.65,
                        0.65,
                        0.65,
                        -7.35,
                        0.26,
                        -38.45,
                        0.08,
                        -0.69,
                        -0.02,
                        0.72,
                        0.56,
                        0.56,
                        0.56,
                        -23.95,
                        0.50,
                        -23.88,
                        -0.04,
                        -0.65,
                        0.02,
                        0.76,
                        0.42,
                        0.42,
                        0.42,
                        -35.58,
                        0.17,
                        -17.36,
                        0.05,
                        -0.65,
                        0.07,
                        0.75,
                        0.53,
                        0.53,
                        0.53,
                        -4.89,
                        -0.3,
                        -24.86,
                        0.11,
                        -0.76,
                        -0.01,
                        0.64,
                        0.43,
                        0.43,
                        0.43,
                        3.48,
                        -0.21,
                        -24.12,
                        0.01,
                        -0.67,
                        0.09,
                        0.73,
                        0.47,
                        0.47,
                        0.47,
                        -20.6,
                        0.35,
                        -31.9,
                        0.08,
                        -0.74,
                        -0.02,
                        0.67,
                        0.80,
                        0.80,
                        0.80,
                        -2.22,
                        0.95,
                        -54.05,
                        0.01,
                        -0.69,
                        0.07,
                        0.72,
                        0.64,
                        0.64,
                        0.64,
                        4.82,
                        -0.15,
                        -24.64,
                        0.06,
                        -0.65,
                        -0.04,
                        0.76,
                        0.85,
                        0.85,
                        0.85,
                        -3.02,
                        0.31,
                        -31.73,
                        -0.07,
                        -0.71,
                        -0.04,
                        0.70,
                        0.44,
                        0.44,
                        0.44,
                        -15.01,
                        -0.07,
                        -50.46,
                        -0.09,
                        -0.68,
                        0.09,
                        0.72,
                        0.83,
                        0.83,
                        0.83,
                        -0.3,
                        1.21,
                        -51.68,
                        0.01,
                        -0.71,
                        0.02,
                        0.70,
                        0.62,
                        0.62,
                        0.62,
                        10.17,
                        0.19,
                        -38.83,
                        0.05,
                        -0.63,
                        -0.09,
                        0.77,
                        0.95,
                        0.95,
                        0.95,
                        -44.04,
                        0.88,
                        -20.14,
                        -0.04,
                        -0.68,
                        -0.07,
                        0.73,
                        0.56,
                        0.56,
                        0.56,
                        -19.23,
                        0.77,
                        -34.56,
                        0.04,
                        -0.77,
                        -0.09,
                        0.63,
                        0.59,
                        0.59,
                        0.59,
                        -34.83,
                        0.34,
                        -16.97,
                        0.03,
                        -0.79,
                        0.01,
                        0.61,
                        0.78,
                        0.78,
                        0.78,
                        39.71,
                        -0.01,
                        -27.44,
                        0.07,
                        -0.68,
                        0.12,
                        0.72,
                        0.97,
                        0.97,
                        0.97,
                        -12.79,
                        0.40,
                        -17.57,
                        0.10,
                        -0.67,
                        -0.07,
                        0.73,
                        0.97,
                        0.97,
                        0.97,
                        -25,
                        0.68,
                        -20.23,
                        -0.03,
                        -0.67,
                        -0.01,
                        0.74,
                        0.54,
                        0.54,
                        0.54,
                        0.88,
                        -0.38,
                        -23.47,
                        0.02,
                        -0.64,
                        0.10,
                        0.76,
                        0.76,
                        0.76,
                        0.76,
                        3.45,
                        -0.24,
                        -23.81,
                        0.09,
                        -0.76,
                        -0.01,
                        0.64,
                        0.98,
                        0.98,
                        0.98,
                        -4.18,
                        0.35,
                        -36.68,
                        0.02,
                        -0.72,
                        0.10,
                        0.69,
                        0.47,
                        0.47,
                        0.47,
                        -19.84,
                        1.50,
                        -19.87,
                        0.04,
                        -0.65,
                        -0.07,
                        0.76,
                        0.42,
                        0.42,
                        0.42,
                        34.01,
                        0.25,
                        -12.51,
                        -0.04,
                        -0.68,
                        -0.07,
                        0.73,
                        0.88,
                        0.88,
                        0.88,
                        -8.98,
                        0.46,
                        -37.8,
                        0.04,
                        -0.76,
                        -0.1,
                        0.65,
                        0.92,
                        0.92,
                        0.92,
                        23.15,
                        0.13,
                        -37.74,
                        0.06,
                        -0.65,
                        0.02,
                        0.76,
                        0.65,
                        0.65,
                        0.65,
                        23.99,
                        -0.46,
                        -8.09,
                        -0.12,
                        -0.68,
                        -0.02,
                        0.73,
                        0.92,
                        0.92,
                        0.92,
                        11.99,
                        0.04,
                        -36.21,
                        -0.04,
                        -0.65,
                        0.08,
                        0.75,
                        0.70,
                        0.70,
                        0.70,
                        -10.59,
                        0.15,
                        -29.8,
                        0.05,
                        -0.76,
                        0.02,
                        0.64,
                        0.66,
                        0.66,
                        0.66,
                        2.12,
                        -0.46,
                        -20.36,
                        0.02,
                        -0.65,
                        0.11,
                        0.75,
                        0.69,
                        0.69,
                        0.69,
                        -27.82,
                        0.28,
                        -17.12,
                        0.11,
                        -0.7,
                        -0.01,
                        0.70,
                        0.66,
                        0.66,
                        0.66,
                        5.14,
                        -0.16,
                        -13.25,
                        -0.05,
                        -0.71,
                        0.05,
                        0.70,
                        0.69,
                        0.69,
                        0.69,
                        8.83,
                        -0.34,
                        -25.16,
                        0.00,
                        -0.76,
                        -0.01,
                        0.65,
                        0.76,
                        0.76,
                        0.76,
                        3.57,
                        0.47,
                        -29.85,
                        0.11,
                        -0.68,
                        0.10,
                        0.72,
                        0.93,
                        0.93,
                        0.93,
                        3.41,
                        0.59,
                        -33.15,
                        -0.12,
                        -0.73,
                        0.08,
                        0.67,
                        0.67,
                        0.67,
                        0.67,
                        25.32,
                        -0.2,
                        -36.77,
                        -0.03,
                        -0.65,
                        -0.01,
                        0.76,
                        0.78,
                        0.78,
                        0.78,
                        6.35,
                        -0.23,
                        -24.43,
                        0.06,
                        -0.74,
                        0.11,
                        0.66,
                        0.83,
                        0.83,
                        0.83,
                        -22.55,
                        0.18,
                        -31.07,
                        0.04,
                        -0.75,
                        -0.11,
                        0.65,
                        0.60,
                        0.60,
                        0.60,
                        16.78,
                        0.92,
                        -38.27,
                        0.06,
                        -0.67,
                        0.01,
                        0.74,
                        0.54,
                        0.54,
                        0.54,
                        -7.1,
                        -0.06,
                        -72.66,
                        -0.11,
                        -0.71,
                        -0.01,
                        0.69,
                        0.66,
                        0.66,
                        0.66,
                        39.37,
                        0.93,
                        -31.57,
                        -0.06,
                        -0.76,
                        0.04,
                        0.65,
                        0.53,
                        0.53,
                        0.53,
                        -21.86,
                        1.06,
                        -21.68,
                        -0.06,
                        -0.66,
                        -0.05,
                        0.75,
                        0.63,
                        0.63,
                        0.63,
                        1.23,
                        -0.53,
                        -21.54,
                        -0.01,
                        -0.63,
                        0.11,
                        0.77,
                        0.84,
                        0.84,
                        0.84,
                        -9.25,
                        -0.06,
                        -28.72,
                        0.09,
                        -0.71,
                        0.02,
                        0.70,
                        0.50,
                        0.50,
                        0.50,
                        -2.47,
                        -0.08,
                        -57.73,
                        -0.06,
                        -0.69,
                        0.08,
                        0.72,
                        0.64,
                        0.64,
                        0.64,
                        -42.75,
                        0.54,
                        -20.97,
                        0.02,
                        -0.71,
                        0.01,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        -11.09,
                        1.00,
                        -34.24,
                        -0.03,
                        -0.61,
                        0.03,
                        0.79,
                        1.00,
                        1.00,
                        1.00,
                        5.04,
                        -0.31,
                        -19.72,
                        0.05,
                        -0.62,
                        0.06,
                        0.78,
                        0.48,
                        0.48,
                        0.48,
                        1.79,
                        0.29,
                        -27.59,
                        0.13,
                        -0.75,
                        0.03,
                        0.65,
                        0.70,
                        0.70,
                        0.70,
                        -26.66,
                        0.32,
                        -18.21,
                        -0.02,
                        -0.7,
                        0.10,
                        0.71,
                        0.69,
                        0.69,
                        0.69,
                        -21.56,
                        0.38,
                        -33,
                        0.03,
                        -0.65,
                        -0.03,
                        0.76,
                        0.96,
                        0.96,
                        0.96,
                        -21.56,
                        0.38,
                        -33,
                        -0.08,
                        -0.69,
                        -0.07,
                        0.71,
                        0.66,
                        0.66,
                        0.66,
                        4.72,
                        -0.21,
                        -13.97,
                        -0.09,
                        -0.72,
                        0.12,
                        0.68,
                        0.78,
                        0.78,
                        0.78,
                        -10.41,
                        0.07,
                        -29.42,
                        0.00,
                        -0.65,
                        -0.02,
                        0.76,
                        0.97,
                        0.97,
                        0.97,
                        22.25,
                        0.05,
                        -36,
                        -0.08,
                        -0.73,
                        -0.11,
                        0.67,
                        0.83,
                        0.83,
                        0.83,
                        17.99,
                        0.17,
                        -31.14,
                        0.09,
                        -0.63,
                        -0.05,
                        0.77,
                        0.53,
                        0.53,
                        0.53,
                        4.21,
                        -0.22,
                        -24.02,
                        -0.07,
                        -0.72,
                        -0.04,
                        0.69,
                        0.90,
                        0.90,
                        0.90,
                        3.95,
                        0.36,
                        -29.6,
                        -0.1,
                        -0.67,
                        0.07,
                        0.73,
                        0.67,
                        0.67,
                        0.67,
                        18.95,
                        -0.72,
                        -21.23,
                        0.01,
                        -0.65,
                        0.03,
                        0.76,
                        0.94,
                        0.94,
                        0.94,
                        18.72,
                        0.53,
                        -31.95,
                        0.12,
                        -0.67,
                        0.05,
                        0.73,
                        0.89,
                        0.89,
                        0.89,
                        -10.23,
                        0.07,
                        -29.6,
                        -0.08,
                        -0.64,
                        0.04,
                        0.76,
                        0.43,
                        0.43,
                        0.43,
                        1.54,
                        0.38,
                        -63.22,
                        0.03,
                        -0.68,
                        0.07,
                        0.73,
                        0.68,
                        0.68,
                        0.68,
                        19.90,
                        -0.65,
                        -20.21,
                        0.10,
                        -0.65,
                        -0.04,
                        0.75,
                        0.76,
                        0.76,
                        0.76,
                        0.97,
                        0.44,
                        -30.83,
                        -0.05,
                        -0.65,
                        -0.01,
                        0.76,
                        0.70,
                        0.70,
                        0.70,
                        16.62,
                        -0.61,
                        -13.53,
                        0.03,
                        -0.66,
                        0.11,
                        0.74,
                        0.55,
                        0.55,
                        0.55,
                        -40.88,
                        0.05,
                        -19.67,
                        0.09,
                        -0.76,
                        -0.02,
                        0.65,
                        0.95,
                        0.95,
                        0.95,
                        -5.74,
                        0.72,
                        -8.78,
                        0.02,
                        -0.73,
                        0.08,
                        0.67,
                        0.86,
                        0.86,
                        0.86,
                        -3.9,
                        -0.19,
                        -26.6,
                        0.02,
                        -0.69,
                        -0.1,
                        0.72,
                        0.69,
                        0.69,
                        0.69,
                        -5.53,
                        0.16,
                        -30.33,
                        0.02,
                        -0.66,
                        -0.05,
                        0.75,
                        0.97,
                        0.97,
                        0.97,
                        -30.72,
                        0.58,
                        -15.77,
                        -0.03,
                        -0.76,
                        -0.07,
                        0.65,
                        0.74,
                        0.74,
                        0.74,
                        18.25,
                        -0.53,
                        -19.9,
                        0.13,
                        -0.72,
                        0.01,
                        0.68,
                        0.75,
                        0.75,
                        0.75,
                        8.26,
                        -0.16,
                        -27.56,
                        -0.04,
                        -0.66,
                        0.06,
                        0.75,
                        0.97,
                        0.97,
                        0.97,
                        -25.33,
                        0.05,
                        -60.83,
                        0.06,
                        -0.74,
                        0.03,
                        0.67,
                        0.63,
                        0.63,
                        0.63,
                        -27.55,
                        0.07,
                        -38.01,
                        -0.01,
                        -0.77,
                        0.10,
                        0.64,
                        0.98,
                        0.98,
                        0.98,
                        1.09,
                        0.99,
                        -50.25,
                        -0.01,
                        -0.68,
                        -0.09,
                        0.72,
                        0.66,
                        0.66,
                        0.66,
                        -29.5,
                        0.23,
                        -40.8,
                        0.03,
                        -0.65,
                        -0.07,
                        0.76,
                        0.60,
                        0.60,
                        0.60,
                        -22.38,
                        0.43,
                        -27.59,
                        -0.04,
                        -0.7,
                        -0.08,
                        0.71,
                        0.95,
                        0.95,
                        0.95,
                        -15.24,
                        0.71,
                        -44.15,
                        0.08,
                        -0.72,
                        -0.09,
                        0.68,
                        0.63,
                        0.63,
                        0.63,
                        -18.72,
                        1.43,
                        -19.58,
                        0.01,
                        -0.75,
                        0.01,
                        0.66,
                        0.47,
                        0.47,
                        0.47,
                        6.25,
                        -0.09,
                        -27.12,
                        0.07,
                        -0.66,
                        0.12,
                        0.74,
                        0.81,
                        0.81,
                        0.81,
                        8.34,
                        -0.16,
                        -27.22,
                        0.08,
                        -0.78,
                        -0.03,
                        0.62,
                        0.55,
                        0.55,
                        0.55,
                        19.66,
                        -0.53,
                        -19.46,
                        0.04,
                        -0.75,
                        0.08,
                        0.66,
                        0.43,
                        0.43,
                        0.43,
                        -7.92,
                        0.73,
                        -32.81,
                        0.01,
                        -0.69,
                        -0.13,
                        0.71,
                        0.88,
                        0.88,
                        0.88,
                        -7.7,
                        0.67,
                        -32.44,
                        0.04,
                        -0.69,
                        -0.06,
                        0.72,
                        0.98,
                        0.98,
                        0.98,
                        -25.89,
                        0.38,
                        -20.1,
                        -0.01,
                        -0.66,
                        -0.03,
                        0.75,
                        0.87,
                        0.87,
                        0.87,
                        3.77,
                        0.56,
                        -31.08,
                        -0.05,
                        -0.67,
                        -0.12,
                        0.73,
                        0.78,
                        0.78,
                        0.78,
                        13.89,
                        -0.6,
                        -12.63,
                        0.04,
                        -0.65,
                        -0.09,
                        0.76,
                        0.93,
                        0.93,
                        0.93,
                        -25.4,
                        0.49,
                        -20.69,
                        -0.02,
                        -0.65,
                        -0.06,
                        0.75,
                        0.47,
                        0.47,
                        0.47,
                        2.42,
                        0.35,
                        -27.85,
                        -0.01,
                        -0.74,
                        -0.12,
                        0.66,
                        0.64,
                        0.64,
                        0.64,
                        -18.78,
                        1.22,
                        -39.34,
                        0.09,
                        -0.68,
                        -0.03,
                        0.73,
                        0.92,
                        0.92,
                        0.92,
                        -36.61,
                        -0.14,
                        -17.93,
                        -0.06,
                        -0.73,
                        0.01,
                        0.68,
                        0.89,
                        0.89,
                        0.89,
                        -22.15,
                        0.26,
                        -28.82,
                        -0.08,
                        -0.69,
                        0.00,
                        0.72,
                        0.95,
                        0.95,
                        0.95,
                        1.47,
                        0.36,
                        -29.06,
                        -0.04,
                        -0.72,
                        0.08,
                        0.69,
                        0.80,
                        0.80,
                        0.80,
                        4.72,
                        -0.21,
                        -23.83,
                        0.00,
                        -0.62,
                        -0.02,
                        0.78,
                        0.97,
                        0.97,
                        0.97,
                        7.81,
                        -0.37,
                        -25.49,
                        -0.07,
                        -0.63,
                        -0.08,
                        0.77,
                        0.71,
                        0.71,
                        0.71,
                        19.35,
                        -0.74,
                        -11.05,
                        0.01,
                        -0.63,
                        -0.11,
                        0.77,
                        0.65,
                        0.65,
                        0.65,
                        3.54,
                        0.69,
                        -31.69,
                        -0.02,
                        -0.68,
                        -0.09,
                        0.73,
                        0.50,
                        0.50,
                        0.50,
                        5.25,
                        -0.3,
                        -19.65,
                        0.03,
                        -0.72,
                        -0.09,
                        0.68,
                        0.80,
                        0.80,
                        0.80,
                        8.59,
                        -0.37,
                        -25.07,
                        0.04,
                        -0.75,
                        -0.01,
                        0.66,
                        0.99,
                        0.99,
                        0.99,
                        16.40,
                        0.81,
                        -35.72,
                        0.04,
                        -0.67,
                        0.09,
                        0.73,
                        0.93,
                        0.93,
                        0.93,
                        -19.67,
                        0.73,
                        -34.95,
                        0.09,
                        -0.76,
                        -0.03,
                        0.64,
                        0.75,
                        0.75,
                        0.75,
                        -6.8,
                        0.11,
                        -30.33,
                        0.02,
                        -0.67,
                        0.07,
                        0.74,
                        0.78,
                        0.78,
                        0.78,
                        20.96,
                        -0.08,
                        -30.63,
                        0.10,
                        -0.76,
                        -0.01,
                        0.65,
                        0.90,
                        0.90,
                        0.90,
                        -14.63,
                        0.50,
                        -45.9,
                        0.01,
                        -0.75,
                        0.07,
                        0.65,
                        0.77,
                        0.77,
                        0.77,
                        1.94,
                        -0.48,
                        -19.88,
                        -0.01,
                        -0.67,
                        -0.1,
                        0.73,
                        0.87,
                        0.87,
                        0.87,
                        5.03,
                        0.06,
                        -28.33,
                        0.03,
                        -0.7,
                        -0.09,
                        0.71,
                        0.92,
                        0.92,
                        0.92,
                        -40.37,
                        0.31,
                        -18.37,
                        0.03,
                        -0.71,
                        -0.04,
                        0.70,
                        0.59,
                        0.59,
                        0.59,
                        -12.2,
                        0.46,
                        -48.61,
                        0.01,
                        -0.64,
                        0.00,
                        0.77,
                        0.79,
                        0.79,
                        0.79,
                        -11.33,
                        0.71,
                        -31.6,
                        -0.08,
                        -0.62,
                        -0.07,
                        0.77,
                        0.61,
                        0.61,
                        0.61,
                        -19.16,
                        0.85,
                        -35.31,
                        0.00,
                        -0.63,
                        0.11,
                        0.77,
                        0.67,
                        0.67,
                        0.67,
                        4.26,
                        0.41,
                        -30.42,
                        0.09,
                        -0.75,
                        0.01,
                        0.66,
                        0.68,
                        0.68,
                        0.68,
                        15.84,
                        -0.15,
                        -10.12,
                        0.00,
                        -0.72,
                        0.10,
                        0.69,
                        0.48,
                        0.48,
                        0.48,
                        -27.92,
                        0.07,
                        -38.31,
                        0.03,
                        -0.75,
                        -0.06,
                        0.66,
                        0.51,
                        0.51,
                        0.51,
                        -22.9,
                        0.17,
                        -52.96,
                        0.07,
                        -0.74,
                        0.03,
                        0.67,
                        0.43,
                        0.43,
                        0.43,
                        23.70,
                        0.14,
                        -38.37,
                        -0.02,
                        -0.65,
                        0.11,
                        0.75,
                        0.56,
                        0.56,
                        0.56,
                        -44.05,
                        0.80,
                        -21.87,
                        0.08,
                        -0.73,
                        0.00,
                        0.68,
                        0.79,
                        0.79,
                        0.79,
                        -17.45,
                        0.97,
                        -20.09,
                        -0.01,
                        -0.76,
                        0.07,
                        0.65,
                        0.95,
                        0.95,
                        0.95,
                        3.10,
                        0.59,
                        -49.94,
                        -0.02,
                        -0.65,
                        -0.08,
                        0.76,
                        0.59,
                        0.59,
                        0.59,
                        -24.92,
                        -0.01,
                        -66.97,
                        0.00,
                        -0.75,
                        -0.1,
                        0.65,
                        0.47,
                        0.47,
                        0.47,
                        18.55,
                        0.64,
                        -34.66,
                        0.09,
                        -0.73,
                        0.00,
                        0.68,
                        0.88,
                        0.88,
                        0.88,
                        18.69,
                        0.72,
                        -36.55,
                        -0.02,
                        -0.69,
                        0.08,
                        0.72,
                        0.94,
                        0.94,
                        0.94,
                        -8.64,
                        0.20,
                        -30.82,
                        0.05,
                        -0.74,
                        -0.02,
                        0.68,
                        0.97,
                        0.97,
                        0.97,
                        -16.29,
                        0.64,
                        -45.65,
                        0.02,
                        -0.64,
                        0.06,
                        0.77,
                        0.85,
                        0.85,
                        0.85,
                        -30.7,
                        0.35,
                        -41.57,
                        0.13,
                        -0.72,
                        0.03,
                        0.68,
                        0.72,
                        0.72,
                        0.72,
                        8.49,
                        -0.2,
                        -26.52,
                        -0.05,
                        -0.75,
                        0.08,
                        0.65,
                        0.69,
                        0.69,
                        0.69,
                        -19.88,
                        0.27,
                        -50.53,
                        -0.03,
                        -0.66,
                        -0.05,
                        0.75,
                        0.91,
                        0.91,
                        0.91,
                        18.66,
                        -0.61,
                        -23.43,
                        -0.01,
                        -0.68,
                        -0.13,
                        0.72,
                        0.91,
                        0.91,
                        0.91,
                        -11.25,
                        1.02,
                        -34.68,
                        0.04,
                        -0.65,
                        -0.06,
                        0.76,
                        0.46,
                        0.46,
                        0.46,
                        -6.9,
                        0.86,
                        -9.96,
                        -0.04,
                        -0.68,
                        -0.07,
                        0.73,
                        0.46,
                        0.46,
                        0.46,
                        18.09,
                        -0.52,
                        -18.92,
                        0.04,
                        -0.75,
                        -0.11,
                        0.65,
                        0.62,
                        0.62,
                        0.62,
                        -2.89,
                        -0.1,
                        -27.36,
                        0.05,
                        -0.75,
                        0.01,
                        0.65,
                        0.96,
                        0.96,
                        0.96,
                        30.62,
                        -0.53,
                        -11,
                        0.02,
                        -0.66,
                        0.10,
                        0.75,
                        0.90,
                        0.90,
                        0.90,
                        -0.92,
                        0.46,
                        -32.63,
                        0.09,
                        -0.76,
                        -0.02,
                        0.65,
                        0.52,
                        0.52,
                        0.52,
                        -26.81,
                        0.07,
                        -37.47,
                        0.02,
                        -0.72,
                        0.08,
                        0.68,
                        0.58,
                        0.58,
                        0.58,
                        -17.51,
                        1.10,
                        -39.55,
                        0.04,
                        -0.73,
                        -0.09,
                        0.68,
                        0.46,
                        0.46,
                        0.46,
                        -18.18,
                        1.34,
                        -40.12,
                        0.04,
                        -0.64,
                        0.00,
                        0.77,
                        0.45,
                        0.45,
                        0.45,
                        5.26,
                        -0.18,
                        -24.47,
                        -0.11,
                        -0.72,
                        -0.06,
                        0.68,
                        0.96,
                        0.96,
                        0.96,
                        5.10,
                        -0.32,
                        -21.81,
                        -0.1,
                        -0.74,
                        0.07,
                        0.67,
                        0.84,
                        0.84,
                        0.84,
                        -10.36,
                        1.13,
                        -35.62,
                        -0.04,
                        -0.71,
                        -0.02,
                        0.70,
                        0.65,
                        0.65,
                        0.65,
                        -19.18,
                        1.16,
                        -39.14,
                        -0.05,
                        -0.79,
                        0.03,
                        0.61,
                        0.58,
                        0.58,
                        0.58,
                        3.90,
                        0.63,
                        -47.92,
                        -0.09,
                        -0.71,
                        -0.07,
                        0.70,
                        0.92,
                        0.92,
                        0.92,
                        -17.95,
                        1.55,
                        -41.98,
                        -0.11,
                        -0.69,
                        0.10,
                        0.71,
                        0.76,
                        0.76,
                        0.76,
                        -37.2,
                        0.36,
                        -16.98,
                        0.00,
                        -0.67,
                        0.01,
                        0.75,
                        0.88,
                        0.88,
                        0.88,
                        6.64,
                        -0.14,
                        -26.72,
                        0.08,
                        -0.62,
                        0.06,
                        0.78,
                        0.89,
                        0.89,
                        0.89,
                        -5.9,
                        0.26,
                        -40.07,
                        -0.11,
                        -0.63,
                        -0.01,
                        0.77,
                        0.75,
                        0.75,
                        0.75,
                        -5.87,
                        -0.32,
                        -25.39,
                        0.00,
                        -0.75,
                        0.09,
                        0.65,
                        0.92,
                        0.92,
                        0.92,
                        8.09,
                        -0.32,
                        -25.32,
                        0.00,
                        -0.68,
                        -0.1,
                        0.72,
                        0.80,
                        0.80,
                        0.80,
                        6.36,
                        -0.35,
                        -23.08,
                        0.03,
                        -0.73,
                        -0.08,
                        0.68,
                        0.58,
                        0.58,
                        0.58,
                        34.60,
                        0.29,
                        -34.44,
                        0.05,
                        -0.69,
                        0.00,
                        0.72,
                        0.50,
                        0.50,
                        0.50,
                        -0.38,
                        1.21,
                        -51.7,
                        -0.06,
                        -0.63,
                        0.01,
                        0.78,
                        0.85,
                        0.85,
                        0.85,
                        -11.2,
                        0.43,
                        -16.27,
                        0.05,
                        -0.72,
                        0.10,
                        0.68,
                        0.92,
                        0.92,
                        0.92,
                        6.81,
                        0.66,
                        -43.85,
                        0.06,
                        -0.75,
                        -0.1,
                        0.66,
                        0.79,
                        0.79,
                        0.79,
                        -12.9,
                        0.13,
                        -50.71,
                        0.04,
                        -0.75,
                        0.02,
                        0.66,
                        0.63,
                        0.63,
                        0.63,
                        1.18,
                        0.46,
                        -35.06,
                        0.02,
                        -0.64,
                        0.11,
                        0.76,
                        0.98,
                        0.98,
                        0.98,
                        32.85,
                        0.50,
                        -37.28,
                        0.10,
                        -0.67,
                        -0.01,
                        0.74,
                        0.65,
                        0.65,
                        0.65,
                        -29.53,
                        0.19,
                        -39.99,
                        -0.07,
                        -0.75,
                        0.01,
                        0.66,
                        0.82,
                        0.82,
                        0.82,
                        -11.09,
                        0.68,
                        -30.93,
                        -0.08,
                        -0.65,
                        -0.02,
                        0.75,
                        0.67,
                        0.67,
                        0.67,
                        -7.05,
                        0.53,
                        -32.6,
                        0.00,
                        -0.66,
                        0.10,
                        0.75,
                        0.99,
                        0.99,
                        0.99,
                        6.27,
                        0.03,
                        -10.69,
                        0.09,
                        -0.69,
                        -0.01,
                        0.72,
                        0.69,
                        0.69,
                        0.69,
                        -5.36,
                        0.20,
                        -40.43,
                        -0.06,
                        -0.7,
                        0.03,
                        0.71,
                        0.68,
                        0.68,
                        0.68,
                        3.42,
                        0.69,
                        -31.66,
                        -0.01,
                        -0.68,
                        0.03,
                        0.73,
                        0.89,
                        0.89,
                        0.89,
                        40.09,
                        0.23,
                        -28.09,
                        0.06,
                        -0.77,
                        0.03,
                        0.63,
                        0.50,
                        0.50,
                        0.50,
                        4.78,
                        -0.26,
                        -14.56,
                        0.03,
                        -0.68,
                        0.13,
                        0.72,
                        0.49,
                        0.49,
                        0.49,
                        -9.38,
                        0.09,
                        -30.05,
                        0.06,
                        -0.63,
                        -0.04,
                        0.77,
                        0.47,
                        0.47,
                        0.47,
                        1.96,
                        0.42,
                        -29.6,
                        -0.06,
                        -0.64,
                        -0.04,
                        0.77,
                        0.61,
                        0.61,
                        0.61,
                        -10.33,
                        0.07,
                        -29.44,
                        0.02,
                        -0.66,
                        0.13,
                        0.74,
                        0.80,
                        0.80,
                        0.80,
                        -8.84,
                        0.51,
                        -37.33,
                        0.08,
                        -0.76,
                        -0.02,
                        0.65,
                        0.64,
                        0.64,
                        0.64,
                        4.31,
                        -0.16,
                        -24.53,
                        0.02,
                        -0.68,
                        0.08,
                        0.73,
                        0.48,
                        0.48,
                        0.48,
                        -1.2,
                        1.05,
                        -53.45,
                        0.09,
                        -0.74,
                        -0.04,
                        0.66,
                        0.65,
                        0.65,
                        0.65,
                        -19.27,
                        1.25,
                        -20.82,
                        0.01,
                        -0.75,
                        0.06,
                        0.66,
                        0.84,
                        0.84,
                        0.84,
                        8.99,
                        0.37,
                        -39.92,
                        -0.01,
                        -0.72,
                        -0.11,
                        0.69,
                        0.91,
                        0.91,
                        0.91,
                        7.04,
                        -0.36,
                        -21.58,
                        0.06,
                        -0.65,
                        -0.04,
                        0.75,
                        0.53,
                        0.53,
                        0.53,
                        -3.34,
                        0.20,
                        -38.95,
                        -0.06,
                        -0.65,
                        -0.03,
                        0.76,
                        0.84,
                        0.84,
                        0.84,
                        -22.13,
                        0.40,
                        -27.18,
                        0.01,
                        -0.68,
                        0.14,
                        0.72,
                        0.49,
                        0.49,
                        0.49,
                        3.84,
                        0.63,
                        -31.54,
                        0.08,
                        -0.69,
                        -0.04,
                        0.72,
                        0.48,
                        0.48,
                        0.48,
                        -9.31,
                        0.28,
                        -30.74,
                        -0.03,
                        -0.66,
                        0.00,
                        0.75,
                        0.90,
                        0.90,
                        0.90,
                        8.25,
                        0.68,
                        -42.62,
                        0.04,
                        -0.63,
                        0.08,
                        0.77,
                        0.64,
                        0.64,
                        0.64,
                        -7.12,
                        0.25,
                        -38.79,
                        0.14,
                        -0.71,
                        0.01,
                        0.69,
                        0.68,
                        0.68,
                        0.68,
                        -14.98,
                        0.17,
                        -49.19,
                        -0.05,
                        -0.71,
                        0.07,
                        0.70,
                        0.79,
                        0.79,
                        0.79,
                        19.08,
                        -0.63,
                        -24.02,
                        0.01,
                        -0.68,
                        -0.01,
                        0.73,
                        0.83,
                        0.83,
                        0.83,
                        -17.56,
                        1.58,
                        -42.08,
                        -0.07,
                        -0.75,
                        -0.09,
                        0.65,
                        0.68,
                        0.68,
                        0.68,
                        -10.23,
                        0.01,
                        -28.85,
                        0.08,
                        -0.61,
                        -0.02,
                        0.79,
                        0.90,
                        0.90,
                        0.90,
                        -12.71,
                        0.34,
                        -17.69,
                        -0.07,
                        -0.77,
                        -0.03,
                        0.63,
                        0.95,
                        0.95,
                        0.95,
                        4.28,
                        -0.18,
                        -24.42,
                        -0.11,
                        -0.64,
                        -0.02,
                        0.76,
                        0.57,
                        0.57,
                        0.57,
                        -6.11,
                        0.41,
                        -34.45,
                        0.00,
                        -0.75,
                        0.09,
                        0.66,
                        0.45,
                        0.45,
                        0.45,
                        -5.13,
                        0.36,
                        -35.72,
                        0.00,
                        -0.67,
                        -0.08,
                        0.73,
                        0.82,
                        0.82,
                        0.82,
                        -10.06,
                        1.05,
                        -36.17,
                        0.01,
                        -0.66,
                        -0.08,
                        0.75,
                        0.87,
                        0.87,
                        0.87,
                        30.33,
                        0.15,
                        -36.77,
                        -0.01,
                        -0.7,
                        -0.09,
                        0.71,
                        0.91,
                        0.91,
                        0.91,
                        8.96,
                        -0.27,
                        -25.47,
                        0.05,
                        -0.75,
                        -0.06,
                        0.65,
                        0.66,
                        0.66,
                        0.66,
                        -28.75,
                        0.08,
                        -38.67,
                        0.05,
                        -0.7,
                        0.05,
                        0.71,
                        0.90,
                        0.90,
                        0.90,
                        7.98,
                        -0.4,
                        -21.73,
                        -0.06,
                        -0.61,
                        0.05,
                        0.79,
                        0.94,
                        0.94,
                        0.94,
                        19.64,
                        0.43,
                        -31.23,
                        0.07,
                        -0.69,
                        0.07,
                        0.71,
                        0.64,
                        0.64,
                        0.64,
                        24.67,
                        0.05,
                        -38.08,
                        0.10,
                        -0.76,
                        -0.08,
                        0.64,
                        0.76,
                        0.76,
                        0.76,
                        -9.71,
                        -0.02,
                        -28.37,
                        0.03,
                        -0.66,
                        0.04,
                        0.75,
                        0.90,
                        0.90,
                        0.90,
                        2.20,
                        0.55,
                        -33.79,
                        0.12,
                        -0.64,
                        0.02,
                        0.76,
                        0.47,
                        0.47,
                        0.47,
                        -24.1,
                        0.15,
                        -54.97,
                        -0.1,
                        -0.68,
                        0.01,
                        0.73,
                        0.68,
                        0.68,
                        0.68,
                        -20.56,
                        1.04,
                        -21.61,
                        -0.02,
                        -0.72,
                        0.07,
                        0.69,
                        0.69,
                        0.69,
                        0.69,
                        7.27,
                        -0.38,
                        -22.37,
                        0.01,
                        -0.77,
                        -0.04,
                        0.64,
                        0.61,
                        0.61,
                        0.61,
                        0.07,
                        0.41,
                        -35.95,
                        0.08,
                        -0.65,
                        0.06,
                        0.75,
                        0.76,
                        0.76,
                        0.76,
                        -19.07,
                        0.87,
                        -35.91,
                        -0.12,
                        -0.75,
                        0.02,
                        0.65,
                        0.54,
                        0.54,
                        0.54,
                        -5.96,
                        0.28,
                        -39.47,
                        -0.08,
                        -0.72,
                        0.00,
                        0.69,
                        0.93,
                        0.93,
                        0.93,
                        -21.15,
                        0.30,
                        -31.56,
                        -0.06,
                        -0.76,
                        0.02,
                        0.65,
                        0.91,
                        0.91,
                        0.91,
                        -11.52,
                        0.85,
                        -32.82,
                        -0.08,
                        -0.66,
                        -0.04,
                        0.74,
                        0.91,
                        0.91,
                        0.91,
                        6.72,
                        -0.2,
                        -25.65,
                        -0.02,
                        -0.76,
                        0.10,
                        0.64,
                        0.86,
                        0.86,
                        0.86,
                        23.72,
                        0.20,
                        -39.01,
                        -0.02,
                        -0.66,
                        -0.08,
                        0.75,
                        0.91,
                        0.91,
                        0.91,
                        8.93,
                        -0.25,
                        -26.39,
                        0.00,
                        -0.7,
                        -0.11,
                        0.70,
                        0.72,
                        0.72,
                        0.72,
                        2.47,
                        0.51,
                        -34.38,
                        0.05,
                        -0.7,
                        -0.06,
                        0.71,
                        0.53,
                        0.53,
                        0.53,
                        1.42,
                        0.30,
                        -58.14,
                        -0.01,
                        -0.74,
                        -0.01,
                        0.68,
                        0.72,
                        0.72,
                        0.72,
                        -19.64,
                        0.79,
                        -35.6,
                        0.10,
                        -0.62,
                        0.05,
                        0.77,
                        0.99,
                        0.99,
                        0.99,
                        -3.95,
                        0.34,
                        -36.69,
                        -0.08,
                        -0.61,
                        0.00,
                        0.79,
                        0.66,
                        0.66,
                        0.66,
                        -29.9,
                        0.13,
                        -39.12,
                        0.04,
                        -0.65,
                        0.10,
                        0.75,
                        0.53,
                        0.53,
                        0.53,
                        -2.46,
                        0.10,
                        -69.68,
                        0.10,
                        -0.76,
                        -0.01,
                        0.65,
                        0.94,
                        0.94,
                        0.94,
                        2.87,
                        0.53,
                        -34.02,
                        0.01,
                        -0.75,
                        0.08,
                        0.66,
                        0.51,
                        0.51,
                        0.51,
                        3.73,
                        0.63,
                        -57.87,
                        0.00,
                        -0.73,
                        -0.1,
                        0.67,
                        0.60,
                        0.60,
                        0.60,
                        7.70,
                        0.68,
                        -45.03,
                        0.08,
                        -0.69,
                        -0.02,
                        0.72,
                        0.66,
                        0.66,
                        0.66,
                        -12.9,
                        0.13,
                        -50.71,
                        -0.06,
                        -0.72,
                        0.02,
                        0.69,
                        0.99,
                        0.99,
                        0.99,
                        -12.02,
                        0.41,
                        -50.99,
                        -0.04,
                        -0.77,
                        0.01,
                        0.64,
                        0.50,
                        0.50,
                        0.50,
                        20.83,
                        0.30,
                        -35.22,
                        -0.08,
                        -0.63,
                        -0.04,
                        0.77,
                        0.90,
                        0.90,
                        0.90,
                        -0.8,
                        0.99,
                        -49.37,
                        0.01,
                        -0.76,
                        0.11,
                        0.64,
                        0.62,
                        0.62,
                        0.62,
                        -0.36,
                        0.39,
                        -56.81,
                        0.00,
                        -0.68,
                        -0.1,
                        0.73,
                        0.96,
                        0.96,
                        0.96,
                        -5.89,
                        0.23,
                        -40.49,
                        0.02,
                        -0.68,
                        -0.08,
                        0.73,
                        0.89,
                        0.89,
                        0.89,
                        3.04,
                        0.65,
                        -32.26,
                        0.00,
                        -0.69,
                        -0.06,
                        0.72,
                        0.98,
                        0.98,
                        0.98,
                        -21.07,
                        0.30,
                        -31.57,
                        0.02,
                        -0.64,
                        -0.05,
                        0.77,
                        0.98,
                        0.98,
                        0.98,
                        13.32,
                        0.54,
                        -37.03,
                        -0.05,
                        -0.76,
                        -0.07,
                        0.64,
                        0.71,
                        0.71,
                        0.71,
                        1.03,
                        -0.29,
                        -23.99,
                        0.11,
                        -0.64,
                        0.00,
                        0.76,
                        0.74,
                        0.74,
                        0.74,
                        1.33,
                        0.48,
                        -34.66,
                        -0.09,
                        -0.67,
                        0.00,
                        0.74,
                        0.58,
                        0.58,
                        0.58,
                        -34.03,
                        0.58,
                        -16.14,
                        -0.01,
                        -0.7,
                        0.09,
                        0.71,
                        0.84,
                        0.84,
                        0.84,
                        -0.32,
                        -0.57,
                        -21.49,
                        0.05,
                        -0.68,
                        -0.04,
                        0.73,
                        1.00,
                        1.00,
                        1.00,
                        -17.71,
                        1.23,
                        -19.56,
                        -0.04,
                        -0.75,
                        -0.03,
                        0.66,
                        0.49,
                        0.49,
                        0.49,
                        18.09,
                        -0.1,
                        -30.22,
                        -0.12,
                        -0.76,
                        -0.03,
                        0.64,
                        0.42,
                        0.42,
                        0.42,
                        26.84,
                        0.12,
                        -38.77,
                        -0.11,
                        -0.69,
                        0.01,
                        0.72,
                        0.42,
                        0.42,
                        0.42,
                        -3.15,
                        0.14,
                        -71.03,
                        -0.02,
                        -0.77,
                        0.05,
                        0.64,
                        0.88,
                        0.88,
                        0.88,
                        20.82,
                        0.30,
                        -35.27,
                        -0.06,
                        -0.68,
                        -0.09,
                        0.72,
                        0.62,
                        0.62,
                        0.62,
                        -0.6,
                        0.04,
                        -60.84,
                        0.05,
                        -0.76,
                        -0.09,
                        0.64,
                        0.77,
                        0.77,
                        0.77,
                        7.59,
                        -0.12,
                        -27.53,
                        0.07,
                        -0.71,
                        0.03,
                        0.70,
                        0.48,
                        0.48,
                        0.48,
                        -11.14,
                        0.52,
                        -30.45,
                        -0.05,
                        -0.77,
                        0.07,
                        0.63,
                        0.43,
                        0.43,
                        0.43,
                        -6.65,
                        0.42,
                        -34.43,
                        -0.04,
                        -0.75,
                        -0.06,
                        0.66,
                        0.43,
                        0.43,
                        0.43,
                        7.30,
                        -0.05,
                        -28.35,
                        0.11,
                        -0.63,
                        -0.01,
                        0.77,
                        0.55,
                        0.55,
                        0.55,
                        11.81,
                        0.04,
                        -36.33,
                        -0.09,
                        -0.67,
                        -0.01,
                        0.73,
                        0.57,
                        0.57,
                        0.57,
                        5.33,
                        0.10,
                        -29.59,
                        -0.02,
                        -0.74,
                        0.09,
                        0.67,
                        0.65,
                        0.65,
                        0.65,
                        -37.98,
                        -0.04,
                        -18.11,
                        0.00,
                        -0.74,
                        -0.06,
                        0.67,
                        0.46,
                        0.46,
                        0.46,
                        -6.28,
                        0.41,
                        -34.14,
                        0.08,
                        -0.66,
                        0.00,
                        0.75,
                        0.94,
                        0.94,
                        0.94,
                        0.01,
                        1.27,
                        -51.25,
                        -0.09,
                        -0.66,
                        -0.01,
                        0.74,
                        0.45,
                        0.45,
                        0.45,
                        17.84,
                        -0.49,
                        -17.86,
                        -0.01,
                        -0.72,
                        0.10,
                        0.69,
                        0.50,
                        0.50,
                        0.50,
                        4.63,
                        0.61,
                        -47.22,
                        0.03,
                        -0.68,
                        -0.06,
                        0.73,
                        0.73,
                        0.73,
                        0.73,
                        -9.04,
                        -0.18,
                        -26.92,
                        -0.01,
                        -0.75,
                        -0.04,
                        0.66,
                        0.58,
                        0.58,
                        0.58,
                        0.79,
                        0.24,
                        -58.26,
                        0.08,
                        -0.62,
                        0.02,
                        0.78,
                        0.90,
                        0.90,
                        0.90,
                        -7.07,
                        0.23,
                        -39.52,
                        -0.1,
                        -0.76,
                        -0.02,
                        0.64,
                        0.56,
                        0.56,
                        0.56,
                        -42.43,
                        0.50,
                        -36.73,
                        -0.11,
                        -0.7,
                        0.00,
                        0.70,
                        0.65,
                        0.65,
                        0.65,
                        -25,
                        0.59,
                        -21.12,
                        -0.04,
                        -0.65,
                        0.05,
                        0.75,
                        0.44,
                        0.44,
                        0.44,
                        -5.71,
                        0.23,
                        -40.4,
                        0.05,
                        -0.65,
                        0.05,
                        0.75,
                        0.63,
                        0.63,
                        0.63,
                        6.50,
                        -0.04,
                        -28.71,
                        -0.13,
                        -0.64,
                        0.00,
                        0.75,
                        0.94,
                        0.94,
                        0.94,
                        -4.33,
                        0.35,
                        -36.25,
                        -0.01,
                        -0.75,
                        0.08,
                        0.66,
                        0.74,
                        0.74,
                        0.74,
                        3.46,
                        0.69,
                        -31.64,
                        -0.01,
                        -0.68,
                        -0.09,
                        0.73,
                        0.97,
                        0.97,
                        0.97,
                        8.09,
                        -0.14,
                        -27.19,
                        0.02,
                        -0.76,
                        -0.07,
                        0.65,
                        0.47,
                        0.47,
                        0.47,
                        15.30,
                        0.86,
                        -37.28,
                        0.07,
                        -0.66,
                        0.03,
                        0.75,
                        1.00,
                        1.00,
                        1.00,
                        18.57,
                        0.74,
                        -36.81,
                        -0.11,
                        -0.74,
                        0.00,
                        0.66,
                        0.88,
                        0.88,
                        0.88,
                        -8.25,
                        0.45,
                        -36.97,
                        -0.09,
                        -0.72,
                        0.01,
                        0.69,
                        0.88,
                        0.88,
                        0.88,
                        -9.1,
                        -0.13,
                        -27.87,
                        -0.06,
                        -0.71,
                        0.03,
                        0.70,
                        0.55,
                        0.55,
                        0.55,
                        -4.58,
                        0.35,
                        -36.29,
                        -0.02,
                        -0.73,
                        0.02,
                        0.68,
                        0.90,
                        0.90,
                        0.90,
                        7.12,
                        -0.27,
                        -26.41,
                        -0.05,
                        -0.76,
                        -0.05,
                        0.65,
                        0.87,
                        0.87,
                        0.87,
                        7.84,
                        -0.2,
                        -26.89,
                        -0.14,
                        -0.66,
                        0.00,
                        0.74,
                        0.75,
                        0.75,
                        0.75,
                        -5.38,
                        0.30,
                        -39.25,
                        -0.03,
                        -0.68,
                        0.08,
                        0.73,
                        0.78,
                        0.78,
                        0.78,
                        -40.24,
                        0.18,
                        -18.77,
                        0.06,
                        -0.7,
                        0.00,
                        0.71,
                        0.56,
                        0.56,
                        0.56,
                        -6.14,
                        0.27,
                        -39.44,
                        -0.04,
                        -0.77,
                        0.03,
                        0.64,
                        0.94,
                        0.94,
                        0.94,
                        -26.37,
                        0.35,
                        -56.44,
                        -0.06,
                        -0.63,
                        -0.05,
                        0.77,
                        0.48,
                        0.48,
                        0.48,
                        8.52,
                        -0.19,
                        -27.04,
                        0.02,
                        -0.76,
                        0.13,
                        0.64,
                        0.70,
                        0.70,
                        0.70,
                        -6.29,
                        0.01,
                        -72.28,
                        0.01,
                        -0.69,
                        -0.1,
                        0.72,
                        0.96,
                        0.96,
                        0.96,
                        3.20,
                        -0.35,
                        -16.84,
                        0.03,
                        -0.71,
                        -0.06,
                        0.70,
                        0.46,
                        0.46,
                        0.46,
                        -25.04,
                        0.63,
                        -20.66,
                        0.03,
                        -0.77,
                        -0.01,
                        0.64,
                        0.50,
                        0.50,
                        0.50,
                        -17.83,
                        1.09,
                        -38.88,
                        0.06,
                        -0.77,
                        0.08,
                        0.63,
                        0.46,
                        0.46,
                        0.46,
                        2.44,
                        0.51,
                        -34.39,
                        0.00,
                        -0.78,
                        -0.09,
                        0.62,
                        0.57,
                        0.57,
                        0.57,
                        -12.15,
                        0.73,
                        -32.45,
                        0.09,
                        -0.76,
                        0.02,
                        0.65,
                        0.99,
                        0.99,
                        0.99,
                        1.93,
                        0.42,
                        -29.64,
                        0.00,
                        -0.77,
                        0.09,
                        0.63,
                        0.44,
                        0.44,
                        0.44,
                        0.78,
                        0.24,
                        -59.14,
                        -0.02,
                        -0.66,
                        -0.09,
                        0.74,
                        0.92,
                        0.92,
                        0.92,
                        -7.12,
                        0.50,
                        -33.98,
                        0.02,
                        -0.74,
                        -0.1,
                        0.67,
                        0.64,
                        0.64,
                        0.64,
                        -6.58,
                        0.37,
                        -36.16,
                        0.07,
                        -0.7,
                        -0.01,
                        0.71,
                        0.71,
                        0.71,
                        0.71,
                        17.79,
                        0.38,
                        -5.19,
                        -0.04,
                        -0.76,
                        0.04,
                        0.65,
                        0.61,
                        0.61,
                        0.61,
                        17.76,
                        0.78,
                        -36.35,
                        -0.07,
                        -0.68,
                        -0.06,
                        0.73,
                        0.80,
                        0.80,
                        0.80,
                        -9.84,
                        -0.01,
                        -28.64,
                        -0.05,
                        -0.64,
                        0.12,
                        0.76,
                        0.75,
                        0.75,
                        0.75,
                        35.03,
                        0.65,
                        -36.05,
                        0.06,
                        -0.67,
                        0.02,
                        0.74,
                        0.66,
                        0.66,
                        0.66,
                        -9.01,
                        0.12,
                        -30.34,
                        -0.1,
                        -0.74,
                        0.01,
                        0.66,
                        0.71,
                        0.71,
                        0.71,
                        19.44,
                        0.49,
                        -32.01,
                        -0.07,
                        -0.75,
                        0.01,
                        0.66,
                        0.62,
                        0.62,
                        0.62,
                        16.32,
                        0.32,
                        -7.87,
                        -0.07,
                        -0.64,
                        -0.01,
                        0.76,
                        0.60,
                        0.60,
                        0.60,
                        16.91,
                        0.42,
                        -7.37,
                        0.02,
                        -0.69,
                        0.11,
                        0.72,
                        0.62,
                        0.62,
                        0.62,
                        -38.94,
                        0.20,
                        -17.98,
                        0.06,
                        -0.77,
                        -0.04,
                        0.64,
                        0.67,
                        0.67,
                        0.67,
                        19.37,
                        -0.7,
                        -23.37,
                        0.05,
                        -0.7,
                        0.07,
                        0.71,
                        0.72,
                        0.72,
                        0.72,
                        -7.25,
                        -0.28,
                        -24.59,
                        0.09,
                        -0.75,
                        -0.08,
                        0.65,
                        0.82,
                        0.82,
                        0.82,
                        3.94,
                        0.65,
                        -32.05,
                        0.03,
                        -0.7,
                        0.04,
                        0.72,
                        0.82,
                        0.82,
                        0.82,
                        1.58,
                        -0.51,
                        -20.47,
                        0.08,
                        -0.62,
                        -0.04,
                        0.78,
                        0.51,
                        0.51,
                        0.51,
                        -31.5,
                        0.62,
                        -15.71,
                        -0.07,
                        -0.65,
                        -0.04,
                        0.75,
                        0.52,
                        0.52,
                        0.52,
                        10.49,
                        0.03,
                        -37.57,
                        0.00,
                        -0.7,
                        0.14,
                        0.70,
                        0.41,
                        0.41,
                        0.41,
                        -14.82,
                        0.29,
                        -47.48,
                        0.05,
                        -0.69,
                        -0.05,
                        0.72,
                        0.51,
                        0.51,
                        0.51,
                        -19.87,
                        0.52,
                        -33.12,
                        -0.01,
                        -0.75,
                        -0.02,
                        0.66,
                        0.87,
                        0.87,
                        0.87,
                        -34.96,
                        0.49,
                        -16.49,
                        0.12,
                        -0.75,
                        0.07,
                        0.65,
                        0.69,
                        0.69,
                        0.69,
                        4.80,
                        -0.19,
                        -24.1,
                        -0.03,
                        -0.64,
                        0.10,
                        0.76,
                        0.94,
                        0.94,
                        0.94,
                        -40.99,
                        -0.17,
                        -20.18,
                        0.06,
                        -0.75,
                        0.02,
                        0.66,
                        0.80,
                        0.80,
                        0.80,
                        0.24,
                        0.40,
                        -30.77,
                        0.01,
                        -0.75,
                        0.10,
                        0.65,
                        0.55,
                        0.55,
                        0.55,
                        8.21,
                        -0.41,
                        -24.65,
                        0.00,
                        -0.65,
                        -0.09,
                        0.75,
                        0.84,
                        0.84,
                        0.84,
                        -11.58,
                        0.57,
                        -4.24,
                        -0.01,
                        -0.68,
                        -0.09,
                        0.73,
                        0.59,
                        0.59,
                        0.59,
                        22.09,
                        -0.54,
                        -8.44,
                        0.02,
                        -0.65,
                        -0.07,
                        0.75,
                        0.86,
                        0.86,
                        0.86,
                        -11.54,
                        0.87,
                        -32.94,
                        -0.02,
                        -0.76,
                        -0.07,
                        0.65,
                        0.92,
                        0.92,
                        0.92,
                        -14.88,
                        0.94,
                        -17.69,
                        0.12,
                        -0.71,
                        0.01,
                        0.69,
                        0.66,
                        0.66,
                        0.66,
                        3.65,
                        0.42,
                        -29.58,
                        -0.05,
                        -0.68,
                        0.07,
                        0.73,
                        0.43,
                        0.43,
                        0.43,
                        -20.82,
                        1.07,
                        -21.59,
                        0.04,
                        -0.69,
                        0.02,
                        0.72,
                        0.73,
                        0.73,
                        0.73,
                        -9.31,
                        -0.11,
                        -27.61,
                        -0.07,
                        -0.61,
                        0.02,
                        0.79,
                        0.87,
                        0.87,
                        0.87,
                        7.74,
                        -0.28,
                        -26.42,
                        0.04,
                        -0.76,
                        0.08,
                        0.64,
                        0.66,
                        0.66,
                        0.66,
                        -6.25,
                        0.26,
                        -39.29,
                        0.00,
                        -0.76,
                        -0.11,
                        0.64,
                        0.93,
                        0.93,
                        0.93,
                        -27.5,
                        0.18,
                        -39.43,
                        0.10,
                        -0.71,
                        0.01,
                        0.69,
                        0.92,
                        0.92,
                        0.92,
                        -18.32,
                        1.11,
                        -38,
                        -0.05,
                        -0.68,
                        0.07,
                        0.73,
                        0.72,
                        0.72,
                        0.72,
                        -6.78,
                        0.94,
                        -8.8,
                        0.04,
                        -0.71,
                        0.01,
                        0.70,
                        0.76,
                        0.76,
                        0.76,
                        -8.54,
                        0.40,
                        -37.86,
                        -0.03,
                        -0.62,
                        0.05,
                        0.78,
                        0.52,
                        0.52,
                        0.52,
                        6.41,
                        -0.31,
                        -20.36,
                        0.06,
                        -0.77,
                        0.05,
                        0.63,
                        0.61,
                        0.61,
                        0.61,
                        5.91,
                        -0.19,
                        -3.93,
                        0.01,
                        -0.76,
                        0.12,
                        0.64,
                        0.86,
                        0.86,
                        0.86,
                        -17.56,
                        1.61,
                        -42.7,
                        0.00,
                        -0.66,
                        -0.09,
                        0.75,
                        0.89,
                        0.89,
                        0.89,
                        -10.98,
                        0.01,
                        -27.74,
                        0.00,
                        -0.66,
                        -0.08,
                        0.75,
                        0.89,
                        0.89,
                        0.89,
                        -6.72,
                        -0.29,
                        -24.69,
                        -0.01,
                        -0.73,
                        -0.09,
                        0.68,
                        0.91,
                        0.91,
                        0.91,
                        9.63,
                        0.02,
                        -37.37,
                        0.08,
                        -0.74,
                        -0.03,
                        0.67,
                        0.81,
                        0.81,
                        0.81,
                        39.34,
                        0.40,
                        -29.34,
                        0.01,
                        -0.72,
                        0.06,
                        0.69,
                        0.92,
                        0.92,
                        0.92,
                        -19.28,
                        1.43,
                        -20.34,
                        0.04,
                        -0.73,
                        -0.09,
                        0.68,
                        0.46,
                        0.46,
                        0.46,
                        -26.81,
                        0.22,
                        -18.83,
                        0.03,
                        -0.64,
                        0.00,
                        0.77,
                        0.66,
                        0.66,
                        0.66,
                        -43.71,
                        0.73,
                        -21.84,
                        -0.08,
                        -0.77,
                        -0.05,
                        0.63,
                        0.83,
                        0.83,
                        0.83,
                        -40.21,
                        0.37,
                        -17.95,
                        -0.13,
                        -0.66,
                        -0.01,
                        0.74,
                        0.64,
                        0.64,
                        0.64,
                        -8.03,
                        -0.28,
                        -27.06,
                        -0.02,
                        -0.69,
                        0.09,
                        0.72,
                        0.46,
                        0.46,
                        0.46,
                        -26.51,
                        0.35,
                        -18.31,
                        0.06,
                        -0.71,
                        -0.02,
                        0.70,
                        0.45,
                        0.45,
                        0.45,
                        -10.87,
                        1.14,
                        -36.33,
                        -0.02,
                        -0.69,
                        0.04,
                        0.72,
                        0.99,
                        0.99,
                        0.99,
                        -25.11,
                        0.52,
                        -21.27,
                        0.06,
                        -0.73,
                        0.01,
                        0.68,
                        0.76,
                        0.76,
                        0.76,
                        -11.35,
                        1.04,
                        -35.62,
                        -0.01,
                        -0.64,
                        0.09,
                        0.76,
                        0.60,
                        0.60,
                        0.60,
                        -13.7,
                        0.37,
                        -48.7,
                        0.05,
                        -0.78,
                        0.01,
                        0.62,
                        0.68,
                        0.68,
                        0.68,
                        -20.35,
                        0.46,
                        -33,
                        0.04,
                        -0.63,
                        0.09,
                        0.77,
                        0.91,
                        0.91,
                        0.91,
                        -6.62,
                        0.24,
                        -39.52,
                        0.13,
                        -0.69,
                        0.00,
                        0.71,
                        0.96,
                        0.96,
                        0.96,
                        17.92,
                        0.67,
                        -33.88,
                        -0.06,
                        -0.75,
                        0.04,
                        0.66,
                        0.95,
                        0.95,
                        0.95,
                        -4.35,
                        0.15,
                        -40.2,
                        -0.05,
                        -0.77,
                        -0.03,
                        0.64,
                        0.95,
                        0.95,
                        0.95,
                        6.98,
                        -0.04,
                        -8.39,
                        -0.13,
                        -0.66,
                        -0.03,
                        0.74,
                        1.00,
                        1.00,
                        1.00,
                        -26.5,
                        0.18,
                        -59.51,
                        -0.03,
                        -0.66,
                        0.09,
                        0.74,
                        0.58,
                        0.58,
                        0.58,
                        2.74,
                        0.53,
                        -34.1,
                        0.07,
                        -0.7,
                        0.01,
                        0.71,
                        0.53,
                        0.53,
                        0.53,
                        3.59,
                        -0.26,
                        -23.56,
                        -0.06,
                        -0.77,
                        0.04,
                        0.64,
                        0.64,
                        0.64,
                        0.64,
                        -27.86,
                        0.28,
                        -40.92,
                        -0.06,
                        -0.64,
                        -0.04,
                        0.76,
                        0.77,
                        0.77,
                        0.77,
                        5.51,
                        -0.33,
                        -22.58,
                        0.01,
                        -0.64,
                        0.12,
                        0.76,
                        0.46,
                        0.46,
                        0.46,
                        12.34,
                        0.40,
                        -37.88,
                        0.09,
                        -0.68,
                        -0.01,
                        0.73,
                        0.99,
                        0.99,
                        0.99,
                        -22.81,
                        1.17,
                        -21.17,
                        -0.07,
                        -0.73,
                        0.02,
                        0.68,
                        0.89,
                        0.89,
                        0.89,
                        -7.01,
                        0.08,
                        -73.26,
                        -0.06,
                        -0.66,
                        0.00,
                        0.75,
                        0.62,
                        0.62,
                        0.62,
                        18.76,
                        0.65,
                        -35.4,
                        0.02,
                        -0.66,
                        0.09,
                        0.75,
                        0.68,
                        0.68,
                        0.68,
                        -25.91,
                        0.10,
                        -61.66,
                        0.09,
                        -0.76,
                        0.00,
                        0.65,
                        0.76,
                        0.76,
                        0.76,
                        32.41,
                        -0.1,
                        -11.7,
                        0.01,
                        -0.66,
                        0.08,
                        0.75,
                        0.75,
                        0.75,
                        0.75,
                        -9.09,
                        0.81,
                        -36.18,
                        0.10,
                        -0.69,
                        0.00,
                        0.72,
                        0.64,
                        0.64,
                        0.64,
                        41.37,
                        0.47,
                        -28.21,
                        -0.06,
                        -0.65,
                        0.03,
                        0.75,
                        0.55,
                        0.55,
                        0.55,
                        -9.05,
                        0.28,
                        -30.85,
                        0.04,
                        -0.69,
                        0.07,
                        0.72,
                        0.86,
                        0.86,
                        0.86,
                        6.87,
                        -0,
                        -29.32,
                        0.11,
                        -0.69,
                        -0.06,
                        0.71,
                        0.68,
                        0.68,
                        0.68,
                        -2.58,
                        0.74,
                        -53.03,
                        -0.02,
                        -0.76,
                        0.01,
                        0.65,
                        0.87,
                        0.87,
                        0.87,
                        -44.63,
                        0.87,
                        -21.38,
                        -0.07,
                        -0.63,
                        -0.06,
                        0.77,
                        0.47,
                        0.47,
                        0.47,
                        25.51,
                        -0.38,
                        -7.1,
                        0.01,
                        -0.69,
                        0.15,
                        0.71,
                        0.58,
                        0.58,
                        0.58,
                        2.38,
                        -0.44,
                        -19.91,
                        0.05,
                        -0.65,
                        -0.04,
                        0.76,
                        0.87,
                        0.87,
                        0.87,
                        -11.32,
                        1.02,
                        -35.15,
                        -0.06,
                        -0.74,
                        -0.05,
                        0.67,
                        0.67,
                        0.67,
                        0.67,
                        -19.17,
                        1.24,
                        -39.79,
                        -0.12,
                        -0.64,
                        0.03,
                        0.76,
                        0.93,
                        0.93,
                        0.93,
                        6.83,
                        0.03,
                        -29.63,
                        0.01,
                        -0.69,
                        0.08,
                        0.72,
                        0.96,
                        0.96,
                        0.96,
                        18.65,
                        -0.57,
                        -17.46,
                        0.08,
                        -0.67,
                        -0.05,
                        0.74,
                        0.49,
                        0.49,
                        0.49,
                        7.94,
                        -0.14,
                        -27.19,
                        -0.05,
                        -0.66,
                        -0.02,
                        0.75,
                        0.84,
                        0.84,
                        0.84,
                        -8.9,
                        0.63,
                        -36.67,
                        0.01,
                        -0.75,
                        0.11,
                        0.65,
                        0.56,
                        0.57,
                        0.57,
                        -6.56,
                        0.46,
                        -33.19,
                        0.01,
                        -0.74,
                        -0.09,
                        0.66,
                        0.51,
                        0.51,
                        0.51,
                        -0.51,
                        0.90,
                        -49.05,
                        0.08,
                        -0.66,
                        0.00,
                        0.75,
                        0.88,
                        0.88,
                        0.88,
                        -16.46,
                        0.70,
                        -45.63,
                        -0.09,
                        -0.75,
                        -0.01,
                        0.66,
                        0.93,
                        0.93,
                        0.93,
                        -2.55,
                        -0.04,
                        -27.77,
                        -0.08,
                        -0.64,
                        0.00,
                        0.77,
                        0.48,
                        0.48,
                        0.48,
                        -6.37,
                        0.25,
                        -39.63,
                        0.03,
                        -0.68,
                        0.10,
                        0.73,
                        0.78,
                        0.78,
                        0.78,
                        18.80,
                        0.44,
                        -31.16,
                        0.09,
                        -0.74,
                        -0.04,
                        0.67,
                        0.95,
                        0.95,
                        0.95,
                        -16.47,
                        -0.01,
                        -50.51,
                        0.01,
                        -0.69,
                        0.05,
                        0.72,
                        0.65,
                        0.65,
                        0.65,
                        -4.46,
                        -0.17,
                        -27.76,
                        0.08,
                        -0.76,
                        -0.02,
                        0.65,
                        0.73,
                        0.73,
                        0.73,
                        -19.54,
                        0.65,
                        -33.85,
                        0.02,
                        -0.66,
                        0.08,
                        0.74,
                        0.47,
                        0.47,
                        0.47,
                        -34.6,
                        0.68,
                        -15.54,
                        0.09,
                        -0.76,
                        -0.01,
                        0.64,
                        0.45,
                        0.45,
                        0.45,
                        -15.39,
                        0.07,
                        -49.84,
                        0.02,
                        -0.68,
                        0.09,
                        0.73,
                        0.73,
                        0.73,
                        0.73,
                        -3.99,
                        0.31,
                        -37.4,
                        0.09,
                        -0.71,
                        -0.04,
                        0.70,
                        0.43,
                        0.43,
                        0.43,
                        4.06,
                        0.42,
                        -30.21,
                        -0.03,
                        -0.71,
                        0.03,
                        0.71,
                        0.87,
                        0.87,
                        0.87,
                        -8.53,
                        -0.27,
                        -26.51,
                        0.00,
                        -0.61,
                        0.00,
                        0.79,
                        0.94,
                        0.94,
                        0.94,
                        -2.87,
                        0.05,
                        -69.03,
                        -0.11,
                        -0.72,
                        -0.11,
                        0.68,
                        0.65,
                        0.65,
                        0.65,
                        24.19,
                        -0.41,
                        -7.61,
                        0.11,
                        -0.65,
                        -0.08,
                        0.75,
                        0.85,
                        0.85,
                        0.85,
                        1.54,
                        -0.51,
                        -19.29,
                        -0.04,
                        -0.72,
                        -0.02,
                        0.70,
                        0.89,
                        0.89,
                        0.89,
                        21.63,
                        -0.43,
                        -7.96,
                        -0.11,
                        -0.71,
                        0.06,
                        0.69,
                        0.86,
                        0.86,
                        0.86,
                        9.39,
                        0.71,
                        -41.17,
                        -0.02,
                        -0.77,
                        0.01,
                        0.64,
                        0.55,
                        0.55,
                        0.55,
                        10.43,
                        0.34,
                        -39.21,
                        -0.11,
                        -0.7,
                        -0.09,
                        0.70,
                        0.89,
                        0.89,
                        0.89,
                        19.26,
                        0.39,
                        -30.54,
                        -0.09,
                        -0.74,
                        0.10,
                        0.66,
                        0.54,
                        0.54,
                        0.54,
                        -42.7,
                        0.61,
                        -20.33,
                        -0.03,
                        -0.68,
                        -0.03,
                        0.74,
                        0.41,
                        0.41,
                        0.41,
                        -22.27,
                        0.15,
                        -29.62,
                        -0.01,
                        -0.62,
                        -0.11,
                        0.78,
                        0.81,
                        0.81,
                        0.81,
                        -7.2,
                        0.23,
                        -39.43,
                        -0.01,
                        -0.66,
                        -0.09,
                        0.75,
                        0.86,
                        0.86,
                        0.86,
                        -7.84,
                        1.24,
                        -7.37,
                        0.01,
                        -0.77,
                        -0.07,
                        0.63,
                        0.61,
                        0.61,
                        0.61,
                        2.80,
                        0.65,
                        -49.28,
                        0.10,
                        -0.71,
                        0.04,
                        0.70,
                        0.54,
                        0.54,
                        0.54,
                        -21.01,
                        -0.01,
                        -52.9,
                        -0.07,
                        -0.72,
                        0.09,
                        0.69,
                        0.84,
                        0.84,
                        0.84,
                        -25.92,
                        0.16,
                        -58.69,
                        -0.01,
                        -0.71,
                        -0.02,
                        0.70,
                        0.91,
                        0.91,
                        0.91,
                        19.22,
                        -0.58,
                        -20.04,
                        0.05,
                        -0.61,
                        -0.02,
                        0.79,
                        0.62,
                        0.62,
                        0.62,
                        -39.6,
                        0.21,
                        -18.22,
                        -0.06,
                        -0.78,
                        -0.04,
                        0.62,
                        0.70,
                        0.70,
                        0.70,
                        6.59,
                        -0.05,
                        -28.94,
                        -0.13,
                        -0.75,
                        -0.03,
                        0.65,
                        0.71,
                        0.71,
                        0.71,
                        6.64,
                        0.02,
                        -29.82,
                        -0.09,
                        -0.65,
                        0.02,
                        0.75,
                        0.43,
                        0.43,
                        0.43,
                        29.88,
                        0.16,
                        -8,
                        0.02,
                        -0.72,
                        0.08,
                        0.69,
                        0.75,
                        0.75,
                        0.75,
                        -10.64,
                        1.13,
                        -35.56,
                        0.04,
                        -0.66,
                        -0.08,
                        0.74,
                        0.56,
                        0.56,
                        0.56
                    ]
                ];
                $5fbffa87c50562b9$var$a.flower_separation = .25;
                let nn = 0;
                let t = 0;
                const trimmed = [];
                const all_flowers = [];
                for (const pqs of flowers_pqs){
                    const new_pqs = [];
                    const n = pqs.length / 10;
                    nn += n;
                    for(let i = 0; i < n; ++i){
                        const ii = i * 10;
                        const m = all_flowers.length / 10;
                        if (!m) {
                            all_flowers.push(pqs[ii + 0], pqs[ii + 1], pqs[ii + 2]);
                            all_flowers.push(pqs[ii + 3], pqs[ii + 4], pqs[ii + 5], pqs[ii + 6]);
                            all_flowers.push(pqs[ii + 7], pqs[ii + 8], pqs[ii + 9]);
                            new_pqs.push(pqs[ii + 0], pqs[ii + 1], pqs[ii + 2]);
                            new_pqs.push(pqs[ii + 3], pqs[ii + 4], pqs[ii + 5], pqs[ii + 6]);
                            new_pqs.push(pqs[ii + 7], pqs[ii + 8], pqs[ii + 9]);
                            t++;
                        } else {
                            let gud = true;
                            for(let j = 0; j < m; ++j){
                                const jj = j * 10;
                                const dx = pqs[ii + 0] - all_flowers[jj + 0];
                                const dy = pqs[ii + 1] - all_flowers[jj + 1];
                                const dz = pqs[ii + 2] - all_flowers[jj + 2];
                                const distance2 = dx * dx + dy * dy + dz * dz;
                                if (distance2 < $5fbffa87c50562b9$var$a.flower_separation) {
                                    gud = false;
                                    break;
                                }
                            }
                            if (gud) {
                                all_flowers.push(pqs[ii + 0], pqs[ii + 1], pqs[ii + 2]);
                                all_flowers.push(pqs[ii + 3], pqs[ii + 4], pqs[ii + 5], pqs[ii + 6]);
                                all_flowers.push(pqs[ii + 7], pqs[ii + 8], pqs[ii + 9]);
                                new_pqs.push(pqs[ii + 0], pqs[ii + 1], pqs[ii + 2]);
                                new_pqs.push(pqs[ii + 3], pqs[ii + 4], pqs[ii + 5], pqs[ii + 6]);
                                //new_pqs.push    ( pqs[ ii + 7 ], pqs[ ii + 8 ], pqs[ ii + 9 ])
                                new_pqs.push(1.3, 1.3, 1.3);
                                t++;
                            }
                        }
                    }
                    trimmed.push(new_pqs);
                }
                console.log(nn + " => " + t);
                for (const [index, name] of [
                    "tulipa_A_src",
                    "tulipa_B_src",
                    "tulipa_C_src",
                    "tulipa_D_src",
                    "tulipa_E_src",
                    "tulipa_F_src",
                    "tulipa_G_src",
                    "tulipa_H_src",
                    "tulipa_I_src",
                    "tulipa_J_src",
                    "tulipa_K_src",
                    "chicory_src",
                    "daisy_src",
                    "sainpaulia",
                    "primrose",
                    "hollyhock"
                ].entries())create_instanced_meshes({
                    names: [
                        name
                    ],
                    pqs: trimmed[index],
                    sway: true
                });
            }
            $5fbffa87c50562b9$var$a.platform001 = garden.scene.getObjectByName("platform001");
            $5fbffa87c50562b9$var$a.platform001.material = $5fbffa87c50562b9$var$reflective_material;
            $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.platform001);
            $5fbffa87c50562b9$var$a.info_disk010 = garden.scene.getObjectByName("info_disk010");
            $5fbffa87c50562b9$var$a.info_disk010.material = $5fbffa87c50562b9$var$reflective_material;
            $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.info_disk010);
            $5fbffa87c50562b9$var$a.platform_b = garden.scene.getObjectByName("platform_b");
            $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.platform_b);
            {
                $5fbffa87c50562b9$var$a.b_patch = new $0147bee01cff6558$export$e4dd07dff30cc924();
                $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.b_patch);
                const b_patch = garden.scene.getObjectByName("b_patch");
                $5fbffa87c50562b9$var$a.b_patch.position.copy(b_patch.position);
                //const platform_b                   = garden.scene.getObjectByName( 'platform_b' )
                //a.b_patch.add                      ( platform_b )
                const clover_b_pqs = [
                    28.03,
                    -0.27,
                    -21.65,
                    0.03,
                    -0.73,
                    -0.02,
                    0.68,
                    1.1874,
                    1.1874,
                    1.1874,
                    28.03,
                    -0.27,
                    -21.65,
                    0.04,
                    -0.66,
                    0.05,
                    0.75,
                    1.4026,
                    1.4026,
                    1.4026,
                    28.03,
                    -0.27,
                    -21.58,
                    0.05,
                    -0.6,
                    -0,
                    0.80,
                    1.4530,
                    1.4530,
                    1.4530,
                    29.00,
                    -0.27,
                    -21.99,
                    -0.11,
                    -0.73,
                    -0.07,
                    0.67,
                    1.2099,
                    1.2099,
                    1.2099,
                    28.99,
                    -0.27,
                    -21.95,
                    -0.11,
                    -0.66,
                    0.05,
                    0.74,
                    1.2185,
                    1.2185,
                    1.2185,
                    28.05,
                    -0.27,
                    -21.19,
                    0.01,
                    -0.73,
                    0.05,
                    0.68,
                    1.2290,
                    1.2290,
                    1.2290,
                    28.04,
                    -0.27,
                    -21.26,
                    -0.04,
                    -0.65,
                    -0.09,
                    0.75,
                    1.4529,
                    1.4529,
                    1.4529,
                    29.03,
                    -0.27,
                    -22.01,
                    0.02,
                    -0.71,
                    -0.13,
                    0.69,
                    1.1203,
                    1.1203,
                    1.1203,
                    28.07,
                    -0.27,
                    -21.15,
                    -0.01,
                    -0.77,
                    0.01,
                    0.64,
                    1.3486,
                    1.3486,
                    1.3486,
                    29.02,
                    -0.27,
                    -22.08,
                    -0.14,
                    -0.66,
                    0.00,
                    0.74,
                    1.0799,
                    1.0799,
                    1.0799,
                    29.19,
                    -0.27,
                    -22.3,
                    -0.02,
                    -0.73,
                    0.08,
                    0.68,
                    1.3377,
                    1.3377,
                    1.3377,
                    28.10,
                    -0.27,
                    -21.11,
                    -0.07,
                    -0.66,
                    0.04,
                    0.75,
                    1.2416,
                    1.2416,
                    1.2416,
                    29.49,
                    -0.27,
                    -21.42,
                    0.03,
                    -0.73,
                    0.06,
                    0.68,
                    1.2902,
                    1.2902,
                    1.2902,
                    29.50,
                    -0.27,
                    -21.45,
                    0.03,
                    -0.67,
                    -0.11,
                    0.73,
                    1.3333,
                    1.3333,
                    1.3333,
                    28.15,
                    -0.27,
                    -20.99,
                    0.09,
                    -0.73,
                    0.04,
                    0.68,
                    1.4754,
                    1.4754,
                    1.4754,
                    29.43,
                    -0.27,
                    -21.57,
                    -0.09,
                    -0.62,
                    0.00,
                    0.78,
                    1.2215,
                    1.2215,
                    1.2215,
                    29.39,
                    -0.27,
                    -21.63,
                    -0.06,
                    -0.75,
                    -0.02,
                    0.66,
                    1.3093,
                    1.3093,
                    1.3093,
                    28.28,
                    -0.27,
                    -20.89,
                    0.02,
                    -0.65,
                    0.01,
                    0.76,
                    1.1968,
                    1.1968,
                    1.1968,
                    28.24,
                    -0.27,
                    -21.51,
                    -0.11,
                    -0.76,
                    0.02,
                    0.64,
                    1.3903,
                    1.3903,
                    1.3903,
                    28.23,
                    -0.27,
                    -21.53,
                    -0.08,
                    -0.74,
                    -0.01,
                    0.67,
                    1.2526,
                    1.2526,
                    1.2526,
                    29.36,
                    -0.27,
                    -21.67,
                    -0.08,
                    -0.64,
                    0.02,
                    0.76,
                    1.2021,
                    1.2021,
                    1.2021,
                    28.79,
                    -0.27,
                    -20.64,
                    0.02,
                    -0.67,
                    -0.11,
                    0.74,
                    1.2537,
                    1.2537,
                    1.2537,
                    29.32,
                    -0.27,
                    -21.72,
                    0.08,
                    -0.65,
                    0.02,
                    0.75,
                    1.2256,
                    1.2256,
                    1.2256,
                    28.82,
                    -0.27,
                    -20.63,
                    -0.05,
                    -0.61,
                    -0,
                    0.79,
                    1.4465,
                    1.4465,
                    1.4465,
                    29.27,
                    -0.27,
                    -21.8,
                    -0.07,
                    -0.65,
                    -0.03,
                    0.76,
                    1.3224,
                    1.3224,
                    1.3224,
                    29.21,
                    -0.27,
                    -21.8,
                    0.00,
                    -0.64,
                    0.10,
                    0.76,
                    1.1345,
                    1.1345,
                    1.1345,
                    28.94,
                    -0.27,
                    -20.61,
                    -0.09,
                    -0.67,
                    0.01,
                    0.74,
                    1.1337,
                    1.1337,
                    1.1337,
                    28.62,
                    -0.28,
                    -22.36,
                    0.03,
                    -0.69,
                    -0.07,
                    0.72,
                    1.4953,
                    1.4953,
                    1.4953,
                    28.86,
                    -0.27,
                    -22.16,
                    0.01,
                    -0.64,
                    -0.03,
                    0.76,
                    1.4358,
                    1.4358,
                    1.4358,
                    29.20,
                    -0.27,
                    -21.84,
                    -0.06,
                    -0.66,
                    -0.09,
                    0.74,
                    1.4004,
                    1.4004,
                    1.4004,
                    28.38,
                    -0.27,
                    -21.52,
                    0.04,
                    -0.72,
                    -0.13,
                    0.68,
                    1.4698,
                    1.4698,
                    1.4698,
                    29.00,
                    -0.27,
                    -20.64,
                    0.05,
                    -0.7,
                    -0.02,
                    0.71,
                    1.0822,
                    1.0822,
                    1.0822,
                    29.01,
                    -0.27,
                    -20.65,
                    -0.03,
                    -0.77,
                    0.02,
                    0.64,
                    1.3254,
                    1.3254,
                    1.3254,
                    29.03,
                    -0.27,
                    -20.63,
                    -0.07,
                    -0.64,
                    -0.06,
                    0.77,
                    1.3170,
                    1.3170,
                    1.3170,
                    28.42,
                    -0.27,
                    -21.97,
                    0.06,
                    -0.66,
                    -0.03,
                    0.75,
                    1.3361,
                    1.3361,
                    1.3361,
                    28.31,
                    -0.27,
                    -21.53,
                    -0.06,
                    -0.75,
                    -0.03,
                    0.66,
                    1.4679,
                    1.4679,
                    1.4679,
                    28.35,
                    -0.27,
                    -21.5,
                    -0.12,
                    -0.66,
                    -0,
                    0.75,
                    1.4023,
                    1.4023,
                    1.4023,
                    29.09,
                    -0.27,
                    -20.62,
                    -0.06,
                    -0.76,
                    -0.05,
                    0.64,
                    1.4619,
                    1.4619,
                    1.4619,
                    28.09,
                    -0.27,
                    -21.75,
                    -0.09,
                    -0.73,
                    0.01,
                    0.67,
                    1.4507,
                    1.4507,
                    1.4507,
                    29.18,
                    -0.27,
                    -20.7,
                    -0.07,
                    -0.66,
                    0.01,
                    0.75,
                    1.4409,
                    1.4409,
                    1.4409,
                    29.18,
                    -0.27,
                    -20.73,
                    0.02,
                    -0.66,
                    0.08,
                    0.75,
                    1.3507,
                    1.3507,
                    1.3507,
                    28.40,
                    -0.27,
                    -21.79,
                    0.01,
                    -0.69,
                    0.10,
                    0.72,
                    1.2991,
                    1.2991,
                    1.2991,
                    28.77,
                    -0.27,
                    -21.03,
                    0.08,
                    -0.71,
                    -0.04,
                    0.69,
                    1.1425,
                    1.1425,
                    1.1425,
                    28.78,
                    -0.27,
                    -21.05,
                    -0.01,
                    -0.75,
                    0.03,
                    0.66,
                    1.1460,
                    1.1460,
                    1.1460,
                    28.78,
                    -0.27,
                    -21.08,
                    -0.05,
                    -0.77,
                    -0.08,
                    0.64,
                    1.3353,
                    1.3353,
                    1.3353,
                    28.73,
                    -0.27,
                    -21.05,
                    0.10,
                    -0.63,
                    0.00,
                    0.77,
                    1.1576,
                    1.1576,
                    1.1576,
                    28.15,
                    -0.27,
                    -21.39,
                    0.02,
                    -0.75,
                    0.01,
                    0.66,
                    1.2680,
                    1.2680,
                    1.2680,
                    28.18,
                    -0.27,
                    -21.35,
                    0.11,
                    -0.7,
                    -0.08,
                    0.70,
                    1.0874,
                    1.0874,
                    1.0874,
                    28.28,
                    -0.27,
                    -21.38,
                    -0.01,
                    -0.76,
                    0.01,
                    0.66,
                    1.4539,
                    1.4539,
                    1.4539,
                    28.62,
                    -0.27,
                    -22.22,
                    0.11,
                    -0.77,
                    -0.05,
                    0.63,
                    1.1035,
                    1.1035,
                    1.1035,
                    28.79,
                    -0.27,
                    -20.68,
                    0.02,
                    -0.65,
                    0.06,
                    0.76,
                    1.4490,
                    1.4490,
                    1.4490,
                    28.35,
                    -0.27,
                    -20.89,
                    0.12,
                    -0.75,
                    0.02,
                    0.66,
                    1.2682,
                    1.2682,
                    1.2682,
                    28.81,
                    -0.27,
                    -20.7,
                    -0.02,
                    -0.65,
                    0.08,
                    0.76,
                    1.4315,
                    1.4315,
                    1.4315,
                    28.38,
                    -0.27,
                    -20.98,
                    0.08,
                    -0.66,
                    0.02,
                    0.75,
                    1.1272,
                    1.1272,
                    1.1272,
                    28.41,
                    -0.27,
                    -21,
                    -0.06,
                    -0.76,
                    0.03,
                    0.65,
                    1.3441,
                    1.3441,
                    1.3441,
                    28.33,
                    -0.27,
                    -21.61,
                    -0.08,
                    -0.68,
                    -0.04,
                    0.73,
                    1.3205,
                    1.3205,
                    1.3205,
                    28.34,
                    -0.27,
                    -21.67,
                    -0.05,
                    -0.71,
                    0.12,
                    0.69,
                    1.4288,
                    1.4288,
                    1.4288,
                    28.35,
                    -0.27,
                    -21.76,
                    0.01,
                    -0.73,
                    -0.03,
                    0.68,
                    1.1429,
                    1.1429,
                    1.1429,
                    29.33,
                    -0.27,
                    -21.62,
                    -0.11,
                    -0.75,
                    -0.01,
                    0.66,
                    1.2518,
                    1.2518,
                    1.2518,
                    29.27,
                    -0.27,
                    -21.64,
                    -0.1,
                    -0.71,
                    0.01,
                    0.70,
                    1.1260,
                    1.1260,
                    1.1260,
                    29.24,
                    -0.27,
                    -21.1,
                    -0.04,
                    -0.65,
                    0.03,
                    0.76,
                    1.3181,
                    1.3181,
                    1.3181,
                    29.21,
                    -0.27,
                    -21.1,
                    0.05,
                    -0.75,
                    0.06,
                    0.65,
                    1.2890,
                    1.2890,
                    1.2890,
                    28.21,
                    -0.27,
                    -21.45,
                    -0.02,
                    -0.75,
                    0.07,
                    0.66,
                    1.1644,
                    1.1644,
                    1.1644,
                    28.25,
                    -0.27,
                    -21.46,
                    -0.02,
                    -0.75,
                    -0.07,
                    0.66,
                    1.4544,
                    1.4544,
                    1.4544,
                    28.20,
                    -0.27,
                    -21.38,
                    0.02,
                    -0.68,
                    0.07,
                    0.73,
                    1.4484,
                    1.4484,
                    1.4484,
                    28.32,
                    -0.27,
                    -21.43,
                    0.09,
                    -0.64,
                    -0.02,
                    0.77,
                    1.2270,
                    1.2270,
                    1.2270,
                    28.64,
                    -0.27,
                    -22.2,
                    0.02,
                    -0.7,
                    -0.06,
                    0.71,
                    1.3163,
                    1.3163,
                    1.3163,
                    28.32,
                    -0.27,
                    -20.94,
                    -0,
                    -0.76,
                    -0.04,
                    0.65,
                    1.4477,
                    1.4477,
                    1.4477,
                    28.33,
                    -0.27,
                    -20.97,
                    0.05,
                    -0.79,
                    0.02,
                    0.61,
                    1.0957,
                    1.0957,
                    1.0957,
                    28.34,
                    -0.27,
                    -21.01,
                    0.06,
                    -0.68,
                    0.13,
                    0.72,
                    1.4324,
                    1.4324,
                    1.4324,
                    28.37,
                    -0.27,
                    -21.1,
                    0.13,
                    -0.68,
                    -0.04,
                    0.72,
                    1.1102,
                    1.1102,
                    1.1102,
                    28.42,
                    -0.27,
                    -21.15,
                    -0.04,
                    -0.65,
                    0.02,
                    0.76,
                    1.4722,
                    1.4722,
                    1.4722,
                    29.36,
                    -0.27,
                    -21.62,
                    0.01,
                    -0.73,
                    -0.13,
                    0.67,
                    1.4765,
                    1.4765,
                    1.4765,
                    29.30,
                    -0.27,
                    -21.53,
                    -0.08,
                    -0.71,
                    -0.03,
                    0.70,
                    1.3555,
                    1.3555,
                    1.3555,
                    29.27,
                    -0.27,
                    -21.05,
                    -0.14,
                    -0.73,
                    -0.01,
                    0.67,
                    1.4533,
                    1.4533,
                    1.4533,
                    29.19,
                    -0.27,
                    -21.02,
                    -0.08,
                    -0.67,
                    0.03,
                    0.74,
                    1.4016,
                    1.4016,
                    1.4016,
                    28.25,
                    -0.27,
                    -20.94,
                    0.06,
                    -0.77,
                    -0.03,
                    0.63,
                    1.3127,
                    1.3127,
                    1.3127,
                    28.25,
                    -0.27,
                    -21.02,
                    0.05,
                    -0.69,
                    0.08,
                    0.72,
                    1.3171,
                    1.3171,
                    1.3171,
                    28.27,
                    -0.27,
                    -21.06,
                    0.04,
                    -0.74,
                    0.06,
                    0.67,
                    1.0967,
                    1.0967,
                    1.0967,
                    28.31,
                    -0.27,
                    -21.07,
                    0.03,
                    -0.73,
                    -0.13,
                    0.67,
                    1.3227,
                    1.3227,
                    1.3227,
                    28.36,
                    -0.27,
                    -21.11,
                    0.04,
                    -0.76,
                    0.08,
                    0.65,
                    1.1881,
                    1.1881,
                    1.1881,
                    28.39,
                    -0.27,
                    -21.14,
                    0.01,
                    -0.65,
                    -0.11,
                    0.75,
                    1.3206,
                    1.3206,
                    1.3206,
                    29.41,
                    -0.27,
                    -21.5,
                    -0,
                    -0.74,
                    -0.08,
                    0.67,
                    1.4657,
                    1.4657,
                    1.4657,
                    29.34,
                    -0.27,
                    -21.54,
                    0.08,
                    -0.74,
                    -0.04,
                    0.67,
                    1.4756,
                    1.4756,
                    1.4756,
                    29.31,
                    -0.27,
                    -21.52,
                    0.02,
                    -0.71,
                    0.06,
                    0.70,
                    1.2631,
                    1.2631,
                    1.2631,
                    29.00,
                    -0.27,
                    -22.4,
                    0.04,
                    -0.64,
                    -0.07,
                    0.76,
                    1.4020,
                    1.4020,
                    1.4020,
                    29.15,
                    -0.27,
                    -20.98,
                    -0.01,
                    -0.77,
                    -0.04,
                    0.64,
                    1.3688,
                    1.3688,
                    1.3688,
                    28.16,
                    -0.27,
                    -21.03,
                    0.09,
                    -0.63,
                    0.05,
                    0.77,
                    1.2634,
                    1.2634,
                    1.2634,
                    28.16,
                    -0.27,
                    -21.06,
                    -0.13,
                    -0.69,
                    -0,
                    0.71,
                    1.1713,
                    1.1713,
                    1.1713,
                    28.25,
                    -0.27,
                    -21.08,
                    -0.05,
                    -0.75,
                    -0.05,
                    0.66,
                    1.4148,
                    1.4148,
                    1.4148,
                    28.31,
                    -0.27,
                    -21.15,
                    -0.03,
                    -0.66,
                    0.05,
                    0.75,
                    1.2336,
                    1.2336,
                    1.2336,
                    28.34,
                    -0.27,
                    -21.13,
                    0.06,
                    -0.69,
                    0.04,
                    0.72,
                    1.1153,
                    1.1153,
                    1.1153,
                    28.36,
                    -0.27,
                    -21.16,
                    -0.1,
                    -0.65,
                    0.07,
                    0.75,
                    1.1387,
                    1.1387,
                    1.1387,
                    29.39,
                    -0.27,
                    -21.43,
                    0.03,
                    -0.73,
                    -0.01,
                    0.68,
                    1.2282,
                    1.2282,
                    1.2282,
                    29.07,
                    -0.27,
                    -22.36,
                    0.03,
                    -0.64,
                    0.07,
                    0.76,
                    1.1854,
                    1.1854,
                    1.1854,
                    29.04,
                    -0.27,
                    -22.34,
                    0.10,
                    -0.64,
                    0.01,
                    0.76,
                    1.2622,
                    1.2622,
                    1.2622,
                    28.98,
                    -0.27,
                    -22.39,
                    -0.08,
                    -0.64,
                    -0,
                    0.77,
                    1.1794,
                    1.1794,
                    1.1794,
                    29.14,
                    -0.27,
                    -20.96,
                    0.04,
                    -0.75,
                    -0.08,
                    0.65,
                    1.2361,
                    1.2361,
                    1.2361,
                    28.13,
                    -0.27,
                    -21.08,
                    0.07,
                    -0.71,
                    0.03,
                    0.70,
                    1.4570,
                    1.4570,
                    1.4570,
                    28.14,
                    -0.27,
                    -21.06,
                    -0.07,
                    -0.72,
                    0.09,
                    0.69,
                    1.1096,
                    1.1096,
                    1.1096,
                    28.17,
                    -0.27,
                    -21.13,
                    -0,
                    -0.73,
                    -0.02,
                    0.68,
                    1.2706,
                    1.2706,
                    1.2706,
                    28.20,
                    -0.27,
                    -21.13,
                    0.04,
                    -0.6,
                    0.01,
                    0.80,
                    1.1029,
                    1.1029,
                    1.1029,
                    28.36,
                    -0.27,
                    -21.19,
                    0.09,
                    -0.74,
                    0.09,
                    0.67,
                    1.3173,
                    1.3173,
                    1.3173,
                    29.13,
                    -0.27,
                    -22.3,
                    0.06,
                    -0.65,
                    0.03,
                    0.76,
                    1.4682,
                    1.4682,
                    1.4682,
                    29.11,
                    -0.27,
                    -22.33,
                    -0.13,
                    -0.73,
                    -0.01,
                    0.68,
                    1.3373,
                    1.3373,
                    1.3373,
                    28.66,
                    -0.27,
                    -21.33,
                    0.01,
                    -0.76,
                    0.04,
                    0.64,
                    1.1979,
                    1.1979,
                    1.1979,
                    28.63,
                    -0.27,
                    -21.37,
                    -0.03,
                    -0.62,
                    -0.07,
                    0.78,
                    1.1528,
                    1.1528,
                    1.1528,
                    29.15,
                    -0.27,
                    -20.93,
                    -0.02,
                    -0.66,
                    -0.12,
                    0.74,
                    1.2390,
                    1.2390,
                    1.2390,
                    28.08,
                    -0.27,
                    -21.17,
                    -0.02,
                    -0.66,
                    -0.07,
                    0.75,
                    1.3018,
                    1.3018,
                    1.3018,
                    28.23,
                    -0.27,
                    -21.18,
                    -0.02,
                    -0.67,
                    -0.09,
                    0.74,
                    1.4664,
                    1.4664,
                    1.4664,
                    28.32,
                    -0.27,
                    -21.22,
                    0.06,
                    -0.66,
                    -0,
                    0.75,
                    1.2857,
                    1.2857,
                    1.2857,
                    28.35,
                    -0.27,
                    -21.24,
                    -0.09,
                    -0.65,
                    -0.02,
                    0.75,
                    1.1343,
                    1.1343,
                    1.1343,
                    28.65,
                    -0.27,
                    -21.03,
                    -0.01,
                    -0.7,
                    0.11,
                    0.70,
                    1.2288,
                    1.2288,
                    1.2288,
                    28.92,
                    -0.27,
                    -22.05,
                    -0.06,
                    -0.74,
                    0.13,
                    0.66,
                    1.3540,
                    1.3540,
                    1.3540,
                    28.87,
                    -0.27,
                    -21.67,
                    0.00,
                    -0.74,
                    -0.09,
                    0.67,
                    1.1335,
                    1.1335,
                    1.1335,
                    28.10,
                    -0.27,
                    -21.23,
                    -0.02,
                    -0.75,
                    0.05,
                    0.65,
                    1.1514,
                    1.1514,
                    1.1514,
                    28.17,
                    -0.27,
                    -21.27,
                    0.13,
                    -0.71,
                    0.00,
                    0.69,
                    1.1676,
                    1.1676,
                    1.1676,
                    28.16,
                    -0.27,
                    -21.25,
                    -0.04,
                    -0.74,
                    0.06,
                    0.67,
                    1.0976,
                    1.0976,
                    1.0976,
                    28.64,
                    -0.27,
                    -21.03,
                    0.03,
                    -0.76,
                    -0.05,
                    0.65,
                    1.1183,
                    1.1183,
                    1.1183,
                    28.94,
                    -0.27,
                    -21.94,
                    0.08,
                    -0.69,
                    0.05,
                    0.72,
                    1.2866,
                    1.2866,
                    1.2866,
                    28.90,
                    -0.27,
                    -22.01,
                    -0.08,
                    -0.77,
                    0.05,
                    0.63,
                    1.4362,
                    1.4362,
                    1.4362,
                    28.90,
                    -0.27,
                    -21.98,
                    -0.07,
                    -0.7,
                    -0.04,
                    0.71,
                    1.3477,
                    1.3477,
                    1.3477,
                    28.68,
                    -0.27,
                    -21.27,
                    0.06,
                    -0.7,
                    0.05,
                    0.71,
                    1.1015,
                    1.1015,
                    1.1015,
                    28.66,
                    -0.27,
                    -21.27,
                    -0.08,
                    -0.63,
                    0.08,
                    0.77,
                    1.4350,
                    1.4350,
                    1.4350,
                    28.52,
                    -0.27,
                    -21.45,
                    0.05,
                    -0.71,
                    0.05,
                    0.70,
                    1.4429,
                    1.4429,
                    1.4429,
                    28.89,
                    -0.27,
                    -21.64,
                    0.08,
                    -0.77,
                    -0.09,
                    0.63,
                    1.4367,
                    1.4367,
                    1.4367,
                    28.08,
                    -0.27,
                    -21.61,
                    0.01,
                    -0.65,
                    0.13,
                    0.75,
                    1.2350,
                    1.2350,
                    1.2350,
                    28.35,
                    -0.27,
                    -22.17,
                    -0.01,
                    -0.76,
                    -0.09,
                    0.64,
                    1.3178,
                    1.3178,
                    1.3178,
                    28.36,
                    -0.27,
                    -22.15,
                    0.11,
                    -0.71,
                    0.01,
                    0.70,
                    1.3881,
                    1.3881,
                    1.3881,
                    29.11,
                    -0.27,
                    -21.48,
                    -0.04,
                    -0.74,
                    -0.12,
                    0.66,
                    1.4693,
                    1.4693,
                    1.4693,
                    29.10,
                    -0.27,
                    -21.49,
                    0.10,
                    -0.67,
                    -0.03,
                    0.74,
                    1.2429,
                    1.2429,
                    1.2429,
                    28.89,
                    -0.27,
                    -21.94,
                    -0.05,
                    -0.75,
                    0.00,
                    0.65,
                    1.4813,
                    1.4813,
                    1.4813,
                    28.66,
                    -0.27,
                    -21.19,
                    -0.09,
                    -0.68,
                    0.06,
                    0.73,
                    1.1128,
                    1.1128,
                    1.1128,
                    28.50,
                    -0.27,
                    -21.42,
                    0.09,
                    -0.77,
                    0.04,
                    0.63,
                    1.4499,
                    1.4499,
                    1.4499,
                    28.48,
                    -0.27,
                    -21.44,
                    0.00,
                    -0.65,
                    0.11,
                    0.75,
                    1.2978,
                    1.2978,
                    1.2978,
                    28.10,
                    -0.27,
                    -21.7,
                    -0.03,
                    -0.69,
                    0.07,
                    0.72,
                    1.1281,
                    1.1281,
                    1.1281,
                    28.33,
                    -0.27,
                    -22.22,
                    -0.08,
                    -0.75,
                    -0.04,
                    0.65,
                    1.4197,
                    1.4197,
                    1.4197,
                    28.42,
                    -0.27,
                    -22.19,
                    -0,
                    -0.75,
                    -0.07,
                    0.65,
                    1.2668,
                    1.2668,
                    1.2668,
                    28.47,
                    -0.27,
                    -22.18,
                    0.08,
                    -0.77,
                    0.01,
                    0.64,
                    1.2513,
                    1.2513,
                    1.2513,
                    28.51,
                    -0.27,
                    -22.15,
                    0.02,
                    -0.66,
                    0.10,
                    0.75,
                    1.1863,
                    1.1863,
                    1.1863,
                    29.06,
                    -0.27,
                    -21.43,
                    0.10,
                    -0.68,
                    -0.02,
                    0.73,
                    1.0966,
                    1.0966,
                    1.0966,
                    29.06,
                    -0.27,
                    -21.42,
                    -0.07,
                    -0.68,
                    0.01,
                    0.73,
                    1.3853,
                    1.3853,
                    1.3853,
                    28.94,
                    -0.27,
                    -21.81,
                    -0.03,
                    -0.67,
                    0.06,
                    0.74,
                    1.2478,
                    1.2478,
                    1.2478,
                    28.92,
                    -0.27,
                    -21.86,
                    0.06,
                    -0.71,
                    0.02,
                    0.70,
                    1.2191,
                    1.2191,
                    1.2191,
                    28.48,
                    -0.27,
                    -21.42,
                    -0.04,
                    -0.79,
                    0.04,
                    0.61,
                    1.4661,
                    1.4661,
                    1.4661,
                    28.13,
                    -0.27,
                    -21.77,
                    -0.05,
                    -0.66,
                    0.05,
                    0.75,
                    1.2038,
                    1.2038,
                    1.2038,
                    28.17,
                    -0.27,
                    -21.72,
                    0.05,
                    -0.68,
                    0.04,
                    0.73,
                    1.3463,
                    1.3463,
                    1.3463,
                    28.37,
                    -0.27,
                    -22.27,
                    0.01,
                    -0.74,
                    0.07,
                    0.67,
                    1.4091,
                    1.4091,
                    1.4091,
                    28.43,
                    -0.27,
                    -22.22,
                    0.06,
                    -0.71,
                    -0.03,
                    0.70,
                    1.3970,
                    1.3970,
                    1.3970,
                    29.08,
                    -0.27,
                    -20.72,
                    0.06,
                    -0.72,
                    -0.14,
                    0.68,
                    1.4380,
                    1.4380,
                    1.4380,
                    29.02,
                    -0.27,
                    -21.43,
                    -0.02,
                    -0.61,
                    0.00,
                    0.79,
                    1.1784,
                    1.1784,
                    1.1784,
                    28.72,
                    -0.27,
                    -21.9,
                    0.14,
                    -0.73,
                    0.00,
                    0.67,
                    1.3126,
                    1.3126,
                    1.3126,
                    28.88,
                    -0.27,
                    -21.84,
                    0.04,
                    -0.65,
                    -0.01,
                    0.76,
                    1.2818,
                    1.2818,
                    1.2818,
                    28.33,
                    -0.27,
                    -21.46,
                    0.06,
                    -0.72,
                    0.06,
                    0.69,
                    1.2930,
                    1.2930,
                    1.2930,
                    28.32,
                    -0.27,
                    -21.43,
                    -0.02,
                    -0.65,
                    -0.04,
                    0.76,
                    1.3586,
                    1.3586,
                    1.3586,
                    28.36,
                    -0.27,
                    -21.43,
                    0.02,
                    -0.65,
                    -0.09,
                    0.76,
                    1.3685,
                    1.3685,
                    1.3685,
                    28.86,
                    -0.27,
                    -21.36,
                    -0.02,
                    -0.66,
                    -0.08,
                    0.74,
                    1.2632,
                    1.2632,
                    1.2632,
                    28.17,
                    -0.27,
                    -21.8,
                    -0.04,
                    -0.74,
                    0.01,
                    0.67,
                    1.2383,
                    1.2383,
                    1.2383,
                    28.21,
                    -0.27,
                    -21.79,
                    -0.12,
                    -0.74,
                    -0.04,
                    0.67,
                    1.2679,
                    1.2679,
                    1.2679,
                    28.23,
                    -0.27,
                    -21.76,
                    -0.1,
                    -0.72,
                    0.04,
                    0.68,
                    1.1153,
                    1.1153,
                    1.1153,
                    28.43,
                    -0.27,
                    -22.29,
                    -0.04,
                    -0.75,
                    0.01,
                    0.66,
                    1.4619,
                    1.4619,
                    1.4619,
                    28.49,
                    -0.27,
                    -22.23,
                    -0.12,
                    -0.67,
                    0.03,
                    0.73,
                    1.2455,
                    1.2455,
                    1.2455,
                    28.97,
                    -0.27,
                    -20.68,
                    0.08,
                    -0.69,
                    -0.02,
                    0.72,
                    1.1862,
                    1.1862,
                    1.1862,
                    28.68,
                    -0.27,
                    -21.89,
                    0.05,
                    -0.65,
                    0.07,
                    0.75,
                    1.1610,
                    1.1610,
                    1.1610,
                    28.66,
                    -0.27,
                    -21.94,
                    0.11,
                    -0.76,
                    -0.01,
                    0.64,
                    1.0866,
                    1.0866,
                    1.0866,
                    28.42,
                    -0.27,
                    -21.73,
                    0.08,
                    -0.74,
                    -0.02,
                    0.67,
                    1.3561,
                    1.3561,
                    1.3561,
                    28.76,
                    -0.27,
                    -21.11,
                    0.03,
                    -0.79,
                    0.01,
                    0.61,
                    1.3398,
                    1.3398,
                    1.3398,
                    28.23,
                    -0.27,
                    -21.86,
                    0.07,
                    -0.68,
                    0.12,
                    0.72,
                    1.4766,
                    1.4766,
                    1.4766,
                    28.26,
                    -0.27,
                    -21.88,
                    0.10,
                    -0.67,
                    -0.07,
                    0.73,
                    1.4726,
                    1.4726,
                    1.4726,
                    28.48,
                    -0.27,
                    -22.34,
                    0.09,
                    -0.76,
                    -0.01,
                    0.64,
                    1.4807,
                    1.4807,
                    1.4807,
                    28.49,
                    -0.27,
                    -22.3,
                    0.02,
                    -0.72,
                    0.10,
                    0.69,
                    1.1154,
                    1.1154,
                    1.1154,
                    28.52,
                    -0.27,
                    -22.27,
                    0.04,
                    -0.65,
                    -0.07,
                    0.76,
                    1.0852,
                    1.0852,
                    1.0852,
                    28.96,
                    -0.27,
                    -20.65,
                    0.04,
                    -0.76,
                    -0.1,
                    0.65,
                    1.4364,
                    1.4364,
                    1.4364,
                    28.93,
                    -0.27,
                    -20.66,
                    0.06,
                    -0.65,
                    0.02,
                    0.76,
                    1.2439,
                    1.2439,
                    1.2439,
                    28.94,
                    -0.27,
                    -20.72,
                    -0.12,
                    -0.68,
                    -0.02,
                    0.73,
                    1.4428,
                    1.4428,
                    1.4428,
                    28.90,
                    -0.27,
                    -20.72,
                    -0.04,
                    -0.65,
                    0.08,
                    0.75,
                    1.2841,
                    1.2841,
                    1.2841,
                    28.95,
                    -0.27,
                    -20.73,
                    0.05,
                    -0.76,
                    0.02,
                    0.64,
                    1.2511,
                    1.2511,
                    1.2511,
                    28.91,
                    -0.27,
                    -20.76,
                    0.02,
                    -0.65,
                    0.11,
                    0.75,
                    1.2770,
                    1.2770,
                    1.2770,
                    28.62,
                    -0.27,
                    -21.92,
                    0.11,
                    -0.7,
                    -0.01,
                    0.70,
                    1.2516,
                    1.2516,
                    1.2516,
                    28.38,
                    -0.27,
                    -21.66,
                    -0.05,
                    -0.71,
                    0.05,
                    0.70,
                    1.2723,
                    1.2723,
                    1.2723,
                    29.26,
                    -0.27,
                    -21.76,
                    0.11,
                    -0.68,
                    0.10,
                    0.72,
                    1.4487,
                    1.4487,
                    1.4487,
                    29.23,
                    -0.27,
                    -21.24,
                    -0.12,
                    -0.73,
                    0.08,
                    0.67,
                    1.2592,
                    1.2592,
                    1.2592,
                    28.85,
                    -0.27,
                    -21.31,
                    0.04,
                    -0.75,
                    -0.11,
                    0.65,
                    1.2104,
                    1.2104,
                    1.2104,
                    28.85,
                    -0.27,
                    -21.29,
                    0.06,
                    -0.67,
                    0.01,
                    0.74,
                    1.1662,
                    1.1662,
                    1.1662,
                    29.21,
                    -0.27,
                    -21.18,
                    -0.11,
                    -0.71,
                    -0.01,
                    0.69,
                    1.2529,
                    1.2529,
                    1.2529,
                    28.77,
                    -0.34,
                    -22.38,
                    -0.06,
                    -0.66,
                    -0.05,
                    0.75,
                    1.2306,
                    1.2306,
                    1.2306,
                    28.32,
                    -0.27,
                    -21.85,
                    -0.06,
                    -0.69,
                    0.08,
                    0.72,
                    1.2368,
                    1.2368,
                    1.2368,
                    28.55,
                    -0.27,
                    -22.29,
                    0.13,
                    -0.75,
                    0.03,
                    0.65,
                    1.2849,
                    1.2849,
                    1.2849,
                    28.82,
                    -0.27,
                    -20.66,
                    0.03,
                    -0.65,
                    -0.03,
                    0.76,
                    1.4694,
                    1.4694,
                    1.4694,
                    28.89,
                    -0.27,
                    -20.69,
                    -0.09,
                    -0.72,
                    0.12,
                    0.68,
                    1.3417,
                    1.3417,
                    1.3417,
                    28.86,
                    -0.27,
                    -20.72,
                    -0,
                    -0.65,
                    -0.02,
                    0.76,
                    1.4735,
                    1.4735,
                    1.4735,
                    28.58,
                    -0.27,
                    -21.93,
                    0.09,
                    -0.63,
                    -0.05,
                    0.77,
                    1.1614,
                    1.1614,
                    1.1614,
                    28.38,
                    -0.27,
                    -21.65,
                    -0.07,
                    -0.72,
                    -0.04,
                    0.69,
                    1.4254,
                    1.4254,
                    1.4254,
                    29.27,
                    -0.27,
                    -21.74,
                    0.01,
                    -0.65,
                    0.03,
                    0.76,
                    1.4521,
                    1.4521,
                    1.4521,
                    29.25,
                    -0.27,
                    -21.64,
                    0.03,
                    -0.68,
                    0.07,
                    0.73,
                    1.2673,
                    1.2673,
                    1.2673,
                    28.88,
                    -0.27,
                    -21.19,
                    0.09,
                    -0.76,
                    -0.02,
                    0.65,
                    1.4583,
                    1.4583,
                    1.4583,
                    28.83,
                    -0.27,
                    -21.14,
                    0.02,
                    -0.73,
                    0.08,
                    0.67,
                    1.3936,
                    1.3936,
                    1.3936
                ];
                for(let i = 0; i < clover_b_pqs.length / 10; ++i){
                    clover_b_pqs[i * 10 + 0] -= $5fbffa87c50562b9$var$a.b_patch.position.x;
                    clover_b_pqs[i * 10 + 1] -= $5fbffa87c50562b9$var$a.b_patch.position.y;
                    clover_b_pqs[i * 10 + 2] -= $5fbffa87c50562b9$var$a.b_patch.position.z;
                    clover_b_pqs[i * 10 + 7] = 1.187;
                    clover_b_pqs[i * 10 + 8] = 1.187;
                    clover_b_pqs[i * 10 + 9] = 1.187;
                }
                const clover_b_instanced_meshes = create_instanced_meshes({
                    names: [
                        "clover_b"
                    ],
                    pqs: clover_b_pqs,
                    add_to_scene: false,
                    sway: true
                });
                clover_b_instanced_meshes.forEach((instanced_mesh)=>$5fbffa87c50562b9$var$a.b_patch.add(instanced_mesh));
                const daisy_b_pqs = [
                    28.86,
                    -0.36,
                    -21.06,
                    0.07,
                    -0.65,
                    0.02,
                    0.75,
                    1.3858,
                    1.3858,
                    1.3858,
                    29.17,
                    -0.36,
                    -21.18,
                    0.21,
                    -0.72,
                    -0.03,
                    0.66,
                    1.0958,
                    1.0958,
                    1.0958,
                    28.26,
                    -0.36,
                    -21.71,
                    -0.02,
                    -0.7,
                    0.07,
                    0.71,
                    1.4932,
                    1.4932,
                    1.4932,
                    28.22,
                    -0.36,
                    -22.01,
                    -0.11,
                    0.94,
                    0.18,
                    0.28,
                    1.1924,
                    1.1924,
                    1.1924,
                    28.87,
                    -0.3,
                    -22.18,
                    0.06,
                    -0.64,
                    0.07,
                    0.77,
                    1.4539,
                    1.4539,
                    1.4539,
                    28.38,
                    -0.41,
                    -22.38,
                    0.10,
                    -0.54,
                    -0.06,
                    0.83,
                    1.5151,
                    1.5151,
                    1.5151,
                    28.44,
                    -0.36,
                    -22.11,
                    -0.09,
                    -0.75,
                    -0.14,
                    0.64,
                    1.2198,
                    1.2198,
                    1.2198,
                    28.41,
                    -0.36,
                    -22.05,
                    -0.11,
                    -0.65,
                    0.02,
                    0.76,
                    1.2303,
                    1.2303,
                    1.2303,
                    28.33,
                    -0.36,
                    -21.95,
                    0.08,
                    -0.73,
                    0.01,
                    0.68,
                    1.2430,
                    1.2430,
                    1.2430,
                    28.31,
                    -0.36,
                    -21.92,
                    0.07,
                    -0.59,
                    -0.15,
                    0.79,
                    1.4228,
                    1.4228,
                    1.4228,
                    28.44,
                    -0.41,
                    -22.37,
                    -0.15,
                    0.35,
                    -0.05,
                    0.92,
                    1.5150,
                    1.5150,
                    1.5150,
                    29.09,
                    -0.36,
                    -21.9,
                    0.06,
                    -0.7,
                    -0.21,
                    0.67,
                    1.1109,
                    1.1109,
                    1.1109,
                    28.81,
                    -0.36,
                    -22.08,
                    0.08,
                    -0.7,
                    -0.06,
                    0.71,
                    1.3363,
                    1.3363,
                    1.3363,
                    28.52,
                    -0.36,
                    -20.86,
                    0.06,
                    -0.78,
                    -0.05,
                    0.62,
                    1.3883,
                    1.3883,
                    1.3883,
                    29.28,
                    -0.36,
                    -21.53,
                    -0.05,
                    -0.8,
                    -0.14,
                    0.59,
                    1.4050,
                    1.4050,
                    1.4050,
                    28.45,
                    -0.36,
                    -20.92,
                    -0.15,
                    -0.65,
                    -0.05,
                    0.74,
                    1.0619,
                    1.0619,
                    1.0619,
                    29.20,
                    -0.36,
                    -21.46,
                    -0.01,
                    -0.74,
                    0.09,
                    0.67,
                    1.3751,
                    1.3751,
                    1.3751,
                    28.10,
                    -0.36,
                    -22.03,
                    -0.13,
                    0.92,
                    0.23,
                    0.30,
                    1.4667,
                    1.4667,
                    1.4667,
                    28.16,
                    -0.36,
                    -21.96,
                    -0.15,
                    0.96,
                    0.07,
                    0.21,
                    1.1613,
                    1.1613,
                    1.1613,
                    28.67,
                    -0.36,
                    -22.24,
                    -0.06,
                    -0.64,
                    0.00,
                    0.76,
                    1.2583,
                    1.2583,
                    1.2583,
                    28.61,
                    -0.36,
                    -22.23,
                    0.08,
                    -0.74,
                    0.05,
                    0.67,
                    1.3174,
                    1.3174,
                    1.3174,
                    28.45,
                    -0.36,
                    -21.11,
                    0.06,
                    -0.66,
                    -0.18,
                    0.73,
                    1.3697,
                    1.3697,
                    1.3697,
                    28.32,
                    -0.36,
                    -21.76,
                    0.05,
                    -0.77,
                    -0.1,
                    0.63,
                    1.2593,
                    1.2593,
                    1.2593,
                    28.81,
                    -0.34,
                    -22.33,
                    0.18,
                    -0.72,
                    0.00,
                    0.67,
                    1.5423,
                    1.5423,
                    1.5423,
                    28.36,
                    -0.36,
                    -21.92,
                    -0.03,
                    -0.59,
                    0.08,
                    0.80,
                    1.2324,
                    1.2324,
                    1.2324,
                    28.53,
                    -0.36,
                    -22.37,
                    -0.08,
                    -0.59,
                    -0.05,
                    0.80,
                    1.2339,
                    1.2339,
                    1.2339,
                    28.34,
                    -0.36,
                    -21.3,
                    0.05,
                    -0.67,
                    0.13,
                    0.73,
                    1.0754,
                    1.0754,
                    1.0754,
                    28.91,
                    -0.36,
                    -21.19,
                    0.17,
                    -0.62,
                    -0.13,
                    0.76,
                    1.1398,
                    1.1398,
                    1.1398,
                    28.29,
                    -0.36,
                    -21.41,
                    -0.01,
                    -0.77,
                    -0.09,
                    0.63,
                    1.3406,
                    1.3406,
                    1.3406,
                    28.98,
                    -0.36,
                    -21.94,
                    -0.12,
                    -0.63,
                    -0.05,
                    0.77,
                    1.3086,
                    1.3086,
                    1.3086,
                    28.35,
                    -0.36,
                    -21.44,
                    0.02,
                    -0.71,
                    0.11,
                    0.70,
                    1.5216,
                    1.5216,
                    1.5216,
                    29.06,
                    -0.36,
                    -21.98,
                    0.12,
                    -0.71,
                    -0.14,
                    0.68,
                    1.1115,
                    1.1115,
                    1.1115
                ];
                for(let i = 0; i < daisy_b_pqs.length / 10; ++i){
                    daisy_b_pqs[i * 10 + 0] -= $5fbffa87c50562b9$var$a.b_patch.position.x;
                    daisy_b_pqs[i * 10 + 1] -= $5fbffa87c50562b9$var$a.b_patch.position.y;
                    daisy_b_pqs[i * 10 + 2] -= $5fbffa87c50562b9$var$a.b_patch.position.z;
                    daisy_b_pqs[i * 10 + 7] = 2;
                    daisy_b_pqs[i * 10 + 8] = 2;
                    daisy_b_pqs[i * 10 + 9] = 2;
                }
                const daisy_b_instanced_meshes = create_instanced_meshes({
                    names: [
                        "daisy_b"
                    ],
                    pqs: daisy_b_pqs,
                    add_to_scene: false,
                    sway: true
                });
                daisy_b_instanced_meshes.forEach((instanced_mesh)=>$5fbffa87c50562b9$var$a.b_patch.add(instanced_mesh));
                const leaf_b_pqs = [
                    28.67,
                    -0.28,
                    -20.89,
                    0.50,
                    -0.01,
                    -0.75,
                    0.43,
                    1.8152,
                    1.8152,
                    1.8152,
                    28.99,
                    -0.28,
                    -21.75,
                    0.87,
                    0.22,
                    -0.4,
                    0.21,
                    1.4353,
                    1.4353,
                    1.4353,
                    28.48,
                    -0.28,
                    -21.24,
                    0.38,
                    -0.54,
                    -0.27,
                    0.70,
                    1.9559,
                    1.9559,
                    1.9559,
                    29.10,
                    -0.28,
                    -21.9,
                    0.81,
                    -0.07,
                    -0.58,
                    0.03,
                    1.5618,
                    1.5618,
                    1.5618,
                    28.66,
                    -0.28,
                    -20.95,
                    0.28,
                    -0.36,
                    0.11,
                    0.88,
                    1.9043,
                    1.9043,
                    1.9043,
                    28.36,
                    -0.28,
                    -21.6,
                    0.06,
                    0.22,
                    -0.97,
                    0.12,
                    1.9845,
                    1.9845,
                    1.9845,
                    28.18,
                    -0.28,
                    -21.29,
                    -0.71,
                    0.49,
                    0.40,
                    0.32,
                    1.5977,
                    1.5977,
                    1.5977,
                    29.09,
                    -0.28,
                    -21.71,
                    0.27,
                    -0.56,
                    -0.7,
                    0.35,
                    1.6115,
                    1.6115,
                    1.6115,
                    29.11,
                    -0.28,
                    -21.37,
                    -0.65,
                    -0.43,
                    0.62,
                    0.05,
                    1.6281,
                    1.6281,
                    1.6281,
                    28.73,
                    -0.28,
                    -21.3,
                    -0.18,
                    -0.11,
                    0.83,
                    0.53,
                    1.8637,
                    1.8637,
                    1.8637,
                    29.11,
                    -0.28,
                    -21.78,
                    0.18,
                    -0.37,
                    -0.91,
                    0.09,
                    1.9844,
                    1.9844,
                    1.9844,
                    28.78,
                    -0.28,
                    -20.95,
                    -0.58,
                    0.17,
                    0.73,
                    0.32,
                    1.4551,
                    1.4551,
                    1.4551,
                    28.94,
                    -0.28,
                    -21.5,
                    0.41,
                    -0.58,
                    -0.35,
                    0.61,
                    1.7503,
                    1.7503,
                    1.7503,
                    28.41,
                    -0.28,
                    -21.33,
                    -0.89,
                    -0.29,
                    0.33,
                    0.09,
                    1.8184,
                    1.8184,
                    1.8184,
                    28.91,
                    -0.28,
                    -21.3,
                    -0.85,
                    0.36,
                    0.19,
                    0.33,
                    1.8403,
                    1.8403,
                    1.8403,
                    28.75,
                    -0.28,
                    -21.26,
                    0.29,
                    -0.68,
                    -0.68,
                    0.05,
                    1.3909,
                    1.3909,
                    1.3909,
                    28.26,
                    -0.28,
                    -21.36,
                    0.33,
                    -0.69,
                    0.03,
                    0.64,
                    1.8011,
                    1.8011,
                    1.8011,
                    28.72,
                    -0.28,
                    -21.45,
                    -0.8,
                    0.23,
                    0.55,
                    0.14,
                    1.9211,
                    1.9211,
                    1.9211,
                    28.92,
                    -0.28,
                    -21.22,
                    0.55,
                    0.44,
                    -0.7,
                    0.08,
                    1.5212,
                    1.5212,
                    1.5212,
                    28.15,
                    -0.28,
                    -21.5,
                    0.32,
                    -0.43,
                    -0.78,
                    0.34,
                    1.6481,
                    1.6481,
                    1.6481,
                    28.62,
                    -0.28,
                    -21.39,
                    0.79,
                    -0.1,
                    -0.4,
                    0.45,
                    1.7255,
                    1.7255,
                    1.7255,
                    28.54,
                    -0.28,
                    -21.5,
                    0.75,
                    -0.47,
                    -0.46,
                    0.02,
                    1.6495,
                    1.6495,
                    1.6495,
                    28.82,
                    -0.28,
                    -21.31,
                    0.67,
                    0.53,
                    -0.51,
                    0.14,
                    2.0202,
                    2.0202,
                    2.0202,
                    28.25,
                    -0.28,
                    -21.61,
                    -0.03,
                    -0.26,
                    -0.19,
                    0.95,
                    1.6143,
                    1.6143,
                    1.6143,
                    28.64,
                    -0.28,
                    -20.94,
                    0.37,
                    -0.33,
                    0.12,
                    0.86,
                    1.5655,
                    1.5655,
                    1.5655,
                    28.40,
                    -0.28,
                    -21.67,
                    0.09,
                    -0.43,
                    -0.89,
                    0.16,
                    1.6161,
                    1.6161,
                    1.6161,
                    28.37,
                    -0.28,
                    -21.79,
                    -0.15,
                    -0.51,
                    0.66,
                    0.54,
                    1.4929,
                    1.4929,
                    1.4929,
                    28.91,
                    -0.28,
                    -21.25,
                    -0.9,
                    -0.03,
                    0.35,
                    0.25,
                    1.7559,
                    1.7559,
                    1.7559,
                    29.22,
                    -0.28,
                    -21.29,
                    0.09,
                    -0.6,
                    -0.75,
                    0.26,
                    1.7141,
                    1.7141,
                    1.7141,
                    28.20,
                    -0.28,
                    -21.61,
                    0.50,
                    -0.41,
                    -0.19,
                    0.74,
                    1.9930,
                    1.9930,
                    1.9930,
                    29.11,
                    -0.28,
                    -21.73,
                    -0.62,
                    -0.42,
                    0.49,
                    0.45,
                    1.4559,
                    1.4559,
                    1.4559,
                    28.89,
                    -0.28,
                    -21.69,
                    0.29,
                    -0.29,
                    -0.46,
                    0.79,
                    1.5769,
                    1.5769,
                    1.5769,
                    28.99,
                    -0.28,
                    -21.8,
                    -0.9,
                    0.21,
                    0.15,
                    0.35,
                    1.5896,
                    1.5896,
                    1.5896,
                    28.26,
                    -0.28,
                    -21.8,
                    0.05,
                    -0.97,
                    -0.07,
                    0.24,
                    1.8847,
                    1.8847,
                    1.8847,
                    29.27,
                    -0.28,
                    -21.23,
                    -0.24,
                    -0.39,
                    -0.24,
                    0.85,
                    1.5853,
                    1.5853,
                    1.5853,
                    28.60,
                    -0.28,
                    -21.39,
                    0.53,
                    -0.62,
                    0.13,
                    0.56,
                    1.6390,
                    1.6390,
                    1.6390,
                    28.46,
                    -0.28,
                    -21.13,
                    0.16,
                    -0.39,
                    -0.66,
                    0.63,
                    1.6674,
                    1.6674,
                    1.6674,
                    29.30,
                    -0.28,
                    -21.41,
                    -0.33,
                    -0.26,
                    0.56,
                    0.71,
                    1.8547,
                    1.8547,
                    1.8547,
                    29.20,
                    -0.28,
                    -21.94,
                    -0.63,
                    0.59,
                    0.50,
                    0.09,
                    1.7698,
                    1.7698,
                    1.7698,
                    28.72,
                    -0.28,
                    -21.26,
                    0.50,
                    -0.47,
                    -0.61,
                    0.39,
                    1.8909,
                    1.8909,
                    1.8909,
                    28.99,
                    -0.28,
                    -21.63,
                    0.46,
                    -0.42,
                    -0.51,
                    0.59,
                    2.0441,
                    2.0441,
                    2.0441,
                    28.19,
                    -0.28,
                    -21.74,
                    0.44,
                    -0.27,
                    -0.09,
                    0.85,
                    1.6227,
                    1.6227,
                    1.6227,
                    28.43,
                    -0.28,
                    -21.01,
                    -0.14,
                    -0.2,
                    -0.5,
                    0.83,
                    1.9742,
                    1.9742,
                    1.9742,
                    28.61,
                    -0.28,
                    -21.33,
                    0.82,
                    0.12,
                    -0.22,
                    0.52,
                    1.4354,
                    1.4354,
                    1.4354,
                    28.56,
                    -0.28,
                    -21.3,
                    0.31,
                    -0.6,
                    -0.69,
                    0.25,
                    1.4631,
                    1.4631,
                    1.4631,
                    28.99,
                    -0.28,
                    -21.17,
                    0.33,
                    -0.34,
                    -0.28,
                    0.83,
                    1.6904,
                    1.6904,
                    1.6904,
                    28.65,
                    -0.28,
                    -20.96,
                    0.08,
                    -0.23,
                    0.23,
                    0.94,
                    1.4777,
                    1.4777,
                    1.4777,
                    28.49,
                    -0.28,
                    -21.53,
                    0.56,
                    -0.24,
                    -0.23,
                    0.76,
                    1.8958,
                    1.8958,
                    1.8958,
                    28.26,
                    -0.28,
                    -21.56,
                    0.00,
                    -0.61,
                    -0.53,
                    0.59,
                    1.4765,
                    1.4765,
                    1.4765,
                    29.01,
                    -0.28,
                    -21.73,
                    0.56,
                    -0.46,
                    -0.19,
                    0.66,
                    1.8802,
                    1.8802,
                    1.8802,
                    28.74,
                    -0.28,
                    -21.41,
                    0.25,
                    -0.55,
                    -0.48,
                    0.64,
                    2.0518,
                    2.0518,
                    2.0518,
                    29.24,
                    -0.28,
                    -21.65,
                    0.23,
                    -0.26,
                    -0.66,
                    0.66,
                    1.9571,
                    1.9571,
                    1.9571,
                    28.22,
                    -0.28,
                    -21.39,
                    -0.29,
                    0.36,
                    0.84,
                    0.26,
                    1.9008,
                    1.9008,
                    1.9008,
                    28.21,
                    -0.28,
                    -21.88,
                    -0.65,
                    0.16,
                    0.68,
                    0.30,
                    2.0112,
                    2.0112,
                    2.0112,
                    28.95,
                    -0.28,
                    -21.29,
                    -0.58,
                    -0.41,
                    0.66,
                    0.27,
                    1.3946,
                    1.3946,
                    1.3946,
                    29.14,
                    -0.28,
                    -21.7,
                    0.95,
                    0.10,
                    -0.31,
                    0.00,
                    1.7814,
                    1.7814,
                    1.7814,
                    28.65,
                    -0.28,
                    -21.87,
                    -0.04,
                    -0.42,
                    -0.84,
                    0.34,
                    1.7681,
                    1.7681,
                    1.7681,
                    28.79,
                    -0.28,
                    -21.08,
                    0.39,
                    0.06,
                    -0.74,
                    0.55,
                    1.6490,
                    1.6490,
                    1.6490,
                    28.31,
                    -0.28,
                    -21.98,
                    0.45,
                    -0.26,
                    -0.47,
                    0.71,
                    1.7986,
                    1.7986,
                    1.7986,
                    28.82,
                    -0.35,
                    -22.34,
                    0.24,
                    -0.88,
                    -0.33,
                    0.25,
                    2.0083,
                    2.0083,
                    2.0083,
                    28.86,
                    -0.28,
                    -21.17,
                    0.12,
                    -0.64,
                    -0.71,
                    0.25,
                    1.9038,
                    1.9038,
                    1.9038,
                    28.44,
                    -0.28,
                    -21.98,
                    0.04,
                    -0.6,
                    0.31,
                    0.74,
                    1.6326,
                    1.6326,
                    1.6326,
                    28.73,
                    -0.28,
                    -21.85,
                    -0.19,
                    -0.33,
                    0.72,
                    0.58,
                    1.9814,
                    1.9814,
                    1.9814,
                    28.54,
                    -0.28,
                    -21.03,
                    -0.06,
                    -0.93,
                    -0.31,
                    0.20,
                    1.9987,
                    1.9987,
                    1.9987,
                    29.12,
                    -0.28,
                    -21.44,
                    -0.2,
                    -0.49,
                    -0.2,
                    0.82,
                    1.9653,
                    1.9653,
                    1.9653,
                    28.95,
                    -0.28,
                    -21.54,
                    0.70,
                    -0.33,
                    -0.27,
                    0.57,
                    1.7855,
                    1.7855,
                    1.7855,
                    28.79,
                    -0.28,
                    -20.87,
                    0.87,
                    0.04,
                    -0.48,
                    0.04,
                    2.0149,
                    2.0149,
                    2.0149,
                    29.16,
                    -0.28,
                    -21.87,
                    -0.21,
                    -0.5,
                    -0.63,
                    0.55,
                    1.6463,
                    1.6463,
                    1.6463,
                    28.28,
                    -0.28,
                    -21.95,
                    0.46,
                    -0.27,
                    -0.26,
                    0.81,
                    1.7397,
                    1.7397,
                    1.7397,
                    29.19,
                    -0.28,
                    -21.99,
                    0.62,
                    -0.48,
                    -0.42,
                    0.46,
                    1.4905,
                    1.4905,
                    1.4905,
                    29.00,
                    -0.28,
                    -21.31,
                    0.86,
                    0.19,
                    -0.47,
                    0.02,
                    1.4961,
                    1.4961,
                    1.4961,
                    29.14,
                    -0.28,
                    -21.54,
                    -0.11,
                    -0.89,
                    -0.4,
                    0.20,
                    1.7972,
                    1.7972,
                    1.7972,
                    28.55,
                    -0.28,
                    -21.39,
                    0.42,
                    0.31,
                    -0.72,
                    0.45,
                    1.5145,
                    1.5145,
                    1.5145,
                    28.57,
                    -0.28,
                    -21.32,
                    0.42,
                    -0.64,
                    -0.63,
                    0.11,
                    1.9445,
                    1.9445,
                    1.9445,
                    28.63,
                    -0.28,
                    -21.92,
                    0.64,
                    -0.08,
                    -0.76,
                    0.09,
                    1.8822,
                    1.8822,
                    1.8822,
                    28.46,
                    -0.28,
                    -21.36,
                    0.78,
                    -0.46,
                    -0.33,
                    0.27,
                    1.6902,
                    1.6902,
                    1.6902,
                    29.15,
                    -0.28,
                    -21.08,
                    0.55,
                    0.12,
                    -0.29,
                    0.78,
                    2.0137,
                    2.0137,
                    2.0137,
                    28.43,
                    -0.28,
                    -20.94,
                    0.70,
                    -0.3,
                    -0.54,
                    0.36,
                    1.4028,
                    1.4028,
                    1.4028,
                    28.57,
                    -0.28,
                    -22.14,
                    0.88,
                    -0.25,
                    -0.39,
                    0.15,
                    1.9859,
                    1.9859,
                    1.9859,
                    29.07,
                    -0.28,
                    -21.91,
                    -0.75,
                    0.31,
                    0.33,
                    0.48,
                    1.5236,
                    1.5236,
                    1.5236,
                    28.93,
                    -0.28,
                    -21.32,
                    0.69,
                    -0.66,
                    -0.28,
                    0.11,
                    1.4284,
                    1.4284,
                    1.4284,
                    29.14,
                    -0.28,
                    -21.14,
                    0.29,
                    -0.24,
                    -0.23,
                    0.90,
                    1.9782,
                    1.9782,
                    1.9782,
                    28.56,
                    -0.28,
                    -21.94,
                    0.02,
                    -0.35,
                    0.13,
                    0.93,
                    1.9503,
                    1.9503,
                    1.9503,
                    28.58,
                    -0.28,
                    -21.15,
                    0.46,
                    0.30,
                    -0.8,
                    0.22,
                    1.4661,
                    1.4661,
                    1.4661,
                    29.34,
                    -0.28,
                    -21.67,
                    -0.46,
                    -0.74,
                    -0.02,
                    0.50,
                    1.4105,
                    1.4105,
                    1.4105,
                    28.91,
                    -0.28,
                    -21.92,
                    0.39,
                    -0.84,
                    -0.15,
                    0.36,
                    1.8112,
                    1.8112,
                    1.8112,
                    28.34,
                    -0.28,
                    -21.3,
                    0.21,
                    -0.61,
                    -0.72,
                    0.25,
                    1.7738,
                    1.7738,
                    1.7738,
                    29.26,
                    -0.28,
                    -21.3,
                    0.60,
                    -0.29,
                    -0.47,
                    0.57,
                    1.9460,
                    1.9460,
                    1.9460,
                    28.64,
                    -0.28,
                    -20.91,
                    -0.09,
                    -0.32,
                    0.88,
                    0.34,
                    2.0290,
                    2.0290,
                    2.0290,
                    28.43,
                    -0.28,
                    -21.92,
                    -0.09,
                    -0.97,
                    -0.2,
                    0.11,
                    1.7475,
                    1.7475,
                    1.7475,
                    29.17,
                    -0.28,
                    -21.43,
                    0.55,
                    -0.76,
                    -0.34,
                    0.08,
                    1.6645,
                    1.6645,
                    1.6645,
                    28.22,
                    -0.28,
                    -21.73,
                    -0.8,
                    0.07,
                    0.54,
                    0.24,
                    1.4642,
                    1.4642,
                    1.4642,
                    28.41,
                    -0.28,
                    -21.3,
                    0.54,
                    -0.66,
                    -0.07,
                    0.51,
                    1.6425,
                    1.6425,
                    1.6425,
                    28.32,
                    -0.28,
                    -21.59,
                    0.83,
                    0.20,
                    -0.48,
                    0.18,
                    1.5254,
                    1.5254,
                    1.5254,
                    28.98,
                    -0.28,
                    -21.98,
                    0.43,
                    -0.34,
                    -0.82,
                    0.18,
                    1.4397,
                    1.4397,
                    1.4397,
                    29.15,
                    -0.28,
                    -21,
                    0.26,
                    -0.47,
                    0.12,
                    0.84,
                    1.9772,
                    1.9772,
                    1.9772,
                    29.36,
                    -0.28,
                    -21.39,
                    0.49,
                    -0.02,
                    -0.54,
                    0.69,
                    1.6249,
                    1.6249,
                    1.6249,
                    28.36,
                    -0.28,
                    -21.04,
                    0.04,
                    -0.59,
                    -0.65,
                    0.48,
                    2.0411,
                    2.0411,
                    2.0411,
                    28.37,
                    -0.28,
                    -21.28,
                    0.53,
                    -0.48,
                    -0.08,
                    0.70,
                    1.8358,
                    1.8358,
                    1.8358,
                    28.29,
                    -0.28,
                    -21.76,
                    -0.6,
                    -0.05,
                    0.78,
                    0.17,
                    1.5893,
                    1.5893,
                    1.5893,
                    28.92,
                    -0.28,
                    -22.16,
                    0.91,
                    -0.39,
                    -0.01,
                    0.13,
                    1.4160,
                    1.4160,
                    1.4160,
                    28.20,
                    -0.28,
                    -21.57,
                    0.34,
                    -0.4,
                    0.47,
                    0.71,
                    1.9517,
                    1.9517,
                    1.9517,
                    28.98,
                    -0.28,
                    -21.22,
                    -0.85,
                    -0.39,
                    0.25,
                    0.26,
                    1.6836,
                    1.6836,
                    1.6836,
                    28.99,
                    -0.28,
                    -21.79,
                    0.53,
                    -0.14,
                    -0.45,
                    0.70,
                    1.4030,
                    1.4030,
                    1.4030,
                    29.09,
                    -0.28,
                    -22.09,
                    0.70,
                    -0.32,
                    -0.31,
                    0.56,
                    1.4391,
                    1.4391,
                    1.4391,
                    28.75,
                    -0.28,
                    -20.87,
                    -0.05,
                    -0.43,
                    -0.2,
                    0.88,
                    2.0151,
                    2.0151,
                    2.0151,
                    29.12,
                    -0.28,
                    -21.43,
                    0.15,
                    -0.66,
                    -0.68,
                    0.27,
                    2.0220,
                    2.0220,
                    2.0220,
                    29.11,
                    -0.28,
                    -21.85,
                    0.46,
                    0.15,
                    -0.85,
                    0.20,
                    1.4564,
                    1.4564,
                    1.4564,
                    29.29,
                    -0.28,
                    -21.72,
                    -0.02,
                    -0.79,
                    -0.45,
                    0.43,
                    1.8294,
                    1.8294,
                    1.8294,
                    28.51,
                    -0.28,
                    -22.06,
                    0.85,
                    -0.24,
                    -0.41,
                    0.23,
                    1.9511,
                    1.9511,
                    1.9511,
                    28.46,
                    -0.28,
                    -21.78,
                    -0.05,
                    -0.92,
                    -0.28,
                    0.27,
                    1.9850,
                    1.9850,
                    1.9850,
                    28.88,
                    -0.28,
                    -21.66,
                    0.31,
                    -0.51,
                    -0.69,
                    0.41,
                    1.9027,
                    1.9027,
                    1.9027,
                    29.10,
                    -0.28,
                    -21.91,
                    0.60,
                    0.13,
                    -0.75,
                    0.23,
                    1.8251,
                    1.8251,
                    1.8251,
                    29.13,
                    -0.28,
                    -21.88,
                    0.48,
                    -0.38,
                    0.03,
                    0.79,
                    1.7683,
                    1.7683,
                    1.7683,
                    28.41,
                    -0.28,
                    -21.36,
                    -0.84,
                    0.44,
                    0.31,
                    0.01,
                    1.6044,
                    1.6044,
                    1.6044,
                    28.39,
                    -0.28,
                    -21.52,
                    0.83,
                    0.05,
                    -0.39,
                    0.40,
                    1.4175,
                    1.4175,
                    1.4175,
                    28.92,
                    -0.28,
                    -21.41,
                    -0.59,
                    -0.38,
                    0.12,
                    0.71,
                    1.7772,
                    1.7772,
                    1.7772,
                    28.56,
                    -0.28,
                    -21.19,
                    -0.81,
                    -0.48,
                    0.30,
                    0.14,
                    2.0157,
                    2.0157,
                    2.0157,
                    29.36,
                    -0.28,
                    -21.77,
                    0.74,
                    0.45,
                    -0.42,
                    0.28,
                    1.5630,
                    1.5630,
                    1.5630,
                    28.69,
                    -0.28,
                    -21.4,
                    0.16,
                    -0.25,
                    -0.81,
                    0.51,
                    1.7739,
                    1.7739,
                    1.7739,
                    28.46,
                    -0.28,
                    -21.23,
                    0.21,
                    -0.77,
                    -0.5,
                    0.32,
                    2.0047,
                    2.0047,
                    2.0047,
                    28.82,
                    -0.28,
                    -21.19,
                    0.89,
                    0.25,
                    -0.38,
                    0.04,
                    1.9687,
                    1.9687,
                    1.9687,
                    28.78,
                    -0.28,
                    -21.1,
                    0.54,
                    0.07,
                    -0.73,
                    0.42,
                    1.5943,
                    1.5943,
                    1.5943,
                    28.95,
                    -0.28,
                    -21.91,
                    -0.87,
                    -0.09,
                    0.49,
                    0.02,
                    2.0204,
                    2.0204,
                    2.0204,
                    28.39,
                    -0.28,
                    -21.52,
                    0.71,
                    0.13,
                    -0.65,
                    0.25,
                    1.6823,
                    1.6823,
                    1.6823,
                    28.75,
                    -0.28,
                    -21.31,
                    -0.49,
                    0.32,
                    0.79,
                    0.17,
                    1.5120,
                    1.5120,
                    1.5120,
                    28.41,
                    -0.28,
                    -21.33,
                    0.34,
                    -0.28,
                    -0.69,
                    0.57,
                    1.8097,
                    1.8097,
                    1.8097,
                    29.08,
                    -0.28,
                    -21.4,
                    -0.87,
                    -0.36,
                    0.19,
                    0.27,
                    1.8506,
                    1.8506,
                    1.8506,
                    28.11,
                    -0.28,
                    -21.44,
                    0.34,
                    0.30,
                    -0.72,
                    0.53,
                    1.6829,
                    1.6829,
                    1.6829,
                    28.86,
                    -0.28,
                    -21.45,
                    -0.74,
                    0.34,
                    0.51,
                    0.27,
                    1.5364,
                    1.5364,
                    1.5364,
                    29.12,
                    -0.28,
                    -21.27,
                    0.06,
                    -0.89,
                    0.13,
                    0.44,
                    1.7591,
                    1.7591,
                    1.7591,
                    28.45,
                    -0.28,
                    -21.8,
                    0.54,
                    -0.68,
                    -0.49,
                    0.04,
                    1.9238,
                    1.9238,
                    1.9238,
                    28.28,
                    -0.28,
                    -21.66,
                    -0.38,
                    -0.81,
                    0.41,
                    0.17,
                    1.8558,
                    1.8558,
                    1.8558,
                    28.56,
                    -0.28,
                    -21.96,
                    0.26,
                    -0.39,
                    -0.53,
                    0.70,
                    1.6354,
                    1.6354,
                    1.6354,
                    28.72,
                    -0.28,
                    -21.51,
                    0.63,
                    -0.27,
                    -0.29,
                    0.67,
                    1.4473,
                    1.4473,
                    1.4473,
                    28.81,
                    -0.28,
                    -21.17,
                    -0.39,
                    -0.41,
                    0.15,
                    0.81,
                    1.4845,
                    1.4845,
                    1.4845,
                    28.93,
                    -0.28,
                    -21.89,
                    0.75,
                    -0.54,
                    -0.14,
                    0.36,
                    1.4748,
                    1.4748,
                    1.4748,
                    28.54,
                    -0.28,
                    -21.27,
                    -0.33,
                    0.34,
                    0.80,
                    0.37,
                    1.9358,
                    1.9358,
                    1.9358,
                    28.30,
                    -0.28,
                    -21.59,
                    -0.68,
                    -0.17,
                    0.59,
                    0.39,
                    1.9861,
                    1.9861,
                    1.9861,
                    29.15,
                    -0.28,
                    -21.3,
                    0.62,
                    -0.54,
                    -0.39,
                    0.42,
                    1.6268,
                    1.6268,
                    1.6268,
                    28.60,
                    -0.28,
                    -21.08,
                    0.30,
                    0.12,
                    -0.88,
                    0.34,
                    1.5588,
                    1.5588,
                    1.5588,
                    28.47,
                    -0.28,
                    -21.9,
                    -0.15,
                    -0.53,
                    0.83,
                    0.10,
                    1.6809,
                    1.6809,
                    1.6809,
                    28.48,
                    -0.28,
                    -21.91,
                    0.18,
                    -0.45,
                    -0.86,
                    0.19,
                    1.5492,
                    1.5492,
                    1.5492,
                    29.26,
                    -0.28,
                    -21.55,
                    -0.81,
                    0.28,
                    0.49,
                    0.14,
                    1.6394,
                    1.6394,
                    1.6394,
                    29.27,
                    -0.28,
                    -21.85,
                    0.76,
                    -0.07,
                    -0.45,
                    0.46,
                    1.9909,
                    1.9909,
                    1.9909,
                    29.37,
                    -0.28,
                    -21.34,
                    0.54,
                    -0.49,
                    -0.4,
                    0.55,
                    1.4381,
                    1.4381,
                    1.4381,
                    28.62,
                    -0.28,
                    -21.5,
                    0.16,
                    -0.8,
                    -0.21,
                    0.54,
                    1.6943,
                    1.6943,
                    1.6943,
                    28.49,
                    -0.28,
                    -21.1,
                    0.14,
                    0.11,
                    -0.76,
                    0.62,
                    1.4275,
                    1.4275,
                    1.4275,
                    28.86,
                    -0.28,
                    -21.13,
                    -0.15,
                    0.71,
                    0.69,
                    0.04,
                    1.9742,
                    1.9742,
                    1.9742,
                    28.15,
                    -0.28,
                    -21.31,
                    0.63,
                    -0.18,
                    -0.68,
                    0.32,
                    1.7777,
                    1.7777,
                    1.7777,
                    28.75,
                    -0.28,
                    -21.39,
                    0.90,
                    -0.11,
                    -0.42,
                    0.03,
                    1.4847,
                    1.4847,
                    1.4847,
                    29.21,
                    -0.28,
                    -21.64,
                    0.62,
                    -0.53,
                    0.29,
                    0.50,
                    1.7686,
                    1.7686,
                    1.7686,
                    28.43,
                    -0.28,
                    -21.06,
                    -0.66,
                    -0.57,
                    -0.08,
                    0.49,
                    1.8556,
                    1.8556,
                    1.8556,
                    28.91,
                    -0.28,
                    -22.02,
                    0.46,
                    -0.05,
                    -0.51,
                    0.72,
                    2.0087,
                    2.0087,
                    2.0087,
                    29.22,
                    -0.28,
                    -21.37,
                    -0.04,
                    -0.9,
                    -0.32,
                    0.30,
                    1.8004,
                    1.8004,
                    1.8004,
                    28.27,
                    -0.28,
                    -21.08,
                    0.35,
                    -0.53,
                    -0.65,
                    0.42,
                    1.6744,
                    1.6744,
                    1.6744,
                    28.86,
                    -0.28,
                    -21.93,
                    0.62,
                    -0.14,
                    -0.64,
                    0.44,
                    1.6183,
                    1.6183,
                    1.6183,
                    28.47,
                    -0.28,
                    -21.99,
                    -0.75,
                    -0.41,
                    0.48,
                    0.21,
                    1.8579,
                    1.8579,
                    1.8579,
                    28.94,
                    -0.28,
                    -21.96,
                    0.87,
                    0.31,
                    -0.38,
                    0.08,
                    1.5787,
                    1.5787,
                    1.5787,
                    28.85,
                    -0.28,
                    -21.27,
                    -0.15,
                    0.16,
                    0.92,
                    0.33,
                    1.5068,
                    1.5068,
                    1.5068,
                    28.97,
                    -0.28,
                    -21.52,
                    -0.37,
                    0.04,
                    0.60,
                    0.71,
                    1.6441,
                    1.6441,
                    1.6441,
                    29.13,
                    -0.28,
                    -21.43,
                    -0.33,
                    -0.18,
                    0.73,
                    0.57,
                    1.9148,
                    1.9148,
                    1.9148,
                    28.31,
                    -0.28,
                    -21.37,
                    -0.43,
                    0.02,
                    0.78,
                    0.45,
                    1.7439,
                    1.7439,
                    1.7439,
                    28.12,
                    -0.28,
                    -21.73,
                    -0.32,
                    -0.18,
                    0.48,
                    0.79,
                    1.7517,
                    1.7517,
                    1.7517,
                    29.07,
                    -0.28,
                    -21.12,
                    -0.33,
                    -0.07,
                    0.80,
                    0.50,
                    1.6480,
                    1.6480,
                    1.6480,
                    28.77,
                    -0.28,
                    -22.17,
                    0.13,
                    -0.41,
                    -0.78,
                    0.45,
                    2.0059,
                    2.0059,
                    2.0059,
                    28.72,
                    -0.28,
                    -21.06,
                    -0.26,
                    -0.43,
                    0.80,
                    0.33,
                    1.7184,
                    1.7184,
                    1.7184,
                    28.71,
                    -0.28,
                    -20.98,
                    0.13,
                    -0.53,
                    -0.79,
                    0.28,
                    1.4774,
                    1.4774,
                    1.4774,
                    28.60,
                    -0.28,
                    -21.5,
                    0.19,
                    -0.57,
                    0.30,
                    0.75,
                    1.6278,
                    1.6278,
                    1.6278,
                    29.16,
                    -0.28,
                    -21.61,
                    0.76,
                    -0.42,
                    -0.47,
                    0.14,
                    1.9684,
                    1.9684,
                    1.9684,
                    28.71,
                    -0.28,
                    -21.22,
                    0.72,
                    -0.34,
                    -0.24,
                    0.56,
                    1.4214,
                    1.4214,
                    1.4214,
                    28.38,
                    -0.28,
                    -22.01,
                    0.72,
                    0.07,
                    -0.57,
                    0.40,
                    1.8270,
                    1.8270,
                    1.8270,
                    28.34,
                    -0.28,
                    -21.41,
                    0.33,
                    -0.86,
                    -0.3,
                    0.25,
                    1.8523,
                    1.8523,
                    1.8523,
                    28.43,
                    -0.28,
                    -21.68,
                    0.51,
                    -0.13,
                    -0.05,
                    0.85,
                    1.6778,
                    1.6778,
                    1.6778,
                    29.20,
                    -0.28,
                    -21.44,
                    -0.39,
                    -0.47,
                    -0.22,
                    0.76,
                    1.6569,
                    1.6569,
                    1.6569,
                    28.73,
                    -0.28,
                    -21.46,
                    0.81,
                    0.07,
                    -0.47,
                    0.35,
                    1.5592,
                    1.5592,
                    1.5592,
                    29.25,
                    -0.28,
                    -21.53,
                    -0.76,
                    0.15,
                    0.54,
                    0.34,
                    1.4762,
                    1.4762,
                    1.4762,
                    28.41,
                    -0.28,
                    -21.56,
                    -0.56,
                    -0.61,
                    0.51,
                    0.23,
                    1.5808,
                    1.5808,
                    1.5808,
                    29.30,
                    -0.28,
                    -21.43,
                    0.82,
                    0.00,
                    -0.54,
                    0.18,
                    1.4191,
                    1.4191,
                    1.4191,
                    28.81,
                    -0.28,
                    -21.01,
                    0.11,
                    -0.66,
                    0.41,
                    0.62,
                    1.4256,
                    1.4256,
                    1.4256,
                    28.75,
                    -0.28,
                    -21.23,
                    -0.9,
                    0.07,
                    0.40,
                    0.17,
                    1.4521,
                    1.4521,
                    1.4521,
                    28.61,
                    -0.28,
                    -21.5,
                    0.44,
                    -0.5,
                    0.15,
                    0.73,
                    1.7198,
                    1.7198,
                    1.7198,
                    28.22,
                    -0.28,
                    -21.72,
                    0.52,
                    -0.79,
                    -0.03,
                    0.30,
                    1.9578,
                    1.9578,
                    1.9578,
                    28.70,
                    -0.28,
                    -21.88,
                    -0.7,
                    0.07,
                    0.53,
                    0.46,
                    1.8170,
                    1.8170,
                    1.8170,
                    28.33,
                    -0.28,
                    -21.13,
                    0.46,
                    -0.55,
                    0.03,
                    0.70,
                    1.4253,
                    1.4253,
                    1.4253,
                    28.36,
                    -0.28,
                    -21.15,
                    -0.01,
                    -0.4,
                    -0.56,
                    0.72,
                    1.9559,
                    1.9559,
                    1.9559,
                    29.21,
                    -0.28,
                    -21.5,
                    0.61,
                    0.38,
                    -0.68,
                    0.14,
                    1.9684,
                    1.9684,
                    1.9684,
                    29.09,
                    -0.28,
                    -22.06,
                    -0.65,
                    -0.61,
                    0.04,
                    0.45,
                    1.9586,
                    1.9586,
                    1.9586,
                    28.32,
                    -0.28,
                    -21.68,
                    0.17,
                    -0.23,
                    0.24,
                    0.93,
                    1.6377,
                    1.6377,
                    1.6377,
                    29.13,
                    -0.28,
                    -21.08,
                    0.64,
                    -0.65,
                    -0.2,
                    0.36,
                    1.4748,
                    1.4748,
                    1.4748,
                    28.73,
                    -0.28,
                    -21.83,
                    0.72,
                    0.46,
                    -0.52,
                    0.10,
                    1.9801,
                    1.9801,
                    1.9801,
                    29.11,
                    -0.28,
                    -21.12,
                    -0.79,
                    0.34,
                    0.42,
                    0.28,
                    1.7693,
                    1.7693,
                    1.7693,
                    29.33,
                    -0.28,
                    -21.64,
                    0.75,
                    0.32,
                    -0.53,
                    0.22,
                    1.8812,
                    1.8812,
                    1.8812,
                    29.23,
                    -0.28,
                    -21.1,
                    0.70,
                    -0.25,
                    -0.59,
                    0.31,
                    1.4893,
                    1.4893,
                    1.4893,
                    29.13,
                    -0.28,
                    -21.9,
                    -0.47,
                    -0.22,
                    0.71,
                    0.48,
                    1.5026,
                    1.5026,
                    1.5026,
                    29.33,
                    -0.28,
                    -21.46,
                    -0.06,
                    -0.17,
                    -0.79,
                    0.59,
                    1.6637,
                    1.6637,
                    1.6637,
                    28.47,
                    -0.28,
                    -21.32,
                    -0.73,
                    0.16,
                    0.33,
                    0.58,
                    2.0104,
                    2.0104,
                    2.0104,
                    28.76,
                    -0.28,
                    -21.15,
                    0.55,
                    -0.33,
                    -0.28,
                    0.71,
                    1.6503,
                    1.6503,
                    1.6503,
                    28.73,
                    -0.28,
                    -22.03,
                    0.78,
                    -0.48,
                    -0.38,
                    0.11,
                    2.0295,
                    2.0295,
                    2.0295,
                    29.30,
                    -0.28,
                    -21.84,
                    -0.6,
                    0.59,
                    0.54,
                    0.09,
                    1.7513,
                    1.7513,
                    1.7513,
                    28.17,
                    -0.28,
                    -21.32,
                    -0.31,
                    -0.55,
                    0.12,
                    0.77,
                    1.4432,
                    1.4432,
                    1.4432,
                    28.50,
                    -0.28,
                    -21.2,
                    0.09,
                    -0.38,
                    0.04,
                    0.92,
                    1.7243,
                    1.7243,
                    1.7243,
                    28.29,
                    -0.28,
                    -21.45,
                    0.61,
                    0.74,
                    -0.26,
                    0.09,
                    1.9796,
                    1.9796,
                    1.9796,
                    28.33,
                    -0.28,
                    -21.9,
                    0.30,
                    0.01,
                    -0.77,
                    0.56,
                    1.7376,
                    1.7376,
                    1.7376,
                    29.31,
                    -0.28,
                    -21.35,
                    0.58,
                    0.02,
                    -0.8,
                    0.15,
                    1.4676,
                    1.4676,
                    1.4676,
                    29.11,
                    -0.28,
                    -21.7,
                    0.40,
                    -0.27,
                    -0.45,
                    0.75,
                    1.8903,
                    1.8903,
                    1.8903,
                    28.84,
                    -0.28,
                    -21.01,
                    0.14,
                    -0.91,
                    -0.34,
                    0.19,
                    1.9315,
                    1.9315,
                    1.9315,
                    28.71,
                    -0.28,
                    -21.4,
                    -0.27,
                    -0.59,
                    -0.36,
                    0.67,
                    1.9722,
                    1.9722,
                    1.9722,
                    29.12,
                    -0.28,
                    -21.73,
                    0.79,
                    0.19,
                    -0.53,
                    0.23,
                    1.4052,
                    1.4052,
                    1.4051,
                    28.92,
                    -0.28,
                    -21.29,
                    0.66,
                    -0.7,
                    -0.04,
                    0.27,
                    1.6636,
                    1.6636,
                    1.6636,
                    28.48,
                    -0.28,
                    -21.34,
                    0.37,
                    0.09,
                    -0.8,
                    0.46,
                    1.5602,
                    1.5602,
                    1.5602,
                    28.15,
                    -0.28,
                    -21.8,
                    -0.43,
                    -0.51,
                    0.73,
                    0.13,
                    1.4175,
                    1.4175,
                    1.4175,
                    28.43,
                    -0.28,
                    -21.95,
                    0.03,
                    -0.6,
                    -0.41,
                    0.68,
                    1.8767,
                    1.8767,
                    1.8767,
                    28.78,
                    -0.28,
                    -21.26,
                    0.74,
                    0.35,
                    -0.56,
                    0.06,
                    2.0161,
                    2.0161,
                    2.0161,
                    29.19,
                    -0.28,
                    -21.82,
                    0.38,
                    -0.37,
                    -0.6,
                    0.61,
                    1.6580,
                    1.6580,
                    1.6580,
                    28.81,
                    -0.28,
                    -21.3,
                    -0.6,
                    -0.44,
                    0.66,
                    0.05,
                    1.6124,
                    1.6124,
                    1.6124,
                    29.18,
                    -0.28,
                    -21.5,
                    0.15,
                    -0.96,
                    0.15,
                    0.17,
                    2.0054,
                    2.0054,
                    2.0054,
                    28.60,
                    -0.28,
                    -21.17,
                    -0.64,
                    0.66,
                    0.36,
                    0.15,
                    2.0314,
                    2.0314,
                    2.0314,
                    28.35,
                    -0.28,
                    -21.38,
                    -0.38,
                    -0.78,
                    0.49,
                    0.06,
                    1.4369,
                    1.4369,
                    1.4369,
                    29.25,
                    -0.28,
                    -21.42,
                    0.11,
                    -0.47,
                    -0.38,
                    0.79,
                    1.5880,
                    1.5880,
                    1.5880,
                    29.04,
                    -0.28,
                    -22.08,
                    0.49,
                    -0.31,
                    -0.25,
                    0.78,
                    1.8148,
                    1.8148,
                    1.8148,
                    28.73,
                    -0.28,
                    -21.19,
                    0.78,
                    -0.21,
                    -0.33,
                    0.49,
                    1.9147,
                    1.9147,
                    1.9147,
                    29.35,
                    -0.28,
                    -21.67,
                    -0.63,
                    0.23,
                    0.70,
                    0.23,
                    1.8797,
                    1.8797,
                    1.8797,
                    29.02,
                    -0.28,
                    -22,
                    -0.59,
                    -0.44,
                    0.60,
                    0.30,
                    1.8954,
                    1.8954,
                    1.8954,
                    28.47,
                    -0.28,
                    -22.01,
                    0.93,
                    -0.26,
                    -0.24,
                    0.13,
                    1.4845,
                    1.4845,
                    1.4845,
                    28.21,
                    -0.28,
                    -21.9,
                    0.08,
                    -0.56,
                    -0.82,
                    0.02,
                    1.3922,
                    1.3922,
                    1.3922,
                    29.20,
                    -0.28,
                    -21.79,
                    -0.66,
                    -0.06,
                    0.62,
                    0.43,
                    1.9606,
                    1.9606,
                    1.9606,
                    29.00,
                    -0.28,
                    -21.67,
                    -0.08,
                    -0.16,
                    -0.21,
                    0.96,
                    1.5476,
                    1.5476,
                    1.5476,
                    28.54,
                    -0.28,
                    -21.34,
                    0.80,
                    0.47,
                    -0.36,
                    0.10,
                    1.7611,
                    1.7611,
                    1.7611,
                    28.21,
                    -0.28,
                    -21.84,
                    0.01,
                    -0.6,
                    0.17,
                    0.78,
                    1.6218,
                    1.6218,
                    1.6218,
                    29.01,
                    -0.28,
                    -22.01,
                    0.43,
                    0.01,
                    -0.85,
                    0.30,
                    1.7121,
                    1.7121,
                    1.7121,
                    28.57,
                    -0.28,
                    -22.01,
                    -0.77,
                    0.08,
                    0.33,
                    0.53,
                    1.4925,
                    1.4925,
                    1.4925,
                    28.50,
                    -0.28,
                    -21.92,
                    0.09,
                    -0.35,
                    -0.79,
                    0.50,
                    1.9669,
                    1.9669,
                    1.9669,
                    28.18,
                    -0.28,
                    -21.56,
                    0.68,
                    0.31,
                    -0.59,
                    0.30,
                    1.7300,
                    1.7300,
                    1.7300,
                    28.24,
                    -0.28,
                    -21.29,
                    -0.07,
                    -0.45,
                    0.34,
                    0.82,
                    1.5157,
                    1.5157,
                    1.5157,
                    28.28,
                    -0.28,
                    -21.7,
                    -0.39,
                    0.02,
                    0.86,
                    0.32,
                    1.8343,
                    1.8343,
                    1.8343,
                    28.90,
                    -0.28,
                    -21.95,
                    -0.36,
                    0.00,
                    0.37,
                    0.86,
                    1.8863,
                    1.8863,
                    1.8863,
                    28.39,
                    -0.28,
                    -21.04,
                    -0.24,
                    -0.21,
                    0.61,
                    0.72,
                    1.8500,
                    1.8500,
                    1.8500,
                    29.25,
                    -0.28,
                    -21.4,
                    0.24,
                    -0.37,
                    -0.83,
                    0.34,
                    1.6826,
                    1.6826,
                    1.6826,
                    28.55,
                    -0.28,
                    -20.94,
                    -0.68,
                    0.12,
                    0.61,
                    0.39,
                    1.7136,
                    1.7136,
                    1.7136,
                    29.12,
                    -0.28,
                    -21.61,
                    0.61,
                    -0.3,
                    -0.53,
                    0.51,
                    1.5003,
                    1.5003,
                    1.5003,
                    28.41,
                    -0.28,
                    -21.71,
                    -0.84,
                    -0.21,
                    0.46,
                    0.20,
                    1.6428,
                    1.6428,
                    1.6428,
                    28.21,
                    -0.28,
                    -21.43,
                    0.37,
                    -0.9,
                    -0.21,
                    0.09,
                    1.7619,
                    1.7619,
                    1.7619,
                    29.19,
                    -0.28,
                    -21.35,
                    -0.61,
                    0.67,
                    0.40,
                    0.11,
                    1.6900,
                    1.6900,
                    1.6900,
                    28.51,
                    -0.28,
                    -21.03,
                    -0.32,
                    -0.79,
                    0.08,
                    0.51,
                    1.4472,
                    1.4472,
                    1.4472,
                    28.73,
                    -0.28,
                    -20.9,
                    0.90,
                    -0.16,
                    -0.4,
                    0.01,
                    1.9987,
                    1.9987,
                    1.9987,
                    28.48,
                    -0.28,
                    -21.54,
                    -0.75,
                    0.49,
                    0.40,
                    0.19,
                    1.8407,
                    1.8407,
                    1.8407,
                    28.56,
                    -0.28,
                    -21.29,
                    -0.07,
                    -0.68,
                    -0.44,
                    0.59,
                    1.6544,
                    1.6544,
                    1.6544,
                    28.96,
                    -0.28,
                    -21.59,
                    0.06,
                    -0.58,
                    0.18,
                    0.79,
                    1.9858,
                    1.9858,
                    1.9858,
                    29.41,
                    -0.28,
                    -21.54,
                    0.82,
                    0.33,
                    -0.32,
                    0.34,
                    1.3992,
                    1.3992,
                    1.3992,
                    28.94,
                    -0.28,
                    -21.21,
                    -0.58,
                    0.45,
                    0.64,
                    0.24,
                    1.6594,
                    1.6594,
                    1.6594,
                    29.32,
                    -0.28,
                    -21.47,
                    0.49,
                    -0.52,
                    -0.18,
                    0.68,
                    1.5599,
                    1.5599,
                    1.5599,
                    28.99,
                    -0.28,
                    -21.57,
                    -0.43,
                    0.06,
                    0.87,
                    0.24,
                    1.3949,
                    1.3949,
                    1.3949,
                    28.20,
                    -0.28,
                    -21.23,
                    0.85,
                    -0.48,
                    -0.14,
                    0.20,
                    1.4015,
                    1.4015,
                    1.4015,
                    29.18,
                    -0.28,
                    -21.28,
                    0.20,
                    -0.44,
                    0.13,
                    0.87,
                    1.4500,
                    1.4500,
                    1.4500,
                    28.62,
                    -0.28,
                    -21.92,
                    0.88,
                    0.19,
                    -0.44,
                    0.01,
                    1.8303,
                    1.8303,
                    1.8303,
                    28.89,
                    -0.28,
                    -22.05,
                    0.22,
                    -0.55,
                    0.12,
                    0.79,
                    1.6472,
                    1.6472,
                    1.6472,
                    28.70,
                    -0.28,
                    -21.16,
                    0.46,
                    0.13,
                    -0.85,
                    0.22,
                    1.8791,
                    1.8791,
                    1.8791,
                    28.31,
                    -0.28,
                    -21.25,
                    -0.53,
                    0.52,
                    0.67,
                    0.01,
                    1.4180,
                    1.4180,
                    1.4180,
                    29.15,
                    -0.28,
                    -21.41,
                    0.25,
                    -0.58,
                    -0.44,
                    0.64,
                    1.8557,
                    1.8557,
                    1.8557,
                    28.84,
                    -0.28,
                    -21.54,
                    0.72,
                    -0.13,
                    -0.63,
                    0.28,
                    1.6238,
                    1.6238,
                    1.6238,
                    28.27,
                    -0.28,
                    -21.94,
                    0.31,
                    -0.48,
                    -0.8,
                    0.20,
                    1.5562,
                    1.5562,
                    1.5562,
                    28.49,
                    -0.28,
                    -21.34,
                    0.42,
                    -0.78,
                    -0.46,
                    0.08,
                    1.5914,
                    1.5914,
                    1.5914,
                    28.52,
                    -0.28,
                    -20.96,
                    0.98,
                    -0.17,
                    -0.09,
                    0.10,
                    1.8045,
                    1.8045,
                    1.8045,
                    28.28,
                    -0.28,
                    -21.61,
                    0.56,
                    -0.04,
                    -0.06,
                    0.83,
                    2.0221,
                    2.0221,
                    2.0221,
                    29.25,
                    -0.28,
                    -21.21,
                    0.26,
                    0.15,
                    -0.87,
                    0.38,
                    1.7863,
                    1.7863,
                    1.7863,
                    28.53,
                    -0.28,
                    -21.08,
                    0.95,
                    0.14,
                    -0.27,
                    0.05,
                    2.0286,
                    2.0286,
                    2.0286,
                    29.05,
                    -0.28,
                    -21.66,
                    0.67,
                    0.21,
                    -0.6,
                    0.38,
                    1.4474,
                    1.4474,
                    1.4474,
                    28.52,
                    -0.28,
                    -21,
                    0.15,
                    -0.54,
                    -0.71,
                    0.42,
                    1.9167,
                    1.9167,
                    1.9167,
                    28.45,
                    -0.28,
                    -21.25,
                    -0.73,
                    -0.38,
                    0.15,
                    0.54,
                    1.9580,
                    1.9580,
                    1.9580,
                    29.37,
                    -0.28,
                    -21.56,
                    0.41,
                    0.20,
                    -0.85,
                    0.26,
                    1.6518,
                    1.6518,
                    1.6518,
                    29.22,
                    -0.28,
                    -21.78,
                    -0.32,
                    -0.64,
                    -0.39,
                    0.57,
                    1.9683,
                    1.9683,
                    1.9683,
                    28.98,
                    -0.28,
                    -21.18,
                    -0.16,
                    -0.36,
                    0.31,
                    0.87,
                    1.7158,
                    1.7158,
                    1.7158,
                    28.64,
                    -0.28,
                    -21.37,
                    -0.76,
                    -0.56,
                    0.34,
                    0.00,
                    1.6633,
                    1.6633,
                    1.6633,
                    28.76,
                    -0.28,
                    -21.17,
                    0.31,
                    -0.02,
                    -0.48,
                    0.82,
                    1.7044,
                    1.7044,
                    1.7044,
                    28.76,
                    -0.28,
                    -21.54,
                    0.76,
                    0.25,
                    -0.57,
                    0.17,
                    1.6640,
                    1.6640,
                    1.6640,
                    28.56,
                    -0.28,
                    -21.48,
                    -0.09,
                    -0.72,
                    0.11,
                    0.68,
                    1.6970,
                    1.6970,
                    1.6970,
                    28.59,
                    -0.28,
                    -21.91,
                    0.66,
                    0.11,
                    -0.13,
                    0.73,
                    1.9776,
                    1.9776,
                    1.9776,
                    28.14,
                    -0.28,
                    -21.39,
                    -0.42,
                    -0.74,
                    0.30,
                    0.44,
                    1.6761,
                    1.6761,
                    1.6761,
                    28.33,
                    -0.28,
                    -21.06,
                    0.13,
                    -0.38,
                    -0.58,
                    0.71,
                    1.8079,
                    1.8079,
                    1.8079,
                    28.55,
                    -0.28,
                    -22.04,
                    0.68,
                    0.40,
                    -0.42,
                    0.46,
                    1.8613,
                    1.8613,
                    1.8613,
                    28.23,
                    -0.28,
                    -21.88,
                    0.47,
                    -0.64,
                    -0.59,
                    0.09,
                    1.5985,
                    1.5985,
                    1.5985,
                    28.57,
                    -0.28,
                    -21.27,
                    0.53,
                    0.14,
                    -0.77,
                    0.32,
                    1.5282,
                    1.5282,
                    1.5282,
                    28.17,
                    -0.28,
                    -21.39,
                    -0.33,
                    -0.77,
                    -0.18,
                    0.52,
                    1.6661,
                    1.6661,
                    1.6661,
                    28.70,
                    -0.28,
                    -20.96,
                    -0.51,
                    0.05,
                    0.60,
                    0.62,
                    1.6307,
                    1.6307,
                    1.6307,
                    28.62,
                    -0.28,
                    -21.49,
                    0.15,
                    -0.12,
                    -0.62,
                    0.76,
                    1.8751,
                    1.8751,
                    1.8751,
                    28.94,
                    -0.28,
                    -21.29,
                    0.80,
                    -0.03,
                    -0.42,
                    0.44,
                    1.4892,
                    1.4892,
                    1.4892,
                    28.49,
                    -0.28,
                    -21.94,
                    0.38,
                    -0.51,
                    -0.45,
                    0.62,
                    1.6405,
                    1.6405,
                    1.6405,
                    28.50,
                    -0.28,
                    -21.89,
                    -0.68,
                    -0.17,
                    0.71,
                    0.05,
                    1.9351,
                    1.9351,
                    1.9351,
                    28.32,
                    -0.28,
                    -21.48,
                    -0.13,
                    -0.13,
                    -0.13,
                    0.97,
                    2.0539,
                    2.0539,
                    2.0539,
                    28.84,
                    -0.28,
                    -21.3,
                    0.29,
                    0.00,
                    -0.28,
                    0.92,
                    1.4579,
                    1.4579,
                    1.4579,
                    28.62,
                    -0.28,
                    -21.04,
                    0.92,
                    0.27,
                    -0.2,
                    0.22,
                    1.7171,
                    1.7171,
                    1.7171,
                    28.99,
                    -0.28,
                    -21.53,
                    -0.01,
                    -0.6,
                    0.38,
                    0.70,
                    1.6991,
                    1.6991,
                    1.6991,
                    29.13,
                    -0.28,
                    -21.77,
                    0.40,
                    -0.07,
                    -0.83,
                    0.39,
                    2.0107,
                    2.0107,
                    2.0107,
                    29.15,
                    -0.28,
                    -22.03,
                    0.24,
                    -0.63,
                    -0.73,
                    0.11,
                    1.6664,
                    1.6664,
                    1.6664,
                    28.46,
                    -0.28,
                    -21.47,
                    -0.3,
                    -0.65,
                    0.46,
                    0.53,
                    1.8075,
                    1.8075,
                    1.8075,
                    28.33,
                    -0.28,
                    -21.31,
                    0.37,
                    -0.08,
                    -0.92,
                    0.11,
                    2.0171,
                    2.0171,
                    2.0171,
                    28.66,
                    -0.28,
                    -21.5,
                    0.30,
                    0.35,
                    -0.89,
                    0.02,
                    1.5206,
                    1.5206,
                    1.5206,
                    29.18,
                    -0.28,
                    -21.94,
                    -0.66,
                    0.42,
                    0.61,
                    0.14,
                    1.9406,
                    1.9406,
                    1.9406,
                    28.80,
                    -0.28,
                    -21.55,
                    0.41,
                    -0.03,
                    -0.85,
                    0.32,
                    1.9831,
                    1.9831,
                    1.9831,
                    29.29,
                    -0.28,
                    -21.81,
                    -0.18,
                    -0.68,
                    0.71,
                    0.02,
                    1.9277,
                    1.9277,
                    1.9277,
                    28.29,
                    -0.28,
                    -21.3,
                    -0.11,
                    -0.47,
                    -0.41,
                    0.77,
                    1.4017,
                    1.4017,
                    1.4017,
                    29.10,
                    -0.28,
                    -21.88,
                    0.51,
                    0.22,
                    -0.79,
                    0.25,
                    1.6891,
                    1.6891,
                    1.6891,
                    29.31,
                    -0.28,
                    -21.41,
                    -0.04,
                    -0.59,
                    0.59,
                    0.55,
                    1.7772,
                    1.7772,
                    1.7772,
                    29.16,
                    -0.28,
                    -21.62,
                    -0.06,
                    -0.44,
                    -0.47,
                    0.77,
                    1.7131,
                    1.7131,
                    1.7131,
                    28.23,
                    -0.28,
                    -21.74,
                    0.18,
                    -0.34,
                    0.40,
                    0.83,
                    1.5387,
                    1.5387,
                    1.5387,
                    28.87,
                    -0.28,
                    -21.64,
                    0.79,
                    -0.52,
                    -0.24,
                    0.23,
                    1.9930,
                    1.9930,
                    1.9930,
                    28.42,
                    -0.28,
                    -21.85,
                    0.63,
                    -0.46,
                    -0.1,
                    0.62,
                    1.8900,
                    1.8900,
                    1.8900,
                    28.96,
                    -0.28,
                    -21.94,
                    0.27,
                    -0.46,
                    -0.68,
                    0.50,
                    1.7038,
                    1.7038,
                    1.7038,
                    28.13,
                    -0.28,
                    -21.5,
                    -0.37,
                    -0.25,
                    0.71,
                    0.55,
                    2.0166,
                    2.0166,
                    2.0166,
                    28.42,
                    -0.28,
                    -21.95,
                    -0.8,
                    0.37,
                    0.40,
                    0.24,
                    1.7624,
                    1.7624,
                    1.7624,
                    28.39,
                    -0.28,
                    -21,
                    0.80,
                    -0.38,
                    -0.14,
                    0.45,
                    1.7678,
                    1.7678,
                    1.7678,
                    28.89,
                    -0.28,
                    -22.02,
                    0.01,
                    -0.45,
                    -0.08,
                    0.89,
                    2.0144,
                    2.0144,
                    2.0144,
                    28.76,
                    -0.28,
                    -22.13,
                    0.47,
                    -0.75,
                    0.05,
                    0.47,
                    1.6368,
                    1.6368,
                    1.6368,
                    28.80,
                    -0.28,
                    -21.28,
                    0.02,
                    -0.52,
                    -0.57,
                    0.64,
                    1.6633,
                    1.6633,
                    1.6633,
                    28.75,
                    -0.28,
                    -22.04,
                    0.37,
                    -0.02,
                    -0.92,
                    0.11,
                    1.6050,
                    1.6050,
                    1.6050,
                    28.32,
                    -0.28,
                    -21.29,
                    -0.57,
                    0.34,
                    0.73,
                    0.19,
                    2.0018,
                    2.0018,
                    2.0018,
                    28.56,
                    -0.28,
                    -21.1,
                    0.68,
                    -0.59,
                    -0.27,
                    0.35,
                    1.4559,
                    1.4559,
                    1.4559,
                    28.59,
                    -0.28,
                    -20.93,
                    0.35,
                    -0.27,
                    0.48,
                    0.76,
                    1.8403,
                    1.8403,
                    1.8403,
                    28.93,
                    -0.28,
                    -22.11,
                    0.77,
                    -0.34,
                    -0.1,
                    0.53,
                    1.4080,
                    1.4080,
                    1.4080,
                    28.56,
                    -0.28,
                    -21.86,
                    -0.42,
                    0.28,
                    0.86,
                    0.04,
                    1.9176,
                    1.9176,
                    1.9176,
                    29.35,
                    -0.28,
                    -21.66,
                    0.40,
                    -0.47,
                    -0.55,
                    0.57,
                    2.0290,
                    2.0290,
                    2.0290,
                    28.21,
                    -0.28,
                    -21.23,
                    0.29,
                    -0.29,
                    -0.78,
                    0.46,
                    1.9092,
                    1.9092,
                    1.9092,
                    28.85,
                    -0.28,
                    -21.54,
                    -0.01,
                    -0.48,
                    -0.82,
                    0.32,
                    1.8085,
                    1.8085,
                    1.8085,
                    29.11,
                    -0.28,
                    -21.45,
                    0.30,
                    -0.2,
                    -0.69,
                    0.63,
                    1.9722,
                    1.9722,
                    1.9722,
                    28.49,
                    -0.28,
                    -21.45,
                    -0.37,
                    0.13,
                    0.89,
                    0.24,
                    1.4475,
                    1.4475,
                    1.4475,
                    28.88,
                    -0.28,
                    -21.38,
                    -0.48,
                    0.55,
                    0.66,
                    0.16,
                    1.6508,
                    1.6508,
                    1.6508,
                    28.32,
                    -0.28,
                    -21.49,
                    -0.57,
                    -0.37,
                    0.74,
                    0.02,
                    1.9586,
                    1.9586,
                    1.9586,
                    28.87,
                    -0.28,
                    -20.89,
                    0.65,
                    -0.54,
                    -0.49,
                    0.23,
                    1.9310,
                    1.9310,
                    1.9310,
                    28.14,
                    -0.28,
                    -21.43,
                    0.39,
                    -0.57,
                    -0.68,
                    0.25,
                    1.9998,
                    1.9998,
                    1.9998,
                    28.37,
                    -0.28,
                    -21.33,
                    0.73,
                    0.05,
                    -0.66,
                    0.18,
                    1.8280,
                    1.8280,
                    1.8280,
                    28.22,
                    -0.28,
                    -21.15,
                    -0.18,
                    -0.06,
                    0.92,
                    0.34,
                    2.0204,
                    2.0204,
                    2.0204,
                    28.72,
                    -0.28,
                    -21.11,
                    -0.34,
                    0.17,
                    0.52,
                    0.76,
                    1.7294,
                    1.7294,
                    1.7294,
                    28.17,
                    -0.28,
                    -21.31,
                    -0.17,
                    -0.03,
                    0.81,
                    0.55,
                    1.6561,
                    1.6561,
                    1.6561,
                    28.31,
                    -0.28,
                    -21.42,
                    0.29,
                    -0.66,
                    -0.56,
                    0.41,
                    1.8256,
                    1.8256,
                    1.8256,
                    29.23,
                    -0.28,
                    -21.27,
                    -0.89,
                    -0.17,
                    0.42,
                    0.03,
                    2.0388,
                    2.0388,
                    2.0388,
                    28.76,
                    -0.28,
                    -20.96,
                    0.35,
                    0.36,
                    -0.86,
                    0.13,
                    1.9724,
                    1.9724,
                    1.9724,
                    28.52,
                    -0.28,
                    -21.39,
                    0.78,
                    -0.54,
                    -0.27,
                    0.16,
                    1.7758,
                    1.7758,
                    1.7758,
                    29.08,
                    -0.28,
                    -21.48,
                    0.24,
                    -0.41,
                    0.12,
                    0.87,
                    1.8064,
                    1.8064,
                    1.8064,
                    28.49,
                    -0.28,
                    -21.06,
                    0.59,
                    -0.75,
                    -0.12,
                    0.29,
                    1.9430,
                    1.9430,
                    1.9430,
                    28.51,
                    -0.28,
                    -21.21,
                    0.51,
                    -0.68,
                    0.10,
                    0.52,
                    1.7963,
                    1.7963,
                    1.7963,
                    28.88,
                    -0.28,
                    -21.68,
                    -0.37,
                    0.25,
                    0.89,
                    0.06,
                    1.9068,
                    1.9068,
                    1.9068,
                    28.43,
                    -0.28,
                    -21.58,
                    -0.61,
                    0.13,
                    0.77,
                    0.13,
                    1.9592,
                    1.9592,
                    1.9592,
                    29.17,
                    -0.28,
                    -21.82,
                    0.16,
                    -0.26,
                    -0.36,
                    0.88,
                    1.8128,
                    1.8128,
                    1.8128,
                    28.27,
                    -0.28,
                    -21.81,
                    -0.3,
                    0.27,
                    0.65,
                    0.64,
                    1.6168,
                    1.6168,
                    1.6168,
                    29.30,
                    -0.28,
                    -21.65,
                    0.17,
                    0.08,
                    -0.97,
                    0.14,
                    1.6845,
                    1.6845,
                    1.6845,
                    28.32,
                    -0.28,
                    -21.35,
                    0.88,
                    0.29,
                    -0.36,
                    0.10,
                    1.6948,
                    1.6948,
                    1.6948,
                    28.73,
                    -0.28,
                    -21.13,
                    0.13,
                    -0.68,
                    0.39,
                    0.60,
                    1.4686,
                    1.4686,
                    1.4686,
                    28.22,
                    -0.28,
                    -21.86,
                    0.73,
                    0.49,
                    -0.47,
                    0.07,
                    1.4015,
                    1.4015,
                    1.4015,
                    28.74,
                    -0.28,
                    -21.41,
                    0.33,
                    -0.08,
                    -0.77,
                    0.53,
                    1.5540,
                    1.5540,
                    1.5540,
                    28.77,
                    -0.28,
                    -21.08,
                    -0.55,
                    -0.66,
                    0.47,
                    0.21,
                    1.8174,
                    1.8174,
                    1.8174,
                    28.12,
                    -0.28,
                    -21.45,
                    0.81,
                    0.33,
                    -0.46,
                    0.15,
                    2.0018,
                    2.0018,
                    2.0018,
                    29.23,
                    -0.28,
                    -21.64,
                    -0.05,
                    -0.36,
                    -0.53,
                    0.77,
                    1.5917,
                    1.5917,
                    1.5917,
                    29.34,
                    -0.28,
                    -21.45,
                    -0.47,
                    0.67,
                    0.58,
                    0.03,
                    1.4550,
                    1.4550,
                    1.4550,
                    29.14,
                    -0.28,
                    -21.95,
                    0.58,
                    -0.13,
                    -0.7,
                    0.40,
                    1.9863,
                    1.9863,
                    1.9863,
                    28.46,
                    -0.28,
                    -21.56,
                    0.48,
                    -0.7,
                    -0.25,
                    0.46,
                    2.0214,
                    2.0214,
                    2.0214,
                    28.32,
                    -0.28,
                    -22.02,
                    0.83,
                    -0.28,
                    -0.09,
                    0.48,
                    1.7402,
                    1.7402,
                    1.7402,
                    29.35,
                    -0.28,
                    -21.34,
                    0.14,
                    -0.85,
                    0.18,
                    0.48,
                    1.7026,
                    1.7026,
                    1.7026,
                    28.73,
                    -0.28,
                    -21.37,
                    0.26,
                    -0.36,
                    -0.85,
                    0.30,
                    1.9486,
                    1.9486,
                    1.9486,
                    28.44,
                    -0.28,
                    -21.17,
                    0.14,
                    -0.44,
                    -0.81,
                    0.36,
                    1.9513,
                    1.9513,
                    1.9512,
                    29.05,
                    -0.28,
                    -21.34,
                    0.37,
                    -0.14,
                    -0.81,
                    0.44,
                    1.4380,
                    1.4380,
                    1.4380,
                    28.58,
                    -0.28,
                    -21.05,
                    -0.5,
                    0.22,
                    0.77,
                    0.32,
                    1.4389,
                    1.4389,
                    1.4389,
                    28.25,
                    -0.28,
                    -21.12,
                    -0.68,
                    -0.39,
                    0.16,
                    0.60,
                    1.6197,
                    1.6197,
                    1.6197,
                    28.26,
                    -0.28,
                    -21.15,
                    0.71,
                    -0.59,
                    -0.19,
                    0.34,
                    2.0123,
                    2.0123,
                    2.0123,
                    29.18,
                    -0.28,
                    -21.03,
                    0.24,
                    -0.3,
                    0.18,
                    0.91,
                    1.9379,
                    1.9379,
                    1.9380,
                    28.92,
                    -0.28,
                    -21.38,
                    0.90,
                    -0.27,
                    -0.29,
                    0.17,
                    1.5088,
                    1.5088,
                    1.5088,
                    28.79,
                    -0.28,
                    -22.15,
                    0.73,
                    -0.06,
                    -0.45,
                    0.51,
                    1.5731,
                    1.5731,
                    1.5731,
                    29.29,
                    -0.28,
                    -21.56,
                    0.27,
                    -0.7,
                    -0.49,
                    0.44,
                    1.4390,
                    1.4390,
                    1.4390,
                    28.87,
                    -0.28,
                    -21.47,
                    0.36,
                    0.09,
                    -0.9,
                    0.24,
                    1.4289,
                    1.4289,
                    1.4289,
                    28.86,
                    -0.28,
                    -21.41,
                    0.00,
                    -0.83,
                    -0.53,
                    0.19,
                    2.0131,
                    2.0131,
                    2.0131,
                    28.24,
                    -0.28,
                    -21.9,
                    0.52,
                    -0.69,
                    -0.26,
                    0.43,
                    1.8744,
                    1.8744,
                    1.8744,
                    28.75,
                    -0.28,
                    -21.5,
                    -0.14,
                    -0.74,
                    -0.14,
                    0.64,
                    1.6523,
                    1.6523,
                    1.6523,
                    29.08,
                    -0.28,
                    -21.35,
                    -0.4,
                    0.63,
                    0.65,
                    0.12,
                    1.9664,
                    1.9664,
                    1.9664,
                    29.01,
                    -0.28,
                    -21.54,
                    -0.23,
                    -0.65,
                    0.15,
                    0.71,
                    1.7787,
                    1.7787,
                    1.7787,
                    28.99,
                    -0.28,
                    -21.68,
                    -0.46,
                    -0.13,
                    0.86,
                    0.18,
                    1.9149,
                    1.9149,
                    1.9149,
                    28.38,
                    -0.28,
                    -21,
                    -0.02,
                    -0.4,
                    0.92,
                    0.01,
                    1.9336,
                    1.9336,
                    1.9336,
                    28.97,
                    -0.28,
                    -21.16,
                    -0.39,
                    0.42,
                    0.76,
                    0.32,
                    1.7728,
                    1.7728,
                    1.7728,
                    28.90,
                    -0.28,
                    -21.26,
                    0.83,
                    -0.08,
                    -0.31,
                    0.46,
                    1.9578,
                    1.9578,
                    1.9578,
                    29.20,
                    -0.28,
                    -21.12,
                    0.34,
                    -0.38,
                    -0.84,
                    0.19,
                    1.8326,
                    1.8326,
                    1.8326,
                    28.54,
                    -0.28,
                    -21.15,
                    -0.76,
                    0.01,
                    0.60,
                    0.25,
                    1.5777,
                    1.5777,
                    1.5777,
                    29.34,
                    -0.28,
                    -21.49,
                    -0.46,
                    -0.44,
                    0.72,
                    0.26,
                    1.4858,
                    1.4858,
                    1.4858,
                    28.47,
                    -0.28,
                    -21.22,
                    0.14,
                    -0.31,
                    -0.89,
                    0.29,
                    1.8852,
                    1.8852,
                    1.8852,
                    29.30,
                    -0.28,
                    -21.65,
                    0.61,
                    -0.39,
                    0.10,
                    0.69,
                    1.9584,
                    1.9584,
                    1.9584,
                    28.95,
                    -0.28,
                    -21.16,
                    0.56,
                    -0.61,
                    -0.55,
                    0.14,
                    1.8178,
                    1.8178,
                    1.8178,
                    28.13,
                    -0.28,
                    -21.38,
                    0.83,
                    0.37,
                    -0.43,
                    0.02,
                    1.6311,
                    1.6311,
                    1.6311,
                    29.25,
                    -0.28,
                    -21.47,
                    0.24,
                    -0.16,
                    -0.06,
                    0.96,
                    2.0334,
                    2.0334,
                    2.0334,
                    28.49,
                    -0.28,
                    -21.47,
                    -0.25,
                    -0.59,
                    0.72,
                    0.25,
                    1.6594,
                    1.6594,
                    1.6594,
                    28.81,
                    -0.28,
                    -22.09,
                    -0.92,
                    0.05,
                    0.38,
                    0.08,
                    1.8548,
                    1.8548,
                    1.8548,
                    29.05,
                    -0.28,
                    -21.89,
                    -0.2,
                    -0.49,
                    -0.43,
                    0.73,
                    1.6836,
                    1.6836,
                    1.6836,
                    28.95,
                    -0.28,
                    -21.6,
                    0.36,
                    -0.08,
                    -0.65,
                    0.66,
                    2.0425,
                    2.0425,
                    2.0425,
                    28.34,
                    -0.28,
                    -21.91,
                    0.68,
                    0.21,
                    -0.66,
                    0.22,
                    1.7047,
                    1.7047,
                    1.7047,
                    28.25,
                    -0.28,
                    -21.21,
                    0.23,
                    -0.67,
                    -0.39,
                    0.59,
                    1.6922,
                    1.6922,
                    1.6922,
                    28.96,
                    -0.28,
                    -21.5,
                    0.28,
                    -0.47,
                    -0.38,
                    0.74,
                    1.9278,
                    1.9278,
                    1.9278,
                    28.36,
                    -0.28,
                    -21.84,
                    0.95,
                    -0.08,
                    -0.19,
                    0.24,
                    1.4914,
                    1.4914,
                    1.4914,
                    28.50,
                    -0.28,
                    -21.52,
                    0.32,
                    -0.16,
                    -0.4,
                    0.84,
                    1.4551,
                    1.4551,
                    1.4551,
                    28.50,
                    -0.28,
                    -21.99,
                    -0.28,
                    0.27,
                    0.89,
                    0.24,
                    1.6118,
                    1.6118,
                    1.6118,
                    28.42,
                    -0.28,
                    -21.44,
                    0.25,
                    0.20,
                    -0.91,
                    0.24,
                    1.8308,
                    1.8309,
                    1.8308,
                    29.08,
                    -0.28,
                    -21.28,
                    0.84,
                    -0.41,
                    -0.3,
                    0.20,
                    1.6416,
                    1.6416,
                    1.6416,
                    28.32,
                    -0.28,
                    -21.39,
                    0.36,
                    -0.4,
                    -0.01,
                    0.84,
                    1.4626,
                    1.4626,
                    1.4626,
                    29.24,
                    -0.28,
                    -21.42,
                    0.70,
                    -0.57,
                    -0.3,
                    0.29,
                    1.6588,
                    1.6588,
                    1.6588,
                    28.42,
                    -0.28,
                    -20.97,
                    0.20,
                    -0.63,
                    -0.7,
                    0.26,
                    1.9469,
                    1.9469,
                    1.9469,
                    28.71,
                    -0.28,
                    -22.04,
                    0.29,
                    -0.35,
                    -0.89,
                    0.05,
                    1.8748,
                    1.8748,
                    1.8748,
                    28.38,
                    -0.28,
                    -21.71,
                    0.57,
                    -0.37,
                    -0.48,
                    0.56,
                    1.4685,
                    1.4685,
                    1.4685,
                    28.86,
                    -0.28,
                    -21.81,
                    -0.45,
                    -0.02,
                    0.84,
                    0.31,
                    1.9361,
                    1.9361,
                    1.9361,
                    29.17,
                    -0.28,
                    -21.96,
                    0.26,
                    0.12,
                    -0.7,
                    0.65,
                    1.6485,
                    1.6485,
                    1.6485,
                    29.11,
                    -0.28,
                    -21.43,
                    0.80,
                    0.34,
                    -0.43,
                    0.26,
                    1.6927,
                    1.6927,
                    1.6927,
                    28.53,
                    -0.28,
                    -21.85,
                    0.61,
                    -0.35,
                    -0.57,
                    0.42,
                    1.8151,
                    1.8151,
                    1.8151,
                    28.85,
                    -0.28,
                    -21.47,
                    0.46,
                    -0.33,
                    -0.69,
                    0.47,
                    1.8643,
                    1.8643,
                    1.8643,
                    29.06,
                    -0.28,
                    -21.37,
                    0.38,
                    0.01,
                    -0.35,
                    0.86,
                    1.9385,
                    1.9385,
                    1.9385,
                    28.33,
                    -0.28,
                    -22,
                    0.02,
                    -0.96,
                    -0.24,
                    0.16,
                    1.9940,
                    1.9940,
                    1.9940,
                    28.84,
                    -0.28,
                    -21.29,
                    -0.39,
                    -0.44,
                    -0.36,
                    0.73,
                    1.5654,
                    1.5654,
                    1.5654,
                    29.27,
                    -0.28,
                    -21.85,
                    0.42,
                    -0.69,
                    0.17,
                    0.56,
                    1.4266,
                    1.4266,
                    1.4266,
                    29.17,
                    -0.28,
                    -21.71,
                    0.18,
                    -0.44,
                    -0.68,
                    0.56,
                    1.8474,
                    1.8474,
                    1.8474,
                    29.20,
                    -0.28,
                    -21.45,
                    0.38,
                    -0.15,
                    -0.91,
                    0.09,
                    1.9115,
                    1.9115,
                    1.9115,
                    28.88,
                    -0.28,
                    -21.86,
                    -0.62,
                    -0.04,
                    0.58,
                    0.53,
                    1.9543,
                    1.9543,
                    1.9543,
                    29.06,
                    -0.28,
                    -22,
                    -0.86,
                    0.19,
                    0.46,
                    0.08,
                    1.6640,
                    1.6640,
                    1.6640,
                    28.30,
                    -0.28,
                    -21.65,
                    0.00,
                    -0.29,
                    -0.81,
                    0.52,
                    1.9864,
                    1.9864,
                    1.9864,
                    29.35,
                    -0.28,
                    -21.24,
                    0.50,
                    0.42,
                    -0.72,
                    0.23,
                    1.6484,
                    1.6484,
                    1.6484,
                    28.88,
                    -0.28,
                    -21.65,
                    0.66,
                    -0.61,
                    -0.4,
                    0.14,
                    1.7830,
                    1.7830,
                    1.7830,
                    29.07,
                    -0.28,
                    -21.85,
                    0.39,
                    0.22,
                    -0.9,
                    0.00,
                    1.9413,
                    1.9413,
                    1.9413,
                    29.07,
                    -0.28,
                    -21.8,
                    0.32,
                    0.52,
                    -0.78,
                    0.15,
                    1.4541,
                    1.4541,
                    1.4541,
                    28.39,
                    -0.28,
                    -21.77,
                    0.34,
                    -0.6,
                    -0.68,
                    0.25,
                    1.6866,
                    1.6866,
                    1.6866,
                    29.23,
                    -0.28,
                    -21.43,
                    -0.04,
                    -0.72,
                    0.29,
                    0.63,
                    1.7073,
                    1.7073,
                    1.7073,
                    28.45,
                    -0.28,
                    -20.94,
                    -0.89,
                    -0.3,
                    0.25,
                    0.24,
                    1.6147,
                    1.6147,
                    1.6147,
                    28.62,
                    -0.28,
                    -21.87,
                    0.50,
                    -0.12,
                    -0.08,
                    0.85,
                    1.7853,
                    1.7853,
                    1.7853,
                    29.19,
                    -0.28,
                    -21.56,
                    0.66,
                    -0.68,
                    -0.28,
                    0.14,
                    1.5275,
                    1.5275,
                    1.5275,
                    28.80,
                    -0.28,
                    -21.04,
                    0.13,
                    -0.92,
                    -0.06,
                    0.36,
                    1.9536,
                    1.9536,
                    1.9536,
                    28.36,
                    -0.28,
                    -21.89,
                    -0.31,
                    -0.47,
                    -0.29,
                    0.77,
                    1.9552,
                    1.9552,
                    1.9552,
                    28.46,
                    -0.28,
                    -21.88,
                    0.04,
                    -0.84,
                    0.43,
                    0.32,
                    1.8910,
                    1.8910,
                    1.8910,
                    28.32,
                    -0.28,
                    -21.35,
                    0.31,
                    -0.25,
                    -0.92,
                    0.05,
                    1.9486,
                    1.9486,
                    1.9486,
                    29.26,
                    -0.28,
                    -21.13,
                    -0.49,
                    0.33,
                    0.80,
                    0.11,
                    1.7380,
                    1.7380,
                    1.7380,
                    28.36,
                    -0.28,
                    -21.35,
                    -0.62,
                    -0.26,
                    0.69,
                    0.27,
                    1.5199,
                    1.5199,
                    1.5199,
                    28.13,
                    -0.28,
                    -21.45,
                    0.47,
                    -0.7,
                    -0.35,
                    0.40,
                    1.7312,
                    1.7312,
                    1.7312,
                    28.26,
                    -0.28,
                    -21.12,
                    0.45,
                    -0.13,
                    0.20,
                    0.86,
                    2.0402,
                    2.0402,
                    2.0402,
                    29.07,
                    -0.28,
                    -21.18,
                    -0.19,
                    -0.33,
                    0.92,
                    0.05,
                    1.5178,
                    1.5178,
                    1.5178,
                    28.47,
                    -0.28,
                    -21.75,
                    -0.47,
                    -0.83,
                    0.22,
                    0.21,
                    1.9880,
                    1.9880,
                    1.9880,
                    28.48,
                    -0.28,
                    -21.44,
                    0.44,
                    -0.71,
                    0.14,
                    0.54,
                    1.4987,
                    1.4987,
                    1.4987,
                    28.14,
                    -0.28,
                    -21.75,
                    -0.74,
                    0.11,
                    0.52,
                    0.41,
                    1.6029,
                    1.6029,
                    1.6029,
                    29.09,
                    -0.28,
                    -21.47,
                    0.69,
                    -0.05,
                    -0.61,
                    0.38,
                    1.6631,
                    1.6631,
                    1.6631,
                    29.08,
                    -0.28,
                    -21.43,
                    -0.79,
                    0.01,
                    0.60,
                    0.12,
                    2.0413,
                    2.0413,
                    2.0413,
                    29.02,
                    -0.28,
                    -21.78,
                    -0.9,
                    -0.28,
                    0.30,
                    0.13,
                    1.4900,
                    1.4900,
                    1.4900,
                    28.67,
                    -0.28,
                    -21.89,
                    -0.37,
                    0.19,
                    0.66,
                    0.62,
                    1.9384,
                    1.9384,
                    1.9384,
                    29.11,
                    -0.28,
                    -22.02,
                    0.81,
                    0.12,
                    -0.29,
                    0.49,
                    1.6203,
                    1.6203,
                    1.6203,
                    29.22,
                    -0.28,
                    -21.52,
                    -0.47,
                    -0,
                    0.73,
                    0.49,
                    2.0098,
                    2.0098,
                    2.0098,
                    28.93,
                    -0.28,
                    -21.84,
                    -0.52,
                    0.03,
                    0.84,
                    0.17,
                    1.9238,
                    1.9238,
                    1.9238,
                    28.26,
                    -0.28,
                    -21.6,
                    -0.08,
                    -0.58,
                    0.78,
                    0.24,
                    1.7616,
                    1.7616,
                    1.7616,
                    28.55,
                    -0.28,
                    -21.08,
                    0.15,
                    -0.59,
                    -0.69,
                    0.39,
                    1.5744,
                    1.5744,
                    1.5744,
                    28.92,
                    -0.28,
                    -22.02,
                    0.44,
                    -0.38,
                    -0.51,
                    0.63,
                    2.0536,
                    2.0536,
                    2.0536,
                    28.42,
                    -0.28,
                    -21.86,
                    -0.9,
                    0.13,
                    0.40,
                    0.15,
                    1.4745,
                    1.4745,
                    1.4745,
                    28.54,
                    -0.28,
                    -21.3,
                    -0.61,
                    0.74,
                    0.28,
                    0.05,
                    1.3924,
                    1.3924,
                    1.3924,
                    29.11,
                    -0.28,
                    -21.59,
                    -0.7,
                    0.21,
                    0.63,
                    0.27,
                    1.4007,
                    1.4007,
                    1.4007,
                    28.87,
                    -0.28,
                    -22.11,
                    0.88,
                    -0.26,
                    -0.27,
                    0.28,
                    1.9168,
                    1.9168,
                    1.9168,
                    28.86,
                    -0.28,
                    -20.87,
                    -0.83,
                    0.25,
                    0.44,
                    0.24,
                    1.7924,
                    1.7924,
                    1.7924,
                    29.31,
                    -0.28,
                    -21.34,
                    0.44,
                    -0.62,
                    0.06,
                    0.64,
                    1.4620,
                    1.4620,
                    1.4620,
                    28.37,
                    -0.28,
                    -21.74,
                    0.91,
                    0.08,
                    -0.33,
                    0.23,
                    1.4112,
                    1.4112,
                    1.4112,
                    28.42,
                    -0.28,
                    -21.45,
                    -0.16,
                    -0.86,
                    -0.3,
                    0.38,
                    1.4020,
                    1.4020,
                    1.4020,
                    28.47,
                    -0.28,
                    -20.98,
                    0.56,
                    0.07,
                    -0.42,
                    0.71,
                    1.5429,
                    1.5429,
                    1.5429,
                    28.53,
                    -0.28,
                    -22.14,
                    -0.15,
                    -0.63,
                    -0.41,
                    0.64,
                    1.5656,
                    1.5656,
                    1.5656,
                    28.72,
                    -0.28,
                    -22.02,
                    0.78,
                    -0.03,
                    -0.5,
                    0.37,
                    1.6617,
                    1.6617,
                    1.6616,
                    29.01,
                    -0.28,
                    -21.2,
                    0.32,
                    -0.74,
                    -0.49,
                    0.34,
                    1.4395,
                    1.4395,
                    1.4395,
                    28.55,
                    -0.28,
                    -21.45,
                    0.53,
                    -0.13,
                    -0.43,
                    0.72,
                    1.9916,
                    1.9916,
                    1.9916,
                    28.78,
                    -0.28,
                    -20.96,
                    0.09,
                    -0.59,
                    -0.68,
                    0.43,
                    1.4257,
                    1.4257,
                    1.4257,
                    29.36,
                    -0.28,
                    -21.52,
                    -0.54,
                    -0.19,
                    0.75,
                    0.33,
                    1.7445,
                    1.7445,
                    1.7445,
                    28.84,
                    -0.28,
                    -21.21,
                    -0.03,
                    -0.38,
                    0.90,
                    0.19,
                    1.9373,
                    1.9373,
                    1.9373,
                    29.28,
                    -0.28,
                    -21.27,
                    0.55,
                    -0.79,
                    -0.29,
                    0.01,
                    1.5532,
                    1.5532,
                    1.5532,
                    29.32,
                    -0.28,
                    -21.63,
                    -0.43,
                    0.04,
                    0.89,
                    0.15,
                    1.4148,
                    1.4148,
                    1.4148,
                    28.95,
                    -0.28,
                    -22.14,
                    -0.29,
                    -0.35,
                    0.89,
                    0.00,
                    1.6301,
                    1.6301,
                    1.6301,
                    28.44,
                    -0.28,
                    -21.57,
                    -0.47,
                    0.46,
                    0.70,
                    0.29,
                    1.9911,
                    1.9911,
                    1.9911,
                    29.32,
                    -0.28,
                    -21.38,
                    0.82,
                    -0.02,
                    -0.42,
                    0.38,
                    1.7558,
                    1.7558,
                    1.7558,
                    28.40,
                    -0.28,
                    -21.36,
                    0.02,
                    -0.5,
                    -0.5,
                    0.71,
                    2.0190,
                    2.0190,
                    2.0190,
                    29.13,
                    -0.28,
                    -21.2,
                    -0.71,
                    -0.5,
                    0.13,
                    0.47,
                    1.4533,
                    1.4533,
                    1.4533,
                    28.19,
                    -0.28,
                    -21.48,
                    0.47,
                    -0.23,
                    -0.18,
                    0.83,
                    2.0509,
                    2.0509,
                    2.0509,
                    28.95,
                    -0.28,
                    -21.72,
                    0.63,
                    -0.68,
                    -0.36,
                    0.09,
                    1.9148,
                    1.9148,
                    1.9148,
                    28.19,
                    -0.28,
                    -21.58,
                    0.43,
                    -0.7,
                    -0.49,
                    0.31,
                    1.9124,
                    1.9124,
                    1.9124,
                    28.85,
                    -0.28,
                    -22.01,
                    0.62,
                    -0.39,
                    -0.64,
                    0.24,
                    1.5387,
                    1.5387,
                    1.5387,
                    28.77,
                    -0.28,
                    -21.32,
                    0.50,
                    -0.67,
                    -0.3,
                    0.46,
                    1.9436,
                    1.9436,
                    1.9436,
                    28.87,
                    -0.28,
                    -21.78,
                    -0.54,
                    0.73,
                    0.42,
                    0.00,
                    1.9036,
                    1.9036,
                    1.9036,
                    28.93,
                    -0.28,
                    -21.36,
                    0.12,
                    -0.73,
                    -0.64,
                    0.19,
                    1.7713,
                    1.7713,
                    1.7713,
                    29.15,
                    -0.28,
                    -21.96,
                    0.39,
                    -0.36,
                    -0.49,
                    0.70,
                    1.8045,
                    1.8045,
                    1.8045,
                    28.10,
                    -0.28,
                    -21.42,
                    0.69,
                    0.19,
                    -0.69,
                    0.11,
                    1.5567,
                    1.5567,
                    1.5567,
                    28.66,
                    -0.28,
                    -21.06,
                    0.91,
                    -0.28,
                    -0.26,
                    0.17,
                    1.9870,
                    1.9870,
                    1.9870,
                    29.26,
                    -0.28,
                    -21.28,
                    0.75,
                    -0.19,
                    -0.04,
                    0.63,
                    1.7121,
                    1.7121,
                    1.7121,
                    29.30,
                    -0.28,
                    -21.54,
                    -0.49,
                    0.22,
                    0.84,
                    0.07,
                    2.0094,
                    2.0094,
                    2.0094,
                    29.19,
                    -0.28,
                    -21.55,
                    0.57,
                    -0.45,
                    -0.64,
                    0.26,
                    1.4398,
                    1.4398,
                    1.4398,
                    29.10,
                    -0.28,
                    -21.1,
                    0.71,
                    -0.62,
                    -0.24,
                    0.22,
                    1.4849,
                    1.4849,
                    1.4849,
                    28.14,
                    -0.28,
                    -21.53,
                    0.78,
                    0.45,
                    -0.31,
                    0.31,
                    1.4451,
                    1.4451,
                    1.4451,
                    28.66,
                    -0.28,
                    -21.47,
                    -0.87,
                    -0.18,
                    0.05,
                    0.45,
                    1.5667,
                    1.5667,
                    1.5667,
                    28.50,
                    -0.28,
                    -21.96,
                    -0.47,
                    -0.81,
                    0.33,
                    0.08,
                    2.0392,
                    2.0392,
                    2.0392,
                    28.39,
                    -0.28,
                    -21.9,
                    0.86,
                    0.19,
                    -0.33,
                    0.35,
                    1.4125,
                    1.4125,
                    1.4125,
                    28.43,
                    -0.28,
                    -20.99,
                    0.11,
                    -0.41,
                    -0.78,
                    0.46,
                    1.9578,
                    1.9578,
                    1.9578,
                    28.27,
                    -0.28,
                    -21.58,
                    -0.73,
                    0.22,
                    0.59,
                    0.26,
                    1.6424,
                    1.6424,
                    1.6424,
                    28.23,
                    -0.28,
                    -21.33,
                    0.51,
                    -0.53,
                    -0.2,
                    0.64,
                    1.7236,
                    1.7236,
                    1.7236,
                    28.97,
                    -0.28,
                    -21.5,
                    0.48,
                    -0.79,
                    -0.12,
                    0.37,
                    1.6165,
                    1.6165,
                    1.6165,
                    29.05,
                    -0.28,
                    -21.5,
                    -0.53,
                    0.28,
                    0.71,
                    0.37,
                    1.8275,
                    1.8275,
                    1.8275,
                    28.40,
                    -0.28,
                    -21.17,
                    -0.05,
                    -0.34,
                    -0.01,
                    0.94,
                    1.7743,
                    1.7743,
                    1.7743,
                    28.21,
                    -0.28,
                    -21.48,
                    0.51,
                    0.27,
                    -0.81,
                    0.12,
                    1.6696,
                    1.6696,
                    1.6696,
                    28.37,
                    -0.28,
                    -21.73,
                    -0.05,
                    -0.91,
                    -0.12,
                    0.40,
                    1.6267,
                    1.6267,
                    1.6267,
                    28.33,
                    -0.28,
                    -21.3,
                    0.19,
                    -0.44,
                    -0.85,
                    0.23,
                    1.5971,
                    1.5971,
                    1.5971,
                    29.29,
                    -0.28,
                    -21.21,
                    0.41,
                    0.35,
                    -0.83,
                    0.12,
                    1.6233,
                    1.6233,
                    1.6233,
                    28.82,
                    -0.28,
                    -21.55,
                    -0.92,
                    0.21,
                    0.33,
                    0.02,
                    1.6837,
                    1.6837,
                    1.6837,
                    28.57,
                    -0.28,
                    -21.16,
                    0.53,
                    -0.41,
                    0.00,
                    0.75,
                    1.7413,
                    1.7413,
                    1.7413,
                    29.10,
                    -0.28,
                    -21.62,
                    -0.86,
                    -0.19,
                    0.38,
                    0.28,
                    1.8470,
                    1.8470,
                    1.8470,
                    28.92,
                    -0.28,
                    -21.92,
                    0.35,
                    -0.54,
                    -0.02,
                    0.76,
                    1.8475,
                    1.8475,
                    1.8475,
                    29.05,
                    -0.28,
                    -21.81,
                    0.39,
                    0.01,
                    -0.51,
                    0.77,
                    1.4996,
                    1.4996,
                    1.4996,
                    28.72,
                    -0.28,
                    -20.86,
                    0.16,
                    -0.45,
                    -0.84,
                    0.23,
                    1.5070,
                    1.5070,
                    1.5070,
                    28.85,
                    -0.28,
                    -20.91,
                    -0.54,
                    -0.35,
                    0.66,
                    0.40,
                    1.4992,
                    1.4992,
                    1.4992,
                    28.72,
                    -0.28,
                    -21.91,
                    -0.89,
                    0.17,
                    0.42,
                    0.03,
                    1.9112,
                    1.9112,
                    1.9112,
                    29.14,
                    -0.28,
                    -21.21,
                    0.84,
                    -0.34,
                    0.10,
                    0.41,
                    1.7056,
                    1.7056,
                    1.7056,
                    29.25,
                    -0.28,
                    -21.29,
                    0.67,
                    -0.62,
                    -0.11,
                    0.39,
                    1.8252,
                    1.8252,
                    1.8252,
                    29.02,
                    -0.28,
                    -21.33,
                    0.35,
                    -0.74,
                    0.32,
                    0.47,
                    1.5384,
                    1.5384,
                    1.5384,
                    28.45,
                    -0.28,
                    -20.96,
                    0.25,
                    -0.26,
                    -0.87,
                    0.33,
                    1.8763,
                    1.8763,
                    1.8763,
                    28.75,
                    -0.28,
                    -22.05,
                    0.14,
                    -0.48,
                    -0.67,
                    0.55,
                    1.5864,
                    1.5864,
                    1.5864,
                    28.15,
                    -0.28,
                    -21.67,
                    -0.29,
                    -0.25,
                    0.65,
                    0.66,
                    1.8903,
                    1.8903,
                    1.8903,
                    29.31,
                    -0.28,
                    -21.18,
                    -0.79,
                    0.38,
                    0.44,
                    0.20,
                    1.9611,
                    1.9611,
                    1.9611,
                    29.32,
                    -0.28,
                    -21.19,
                    0.85,
                    -0.13,
                    -0.28,
                    0.43,
                    1.6714,
                    1.6714,
                    1.6714,
                    28.27,
                    -0.28,
                    -21.36,
                    0.43,
                    -0.33,
                    -0.68,
                    0.49,
                    1.4028,
                    1.4028,
                    1.4028,
                    28.82,
                    -0.28,
                    -21.49,
                    -0.46,
                    -0.43,
                    0.75,
                    0.21,
                    1.7421,
                    1.7421,
                    1.7421,
                    29.02,
                    -0.28,
                    -21.79,
                    -0.25,
                    0.23,
                    0.89,
                    0.31,
                    1.9121,
                    1.9121,
                    1.9121,
                    29.23,
                    -0.28,
                    -21.65,
                    -0.65,
                    0.51,
                    0.51,
                    0.26,
                    1.9744,
                    1.9744,
                    1.9744,
                    28.81,
                    -0.28,
                    -21.01,
                    0.71,
                    0.42,
                    -0.57,
                    0.07,
                    1.9582,
                    1.9582,
                    1.9582,
                    28.28,
                    -0.28,
                    -21.6,
                    0.42,
                    -0.4,
                    -0.58,
                    0.58,
                    1.7335,
                    1.7335,
                    1.7335,
                    28.46,
                    -0.28,
                    -22.02,
                    -0.11,
                    -0.19,
                    0.05,
                    0.97,
                    1.5133,
                    1.5133,
                    1.5133,
                    29.11,
                    -0.28,
                    -21.86,
                    0.49,
                    -0.8,
                    0.16,
                    0.29,
                    1.6126,
                    1.6126,
                    1.6126,
                    28.75,
                    -0.28,
                    -21.29,
                    -0.37,
                    0.01,
                    0.85,
                    0.37,
                    1.9241,
                    1.9241,
                    1.9241,
                    29.03,
                    -0.28,
                    -21.47,
                    -0.72,
                    -0.08,
                    0.42,
                    0.54,
                    1.9477,
                    1.9477,
                    1.9477,
                    28.63,
                    -0.28,
                    -21.1,
                    -0.86,
                    -0.19,
                    0.48,
                    0.04,
                    1.8366,
                    1.8366,
                    1.8366,
                    29.17,
                    -0.28,
                    -21.44,
                    0.60,
                    -0.42,
                    -0.27,
                    0.62,
                    1.9659,
                    1.9659,
                    1.9659,
                    28.80,
                    -0.28,
                    -21.25,
                    -0.57,
                    -0.49,
                    0.28,
                    0.59,
                    1.4403,
                    1.4403,
                    1.4403,
                    28.12,
                    -0.28,
                    -21.61,
                    0.19,
                    -0.29,
                    -0.1,
                    0.93,
                    1.6723,
                    1.6723,
                    1.6723,
                    29.24,
                    -0.28,
                    -21.61,
                    0.05,
                    -0.95,
                    -0.29,
                    0.08,
                    1.8633,
                    1.8633,
                    1.8633,
                    28.46,
                    -0.28,
                    -21.27,
                    0.23,
                    -0.64,
                    -0.73,
                    0.09,
                    1.6436,
                    1.6436,
                    1.6436,
                    28.28,
                    -0.28,
                    -21.52,
                    0.48,
                    -0.28,
                    -0.51,
                    0.65,
                    1.4423,
                    1.4423,
                    1.4423,
                    29.02,
                    -0.28,
                    -21.68,
                    0.74,
                    -0.19,
                    -0.58,
                    0.30,
                    1.4343,
                    1.4343,
                    1.4343,
                    28.12,
                    -0.28,
                    -21.61,
                    0.44,
                    -0.42,
                    -0.52,
                    0.60,
                    2.0408,
                    2.0408,
                    2.0408,
                    28.89,
                    -0.28,
                    -22.15,
                    0.84,
                    0.08,
                    -0.5,
                    0.19,
                    1.7824,
                    1.7824,
                    1.7824,
                    28.96,
                    -0.28,
                    -21.21,
                    0.28,
                    -0.02,
                    -0.9,
                    0.34,
                    1.5995,
                    1.5995,
                    1.5995,
                    28.90,
                    -0.28,
                    -21.37,
                    0.28,
                    0.09,
                    -0.63,
                    0.72,
                    1.9518,
                    1.9518,
                    1.9518,
                    28.30,
                    -0.28,
                    -21.89,
                    0.78,
                    -0.13,
                    -0.31,
                    0.53,
                    2.0038,
                    2.0038,
                    2.0038,
                    29.03,
                    -0.28,
                    -21.17,
                    -0.91,
                    0.24,
                    0.31,
                    0.17,
                    1.9936,
                    1.9936,
                    1.9936,
                    29.01,
                    -0.28,
                    -21.65,
                    -0.37,
                    -0.58,
                    -0.46,
                    0.56,
                    2.0512,
                    2.0512,
                    2.0512,
                    28.95,
                    -0.28,
                    -21.13,
                    0.34,
                    -0.26,
                    -0.6,
                    0.67,
                    1.5817,
                    1.5817,
                    1.5817,
                    28.35,
                    -0.28,
                    -21.05,
                    0.53,
                    -0.48,
                    -0.18,
                    0.68,
                    1.5168,
                    1.5168,
                    1.5168,
                    28.88,
                    -0.28,
                    -22.08,
                    -0.1,
                    -0.93,
                    0.12,
                    0.32,
                    1.6488,
                    1.6488,
                    1.6488,
                    28.81,
                    -0.28,
                    -20.88,
                    -0.39,
                    0.17,
                    0.77,
                    0.47,
                    1.7924,
                    1.7924,
                    1.7924,
                    29.17,
                    -0.28,
                    -21.63,
                    0.19,
                    -0.18,
                    0.00,
                    0.97,
                    1.4356,
                    1.4356,
                    1.4356,
                    28.27,
                    -0.28,
                    -21.4,
                    -0.47,
                    -0.48,
                    0.74,
                    0.06,
                    2.0396,
                    2.0396,
                    2.0396,
                    28.34,
                    -0.28,
                    -21.07,
                    -0.08,
                    -0.51,
                    -0.4,
                    0.76,
                    1.6263,
                    1.6263,
                    1.6263,
                    28.48,
                    -0.28,
                    -21.8,
                    0.18,
                    -0.32,
                    0.16,
                    0.92,
                    1.6869,
                    1.6869,
                    1.6869,
                    28.96,
                    -0.28,
                    -21.12,
                    -0.64,
                    -0.7,
                    0.30,
                    0.14,
                    1.7767,
                    1.7767,
                    1.7767,
                    28.49,
                    -0.28,
                    -22.08,
                    0.31,
                    -0.22,
                    -0.35,
                    0.86,
                    1.7655,
                    1.7655,
                    1.7655,
                    28.18,
                    -0.28,
                    -21.77,
                    0.61,
                    -0.38,
                    -0.16,
                    0.67,
                    1.6479,
                    1.6479,
                    1.6479,
                    29.18,
                    -0.28,
                    -21.15,
                    0.29,
                    -0.39,
                    -0.79,
                    0.36,
                    1.5462,
                    1.5462,
                    1.5462,
                    28.86,
                    -0.28,
                    -21.85,
                    0.59,
                    -0.14,
                    -0.43,
                    0.67,
                    1.8973,
                    1.8973,
                    1.8973,
                    28.83,
                    -0.28,
                    -21.04,
                    -0.31,
                    -0.67,
                    0.45,
                    0.50,
                    1.6910,
                    1.6910,
                    1.6910,
                    28.78,
                    -0.28,
                    -21,
                    -0.87,
                    -0.31,
                    0.37,
                    0.12,
                    1.9010,
                    1.9010,
                    1.9010,
                    28.22,
                    -0.28,
                    -21.3,
                    0.00,
                    -0.39,
                    -0.9,
                    0.20,
                    1.4507,
                    1.4507,
                    1.4507,
                    29.03,
                    -0.28,
                    -21.71,
                    0.41,
                    0.26,
                    -0.81,
                    0.33,
                    1.5755,
                    1.5755,
                    1.5755,
                    28.25,
                    -0.28,
                    -21.17,
                    0.40,
                    -0.18,
                    -0.63,
                    0.64,
                    1.9072,
                    1.9072,
                    1.9072,
                    29.15,
                    -0.28,
                    -21.13,
                    -0.06,
                    -0.84,
                    -0.37,
                    0.39,
                    1.6819,
                    1.6819,
                    1.6819,
                    29.36,
                    -0.28,
                    -21.72,
                    0.07,
                    -0.58,
                    -0.73,
                    0.35,
                    1.9694,
                    1.9694,
                    1.9694,
                    28.66,
                    -0.28,
                    -21.88,
                    0.39,
                    -0.45,
                    -0.08,
                    0.80,
                    2.0105,
                    2.0105,
                    2.0105,
                    29.13,
                    -0.28,
                    -21.4,
                    0.52,
                    -0.23,
                    -0.55,
                    0.62,
                    1.4716,
                    1.4716,
                    1.4716,
                    29.15,
                    -0.28,
                    -21.42,
                    0.03,
                    -0.49,
                    -0.53,
                    0.69,
                    1.8722,
                    1.8722,
                    1.8722
                ];
                for(let i = 0; i < leaf_b_pqs.length / 10; ++i){
                    leaf_b_pqs[i * 10 + 0] -= $5fbffa87c50562b9$var$a.b_patch.position.x;
                    leaf_b_pqs[i * 10 + 1] -= $5fbffa87c50562b9$var$a.b_patch.position.y;
                    leaf_b_pqs[i * 10 + 2] -= $5fbffa87c50562b9$var$a.b_patch.position.z;
                    leaf_b_pqs[i * 10 + 7] = .924;
                    leaf_b_pqs[i * 10 + 8] = -0.924;
                    leaf_b_pqs[i * 10 + 9] = .924;
                }
                const leaf_b_instanced_meshes = create_instanced_meshes({
                    names: [
                        "leaf_b"
                    ],
                    pqs: leaf_b_pqs,
                    add_to_scene: false,
                    sway: true
                });
                leaf_b_instanced_meshes.forEach((instanced_mesh)=>$5fbffa87c50562b9$var$a.b_patch.add(instanced_mesh));
                const tulipa_A_b_pqs = [
                    28.90,
                    -0.34,
                    -22.58,
                    0.07,
                    -0.65,
                    0.02,
                    0.75,
                    1.4091,
                    1.4091,
                    1.4091,
                    28.58,
                    -0.34,
                    -22.57,
                    -0.1,
                    0.87,
                    -0.18,
                    0.45,
                    1.0103,
                    1.0103,
                    1.0103,
                    28.76,
                    -0.34,
                    -22.53,
                    -0.06,
                    -0.97,
                    0.05,
                    0.23,
                    1.5511,
                    1.1855,
                    1.5550,
                    28.27,
                    -0.34,
                    -22.56,
                    0.08,
                    -0.73,
                    -0.07,
                    0.67,
                    1.1322,
                    0.8774,
                    1.1432,
                    28.20,
                    -0.34,
                    -22.59,
                    0.02,
                    -0.94,
                    0.09,
                    0.32,
                    1.5026,
                    1.1490,
                    1.4919,
                    27.94,
                    -0.34,
                    -22.18,
                    0.10,
                    -0.54,
                    -0.06,
                    0.83,
                    1.5725,
                    1.2225,
                    1.5826,
                    27.81,
                    -0.34,
                    -21.94,
                    -0.09,
                    -0.75,
                    -0.14,
                    0.64,
                    1.1808,
                    1.1808,
                    1.1808,
                    27.71,
                    -0.34,
                    -21.88,
                    -0.1,
                    -0.95,
                    -0.04,
                    0.30,
                    1.1873,
                    0.9190,
                    1.1905,
                    27.42,
                    -0.34,
                    -21.29,
                    0.08,
                    -0.73,
                    0.01,
                    0.68,
                    1.2127,
                    1.2127,
                    1.2127,
                    27.70,
                    -0.34,
                    -21.56,
                    0.07,
                    -0.59,
                    -0.15,
                    0.79,
                    1.4270,
                    1.1472,
                    1.4582,
                    27.70,
                    -0.34,
                    -21.35,
                    0.05,
                    -0.94,
                    -0.15,
                    0.31,
                    1.0092,
                    1.0092,
                    1.0092,
                    27.71,
                    -0.34,
                    -21.22,
                    0.06,
                    -0.7,
                    -0.21,
                    0.67,
                    1.0001,
                    0.8300,
                    1.0213,
                    27.85,
                    -0.34,
                    -20.95,
                    0.08,
                    -0.7,
                    -0.06,
                    0.71,
                    1.3410,
                    1.3410,
                    1.3410,
                    28.06,
                    -0.34,
                    -20.71,
                    0.07,
                    -0.99,
                    -0.01,
                    0.11,
                    1.4060,
                    1.0750,
                    1.4125,
                    28.03,
                    -0.34,
                    -21.15,
                    -0.05,
                    -0.8,
                    -0.14,
                    0.59,
                    1.4355,
                    1.4355,
                    1.4355,
                    28.15,
                    -0.34,
                    -20.57,
                    -0.15,
                    -0.65,
                    -0.05,
                    0.74,
                    0.9637,
                    0.9637,
                    0.9637,
                    28.45,
                    -0.34,
                    -20.42,
                    -0.01,
                    -0.74,
                    0.09,
                    0.67,
                    1.3944,
                    1.3944,
                    1.3944,
                    28.56,
                    -0.34,
                    -20.47,
                    0.05,
                    -0.75,
                    -0.12,
                    0.65,
                    1.5040,
                    1.1748,
                    1.5161,
                    28.77,
                    -0.34,
                    -20.47,
                    0.18,
                    -0.67,
                    -0.04,
                    0.72,
                    1.1004,
                    1.1004,
                    1.1004,
                    28.98,
                    -0.34,
                    -20.52,
                    -0.06,
                    -0.64,
                    0.00,
                    0.76,
                    1.2337,
                    1.2337,
                    1.2337,
                    29.17,
                    -0.34,
                    -20.61,
                    0.04,
                    -0.98,
                    0.08,
                    0.18,
                    1.3143,
                    1.0056,
                    1.3060,
                    29.45,
                    -0.34,
                    -20.78,
                    0.06,
                    -0.66,
                    -0.18,
                    0.73,
                    1.3527,
                    1.0993,
                    1.3803,
                    29.48,
                    -0.34,
                    -20.89,
                    0.05,
                    -0.77,
                    -0.1,
                    0.63,
                    1.2252,
                    0.9484,
                    1.2331,
                    29.68,
                    -0.34,
                    -21.15,
                    0.18,
                    -0.72,
                    0.00,
                    0.67,
                    1.6243,
                    1.6243,
                    1.6243,
                    29.67,
                    -0.34,
                    -21.27,
                    -0.03,
                    -0.59,
                    0.08,
                    0.80,
                    1.1907,
                    0.9151,
                    1.1977,
                    29.70,
                    -0.34,
                    -21.48,
                    0.10,
                    -0.63,
                    0.05,
                    0.77,
                    1.1470,
                    1.1470,
                    1.1470,
                    29.69,
                    -0.34,
                    -21.69,
                    -0.08,
                    -0.59,
                    -0.05,
                    0.80,
                    1.2002,
                    1.2002,
                    1.2002,
                    29.88,
                    -0.34,
                    -22.02,
                    -0.03,
                    -0.95,
                    0.14,
                    0.27,
                    0.9822,
                    0.9822,
                    0.9822,
                    29.55,
                    -0.34,
                    -22.09,
                    0.17,
                    -0.62,
                    -0.13,
                    0.76,
                    1.0708,
                    1.0708,
                    1.0708,
                    29.43,
                    -0.34,
                    -22.26,
                    -0.01,
                    -0.77,
                    -0.09,
                    0.63,
                    1.3469,
                    1.3469,
                    1.3469,
                    29.21,
                    -0.34,
                    -22.5,
                    -0.07,
                    -0.94,
                    -0.11,
                    0.32,
                    1.3030,
                    1.3030,
                    1.3030,
                    29.09,
                    -0.34,
                    -22.51,
                    0.02,
                    -0.71,
                    0.11,
                    0.70,
                    1.5912,
                    1.2254,
                    1.5846,
                    28.66,
                    -0.34,
                    -21.86,
                    0.12,
                    -0.71,
                    -0.14,
                    0.68,
                    1.0026,
                    0.8166,
                    1.0317,
                    28.59,
                    -0.34,
                    -21.86,
                    0.04,
                    -0.63,
                    -0.01,
                    0.78,
                    1.1590,
                    1.1590,
                    1.1590,
                    28.53,
                    -0.34,
                    -21.85,
                    -0.07,
                    -0.78,
                    -0.14,
                    0.60,
                    1.1716,
                    0.9163,
                    1.1489,
                    28.47,
                    -0.34,
                    -21.82,
                    -0.13,
                    -0.78,
                    0.01,
                    0.61,
                    1.4680,
                    1.1459,
                    1.4757,
                    28.38,
                    -0.34,
                    -21.78,
                    -0.11,
                    -0.74,
                    -0.02,
                    0.66,
                    1.2467,
                    0.9635,
                    1.2438,
                    28.34,
                    -0.34,
                    -21.73,
                    -0.1,
                    -0.61,
                    0.01,
                    0.78,
                    1.1678,
                    1.1678,
                    1.1678,
                    28.34,
                    -0.34,
                    -21.69,
                    0.06,
                    -0.75,
                    0.10,
                    0.65,
                    1.2242,
                    1.2242,
                    1.2242,
                    28.32,
                    -0.34,
                    -21.64,
                    0.03,
                    -0.65,
                    -0.16,
                    0.74,
                    1.2343,
                    0.9807,
                    1.2472,
                    28.29,
                    -0.34,
                    -21.54,
                    0.07,
                    -0.64,
                    -0.16,
                    0.75,
                    1.4149,
                    1.1443,
                    1.4479,
                    28.31,
                    -0.34,
                    -21.51,
                    0.01,
                    -0.77,
                    -0.13,
                    0.62,
                    1.3528,
                    1.0539,
                    1.3504,
                    28.31,
                    -0.34,
                    -21.41,
                    0.19,
                    -0.67,
                    -0.02,
                    0.71,
                    1.1168,
                    1.1168,
                    1.1168,
                    28.34,
                    -0.34,
                    -21.36,
                    -0.05,
                    -0.7,
                    0.02,
                    0.72,
                    1.4886,
                    1.4886,
                    1.4886,
                    28.38,
                    -0.34,
                    -21.34,
                    0.02,
                    -0.69,
                    0.00,
                    0.73,
                    1.6493,
                    1.2463,
                    1.6490,
                    28.42,
                    -0.34,
                    -21.3,
                    0.11,
                    -0.63,
                    0.02,
                    0.77,
                    1.2036,
                    0.9284,
                    1.1973,
                    28.47,
                    -0.34,
                    -21.26,
                    -0.05,
                    -0.57,
                    -0.02,
                    0.82,
                    1.5759,
                    1.1959,
                    1.5719,
                    28.53,
                    -0.34,
                    -21.24,
                    0.13,
                    -0.76,
                    0.10,
                    0.63,
                    1.0094,
                    0.7909,
                    0.9895,
                    28.59,
                    -0.34,
                    -21.23,
                    0.05,
                    -0.73,
                    -0.18,
                    0.66,
                    1.0395,
                    1.0395,
                    1.0395,
                    28.69,
                    -0.34,
                    -21.21,
                    0.07,
                    -0.64,
                    -0.03,
                    0.77,
                    1.2782,
                    1.2782,
                    1.2782,
                    28.71,
                    -0.34,
                    -21.24,
                    -0.04,
                    -0.63,
                    -0.12,
                    0.77,
                    1.3625,
                    1.0585,
                    1.3557,
                    28.81,
                    -0.34,
                    -21.26,
                    0.01,
                    -0.61,
                    0.14,
                    0.78,
                    1.0549,
                    1.0549,
                    1.0549,
                    28.82,
                    -0.34,
                    -21.3,
                    0.13,
                    -0.64,
                    0.00,
                    0.75,
                    1.4937,
                    1.4937,
                    1.4937,
                    28.87,
                    -0.34,
                    -21.34,
                    -0.1,
                    -0.65,
                    -0.01,
                    0.75,
                    1.0536,
                    1.0536,
                    1.0536,
                    28.90,
                    -0.34,
                    -21.39,
                    0.03,
                    -0.72,
                    0.08,
                    0.68,
                    1.4755,
                    1.1283,
                    1.4696,
                    28.93,
                    -0.34,
                    -21.45,
                    0.05,
                    -0.68,
                    -0.1,
                    0.72,
                    1.6417,
                    1.2747,
                    1.6555,
                    28.94,
                    -0.34,
                    -21.51,
                    0.03,
                    -0.62,
                    -0.07,
                    0.78,
                    1.5520,
                    1.1854,
                    1.5576,
                    28.94,
                    -0.34,
                    -21.57,
                    -0.04,
                    -0.64,
                    -0.18,
                    0.74,
                    1.4855,
                    1.1845,
                    1.4714,
                    28.69,
                    -0.34,
                    -21.87,
                    0.09,
                    -0.72,
                    -0.21,
                    0.66,
                    1.6149,
                    1.6149,
                    1.6149,
                    28.62,
                    -0.34,
                    -22.54,
                    0.13,
                    -0.69,
                    -0.08,
                    0.71,
                    0.9494,
                    0.7550,
                    0.9667,
                    28.62,
                    -0.34,
                    -22.76,
                    0.03,
                    -0.79,
                    -0.03,
                    0.61,
                    1.3718,
                    1.0397,
                    1.3737,
                    28.69,
                    -0.34,
                    -22.24,
                    -0.08,
                    -0.61,
                    -0.11,
                    0.78,
                    1.3597,
                    1.3597,
                    1.3597,
                    28.67,
                    -0.34,
                    -21.98,
                    0.10,
                    -0.64,
                    -0.05,
                    0.76,
                    1.3788,
                    1.0700,
                    1.3900,
                    28.56,
                    -0.34,
                    -22.24,
                    -0.02,
                    -0.69,
                    0.12,
                    0.71,
                    1.2175,
                    1.2175,
                    1.2175,
                    28.55,
                    -0.34,
                    -22.36,
                    0.11,
                    -0.61,
                    -0.11,
                    0.78,
                    1.5837,
                    1.5837,
                    1.5837,
                    28.43,
                    -0.34,
                    -22.85,
                    -0.08,
                    -0.78,
                    -0.08,
                    0.61,
                    1.6015,
                    1.2311,
                    1.5855,
                    29.46,
                    -0.34,
                    -21.99,
                    -0.11,
                    -0.78,
                    -0.06,
                    0.61,
                    0.9682,
                    0.9682,
                    0.9682,
                    29.34,
                    -0.34,
                    -22.02,
                    -0.05,
                    -0.75,
                    -0.05,
                    0.66,
                    1.5830,
                    1.5830,
                    1.5830,
                    29.95,
                    -0.34,
                    -21.62,
                    -0.09,
                    -0.64,
                    0.01,
                    0.76,
                    1.5617,
                    1.1966,
                    1.5612,
                    29.13,
                    -0.34,
                    -21.81,
                    0.06,
                    -0.64,
                    0.07,
                    0.76,
                    1.4160,
                    1.4160,
                    1.4160,
                    28.95,
                    -0.34,
                    -21.87,
                    0.16,
                    -0.69,
                    -0.02,
                    0.71,
                    1.3780,
                    1.3780,
                    1.3780,
                    29.04,
                    -0.34,
                    -21.96,
                    -0,
                    -0.76,
                    -0,
                    0.65,
                    1.6189,
                    1.6189,
                    1.6189,
                    29.16,
                    -0.34,
                    -21.98,
                    0.06,
                    -0.99,
                    -0.09,
                    0.13,
                    1.4680,
                    1.1345,
                    1.4665,
                    29.23,
                    -0.34,
                    -22.15,
                    -0.13,
                    -0.6,
                    -0.04,
                    0.79,
                    1.2292,
                    0.9545,
                    1.2154,
                    29.36,
                    -0.34,
                    -22.14,
                    0.04,
                    -0.68,
                    0.11,
                    0.73,
                    1.3269,
                    1.0245,
                    1.3173,
                    28.17,
                    -0.34,
                    -20.71,
                    0.12,
                    -0.71,
                    -0.07,
                    0.69,
                    1.0519,
                    0.8288,
                    1.0673,
                    28.29,
                    -0.34,
                    -20.74,
                    0.05,
                    -0.99,
                    0.01,
                    0.15,
                    1.0717,
                    0.8148,
                    1.0737,
                    28.29,
                    -0.34,
                    -20.93,
                    -0.06,
                    -0.78,
                    -0.11,
                    0.61,
                    1.3899,
                    1.0739,
                    1.3719,
                    28.35,
                    -0.34,
                    -21.04,
                    0.17,
                    -0.59,
                    -0.03,
                    0.79,
                    1.0934,
                    1.0934,
                    1.0934,
                    28.44,
                    -0.34,
                    -21.11,
                    -0.1,
                    -0.7,
                    -0.06,
                    0.70,
                    1.5449,
                    1.5449,
                    1.5449,
                    28.49,
                    -0.34,
                    -21.12,
                    -0.02,
                    -0.69,
                    0.03,
                    0.72,
                    1.4795,
                    1.4795,
                    1.4795,
                    28.46,
                    -0.34,
                    -21,
                    0.06,
                    -0.99,
                    0.01,
                    0.14,
                    1.2747,
                    0.9695,
                    1.2775,
                    28.48,
                    -0.34,
                    -20.82,
                    0.14,
                    -0.66,
                    0.13,
                    0.73,
                    1.6175,
                    1.6175,
                    1.6175,
                    28.45,
                    -0.34,
                    -20.69,
                    0.16,
                    -0.69,
                    -0.11,
                    0.69,
                    0.9762,
                    0.9762,
                    0.9762,
                    28.43,
                    -0.34,
                    -20.31,
                    0.03,
                    -0.77,
                    -0.02,
                    0.63,
                    1.5862,
                    1.2021,
                    1.5884,
                    28.50,
                    -0.34,
                    -21.97,
                    -0.06,
                    -0.75,
                    -0.18,
                    0.64,
                    1.1031,
                    1.1031,
                    1.1031,
                    28.39,
                    -0.34,
                    -22.09,
                    0.17,
                    -0.98,
                    0.02,
                    0.09,
                    0.9786,
                    0.7898,
                    1.0022,
                    28.42,
                    -0.34,
                    -22.21,
                    0.05,
                    -0.63,
                    0.06,
                    0.78,
                    1.5803,
                    1.5803,
                    1.5803,
                    28.29,
                    -0.34,
                    -22.34,
                    0.23,
                    -0.74,
                    -0.03,
                    0.63,
                    1.2782,
                    1.2782,
                    1.2782,
                    28.41,
                    -0.34,
                    -22.96,
                    -0.02,
                    -0.63,
                    0.11,
                    0.77,
                    1.5398,
                    1.1906,
                    1.5471,
                    28.88,
                    -0.34,
                    -21.93,
                    0.15,
                    -0.63,
                    -0.02,
                    0.76,
                    1.0315,
                    0.8124,
                    1.0345,
                    28.99,
                    -0.34,
                    -21.98,
                    -0.15,
                    -0.73,
                    0.01,
                    0.67,
                    0.9736,
                    0.7673,
                    0.9764,
                    29.07,
                    -0.34,
                    -22.08,
                    -0.05,
                    -0.77,
                    0.02,
                    0.63,
                    1.4050,
                    1.4050,
                    1.4050,
                    29.10,
                    -0.34,
                    -22.26,
                    -0.08,
                    -0.68,
                    -0.09,
                    0.73,
                    1.3657,
                    1.3657,
                    1.3657,
                    29.17,
                    -0.34,
                    -22.37,
                    -0.03,
                    -0.72,
                    0.11,
                    0.69,
                    1.5464,
                    1.5464,
                    1.5464,
                    28.62,
                    -0.34,
                    -21.07,
                    0.03,
                    -0.74,
                    -0.05,
                    0.67,
                    1.0690,
                    1.0690,
                    1.0690,
                    28.62,
                    -0.34,
                    -20.94,
                    0.13,
                    -0.59,
                    -0.04,
                    0.80,
                    1.6336,
                    1.6336,
                    1.6336,
                    28.55,
                    -0.34,
                    -20.85,
                    -0.12,
                    -0.8,
                    -0.05,
                    0.59,
                    1.3334,
                    1.0344,
                    1.3243,
                    28.54,
                    -0.34,
                    -20.72,
                    -0.11,
                    -0.77,
                    -0.05,
                    0.63,
                    1.2509,
                    1.2509,
                    1.2509,
                    28.53,
                    -0.34,
                    -20.6,
                    -0.06,
                    -0.72,
                    -0.05,
                    0.69,
                    1.0405,
                    0.7931,
                    1.0351,
                    28.36,
                    -0.34,
                    -21.93,
                    -0,
                    -0.63,
                    -0.03,
                    0.77,
                    1.3616,
                    1.3616,
                    1.3616,
                    28.29,
                    -0.34,
                    -22.04,
                    0.07,
                    -0.77,
                    0.08,
                    0.63,
                    1.3131,
                    1.3131,
                    1.3131,
                    28.30,
                    -0.34,
                    -22.86,
                    0.03,
                    -0.77,
                    -0.18,
                    0.61,
                    1.5453,
                    1.5453,
                    1.5453,
                    28.14,
                    -0.34,
                    -22.47,
                    0.12,
                    -0.73,
                    -0,
                    0.67,
                    1.2278,
                    1.2278,
                    1.2278,
                    27.92,
                    -0.34,
                    -22.82,
                    0.04,
                    -0.77,
                    0.04,
                    0.64,
                    1.1049,
                    0.8378,
                    1.1021,
                    28.83,
                    -0.34,
                    -21.93,
                    -0.01,
                    -0.76,
                    -0.12,
                    0.64,
                    1.5892,
                    1.5892,
                    1.5892,
                    28.89,
                    -0.34,
                    -22.04,
                    0.17,
                    -0.66,
                    -0.02,
                    0.73,
                    1.4743,
                    1.1773,
                    1.4803,
                    28.90,
                    -0.34,
                    -22.22,
                    -0.04,
                    -0.65,
                    -0.02,
                    0.76,
                    1.0147,
                    0.7685,
                    1.0134,
                    28.95,
                    -0.34,
                    -22.34,
                    0.04,
                    -0.67,
                    0.09,
                    0.74,
                    1.5792,
                    1.5792,
                    1.5792,
                    29.00,
                    -0.34,
                    -22.46,
                    0.13,
                    -0.61,
                    -0.05,
                    0.78,
                    1.1942,
                    0.9399,
                    1.2039,
                    28.71,
                    -0.34,
                    -21.08,
                    -0.09,
                    -0.65,
                    -0.06,
                    0.75,
                    1.6464,
                    1.6464,
                    1.6464,
                    28.74,
                    -0.34,
                    -20.95,
                    0.00,
                    -0.73,
                    0.12,
                    0.67,
                    1.4308,
                    1.4308,
                    1.4308,
                    28.76,
                    -0.34,
                    -20.82,
                    0.05,
                    -0.69,
                    -0.12,
                    0.71,
                    1.3414,
                    1.0509,
                    1.3563,
                    28.79,
                    -0.34,
                    -20.69,
                    0.13,
                    -0.96,
                    -0.06,
                    0.26,
                    1.1720,
                    1.1720,
                    1.1720,
                    28.81,
                    -0.34,
                    -20.56,
                    0.07,
                    -0.78,
                    -0.12,
                    0.62,
                    1.5780,
                    1.5780,
                    1.5780,
                    28.29,
                    -0.34,
                    -21.87,
                    0.10,
                    -0.82,
                    0.01,
                    0.57,
                    0.9901,
                    0.9901,
                    0.9901,
                    28.20,
                    -0.34,
                    -21.96,
                    0.08,
                    -0.67,
                    0.17,
                    0.72,
                    1.5524,
                    1.5524,
                    1.5524,
                    28.18,
                    -0.34,
                    -22.08,
                    0.20,
                    -0.97,
                    -0.01,
                    0.11,
                    1.2710,
                    1.2710,
                    1.2710,
                    28.01,
                    -0.34,
                    -22.15,
                    0.08,
                    -0.66,
                    0.05,
                    0.74,
                    0.9762,
                    0.7481,
                    0.9683,
                    28.02,
                    -0.34,
                    -22.28,
                    0.19,
                    -0.67,
                    -0.06,
                    0.71,
                    0.9896,
                    0.8068,
                    1.0069,
                    28.75,
                    -0.34,
                    -21.97,
                    -0.04,
                    -0.63,
                    0.02,
                    0.77,
                    1.6191,
                    1.6191,
                    1.6191,
                    28.79,
                    -0.34,
                    -22.09,
                    0.12,
                    -0.77,
                    0.06,
                    0.63,
                    1.4660,
                    1.4660,
                    1.4660,
                    28.83,
                    -0.34,
                    -22.21,
                    0.02,
                    -0.74,
                    -0.19,
                    0.65,
                    1.6011,
                    1.2896,
                    1.6032,
                    28.79,
                    -0.34,
                    -22.39,
                    0.14,
                    -0.94,
                    0.00,
                    0.32,
                    1.0176,
                    0.8013,
                    1.0304,
                    28.81,
                    -0.34,
                    -22.52,
                    -0.1,
                    -0.71,
                    -0.06,
                    0.69,
                    1.4231,
                    1.0970,
                    1.4082,
                    28.80,
                    -0.34,
                    -21.11,
                    -0.05,
                    -0.76,
                    0.04,
                    0.64,
                    1.5518,
                    1.5518,
                    1.5518,
                    28.79,
                    -0.34,
                    -21,
                    -0.03,
                    -0.76,
                    -0.06,
                    0.65,
                    1.1749,
                    0.8933,
                    1.1709,
                    28.82,
                    -0.34,
                    -20.87,
                    -0.16,
                    -0.74,
                    -0.03,
                    0.65,
                    1.5737,
                    1.2461,
                    1.5642,
                    28.86,
                    -0.34,
                    -20.75,
                    -0.07,
                    -0.66,
                    0.00,
                    0.75,
                    1.5011,
                    1.5011,
                    1.5011,
                    29.00,
                    -0.34,
                    -20.62,
                    0.07,
                    -0.69,
                    0.03,
                    0.72,
                    1.4196,
                    1.4196,
                    1.4196,
                    28.23,
                    -0.34,
                    -21.8,
                    0.12,
                    -0.79,
                    -0.07,
                    0.60,
                    1.3304,
                    1.0502,
                    1.3524,
                    28.18,
                    -0.34,
                    -21.91,
                    0.02,
                    -0.96,
                    0.13,
                    0.26,
                    1.3598,
                    1.0510,
                    1.3413,
                    28.01,
                    -0.34,
                    -21.95,
                    0.13,
                    -0.79,
                    -0.09,
                    0.59,
                    1.1879,
                    1.1879,
                    1.1879,
                    27.90,
                    -0.34,
                    -22.02,
                    0.11,
                    -0.75,
                    0.05,
                    0.66,
                    0.9896,
                    0.7635,
                    0.9823,
                    28.19,
                    -0.34,
                    -23.18,
                    0.10,
                    -0.73,
                    -0.24,
                    0.63,
                    1.3089,
                    1.1262,
                    1.3553,
                    28.88,
                    -0.34,
                    -21.15,
                    0.13,
                    -0.78,
                    -0.07,
                    0.61,
                    1.6196,
                    1.6196,
                    1.6196,
                    29.03,
                    -0.34,
                    -20.93,
                    0.02,
                    -0.62,
                    -0.17,
                    0.77,
                    1.3658,
                    1.3658,
                    1.3658,
                    29.10,
                    -0.34,
                    -20.82,
                    0.01,
                    -0.75,
                    -0.12,
                    0.65,
                    1.5990,
                    1.2393,
                    1.5979,
                    29.17,
                    -0.34,
                    -20.71,
                    0.16,
                    -0.76,
                    -0.05,
                    0.63,
                    1.5392,
                    1.2330,
                    1.5646,
                    28.23,
                    -0.34,
                    -21.75,
                    0.06,
                    -0.67,
                    0.07,
                    0.73,
                    1.1772,
                    1.1772,
                    1.1772,
                    28.12,
                    -0.34,
                    -20.35,
                    0.17,
                    -0.97,
                    0.00,
                    0.16,
                    1.6246,
                    1.6246,
                    1.6246,
                    28.01,
                    -0.34,
                    -21.87,
                    0.08,
                    -0.71,
                    0.03,
                    0.70,
                    1.2697,
                    1.2697,
                    1.2697,
                    27.82,
                    -0.34,
                    -21.87,
                    0.09,
                    -0.61,
                    -0.14,
                    0.77,
                    1.5017,
                    1.5017,
                    1.5017,
                    27.70,
                    -0.34,
                    -21.92,
                    -0.02,
                    -0.68,
                    -0.14,
                    0.72,
                    1.0908,
                    1.0908,
                    1.0908,
                    28.90,
                    -0.34,
                    -21.2,
                    0.15,
                    -0.94,
                    -0.09,
                    0.30,
                    1.3676,
                    1.1079,
                    1.4013,
                    29.23,
                    -0.34,
                    -20.93,
                    -0.07,
                    -0.96,
                    -0.12,
                    0.23,
                    1.1164,
                    1.1164,
                    1.1164,
                    29.22,
                    -0.34,
                    -20.81,
                    -0.05,
                    -0.77,
                    0.06,
                    0.63,
                    1.3503,
                    1.3503,
                    1.3503,
                    28.20,
                    -0.34,
                    -21.67,
                    -0.03,
                    -0.76,
                    -0.1,
                    0.64,
                    1.5210,
                    1.1689,
                    1.5109,
                    28.03,
                    -0.34,
                    -21.66,
                    0.26,
                    -0.94,
                    0.08,
                    0.20,
                    1.3851,
                    1.2028,
                    1.4323,
                    27.90,
                    -0.34,
                    -21.68,
                    -0.02,
                    -0.65,
                    0.04,
                    0.76,
                    1.2204,
                    1.2204,
                    1.2204,
                    27.84,
                    -0.34,
                    -21.78,
                    0.11,
                    -0.69,
                    0.03,
                    0.72,
                    1.0206,
                    0.7869,
                    1.0140,
                    27.64,
                    -0.34,
                    -20.85,
                    -0.13,
                    -0.63,
                    0.08,
                    0.76,
                    0.8469,
                    0.8469,
                    0.8469,
                    29.01,
                    -0.34,
                    -21.28,
                    0.05,
                    -0.78,
                    0.03,
                    0.62,
                    1.0512,
                    0.7984,
                    1.0490,
                    29.12,
                    -0.34,
                    -21.21,
                    -0.03,
                    -0.66,
                    -0.22,
                    0.72,
                    1.5358,
                    1.5358,
                    1.5358,
                    29.16,
                    -0.34,
                    -21.1,
                    0.12,
                    -0.71,
                    -0.18,
                    0.67,
                    1.5292,
                    1.2775,
                    1.5859,
                    29.34,
                    -0.34,
                    -21.06,
                    0.06,
                    -0.74,
                    -0.03,
                    0.67,
                    1.2114,
                    1.2114,
                    1.2114,
                    29.35,
                    -0.34,
                    -20.94,
                    0.05,
                    -0.93,
                    0.07,
                    0.35,
                    1.1396,
                    0.8702,
                    1.1330,
                    28.15,
                    -0.34,
                    -21.54,
                    0.19,
                    -0.6,
                    -0.04,
                    0.78,
                    1.2443,
                    1.0089,
                    1.2517,
                    28.02,
                    -0.34,
                    -21.54,
                    -0.08,
                    -0.62,
                    -0.05,
                    0.78,
                    1.1299,
                    1.1299,
                    1.1299,
                    27.93,
                    -0.34,
                    -21.61,
                    0.04,
                    -0.73,
                    0.13,
                    0.67,
                    1.2487,
                    1.2487,
                    1.2487,
                    27.76,
                    -0.34,
                    -21.54,
                    0.09,
                    -0.77,
                    -0.13,
                    0.62,
                    1.2010,
                    0.9582,
                    1.2220,
                    27.68,
                    -0.34,
                    -21.64,
                    0.13,
                    -0.71,
                    0.01,
                    0.70,
                    1.0143,
                    0.7890,
                    1.0121,
                    29.05,
                    -0.34,
                    -21.36,
                    -0.06,
                    -0.72,
                    0.09,
                    0.69,
                    1.0046,
                    0.7768,
                    1.0128,
                    29.12,
                    -0.34,
                    -21.27,
                    0.00,
                    -0.74,
                    -0.03,
                    0.67,
                    1.2823,
                    1.2823,
                    1.2823,
                    29.30,
                    -0.34,
                    -21.26,
                    0.07,
                    -0.55,
                    -0.02,
                    0.83,
                    0.9996,
                    0.7629,
                    0.9997,
                    29.35,
                    -0.34,
                    -21.15,
                    -0.14,
                    -0.68,
                    -0.14,
                    0.71,
                    1.5760,
                    1.2517,
                    1.5274,
                    29.54,
                    -0.34,
                    -21.16,
                    -0.08,
                    -0.97,
                    0.05,
                    0.23,
                    1.3597,
                    1.0485,
                    1.3687,
                    28.18,
                    -0.34,
                    -21.5,
                    0.08,
                    -0.99,
                    -0.01,
                    0.13,
                    1.0622,
                    1.0622,
                    1.0622,
                    27.88,
                    -0.34,
                    -21.57,
                    0.14,
                    -0.78,
                    -0.19,
                    0.57,
                    1.3905,
                    1.1810,
                    1.4447,
                    27.80,
                    -0.34,
                    -20.59,
                    0.11,
                    -0.62,
                    0.01,
                    0.77,
                    1.6123,
                    1.6123,
                    1.6123,
                    27.18,
                    -0.34,
                    -21.05,
                    -0.15,
                    -0.73,
                    -0.04,
                    0.66,
                    1.3936,
                    1.3936,
                    1.3936,
                    29.08,
                    -0.34,
                    -21.45,
                    -0.07,
                    -0.67,
                    0.01,
                    0.74,
                    1.2582,
                    0.9594,
                    1.2592,
                    29.21,
                    -0.34,
                    -21.42,
                    0.03,
                    -0.97,
                    0.05,
                    0.25,
                    1.2022,
                    0.9119,
                    1.1995,
                    29.34,
                    -0.34,
                    -21.4,
                    0.16,
                    -0.73,
                    -0.1,
                    0.66,
                    1.4110,
                    1.1539,
                    1.4528,
                    29.41,
                    -0.34,
                    -21.3,
                    0.08,
                    -0.78,
                    0.00,
                    0.62,
                    1.1572,
                    0.8843,
                    1.1585,
                    29.60,
                    -0.34,
                    -21.35,
                    -0,
                    -0.58,
                    -0.16,
                    0.80,
                    1.0854,
                    1.0854,
                    1.0854,
                    28.19,
                    -0.34,
                    -21.36,
                    0.13,
                    -0.93,
                    -0.18,
                    0.29,
                    1.1956,
                    0.9941,
                    1.2113,
                    28.07,
                    -0.34,
                    -21.31,
                    0.08,
                    -0.63,
                    -0.18,
                    0.75,
                    1.5137,
                    1.5137,
                    1.5137,
                    27.83,
                    -0.34,
                    -20.71,
                    0.06,
                    -0.63,
                    -0.21,
                    0.74,
                    1.3425,
                    1.3425,
                    1.3425,
                    27.18,
                    -0.34,
                    -20.88,
                    0.05,
                    -0.62,
                    -0.16,
                    0.77,
                    1.2067,
                    0.9706,
                    1.2299,
                    29.06,
                    -0.34,
                    -21.5,
                    -0.01,
                    -0.65,
                    -0.14,
                    0.75,
                    1.5960,
                    1.2517,
                    1.5944,
                    29.22,
                    -0.34,
                    -21.54,
                    0.10,
                    -0.74,
                    -0.19,
                    0.63,
                    1.3150,
                    1.0946,
                    1.3522,
                    29.35,
                    -0.34,
                    -21.54,
                    0.14,
                    -0.63,
                    -0.07,
                    0.76,
                    1.2840,
                    1.0232,
                    1.3031,
                    29.44,
                    -0.34,
                    -21.46,
                    -0.09,
                    -0.64,
                    -0.07,
                    0.76,
                    1.0546,
                    1.0546,
                    1.0546,
                    29.57,
                    -0.34,
                    -21.45,
                    0.00,
                    -0.7,
                    0.14,
                    0.70,
                    1.2020,
                    0.9433,
                    1.2012,
                    28.23,
                    -0.34,
                    -21.28,
                    0.09,
                    -0.76,
                    -0.09,
                    0.64,
                    1.5492,
                    1.2125,
                    1.5699,
                    28.12,
                    -0.34,
                    -21.21,
                    0.06,
                    -0.98,
                    0.09,
                    0.19,
                    0.9944,
                    0.7637,
                    0.9879,
                    26.79,
                    -0.34,
                    -21.45,
                    0.01,
                    -0.78,
                    -0.06,
                    0.62,
                    1.4453,
                    1.0998,
                    1.4460,
                    27.78,
                    -0.34,
                    -21.1,
                    0.14,
                    -0.62,
                    0.06,
                    0.77,
                    1.2649,
                    1.2649,
                    1.2649,
                    29.34,
                    -0.34,
                    -21.68,
                    -0.15,
                    -0.63,
                    0.01,
                    0.77,
                    1.2429,
                    1.2429,
                    1.2429,
                    29.47,
                    -0.34,
                    -21.71,
                    0.02,
                    -0.98,
                    0.08,
                    0.16,
                    1.1404,
                    1.1404,
                    1.1404,
                    29.57,
                    -0.34,
                    -21.63,
                    0.05,
                    -0.74,
                    -0.16,
                    0.65,
                    1.0533,
                    1.0533,
                    1.0533,
                    28.29,
                    -0.34,
                    -21.21,
                    0.18,
                    -0.71,
                    -0.08,
                    0.67,
                    1.1631,
                    1.1631,
                    1.1631,
                    28.20,
                    -0.34,
                    -21.12,
                    -0.02,
                    -0.77,
                    0.07,
                    0.63,
                    1.0832,
                    1.0832,
                    1.0832,
                    28.10,
                    -0.34,
                    -21.02,
                    -0.02,
                    -0.78,
                    -0.12,
                    0.62,
                    1.0852,
                    0.8411,
                    1.0785,
                    27.98,
                    -0.34,
                    -21.02,
                    0.20,
                    -0.71,
                    -0.01,
                    0.68,
                    1.0887,
                    0.8851,
                    1.0950,
                    27.91,
                    -0.34,
                    -20.83,
                    0.00,
                    -0.75,
                    0.03,
                    0.66,
                    0.9932,
                    0.9932,
                    0.9932,
                    29.29,
                    -0.34,
                    -21.74,
                    0.09,
                    -0.98,
                    -0.08,
                    0.13,
                    1.0994,
                    1.0994,
                    1.0994,
                    29.51,
                    -0.34,
                    -22.63,
                    0.20,
                    -0.77,
                    -0.01,
                    0.61,
                    1.5019,
                    1.5019,
                    1.5019,
                    29.54,
                    -0.34,
                    -21.92,
                    0.00,
                    -0.72,
                    0.14,
                    0.68,
                    0.9918,
                    0.7778,
                    0.9908,
                    28.34,
                    -0.34,
                    -21.2,
                    0.09,
                    -0.77,
                    -0.11,
                    0.62,
                    1.0279,
                    1.0279,
                    1.0279,
                    28.26,
                    -0.34,
                    -21.1,
                    0.11,
                    -0.68,
                    0.07,
                    0.72,
                    1.3090,
                    1.3090,
                    1.3090,
                    28.21,
                    -0.34,
                    -20.93,
                    -0.08,
                    -0.8,
                    0.04,
                    0.60,
                    1.5588,
                    1.5588,
                    1.5588,
                    28.14,
                    -0.34,
                    -20.41,
                    -0.03,
                    -0.7,
                    -0.12,
                    0.70,
                    1.4110,
                    1.4110,
                    1.4110,
                    28.02,
                    -0.34,
                    -20.81,
                    -0.06,
                    -0.61,
                    0.07,
                    0.79,
                    1.4081,
                    1.4081,
                    1.4081,
                    27.74,
                    -0.34,
                    -23.17,
                    0.04,
                    -0.77,
                    0.04,
                    0.64,
                    1.1049,
                    0.8378,
                    1.1021,
                    27.04,
                    -0.34,
                    -21.48,
                    0.01,
                    -0.78,
                    -0.06,
                    0.62,
                    1.4453,
                    1.0998,
                    1.4460,
                    26.94,
                    -0.34,
                    -21.4,
                    0.04,
                    -0.96,
                    -0.05,
                    0.26,
                    1.7294,
                    1.3160,
                    1.7303,
                    27.27,
                    -0.34,
                    -21.41,
                    -0.06,
                    0.86,
                    0.01,
                    0.50,
                    1.7294,
                    1.3160,
                    1.7303,
                    28.39,
                    -0.34,
                    -23.13,
                    -0.02,
                    -0.63,
                    0.11,
                    0.77,
                    1.5398,
                    1.1906,
                    1.5471,
                    27.58,
                    -0.34,
                    -20.87,
                    -0.1,
                    -0.38,
                    0.12,
                    0.91,
                    1.4774,
                    1.4774,
                    1.4774,
                    28.59,
                    -0.34,
                    -20.07,
                    0.03,
                    -0.77,
                    -0.02,
                    0.63,
                    1.5862,
                    1.2021,
                    1.5884,
                    29.32,
                    -0.34,
                    -20.27,
                    -0.04,
                    0.99,
                    -0.01,
                    0.12,
                    1.5862,
                    1.2021,
                    1.5884,
                    29.57,
                    -0.34,
                    -20.54,
                    -0.04,
                    0.99,
                    -0.01,
                    0.12,
                    1.5862,
                    1.2021,
                    1.5884,
                    29.86,
                    -0.34,
                    -20.89,
                    -0.04,
                    0.99,
                    -0.01,
                    0.12,
                    1.5862,
                    1.2021,
                    1.5884,
                    29.91,
                    -0.34,
                    -20.75,
                    -0.04,
                    0.99,
                    -0.01,
                    0.12,
                    1.5862,
                    1.2021,
                    1.5884,
                    29.94,
                    -0.34,
                    -21.3,
                    -0.04,
                    0.99,
                    -0.01,
                    0.12,
                    1.5862,
                    1.2021,
                    1.5884,
                    30.05,
                    -0.34,
                    -21.5,
                    -0.05,
                    0.22,
                    0.07,
                    0.97,
                    1.2693,
                    0.9725,
                    1.2689,
                    29.96,
                    -0.34,
                    -21.96,
                    -0.08,
                    -0.96,
                    -0.04,
                    0.27,
                    1.7937,
                    1.3743,
                    1.7931,
                    29.76,
                    -0.34,
                    -22.7,
                    -0.08,
                    -0.96,
                    -0.04,
                    0.27,
                    1.7937,
                    1.3743,
                    1.7931,
                    29.81,
                    -0.34,
                    -22.52,
                    -0.08,
                    -0.96,
                    -0.04,
                    0.27,
                    1.7937,
                    1.3743,
                    1.7931,
                    29.63,
                    -0.34,
                    -22.6,
                    -0.08,
                    -0.96,
                    -0.04,
                    0.27,
                    1.7937,
                    1.3743,
                    1.7931,
                    26.70,
                    -0.34,
                    -21.51,
                    0.04,
                    -0.96,
                    -0.05,
                    0.26,
                    1.7294,
                    1.3160,
                    1.7303,
                    26.92,
                    -0.34,
                    -21.49,
                    -0.05,
                    0.26,
                    -0.04,
                    0.96,
                    1.3866,
                    1.0551,
                    1.3873
                ];
                for(let i = 0; i < tulipa_A_b_pqs.length / 10; ++i){
                    tulipa_A_b_pqs[i * 10 + 0] -= $5fbffa87c50562b9$var$a.b_patch.position.x;
                    tulipa_A_b_pqs[i * 10 + 1] -= $5fbffa87c50562b9$var$a.b_patch.position.y;
                    tulipa_A_b_pqs[i * 10 + 2] -= $5fbffa87c50562b9$var$a.b_patch.position.z;
                    tulipa_A_b_pqs[i * 10 + 7] = 1.409;
                    tulipa_A_b_pqs[i * 10 + 8] = 1.409;
                    tulipa_A_b_pqs[i * 10 + 9] = 1.409;
                }
                const tulipa_A_b_instanced_meshes = create_instanced_meshes({
                    names: [
                        "tulipa_A_b"
                    ],
                    pqs: tulipa_A_b_pqs,
                    add_to_scene: false,
                    sway: true
                });
                tulipa_A_b_instanced_meshes.forEach((instanced_mesh)=>$5fbffa87c50562b9$var$a.b_patch.add(instanced_mesh));
                const tulipa_J_b_pqs = [
                    28.90,
                    -0.34,
                    -22.58,
                    0.07,
                    -0.65,
                    0.02,
                    0.75,
                    1.4091,
                    1.4091,
                    1.4091,
                    28.58,
                    -0.34,
                    -22.57,
                    -0.1,
                    0.87,
                    -0.18,
                    0.45,
                    1.0103,
                    1.0103,
                    1.0103,
                    28.76,
                    -0.34,
                    -22.53,
                    -0.06,
                    -0.97,
                    0.05,
                    0.23,
                    1.5511,
                    1.1855,
                    1.5550,
                    28.27,
                    -0.34,
                    -22.56,
                    0.08,
                    -0.73,
                    -0.07,
                    0.67,
                    1.1322,
                    0.8774,
                    1.1432,
                    28.20,
                    -0.34,
                    -22.59,
                    0.02,
                    -0.94,
                    0.09,
                    0.32,
                    1.5026,
                    1.1490,
                    1.4919,
                    27.94,
                    -0.34,
                    -22.18,
                    0.10,
                    -0.54,
                    -0.06,
                    0.83,
                    1.5725,
                    1.2225,
                    1.5826,
                    27.81,
                    -0.34,
                    -21.94,
                    -0.09,
                    -0.75,
                    -0.14,
                    0.64,
                    1.1808,
                    1.1808,
                    1.1808,
                    27.71,
                    -0.34,
                    -21.88,
                    -0.1,
                    -0.95,
                    -0.04,
                    0.30,
                    1.1873,
                    0.9190,
                    1.1905,
                    27.42,
                    -0.34,
                    -21.29,
                    0.08,
                    -0.73,
                    0.01,
                    0.68,
                    1.2127,
                    1.2127,
                    1.2127,
                    27.70,
                    -0.34,
                    -21.56,
                    0.07,
                    -0.59,
                    -0.15,
                    0.79,
                    1.4270,
                    1.1472,
                    1.4582,
                    27.70,
                    -0.34,
                    -21.35,
                    0.05,
                    -0.94,
                    -0.15,
                    0.31,
                    1.0092,
                    1.0092,
                    1.0092,
                    27.71,
                    -0.34,
                    -21.22,
                    0.06,
                    -0.7,
                    -0.21,
                    0.67,
                    1.0001,
                    0.8300,
                    1.0213,
                    27.85,
                    -0.34,
                    -20.95,
                    0.08,
                    -0.7,
                    -0.06,
                    0.71,
                    1.3410,
                    1.3410,
                    1.3410,
                    28.06,
                    -0.34,
                    -20.71,
                    0.07,
                    -0.99,
                    -0.01,
                    0.11,
                    1.4060,
                    1.0750,
                    1.4125,
                    28.03,
                    -0.34,
                    -21.15,
                    -0.05,
                    -0.8,
                    -0.14,
                    0.59,
                    1.4355,
                    1.4355,
                    1.4355,
                    28.15,
                    -0.34,
                    -20.57,
                    -0.15,
                    -0.65,
                    -0.05,
                    0.74,
                    0.9637,
                    0.9637,
                    0.9637,
                    28.45,
                    -0.34,
                    -20.42,
                    -0.01,
                    -0.74,
                    0.09,
                    0.67,
                    1.3944,
                    1.3944,
                    1.3944,
                    28.56,
                    -0.34,
                    -20.47,
                    0.05,
                    -0.75,
                    -0.12,
                    0.65,
                    1.5040,
                    1.1748,
                    1.5161,
                    28.77,
                    -0.34,
                    -20.47,
                    0.18,
                    -0.67,
                    -0.04,
                    0.72,
                    1.1004,
                    1.1004,
                    1.1004,
                    28.98,
                    -0.34,
                    -20.52,
                    -0.06,
                    -0.64,
                    0.00,
                    0.76,
                    1.2337,
                    1.2337,
                    1.2337,
                    29.17,
                    -0.34,
                    -20.61,
                    0.04,
                    -0.98,
                    0.08,
                    0.18,
                    1.3143,
                    1.0056,
                    1.3060,
                    29.45,
                    -0.34,
                    -20.78,
                    0.06,
                    -0.66,
                    -0.18,
                    0.73,
                    1.3527,
                    1.0993,
                    1.3803,
                    29.48,
                    -0.34,
                    -20.89,
                    0.05,
                    -0.77,
                    -0.1,
                    0.63,
                    1.2252,
                    0.9484,
                    1.2331,
                    29.68,
                    -0.34,
                    -21.15,
                    0.18,
                    -0.72,
                    0.00,
                    0.67,
                    1.6243,
                    1.6243,
                    1.6243,
                    29.67,
                    -0.34,
                    -21.27,
                    -0.03,
                    -0.59,
                    0.08,
                    0.80,
                    1.1907,
                    0.9151,
                    1.1977,
                    29.70,
                    -0.34,
                    -21.48,
                    0.10,
                    -0.63,
                    0.05,
                    0.77,
                    1.1470,
                    1.1470,
                    1.1470,
                    29.69,
                    -0.34,
                    -21.69,
                    -0.08,
                    -0.59,
                    -0.05,
                    0.80,
                    1.2002,
                    1.2002,
                    1.2002,
                    29.88,
                    -0.34,
                    -22.02,
                    -0.03,
                    -0.95,
                    0.14,
                    0.27,
                    0.9822,
                    0.9822,
                    0.9822,
                    29.55,
                    -0.34,
                    -22.09,
                    0.17,
                    -0.62,
                    -0.13,
                    0.76,
                    1.0708,
                    1.0708,
                    1.0708,
                    29.43,
                    -0.34,
                    -22.26,
                    -0.01,
                    -0.77,
                    -0.09,
                    0.63,
                    1.3469,
                    1.3469,
                    1.3469,
                    29.21,
                    -0.34,
                    -22.5,
                    -0.07,
                    -0.94,
                    -0.11,
                    0.32,
                    1.3030,
                    1.3030,
                    1.3030,
                    29.09,
                    -0.34,
                    -22.51,
                    0.02,
                    -0.71,
                    0.11,
                    0.70,
                    1.5912,
                    1.2254,
                    1.5846,
                    28.66,
                    -0.34,
                    -21.86,
                    0.12,
                    -0.71,
                    -0.14,
                    0.68,
                    1.0026,
                    0.8166,
                    1.0317,
                    28.59,
                    -0.34,
                    -21.86,
                    0.04,
                    -0.63,
                    -0.01,
                    0.78,
                    1.1590,
                    1.1590,
                    1.1590,
                    28.53,
                    -0.34,
                    -21.85,
                    -0.07,
                    -0.78,
                    -0.14,
                    0.60,
                    1.1716,
                    0.9163,
                    1.1489,
                    28.47,
                    -0.34,
                    -21.82,
                    -0.13,
                    -0.78,
                    0.01,
                    0.61,
                    1.4680,
                    1.1459,
                    1.4757,
                    28.38,
                    -0.34,
                    -21.78,
                    -0.11,
                    -0.74,
                    -0.02,
                    0.66,
                    1.2467,
                    0.9635,
                    1.2438,
                    28.34,
                    -0.34,
                    -21.73,
                    -0.1,
                    -0.61,
                    0.01,
                    0.78,
                    1.1678,
                    1.1678,
                    1.1678,
                    28.34,
                    -0.34,
                    -21.69,
                    0.06,
                    -0.75,
                    0.10,
                    0.65,
                    1.2242,
                    1.2242,
                    1.2242,
                    28.32,
                    -0.34,
                    -21.64,
                    0.03,
                    -0.65,
                    -0.16,
                    0.74,
                    1.2343,
                    0.9807,
                    1.2472,
                    28.29,
                    -0.34,
                    -21.54,
                    0.07,
                    -0.64,
                    -0.16,
                    0.75,
                    1.4149,
                    1.1443,
                    1.4479,
                    28.31,
                    -0.34,
                    -21.51,
                    0.01,
                    -0.77,
                    -0.13,
                    0.62,
                    1.3528,
                    1.0539,
                    1.3504,
                    28.31,
                    -0.34,
                    -21.41,
                    0.19,
                    -0.67,
                    -0.02,
                    0.71,
                    1.1168,
                    1.1168,
                    1.1168,
                    28.34,
                    -0.34,
                    -21.36,
                    -0.05,
                    -0.7,
                    0.02,
                    0.72,
                    1.4886,
                    1.4886,
                    1.4886,
                    28.38,
                    -0.34,
                    -21.34,
                    0.02,
                    -0.69,
                    0.00,
                    0.73,
                    1.6493,
                    1.2463,
                    1.6490,
                    28.42,
                    -0.34,
                    -21.3,
                    0.11,
                    -0.63,
                    0.02,
                    0.77,
                    1.2036,
                    0.9284,
                    1.1973,
                    28.47,
                    -0.34,
                    -21.26,
                    -0.05,
                    -0.57,
                    -0.02,
                    0.82,
                    1.5759,
                    1.1959,
                    1.5719,
                    28.53,
                    -0.34,
                    -21.24,
                    0.13,
                    -0.76,
                    0.10,
                    0.63,
                    1.0094,
                    0.7909,
                    0.9895,
                    28.59,
                    -0.34,
                    -21.23,
                    0.05,
                    -0.73,
                    -0.18,
                    0.66,
                    1.0395,
                    1.0395,
                    1.0395,
                    28.69,
                    -0.34,
                    -21.21,
                    0.07,
                    -0.64,
                    -0.03,
                    0.77,
                    1.2782,
                    1.2782,
                    1.2782,
                    28.71,
                    -0.34,
                    -21.24,
                    -0.04,
                    -0.63,
                    -0.12,
                    0.77,
                    1.3625,
                    1.0585,
                    1.3557,
                    28.81,
                    -0.34,
                    -21.26,
                    0.01,
                    -0.61,
                    0.14,
                    0.78,
                    1.0549,
                    1.0549,
                    1.0549,
                    28.82,
                    -0.34,
                    -21.3,
                    0.13,
                    -0.64,
                    0.00,
                    0.75,
                    1.4937,
                    1.4937,
                    1.4937,
                    28.87,
                    -0.34,
                    -21.34,
                    -0.1,
                    -0.65,
                    -0.01,
                    0.75,
                    1.0536,
                    1.0536,
                    1.0536,
                    28.90,
                    -0.34,
                    -21.39,
                    0.03,
                    -0.72,
                    0.08,
                    0.68,
                    1.4755,
                    1.1283,
                    1.4696,
                    28.93,
                    -0.34,
                    -21.45,
                    0.05,
                    -0.68,
                    -0.1,
                    0.72,
                    1.6417,
                    1.2747,
                    1.6555,
                    28.94,
                    -0.34,
                    -21.51,
                    0.03,
                    -0.62,
                    -0.07,
                    0.78,
                    1.5520,
                    1.1854,
                    1.5576,
                    28.94,
                    -0.34,
                    -21.57,
                    -0.04,
                    -0.64,
                    -0.18,
                    0.74,
                    1.4855,
                    1.1845,
                    1.4714,
                    28.69,
                    -0.34,
                    -21.87,
                    0.09,
                    -0.72,
                    -0.21,
                    0.66,
                    1.6149,
                    1.6149,
                    1.6149,
                    28.62,
                    -0.34,
                    -22.54,
                    0.13,
                    -0.69,
                    -0.08,
                    0.71,
                    0.9494,
                    0.7550,
                    0.9667,
                    28.62,
                    -0.34,
                    -22.76,
                    0.03,
                    -0.79,
                    -0.03,
                    0.61,
                    1.3718,
                    1.0397,
                    1.3737,
                    28.69,
                    -0.34,
                    -22.24,
                    -0.08,
                    -0.61,
                    -0.11,
                    0.78,
                    1.3597,
                    1.3597,
                    1.3597,
                    28.67,
                    -0.34,
                    -21.98,
                    0.10,
                    -0.64,
                    -0.05,
                    0.76,
                    1.3788,
                    1.0700,
                    1.3900,
                    28.56,
                    -0.34,
                    -22.24,
                    -0.02,
                    -0.69,
                    0.12,
                    0.71,
                    1.2175,
                    1.2175,
                    1.2175,
                    28.55,
                    -0.34,
                    -22.36,
                    0.11,
                    -0.61,
                    -0.11,
                    0.78,
                    1.5837,
                    1.5837,
                    1.5837,
                    28.43,
                    -0.34,
                    -22.85,
                    -0.08,
                    -0.78,
                    -0.08,
                    0.61,
                    1.6015,
                    1.2311,
                    1.5855,
                    29.46,
                    -0.34,
                    -21.99,
                    -0.11,
                    -0.78,
                    -0.06,
                    0.61,
                    0.9682,
                    0.9682,
                    0.9682,
                    29.34,
                    -0.34,
                    -22.02,
                    -0.05,
                    -0.75,
                    -0.05,
                    0.66,
                    1.5830,
                    1.5830,
                    1.5830,
                    29.95,
                    -0.34,
                    -21.62,
                    -0.09,
                    -0.64,
                    0.01,
                    0.76,
                    1.5617,
                    1.1966,
                    1.5612,
                    29.13,
                    -0.34,
                    -21.81,
                    0.06,
                    -0.64,
                    0.07,
                    0.76,
                    1.4160,
                    1.4160,
                    1.4160,
                    28.95,
                    -0.34,
                    -21.87,
                    0.16,
                    -0.69,
                    -0.02,
                    0.71,
                    1.3780,
                    1.3780,
                    1.3780,
                    29.04,
                    -0.34,
                    -21.96,
                    -0,
                    -0.76,
                    -0,
                    0.65,
                    1.6189,
                    1.6189,
                    1.6189,
                    29.16,
                    -0.34,
                    -21.98,
                    0.06,
                    -0.99,
                    -0.09,
                    0.13,
                    1.4680,
                    1.1345,
                    1.4665,
                    29.23,
                    -0.34,
                    -22.15,
                    -0.13,
                    -0.6,
                    -0.04,
                    0.79,
                    1.2292,
                    0.9545,
                    1.2154,
                    29.36,
                    -0.34,
                    -22.14,
                    0.04,
                    -0.68,
                    0.11,
                    0.73,
                    1.3269,
                    1.0245,
                    1.3173,
                    28.17,
                    -0.34,
                    -20.71,
                    0.12,
                    -0.71,
                    -0.07,
                    0.69,
                    1.0519,
                    0.8288,
                    1.0673,
                    28.29,
                    -0.34,
                    -20.74,
                    0.05,
                    -0.99,
                    0.01,
                    0.15,
                    1.0717,
                    0.8148,
                    1.0737,
                    28.29,
                    -0.34,
                    -20.93,
                    -0.06,
                    -0.78,
                    -0.11,
                    0.61,
                    1.3899,
                    1.0739,
                    1.3719,
                    28.35,
                    -0.34,
                    -21.04,
                    0.17,
                    -0.59,
                    -0.03,
                    0.79,
                    1.0934,
                    1.0934,
                    1.0934,
                    28.44,
                    -0.34,
                    -21.11,
                    -0.1,
                    -0.7,
                    -0.06,
                    0.70,
                    1.5449,
                    1.5449,
                    1.5449,
                    28.49,
                    -0.34,
                    -21.12,
                    -0.02,
                    -0.69,
                    0.03,
                    0.72,
                    1.4795,
                    1.4795,
                    1.4795,
                    28.46,
                    -0.34,
                    -21,
                    0.06,
                    -0.99,
                    0.01,
                    0.14,
                    1.2747,
                    0.9695,
                    1.2775,
                    28.48,
                    -0.34,
                    -20.82,
                    0.14,
                    -0.66,
                    0.13,
                    0.73,
                    1.6175,
                    1.6175,
                    1.6175,
                    28.45,
                    -0.34,
                    -20.69,
                    0.16,
                    -0.69,
                    -0.11,
                    0.69,
                    0.9762,
                    0.9762,
                    0.9762,
                    28.43,
                    -0.34,
                    -20.31,
                    0.03,
                    -0.77,
                    -0.02,
                    0.63,
                    1.5862,
                    1.2021,
                    1.5884,
                    28.50,
                    -0.34,
                    -21.97,
                    -0.06,
                    -0.75,
                    -0.18,
                    0.64,
                    1.1031,
                    1.1031,
                    1.1031,
                    28.39,
                    -0.34,
                    -22.09,
                    0.17,
                    -0.98,
                    0.02,
                    0.09,
                    0.9786,
                    0.7898,
                    1.0022,
                    28.42,
                    -0.34,
                    -22.21,
                    0.05,
                    -0.63,
                    0.06,
                    0.78,
                    1.5803,
                    1.5803,
                    1.5803,
                    28.29,
                    -0.34,
                    -22.34,
                    0.23,
                    -0.74,
                    -0.03,
                    0.63,
                    1.2782,
                    1.2782,
                    1.2782,
                    28.41,
                    -0.34,
                    -22.96,
                    -0.02,
                    -0.63,
                    0.11,
                    0.77,
                    1.5398,
                    1.1906,
                    1.5471,
                    28.88,
                    -0.34,
                    -21.93,
                    0.15,
                    -0.63,
                    -0.02,
                    0.76,
                    1.0315,
                    0.8124,
                    1.0345,
                    28.99,
                    -0.34,
                    -21.98,
                    -0.15,
                    -0.73,
                    0.01,
                    0.67,
                    0.9736,
                    0.7673,
                    0.9764,
                    29.07,
                    -0.34,
                    -22.08,
                    -0.05,
                    -0.77,
                    0.02,
                    0.63,
                    1.4050,
                    1.4050,
                    1.4050,
                    29.10,
                    -0.34,
                    -22.26,
                    -0.08,
                    -0.68,
                    -0.09,
                    0.73,
                    1.3657,
                    1.3657,
                    1.3657,
                    29.17,
                    -0.34,
                    -22.37,
                    -0.03,
                    -0.72,
                    0.11,
                    0.69,
                    1.5464,
                    1.5464,
                    1.5464,
                    28.62,
                    -0.34,
                    -21.07,
                    0.03,
                    -0.74,
                    -0.05,
                    0.67,
                    1.0690,
                    1.0690,
                    1.0690,
                    28.62,
                    -0.34,
                    -20.94,
                    0.13,
                    -0.59,
                    -0.04,
                    0.80,
                    1.6336,
                    1.6336,
                    1.6336,
                    28.55,
                    -0.34,
                    -20.85,
                    -0.12,
                    -0.8,
                    -0.05,
                    0.59,
                    1.3334,
                    1.0344,
                    1.3243,
                    28.54,
                    -0.34,
                    -20.72,
                    -0.11,
                    -0.77,
                    -0.05,
                    0.63,
                    1.2509,
                    1.2509,
                    1.2509,
                    28.53,
                    -0.34,
                    -20.6,
                    -0.06,
                    -0.72,
                    -0.05,
                    0.69,
                    1.0405,
                    0.7931,
                    1.0351,
                    28.36,
                    -0.34,
                    -21.93,
                    -0,
                    -0.63,
                    -0.03,
                    0.77,
                    1.3616,
                    1.3616,
                    1.3616,
                    28.29,
                    -0.34,
                    -22.04,
                    0.07,
                    -0.77,
                    0.08,
                    0.63,
                    1.3131,
                    1.3131,
                    1.3131,
                    28.30,
                    -0.34,
                    -22.86,
                    0.03,
                    -0.77,
                    -0.18,
                    0.61,
                    1.5453,
                    1.5453,
                    1.5453,
                    28.14,
                    -0.34,
                    -22.47,
                    0.12,
                    -0.73,
                    -0,
                    0.67,
                    1.2278,
                    1.2278,
                    1.2278,
                    27.92,
                    -0.34,
                    -22.82,
                    0.04,
                    -0.77,
                    0.04,
                    0.64,
                    1.1049,
                    0.8378,
                    1.1021,
                    28.83,
                    -0.34,
                    -21.93,
                    -0.01,
                    -0.76,
                    -0.12,
                    0.64,
                    1.5892,
                    1.5892,
                    1.5892,
                    28.89,
                    -0.34,
                    -22.04,
                    0.17,
                    -0.66,
                    -0.02,
                    0.73,
                    1.4743,
                    1.1773,
                    1.4803,
                    28.90,
                    -0.34,
                    -22.22,
                    -0.04,
                    -0.65,
                    -0.02,
                    0.76,
                    1.0147,
                    0.7685,
                    1.0134,
                    28.95,
                    -0.34,
                    -22.34,
                    0.04,
                    -0.67,
                    0.09,
                    0.74,
                    1.5792,
                    1.5792,
                    1.5792,
                    29.00,
                    -0.34,
                    -22.46,
                    0.13,
                    -0.61,
                    -0.05,
                    0.78,
                    1.1942,
                    0.9399,
                    1.2039,
                    28.71,
                    -0.34,
                    -21.08,
                    -0.09,
                    -0.65,
                    -0.06,
                    0.75,
                    1.6464,
                    1.6464,
                    1.6464,
                    28.74,
                    -0.34,
                    -20.95,
                    0.00,
                    -0.73,
                    0.12,
                    0.67,
                    1.4308,
                    1.4308,
                    1.4308,
                    28.76,
                    -0.34,
                    -20.82,
                    0.05,
                    -0.69,
                    -0.12,
                    0.71,
                    1.3414,
                    1.0509,
                    1.3563,
                    28.79,
                    -0.34,
                    -20.69,
                    0.13,
                    -0.96,
                    -0.06,
                    0.26,
                    1.1720,
                    1.1720,
                    1.1720,
                    28.81,
                    -0.34,
                    -20.56,
                    0.07,
                    -0.78,
                    -0.12,
                    0.62,
                    1.5780,
                    1.5780,
                    1.5780,
                    28.29,
                    -0.34,
                    -21.87,
                    0.10,
                    -0.82,
                    0.01,
                    0.57,
                    0.9901,
                    0.9901,
                    0.9901,
                    28.20,
                    -0.34,
                    -21.96,
                    0.08,
                    -0.67,
                    0.17,
                    0.72,
                    1.5524,
                    1.5524,
                    1.5524,
                    28.18,
                    -0.34,
                    -22.08,
                    0.20,
                    -0.97,
                    -0.01,
                    0.11,
                    1.2710,
                    1.2710,
                    1.2710,
                    28.01,
                    -0.34,
                    -22.15,
                    0.08,
                    -0.66,
                    0.05,
                    0.74,
                    0.9762,
                    0.7481,
                    0.9683,
                    28.02,
                    -0.34,
                    -22.28,
                    0.19,
                    -0.67,
                    -0.06,
                    0.71,
                    0.9896,
                    0.8068,
                    1.0069,
                    28.75,
                    -0.34,
                    -21.97,
                    -0.04,
                    -0.63,
                    0.02,
                    0.77,
                    1.6191,
                    1.6191,
                    1.6191,
                    28.79,
                    -0.34,
                    -22.09,
                    0.12,
                    -0.77,
                    0.06,
                    0.63,
                    1.4660,
                    1.4660,
                    1.4660,
                    28.83,
                    -0.34,
                    -22.21,
                    0.02,
                    -0.74,
                    -0.19,
                    0.65,
                    1.6011,
                    1.2896,
                    1.6032,
                    28.79,
                    -0.34,
                    -22.39,
                    0.14,
                    -0.94,
                    0.00,
                    0.32,
                    1.0176,
                    0.8013,
                    1.0304,
                    28.81,
                    -0.34,
                    -22.52,
                    -0.1,
                    -0.71,
                    -0.06,
                    0.69,
                    1.4231,
                    1.0970,
                    1.4082,
                    28.80,
                    -0.34,
                    -21.11,
                    -0.05,
                    -0.76,
                    0.04,
                    0.64,
                    1.5518,
                    1.5518,
                    1.5518,
                    28.79,
                    -0.34,
                    -21,
                    -0.03,
                    -0.76,
                    -0.06,
                    0.65,
                    1.1749,
                    0.8933,
                    1.1709,
                    28.82,
                    -0.34,
                    -20.87,
                    -0.16,
                    -0.74,
                    -0.03,
                    0.65,
                    1.5737,
                    1.2461,
                    1.5642,
                    28.86,
                    -0.34,
                    -20.75,
                    -0.07,
                    -0.66,
                    0.00,
                    0.75,
                    1.5011,
                    1.5011,
                    1.5011,
                    29.00,
                    -0.34,
                    -20.62,
                    0.07,
                    -0.69,
                    0.03,
                    0.72,
                    1.4196,
                    1.4196,
                    1.4196,
                    28.23,
                    -0.34,
                    -21.8,
                    0.12,
                    -0.79,
                    -0.07,
                    0.60,
                    1.3304,
                    1.0502,
                    1.3524,
                    28.18,
                    -0.34,
                    -21.91,
                    0.02,
                    -0.96,
                    0.13,
                    0.26,
                    1.3598,
                    1.0510,
                    1.3413,
                    28.01,
                    -0.34,
                    -21.95,
                    0.13,
                    -0.79,
                    -0.09,
                    0.59,
                    1.1879,
                    1.1879,
                    1.1879,
                    27.90,
                    -0.34,
                    -22.02,
                    0.11,
                    -0.75,
                    0.05,
                    0.66,
                    0.9896,
                    0.7635,
                    0.9823,
                    28.19,
                    -0.34,
                    -23.18,
                    0.10,
                    -0.73,
                    -0.24,
                    0.63,
                    1.3089,
                    1.1262,
                    1.3553,
                    28.88,
                    -0.34,
                    -21.15,
                    0.13,
                    -0.78,
                    -0.07,
                    0.61,
                    1.6196,
                    1.6196,
                    1.6196,
                    29.03,
                    -0.34,
                    -20.93,
                    0.02,
                    -0.62,
                    -0.17,
                    0.77,
                    1.3658,
                    1.3658,
                    1.3658,
                    29.10,
                    -0.34,
                    -20.82,
                    0.01,
                    -0.75,
                    -0.12,
                    0.65,
                    1.5990,
                    1.2393,
                    1.5979,
                    29.17,
                    -0.34,
                    -20.71,
                    0.16,
                    -0.76,
                    -0.05,
                    0.63,
                    1.5392,
                    1.2330,
                    1.5646,
                    28.23,
                    -0.34,
                    -21.75,
                    0.06,
                    -0.67,
                    0.07,
                    0.73,
                    1.1772,
                    1.1772,
                    1.1772,
                    28.12,
                    -0.34,
                    -20.35,
                    0.17,
                    -0.97,
                    0.00,
                    0.16,
                    1.6246,
                    1.6246,
                    1.6246,
                    28.01,
                    -0.34,
                    -21.87,
                    0.08,
                    -0.71,
                    0.03,
                    0.70,
                    1.2697,
                    1.2697,
                    1.2697,
                    27.82,
                    -0.34,
                    -21.87,
                    0.09,
                    -0.61,
                    -0.14,
                    0.77,
                    1.5017,
                    1.5017,
                    1.5017,
                    27.70,
                    -0.34,
                    -21.92,
                    -0.02,
                    -0.68,
                    -0.14,
                    0.72,
                    1.0908,
                    1.0908,
                    1.0908,
                    28.90,
                    -0.34,
                    -21.2,
                    0.15,
                    -0.94,
                    -0.09,
                    0.30,
                    1.3676,
                    1.1079,
                    1.4013,
                    29.23,
                    -0.34,
                    -20.93,
                    -0.07,
                    -0.96,
                    -0.12,
                    0.23,
                    1.1164,
                    1.1164,
                    1.1164,
                    29.22,
                    -0.34,
                    -20.81,
                    -0.05,
                    -0.77,
                    0.06,
                    0.63,
                    1.3503,
                    1.3503,
                    1.3503,
                    28.20,
                    -0.34,
                    -21.67,
                    -0.03,
                    -0.76,
                    -0.1,
                    0.64,
                    1.5210,
                    1.1689,
                    1.5109,
                    28.03,
                    -0.34,
                    -21.66,
                    0.26,
                    -0.94,
                    0.08,
                    0.20,
                    1.3851,
                    1.2028,
                    1.4323,
                    27.90,
                    -0.34,
                    -21.68,
                    -0.02,
                    -0.65,
                    0.04,
                    0.76,
                    1.2204,
                    1.2204,
                    1.2204,
                    27.84,
                    -0.34,
                    -21.78,
                    0.11,
                    -0.69,
                    0.03,
                    0.72,
                    1.0206,
                    0.7869,
                    1.0140,
                    27.64,
                    -0.34,
                    -20.85,
                    -0.13,
                    -0.63,
                    0.08,
                    0.76,
                    0.8469,
                    0.8469,
                    0.8469,
                    29.01,
                    -0.34,
                    -21.28,
                    0.05,
                    -0.78,
                    0.03,
                    0.62,
                    1.0512,
                    0.7984,
                    1.0490,
                    29.12,
                    -0.34,
                    -21.21,
                    -0.03,
                    -0.66,
                    -0.22,
                    0.72,
                    1.5358,
                    1.5358,
                    1.5358,
                    29.16,
                    -0.34,
                    -21.1,
                    0.12,
                    -0.71,
                    -0.18,
                    0.67,
                    1.5292,
                    1.2775,
                    1.5859,
                    29.34,
                    -0.34,
                    -21.06,
                    0.06,
                    -0.74,
                    -0.03,
                    0.67,
                    1.2114,
                    1.2114,
                    1.2114,
                    29.35,
                    -0.34,
                    -20.94,
                    0.05,
                    -0.93,
                    0.07,
                    0.35,
                    1.1396,
                    0.8702,
                    1.1330,
                    28.15,
                    -0.34,
                    -21.54,
                    0.19,
                    -0.6,
                    -0.04,
                    0.78,
                    1.2443,
                    1.0089,
                    1.2517,
                    28.02,
                    -0.34,
                    -21.54,
                    -0.08,
                    -0.62,
                    -0.05,
                    0.78,
                    1.1299,
                    1.1299,
                    1.1299,
                    27.93,
                    -0.34,
                    -21.61,
                    0.04,
                    -0.73,
                    0.13,
                    0.67,
                    1.2487,
                    1.2487,
                    1.2487,
                    27.76,
                    -0.34,
                    -21.54,
                    0.09,
                    -0.77,
                    -0.13,
                    0.62,
                    1.2010,
                    0.9582,
                    1.2220,
                    27.68,
                    -0.34,
                    -21.64,
                    0.13,
                    -0.71,
                    0.01,
                    0.70,
                    1.0143,
                    0.7890,
                    1.0121,
                    29.05,
                    -0.34,
                    -21.36,
                    -0.06,
                    -0.72,
                    0.09,
                    0.69,
                    1.0046,
                    0.7768,
                    1.0128,
                    29.12,
                    -0.34,
                    -21.27,
                    0.00,
                    -0.74,
                    -0.03,
                    0.67,
                    1.2823,
                    1.2823,
                    1.2823,
                    29.30,
                    -0.34,
                    -21.26,
                    0.07,
                    -0.55,
                    -0.02,
                    0.83,
                    0.9996,
                    0.7629,
                    0.9997,
                    29.35,
                    -0.34,
                    -21.15,
                    -0.14,
                    -0.68,
                    -0.14,
                    0.71,
                    1.5760,
                    1.2517,
                    1.5274,
                    29.54,
                    -0.34,
                    -21.16,
                    -0.08,
                    -0.97,
                    0.05,
                    0.23,
                    1.3597,
                    1.0485,
                    1.3687,
                    28.18,
                    -0.34,
                    -21.5,
                    0.08,
                    -0.99,
                    -0.01,
                    0.13,
                    1.0622,
                    1.0622,
                    1.0622,
                    27.88,
                    -0.34,
                    -21.57,
                    0.14,
                    -0.78,
                    -0.19,
                    0.57,
                    1.3905,
                    1.1810,
                    1.4447,
                    27.80,
                    -0.34,
                    -20.59,
                    0.11,
                    -0.62,
                    0.01,
                    0.77,
                    1.6123,
                    1.6123,
                    1.6123,
                    27.18,
                    -0.34,
                    -21.05,
                    -0.15,
                    -0.73,
                    -0.04,
                    0.66,
                    1.3936,
                    1.3936,
                    1.3936,
                    29.08,
                    -0.34,
                    -21.45,
                    -0.07,
                    -0.67,
                    0.01,
                    0.74,
                    1.2582,
                    0.9594,
                    1.2592,
                    29.21,
                    -0.34,
                    -21.42,
                    0.03,
                    -0.97,
                    0.05,
                    0.25,
                    1.2022,
                    0.9119,
                    1.1995,
                    29.34,
                    -0.34,
                    -21.4,
                    0.16,
                    -0.73,
                    -0.1,
                    0.66,
                    1.4110,
                    1.1539,
                    1.4528,
                    29.41,
                    -0.34,
                    -21.3,
                    0.08,
                    -0.78,
                    0.00,
                    0.62,
                    1.1572,
                    0.8843,
                    1.1585,
                    29.60,
                    -0.34,
                    -21.35,
                    -0,
                    -0.58,
                    -0.16,
                    0.80,
                    1.0854,
                    1.0854,
                    1.0854,
                    28.19,
                    -0.34,
                    -21.36,
                    0.13,
                    -0.93,
                    -0.18,
                    0.29,
                    1.1956,
                    0.9941,
                    1.2113,
                    28.07,
                    -0.34,
                    -21.31,
                    0.08,
                    -0.63,
                    -0.18,
                    0.75,
                    1.5137,
                    1.5137,
                    1.5137,
                    27.83,
                    -0.34,
                    -20.71,
                    0.06,
                    -0.63,
                    -0.21,
                    0.74,
                    1.3425,
                    1.3425,
                    1.3425,
                    27.18,
                    -0.34,
                    -20.88,
                    0.05,
                    -0.62,
                    -0.16,
                    0.77,
                    1.2067,
                    0.9706,
                    1.2299,
                    29.06,
                    -0.34,
                    -21.5,
                    -0.01,
                    -0.65,
                    -0.14,
                    0.75,
                    1.5960,
                    1.2517,
                    1.5944,
                    29.22,
                    -0.34,
                    -21.54,
                    0.10,
                    -0.74,
                    -0.19,
                    0.63,
                    1.3150,
                    1.0946,
                    1.3522,
                    29.35,
                    -0.34,
                    -21.54,
                    0.14,
                    -0.63,
                    -0.07,
                    0.76,
                    1.2840,
                    1.0232,
                    1.3031,
                    29.44,
                    -0.34,
                    -21.46,
                    -0.09,
                    -0.64,
                    -0.07,
                    0.76,
                    1.0546,
                    1.0546,
                    1.0546,
                    29.57,
                    -0.34,
                    -21.45,
                    0.00,
                    -0.7,
                    0.14,
                    0.70,
                    1.2020,
                    0.9433,
                    1.2012,
                    28.23,
                    -0.34,
                    -21.28,
                    0.09,
                    -0.76,
                    -0.09,
                    0.64,
                    1.5492,
                    1.2125,
                    1.5699,
                    28.12,
                    -0.34,
                    -21.21,
                    0.06,
                    -0.98,
                    0.09,
                    0.19,
                    0.9944,
                    0.7637,
                    0.9879,
                    26.79,
                    -0.34,
                    -21.45,
                    0.01,
                    -0.78,
                    -0.06,
                    0.62,
                    1.4453,
                    1.0998,
                    1.4460,
                    27.78,
                    -0.34,
                    -21.1,
                    0.14,
                    -0.62,
                    0.06,
                    0.77,
                    1.2649,
                    1.2649,
                    1.2649,
                    29.34,
                    -0.34,
                    -21.68,
                    -0.15,
                    -0.63,
                    0.01,
                    0.77,
                    1.2429,
                    1.2429,
                    1.2429,
                    29.47,
                    -0.34,
                    -21.71,
                    0.02,
                    -0.98,
                    0.08,
                    0.16,
                    1.1404,
                    1.1404,
                    1.1404,
                    29.57,
                    -0.34,
                    -21.63,
                    0.05,
                    -0.74,
                    -0.16,
                    0.65,
                    1.0533,
                    1.0533,
                    1.0533,
                    28.29,
                    -0.34,
                    -21.21,
                    0.18,
                    -0.71,
                    -0.08,
                    0.67,
                    1.1631,
                    1.1631,
                    1.1631,
                    28.20,
                    -0.34,
                    -21.12,
                    -0.02,
                    -0.77,
                    0.07,
                    0.63,
                    1.0832,
                    1.0832,
                    1.0832,
                    28.10,
                    -0.34,
                    -21.02,
                    -0.02,
                    -0.78,
                    -0.12,
                    0.62,
                    1.0852,
                    0.8411,
                    1.0785,
                    27.98,
                    -0.34,
                    -21.02,
                    0.20,
                    -0.71,
                    -0.01,
                    0.68,
                    1.0887,
                    0.8851,
                    1.0950,
                    27.91,
                    -0.34,
                    -20.83,
                    0.00,
                    -0.75,
                    0.03,
                    0.66,
                    0.9932,
                    0.9932,
                    0.9932,
                    29.29,
                    -0.34,
                    -21.74,
                    0.09,
                    -0.98,
                    -0.08,
                    0.13,
                    1.0994,
                    1.0994,
                    1.0994,
                    29.51,
                    -0.34,
                    -22.63,
                    0.20,
                    -0.77,
                    -0.01,
                    0.61,
                    1.5019,
                    1.5019,
                    1.5019,
                    29.54,
                    -0.34,
                    -21.92,
                    0.00,
                    -0.72,
                    0.14,
                    0.68,
                    0.9918,
                    0.7778,
                    0.9908,
                    28.34,
                    -0.34,
                    -21.2,
                    0.09,
                    -0.77,
                    -0.11,
                    0.62,
                    1.0279,
                    1.0279,
                    1.0279,
                    28.26,
                    -0.34,
                    -21.1,
                    0.11,
                    -0.68,
                    0.07,
                    0.72,
                    1.3090,
                    1.3090,
                    1.3090,
                    28.21,
                    -0.34,
                    -20.93,
                    -0.08,
                    -0.8,
                    0.04,
                    0.60,
                    1.5588,
                    1.5588,
                    1.5588,
                    28.14,
                    -0.34,
                    -20.41,
                    -0.03,
                    -0.7,
                    -0.12,
                    0.70,
                    1.4110,
                    1.4110,
                    1.4110,
                    28.02,
                    -0.34,
                    -20.81,
                    -0.06,
                    -0.61,
                    0.07,
                    0.79,
                    1.4081,
                    1.4081,
                    1.4081,
                    27.74,
                    -0.34,
                    -23.17,
                    0.04,
                    -0.77,
                    0.04,
                    0.64,
                    1.1049,
                    0.8378,
                    1.1021,
                    27.04,
                    -0.34,
                    -21.48,
                    0.01,
                    -0.78,
                    -0.06,
                    0.62,
                    1.4453,
                    1.0998,
                    1.4460,
                    26.94,
                    -0.34,
                    -21.4,
                    0.04,
                    -0.96,
                    -0.05,
                    0.26,
                    1.7294,
                    1.3160,
                    1.7303,
                    27.27,
                    -0.34,
                    -21.41,
                    -0.06,
                    0.86,
                    0.01,
                    0.50,
                    1.7294,
                    1.3160,
                    1.7303,
                    28.39,
                    -0.34,
                    -23.13,
                    -0.02,
                    -0.63,
                    0.11,
                    0.77,
                    1.5398,
                    1.1906,
                    1.5471,
                    27.58,
                    -0.34,
                    -20.87,
                    -0.1,
                    -0.38,
                    0.12,
                    0.91,
                    1.4774,
                    1.4774,
                    1.4774,
                    28.59,
                    -0.34,
                    -20.07,
                    0.03,
                    -0.77,
                    -0.02,
                    0.63,
                    1.5862,
                    1.2021,
                    1.5884,
                    29.32,
                    -0.34,
                    -20.27,
                    -0.04,
                    0.99,
                    -0.01,
                    0.12,
                    1.5862,
                    1.2021,
                    1.5884,
                    29.57,
                    -0.34,
                    -20.54,
                    -0.04,
                    0.99,
                    -0.01,
                    0.12,
                    1.5862,
                    1.2021,
                    1.5884,
                    29.86,
                    -0.34,
                    -20.89,
                    -0.04,
                    0.99,
                    -0.01,
                    0.12,
                    1.5862,
                    1.2021,
                    1.5884,
                    29.91,
                    -0.34,
                    -20.75,
                    -0.04,
                    0.99,
                    -0.01,
                    0.12,
                    1.5862,
                    1.2021,
                    1.5884,
                    29.94,
                    -0.34,
                    -21.3,
                    -0.04,
                    0.99,
                    -0.01,
                    0.12,
                    1.5862,
                    1.2021,
                    1.5884,
                    30.05,
                    -0.34,
                    -21.5,
                    -0.05,
                    0.22,
                    0.07,
                    0.97,
                    1.2693,
                    0.9725,
                    1.2689,
                    29.96,
                    -0.34,
                    -21.96,
                    -0.08,
                    -0.96,
                    -0.04,
                    0.27,
                    1.7937,
                    1.3743,
                    1.7931,
                    29.76,
                    -0.34,
                    -22.7,
                    -0.08,
                    -0.96,
                    -0.04,
                    0.27,
                    1.7937,
                    1.3743,
                    1.7931,
                    29.81,
                    -0.34,
                    -22.52,
                    -0.08,
                    -0.96,
                    -0.04,
                    0.27,
                    1.7937,
                    1.3743,
                    1.7931,
                    29.63,
                    -0.34,
                    -22.6,
                    -0.08,
                    -0.96,
                    -0.04,
                    0.27,
                    1.7937,
                    1.3743,
                    1.7931,
                    26.70,
                    -0.34,
                    -21.51,
                    0.04,
                    -0.96,
                    -0.05,
                    0.26,
                    1.7294,
                    1.3160,
                    1.7303,
                    26.92,
                    -0.34,
                    -21.49,
                    -0.05,
                    0.26,
                    -0.04,
                    0.96,
                    1.3866,
                    1.0551,
                    1.3873
                ];
                for(let i = 0; i < tulipa_J_b_pqs.length / 10; ++i){
                    tulipa_J_b_pqs[i * 10 + 0] -= $5fbffa87c50562b9$var$a.b_patch.position.x;
                    tulipa_J_b_pqs[i * 10 + 1] -= $5fbffa87c50562b9$var$a.b_patch.position.y;
                    tulipa_J_b_pqs[i * 10 + 2] -= $5fbffa87c50562b9$var$a.b_patch.position.z;
                    tulipa_J_b_pqs[i * 10 + 7] = .443;
                    tulipa_J_b_pqs[i * 10 + 8] = .443;
                    tulipa_J_b_pqs[i * 10 + 9] = .443;
                }
                const tulipa_J_b_instanced_meshes = create_instanced_meshes({
                    names: [
                        "tulipa_J_b"
                    ],
                    pqs: tulipa_J_b_pqs,
                    add_to_scene: false,
                    sway: true
                });
                tulipa_J_b_instanced_meshes.forEach((instanced_mesh)=>$5fbffa87c50562b9$var$a.b_patch.add(instanced_mesh));
            }
            {
                $5fbffa87c50562b9$var$a.lp_patch = new $0147bee01cff6558$export$e4dd07dff30cc924();
                $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.lp_patch);
                const lp_patch = garden.scene.getObjectByName("lp_patch");
                $5fbffa87c50562b9$var$a.lp_patch.position.copy(lp_patch.position);
                const platform_lp = garden.scene.getObjectByName("platform_lp");
                $5fbffa87c50562b9$var$a.lp_patch.add(platform_lp);
                const leaf_lp_pqs = [
                    8.00,
                    -0.09,
                    -15.32,
                    0.50,
                    0.79,
                    0.14,
                    -0.34,
                    0.92,
                    0.92,
                    0.92,
                    7.48,
                    -0.09,
                    -14.82,
                    0.17,
                    0.38,
                    -0.71,
                    -0.57,
                    0.89,
                    0.89,
                    0.89,
                    8.11,
                    -0.09,
                    -15.48,
                    0.10,
                    -0.35,
                    -0.42,
                    0.83,
                    1.14,
                    1.14,
                    1.14,
                    7.67,
                    -0.09,
                    -14.52,
                    0.25,
                    -0.91,
                    -0.09,
                    0.31,
                    1.17,
                    1.17,
                    1.17,
                    7.37,
                    -0.09,
                    -15.18,
                    0.68,
                    -0.09,
                    -0.45,
                    -0.57,
                    0.86,
                    0.86,
                    0.86,
                    7.19,
                    -0.09,
                    -14.87,
                    0.86,
                    0.37,
                    -0.35,
                    0.04,
                    1.07,
                    1.07,
                    1.07,
                    8.10,
                    -0.09,
                    -15.28,
                    0.14,
                    -0.82,
                    -0.33,
                    0.45,
                    1.18,
                    1.18,
                    1.18,
                    8.12,
                    -0.09,
                    -14.95,
                    0.18,
                    0.57,
                    0.12,
                    -0.8,
                    0.98,
                    0.98,
                    0.98,
                    7.74,
                    -0.09,
                    -14.87,
                    0.20,
                    0.82,
                    -0.46,
                    -0.28,
                    1.03,
                    1.03,
                    1.03,
                    8.12,
                    -0.09,
                    -15.36,
                    0.90,
                    0.26,
                    -0.36,
                    0.03,
                    0.86,
                    0.86,
                    0.86,
                    7.79,
                    -0.09,
                    -14.53,
                    0.01,
                    -0.91,
                    -0.3,
                    0.28,
                    0.85,
                    0.85,
                    0.85,
                    7.95,
                    -0.09,
                    -15.07,
                    0.71,
                    0.49,
                    -0.13,
                    -0.49,
                    1.03,
                    1.03,
                    1.03,
                    7.42,
                    -0.09,
                    -14.91,
                    0.11,
                    0.77,
                    0.13,
                    -0.61,
                    0.83,
                    0.83,
                    0.83,
                    7.92,
                    -0.09,
                    -14.88,
                    0.19,
                    -0.67,
                    -0.22,
                    0.68,
                    1.13,
                    1.13,
                    1.13,
                    7.76,
                    -0.09,
                    -14.83,
                    0.56,
                    0.13,
                    -0.08,
                    -0.81,
                    1.17,
                    1.17,
                    1.17,
                    7.27,
                    -0.09,
                    -14.94,
                    0.51,
                    -0.61,
                    0.46,
                    0.41,
                    0.98,
                    0.98,
                    0.98,
                    7.93,
                    -0.09,
                    -14.8,
                    0.13,
                    0.59,
                    -0.48,
                    -0.63,
                    1.14,
                    1.14,
                    1.14,
                    7.16,
                    -0.09,
                    -15.08,
                    0.57,
                    -0.29,
                    -0.76,
                    0.12,
                    1.12,
                    1.12,
                    1.12,
                    7.63,
                    -0.09,
                    -14.96,
                    0.15,
                    0.81,
                    -0.52,
                    -0.24,
                    0.91,
                    0.91,
                    0.91,
                    8.03,
                    -0.09,
                    -14.57,
                    0.10,
                    0.01,
                    -0.73,
                    -0.67,
                    1.14,
                    1.14,
                    1.14,
                    7.55,
                    -0.09,
                    -15.08,
                    0.54,
                    0.14,
                    -0.82,
                    0.11,
                    0.91,
                    0.91,
                    0.91,
                    7.83,
                    -0.09,
                    -14.88,
                    0.61,
                    0.19,
                    -0.51,
                    -0.58,
                    0.82,
                    0.82,
                    0.82,
                    7.26,
                    -0.09,
                    -15.18,
                    0.34,
                    0.07,
                    -0.13,
                    -0.93,
                    1.09,
                    1.09,
                    1.09,
                    7.65,
                    -0.09,
                    -14.54,
                    0.77,
                    -0.37,
                    -0.11,
                    0.51,
                    1.13,
                    1.13,
                    1.13,
                    7.41,
                    -0.09,
                    -15.24,
                    0.23,
                    -0.86,
                    0.30,
                    0.34,
                    0.96,
                    0.96,
                    0.96,
                    7.65,
                    -0.09,
                    -15.4,
                    0.33,
                    0.74,
                    0.31,
                    -0.5,
                    0.91,
                    0.91,
                    0.91,
                    7.38,
                    -0.09,
                    -15.36,
                    0.62,
                    0.38,
                    -0.65,
                    -0.2,
                    1.11,
                    1.11,
                    1.11,
                    7.92,
                    -0.09,
                    -14.83,
                    0.14,
                    -0.74,
                    0.01,
                    0.66,
                    1.15,
                    1.15,
                    1.15,
                    8.23,
                    -0.09,
                    -14.86,
                    0.89,
                    0.27,
                    -0.03,
                    -0.36,
                    0.96,
                    0.96,
                    0.96,
                    7.21,
                    -0.09,
                    -15.19,
                    0.20,
                    -0.93,
                    0.26,
                    0.16,
                    1.01,
                    1.01,
                    1.01,
                    8.12,
                    -0.09,
                    -15.3,
                    0.22,
                    -0.88,
                    0.33,
                    0.25,
                    1.02,
                    1.02,
                    1.02,
                    7.90,
                    -0.09,
                    -15.26,
                    0.24,
                    0.26,
                    -0.47,
                    -0.81,
                    0.84,
                    0.84,
                    0.84,
                    8.00,
                    -0.09,
                    -15.38,
                    0.37,
                    0.73,
                    0.12,
                    -0.56,
                    1.05,
                    1.05,
                    1.05,
                    7.27,
                    -0.09,
                    -15.38,
                    0.30,
                    0.41,
                    -0.17,
                    -0.84,
                    0.92,
                    0.92,
                    0.92,
                    8.02,
                    -0.09,
                    -14.57,
                    0.29,
                    -0.79,
                    0.09,
                    0.54,
                    1.04,
                    1.04,
                    1.04,
                    8.28,
                    -0.09,
                    -14.81,
                    0.63,
                    0.57,
                    -0.03,
                    -0.53,
                    1.00,
                    1.00,
                    1.00,
                    7.61,
                    -0.09,
                    -14.97,
                    0.15,
                    -0.91,
                    0.11,
                    0.37,
                    1.17,
                    1.17,
                    1.17,
                    7.47,
                    -0.09,
                    -14.71,
                    0.17,
                    -0.95,
                    -0.14,
                    0.22,
                    1.02,
                    1.02,
                    1.02,
                    8.31,
                    -0.09,
                    -14.99,
                    0.47,
                    -0.4,
                    0.22,
                    0.76,
                    1.08,
                    1.08,
                    1.08,
                    8.21,
                    -0.09,
                    -15.51,
                    0.41,
                    0.79,
                    0.22,
                    -0.4,
                    1.09,
                    1.09,
                    1.09,
                    7.68,
                    -0.09,
                    -15.64,
                    0.15,
                    -0.41,
                    0.15,
                    0.89,
                    1.12,
                    1.12,
                    1.12,
                    7.73,
                    -0.09,
                    -14.84,
                    0.63,
                    -0.55,
                    -0.32,
                    0.45,
                    1.10,
                    1.10,
                    1.10,
                    8.00,
                    -0.09,
                    -15.21,
                    0.14,
                    0.43,
                    0.00,
                    -0.89,
                    0.84,
                    0.84,
                    0.84,
                    7.20,
                    -0.09,
                    -15.31,
                    0.55,
                    -0.66,
                    0.08,
                    0.51,
                    1.00,
                    1.00,
                    1.00,
                    7.44,
                    -0.09,
                    -14.59,
                    0.49,
                    -0.14,
                    -0.34,
                    0.79,
                    0.98,
                    0.98,
                    0.98,
                    7.62,
                    -0.09,
                    -14.9,
                    0.51,
                    0.10,
                    -0.51,
                    -0.69,
                    1.04,
                    1.04,
                    1.04,
                    7.57,
                    -0.09,
                    -14.88,
                    0.05,
                    0.37,
                    -0.64,
                    -0.67,
                    0.92,
                    0.92,
                    0.92,
                    8.00,
                    -0.09,
                    -14.74,
                    0.24,
                    -0.57,
                    -0.71,
                    0.35,
                    1.17,
                    1.17,
                    1.17,
                    7.62,
                    -0.09,
                    -15.26,
                    0.47,
                    0.30,
                    0.02,
                    -0.83,
                    0.93,
                    0.93,
                    0.93,
                    7.66,
                    -0.09,
                    -14.53,
                    0.45,
                    0.82,
                    -0.3,
                    -0.17,
                    0.87,
                    0.87,
                    0.87,
                    7.50,
                    -0.09,
                    -15.11,
                    0.11,
                    0.49,
                    -0.03,
                    -0.86,
                    0.96,
                    0.96,
                    0.96,
                    7.27,
                    -0.09,
                    -15.14,
                    0.18,
                    -0.35,
                    -0.35,
                    0.85,
                    0.92,
                    0.92,
                    0.92,
                    8.02,
                    -0.09,
                    -15.3,
                    0.21,
                    0.10,
                    -0.55,
                    -0.8,
                    1.09,
                    1.09,
                    1.09,
                    7.75,
                    -0.09,
                    -14.99,
                    0.16,
                    0.55,
                    0.30,
                    -0.76,
                    0.93,
                    0.93,
                    0.93,
                    8.25,
                    -0.09,
                    -15.22,
                    0.54,
                    -0.26,
                    -0.29,
                    0.75,
                    1.11,
                    1.11,
                    1.11,
                    7.23,
                    -0.09,
                    -14.97,
                    0.74,
                    -0.15,
                    -0.43,
                    -0.49,
                    0.88,
                    0.88,
                    0.88,
                    7.22,
                    -0.09,
                    -15.45,
                    0.32,
                    -0.66,
                    0.42,
                    0.53,
                    0.82,
                    0.82,
                    0.82,
                    7.96,
                    -0.09,
                    -14.87,
                    0.19,
                    0.78,
                    0.19,
                    -0.57,
                    0.84,
                    0.84,
                    0.84,
                    8.15,
                    -0.09,
                    -15.28,
                    0.69,
                    0.33,
                    -0.55,
                    -0.34,
                    0.90,
                    0.90,
                    0.90,
                    7.66,
                    -0.09,
                    -15.45,
                    0.75,
                    0.28,
                    -0.56,
                    -0.21,
                    1.01,
                    1.01,
                    1.01,
                    7.80,
                    -0.09,
                    -14.65,
                    0.89,
                    -0.13,
                    -0.17,
                    -0.41,
                    0.85,
                    0.85,
                    0.85,
                    7.32,
                    -0.09,
                    -15.56,
                    0.43,
                    0.66,
                    -0.57,
                    0.25,
                    1.00,
                    1.00,
                    1.00,
                    7.63,
                    -0.09,
                    -15.57,
                    0.66,
                    0.09,
                    -0.32,
                    -0.67,
                    0.87,
                    0.87,
                    0.87,
                    7.87,
                    -0.09,
                    -14.75,
                    0.48,
                    0.26,
                    -0.26,
                    -0.8,
                    0.91,
                    0.91,
                    0.91,
                    7.45,
                    -0.09,
                    -15.56,
                    0.14,
                    0.29,
                    -0.41,
                    -0.85,
                    1.11,
                    1.11,
                    1.11,
                    7.74,
                    -0.09,
                    -15.43,
                    0.02,
                    0.53,
                    -0.16,
                    -0.84,
                    1.15,
                    1.15,
                    1.15,
                    7.55,
                    -0.09,
                    -14.61,
                    0.71,
                    0.12,
                    -0.62,
                    -0.3,
                    0.83,
                    0.83,
                    0.83,
                    7.88,
                    -0.09,
                    -14.58,
                    0.42,
                    -0.19,
                    -0.09,
                    0.88,
                    0.96,
                    0.96,
                    0.96,
                    7.81,
                    -0.09,
                    -15.34,
                    0.29,
                    -0.64,
                    0.58,
                    0.41,
                    1.12,
                    1.12,
                    1.12,
                    8.13,
                    -0.09,
                    -15.02,
                    0.35,
                    -0.11,
                    -0.85,
                    0.36,
                    0.87,
                    0.87,
                    0.87,
                    7.68,
                    -0.09,
                    -15.36,
                    0.04,
                    0.88,
                    0.19,
                    -0.43,
                    0.88,
                    0.88,
                    0.88,
                    7.96,
                    -0.09,
                    -15.12,
                    0.75,
                    -0.17,
                    -0.42,
                    -0.47,
                    1.00,
                    1.00,
                    1.00,
                    7.80,
                    -0.09,
                    -14.48,
                    0.62,
                    -0.68,
                    -0.38,
                    -0.03,
                    0.83,
                    0.83,
                    0.83,
                    7.97,
                    -0.09,
                    -14.62,
                    0.19,
                    -0.32,
                    -0.47,
                    0.80,
                    0.86,
                    0.86,
                    0.86,
                    8.17,
                    -0.09,
                    -15.44,
                    0.34,
                    0.21,
                    -0.58,
                    -0.71,
                    1.18,
                    1.18,
                    1.18,
                    7.29,
                    -0.09,
                    -15.52,
                    0.20,
                    0.62,
                    0.16,
                    -0.74,
                    1.05,
                    1.05,
                    1.05,
                    8.20,
                    -0.09,
                    -15.54,
                    0.01,
                    0.45,
                    0.09,
                    -0.89,
                    0.99,
                    0.99,
                    0.99,
                    8.01,
                    -0.09,
                    -14.89,
                    0.52,
                    -0.62,
                    0.08,
                    0.58,
                    1.06,
                    1.06,
                    1.06,
                    8.15,
                    -0.09,
                    -15.12,
                    0.15,
                    -0.23,
                    -0.19,
                    0.94,
                    1.18,
                    1.18,
                    1.18,
                    7.56,
                    -0.09,
                    -14.97,
                    0.63,
                    -0.09,
                    -0.62,
                    -0.45,
                    1.15,
                    1.15,
                    1.15,
                    7.58,
                    -0.09,
                    -14.9,
                    0.09,
                    0.48,
                    -0.78,
                    -0.39,
                    1.12,
                    1.12,
                    1.12,
                    7.64,
                    -0.09,
                    -15.49,
                    0.37,
                    0.89,
                    -0.1,
                    -0.26,
                    1.20,
                    1.20,
                    1.20,
                    7.47,
                    -0.09,
                    -14.94,
                    0.36,
                    0.48,
                    0.19,
                    -0.77,
                    1.10,
                    1.10,
                    1.10,
                    8.16,
                    -0.09,
                    -14.66,
                    0.10,
                    0.80,
                    -0.41,
                    -0.43,
                    1.06,
                    1.06,
                    1.06,
                    7.52,
                    -0.09,
                    -14.55,
                    0.26,
                    0.55,
                    0.30,
                    -0.73,
                    1.05,
                    1.05,
                    1.05,
                    7.58,
                    -0.09,
                    -15.72,
                    0.55,
                    -0.06,
                    -0.6,
                    0.57,
                    1.21,
                    1.21,
                    1.21,
                    8.08,
                    -0.09,
                    -15.48,
                    0.04,
                    0.38,
                    -0.26,
                    -0.89,
                    0.88,
                    0.88,
                    0.88,
                    7.94,
                    -0.09,
                    -14.9,
                    0.70,
                    0.60,
                    -0.38,
                    0.09,
                    1.00,
                    1.00,
                    1.00,
                    8.15,
                    -0.09,
                    -14.71,
                    0.07,
                    -0.69,
                    0.27,
                    0.67,
                    0.82,
                    0.82,
                    0.82,
                    7.91,
                    -0.09,
                    -14.62,
                    0.39,
                    0.73,
                    -0.3,
                    -0.48,
                    0.86,
                    0.86,
                    0.86,
                    7.57,
                    -0.09,
                    -15.52,
                    0.54,
                    0.16,
                    -0.81,
                    0.19,
                    1.19,
                    1.19,
                    1.19,
                    7.59,
                    -0.09,
                    -14.73,
                    0.13,
                    -0.18,
                    0.05,
                    0.97,
                    0.85,
                    0.85,
                    0.85,
                    8.35,
                    -0.09,
                    -15.24,
                    0.42,
                    -0.65,
                    0.44,
                    0.46,
                    0.88,
                    0.88,
                    0.88,
                    7.92,
                    -0.09,
                    -15.49,
                    0.33,
                    0.78,
                    -0.38,
                    -0.36,
                    1.02,
                    1.02,
                    1.02,
                    7.35,
                    -0.09,
                    -14.87,
                    0.65,
                    0.32,
                    -0.27,
                    -0.63,
                    0.87,
                    0.87,
                    0.87,
                    8.27,
                    -0.09,
                    -14.88,
                    0.57,
                    0.51,
                    -0.62,
                    0.18,
                    0.98,
                    0.98,
                    0.98,
                    8.10,
                    -0.09,
                    -14.55,
                    0.27,
                    0.94,
                    -0.09,
                    -0.2,
                    0.87,
                    0.87,
                    0.87,
                    7.65,
                    -0.09,
                    -14.51,
                    0.39,
                    -0.82,
                    0.18,
                    0.39,
                    0.99,
                    0.99,
                    0.99,
                    7.44,
                    -0.09,
                    -15.5,
                    0.11,
                    0.93,
                    -0.12,
                    -0.32,
                    1.20,
                    1.20,
                    1.20,
                    8.18,
                    -0.09,
                    -15,
                    0.19,
                    0.56,
                    0.10,
                    -0.8,
                    1.17,
                    1.17,
                    1.17,
                    7.23,
                    -0.09,
                    -15.31,
                    0.30,
                    -0.29,
                    -0.42,
                    0.81,
                    1.02,
                    1.02,
                    1.02,
                    8.11,
                    -0.09,
                    -14.53,
                    0.82,
                    -0.27,
                    -0.42,
                    -0.27,
                    0.84,
                    0.84,
                    0.84,
                    7.93,
                    -0.09,
                    -14.61,
                    0.06,
                    -0.37,
                    -0.54,
                    0.75,
                    0.92,
                    0.92,
                    0.92,
                    7.42,
                    -0.09,
                    -14.87,
                    0.60,
                    0.06,
                    -0.6,
                    -0.53,
                    0.86,
                    0.86,
                    0.86,
                    7.33,
                    -0.09,
                    -15.16,
                    0.80,
                    0.19,
                    -0.55,
                    0.14,
                    0.95,
                    0.95,
                    0.95,
                    7.54,
                    -0.09,
                    -15.34,
                    0.16,
                    0.78,
                    -0.52,
                    -0.29,
                    1.07,
                    1.07,
                    1.07,
                    7.62,
                    -0.09,
                    -15.7,
                    0.28,
                    0.72,
                    0.36,
                    -0.53,
                    1.05,
                    1.05,
                    1.05,
                    7.99,
                    -0.09,
                    -15.56,
                    0.49,
                    -0.81,
                    -0.12,
                    0.30,
                    1.06,
                    1.06,
                    1.06,
                    8.16,
                    -0.09,
                    -14.58,
                    0.47,
                    0.72,
                    -0.47,
                    -0.22,
                    1.17,
                    1.17,
                    1.17,
                    8.37,
                    -0.09,
                    -14.97,
                    0.91,
                    0.14,
                    -0.37,
                    -0.09,
                    0.94,
                    0.94,
                    0.94,
                    7.37,
                    -0.09,
                    -14.61,
                    0.26,
                    0.88,
                    -0.12,
                    -0.37,
                    0.98,
                    0.98,
                    0.98,
                    7.38,
                    -0.09,
                    -14.86,
                    0.76,
                    0.48,
                    -0.44,
                    -0.1,
                    1.15,
                    1.15,
                    1.15,
                    7.52,
                    -0.09,
                    -15.26,
                    0.29,
                    0.53,
                    -0.18,
                    -0.78,
                    1.04,
                    1.04,
                    1.04,
                    7.30,
                    -0.09,
                    -15.34,
                    0.18,
                    -0.52,
                    0.12,
                    0.82,
                    1.21,
                    1.21,
                    1.21,
                    8.06,
                    -0.09,
                    -14.57,
                    0.20,
                    -0.67,
                    0.59,
                    0.40,
                    0.91,
                    0.91,
                    0.91,
                    7.93,
                    -0.09,
                    -15.7,
                    0.02,
                    0.34,
                    0.53,
                    -0.78,
                    0.91,
                    0.91,
                    0.91,
                    7.21,
                    -0.09,
                    -15.15,
                    0.26,
                    0.19,
                    -0.95,
                    -0.06,
                    1.08,
                    1.08,
                    1.08,
                    7.99,
                    -0.09,
                    -14.8,
                    0.17,
                    0.29,
                    -0.86,
                    -0.38,
                    0.90,
                    0.90,
                    0.90,
                    8.00,
                    -0.09,
                    -15.36,
                    0.24,
                    -0.58,
                    0.34,
                    0.69,
                    0.88,
                    0.88,
                    0.88,
                    8.10,
                    -0.09,
                    -15.62,
                    0.01,
                    0.32,
                    0.04,
                    -0.95,
                    1.19,
                    1.19,
                    1.19,
                    7.76,
                    -0.09,
                    -14.48,
                    0.36,
                    0.53,
                    -0.76,
                    0.11,
                    0.92,
                    0.92,
                    0.92,
                    7.67,
                    -0.09,
                    -15.4,
                    0.90,
                    0.01,
                    -0.27,
                    0.34,
                    0.90,
                    0.90,
                    0.90,
                    8.13,
                    -0.09,
                    -15,
                    0.19,
                    0.92,
                    0.05,
                    -0.35,
                    1.06,
                    1.06,
                    1.06,
                    8.12,
                    -0.09,
                    -15.43,
                    0.70,
                    0.09,
                    -0.58,
                    0.40,
                    1.18,
                    1.18,
                    1.18,
                    8.30,
                    -0.09,
                    -15.3,
                    0.10,
                    -0.42,
                    -0.2,
                    0.88,
                    1.10,
                    1.10,
                    1.10,
                    7.52,
                    -0.09,
                    -15.64,
                    0.34,
                    -0.78,
                    0.15,
                    0.50,
                    0.89,
                    0.89,
                    0.89,
                    7.97,
                    -0.09,
                    -14.57,
                    0.41,
                    0.13,
                    -0.57,
                    -0.7,
                    0.94,
                    0.94,
                    0.94,
                    7.47,
                    -0.09,
                    -15.36,
                    0.59,
                    0.66,
                    -0.36,
                    -0.3,
                    1.12,
                    1.12,
                    1.12,
                    7.89,
                    -0.09,
                    -15.24,
                    0.49,
                    -0.68,
                    -0.22,
                    0.51,
                    1.12,
                    1.12,
                    1.12,
                    8.11,
                    -0.09,
                    -15.49,
                    0.34,
                    -0.36,
                    -0.32,
                    0.81,
                    1.03,
                    1.03,
                    1.03,
                    7.67,
                    -0.09,
                    -15.64,
                    0.05,
                    0.12,
                    -0.32,
                    -0.94,
                    1.07,
                    1.07,
                    1.07,
                    8.14,
                    -0.09,
                    -15.46,
                    0.57,
                    0.34,
                    -0.58,
                    0.46,
                    1.07,
                    1.07,
                    1.07,
                    7.42,
                    -0.09,
                    -14.94,
                    0.33,
                    -0.87,
                    -0.09,
                    0.35,
                    0.93,
                    0.93,
                    0.93,
                    7.40,
                    -0.09,
                    -15.09,
                    0.27,
                    0.57,
                    0.27,
                    -0.73,
                    1.07,
                    1.07,
                    1.07,
                    7.93,
                    -0.09,
                    -14.98,
                    0.74,
                    -0.35,
                    -0.57,
                    -0.06,
                    0.90,
                    0.90,
                    0.90,
                    7.57,
                    -0.09,
                    -14.77,
                    0.00,
                    -0.39,
                    -0.09,
                    0.91,
                    1.11,
                    1.11,
                    1.11,
                    8.37,
                    -0.09,
                    -15.34,
                    0.73,
                    0.50,
                    0.06,
                    -0.46,
                    1.08,
                    1.08,
                    1.08,
                    7.70,
                    -0.09,
                    -14.98,
                    0.43,
                    -0.52,
                    -0.74,
                    -0.02,
                    0.85,
                    0.85,
                    0.85,
                    7.47,
                    -0.09,
                    -14.81,
                    0.83,
                    -0.11,
                    -0.42,
                    -0.33,
                    0.88,
                    0.88,
                    0.88,
                    7.83,
                    -0.09,
                    -14.77,
                    0.54,
                    0.43,
                    -0.68,
                    0.24,
                    1.19,
                    1.19,
                    1.19,
                    7.79,
                    -0.09,
                    -14.67,
                    0.42,
                    -0.33,
                    -0.1,
                    0.84,
                    1.20,
                    1.20,
                    1.20,
                    7.96,
                    -0.09,
                    -15.49,
                    0.47,
                    0.12,
                    -0.74,
                    -0.47,
                    1.01,
                    1.01,
                    1.01,
                    7.40,
                    -0.09,
                    -15.1,
                    0.22,
                    0.44,
                    0.19,
                    -0.85,
                    1.20,
                    1.20,
                    1.20,
                    7.95,
                    -0.09,
                    -14.59,
                    0.29,
                    0.22,
                    -0.74,
                    -0.57,
                    0.95,
                    0.95,
                    0.95,
                    7.76,
                    -0.09,
                    -14.89,
                    0.14,
                    0.80,
                    -0.1,
                    -0.57,
                    0.90,
                    0.90,
                    0.90,
                    7.42,
                    -0.09,
                    -14.9,
                    0.13,
                    0.76,
                    -0.52,
                    -0.37,
                    0.97,
                    0.97,
                    0.97,
                    8.09,
                    -0.09,
                    -14.97,
                    0.42,
                    -0.65,
                    0.48,
                    0.42,
                    1.05,
                    1.05,
                    1.05,
                    7.12,
                    -0.09,
                    -15.02,
                    0.32,
                    0.84,
                    -0.31,
                    -0.3,
                    0.93,
                    0.93,
                    0.93,
                    7.87,
                    -0.09,
                    -15.03,
                    0.53,
                    -0.54,
                    -0,
                    0.66,
                    0.87,
                    0.87,
                    0.87,
                    8.13,
                    -0.09,
                    -14.85,
                    0.23,
                    0.10,
                    -0.86,
                    0.45,
                    0.97,
                    0.97,
                    0.97,
                    7.46,
                    -0.09,
                    -15.38,
                    0.19,
                    0.21,
                    -0.83,
                    -0.48,
                    1.17,
                    1.17,
                    1.17,
                    7.29,
                    -0.09,
                    -15.23,
                    0.09,
                    0.88,
                    0.31,
                    -0.36,
                    0.95,
                    0.95,
                    0.95,
                    7.57,
                    -0.09,
                    -15.54,
                    0.28,
                    0.57,
                    0.08,
                    -0.77,
                    0.96,
                    0.96,
                    0.96,
                    7.82,
                    -0.09,
                    -14.74,
                    0.46,
                    0.76,
                    -0.45,
                    -0.11,
                    0.88,
                    0.88,
                    0.88,
                    7.94,
                    -0.09,
                    -15.47,
                    0.65,
                    -0.65,
                    0.00,
                    0.41,
                    1.09,
                    1.09,
                    1.09,
                    7.55,
                    -0.09,
                    -14.84,
                    0.47,
                    -0.29,
                    -0.48,
                    0.68,
                    1.22,
                    1.22,
                    1.22,
                    7.31,
                    -0.09,
                    -15.16,
                    0.10,
                    0.32,
                    -0.31,
                    -0.89,
                    1.13,
                    1.13,
                    1.13,
                    8.16,
                    -0.09,
                    -14.88,
                    0.66,
                    0.67,
                    0.03,
                    -0.35,
                    1.17,
                    1.17,
                    1.17,
                    7.61,
                    -0.09,
                    -14.66,
                    0.74,
                    -0.29,
                    -0.46,
                    0.39,
                    0.95,
                    0.95,
                    0.95,
                    7.48,
                    -0.09,
                    -15.47,
                    0.23,
                    -0.34,
                    -0.01,
                    0.91,
                    1.19,
                    1.19,
                    1.19,
                    7.49,
                    -0.09,
                    -15.49,
                    0.58,
                    -0.17,
                    -0.4,
                    -0.69,
                    1.01,
                    1.01,
                    1.01,
                    7.93,
                    -0.09,
                    -14.67,
                    0.05,
                    -0.59,
                    0.57,
                    0.57,
                    1.07,
                    1.07,
                    1.07,
                    8.27,
                    -0.09,
                    -15.13,
                    0.24,
                    0.85,
                    0.08,
                    -0.47,
                    0.85,
                    0.85,
                    0.85,
                    8.28,
                    -0.09,
                    -15.43,
                    0.82,
                    0.25,
                    -0.52,
                    -0.02,
                    1.02,
                    1.02,
                    1.02,
                    8.38,
                    -0.09,
                    -14.92,
                    0.42,
                    0.53,
                    -0.16,
                    -0.72,
                    0.89,
                    0.89,
                    0.89,
                    7.63,
                    -0.09,
                    -15.07,
                    0.23,
                    0.30,
                    -0.53,
                    -0.76,
                    0.92,
                    0.92,
                    0.92,
                    7.50,
                    -0.09,
                    -14.68,
                    0.75,
                    0.45,
                    -0.44,
                    -0.2,
                    0.85,
                    0.85,
                    0.85,
                    7.87,
                    -0.09,
                    -14.71,
                    0.32,
                    0.60,
                    -0.38,
                    -0.64,
                    1.19,
                    1.19,
                    1.19,
                    7.16,
                    -0.09,
                    -14.88,
                    0.48,
                    0.31,
                    -0.13,
                    -0.81,
                    1.16,
                    1.16,
                    1.16,
                    7.76,
                    -0.09,
                    -14.97,
                    0.19,
                    -0.05,
                    -0.57,
                    -0.8,
                    0.98,
                    0.98,
                    0.98,
                    8.22,
                    -0.09,
                    -15.22,
                    0.44,
                    0.87,
                    -0.11,
                    -0.19,
                    0.89,
                    0.89,
                    0.89,
                    7.44,
                    -0.09,
                    -14.64,
                    0.05,
                    0.46,
                    -0.82,
                    -0.35,
                    0.87,
                    0.87,
                    0.87,
                    7.92,
                    -0.09,
                    -15.59,
                    0.81,
                    0.57,
                    -0.07,
                    -0.13,
                    1.06,
                    1.06,
                    1.06,
                    8.23,
                    -0.09,
                    -14.94,
                    0.04,
                    -0.29,
                    0.40,
                    0.87,
                    0.92,
                    0.92,
                    0.92,
                    7.28,
                    -0.09,
                    -14.65,
                    0.85,
                    0.38,
                    -0.2,
                    -0.32,
                    0.86,
                    0.86,
                    0.86,
                    7.87,
                    -0.09,
                    -15.5,
                    0.59,
                    0.68,
                    -0.22,
                    -0.38,
                    0.97,
                    0.97,
                    0.97,
                    7.48,
                    -0.09,
                    -15.57,
                    0.20,
                    -0.49,
                    0.11,
                    0.84,
                    0.96,
                    0.96,
                    0.96,
                    7.95,
                    -0.09,
                    -15.54,
                    0.50,
                    0.34,
                    0.06,
                    -0.79,
                    0.82,
                    0.82,
                    0.82,
                    7.86,
                    -0.09,
                    -14.85,
                    0.24,
                    0.83,
                    0.33,
                    -0.4,
                    0.92,
                    0.92,
                    0.92,
                    7.98,
                    -0.09,
                    -15.09,
                    0.71,
                    0.14,
                    -0.69,
                    0.05,
                    1.18,
                    1.18,
                    1.18,
                    8.14,
                    -0.09,
                    -15,
                    0.27,
                    0.61,
                    -0.64,
                    -0.38,
                    1.11,
                    1.11,
                    1.11,
                    7.32,
                    -0.09,
                    -14.94,
                    0.42,
                    0.90,
                    -0.05,
                    -0.15,
                    0.99,
                    0.99,
                    0.99,
                    7.13,
                    -0.09,
                    -15.31,
                    0.66,
                    0.03,
                    -0.57,
                    0.49,
                    1.10,
                    1.10,
                    1.10,
                    8.08,
                    -0.09,
                    -14.7,
                    0.03,
                    0.33,
                    0.07,
                    -0.94,
                    1.06,
                    1.06,
                    1.06,
                    7.78,
                    -0.09,
                    -15.67,
                    0.20,
                    0.09,
                    -0.78,
                    -0.58,
                    1.03,
                    1.03,
                    1.03,
                    7.60,
                    -0.09,
                    -15.13,
                    0.39,
                    0.56,
                    0.16,
                    -0.72,
                    1.02,
                    1.02,
                    1.02,
                    7.73,
                    -0.09,
                    -14.64,
                    0.05,
                    -0.51,
                    0.31,
                    0.80,
                    1.07,
                    1.07,
                    1.07,
                    7.72,
                    -0.09,
                    -14.56,
                    0.91,
                    0.18,
                    -0.31,
                    -0.18,
                    1.04,
                    1.04,
                    1.04,
                    7.61,
                    -0.09,
                    -15.08,
                    0.67,
                    0.57,
                    -0.19,
                    -0.44,
                    1.08,
                    1.08,
                    1.08,
                    8.17,
                    -0.09,
                    -15.19,
                    0.72,
                    -0.11,
                    -0.5,
                    -0.47,
                    0.91,
                    0.91,
                    0.91,
                    7.72,
                    -0.09,
                    -14.8,
                    0.53,
                    0.52,
                    -0.66,
                    0.13,
                    1.11,
                    1.11,
                    1.11,
                    7.39,
                    -0.09,
                    -15.58,
                    0.16,
                    -0.33,
                    0.10,
                    0.93,
                    1.16,
                    1.16,
                    1.16,
                    7.35,
                    -0.09,
                    -14.98,
                    0.17,
                    -0.61,
                    0.31,
                    0.70,
                    0.91,
                    0.91,
                    0.91,
                    7.44,
                    -0.09,
                    -15.26,
                    0.40,
                    0.67,
                    -0.33,
                    -0.53,
                    1.07,
                    1.07,
                    1.07,
                    8.21,
                    -0.09,
                    -15.01,
                    0.89,
                    0.06,
                    -0.4,
                    -0.2,
                    1.14,
                    1.14,
                    1.14,
                    8.26,
                    -0.09,
                    -15.11,
                    0.93,
                    0.31,
                    -0.17,
                    0.11,
                    0.97,
                    0.97,
                    0.97,
                    7.42,
                    -0.09,
                    -15.14,
                    0.18,
                    0.57,
                    0.22,
                    -0.77,
                    1.00,
                    1.00,
                    1.00,
                    7.80,
                    -0.09,
                    -15.21,
                    0.01,
                    0.65,
                    -0.37,
                    -0.66,
                    1.13,
                    1.13,
                    1.13,
                    7.61,
                    -0.09,
                    -15.11,
                    0.13,
                    0.43,
                    -0.22,
                    -0.86,
                    1.10,
                    1.10,
                    1.10,
                    7.73,
                    -0.09,
                    -15.35,
                    0.31,
                    0.89,
                    -0.24,
                    -0.22,
                    1.03,
                    1.03,
                    1.03,
                    8.31,
                    -0.09,
                    -15,
                    0.64,
                    -0.48,
                    0.20,
                    0.57,
                    1.18,
                    1.18,
                    1.18,
                    7.75,
                    -0.09,
                    -15.22,
                    0.62,
                    0.43,
                    -0.27,
                    -0.6,
                    0.97,
                    0.97,
                    0.97,
                    7.92,
                    -0.09,
                    -14.53,
                    0.19,
                    -0.92,
                    0.06,
                    0.34,
                    1.12,
                    1.12,
                    1.12,
                    7.82,
                    -0.09,
                    -14.59,
                    0.19,
                    0.04,
                    -0.6,
                    0.78,
                    1.09,
                    1.09,
                    1.09,
                    7.76,
                    -0.09,
                    -14.81,
                    0.43,
                    -0.45,
                    0.21,
                    0.76,
                    0.94,
                    0.94,
                    0.94,
                    7.62,
                    -0.09,
                    -15.07,
                    0.31,
                    0.83,
                    0.23,
                    -0.39,
                    1.08,
                    1.08,
                    1.08,
                    7.23,
                    -0.09,
                    -15.3,
                    0.64,
                    -0.41,
                    -0.03,
                    0.65,
                    1.11,
                    1.11,
                    1.11,
                    7.71,
                    -0.09,
                    -15.46,
                    0.25,
                    0.40,
                    -0.26,
                    -0.84,
                    1.11,
                    1.11,
                    1.11,
                    7.60,
                    -0.09,
                    -15.69,
                    0.17,
                    0.52,
                    -0.53,
                    -0.65,
                    1.12,
                    1.12,
                    1.12,
                    7.34,
                    -0.09,
                    -14.71,
                    0.12,
                    0.85,
                    -0.01,
                    -0.51,
                    0.99,
                    0.99,
                    0.99,
                    7.37,
                    -0.09,
                    -14.72,
                    0.23,
                    0.67,
                    0.08,
                    -0.7,
                    1.01,
                    1.01,
                    1.01,
                    8.22,
                    -0.09,
                    -15.08,
                    0.23,
                    -0.87,
                    -0.36,
                    0.22,
                    1.11,
                    1.11,
                    1.11,
                    8.10,
                    -0.09,
                    -15.57,
                    0.30,
                    0.36,
                    -0.85,
                    0.24,
                    1.17,
                    1.17,
                    1.17,
                    7.95,
                    -0.09,
                    -14.52,
                    0.83,
                    0.12,
                    -0.03,
                    -0.54,
                    0.95,
                    0.95,
                    0.95,
                    7.33,
                    -0.09,
                    -15.25,
                    0.53,
                    0.79,
                    -0.16,
                    -0.27,
                    1.11,
                    1.11,
                    1.11,
                    8.13,
                    -0.09,
                    -14.65,
                    0.31,
                    0.77,
                    -0.26,
                    -0.49,
                    1.01,
                    1.01,
                    1.01,
                    7.74,
                    -0.09,
                    -15.41,
                    0.23,
                    0.54,
                    -0.65,
                    -0.48,
                    0.95,
                    0.95,
                    0.95,
                    8.12,
                    -0.09,
                    -14.7,
                    0.50,
                    0.68,
                    0.25,
                    -0.47,
                    0.90,
                    0.90,
                    0.90,
                    8.34,
                    -0.09,
                    -15.21,
                    0.65,
                    0.03,
                    -0.63,
                    -0.41,
                    1.01,
                    1.01,
                    1.01,
                    8.24,
                    -0.09,
                    -14.68,
                    0.54,
                    0.36,
                    -0.76,
                    0.05,
                    0.95,
                    0.95,
                    0.95,
                    8.14,
                    -0.09,
                    -15.47,
                    0.70,
                    -0.22,
                    -0.06,
                    0.67,
                    1.16,
                    1.16,
                    1.16,
                    8.34,
                    -0.09,
                    -15.04,
                    0.16,
                    -0.01,
                    -0.9,
                    -0.4,
                    0.91,
                    0.91,
                    0.91,
                    7.48,
                    -0.09,
                    -14.9,
                    0.73,
                    0.53,
                    0.05,
                    -0.43,
                    0.85,
                    0.85,
                    0.85,
                    7.77,
                    -0.09,
                    -14.73,
                    0.06,
                    0.41,
                    -0.56,
                    -0.72,
                    0.82,
                    0.82,
                    0.82,
                    7.74,
                    -0.09,
                    -15.6,
                    0.82,
                    0.23,
                    -0.51,
                    -0.15,
                    0.90,
                    0.90,
                    0.90,
                    8.31,
                    -0.09,
                    -15.41,
                    0.38,
                    -0.37,
                    -0.47,
                    0.70,
                    0.90,
                    0.90,
                    0.90,
                    7.18,
                    -0.09,
                    -14.89,
                    0.00,
                    -0.89,
                    0.37,
                    0.26,
                    1.08,
                    1.08,
                    1.08,
                    7.51,
                    -0.09,
                    -14.78,
                    0.22,
                    0.08,
                    -0.67,
                    -0.7,
                    1.08,
                    1.08,
                    1.08,
                    7.30,
                    -0.09,
                    -15.02,
                    0.58,
                    0.52,
                    -0.28,
                    -0.56,
                    1.02,
                    1.02,
                    1.02,
                    7.34,
                    -0.09,
                    -15.47,
                    0.69,
                    0.39,
                    -0.44,
                    -0.42,
                    0.91,
                    0.91,
                    0.91,
                    7.60,
                    -0.09,
                    -15.41,
                    0.03,
                    0.71,
                    -0.65,
                    -0.29,
                    0.90,
                    0.90,
                    0.90,
                    8.32,
                    -0.09,
                    -14.92,
                    0.06,
                    0.18,
                    -0.78,
                    -0.59,
                    1.21,
                    1.21,
                    1.21,
                    8.12,
                    -0.09,
                    -15.27,
                    0.67,
                    0.29,
                    -0.62,
                    -0.27,
                    1.03,
                    1.03,
                    1.03,
                    7.85,
                    -0.09,
                    -14.59,
                    0.28,
                    0.59,
                    -0.21,
                    -0.73,
                    1.10,
                    1.10,
                    1.10,
                    7.72,
                    -0.09,
                    -14.97,
                    0.07,
                    0.16,
                    -0.86,
                    -0.49,
                    0.92,
                    0.92,
                    0.92,
                    8.13,
                    -0.09,
                    -15.31,
                    0.07,
                    0.95,
                    -0.3,
                    -0.04,
                    1.07,
                    1.07,
                    1.07,
                    7.92,
                    -0.09,
                    -14.55,
                    0.26,
                    -0.84,
                    0.39,
                    0.26,
                    1.07,
                    1.07,
                    1.07,
                    7.93,
                    -0.09,
                    -14.87,
                    0.74,
                    -0.38,
                    -0.45,
                    -0.33,
                    1.09,
                    1.09,
                    1.09,
                    7.49,
                    -0.09,
                    -14.91,
                    0.08,
                    -0.28,
                    -0.16,
                    0.94,
                    1.14,
                    1.14,
                    1.14,
                    7.16,
                    -0.09,
                    -15.37,
                    0.07,
                    0.25,
                    0.38,
                    -0.89,
                    0.84,
                    0.84,
                    0.84,
                    7.44,
                    -0.09,
                    -15.53,
                    0.38,
                    0.01,
                    -0.68,
                    -0.63,
                    1.21,
                    1.21,
                    1.21,
                    7.79,
                    -0.09,
                    -14.83,
                    0.17,
                    -0.66,
                    -0.3,
                    0.66,
                    0.95,
                    0.95,
                    0.95,
                    8.20,
                    -0.09,
                    -15.39,
                    0.94,
                    -0.05,
                    -0.35,
                    -0.01,
                    1.10,
                    1.10,
                    1.10,
                    7.82,
                    -0.09,
                    -14.88,
                    0.15,
                    0.12,
                    0.25,
                    -0.95,
                    0.85,
                    0.85,
                    0.85,
                    8.19,
                    -0.09,
                    -15.08,
                    0.27,
                    -0.92,
                    0.21,
                    0.18,
                    0.95,
                    0.95,
                    0.95,
                    7.61,
                    -0.09,
                    -14.74,
                    0.84,
                    -0.3,
                    -0.43,
                    -0.15,
                    1.04,
                    1.04,
                    1.04,
                    7.36,
                    -0.09,
                    -14.96,
                    0.13,
                    -0.32,
                    -0.31,
                    0.88,
                    0.95,
                    0.95,
                    0.95,
                    8.26,
                    -0.09,
                    -15,
                    0.80,
                    0.51,
                    -0.18,
                    -0.26,
                    1.15,
                    1.15,
                    1.15,
                    8.05,
                    -0.09,
                    -15.61,
                    0.28,
                    0.25,
                    -0.87,
                    -0.33,
                    1.03,
                    1.03,
                    1.03,
                    7.95,
                    -0.09,
                    -14.58,
                    0.17,
                    0.43,
                    -0.57,
                    -0.68,
                    1.02,
                    1.02,
                    1.02,
                    7.74,
                    -0.09,
                    -14.77,
                    0.69,
                    0.39,
                    -0.44,
                    -0.41,
                    1.05,
                    1.05,
                    1.05,
                    8.36,
                    -0.09,
                    -15.25,
                    0.11,
                    -0.59,
                    -0.32,
                    0.73,
                    1.00,
                    1.00,
                    1.00,
                    8.03,
                    -0.09,
                    -15.57,
                    0.26,
                    0.44,
                    -0.85,
                    -0.13,
                    1.10,
                    1.10,
                    1.10,
                    7.48,
                    -0.09,
                    -15.58,
                    0.18,
                    0.10,
                    -0.89,
                    -0.41,
                    0.94,
                    0.94,
                    0.94,
                    7.22,
                    -0.09,
                    -15.48,
                    0.27,
                    -0.47,
                    0.33,
                    0.77,
                    0.93,
                    0.93,
                    0.93,
                    8.21,
                    -0.09,
                    -15.37,
                    0.16,
                    -0.24,
                    -0.17,
                    0.94,
                    1.14,
                    1.14,
                    1.14,
                    7.78,
                    -0.09,
                    -15.35,
                    0.30,
                    0.73,
                    -0.61,
                    0.02,
                    0.84,
                    0.84,
                    0.84,
                    8.01,
                    -0.09,
                    -15.25,
                    0.79,
                    0.34,
                    -0.15,
                    -0.49,
                    0.93,
                    0.93,
                    0.93,
                    7.64,
                    -0.09,
                    -15.29,
                    0.36,
                    -0.34,
                    -0.68,
                    0.54,
                    1.06,
                    1.06,
                    1.06,
                    7.55,
                    -0.09,
                    -14.91,
                    0.50,
                    0.28,
                    -0.33,
                    -0.75,
                    1.02,
                    1.02,
                    1.02,
                    7.22,
                    -0.09,
                    -15.42,
                    0.10,
                    0.50,
                    0.52,
                    -0.68,
                    0.91,
                    0.91,
                    0.91,
                    8.02,
                    -0.09,
                    -15.59,
                    0.63,
                    -0.07,
                    -0.39,
                    0.67,
                    1.20,
                    1.20,
                    1.20,
                    7.58,
                    -0.09,
                    -15.59,
                    0.25,
                    -0.44,
                    0.19,
                    0.84,
                    0.92,
                    0.92,
                    0.92,
                    7.51,
                    -0.09,
                    -15.49,
                    0.74,
                    -0.31,
                    -0.08,
                    0.59,
                    0.84,
                    0.84,
                    0.84,
                    7.19,
                    -0.09,
                    -15.13,
                    0.21,
                    0.41,
                    -0.21,
                    -0.87,
                    1.17,
                    1.17,
                    1.17,
                    7.25,
                    -0.09,
                    -14.86,
                    0.07,
                    -0.61,
                    0.38,
                    0.70,
                    0.83,
                    0.83,
                    0.83,
                    7.29,
                    -0.09,
                    -15.28,
                    0.42,
                    0.67,
                    -0.35,
                    -0.5,
                    1.18,
                    1.18,
                    1.18,
                    7.91,
                    -0.09,
                    -15.52,
                    0.13,
                    -0.82,
                    -0.41,
                    0.39,
                    1.09,
                    1.09,
                    1.09,
                    7.40,
                    -0.09,
                    -14.61,
                    0.27,
                    -0.96,
                    -0.08,
                    0.05,
                    0.96,
                    0.96,
                    0.96,
                    8.26,
                    -0.09,
                    -14.98,
                    0.08,
                    0.57,
                    0.77,
                    -0.26,
                    1.05,
                    1.05,
                    1.05,
                    7.56,
                    -0.09,
                    -14.55,
                    0.52,
                    0.78,
                    -0.13,
                    -0.33,
                    0.91,
                    0.91,
                    0.91,
                    8.13,
                    -0.09,
                    -15.19,
                    0.45,
                    0.27,
                    -0.48,
                    -0.71,
                    1.09,
                    1.09,
                    1.09,
                    7.42,
                    -0.09,
                    -15.29,
                    0.34,
                    -0.82,
                    -0.1,
                    0.46,
                    1.11,
                    1.11,
                    1.11,
                    7.22,
                    -0.09,
                    -15,
                    0.80,
                    0.43,
                    -0.42,
                    -0.09,
                    0.84,
                    0.84,
                    0.84,
                    8.20,
                    -0.09,
                    -14.93,
                    0.25,
                    -0.22,
                    -0.94,
                    0.01,
                    0.84,
                    0.84,
                    0.84,
                    7.52,
                    -0.09,
                    -14.6,
                    0.77,
                    -0.26,
                    -0.42,
                    -0.39,
                    1.15,
                    1.15,
                    1.15,
                    7.74,
                    -0.09,
                    -14.5,
                    0.40,
                    0.75,
                    0.23,
                    -0.47,
                    1.01,
                    1.01,
                    1.01,
                    7.49,
                    -0.09,
                    -15.12,
                    0.23,
                    0.36,
                    -0.71,
                    -0.56,
                    0.84,
                    0.84,
                    0.84,
                    7.57,
                    -0.09,
                    -14.87,
                    0.63,
                    0.59,
                    -0.13,
                    -0.49,
                    1.01,
                    1.01,
                    1.01,
                    7.97,
                    -0.09,
                    -15.17,
                    0.29,
                    0.31,
                    -0.57,
                    -0.7,
                    0.86,
                    0.86,
                    0.86,
                    7.56,
                    -0.09,
                    -15.48,
                    0.08,
                    0.59,
                    0.18,
                    -0.78,
                    0.87,
                    0.87,
                    0.87,
                    8.42,
                    -0.09,
                    -15.12,
                    0.13,
                    -0.91,
                    -0.21,
                    0.32,
                    0.93,
                    0.93,
                    0.93,
                    7.95,
                    -0.09,
                    -14.79,
                    0.39,
                    0.79,
                    0.26,
                    -0.38,
                    0.90,
                    0.90,
                    0.90,
                    8.33,
                    -0.09,
                    -15.05,
                    0.38,
                    0.30,
                    -0.23,
                    -0.84,
                    1.05,
                    1.05,
                    1.05,
                    8.00,
                    -0.09,
                    -15.14,
                    0.24,
                    -0.85,
                    0.05,
                    0.47,
                    1.02,
                    1.02,
                    1.02,
                    7.72,
                    -0.09,
                    -15.22,
                    0.77,
                    0.50,
                    -0.39,
                    -0,
                    1.13,
                    1.13,
                    1.13,
                    7.21,
                    -0.09,
                    -14.8,
                    0.19,
                    0.66,
                    -0.7,
                    -0.18,
                    0.83,
                    0.83,
                    0.83,
                    8.19,
                    -0.09,
                    -14.85,
                    0.05,
                    0.42,
                    -0.65,
                    -0.64,
                    0.87,
                    0.87,
                    0.87,
                    7.63,
                    -0.09,
                    -15.49,
                    0.05,
                    0.68,
                    -0.1,
                    -0.73,
                    0.87,
                    0.87,
                    0.87,
                    7.90,
                    -0.09,
                    -15.63,
                    0.38,
                    0.14,
                    -0.91,
                    -0.02,
                    0.95,
                    0.95,
                    0.95,
                    7.71,
                    -0.09,
                    -14.74,
                    0.24,
                    -0.55,
                    0.73,
                    0.33,
                    1.13,
                    1.13,
                    1.13,
                    7.32,
                    -0.09,
                    -14.82,
                    0.43,
                    0.86,
                    -0.21,
                    -0.19,
                    0.94,
                    0.94,
                    0.94,
                    8.16,
                    -0.09,
                    -14.99,
                    0.13,
                    0.84,
                    0.02,
                    -0.52,
                    1.19,
                    1.19,
                    1.19,
                    7.75,
                    -0.09,
                    -15.25,
                    0.56,
                    0.77,
                    -0.31,
                    -0.09,
                    1.17,
                    1.17,
                    1.17,
                    7.28,
                    -0.09,
                    -15.51,
                    0.33,
                    0.31,
                    -0.31,
                    -0.84,
                    0.88,
                    0.88,
                    0.88,
                    7.50,
                    -0.09,
                    -14.91,
                    0.24,
                    0.51,
                    0.30,
                    -0.77,
                    1.15,
                    1.15,
                    1.15,
                    7.53,
                    -0.09,
                    -14.57,
                    0.24,
                    0.62,
                    -0.7,
                    -0.27,
                    1.10,
                    1.10,
                    1.10,
                    7.29,
                    -0.09,
                    -15.18,
                    0.06,
                    0.34,
                    0.13,
                    -0.93,
                    1.00,
                    1.00,
                    1.00,
                    7.67,
                    -0.09,
                    -15.34,
                    0.29,
                    -0.01,
                    -0.61,
                    0.73,
                    0.85,
                    0.85,
                    0.85,
                    7.79,
                    -0.09,
                    -15.34,
                    0.32,
                    -0.48,
                    0.24,
                    0.78,
                    0.93,
                    0.93,
                    0.93,
                    8.26,
                    -0.09,
                    -14.78,
                    0.50,
                    0.33,
                    -0.77,
                    0.23,
                    0.94,
                    0.94,
                    0.94,
                    7.54,
                    -0.09,
                    -14.65,
                    0.02,
                    0.48,
                    -0.62,
                    -0.62,
                    1.14,
                    1.14,
                    1.14,
                    8.06,
                    -0.09,
                    -15.24,
                    0.10,
                    -0.69,
                    -0.5,
                    0.52,
                    0.95,
                    0.95,
                    0.95,
                    7.60,
                    -0.09,
                    -15.4,
                    0.86,
                    0.16,
                    -0.47,
                    -0.1,
                    1.20,
                    1.20,
                    1.20,
                    7.68,
                    -0.09,
                    -14.5,
                    0.17,
                    -0.36,
                    -0.44,
                    0.81,
                    1.01,
                    1.01,
                    1.01,
                    7.53,
                    -0.09,
                    -14.57,
                    0.33,
                    -0.35,
                    -0.88,
                    -0.03,
                    1.00,
                    1.00,
                    1.00,
                    7.46,
                    -0.09,
                    -14.83,
                    0.09,
                    -0.93,
                    0.22,
                    0.29,
                    0.84,
                    0.84,
                    0.84,
                    8.36,
                    -0.09,
                    -15.14,
                    0.38,
                    -0.29,
                    -0.86,
                    -0.18,
                    1.20,
                    1.20,
                    1.20,
                    8.23,
                    -0.09,
                    -15.35,
                    0.33,
                    0.30,
                    -0.87,
                    -0.21,
                    1.04,
                    1.04,
                    1.04,
                    7.99,
                    -0.09,
                    -14.76,
                    0.66,
                    -0.17,
                    -0.67,
                    -0.3,
                    1.15,
                    1.15,
                    1.15,
                    7.65,
                    -0.09,
                    -14.94,
                    0.47,
                    0.71,
                    -0.48,
                    -0.21,
                    0.88,
                    0.88,
                    0.88,
                    7.77,
                    -0.09,
                    -14.74,
                    0.14,
                    -0.61,
                    0.35,
                    0.70,
                    1.03,
                    1.03,
                    1.03,
                    7.57,
                    -0.09,
                    -15.05,
                    0.40,
                    0.62,
                    -0.23,
                    -0.64,
                    0.96,
                    0.96,
                    0.96,
                    7.65,
                    -0.09,
                    -15.26,
                    0.67,
                    0.57,
                    -0.41,
                    -0.23,
                    0.91,
                    0.91,
                    0.91,
                    7.60,
                    -0.09,
                    -15.48,
                    0.04,
                    0.91,
                    -0.42,
                    -0.07,
                    1.21,
                    1.21,
                    1.21,
                    7.15,
                    -0.09,
                    -14.97,
                    0.07,
                    -0.14,
                    0.75,
                    0.65,
                    0.89,
                    0.89,
                    0.89,
                    7.34,
                    -0.09,
                    -14.63,
                    0.54,
                    -0.3,
                    -0.74,
                    0.26,
                    0.83,
                    0.83,
                    0.83,
                    7.56,
                    -0.09,
                    -15.62,
                    0.87,
                    -0,
                    -0.45,
                    -0.2,
                    0.84,
                    0.84,
                    0.84,
                    7.24,
                    -0.09,
                    -15.45,
                    0.41,
                    0.90,
                    -0.16,
                    0.02,
                    1.17,
                    1.17,
                    1.17,
                    7.58,
                    -0.09,
                    -14.84,
                    0.24,
                    0.16,
                    -0.53,
                    -0.8,
                    1.11,
                    1.11,
                    1.11,
                    7.18,
                    -0.09,
                    -14.96,
                    0.31,
                    -0.39,
                    -0.3,
                    0.81,
                    0.91,
                    0.91,
                    0.91,
                    7.49,
                    -0.09,
                    -15.19,
                    0.10,
                    0.56,
                    -0.64,
                    -0.52,
                    1.13,
                    1.13,
                    1.13,
                    7.71,
                    -0.09,
                    -14.54,
                    0.45,
                    -0.63,
                    -0.63,
                    0.06,
                    0.88,
                    0.88,
                    0.88,
                    7.63,
                    -0.09,
                    -15.07,
                    0.03,
                    -0.34,
                    0.14,
                    0.93,
                    1.21,
                    1.21,
                    1.21,
                    7.95,
                    -0.09,
                    -14.86,
                    0.10,
                    -0.18,
                    -0.45,
                    0.87,
                    0.90,
                    0.90,
                    0.90,
                    7.50,
                    -0.09,
                    -15.52,
                    0.11,
                    0.86,
                    -0.45,
                    -0.2,
                    1.18,
                    1.18,
                    1.18,
                    7.51,
                    -0.09,
                    -15.46,
                    0.58,
                    0.50,
                    -0.04,
                    -0.64,
                    1.07,
                    1.07,
                    1.07,
                    7.33,
                    -0.09,
                    -15.06,
                    0.27,
                    0.72,
                    0.09,
                    -0.63,
                    1.16,
                    1.16,
                    1.16,
                    7.85,
                    -0.09,
                    -14.88,
                    0.55,
                    0.31,
                    -0.7,
                    -0.34,
                    1.00,
                    1.00,
                    1.00,
                    7.63,
                    -0.09,
                    -14.61,
                    0.26,
                    -0.51,
                    0.01,
                    0.82,
                    0.99,
                    0.99,
                    0.99,
                    8.00,
                    -0.09,
                    -15.11,
                    0.65,
                    0.18,
                    0.03,
                    -0.73,
                    1.04,
                    1.04,
                    1.04,
                    8.14,
                    -0.09,
                    -15.35,
                    0.26,
                    0.56,
                    0.58,
                    -0.52,
                    1.01,
                    1.01,
                    1.01,
                    8.16,
                    -0.09,
                    -15.6,
                    0.18,
                    0.84,
                    -0.05,
                    -0.51,
                    1.20,
                    1.20,
                    1.20,
                    7.47,
                    -0.09,
                    -15.04,
                    0.61,
                    0.14,
                    -0.37,
                    -0.68,
                    1.00,
                    1.00,
                    1.00,
                    7.34,
                    -0.09,
                    -14.88,
                    0.93,
                    0.35,
                    -0.09,
                    0.02,
                    1.05,
                    1.05,
                    1.05,
                    8.07,
                    -0.09,
                    -14.55,
                    0.40,
                    0.59,
                    -0.66,
                    -0.23,
                    1.16,
                    1.16,
                    1.16,
                    8.19,
                    -0.09,
                    -15.51,
                    0.37,
                    -0.31,
                    0.22,
                    0.85,
                    1.01,
                    1.01,
                    1.01,
                    7.66,
                    -0.09,
                    -15.17,
                    0.66,
                    -0.65,
                    -0.26,
                    0.28,
                    1.15,
                    1.15,
                    1.15,
                    8.30,
                    -0.09,
                    -15.39,
                    0.92,
                    0.25,
                    -0.3,
                    -0.02,
                    1.04,
                    1.04,
                    1.04,
                    7.30,
                    -0.09,
                    -14.87,
                    0.11,
                    0.90,
                    0.28,
                    -0.31,
                    1.21,
                    1.21,
                    1.21,
                    8.11,
                    -0.09,
                    -15.46,
                    0.76,
                    0.09,
                    -0.55,
                    0.32,
                    0.90,
                    0.90,
                    0.90,
                    8.32,
                    -0.09,
                    -14.99,
                    0.20,
                    0.44,
                    0.10,
                    -0.87,
                    0.83,
                    0.83,
                    0.83,
                    8.17,
                    -0.09,
                    -15.2,
                    0.37,
                    -0.72,
                    0.22,
                    0.54,
                    1.12,
                    1.12,
                    1.12,
                    7.24,
                    -0.09,
                    -15.32,
                    0.54,
                    0.15,
                    -0.45,
                    -0.69,
                    0.98,
                    0.98,
                    0.98,
                    7.88,
                    -0.09,
                    -15.21,
                    0.08,
                    -0.54,
                    -0.53,
                    0.65,
                    1.04,
                    1.04,
                    1.04,
                    8.37,
                    -0.11,
                    -15.04,
                    0.38,
                    -0.29,
                    -0.86,
                    -0.18,
                    0.79,
                    0.79,
                    0.79,
                    8.31,
                    -0.09,
                    -14.92,
                    0.47,
                    -0.4,
                    0.22,
                    0.76,
                    0.81,
                    0.81,
                    0.81,
                    8.37,
                    -0.09,
                    -14.9,
                    0.91,
                    0.14,
                    -0.37,
                    -0.09,
                    0.71,
                    0.71,
                    0.71,
                    8.34,
                    -0.09,
                    -14.85,
                    0.42,
                    0.53,
                    -0.16,
                    -0.72,
                    0.67,
                    0.67,
                    0.67,
                    8.31,
                    -0.09,
                    -14.93,
                    0.64,
                    -0.48,
                    0.20,
                    0.57,
                    0.88,
                    0.88,
                    0.88,
                    8.34,
                    -0.09,
                    -14.96,
                    0.16,
                    -0.01,
                    -0.9,
                    -0.4,
                    0.68,
                    0.68,
                    0.68,
                    8.32,
                    -0.09,
                    -14.86,
                    0.06,
                    0.18,
                    -0.78,
                    -0.59,
                    0.90,
                    0.90,
                    0.90,
                    8.33,
                    -0.09,
                    -14.98,
                    0.38,
                    0.30,
                    -0.23,
                    -0.84,
                    0.79,
                    0.79,
                    0.79,
                    8.38,
                    -0.09,
                    -15.06,
                    0.38,
                    -0.29,
                    -0.86,
                    -0.18,
                    0.90,
                    0.90,
                    0.90,
                    8.37,
                    -0.11,
                    -14.97,
                    0.38,
                    -0.29,
                    -0.86,
                    -0.18,
                    0.59,
                    0.59,
                    0.59,
                    8.26,
                    -0.09,
                    -14.72,
                    0.41,
                    0.60,
                    -0.19,
                    -0.66,
                    0.89,
                    0.89,
                    0.89,
                    8.20,
                    -0.09,
                    -14.71,
                    0.02,
                    -0.23,
                    0.79,
                    0.57,
                    1.21,
                    1.21,
                    1.21,
                    8.19,
                    -0.09,
                    -14.71,
                    0.49,
                    -0.47,
                    0.18,
                    0.72,
                    0.81,
                    0.81,
                    0.81,
                    8.19,
                    -0.09,
                    -14.66,
                    0.41,
                    0.60,
                    -0.19,
                    -0.66,
                    0.67,
                    0.67,
                    0.67,
                    8.23,
                    -0.09,
                    -14.71,
                    0.08,
                    0.03,
                    -0.91,
                    -0.4,
                    0.68,
                    0.68,
                    0.68,
                    8.18,
                    -0.09,
                    -14.64,
                    0.02,
                    -0.23,
                    0.79,
                    0.57,
                    0.90,
                    0.90,
                    0.90,
                    8.26,
                    -0.11,
                    -14.74,
                    0.29,
                    -0.27,
                    -0.89,
                    -0.21,
                    0.59,
                    0.59,
                    0.59,
                    8.13,
                    -0.09,
                    -14.58,
                    0.82,
                    -0.27,
                    -0.42,
                    -0.27,
                    0.55,
                    0.55,
                    0.55,
                    8.15,
                    -0.09,
                    -14.61,
                    0.92,
                    -0.37,
                    0.10,
                    -0.08,
                    0.55,
                    0.55,
                    0.55,
                    8.36,
                    -0.11,
                    -15.01,
                    0.16,
                    -0.01,
                    -0.9,
                    -0.4,
                    0.68,
                    0.68,
                    0.68,
                    8.35,
                    -0.11,
                    -15.13,
                    0.16,
                    -0.01,
                    -0.9,
                    -0.4,
                    0.68,
                    0.68,
                    0.68,
                    8.31,
                    -0.11,
                    -15.34,
                    0.16,
                    -0.01,
                    -0.9,
                    -0.4,
                    0.68,
                    0.68,
                    0.68,
                    8.30,
                    -0.1,
                    -15.42,
                    0.63,
                    0.26,
                    0.37,
                    -0.63,
                    1.08,
                    1.08,
                    1.08,
                    8.24,
                    -0.09,
                    -15.43,
                    0.38,
                    -0.29,
                    -0.86,
                    -0.18,
                    1.20,
                    1.20,
                    1.20
                ];
                for(let i = 0; i < leaf_lp_pqs.length / 10; ++i){
                    leaf_lp_pqs[i * 10 + 0] -= $5fbffa87c50562b9$var$a.lp_patch.position.x;
                    leaf_lp_pqs[i * 10 + 1] -= $5fbffa87c50562b9$var$a.lp_patch.position.y;
                    leaf_lp_pqs[i * 10 + 2] -= $5fbffa87c50562b9$var$a.lp_patch.position.z;
                    leaf_lp_pqs[i * 10 + 7] = .924;
                    leaf_lp_pqs[i * 10 + 8] = -0.924;
                    leaf_lp_pqs[i * 10 + 9] = .924;
                }
                const leaf_lp_instanced_meshes = create_instanced_meshes({
                    names: [
                        "leaf_lp"
                    ],
                    pqs: leaf_lp_pqs,
                    add_to_scene: false,
                    sway: true
                });
                leaf_lp_instanced_meshes.forEach((instanced_mesh)=>$5fbffa87c50562b9$var$a.lp_patch.add(instanced_mesh));
                const tulipa_D_lp_pqs = [
                    8.32,
                    -0.11,
                    -15.23,
                    0.70,
                    -0.08,
                    -0.71,
                    -0.03,
                    0.31,
                    0.31,
                    0.31,
                    7.57,
                    -0.11,
                    -15.23,
                    0.23,
                    0.02,
                    0.97,
                    0.09,
                    0.31,
                    0.31,
                    0.31,
                    7.48,
                    -0.16,
                    -14.72,
                    0.52,
                    -0.07,
                    -0.85,
                    -0.05,
                    0.31,
                    0.31,
                    0.31,
                    7.80,
                    -0.13,
                    -14.65,
                    0.52,
                    -0.07,
                    -0.85,
                    -0.05,
                    0.31,
                    0.31,
                    0.31,
                    7.89,
                    -0.13,
                    -15.52,
                    0.87,
                    -0.09,
                    -0.49,
                    -0.01,
                    0.31,
                    0.31,
                    0.31,
                    8.11,
                    -0.13,
                    -14.73,
                    0.87,
                    -0.09,
                    -0.49,
                    -0.01,
                    0.21,
                    0.21,
                    0.21,
                    8.09,
                    -0.13,
                    -15.19,
                    0.52,
                    -0.07,
                    -0.85,
                    -0.05,
                    0.31,
                    0.31,
                    0.31,
                    8.22,
                    -0.13,
                    -15.05,
                    1.00,
                    -0.08,
                    -0.01,
                    0.04,
                    0.21,
                    0.21,
                    0.21
                ];
                for(let i = 0; i < tulipa_D_lp_pqs.length / 10; ++i){
                    tulipa_D_lp_pqs[i * 10 + 0] -= $5fbffa87c50562b9$var$a.lp_patch.position.x;
                    tulipa_D_lp_pqs[i * 10 + 1] -= $5fbffa87c50562b9$var$a.lp_patch.position.y;
                    tulipa_D_lp_pqs[i * 10 + 2] -= $5fbffa87c50562b9$var$a.lp_patch.position.z;
                    tulipa_D_lp_pqs[i * 10 + 7] = .31;
                    tulipa_D_lp_pqs[i * 10 + 8] = -0.31;
                    tulipa_D_lp_pqs[i * 10 + 9] = .31;
                }
                const tulipa_D_lp_instanced_meshes = create_instanced_meshes({
                    names: [
                        "tulipa_D_lp"
                    ],
                    pqs: tulipa_D_lp_pqs,
                    add_to_scene: false,
                    sway: true
                });
                tulipa_D_lp_instanced_meshes.forEach((instanced_mesh)=>$5fbffa87c50562b9$var$a.lp_patch.add(instanced_mesh));
            }
            {
                $5fbffa87c50562b9$var$a.k_patch = new $0147bee01cff6558$export$e4dd07dff30cc924();
                $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.k_patch);
                const k_patch = garden.scene.getObjectByName("k_patch");
                $5fbffa87c50562b9$var$a.k_patch.position.copy(k_patch.position);
                const platform_k = garden.scene.getObjectByName("platform_k");
                $5fbffa87c50562b9$var$a.k_patch.add(platform_k);
                const leaf_k_pqs = [
                    -33.41,
                    1.26,
                    -26.98,
                    0.50,
                    0.79,
                    0.14,
                    -0.34,
                    0.92,
                    0.92,
                    0.92,
                    -33.92,
                    1.26,
                    -26.47,
                    0.17,
                    0.38,
                    -0.71,
                    -0.57,
                    0.89,
                    0.89,
                    0.89,
                    -33.3,
                    1.26,
                    -27.13,
                    0.10,
                    -0.35,
                    -0.42,
                    0.83,
                    1.14,
                    1.14,
                    1.14,
                    -33.73,
                    1.26,
                    -26.18,
                    0.25,
                    -0.91,
                    -0.09,
                    0.31,
                    1.17,
                    1.17,
                    1.17,
                    -34.04,
                    1.26,
                    -26.83,
                    0.68,
                    -0.09,
                    -0.45,
                    -0.57,
                    0.86,
                    0.86,
                    0.86,
                    -34.21,
                    1.26,
                    -26.52,
                    0.86,
                    0.37,
                    -0.35,
                    0.04,
                    1.07,
                    1.07,
                    1.07,
                    -33.3,
                    1.26,
                    -26.94,
                    0.14,
                    -0.82,
                    -0.33,
                    0.45,
                    1.18,
                    1.18,
                    1.18,
                    -33.29,
                    1.26,
                    -26.6,
                    0.18,
                    0.57,
                    0.12,
                    -0.8,
                    0.98,
                    0.98,
                    0.98,
                    -33.67,
                    1.26,
                    -26.53,
                    0.20,
                    0.82,
                    -0.46,
                    -0.28,
                    1.03,
                    1.03,
                    1.03,
                    -33.29,
                    1.26,
                    -27.02,
                    0.90,
                    0.26,
                    -0.36,
                    0.03,
                    0.86,
                    0.86,
                    0.86,
                    -33.61,
                    1.26,
                    -26.18,
                    0.01,
                    -0.91,
                    -0.3,
                    0.28,
                    0.85,
                    0.85,
                    0.85,
                    -33.46,
                    1.26,
                    -26.73,
                    0.71,
                    0.49,
                    -0.13,
                    -0.49,
                    1.03,
                    1.03,
                    1.03,
                    -33.99,
                    1.26,
                    -26.57,
                    0.11,
                    0.77,
                    0.13,
                    -0.61,
                    0.83,
                    0.83,
                    0.83,
                    -33.48,
                    1.26,
                    -26.54,
                    0.19,
                    -0.67,
                    -0.22,
                    0.68,
                    1.13,
                    1.13,
                    1.13,
                    -33.64,
                    1.26,
                    -26.49,
                    0.56,
                    0.13,
                    -0.08,
                    -0.81,
                    1.17,
                    1.17,
                    1.17,
                    -34.14,
                    1.26,
                    -26.6,
                    0.51,
                    -0.61,
                    0.46,
                    0.41,
                    0.98,
                    0.98,
                    0.98,
                    -33.48,
                    1.26,
                    -26.46,
                    0.13,
                    0.59,
                    -0.48,
                    -0.63,
                    1.14,
                    1.14,
                    1.14,
                    -34.24,
                    1.26,
                    -26.74,
                    0.57,
                    -0.29,
                    -0.76,
                    0.12,
                    1.12,
                    1.12,
                    1.12,
                    -33.77,
                    1.26,
                    -26.62,
                    0.15,
                    0.81,
                    -0.52,
                    -0.24,
                    0.91,
                    0.91,
                    0.91,
                    -33.38,
                    1.26,
                    -26.23,
                    0.10,
                    0.01,
                    -0.73,
                    -0.67,
                    1.14,
                    1.14,
                    1.14,
                    -33.85,
                    1.26,
                    -26.74,
                    0.54,
                    0.14,
                    -0.82,
                    0.11,
                    0.91,
                    0.91,
                    0.91,
                    -33.58,
                    1.26,
                    -26.54,
                    0.61,
                    0.19,
                    -0.51,
                    -0.58,
                    0.82,
                    0.82,
                    0.82,
                    -34.14,
                    1.26,
                    -26.84,
                    0.34,
                    0.07,
                    -0.13,
                    -0.93,
                    1.09,
                    1.09,
                    1.09,
                    -33.76,
                    1.26,
                    -26.2,
                    0.77,
                    -0.37,
                    -0.11,
                    0.51,
                    1.13,
                    1.13,
                    1.13,
                    -33.99,
                    1.26,
                    -26.9,
                    0.23,
                    -0.86,
                    0.30,
                    0.34,
                    0.96,
                    0.96,
                    0.96,
                    -33.75,
                    1.26,
                    -27.06,
                    0.33,
                    0.74,
                    0.31,
                    -0.5,
                    0.91,
                    0.91,
                    0.91,
                    -34.03,
                    1.26,
                    -27.02,
                    0.62,
                    0.38,
                    -0.65,
                    -0.2,
                    1.11,
                    1.11,
                    1.11,
                    -33.48,
                    1.26,
                    -26.48,
                    0.14,
                    -0.74,
                    0.01,
                    0.66,
                    1.15,
                    1.15,
                    1.15,
                    -33.18,
                    1.26,
                    -26.52,
                    0.89,
                    0.27,
                    -0.03,
                    -0.36,
                    0.96,
                    0.96,
                    0.96,
                    -34.2,
                    1.26,
                    -26.85,
                    0.20,
                    -0.93,
                    0.26,
                    0.16,
                    1.01,
                    1.01,
                    1.01,
                    -33.29,
                    1.26,
                    -26.96,
                    0.22,
                    -0.88,
                    0.33,
                    0.25,
                    1.02,
                    1.02,
                    1.02,
                    -33.5,
                    1.26,
                    -26.92,
                    0.24,
                    0.26,
                    -0.47,
                    -0.81,
                    0.84,
                    0.84,
                    0.84,
                    -33.41,
                    1.26,
                    -27.04,
                    0.37,
                    0.73,
                    0.12,
                    -0.56,
                    1.05,
                    1.05,
                    1.05,
                    -34.13,
                    1.26,
                    -27.03,
                    0.30,
                    0.41,
                    -0.17,
                    -0.84,
                    0.92,
                    0.92,
                    0.92,
                    -33.39,
                    1.26,
                    -26.23,
                    0.29,
                    -0.79,
                    0.09,
                    0.54,
                    1.04,
                    1.04,
                    1.04,
                    -33.13,
                    1.26,
                    -26.47,
                    0.63,
                    0.57,
                    -0.03,
                    -0.53,
                    1.00,
                    1.00,
                    1.00,
                    -33.8,
                    1.26,
                    -26.62,
                    0.15,
                    -0.91,
                    0.11,
                    0.37,
                    1.17,
                    1.17,
                    1.17,
                    -33.94,
                    1.26,
                    -26.36,
                    0.17,
                    -0.95,
                    -0.14,
                    0.22,
                    1.02,
                    1.02,
                    1.02,
                    -33.09,
                    1.26,
                    -26.65,
                    0.47,
                    -0.4,
                    0.22,
                    0.76,
                    1.08,
                    1.08,
                    1.08,
                    -33.2,
                    1.26,
                    -27.17,
                    0.41,
                    0.79,
                    0.22,
                    -0.4,
                    1.09,
                    1.09,
                    1.09,
                    -33.72,
                    1.26,
                    -27.3,
                    0.15,
                    -0.41,
                    0.15,
                    0.89,
                    1.12,
                    1.12,
                    1.12,
                    -33.68,
                    1.26,
                    -26.49,
                    0.63,
                    -0.55,
                    -0.32,
                    0.45,
                    1.10,
                    1.10,
                    1.10,
                    -33.4,
                    1.26,
                    -26.86,
                    0.14,
                    0.43,
                    0.00,
                    -0.89,
                    0.84,
                    0.84,
                    0.84,
                    -34.21,
                    1.26,
                    -26.97,
                    0.55,
                    -0.66,
                    0.08,
                    0.51,
                    1.00,
                    1.00,
                    1.00,
                    -33.97,
                    1.26,
                    -26.25,
                    0.49,
                    -0.14,
                    -0.34,
                    0.79,
                    0.98,
                    0.98,
                    0.98,
                    -33.78,
                    1.26,
                    -26.56,
                    0.51,
                    0.10,
                    -0.51,
                    -0.69,
                    1.04,
                    1.04,
                    1.04,
                    -33.83,
                    1.26,
                    -26.54,
                    0.05,
                    0.37,
                    -0.64,
                    -0.67,
                    0.92,
                    0.92,
                    0.92,
                    -33.4,
                    1.26,
                    -26.4,
                    0.24,
                    -0.57,
                    -0.71,
                    0.35,
                    1.17,
                    1.17,
                    1.17,
                    -33.79,
                    1.26,
                    -26.91,
                    0.47,
                    0.30,
                    0.02,
                    -0.83,
                    0.93,
                    0.93,
                    0.93,
                    -33.75,
                    1.26,
                    -26.19,
                    0.45,
                    0.82,
                    -0.3,
                    -0.17,
                    0.87,
                    0.87,
                    0.87,
                    -33.91,
                    1.26,
                    -26.77,
                    0.11,
                    0.49,
                    -0.03,
                    -0.86,
                    0.96,
                    0.96,
                    0.96,
                    -34.13,
                    1.26,
                    -26.79,
                    0.18,
                    -0.35,
                    -0.35,
                    0.85,
                    0.92,
                    0.92,
                    0.92,
                    -33.39,
                    1.26,
                    -26.96,
                    0.21,
                    0.10,
                    -0.55,
                    -0.8,
                    1.09,
                    1.09,
                    1.09,
                    -33.66,
                    1.26,
                    -26.64,
                    0.16,
                    0.55,
                    0.30,
                    -0.76,
                    0.93,
                    0.93,
                    0.93,
                    -33.15,
                    1.26,
                    -26.88,
                    0.54,
                    -0.26,
                    -0.29,
                    0.75,
                    1.11,
                    1.11,
                    1.11,
                    -34.17,
                    1.26,
                    -26.63,
                    0.74,
                    -0.15,
                    -0.43,
                    -0.49,
                    0.88,
                    0.88,
                    0.88,
                    -34.19,
                    1.26,
                    -27.11,
                    0.32,
                    -0.66,
                    0.42,
                    0.53,
                    0.82,
                    0.82,
                    0.82,
                    -33.44,
                    1.26,
                    -26.52,
                    0.19,
                    0.78,
                    0.19,
                    -0.57,
                    0.84,
                    0.84,
                    0.84,
                    -33.26,
                    1.26,
                    -26.93,
                    0.69,
                    0.33,
                    -0.55,
                    -0.34,
                    0.90,
                    0.90,
                    0.90,
                    -33.75,
                    1.26,
                    -27.11,
                    0.75,
                    0.28,
                    -0.56,
                    -0.21,
                    1.01,
                    1.01,
                    1.01,
                    -33.61,
                    1.26,
                    -26.31,
                    0.89,
                    -0.13,
                    -0.17,
                    -0.41,
                    0.85,
                    0.85,
                    0.85,
                    -34.09,
                    1.26,
                    -27.22,
                    0.43,
                    0.66,
                    -0.57,
                    0.25,
                    1.00,
                    1.00,
                    1.00,
                    -33.78,
                    1.26,
                    -27.23,
                    0.66,
                    0.09,
                    -0.32,
                    -0.67,
                    0.87,
                    0.87,
                    0.87,
                    -33.54,
                    1.26,
                    -26.41,
                    0.48,
                    0.26,
                    -0.26,
                    -0.8,
                    0.91,
                    0.91,
                    0.91,
                    -33.96,
                    1.26,
                    -27.21,
                    0.14,
                    0.29,
                    -0.41,
                    -0.85,
                    1.11,
                    1.11,
                    1.11,
                    -33.67,
                    1.26,
                    -27.09,
                    0.02,
                    0.53,
                    -0.16,
                    -0.84,
                    1.15,
                    1.15,
                    1.15,
                    -33.86,
                    1.26,
                    -26.26,
                    0.71,
                    0.12,
                    -0.62,
                    -0.3,
                    0.83,
                    0.83,
                    0.83,
                    -33.53,
                    1.26,
                    -26.23,
                    0.42,
                    -0.19,
                    -0.09,
                    0.88,
                    0.96,
                    0.96,
                    0.96,
                    -33.6,
                    1.26,
                    -27,
                    0.29,
                    -0.64,
                    0.58,
                    0.41,
                    1.12,
                    1.12,
                    1.12,
                    -33.28,
                    1.26,
                    -26.67,
                    0.35,
                    -0.11,
                    -0.85,
                    0.36,
                    0.87,
                    0.87,
                    0.87,
                    -33.72,
                    1.26,
                    -27.02,
                    0.04,
                    0.88,
                    0.19,
                    -0.43,
                    0.88,
                    0.88,
                    0.88,
                    -33.45,
                    1.26,
                    -26.77,
                    0.75,
                    -0.17,
                    -0.42,
                    -0.47,
                    1.00,
                    1.00,
                    1.00,
                    -33.6,
                    1.26,
                    -26.13,
                    0.62,
                    -0.68,
                    -0.38,
                    -0.03,
                    0.83,
                    0.83,
                    0.83,
                    -33.44,
                    1.26,
                    -26.27,
                    0.19,
                    -0.32,
                    -0.47,
                    0.80,
                    0.86,
                    0.86,
                    0.86,
                    -33.23,
                    1.26,
                    -27.1,
                    0.34,
                    0.21,
                    -0.58,
                    -0.71,
                    1.18,
                    1.18,
                    1.18,
                    -34.12,
                    1.26,
                    -27.18,
                    0.20,
                    0.62,
                    0.16,
                    -0.74,
                    1.05,
                    1.05,
                    1.05,
                    -33.2,
                    1.26,
                    -27.2,
                    0.01,
                    0.45,
                    0.09,
                    -0.89,
                    0.99,
                    0.99,
                    0.99,
                    -33.4,
                    1.26,
                    -26.54,
                    0.52,
                    -0.62,
                    0.08,
                    0.58,
                    1.06,
                    1.06,
                    1.06,
                    -33.25,
                    1.26,
                    -26.78,
                    0.15,
                    -0.23,
                    -0.19,
                    0.94,
                    1.18,
                    1.18,
                    1.18,
                    -33.85,
                    1.26,
                    -26.62,
                    0.63,
                    -0.09,
                    -0.62,
                    -0.45,
                    1.15,
                    1.15,
                    1.15,
                    -33.83,
                    1.26,
                    -26.55,
                    0.09,
                    0.48,
                    -0.78,
                    -0.39,
                    1.12,
                    1.12,
                    1.12,
                    -33.77,
                    1.26,
                    -27.15,
                    0.37,
                    0.89,
                    -0.1,
                    -0.26,
                    1.20,
                    1.20,
                    1.20,
                    -33.94,
                    1.26,
                    -26.59,
                    0.36,
                    0.48,
                    0.19,
                    -0.77,
                    1.10,
                    1.10,
                    1.10,
                    -33.25,
                    1.26,
                    -26.31,
                    0.10,
                    0.80,
                    -0.41,
                    -0.43,
                    1.06,
                    1.06,
                    1.06,
                    -33.89,
                    1.26,
                    -26.21,
                    0.26,
                    0.55,
                    0.30,
                    -0.73,
                    1.05,
                    1.05,
                    1.05,
                    -33.83,
                    1.26,
                    -27.37,
                    0.55,
                    -0.06,
                    -0.6,
                    0.57,
                    1.21,
                    1.21,
                    1.21,
                    -33.32,
                    1.26,
                    -27.14,
                    0.04,
                    0.38,
                    -0.26,
                    -0.89,
                    0.88,
                    0.88,
                    0.88,
                    -33.47,
                    1.26,
                    -26.55,
                    0.70,
                    0.60,
                    -0.38,
                    0.09,
                    1.00,
                    1.00,
                    1.00,
                    -33.25,
                    1.26,
                    -26.37,
                    0.07,
                    -0.69,
                    0.27,
                    0.67,
                    0.82,
                    0.82,
                    0.82,
                    -33.5,
                    1.26,
                    -26.28,
                    0.39,
                    0.73,
                    -0.3,
                    -0.48,
                    0.86,
                    0.86,
                    0.86,
                    -33.84,
                    1.26,
                    -27.17,
                    0.54,
                    0.16,
                    -0.81,
                    0.19,
                    1.19,
                    1.19,
                    1.19,
                    -33.81,
                    1.26,
                    -26.38,
                    0.13,
                    -0.18,
                    0.05,
                    0.97,
                    0.85,
                    0.85,
                    0.85,
                    -33.05,
                    1.26,
                    -26.9,
                    0.42,
                    -0.65,
                    0.44,
                    0.46,
                    0.88,
                    0.88,
                    0.88,
                    -33.48,
                    1.26,
                    -27.15,
                    0.33,
                    0.78,
                    -0.38,
                    -0.36,
                    1.02,
                    1.02,
                    1.02,
                    -34.05,
                    1.26,
                    -26.53,
                    0.65,
                    0.32,
                    -0.27,
                    -0.63,
                    0.87,
                    0.87,
                    0.87,
                    -33.14,
                    1.26,
                    -26.54,
                    0.57,
                    0.51,
                    -0.62,
                    0.18,
                    0.98,
                    0.98,
                    0.98,
                    -33.3,
                    1.26,
                    -26.21,
                    0.27,
                    0.94,
                    -0.09,
                    -0.2,
                    0.87,
                    0.87,
                    0.87,
                    -33.75,
                    1.26,
                    -26.17,
                    0.39,
                    -0.82,
                    0.18,
                    0.39,
                    0.99,
                    0.99,
                    0.99,
                    -33.97,
                    1.26,
                    -27.15,
                    0.11,
                    0.93,
                    -0.12,
                    -0.32,
                    1.20,
                    1.20,
                    1.20,
                    -33.23,
                    1.26,
                    -26.66,
                    0.19,
                    0.56,
                    0.10,
                    -0.8,
                    1.17,
                    1.17,
                    1.17,
                    -34.17,
                    1.26,
                    -26.96,
                    0.30,
                    -0.29,
                    -0.42,
                    0.81,
                    1.02,
                    1.02,
                    1.02,
                    -33.3,
                    1.26,
                    -26.19,
                    0.82,
                    -0.27,
                    -0.42,
                    -0.27,
                    0.84,
                    0.84,
                    0.84,
                    -33.47,
                    1.26,
                    -26.27,
                    0.06,
                    -0.37,
                    -0.54,
                    0.75,
                    0.92,
                    0.92,
                    0.92,
                    -33.99,
                    1.26,
                    -26.53,
                    0.60,
                    0.06,
                    -0.6,
                    -0.53,
                    0.86,
                    0.86,
                    0.86,
                    -34.07,
                    1.26,
                    -26.82,
                    0.80,
                    0.19,
                    -0.55,
                    0.14,
                    0.95,
                    0.95,
                    0.95,
                    -33.87,
                    1.26,
                    -26.99,
                    0.16,
                    0.78,
                    -0.52,
                    -0.29,
                    1.07,
                    1.07,
                    1.07,
                    -33.79,
                    1.26,
                    -27.36,
                    0.28,
                    0.72,
                    0.36,
                    -0.53,
                    1.05,
                    1.05,
                    1.05,
                    -33.42,
                    1.26,
                    -27.22,
                    0.49,
                    -0.81,
                    -0.12,
                    0.30,
                    1.06,
                    1.06,
                    1.06,
                    -33.24,
                    1.26,
                    -26.24,
                    0.47,
                    0.72,
                    -0.47,
                    -0.22,
                    1.17,
                    1.17,
                    1.17,
                    -33.03,
                    1.26,
                    -26.63,
                    0.91,
                    0.14,
                    -0.37,
                    -0.09,
                    0.94,
                    0.94,
                    0.94,
                    -34.04,
                    1.26,
                    -26.27,
                    0.26,
                    0.88,
                    -0.12,
                    -0.37,
                    0.98,
                    0.98,
                    0.98,
                    -34.03,
                    1.26,
                    -26.52,
                    0.76,
                    0.48,
                    -0.44,
                    -0.1,
                    1.15,
                    1.15,
                    1.15,
                    -33.89,
                    1.26,
                    -26.92,
                    0.29,
                    0.53,
                    -0.18,
                    -0.78,
                    1.04,
                    1.04,
                    1.04,
                    -34.11,
                    1.26,
                    -26.99,
                    0.18,
                    -0.52,
                    0.12,
                    0.82,
                    1.21,
                    1.21,
                    1.21,
                    -33.34,
                    1.26,
                    -26.23,
                    0.20,
                    -0.67,
                    0.59,
                    0.40,
                    0.91,
                    0.91,
                    0.91,
                    -33.47,
                    1.26,
                    -27.36,
                    0.02,
                    0.34,
                    0.53,
                    -0.78,
                    0.91,
                    0.91,
                    0.91,
                    -34.19,
                    1.26,
                    -26.8,
                    0.26,
                    0.19,
                    -0.95,
                    -0.06,
                    1.08,
                    1.08,
                    1.08,
                    -33.41,
                    1.26,
                    -26.46,
                    0.17,
                    0.29,
                    -0.86,
                    -0.38,
                    0.90,
                    0.90,
                    0.90,
                    -33.41,
                    1.26,
                    -27.02,
                    0.24,
                    -0.58,
                    0.34,
                    0.69,
                    0.88,
                    0.88,
                    0.88,
                    -33.31,
                    1.26,
                    -27.28,
                    0.01,
                    0.32,
                    0.04,
                    -0.95,
                    1.19,
                    1.19,
                    1.19,
                    -33.64,
                    1.26,
                    -26.13,
                    0.36,
                    0.53,
                    -0.76,
                    0.11,
                    0.92,
                    0.92,
                    0.92,
                    -33.74,
                    1.26,
                    -27.06,
                    0.90,
                    0.01,
                    -0.27,
                    0.34,
                    0.90,
                    0.90,
                    0.90,
                    -33.28,
                    1.26,
                    -26.66,
                    0.19,
                    0.92,
                    0.05,
                    -0.35,
                    1.06,
                    1.06,
                    1.06,
                    -33.29,
                    1.26,
                    -27.09,
                    0.70,
                    0.09,
                    -0.58,
                    0.40,
                    1.18,
                    1.18,
                    1.18,
                    -33.11,
                    1.26,
                    -26.95,
                    0.10,
                    -0.42,
                    -0.2,
                    0.88,
                    1.10,
                    1.10,
                    1.10,
                    -33.89,
                    1.26,
                    -27.3,
                    0.34,
                    -0.78,
                    0.15,
                    0.50,
                    0.89,
                    0.89,
                    0.89,
                    -33.43,
                    1.26,
                    -26.23,
                    0.41,
                    0.13,
                    -0.57,
                    -0.7,
                    0.94,
                    0.94,
                    0.94,
                    -33.94,
                    1.26,
                    -27.01,
                    0.59,
                    0.66,
                    -0.36,
                    -0.3,
                    1.12,
                    1.12,
                    1.12,
                    -33.51,
                    1.26,
                    -26.89,
                    0.49,
                    -0.68,
                    -0.22,
                    0.51,
                    1.12,
                    1.12,
                    1.12,
                    -33.3,
                    1.26,
                    -27.15,
                    0.34,
                    -0.36,
                    -0.32,
                    0.81,
                    1.03,
                    1.03,
                    1.03,
                    -33.73,
                    1.26,
                    -27.29,
                    0.05,
                    0.12,
                    -0.32,
                    -0.94,
                    1.07,
                    1.07,
                    1.07,
                    -33.26,
                    1.26,
                    -27.11,
                    0.57,
                    0.34,
                    -0.58,
                    0.46,
                    1.07,
                    1.07,
                    1.07,
                    -33.99,
                    1.26,
                    -26.59,
                    0.33,
                    -0.87,
                    -0.09,
                    0.35,
                    0.93,
                    0.93,
                    0.93,
                    -34,
                    1.26,
                    -26.75,
                    0.27,
                    0.57,
                    0.27,
                    -0.73,
                    1.07,
                    1.07,
                    1.07,
                    -33.48,
                    1.26,
                    -26.64,
                    0.74,
                    -0.35,
                    -0.57,
                    -0.06,
                    0.90,
                    0.90,
                    0.90,
                    -33.84,
                    1.26,
                    -26.42,
                    0.00,
                    -0.39,
                    -0.09,
                    0.91,
                    1.11,
                    1.11,
                    1.11,
                    -33.04,
                    1.26,
                    -27,
                    0.73,
                    0.50,
                    0.06,
                    -0.46,
                    1.08,
                    1.08,
                    1.08,
                    -33.7,
                    1.26,
                    -26.64,
                    0.43,
                    -0.52,
                    -0.74,
                    -0.02,
                    0.85,
                    0.85,
                    0.85,
                    -33.94,
                    1.26,
                    -26.47,
                    0.83,
                    -0.11,
                    -0.42,
                    -0.33,
                    0.88,
                    0.88,
                    0.88,
                    -33.57,
                    1.26,
                    -26.43,
                    0.54,
                    0.43,
                    -0.68,
                    0.24,
                    1.19,
                    1.19,
                    1.19,
                    -33.62,
                    1.26,
                    -26.33,
                    0.42,
                    -0.33,
                    -0.1,
                    0.84,
                    1.20,
                    1.20,
                    1.20,
                    -33.44,
                    1.26,
                    -27.14,
                    0.47,
                    0.12,
                    -0.74,
                    -0.47,
                    1.01,
                    1.01,
                    1.01,
                    -34.01,
                    1.26,
                    -26.75,
                    0.22,
                    0.44,
                    0.19,
                    -0.85,
                    1.20,
                    1.20,
                    1.20,
                    -33.46,
                    1.26,
                    -26.25,
                    0.29,
                    0.22,
                    -0.74,
                    -0.57,
                    0.95,
                    0.95,
                    0.95,
                    -33.65,
                    1.26,
                    -26.54,
                    0.14,
                    0.80,
                    -0.1,
                    -0.57,
                    0.90,
                    0.90,
                    0.90,
                    -33.98,
                    1.26,
                    -26.56,
                    0.13,
                    0.76,
                    -0.52,
                    -0.37,
                    0.97,
                    0.97,
                    0.97,
                    -33.32,
                    1.26,
                    -26.63,
                    0.42,
                    -0.65,
                    0.48,
                    0.42,
                    1.05,
                    1.05,
                    1.05,
                    -34.28,
                    1.26,
                    -26.68,
                    0.32,
                    0.84,
                    -0.31,
                    -0.3,
                    0.93,
                    0.93,
                    0.93,
                    -33.54,
                    1.26,
                    -26.69,
                    0.53,
                    -0.54,
                    -0,
                    0.66,
                    0.87,
                    0.87,
                    0.87,
                    -33.28,
                    1.26,
                    -26.51,
                    0.23,
                    0.10,
                    -0.86,
                    0.45,
                    0.97,
                    0.97,
                    0.97,
                    -33.94,
                    1.26,
                    -27.04,
                    0.19,
                    0.21,
                    -0.83,
                    -0.48,
                    1.17,
                    1.17,
                    1.17,
                    -34.12,
                    1.26,
                    -26.89,
                    0.09,
                    0.88,
                    0.31,
                    -0.36,
                    0.95,
                    0.95,
                    0.95,
                    -33.83,
                    1.26,
                    -27.19,
                    0.28,
                    0.57,
                    0.08,
                    -0.77,
                    0.96,
                    0.96,
                    0.96,
                    -33.58,
                    1.26,
                    -26.4,
                    0.46,
                    0.76,
                    -0.45,
                    -0.11,
                    0.88,
                    0.88,
                    0.88,
                    -33.46,
                    1.26,
                    -27.13,
                    0.65,
                    -0.65,
                    0.00,
                    0.41,
                    1.09,
                    1.09,
                    1.09,
                    -33.86,
                    1.26,
                    -26.5,
                    0.47,
                    -0.29,
                    -0.48,
                    0.68,
                    1.22,
                    1.22,
                    1.22,
                    -34.1,
                    1.26,
                    -26.82,
                    0.10,
                    0.32,
                    -0.31,
                    -0.89,
                    1.13,
                    1.13,
                    1.13,
                    -33.24,
                    1.26,
                    -26.54,
                    0.66,
                    0.67,
                    0.03,
                    -0.35,
                    1.17,
                    1.17,
                    1.17,
                    -33.79,
                    1.26,
                    -26.32,
                    0.74,
                    -0.29,
                    -0.46,
                    0.39,
                    0.95,
                    0.95,
                    0.95,
                    -33.93,
                    1.26,
                    -27.13,
                    0.23,
                    -0.34,
                    -0.01,
                    0.91,
                    1.19,
                    1.19,
                    1.19,
                    -33.91,
                    1.26,
                    -27.14,
                    0.58,
                    -0.17,
                    -0.4,
                    -0.69,
                    1.01,
                    1.01,
                    1.01,
                    -33.47,
                    1.26,
                    -26.33,
                    0.05,
                    -0.59,
                    0.57,
                    0.57,
                    1.07,
                    1.07,
                    1.07,
                    -33.13,
                    1.26,
                    -26.78,
                    0.24,
                    0.85,
                    0.08,
                    -0.47,
                    0.85,
                    0.85,
                    0.85,
                    -33.12,
                    1.26,
                    -27.08,
                    0.82,
                    0.25,
                    -0.52,
                    -0.02,
                    1.02,
                    1.02,
                    1.02,
                    -33.03,
                    1.26,
                    -26.57,
                    0.42,
                    0.53,
                    -0.16,
                    -0.72,
                    0.89,
                    0.89,
                    0.89,
                    -33.78,
                    1.26,
                    -26.73,
                    0.23,
                    0.30,
                    -0.53,
                    -0.76,
                    0.92,
                    0.92,
                    0.92,
                    -33.91,
                    1.26,
                    -26.33,
                    0.75,
                    0.45,
                    -0.44,
                    -0.2,
                    0.85,
                    0.85,
                    0.85,
                    -33.53,
                    1.26,
                    -26.36,
                    0.32,
                    0.60,
                    -0.38,
                    -0.64,
                    1.19,
                    1.19,
                    1.19,
                    -34.24,
                    1.26,
                    -26.54,
                    0.48,
                    0.31,
                    -0.13,
                    -0.81,
                    1.16,
                    1.16,
                    1.16,
                    -33.65,
                    1.26,
                    -26.63,
                    0.19,
                    -0.05,
                    -0.57,
                    -0.8,
                    0.98,
                    0.98,
                    0.98,
                    -33.19,
                    1.26,
                    -26.87,
                    0.44,
                    0.87,
                    -0.11,
                    -0.19,
                    0.89,
                    0.89,
                    0.89,
                    -33.97,
                    1.26,
                    -26.29,
                    0.05,
                    0.46,
                    -0.82,
                    -0.35,
                    0.87,
                    0.87,
                    0.87,
                    -33.49,
                    1.26,
                    -27.25,
                    0.81,
                    0.57,
                    -0.07,
                    -0.13,
                    1.06,
                    1.06,
                    1.06,
                    -33.17,
                    1.26,
                    -26.6,
                    0.04,
                    -0.29,
                    0.40,
                    0.87,
                    0.92,
                    0.92,
                    0.92,
                    -34.13,
                    1.26,
                    -26.31,
                    0.85,
                    0.38,
                    -0.2,
                    -0.32,
                    0.86,
                    0.86,
                    0.86,
                    -33.54,
                    1.26,
                    -27.16,
                    0.59,
                    0.68,
                    -0.22,
                    -0.38,
                    0.97,
                    0.97,
                    0.97,
                    -33.92,
                    1.26,
                    -27.23,
                    0.20,
                    -0.49,
                    0.11,
                    0.84,
                    0.96,
                    0.96,
                    0.96,
                    -33.45,
                    1.26,
                    -27.2,
                    0.50,
                    0.34,
                    0.06,
                    -0.79,
                    0.82,
                    0.82,
                    0.82,
                    -33.54,
                    1.26,
                    -26.5,
                    0.24,
                    0.83,
                    0.33,
                    -0.4,
                    0.92,
                    0.92,
                    0.92,
                    -33.42,
                    1.26,
                    -26.75,
                    0.71,
                    0.14,
                    -0.69,
                    0.05,
                    1.18,
                    1.18,
                    1.18,
                    -33.26,
                    1.26,
                    -26.66,
                    0.27,
                    0.61,
                    -0.64,
                    -0.38,
                    1.11,
                    1.11,
                    1.11,
                    -34.09,
                    1.26,
                    -26.6,
                    0.42,
                    0.90,
                    -0.05,
                    -0.15,
                    0.99,
                    0.99,
                    0.99,
                    -34.27,
                    1.26,
                    -26.96,
                    0.66,
                    0.03,
                    -0.57,
                    0.49,
                    1.10,
                    1.10,
                    1.10,
                    -33.33,
                    1.26,
                    -26.35,
                    0.03,
                    0.33,
                    0.07,
                    -0.94,
                    1.06,
                    1.06,
                    1.06,
                    -33.63,
                    1.26,
                    -27.32,
                    0.20,
                    0.09,
                    -0.78,
                    -0.58,
                    1.03,
                    1.03,
                    1.03,
                    -33.81,
                    1.26,
                    -26.79,
                    0.39,
                    0.56,
                    0.16,
                    -0.72,
                    1.02,
                    1.02,
                    1.02,
                    -33.67,
                    1.26,
                    -26.3,
                    0.05,
                    -0.51,
                    0.31,
                    0.80,
                    1.07,
                    1.07,
                    1.07,
                    -33.68,
                    1.26,
                    -26.21,
                    0.91,
                    0.18,
                    -0.31,
                    -0.18,
                    1.04,
                    1.04,
                    1.04,
                    -33.79,
                    1.26,
                    -26.74,
                    0.67,
                    0.57,
                    -0.19,
                    -0.44,
                    1.08,
                    1.08,
                    1.08,
                    -33.24,
                    1.26,
                    -26.85,
                    0.72,
                    -0.11,
                    -0.5,
                    -0.47,
                    0.91,
                    0.91,
                    0.91,
                    -33.68,
                    1.26,
                    -26.46,
                    0.53,
                    0.52,
                    -0.66,
                    0.13,
                    1.11,
                    1.11,
                    1.11,
                    -34.01,
                    1.26,
                    -27.24,
                    0.16,
                    -0.33,
                    0.10,
                    0.93,
                    1.16,
                    1.16,
                    1.16,
                    -34.06,
                    1.26,
                    -26.64,
                    0.17,
                    -0.61,
                    0.31,
                    0.70,
                    0.91,
                    0.91,
                    0.91,
                    -33.96,
                    1.26,
                    -26.92,
                    0.40,
                    0.67,
                    -0.33,
                    -0.53,
                    1.07,
                    1.07,
                    1.07,
                    -33.2,
                    1.26,
                    -26.67,
                    0.89,
                    0.06,
                    -0.4,
                    -0.2,
                    1.14,
                    1.14,
                    1.14,
                    -33.15,
                    1.26,
                    -26.76,
                    0.93,
                    0.31,
                    -0.17,
                    0.11,
                    0.97,
                    0.97,
                    0.97,
                    -33.99,
                    1.26,
                    -26.8,
                    0.18,
                    0.57,
                    0.22,
                    -0.77,
                    1.00,
                    1.00,
                    1.00,
                    -33.61,
                    1.26,
                    -26.87,
                    0.01,
                    0.65,
                    -0.37,
                    -0.66,
                    1.13,
                    1.13,
                    1.13,
                    -33.8,
                    1.26,
                    -26.76,
                    0.13,
                    0.43,
                    -0.22,
                    -0.86,
                    1.10,
                    1.10,
                    1.10,
                    -33.68,
                    1.26,
                    -27,
                    0.31,
                    0.89,
                    -0.24,
                    -0.22,
                    1.03,
                    1.03,
                    1.03,
                    -33.1,
                    1.26,
                    -26.66,
                    0.64,
                    -0.48,
                    0.20,
                    0.57,
                    1.18,
                    1.18,
                    1.18,
                    -33.66,
                    1.26,
                    -26.88,
                    0.62,
                    0.43,
                    -0.27,
                    -0.6,
                    0.97,
                    0.97,
                    0.97,
                    -33.49,
                    1.26,
                    -26.19,
                    0.19,
                    -0.92,
                    0.06,
                    0.34,
                    1.12,
                    1.12,
                    1.12,
                    -33.59,
                    1.26,
                    -26.25,
                    0.19,
                    0.04,
                    -0.6,
                    0.78,
                    1.09,
                    1.09,
                    1.09,
                    -33.65,
                    1.26,
                    -26.46,
                    0.43,
                    -0.45,
                    0.21,
                    0.76,
                    0.94,
                    0.94,
                    0.94,
                    -33.78,
                    1.26,
                    -26.73,
                    0.31,
                    0.83,
                    0.23,
                    -0.39,
                    1.08,
                    1.08,
                    1.08,
                    -34.17,
                    1.26,
                    -26.96,
                    0.64,
                    -0.41,
                    -0.03,
                    0.65,
                    1.11,
                    1.11,
                    1.11,
                    -33.69,
                    1.26,
                    -27.12,
                    0.25,
                    0.40,
                    -0.26,
                    -0.84,
                    1.11,
                    1.11,
                    1.11,
                    -33.8,
                    1.26,
                    -27.35,
                    0.17,
                    0.52,
                    -0.53,
                    -0.65,
                    1.12,
                    1.12,
                    1.12,
                    -34.07,
                    1.26,
                    -26.36,
                    0.12,
                    0.85,
                    -0.01,
                    -0.51,
                    0.99,
                    0.99,
                    0.99,
                    -34.04,
                    1.26,
                    -26.38,
                    0.23,
                    0.67,
                    0.08,
                    -0.7,
                    1.01,
                    1.01,
                    1.01,
                    -33.19,
                    1.26,
                    -26.73,
                    0.23,
                    -0.87,
                    -0.36,
                    0.22,
                    1.11,
                    1.11,
                    1.11,
                    -33.3,
                    1.26,
                    -27.23,
                    0.30,
                    0.36,
                    -0.85,
                    0.24,
                    1.17,
                    1.17,
                    1.17,
                    -33.46,
                    1.26,
                    -26.18,
                    0.83,
                    0.12,
                    -0.03,
                    -0.54,
                    0.95,
                    0.95,
                    0.95,
                    -34.07,
                    1.26,
                    -26.91,
                    0.53,
                    0.79,
                    -0.16,
                    -0.27,
                    1.11,
                    1.11,
                    1.11,
                    -33.27,
                    1.26,
                    -26.31,
                    0.31,
                    0.77,
                    -0.26,
                    -0.49,
                    1.01,
                    1.01,
                    1.01,
                    -33.66,
                    1.26,
                    -27.06,
                    0.23,
                    0.54,
                    -0.65,
                    -0.48,
                    0.95,
                    0.95,
                    0.95,
                    -33.29,
                    1.26,
                    -26.35,
                    0.50,
                    0.68,
                    0.25,
                    -0.47,
                    0.90,
                    0.90,
                    0.90,
                    -33.06,
                    1.26,
                    -26.87,
                    0.65,
                    0.03,
                    -0.63,
                    -0.41,
                    1.01,
                    1.01,
                    1.01,
                    -33.16,
                    1.26,
                    -26.33,
                    0.54,
                    0.36,
                    -0.76,
                    0.05,
                    0.95,
                    0.95,
                    0.95,
                    -33.27,
                    1.26,
                    -27.13,
                    0.70,
                    -0.22,
                    -0.06,
                    0.67,
                    1.16,
                    1.16,
                    1.16,
                    -33.06,
                    1.26,
                    -26.69,
                    0.16,
                    -0.01,
                    -0.9,
                    -0.4,
                    0.91,
                    0.91,
                    0.91,
                    -33.93,
                    1.26,
                    -26.56,
                    0.73,
                    0.53,
                    0.05,
                    -0.43,
                    0.85,
                    0.85,
                    0.85,
                    -33.63,
                    1.26,
                    -26.38,
                    0.06,
                    0.41,
                    -0.56,
                    -0.72,
                    0.82,
                    0.82,
                    0.82,
                    -33.67,
                    1.26,
                    -27.26,
                    0.82,
                    0.23,
                    -0.51,
                    -0.15,
                    0.90,
                    0.90,
                    0.90,
                    -33.1,
                    1.26,
                    -27.07,
                    0.38,
                    -0.37,
                    -0.47,
                    0.70,
                    0.90,
                    0.90,
                    0.90,
                    -34.23,
                    1.26,
                    -26.55,
                    0.00,
                    -0.89,
                    0.37,
                    0.26,
                    1.08,
                    1.08,
                    1.08,
                    -33.9,
                    1.26,
                    -26.44,
                    0.22,
                    0.08,
                    -0.67,
                    -0.7,
                    1.08,
                    1.08,
                    1.08,
                    -34.1,
                    1.26,
                    -26.68,
                    0.58,
                    0.52,
                    -0.28,
                    -0.56,
                    1.02,
                    1.02,
                    1.02,
                    -34.06,
                    1.26,
                    -27.13,
                    0.69,
                    0.39,
                    -0.44,
                    -0.42,
                    0.91,
                    0.91,
                    0.91,
                    -33.8,
                    1.26,
                    -27.07,
                    0.03,
                    0.71,
                    -0.65,
                    -0.29,
                    0.90,
                    0.90,
                    0.90,
                    -33.08,
                    1.26,
                    -26.58,
                    0.06,
                    0.18,
                    -0.78,
                    -0.59,
                    1.21,
                    1.21,
                    1.21,
                    -33.29,
                    1.26,
                    -26.93,
                    0.67,
                    0.29,
                    -0.62,
                    -0.27,
                    1.03,
                    1.03,
                    1.03,
                    -33.56,
                    1.26,
                    -26.24,
                    0.28,
                    0.59,
                    -0.21,
                    -0.73,
                    1.10,
                    1.10,
                    1.10,
                    -33.69,
                    1.26,
                    -26.63,
                    0.07,
                    0.16,
                    -0.86,
                    -0.49,
                    0.92,
                    0.92,
                    0.92,
                    -33.28,
                    1.26,
                    -26.96,
                    0.07,
                    0.95,
                    -0.3,
                    -0.04,
                    1.07,
                    1.07,
                    1.07,
                    -33.48,
                    1.26,
                    -26.21,
                    0.26,
                    -0.84,
                    0.39,
                    0.26,
                    1.07,
                    1.07,
                    1.07,
                    -33.47,
                    1.26,
                    -26.52,
                    0.74,
                    -0.38,
                    -0.45,
                    -0.33,
                    1.09,
                    1.09,
                    1.09,
                    -33.91,
                    1.26,
                    -26.57,
                    0.08,
                    -0.28,
                    -0.16,
                    0.94,
                    1.14,
                    1.14,
                    1.14,
                    -34.25,
                    1.26,
                    -27.03,
                    0.07,
                    0.25,
                    0.38,
                    -0.89,
                    0.84,
                    0.84,
                    0.84,
                    -33.97,
                    1.26,
                    -27.18,
                    0.38,
                    0.01,
                    -0.68,
                    -0.63,
                    1.21,
                    1.21,
                    1.21,
                    -33.61,
                    1.26,
                    -26.49,
                    0.17,
                    -0.66,
                    -0.3,
                    0.66,
                    0.95,
                    0.95,
                    0.95,
                    -33.21,
                    1.26,
                    -27.05,
                    0.94,
                    -0.05,
                    -0.35,
                    -0.01,
                    1.10,
                    1.10,
                    1.10,
                    -33.59,
                    1.26,
                    -26.54,
                    0.15,
                    0.12,
                    0.25,
                    -0.95,
                    0.85,
                    0.85,
                    0.85,
                    -33.22,
                    1.26,
                    -26.74,
                    0.27,
                    -0.92,
                    0.21,
                    0.18,
                    0.95,
                    0.95,
                    0.95,
                    -33.79,
                    1.26,
                    -26.4,
                    0.84,
                    -0.3,
                    -0.43,
                    -0.15,
                    1.04,
                    1.04,
                    1.04,
                    -34.05,
                    1.26,
                    -26.61,
                    0.13,
                    -0.32,
                    -0.31,
                    0.88,
                    0.95,
                    0.95,
                    0.95,
                    -33.15,
                    1.26,
                    -26.65,
                    0.80,
                    0.51,
                    -0.18,
                    -0.26,
                    1.15,
                    1.15,
                    1.15,
                    -33.36,
                    1.26,
                    -27.27,
                    0.28,
                    0.25,
                    -0.87,
                    -0.33,
                    1.03,
                    1.03,
                    1.03,
                    -33.46,
                    1.26,
                    -26.24,
                    0.17,
                    0.43,
                    -0.57,
                    -0.68,
                    1.02,
                    1.02,
                    1.02,
                    -33.67,
                    1.26,
                    -26.42,
                    0.69,
                    0.39,
                    -0.44,
                    -0.41,
                    1.05,
                    1.05,
                    1.05,
                    -33.05,
                    1.26,
                    -26.91,
                    0.11,
                    -0.59,
                    -0.32,
                    0.73,
                    1.00,
                    1.00,
                    1.00,
                    -33.38,
                    1.26,
                    -27.23,
                    0.26,
                    0.44,
                    -0.85,
                    -0.13,
                    1.10,
                    1.10,
                    1.10,
                    -33.93,
                    1.26,
                    -27.24,
                    0.18,
                    0.10,
                    -0.89,
                    -0.41,
                    0.94,
                    0.94,
                    0.94,
                    -34.18,
                    1.26,
                    -27.14,
                    0.27,
                    -0.47,
                    0.33,
                    0.77,
                    0.93,
                    0.93,
                    0.93,
                    -33.19,
                    1.26,
                    -27.02,
                    0.16,
                    -0.24,
                    -0.17,
                    0.94,
                    1.14,
                    1.14,
                    1.14,
                    -33.62,
                    1.26,
                    -27.01,
                    0.30,
                    0.73,
                    -0.61,
                    0.02,
                    0.84,
                    0.84,
                    0.84,
                    -33.4,
                    1.26,
                    -26.91,
                    0.79,
                    0.34,
                    -0.15,
                    -0.49,
                    0.93,
                    0.93,
                    0.93,
                    -33.77,
                    1.26,
                    -26.95,
                    0.36,
                    -0.34,
                    -0.68,
                    0.54,
                    1.06,
                    1.06,
                    1.06,
                    -33.85,
                    1.26,
                    -26.57,
                    0.50,
                    0.28,
                    -0.33,
                    -0.75,
                    1.02,
                    1.02,
                    1.02,
                    -34.19,
                    1.26,
                    -27.08,
                    0.10,
                    0.50,
                    0.52,
                    -0.68,
                    0.91,
                    0.91,
                    0.91,
                    -33.38,
                    1.26,
                    -27.24,
                    0.63,
                    -0.07,
                    -0.39,
                    0.67,
                    1.20,
                    1.20,
                    1.20,
                    -33.83,
                    1.26,
                    -27.24,
                    0.25,
                    -0.44,
                    0.19,
                    0.84,
                    0.92,
                    0.92,
                    0.92,
                    -33.9,
                    1.26,
                    -27.15,
                    0.74,
                    -0.31,
                    -0.08,
                    0.59,
                    0.84,
                    0.84,
                    0.84,
                    -34.21,
                    1.26,
                    -26.79,
                    0.21,
                    0.41,
                    -0.21,
                    -0.87,
                    1.17,
                    1.17,
                    1.17,
                    -34.16,
                    1.26,
                    -26.52,
                    0.07,
                    -0.61,
                    0.38,
                    0.70,
                    0.83,
                    0.83,
                    0.83,
                    -34.12,
                    1.26,
                    -26.93,
                    0.42,
                    0.67,
                    -0.35,
                    -0.5,
                    1.18,
                    1.18,
                    1.18,
                    -33.49,
                    1.26,
                    -27.18,
                    0.13,
                    -0.82,
                    -0.41,
                    0.39,
                    1.09,
                    1.09,
                    1.09,
                    -34.01,
                    1.26,
                    -26.27,
                    0.27,
                    -0.96,
                    -0.08,
                    0.05,
                    0.96,
                    0.96,
                    0.96,
                    -33.15,
                    1.26,
                    -26.64,
                    0.08,
                    0.57,
                    0.77,
                    -0.26,
                    1.05,
                    1.05,
                    1.05,
                    -33.85,
                    1.26,
                    -26.21,
                    0.52,
                    0.78,
                    -0.13,
                    -0.33,
                    0.91,
                    0.91,
                    0.91,
                    -33.27,
                    1.26,
                    -26.85,
                    0.45,
                    0.27,
                    -0.48,
                    -0.71,
                    1.09,
                    1.09,
                    1.09,
                    -33.98,
                    1.26,
                    -26.95,
                    0.34,
                    -0.82,
                    -0.1,
                    0.46,
                    1.11,
                    1.11,
                    1.11,
                    -34.18,
                    1.26,
                    -26.66,
                    0.80,
                    0.43,
                    -0.42,
                    -0.09,
                    0.84,
                    0.84,
                    0.84,
                    -33.21,
                    1.26,
                    -26.58,
                    0.25,
                    -0.22,
                    -0.94,
                    0.01,
                    0.84,
                    0.84,
                    0.84,
                    -33.89,
                    1.26,
                    -26.26,
                    0.77,
                    -0.26,
                    -0.42,
                    -0.39,
                    1.15,
                    1.15,
                    1.15,
                    -33.66,
                    1.26,
                    -26.16,
                    0.40,
                    0.75,
                    0.23,
                    -0.47,
                    1.01,
                    1.01,
                    1.01,
                    -33.92,
                    1.26,
                    -26.77,
                    0.23,
                    0.36,
                    -0.71,
                    -0.56,
                    0.84,
                    0.84,
                    0.84,
                    -33.84,
                    1.26,
                    -26.53,
                    0.63,
                    0.59,
                    -0.13,
                    -0.49,
                    1.01,
                    1.01,
                    1.01,
                    -33.44,
                    1.26,
                    -26.83,
                    0.29,
                    0.31,
                    -0.57,
                    -0.7,
                    0.86,
                    0.86,
                    0.86,
                    -33.84,
                    1.26,
                    -27.13,
                    0.08,
                    0.59,
                    0.18,
                    -0.78,
                    0.87,
                    0.87,
                    0.87,
                    -32.98,
                    1.26,
                    -26.78,
                    0.13,
                    -0.91,
                    -0.21,
                    0.32,
                    0.93,
                    0.93,
                    0.93,
                    -33.45,
                    1.26,
                    -26.44,
                    0.39,
                    0.79,
                    0.26,
                    -0.38,
                    0.90,
                    0.90,
                    0.90,
                    -33.08,
                    1.26,
                    -26.71,
                    0.38,
                    0.30,
                    -0.23,
                    -0.84,
                    1.05,
                    1.05,
                    1.05,
                    -33.4,
                    1.26,
                    -26.8,
                    0.24,
                    -0.85,
                    0.05,
                    0.47,
                    1.02,
                    1.02,
                    1.02,
                    -33.69,
                    1.26,
                    -26.88,
                    0.77,
                    0.50,
                    -0.39,
                    -0,
                    1.13,
                    1.13,
                    1.13,
                    -34.2,
                    1.26,
                    -26.46,
                    0.19,
                    0.66,
                    -0.7,
                    -0.18,
                    0.83,
                    0.83,
                    0.83,
                    -33.22,
                    1.26,
                    -26.51,
                    0.05,
                    0.42,
                    -0.65,
                    -0.64,
                    0.87,
                    0.87,
                    0.87,
                    -33.78,
                    1.26,
                    -27.15,
                    0.05,
                    0.68,
                    -0.1,
                    -0.73,
                    0.87,
                    0.87,
                    0.87,
                    -33.5,
                    1.26,
                    -27.28,
                    0.38,
                    0.14,
                    -0.91,
                    -0.02,
                    0.95,
                    0.95,
                    0.95,
                    -33.7,
                    1.26,
                    -26.39,
                    0.24,
                    -0.55,
                    0.73,
                    0.33,
                    1.13,
                    1.13,
                    1.13,
                    -34.08,
                    1.26,
                    -26.48,
                    0.43,
                    0.86,
                    -0.21,
                    -0.19,
                    0.94,
                    0.94,
                    0.94,
                    -33.24,
                    1.26,
                    -26.64,
                    0.13,
                    0.84,
                    0.02,
                    -0.52,
                    1.19,
                    1.19,
                    1.19,
                    -33.66,
                    1.26,
                    -26.91,
                    0.56,
                    0.77,
                    -0.31,
                    -0.09,
                    1.17,
                    1.17,
                    1.17,
                    -34.12,
                    1.26,
                    -27.17,
                    0.33,
                    0.31,
                    -0.31,
                    -0.84,
                    0.88,
                    0.88,
                    0.88,
                    -33.91,
                    1.26,
                    -26.57,
                    0.24,
                    0.51,
                    0.30,
                    -0.77,
                    1.15,
                    1.15,
                    1.15,
                    -33.87,
                    1.26,
                    -26.22,
                    0.24,
                    0.62,
                    -0.7,
                    -0.27,
                    1.10,
                    1.10,
                    1.10,
                    -34.12,
                    1.26,
                    -26.84,
                    0.06,
                    0.34,
                    0.13,
                    -0.93,
                    1.00,
                    1.00,
                    1.00,
                    -33.74,
                    1.26,
                    -26.99,
                    0.29,
                    -0.01,
                    -0.61,
                    0.73,
                    0.85,
                    0.85,
                    0.85,
                    -33.62,
                    1.26,
                    -27,
                    0.32,
                    -0.48,
                    0.24,
                    0.78,
                    0.93,
                    0.93,
                    0.93,
                    -33.15,
                    1.26,
                    -26.44,
                    0.50,
                    0.33,
                    -0.77,
                    0.23,
                    0.94,
                    0.94,
                    0.94,
                    -33.87,
                    1.26,
                    -26.31,
                    0.02,
                    0.48,
                    -0.62,
                    -0.62,
                    1.14,
                    1.14,
                    1.14,
                    -33.34,
                    1.26,
                    -26.9,
                    0.10,
                    -0.69,
                    -0.5,
                    0.52,
                    0.95,
                    0.95,
                    0.95,
                    -33.81,
                    1.26,
                    -27.05,
                    0.86,
                    0.16,
                    -0.47,
                    -0.1,
                    1.20,
                    1.20,
                    1.20,
                    -33.72,
                    1.26,
                    -26.15,
                    0.17,
                    -0.36,
                    -0.44,
                    0.81,
                    1.01,
                    1.01,
                    1.01,
                    -33.87,
                    1.26,
                    -26.23,
                    0.33,
                    -0.35,
                    -0.88,
                    -0.03,
                    1.00,
                    1.00,
                    1.00,
                    -33.95,
                    1.26,
                    -26.48,
                    0.09,
                    -0.93,
                    0.22,
                    0.29,
                    0.84,
                    0.84,
                    0.84,
                    -33.05,
                    1.26,
                    -26.79,
                    0.38,
                    -0.29,
                    -0.86,
                    -0.18,
                    1.20,
                    1.20,
                    1.20,
                    -33.18,
                    1.26,
                    -27.01,
                    0.33,
                    0.30,
                    -0.87,
                    -0.21,
                    1.04,
                    1.04,
                    1.04,
                    -33.41,
                    1.26,
                    -26.41,
                    0.66,
                    -0.17,
                    -0.67,
                    -0.3,
                    1.15,
                    1.15,
                    1.15,
                    -33.76,
                    1.26,
                    -26.6,
                    0.47,
                    0.71,
                    -0.48,
                    -0.21,
                    0.88,
                    0.88,
                    0.88,
                    -33.64,
                    1.26,
                    -26.4,
                    0.14,
                    -0.61,
                    0.35,
                    0.70,
                    1.03,
                    1.03,
                    1.03,
                    -33.84,
                    1.26,
                    -26.71,
                    0.40,
                    0.62,
                    -0.23,
                    -0.64,
                    0.96,
                    0.96,
                    0.96,
                    -33.76,
                    1.26,
                    -26.92,
                    0.67,
                    0.57,
                    -0.41,
                    -0.23,
                    0.91,
                    0.91,
                    0.91,
                    -33.81,
                    1.26,
                    -27.14,
                    0.04,
                    0.91,
                    -0.42,
                    -0.07,
                    1.21,
                    1.21,
                    1.21,
                    -34.26,
                    1.26,
                    -26.62,
                    0.07,
                    -0.14,
                    0.75,
                    0.65,
                    0.89,
                    0.89,
                    0.89,
                    -34.06,
                    1.26,
                    -26.29,
                    0.54,
                    -0.3,
                    -0.74,
                    0.26,
                    0.83,
                    0.83,
                    0.83,
                    -33.84,
                    1.26,
                    -27.27,
                    0.87,
                    -0,
                    -0.45,
                    -0.2,
                    0.84,
                    0.84,
                    0.84,
                    -34.17,
                    1.26,
                    -27.11,
                    0.41,
                    0.90,
                    -0.16,
                    0.02,
                    1.17,
                    1.17,
                    1.17,
                    -33.83,
                    1.26,
                    -26.5,
                    0.24,
                    0.16,
                    -0.53,
                    -0.8,
                    1.11,
                    1.11,
                    1.11,
                    -34.22,
                    1.26,
                    -26.62,
                    0.31,
                    -0.39,
                    -0.3,
                    0.81,
                    0.91,
                    0.91,
                    0.91,
                    -33.91,
                    1.26,
                    -26.85,
                    0.10,
                    0.56,
                    -0.64,
                    -0.52,
                    1.13,
                    1.13,
                    1.13,
                    -33.69,
                    1.26,
                    -26.2,
                    0.45,
                    -0.63,
                    -0.63,
                    0.06,
                    0.88,
                    0.88,
                    0.88,
                    -33.78,
                    1.26,
                    -26.72,
                    0.03,
                    -0.34,
                    0.14,
                    0.93,
                    1.21,
                    1.21,
                    1.21,
                    -33.45,
                    1.26,
                    -26.52,
                    0.10,
                    -0.18,
                    -0.45,
                    0.87,
                    0.90,
                    0.90,
                    0.90,
                    -33.91,
                    1.26,
                    -27.17,
                    0.11,
                    0.86,
                    -0.45,
                    -0.2,
                    1.18,
                    1.18,
                    1.18,
                    -33.9,
                    1.26,
                    -27.12,
                    0.58,
                    0.50,
                    -0.04,
                    -0.64,
                    1.07,
                    1.07,
                    1.07,
                    -34.07,
                    1.26,
                    -26.72,
                    0.27,
                    0.72,
                    0.09,
                    -0.63,
                    1.16,
                    1.16,
                    1.16,
                    -33.55,
                    1.26,
                    -26.54,
                    0.55,
                    0.31,
                    -0.7,
                    -0.34,
                    1.00,
                    1.00,
                    1.00,
                    -33.78,
                    1.26,
                    -26.27,
                    0.26,
                    -0.51,
                    0.01,
                    0.82,
                    0.99,
                    0.99,
                    0.99,
                    -33.41,
                    1.26,
                    -26.76,
                    0.65,
                    0.18,
                    0.03,
                    -0.73,
                    1.04,
                    1.04,
                    1.04,
                    -33.27,
                    1.26,
                    -27,
                    0.26,
                    0.56,
                    0.58,
                    -0.52,
                    1.01,
                    1.01,
                    1.01,
                    -33.25,
                    1.26,
                    -27.26,
                    0.18,
                    0.84,
                    -0.05,
                    -0.51,
                    1.20,
                    1.20,
                    1.20,
                    -33.94,
                    1.26,
                    -26.7,
                    0.61,
                    0.14,
                    -0.37,
                    -0.68,
                    1.00,
                    1.00,
                    1.00,
                    -34.07,
                    1.26,
                    -26.54,
                    0.93,
                    0.35,
                    -0.09,
                    0.02,
                    1.05,
                    1.05,
                    1.05,
                    -33.34,
                    1.26,
                    -26.21,
                    0.40,
                    0.59,
                    -0.66,
                    -0.23,
                    1.16,
                    1.16,
                    1.16,
                    -33.22,
                    1.26,
                    -27.17,
                    0.37,
                    -0.31,
                    0.22,
                    0.85,
                    1.01,
                    1.01,
                    1.01,
                    -33.75,
                    1.26,
                    -26.83,
                    0.66,
                    -0.65,
                    -0.26,
                    0.28,
                    1.15,
                    1.15,
                    1.15,
                    -33.1,
                    1.26,
                    -27.05,
                    0.92,
                    0.25,
                    -0.3,
                    -0.02,
                    1.04,
                    1.04,
                    1.04,
                    -34.1,
                    1.26,
                    -26.53,
                    0.11,
                    0.90,
                    0.28,
                    -0.31,
                    1.21,
                    1.21,
                    1.21,
                    -33.3,
                    1.26,
                    -27.11,
                    0.76,
                    0.09,
                    -0.55,
                    0.32,
                    0.90,
                    0.90,
                    0.90,
                    -33.09,
                    1.26,
                    -26.65,
                    0.20,
                    0.44,
                    0.10,
                    -0.87,
                    0.83,
                    0.83,
                    0.83,
                    -33.24,
                    1.26,
                    -26.86,
                    0.37,
                    -0.72,
                    0.22,
                    0.54,
                    1.12,
                    1.12,
                    1.12,
                    -34.17,
                    1.26,
                    -26.97,
                    0.54,
                    0.15,
                    -0.45,
                    -0.69,
                    0.98,
                    0.98,
                    0.98,
                    -33.53,
                    1.26,
                    -26.87,
                    0.08,
                    -0.54,
                    -0.53,
                    0.65,
                    1.04,
                    1.04,
                    1.04,
                    -33.04,
                    1.24,
                    -26.7,
                    0.38,
                    -0.29,
                    -0.86,
                    -0.18,
                    0.79,
                    0.79,
                    0.79,
                    -33.09,
                    1.26,
                    -26.57,
                    0.47,
                    -0.4,
                    0.22,
                    0.76,
                    0.81,
                    0.81,
                    0.81,
                    -33.03,
                    1.26,
                    -26.55,
                    0.91,
                    0.14,
                    -0.37,
                    -0.09,
                    0.71,
                    0.71,
                    0.71,
                    -33.07,
                    1.26,
                    -26.5,
                    0.42,
                    0.53,
                    -0.16,
                    -0.72,
                    0.67,
                    0.67,
                    0.67,
                    -33.1,
                    1.26,
                    -26.59,
                    0.64,
                    -0.48,
                    0.20,
                    0.57,
                    0.88,
                    0.88,
                    0.88,
                    -33.07,
                    1.26,
                    -26.62,
                    0.16,
                    -0.01,
                    -0.9,
                    -0.4,
                    0.68,
                    0.68,
                    0.68,
                    -33.09,
                    1.26,
                    -26.51,
                    0.06,
                    0.18,
                    -0.78,
                    -0.59,
                    0.90,
                    0.90,
                    0.90,
                    -33.08,
                    1.26,
                    -26.63,
                    0.38,
                    0.30,
                    -0.23,
                    -0.84,
                    0.79,
                    0.79,
                    0.79,
                    -33.03,
                    1.26,
                    -26.72,
                    0.38,
                    -0.29,
                    -0.86,
                    -0.18,
                    0.90,
                    0.90,
                    0.90,
                    -33.04,
                    1.24,
                    -26.62,
                    0.38,
                    -0.29,
                    -0.86,
                    -0.18,
                    0.59,
                    0.59,
                    0.59,
                    -33.15,
                    1.26,
                    -26.38,
                    0.41,
                    0.60,
                    -0.19,
                    -0.66,
                    0.89,
                    0.89,
                    0.89,
                    -33.2,
                    1.26,
                    -26.37,
                    0.02,
                    -0.23,
                    0.79,
                    0.57,
                    1.21,
                    1.21,
                    1.21,
                    -33.22,
                    1.26,
                    -26.36,
                    0.49,
                    -0.47,
                    0.18,
                    0.72,
                    0.81,
                    0.81,
                    0.81,
                    -33.22,
                    1.26,
                    -26.31,
                    0.41,
                    0.60,
                    -0.19,
                    -0.66,
                    0.67,
                    0.67,
                    0.67,
                    -33.17,
                    1.26,
                    -26.37,
                    0.08,
                    0.03,
                    -0.91,
                    -0.4,
                    0.68,
                    0.68,
                    0.68,
                    -33.23,
                    1.26,
                    -26.3,
                    0.02,
                    -0.23,
                    0.79,
                    0.57,
                    0.90,
                    0.90,
                    0.90,
                    -33.15,
                    1.24,
                    -26.39,
                    0.29,
                    -0.27,
                    -0.89,
                    -0.21,
                    0.59,
                    0.59,
                    0.59,
                    -33.27,
                    1.26,
                    -26.24,
                    0.82,
                    -0.27,
                    -0.42,
                    -0.27,
                    0.55,
                    0.55,
                    0.55,
                    -33.25,
                    1.26,
                    -26.27,
                    0.92,
                    -0.37,
                    0.10,
                    -0.08,
                    0.55,
                    0.55,
                    0.55,
                    -33.04,
                    1.24,
                    -26.67,
                    0.16,
                    -0.01,
                    -0.9,
                    -0.4,
                    0.68,
                    0.68,
                    0.68,
                    -33.05,
                    1.24,
                    -26.79,
                    0.16,
                    -0.01,
                    -0.9,
                    -0.4,
                    0.68,
                    0.68,
                    0.68,
                    -33.1,
                    1.24,
                    -27,
                    0.16,
                    -0.01,
                    -0.9,
                    -0.4,
                    0.68,
                    0.68,
                    0.68,
                    -33.11,
                    1.25,
                    -27.08,
                    0.63,
                    0.26,
                    0.37,
                    -0.63,
                    1.08,
                    1.08,
                    1.08,
                    -33.16,
                    1.26,
                    -27.09,
                    0.38,
                    -0.29,
                    -0.86,
                    -0.18,
                    1.20,
                    1.20,
                    1.20
                ];
                for(let i = 0; i < leaf_k_pqs.length / 10; ++i){
                    leaf_k_pqs[i * 10 + 0] -= $5fbffa87c50562b9$var$a.k_patch.position.x;
                    leaf_k_pqs[i * 10 + 1] -= $5fbffa87c50562b9$var$a.k_patch.position.y;
                    leaf_k_pqs[i * 10 + 2] -= $5fbffa87c50562b9$var$a.k_patch.position.z;
                    leaf_k_pqs[i * 10 + 7] = .924;
                    leaf_k_pqs[i * 10 + 8] = -0.924;
                    leaf_k_pqs[i * 10 + 9] = .924;
                }
                const leaf_k_instanced_meshes = create_instanced_meshes({
                    names: [
                        "leaf_k"
                    ],
                    pqs: leaf_k_pqs,
                    add_to_scene: false,
                    sway: true
                });
                leaf_k_instanced_meshes.forEach((instanced_mesh)=>$5fbffa87c50562b9$var$a.k_patch.add(instanced_mesh));
                const tulipa_D_k_pqs = [
                    -33.09,
                    1.24,
                    -26.89,
                    0.70,
                    -0.08,
                    -0.71,
                    -0.03,
                    0.31,
                    0.31,
                    0.31,
                    -33.83,
                    1.24,
                    -26.89,
                    0.23,
                    0.02,
                    0.97,
                    0.09,
                    0.31,
                    0.31,
                    0.31,
                    -33.93,
                    1.19,
                    -26.38,
                    0.52,
                    -0.07,
                    -0.85,
                    -0.05,
                    0.31,
                    0.31,
                    0.31,
                    -33.6,
                    1.22,
                    -26.31,
                    0.52,
                    -0.07,
                    -0.85,
                    -0.05,
                    0.31,
                    0.31,
                    0.31,
                    -33.51,
                    1.22,
                    -27.18,
                    0.87,
                    -0.09,
                    -0.49,
                    -0.01,
                    0.31,
                    0.31,
                    0.31,
                    -33.3,
                    1.22,
                    -26.39,
                    0.87,
                    -0.09,
                    -0.49,
                    -0.01,
                    0.21,
                    0.21,
                    0.21,
                    -33.31,
                    1.22,
                    -26.85,
                    0.52,
                    -0.07,
                    -0.85,
                    -0.05,
                    0.31,
                    0.31,
                    0.31,
                    -33.19,
                    1.22,
                    -26.71,
                    1.00,
                    -0.08,
                    -0.01,
                    0.04,
                    0.21,
                    0.21,
                    0.21
                ];
                for(let i = 0; i < tulipa_D_k_pqs.length / 10; ++i){
                    tulipa_D_k_pqs[i * 10 + 0] -= $5fbffa87c50562b9$var$a.k_patch.position.x;
                    tulipa_D_k_pqs[i * 10 + 1] -= $5fbffa87c50562b9$var$a.k_patch.position.y;
                    tulipa_D_k_pqs[i * 10 + 2] -= $5fbffa87c50562b9$var$a.k_patch.position.z;
                    tulipa_D_k_pqs[i * 10 + 7] = .21;
                    tulipa_D_k_pqs[i * 10 + 8] = -0.21;
                    tulipa_D_k_pqs[i * 10 + 9] = .21;
                }
                const tulipa_D_k_instanced_meshes = create_instanced_meshes({
                    names: [
                        "tulipa_D_k"
                    ],
                    pqs: tulipa_D_k_pqs,
                    add_to_scene: false,
                    sway: true
                });
                tulipa_D_k_instanced_meshes.forEach((instanced_mesh)=>$5fbffa87c50562b9$var$a.k_patch.add(instanced_mesh));
            }
            $5fbffa87c50562b9$var$a.info_disk = garden.scene.getObjectByName("info_disk");
            $5fbffa87c50562b9$var$a.info_disk.material = $5fbffa87c50562b9$var$reflective_material;
            $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.info_disk);
            new $5fbffa87c50562b9$var$Fader({
                distance: 8,
                mesh: $5fbffa87c50562b9$var$a.info_disk
            });
            $5fbffa87c50562b9$var$a.info_disk002 = garden.scene.getObjectByName("info_disk002");
            $5fbffa87c50562b9$var$a.info_disk002.material = $5fbffa87c50562b9$var$reflective_material;
            $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.info_disk002);
            new $5fbffa87c50562b9$var$Fader({
                distance: 8,
                mesh: $5fbffa87c50562b9$var$a.info_disk002
            });
            $5fbffa87c50562b9$var$a.info_disk003 = garden.scene.getObjectByName("info_disk003");
            $5fbffa87c50562b9$var$a.info_disk003.material = $5fbffa87c50562b9$var$reflective_material;
            $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.info_disk003);
            new $5fbffa87c50562b9$var$Fader({
                distance: 8,
                mesh: $5fbffa87c50562b9$var$a.info_disk003
            });
            $5fbffa87c50562b9$var$a.info_disk004 = garden.scene.getObjectByName("info_disk004");
            $5fbffa87c50562b9$var$a.info_disk004.material = $5fbffa87c50562b9$var$reflective_material;
            $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.info_disk004);
            new $5fbffa87c50562b9$var$Fader({
                distance: 8,
                mesh: $5fbffa87c50562b9$var$a.info_disk004
            });
            $5fbffa87c50562b9$var$a.info_disk001 = garden.scene.getObjectByName("info_disk001");
            $5fbffa87c50562b9$var$a.info_disk001.material = $5fbffa87c50562b9$var$reflective_material;
            $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.info_disk001);
            new $5fbffa87c50562b9$var$Fader({
                distance: 8,
                mesh: $5fbffa87c50562b9$var$a.info_disk001
            });
            $5fbffa87c50562b9$var$a.arch = garden.scene.getObjectByName("arch");
            $5fbffa87c50562b9$var$a.arch.castShadow = true;
            $5fbffa87c50562b9$var$a.arch.material = $5fbffa87c50562b9$var$reflective_double_side_material;
            $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.arch);
            $5fbffa87c50562b9$var$a.arch003 = garden.scene.getObjectByName("arch003");
            $5fbffa87c50562b9$var$a.arch003.material = $5fbffa87c50562b9$var$reflective_double_side_material;
            $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.arch003);
            $5fbffa87c50562b9$var$a.flower = garden.scene.getObjectByName("flower");
            $5fbffa87c50562b9$var$a.flower.traverse((child)=>{
                child.material = $5fbffa87c50562b9$var$reflective_material;
            });
            $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.flower);
            $5fbffa87c50562b9$var$a.tulip = garden.scene.getObjectByName("tulip");
            for (const child of $5fbffa87c50562b9$var$a.tulip.children)if (child.isMesh) child.material = $5fbffa87c50562b9$var$reflective_material;
            $5fbffa87c50562b9$var$a.tulip_portal = garden.scene.getObjectByName("tulip_portal");
            $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.tulip);
            new $5fbffa87c50562b9$var$Interactive({
                billboard: false,
                scene: $5fbffa87c50562b9$var$g.scene,
                mesh: $5fbffa87c50562b9$var$a.tulip_portal,
                interactive: true
            });
            $5fbffa87c50562b9$var$a.dome = garden.scene.getObjectByName("dome");
            for (const child of $5fbffa87c50562b9$var$a.dome.children)if (child.isMesh) child.material = $5fbffa87c50562b9$var$reflective_material;
            $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.dome);
            new $0147bee01cff6558$export$fd1bfc71f64c538c().load("./assets/textures/water_normals.jpg", (texture)=>{
                $5fbffa87c50562b9$var$a.water_normals = texture;
                $5fbffa87c50562b9$var$a.water_normals.wrapS = texture.wrapT = $0147bee01cff6558$export$533346c8e8dac0f5;
                $5fbffa87c50562b9$var$a.water_mesh = new (0, $1830f4d044a5f406$export$1832bdd7a783545e)(new $0147bee01cff6558$export$967d831af31f69ce(25, 25), {
                    textureWidth: 128,
                    textureHeight: 128,
                    waterNormals: $5fbffa87c50562b9$var$a.water_normals,
                    sunDirection: new $0147bee01cff6558$export$64b5c384219d3699(),
                    sunColor: 0xffffff,
                    waterColor: 0x4a96bd,
                    distortionScale: 0.5,
                    size: 0.1,
                    fog: true
                }) //g.scene.fog !== undefined })
                ;
                $5fbffa87c50562b9$var$a.water_mesh.material.uniforms.scale = .01;
                $5fbffa87c50562b9$var$a.water_mesh.rotation.x = -Math.PI / 2;
                $5fbffa87c50562b9$var$a.water_mesh.position.set(28.826, -0.8, -21.399);
                $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.water_mesh);
            });
            $5fbffa87c50562b9$var$a.path_entrance = garden.scene.getObjectByName("path_entrance");
            $5fbffa87c50562b9$var$a.path_entrance.material = $5fbffa87c50562b9$var$reflective_material;
            $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.path_entrance);
            $5fbffa87c50562b9$var$a.halo_meshes = [];
            $5fbffa87c50562b9$var$a.halo_visibility_distance = 10;
            {
                const special_flowers_pqs = [
                    0.81,
                    0.43,
                    0.44,
                    0.00,
                    -0.18,
                    -0,
                    0.98,
                    1.00,
                    1.00,
                    1.00,
                    0.59,
                    1.19,
                    -0.45,
                    0.00,
                    -0.21,
                    0.00,
                    0.98,
                    1.00,
                    1.00,
                    1.00,
                    0.23,
                    0.97,
                    1.47,
                    0.00,
                    -0.21,
                    0.00,
                    0.98,
                    1.00,
                    1.00,
                    1.00,
                    0.82,
                    1.74,
                    -0.83,
                    -0.02,
                    -0.2,
                    0.10,
                    0.97,
                    1.00,
                    1.00,
                    1.00,
                    0.09,
                    1.23,
                    0.90,
                    -0.07,
                    -0.53,
                    0.22,
                    0.82,
                    1.00,
                    1.00,
                    1.00,
                    0.22,
                    0.40,
                    0.82,
                    -0.07,
                    -0.52,
                    0.22,
                    0.82,
                    1.00,
                    1.00,
                    1.00,
                    0.91,
                    1.46,
                    0.16,
                    -0.05,
                    -0.52,
                    0.23,
                    0.82,
                    1.00,
                    1.00,
                    1.00,
                    -1.1,
                    1.13,
                    0.91,
                    -0.02,
                    -0.78,
                    0.24,
                    0.58,
                    1.00,
                    1.00,
                    1.00,
                    0.68,
                    1.48,
                    -1.08,
                    -0.07,
                    -0.52,
                    0.22,
                    0.82,
                    1.00,
                    1.00,
                    1.00,
                    0.98,
                    1.22,
                    0.37,
                    -0.06,
                    -0.44,
                    0.33,
                    0.83,
                    1.00,
                    1.00,
                    1.00,
                    -0.71,
                    1.77,
                    1.16,
                    -0.02,
                    -0.78,
                    0.24,
                    0.58,
                    1.00,
                    1.00,
                    1.00,
                    0.86,
                    0.57,
                    -1.22,
                    -0.07,
                    -0.52,
                    0.22,
                    0.82,
                    1.00,
                    1.00,
                    1.00,
                    -0.37,
                    0.56,
                    1.14,
                    -0.02,
                    -0.78,
                    0.24,
                    0.58,
                    1.00,
                    1.00,
                    1.00,
                    0.32,
                    1.47,
                    1.07,
                    -0.05,
                    -0.55,
                    0.19,
                    0.81,
                    1.00,
                    1.00,
                    1.00,
                    -0.46,
                    1.48,
                    1.01,
                    -0.07,
                    0.98,
                    -0.2,
                    0.02,
                    1.00,
                    1.00,
                    1.00,
                    1.21,
                    0.95,
                    -0.14,
                    -0.07,
                    -0.52,
                    0.22,
                    0.82,
                    1.00,
                    1.00,
                    1.00
                ];
                const specials = create_instanced_meshes({
                    names: [
                        "special_flower021"
                    ],
                    pqs: special_flowers_pqs,
                    sway: false,
                    add_to_scene: false
                });
                specials.forEach((special)=>{
                    special.material = $5fbffa87c50562b9$var$reflective_double_side_material;
                    $5fbffa87c50562b9$var$a.flower.add(special);
                });
                let special = 0;
                const rings_pqs = [
                    0.81,
                    0.60,
                    -1.25,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.35,
                    0.35,
                    0.35,
                    -1.12,
                    1.16,
                    0.87,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.35,
                    0.35,
                    0.35,
                    -0.73,
                    1.79,
                    1.10,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.35,
                    0.35,
                    0.35,
                    -0.43,
                    1.53,
                    0.99,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.35,
                    0.35,
                    0.35,
                    -0.39,
                    0.58,
                    1.10,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.35,
                    0.35,
                    0.35,
                    0.04,
                    1.25,
                    0.89,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.35,
                    0.35,
                    0.35,
                    0.19,
                    1.02,
                    1.48,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.35,
                    0.35,
                    0.35,
                    0.16,
                    0.42,
                    0.80,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.35,
                    0.35,
                    0.35,
                    0.27,
                    1.51,
                    1.04,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.35,
                    0.35,
                    0.35,
                    0.78,
                    0.48,
                    0.45,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.35,
                    0.35,
                    0.35,
                    0.94,
                    1.22,
                    0.34,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.35,
                    0.35,
                    0.35,
                    0.87,
                    1.49,
                    0.13,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.35,
                    0.35,
                    0.35,
                    1.17,
                    0.96,
                    -0.17,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.35,
                    0.35,
                    0.35,
                    0.77,
                    1.80,
                    -0.82,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.35,
                    0.35,
                    0.35,
                    0.63,
                    1.50,
                    -1.11,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.35,
                    0.35,
                    0.35,
                    0.54,
                    1.24,
                    -0.44,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.35,
                    0.35,
                    0.35
                ];
                for(let i = 0; i < Math.min($5fbffa87c50562b9$var$special_mp3s.length, rings_pqs.length / 10); ++i){
                    if (special >= $5fbffa87c50562b9$var$special_mp3s.length) break;
                    const halo_plane = new $0147bee01cff6558$export$e176487c05830cc5(new $0147bee01cff6558$export$967d831af31f69ce(.5, .5), new $0147bee01cff6558$export$55cbcc9b622fe1f5({
                        transparent: true,
                        map: $5fbffa87c50562b9$var$a.loader_empty_texture
                    }));
                    halo_plane.userData.visibility_distance = 4;
                    halo_plane.userData.type = "special";
                    halo_plane.userData.audio_src = $5fbffa87c50562b9$var$special_mp3s[special++].path;
                    $5fbffa87c50562b9$var$a.flower.getWorldPosition(halo_plane.position);
                    halo_plane.position.x += rings_pqs[i * 10 + 0];
                    halo_plane.position.y += rings_pqs[i * 10 + 1];
                    halo_plane.position.z += rings_pqs[i * 10 + 2];
                    $5fbffa87c50562b9$var$a.halo_meshes.push(halo_plane);
                    $5fbffa87c50562b9$var$g.scene.add(halo_plane);
                    new $5fbffa87c50562b9$var$Interactive({
                        scene: $5fbffa87c50562b9$var$g.scene,
                        mesh: halo_plane,
                        interactive: true
                    });
                }
            /*
					const sf = garden.scene.getObjectByName( 'special_flowers' )
					let s = '['
					sf.traverse( f =>{
						if( f.name.startsWith( 'ring_special_' )){
							s += f.position.x.toFixed( 2 )   + ',' + f.position.y.toFixed( 2 )   + ',' + f.position.z.toFixed( 2 )   + ',' +
								 f.quaternion.x.toFixed( 2 ) + ',' + f.quaternion.y.toFixed( 2 ) + ',' + f.quaternion.z.toFixed( 2 ) + ',' + f.quaternion.w.toFixed( 2 ) + ',' +
								 f.scale.x.toFixed( 2 )      + ',' + f.scale.y.toFixed( 2 )      + ',' + f.scale.z.toFixed( 2 )      + ',' 
						}
					})
					console.log( s )
*/ }
            {
                const friend_pqs = [
                    27.72,
                    -0.31,
                    -23.26,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.68,
                    0.68,
                    0.68,
                    27.03,
                    -0.31,
                    -21.39,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.82,
                    0.82,
                    0.82,
                    27.27,
                    -0.31,
                    -21.32,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.65,
                    0.65,
                    0.65,
                    27.41,
                    -0.31,
                    -21.08,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.70,
                    0.70,
                    0.70,
                    29.64,
                    -0.31,
                    -20.49,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.82,
                    0.82,
                    0.82,
                    29.86,
                    -0.31,
                    -22.63,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.57,
                    0.57,
                    0.57,
                    29.98,
                    -0.31,
                    -20.86,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.72,
                    0.72,
                    0.72,
                    30.01,
                    -0.31,
                    -21.34,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.82,
                    0.82,
                    0.82,
                    28.76,
                    -0.31,
                    -20.37,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.82,
                    0.82,
                    0.82,
                    28.62,
                    -0.31,
                    -19.98,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.60,
                    0.60,
                    0.60,
                    29.37,
                    -0.31,
                    -20.19,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.67,
                    0.67,
                    0.67,
                    28.12,
                    -0.31,
                    -20.22,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.82,
                    0.82,
                    0.82,
                    29.32,
                    -0.31,
                    -20.76,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.70,
                    0.70,
                    0.70,
                    27.65,
                    -0.31,
                    -20.77,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.82,
                    0.82,
                    0.82,
                    30.09,
                    -0.31,
                    -21.61,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.66,
                    0.66,
                    0.66,
                    29.96,
                    -0.31,
                    -22.05,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.82,
                    0.82,
                    0.82,
                    29.57,
                    -0.31,
                    -22.11,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.69,
                    0.69,
                    0.69,
                    26.80,
                    -0.31,
                    -21.36,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.64,
                    0.64,
                    0.64,
                    28.50,
                    -0.31,
                    -23.13,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.82,
                    0.82,
                    0.82,
                    28.14,
                    -0.31,
                    -22.77,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    0.61,
                    0.61,
                    0.61
                ];
                create_instanced_meshes({
                    names: [
                        "friend_flower"
                    ],
                    pqs: friend_pqs,
                    sway: false
                });
                const count = Math.min($5fbffa87c50562b9$var$common_mp3s.length, friend_pqs.length / 10);
                for(let i = 0; i < count; ++i)$5fbffa87c50562b9$var$friend_mp3s.push($5fbffa87c50562b9$var$common_mp3s.pop());
                const friend_flower_empty = garden.scene.getObjectByName("friend_flower").children[0];
                for(let i = 0; i < friend_pqs.length / 10; ++i){
                    if (i >= $5fbffa87c50562b9$var$friend_mp3s.length) break;
                    const halo_plane = new $0147bee01cff6558$export$e176487c05830cc5(new $0147bee01cff6558$export$967d831af31f69ce(.5, .5), new $0147bee01cff6558$export$55cbcc9b622fe1f5({
                        transparent: true,
                        map: $5fbffa87c50562b9$var$a.loader_empty_texture
                    }));
                    halo_plane.userData.visibility_distance = 4;
                    halo_plane.userData.type = "common";
                    halo_plane.userData.audio_src = $5fbffa87c50562b9$var$friend_mp3s[i].path;
                    const y = friend_flower_empty.position.y * friend_pqs[i * 10 + 8];
                    halo_plane.position.set(friend_pqs[i * 10 + 0], friend_pqs[i * 10 + 1] + y, friend_pqs[i * 10 + 2]);
                    halo_plane.scale.set(friend_pqs[i * 10 + 7], friend_pqs[i * 10 + 8], friend_pqs[i * 10 + 9]);
                    $5fbffa87c50562b9$var$a.halo_meshes.push(halo_plane);
                    $5fbffa87c50562b9$var$g.scene.add(halo_plane);
                    new $5fbffa87c50562b9$var$Interactive({
                        scene: $5fbffa87c50562b9$var$g.scene,
                        mesh: halo_plane,
                        interactive: true
                    });
                }
            }
            {
                const common_flower_pqs = [
                    -4.59,
                    0.50,
                    -54.41,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -12.23,
                    0.77,
                    -33.05,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    8.18,
                    0.26,
                    -39.55,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    14.27,
                    0.10,
                    -34.17,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -3.55,
                    0.58,
                    -53.92,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -5.49,
                    0.18,
                    -40.78,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -7.35,
                    0.20,
                    -40.31,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    8.46,
                    -0.38,
                    -20.83,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    0.54,
                    -0.6,
                    -18.6,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    1.25,
                    -0.53,
                    -17.63,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    16.53,
                    -0.39,
                    -17.92,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -2.75,
                    0.61,
                    -51.43,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -15.25,
                    0.97,
                    -42.19,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    14.59,
                    -0.42,
                    -14.86,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -18.3,
                    0.84,
                    -34.86,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -10.48,
                    0.32,
                    -16.69,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    8.98,
                    -0.26,
                    -25.51,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -20.01,
                    0.40,
                    -28.61,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -12.34,
                    0.20,
                    -18.33,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -2.63,
                    0.63,
                    -52.31,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    2.22,
                    0.66,
                    -47.37,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    17.84,
                    -0.31,
                    -29.57,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    9.07,
                    -0.27,
                    -26.21,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -11.18,
                    0.92,
                    -36.81,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -3.96,
                    0.09,
                    -40.72,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    2.40,
                    0.38,
                    -35.74,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -8.07,
                    0.67,
                    -12.86,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -11.46,
                    0.61,
                    -49.39,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    12.30,
                    0.00,
                    -35.58,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    17.93,
                    -0.58,
                    -22.23,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    9.21,
                    -0.41,
                    -24.11,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    1.42,
                    0.40,
                    -36.67,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -0.68,
                    -0.63,
                    -19.68,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    11.25,
                    -0.03,
                    -36.12,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -1.97,
                    0.08,
                    -39.82,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    8.54,
                    0.15,
                    -38.45,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    7.65,
                    0.01,
                    -29.05,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    13.36,
                    0.07,
                    -34.8,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -15.11,
                    0.35,
                    -20.16,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -0.41,
                    0.25,
                    -38.63,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    0.14,
                    0.38,
                    -37.67,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -6.67,
                    0.33,
                    -53.9,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    5.55,
                    0.37,
                    -32.26,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -6.74,
                    0.69,
                    -11.28,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    0.91,
                    0.40,
                    -37.15,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -1.91,
                    0.81,
                    -50.86,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -12.95,
                    0.72,
                    -46.19,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -11.93,
                    0.05,
                    -28.02,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    5.95,
                    0.28,
                    -31.66,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    7.28,
                    -0.33,
                    -19.79,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -11.8,
                    0.89,
                    -34.46,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -12.47,
                    0.56,
                    -30.09,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -8.25,
                    -0.18,
                    -24.23,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -13.69,
                    0.82,
                    -44.62,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -6.31,
                    -0.24,
                    -23.44,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -10.7,
                    -0.06,
                    -25.9,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -16.48,
                    0.42,
                    -20.7,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -1.7,
                    -0.55,
                    -20.56,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    3.86,
                    0.66,
                    -46.16,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    8.08,
                    -0.14,
                    -28.15,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -11.45,
                    1.02,
                    -35.61,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    4.77,
                    0.73,
                    -44.62,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -9.89,
                    -0.08,
                    -25.01,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -5.26,
                    0.40,
                    -54.62,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    7.06,
                    0.15,
                    -30.05,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -5.22,
                    -0.25,
                    -22.84,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -20.55,
                    0.44,
                    -27.9,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -8.51,
                    0.22,
                    -39.93,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -8.96,
                    0.50,
                    -14.98,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    4.49,
                    0.40,
                    -33.55,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    8.71,
                    -0.24,
                    -27.19,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -9.16,
                    -0.13,
                    -24.47,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    7.61,
                    0.40,
                    -40.65,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    9.22,
                    -0.47,
                    -23.02,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    6.29,
                    -0.28,
                    -18.96,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    3.83,
                    0.42,
                    -34.07,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    16.26,
                    -0.31,
                    -31.15,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    9.20,
                    -0.31,
                    -24.8,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -12.47,
                    0.56,
                    -30.09,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    17.32,
                    -0.49,
                    -20.29,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    10.47,
                    -0.02,
                    -36.93,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -16.37,
                    1.21,
                    -40.95,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    18.14,
                    -0.59,
                    -23.69,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    5.03,
                    -0.26,
                    -18.08,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -3.47,
                    0.08,
                    -40.53,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    9.43,
                    0.06,
                    -37.91,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    3.40,
                    0.39,
                    -34.75,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -4.11,
                    -0.3,
                    -22.17,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    15.89,
                    -0.19,
                    -32.09,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -9.54,
                    0.37,
                    -39.03,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -2.16,
                    0.79,
                    -50.13,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -11.38,
                    -0.04,
                    -26.65,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -1.52,
                    0.89,
                    -49.36,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -13.86,
                    0.26,
                    -19.25,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -12.04,
                    0.50,
                    -48.32,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    18.96,
                    -0.3,
                    -27.72,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -2.9,
                    -0.42,
                    -21.42,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -17.86,
                    0.56,
                    -21.35,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -12.52,
                    0.64,
                    -31.93,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -18.11,
                    0.87,
                    -36.86,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -2.85,
                    0.71,
                    -53.42,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    14.74,
                    0.01,
                    -33.19,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -6.39,
                    0.21,
                    -40.75,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -14.35,
                    0.95,
                    -43.31,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -7.18,
                    -0.24,
                    -23.83,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    6.61,
                    0.16,
                    -30.96,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    5.02,
                    0.45,
                    -33.04,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -18.61,
                    0.69,
                    -33.29,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    1.22,
                    0.71,
                    -48.42,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    0.00,
                    0.30,
                    -38.31,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    8.96,
                    -0.41,
                    -21.92,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -17.1,
                    0.95,
                    -39.16,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00,
                    -1.08,
                    0.18,
                    -39.03,
                    0.00,
                    0.00,
                    0.00,
                    1.00,
                    1.00,
                    1.00,
                    1.00
                ];
                create_instanced_meshes({
                    names: [
                        "common_flower"
                    ],
                    pqs: common_flower_pqs,
                    sway: false
                });
                const common_flower_empty = garden.scene.getObjectByName("common_flower").children[0];
                for(let i = 0; i < common_flower_pqs.length / 10; ++i){
                    if (i >= $5fbffa87c50562b9$var$common_mp3s.length) break;
                    const halo_plane = new $0147bee01cff6558$export$e176487c05830cc5(new $0147bee01cff6558$export$967d831af31f69ce(.5, .5), new $0147bee01cff6558$export$55cbcc9b622fe1f5({
                        transparent: true,
                        map: $5fbffa87c50562b9$var$a.loader_empty_texture
                    }));
                    halo_plane.userData.visibility_distance = 10;
                    halo_plane.userData.type = "common";
                    halo_plane.userData.audio_src = $5fbffa87c50562b9$var$common_mp3s[i].path;
                    halo_plane.position.addVectors(common_flower_empty.position, new $0147bee01cff6558$export$64b5c384219d3699(common_flower_pqs[i * 10 + 0], common_flower_pqs[i * 10 + 1], common_flower_pqs[i * 10 + 2]));
                    $5fbffa87c50562b9$var$a.halo_meshes.push(halo_plane);
                    $5fbffa87c50562b9$var$g.scene.add(halo_plane);
                    new $5fbffa87c50562b9$var$Interactive({
                        scene: $5fbffa87c50562b9$var$g.scene,
                        mesh: halo_plane,
                        interactive: true
                    });
                }
            }
            const envMap = $5fbffa87c50562b9$var$load_cube_map({
                path: "./assets/textures/dress"
            });
            const material = new $0147bee01cff6558$export$55cbcc9b622fe1f5({
                envMap: envMap
            });
            const dress = garden.scene.getObjectByName("dress");
            dress.material = material;
            const tallgrass = garden.scene.getObjectByName("tallgrass");
            tallgrass.material = material;
            $5fbffa87c50562b9$var$a.flower.add(tallgrass);
            $5fbffa87c50562b9$var$a.breonna = garden.scene.getObjectByName("breonna");
            $5fbffa87c50562b9$var$a.breonna_position = new $0147bee01cff6558$export$64b5c384219d3699().copy($5fbffa87c50562b9$var$a.breonna.position);
            $5fbffa87c50562b9$var$a.breonna.position.set(0, 0, 0);
            $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.breonna);
            new $5fbffa87c50562b9$var$Fader({
                mesh: $5fbffa87c50562b9$var$a.breonna
            });
            update_progress("OPENING PORTALS");
            const gltf_loader = new (0, $3af46d7a32572744$export$aa93f11e7884f0f4)();
            gltf_loader.setDRACOLoader($5fbffa87c50562b9$var$g.draco_loader);
            gltf_loader.load("./assets/models/room.glb", (room)=>{
                $5fbffa87c50562b9$var$g.room_scene.environment = new $0147bee01cff6558$export$6add42717753e221($5fbffa87c50562b9$var$g.renderer).fromScene(new (0, $ee4de29e557e6ffd$export$3ee6a4df67079774)(), 0.04).texture;
                $5fbffa87c50562b9$var$g.room_scene.add(room.scene);
                $5fbffa87c50562b9$var$a.room_spawn = room.scene.getObjectByName("room_spawn__spawn");
                $5fbffa87c50562b9$var$a.room_collider = room.scene.getObjectByName("room_ground_collider");
                //a.room_collider.visible = false
                $5fbffa87c50562b9$var$a.room_collider.position.y = -0.1;
                $5fbffa87c50562b9$var$a.portal = room.scene.getObjectByName("portal");
                //g.room_scene.add        ( a.portal )
                new $5fbffa87c50562b9$var$Interactive({
                    billboard: false,
                    scene: $5fbffa87c50562b9$var$g.room_scene,
                    mesh: $5fbffa87c50562b9$var$a.portal,
                    interactive: true
                });
                $5fbffa87c50562b9$var$a.tamika1 = room.scene.getObjectByName("tamika1__ho_kw");
                $5fbffa87c50562b9$var$a.tamika1_holo = new $5fbffa87c50562b9$var$Holo({
                    minBuffers: 2 /*23*/ ,
                    volume: .4,
                    duration: 29000,
                    proximity_processing: false,
                    visible: false,
                    scene: $5fbffa87c50562b9$var$g.room_scene,
                    position: $5fbffa87c50562b9$var$a.tamika1.position,
                    rotation: $5fbffa87c50562b9$var$a.tamika1.rotation,
                    hcap: "./captures/2b_7yo_nurse_1/2b_7_year_old_nurse_take1.hcap"
                });
                $5fbffa87c50562b9$var$a.tamika2 = room.scene.getObjectByName("tamika2__ho_kw");
                $5fbffa87c50562b9$var$a.tamika2_holo = new $5fbffa87c50562b9$var$Holo({
                    minBuffers: 2,
                    volume: .4,
                    duration: 39000,
                    proximity_processing: false,
                    visible: false,
                    scene: $5fbffa87c50562b9$var$g.room_scene,
                    position: $5fbffa87c50562b9$var$a.tamika2.position,
                    rotation: $5fbffa87c50562b9$var$a.tamika2.rotation,
                    hcap: "./captures/3d_against_3/web/3d_against_the_world_take3.hcap"
                });
                $5fbffa87c50562b9$var$a.painting = room.scene.getObjectByName("video_frame");
                $5fbffa87c50562b9$var$a.painting_video = document.createElement("video");
                $5fbffa87c50562b9$var$a.painting_video.src = "./assets/textures/BG - Painting Loop.mp4";
                $5fbffa87c50562b9$var$a.painting_video.load();
                $5fbffa87c50562b9$var$a.painting_video.addEventListener("loadeddata", function() {
                    update_progress("PAINTING");
                    $5fbffa87c50562b9$var$a.painting_video.loop = true;
                    $5fbffa87c50562b9$var$a.painting_video_texture = new $0147bee01cff6558$export$6e09d1edf8d5a25c($5fbffa87c50562b9$var$a.painting_video);
                    $5fbffa87c50562b9$var$a.painting_video.play();
                    $5fbffa87c50562b9$var$a.painting.material = new $0147bee01cff6558$export$55cbcc9b622fe1f5({
                        map: $5fbffa87c50562b9$var$a.painting_video_texture
                    });
                //painting_mesh.material.map = painting_video_texture
                }, false);
                $5fbffa87c50562b9$var$a.video = document.createElement("video");
                $5fbffa87c50562b9$var$a.video.src = "./assets/textures/portal.mp4";
                $5fbffa87c50562b9$var$a.video.load();
                $5fbffa87c50562b9$var$a.video.addEventListener("loadeddata", ()=>{
                    update_progress("PLANTING GARDEN");
                    $5fbffa87c50562b9$var$a.video.loop = true;
                    $5fbffa87c50562b9$var$a.video_texture = new $0147bee01cff6558$export$6e09d1edf8d5a25c($5fbffa87c50562b9$var$a.video);
                    $5fbffa87c50562b9$var$a.tulip_portal.material.map = $5fbffa87c50562b9$var$a.video_texture;
                    $5fbffa87c50562b9$var$a.portal.material.map = $5fbffa87c50562b9$var$a.video_texture;
                    $5fbffa87c50562b9$var$a.video.play();
                }, false);
                const gltf_loader = new (0, $3af46d7a32572744$export$aa93f11e7884f0f4)();
                gltf_loader.setDRACOLoader($5fbffa87c50562b9$var$g.draco_loader);
                gltf_loader.load("./assets/models/butterflies.glb", (glb)=>{
                    update_progress("BLOOMING");
                    $5fbffa87c50562b9$var$butterflies = glb.scene;
                    $5fbffa87c50562b9$var$g.garden_scene.add($5fbffa87c50562b9$var$butterflies);
                    const clip = $0147bee01cff6558$export$d942c706bf23829c.findByName(glb.animations, "Animation");
                    $5fbffa87c50562b9$var$butterflies_mixer = new $0147bee01cff6558$export$fbd77e5aefaa0102($5fbffa87c50562b9$var$butterflies);
                    const action = $5fbffa87c50562b9$var$butterflies_mixer.clipAction(clip);
                    action.play();
                    const gltf_loader = new (0, $3af46d7a32572744$export$aa93f11e7884f0f4)();
                    gltf_loader.setDRACOLoader($5fbffa87c50562b9$var$g.draco_loader);
                    gltf_loader.load("./assets/models/room_butterflies.glb", (glb)=>{
                        update_progress("GATHERING FRIENDS");
                        $5fbffa87c50562b9$var$room_butterflies = glb.scene;
                        $5fbffa87c50562b9$var$g.room_scene.add($5fbffa87c50562b9$var$room_butterflies);
                        const clip = $0147bee01cff6558$export$d942c706bf23829c.findByName(glb.animations, "Animation");
                        $5fbffa87c50562b9$var$room_butterflies_mixer = new $0147bee01cff6558$export$fbd77e5aefaa0102($5fbffa87c50562b9$var$room_butterflies);
                        const action = $5fbffa87c50562b9$var$room_butterflies_mixer.clipAction(clip);
                        action.play();
                        const interval = setInterval((event)=>{
                            if ($5fbffa87c50562b9$var$loader_images_loaded() && $5fbffa87c50562b9$var$particle_images_loaded() && $5fbffa87c50562b9$var$Holo.loaded_all()) {
                                clearInterval(interval);
                                update_progress("SPAWNING BUTTERFLIES");
                                $5fbffa87c50562b9$var$place_and_rotate_camera_with_collider({
                                    position: $5fbffa87c50562b9$var$a.garden_spawn.position,
                                    rotation: $5fbffa87c50562b9$var$a.garden_spawn.rotation,
                                    collider: $5fbffa87c50562b9$var$a.garden_collider
                                });
                                //g.renderer.compile()
                                $5fbffa87c50562b9$var$g.renderer.setAnimationLoop((args)=>{
                                    $5fbffa87c50562b9$var$g.camera.getWorldPosition($5fbffa87c50562b9$var$g.camera_position);
                                    //g.csm.update      ()
                                    $5fbffa87c50562b9$var$Fader.update();
                                    $5fbffa87c50562b9$var$Interactive.update();
                                    $5fbffa87c50562b9$var$Holo.update();
                                    $5fbffa87c50562b9$var$s.update();
                                    //w.draw            ()
                                    $5fbffa87c50562b9$var$g.renderer.render($5fbffa87c50562b9$var$g.scene, $5fbffa87c50562b9$var$g.camera);
                                    $5fbffa87c50562b9$var$g.old_camera_position.copy($5fbffa87c50562b9$var$g.camera_position);
                                });
                                setTimeout((event)=>{
                                    $5fbffa87c50562b9$var$a.breonna.position.copy($5fbffa87c50562b9$var$a.breonna_position);
                                    document.body.appendChild($5fbffa87c50562b9$var$g.renderer.domElement);
                                }, 1000);
                                callback();
                            }
                        }, 1000);
                    }, (xhr)=>{}, (error)=>{});
                }, (xhr)=>{}, (error)=>{});
            }, (xhr)=>{}, (error)=>{});
        }, (xhr)=>{}, (error)=>{});
    };
}
class $5fbffa87c50562b9$var$ar {
    static start = (args)=>{
        $5fbffa87c50562b9$var$g.renderer = new $0147bee01cff6558$export$f6cc00ef28d7cf97();
        $5fbffa87c50562b9$var$g.scene = new $0147bee01cff6558$export$38af1803e3442a7f();
        const envMap = $5fbffa87c50562b9$var$load_cube_map({
            path: "./assets/textures/sky"
        });
        $5fbffa87c50562b9$var$g.scene.environment = envMap;
        $5fbffa87c50562b9$var$g.camera = new $0147bee01cff6558$export$74e4ae24825f68d7(50, 1, .01, 10000);
        $5fbffa87c50562b9$var$g.clock = new $0147bee01cff6558$export$9735c82c4bae3302();
        $5fbffa87c50562b9$var$g.raycaster = new $0147bee01cff6558$export$8b7aaceff00bd2f();
        new $0147bee01cff6558$export$fd1bfc71f64c538c().load("./assets/textures/floorplacement.png", (texture)=>{
            $5fbffa87c50562b9$var$ar.reticle_texture = texture;
        });
        console.log("about to load AR glb");
        const draco_loader = new (0, $c9d3829446f00917$export$45c25de53be259ac)().setDecoderPath("three/examples/jsm/libs/draco/");
        const gltf_loader = new (0, $3af46d7a32572744$export$aa93f11e7884f0f4)();
        gltf_loader.setDRACOLoader(draco_loader);
        console.log("draco done");
        gltf_loader.load("./assets/models/scene.glb", (glb)=>{
            const interval = setInterval((event)=>{
                if ($5fbffa87c50562b9$var$sounds_loaded) {
                    clearInterval(interval);
                    $5fbffa87c50562b9$var$ar.mesh = glb.scene;
                    let special = 0;
                    let common = 0;
                    const child_plane_meshes = [];
                    let special_flowers = [];
                    for (const child of $5fbffa87c50562b9$var$ar.mesh.children[0].children){
                        const create_plane_mesh = (args)=>{
                            const plane_mesh = new $0147bee01cff6558$export$e176487c05830cc5(new $0147bee01cff6558$export$967d831af31f69ce(1, 1), new $0147bee01cff6558$export$55cbcc9b622fe1f5({
                                transparent: true,
                                map: $5fbffa87c50562b9$var$a.loader_empty_texture
                            }));
                            plane_mesh.rotation.x = -Math.PI / 2;
                            plane_mesh.rotation.y = -Math.PI / 2;
                            child_plane_meshes.push({
                                child: child,
                                plane_mesh: plane_mesh
                            });
                            plane_mesh.userData.type = args.type;
                            plane_mesh.userData.src = args.src;
                            $5fbffa87c50562b9$var$ar_loader_rings.push(plane_mesh);
                            return plane_mesh;
                        };
                        if ("user_flower" == child.name) child.visible = null != $5fbffa87c50562b9$var$user_entry;
                        if ("user_flower_ring" == child.name && $5fbffa87c50562b9$var$user_entry) create_plane_mesh({
                            type: "user",
                            src: $5fbffa87c50562b9$var$user_entry.path
                        });
                        if ("breonna" == child.name) {
                            $5fbffa87c50562b9$var$ar.breonna_mesh = child;
                            for (const grandchild of child.children)if ("dress" == grandchild.name) $5fbffa87c50562b9$var$ar.dress_mesh = grandchild;
                        }
                        if (child.name.startsWith("special_flower")) special_flowers.push(child);
                        if ("TallGrass" == child.name) $5fbffa87c50562b9$var$ar.tallgrass_mesh = child;
                        if ("JuNiyah__ho_kw" == child.name) $5fbffa87c50562b9$var$a.jun_holo = new $5fbffa87c50562b9$var$Holo({
                            any_scene: true,
                            proximity_processing: false,
                            duration: 2000,
                            volume: .25,
                            scene: child,
                            hcap: "./captures/juniyah_7/juniyah_take7.hcap",
                            flip: false
                        });
                        if (child.name.startsWith("ring_special_") && special < $5fbffa87c50562b9$var$special_mp3s.length) create_plane_mesh({
                            type: "special",
                            src: $5fbffa87c50562b9$var$special_mp3s[special++].path
                        });
                        if (child.name.startsWith("ring_common_") && common < $5fbffa87c50562b9$var$common_mp3s.length) create_plane_mesh({
                            type: "common",
                            src: $5fbffa87c50562b9$var$common_mp3s[common++].path
                        });
                    }
                    for (const child_plane_mesh of child_plane_meshes)child_plane_mesh.child.add(child_plane_mesh.plane_mesh);
                    const envMap = $5fbffa87c50562b9$var$load_cube_map({
                        path: "./assets/textures/dress"
                    });
                    const material = new $0147bee01cff6558$export$55cbcc9b622fe1f5({
                        envMap: envMap
                    });
                    if ($5fbffa87c50562b9$var$ar.dress_mesh) $5fbffa87c50562b9$var$ar.dress_mesh.material = material;
                    if ($5fbffa87c50562b9$var$ar.tallgrass_mesh) $5fbffa87c50562b9$var$ar.tallgrass_mesh.material = material;
                    for (const special_flower of special_flowers)special_flower.material = material;
                    $5fbffa87c50562b9$var$ar.breonna_fader = new $5fbffa87c50562b9$var$Fader({
                        mesh: $5fbffa87c50562b9$var$ar.breonna_mesh,
                        proximity_processing: false
                    });
                    const gltf_loader = new (0, $3af46d7a32572744$export$aa93f11e7884f0f4)();
                    gltf_loader.setDRACOLoader(draco_loader);
                    gltf_loader.load("./assets/models/butterflies_ar.glb", (glb)=>{
                        $5fbffa87c50562b9$var$butterflies_ar = glb.scene;
                        const clip = $0147bee01cff6558$export$d942c706bf23829c.findByName(glb, "Animation");
                        $5fbffa87c50562b9$var$butterflies_ar_mixer = new $0147bee01cff6558$export$fbd77e5aefaa0102($5fbffa87c50562b9$var$butterflies_ar);
                        const action = $5fbffa87c50562b9$var$butterflies_ar_mixer.clipAction(clip);
                        action.play();
                        $5fbffa87c50562b9$var$ar.mesh.add($5fbffa87c50562b9$var$butterflies_ar);
                        $5fbffa87c50562b9$var$ar.mesh.visible = false;
                        $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$ar.mesh);
                        const holo_loaded_interval = setInterval(()=>{
                            if ($5fbffa87c50562b9$var$ar.reticle_texture && $5fbffa87c50562b9$var$a.jun_holo.has_loaded() && $5fbffa87c50562b9$var$a.jun_holo.fader) {
                                $5fbffa87c50562b9$var$g.renderer.compile($5fbffa87c50562b9$var$g.scene, $5fbffa87c50562b9$var$g.camera);
                                args.callback();
                                clearInterval(holo_loaded_interval);
                            }
                        }, 500);
                    }, (xhr)=>{}, (error)=>{});
                }
            }, 1000);
        }, (xhr)=>{}, (error)=>{
            console.log(error.message);
        });
    };
}
class $5fbffa87c50562b9$var$d {
    static mouse_buttons = {
        none: -1,
        left: 0,
        middle: 1,
        right: 2
    };
    static start = (args)=>{
        $5fbffa87c50562b9$var$a.crosshair = new $0147bee01cff6558$export$e176487c05830cc5(new $0147bee01cff6558$export$68cb731f50f614af(.01, .005 /*0.0005, 0.001*/ ), new $0147bee01cff6558$export$55cbcc9b622fe1f5({
            color: 0xffffff,
            transparent: true,
            opacity: .3,
            side: $0147bee01cff6558$export$3b296b6f144d5b03
        }));
        $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.crosshair);
        $5fbffa87c50562b9$var$d.speed = .1;
        $5fbffa87c50562b9$var$d.moveForward = false;
        $5fbffa87c50562b9$var$d.moveBackward = false;
        $5fbffa87c50562b9$var$d.moveLeft = false;
        $5fbffa87c50562b9$var$d.moveRight = false;
        $5fbffa87c50562b9$var$d.pointer_lock_controls = new (0, $20476b744622e59b$export$e08ee79bd6cc99de)($5fbffa87c50562b9$var$g.camera, document.body);
        $5fbffa87c50562b9$var$d.pointer_lock_controls.addEventListener("lock", function() {});
        $5fbffa87c50562b9$var$d.pointer_lock_controls.addEventListener("unlock", (event)=>{
            $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.show_info);
        });
        document.addEventListener("keydown", (event)=>{
            switch(event.code){
                case "ArrowUp":
                case "KeyW":
                    $5fbffa87c50562b9$var$d.moveForward = true;
                    break;
                case "ArrowLeft":
                case "KeyA":
                    $5fbffa87c50562b9$var$d.moveLeft = true;
                    break;
                case "ArrowDown":
                case "KeyS":
                    $5fbffa87c50562b9$var$d.moveBackward = true;
                    break;
                case "ArrowRight":
                case "KeyD":
                    $5fbffa87c50562b9$var$d.moveRight = true;
                    break;
            }
        });
        document.addEventListener("keyup", (event)=>{
            switch(event.code){
                case "ArrowUp":
                case "KeyW":
                    $5fbffa87c50562b9$var$d.moveForward = false;
                    break;
                case "ArrowLeft":
                case "KeyA":
                    $5fbffa87c50562b9$var$d.moveLeft = false;
                    break;
                case "ArrowDown":
                case "KeyS":
                    $5fbffa87c50562b9$var$d.moveBackward = false;
                    break;
                case "ArrowRight":
                case "KeyD":
                    $5fbffa87c50562b9$var$d.moveRight = false;
                    break;
            }
        });
        document.addEventListener("pointerdown", (event)=>{
            $5fbffa87c50562b9$var$s.select();
        });
        $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.show_info);
    };
    static update = (args)=>{
        if (!$5fbffa87c50562b9$var$d.pointer_lock_controls.isLocked) return;
        const velocity = new $0147bee01cff6558$export$64b5c384219d3699();
        const fallback = $5fbffa87c50562b9$var$d.pointer_lock_controls.getObject().position.clone();
        if ($5fbffa87c50562b9$var$d.moveForward || $5fbffa87c50562b9$var$d.moveBackward) velocity.z = $5fbffa87c50562b9$var$d.speed * (Number($5fbffa87c50562b9$var$d.moveForward) - Number($5fbffa87c50562b9$var$d.moveBackward));
        if ($5fbffa87c50562b9$var$d.moveRight || $5fbffa87c50562b9$var$d.moveLeft) velocity.x -= $5fbffa87c50562b9$var$d.speed * (Number($5fbffa87c50562b9$var$d.moveRight) - Number($5fbffa87c50562b9$var$d.moveLeft));
        $5fbffa87c50562b9$var$d.pointer_lock_controls.moveRight(-velocity.x);
        $5fbffa87c50562b9$var$d.pointer_lock_controls.moveForward(velocity.z);
        $5fbffa87c50562b9$var$g.raycaster.set($5fbffa87c50562b9$var$d.pointer_lock_controls.getObject().position, new $0147bee01cff6558$export$64b5c384219d3699(0, -1, 0));
        const intersections = $5fbffa87c50562b9$var$g.raycaster.intersectObject($5fbffa87c50562b9$var$a.collider);
        if (intersections.length) {
            const point = intersections[0].point;
            $5fbffa87c50562b9$var$d.pointer_lock_controls.getObject().position.y = point.y + 1.75 + .1;
        } else $5fbffa87c50562b9$var$d.pointer_lock_controls.getObject().position.copy(fallback);
        $5fbffa87c50562b9$var$a.crosshair.position.copy($5fbffa87c50562b9$var$g.camera.position);
        $5fbffa87c50562b9$var$a.crosshair.rotation.copy($5fbffa87c50562b9$var$g.camera.rotation);
        $5fbffa87c50562b9$var$a.crosshair.updateMatrix();
        $5fbffa87c50562b9$var$a.crosshair.translateZ(-1.1);
    };
}
class $5fbffa87c50562b9$var$v {
    static #_ = (()=>{
        $5fbffa87c50562b9$var$v.controller1 = null;
        $5fbffa87c50562b9$var$v.controller2 = null;
    })();
    static axes = {
        x: 2,
        y: 3
    };
    static buttons = {
        index: 0,
        middle: 1,
        menu: 2,
        thumbstick: 3,
        a: 4,
        b: 5
    };
    static start = async (args)=>{
        $5fbffa87c50562b9$var$v.position = new $0147bee01cff6558$export$64b5c384219d3699();
        $5fbffa87c50562b9$var$v.use_hands = false;
        // info
        $5fbffa87c50562b9$var$info_group = new (0, $5ad5390113600fe3$export$9aa3194f2509a9b4)($5fbffa87c50562b9$var$g.renderer, $5fbffa87c50562b9$var$g.camera);
        $5fbffa87c50562b9$var$info_group.visible = false;
        $5fbffa87c50562b9$var$g.camera.add($5fbffa87c50562b9$var$info_group);
        const info_div = document.createElement("div");
        info_div.style = "width: 1024px; height: 800px;";
        document.body.appendChild(info_div);
        const info_mesh = new (0, $6a85eb725296279e$export$f537b6caa7ee8695)(info_div);
        info_mesh.position.x = .25;
        //info_mesh.position.y = 1.5
        info_mesh.position.z = -1 //-.75
        ;
        $5fbffa87c50562b9$var$info_group.add(info_mesh);
        info_div.appendChild($5fbffa87c50562b9$var$vr_info_div_2_element);
        $5fbffa87c50562b9$var$vr_info_div_2_element.style.display = "grid";
        const onSessionEnded = (args)=>{
            $5fbffa87c50562b9$var$v.currentSession.removeEventListener("end", onSessionEnded);
            $5fbffa87c50562b9$var$v.currentSession = null;
        };
        try {
            $5fbffa87c50562b9$var$v.currentSession = await navigator.xr.requestSession("immersive-vr", {
                optionalFeatures: [
                    "local-floor",
                    "bounded-floor",
                    "layers"
                ]
            });
            $5fbffa87c50562b9$var$v.currentSession.addEventListener("end", onSessionEnded);
            await $5fbffa87c50562b9$var$g.renderer.xr.setSession($5fbffa87c50562b9$var$v.currentSession);
            const controllerModelFactory = new (0, $25a186ed6a8e7fe5$export$100331f925a5e0de)();
            const buildController = (data)=>{
                let geometry, material;
                switch(data.targetRayMode){
                    case "tracked-pointer":
                        geometry = new $0147bee01cff6558$export$b7be63a67df8959();
                        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd([
                            0,
                            0,
                            0,
                            0,
                            0,
                            -1
                        ], 3));
                        geometry.setAttribute("color", new $0147bee01cff6558$export$cbe7a62641830ebd([
                            0.5,
                            0.5,
                            0.5,
                            0,
                            0,
                            0
                        ], 3));
                        material = new $0147bee01cff6558$export$fbaaa33907730a0c({
                            vertexColors: true,
                            blending: $0147bee01cff6558$export$777d8f9551c2216b
                        });
                        return new $0147bee01cff6558$export$17d680238e50603e(geometry, material);
                    case "gaze":
                        geometry = new $0147bee01cff6558$export$68cb731f50f614af(0.02, 0.04, 32).translate(0, 0, -1);
                        material = new $0147bee01cff6558$export$55cbcc9b622fe1f5({
                            opacity: 0.5,
                            transparent: true
                        });
                        return new $0147bee01cff6558$export$e176487c05830cc5(geometry, material);
                }
            };
            const onSelectEnd_1 = ()=>{
                $5fbffa87c50562b9$var$s.select({
                    controller: $5fbffa87c50562b9$var$v.controller1
                });
            };
            $5fbffa87c50562b9$var$v.controller1 = $5fbffa87c50562b9$var$g.renderer.xr.getController(0);
            $5fbffa87c50562b9$var$v.controller1.gamepad = null;
            $5fbffa87c50562b9$var$v.controller1.addEventListener("connected", (event)=>{
                $5fbffa87c50562b9$var$v.controller1.button_a_pressed = false;
                $5fbffa87c50562b9$var$v.controller1.gamepad = event.data.gamepad;
                $5fbffa87c50562b9$var$v.controller1.handedness = event.data.handedness;
                $5fbffa87c50562b9$var$v.controllerGrip1 = $5fbffa87c50562b9$var$g.renderer.xr.getControllerGrip(0);
                $5fbffa87c50562b9$var$v.controllerGrip1.add(controllerModelFactory.createControllerModel($5fbffa87c50562b9$var$v.controllerGrip1));
                $5fbffa87c50562b9$var$g.camera_group.add($5fbffa87c50562b9$var$v.controller1);
                $5fbffa87c50562b9$var$g.camera_group.add($5fbffa87c50562b9$var$v.controllerGrip1);
                $5fbffa87c50562b9$var$v.controller1.add(buildController(event.data));
                $5fbffa87c50562b9$var$v.controller1.addEventListener("selectend", onSelectEnd_1);
                $5fbffa87c50562b9$var$v.controller1.marker = new $0147bee01cff6558$export$e176487c05830cc5(new $0147bee01cff6558$export$d5c0e8d607467193(0.25, 32).rotateX(-Math.PI / 2), new $0147bee01cff6558$export$55cbcc9b622fe1f5({
                    color: 0xbcbcbc
                }));
                $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$v.controller1.marker);
            });
            const onSelectEnd_2 = ()=>{
                $5fbffa87c50562b9$var$s.select({
                    controller: $5fbffa87c50562b9$var$v.controller2
                });
            };
            $5fbffa87c50562b9$var$v.controller2 = $5fbffa87c50562b9$var$g.renderer.xr.getController(1);
            $5fbffa87c50562b9$var$v.controller2.gamepad = null;
            $5fbffa87c50562b9$var$v.controller2.addEventListener("connected", (event)=>{
                $5fbffa87c50562b9$var$v.controller2.button_a_pressed = false;
                $5fbffa87c50562b9$var$v.controller2.gamepad = event.data.gamepad;
                $5fbffa87c50562b9$var$v.controller2.handedness = event.data.handedness;
                $5fbffa87c50562b9$var$v.controllerGrip2 = $5fbffa87c50562b9$var$g.renderer.xr.getControllerGrip(1);
                $5fbffa87c50562b9$var$v.controllerGrip2.add(controllerModelFactory.createControllerModel($5fbffa87c50562b9$var$v.controllerGrip2));
                $5fbffa87c50562b9$var$g.camera_group.add($5fbffa87c50562b9$var$v.controller2);
                $5fbffa87c50562b9$var$g.camera_group.add($5fbffa87c50562b9$var$v.controllerGrip2);
                $5fbffa87c50562b9$var$v.controller2.add(buildController(event.data));
                $5fbffa87c50562b9$var$v.controller2.addEventListener("selectend", onSelectEnd_2);
                $5fbffa87c50562b9$var$v.controller2.marker = new $0147bee01cff6558$export$e176487c05830cc5(new $0147bee01cff6558$export$d5c0e8d607467193(0.25, 32).rotateX(-Math.PI / 2), new $0147bee01cff6558$export$55cbcc9b622fe1f5({
                    color: 0xbcbcbc
                }));
                $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$v.controller2.marker);
            });
        } catch (error) {
            alert(error);
        }
    };
    static update = (args)=>{
        const process_controller = (args)=>{
            if (!args.controller) return;
            if (!args.controller.gamepad) return;
            {
                $5fbffa87c50562b9$var$matrix.identity().extractRotation(args.controller.matrixWorld);
                $5fbffa87c50562b9$var$g.raycaster.ray.origin.setFromMatrixPosition(args.controller.matrixWorld);
                $5fbffa87c50562b9$var$g.raycaster.ray.direction.set(0, 0, -1).applyMatrix4($5fbffa87c50562b9$var$matrix);
                const intersections = $5fbffa87c50562b9$var$g.raycaster.intersectObject($5fbffa87c50562b9$var$a.collider);
                if (intersections.length) {
                    const point = intersections[0].point;
                    if ("marker" in args.controller) {
                        args.controller.marker.position.copy(point);
                        args.controller.marker.visible = true;
                    }
                } else if ("marker" in args.controller) args.controller.marker.visible = false;
            }
            if (!args.controller.gamepad.buttons[$5fbffa87c50562b9$var$v.buttons.a].pressed && args.controller.button_a_pressed) $5fbffa87c50562b9$var$info_group.visible = !$5fbffa87c50562b9$var$info_group.visible;
            args.controller.button_a_pressed = args.controller.gamepad.buttons[$5fbffa87c50562b9$var$v.buttons.a].pressed;
            {
                $5fbffa87c50562b9$var$v.position.copy($5fbffa87c50562b9$var$g.camera_group.position);
                const x1 = args.controller.gamepad.axes[$5fbffa87c50562b9$var$v.axes.x];
                const y1 = args.controller.gamepad.axes[$5fbffa87c50562b9$var$v.axes.y];
                $5fbffa87c50562b9$var$g.camera_group.rotation.y += -x1 / 50;
                const direction = new $0147bee01cff6558$export$64b5c384219d3699();
                $5fbffa87c50562b9$var$g.camera.getWorldDirection(direction);
                $5fbffa87c50562b9$var$v.position.sub(direction.multiplyScalar(y1 / 10));
                $5fbffa87c50562b9$var$g.raycaster.set(new $0147bee01cff6558$export$64b5c384219d3699($5fbffa87c50562b9$var$v.position.x, 1000, $5fbffa87c50562b9$var$v.position.z), new $0147bee01cff6558$export$64b5c384219d3699(0, -1, 0));
                const intersections = $5fbffa87c50562b9$var$g.raycaster.intersectObject($5fbffa87c50562b9$var$a.collider);
                if (intersections.length) {
                    const point = intersections[0].point;
                    $5fbffa87c50562b9$var$g.camera_group.position.copy(point);
                }
            }
        };
        process_controller({
            controller: $5fbffa87c50562b9$var$v.controller1
        });
        process_controller({
            controller: $5fbffa87c50562b9$var$v.controller2
        });
    };
}
class $5fbffa87c50562b9$var$s {
    static start = (args)=>{};
    static update = (args)=>{
        const now = performance.now() / 1000;
        const delta1 = $5fbffa87c50562b9$var$g.clock.getDelta();
        for (const [index, particle] of $5fbffa87c50562b9$var$a.particles.entries()){
            particle.rotation.x -= 0.00001 + index / 10000;
            particle.rotation.y += 0.0002 + index / 15000;
        }
        for (const halo_mesh of $5fbffa87c50562b9$var$a.halo_meshes){
            halo_mesh.visible = halo_mesh.position.distanceToSquared($5fbffa87c50562b9$var$g.camera_position) < halo_mesh.userData.visibility_distance * halo_mesh.userData.visibility_distance;
            if (halo_mesh.visible) halo_mesh.lookAt($5fbffa87c50562b9$var$g.camera_position);
        }
        if ($5fbffa87c50562b9$var$butterflies_mixer) $5fbffa87c50562b9$var$butterflies_mixer.update(delta1);
        if ($5fbffa87c50562b9$var$room_butterflies_mixer) $5fbffa87c50562b9$var$room_butterflies_mixer.update(delta1);
        //w.draw()
        switch($5fbffa87c50562b9$var$mode){
            case "desktop":
                $5fbffa87c50562b9$var$d.update();
                break;
            case "vr":
                $5fbffa87c50562b9$var$v.update();
                break;
        }
        if ($5fbffa87c50562b9$var$a.water_mesh != undefined) {
            $5fbffa87c50562b9$var$a.water_mesh.material.uniforms["time"].value = now / 10;
            const flower_distance = $5fbffa87c50562b9$var$a.flower.position.distanceTo($5fbffa87c50562b9$var$g.camera_position);
            const tulip_distance = $5fbffa87c50562b9$var$a.tulip.position.distanceTo($5fbffa87c50562b9$var$g.camera_position);
            const dome_distance = $5fbffa87c50562b9$var$a.dome.position.distanceTo($5fbffa87c50562b9$var$g.camera_position);
            if (flower_distance < tulip_distance && flower_distance < dome_distance) $5fbffa87c50562b9$var$a.water_mesh.position.set($5fbffa87c50562b9$var$a.flower.position.x, -0.8, $5fbffa87c50562b9$var$a.flower.position.z);
            if (tulip_distance < flower_distance && tulip_distance < dome_distance) $5fbffa87c50562b9$var$a.water_mesh.position.set($5fbffa87c50562b9$var$a.tulip.position.x, 0, $5fbffa87c50562b9$var$a.tulip.position.z);
            if (dome_distance < flower_distance && dome_distance < tulip_distance) $5fbffa87c50562b9$var$a.water_mesh.position.set($5fbffa87c50562b9$var$a.dome.position.x, 0, $5fbffa87c50562b9$var$a.dome.position.z);
        }
        $5fbffa87c50562b9$var$Swaying_material.update({
            now: now
        });
    };
    static select = (args)=>{
        if ($5fbffa87c50562b9$var$dialoging) return;
        // enter portal / play flower
        if ($5fbffa87c50562b9$var$Interactive.selected_mesh) {
            if ($5fbffa87c50562b9$var$a.portal == $5fbffa87c50562b9$var$Interactive.selected_mesh) {
                $5fbffa87c50562b9$var$g.scene = $5fbffa87c50562b9$var$g.garden_scene;
                $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$g.camera_group);
                $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.crosshair);
                $5fbffa87c50562b9$var$place_and_rotate_camera_with_collider({
                    position: $5fbffa87c50562b9$var$a.garden_teleport_spawn.position,
                    rotation: $5fbffa87c50562b9$var$a.garden_teleport_spawn.rotation,
                    collider: $5fbffa87c50562b9$var$a.garden_collider
                });
            } else if ($5fbffa87c50562b9$var$a.tulip_portal == $5fbffa87c50562b9$var$Interactive.selected_mesh) {
                $5fbffa87c50562b9$var$g.scene = $5fbffa87c50562b9$var$g.room_scene;
                $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$g.camera_group);
                $5fbffa87c50562b9$var$g.scene.add($5fbffa87c50562b9$var$a.crosshair);
                $5fbffa87c50562b9$var$place_and_rotate_camera_with_collider({
                    position: $5fbffa87c50562b9$var$a.room_spawn.position,
                    rotation: $5fbffa87c50562b9$var$a.room_spawn.rotation,
                    collider: $5fbffa87c50562b9$var$a.room_collider
                });
                setTimeout((event)=>{
                    $5fbffa87c50562b9$var$a.tamika1_holo.fader.fade_in();
                    $5fbffa87c50562b9$var$a.tamika1_holo.play();
                }, 1000);
            } else switch($5fbffa87c50562b9$var$Interactive.selected_mesh.userData.type){
                case "user":
                case "common":
                case "special":
                case "friend":
                    $5fbffa87c50562b9$var$a.jun_holo.fader.fade_out();
                    $5fbffa87c50562b9$var$a.lp_holo.fader.fade_out();
                    $5fbffa87c50562b9$var$a.ken_holo.fader.fade_out();
                    $5fbffa87c50562b9$var$Holo.stop_all();
                    if (!$5fbffa87c50562b9$var$howl_mesh) $5fbffa87c50562b9$var$music_howl.fade($5fbffa87c50562b9$var$music_howl_volume, 0, 1000);
                    $5fbffa87c50562b9$var$stop_howl();
                    $5fbffa87c50562b9$var$howl_mesh = $5fbffa87c50562b9$var$Interactive.selected_mesh;
                    if ($5fbffa87c50562b9$var$last_howl_mesh == $5fbffa87c50562b9$var$howl_mesh) {
                        if ($5fbffa87c50562b9$var$howl_interval) clearInterval($5fbffa87c50562b9$var$howl_interval);
                        $5fbffa87c50562b9$var$howl_interval = null;
                        $5fbffa87c50562b9$var$howl_mesh.material.map = $5fbffa87c50562b9$var$a.loader_empty_texture;
                        $5fbffa87c50562b9$var$howl_mesh.material.opacity = 1;
                        $5fbffa87c50562b9$var$howl_mesh = null;
                        $5fbffa87c50562b9$var$last_howl_mesh = null;
                        $5fbffa87c50562b9$var$music_howl.fade(0, $5fbffa87c50562b9$var$music_howl_volume, 1000);
                        return;
                    }
                    $5fbffa87c50562b9$var$last_howl_mesh = $5fbffa87c50562b9$var$howl_mesh;
                    $5fbffa87c50562b9$var$howl_mesh.material.map = $5fbffa87c50562b9$var$a.loader_full_texture;
                    $5fbffa87c50562b9$var$howl = new (0, $ca0c8b2242e522d2$export$b791fe48eec8032a)({
                        src: [
                            $5fbffa87c50562b9$var$howl_mesh.userData.audio_src
                        ],
                        volume: 1,
                        onplay: ()=>{
                            $5fbffa87c50562b9$var$howl_index = -1;
                            $5fbffa87c50562b9$var$howl_interval = setInterval((event)=>{
                                if (!$5fbffa87c50562b9$var$howl_mesh) return;
                                if (++$5fbffa87c50562b9$var$howl_index >= $5fbffa87c50562b9$var$a.particle_images.length) $5fbffa87c50562b9$var$howl_index = 0;
                                const progress = $5fbffa87c50562b9$var$howl.seek() / $5fbffa87c50562b9$var$howl.duration();
                                const loader_index = Math.floor($5fbffa87c50562b9$var$a.loader_images.length * progress);
                                $5fbffa87c50562b9$var$howl_mesh.material.color.setHex(-1);
                                $5fbffa87c50562b9$var$context.clearRect(0, 0, $5fbffa87c50562b9$var$canvas.width, $5fbffa87c50562b9$var$canvas.height);
                                try {
                                    $5fbffa87c50562b9$var$context.drawImage($5fbffa87c50562b9$var$a.particle_images[$5fbffa87c50562b9$var$howl_index], 0, 0);
                                    $5fbffa87c50562b9$var$context.drawImage($5fbffa87c50562b9$var$a.loader_images[loader_index], 0, 0);
                                } catch (error) {}
                                $5fbffa87c50562b9$var$howl_mesh.material.map = new $0147bee01cff6558$export$f7189e49152d1c13($5fbffa87c50562b9$var$canvas);
                                $5fbffa87c50562b9$var$howl_mesh.material.opacity += $5fbffa87c50562b9$var$howl_mesh_opacity_step;
                                if ($5fbffa87c50562b9$var$howl_mesh.material.opacity > 1) {
                                    $5fbffa87c50562b9$var$howl_mesh.material.opacity = 1;
                                    $5fbffa87c50562b9$var$howl_mesh_opacity_step = -$5fbffa87c50562b9$var$howl_mesh_opacity_step;
                                } else if ($5fbffa87c50562b9$var$howl_mesh.material.opacity < .3) {
                                    $5fbffa87c50562b9$var$howl_mesh.material.opacity = .5;
                                    $5fbffa87c50562b9$var$howl_mesh_opacity_step = -$5fbffa87c50562b9$var$howl_mesh_opacity_step;
                                }
                            }, 1000 / 30);
                        },
                        onend: ()=>{
                            if ($5fbffa87c50562b9$var$howl_interval) clearInterval($5fbffa87c50562b9$var$howl_interval);
                            $5fbffa87c50562b9$var$howl_interval = null;
                            $5fbffa87c50562b9$var$howl_mesh.material.map = $5fbffa87c50562b9$var$a.loader_empty_texture;
                            $5fbffa87c50562b9$var$howl_mesh.material.opacity = 1;
                            $5fbffa87c50562b9$var$howl_mesh = null;
                            $5fbffa87c50562b9$var$last_howl_mesh = null;
                            $5fbffa87c50562b9$var$music_howl.fade(0, $5fbffa87c50562b9$var$music_howl_volume, 1000);
                        }
                    });
                    $5fbffa87c50562b9$var$howl.seek(.25);
                    $5fbffa87c50562b9$var$howl.play();
            }
        } else // move vr camera
        if ("vr" == $5fbffa87c50562b9$var$mode) {
            if (args.controller && "marker" in args.controller && args.controller.visible) $5fbffa87c50562b9$var$g.camera_group.position.copy(args.controller.marker.position);
            else $5fbffa87c50562b9$var$g.camera_group.position.copy(args.controller.marker.position);
        }
    };
}
class $5fbffa87c50562b9$var$Fader {
    static instances = [];
    static states = {
        done: 0,
        in: 1,
        out: 2
    };
    static update(args) {
        for (const fader of $5fbffa87c50562b9$var$Fader.instances){
            if ($5fbffa87c50562b9$var$Fader.states.done != fader.state) {
                const elapsed = performance.now() - fader.start;
                let opacity = elapsed / fader.duration;
                if (opacity >= 1) {
                    switch(fader.state){
                        case $5fbffa87c50562b9$var$Fader.states.in:
                            if ("material" in fader.mesh) fader.mesh.material.opacity = 1;
                            fader.mesh.traverse((child)=>{
                                if ("material" in child) child.material.opacity = 1;
                            });
                            fader.shown_callback();
                            break;
                        case $5fbffa87c50562b9$var$Fader.states.out:
                            fader.mesh.visible = false;
                            fader.hidden_callback();
                            break;
                    }
                    fader.state = $5fbffa87c50562b9$var$Fader.states.done;
                } else {
                    if ($5fbffa87c50562b9$var$Fader.states.out == fader.state) opacity = 1 - opacity;
                    if ("material" in fader.mesh) fader.mesh.material.opacity = opacity;
                    fader.mesh.traverse((child)=>{
                        if ("material" in child) child.material.opacity = opacity;
                    });
                }
            }
            if (!fader.proximity_processing) continue;
            const now_visible = fader.mesh.position.distanceToSquared($5fbffa87c50562b9$var$g.camera_position) <= fader.distance * fader.distance;
            if (fader.before_visible != now_visible) {
                // start fading in or out
                if (now_visible) fader.fade_in();
                else fader.fade_out();
                fader.before_visible = now_visible;
                fader.mesh.visible = true;
            }
        }
    }
    constructor(args){
        this.mesh = null;
        this.distance = 5;
        this.start = 0;
        this.duration = 1000;
        this.shown_callback = ()=>{};
        this.hidden_callback = ()=>{};
        this.state = $5fbffa87c50562b9$var$Fader.states.done;
        this.proximity_processing = true;
        this.before_visible = false;
        if (args) {
            if ("proximity_processing" in args) this.proximity_processing = args.proximity_processing;
            if ("mesh" in args) {
                this.mesh = args.mesh;
                this.mesh.visible = false;
                if ("material" in this.mesh) {
                    this.mesh.material = this.mesh.material.clone();
                    this.mesh.material.transparent = true;
                    this.mesh.material.opacity = 0;
                }
                for (const child of this.mesh.children)if ("material" in child) {
                    child.material = child.material.clone();
                    child.material.transparent = true;
                    child.material.opacity = 0;
                }
            }
            if ("distance" in args) this.distance = args.distance;
            if ("duration" in args) this.duration = args.duration;
            if ("shown_callback" in args) this.shown_callback = args.shown_callback;
            if ("hidden_callback" in args) this.hidden_callback = args.hidden_callback;
        }
        $5fbffa87c50562b9$var$Fader.instances.push(this);
    }
    fade_in(args) {
        this.start = performance.now();
        this.state = $5fbffa87c50562b9$var$Fader.states.in;
        this.before_visible = false;
        this.mesh.visible = true;
        if ("material" in this.mesh) {
            this.mesh.material.opacity = 0;
            for (const child of this.mesh.children)if ("material" in child) child.material.opacity = 0;
        }
    }
    fade_out(args) {
        if (!this.mesh.visible) return;
        this.start = performance.now();
        this.state = $5fbffa87c50562b9$var$Fader.states.out;
    }
}
class $5fbffa87c50562b9$var$Interactive {
    static intersection = null;
    static selected_mesh = null;
    static instances = [];
    static interactives = [];
    static remove(item) {
        let index = $5fbffa87c50562b9$var$Interactive.instances.indexOf(item);
        if (index != -1) $5fbffa87c50562b9$var$Interactive.instances.splice(index, 1);
        index = $5fbffa87c50562b9$var$Interactive.interactives.indexOf(item);
        if (index != -1) $5fbffa87c50562b9$var$Interactive.interactives.splice(index, 1);
    }
    static update(args) {
        // billboarding
        for (const interactive of $5fbffa87c50562b9$var$Interactive.instances)if (interactive.billboard) interactive.mesh.lookAt($5fbffa87c50562b9$var$g.camera_position);
        switch($5fbffa87c50562b9$var$mode){
            case "desktop":
                {
                    $5fbffa87c50562b9$var$pointer.set(0, 0);
                    $5fbffa87c50562b9$var$g.raycaster.setFromCamera($5fbffa87c50562b9$var$pointer, $5fbffa87c50562b9$var$g.camera);
                    const intersections = $5fbffa87c50562b9$var$g.raycaster.intersectObjects($5fbffa87c50562b9$var$Interactive.interactives, false);
                    if ($5fbffa87c50562b9$var$Interactive.selected_mesh) {
                        if ($5fbffa87c50562b9$var$howl_mesh != $5fbffa87c50562b9$var$Interactive.selected_mesh) $5fbffa87c50562b9$var$Interactive.selected_mesh.material.color.setHex(-1);
                    }
                    if (intersections.length) {
                        $5fbffa87c50562b9$var$Interactive.selected_mesh = intersections[0].object;
                        if ($5fbffa87c50562b9$var$howl_mesh != $5fbffa87c50562b9$var$Interactive.selected_mesh) $5fbffa87c50562b9$var$Interactive.selected_mesh.material.color.setHex($5fbffa87c50562b9$var$a.highlight_color_number);
                    } else $5fbffa87c50562b9$var$Interactive.selected_mesh = null;
                }
                break;
            case "vr":
                if ($5fbffa87c50562b9$var$v.controller1) {
                    $5fbffa87c50562b9$var$matrix.identity().extractRotation($5fbffa87c50562b9$var$v.controller1.matrixWorld);
                    $5fbffa87c50562b9$var$g.raycaster.ray.origin.setFromMatrixPosition($5fbffa87c50562b9$var$v.controller1.matrixWorld);
                    $5fbffa87c50562b9$var$g.raycaster.ray.direction.set(0, 0, -1).applyMatrix4($5fbffa87c50562b9$var$matrix);
                    const intersections = $5fbffa87c50562b9$var$g.raycaster.intersectObjects($5fbffa87c50562b9$var$Interactive.interactives, false);
                    if ($5fbffa87c50562b9$var$Interactive.selected_mesh) {
                        if ($5fbffa87c50562b9$var$howl_mesh != $5fbffa87c50562b9$var$Interactive.selected_mesh) $5fbffa87c50562b9$var$Interactive.selected_mesh.material.color.setHex(-1);
                    }
                    if (intersections.length) {
                        $5fbffa87c50562b9$var$Interactive.selected_mesh = intersections[0].object;
                        if ($5fbffa87c50562b9$var$howl_mesh != $5fbffa87c50562b9$var$Interactive.selected_mesh) $5fbffa87c50562b9$var$Interactive.selected_mesh.material.color.setHex($5fbffa87c50562b9$var$a.highlight_color_number);
                    } else $5fbffa87c50562b9$var$Interactive.selected_mesh = null;
                }
                if ($5fbffa87c50562b9$var$v.controller2 && !$5fbffa87c50562b9$var$Interactive.selected_mesh) {
                    $5fbffa87c50562b9$var$matrix.identity().extractRotation($5fbffa87c50562b9$var$v.controller2.matrixWorld);
                    $5fbffa87c50562b9$var$g.raycaster.ray.origin.setFromMatrixPosition($5fbffa87c50562b9$var$v.controller2.matrixWorld);
                    $5fbffa87c50562b9$var$g.raycaster.ray.direction.set(0, 0, -1).applyMatrix4($5fbffa87c50562b9$var$matrix);
                    const intersections = $5fbffa87c50562b9$var$g.raycaster.intersectObjects($5fbffa87c50562b9$var$Interactive.interactives, false);
                    if ($5fbffa87c50562b9$var$Interactive.selected_mesh) {
                        if ($5fbffa87c50562b9$var$howl_mesh != $5fbffa87c50562b9$var$Interactive.selected_mesh) $5fbffa87c50562b9$var$Interactive.selected_mesh.material.color.setHex(-1);
                    }
                    if (intersections.length) {
                        $5fbffa87c50562b9$var$Interactive.selected_mesh = intersections[0].object;
                        if ($5fbffa87c50562b9$var$howl_mesh != $5fbffa87c50562b9$var$Interactive.selected_mesh) $5fbffa87c50562b9$var$Interactive.selected_mesh.material.color.setHex($5fbffa87c50562b9$var$a.highlight_color_number);
                    } else $5fbffa87c50562b9$var$Interactive.selected_mesh = null;
                }
                break;
        }
        const intersections = $5fbffa87c50562b9$var$g.raycaster.intersectObjects($5fbffa87c50562b9$var$Interactive.interactives, false);
        if ($5fbffa87c50562b9$var$Interactive.selected_mesh) {
            if ($5fbffa87c50562b9$var$howl_mesh != $5fbffa87c50562b9$var$Interactive.selected_mesh) $5fbffa87c50562b9$var$Interactive.selected_mesh.material.color.setHex(-1);
        }
        if (intersections.length) {
            $5fbffa87c50562b9$var$Interactive.selected_mesh = intersections[0].object;
            if ($5fbffa87c50562b9$var$howl_mesh != $5fbffa87c50562b9$var$Interactive.selected_mesh) $5fbffa87c50562b9$var$Interactive.selected_mesh.material.color.setHex($5fbffa87c50562b9$var$a.highlight_color_number);
        } else $5fbffa87c50562b9$var$Interactive.selected_mesh = null;
    }
    constructor(args){
        this.mesh = null;
        this.interactive = false;
        this.scene = null;
        this.start = 0;
        this.duration = 1000;
        this.fading_in = false;
        this.billboard = true;
        if (args) {
            if ("mesh" in args) {
                this.mesh = args.mesh;
                if ("material" in this.mesh) {
                    this.mesh.material = this.mesh.material.clone();
                    this.mesh.material.transparent = true;
                }
                this.mesh.traverse((child)=>{
                    if ("material" in child) {
                        child.material = child.material.clone();
                        child.material.transparent = true;
                    }
                });
            }
            if ("interactive" in args) this.interactive = args.interactive;
            if ("scene" in args) this.scene = args.scene;
            if ("billboard" in args) this.billboard = args.billboard;
        }
        //scene.add( this.mesh )
        $5fbffa87c50562b9$var$Interactive.instances.push(this);
        if (this.interactive) $5fbffa87c50562b9$var$Interactive.interactives.push(this.mesh);
    }
}
class $5fbffa87c50562b9$var$Holo {
    static states = {
        stopped: 0,
        playing: 1,
        silenced: 2,
        played: 3
    };
    static instances = [];
    static update() {
        //d_div_element.innerText = ''
        for (const holo of $5fbffa87c50562b9$var$Holo.instances){
            //d_div_element.innerText += holo.hvot.state + ' -> ' + holo.state + '\n'
            if (!holo.any_scene && holo.scene != $5fbffa87c50562b9$var$g.scene) continue;
            if (!("mesh" in holo)) continue;
            if (!holo.mesh) continue;
            holo.hvot.update();
            if ($13ab5e4789d9fbdb$export$47283907dceba392.Playing == holo.old_state) {
                if ($13ab5e4789d9fbdb$export$47283907dceba392.Playing != holo.hvot.state) {
                    holo.state = $5fbffa87c50562b9$var$Holo.states.stopped;
                    //holo.hvot.rewind()
                    holo.fader.fade_out();
                    //alert( a.jun_holo + ' , ' + holo + ' , ' + mode )
                    if ($5fbffa87c50562b9$var$a.jun_holo == holo && $5fbffa87c50562b9$var$mode === "ar") {
                        $5fbffa87c50562b9$var$jun_holo_played = true;
                        $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$instruction);
                        document.cookie = "saw_holo=yes; expires=Sat, 21 Sep 2024 12:00:00 UTC";
                        $5fbffa87c50562b9$var$show_ar_halos = true;
                    }
                    if ($5fbffa87c50562b9$var$a.tamika1_holo == holo) {
                        $5fbffa87c50562b9$var$a.tamika2_holo.fader.fade_in();
                        $5fbffa87c50562b9$var$a.tamika2_holo.play();
                    }
                }
            }
            holo.old_state = holo.hvot.state;
            //if (!holo.mesh.visible) continue
            if (holo.proximity_processing && $5fbffa87c50562b9$var$Holo.states.stopped == holo.state) {
                if (holo.mesh.position.distanceToSquared($5fbffa87c50562b9$var$g.camera_position) < 25 && holo.mesh.position.distanceToSquared($5fbffa87c50562b9$var$g.old_camera_position) > 25) holo.play();
            }
        }
    }
    static stop_all() {
        console.log("STOP ALL");
        for (const holo of $5fbffa87c50562b9$var$Holo.instances)if ("hvot" in holo) {
            holo.hvot.setAudioEnabled(false);
            holo.fader.fade_out();
        }
    }
    static loaded_all() {
        let result = true;
        for (const holo of $5fbffa87c50562b9$var$Holo.instances)if (!holo.has_loaded()) {
            result = false;
            break;
        }
        return result;
    }
    constructor(args){
        this.mesh = null;
        this.hvot = null;
        this.scene = null;
        this.state = $5fbffa87c50562b9$var$Holo.states.stopped;
        this.old_state = -1;
        this.volume = 1;
        this.fader = null;
        this.proximity_processing = true;
        this.play_start = 0;
        this.duration = 0;
        this.any_scene = false;
        this.howl = null;
        if (args) {
            if ("sound_src" in args) this.howl = new (0, $ca0c8b2242e522d2$export$b791fe48eec8032a)({
                src: [
                    args.sound_src
                ],
                loop: true,
                volume: 0,
                autoplay: true
            });
            if ("any_scene" in args) this.any_scene = args.any_scene;
            if ("duration" in args) this.duration = args.duration;
            if ("proximity_processing" in args) this.proximity_processing = args.proximity_processing;
            if ("volume" in args) this.volume = args.volume;
            if ("scene" in args) this.scene = args.scene;
            if ("hcap" in args) {
                this.hvot = new $5baf1ca6b7ed00ff$export$ca33ba2b41a58bcf($5fbffa87c50562b9$var$g.renderer, (mesh)=>{
                    if ("position" in args) mesh.position.copy(args.position);
                    if ("rotation" in args) mesh.rotation.copy(args.rotation);
                    let flip = -1;
                    if ("flip" in args) flip = args.flip ? -1 : 1;
                    mesh.scale.set(0.001, 0.001, 0.001 * flip);
                    mesh.material = new $0147bee01cff6558$export$55cbcc9b622fe1f5({
                        map: mesh.material.map
                    });
                    this.mesh = mesh;
                    if (this.scene) this.scene.add(this.mesh);
                    this.fader = new $5fbffa87c50562b9$var$Fader({
                        mesh: this.mesh,
                        proximity_processing: this.proximity_processing,
                        hidden_callback: ()=>{
                            this.mute();
                            if (this.howl) {
                                this.howl.fade(.5, 0, 1000);
                                $5fbffa87c50562b9$var$music_howl.fade(0, .25, 1000);
                            }
                        },
                        shown_callback: ()=>{
                            this.unmute();
                            $5fbffa87c50562b9$var$stop_howl();
                            if (this.howl) {
                                this.howl.fade(0, .5, 1000);
                                //this.howl.play()
                                $5fbffa87c50562b9$var$music_howl.fade(.25, 0, 1000);
                            }
                        }
                    });
                });
                let minBuffers = 2;
                if ("minBuffers" in args) minBuffers = args.minBuffers;
                this.hvot.open(args.hcap, {
                    keepAllMeshesInMemory: true,
                    minBuffers: minBuffers,
                    audioEnabled: false
                });
            }
        }
        $5fbffa87c50562b9$var$Holo.instances.push(this);
    }
    play(args) {
        switch(this.state){
            case $5fbffa87c50562b9$var$Holo.states.stopped:
                $5fbffa87c50562b9$var$stop_howl();
                this.unmute();
                this.hvot.setAudioVolume(this.volume);
                if (this.has_loaded()) {
                    //if( HVO.States.Playing != this.hvot.state ) this.hvot.rewind()
                    this.hvot.play();
                    this.play_start = performance.now();
                    this.state = $5fbffa87c50562b9$var$Holo.states.playing;
                }
                break;
        }
    }
    mute(args) {
        this.hvot.setAudioEnabled(false);
    }
    unmute(args) {
        this.hvot.setAudioEnabled(true);
    }
    has_loaded(args) {
        return this.hvot.state == $13ab5e4789d9fbdb$export$47283907dceba392.Opened || this.hvot.state == $13ab5e4789d9fbdb$export$47283907dceba392.Opening;
    }
}
class $5fbffa87c50562b9$var$Recorder {
    static recording = false;
    static recorder = null;
    static blob = null;
    static audio = null;
    static record = ()=>{
        if (!navigator.mediaDevices) {
            overlay.innerText = "Messages: Your browser cannot access your computer's microphone. " + e;
            return;
        }
        $5fbffa87c50562b9$var$Recorder.recording = true;
        navigator.mediaDevices.getUserMedia({
            "audio": true
        }).then((stream)=>{
            $5fbffa87c50562b9$var$Recorder.recorder = new MediaRecorder(stream);
            $5fbffa87c50562b9$var$Recorder.recorder.addEventListener("dataavailable", (event)=>{
                $5fbffa87c50562b9$var$Recorder.audio = new Audio();
                $5fbffa87c50562b9$var$Recorder.blob = event.data;
                $5fbffa87c50562b9$var$Recorder.audio.src = URL.createObjectURL($5fbffa87c50562b9$var$Recorder.blob);
                $5fbffa87c50562b9$var$Recorder.audio.play();
            });
            $5fbffa87c50562b9$var$Recorder.recorder.start();
        }).catch((event)=>{});
    };
    static stop = ()=>{
        $5fbffa87c50562b9$var$Recorder.recording = false;
        if ($5fbffa87c50562b9$var$Recorder.recorder) $5fbffa87c50562b9$var$Recorder.recorder.stop();
    };
    static play = ()=>{
        if ($5fbffa87c50562b9$var$Recorder.audio) $5fbffa87c50562b9$var$Recorder.audio.play();
    };
}
$5fbffa87c50562b9$var$skippable_holo = document.cookie.includes("saw_holo");
window.addEventListener("error", (event)=>{
    alert(event.lineno + " = " + event.message);
});
$5fbffa87c50562b9$var$canvas = document.createElement("canvas");
$5fbffa87c50562b9$var$canvas.width = 256;
$5fbffa87c50562b9$var$canvas.height = 256;
$5fbffa87c50562b9$var$context = $5fbffa87c50562b9$var$canvas.getContext("2d");
$5fbffa87c50562b9$var$submit_cancel_button.onclick = ()=>{
    //location.reload()
    $5fbffa87c50562b9$var$dialoging = false;
    $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$submit_message_element);
    $5fbffa87c50562b9$var$submission_modal.removeChild($5fbffa87c50562b9$var$submit_message_element);
    $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$submission_overlay);
    $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$submission_modal);
    if ($5fbffa87c50562b9$var$music_howl) $5fbffa87c50562b9$var$music_howl.fade(0, $5fbffa87c50562b9$var$music_howl_volume, 1000);
};
$5fbffa87c50562b9$var$close_iframe_modal.onclick = ()=>{
    console.log("hello");
    $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$iframe_modal);
};
$5fbffa87c50562b9$var$menu_justice_button.onclick = ()=>{
    $5fbffa87c50562b9$var$iframe_modal_content.src = "https://justiceforbreonna.org/";
    $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$iframe_modal);
};
$5fbffa87c50562b9$var$about_close_button.onclick = ()=>{
    $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.hide_about);
};
$5fbffa87c50562b9$var$credits_close_button.onclick = ()=>{
    $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.hide_credits);
};
$5fbffa87c50562b9$var$menu_learn_button.onclick = ()=>{
    $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.show_about);
};
$5fbffa87c50562b9$var$menu_credits_button.onclick = ()=>{
    $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.show_credits);
};
$5fbffa87c50562b9$var$menu_return_button.onclick = ()=>{
    $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.hide_menu);
};
$5fbffa87c50562b9$var$ar_menu_button_element.onclick = ()=>{
    if (!$5fbffa87c50562b9$var$dialoging) $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.show_menu);
};
$5fbffa87c50562b9$var$holo_skip_button.onclick = ()=>{
    // SKIP JUNIYAH HOLO
    $5fbffa87c50562b9$var$a.jun_holo.play_start = performance.now() - $5fbffa87c50562b9$var$a.jun_holo.duration;
    $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$holo_skip_button);
};
$5fbffa87c50562b9$var$ar_move_button_element.onclick = ()=>{
    $5fbffa87c50562b9$var$ar_move_button_img.src = "./assets/ar_move_downstate.svg";
    $5fbffa87c50562b9$var$Holo.stop_all();
    $5fbffa87c50562b9$var$stop_howl();
    $5fbffa87c50562b9$var$ar.mesh.visible = false;
    // delay the scan so that taps don't blend
    setTimeout((event)=>{
        $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.scan);
    }, 250);
};
$5fbffa87c50562b9$var$upload_fail_k_button_element.onclick = ()=>{
    //location.reload()
    $5fbffa87c50562b9$var$dialoging = false;
    $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$upload_fail_element);
    $5fbffa87c50562b9$var$submission_modal.removeChild($5fbffa87c50562b9$var$upload_fail_element);
    $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$submission_overlay);
    $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$submission_modal);
    $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.use_flowers);
};
$5fbffa87c50562b9$var$thanks_k_button_element.onclick = ()=>{
    //location.reload()
    $5fbffa87c50562b9$var$dialoging = false;
    $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$thank_you_element);
    $5fbffa87c50562b9$var$submission_modal.removeChild($5fbffa87c50562b9$var$thank_you_element);
    $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$submission_overlay);
    $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$submission_modal);
    $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.use_flowers);
    if ($5fbffa87c50562b9$var$music_howl) $5fbffa87c50562b9$var$music_howl.fade(0, $5fbffa87c50562b9$var$music_howl_volume, 1000);
};
// submission form validation
$5fbffa87c50562b9$var$firstname_element.addEventListener("input", (event)=>{
    $5fbffa87c50562b9$var$cloak(invalid_firstname);
    $5fbffa87c50562b9$var$firstname_element.classList.add("border-[#a10dd9]");
    $5fbffa87c50562b9$var$firstname_element.classList.remove("border-[#ff0000]");
});
$5fbffa87c50562b9$var$lastname_element.addEventListener("input", (event)=>{
    $5fbffa87c50562b9$var$cloak(invalid_lastname);
    $5fbffa87c50562b9$var$lastname_element.classList.add("border-[#a10dd9]");
    $5fbffa87c50562b9$var$lastname_element.classList.remove("border-[#ff0000]");
});
$5fbffa87c50562b9$var$email_element.addEventListener("input", (event)=>{
    $5fbffa87c50562b9$var$cloak($5fbffa87c50562b9$var$invalid_email);
    $5fbffa87c50562b9$var$email_element.classList.add("border-[#a10dd9]");
    $5fbffa87c50562b9$var$email_element.classList.remove("border-[#ff0000]");
});
const $5fbffa87c50562b9$var$validateEmail = (email)=>{
    return email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
};
const $5fbffa87c50562b9$var$invalid_email = document.getElementById("invalid_email");
const $5fbffa87c50562b9$var$form_validation = ()=>{
    let good_first = false, good_last = false, good_email = false;
    if ($5fbffa87c50562b9$var$firstname_element.value.length < 1) {
        $5fbffa87c50562b9$var$show(invalid_firstname);
        $5fbffa87c50562b9$var$firstname_element.classList.remove("border-[#a10dd9]");
        $5fbffa87c50562b9$var$firstname_element.classList.add("border-[#ff0000]");
    } else good_first = true;
    if ($5fbffa87c50562b9$var$lastname_element.value.length < 1) {
        $5fbffa87c50562b9$var$show(invalid_lastname);
        $5fbffa87c50562b9$var$lastname_element.classList.remove("border-[#a10dd9]");
        $5fbffa87c50562b9$var$lastname_element.classList.add("border-[#ff0000]");
    } else good_last = true;
    if ($5fbffa87c50562b9$var$email_element.value.length < 1 || !$5fbffa87c50562b9$var$validateEmail($5fbffa87c50562b9$var$email_element.value)) {
        $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$invalid_email);
        $5fbffa87c50562b9$var$email_element.classList.remove("border-[#a10dd9]");
        $5fbffa87c50562b9$var$email_element.classList.add("border-[#ff0000]");
    } else good_email = true;
    return good_first && good_last && good_email;
};
$5fbffa87c50562b9$var$send_button_element.onclick = ()=>{
    if ($5fbffa87c50562b9$var$form_validation()) $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.upload_message);
};
$5fbffa87c50562b9$var$vr_info_button_element.onclick = ()=>{
    $5fbffa87c50562b9$var$v.start();
};
$5fbffa87c50562b9$var$ar_record_button_element.onclick = ()=>{
    if ($5fbffa87c50562b9$var$Recorder.recording) {
        //overlay.style.display = 'none'
        $5fbffa87c50562b9$var$ar_record_button_img.src = "./assets/record_upstate.svg";
        $5fbffa87c50562b9$var$Recorder.stop();
        $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.show_form);
    } else {
        $5fbffa87c50562b9$var$Holo.stop_all();
        $5fbffa87c50562b9$var$stop_howl();
        if ($5fbffa87c50562b9$var$music_howl) $5fbffa87c50562b9$var$music_howl.fade($5fbffa87c50562b9$var$music_howl_volume, 0, 1000);
        $5fbffa87c50562b9$var$reload_ar = false;
        //currentSession.end()
        $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$instruction);
        $5fbffa87c50562b9$var$ar_record_button_img.src = "./assets/record_downstate.svg";
        $5fbffa87c50562b9$var$Recorder.record();
    }
};
const $5fbffa87c50562b9$var$load_cube_map = (args)=>{
    const files = [
        args.path + "/posX.jpg",
        args.path + "/negX.jpg",
        args.path + "/posY.jpg",
        args.path + "/negY.jpg",
        args.path + "/posZ.jpg",
        args.path + "/negZ.jpg"
    ];
    return new $0147bee01cff6558$export$2ec114afc2cf6308().load(files);
};
const $5fbffa87c50562b9$var$place_and_rotate_camera_with_collider = (args)=>{
    const camera = $5fbffa87c50562b9$var$mode == "vr" ? $5fbffa87c50562b9$var$g.camera_group : $5fbffa87c50562b9$var$g.camera;
    camera.position.copy(args.position);
    //camera.rotation.copy( args.rotation )
    $5fbffa87c50562b9$var$a.collider = args.collider;
};
const $5fbffa87c50562b9$var$start_music = (volume)=>{
    $5fbffa87c50562b9$var$music_howl_volume = volume;
    $5fbffa87c50562b9$var$music_howl = new (0, $ca0c8b2242e522d2$export$b791fe48eec8032a)({
        src: [
            "./assets/BT_BG_Music.mp3"
        ],
        autoplay: true,
        loop: true,
        volume: $5fbffa87c50562b9$var$music_howl_volume
    });
};
const $5fbffa87c50562b9$var$stop_howl = ()=>{
    if ($5fbffa87c50562b9$var$howl) $5fbffa87c50562b9$var$howl.stop();
    if ($5fbffa87c50562b9$var$howl_interval) clearInterval($5fbffa87c50562b9$var$howl_interval);
    $5fbffa87c50562b9$var$howl_interval = null;
    if ($5fbffa87c50562b9$var$howl_mesh) $5fbffa87c50562b9$var$howl_mesh.material.map = $5fbffa87c50562b9$var$a.loader_empty_texture;
    $5fbffa87c50562b9$var$howl_mesh = null;
};
const $5fbffa87c50562b9$var$pause = ()=>{
    const pause_wrapper = document.getElementById("pause_overlay");
    $5fbffa87c50562b9$var$show(pause_wrapper);
    if ($5fbffa87c50562b9$var$d.pointer_lock_controls) $5fbffa87c50562b9$var$d.pointer_lock_controls.unlock();
    $5fbffa87c50562b9$var$dialoging = true;
    setTimeout(()=>{
        $5fbffa87c50562b9$var$show(unpause_button);
    }, 1000);
    //Holo.stop_all()
    $5fbffa87c50562b9$var$stop_howl();
};
const $5fbffa87c50562b9$var$unpause = ()=>{
    const pause_wrapper = document.getElementById("pause_overlay");
    $5fbffa87c50562b9$var$hide(pause_wrapper);
    $5fbffa87c50562b9$var$cloak(unpause_button);
    $5fbffa87c50562b9$var$dialoging = false;
    if ($5fbffa87c50562b9$var$d.pointer_lock_controls) $5fbffa87c50562b9$var$d.pointer_lock_controls.lock();
};
const $5fbffa87c50562b9$var$cloak = (element)=>{
    element.classList.add("invisible");
};
const $5fbffa87c50562b9$var$hide = (element)=>{
    element.classList.add("hidden");
};
const $5fbffa87c50562b9$var$show = (element)=>{
    element.classList.remove("hidden");
    element.classList.remove("invisible");
    element.style.animation = "none";
    element.offsetHeight // ???
    ;
    element.style.animation = null;
};
const $5fbffa87c50562b9$var$setup_controls = (controls)=>{
    const pause_wrapper = document.getElementById("pause_wrapper");
    const unpause_button1 = document.getElementById("unpause_button");
    unpause_button1.onclick = ()=>{
        $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.hide_info);
    };
    /*
	if (controls === "mouse"){
		document.addEventListener('keydown', (keyEvent) => {
			if (!dialoging){
				switch (keyEvent.code){
					case 'Enter': SM.execute(SM.commands.hide_info); break
					case 'ArrowUp':
					case 'KeyW':
						Player.moveForward = true
						break
					case 'ArrowLeft':
					case 'KeyA':
						Player.moveLeft = true
						break
					case 'ArrowDown':
					case 'KeyS':
						Player.moveBackward = true
						break
					case 'ArrowRight':
					case 'KeyD':
						Player.moveRight = true
						break
				}
			}
			else {
				switch (keyEvent.code){
					case 'Escape': SM.execute(SM.commands.show_info); break
				}
			}
		});

		document.addEventListener('keyup', (keyEvent) => {
			switch (keyEvent.code){
				case 'ArrowUp':
				case 'KeyW':
					Player.moveForward = false
					break
				case 'ArrowLeft':
				case 'KeyA':
					Player.moveLeft = false
					break
				case 'ArrowDown':
				case 'KeyS':
					Player.moveBackward = false
					break
				case 'ArrowRight':
				case 'KeyD':
					Player.moveRight = false
					break
			}
		});
	}
	*/ const pause_div = document.getElementById("pause_div");
    const pause_content = pause_div.getElementsByTagName("div")[0];
    const controls_pause_content = document.getElementById(controls + "_pause_content");
    $5fbffa87c50562b9$var$pause_helper = document.getElementById(controls + "_pause_helper");
    pause_div.replaceChild(controls_pause_content, pause_content);
    $5fbffa87c50562b9$var$show(controls_pause_content);
};
class $5fbffa87c50562b9$var$SM {
    static states = {
        waiting: 0,
        loading: 1,
        showing_info: 2,
        playing: 3,
        showing_qr: 4,
        showing_about: 5,
        scanning: 6,
        placing: 7,
        using_flowers: 8,
        menuing: 9,
        recording: 10,
        showing_form: 11,
        uploading_message: 12,
        thank_you: 13,
        logo: 15,
        video: 16,
        headphones: 17,
        bad_browser: 18,
        splash: 19,
        ar_session_over: 20
    };
    static commands = {
        load: 0,
        play: 1,
        show_info: 2,
        hide_info: 3,
        show_qr: 6,
        hide_qr: 7,
        show_about: 8,
        hide_about: 9,
        scan: 10,
        place: 11,
        use_flowers: 12,
        show_form: 13,
        upload_message: 14,
        thanks: 15,
        show_menu: 16,
        hide_menu: 4,
        video: 18,
        headphones: 19,
        reject_browser: 20,
        splash: 21,
        camera_access: 22,
        show_credits: 23,
        hide_credits: 24,
        ar_session_over: 25
    };
    static state = $5fbffa87c50562b9$var$SM.states.waiting;
    static execute = (command)=>{
        switch(command){
            case $5fbffa87c50562b9$var$SM.commands.load:
                $5fbffa87c50562b9$var$SM.state = $5fbffa87c50562b9$var$SM.states.loading;
                if ("ar" == $5fbffa87c50562b9$var$mode) $5fbffa87c50562b9$var$load_ar(()=>{
                    $5fbffa87c50562b9$var$ar_loaded = true;
                });
                else {
                    const desktop_quote = document.getElementById("desktop_quote");
                    $5fbffa87c50562b9$var$show(desktop_quote);
                    $5fbffa87c50562b9$var$onboarding_content.appendChild(desktop_quote);
                    let quote_index = 0;
                    const quotes = [
                        "The Garden makes me feel like I get another opportunity to be with Breonna in person. It's like I get my sister back and we’re together again in the same setting.",
                        "Breonna's Garden centers Breonna Taylor's purpose, Breonna loved uplifting her community and bringing people together. We created The Garden to honor her life with the intention that it be a peaceful refuge, unencumbered by the weight of the world."
                    ];
                    const authors = [
                        "Ju'Niyah Palmer",
                        "Creator and Director, Lady Phe\xf8nix"
                    ];
                    const quote_text = document.getElementById("quote_text");
                    const author_text = document.getElementById("author_text");
                    const switch_quote = ()=>{
                        quote_text.innerText = quotes[quote_index];
                        author_text.innerText = `- ${authors[quote_index]}`;
                        setTimeout(()=>{
                            quote_index++;
                            if (quote_index >= quotes.length) quote_index = 0;
                            switch_quote();
                        }, 7000);
                    };
                    switch_quote();
                    $5fbffa87c50562b9$var$load_garden(()=>{
                        $5fbffa87c50562b9$var$hide(desktop_quote);
                        $5fbffa87c50562b9$var$onboarding_content.removeChild(desktop_quote);
                        $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$onboarding);
                        $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.play);
                    });
                }
                break;
            case $5fbffa87c50562b9$var$SM.commands.play:
                $5fbffa87c50562b9$var$SM.state = $5fbffa87c50562b9$var$SM.states.playing;
                $5fbffa87c50562b9$var$start_scene();
                break;
            case $5fbffa87c50562b9$var$SM.commands.show_info:
                if ($5fbffa87c50562b9$var$SM.state == $5fbffa87c50562b9$var$SM.states.playing) {
                    $5fbffa87c50562b9$var$pause();
                    $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$pause_helper);
                    $5fbffa87c50562b9$var$SM.state = $5fbffa87c50562b9$var$SM.states.showing_info;
                }
                break;
            case $5fbffa87c50562b9$var$SM.commands.hide_info:
                if ($5fbffa87c50562b9$var$SM.state == $5fbffa87c50562b9$var$SM.states.showing_info) {
                    $5fbffa87c50562b9$var$unpause();
                    $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$pause_helper);
                    $5fbffa87c50562b9$var$SM.state = $5fbffa87c50562b9$var$SM.states.playing;
                }
                break;
            case $5fbffa87c50562b9$var$SM.commands.show_qr:
                $5fbffa87c50562b9$var$SM.state = $5fbffa87c50562b9$var$SM.states.showing_qr;
                $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$qr_div_element);
                break;
            case $5fbffa87c50562b9$var$SM.commands.hide_qr:
                $5fbffa87c50562b9$var$SM.state = $5fbffa87c50562b9$var$SM.states.splash;
                $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$qr_div_element);
                $5fbffa87c50562b9$var$cloak($5fbffa87c50562b9$var$qr_copied);
                break;
            case $5fbffa87c50562b9$var$SM.commands.show_about:
                $5fbffa87c50562b9$var$about_close_button_img.src = "./assets/close_upstate.svg";
                $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$phone_about);
                setTimeout(()=>{
                    $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$phone_menu);
                }, 800);
                break;
            case $5fbffa87c50562b9$var$SM.commands.hide_about:
                $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$phone_menu);
                $5fbffa87c50562b9$var$about_close_button_img.src = "./assets/close_downstate.svg";
                setTimeout(()=>{
                    $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$phone_about);
                }, 800);
                break;
            case $5fbffa87c50562b9$var$SM.commands.show_credits:
                $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$phone_credits);
                $5fbffa87c50562b9$var$credits_close_button_img.src = "./assets/close_upstate.svg";
                setTimeout(()=>{
                    $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$phone_menu);
                }, 800);
                break;
            case $5fbffa87c50562b9$var$SM.commands.hide_credits:
                $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$phone_menu);
                $5fbffa87c50562b9$var$credits_close_button_img.src = "./assets/close_downstate.svg";
                setTimeout(()=>{
                    $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$phone_credits);
                }, 800);
                break;
            case $5fbffa87c50562b9$var$SM.commands.show_menu:
                $5fbffa87c50562b9$var$ar_menu_button_img.src = "./assets/ar_menu_downstate.svg";
                $5fbffa87c50562b9$var$Holo.stop_all();
                $5fbffa87c50562b9$var$stop_howl();
                $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$use_flowers_div_element);
                $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$phone_menu);
                break;
            case $5fbffa87c50562b9$var$SM.commands.hide_menu:
                $5fbffa87c50562b9$var$ar_menu_button_img.src = "./assets/ar_menu_upstate.svg";
                $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$phone_menu);
                $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$use_flowers_div_element);
                if (!$5fbffa87c50562b9$var$jun_holo_played) setTimeout((event)=>{
                    $5fbffa87c50562b9$var$a.jun_holo.fader.fade_in();
                    $5fbffa87c50562b9$var$a.jun_holo.play();
                }, 500);
                break;
            case $5fbffa87c50562b9$var$SM.commands.scan:
                $5fbffa87c50562b9$var$ar_move_button_img.src = "./assets/ar_move_upstate.svg";
                $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$move_phone_div_element);
                $5fbffa87c50562b9$var$SM.state = $5fbffa87c50562b9$var$SM.states.scanning;
                break;
            case $5fbffa87c50562b9$var$SM.commands.place:
                $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$move_phone_image_element);
                $5fbffa87c50562b9$var$move_phone_slider_element.innerHTML = "Tap on the ground to<br />position Breonna's Garden";
                $5fbffa87c50562b9$var$SM.state = $5fbffa87c50562b9$var$SM.states.placing;
                break;
            case $5fbffa87c50562b9$var$SM.commands.use_flowers:
                $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$move_phone_div_element);
                $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$use_flowers_div_element);
                $5fbffa87c50562b9$var$SM.state = $5fbffa87c50562b9$var$SM.states.using_flowers;
                break;
            case $5fbffa87c50562b9$var$SM.commands.show_form:
                $5fbffa87c50562b9$var$dialoging = true;
                $5fbffa87c50562b9$var$firstname_element.value = "";
                $5fbffa87c50562b9$var$lastname_element.value = "";
                $5fbffa87c50562b9$var$email_element.value = "";
                $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$submission_overlay);
                $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$submission_modal);
                $5fbffa87c50562b9$var$submission_modal.appendChild($5fbffa87c50562b9$var$submit_message_element);
                $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$submit_message_element);
                $5fbffa87c50562b9$var$SM.state = $5fbffa87c50562b9$var$SM.states.showing_form;
                break;
            case $5fbffa87c50562b9$var$SM.commands.upload_message:
                $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$submit_message_element);
                $5fbffa87c50562b9$var$submission_modal.removeChild($5fbffa87c50562b9$var$submit_message_element);
                $5fbffa87c50562b9$var$submission_modal.appendChild($5fbffa87c50562b9$var$uploading_message_element);
                $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$uploading_message_element);
                $5fbffa87c50562b9$var$SM.state = $5fbffa87c50562b9$var$SM.states.uploading_message;
                $5fbffa87c50562b9$var$upload();
                break;
            case $5fbffa87c50562b9$var$SM.commands.thanks:
                $5fbffa87c50562b9$var$submission_modal.appendChild($5fbffa87c50562b9$var$thank_you_element);
                $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$thank_you_element);
                $5fbffa87c50562b9$var$SM.state = $5fbffa87c50562b9$var$SM.states.thank_you;
                break;
            case $5fbffa87c50562b9$var$SM.commands.camera_access:
                {
                    const ar_camera = document.getElementById("ar_camera");
                    $5fbffa87c50562b9$var$show(ar_camera);
                    $5fbffa87c50562b9$var$onboarding_content.appendChild(ar_camera);
                    const ar_camera_begin = document.getElementById("ar_camera_begin");
                    ar_camera_begin.onclick = ()=>{
                        $5fbffa87c50562b9$var$hide(ar_camera);
                        $5fbffa87c50562b9$var$onboarding_content.removeChild(ar_camera);
                        $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$onboarding);
                        $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.play);
                    };
                }
                break;
            case $5fbffa87c50562b9$var$SM.commands.logo:
                {
                    const ar_quote = document.getElementById("ar_quote");
                    $5fbffa87c50562b9$var$show(ar_quote);
                    $5fbffa87c50562b9$var$onboarding_content.appendChild(ar_quote);
                    const start_load = ()=>{
                        $5fbffa87c50562b9$var$video_element.src = "./assets/textures/Breonnaintro_JakeSml2.mp4";
                        $5fbffa87c50562b9$var$video_element.onloadeddata = ()=>{
                            console.log("video loaded");
                            $5fbffa87c50562b9$var$video_loaded = true;
                        };
                        $5fbffa87c50562b9$var$video_element.load();
                        $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.load);
                    };
                    start_load();
                    setTimeout((event)=>{
                        const video_loaded_interval = setInterval(()=>{
                            if ($5fbffa87c50562b9$var$video_loaded) {
                                $5fbffa87c50562b9$var$hide(ar_quote);
                                $5fbffa87c50562b9$var$onboarding_content.removeChild(ar_quote);
                                $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.headphones);
                                clearInterval(video_loaded_interval);
                            }
                        }, 500);
                    }, 2500);
                }
                break;
            case $5fbffa87c50562b9$var$SM.commands.video:
                {
                    $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$onboarding);
                    $5fbffa87c50562b9$var$video_element.play();
                    $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$video_div_element);
                    $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$skip_button_element);
                    const finish_video = ()=>{
                        console.log("video finished, ar_loaded: " + $5fbffa87c50562b9$var$ar_loaded);
                        $5fbffa87c50562b9$var$video_element.pause();
                        $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$video_div_element);
                        $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$onboarding);
                        if ($5fbffa87c50562b9$var$ar_loaded) $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.camera_access);
                        else {
                            const check_load_interval = setIntervawl(()=>{
                                console.log("video finished, ar_loaded: " + $5fbffa87c50562b9$var$ar_loaded);
                                if ($5fbffa87c50562b9$var$ar_loaded) {
                                    $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.camera_access);
                                    clearInterval(check_load_interval);
                                }
                            }, 500);
                        }
                    };
                    const ar_ready = ()=>{
                        $5fbffa87c50562b9$var$skip_button_element.innerText = "SKIP";
                        $5fbffa87c50562b9$var$skip_button_element.style.color = "#ffffff";
                        $5fbffa87c50562b9$var$skip_button_element.onclick = finish_video;
                    };
                    if ($5fbffa87c50562b9$var$ar_loaded) ar_ready();
                    else {
                        const check_load_interval = setInterval(()=>{
                            console.log("video playing, ar_loaded: " + $5fbffa87c50562b9$var$ar_loaded);
                            if ($5fbffa87c50562b9$var$ar_loaded) {
                                ar_ready();
                                clearInterval(check_load_interval);
                            }
                        }, 500);
                    }
                    $5fbffa87c50562b9$var$video_element.onended = finish_video;
                }
                break;
            case $5fbffa87c50562b9$var$SM.commands.headphones:
                {
                    const ar_headphones = document.getElementById("ar_headphones");
                    $5fbffa87c50562b9$var$show(ar_headphones);
                    $5fbffa87c50562b9$var$onboarding_content.appendChild(ar_headphones);
                    const ar_headphones_ok = document.getElementById("ar_headphones_ok");
                    ar_headphones_ok.onclick = ()=>{
                        $5fbffa87c50562b9$var$hide(ar_headphones);
                        $5fbffa87c50562b9$var$onboarding_content.removeChild(ar_headphones);
                        $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.video);
                    };
                    $5fbffa87c50562b9$var$SM.state = $5fbffa87c50562b9$var$SM.states.headphones;
                }
                break;
            case $5fbffa87c50562b9$var$SM.commands.reject_browser:
                {
                    $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$background_image);
                    $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$stems_element);
                    const ar_bad_browser = document.getElementById("ar_bad_browser");
                    $5fbffa87c50562b9$var$show(ar_bad_browser);
                    $5fbffa87c50562b9$var$onboarding_content.appendChild(ar_bad_browser);
                    $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$onboarding);
                    const ar_bad_browser_copy_button = document.getElementById("ar_bad_browser_copy_button");
                    const ar_bad_browser_copied = document.getElementById("ar_bad_browser_copied");
                    ar_bad_browser_copy_button.onclick = ()=>{
                        $5fbffa87c50562b9$var$show(ar_bad_browser_copied);
                        navigator.clipboard.writeText("https://play.eyejack.xyz/c/bg");
                    };
                    $5fbffa87c50562b9$var$SM.state = $5fbffa87c50562b9$var$SM.states.bad_browser;
                }
                break;
            case $5fbffa87c50562b9$var$SM.commands.splash:
                {
                    $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$background_image);
                    $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$stems_element);
                    const splash = document.getElementById("splash");
                    const splash_continue = document.getElementById("splash_continue");
                    const splash_play_ar = document.getElementById("splash_play_ar");
                    const splash_about = document.getElementById("splash_about");
                    $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$onboarding);
                    $5fbffa87c50562b9$var$show(splash);
                    $5fbffa87c50562b9$var$onboarding_content.appendChild(splash);
                    splash_continue.addEventListener("click", ()=>{
                        $5fbffa87c50562b9$var$hide(splash);
                        $5fbffa87c50562b9$var$onboarding_content.removeChild(splash);
                    });
                    // splash_about.addEventListener("click", () => {
                    // 	show(about_div_element)
                    // })
                    splash_about.onclick = ()=>{
                        $5fbffa87c50562b9$var$iframe_modal_content.src = "https://breonnas.garden/";
                        $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$iframe_modal);
                    };
                    if ($5fbffa87c50562b9$var$mode === "ar" || $5fbffa87c50562b9$var$mode === "vr") {
                        $5fbffa87c50562b9$var$hide(splash_play_ar);
                        splash_about.classList.add("mr-auto");
                    }
                    if ($5fbffa87c50562b9$var$mode === "ar") splash_continue.addEventListener("click", ()=>{
                        $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.logo);
                    });
                    else {
                        splash_continue.onclick = ()=>{
                            $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.hide_qr);
                            $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.load);
                        };
                        splash_play_ar.addEventListener("click", ()=>{
                            $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.show_qr);
                        });
                        $5fbffa87c50562b9$var$qr_copy_button.addEventListener("click", ()=>{
                            $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$qr_copied);
                            var ar_link = "play.eyejack.xyz/c/bg";
                            var entry_id = new URLSearchParams(window.location.search).get("id");
                            if (entry_id) ar_link += "?id=" + entry_id;
                            navigator.clipboard.writeText(ar_link);
                        });
                        $5fbffa87c50562b9$var$close_qr_button_element.addEventListener("click", ()=>{
                            $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.hide_qr);
                        });
                    }
                    $5fbffa87c50562b9$var$SM.state = $5fbffa87c50562b9$var$SM.states.splash;
                }
                break;
            case $5fbffa87c50562b9$var$SM.commands.ar_session_over:
                //const ar_session_over = document.getElementById( "ar_session_over" )
                $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$ar_session_over_element);
                /*
				//onboarding_content.appendChild( ar_session_over_element )
				const ar_session_over_ok_element = document.getElementById( "ar_session_over_ok" )

				ar_session_over_ok_element.onclick = () => {
					hide( ar_session_over_element )
					//onboarding_content.removeChild( ar_session_over_element )
					SM.execute( SM.commands.play )
				}
				*/ $5fbffa87c50562b9$var$SM.state = $5fbffa87c50562b9$var$SM.states.ar_session_over;
                break;
        }
    };
}
const $5fbffa87c50562b9$var$load_garden = (callback)=>{
    $5fbffa87c50562b9$var$g.start();
    //w.start()
    $5fbffa87c50562b9$var$s.start();
    $5fbffa87c50562b9$var$a.start(callback);
};
const $5fbffa87c50562b9$var$load_ar = (callback)=>{
    $5fbffa87c50562b9$var$ar.start({
        callback: callback
    });
};
const $5fbffa87c50562b9$var$start_ar_scene = async ()=>{
    $5fbffa87c50562b9$var$start_music($5fbffa87c50562b9$var$music_howl_volume * .3);
    $5fbffa87c50562b9$var$g.renderer.xr.enabled = true;
    document.body.appendChild($5fbffa87c50562b9$var$g.renderer.domElement);
    const overlay1 = document.createElement("div");
    overlay1.style.display = "none";
    overlay1.classList.add("w-full");
    overlay1.classList.add("h-full");
    document.body.appendChild(overlay1);
    overlay1.appendChild($5fbffa87c50562b9$var$move_phone_div_element);
    overlay1.appendChild($5fbffa87c50562b9$var$use_flowers_div_element);
    // xxx if ( skippable_holo ) {
    $5fbffa87c50562b9$var$use_flowers_div_element.appendChild($5fbffa87c50562b9$var$holo_skip_button);
    //holo_skip_button.style.display = 'grid'
    //}
    overlay1.appendChild($5fbffa87c50562b9$var$submit_message_element);
    overlay1.appendChild($5fbffa87c50562b9$var$uploading_message_element);
    overlay1.appendChild($5fbffa87c50562b9$var$thank_you_element);
    overlay1.appendChild($5fbffa87c50562b9$var$submission_modal);
    overlay1.appendChild($5fbffa87c50562b9$var$upload_fail_element);
    overlay1.appendChild($5fbffa87c50562b9$var$ar_session_over_element);
    overlay1.appendChild($5fbffa87c50562b9$var$iframe_modal);
    overlay1.appendChild($5fbffa87c50562b9$var$phone_credits);
    overlay1.appendChild($5fbffa87c50562b9$var$phone_about);
    overlay1.appendChild($5fbffa87c50562b9$var$phone_menu);
    //window.onerror = (event, source, lineno, colno, error) => { overlay.innerText += '_____' + lineno + ' = ' + error + ' @ ' + source }
    $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.scan);
    const onSessionEnded = ()=>{
        document.body.removeChild($5fbffa87c50562b9$var$g.renderer.domElement);
        $5fbffa87c50562b9$var$g.renderer.setAnimationLoop(null);
        $5fbffa87c50562b9$var$currentSession.removeEventListener("end", onSessionEnded);
        //overlay.style.display = 'none'
        //overlay.innerHTML = ''
        $5fbffa87c50562b9$var$currentSession = null;
        if ($5fbffa87c50562b9$var$reload_ar) location.reload();
    };
    async function onSessionStarted(session) {
        $5fbffa87c50562b9$var$currentSession = session;
        session.addEventListener("end", onSessionEnded);
        $5fbffa87c50562b9$var$g.renderer.xr.setReferenceSpaceType("local");
        await $5fbffa87c50562b9$var$g.renderer.xr.setSession(session);
        overlay1.style.display = "";
    }
    try {
        navigator.xr.requestSession("immersive-ar", {
            requiredFeatures: [
                "hit-test"
            ],
            optionalFeatures: [
                "dom-overlay"
            ],
            domOverlay: {
                root: overlay1
            }
        }).then(onSessionStarted);
    } catch (error) {
        $5fbffa87c50562b9$var$hide(overlay1);
        $5fbffa87c50562b9$var$show(document.getElementById("ar_bad_browser_text_chrome"));
        $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.reject_browser);
        return;
    }
    function intersectObjects(controller1) {
        if (controller1.userData.targetRayMode === "screen") return;
        // Do not highlight when already selected
        if (controller1.userData.selected !== undefined) return;
        const line = controller1.getObjectByName("line");
        const intersections = getIntersections(controller1);
        if (intersections.length) {
            const intersection = intersections[0];
            const object = intersection.object;
            intersected.push(object);
            line.scale.z = intersection.distance;
        } else line.scale.z = 5;
    }
    function getIntersections(controller1) {
        controller1.updateMatrixWorld();
        $5fbffa87c50562b9$var$tempMatrix.identity().extractRotation(controller1.matrixWorld);
        $5fbffa87c50562b9$var$g.raycaster.ray.origin.setFromMatrixPosition(controller1.matrixWorld);
        $5fbffa87c50562b9$var$g.raycaster.ray.direction.set(0, 0, -1).applyMatrix4($5fbffa87c50562b9$var$tempMatrix);
        return $5fbffa87c50562b9$var$g.raycaster.intersectObjects($5fbffa87c50562b9$var$ar_loader_rings, true);
    }
    function onSelectStart(event) {
        if ($5fbffa87c50562b9$var$dialoging) return;
        if (!$5fbffa87c50562b9$var$ar.mesh.visible) {
            if (reticle.visible) {
                reticle.matrix.decompose($5fbffa87c50562b9$var$ar.mesh.position, $5fbffa87c50562b9$var$ar.mesh.quaternion, $5fbffa87c50562b9$var$ar.mesh.scale);
                $5fbffa87c50562b9$var$ar.mesh.visible = true;
                $5fbffa87c50562b9$var$ar.breonna_fader.fade_in();
                if (!$5fbffa87c50562b9$var$jun_holo_played) setTimeout((event)=>{
                    $5fbffa87c50562b9$var$a.jun_holo.fader.fade_in();
                    $5fbffa87c50562b9$var$a.jun_holo.play();
                }, 500);
                $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.use_flowers);
            }
        } else if ($5fbffa87c50562b9$var$jun_holo_played) {
            const controller1 = event.target;
            const intersections = getIntersections(controller1);
            if (intersections.length) {
                const intersection = intersections[0];
                const object = intersection.object;
                controller1.userData.selected = object;
                $5fbffa87c50562b9$var$instruction.innerHTML = "Record a message for a loved one <br /> or Breonna’s family.<br />Tap to record, and again to finish.";
                $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$ar_record_button_element);
                //if (!howl_mesh) music_howl.fade(music_howl_volume, music_howl_volume * .2, 1000)
                ///xxxif (!howl_mesh) music_howl.fade(music_howl_volume, 0, 1000)
                $5fbffa87c50562b9$var$stop_howl();
                $5fbffa87c50562b9$var$howl_mesh = object;
                if ($5fbffa87c50562b9$var$last_howl_mesh == $5fbffa87c50562b9$var$howl_mesh) {
                    if ($5fbffa87c50562b9$var$howl_interval) clearInterval($5fbffa87c50562b9$var$howl_interval);
                    $5fbffa87c50562b9$var$howl_interval = null;
                    $5fbffa87c50562b9$var$howl_mesh.material.map = $5fbffa87c50562b9$var$a.loader_empty_texture;
                    $5fbffa87c50562b9$var$howl_mesh.material.opacity = 1;
                    $5fbffa87c50562b9$var$howl_mesh = null;
                    $5fbffa87c50562b9$var$last_howl_mesh = null;
                    $5fbffa87c50562b9$var$music_howl.fade(0, $5fbffa87c50562b9$var$music_howl_volume, 1000);
                    return;
                }
                $5fbffa87c50562b9$var$last_howl_mesh = $5fbffa87c50562b9$var$howl_mesh;
                $5fbffa87c50562b9$var$howl_mesh.material.map = $5fbffa87c50562b9$var$a.loader_full_texture;
                $5fbffa87c50562b9$var$howl = new (0, $ca0c8b2242e522d2$export$b791fe48eec8032a)({
                    src: [
                        object.userData.src
                    ],
                    volume: 1,
                    onplay: ()=>{
                        if ($5fbffa87c50562b9$var$howl_mesh) $5fbffa87c50562b9$var$howl_mesh.material.map = $5fbffa87c50562b9$var$a.loader_empty_texture;
                        $5fbffa87c50562b9$var$howl_index = -1;
                        $5fbffa87c50562b9$var$howl_interval = setInterval((event)=>{
                            if (++$5fbffa87c50562b9$var$howl_index >= $5fbffa87c50562b9$var$a.particle_images.length) $5fbffa87c50562b9$var$howl_index = 0;
                            const progress = $5fbffa87c50562b9$var$howl.seek() / $5fbffa87c50562b9$var$howl.duration();
                            const loader_index = Math.floor($5fbffa87c50562b9$var$a.loader_images.length * progress);
                            $5fbffa87c50562b9$var$context.clearRect(0, 0, $5fbffa87c50562b9$var$canvas.width, $5fbffa87c50562b9$var$canvas.height);
                            try {
                                $5fbffa87c50562b9$var$context.drawImage($5fbffa87c50562b9$var$a.particle_images[$5fbffa87c50562b9$var$howl_index], 0, 0);
                                $5fbffa87c50562b9$var$context.drawImage($5fbffa87c50562b9$var$a.loader_images[loader_index], 0, 0);
                            } catch (error) {}
                            if ($5fbffa87c50562b9$var$howl_mesh) {
                                $5fbffa87c50562b9$var$howl_mesh.material.map = new $0147bee01cff6558$export$f7189e49152d1c13($5fbffa87c50562b9$var$canvas);
                                $5fbffa87c50562b9$var$howl_mesh.material.opacity += $5fbffa87c50562b9$var$howl_mesh_opacity_step;
                                if ($5fbffa87c50562b9$var$howl_mesh.material.opacity > 1) {
                                    $5fbffa87c50562b9$var$howl_mesh.material.opacity = 1;
                                    $5fbffa87c50562b9$var$howl_mesh_opacity_step = -$5fbffa87c50562b9$var$howl_mesh_opacity_step;
                                } else if ($5fbffa87c50562b9$var$howl_mesh.material.opacity < .3) {
                                    $5fbffa87c50562b9$var$howl_mesh.material.opacity = .5;
                                    $5fbffa87c50562b9$var$howl_mesh_opacity_step = -$5fbffa87c50562b9$var$howl_mesh_opacity_step;
                                }
                            }
                        }, 1000 / 30);
                    },
                    onend: ()=>{
                        if ($5fbffa87c50562b9$var$howl_interval) clearInterval($5fbffa87c50562b9$var$howl_interval);
                        $5fbffa87c50562b9$var$howl_interval = null;
                        if ($5fbffa87c50562b9$var$howl_mesh) {
                            $5fbffa87c50562b9$var$howl_mesh.material.map = $5fbffa87c50562b9$var$a.loader_empty_texture;
                            $5fbffa87c50562b9$var$howl_mesh.material.opacity = 1;
                            $5fbffa87c50562b9$var$howl_mesh = null;
                        }
                        $5fbffa87c50562b9$var$music_howl.fade($5fbffa87c50562b9$var$music_howl_volume * .2, $5fbffa87c50562b9$var$music_howl_volume, 1000);
                    }
                });
                $5fbffa87c50562b9$var$howl.seek(.25);
                $5fbffa87c50562b9$var$howl.play();
            }
            controller1.userData.targetRayMode = event.data.targetRayMode;
        }
    }
    controller = $5fbffa87c50562b9$var$g.renderer.xr.getController(0);
    controller.addEventListener("selectstart", onSelectStart);
    $5fbffa87c50562b9$var$g.scene.add(controller);
    const plane_geometry = new $0147bee01cff6558$export$967d831af31f69ce(2, 2);
    plane_geometry.rotateX(-Math.PI / 2);
    reticle = new $0147bee01cff6558$export$e176487c05830cc5(plane_geometry, new $0147bee01cff6558$export$55cbcc9b622fe1f5({
        map: $5fbffa87c50562b9$var$ar.reticle_texture,
        transparent: true
    }));
    reticle.matrixAutoUpdate = false;
    reticle.visible = false;
    $5fbffa87c50562b9$var$g.scene.add(reticle);
    function render(timestamp, frame) {
        if (frame) {
            const referenceSpace = $5fbffa87c50562b9$var$g.renderer.xr.getReferenceSpace();
            const session = $5fbffa87c50562b9$var$g.renderer.xr.getSession();
            if ($5fbffa87c50562b9$var$hitTestSourceRequested === false) {
                session.requestReferenceSpace("viewer").then(function(referenceSpace) {
                    session.requestHitTestSource({
                        space: referenceSpace
                    }).then(function(source) {
                        $5fbffa87c50562b9$var$hitTestSource = source;
                    });
                });
                session.addEventListener("end", function() {
                    $5fbffa87c50562b9$var$hitTestSourceRequested = false;
                    $5fbffa87c50562b9$var$hitTestSource = null;
                });
                $5fbffa87c50562b9$var$hitTestSourceRequested = true;
            }
            if ($5fbffa87c50562b9$var$hitTestSource) {
                const hitTestResults = frame.getHitTestResults($5fbffa87c50562b9$var$hitTestSource);
                if (hitTestResults.length) {
                    if ($5fbffa87c50562b9$var$SM.states.scanning == $5fbffa87c50562b9$var$SM.state) $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.place);
                    const hit = hitTestResults[0];
                    reticle.visible = $5fbffa87c50562b9$var$SM.states.placing == $5fbffa87c50562b9$var$SM.state;
                    reticle.matrix.fromArray(hit.getPose(referenceSpace).transform.matrix);
                } else reticle.visible = false;
            }
        }
        delta = $5fbffa87c50562b9$var$g.clock.getDelta();
        if ($5fbffa87c50562b9$var$butterflies_ar_mixer) $5fbffa87c50562b9$var$butterflies_ar_mixer.update(delta);
        $5fbffa87c50562b9$var$Fader.update();
        $5fbffa87c50562b9$var$Holo.update();
        for (const ar_loader_ring of $5fbffa87c50562b9$var$ar_loader_rings)if ($5fbffa87c50562b9$var$show_ar_halos) ar_loader_ring.lookAt($5fbffa87c50562b9$var$g.camera.position);
        else ar_loader_ring.rotation.copy($5fbffa87c50562b9$var$g.camera.rotation);
        $5fbffa87c50562b9$var$g.renderer.render($5fbffa87c50562b9$var$g.scene, $5fbffa87c50562b9$var$g.camera);
    }
    $5fbffa87c50562b9$var$g.renderer.setAnimationLoop(render);
};
const $5fbffa87c50562b9$var$start_scene = ()=>{
    $5fbffa87c50562b9$var$start_music($5fbffa87c50562b9$var$music_howl_volume);
    switch($5fbffa87c50562b9$var$mode){
        case "desktop":
            $5fbffa87c50562b9$var$d.start();
            break;
        case "vr":
            $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$vr_info_div_element);
            break;
        case "ar":
            $5fbffa87c50562b9$var$start_ar_scene();
            break;
    }
};
const $5fbffa87c50562b9$var$webm_to_mp3 = (blobWebm, callback)=>{
    const audioBufferToMp3 = (audioBuffer)=>{
        const numberOfChannels = audioBuffer.numberOfChannels;
        const channelData = [];
        for(let i = 0; i < numberOfChannels; ++i)channelData.push(audioBuffer.getChannelData(i));
        const mp3Data = (0, $471e05f612aa773e$exports.simpleMp3)({
            channelData: channelData,
            sampleRate: audioBuffer.sampleRate
        }, (progress)=>{});
        const blobMp3 = new window.Blob(mp3Data, {
            type: "audio/mpeg"
        });
        return blobMp3;
    };
    const fileReader = new FileReader();
    fileReader.onloadend = ()=>{
        const arrayBuffer = fileReader.result;
        const audioContext = new AudioContext();
        audioContext.decodeAudioData(arrayBuffer, (audioBuffer)=>{
            const blobMp3 = audioBufferToMp3(audioBuffer);
            callback(blobMp3);
        });
    };
    try {
        fileReader.readAsArrayBuffer(blobWebm);
    } catch  {
        callback(undefined);
    }
};
const $5fbffa87c50562b9$var$upload = ()=>{
    const msgData = {
        entryData: {
            firstname: $5fbffa87c50562b9$var$firstname_element.value,
            lastname: $5fbffa87c50562b9$var$lastname_element.value,
            email: $5fbffa87c50562b9$var$email_element.value
        }
    };
    const data = JSON.stringify(msgData);
    const path = $5fbffa87c50562b9$var$post_submit + "?key=" + $5fbffa87c50562b9$var$APIKEY;
    let failed = false;
    const fail_upload = ()=>{
        if (!failed) {
            $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$uploading_message_element);
            $5fbffa87c50562b9$var$submission_modal.removeChild($5fbffa87c50562b9$var$uploading_message_element);
            $5fbffa87c50562b9$var$submission_modal.appendChild($5fbffa87c50562b9$var$upload_fail_element);
            $5fbffa87c50562b9$var$show($5fbffa87c50562b9$var$upload_fail_element);
            if ($5fbffa87c50562b9$var$music_howl) $5fbffa87c50562b9$var$music_howl.fade(0, $5fbffa87c50562b9$var$music_howl_volume, 1000);
            failed = true;
        }
    };
    fetch(path, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: data
    }).then((result)=>{
        if (result.ok) {
            const json = result.clone().json();
            return json;
        } else fail_upload();
    }).then((result)=>{
        $5fbffa87c50562b9$var$webm_to_mp3($5fbffa87c50562b9$var$Recorder.blob, (mp3_blob)=>{
            if (!$5fbffa87c50562b9$var$dialoging) ;
            else if (!mp3_blob || !result) fail_upload();
            else {
                const formData = new FormData();
                formData.append("data", mp3_blob);
                const path = result.uploadUrl;
                fetch(path, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "audio/mpeg"
                    },
                    body: formData
                }).then((result)=>{
                    if (result.ok && result.statusText && result.statusText == "OK") {
                        $5fbffa87c50562b9$var$hide($5fbffa87c50562b9$var$uploading_message_element);
                        $5fbffa87c50562b9$var$submission_modal.removeChild($5fbffa87c50562b9$var$uploading_message_element);
                        $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.thanks);
                    } else fail_upload();
                }).catch((e1)=>{
                    fail_upload();
                });
            }
        });
    });
};
const $5fbffa87c50562b9$var$download = ()=>{
    $5fbffa87c50562b9$var$sounds_loaded = false;
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    const path = $5fbffa87c50562b9$var$get_submissions + "?key=" + $5fbffa87c50562b9$var$APIKEY + "&take=" + $5fbffa87c50562b9$var$number_of_audio_flowers;
    fetch(path).then((response)=>{
        return response.json();
    }).then((response)=>{
        if (response && response.entries && response.entries.length) {
            const entries = response.entries;
            $5fbffa87c50562b9$var$special_mp3s = [];
            $5fbffa87c50562b9$var$common_mp3s = [];
            for (const entry of entries){
                if (id && id == entry.id) $5fbffa87c50562b9$var$user_entry = entry;
                if (entry.type == "special") $5fbffa87c50562b9$var$special_mp3s.push(entry);
                else $5fbffa87c50562b9$var$common_mp3s.push(entry);
            }
            $5fbffa87c50562b9$var$sounds_loaded = true;
        } else //alert("Messages: SDK error")
        $5fbffa87c50562b9$var$sounds_loaded = true;
    }).catch((e1)=>{
        //alert("Messages: SDK error " + e)
        $5fbffa87c50562b9$var$sounds_loaded = true;
    });
};
const $5fbffa87c50562b9$var$start_session = (session_intrinsics)=>{
    if (session_intrinsics.isMobile) {
        if (!session_intrinsics.isChrome && !session_intrinsics.isEyejack) {
            if (session_intrinsics.iOS && (session_intrinsics.isIncognito || !session_intrinsics.isSafari)) $5fbffa87c50562b9$var$show(document.getElementById("ar_bad_browser_text_safari"));
            else if (session_intrinsics.iOS) {
                $5fbffa87c50562b9$var$show(document.getElementById("ar_app_clip_instruction_text"));
                $5fbffa87c50562b9$var$cloak(document.getElementById("ar_bad_browser_copy"));
            } else $5fbffa87c50562b9$var$show(document.getElementById("ar_bad_browser_text_chrome"));
            $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.reject_browser);
        } else {
            $5fbffa87c50562b9$var$mode = "ar";
            $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.splash);
        }
    } else if (session_intrinsics.vrCapable) {
        $5fbffa87c50562b9$var$setup_controls("gamepad");
        $5fbffa87c50562b9$var$mode = "vr";
        $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.splash);
    } else {
        $5fbffa87c50562b9$var$setup_controls("mouse");
        $5fbffa87c50562b9$var$mode = "desktop";
        $5fbffa87c50562b9$var$SM.execute($5fbffa87c50562b9$var$SM.commands.splash);
    }
};
$5fbffa87c50562b9$var$download();
$5fbffa87c50562b9$var$envMap = $5fbffa87c50562b9$var$load_cube_map({
    path: "./assets/textures/sky"
});
const $5fbffa87c50562b9$var$reflective_material = new $0147bee01cff6558$export$55cbcc9b622fe1f5({
    envMap: $5fbffa87c50562b9$var$envMap,
    reflectivity: .9,
    color: 0xf2e1ee
});
const $5fbffa87c50562b9$var$reflective_double_side_material = $5fbffa87c50562b9$var$reflective_material.clone();
$5fbffa87c50562b9$var$reflective_double_side_material.side = $0147bee01cff6558$export$3b296b6f144d5b03;
$5fbffa87c50562b9$var$a.highlight_color_number = 0xd070d0;
$5fbffa87c50562b9$var$a.white_color = new $0147bee01cff6558$export$892596cec99bc70e(-1);
$5fbffa87c50562b9$var$a.highlight_color = new $0147bee01cff6558$export$892596cec99bc70e($5fbffa87c50562b9$var$a.highlight_color_number);
$5fbffa87c50562b9$var$a.clear_texture = new $0147bee01cff6558$export$fd1bfc71f64c538c().load("./assets/textures/clear_texture.png");
const $5fbffa87c50562b9$var$number_of_loader_images = 25;
$5fbffa87c50562b9$var$a.loader_images = [];
for(let i = 1; i <= $5fbffa87c50562b9$var$number_of_loader_images; ++i){
    const filename = "loader" + i + ".png";
    const image = new Image();
    image.src = "./assets/textures/loader/" + filename;
    $5fbffa87c50562b9$var$a.loader_images.push(image);
    if (i == $5fbffa87c50562b9$var$a.loader_images.length) {
        $5fbffa87c50562b9$var$a.loader_empty_texture = new $0147bee01cff6558$export$f7189e49152d1c13($5fbffa87c50562b9$var$a.loader_images[0]);
        $5fbffa87c50562b9$var$a.loader_full_texture = new $0147bee01cff6558$export$f7189e49152d1c13($5fbffa87c50562b9$var$a.loader_images[$5fbffa87c50562b9$var$a.loader_images.length - 1]);
    }
}
const $5fbffa87c50562b9$var$loader_images_loaded = ()=>{
    return $5fbffa87c50562b9$var$number_of_loader_images == $5fbffa87c50562b9$var$a.loader_images.length;
};
const $5fbffa87c50562b9$var$number_of_particle_images = 150;
$5fbffa87c50562b9$var$a.particle_images = [];
for(let i = 1; i <= $5fbffa87c50562b9$var$number_of_particle_images; ++i){
    let filename = "0";
    if (i < 100) filename += "0";
    if (i < 10) filename += "0";
    filename += i + ".png";
    const image = new Image();
    image.src = "./assets/textures/ring_particles/" + filename;
    $5fbffa87c50562b9$var$a.particle_images.push(image);
}
const $5fbffa87c50562b9$var$particle_images_loaded = ()=>{
    return $5fbffa87c50562b9$var$number_of_particle_images == $5fbffa87c50562b9$var$a.particle_images.length;
};
(0, $548a1d91083ea662$export$18964e4f616ed5c8)($5fbffa87c50562b9$var$start_session);

})();
//# sourceMappingURL=index.68683d4b.js.map
